webpackJsonp([12],{

/***/ "+/Gj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{attrs:{"title":"Dashboard","subtitle":"Summary of statuses and recent activity","fixed":false}},[_c('span',{attrs:{"slot":"action"},slot:"action"},[(_vm.widgets.length || _vm.id)?_c('ed-button',{staticClass:"hidden",on:{"click":_vm.addWidget}},[_vm._v("Add Widgets")]):_vm._e()],1)]),_c('div',{staticClass:"dashboard-wrapper"},[_c('div',{staticClass:"container-fluid no-padding"},[_c('div',{staticClass:"main-body"},[_c('chart-tooltip'),(!_vm.widgets.length && _vm.dashboardResolved || !_vm.newDashboard)?_c('new-dashboard',{ref:"newWidget",attrs:{"container-id":_vm.id,"new-dashboard":_vm.id ? false : _vm.newDashboard,"action":_vm.newAction,"endpoint":_vm.api.$.dashboard.getData},on:{"create":_vm.create}}):_vm._e(),_c('grid-layout',{ref:"gridLayout",attrs:{"layout":_vm.widgets,"col-num":12,"is-draggable":true,"is-resizable":false,"row-height":_vm.ROW_HEIGHT,"use-css-transforms":false,"margin":[30, 20]}},_vm._l((_vm.widgets),function(widget,i){return _c('grid-item',{key:widget.id,ref:"gridItems",refInFor:true,staticClass:"widget",style:({ minHeight: ((widget.h * _vm.ROW_HEIGHT) + "px") }),attrs:{"is-resizable":_vm.isResizable(widget),"i":widget.i,"min-w":4,"max-w":12,"min-h":widget.h,"max-h":widget.mh,"x":widget.x,"y":widget.y,"w":widget.w,"h":widget.h,"drag-allow-from":".widget-header","drag-ignore-from":".no-drag"},on:{"moved":function (idx, newX, newY) { return _vm.moved(widget, i, newX, newY); }}},[_c('ed-widget',{ref:"widgets",refInFor:true,attrs:{"id":widget.id,"value":widget,"title":_vm.getTitle(widget),"settings":widget.settings,"toolbar":!widget.component,"position":{
                                  isCollapsed: widget.isCollapsed,
                                  x: widget.x,
                                  y: widget.y,
                                  w: widget.w,
                                  h: widget.h,
                                  height: widget.h * _vm.ROW_HEIGHT,
                                  offset: _vm.offset
                                },"draggable":"true"},on:{"removed":function($event){return _vm.removed(widget, i)},"cloned":function($event){return _vm.cloned(widget, $event)},"saved":function($event){return _vm.saved(widget)}},scopedSlots:_vm._u([{key:"content",fn:function(props){return [(widget.component)?_c(widget.component,{ref:"charts",refInFor:true,tag:"component",attrs:{"id":("W-" + (widget.id)),"widget":widget}}):_vm._e()]}}],null,true)})],1)}),1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+0ya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen content"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-generic"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"wrapper- wrapper-full-page- section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v(_vm._s(_vm.$t('501 Not Implemented')))]),_vm._v(" "),_c('h3',{staticClass:"title"},[_c('i',{staticClass:"fas fa-bullhorn"}),_vm._v("   "+_vm._s(_vm.$t('pageNotSupported')))])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-generic"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+7vF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart-Tooltip"}},[(_vm.hasData)?_c(_vm.type,{tag:"component",style:(_vm.style),attrs:{"contents":_vm.tooltipData,"currency":_vm.currency}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+9Xe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    card: Object,
    accountSettings: Object
  },
  computed: {},
  methods: {
    save: function save() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.accountOrGlCode = (_this.accountOrGlCode || '').trim();
              if (!_this.pushToAccountingSystem) {
                _context.next = 9;
                break;
              }
              _this.accountOrGlCode = (_this.accountOrGlCode || '').trim();
              if (_this.accountOrGlCode.trim()) {
                _context.next = 8;
                break;
              }
              _this.error = true;
              return _context.abrupt("return", false);
            case 8:
              _this.error = false;
            case 9:
              if (!_this.card.Id) {
                _context.next = 27;
                break;
              }
              _context.prev = 10;
              _context.next = 13;
              return _this.api.patch("evedpaycards/".concat(_this.card.Id, "/accounting-system-settings"), {
                AccountOrGlCode: _this.accountOrGlCode,
                PushToAccountingSystem: _this.pushToAccountingSystem,
                CardNumberInAccountingSystem: _this.cardNumberInAccountingSystem
              });
            case 13:
              response = _context.sent;
              if (!(response.status === 200)) {
                _context.next = 20;
                break;
              }
              _this.card.AccountOrGlCode = _this.accountOrGlCode;
              _this.card.CardNumberInAccountingSystem = _this.cardNumberInAccountingSystem;
              return _context.abrupt("return", true);
            case 20:
              console.log(response);
            case 21:
              _context.next = 26;
              break;
            case 23:
              _context.prev = 23;
              _context.t0 = _context["catch"](10);
              console.log(_context.t0);
            case 26:
              return _context.abrupt("return", false);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[10, 23]]);
      }))();
    }
  },
  data: function data() {
    return {
      accountOrGlCode: this.card.AccountOrGlCode,
      cardNumberInAccountingSystem: this.card.CardNumberInAccountingSystem,
      pushToAccountingSystem: false,
      error: false,
      errorMessage: 'Required'
    };
  }
});

/***/ }),

/***/ "+C3y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tabs = function tabs() {
  return [ACCOUNTS, CARDS, TRANSACTIONS, ENVELOPES];
};
/* harmony default export */ __webpack_exports__["a"] = ({
  get tabs() {
    return tabs();
  }
});
var ACCOUNTS = {
  label: 'Accounts',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: undefined
    }
  }
};
var CARDS = {
  label: 'Cards',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: 'cards'
    }
  }
};
var TRANSACTIONS = {
  label: 'Transactions',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: 'transactions'
    }
  }
};
var ENVELOPES = {
  label: 'Envelopes',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: 'envelopes'
    }
  }
};

/***/ }),

/***/ "+CMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suppliers_edit_invoice_vue__ = __webpack_require__("ziuV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ba06b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suppliers_edit_invoice_vue__ = __webpack_require__("8und");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suppliers_edit_invoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ba06b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suppliers_edit_invoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+HLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseChartWidget__ = __webpack_require__("wrv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__("2BGA");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__baseChartWidget__["a" /* default */])('paymentSupplierType-wdg-cmp', __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]));

/***/ }),

/***/ "+IqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionStatus_vue__ = __webpack_require__("umJA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10bccc69_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionStatus_vue__ = __webpack_require__("0KuK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10bccc69_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Jq4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Divisions_list_DivisionModel__ = __webpack_require__("j9Ga");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Grid_cells_actions__ = __webpack_require__("ayPo");



function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_5__components_Grid__["a" /* default */]
  },
  props: {
    show: Boolean
  },
  data: function data() {
    return {
      DivisionModel: __WEBPACK_IMPORTED_MODULE_4__Divisions_list_DivisionModel__["a" /* default */],
      itemsHash: function itemsHash(items) {
        return items.map(function (item) {
          return item.DivisionId;
        }).join('') + items.length;
      },
      actions: [__WEBPACK_IMPORTED_MODULE_6__components_Grid_cells_actions__["g" /* remove */]],
      formData: {
        city: '',
        postalCode: '',
        originalCountryName: '',
        country: '',
        state: {
          StateID: 0,
          StateName: ''
        },
        canadaState: {
          StateID: 0,
          StateName: ''
        },
        region: ''
      },
      roles: [],
      divisions: [],
      divisionsDropdown: [],
      costCenters: [],
      businessUnit: [],
      businessUnitAndCostCenter: [],
      selectCostCenter: [],
      deletedCostCenterIds: [],
      deletedBusinessUnitIds: [],
      deletedBuAndCcPair: [],
      selectBusinessUnit: [],
      selectBusinessUnitAndCostCenter: [],
      divisionsGrid: [],
      deletedDivisionIDs: [],
      countries: [],
      originalCountries: [],
      addObjectUser: {},
      selectRole: '',
      selectDivision: '',
      emailError: '',
      rolesLoaded: false,
      divisionsLoaded: false,
      costCenterLoaded: false,
      businessUnitLoaded: false,
      businessUnitAndCostCenterLoaded: false,
      roleIncomplete: false,
      divisionIncomplete: false,
      countryIncomplete: false,
      firstNameIncomplete: false,
      lastNameIncomplete: false,
      positionIncomplete: false,
      emailIncomplete: false,
      mobilePhoneIncomplete: false,
      user: {
        VendorUserID: 0,
        FirstName: '',
        LastName: '',
        Email: '',
        PhoneNumber: '',
        MobilePhoneNumber: '',
        MobilePhoneCode: '',
        MobileCountryCode: '',
        Position: '',
        RoleID: '',
        CountryID: '',
        TurnOffEmail: false,
        ReceiveAllRatings: false,
        ReceiveAllAdmin: false,
        VendorIdFromEOAdmin: 0
      }
    };
  },
  methods: {
    addUser: function addUser() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee() {
        var valid, response;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              valid = true;
              if (!_this.selectRole) {
                _this.roleIncomplete = true;
                valid = false;
              } else {
                _this.roleIncomplete = false;
              }
              if (_this.divisionsGrid.length === 0) {
                _this.divisionIncomplete = true;
                valid = false;
              } else {
                _this.divisionIncomplete = false;
              }
              if (!_this.user.FirstName) {
                _this.firstNameIncomplete = true;
                valid = false;
              } else {
                _this.firstNameIncomplete = false;
              }
              if (!_this.user.LastName) {
                _this.lastNameIncomplete = true;
                valid = false;
              } else {
                _this.lastNameIncomplete = false;
              }
              if (!_this.user.Email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(_this.user.Email)) {
                _this.emailIncomplete = true;
                valid = false;
              } else {
                _this.emailIncomplete = false;
              }
              if (valid) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              _context.next = 10;
              return _this.api.forms.post(_this.api.$.evedpaycard.saveUser, {
                user: JSON.stringify(_objectSpread(_objectSpread({}, _this.user), {}, {
                  CountryID: _this.formData.country ? _this.formData.country.CountryID : '',
                  RoleID: _this.selectRole.Id,
                  DivisionId: _this.selectDivision.DivisionId,
                  costCenterId: _this.selectCostCenter.Key,
                  businessUnitId: _this.selectBusinessUnit.Key
                })),
                newDivisionIDs: JSON.stringify(_this.divisionsGrid.map(function (division) {
                  return division.DivisionId + '';
                })),
                deletedDivisionIDs: JSON.stringify(_this.deletedDivisionIDs.map(function (deletedDivision) {
                  return deletedDivision.Key + '';
                })),
                costCenters: JSON.stringify(_this.selectCostCenter.map(function (costCenter) {
                  return costCenter.Key + '';
                })),
                business: JSON.stringify(_this.selectBusinessUnit.map(function (businessUnit) {
                  return businessUnit.Key + '';
                })),
                isFromEmail: false,
                isAllCC: 'false',
                buAndCcPairs: JSON.stringify(_this.selectBusinessUnitAndCostCenter.map(function (buAndCcPairs) {
                  return buAndCcPairs.Key + '';
                })),
                deletedBuAndCcPair: JSON.stringify(_this.deletedBuAndCcPair.map(function (deletedBuAndCcPair) {
                  return deletedBuAndCcPair.Key + '';
                })),
                deletedCostCenterIds: JSON.stringify(_this.deletedCostCenterIds.map(function (deletedcostCenter) {
                  return deletedcostCenter.Key + '';
                }))
              });
            case 10:
              response = _context.sent;
              if (response && response.data) {
                if (response.data.SuccessMessage !== 'NotUnique') {
                  _this.showModalUser();
                } else {
                  _this.emailError = 'The e-mail address entered has already been used.';
                  _this.emailIncomplete = true;
                }
              }
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    decodeHtml: function decodeHtml(html) {
      var txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },
    singularize: function singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value;
    },
    getUserRoles: function getUserRoles() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, result, _iterator, _step, role;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this2.rolesLoaded) {
                _context2.next = 17;
                break;
              }
              _context2.prev = 1;
              _context2.next = 4;
              return _this2.api.get(_this2.api.$.approval.getRoles);
            case 4:
              response = _context2.sent;
              result = JSON.parse(response.data);
              result.sort(function (a, b) {
                return a.Name.localeCompare(b.Name);
              });
              _iterator = _createForOfIteratorHelper(result);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  role = _step.value;
                  _this2.roles.push({
                    Id: role.Id,
                    Name: role.Name
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _this2.rolesLoaded = true;
              _this2.hasData = true;
              _context2.next = 17;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](1);
              _this2.hasData = false;
              console.warn('error', _context2.t0);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 13]]);
      }))();
    },
    getCostCenters: function getCostCenters() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (_this3.costCentersLoaded) {
                _context3.next = 14;
                break;
              }
              _context3.prev = 1;
              _context3.next = 4;
              return _this3.api.post(_this3.api.$.evedpaycard.costCenters);
            case 4:
              response = _context3.sent;
              if (response && response.data && Array.isArray(response.data.Data)) {
                _this3.costCenters = response.data.Data.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    Value: _this3.decodeHtml(item.Value)
                  });
                });
              }
              _this3.costCentersLoaded = true;
              _this3.hasData = true;
              _context3.next = 14;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](1);
              console.warn('error', _context3.t0);
              _this3.hasData = false;
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 10]]);
      }))();
    },
    getBusinessUnit: function getBusinessUnit() {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this4.businessUnitLoaded) {
                _context4.next = 14;
                break;
              }
              _context4.prev = 1;
              _context4.next = 4;
              return _this4.api.post(_this4.api.$.evedpaycard.businessUnits);
            case 4:
              response = _context4.sent;
              if (response && response.data) {
                _this4.businessUnit = response.data.Data.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    Value: _this4.decodeHtml(item.Value)
                  });
                });
              }
              _this4.businessUnitLoaded = true;
              _this4.hasData = true;
              _context4.next = 14;
              break;
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](1);
              console.warn('error', _context4.t0);
              _this4.hasData = false;
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 10]]);
      }))();
    },
    getBusinessUnitAndCostCenter: function getBusinessUnitAndCostCenter() {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (_this5.businessUnitAndCostCenterLoaded) {
                _context5.next = 14;
                break;
              }
              _context5.prev = 1;
              _context5.next = 4;
              return _this5.api.post(_this5.api.$.evedpaycard.BU_CC_pair);
            case 4:
              response = _context5.sent;
              if (response && response.data && Array.isArray(response.data.Data)) {
                _this5.businessUnitAndCostCenter = response.data.Data.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    Value: _this5.decodeHtml(item.Value)
                  });
                });
              }
              _this5.businessUnitAndCostCenterLoaded = true;
              _this5.hasData = true;
              _context5.next = 14;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](1);
              console.warn('error', _context5.t0);
              _this5.hasData = false;
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[1, 10]]);
      }))();
    },
    fetchDivisions: function fetchDivisions() {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (_this6.divisionsLoaded) {
                _context6.next = 11;
                break;
              }
              _context6.prev = 1;
              _context6.next = 4;
              return _this6.api.get(_this6.api.$.evedpaycard.division);
            case 4:
              response = _context6.sent;
              if (response && response.data) {
                _this6.divisions = response.data;
                _this6.divisionsLoaded = true;
              }
              _context6.next = 11;
              break;
            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);
              console.error('error', _context6.t0);
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[1, 8]]);
      }))();
    },
    getUserDivisions: function getUserDivisions() {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this7.fetchDivisions();
            case 2:
              _this7.divisionsDropdown = _this7.divisions;
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    removeAllDivisions: function removeAllDivisions() {
      this.divisionsGrid = [];
    },
    addAllDivisions: function addAllDivisions() {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this8.fetchDivisions();
            case 2:
              _this8.divisionsGrid = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this8.divisions);
              _this8.divisionIncomplete = false;
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    addSelectedDivisionToGrid: function addSelectedDivisionToGrid() {
      var _this9 = this;
      if (this.selectDivision) {
        var selectedDivision = this.divisionsDropdown.find(function (division) {
          return division.DivisionId === _this9.selectDivision.DivisionId;
        });
        if (!this.divisionsGrid.find(function (division) {
          return division.DivisionId === selectedDivision.DivisionId;
        })) {
          this.divisionsGrid.push(selectedDivision);
        } else {
          alert('This division is already added.');
        }
      } else {
        alert('Please select a division first.');
      }
    },
    handleRemoveDivision: function handleRemoveDivision(payload, success, fail) {
      var divisionId = this.divisionsGrid[payload.index].DivisionId;
      this.divisionsGrid.splice(+payload.index, 1);
      this.deletedDivisionIDs.push(divisionId);
      success();
    },
    countrySelected: function countrySelected(e) {
      this.doDisplayCountryError = false;
      this.resetState(e.CountryName);
    },
    resetState: function resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.formData.state = {
          StateID: 0,
          StateName: ''
        };
        this.formData.canadaState = {
          StateID: 0,
          StateName: ''
        };
        this.formData.region = '';
      } else {
        this.originalCountryName = countryName;
      }
    },
    fetchCountriesOnOpen: function fetchCountriesOnOpen() {
      var _this10 = this;
      if (this.countries.length) {} else {
        this.api.forms.post(this.api.$.profile.getAllCountries, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this10.countries = r.data.Data;
            _this10.originalCountries = r.data.Data;
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    showModalUser: function showModalUser() {
      this.resetModalFields();
      this.$emit('close');
    },
    selectCostCenter: function selectCostCenter(newValues, oldValues) {
      var _this$deletedCostCent;
      var newKeys = new Set(newValues.map(function (item) {
        return item.Key;
      }));
      var deletedItems = oldValues.filter(function (item) {
        return !newKeys.has(item.Key);
      });
      var deletedIds = deletedItems.map(function (item) {
        return item.Key;
      });
      (_this$deletedCostCent = this.deletedCostCenterIds).push.apply(_this$deletedCostCent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(deletedIds));
      this.deletedCostCenterIds = Array.from(new Set(this.deletedCostCenterIds));
    },
    selectBusinessUnit: function selectBusinessUnit(newValues, oldValues) {
      var _this$deletedBusiness;
      var newKeys = new Set(newValues.map(function (item) {
        return item.Key;
      }));
      var deletedItems = oldValues.filter(function (item) {
        return !newKeys.has(item.Key);
      });
      var deletedIds = deletedItems.map(function (item) {
        return item.Key;
      });
      (_this$deletedBusiness = this.deletedBusinessUnitIds).push.apply(_this$deletedBusiness, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(deletedIds));
      this.deletedBusinessUnitIds = Array.from(new Set(this.deletedBusinessUnitIds));
    },
    selectBusinessUnitAndCostCenter: function selectBusinessUnitAndCostCenter(newValues, oldValues) {
      var _this$deletedBuAndCcP;
      var newKeys = new Set(newValues.map(function (item) {
        return item.Key;
      }));
      var deletedItems = oldValues.filter(function (item) {
        return !newKeys.has(item.Key);
      });
      var deletedIds = deletedItems.map(function (item) {
        return item.Key;
      });
      (_this$deletedBuAndCcP = this.deletedBuAndCcPair).push.apply(_this$deletedBuAndCcP, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(deletedIds));
      this.deletedBuAndCcPair = Array.from(new Set(this.deletedBuAndCcPair));
    },
    onCountrySelect: function onCountrySelect(_ref) {
      var dialCode = _ref.dialCode,
        iso2 = _ref.iso2;
      this.user.MobilePhoneCode = '+' + dialCode;
      this.user.MobileCountryCode = iso2;
    },
    resetModalFields: function resetModalFields() {
      var _this11 = this;
      this.$nextTick(function () {
        _this11.$refs.formRef.reset();
        _this11.formData = {
          city: '',
          postalCode: '',
          originalCountryName: '',
          country: '',
          state: {
            StateID: 0,
            StateName: ''
          },
          canadaState: {
            StateID: 0,
            StateName: ''
          },
          region: ''
        };
        _this11.user = {
          VendorUserID: 0,
          FirstName: '',
          LastName: '',
          Email: '',
          PhoneNumber: '',
          MobilePhone: '',
          Position: '',
          RoleID: '',
          CountryID: '',
          TurnOffEmail: false,
          ReceiveAllRatings: false,
          ReceiveAllAdmin: false,
          VendorIdFromEOAdmin: 0
        };
        _this11.selectRole = '';
        _this11.selectDivision = '';
        _this11.selectCostCenter = [];
        _this11.selectBusinessUnit = [];
        _this11.selectBusinessUnitAndCostCenter = [];
        _this11.divisionsGrid = [];
        _this11.deletedDivisionIDs = [];
        _this11.emailError = false;
        _this11.emailIncomplete = false;
        _this11.firstNameIncomplete = false;
        _this11.lastNameIncomplete = false;
        _this11.divisionIncomplete = false;
        _this11.roleIncomplete = false;
      });
    }
  },
  watch: {
    turnOffEmailCheckbox: function turnOffEmailCheckbox(newVal) {
      if (newVal) {
        this.user.ReceiveAllRatings = false;
        this.user.ReceiveAllAdmin = false;
      }
    },
    show: function show(newVal) {
      if (!newVal) {
        this.resetModalFields();
      }
    }
  }
});

/***/ }),

/***/ "+WA9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("15+g");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff17c66_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Uy8+");
function injectStyle (ssrContext) {
  __webpack_require__("6RsF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ff17c66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff17c66_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+aHG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("/jrm");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b0f015_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("I1Ww");
function injectStyle (ssrContext) {
  __webpack_require__("DEhj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75b0f015"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b0f015_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+gd8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1u-8TChjLYF9OTBnbyPN6B","Dell":"P9q1FJUKYfJNcCzT1eU_-","Abbott":"_2-WxJQJ0KFK7HLtKlGE7_E","Gap":"_35eA19RHHRRpNBNQ2fnS8B","Allstate":"_1wjTpGHckZCnMOG2Cu8s2Z","Asurion":"_2rF8Hwbi-HOI4EABo5qvrj","Invitae":"_18pmRf0e719MKyHabalSa0","JWE":"_1SJ7xw_s-X-BsPd_Ez-eMf"};

/***/ }),

/***/ "+i84":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnFundsToAccount_vue__ = __webpack_require__("qFHZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7e6b144_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnFundsToAccount_vue__ = __webpack_require__("/9WQ");
function injectStyle (ssrContext) {
  __webpack_require__("hDj0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f7e6b144"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnFundsToAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7e6b144_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnFundsToAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+mp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{ref:"conditionRow",staticClass:"row"},[_c('div',{staticClass:"col-md-12"}),_c('div',{staticClass:"well well-sm"},[_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-md-1"},[_vm._v(_vm._s(_vm.label))]),(_vm.label == "WHEN")?_c('ed-select',{staticClass:"col-md-5 middle",attrs:{"options":_vm.operators,"disabled":true},model:{value:(_vm.operators[1]),callback:function ($$v) {_vm.$set(_vm.operators, 1, $$v)},expression:"operators[1]"}}):_c('ed-select',{staticClass:"col-md-5 middle",attrs:{"options":_vm.operators},on:{"select":function($event){return _vm.changeOperator($event)}},model:{value:(_vm.operatorModel),callback:function ($$v) {_vm.operatorModel=$$v},expression:"operatorModel"}}),(_vm.label != "WHEN")?_vm._t("delete-condition"):_vm._e(),_vm._l((_vm.processedConditions),function(condition,i){return _c('div',{key:i,staticClass:"row"},[_c('ed-select',{staticClass:"col-md-3",attrs:{"options":condition.conditionValues,"label":"label","customLabel":_vm.getContextLabel,"placeholder":"Select condition context"},on:{"select":function($event){return _vm.resetConditionLine(condition, $event)}},model:{value:(condition.__selectedContextType),callback:function ($$v) {_vm.$set(condition, "__selectedContextType", $$v)},expression:"condition.__selectedContextType"}}),(condition[_vm.xsi] === _vm.type.amount || condition[_vm.xsi] === _vm.type.adjustmentAmount)?_c('ed-select',{staticClass:"col-md-3",attrs:{"placeholder":"Select operator","options":_vm.conditionAdditionalOperators},on:{"select":function($event){return _vm.changeConditionOperator(condition, $event)}},model:{value:(_vm.operatorType[condition.AdditionalOperator]),callback:function ($$v) {_vm.$set(_vm.operatorType, condition.AdditionalOperator, $$v)},expression:"operatorType[condition.AdditionalOperator]"}}):(_vm.label == "WHEN")?_c('ed-select',{staticClass:"col-md-3",attrs:{"placeholder":"Select operator","options":_vm.conditionOperators,"disabled":true},on:{"select":function($event){return _vm.changeConditionOperator(condition, $event)}},model:{value:(_vm.conditionOperators[0]),callback:function ($$v) {_vm.$set(_vm.conditionOperators, 0, $$v)},expression:"conditionOperators[0]"}}):_c('ed-select',{staticClass:"col-md-3",attrs:{"placeholder":"Select operator","options":_vm.conditionOperators},on:{"select":function($event){return _vm.changeConditionOperator(condition, $event)}},model:{value:(_vm.operatorType[condition.Operator]),callback:function ($$v) {_vm.$set(_vm.operatorType, condition.Operator, $$v)},expression:"operatorType[condition.Operator]"}}),(condition[_vm.xsi] === _vm.type.amount || condition[_vm.xsi] === _vm.type.adjustmentAmount)?_c('ed-input',{staticClass:"col-md-3",attrs:{"placeholder":"0.00","amount":"","type":"money"},on:{"change":function($event){return _vm.changeConditionAmount(condition, $event)}},model:{value:(condition.Values[_vm.type.conditionValue].Value[_vm.text]),callback:function ($$v) {_vm.$set(condition.Values[_vm.type.conditionValue].Value, _vm.text, $$v)},expression:"condition.Values[type.conditionValue].Value[text]"}}):(condition[_vm.xsi] === _vm.type.discountPaymentTerms)?_c('ed-select',{staticClass:"col-md-3",attrs:{"placeholder":"Select condition","options":_vm.discountsConditions,"disabled":"","close-on-select":""},on:{"select":function($event){return _vm.setDiscountsConditionOptions(condition, $event)}},model:{value:(_vm.discountsConditions[0]),callback:function ($$v) {_vm.$set(_vm.discountsConditions, 0, $$v)},expression:"discountsConditions[0]"}}):(condition[_vm.xsi] === _vm.type.preCommit)?_c('ed-select',{staticClass:"col-md-3",attrs:{"placeholder":"Select condition","options":_vm.preCommitConditions,"disabled":"","close-on-select":""},on:{"select":function($event){return _vm.setPreCommitConditionOptions(condition, $event)}},model:{value:(_vm.preCommitConditions[0]),callback:function ($$v) {_vm.$set(_vm.preCommitConditions, 0, $$v)},expression:"preCommitConditions[0]"}}):(condition[_vm.xsi] === _vm.type.supplierLocation)?_c('ed-select',{staticClass:"col-md-3",attrs:{"placeholder":"Select condition","value":condition.Values[_vm.type.conditionValue].Value ? condition.Values[_vm.type.conditionValue].Value[_vm.text] : _vm.supplierLocationConditions[0],"options":_vm.supplierLocationConditions,"close-on-select":""},on:{"select":function($event){return _vm.setSupplierLocationConditionOptions(condition, $event)}}}):(condition[_vm.xsi] === _vm.type.supplierOrganizationType)?_c('ed-select',{staticClass:"col-md-3",attrs:{"placeholder":"Select condition","value":condition.Values[_vm.type.conditionValue].Value ? condition.Values[_vm.type.conditionValue].Value[_vm.text] : _vm.supplierOrganizationTypeConditions[0],"options":_vm.supplierOrganizationTypeConditions,"close-on-select":""},on:{"select":function($event){return _vm.setSupplierOrganizationTypeConditionOptions(condition, $event)}}}):_c('ed-select',{staticClass:"col-md-3",attrs:{"placeholder":"Select condition","openEndpoint":_vm.getEndpoint(condition),"multiple":"","checkboxes":"","multilist":"","options":condition.__o,"groupLabel":"label","groupValues":"options","label":"Name","trackBy":"Uid","disableSelected":"","globalSelectedValues":_vm.__selectedGlobalOptions,"selectedValues":condition.__selectedOp},on:{"apply":function($event){return _vm.setConditionOptions(condition, $event)},"open":function($event){condition.__selectedContextType && _vm.getConditionOptions(condition, $event)}},model:{value:(condition.__selectedOptions),callback:function ($$v) {_vm.$set(condition, "__selectedOptions", $$v)},expression:"condition.__selectedOptions"}}),_c('div',{staticClass:"col-md-3 icon-bar"},[_c('div',{staticClass:"fas fa-trash-alt pull-right",on:{"click":function($event){return _vm.deleteConditionModal(condition)}}}),_c('div',{staticClass:"fas fa-copy pull-right",on:{"click":function($event){return _vm.copyConditionLine(condition.Id, i)}}})])],1)})],2)])]),_c('ed-modal',{attrs:{"show":_vm.showDeleteModal,"title":"","subtitle":"Are you sure you want to delete this condition?","primaryButton":"Yes","secondaryButton":"No","type":"small"},on:{"close":function($event){_vm.showDeleteModal = false},"confirm":function($event){return _vm.deleteConditionLine()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+nXB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group dawn-checkbox-group"},[(_vm.fieldLabel)?_c('label',{staticClass:"control-label",class:{ error: _vm.error }},[_vm._v(_vm._s(_vm.fieldLabel)),(!_vm.required && !_vm.hideOptional)?_c('em',{staticClass:"optional"},[_vm._v(" - optional")]):_vm._e()]):_vm._e(),(_vm.helptipBody && _vm.error)?_c('ed-input-tooltip',{class:{ "error-message": _vm.error },attrs:{"helptipHeader":_vm.helptipHeader,"errorTip":_vm.error,"helptipBody":_vm.helptipBody}}):_vm._e(),_vm._l((_vm.options || _vm.filteredOptions),function(option,index){return _c('checkbox',{directives:[{name:"show",rawName:"v-show",value:(!option.hide),expression:"!option.hide"}],key:index,class:{ "checked": option.status },attrs:{"name":_vm.name,"option-index":index,"option-label":option.label || option,"option-status":_vm.checked(option),"disabled":_vm.disabled || option.isDisabled,"removeOnly":_vm.removeOnly,"error":_vm.error,"icon":option.icon,"iconColor":option.iconColor},on:{"change-status":function($event){return _vm.changeStatus(option, $event)}},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}),_vm._t("additionalText")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+qQe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue__ = __webpack_require__("N3ql");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b860cd1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__("ViMU");
function injectStyle (ssrContext) {
  __webpack_require__("Xacs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b860cd1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+qbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__("dwv+");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636e740c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__("mYwu");
function injectStyle (ssrContext) {
  __webpack_require__("hG3n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-636e740c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636e740c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+rGs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"vWHgalp0fh1Bfo7wz_J7r","Dell":"_1q58OHXeiGEks_5RoxKdKo","Abbott":"_1SKXZ0q4me7WgCOgpyn7sR","Gap":"_27Tir7p6PpYJ3cScaD1fn_","Allstate":"_3UI6iysNRLxdRyThFFE3iv","Asurion":"_3ACFfbmtKRUa7NoLgbtrIE","Invitae":"_32tv9_xka8cBcKTfxaus7I","JWE":"_3YcdFvOCWmhRSfj6Upk9sz"};

/***/ }),

/***/ "+zUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-spend-limit-overlay"},[_c('p',{staticClass:"small"},[_vm._v("\n    Set the daily spend limit for this card.\n  ")]),_vm._v(" "),(_vm.card.Holder)?_c('div',[_c('label',[_vm._v("Card")]),_vm._v(" "),_c('br'),_vm._v("\n    *"+_vm._s(_vm.card.CardNumber)+" - "+_vm._s(_vm.holderDisplay)+"\n  ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': !!_vm.validationError }},[_c('ed-input',{attrs:{"type":"money","amount":"","required":_vm.isDailySpendLimitRequired,"help-text":_vm.maxLimitHelpText,"field-label":"Daily Spend Limit"},on:{"input":_vm.validateDailySpendLimit},model:{value:(_vm.DailySpendLimit),callback:function ($$v) {_vm.DailySpendLimit=$$v},expression:"DailySpendLimit"}})],1),_vm._v(" "),(_vm.validationError)?_c('p',{staticClass:"dsl-validation-error"},[_vm._v(_vm._s(_vm.validationError))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/+ia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transactiondetails_vue__ = __webpack_require__("Vv+m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59145253_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transactiondetails_vue__ = __webpack_require__("Ibr+");
function injectStyle (ssrContext) {
  __webpack_require__("ew7J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59145253"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transactiondetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59145253_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transactiondetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/0XY":
/***/ (function(module, exports) {

module.exports = {"Status":"Status","ProgramNumber":"Program","ProgramStartDateFormatted":"Start Date","ProgramName":"Program Name","Amount":"Amount","Balance":"Balance","SupplierName":"Supplier Name","SentDateFormatted":"Sent","ContactName":{"label":"Contact Name","visible":false},"DueDateWithinFormatted":{"label":"Due Date Within","visible":false},"ProgramEndDateFormatted":{"label":"End Date","visible":false},"PaymentStatus":{"label":"Payment Status","visible":false},"CreatedBy":{"label":"Prepared By","visible":false},"ProgramInternalID":{"label":"Program ID","visible":false},"Venue":{"label":"Venue","visible":false}}

/***/ }),

/***/ "/436":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    selectedRows: [],
    disabled: false,
    tooltip: ''
  },
  data: function data() {
    return {
      showAddTransactionNumber: false,
      transactionNumber: ''
    };
  },
  created: function created() {},
  methods: {
    saveTransactionNumber: function saveTransactionNumber() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var ids, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ids = _this.selectedRows.map(function (row) {
                return row.data.Id;
              });
              _context.prev = 1;
              _context.next = 4;
              return _this.api.post(_this.api.$.evedpaycard.addTransactionNumberToEnvelope, {
                ids: ids,
                transactionNumber: _this.transactionNumber
              });
            case 4:
              response = _context.sent;
              if (response.status === 200) {
                _this.$emit('success');
              } else {
                alert('Error saving transaction number.');
              }
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error('Error saving transaction number:', _context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    showModal: function showModal(showAddTransactionNumber) {
      this.showAddTransactionNumber = !showAddTransactionNumber;
      if (!showAddTransactionNumber) {
        this.resetModal();
      }
    },
    resetModal: function resetModal() {
      this.transactionNumber = '';
    }
  }
});

/***/ }),

/***/ "/4fP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_Dashboard_widgets_ProgramBudget__ = __webpack_require__("yjLw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_charts_components_chart_tooltip__ = __webpack_require__("2jaw");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProgramSpend: __WEBPACK_IMPORTED_MODULE_1__components_modules_Dashboard_widgets_ProgramBudget__["default"],
    ChartTooltip: __WEBPACK_IMPORTED_MODULE_2__core_charts_components_chart_tooltip__["a" /* default */]
  },
  props: {
    data: Array,
    title: String,
    currency: {
      type: String,
      default: 'USD'
    }
  },
  data: function data() {
    return {
      widget: {
        endPoint: '_',
        dateRangeFilter: {}
      }
    };
  },
  mounted: function mounted() {
    this.title && this.setTitle();
    this.setData();
    this.$refs.programSpend.load();
  },
  computed: {
    budgetBalance: function budgetBalance() {
      return this.data[0][2];
    },
    revisedBudget: function revisedBudget() {
      return this.data[0][1];
    },
    budgetBalancePercent: function budgetBalancePercent() {
      return this.budgetBalance <= 0 ? 0 : this.budgetBalance * 100 / this.revisedBudget;
    },
    displayNotice: function displayNotice() {
      return this.budgetBalancePercent < 20;
    },
    noticeMsg: function noticeMsg() {
      var programLabel = global.app.$user.sessionSettings.CompanySettings.ProgramLabel;
      if (this.budgetBalance < 0) return programLabel + ' is over budget.';
      return this.budgetBalancePercent < 20 ? Math.ceil(this.budgetBalancePercent).toFixed(0) + '% of ' + programLabel.toLowerCase() + ' budget remains.' : '';
    },
    noticeType: function noticeType() {
      return 'warn'; // this.budgetBalancePercent <= 0 ? 'danger' : 'warn'
    }
  },
  methods: {
    setTitle: function setTitle() {
      this.widget.chartComponent.chartOpts.customSettings = _objectSpread(_objectSpread({}, this.widget.chartComponent.chartOpts.customSettings), {}, {
        chartGroupValue: this.title
      });
      this.widget.chartComponent.chartOpts.axisY = _objectSpread(_objectSpread({}, this.widget.chartComponent.chartOpts.axisY), {}, {
        offset: -50,
        labelInterpolationFnc: function labelInterpolationFnc() {
          return '';
        }
      });
    },
    setData: function setData() {
      var _this = this;
      this.$refs.programSpend.$refs.chart.api = {
        get: function get() {
          return Promise.resolve({
            data: {
              ChartData: _this.data
            }
          });
        }
      };
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "/6HA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardSettings_vue__ = __webpack_require__("Lrqp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e44229_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardSettings_vue__ = __webpack_require__("5KP6");
function injectStyle (ssrContext) {
  __webpack_require__("HD5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61e44229"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e44229_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/9WQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"return-funds-overlay"},[_c('div',[_c('p',[_vm._m(0),_c('br'),_vm._v(" "),_c('v-money',{staticClass:"small",attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.card.Balance))])],1)]),_vm._v(" "),_c('div',[_vm._m(1),_vm._v(" "),_c('ed-input',{attrs:{"type":"money","amount":""},on:{"input":function (value) { return _vm.$emit('returnFunds', value); }},model:{value:(_vm.returnFunds),callback:function ($$v) {_vm.returnFunds=$$v},expression:"returnFunds"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('small',[_vm._v("Current Balance")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_c('small',[_vm._v("Return Amount")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Blb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("/GGT");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db7def54_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("nf0W");
function injectStyle (ssrContext) {
  __webpack_require__("qDeO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db7def54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db7def54_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/C9s":
/***/ (function(module, exports) {

module.exports = {"[placeholder] Owner":"ProgramOwner","Meeting Requestor":"MeetingRequestor","Collaborator – Any Settings":"AnySettings","Collaborator – Can Approve Invoices":"CanApproveInvoices","Collaborator – Can Invite to [placeholder]":"CanInviteToProgram","Collaborator – Display on POs":"DisplayOnPOs","Collaborator – Receives PO Notifications":"ReceivesPONotifications","Collaborator – Receives RFP Notifications":"ReceivesRFPNotifications","Collaborator – Receives Status Notifications":"ReceivesStatusNotifications","Custom Title":"CustomTitle"}

/***/ }),

/***/ "/Dpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"ScanInvoiceHIstoryGrid",attrs:{"model":_vm.getModel,"name":"Invoice Scanning","desc":"Line Item Entry","search-placeholder":"Scanned Invoices","fit-columns":"","search":true,"resizing":false,"footer":"","endpoint":_vm.api.$.admin.getInvoicesToBeScannedHistory,"alias":"InvoiceScanHistory","checkboxes":false,"tabs":_vm.tabs}},[_c('back',{attrs:{"slot":"back-action"},slot:"back-action"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/GGT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__("4Su7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__approve_dialog__ = __webpack_require__("u8Yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reject_dialog__ = __webpack_require__("2E/x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_scrollbarHelper_js__ = __webpack_require__("7yCl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_user__ = __webpack_require__("uduW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'approval-needed-wdg-cmp',
  props: {
    widget: Object
  },
  computed: {
    hasData: function hasData() {
      return this.cards !== null && this.cards.length > 0;
    }
  },
  data: function data() {
    return {
      useMeetingRequestor: false,
      meetingRequesterName: null,
      originalLabel: null,
      cards: [],
      showRejectDialog: false,
      showApproveDialog: false,
      dialogList: [],
      rejectText: null,
      loading: false,
      companySettings: {},
      programLabel: 'Program',
      divisionLabel: 'Division',
      submitEndpoint: null
    };
  },
  created: function created() {
    if (!this.widget.originalLabel) {
      this.widget.originalLabel = this.widget.label;
    }
    this.originalLabel = this.widget.originalLabel;
    this.companySettings = __WEBPACK_IMPORTED_MODULE_5__core_user__["a" /* default */].getCompanySettings();
    this.programLabel = this.companySettings.ProgramLabel ? this.companySettings.ProgramLabel : 'Program';
    this.divisionLabel = this.companySettings.DivsionLabel ? this.companySettings.DivisionLabel : 'Division';
    this.approveUrl = this.widget.endPoint.replace(/GetApprovalNeededList/, 'Approve');
    this.rejectUrl = this.widget.endPoint.replace(/GetApprovalNeededList/, 'Reject');
    this.reload();
  },
  methods: {
    reload: function reload() {
      var _this = this;
      this.loading = true;
      this.showApproveDialog = false;
      this.showRejectDialog = false;
      this.api.get(this.widget.endPoint, {}).then(function (r) {
        _this.useMeetingRequestor = r.data.useMeetingRequestor;
        _this.meetingRequesterName = r.data.meetingRequesterName;
        _this.rejectText = 'Decline';
        _this.cards = r.data.items;
        _this.widget.label = _this.cards && _this.cards.length ? _this.originalLabel + ' (' + _this.cards.length + ')' : _this.originalLabel;
        if (_this.hasData) {
          _this.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('updateWidgetHeightSimple', {
              wId: _this.widget.id,
              height: _this.$el.clientHeight + (_this.cards.length === 1 ? 20 : 0)
            });
            if (_this.cards.length >= 5) Object(__WEBPACK_IMPORTED_MODULE_3__helpers_scrollbarHelper_js__["a" /* initScrollbar */])(_this, '.scroller');
          });
        }
        var cardId = _this.$route.query.cardId;
        var isApprove = _this.$route.query.IsApproveCardFromEmail;
        var isReject = _this.$route.query.IsRejectCardFromEmail;
        if (cardId && isApprove) {
          var _card = _this.cards.find(function (c) {
            return c.Id === cardId;
          });
          _this.showApprove(_card);
        }
        if (cardId && isReject) {
          var _card2 = _this.cards.find(function (c) {
            return c.Id === cardId;
          });
          _this.showReject(_card2);
        }
        var cardFundsId = _this.$route.query.cardFundsId;
        var isApproveCardFunds = _this.$route.query.IsApproveCardFundsFromEmail;
        var isRejectCardFunds = _this.$route.query.IsRejectCardFundsFromEmail;
        if (cardFundsId && isApproveCardFunds) {
          var _card3 = _this.cards.find(function (c) {
            return c.Id === cardFundsId;
          });
          _this.showApprove(_card3);
        }
        if (cardFundsId && isRejectCardFunds) {
          var _card4 = _this.cards.find(function (c) {
            return c.Id === cardFundsId;
          });
          _this.showReject(_card4);
        }
        var cardRefillId = _this.$route.query.cardRefillId;
        var isApproveCardRefill = _this.$route.query.IsApproveCardRefillFromEmail;
        var isRejectCardRefill = _this.$route.query.IsRejectCardRefillFromEmail;
        if (cardRefillId && isApproveCardRefill) {
          var _card5 = _this.cards.find(function (c) {
            return c.Id === cardRefillId;
          });
          _this.showApprove(_card5);
        }
        if (cardRefillId && isRejectCardRefill) {
          var _card6 = _this.cards.find(function (c) {
            return c.Id === cardRefillId;
          });
          _this.showReject(_card6);
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    showApproveAll: function showApproveAll() {
      this.dialogList = this.cards;
      this.showApproveDialog = true;
      this.scrollParentTopIfInIframe();
    },
    showRejectAll: function showRejectAll() {
      this.dialogList = this.cards;
      this.showRejectDialog = true;
      this.scrollParentTopIfInIframe();
    },
    showApprove: function showApprove(card) {
      this.dialogList = [card];
      this.showApproveDialog = true;
      this.scrollParentTopIfInIframe();
    },
    showReject: function showReject(card) {
      this.dialogList = [card];
      this.showRejectDialog = true;
      this.scrollParentTopIfInIframe();
    },
    scrollParentTopIfInIframe: function scrollParentTopIfInIframe() {
      if (window.self === window.top) return;
      this.$nextTick(function () {
        try {
          var parentDoc = window.parent.document;
          var overlayShell = parentDoc.querySelector('.stepin-layout-content');
          if (overlayShell) {
            if (overlayShell.scrollTo) {
              overlayShell.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            } else {
              overlayShell.scrollTop = 0;
            }
            return;
          }

          // fallback: scroll main document
          var scroller = parentDoc.scrollingElement || parentDoc.documentElement || parentDoc.body;
          if (scroller.scrollTo) {
            scroller.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          } else {
            scroller.scrollTop = 0;
          }
        } catch (e) {
          console.error('Could not scroll parent from iframe:', e);
        }
      });
    },
    getIdsList: function getIdsList() {
      return this.dialogList.map(function (item) {
        return item.Id;
      });
    },
    doApprove: function doApprove(reason) {
      var _this2 = this;
      this.loading = true;
      this.submitEndpoint = this.approveUrl;
      // /ApprovalNeededWidget/Approve
      this.api.post(this.approveUrl, {
        list: this.getIdsList(),
        reason: reason
      }).then(function (r) {
        _this2.reload();
      }).finally(function () {
        _this2.loading = false;
      });
    },
    doReject: function doReject(reason, notifySupplier) {
      var _this3 = this;
      this.loading = true;
      this.submitEndpoint = this.rejectUrl;
      // /ApprovalNeededWidget/Reject
      this.api.post(this.rejectUrl, {
        list: this.getIdsList(),
        reason: reason,
        notifySupplier: notifySupplier
      }).then(function (r) {
        _this3.reload();
      }).finally(function () {
        _this3.loading = false;
      });
    }
  },
  components: {
    card: __WEBPACK_IMPORTED_MODULE_0__card__["default"],
    approveDialog: __WEBPACK_IMPORTED_MODULE_1__approve_dialog__["default"],
    rejectDialog: __WEBPACK_IMPORTED_MODULE_2__reject_dialog__["default"]
  }
});

/***/ }),

/***/ "/HVE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/MqT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardPIN_vue__ = __webpack_require__("bQmM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_884ebefe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardPIN_vue__ = __webpack_require__("YR7Z");
function injectStyle (ssrContext) {
  __webpack_require__("2zeO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-884ebefe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardPIN_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_884ebefe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardPIN_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Z1n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"grid",attrs:{"name":_vm.$t("Payments"),"desc":"Manage Invoices & Payments","search":"","search-placeholder":"Invoices","views":false,"sort":{ DueDateWithin: "asc", DueDateWithinFormatted: "asc" },"endpoint":_vm.api.$.invoice.list.$,"screen":_vm.api.$.invoice.list.sentCta,"alias":"PaymentInvoiceList_SentActionPayment","legacy":"","tabs":_vm.tabs,"row-classes":_vm.rowClasses,"fit-columns":"","footer":""},on:{"selectedRows":_vm.rowSelected}},[_c('span',{attrs:{"slot":"selectionButtons"},slot:"selectionButtons"},[_c('remit-payment',{attrs:{"rows":_vm.selectedRows}}),_c('edit-invoice-for-supplier',{attrs:{"rows":_vm.selectedRows,"fromPage":"action-required"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/egI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/jrm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_scrollbarHelper_js__ = __webpack_require__("7yCl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'news-wdg-cmp',
  name: 'news',
  props: {
    widget: Object
  },
  computed: {
    hasNews: function hasNews() {
      if (this.newsData.length > 0) return true;else {
        return false;
      }
    }
  },
  created: function created() {
    var _this = this;
    this.api.get(this.widget.endPoint, {}).then(function (r) {
      _this.newsData = r.data.Data;
      _this.newsLoaded = true;
      _this.$nextTick(function () {
        var maxH = _this.newsData.length >= 3 ? 3 : _this.newsData.length;
        var desiredHeight = _this.hasNews ? maxH : 1;
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit('updateWidgetHeight', {
          wId: _this.widget.id,
          height: desiredHeight,
          alt: -1
        });
        if (_this.newsData.length > 3) {
          _this.$el.querySelector('.scroller').style.height = '190px';
          Object(__WEBPACK_IMPORTED_MODULE_1__helpers_scrollbarHelper_js__["a" /* initScrollbar */])(_this, '.scroller');
        }
      });
    });
  },
  data: function data() {
    return {
      newsData: [],
      newsLoaded: false
    };
  },
  methods: {
    handleClick: function handleClick(entry) {
      this.$router.push('/i/Admin/UserNotification/GetNotificationCenter?notificationId=' + entry.AppNotificationId);
    }
  }
});

/***/ }),

/***/ "/ofR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"endpoint":_vm.api.$.evedpaycard.transactions}},[_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"evedpay-transactions"},[(_vm.transactions && !_vm.transactions.length)?_c('div',{staticClass:"no-data"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.transactions),function(transaction,i){return _c('div',{key:transaction.id,on:{"click":function () { return _vm.redirectTransaction(transaction); }}},[(_vm.showHeader(transaction, i))?_c('h6',[_vm._v("\n        "+_vm._s(_vm.headerText(transaction))+"\n      ")]):_vm._e(),_vm._v(" "),_c('ed-notice',{staticClass:"transaction",attrs:{"type":_vm.transactionStatusColor(transaction.status, transaction.reconcileStatus)}},[_c('p',[_c('strong',[_vm._v("EvedPay Card ... "+_vm._s(transaction.cardNumber))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-9",staticStyle:{"padding":"0"}},[_c('p',{staticClass:"merchant"},[_c('strong',[_vm._v(_vm._s(transaction.merchant))])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3 text-right"},[_c('p',{staticClass:"amount"},[_c('strong',[_c('v-money',[_vm._v(_vm._s(transaction.amount))])],1)])]),_vm._v(" "),(transaction.status === 'Pending')?_c('div',{staticClass:"col-xs-9",staticStyle:{"padding":"0"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.showDate(transaction))+" | Pending")])]):_c('div',{staticClass:"col-xs-9",staticStyle:{"padding":"0"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.showDate(transaction)))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3 text-right",staticStyle:{"padding-right":"15px"}},[(transaction.receipt !== null)?_c('i',{staticClass:"fas fa-camera",staticStyle:{"color":"#4A90E2"}}):_vm._e()])])],1)})],2)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"icon fas fa-list"}),_vm._v(" "),_c('h3',[_vm._v("No Transactions")]),_vm._v(" "),_c('p',[_vm._v("Your transactions will appear here")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/roU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardAddFunds_vue__ = __webpack_require__("vm9F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a028bcfa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardAddFunds_vue__ = __webpack_require__("DI5E");
function injectStyle (ssrContext) {
  __webpack_require__("v4a3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a028bcfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardAddFunds_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a028bcfa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardAddFunds_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/rsB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-card',
  props: {
    id: {
      type: Number,
      default: 1
    },
    title: {
      type: String
    },
    titleTooltip: {
      type: String
    },
    subtitle: String,
    footerButton: {
      type: String,
      default: 'Edit'
    },
    icon: Array,
    href: String,
    removable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasSlotTop: function hasSlotTop() {
      return this.$slots.top;
    },
    hasSlotTitle: function hasSlotTitle() {
      return this.$slots.title;
    },
    hasSlotFooter: function hasSlotFooter() {
      return this.$slots.footer;
    },
    iconClass: function iconClass() {
      return this.icon[0] + ' fa-' + this.icon[1];
    }
  },
  methods: {
    removecard: function removecard() {
      var id = this.id;
      this.$emit('removecard', id);
    },
    edit: function edit() {
      var id = this.id;
      this.$emit('edit', id);
    }
  }
});

/***/ }),

/***/ "/yid":
/***/ (function(module, exports) {

module.exports = {"CostCenterId":"_","*CostCenterNo":{"label":"Cost Center ID","editable":true},"CostCenterName":{"label":"Cost Center Name","editable":true}}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "03tc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mobileWebview__ = __webpack_require__("a45c");


var RETRY_STATUSES = [500, 502, 503, 504];
var DEFAULT_MAX_RETRIES = 3;
var DEFAULT_BASE_DELAY = 1000;
var UPLOAD_TIMEOUT_MS = 60000;
var POLL_TIMEOUT_MS = 15000;
function isPlatformSentinelError(error) {
  if (!error.response) {
    return true;
  }
  if (error.response.status >= 500) {
    return true;
  }
  return false;
}
function isRetryable(error) {
  if (error.response && error.response.status === 401) {
    return false;
  }
  if (error.response && RETRY_STATUSES.indexOf(error.response.status) !== -1) {
    return true;
  }
  if (!error.response) {
    return true;
  }
  return false;
}
function attachAuthInterceptor(instance) {
  instance.interceptors.request.use(function (request) {
    if (global.app && global.app.$user && global.app.$user.sessionSettings && global.app.$user.sessionSettings.Token) {
      request.headers['Authorization'] = 'Bearer ' + global.app.$user.sessionSettings.Token;
    }
    return request;
  }, null, {
    synchronous: true
  });
}
function attachResponseInterceptor(instance) {
  instance.interceptors.response.use(function onSuccess(response) {
    return response.data;
  }, function onError(error) {
    if (error.response && error.response.status === 401) {
      // Only treat a 401 as session-expiry when we actually sent a bearer. A 401 on a
      // request that carried no Authorization header means we fired before the app was
      // ready — e.g. an httpPlatform call in a component created() during a hard-refresh
      // bootstrap, before App.vue's `global.app = new Vue(...)` is assigned, so the request
      // interceptor above couldn't attach the token. That is not a real expiry; logging out
      // would kick a perfectly-authenticated user. Reject and let the caller handle it.
      var sentAuth = error.config && error.config.headers && error.config.headers['Authorization'];
      if (sentAuth && !Object(__WEBPACK_IMPORTED_MODULE_1__mobileWebview__["a" /* default */])() && global.app && global.app.$user && typeof global.app.$user.logout === 'function') {
        global.app.$user.logout();
      }
      return Promise.reject(error);
    }
    if (isPlatformSentinelError(error)) {
      error.isPlatformSentinelError = true;
    }
    return Promise.reject(error);
  });
}
function attachRetryInterceptor(instance, maxRetries, baseDelay) {
  instance.interceptors.response.use(null, function retryOnError(error) {
    var config = error.config;
    if (!config) {
      return Promise.reject(error);
    }
    config.__retryCount = config.__retryCount || 0;
    if (!isRetryable(error) || config.__retryCount >= maxRetries) {
      return Promise.reject(error);
    }
    config.__retryCount++;
    var delayMs = baseDelay * Math.pow(2, config.__retryCount - 1);
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(instance(config));
      }, delayMs);
    });
  });
}
function setupInstance(instance, maxRetries, baseDelay) {
  attachAuthInterceptor(instance);
  attachResponseInterceptor(instance);
  attachRetryInterceptor(instance, maxRetries, baseDelay);
}
var httpPlatform = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://platform.eved.com",
  withCredentials: true,
  timeout: UPLOAD_TIMEOUT_MS
});
setupInstance(httpPlatform, DEFAULT_MAX_RETRIES, DEFAULT_BASE_DELAY);
httpPlatform.create = function createPlatformInstance(options) {
  options = options || {};
  var maxRetries = typeof options.maxRetries === 'number' ? options.maxRetries : DEFAULT_MAX_RETRIES;
  var baseDelay = typeof options.baseDelay === 'number' ? options.baseDelay : DEFAULT_BASE_DELAY;
  var axiosConfig = {};
  Object.keys(options).forEach(function (key) {
    if (key !== 'maxRetries' && key !== 'baseDelay') {
      axiosConfig[key] = options[key];
    }
  });
  if (!axiosConfig.baseURL) {
    axiosConfig.baseURL = "https://platform.eved.com";
  }
  if (axiosConfig.withCredentials === undefined) {
    axiosConfig.withCredentials = true;
  }
  if (axiosConfig.timeout === undefined) {
    axiosConfig.timeout = UPLOAD_TIMEOUT_MS;
  }
  var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(axiosConfig);
  setupInstance(instance, maxRetries, baseDelay);
  return instance;
};
httpPlatform.isPlatformSentinelError = isPlatformSentinelError;
httpPlatform.UPLOAD_TIMEOUT_MS = UPLOAD_TIMEOUT_MS;
httpPlatform.POLL_TIMEOUT_MS = POLL_TIMEOUT_MS;
/* harmony default export */ __webpack_exports__["a"] = (httpPlatform);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "07Tp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row content"},[_c('div',{staticClass:"summary well small col-md-12"},[_c('table',{staticClass:"col-md-12"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.paymentsNoLabel))]),_vm._v(" "),_c('td',[_vm._v("Total Payment")])])]),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.paymentsNoLabel))]),_vm._v(" "),_c('td',[_vm._v("Total Payment")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.model.count))]),_vm._v(" "),_c('td',[_c('v-money',{attrs:{"name":"total_payment_amount","currency":_vm.model.currencyCode}},[_vm._v(_vm._s(_vm.model.totalAmount))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"clear"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0C6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-slider',
  data: function data() {
    return {
      flag: false,
      size: 0,
      currentValue: 0,
      currentSlider: 0,
      showHelp: false,
      showIcon: 'fas fa-question-circle',
      hideIcon: 'far fa-times-circle'
    };
  },
  props: {
    fieldLabel: String,
    required: Boolean,
    symbol: {
      type: String,
      default: '%'
    },
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String],
      default: 6
    },
    data: {
      type: Array,
      default: null
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotWidth: {
      type: Number,
      required: false
    },
    dotHeight: {
      type: Number,
      default: 12,
      required: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    interval: {
      type: Number,
      default: 1
    },
    show: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    piecewise: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: [String, Boolean],
      default: false
    },
    eventType: {
      type: String,
      default: 'auto'
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    reverse: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
    speed: {
      type: Number,
      default: 0.5
    },
    realTime: {
      type: Boolean,
      default: false
    },
    stopPropagation: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Array],
      default: 0
    },
    piecewiseLabel: {
      type: Boolean,
      default: false
    },
    sliderStyle: [Array, Object, Function],
    tooltipDir: [Array, String],
    formatter: [String, Function],
    piecewiseStyle: Object,
    piecewiseActiveStyle: Object,
    processStyle: Object,
    bgStyle: Object,
    tooltipStyle: [Array, Object, Function],
    labelStyle: Object,
    labelActiveStyle: Object,
    helptipHeader: String,
    helptipBody: String,
    error: Boolean
  },
  computed: {
    dotWidthVal: function dotWidthVal() {
      return typeof this.dotWidth === 'number' ? this.dotWidth : this.dotSize;
    },
    dotHeightVal: function dotHeightVal() {
      return typeof this.dotHeight === 'number' ? this.dotHeight : this.dotSize;
    },
    flowDirection: function flowDirection() {
      return "vue-slider-".concat(this.direction + (this.reverse ? '-reverse' : ''));
    },
    tooltipDirection: function tooltipDirection() {
      var dir = this.tooltipDir || (this.direction === 'vertical' ? 'left' : 'top');
      if (Array.isArray(dir)) {
        return this.isRange ? dir : dir[1];
      } else {
        return this.isRange ? [dir, dir] : dir;
      }
    },
    tooltipStatus: function tooltipStatus() {
      return this.tooltip === 'hover' && this.flag ? 'vue-slider-always' : this.tooltip ? "vue-slider-".concat(this.tooltip) : '';
    },
    tooltipClass: function tooltipClass() {
      return ["vue-slider-tooltip-".concat(this.tooltipDirection), 'vue-slider-tooltip'];
    },
    isDisabled: function isDisabled() {
      return this.eventType === 'none' ? true : this.disabled;
    },
    disabledClass: function disabledClass() {
      return this.disabled ? 'vue-slider-disabled' : '';
    },
    isRange: function isRange() {
      return Array.isArray(this.value);
    },
    slider: function slider() {
      return this.isRange ? [this.$refs.dot0, this.$refs.dot1] : this.$refs.dot;
    },
    minimum: function minimum() {
      return this.data ? 0 : this.min;
    },
    val: {
      get: function get() {
        return this.data ? this.isRange ? [this.data[this.currentValue[0]], this.data[this.currentValue[1]]] : this.data[this.currentValue] : this.currentValue;
      },
      set: function set(val) {
        if (this.data) {
          if (this.isRange) {
            var index0 = this.data.indexOf(val[0]);
            var index1 = this.data.indexOf(val[1]);
            if (index0 > -1 && index1 > -1) {
              this.currentValue = [index0, index1];
            }
          } else {
            var index = this.data.indexOf(val);
            if (index > -1) {
              this.currentValue = index;
            }
          }
        } else {
          this.currentValue = val;
        }
      }
    },
    currentIndex: function currentIndex() {
      if (this.isRange) {
        return this.data ? this.currentValue : [(this.currentValue[0] - this.minimum) / this.spacing, (this.currentValue[1] - this.minimum) / this.spacing];
      } else {
        return (this.currentValue - this.minimum) / this.spacing;
      }
    },
    indexRange: function indexRange() {
      if (this.isRange) {
        return this.currentIndex;
      } else {
        return [0, this.currentIndex];
      }
    },
    maximum: function maximum() {
      return this.data ? this.data.length - 1 : this.max;
    },
    multiple: function multiple() {
      var decimals = "".concat(this.interval).split('.')[1];
      return decimals ? Math.pow(10, decimals.length) : 1;
    },
    spacing: function spacing() {
      return this.data ? 1 : this.interval;
    },
    total: function total() {
      if (this.data) {
        return this.data.length - 1;
      } else if (~~((this.maximum - this.minimum) * this.multiple) % (this.interval * this.multiple) !== 0) {
        console.error('[Vue-slider warn]: Prop[interval] is illegal, Please make sure that the interval can be divisible');
      }
      return (this.maximum - this.minimum) / this.interval;
    },
    gap: function gap() {
      return this.size / this.total;
    },
    position: function position() {
      return this.isRange ? [(this.currentValue[0] - this.minimum) / this.spacing * this.gap, (this.currentValue[1] - this.minimum) / this.spacing * this.gap] : (this.currentValue - this.minimum) / this.spacing * this.gap;
    },
    limit: function limit() {
      return this.isRange ? [[0, this.position[1]], [this.position[0], this.size]] : [0, this.size];
    },
    valueLimit: function valueLimit() {
      return this.isRange ? [[this.minimum, this.currentValue[1]], [this.currentValue[0], this.maximum]] : [this.minimum, this.maximum];
    },
    wrapStyles: function wrapStyles() {
      return this.direction === 'vertical' ? {
        height: typeof this.height === 'number' ? "".concat(this.height, "px") : this.height
      } : {
        width: typeof this.width === 'number' ? "".concat(this.width, "px") : this.width
      };
    },
    sliderStyles: function sliderStyles() {
      if (Array.isArray(this.sliderStyle)) {
        return this.isRange ? this.sliderStyle : this.sliderStyle[1];
      } else if (typeof this.sliderStyle === 'function') {
        return this.sliderStyle(this.val, this.currentIndex);
      } else {
        return this.isRange ? [this.sliderStyle, this.sliderStyle] : this.sliderStyle;
      }
    },
    tooltipStyles: function tooltipStyles() {
      if (Array.isArray(this.tooltipStyle)) {
        return this.isRange ? this.tooltipStyle : this.tooltipStyle[1];
      } else if (typeof this.tooltipStyle === 'function') {
        return this.tooltipStyle(this.val, this.currentIndex);
      } else {
        return this.isRange ? [this.tooltipStyle, this.tooltipStyle] : this.tooltipStyle;
      }
    },
    elemStyles: function elemStyles() {
      return this.direction === 'vertical' ? {
        width: "".concat(this.width, "px"),
        height: '100%'
      } : {
        height: "".concat(this.height, "px")
      };
    },
    dotStyles: function dotStyles() {
      return this.direction === 'vertical' ? {
        width: "".concat(this.dotWidthVal, "px"),
        height: "".concat(this.dotHeightVal, "px"),
        left: "".concat(-(this.dotWidthVal - this.width) / 2, "px")
      } : {
        width: "".concat(this.dotWidthVal, "px"),
        height: "".concat(this.dotHeightVal, "px"),
        top: "".concat(-(this.dotHeightVal - this.height) / 2, "px")
      };
    },
    piecewiseDotStyle: function piecewiseDotStyle() {
      return this.direction === 'vertical' ? {
        width: "".concat(this.width, "px"),
        height: "".concat(this.width, "px")
      } : {
        width: "".concat(this.height, "px"),
        height: "".concat(this.height, "px")
      };
    },
    piecewiseDotWrap: function piecewiseDotWrap() {
      if (!this.piecewise && !this.piecewiseLabel) {
        return false;
      }
      var arr = [];
      for (var i = 0; i <= this.total; i++) {
        var style = this.direction === 'vertical' ? {
          bottom: "".concat(this.gap * i - this.width / 2, "px"),
          left: 0
        } : {
          left: "".concat(this.gap * i - this.height / 2, "px"),
          top: 0
        };
        var index = this.reverse ? this.total - i : i;
        var label = this.data ? this.data[index] : this.spacing * index + this.min;
        arr.push({
          style: style,
          label: this.formatter ? this.formatting(label) : label,
          inRange: index >= this.indexRange[0] && index <= this.indexRange[1]
        });
      }
      return arr;
    }
  },
  watch: {
    value: function value(val) {
      this.flag || this.setValue(val, true);
    },
    max: function max(val) {
      var resetVal = this.limitValue(this.val);
      resetVal !== false && this.setValue(resetVal);
      this.refresh();
    },
    min: function min(val) {
      var resetVal = this.limitValue(this.val);
      resetVal !== false && this.setValue(resetVal);
      this.refresh();
    },
    show: function show(bool) {
      var _this = this;
      if (bool && !this.size) {
        this.$nextTick(function () {
          _this.refresh();
        });
      }
    }
  },
  methods: {
    toggleHelp: function toggleHelp() {
      this.showHelp = !this.showHelp;
    },
    onChg: function onChg(e) {
      this.setValue(this.currentValue, e.target.value);
      if (this.currentValue > this.maximum) {
        this.setValue(this.maximum, e.target.value);
      }
    },
    bindEvents: function bindEvents() {
      document.addEventListener('touchmove', this.moving, {
        passive: false
      });
      document.addEventListener('touchend', this.moveEnd, {
        passive: false
      });
      document.addEventListener('mousemove', this.moving);
      document.addEventListener('mouseup', this.moveEnd);
      document.addEventListener('mouseleave', this.moveEnd);
      window.addEventListener('resize', this.refresh);
    },
    unbindEvents: function unbindEvents() {
      window.removeEventListener('resize', this.refresh);
      document.removeEventListener('touchmove', this.moving);
      document.removeEventListener('touchend', this.moveEnd);
      document.removeEventListener('mousemove', this.moving);
      document.removeEventListener('mouseup', this.moveEnd);
      document.removeEventListener('mouseleave', this.moveEnd);
    },
    formatting: function formatting(value) {
      return typeof this.formatter === 'string' ? this.formatter.replace(/\{value\}/, value) : this.formatter(value);
    },
    getPos: function getPos(e) {
      this.realTime && this.getStaticData();
      return this.direction === 'vertical' ? this.reverse ? e.pageY - this.offset : this.size - (e.pageY - this.offset) : this.reverse ? this.size - (e.clientX - this.offset) : e.clientX - this.offset;
    },
    wrapClick: function wrapClick(e) {
      if (this.isDisabled || !this.clickable) return false;
      var pos = this.getPos(e);
      if (this.isRange) {
        this.currentSlider = pos > (this.position[1] - this.position[0]) / 2 + this.position[0] ? 1 : 0;
      }
      this.setValueOnPos(pos);
    },
    moveStart: function moveStart(e, index) {
      if (this.stopPropagation) {
        e.stopPropagation();
      }
      if (this.isDisabled) return false;else if (this.isRange) {
        this.currentSlider = index;
      }
      this.flag = true;
      this.$emit('drag-start', this);
    },
    moving: function moving(e) {
      if (this.stopPropagation) {
        e.stopPropagation();
      }
      if (!this.flag) return false;
      e.preventDefault();
      if (e.targetTouches && e.targetTouches[0]) e = e.targetTouches[0];
      this.setValueOnPos(this.getPos(e), true);
    },
    moveEnd: function moveEnd(e) {
      if (this.stopPropagation) {
        e.stopPropagation();
      }
      if (this.flag) {
        this.$emit('drag-end', this);
        if (this.lazy && this.isDiff(this.val, this.value)) {
          this.syncValue();
        }
      } else {
        return false;
      }
      this.flag = false;
      this.setPosition();
    },
    setValueOnPos: function setValueOnPos(pos, isDrag) {
      var range = this.isRange ? this.limit[this.currentSlider] : this.limit;
      var valueRange = this.isRange ? this.valueLimit[this.currentSlider] : this.valueLimit;
      if (pos >= range[0] && pos <= range[1]) {
        this.setTransform(pos);
        var v = (Math.round(pos / this.gap) * (this.spacing * this.multiple) + this.minimum * this.multiple) / this.multiple;
        this.setCurrentValue(v, isDrag);
      } else if (pos < range[0]) {
        this.setTransform(range[0]);
        this.setCurrentValue(valueRange[0]);
        if (this.currentSlider === 1) this.currentSlider = 0;
      } else {
        this.setTransform(range[1]);
        this.setCurrentValue(valueRange[1]);
        if (this.currentSlider === 0) this.currentSlider = 1;
      }
    },
    isDiff: function isDiff(a, b) {
      if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b)) {
        return true;
      } else if (Array.isArray(a) && a.length === b.length) {
        return a.some(function (v, i) {
          return v !== b[i];
        });
      }
      return a !== b;
    },
    setCurrentValue: function setCurrentValue(val, bool) {
      if (val < this.minimum || val > this.maximum) return false;
      if (this.isRange) {
        if (this.isDiff(this.currentValue[this.currentSlider], val)) {
          this.currentValue.splice(this.currentSlider, 1, val);
          if (!this.lazy || !this.flag) {
            this.syncValue();
          }
        }
      } else if (this.isDiff(this.currentValue, val)) {
        this.currentValue = val;
        if (!this.lazy || !this.flag) {
          this.syncValue();
        }
      }
      bool || this.setPosition();
    },
    setIndex: function setIndex(val) {
      if (Array.isArray(val) && this.isRange) {
        var value;
        if (this.data) {
          value = [this.data[val[0]], this.data[val[1]]];
        } else {
          value = [this.spacing * val[0] + this.minimum, this.spacing * val[1] + this.minimum];
        }
        this.setValue(value);
      } else {
        val = this.spacing * val + this.minimum;
        if (this.isRange) {
          this.currentSlider = val > (this.currentValue[1] - this.currentValue[0]) / 2 + this.currentValue[0] ? 1 : 0;
        }
        this.setCurrentValue(val);
      }
    },
    setValue: function setValue(val, noCb, speed) {
      var _this2 = this;
      if (this.isDiff(this.val, val)) {
        var resetVal = this.limitValue(val);
        if (resetVal !== false) {
          this.val = this.isRange ? resetVal.concat() : resetVal;
        } else {
          this.val = this.isRange ? val.concat() : val;
        }
        this.syncValue(noCb);
      }
      this.$nextTick(function () {
        return _this2.setPosition(speed);
      });
    },
    setPosition: function setPosition(speed) {
      this.flag || this.setTransitionTime(speed === undefined ? this.speed : speed);
      if (this.isRange) {
        this.currentSlider = 0;
        this.setTransform(this.position[this.currentSlider]);
        this.currentSlider = 1;
        this.setTransform(this.position[this.currentSlider]);
      } else {
        this.setTransform(this.position);
      }
      this.flag || this.setTransitionTime(0);
    },
    setTransform: function setTransform(val) {
      var value = (this.direction === 'vertical' ? this.dotHeightVal / 2 - val : val - this.dotWidthVal / 2) * (this.reverse ? -1 : 1);
      var translateValue = this.direction === 'vertical' ? "translateY(".concat(value, "px)") : "translateX(".concat(value, "px)");
      var processSize = "".concat(this.currentSlider === 0 ? this.position[1] - val : val - this.position[0], "px");
      var processPos = "".concat(this.currentSlider === 0 ? val : this.position[0], "px");
      if (this.isRange) {
        this.slider[this.currentSlider].style.transform = translateValue;
        this.slider[this.currentSlider].style.WebkitTransform = translateValue;
        this.slider[this.currentSlider].style.msTransform = translateValue;
        if (this.direction === 'vertical') {
          this.$refs.process.style.height = processSize;
          this.$refs.process.style[this.reverse ? 'top' : 'bottom'] = processPos;
        } else {
          this.$refs.process.style.width = processSize;
          this.$refs.process.style[this.reverse ? 'right' : 'left'] = processPos;
        }
      } else {
        this.slider.style.transform = translateValue;
        this.slider.style.WebkitTransform = translateValue;
        this.slider.style.msTransform = translateValue;
        if (this.direction === 'vertical') {
          this.$refs.process.style.height = "".concat(val, "px");
          this.$refs.process.style[this.reverse ? 'top' : 'bottom'] = 0;
        } else {
          this.$refs.process.style.width = "".concat(val, "px");
          this.$refs.process.style[this.reverse ? 'right' : 'left'] = 0;
        }
      }
    },
    setTransitionTime: function setTransitionTime(time) {
      return time || this.$refs.process.offsetWidth;
      if (this.isRange) {
        // eslint-disable-line
        for (var i = 0; i < this.slider.length; i++) {
          this.slider[i].style.transitionDuration = "".concat(time, "s");
          this.slider[i].style.WebkitTransitionDuration = "".concat(time, "s");
        }
        this.$refs.process.style.transitionDuration = "".concat(time, "s");
        this.$refs.process.style.WebkitTransitionDuration = "".concat(time, "s");
      } else {
        this.slider.style.transitionDuration = "".concat(time, "s");
        this.slider.style.WebkitTransitionDuration = "".concat(time, "s");
        this.$refs.process.style.transitionDuration = "".concat(time, "s");
        this.$refs.process.style.WebkitTransitionDuration = "".concat(time, "s");
      }
    },
    limitValue: function limitValue(val) {
      var _this3 = this;
      if (this.data) {
        return val;
      }
      var bool = false;
      if (this.isRange) {
        val = val.map(function (v) {
          if (v < _this3.min) {
            bool = true;
            return _this3.min;
          } else if (v > _this3.max) {
            bool = true;
            return _this3.max;
          }
          return v;
        });
      } else if (val > this.max) {
        bool = true;
        val = this.max;
      } else if (val < this.min) {
        bool = true;
        val = this.min;
      }
      return bool && val;
    },
    syncValue: function syncValue(noCb) {
      noCb || this.$emit('callback', this.val);
      this.$emit('input', this.isRange ? this.val.concat() : this.val);
    },
    getValue: function getValue() {
      return this.val;
    },
    getIndex: function getIndex() {
      return this.currentIndex;
    },
    getStaticData: function getStaticData() {
      if (this.$refs.elem) {
        this.size = this.direction === 'vertical' ? this.$refs.elem.offsetHeight : this.$refs.elem.offsetWidth;
        this.offset = this.direction === 'vertical' ? this.$refs.elem.getBoundingClientRect().top + window.pageYOffset || document.documentElement.scrollTop : this.$refs.elem.getBoundingClientRect().left;
      }
    },
    refresh: function refresh() {
      if (this.$refs.elem) {
        this.getStaticData();
        this.setPosition();
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    this.$nextTick(function () {
      _this4.getStaticData();
      _this4.setValue(_this4.value, true, 0);
      _this4.bindEvents();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindEvents();
  }
});

/***/ }),

/***/ "0FyU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0KuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.node.rowPinned !== 'bottom')?_c('span',{staticClass:"wrapper"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:({ content: _vm.tooltipContent }),expression:"{ content: tooltipContent }",modifiers:{"bottom":true}}],style:({ color: _vm.isDeclined ? 'red' : 'inherit' })},[_vm._v("\n    "+_vm._s(_vm.params.value)+"\n    "),(_vm.isDeclined)?_c('i',{staticClass:"fas fa-info-circle"}):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0MDp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-span',[_vm._v(_vm._s(_vm.rounded)+" "+_vm._s(_vm.currency))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Okf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"tqqCnnneaqnE6Su_vu_fQ","Dell":"_217mPS6mCRTEBmXuLF_gX1","Abbott":"EvSam9NGslZK8u7y87cx-","Gap":"yF5Sel1cKmYgfUeJcU6q6","Allstate":"_3mDyrtvc_ooKwIP6ikI4PB","Asurion":"_1s7pivGWqxTiSftV9tmmuA","Invitae":"_1GYZxkQF99I3n9bpF26WUm","JWE":"_1vPZhoOxniU9JJDboBP5Ty"};

/***/ }),

/***/ "0R6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__("NM/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__("naW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__option_type__ = __webpack_require__("Ga5e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__option_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__option_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_add_options__ = __webpack_require__("k9o7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_add_options___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__action_add_options__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__team_tab_type__ = __webpack_require__("/C9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__team_tab_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__team_tab_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_type__ = __webpack_require__("40N4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__context_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__operator_type__ = __webpack_require__("bA1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__operator_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__operator_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_components_edCheckbox_checkbox_vue__ = __webpack_require__("+qQe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__option_rules__ = __webpack_require__("1P/l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__option_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__option_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__core_events_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__route_values__ = __webpack_require__("1SGE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__route_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__route_values__);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var approvalRuleUtils = __webpack_require__("IJVW");
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'checkbox': __WEBPACK_IMPORTED_MODULE_7__core_components_edCheckbox_checkbox_vue__["default"]
  },
  props: {
    actions: Object,
    rule: Object,
    actionOptions: Object,
    routeValues: Array,
    useParallelApprovalRoutes: Boolean
  },
  data: function data() {
    var _this = this;
    return {
      actionOperators: ['Perform all of the following actions step by step', 'Perform all of the following actions simultaneously'],
      processedActions: [],
      list: utils.collection.list,
      max: utils.collection.max,
      showDeleteModal: false,
      deleteTarget: null,
      contextType: __WEBPACK_IMPORTED_MODULE_5__context_type___default.a,
      operatorType: __WEBPACK_IMPORTED_MODULE_6__operator_type___default.a,
      routesValues: __WEBPACK_IMPORTED_MODULE_11__route_values___default.a,
      actionAddOptions: __WEBPACK_IMPORTED_MODULE_3__action_add_options___default.a,
      xsi: '@xsi:type',
      resultOptions: [],
      contextTypeMap: Object.keys(__WEBPACK_IMPORTED_MODULE_5__context_type___default.a),
      operatorTypeMap: Object.keys(__WEBPACK_IMPORTED_MODULE_6__operator_type___default.a),
      routesValuesMap: Object.keys(__WEBPACK_IMPORTED_MODULE_11__route_values___default.a.routeNumber),
      values: function values(action) {
        var result = [];
        if (action.Roles && action.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role]) {
          var roles = _this.list(action.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role]).filter(function (key) {
            return key.IsTeamTabRole === 'false' && key.IsUserTitle !== 'true';
          }).map(function (role) {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId)
            };
            return role;
          });
          var teamTabRoles = _this.list(action.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role]).filter(function (key) {
            return key.IsTeamTabRole === 'true';
          }).map(function (role) {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId),
              Key: role.TeamTabRole
            };
            return role;
          });
          var usersTitles = _this.list(action.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role]).filter(function (key) {
            return key.IsUserTitle === 'true';
          }).map(function (role) {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId)
            };
            return role;
          });
          if (roles.length) {
            result.push({
              label: __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['Roles'],
              type: 'Roles',
              options: roles
            });
          }
          if (teamTabRoles.length) {
            result.push({
              label: __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['TeamTabRoles'],
              type: 'TeamTabRoles',
              options: teamTabRoles
            });
          }
          if (usersTitles.length) {
            result.push({
              label: __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['UsersTitles'],
              type: 'UsersTitles',
              options: usersTitles
            });
          }
        }
        if (action.Users && action.Users[__WEBPACK_IMPORTED_MODULE_1__type___default.a.user]) {
          var users = _this.list(action.Users[__WEBPACK_IMPORTED_MODULE_1__type___default.a.user]).map(function (user) {
            user = {
              Name: user.FirstName + ' ' + user.LastName,
              Id: parseInt(user.UserID)
            };
            return user;
          }) || [];
          result.push({
            label: __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['Users'],
            type: 'Users',
            options: users
          });
        }
        _this.resultOptions = result.GroupValues;
        return result;
      },
      __selectedGlobalOptions: [],
      optionRules: __WEBPACK_IMPORTED_MODULE_8__option_rules___default.a,
      componentDestroyed: false,
      useHierarchyApproval: this.$user.$.companySettings && this.$user.$.companySettings.UseHierarchyApproval
    };
  },
  created: function created() {
    var _this2 = this;
    __WEBPACK_IMPORTED_MODULE_9__event_bus__["b" /* EventBus */].$on('rootOptionChanged', function (limitation) {
      _this2.rootOptionsChangedEvent();
    });
    this.processActions();
    __WEBPACK_IMPORTED_MODULE_9__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_10__core_events_events___default.a.APPROVAL_RULE.VALIDATE_COMPONENTS, function (r) {
      _this2.validateRule();
    });
    __WEBPACK_IMPORTED_MODULE_9__event_bus__["b" /* EventBus */].$on('usingParallelRoutesChanged', function (r) {
      _this2.usingParallelRoutesChangedEvent(r);
    });
    __WEBPACK_IMPORTED_MODULE_9__event_bus__["b" /* EventBus */].$on('updateMaxRoutesChanged', function (r) {
      _this2.updateMaxRoutesChangedEvent(r);
    });
  },
  // solution from this link does not work
  // https://stackoverflow.com/questions/45399302/stop-receiving-events-from-destroyed-child-component
  beforeDestroy: function beforeDestroy() {
    this.componentDestroyed = true;
  },
  computed: {
    operators: function operators() {
      var operators = [];
      if (this.actionOptions.Operators) {
        for (var i = 0; i < this.actionOptions.Operators.length; i++) {
          operators.push(__WEBPACK_IMPORTED_MODULE_6__operator_type___default.a[this.actionOptions.Operators[i]]);
        }
      }
      return operators;
    },
    actionOperatorModel: function actionOperatorModel() {
      if (this.rule && this.rule.ActionOperator) {
        return this.rule.ActionOperator === 'StepByStep' ? this.actionOperators[0] : this.actionOperators[1];
      }
    },
    programLabel: function programLabel() {
      return global.app.$user.sessionSettings.CompanySettings.ProgramLabel;
    }
  },
  methods: {
    validateRule: function validateRule() {
      var _this3 = this;
      if (!this.componentDestroyed) {
        var valid = true;
        if (this.actions && this.actions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.action]) {
          if (this.list(this.actions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.action]).length === 0) {
            valid = false;
          }
          if (!this.rule.ActionOperator) {
            valid = false;
          }
          var actionsList = this.list(this.actions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.action]);
          actionsList.map(function (action) {
            var hasNotCompletedParallelRoutes = action['@xsi:type'] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.requestApprovalAction && _this3.useParallelApprovalRoutes ? action.ParallelRouteNo === null : false;
            if (!action['@xsi:type'] || !action.Operator || hasNotCompletedParallelRoutes) {
              valid = false;
            } else {
              // verify if any role/user is set on action
              var missingRoles = false;
              var missingUsers = false;
              if (!action.Roles || action.Roles && (!action.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role] || _this3.list(action.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role]).length === 0)) {
                missingRoles = true;
              }
              // verify if any user is set on action
              if (!action.Users || action.Users && (!action.Users[__WEBPACK_IMPORTED_MODULE_1__type___default.a.user] || _this3.list(action.Users[__WEBPACK_IMPORTED_MODULE_1__type___default.a.user]).length === 0)) {
                missingUsers = true;
              }
              if (missingRoles && missingUsers) {
                valid = false;
              }
            }
            var payload = {
              Id: action.Id,
              valid: valid
            };
            __WEBPACK_IMPORTED_MODULE_9__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__core_events_events___default.a.APPROVAL_RULE.VALIDATION_COMPLETED, payload);
          });
        }
        if (!valid) {
          this.invalidateConditionBlock();
        } else {
          this.resetConditionBlock();
        }
      }
    },
    invalidateConditionBlock: function invalidateConditionBlock() {
      if (this.$refs.actionRaw && this.$refs.actionRaw.classList) {
        this.$refs.actionRaw.classList.add('invalid');
      }
    },
    resetConditionBlock: function resetConditionBlock() {
      if (this.$refs.actionRaw && this.$refs.actionRaw.classList) {
        this.$refs.actionRaw.classList.remove('invalid');
      }
    },
    rootOptionsChangedEvent: function rootOptionsChangedEvent() {
      var _this4 = this;
      if (this.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.PoCancelledClosedSelected]) {
        this.processedActions = this.processedActions.map(function (action) {
          var _iterator = _createForOfIteratorHelper(action.actionValues.entries()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_step.value, 2),
                i = _step$value[0],
                value = _step$value[1];
              if (value.label === _this4.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.requestApprovalAction]) {
                action.actionValues.splice(i, 1);
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          action.__selectedAdditionalOptions = action.__selectedContextType !== '' ? _this4.getAdditionalOptions(action) : [];
          return action;
        });
      } else {
        this.processedActions = this.processedActions.map(function (action) {
          var alreadyContainsItem = false;
          action.actionValues.map(function (actionValue) {
            if (actionValue.label === _this4.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.requestApprovalAction]) {
              alreadyContainsItem = true;
            }
          });
          if (!alreadyContainsItem) {
            action.actionValues.push({
              label: _this4.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.requestApprovalAction],
              values: [{
                label: '',
                options: []
              }]
            });
          }
          action.__selectedAdditionalOptions = action.__selectedContextType !== '' ? _this4.getAdditionalOptions(action) : [];
          return action;
        });
        if (this.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.PoSelected]) {
          this.processedActions = this.processedActions.map(function (action) {
            var alreadyContainsItem = false;
            action.actionValues.map(function (actionValue) {
              if (actionValue.label === _this4.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.notify]) {
                alreadyContainsItem = true;
              }
            });
            if (!alreadyContainsItem) {
              action.actionValues.push({
                label: _this4.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.notify],
                values: [{
                  label: '',
                  options: []
                }]
              });
            }
            action.__selectedAdditionalOptions = action.__selectedContextType !== '' ? _this4.getAdditionalOptions(action) : [];
            return action;
          });
        } else {
          this.processedActions = this.processedActions.map(function (action) {
            var _iterator2 = _createForOfIteratorHelper(action.actionValues.entries()),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _step2$value = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_step2.value, 2),
                  i = _step2$value[0],
                  value = _step2$value[1];
                if (value.label === _this4.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.notify]) {
                  action.actionValues.splice(i, 1);
                  break;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            action.__selectedAdditionalOptions = action.__selectedContextType !== '' ? _this4.getAdditionalOptions(action) : [];
            return action;
          });
        }
      }
    },
    usingParallelRoutesChangedEvent: function usingParallelRoutesChangedEvent(r) {
      var _this5 = this;
      this.processedActions = this.processedActions.map(function (action) {
        var updatedAction = utils.copy(action);
        _this5.$store.state.routeNumbers = [];
        if (!r.data) {
          updatedAction.ParallelRouteNo = null;
        } else {
          updatedAction.ParallelRouteNo = action['@xsi:type'] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.requestApprovalAction ? action._parallelRouteNo.id : null;
          if (action['@xsi:type'] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.requestApprovalAction && typeof action._parallelRouteNo !== 'undefined' && parseInt(action._parallelRouteNo.id) !== null) {
            _this5.$store.state.routeNumbers.push(action._parallelRouteNo.id);
          }
        }
        _this5.updateAction(action.Id, updatedAction);
        return action;
      });
    },
    updateMaxRoutesChangedEvent: function updateMaxRoutesChangedEvent(r) {
      var _this6 = this;
      this.processedActions = this.processedActions.map(function (action) {
        if (action['@xsi:type'] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.requestApprovalAction && action._parallelRouteNo.id > parseInt(r.data)) {
          _this6.$store.state.routeNumbers.splice(_this6.$store.state.routeNumbers.indexOf(action._parallelRouteNo.id), 1);
          action.ParallelRouteNo = null;
          action._parallelRouteNo = {
            label: '',
            id: null
          };
          var updatedAction = utils.copy(action);
          _this6.updateAction(action.Id, updatedAction);
        }
        return action;
      });
    },
    getOriginalAdditionalOptions: function getOriginalAdditionalOptions(action) {
      var _this7 = this;
      var options = this.actionOptions.AdditionalOptions.filter(function (option) {
        return !_this7.useHierarchyApproval && option !== 'UseHierarchyApproval' || _this7.useHierarchyApproval;
      }).map(function (option) {
        option = {
          id: option,
          label: __WEBPACK_IMPORTED_MODULE_3__action_add_options___default.a[option],
          status: action[option] && action[option].toString() === 'true',
          originalStatus: action[option] && action[option].toString() === 'true',
          hide: false
        };
        return option;
      });
      return options;
    },
    getAdditionalOptions: function getAdditionalOptions(action) {
      var options = this.getOriginalAdditionalOptions(action);
      var copyOptions = utils.copy(options);
      if (this.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.InvoiceSelected]) {
        copyOptions = copyOptions.filter(function (option) {
          return option.id !== 'RequestEveryTime';
        });
      }
      if (!this.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.ProgramBudgetSelected]) {
        copyOptions = copyOptions.filter(function (option) {
          return option.id !== 'UseHierarchyApproval';
        });
      }
      options = copyOptions;
      return options;
    },
    applyActionContext: function applyActionContext(action, index) {
      var _this8 = this;
      action.__selectedAdditionalOptions = [];
      action.__selectedOptions = [];
      action.__selectedContextType = '';
      action.__o = [{}];
      action.__selectedOp = [];
      action.actionValues = [];
      if (this.actionOptions && this.actionOptions.Options) {
        // limitate THEN options based on internal rules
        this.actionOptions = this.limitateOptions(this.actionOptions);
        this.actionOptions.Options.map(function (option, index) {
          // this.$store.state.rootOptionSelected = o
          action.actionValues.push({
            label: _this8.$t(__WEBPACK_IMPORTED_MODULE_5__context_type___default.a[option.Type]),
            values: option.Type === action['@xsi:type'] ? _this8.values(action) : [{
              label: '',
              options: []
            }]
          });
          if (option.Type === action['@xsi:type']) {
            action.__selectedContextType = action.actionValues[index];
          }
        });
        if (action.__selectedContextType !== '') {
          action.__selectedAdditionalOptions = this.getAdditionalOptions(action);
        }
      }
      action._parallelRouteNo = typeof action.ParallelRouteNo !== 'undefined' && this.useParallelApprovalRoutes ? {
        label: this.routesValuesMap.filter(function (key) {
          return __WEBPACK_IMPORTED_MODULE_11__route_values___default.a.routeNumber[key] === action.ParallelRouteNo;
        })[0],
        id: parseInt(action.ParallelRouteNo)
      } : {
        label: '',
        id: null
      };
      action.ParallelRouteNo = action._parallelRouteNo.id;
      this.$store.state.routeNumbers.push(action._parallelRouteNo.id);
      // set initial values
      // TODO: get default group
      this.markGroupOptions({
        data: '{"Roles": []}'
      }, action, true);
      return action;
    },
    limitateOptions: function limitateOptions(actionOptions) {
      // get original options from $store
      this.actionOptions.Options = utils.copy(this.$store.state.originalActionOptions.options);
      this.actionOptions.AdditionalOptions = utils.copy(this.$store.state.originalActionOptions.additionalOptions);
      var _iterator3 = _createForOfIteratorHelper(actionOptions.Options.entries()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_step3.value, 2),
            i = _step3$value[0],
            value = _step3$value[1];
          if (this.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.PoCancelledClosedSelected]) {
            if (value.Type === __WEBPACK_IMPORTED_MODULE_1__type___default.a.requestApprovalAction) {
              actionOptions.Options.splice(i, 1);
            }
          } else {
            if (!this.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.PoSelected]) {
              if (value.Type === __WEBPACK_IMPORTED_MODULE_1__type___default.a.notify) {
                actionOptions.Options.splice(i, 1);
              }
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (this.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.InvoiceSelected]) {
        actionOptions.AdditionalOptions.filter(function (option) {
          return option !== 'RequestEveryTime';
        });
      }
      if (!this.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.ProgramBudgetSelected]) {
        actionOptions.AdditionalOptions.filter(function (option) {
          return option !== 'UseHierarchyApproval';
        });
      }
      return actionOptions;
    },
    /*
    * 1. init action model
    */
    processActions: function processActions() {
      var vm = this;
      this.__selectedGlobalOptions = [];
      this.processedActions = this.list(utils.copy(this.actions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.action])).map(function (action, index) {
        action = vm.applyActionContext(action, index);
        return action;
      });
    },
    /*
     * 2. fetch all options
     */
    getOptions: function getOptions(action) {
      var vm = this;
      var endpoint = this.api.$.approval.getItemOwnerValues;
      var payload = {
        type: action['@xsi:type']
      };
      // call api
      endpoint && this.api.forms.post(endpoint, payload).then(function (r) {
        if (r && r.data) {
          vm.markGroupOptions(r, action, false);
        }
      });
    },
    /*
    * 3. mark existing options
    */
    markGroupOptions: function markGroupOptions(r, action, isInitiallySetting) {
      var _this9 = this;
      var resultObj = JSON.parse(r.data);
      var initialSelected = action.__selectedContextType.values ? action.__selectedContextType.values.map(flagSaved).reduce(function (selectedOptions, value) {
        return selectedOptions.concat(value);
      }, []) : [];
      var newAction = [{
        label: '',
        values: [{
          label: '',
          options: []
        }]
      }];
      Object.keys(resultObj).map(function (key, i) {
        var res = resultObj[key].map(function (k) {
          k.Uid = k.Id + '_' + key;
          k.Type = key;
          k.Name = _this9.formatLabel(k.Name);
          return k;
        });
        newAction = action.actionValues.filter(function (v) {
          return v.label === __WEBPACK_IMPORTED_MODULE_5__context_type___default.a[action['@xsi:type']];
        })[0];
        action.__selectedOptions = action.__selectedOptions.length ? action.__selectedOptions : initialSelected;
        if (isInitiallySetting) {
          action.__selectedOp = utils.copy(action.__selectedOptions);
        }
        action.__selectedOptions.map(function (option) {
          if (_this9.__selectedGlobalOptions.filter(function (o) {
            return o.Uid === option.Uid;
          }).length === 0 && (isInitiallySetting ? true : action.__selectedOp.filter(function (o) {
            return o.Uid === option.Uid;
          }).length !== 0)) {
            _this9.__selectedGlobalOptions.push(option);
          }
        });
        if (newAction) {
          var verification = !_this9.useHierarchyApproval && key !== 'UsersTitles' || _this9.useHierarchyApproval && (!_this9.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.ProgramBudgetSelected] && key !== 'UsersTitles' || _this9.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.ProgramBudgetSelected]);
          if (verification) {
            if (newAction.values[i]) {
              newAction.values[i].label = __WEBPACK_IMPORTED_MODULE_2__option_type___default.a[key];
              newAction.values[i].options = res;
            } else {
              newAction.values.push({
                label: __WEBPACK_IMPORTED_MODULE_2__option_type___default.a[key],
                options: res
              });
            }
          }
        }
      });
      newAction && this.setOptions(action, newAction);
      function flagSaved(val) {
        return val.options.map(function (k) {
          k.Uid = k.Id + '_' + val.type;
          k.Type = val.type;
          // k.Key = k.Key
          return k;
        });
      }
    },
    setOptions: function setOptions(action, e) {
      action.__o = e.values;
      e.values = [{
        label: '',
        options: []
      }];
    },
    getTeamTabType: function getTeamTabType(searchKey) {
      var result = searchKey;
      Object.keys(__WEBPACK_IMPORTED_MODULE_4__team_tab_type___default.a).map(function (key) {
        var keyF = key.replace('[placeholder]', global.app.$user.sessionSettings.CompanySettings.ProgramLabel);
        if (keyF === searchKey) {
          result = __WEBPACK_IMPORTED_MODULE_4__team_tab_type___default.a[key];
        }
      });
      return result;
    },
    setActionOptions: function setActionOptions(action, e) {
      var _this10 = this;
      this.enableSaveButton();
      var RolesList = [];
      var UsersList = [];
      action.__selectedOptions.map(function (selectedOption) {
        if (_this10.__selectedGlobalOptions.filter(function (o) {
          return o.Uid === selectedOption.Uid;
        }).length === 0) {
          _this10.__selectedGlobalOptions.push(selectedOption);
        }
        _this10.processedActions.map(function (processedAction) {
          if (processedAction.Id !== action.Id) {
            processedAction.__selectedOptions.map(function (option, index) {
              if (option.Uid === selectedOption.Uid) {
                processedAction.__selectedOptions.splice(index, 1);
              }
              return option;
            });
            return processedAction;
          }
        });
        switch (selectedOption.Type) {
          case 'Roles':
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: _this10.getTeamTabType(_this10.programLabel + ' Owner'),
              // Program Owner
              CustomTitleId: 0,
              Name: selectedOption.Name,
              IsTeamTabRole: 'false',
              IsUserTitle: 'false'
            });
            break;
          case 'TeamTabRoles':
            var teamTabText = '';
            if (selectedOption.Key === _this10.getTeamTabType('Meeting Requestor')) {
              teamTabText = _this10.getTeamTabType('Meeting Requestor');
            } else {
              if (selectedOption.Id >= 0) {
                teamTabText = _this10.getTeamTabType(selectedOption.Name);
              } else {
                teamTabText = _this10.getTeamTabType('Custom Title');
              }
            }
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: teamTabText,
              CustomTitleId: selectedOption.Id >= 0 ? selectedOption.Id : -1 * selectedOption.Id,
              Name: selectedOption.Name,
              IsTeamTabRole: 'true',
              IsUserTitle: 'false'
            });
            break;
          case 'Users':
            UsersList.push({
              UserID: selectedOption.Id,
              RoleID: 0,
              FirstName: selectedOption.Name.split(' ')[0],
              LastName: selectedOption.Name.split(' ')[1]
            });
            break;
          case 'UsersTitles':
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: _this10.getTeamTabType(_this10.programLabel + ' Owner'),
              // Program Owner
              CustomTitleId: 0,
              Name: selectedOption.Name,
              IsTeamTabRole: 'false',
              IsUserTitle: 'true'
            });
            break;
        }
      });
      action.__selectedAdditionalOptions = action.__selectedAdditionalOptions.map(function (selectedOption) {
        selectedOption.originalStatus = selectedOption.status;
        switch (selectedOption.id) {
          case 'MatchBusinessUnit':
            action.MatchBusinessUnit = selectedOption.originalStatus;
            break;
          case 'MatchCostCenter':
            action.MatchCostCenter = selectedOption.originalStatus;
            break;
          case 'OverridePreviousSteps':
            action.OverridePreviousSteps = selectedOption.originalStatus;
            break;
          case 'RequestEveryTime':
            action.RequestEveryTime = selectedOption.originalStatus;
            break;
          case 'UseHierarchyApproval':
            action.UseHierarchyApproval = selectedOption.originalStatus;
            break;
        }

        // even though the options do not appear in UI
        // we need to save them in the approval XML with false values
        if (_this10.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.InvoiceSelected]) {
          action.RequestEveryTime = false;
        }
        if (!_this10.useHierarchyApproval || !_this10.$store.state[__WEBPACK_IMPORTED_MODULE_8__option_rules___default.a.ProgramBudgetSelected]) {
          action.UseHierarchyApproval = false;
        }
        return selectedOption;
      });
      if (RolesList.length > 0) {
        if (!action.Roles) {
          action.Roles = {};
        }
        action.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role] = RolesList.length === 1 ? RolesList[0] : RolesList;
      } else {
        action.Roles = null;
      }
      if (UsersList.length > 0) {
        if (!action.Users) {
          action.Users = {};
        }
        action.Users[__WEBPACK_IMPORTED_MODULE_1__type___default.a.user] = UsersList.length === 1 ? UsersList[0] : UsersList;
      } else {
        action.Users = null;
      }
      var updatedAction = utils.copy(action);
      var copyselectedOp = utils.copy(action.__selectedOp);
      this.__selectedGlobalOptions.map(function (option, index) {
        if (copyselectedOp.filter(function (o) {
          return o.Uid === option.Uid;
        }).length !== 0 && action.__selectedOptions.filter(function (o) {
          return o.Uid === option.Uid;
        }).length === 0) {
          _this10.__selectedGlobalOptions.splice(index, 1);
        }
      });
      action.__selectedOp = utils.copy(action.__selectedOptions);
      this.updateAction(action.Id, updatedAction);
    },
    updateAction: function updateAction(actionId, updatedAction) {
      delete updatedAction.__selectedOptions;
      delete updatedAction.__selectedContextType;
      delete updatedAction.__selectedAdditionalOptions;
      delete updatedAction.__o;
      delete updatedAction.actionValues;
      delete updatedAction.__selectedOp;
      delete updatedAction._parallelRouteNo;
      var payload = {
        Id: actionId,
        Action: updatedAction
      };
      this.$emit('updateAction', payload);
    },
    addAction: function addAction(newAction) {
      newAction.Id = this.max(this.$store.state.approvalRuleIds.actionIds) + 1;
      this.$store.state.approvalRuleIds.actionIds.push(newAction.Id);
      var copyNewAction = utils.copy(newAction);
      if (this.processedActions.constructor === Array) {
        this.processedActions.push(this.applyActionContext(copyNewAction));
        var sanitizedNewAction = utils.copy(newAction);
        delete sanitizedNewAction.__selectedOptions;
        delete sanitizedNewAction.__selectedContextType;
        delete sanitizedNewAction.__selectedAdditionalOptions;
        delete sanitizedNewAction.__o;
        delete sanitizedNewAction.actionValues;
        delete sanitizedNewAction.__selectedOp;
        delete sanitizedNewAction._parallelRouteNo;
        this.$emit('addActionLine', sanitizedNewAction);
        return;
      }
    },
    matchStatus: function matchStatus(item) {
      return item === 'true';
    },
    deleteConditionModal: function deleteConditionModal(action) {
      this.showDeleteModal = true;
      this.deleteTarget = action;
    },
    deleteActionLine: function deleteActionLine() {
      var _this11 = this;
      this.processedActions.splice(this.processedActions.indexOf(this.deleteTarget), 1);
      this.deleteTarget.__selectedOp.map(function (option) {
        if (_this11.__selectedGlobalOptions.filter(function (o) {
          return o.Uid === option.Uid;
        }).length !== 0) {
          var index = _this11.__selectedGlobalOptions.map(function (op) {
            return op.Uid;
          }).indexOf(option.Uid);
          _this11.__selectedGlobalOptions.splice(index, 1);
        }
      });
      this.$emit('deleteLine', this.deleteTarget);
      this.enableSaveButton();
    },
    copyActionLine: function copyActionLine(index) {
      var newAction = utils.copy(this.processedActions[index]);
      var id = this.max(this.$store.state.approvalRuleIds.actionIds) + 1;
      newAction.Id = id;
      this.$store.state.approvalRuleIds.actionIds.push(id);
      var sanitizedNewAction = utils.copy(newAction);
      delete sanitizedNewAction.__selectedOptions;
      delete sanitizedNewAction.__selectedContextType;
      delete sanitizedNewAction.__selectedAdditionalOptions;
      delete sanitizedNewAction.__o;
      delete sanitizedNewAction.actionValues;
      delete sanitizedNewAction.__selectedOp;
      delete sanitizedNewAction._parallelRouteNo;
      this.processedActions.splice(index + 1, 0, newAction);
      this.$emit('copyLine', sanitizedNewAction);
      this.enableSaveButton();
    },
    resetActionLine: function resetActionLine(action, e) {
      var _this12 = this;
      this.enableSaveButton();
      var copyselectedOp = utils.copy(action.__selectedOp);
      var copyselectedOptions = utils.copy(action.__selectedOptions);
      this.__selectedGlobalOptions.map(function (option) {
        if (copyselectedOp.filter(function (o) {
          return o.Uid === option.Uid;
        }).length !== 0 && copyselectedOptions.filter(function (o) {
          return o.Uid === option.Uid;
        }).length !== 0) {
          _this12.__selectedGlobalOptions.splice(_this12.__selectedGlobalOptions.indexOf(option), 1);
        }
      });
      action['@xsi:type'] = this.contextTypeMap.filter(function (key) {
        return __WEBPACK_IMPORTED_MODULE_5__context_type___default.a[key] === e.label;
      })[0];
      action.Operator = null;
      action.__selectedOptions = [];
      action.__selectedContextType = '';
      action.__selectedAdditionalOptions = this.getAdditionalOptions(action);
      action.__o = [{}];
      action.__selectedOp = [];
      action.Values = null;
      action.Roles = {
        RoleDTO: null
      };
      action.Users = {
        UserDTO: null
      };
      action._parallelRouteNo = {
        label: '',
        id: null
      };
      action.ParallelRouteNo = null;
      this.$store.state.routeNumbers.splice(this.$store.state.routeNumbers.indexOf(action._parallelRouteNo.id), 1);
      this.setOptions(action, e);
      var updatedAction = utils.copy(action);
      this.updateAction(action.Id, updatedAction);
    },
    resetActionOperator: function resetActionOperator(action, e) {
      action.Operator = this.operatorTypeMap.filter(function (key) {
        return __WEBPACK_IMPORTED_MODULE_6__operator_type___default.a[key] === e;
      })[0];
      var updatedAction = utils.copy(action);
      this.updateAction(action.Id, updatedAction);
    },
    changeActionOperator: function changeActionOperator(action, e) {
      action.Operator = this.operatorTypeMap.filter(function (key) {
        return __WEBPACK_IMPORTED_MODULE_6__operator_type___default.a[key] === e;
      })[0];
      var updatedAction = utils.copy(action);
      this.updateAction(action.Id, updatedAction);
      this.enableSaveButton();
    },
    changeOperator: function changeOperator(e) {
      this.rule.ActionOperator = e === this.actionOperators[0] ? 'StepByStep' : 'Simultaneously';
      var updatedOperator = utils.copy(this.rule.ActionOperator);
      this.$emit('changeOperator', updatedOperator);
      this.enableSaveButton();
    },
    changeRouteNo: function changeRouteNo(action, e) {
      if (this.$store.state.routeNumbers.indexOf(parseInt(action._parallelRouteNo.id)) > -1) {
        this.$store.state.routeNumbers.splice(this.$store.state.routeNumbers.indexOf(parseInt(action._parallelRouteNo.id)), 1);
      }
      this.$store.state.routeNumbers.push(parseInt(e.id));
      action._parallelRouteNo = typeof action.ParallelRouteNo !== 'undefined' && this.useParallelApprovalRoutes ? {
        label: this.routesValuesMap.filter(function (key) {
          return __WEBPACK_IMPORTED_MODULE_11__route_values___default.a.routeNumber[key] === e.id;
        })[0],
        id: parseInt(e.id)
      } : {
        label: '',
        id: null
      };
      action.ParallelRouteNo = parseInt(e.id);
      var updatedAction = utils.copy(action);
      this.updateAction(action.Id, updatedAction);
      this.enableSaveButton();
    },
    enableSaveButton: function enableSaveButton() {
      approvalRuleUtils.utils.enableSaveButton(!this.$store.state.enableSaveButton);
    },
    formatLabel: function formatLabel(value) {
      if (typeof value !== 'string') return value;
      return value.replace('Program', this.programLabel);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "0SPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"dawn-tab ghost"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0TFE":
/***/ (function(module, exports) {

module.exports = {"_id":"English (US)","login":{"cta":"Please login with your email and password","Email":"E-mail","Password":"Password","emailHint":"Email","passwordHint":"Password","button":"Login"},"pageNotSupported":"Oops! It seems that this page is not supported.","clear.cancel":"Clear","clear.default":"Default"}

/***/ }),

/***/ "0VFA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_34mZBiTJlzj7U4IxhlID4K","Dell":"_7_Lyy18bEIFfDf5_1MM_L","Abbott":"_3wky0KU725cHVOHjw2tA67","Gap":"_2-sYH-67Hmc2mf6O6CnH-4","Allstate":"_3IJJtvYMyfodo_xiP0Bes8","Asurion":"vgp636e3Gu5dFhGeVtr7c","Invitae":"_2ZMcmskKj07sPQuqfdeh_q","JWE":"_1MQxyGJMyQBHge4b5sQQd2"};

/***/ }),

/***/ "0VFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$router.replace({
      path: '/'
    });
  }
});

/***/ }),

/***/ "0YHh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('grid',{ref:"BusinessUnitsGrid",attrs:{"model":_vm.getModel,"name":"","label":"Business Unit","desc":"","views":false,"layout":"frame","search":"","endpoint":_vm.api.$.BUAndCC.getBusinessUnits,"actions":_vm.actions,"remove-many":"","fit-columns":""},on:{"removeRow":_vm.removeBU,"removeRows":_vm.removeBUs,"changeRow":_vm.editBU}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.addBU}},[_vm._v("Add BU")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0cyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTransactionNumber_vue__ = __webpack_require__("/436");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c8a58a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTransactionNumber_vue__ = __webpack_require__("ztSI");
function injectStyle (ssrContext) {
  __webpack_require__("Hfpp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58c8a58a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTransactionNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c8a58a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTransactionNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0eis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dawnSelect__content-table-wrapper"},[_c('div',{staticClass:"dawnSelect__content-table-body-wrapper"},[_c('div',{staticClass:"dawnSelect__content-table-row-wrapper"},[(_vm.thumbnails)?_c('div',{staticClass:"dawnSelect__content-table-image-wrapper"},[_vm._t("image")],2):_vm._e(),_c('div',{staticClass:"dawnSelect__content-table-content-wrapper"},[_vm._t("row1"),_vm._t("row2"),_vm._t("row3"),_vm._t("row4"),_vm._t("row5"),_vm._t("row6")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0kLI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Toolbar__ = __webpack_require__("fGtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FundingAddress_vue__ = __webpack_require__("OA49");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CorrectApFile',
  components: {
    toolbar: __WEBPACK_IMPORTED_MODULE_3__Toolbar__["a" /* default */],
    FundingAddress: __WEBPACK_IMPORTED_MODULE_4__components_FundingAddress_vue__["a" /* default */]
  },
  data: function data() {
    var id = Number((this.$route.query || {}).id || 0);
    return {
      id: id,
      busy: false,
      apiApFileUrl: '',
      apFileName: '',
      fundingAddressModel: null,
      form: {
        fundingAddress: "",
        paymentNotes: ''
      },
      email: {
        to: '',
        cc: '',
        bcc: '',
        subject: '',
        message: ''
      },
      correctedApFile: null,
      extraFiles: [],
      fundingStatementUrl: '',
      fundingStatementName: '',
      auditFileId: 0,
      fundingInvoiceId: 0,
      showFsReplace: false,
      fsPaymentNotes: '',
      fsUploadFinished: true,
      fsAttachmentFiles: null,
      fsAttachmentMissingError: false,
      fsDisplayUploadError: false,
      fsUploadError: '',
      showApReplace: false,
      apReplaceNotes: '',
      apUploadFinished: true,
      apAttachmentFiles: null,
      apAttachmentMissingError: false,
      apDisplayUploadError: false,
      apUploadError: ''
    };
  },
  computed: {
    apFileUrl: function apFileUrl() {
      return this.apiApFileUrl || '/ProgramFusion/GenerateAuditFile?auditFileID=' + this.id;
    },
    correctedApName: function correctedApName() {
      return this.correctedApFile ? this.correctedApFile.name : '';
    },
    extraFileNames: function extraFileNames() {
      return Array.prototype.map.call(this.extraFiles || [], function (f) {
        return f.name;
      });
    },
    messageHtml: function messageHtml() {
      var raw = this.email && this.email.message || '';
      var escaped = raw.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      var withLinks = escaped.replace(/([\w.+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g, '<a href="mailto:$1">$1</a>');
      return withLinks.replace(/\n/g, '<br/>');
    },
    fsUploadSettings: function fsUploadSettings() {
      return {
        folder: 'Temp/',
        token: this.$user.sessionSettings.AspxToken,
        fileType: 'pdf',
        renameFile: this.fsAttachmentFiles && this.fsAttachmentFiles[0] ? this.fsAttachmentFiles[0].name : undefined
      };
    },
    canReplaceFs: function canReplaceFs() {
      return !!(this.uploadToken || this.token);
    },
    apUploadSettings: function apUploadSettings() {
      return {
        folder: 'Temp/',
        token: this.$user.sessionSettings.AspxToken,
        fileType: 'excel/csv',
        renameFile: this.apAttachmentFiles && this.apAttachmentFiles[0] ? this.apAttachmentFiles[0].name : undefined
      };
    }
  },
  created: function created() {
    this.loadData(false);
  },
  methods: {
    loadData: function loadData(isReversal) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var _yield$_this$api$get, r, formatted;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _this.busy = true;
              _context.next = 4;
              return _this.api.get(_this.api.$.payment.getReversalOrCorrectApFileInfo, {
                params: {
                  apFileId: _this.id,
                  isReversal: isReversal
                }
              });
            case 4:
              _yield$_this$api$get = _context.sent;
              r = _yield$_this$api$get.data;
              _this.fundingAddressModel = _this.normalizeAddressModel(r.FundingAddress) || _this.fundingAddressModel;
              formatted = _this.formatFundingAddress(_this.fundingAddressModel) || _this.form.fundingAddress;
              _this.form.fundingAddress = formatted;
              _this.email.to = r.To || _this.email.to;
              _this.email.cc = typeof r.Cc === 'string' ? r.Cc : _this.email.cc;
              _this.email.subject = r.Subject || _this.email.subject;
              _this.email.message = _this.cleanBackendMessage(r.EmailBody || '');
              _this.apiApFileUrl = r.APFileUrl || _this.apiApFileUrl;
              _this.fundingStatementUrl = r.FundingStatementUrl || _this.fundingStatementUrl;
              _this.fundingStatementName = _this.pickFundingStatementName(r) || _this.fundingStatementName || '';
              _this.apFileName = r.AuditFileNumber || _this.apFileName;
              _this.auditFileId = r.AuditFileId || r.ApFileId || _this.id || 0;
              _this.fundingStatementId = r.FundingInvoiceId || 0;
              _context.next = 24;
              break;
            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              console.warn('Failed to load AP info', _context.t0);
            case 24:
              _context.prev = 24;
              _this.busy = false;
              return _context.finish(24);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 21, 24, 27]]);
      }))();
    },
    onChangeAddress: function onChangeAddress(addr) {
      if (typeof addr === 'string') {
        this.form.fundingAddress = addr;
      } else {
        this.fundingAddressModel = this.normalizeAddressModel(addr);
        this.form.fundingAddress = this.formatFundingAddress(this.fundingAddressModel);
      }
    },
    normalizeAddressModel: function normalizeAddressModel(addr) {
      if (!addr) return null;
      if (typeof addr === 'string') {
        try {
          return JSON.parse(addr);
        } catch (e) {
          return {
            Raw: addr
          };
        }
      }
      return addr;
    },
    formatFundingAddress: function formatFundingAddress(addr) {
      if (!addr) return '';
      if (addr.Raw && typeof addr.Raw === 'string') return addr.Raw;
      if (typeof addr === 'string') return addr;
      var parts = [addr.Name || addr.Company, addr.Address1, addr.Address2, [addr.City, addr.State || addr.Province, addr.PostalCode].filter(Boolean).join(', '), addr.Country].filter(Boolean);
      return parts.join('\n');
    },
    cleanBackendMessage: function cleanBackendMessage(html) {
      if (!html) return '';
      var s = String(html);
      s = s.replace(/<br\s*\/?>/gi, '\n');
      s = s.replace(/<a[^>]*href=["']mailto:([^"']+)["'][^>]*>[\s\S]*?<\/a>/gi, '$1');
      s = s.replace(/<\/?[^>]+>/g, '');
      s = s.replace(/&nbsp;/gi, ' ').replace(/&amp;/gi, '&').replace(/&lt;/gi, '<').replace(/&gt;/gi, '>').replace(/&quot;/gi, '"').replace(/&#39;/g, "'");
      s = s.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
      return s;
    },
    pickFundingStatementName: function pickFundingStatementName(r) {
      if (!r) return '';
      var src = r.FundingStatementUrl || '';
      if (!src) return '';
      try {
        var u = new URL(src, window.location.origin);
        var m = u.pathname.match(/GenerateFundingInvoicePdf\/([^/?#]+)/i);
        if (m && m[1]) return m[1];
        var inv = u.searchParams.get('fundingInvoiceId');
        if (inv) return inv;
      } catch (e) {
        var m2 = String(src).match(/GenerateFundingInvoicePdf\/([^/?#]+)/i);
        if (m2 && m2[1]) return m2[1];
      }
      if (r.FundingInvoiceId) return String(r.FundingInvoiceId);
      return '';
    },
    triggerCorrected: function triggerCorrected() {
      this.$refs.correctedInput && this.$refs.correctedInput.click();
    },
    onCorrectedAp: function onCorrectedAp(e) {
      this.correctedApFile = (e.target.files || [])[0] || null;
    },
    triggerExtra: function triggerExtra() {
      this.$refs.extraInput && this.$refs.extraInput.click();
    },
    onExtraFiles: function onExtraFiles(e) {
      this.extraFiles = e.target.files || [];
    },
    cancel: function cancel() {
      this.$router.push('/i/Programs/Invoice-AP/');
    },
    getFileExtension: function getFileExtension(fileName) {
      if (/[.]/.exec(fileName)) {
        var ext = /[^.]+$/.exec(fileName);
        if (ext && ext.length > 0) return ext[0];
      }
      return 'pdf';
    },
    isJson: function isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    parseFundingStatementIdFromUrl: function parseFundingStatementIdFromUrl(src) {
      if (!src) return 0;
      try {
        var u = new URL(src, window.location.origin);
        var qs = u.searchParams.get('fundingStatementId') || u.searchParams.get('fundingInvoiceId');
        if (qs) return Number(qs) || 0;
        var m = u.pathname.match(/Funding(?:Statement|Invoice)\w*\/(\d+)/i);
        if (m && m[1]) return Number(m[1]) || 0;
      } catch (e) {
        var m2 = String(src).match(/(\d+)/);
        if (m2 && m2[1]) return Number(m2[1]) || 0;
      }
      return 0;
    },
    onFsClose: function onFsClose() {
      this.showFsReplace = false;
      this.fsAttachmentFiles = [];
      this.fsPaymentNotes = '';
      this.fsAttachmentMissingError = false;
    },
    fsIsValid: function fsIsValid() {
      var valid = this.fsAttachmentFiles && this.fsAttachmentFiles.length > 0;
      this.fsAttachmentMissingError = !valid;
      return valid;
    },
    onFsSave: function onFsSave() {
      if (!this.fsIsValid()) return;
      this.doReplaceFundingStatement();
    },
    onFsUploadComplete: function onFsUploadComplete(e) {
      var _this2 = this;
      var completed = e.filter(function (item) {
        return item.success || !item.success && item.response && typeof item.response === 'string' && !_this2.isJson(item.response);
      });
      if (completed.length >= 1) this.fsAttachmentMissingError = false;
      if (completed.length === e.length) {
        this.fsUploadFinished = true;
        e.forEach(function (item) {
          var resp = null;
          if (item.success && item.response) {
            resp = JSON.parse(item.response);
            _this2.fsUploadError = resp && resp.uploadError ? resp.uploadError : '';
          }
          if (!item.success) _this2.fsUploadError = 'Upload request failed';
        });
        if (this.fsUploadError) this.fsDisplayUploadError = true;
        this.fsAttachmentFiles = e.filter(function (item) {
          return item.success && JSON.parse(item.response).success;
        });
      } else {
        this.fsUploadFinished = false;
      }
    },
    doReplaceFundingStatement: function doReplaceFundingStatement() {
      var _this3 = this;
      var uploadedFile = '';
      var fileName = '';
      if (this.fsAttachmentFiles && this.fsAttachmentFiles.length > 0) {
        var fileItem = this.fsAttachmentFiles[0];
        try {
          var resp = JSON.parse(fileItem.response);
          if (resp && resp.success) {
            uploadedFile = resp.file;
            fileName = resp.fileName || fileItem.name;
          }
        } catch (e) {
          console.warn('Failed to parse upload response', e);
        }
      }
      this.api.post(this.api.$.payment.replaceFundingStatement, {
        fundingStatementId: this.fundingStatementId,
        uploadedFile: uploadedFile,
        additionalNote: this.fsPaymentNotes
      }).then(function () {
        _this3.fundingStatementName = fileName;
        _this3.onFsClose();
      }).catch(function (err) {
        _this3.fsUploadError = 'CorrectFundingStatement failed';
        _this3.fsDisplayUploadError = true;
        console.warn('CorrectFundingStatement error', err);
      });
    },
    onApClose: function onApClose() {
      this.showApReplace = false;
      this.apAttachmentFiles = [];
      this.apReplaceNotes = '';
      this.apAttachmentMissingError = false;
    },
    apIsValid: function apIsValid() {
      var valid = this.apAttachmentFiles && this.apAttachmentFiles.length > 0;
      this.apAttachmentMissingError = !valid;
      return valid;
    },
    onApSave: function onApSave() {
      if (!this.apIsValid()) return;
      this.doReplaceApFile();
    },
    onApUploadComplete: function onApUploadComplete(e) {
      var _this4 = this;
      var completed = e.filter(function (item) {
        return item.success || !item.success && item.response && typeof item.response === 'string' && !_this4.isJson(item.response);
      });
      if (completed.length >= 1) this.apAttachmentMissingError = false;
      if (completed.length === e.length) {
        this.apUploadFinished = true;
        e.forEach(function (item) {
          var resp = null;
          if (item.success && item.response) {
            try {
              resp = JSON.parse(item.response);
              _this4.apUploadError = resp && resp.uploadError ? resp.uploadError : '';
            } catch (err) {
              _this4.apUploadError = '';
            }
          }
          if (!item.success) _this4.apUploadError = 'Upload request failed';
        });
        if (this.apUploadError) this.apDisplayUploadError = true;
        this.apAttachmentFiles = e.filter(function (item) {
          try {
            return item.success && JSON.parse(item.response).success;
          } catch (err) {
            return false;
          }
        });
      } else {
        this.apUploadFinished = false;
      }
    },
    doReplaceApFile: function doReplaceApFile() {
      var _this5 = this;
      var uploadedFile = '';
      var fileName = '';
      if (this.apAttachmentFiles && this.apAttachmentFiles.length > 0) {
        var fileItem = this.apAttachmentFiles[0];
        try {
          var resp = JSON.parse(fileItem.response);
          if (resp && resp.success) {
            uploadedFile = resp.file;
            fileName = resp.fileName || fileItem.name;
          }
        } catch (e) {
          console.warn('Failed to parse upload response', e);
        }
      }
      this.api.post(this.api.$.payment.correctApFile, {
        auditFileId: this.auditFileId || this.id || 0,
        uploadedFile: uploadedFile,
        additionalNote: this.apReplaceNotes
      }).then(function () {
        _this5.apFileName = fileName;
        _this5.onApClose();
      }).catch(function (err) {
        _this5.apUploadError = 'Correct AP File failed';
        _this5.apDisplayUploadError = true;
        console.warn('Correct AP File error', err);
      });
    },
    send: function send() {
      var _this6 = this;
      this.busy = true;
      var fd = new FormData();
      fd.append('isReversal', false);
      var auditFile = {
        FundingInvoiceId: this.fundingStatementId || 0,
        AuditFileId: this.auditFileId || 0,
        Subject: this.email.subject || '',
        To: this.email.to || '',
        Bcc: this.email.bcc || '',
        Cc: this.email.cc || '',
        Message: this.email.message || '',
        EmailBody: this.rawEmailBody || this.email.message || '',
        AuditFileNumber: this.apFileName || '',
        FundingAddress: this.fundingAddressModel || {}
      };
      var _appendFormData = function appendFormData(data) {
        var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        for (var key in data) {
          var value = data[key];
          var formKey = root ? "".concat(root, ".").concat(key) : key;
          if (value === null || value === undefined) continue;
          if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(value) === 'object' && !(value instanceof File)) {
            _appendFormData(value, formKey);
          } else {
            fd.append("auditFile.".concat(formKey), value);
          }
        }
      };
      _appendFormData(auditFile);
      if (this.extraFiles && this.extraFiles.length) {
        this.extraFiles.forEach(function (f) {
          return fd.append('auditFile.Attachments', f);
        });
      }
      this.api.post(this.api.$.payment.sendReversalOrCorrectedApFile, fd).then(function () {
        return _this6.cancel();
      }).catch(function (err) {
        return console.warn('Send correct failed', err);
      }).finally(function () {
        _this6.busy = false;
      });
    }
  }
});

/***/ }),

/***/ "0mfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    icon: String,
    title: String,
    href: String
  }
});

/***/ }),

/***/ "0nwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewEmailPage_vue__ = __webpack_require__("IS7y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311b06aa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewEmailPage_vue__ = __webpack_require__("eOek");
function injectStyle (ssrContext) {
  __webpack_require__("VTbA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-311b06aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewEmailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311b06aa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewEmailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0pAm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_lang__ = __webpack_require__("pe4m");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      text: '',
      columnTitle: ''
    };
  },
  created: function created() {
    this.columnTitle = this.params.colDef.headerName;
  },
  methods: {
    t: function t(key) {
      return __WEBPACK_IMPORTED_MODULE_0__lang_lang__["a" /* i18n */].t(key);
    },
    getModel: function getModel() {
      return {
        filter: this.text
      };
    },
    setModel: function setModel(model) {
      if (model && model.filter) {
        this.text = model.filter;
      }
      if (model === null) {
        this.text = '';
      }
    },
    isFilterActive: function isFilterActive() {
      return this.text !== null && this.text !== undefined && this.text !== '';
    },
    doesFilterPass: function doesFilterPass(params) {
      return ~params.data[this.params.column.colId].toString().toLowerCase().indexOf(this.text.toLowerCase());
    },
    apply: function apply() {
      this.params.filterChangedCallback();
    }
  }
});

/***/ }),

/***/ "0zcJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("bc6u");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15ae5c0b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Rdd0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15ae5c0b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "11RA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCard_vue__ = __webpack_require__("E5ao");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6146f606_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCard_vue__ = __webpack_require__("dQfM");
function injectStyle (ssrContext) {
  __webpack_require__("5wL5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6146f606"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6146f606_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "127V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"jtCKOkDcDn1U1sttcPVle","Dell":"_3Od7wT7f2658zMBU2_Jni3","Abbott":"_38OjEb8xP72oILGjUa2mde","Gap":"_30J9JrjTvQQXfZm6Pidi-4","Allstate":"_2iEjqBqbHh-jngI_ZoD0z","Asurion":"BIAcqshuOOKUv53tUV6pT","Invitae":"Z7EGHiFXhhjkyIYRe42ZL","JWE":"_16XiDfTzFpN11OlDGKwuUP"};

/***/ }),

/***/ "12TM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"HpJ0iKrffPOrYieyc54iZ","Dell":"_359rCzSlC7rvfGcbCCjCes","Abbott":"_1PvwRBdc-DOB7e5Asd0i8-","Gap":"_3CNUS-yu6nO7BS6K46MWGw","Allstate":"A8vv9-DJlWMRJfmOAVlZ4","Asurion":"_1AwR6pHP7zU2dyCBfL0y8L","Invitae":"_3S76r5gO3iWy-L_NBO1SLA","JWE":"_37TUT3kJQPMNwfZMAewcjZ"};

/***/ }),

/***/ "14bo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * Available white-labels
 *
 * @returns {Object.<Promise>} default - list of available themes
 * @param {string} [property]          - theme alias
 * @param {string} webpackChunkName    - theme pack
 * @param {string} import(arg)         - path to theme
 *
 */
var themes = {};
var whiteLabels = ['docs', 'default', 'Apple', 'Dell'];
whiteLabels.forEach(function (key) {
  themes[key] = function () {
    return __webpack_require__("ZEOY")("./".concat(key, "/theme.scss"));
  };
});
/* harmony default export */ __webpack_exports__["a"] = ({
  app: themes,
  domains: {
    default: 'default',
    // 'alt.dozainer.com': 'Apple',
    'www.dozainer.org': 'Dell'
  }
});

/***/ }),

/***/ "14vj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.fieldLabel)?_c('label',[_vm._v("\n    "+_vm._s(_vm.fieldLabel)+"\n    "),(!_vm.required && !_vm.hideOptional)?_c('em',{staticClass:"optional"},[_vm._v("  - optional")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.helptipBody && _vm.showPopup || _vm.helptipBody && _vm.error || _vm.$slots.info)?_c('ed-input-tooltip',{class:{ "error-message": _vm.error },attrs:{"helptipHeader":_vm.$slots.info ? "" : _vm.helptipHeader,"helptipBody":_vm.$slots.info ? "" : _vm.helptipBody,"errorTip":_vm.error}},[_vm._t("info",null,{"slot":"info"})],2):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.closePopup),expression:"closePopup"}],staticClass:"datepicker",class:{ "shortcuts": !_vm.range && _vm.shortcuts },style:({"width": _vm.placement === "inline" ? "100%" : _vm.width + "px", "min-width": _vm.range ? (_vm.type === "datetime" ? "320px" : "210px") : "140px"})},[(!_vm.range)?_c('input',{ref:"input",class:[_vm.inputClass, _vm.error ? "error" : ""],attrs:{"type":"text","placeholder":_vm.innerPlaceholder,"disabled":_vm.disabled},domProps:{"value":_vm.text},on:{"click":_vm.togglePopup,"keyup":_vm.keyMonitor,"change":_vm.changeDate}}):_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden),expression:"!hidden"}],staticClass:"range-input"},[_c('ed-input',{class:{'small': true, 'inline': true,'compact': _vm.compact},attrs:{"hide-optional":"","placeholder":"Select Date","field-label":"From","value":_vm.value && _vm.stringify(_vm.value[0])}}),_vm._v(" "),(_vm.compact)?_c('span',[_vm._v(" - ")]):_vm._e(),_vm._v(" "),_c('ed-input',{class:{'small': true, 'inline': true,'compact': _vm.compact},attrs:{"hide-optional":"","placeholder":"Select Date","field-label":"To","value":_vm.value && _vm.stringify(_vm.value[1])}})],1),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden),expression:"!hidden"}],staticClass:"input-icon input-icon__calendar",on:{"click":_vm.clickIcon}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopup || _vm.fit),expression:"showPopup || fit"}],ref:"calendar",class:{ 'datepicker-popup': true, 'range': _vm.range, 'fit': _vm.fit && !_vm.range, 'inline': _vm.placement === 'inline' },style:(_vm.position)},[(!_vm.range)?[_c('calendar-panel',{class:{ "fit": _vm.fit },attrs:{"show":_vm.showPopup || _vm.fit},on:{"select":_vm.selectDate},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})]:[_c('div',{class:{ 'range-wrapper': true, 'fit': _vm.fit }},[_c('div',{staticClass:"calendars-wrapper"},[_c('div',{staticClass:"navigator"},[_c('ed-button',{attrs:{"href":"#","button-class":"navigator-arrow"},on:{"click":_vm.moveToPrevRange}},[_c('i',{staticClass:"fas fa-chevron-circle-left"})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('ed-button',{attrs:{"href":"#","button-class":"navigator-arrow"},on:{"click":_vm.moveToNextRange}},[_c('i',{staticClass:"fas fa-chevron-circle-right"})])],1),_vm._v(" "),_c('calendar-panel',{staticStyle:{"width":"50%"},attrs:{"end-at":_vm.currentValue[1],"show":_vm.showPopup || _vm.fit,"range":""},on:{"select":_vm.selectDate},model:{value:(_vm.currentValue[0]),callback:function ($$v) {_vm.$set(_vm.currentValue, 0, $$v)},expression:"currentValue[0]"}}),_vm._v(" "),_c('calendar-panel',{staticStyle:{"width":"50%"},attrs:{"start-at":_vm.currentValue[0],"show":_vm.showPopup || _vm.fit,"range":""},on:{"select":_vm.selectDate},model:{value:(_vm.currentValue[1]),callback:function ($$v) {_vm.$set(_vm.currentValue, 1, $$v)},expression:"currentValue[1]"}})],1),_vm._v(" "),(_vm.ranges.length)?_c('div',{staticClass:"range-links-wrapper"},_vm._l((_vm.ranges),function(range){return _c('span',{staticClass:"range-quick-link",on:{"click":function($event){return _vm.selectRange(range)}}},[_vm._v(_vm._s(range.text))])}),0):_vm._e()])],_vm._v(" "),(_vm.confirm !== false)?_c('div',{class:{ 'datepicker-footer': true, 'has-ranges': _vm.ranges.length }},[_c('ed-button',{staticClass:"btn-actionbar",on:{"click":_vm.confirmDate}},[_vm._v(_vm._s(_vm.confirm === true ? "Confirm" : _vm.confirm))])],1):_vm._e()],2)]),_vm._v(" "),_vm._t("shortcuts",function(){return [(_vm.shortcuts.length)?_c('span',_vm._l((_vm.shortcuts),function(date){return _c('a',{key:date.key,staticClass:"shortcut-label",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.selectShortcut(date.key)}}},[_vm._v(_vm._s(date.label))])}),0):_vm._e()]}),_vm._v(" "),(_vm.helpText)?_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.helpText))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "15+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__multiselectMixin__ = __webpack_require__("h8o0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointerMixin__ = __webpack_require__("MlyN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_components_edInputTooltip__ = __webpack_require__("7npE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_components_edCheckbox_checkbox__ = __webpack_require__("+qQe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-select',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"], __WEBPACK_IMPORTED_MODULE_2__multiselectMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__pointerMixin__["a" /* default */]],
  props: {
    decodeEntities: Boolean,
    hideOptional: Boolean,
    icon: String,
    required: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    fieldLabel: {
      type: String,
      default: ''
    },
    title: String,
    helptipHeader: String,
    helptipBody: String,
    name: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: 'Press enter to select'
    },
    selectedLabel: {
      type: String,
      default: 'Selected'
    },
    deselectLabel: {
      type: String,
      default: 'Press enter to remove'
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 99999
    },
    maxHeight: {
      type: Number,
      default: 200
    },
    limitText: {
      type: Function,
      default: function _default(count) {
        return "and ".concat(count, " more");
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    openDirection: {
      type: String,
      default: ''
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    error: Boolean,
    checkboxes: Boolean,
    multilist: Boolean,
    hidden: {
      type: Boolean,
      default: false
    },
    serverSearch: Boolean
  },
  directives: {
    focus: {
      inserted: function inserted(el, binding) {
        if (binding.value) el.focus();else el.blur();
      },
      componentUpdated: function componentUpdated(el, binding) {
        if (binding.modifiers.lazy) {
          if (Boolean(binding.value) === Boolean(binding.oldValue)) {
            return;
          }
        }
        if (binding.value) el.focus();else el.blur();
      }
    }
  },
  components: {
    'ed-input-tooltip': __WEBPACK_IMPORTED_MODULE_4__core_components_edInputTooltip__["default"],
    'checkbox': __WEBPACK_IMPORTED_MODULE_5__core_components_edCheckbox_checkbox__["default"]
  },
  created: function created() {
    this.closeOnSelect = this.checkboxes === true ? false : this.closeOnSelect;
    this.clearOnSelect = this.checkboxes === true ? false : this.clearOnSelect;
    this.title && this.$on('open', this.updateBox);
  },
  watch: {
    options: function options(newV, oldV) {
      var _this = this;
      this.title && this.updateBox();
      this.selectedPointerSet(undefined, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, this.trackBy, (this.getValue() || {})[this.trackBy]));
      this.$nextTick(function () {
        _this.$refs.list.scrollTop = _this.selectedPointerPosition;
      });
    }
  },
  data: function data() {
    return {
      focused: false,
      toolbarStyle: {}
    };
  },
  computed: {
    selectedGroup: function selectedGroup() {
      var groups = this.options;
      var options = this.groupValues;
      var key = this.trackBy;
      var firstSelectedKey = this.selectedValues[0] && this.selectedValues[0][key];
      return groups.find(function (group) {
        return group[options] && group[options].find(function (option) {
          return option[key] === firstSelectedKey;
        });
      }) || groups[0];
    },
    visibleValue: function visibleValue() {
      return this.multiple || this.multilist || this.checkboxes ? this.internalValue.slice(0, this.limit) : [];
    },
    deselectLabelText: function deselectLabelText() {
      return this.showLabels ? this.deselectLabel : '';
    },
    selectLabelText: function selectLabelText() {
      return this.showLabels ? this.selectLabel : '';
    },
    selectedLabelText: function selectedLabelText() {
      return this.showLabels ? this.selectedLabel : '';
    },
    // inputStyle () {
    //  if (this.multiple && this.value && this.value.length) {
    //    // Hide input by setting the width to 0 allowing it to receive focus
    //    return this.isOpen ? { 'width': 'auto' } : { 'width': '0', 'position': 'absolute' }
    //  }
    // },
    displayedValueStyle: function displayedValueStyle() {
      var extraText = ~this.currentOptionLabel.indexOf('|');
      var longText = this.currentOptionLabel.length > 20;
      if (extraText || longText) {
        return {
          // fontSize: '12px',
          textOverflow: 'ellipsis'
        };
      }
      return null;
    },
    displayedValueTitle: function displayedValueTitle() {
      var extraText = ~this.currentOptionLabel.indexOf('|');
      var longText = this.currentOptionLabel.length > 20;
      if (extraText || longText) {
        return this.currentOptionLabel;
      }
      return null;
    },
    contentStyle: function contentStyle() {
      return this.options.length ? {
        'display': 'inline-block'
      } : {
        'display': 'block'
      };
    },
    isAbove: function isAbove() {
      // never open above
      return false;
    },
    isOver: function isOver() {
      return this.openDirection === 'over';
    },
    shownValue: function shownValue() {
      var val = this.internalValue;
      return val[0] && (this.label ? val[0][this.label] : val[0]) + ' ' + (val.length > 1 ? this.limitText(val.length - 1) : '');
    }
  },
  methods: {
    apply: function apply() {
      this.$emit('apply', this.internalValue);
      this.deactivate();
    },
    selectGroup: function selectGroup(v) {
      var _this2 = this;
      this.selectedGroupAfter = this.options.filter(function (group) {
        return v[_this2.groupLabel] === group[_this2.groupLabel];
      })[0];
      this.options = this.options.concat(null);
      this.options.pop();
    },
    updateBox: function updateBox() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.toolbarStyle = {
          'margin-top': "".concat(_this3.$refs.list.clientHeight, "px")
        };
      });
    },
    optionTooltip: function optionTooltip(option, index) {
      var shouldDisplayTooltip = (this.$refs.options && this.$refs.options[index] && this.$refs.options[index].children[0].offsetWidth) > (this.$refs.list && this.$refs.list.offsetWidth) - 40;
      return {
        content: shouldDisplayTooltip ? this.getOptionLabel(option) : '-',
        classes: [shouldDisplayTooltip ? 'option-tooltip' : 'hide']
      };
    }
  }
});

/***/ }),

/***/ "15rp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "19h7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programs_vue__ = __webpack_require__("PZSu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5898698b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_programs_vue__ = __webpack_require__("D53q");
function injectStyle (ssrContext) {
  __webpack_require__("s7CT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5898698b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5898698b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_programs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1CWy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_loginService__ = __webpack_require__("6SW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_legacy_auth_gotoV3__ = __webpack_require__("UYvm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_notifications__ = __webpack_require__("euHs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__core_events_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_clickaway__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import tour from '@/components/tour'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-meta-nav',
  mixins: [__WEBPACK_IMPORTED_MODULE_6_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      featureFlags: __WEBPACK_IMPORTED_MODULE_1__core_feature_flags_feature_flags__["a" /* default */],
      showDropdown: false,
      showNotifications: false,
      events: __WEBPACK_IMPORTED_MODULE_5__core_events_events___default.a.queue,
      newEvents: []
    };
  },
  computed: {
    notificationsCenter: function notificationsCenter() {
      // return this.events && this.events.length ? 'javascript:;' : '#/i/Admin/UserNotification/GetNotificationCenter'
      return 'javascript:;';
    },
    accounts: function accounts() {
      return this.$user.sessionSettings && this.$user.sessionSettings.UserCompanies || {};
    },
    hasAccounts: function hasAccounts() {
      return Object.keys(this.accounts).length > 1;
    },
    currentCompany: function currentCompany() {
      return this.$user.$.data.CompanyName;
    },
    hasEoAdminAccount: function hasEoAdminAccount() {
      return this.$user.sessionSettings && this.$user.sessionSettings.HasEoAdminAccount;
    }
  },
  methods: {
    switchAccount: function switchAccount() {
      var _this = this;
      var account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var id = account.id;
      if (!id) {
        this.$router.push({
          query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
            switchAccount: ''
          })
        });
        return;
      }
      if (account.name === this.currentCompany) {
        if (account.type === 1) {
          __WEBPACK_IMPORTED_MODULE_3__core_legacy_auth_gotoV3__["b" /* navigateToV3Home */].call(this);
        }
        if (this.$router.currentRoute.name === 'switchaccount') {
          window.history.go(-2);
        }
        return;
      }
      this.api.get(this.api.$.initLegacy, {
        params: {
          'companyId': id
        }
      });
      this.api.get(this.api.$.settings.my.switch, {
        params: {
          companyId: id
        }
      }).then(function (settings) {
        var redirectUrl = settings.data && settings.data.RedirectUrl;
        if (redirectUrl) {
          global.location.href = redirectUrl;
        } else {
          var user = settings.data && settings.data.UserLogin;
          if (user) {
            // user.sk = 'dummy'
            __WEBPACK_IMPORTED_MODULE_2__components_Login_loginService__["b" /* setUser */].call(_this, user);
            __WEBPACK_IMPORTED_MODULE_2__components_Login_loginService__["c" /* setUserSettings */].call(_this, settings, null, {
              returnUrl: ''
            }, !__WEBPACK_IMPORTED_MODULE_1__core_feature_flags_feature_flags__["a" /* default */].legacyViewDisabled);
            _this.$routerHistory.push(_this.$route.path);
            // window.location.reload()

            __WEBPACK_IMPORTED_MODULE_3__core_legacy_auth_gotoV3__["b" /* navigateToV3Home */].call(_this, user);
          }
        }
      });
    },
    switchToEoAdminAccount: function switchToEoAdminAccount() {
      this.api.get(this.api.$.settings.my.switchToEoAdmin).then(function (r) {
        var redirectUrl = r.data;
        if (redirectUrl) {
          redirectUrl = new URL(redirectUrl);
          redirectUrl.host = window.location.host;
          redirectUrl.pathname = window.location.pathname;
          global.location.href = redirectUrl;
        }
      });
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
      this.$root.masked = this.showDropdown;
    },
    toggleNotifications: function toggleNotifications() {
      this.showNotifications = !this.showNotifications;
      this.$root.masked = this.showNotifications;
      if (this.showNotifications && this.newEvents.length) this.markAsRead();
    },
    markAsRead: function markAsRead() {
      this.api.forms.post(this.api.$.common.readNotifications, {
        appNotifications: this.newEvents
      });
    },
    logout: function logout() {
      this.$user.logout();
    },
    helpsite: function helpsite() {
      return this.$user.$.data.IsE360 === true ? 'https://eved.my.site.com/EventCompany/s/' : this.$user.$.data.MarketTypeID === 1 ? 'https://eved.my.site.com/Client/s/' : 'https://eved.my.site.com/Supplier/s/';
    }
    /* ,
    tour() {
      tour.reset()
      tour.show(this.$route)
    } */
  },
  created: function created() {
    var vm = this;

    // get notifications
    this.api.get(this.api.$.common.notifications).then(function (r) {
      vm.events = r.data.Data;
      vm.newEvents = vm.events.filter(function (notification) {
        return notification.IsViewed === false;
      }).map(function (notification) {
        return notification.AppNotificationId;
      });
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "1FKg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3xhNePSOFyLNNG3oTR50og","Dell":"_1pOxF07PZisFGPNjQ9WdJr","Abbott":"_3E-UkoBpwfzTObctGOHcAI","Gap":"_3jiZ4Vte5KuqSo2XV0EH28","Allstate":"_2rQmSL4Y9siDDQutfw4Sl9","Asurion":"_3TtjD_utsiSJllNXhd4T-d","Invitae":"_3DvbHCuoMKtzcEqO9mKKWP","JWE":"NdoFUeixQXDlnzdwTxm8k"};

/***/ }),

/***/ "1Fv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_cells_actions__ = __webpack_require__("ayPo");

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    var model = {
      'PaymentInvoiceId': '_',
      'InvoiceNumber': {
        label: 'Invoice',
        width: 120,
        getter: getInvoiceNumberPDFLink
      },
      MediaCode: {
        label: 'Attachment',
        width: 100,
        getter: getAttachmentPDF
      },
      'InitialTotalAmount': {
        label: 'Initial Amount',
        width: 110
      },
      'FinalAmount': {
        label: 'Amount',
        width: 110
      },
      Scanner: {
        label: 'Scanned by',
        width: 120
      },
      Reviewer: {
        label: 'Reviewer',
        type: 'text',
        width: 110
      },
      Client: {
        label: 'Client',
        width: 160
      },
      Planner: {
        label: 'Submitted By',
        width: 130
      },
      Created: {
        label: 'Date Submitted',
        type: 'text',
        width: 110
      },
      Completed: {
        label: 'Date Scanned',
        type: 'text',
        width: 110
      }
    };
    return model;
  }
});
function getAttachmentPDF(params) {
  if (params && params.data && params.data.AttachmentURL) {
    params.node.uri = params.colDef.uri = params.data.AttachmentURL;
    params.value = params.data.MediaCode;
    params.newTab = true;
    return __WEBPACK_IMPORTED_MODULE_0__components_Grid_cells_actions__["f" /* gotoCustom */].template(params);
  } else {
    return '';
  }
}
function getInvoiceNumberPDFLink(params) {
  if (params && params.data && params.data.ScannedInvoicePDFURL) {
    params.node.uri = params.colDef.uri = params.data.ScannedInvoicePDFURL;
    params.value = params.data.InvoiceNumber;
    params.newTab = true;
    return __WEBPACK_IMPORTED_MODULE_0__components_Grid_cells_actions__["f" /* gotoCustom */].template(params);
  } else {
    return '';
  }
}

/***/ }),

/***/ "1IA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__override__ = __webpack_require__("bDlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LegacyContainer__ = __webpack_require__("jIfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Toolbar__ = __webpack_require__("fGtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Invoices_vue__ = __webpack_require__("jHm1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FundingInformation_vue__ = __webpack_require__("N7mj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MakePayment_vue__ = __webpack_require__("KXg4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PostPayment_vue__ = __webpack_require__("Uv1P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SendApFile_vue__ = __webpack_require__("AbMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Snapshot__ = __webpack_require__("9953");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__models_snapshot_model__ = __webpack_require__("udCy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_error_model__ = __webpack_require__("Ex2o");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import invoiceModel from './models/invoices-model'









// import settingsModel from './models/settings-model'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Payment',
  components: {
    legacySteps: __WEBPACK_IMPORTED_MODULE_5__components_LegacyContainer__["a" /* default */],
    invoices: __WEBPACK_IMPORTED_MODULE_7__Invoices_vue__["a" /* default */],
    snapshot: __WEBPACK_IMPORTED_MODULE_12__Snapshot__["a" /* default */],
    makePayment: __WEBPACK_IMPORTED_MODULE_9__MakePayment_vue__["a" /* default */],
    postPayment: __WEBPACK_IMPORTED_MODULE_10__PostPayment_vue__["a" /* default */],
    fundingInformation: __WEBPACK_IMPORTED_MODULE_8__FundingInformation_vue__["a" /* default */],
    sendApFile: __WEBPACK_IMPORTED_MODULE_11__SendApFile_vue__["a" /* default */],
    toolbar: __WEBPACK_IMPORTED_MODULE_6__Toolbar__["a" /* default */]
  },
  activated: function activated() {
    var _this = this;
    this.$nextTick(function () {
      _this.highlightTabs();
      _this.init();
    });
  },
  deactivated: function deactivated() {
    this.clearTabs();
  },
  beforeLeave: function beforeLeave() {
    return this.checkedBeforeLeave;
  },
  data: function data() {
    return {
      disablePaymentAction: false,
      displaySendApFile: false,
      // TODO
      invoicesByDivisionOrBU: [],
      step2Models: [],
      settings: {
        displayFundingCurrencies: false,
        hideFundingEquivalentMessage: false,
        showFundingAddress: false,
        fundingCurrencies: [],
        fundingCurrencyCode: '',
        paymentMethodId: 0,
        paymentMethods: [],
        hasAuditFile: true,
        hasFundingAddressAndAPTemplate: false,
        AchInfo: ''
      },
      snapshot: {
        count: 0,
        totalAmount: 0,
        currencyCode: utils.constants.invoice.USD
      },
      snapshotModel: __WEBPACK_IMPORTED_MODULE_13__models_snapshot_model__["a" /* default */],
      processingErrorModel: __WEBPACK_IMPORTED_MODULE_14__models_error_model__["a" /* default */],
      user: {
        token: ''
      },
      approvalStatus: false,
      usdEquivalent: 0,
      paymentDate: global.moment(new Date()).format(this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat),
      validationErrors: {
        USDEquivalentMissing: false,
        ApprovalCheckboxError: false,
        PaymentDateMissing: false,
        FundingCurrency: false
      },
      checkedBeforeLeave: true,
      fundingAddress: {
        Venue: '',
        Address: '',
        Address2: '',
        CityStateZip: '',
        CountryName: '',
        VatNo: ''
      }
    };
  },
  computed: {
    snapshotSettings: function snapshotSettings() {
      return __WEBPACK_IMPORTED_MODULE_13__models_snapshot_model__["a" /* default */];
    },
    paymentType: function paymentType() {
      return this.$route.query.type;
    },
    paymentKey: function paymentKey() {
      var key = this.$route.query.key;
      if (!key) {
        key = this.utils.cookie.get('PaymentKey');
      }
      return key;
    },
    isMakePayment: function isMakePayment() {
      return this.paymentType === 'make';
    },
    isPostPayment: function isPostPayment() {
      return this.paymentType === 'post';
    },
    pageTitle: function pageTitle() {
      return this.capitalize(this.paymentType) + ' Payment';
    },
    submitPaymentButton: function submitPaymentButton() {
      return this.isPostPayment ? 'Send' : 'Next';
    },
    subtitle: function subtitle() {
      return this.isMakePayment && this.settings.hasAuditFile ? !this.displaySendApFile ? 'Payment Step 1 of 2' : 'Payment Step 2 of 2' : '';
    },
    getInvoiceModelCurrencies: function getInvoiceModelCurrencies() {
      var currencyCodes = [];
      this.invoicesByDivisionOrBU && this.invoicesByDivisionOrBU.length && this.invoicesByDivisionOrBU.map(function (div) {
        div.Invoices.map(function (i) {
          i.CurrencyCode && currencyCodes.push(i.CurrencyCode);
        });
      });

      // return distinct currencyCodes if there are duplicates
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(new Set(currencyCodes));
    },
    isFundingCurrencyDifferent: function isFundingCurrencyDifferent() {
      var result = false;
      this.isMakePayment && this.invoicesByDivisionOrBU && this.invoicesByDivisionOrBU.length && this.invoicesByDivisionOrBU.map(function (div) {
        div.Invoices.map(function (i) {
          if (i.CurrencyCode && i.FundingCurrencyCode && i.CurrencyCode !== i.FundingCurrencyCode) {
            result = true;
          }
        });
      });
      return result;
    }
  },
  methods: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    getInvoices: function getInvoices(division) {
      return division.Invoices;
    },
    back: function back() {
      if (this.mustSave) {
        this.save();
      }
    },
    getFundingCurrencyCode: function getFundingCurrencyCode(division) {
      if (this.isPostPayment) {
        return this.invoicesByDivisionOrBU.length >= 1 && this.invoicesByDivisionOrBU[0].Invoices && this.invoicesByDivisionOrBU[0].Invoices.length >= 1 && this.invoicesByDivisionOrBU[0].Invoices[0].CurrencyCode || null;
      }

      // Make payment
      if (!this.settings.displayFundingCurrencies && division && division.Invoices && division.Invoices[0]) {
        return division.Invoices[0].FundingCurrencyCode;
      }
      return this.settings.fundingCurrencyCode || '';
    },
    getInvoicesSettings: function getInvoicesSettings(division) {
      return {
        divisionOrBUName: division.DivisionOrBUName,
        title: 'Selected Invoices',
        subtitle: this.isMakePayment ? 'Payments are grouped by Division. Specify your payment information below and click Next when complete.' : 'Payments are grouped by Division. Enter the payment method, the reference number if applicable, and any notes in the fields below.',
        editable: true,
        displayUSDEquivalent: this.isMakePayment && !this.settings.hideFundingEquivalentMessage,
        isMakePayment: this.isMakePayment,
        fundingCurrencyCode: this.getFundingCurrencyCode(division),
        isStep2: this.displaySendApFile
      };
    },
    getApFileInvoicesSettings: function getApFileInvoicesSettings(auditFile) {
      var division = this.getDivisionByName(auditFile.DivisionOrBUName);
      var hasTemplateName = (auditFile.AuditFileTemplateName || '') !== '';
      var isGroupedByTemplate = this.settings.hasFundingAddressAndAPTemplate && hasTemplateName;
      return {
        divisionOrBUName: isGroupedByTemplate ? auditFile.AuditFileTemplateName : division.DivisionOrBUName,
        title: 'Message Details',
        subtitle: 'In addition to the selected user, enter the email address of each person or people you would like to copy (CC) or blind carbon copy (BCC) this statement to.',
        editable: false,
        displayUSDEquivalent: this.isMakePayment && !this.settings.hideFundingEquivalentMessage,
        isMakePayment: this.isMakePayment,
        displayDivisionOnExpand: this.isMakePayment && isGroupedByTemplate,
        fundingCurrencyCode: isGroupedByTemplate ? auditFile.FundingCurrencyCode : this.getFundingCurrencyCode(division),
        isStep2: this.displaySendApFile
      };
    },
    getFundingInformationModel: function getFundingInformationModel() {
      return {
        currencies: this.settings.fundingCurrencies,
        displayFundingCurrencies: this.isMakePayment && this.settings.displayFundingCurrencies,
        hideFundingEquivalentMessage: this.settings.hideFundingEquivalentMessage,
        displayUSDEquivalent: this.isPostPayment,
        disableUSDEquivalent: this.allInvoicesAreInUSD(),
        usdEquivalent: this.usdEquivalent,
        disablePaymentDate: this.isMakePayment && !this.settings.AllowScheduledPayments && !this.settings.AllowPostingDate,
        hideDatePickerYesterdayLink: this.isMakePayment && (this.settings.AllowScheduledPayments || this.settings.AllowPostingDate),
        notBeforePaymentDate: this.isMakePayment ? new Date() : null
      };
    },
    amountOnInvoiceWasChanged: function amountOnInvoiceWasChanged() {
      this.setUsdEquivalentTotal();
      this.setSnapshotPaymentAmount();
    },
    setUsdEquivalentTotal: function setUsdEquivalentTotal() {
      if (this.isPostPayment) {
        if (this.allInvoicesAreInUSD()) {
          this.usdEquivalent = this.getInvoicesTotalAmountToPay();
        }
      }
    },
    allInvoicesAreInUSD: function allInvoicesAreInUSD() {
      var allInUSD = true;
      this.invoicesByDivisionOrBU.map && this.invoicesByDivisionOrBU.map(function (div) {
        div.Invoices.map(function (inv) {
          if (inv.CurrencyCode !== 'USD') {
            allInUSD = false;
          }
        });
      });
      return allInUSD;
    },
    getInvoicesTotalAmountToPay: function getInvoicesTotalAmountToPay() {
      var sum = 0;
      this.invoicesByDivisionOrBU.map && this.invoicesByDivisionOrBU.map(function (div) {
        div.Invoices.map(function (inv) {
          sum += Number(inv.Amount) || 0;
        });
      });
      return sum.toFixed(2);
    },
    filterInvoicesForStep2: function filterInvoicesForStep2(auditFile, auditFileTemplateId) {
      var _this2 = this;
      var invoices = [];
      Array.isArray(this.invoicesByDivisionOrBU) && this.invoicesByDivisionOrBU.map(function (div) {
        if (_this2.settings.hasFundingAddressAndAPTemplate && (auditFile.AuditFileTemplateId || 0) > 0) {
          if ((div.AuditFileTemplateId || 0) === (auditFile.AuditFileTemplateId || 0) && (_this2.step2Models.length === 1 || (div.FundingAddressId || 0) === (auditFile.FundingAddressId || 0)) && div.Invoices && div.Invoices.length > 0 && div.Invoices[0].FundingCurrencyCode === auditFile.FundingCurrencyCode && (div.DivisionOrBUName === auditFile.BusinessUnitName || !auditFile.HasAPSettingsByBU)) {
            invoices = invoices.concat(div.Invoices);
          }
        } else if (div.DivisionOrBUName === auditFile.DivisionOrBUName) {
          invoices = div.Invoices;
        }
      });
      return invoices;
    },
    filterSameDayInvoicesForStep2: function filterSameDayInvoicesForStep2(auditFile) {
      var _this3 = this;
      var invoices = [];
      Array.isArray(this.invoicesByDivisionOrBU) && this.invoicesByDivisionOrBU.map(function (div) {
        if (_this3.settings.hasFundingAddressAndAPTemplate && (auditFile.AuditFileTemplateId || 0) > 0) {
          if ((div.AuditFileTemplateId || 0) === (auditFile.AuditFileTemplateId || 0) && (_this3.step2Models.length === 1 || (div.FundingAddressId || 0) === (auditFile.FundingAddressId || 0)) && div.SameDayInvoices && div.SameDayInvoices.length > 0 && div.SameDayInvoices[0].FundingCurrencyCode === auditFile.FundingCurrencyCode) {
            invoices = invoices.concat(div.SameDayInvoices);
          }
        }
      });
      return invoices;
    },
    getDivisionByName: function getDivisionByName(divisionOrBUName) {
      var division = {};
      Array.isArray(this.invoicesByDivisionOrBU) && this.invoicesByDivisionOrBU.map(function (div) {
        if (div.DivisionOrBUName === divisionOrBUName) {
          division = div;
        }
      });
      return division;
    },
    init: function init() {
      var _this4 = this;
      this.displaySendApFile = false;

      // TODO: REMOVE
      // this.goToStep2(JSON.stringify([{'16688': 'Division A <approval>'}]), null)

      return this.getInitAction().then(function (response) {
        _this4.invoicesByDivisionOrBU = response.data.InvoicesByDivisionOrBU;
        _this4.settings.displayFundingCurrencies = response.data.CanSelectFundingCurrency;
        _this4.settings.hideFundingEquivalentMessage = response.data.HideFundingEquivalentMessage;
        _this4.settings.fundingCurrencies = response.data.FundingCurrencies;
        _this4.settings.showFundingAddress = response.data.ShowFundingAddress;
        _this4.settings.fundingCurrencyCode = response.data.FundingCurrencyCode;
        _this4.settings.paymentMethodId = response.data.PaymentMethodId;
        _this4.settings.paymentMethods = response.data.PaymentMethods;
        _this4.settings.hasAuditFile = response.data.HasAuditFile;
        _this4.settings.hasFundingAddressAndAPTemplate = response.data.HasFundingAddressAndAPTemplate;
        _this4.settings.AchInfo = response.data.AchInfo;
        _this4.settings.AllowScheduledPayments = response.data.AllowScheduledPayments;
        _this4.settings.AllowPostingDate = response.data.AllowPostingDate;
        _this4.initSnapshot();
        _this4.setUsdEquivalentTotal();
        _this4.user.token = response.data.Token;
        _this4.doCurrencyConversion({
          CurrencyCode: response.data.FundingCurrencyCode
        });
      });
    },
    getInitAction: function getInitAction() {
      return this.paymentKey.length > 1900 ? this.api.post(this.api.$.payment.init, {
        key: this.paymentKey,
        paymentType: this.paymentType
      }) : this.api.get(this.api.$.payment.init, {
        params: {
          key: this.paymentKey,
          paymentType: this.paymentType
        }
      });
    },
    initSnapshot: function initSnapshot() {
      this.setSnapshotPaymentsNo();
      this.setSnapshotPaymentAmount();
    },
    setSnapshotPaymentsNo: function setSnapshotPaymentsNo() {
      var count = 0;
      this.invoicesByDivisionOrBU && this.invoicesByDivisionOrBU.map(function (div) {
        count += div.Invoices.length;
      });
      this.snapshotModel.count = count;
    },
    setSnapshotPaymentAmount: function setSnapshotPaymentAmount() {
      var _this5 = this;
      var paymentAmount = 0;
      var fundCurrencyCode = null;
      this.invoicesByDivisionOrBU && this.invoicesByDivisionOrBU.map(function (div) {
        div.Invoices.map(function (inv) {
          if (!inv.IsSameDayDeposit) {
            if (fundCurrencyCode === null) {
              fundCurrencyCode = _this5.getFundingCurrencyCode(div);
            }
            paymentAmount += Number(_this5.isPostPayment || inv.CurrencyCode === fundCurrencyCode ? inv.Amount : inv.AmountUSD) || 0;
          }
        });
      });
      this.snapshotModel.totalAmount = paymentAmount;
      this.snapshotModel.currencyCode = fundCurrencyCode;
    },
    resetJSONmodel: function resetJSONmodel() {
      // reset submission approval
      this.approvalStatus = false;
    },
    cancel: function cancel(checkedBeforeLeave) {
      this.checkedBeforeLeave = checkedBeforeLeave || false;
      var tab = '';
      var subtab = '';
      var url = '/i/Programs/Invoice-received/';
      if (this.$route.query.from) {
        if (this.$route.query.from.toLowerCase().trim() === 'programinvoices') {
          // Program dashboard > Invoices tab
          url = '/i/Programs/Program-list/?goto=PaymentInvoice/ProgramInvoiceList/' + (typeof this.$route.query.programId !== 'undefined' ? this.$route.query.programId : 0);
          tab = 'Commerce';
          subtab = 'Invoices';
        } else if (this.$route.query.from.toLowerCase().trim().indexOf('poinvoices') === 0) {
          // PO Details > Invoices tab
          url = '/i/Programs/Program-list/?goto=PaymentInvoiceFusion' + (typeof this.$route.query.poId !== 'undefined' ? this.$route.query.poId : 0);
          tab = 'Commerce';
          subtab = 'ProgramList';
        }
      }
      if (tab !== '' && subtab !== '') {
        this.$root.legacyTab = tab;
        this.$root.legacySubtab = subtab;
      }
      this.$router.push(url);
    },
    validate: function validate() {
      var _this6 = this;
      var valid = this.approvalStatus;
      // Payment Date
      if (!this.paymentDate) {
        this.validationErrors.PaymentDateMissing = true;
        valid = false;
      } else {
        this.validationErrors.PaymentDateMissing = false;
      }

      // Approval checkbox
      if (!this.approvalStatus) {
        this.validationErrors.ApprovalCheckboxError = true;
      } else {
        this.validationErrors.ApprovalCheckboxError = false;
      }
      if (this.isMakePayment) {
        if (this.settings.fundingCurrencyCode === null || this.settings.fundingCurrencyCode === '') {
          this.validationErrors.FundingCurrency = true;
          valid = false;
        }
      }
      if (this.isPostPayment) {
        this.invoicesByDivisionOrBU.map(function (div) {
          __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].PAYMENT.VALIDATE_POST_PAYMENT_FIELDS + _this6.invoicesByDivisionOrBU.indexOf(div));

          // Paid By
          if (div.DisplayPaidBy && (!div.PaidBy || div.PaidBy === null || div.PaidBy === '')) {
            valid = false;
          }

          // Payment Method
          if ((div.PaymentMethodId || 0) === 0) {
            valid = false;
          }

          // Reference No
          if (!div.ReferenceNo || div.ReferenceNo === null || div.ReferenceNo === '') {
            valid = false;
          }

          // Cost Center
          if (div.ValidateCostCenter && div.CostCenters.length > 0 && (div.CostCenterId || 0) === 0) {
            valid = false;
          }
        });
      }

      // validate grid values
      var invalidGrid = false;
      this.$refs.invoicesComp.map(function (div) {
        if (div.$refs.PaymentInvoices.validateCells()) {
          invalidGrid = true;
        }
      });
      if (invalidGrid) {
        valid = false;
      }
      this.checkedBeforeLeave = true;
      return valid;
    },
    validateAndSubmit: function validateAndSubmit() {
      var valid = this.validate();
      if (valid) {
        this.submit();
      } else {
        this.showErrorPopup();
      }
    },
    showErrorPopup: function showErrorPopup() {
      if (this.validationErrorTitle) {
        this.showValidationError = true;
      }
    },
    getInfoToSubmitPayments: function getInfoToSubmitPayments() {
      var _this7 = this;
      var paymentInfo = [];
      var amountsByEvent = {};
      var paymentMethodId = this.settings.paymentMethodId;
      this.invoicesByDivisionOrBU.map(function (div) {
        var itemInfo = {
          ReceiverID: 0,
          HasUSDEquivalent: !_this7.isPostPayment,
          currencyCode: _this7.settings.fundingCurrencyCode,
          paymentMethod: div.PaymentMethodId || paymentMethodId,
          paymentNotes: div.PaymentNotes,
          auditFileTemplateId: div.AuditFileTemplateId,
          fundingAddressId: div.FundingAddressId
        };
        if (_this7.isPostPayment) {
          if (div.ValidateCostCenter) {
            itemInfo.costCenter = div.CostCenterId || '';
          }
          itemInfo.referenceNo = div.ReferenceNo;
          if (div.DisplayPaidBy) {
            itemInfo.paymentMethodMSP = div.PaidBy;
          }
          itemInfo.attachmentFile = div.Attachment.AttachmentFile;
          itemInfo.attachmentSize = div.Attachment.AttachmentSize;
          itemInfo.attachmentName = div.Attachment.AttachmentName;
        }
        var receiverVendorIds = [];
        var invoiceIds = [];
        div.Invoices.map(function (inv) {
          itemInfo.PaymentNote = inv.PaymentNote;
          if (receiverVendorIds.indexOf(inv.SupplierVendorId) === -1) {
            receiverVendorIds.push(inv.SupplierVendorId);
          }
          invoiceIds.push(inv.PaymentInvoiceId);
          inv.Events.map(function (ev) {
            amountsByEvent[ev.InvoiceRequestPaymentId] = ev.Balance;
          });
        });
        if (receiverVendorIds.length > 1) {
          itemInfo.ReceiverIDList = receiverVendorIds.join(',');
        } else if (receiverVendorIds.length === 1) {
          itemInfo.ReceiverID = receiverVendorIds[0];
        }
        itemInfo.ItemIDList = invoiceIds.join(',');
        paymentInfo.push(itemInfo);
      });
      return {
        paymentInfo: paymentInfo,
        amountsByEvent: amountsByEvent
      };
    },
    submit: function submit() {
      var _this8 = this;
      var data = this.getInfoToSubmitPayments();

      // disable action
      this.disablePaymentAction = true;
      this.api.post(this.api.$.payment.submit, {
        key: this.paymentKey,
        paymentInfo: data.paymentInfo,
        amountsByEvent: data.amountsByEvent,
        paymentType: this.paymentType,
        fundingCurrencyCode: this.settings.fundingCurrencyCode,
        usdEquivalent: this.usdEquivalent,
        paymentDate: this.paymentDate,
        fundingAddress: this.fundingAddress
      }).then(function (response) {
        var msg = response.data.SuccessMessage;

        // re-enable action
        _this8.disablePaymentAction = false;
        if (msg === 'Error') {
          _this8.showProcessingError(response.data.Data);
        } else if (msg === 'SetupAuditFile') {
          _this8.goToStep2(response.data.Data, null);
        } else if (msg === 'SendFundingInvoice') {
          _this8.goToStep2(null, response.data.Data);
        } else {
          _this8.cancel(true);
        }
      }).catch(function (e) {
        _this8.disablePaymentAction = false;
      });
    },
    showProcessingError: function showProcessingError(r) {
      if (!r || r === null || r === '') {
        this.processingErrorModel.display = true;
        this.processingErrorModel.headerLabel = 'Something went wrong.';
      } else {
        this.processingErrorModel.display = true;
        this.processingErrorModel.errors = [];
        var errors = JSON.parse(r);
        for (var i = 0; i < errors.length; i++) {
          if (i === 0) {
            // Main Error
            this.processingErrorModel.headerLabel = errors[i].Message;
          } else if (i === 1) {
            // header
            this.processingErrorModel.columns = errors[i].Message.split('_____');
          } else {
            // invoices with error
            var items = errors[i].Message.split('_____');
            var rows = [];
            for (var k = 0; k < items.length; k++) {
              var err = {
                message: items[k],
                url: ''
              };
              if (err.message && err.message.indexOf('[') !== -1 && err.message.indexOf(']') !== -1) {
                // has URL
                var arr = err.message.split('[');
                err.message = arr[0];
                err.url = arr[1].replace(']', '');
              }
              rows.push(err);
            }
            this.processingErrorModel.errors.push(rows);
          }
        }
      }
    },
    formatStep2Parameter: function formatStep2Parameter(apFileIdsByDivision, fundingInvoiceIdsByDivision) {
      var itemsToProcess = [];
      if (apFileIdsByDivision != null) {
        var ids = JSON.parse(apFileIdsByDivision);
        for (var key in ids) {
          if (ids.hasOwnProperty(key)) {
            itemsToProcess.push({
              AuditFileId: Number(key) || 0,
              DivisionOrBUName: ids[key]
            });
          }
        }
      }
      if (fundingInvoiceIdsByDivision != null) {
        var _ids = JSON.parse(fundingInvoiceIdsByDivision);
        for (var _key in _ids) {
          if (_ids.hasOwnProperty(_key)) {
            itemsToProcess.push({
              FundingInvoiceId: Number(_key) || 0,
              DivisionOrBUName: _ids[_key]
            });
          }
        }
      }
      return itemsToProcess;
    },
    goToStep2: function goToStep2(apFileIdsByDivision, fundingInvoiceIdsByDivision) {
      var _this9 = this;
      var itemsToProcess = this.formatStep2Parameter(apFileIdsByDivision, fundingInvoiceIdsByDivision);
      this.api.post(this.api.$.payment.initApFiles, {
        ids: itemsToProcess
      }).then(function (response) {
        _this9.step2Models = response.data;
        _this9.displaySendApFile = true;
      });
    },
    getInfoToSendApFiles: function getInfoToSendApFiles() {
      var _this10 = this;
      var result = [];
      this.step2Models.map(function (itm) {
        result.push({
          AuditFileId: itm.ApFileId,
          FundingInvoiceId: itm.FundingInvoiceId,
          /* AuditFileTemplateId: itm.AuditFileTemplateId,
          FundingAddressId: itm.FundingAddressId, */
          Cc: itm.Cc,
          Bcc: itm.Bcc,
          Message: itm.Message,
          Attachments: itm.Attachments,
          FundingAddress: _this10.fundingAddress
        });
      });
      return result;
    },
    sendApFiles: function sendApFiles() {
      var _this11 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this11.disablePaymentAction = true;
              _context.prev = 1;
              data = _this11.getInfoToSendApFiles();
              _context.next = 5;
              return _this11.checkPaymentProcessingFinished(data);
            case 5:
              _this11.api.post(_this11.api.$.payment.sendApFiles, {
                auditFiles: data
              }).then(function (response) {
                _this11.disablePaymentAction = false;
                _this11.resetFundingAddress();
                _this11.cancel(true);
              }).catch(function (e) {
                _this11.disablePaymentAction = false;
              });
              _context.next = 10;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    resetFundingAddress: function resetFundingAddress() {
      var _this12 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this12.fundingAddress = {
                Venue: '',
                Address: '',
                Address2: '',
                CityStateZip: '',
                CountryName: '',
                VatNo: ''
              };
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    checkPaymentProcessingFinished: function checkPaymentProcessingFinished(data) {
      var _this13 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var isPaymentProcessingFinished;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              isPaymentProcessingFinished = true;
              _context3.next = 3;
              return _this13.api.post(_this13.api.$.payment.checkPaymentProcessingFinished, {
                auditFiles: data
              }).then(function (response) {
                var msg = response.data.SuccessMessage;
                if (msg === 'Error') {
                  _this13.showCheckProcessingError();
                  // re-enable action
                  _this13.disablePaymentAction = false;
                  isPaymentProcessingFinished = false;
                }
              }).catch(function (e) {
                _this13.disablePaymentAction = false;
              });
            case 3:
              if (isPaymentProcessingFinished) {
                _context3.next = 5;
                break;
              }
              throw new Error('Processing did not finish');
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    showCheckProcessingError: function showCheckProcessingError() {
      global.alert('The funding statement has not been fully generated, please try again in a few seconds.');
    },
    apFileChanges: function apFileChanges(e) {
      this.step2Models.map(function (itm) {
        if (itm.DivisionOrBUName === e.divisionOrBUName) {
          itm.Cc = e.cc;
          itm.Bcc = e.bcc;
          itm.Message = e.message;
          itm.Attachments = e.attachments;
        }
      });
    },
    fundingInfoChanged: function fundingInfoChanged(e) {
      if (typeof e.Approval === 'boolean') {
        this.approvalStatus = e.Approval;
        if (e.From && utils.constants.invoice.ApprovalCheckbox && e.From === utils.constants.invoice.ApprovalCheckbox) {
          return;
        }
      }
      if (typeof e.CurrencyCode === 'string' && e.CurrencyCode !== '') {
        this.settings.fundingCurrencyCode = e.CurrencyCode;
        this.doCurrencyConversion(e);
      }
      if (typeof e.USDEquivalent === 'number') {
        this.usdEquivalent = e.USDEquivalent;
        if (this.usdEquivalent !== 0) {
          this.validationErrors.USDEquivalentMissing = false;
        }
      }
      if (typeof e.PaymentDate === 'string') {
        this.paymentDate = e.PaymentDate;
      }
      this.emitRefreshCurrencyChanged();
    },
    emitRefreshCurrencyChanged: function emitRefreshCurrencyChanged() {
      this.$refs.invoicesComp && this.$refs.invoicesComp.forEach(function (div) {
        return div.$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].PAYMENT.FUNDING_CURRENCY_CHANGED);
      });
    },
    doCurrencyConversion: function doCurrencyConversion(e, cb) {
      var _this14 = this;
      var paymentInvoiceId = e.PaymentInvoiceId;
      var fundingCurrencyCodeGlobal = e.CurrencyCode;
      var conversionData = {
        Divisions: []
      };
      this.invoicesByDivisionOrBU.map(function (div) {
        if (div.Invoices.length > 0) {
          var fundingCurrencyCode = _this14.settings.displayFundingCurrencies ? fundingCurrencyCodeGlobal // selected currency at payment run
          : div.Invoices[0].FundingCurrencyCode /* TODO: add variable to div */ || fundingCurrencyCodeGlobal; // currency at division level (or the global one)

          var division = _this14.createDivisionConversionObj(div, fundingCurrencyCode);

          // Invoices
          div.Invoices.map(function (invoice) {
            if (paymentInvoiceId && invoice.PaymentInvoiceId === paymentInvoiceId || !paymentInvoiceId) {
              division.Invoices.push(_this14.createInvoiceConversionObject(invoice));
            }
          });
          conversionData.Divisions.push(division);
        }
      });
      this.changeFundingCurrency(conversionData, cb);
    },
    createDivisionConversionObj: function createDivisionConversionObj(division, fundingCurrencyCode) {
      return {
        DivisionId: division.Invoices[0].DivisionId,
        BusinessUnitId: division.Invoices[0].BusinessUnitId,
        DivisionOrBUName: division.DivisionOrBUName,
        FundingCurrencyCode: fundingCurrencyCode,
        Invoices: []
      };
    },
    createInvoiceConversionObject: function createInvoiceConversionObject(invoice) {
      return {
        ItemID: invoice.PaymentInvoiceId,
        CurrencyCode: invoice.CurrencyCode,
        ToPayAmount: invoice.Amount
      };
    },
    changeFundingCurrency: function changeFundingCurrency(conversionData, cb) {
      var _this15 = this;
      this.api.post(this.api.$.payment.changeFundingCurrency, {
        conversionData: conversionData
      }).then(function (response) {
        if (response.SuccessMessage !== 'Error') {
          _this15.changeInvoiceModelAfterConversion(response.data, cb);
          _this15.setSnapshotPaymentAmount();
        }
      });
    },
    changeInvoiceModelAfterConversion: function changeInvoiceModelAfterConversion(paymentObj, cb) {
      var _this16 = this;
      var match = null;
      paymentObj && paymentObj.Divisions && paymentObj.Divisions.map(function (item) {
        _this16.invoicesByDivisionOrBU = _this16.invoicesByDivisionOrBU.map(function (div) {
          // match divisions
          if (div.DivisionOrBUName === item.DivisionOrBUName) {
            item.Invoices.map(function (paymentOnCurrencyItem) {
              div.Invoices = div.Invoices.map(function (invoice) {
                // match invoices
                if (invoice.PaymentInvoiceId === paymentOnCurrencyItem.ItemID) {
                  invoice.AmountUSD = paymentOnCurrencyItem.ToPayAmountFundedCurrency;
                  match = div.Invoices;
                  if (_this16.settings.displayFundingCurrencies) {
                    invoice.FundingCurrencyCode = item.FundingCurrencyCode;
                  }
                }
                return invoice;
              });
              return paymentOnCurrencyItem;
            });
          }
          return div;
        });
      });
      //
      if (match && match.length) {
        typeof cb === 'function' && cb(match);
      }
    },
    makePaymentFieldsChanges: function makePaymentFieldsChanges(e) {
      var _this17 = this;
      this.invoicesByDivisionOrBU.map(function (div) {
        if (div.DivisionOrBUName === e.divisionOrBUName) {
          div.PaymentNote = e.note;
          div.PaymentMethodId = _this17.settings.paymentMethodId;
        }
      });
    },
    postPaymentFieldsChanged: function postPaymentFieldsChanged(e) {
      this.invoicesByDivisionOrBU.map(function (div) {
        if (div.DivisionOrBUName === e.divisionOrBUName) {
          div.PaymentMethodId = e.paymentMethodId;
          div.PaymentNotes = e.note;
          div.ReferenceNo = e.referenceNo;
          div.CostCenterId = e.costCenterId;
          div.ValidateCostCenter = e.validateCostCenter;
          div.PaidBy = e.paidBy;
          div.Attachment = e.attachment;
        }
      });
    },
    highlightTabs: function highlightTabs() {
      this.$root.legacyTab = 'Commerce';
      this.$root.legacySubtab = 'Invoices';
    },
    clearTabs: function clearTabs() {
      var _this18 = this;
      this.$nextTick(function () {
        _this18.$root.legacyTab = _this18.$root.legacySubtab = '';
        _this18.invoicesByDivisionOrBU = {};
        _this18.usdEquivalent = 0;
        _this18.settings.displayFundingCurrencies = false;
        _this18.settings.hideFundingEquivalentMessage = false;
        _this18.settings.fundingCurrencies = [];
        _this18.settings.fundingCurrencyCode = '';
        _this18.settings.paymentMethodId = 0;
        _this18.settings.hideFundingEquivalentMessage = false;
        _this18.settings.hasFundingAddressAndAPTemplate = false;
        _this18.settings.showFundingAddress = false;
        _this18.snapshotModel.count = 0;
        _this18.snapshotModel.totalAmount = 0;
        _this18.snapshotModel.currencyCode = null;
        _this18.processingErrorModel.display = false;
        _this18.validationErrors.USDEquivalentMissing = false;
        _this18.validationErrors.ApprovalCheckboxError = false;
        _this18.validationErrors.PaymentDateMissing = false;
        _this18.validationErrors.FundingCurrency = false;
      });
    },
    changeAddress: function changeAddress(d, i) {
      this.fundingAddress = d;
      this.invoicesByDivisionOrBU[i].FundingAddresses[0].Value = d;
    }
  }
});
Object(__WEBPACK_IMPORTED_MODULE_3__override__["a" /* attach */])();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "1KxB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-filter"},[_c('p',{staticClass:"column-title"},[_vm._v(_vm._s(_vm.columnTitle))]),_c('ed-input',{ref:'input',attrs:{"placeholder":_vm.t("Search"),"search":""},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.apply}},[_vm._v(_vm._s(_vm.t("Apply")))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1P/l":
/***/ (function(module, exports) {

module.exports = {"PoSelected":"po-selected","PoCancelledClosedSelected":"po-cancelled-closed-selected","InvoiceSelected":"invoice-selected","ProgramBudgetSelected":"program-budget-selected"}

/***/ }),

/***/ "1PG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpayrequestaddfunds',
  data: function data() {
    return {
      fundingAmount: '',
      cardId: this.$route.query.cardid,
      accBalance: this.$route.query.accBalance,
      loadingEndpoint: '',
      isDisabled: false
    };
  },
  computed: {
    isUserAdmin: function isUserAdmin() {
      if (this.$user.$.userPermissions.includes('EvedPayCardAdministrator')) {
        return true;
      }
      return false;
    }
  },
  methods: {
    addFunds: function addFunds() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, _response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.isDisabled = true;
              if (!(_this.fundingAmount <= 0 || _this.fundingAmount > _this.accBalance)) {
                _context.next = 5;
                break;
              }
              alert('The amount cannot be 0, negative, or exceed the current balance.');
              _this.isDisabled = false;
              return _context.abrupt("return");
            case 5:
              if (_this.isUserAdmin) {
                _context.next = 20;
                break;
              }
              _this.loadingEndpoint = "evedpaycards/".concat(_this.cardId, "/request-funds");
              _context.prev = 7;
              _context.next = 10;
              return _this.api.post("evedpaycards/".concat(_this.cardId, "/request-funds"), {
                Amount: parseFloat(_this.fundingAmount)
              });
            case 10:
              response = _context.sent;
              if (response.status === 200) {
                __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('fundsAdded');
                _this.$router.push({
                  path: "/evedpay/details?cardid=".concat(_this.cardId),
                  query: _objectSpread(_objectSpread({}, _this.$route.query), _this.$route.query.cardNumber)
                });
              } else {
                alert('Error while requesting funds.');
                _this.isDisabled = false;
              }
              _context.next = 18;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](7);
              _this.isDisabled = false;
              console.error(_context.t0);
            case 18:
              _context.next = 32;
              break;
            case 20:
              _this.loadingEndpoint = "evedpaycards/".concat(_this.cardId, "/add-funds");
              _context.prev = 21;
              _context.next = 24;
              return _this.api.post("evedpaycards/".concat(_this.cardId, "/add-funds"), {
                Amount: parseFloat(_this.fundingAmount)
              });
            case 24:
              _response = _context.sent;
              if (_response.status === 200) {
                __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('fundsAdded');
                _this.$router.push({
                  path: "/evedpay/details?cardid=".concat(_this.cardId),
                  query: _objectSpread(_objectSpread({}, _this.$route.query), _this.$route.query.cardNumber)
                });
              } else {
                alert('Error while requesting funds.');
                _this.isDisabled = false;
              }
              _context.next = 32;
              break;
            case 28:
              _context.prev = 28;
              _context.t1 = _context["catch"](21);
              console.error(_context.t1);
              _this.isDisabled = false;
            case 32:
              _this.fundingAmount = '';
              _this.isDisabled = false;
            case 34:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[7, 14], [21, 28]]);
      }))();
    }
  }
});

/***/ }),

/***/ "1RXC":
/***/ (function(module, exports) {

module.exports = {"GENERIC":{"SELECTED_ALL":"selected-all","UNSELECTED_ALL":"unselected-all","SELECTED_ITEM":"selected","UNSELECTED_ITEM":"unselected","EXPORT":"export","LANGUAGE_CHANGED":"language-changed","WIZARD":{"ENTERED_STEP":"%Viewed wizard Step","UPLOADED_FILE":"%Uploaded file","INVALID":"%Required information not filled","ERRORS":"%Got errors","SUCCESS":"%Successfully completed wizard","RESET":"%Went to first step","ABANDONED":"%Left wizard"},"SELECTED_CHECKBOX":"%Selected checkbox"},"RFP":{"CREATED":"rfp-created","RECEIVED":"rfp-received","SENT":"rfp-sent"},"PROGRAM":{"CREATED":"program-created","RECEIVED":"program-received","SENT":"program-sent"},"EXPENSE":{"IMPORT":{"$":"Expense Import","ENTERED_STEP":"Viewed Expense Import Step","INVALID":"Required expense fields not matched","ERRORS":"Got matching erros","SUCCESS":"Successfully imported expenses","RESET":"Went to first step","ABANDONED":"Left expense import"}},"INVOICE":{"IMPORT":{"$":"Invoice Import","ENTERED_STEP":"Viewed Invoice Import Step","INVALID":"Required invoice fields not matched","ERRORS":"Got matching erros","SUCCESS":"Successfully imported invoices","RESET":"Went to first step","ABANDONED":"Left invoice import"}},"APPROVAL_RULE":{"CONDITION":{"ADDED":"approval-rule-condition-added","REMOVED":"approval-rule-condition-removed","CLONED":"approval-rule-condition-cloned"},"ACTION":{"ADDED":"approval-rule-action-added","REMOVED":"approval-rule-action-removed","CLONED":"approval-rule-action-cloned"},"OPENED":"approval-rule-opened","ADDED":"approval-rule-added","REMOVED":"approval-rule-removed","CLONED":"approval-rule-cloned","SAVED":"approval-rule-saved","DELETED":"approval-rule-deleted","UPDATE_RULE":{"UPDATE_CONDITION":"approval-update-rule-condition","UPDATE_SINGLE_RULE":"approval-update-single-rule","MOVE_RULE":"approval-move-rule"},"REFRESH":"approval-refresh-table","INVALIDATE_RULE":"approval-invalidate-rule","VALIDATION_PASSED":"approval-validation-passed","VALIDATION_COMPLETED":"validation-completed","VALIDATE_COMPONENTS":"validate-components","ENABLE_SAVE_BUTTON":"enable-save-button"},"BU_CC":{"REFRESH":"bu-cc-refresh-table"},"I2P":{"UPDATE_INVOICE_SETTINGS":"updateInvoiceSettings","PROGRAM_SELECTED":"programSelected","BEFORE_PROGRAM_SELECTED":"beforeProgramSelected","CONFIRM_PROGRAM_SELECTED":"confirmProgramSelected","VALIDATE_INVOICE":"validateInvoice","VALIDATION_COMPLETED":"validationCompleted","SUPPLIER_REMOVED":"supplierRemoved","ADDED_NEW_SUPPLIER":"onAddedNewSupplier","CURRENCY_SELECTED":"currencySelected","MAP_INVOICE_INFORMATION_FIELDS":"mapInvoiceInformationFields","MAP_DEFAULT_PAYMENT_TYPE_DISCOUNT":"mapDefaultPaymentTypeAndDiscount","UPDATE_SNAPSHOT":"updateSnapshot","UPDATE_P2P_Snapshot":"updatep2pSnapshot","UPDATE_INVOICE_SCAN_SNAPSHOT":"updateInvoiceScanSnapshot","RECALCULATE_PO":"recalculatePO","DUE_DATE_COMPUTED_ON_INIT":"dueDateComputedOnInit","CHANGE_ALLOCATION":"changeAllocation","INVOICE_AMOUNT_CHANGED":"invoiceAmountChanged","VAT_AMOUNT_CHANGED":"vatAmountChanged","REMOVE_SUPPLIER":"removeSupplier","INVOICE_INITIAL_TOTAL_AMOUNT_CHANGED":"changeInitialTotalAmount","UPDATE_ALLOCATION_MODEL":"updateAllocationModel","INIT_ALLOCATION_MODEL":"initAllocationModel","ADD_CC_FOR_SCAN":"addCCForScan","UPDATE_PO_MODEL":"updatePOModel","UPDATE_PO_MODEL_COMPLETED":"updatePOModelCompleted","PO_AMOUNT_CHANGED":"poAmountChanged","UPDATE_P2P_ITEMS":"updateItems","REMOVE_P2P_PO":"removeP2PPO","SUPPLIER_COUNTRY_CONFIRMED":"supplierCountryConfirmed"},"PAYMENT":{"FUNDING_INFO_CHANGED":"fundingInfoChanged","DIVISION_FIELDS_CHANGES":"paymentChanges","APFILE_FIELDS_CHANGES":"apFileChanges","MAKE_PAYMENT_CONVERSION":"makePaymentCurrencyConversion","PAYMENT_AMOUNT_CHANGED":"amountOnInvoiceWasChanged","VALIDATE_POST_PAYMENT_FIELDS":"validatePostPaymentFields","VALIDATE_MAKE_PAYMENT_FIELDS":"validateMakePaymentFields","FUNDING_CURRENCY_CHANGED":"fundingCurrencyChanged"},"SETTINGS":{"MENU_CHANGED":"menuChanged"},"EVEDPAY_CARDS":{"OPEN_ENVELOPE":"openEnvelope","OPEN_RECONCILE":"openReconcile"}}

/***/ }),

/***/ "1SGE":
/***/ (function(module, exports) {

module.exports = {"maxRoutes":{"2":"2","3":"3","4":"4","5":"5"},"routeNumber":{"1":"1","2":"2","3":"3","4":"4","5":"5","All":"0"}}

/***/ }),

/***/ "1WsA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1YFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"show":_vm.show,"title":_vm.title,"primary-button":"OK","secondary-button":"CANCEL","validation":true,"closeOnEsc":true,"name":"rush_payment"},on:{"close":_vm.onClose,"validate":_vm.onSave}},[_c('div',{staticClass:"content",attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"small"},[_vm._v("\n        You have selected an Invoice Due Date that is earlier than the standard Payment Terms for your company with the supplier.\n         Please enter a Rush Payment Reason to request this Rush Payment.\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"panel panel-danger panel-side no-icon"},[_c('div',{staticClass:"panel-heading"}),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',[_vm._v("\n          This rush payment request has a "+_vm._s(this.model.RushPaymentTermsDays)+"-day payment term,\n          which is "+_vm._s(this.model.DaysEarlier)+" days earlier than the "+_vm._s(this.model.HasDiscountedPaymentTerm ? 'discounted' : 'standard')+" "+_vm._s(this.model.StandardRushPaymentDays)+"-day payment term.\n        ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('ed-textarea',{ref:"reasonText",attrs:{"field-label":"Rush Payment Reason","max-length":250,"rows":4,"required":"","name":"rush_payment_textarea"},on:{"input":_vm.reasonChanged},model:{value:(_vm.reason),callback:function ($$v) {_vm.reason=$$v},expression:"reason"}})],1),_vm._v(" "),_c('br')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1hbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseChartWidget__ = __webpack_require__("wrv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__("nxvh");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__baseChartWidget__["a" /* default */])('invoicePaymentSpend-wdg-cmp', __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]));

/***/ }),

/***/ "1j21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_tabs__ = __webpack_require__("qNdS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("4CTm");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'md-tab',
  props: {
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    NavTabs: __WEBPACK_IMPORTED_MODULE_0__nav_tabs__["a" /* default */]
  },
  computed: {
    hasDefaultSlot: function hasDefaultSlot() {
      return !!this.$slots.default;
    },
    hasTabSlot: function hasTabSlot() {
      return !!this.$slots['tab'];
    },
    hasTabContent: function hasTabContent() {
      return !!this.$slots['content'];
    }
  },
  methods: {
    onTabClick: function onTabClick(tab) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EVENT_ON_TAB_CLICK */], tab);
    }
  }
});

/***/ }),

/***/ "1kRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table",class:_vm.tableClass},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(c){return _c('th',{key:c},[_vm._v(_vm._s(c))])}),0)]),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',{key:item},_vm._l((_vm.columns),function(c){return (_vm.hasValue(item, c))?_c('td',{key:c},[_vm._v(_vm._s(_vm.itemValue(item, c)))]):_vm._e()}),0)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1lw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("1hbq");
/* empty harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1m0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attach; });
var attach = function attach() {};

/***/ }),

/***/ "1oXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content grid",class:"layout-" + _vm.layout},[(_vm.name && _vm.layout === "page")?_c('div',{staticClass:"title"},[_c('ed-title-nav',{class:["grid-navigation-bar", _vm.$slots["overview"] ? "overview" : ""],attrs:{"title":_vm.name,"subtitle":_vm.desc,"tabs":_vm.tabs}},[(_vm.$slots["back-action"])?_vm._t("back-action",null,{"slot":"action"}):_c('span',{attrs:{"slot":"action"},slot:"action"},[(_vm.$routerHistory.hasHistory() && _vm.$route.query["back-to"])?_c('router-link',{attrs:{"to":{ path: _vm.$routerHistory.previous().path, hash: "" }}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_c('span',[_vm._v("  "+_vm._s(_vm.$t('Back') + ' ' + _vm.$t('to') + ' ' + _vm.$t(_vm.$route.query['back-to'])))])]):_vm._e()],1)],2)],1):_vm._e(),(_vm.$slots["overview"])?_c('div',{staticClass:"container"},[_vm._t("overview")],2):_vm._e(),(!_vm.disableFilter)?_c('div',{staticClass:"search bar"},[_c('div',{staticClass:"container"})]):_vm._e(),(!_vm.disableFilter)?_c('div',{staticClass:"filter bar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",class:{ "no-pad": _vm.layout === "frame" }},[(_vm.layout === "page" && _vm.views)?_c('ed-select',{ref:"currentViewList",staticClass:"filter-views inline inline-block ghost label-top",attrs:{"field-label":"Current View","hide-optional":"","searchable":false,"has-toolbar":true,"hide-selected":true,"track-by":"Label","options":_vm.savedViews,"placeholder":"","label":"Label","endpoint":_vm.api.$.common.filterViews,"open-direction":"over","icon":_vm.currentView && _vm.currentView.icon || "fas fa-filter","title":"Saved Views"},on:{"select":function($event){return _vm.applySavedFilter($event)}},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('small',[_c('i',{class:props.option.icon || "action-icon far fa-star option-icon-hover",on:{"click":function($event){$event.stopPropagation();return _vm.setDefaultView(props.option)}}})]),_vm._v("  "+_vm._s(props.option.Label)),(_vm.customViews)?_c('i',{staticClass:"action-icon pull-right fas fa-trash-alt option-icon-hover",on:{"click":function($event){$event.stopPropagation();return _vm.removeView(props.option)}}}):_vm._e()]}}],null,false,2015319375),model:{value:(_vm.currentView),callback:function ($$v) {_vm.currentView=$$v},expression:"currentView"}},[(!_vm.backendSavedViews)?_c('span',{attrs:{"slot":"beforeList"},slot:"beforeList"},[_vm._v("No saved views")]):_vm._e(),(_vm.customViews)?_c('div',{attrs:{"slot":"toolbar"},slot:"toolbar"},[(_vm.backendSavedViews)?_c('span',[_c('label',[_c('small',[_vm._v("Save current table as:")])]),_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"endpoint":_vm.api.$.common.filterViews},on:{"click":_vm.updateView}},[(_vm.currentView)?[_vm._v("Save as ‘"+_vm._s(_vm.currentView.Label)+"’")]:[_vm._v("Save view")]],2)],1):_vm._e(),_c('ed-input',{staticClass:"small box",attrs:{"placeholder":"Save as new view","helptip-header":"","helptip-body":!_vm.viewToBeSavedValid && "That name has already been taken." || "","error":!_vm.viewToBeSavedValid},model:{value:(_vm.viewToBeSaved.label),callback:function ($$v) {_vm.$set(_vm.viewToBeSaved, "label", $$v)},expression:"viewToBeSaved.label"}}),(_vm.currentView && _vm.currentView.Label)?_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"endpoint":_vm.api.$.common.filterViews},on:{"click":_vm.saveView}},[_vm._v("Save")]):_vm._e()],1):_vm._e()]):_vm._e(),(_vm.layout==="page" && _vm.search)?_c('ed-input',{ref:"quickSearch",staticClass:"filter-views search-box- inline label-top",attrs:{"field-label":"Search","hide-optional":"","placeholder":_vm.quickSearchPlaceholder,"xsearch":"","search-box":""},on:{"change":_vm.quickSearch},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}):_vm._e(),(_vm.layout !== "page" && _vm.search)?_c('ed-input',{ref:"quickSearch",staticClass:"search-box",attrs:{"placeholder":_vm.name ? _vm.$t("Search ") + " " + _vm.name : _vm.$t("Search"),"search":""},on:{"change":_vm.quickSearch},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}):_vm._e(),(!_vm.disableFilter && _vm.search && _vm.filters.length)?_c('div',{staticClass:"form-group filters-group"},[(_vm.layout === "page")?_c('label',[_vm._v(" ")]):_vm._e(),_c('ul',{staticClass:"filters ghost",attrs:{"endpoint":_vm.api.$.common.optionsFilter}},[(_vm.filters.length)?_c('li',[_c('a',{staticClass:"filter clear",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeFilters.apply(null, arguments)}}},[_vm._v("clear all filters")]),_c('i',{staticClass:"fas fa-times-circle del-icon",on:{"click":_vm.removeFilters}})]):_vm._e(),_vm._l((_vm.filters),function(filter){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(!~_vm.additionalFilters.indexOf(filter.key)),expression:"!~additionalFilters.indexOf(filter.key)"}],staticClass:"filter"},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:("Click to edit"),expression:"\"Click to edit\""}],staticClass:"filter",attrs:{"href":"#","title":filter.key},on:{"click":function($event){$event.preventDefault();return _vm.editFilter(filter)}}},[_vm._v(_vm._s(filter.column ? ((filter.column) + ": ") : '')+_vm._s(filter.label))]),_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:("Click to remove"),expression:"\"Click to remove\""}],staticClass:"fas fa-times-circle del-icon",on:{"click":function($event){return _vm.removeFilter(filter)}}})])})],2)]):_vm._e()],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._t("additionalLabel")],2)]),_c('div',{staticClass:"row action-buttons"},[_c('div',{staticClass:"col-md-6 col-xs-12 label-bar"},[(!_vm.search)?_c('label',[_vm._v(_vm._s(_vm.label))]):(_vm.additionalFilters.length)?_vm._t("additionalFilters",null,{"filters":_vm.filters}):_c('label',[_vm._v(" ")])],2),_c('div',{staticClass:"col-md-6 xcol-md-offset-4 col-xs-12 col-xs-offset-0 actions-bar"},[_vm._t("additionalButtons"),(this.selectedRows.length || this.allRowsSelected)?_c('span',[_vm._t("selectionButtons")],2):_vm._e(),(_vm.removeMany && (this.selectedRows.length || this.allRowsSelected))?_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.removeRows}},[_vm._v("Delete")]):_vm._e(),(_vm.cloneMany && (this.selectedRows.length || this.allRowsSelected))?_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.cloneRows}},[_vm._v("Duplicate")]):_vm._e(),_vm._v(" "),(_vm.allowExport)?_c('export-data',{attrs:{"endpoint":_vm.exportUri}}):_vm._e(),(this.showColumnSelector)?_c('column-selector',{attrs:{"columns":this.columnDefs,"api":_vm.gridOptions.columnApi}}):_vm._e()],2)])])]):_vm._e(),_c('div',{staticClass:"row grid"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"grid-wrap loading-top list",class:{ "loading": _vm.loading || _vm.pendingRequests > 0 }},[_c('ag-grid-vue',{ref:"grid",staticClass:"grid ag-fresh list",class:{
            "checkboxes": _vm.checkboxes,
            "all-rows-selected": !!_vm.allRowsSelected,
            "draggable": !!_vm.dragRows,
            "editable": !!_vm.editable,
            "editable-on-add": !!_vm.editFullRowOnAdd,
            "shown-details": _vm.shownDetails,
            "popover-open": _vm.shownPopover && _vm.data,
            "no-results-overlay": _vm.data,
            "no-select-all": _vm.noResults() || _vm.hideSelectAll
          },style:(_vm.getSize),attrs:{"endpoint":_vm.endpoint,"gridOptions":_vm.gridOptions,"enableColResize":_vm.resizing}}),(_vm.footer)?_c('div',{staticClass:"bottom-bar"},[_c('ed-button',{staticClass:"refresh-button btn btn-actionbar",on:{"click":_vm.quickSearch}},[_vm._v("Reload")]),_c('span',[_vm._v(_vm._s(_vm.$t('Number of records'))+": "+_vm._s(_vm.noOfRecords))])],1):_vm._e()],1),(_vm.totalsInvalid && _vm.data.length && _vm.enableErrorMessage)?_c('ed-input-tooltip',{class:{ "error-message": _vm.totalsInvalid },attrs:{"helptipHeader":_vm.helptipHeader,"helptipBody":_vm.helptipBody}}):_vm._e(),_vm._l((_vm.Notifications),function(notification,i){return (_vm.canShowNotifications)?_c('ed-input-tooltip',{directives:[{name:"show",rawName:"v-show",value:(_vm.canShowNotifications && !notification.hide && notification.type !== "info"),expression:"canShowNotifications && !notification.hide && notification.type !== \"info\""}],key:(i + "+" + _vm.resetNotifications),staticClass:"error-message error cell-error",style:({ top: (notification.position || {}).offsetTop }),attrs:{"helptipHeader":" ","helptipBody":" "}},[_c('span',{attrs:{"slot":"message"},slot:"message"},[_c(notification.component,{tag:"component"})],1)]):_vm._e()})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1t90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardStatus_vue__ = __webpack_require__("g4pB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a03eb6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardStatus_vue__ = __webpack_require__("hfDE");
function injectStyle (ssrContext) {
  __webpack_require__("dxaE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55a03eb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a03eb6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1uct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locale; });
var locale = {
  getLang: function getLang() {
    if (navigator.languages !== undefined) {
      return navigator.languages[0];
    } else {
      return navigator.language;
    }
  },
  getLocaleThousandSeparator: function getLocaleThousandSeparator() {
    // var n = 1234
    // n = n.toLocaleString(this.getLang()).substring(1, 2)
    // return n

    // FIXME: until proper localization for currency, default to `,`
    return ',';
  },
  getDecimalSeparator: function getDecimalSeparator() {
    // var n = 1.1
    // n = n.toLocaleString(this.getLang()).substring(1, 2)
    // return n

    // FIXME: until proper localization for currency, default to `.`
    return '.';
  }
};

/***/ }),

/***/ "1wCz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2e82eNOe0o84r4Mu77sV9H","Dell":"FUPzXSxqO0_IVfV_FXK5g","Abbott":"DLtL_2Ut_OgJyfUZ-Qc_N","Gap":"_3udIIomHDIoHNvWkinOzLJ","Allstate":"PDU1CRFUQ6ketkqMjW2Zv","Asurion":"_3hHbNAJt3ke0sZlT8o1HGj","Invitae":"_6YjNBlDqft6QbOyjd_2cP","JWE":"_12jmxwald089AEgqLhsmUB"};

/***/ }),

/***/ "2+iS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules__ = __webpack_require__("vZ0M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_legacy_auth__ = __webpack_require__("mnjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json__ = __webpack_require__("ZVSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_intercom__ = __webpack_require__("dmNr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var allowedModules = __WEBPACK_IMPORTED_MODULE_1__core_legacy_auth__["a" /* default */].allowedModules;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'site-map',
  props: {
    reference: null,
    className: {
      type: Object,
      default: function _default() {
        return {
          value: ''
        };
      }
    }
  },
  created: function created() {
    this.allowedModules = allowedModules.get;
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return global.config ? true : this.$store.state.isLoggedIn;
    },
    // application namespace
    namespace: function namespace() {
      return global.config.namespace || 'd'; // this.$router.currentRoute.params.namespace
    },
    tabs: function tabs() {
      return this.sitemap || (this.namespace !== 'd' ? this.namespace === '404' ? this.allowedModules : this.allowedModules /* Modules */ : this.allowedModules);
    }
  },
  methods: {
    isTabActive: function isTabActive(tab, key) {
      return key === this.$route.params.page && this.$root.legacyTab === '' || tab.label === this.$root.legacyTab;
    },
    showSubtabs: function showSubtabs(tab, key) {
      var isActive = this.isTabActive(tab, key);
      if (isActive) {
        !tab.autoHideSubtabs || tab.subtabs.length > 1 ? this.className.value = '' : this.className.value = 'no-tabs';
      }
      return (!tab.autoHideSubtabs || tab.subtabs.length > 1) && isActive;
    },
    track: function track(e) {
      var page = e.target.firstChild.textContent;
      var event = "visited_".concat(page);
      __WEBPACK_IMPORTED_MODULE_3__components_intercom__["a" /* default */].track(event);
    }
  },
  data: function data() {
    var _this = this;
    return {
      sitemap: global.config.namespace && global.config.sitemap && global.config.sitemap[global.config.namespace],
      section: function section(tab, subTab, subKey) {
        // if (Modules[tab].notImplemented) return subTab
        var url = __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab] ? __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack && ((__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack[subTab] || {}).name || __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack[subTab]) || this.tabs[tab].subtabs && this.tabs[tab].subtabs[subKey] : '';
        if (this.tabs[tab].subtabs && global.config.namespace) {
          return subKey;
        }
        return (url.label || url).replace('*', '').replace('#', '');
      },
      isActive: function isActive(tab, subTab, subKey) {
        var url = __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab] ? __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack && (
        // Modules[tab].notImplemented
        // ? subTab
        /* : */
        (__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack[subTab] || {}).name || __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack[subTab]) || this.tabs[tab].subtabs && this.tabs[tab].subtabs[subKey] : '';
        url = (url.label || '').replace('#', '') || url;
        var currentRoute = this.$route.params.section + (this.$route.params.action ? '/' + this.$route.params.action : '');

        // if (this.tabs[tab].label === this.$root.legacyTab) return true
        // if (subTab === this.$root.legacySubtab) return true
        if (this.$root.legacySubtab === this.subNavLabel(subKey)) return true;
        if (this.reference && this.reference === tab + '/' + url) {
          global.app.backReferenceTitle = this.subNavLabel(subKey);
          return true;
        }
        if (this.tabs[tab].subtabs && global.config.namespace) {
          return this.$route.params.section === subKey;
        }

        // Admin tabs
        var COMPANY_SETTINGS_CARDS = this.$route.params.page === 'Admin' && this.$route.params.section !== 'Settings' && this.$route.params.section !== 'GeneralSettings' && this.$route.query['back-to'];
        if (COMPANY_SETTINGS_CARDS) {
          return adminSubtabs();
        }
        if (~url.indexOf('#/d')) {
          return ~window.location.hash.indexOf(url);
        } else {
          if (currentRoute.includes(url) && currentRoute !== url) {
            return true;
          } else {
            return !this.$root.legacySubtab && url === currentRoute || ~window.location.hash.indexOf(url);
          }
        }
        function adminSubtabs() {
          return subTab === 'Settings';
        }
      },
      sectionNamespace: function sectionNamespace(tab, subTab, subKey) {
        if (global.config.namespace) return global.config.namespace;
        if (__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack && __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack[subTab] && __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack[subTab].name.indexOf('>') === 0 || __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack && __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack[subTab] && __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack[subTab].name.indexOf('#') === 0 || __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].subtabs && __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].subtabs[subKey] && __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].subtabs[subKey].indexOf('#') === 0 || (subTab.label || subTab).indexOf('#') === 0) {
          return 'd';
        }
        return __WEBPACK_IMPORTED_MODULE_0__components_modules__["a" /* default */][tab] && !__WEBPACK_IMPORTED_MODULE_0__components_modules__["a" /* default */][tab].entry && !__WEBPACK_IMPORTED_MODULE_0__components_modules__["a" /* default */][tab].notImplemented || __WEBPACK_IMPORTED_MODULE_0__components_modules__["a" /* default */][tab + '/' + this.section(tab, subTab, subKey)] || __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].subtabs && __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].subtabs[subTab] ? 'd' : 'i';
      },
      subTabUrl: function subTabUrl(key, subTab, subKey) {
        var url = '';
        var section = _this.section(key, subTab, subKey);
        section = section.label || section;
        if (~section.indexOf('#/d')) {
          url = "".concat(section, "/");
        } else {
          url = "#/".concat(_this.sectionNamespace(key, subTab, subKey), "/").concat(key, "/").concat(section, "/");
        }
        return url;
      },
      subNavLabel: function subNavLabel(key) {
        return this.$t(key.replace(/-/g, ' '));
      },
      newMenus: function newMenus(tab) {
        return false;
        // return Modules[tab] && Modules[tab].notImplemented && !Modules[tab].pack
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "2+zr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "234v":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ApprovalNeeded/approve-dialog.vue": "u8Yq",
	"./ApprovalNeeded/card.vue": "4Su7",
	"./ApprovalNeeded/index.vue": "/Blb",
	"./ApprovalNeeded/items-list.vue": "5zl1",
	"./ApprovalNeeded/reject-dialog.vue": "2E/x",
	"./ApprovalNeeded/user-info.vue": "vFKZ",
	"./CategorySpend/index.vue": "pgOF",
	"./CurrentInvoices/index.vue": "oePj",
	"./CurrentPrograms/index.vue": "T7Wz",
	"./HotelSpend/index.vue": "CquV",
	"./ImmediatePaymentEscrows/index.vue": "dp0g",
	"./InvoicePaymentStatus/index.vue": "1lw4",
	"./News/index.vue": "+aHG",
	"./PaymentsBySupplierType/index.vue": "EO3P",
	"./ProgramBudget/index.vue": "yjLw",
	"./RecentUpdates/card.vue": "yYTH",
	"./RecentUpdates/index.vue": "i2x5",
	"./SharedComponents/WidgetOptions.vue": "eiQj",
	"./SharedComponents/WidgetSettingsMenu.vue": "XEt1",
	"./Shortcuts/addDivisionModal.vue": "gvZX",
	"./Shortcuts/index.vue": "rR4Q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "234v";

/***/ }),

/***/ "26UQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"md-nav-tabs nav nav-tabs",attrs:{"role":"tablist"}},[_vm._l((_vm.tabs),function(t){return (!_vm.hasDefaultSlot)?_c('nav-tab',{key:t.id,attrs:{"id":t.id,"name":t.name,"active":t.active,"icon":t.icon},on:{"onTabClick":_vm.onTabClick}}):_vm._e()}),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2BGA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_charts_components_tooltip_standard__ = __webpack_require__("Ik2T");

/* harmony default export */ __webpack_exports__["a"] = ({
  chartType: 'Pie',
  showInChartLegend: true,
  chartOpts: getOptions(),
  chartData: function chartData(widget, data) {
    return getChartData(data);
  },
  chartInfo: function chartInfo(widget, data) {
    return getChartInfo(data);
  },
  colors: {
    Preferred: 3,
    Other: 1,
    Approved: 5
  },
  components: {
    tooltip: __WEBPACK_IMPORTED_MODULE_0__core_charts_components_tooltip_standard__["a" /* default */]
  }
});
function getOptions() {
  var baseCustSet = {
    chartGroupValue: 'Supplier Type',
    showTotal: true,
    isGaugeChart: true,
    chartInfoTooltip: true,
    hasDrillDown: false,
    containterStyle: 'height: 220px; margin-top: 10px; margin-left: 1px; margin-bottom: -100px; pointer-events: none',
    tooltip: {
      width: '190px'
    }
  };
  var baseOpts = {
    customSettings: baseCustSet,
    donut: true,
    donutWidth: 50,
    startAngle: 270,
    total: 0,
    width: '290px'
  };
  return baseOpts;
}
function getChartInfo(data) {
  var result = prepareData(data).map(function (k) {
    return k[1];
  });
  return result;
}
function getChartData(data) {
  var datagrouped = prepareData(data);
  var labelsGrouped = datagrouped.map(function (k) {
    return k[0];
  });
  var seriesGrouped = datagrouped.map(function (k) {
    return k[1];
  });
  var total = seriesGrouped.reduce(function (partialSum, a) {
    return partialSum + a;
  });
  return {
    labels: labelsGrouped,
    series: seriesGrouped.map(function (q) {
      return Math.abs(q);
    }),
    total: total,
    labelData: seriesGrouped,
    tooltipData: {
      metadata: tooltipMetadata,
      data: [labelsGrouped.map(function (k) {
        return k + ' Suppliers';
      }), seriesGrouped, seriesGrouped.map(function (k) {
        return (k * 100 / total).toFixed(2);
      })]
    }
  };
}
function prepareData(data) {
  var datagrouped = [];
  var sortedData = [];
  var a;
  var o;
  var p;
  data.forEach(function (elem) {
    if (elem[0] !== 'Approved' && elem[0] !== 'Preferred') elem[0] = 'Other';
    var pos = datagrouped.findIndex(function (k) {
      return k[0] === elem[0];
    });
    if (pos === -1) datagrouped.push([elem[0], elem[1]]);else datagrouped[pos][1] += elem[1];
  });
  datagrouped.forEach(function (elem) {
    if (elem[0] === 'Approved') a = elem;else if (elem[0] === 'Preferred') p = elem;else if (elem[0] === 'Other') o = elem;
  });
  if (p) sortedData.push(p);
  if (a) sortedData.push(a);
  if (o) sortedData.push(o);
  return sortedData;
}
var tooltipMetadata = [{
  label: '',
  type: 'title',
  format: ''
}, {
  label: 'Payments',
  type: 'main',
  format: 'currency'
}, {
  label: '% of Total',
  type: 'secondary',
  format: 'percentage'
}];

/***/ }),

/***/ "2Bs7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_scan_invoice_history_model_js__ = __webpack_require__("1Fv/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabs__ = __webpack_require__("xp7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_back__ = __webpack_require__("tdUP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */],
    back: __WEBPACK_IMPORTED_MODULE_4__Components_back__["a" /* default */]
  },
  data: function data() {
    return {
      ScanInvoiceHistoryModel: __WEBPACK_IMPORTED_MODULE_1__models_scan_invoice_history_model_js__["a" /* default */],
      paymentInvoiceId: 0,
      tabs: __WEBPACK_IMPORTED_MODULE_3__tabs__["a" /* default */].tabs
    };
  },
  computed: {
    getModel: function getModel() {
      return __WEBPACK_IMPORTED_MODULE_1__models_scan_invoice_history_model_js__["a" /* default */].get();
    }
  },
  methods: {
    openInvoice: function openInvoice(paymentInvoiceId) {
      // this.redirectToUploadInvoicePage(paymentInvoiceId)
      this.refresh();
    },
    redirectToUploadInvoicePage: function redirectToUploadInvoicePage(paymentInvoiceId) {
      window.location.reload(this.$router.replace('/d/InvoiceToPay/upload?invoiceId=' + paymentInvoiceId));
    },
    refresh: function refresh() {
      this.$refs.ScanInvoiceHIstoryGrid.quickSearch();
      this.$refs.ScanInvoiceHIstoryGrid.onSelectAll(false);
    },
    handleButtons: function handleButtons(r) {
      if (r && r.data && r.data.length === 1) {
        this.enableButtons(false);
        this.paymentInvoiceId = r.data[0].PaymentInvoiceId;
      } else {
        this.enableButtons(true);
        this.paymentInvoiceId = 0;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ALL);
  }
});

/***/ }),

/***/ "2CAy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"I8XR3sB6GSRHL7o5DmU7r","Dell":"_2emOJEnU4ho0aoQ4e9rgfy","Abbott":"_1kWZzhRlnTeD6AZ9GfdytD","Gap":"_2zMCPmKMp2D7a2-AKNm0ja","Allstate":"_3Y5pbpcoGdUrI6smSRfYht","Asurion":"_2upWsl3864Ul04DD4joiXi","Invitae":"_1PQRIvsNuPZWx0NRp9SkyU","JWE":"_3uHOrkN4NNVl-x1OwQrX4t"};

/***/ }),

/***/ "2E/x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reject_dialog_vue__ = __webpack_require__("HpCA");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb0aa3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reject_dialog_vue__ = __webpack_require__("Rpzf");
function injectStyle (ssrContext) {
  __webpack_require__("Ar5I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bb0aa3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reject_dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb0aa3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reject_dialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2LH4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_38pIywt-1UagraJC7nDH_U","Dell":"_3df_F2k49WQlswD9Lv9240","Abbott":"_3z9ZtrVnkGionP-LPctIbS","Gap":"_2429f5v4WjtkpIeDez51kM","Allstate":"_3DK-P1lALQ7Ektc2TAs0_Z","Asurion":"_1OMmpXFyuXhK7jgt0SzZTK","Invitae":"nO_j7MGW8h3i2RhlObmuG","JWE":"_2ZQFPWSq4qcT5-e2dALlEo"};

/***/ }),

/***/ "2OBO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"bIfb_FGG11ZglpHyb7Enl","Dell":"_2WDvp_T2um1nLq8XxYUUtX","Abbott":"_3Up3gtF9oBnust0Rw5AVjm","Gap":"_2UEcflWLjXy4r7RxjeAerP","Allstate":"_2-zUTYA0hW6EpnaGiZoWWA","Asurion":"mJ4IMQt8FigQ4-4VpJm4n","Invitae":"_16u684M8SwSqH0DwIJzE31","JWE":"_3sp7nHDv6SmeoQ2A1PllsT"};

/***/ }),

/***/ "2Pzm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_scrollbarHelper_js__ = __webpack_require__("7yCl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_user__ = __webpack_require__("uduW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pluralize__ = __webpack_require__("wMK+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_pluralize__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_pluralize___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'current-programs-wdg-cmp',
  props: {
    widget: Object
  },
  data: function data() {
    return {
      items: [],
      loading: false,
      companySettings: {}
    };
  },
  computed: {
    hasData: function hasData() {
      if (this.items !== null && this.items.length > 0) return true;else {
        return false;
      }
    }
  },
  created: function created() {
    var _this = this;
    this.loading = true;
    this.companySettings = __WEBPACK_IMPORTED_MODULE_3__core_user__["a" /* default */].getCompanySettings();
    this.api.get(this.widget.endPoint, {}).then(function (r) {
      _this.items = r.data.items;
    }).finally(function () {
      _this.loading = false;
      _this.$nextTick(function () {
        var desiredHeight = !_this.hasData ? 1 : getDesiredSize(_this.items.length);
        __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$emit('updateWidgetHeight', {
          wId: _this.widget.id,
          height: desiredHeight,
          alt: -1
        });
        if (_this.items.length > 6) {
          _this.$el.querySelector('.scroller').style.height = '156px';
          Object(__WEBPACK_IMPORTED_MODULE_0__helpers_scrollbarHelper_js__["a" /* initScrollbar */])(_this, '.scroller');
        }
      });
    });
  },
  methods: {
    getProgramLabel: function getProgramLabel(plural, lower) {
      var label = this.companySettings.ProgramLabel ? this.companySettings.ProgramLabel : 'Program';
      if (plural === true) label = this.companySettings.ProgramsLabel;
      if (lower === true) label = label.toLowerCase();
      return label;
    }
  }
});
function getDesiredSize(len) {
  var res = 1;
  if (len >= 6) return 3;
  switch (len) {
    case 1:
      res = 1;
      break;
    case 2:
    case 3:
      res = 2;
      break;
    case 4:
    case 5:
      res = 3;
      break;
  }
  return res;
}

/***/ }),

/***/ "2SPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_requestAddFunds_vue__ = __webpack_require__("1PG7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_515d7099_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_requestAddFunds_vue__ = __webpack_require__("RWJl");
function injectStyle (ssrContext) {
  __webpack_require__("3AxR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-515d7099"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_requestAddFunds_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_515d7099_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_requestAddFunds_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2WLZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3VYk-i4s6bmTHIZok3WAz-","Dell":"MwMtsVNX9NA-FoKdDsGq","Abbott":"_3WrPpmzfzRZk0MIOzCRTK1","Gap":"_28zPG0ZDoLvVDc1flhaGwU","Allstate":"_19pxCNWNsP-5H1NKe5ae6A","Asurion":"_2xsXBedvUvXp47818iLVX7","Invitae":"_2iHxZZgVwnZHfdT7eKvdb4","JWE":"_3wFmJsKMfN-wFfWsbYr9qA"};

/***/ }),

/***/ "2Yta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approve_all_vue__ = __webpack_require__("4LcA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f357ad52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_approve_all_vue__ = __webpack_require__("dK8e");
function injectStyle (ssrContext) {
  __webpack_require__("HP22")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approve_all_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f357ad52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_approve_all_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Yud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2fKY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_Programs_Card_cards_CardHolder_vue__ = __webpack_require__("rMOU");

/* harmony default export */ __webpack_exports__["a"] = ({
  'Date': {
    label: 'Date',
    width: 100
  },
  'Action': {
    label: 'Action',
    width: 180
  },
  'CardNumber': {
    label: 'Card',
    compose: maskedCardNumber,
    width: 100
  },
  'CardHolder': {
    label: 'Card Holder',
    render: __WEBPACK_IMPORTED_MODULE_0__components_modules_Programs_Card_cards_CardHolder_vue__["a" /* default */],
    width: 180
  },
  NameOnCard: '_',
  'LoggedInUser': {
    label: 'User',
    width: 180
  },
  'Description': {
    label: 'Description',
    width: 250
  },
  'AccountID': '_',
  'HolderUserID': '_'
});
function maskedCardNumber(card) {
  if (card && card.data && card.data.CardNumber) {
    return '****' + card.data.CardNumber;
  } else {
    return '****';
  }
}

/***/ }),

/***/ "2iQL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2iRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("BegE");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a124efd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("7dKZ");
function injectStyle (ssrContext) {
  __webpack_require__("Y6oM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a124efd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a124efd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2jaw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_tooltip_vue__ = __webpack_require__("kVbx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4620a882_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_tooltip_vue__ = __webpack_require__("+7vF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_tooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4620a882_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2umB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2wGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__ = __webpack_require__("Jvju");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14067d28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__ = __webpack_require__("obo4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14067d28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2y1t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2w_JCcRORjt9OKSiW7QmjK","Dell":"_2uEbH0BA6s3PDEcGxmIla1","Abbott":"_2b3quGjZg_H37LyUoyPypB","Gap":"_3iIZAkEzh04wp3i8DssB9-","Allstate":"_32BRI3bpbfqRAXrnKdeoaV","Asurion":"gIBVqio_aXDfpehzpUm27","Invitae":"_2loiBtUGob4ZhsaTWcBBjf","JWE":"_2-FQBzCdgDm77kFnXX7eEf"};

/***/ }),

/***/ "2zeO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "30EY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_scrollbarHelper_js__ = __webpack_require__("7yCl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'current-invoices-wdg-cmp',
  props: {
    widget: Object
  },
  data: function data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    hasData: function hasData() {
      if (this.items !== null && this.items.length > 0) return true;else return false;
    }
  },
  methods: {
    handleClick: function handleClick(item) {
      var isEmbedded = window.self !== window.top;
      if (isEmbedded) {
        window.parent.postMessage({
          type: 'LEGACY_INVOICE_CLICK',
          invoiceId: item.PaymentInvoiceId
        }, '*');
        return;
      }
    }
  },
  created: function created() {
    var _this = this;
    this.loading = true;
    this.api.get(this.widget.endPoint, {}).then(function (r) {
      _this.items = r.data.items;
    }).finally(function () {
      _this.loading = false;
      _this.$nextTick(function () {
        var desiredHeight = !_this.hasData ? 1 : getDesiredSize(_this.items.length);
        __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$emit('updateWidgetHeight', {
          wId: _this.widget.id,
          height: desiredHeight,
          alt: -1
        });
        if (_this.items.length > 6) {
          _this.$el.querySelector('.scroller').style.height = '156px';
          Object(__WEBPACK_IMPORTED_MODULE_0__helpers_scrollbarHelper_js__["a" /* initScrollbar */])(_this, '.scroller');
        }
      });
    });
  }
});
function getDesiredSize(len) {
  var res = 1;
  if (len >= 6) return 3;
  switch (len) {
    case 1:
      res = 1;
      break;
    case 2:
    case 3:
      res = 2;
      break;
    case 4:
    case 5:
      res = 3;
      break;
  }
  return res;
}

/***/ }),

/***/ "37qm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("qYUL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e9b27bb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("9p7v");
function injectStyle (ssrContext) {
  __webpack_require__("m50H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e9b27bb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "38ON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceiptImageViewer_vue__ = __webpack_require__("fnpj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6b8ec84_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceiptImageViewer_vue__ = __webpack_require__("u1B6");
function injectStyle (ssrContext) {
  __webpack_require__("WQcv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a6b8ec84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceiptImageViewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6b8ec84_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceiptImageViewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3AxR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3ETzmmMYETdRt8GM0gk9Mj","Dell":"_2yydW8hPiOr1VhkaqgIy0E","Abbott":"_3IVtu8pvFJNF0orgU2zYaU","Gap":"_31OuNN_0JRmqRpdUOD6Bh1","Allstate":"_1jsiZ5MgdCtzD1CpTCG6Im","Asurion":"_1QhK0rfRqP4PX0UP_raWow","Invitae":"_19LheF9nFKG6gB0S5Bnu-M","JWE":"_2hRAPQLqgPb1zFnOXJV70X"};

/***/ }),

/***/ "3BJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export hasEpcTabAccess */
/* unused harmony export isApprovalDashboardRestricted */
/* unused harmony export translateEpcRoute */
/* unused harmony export getV3BaseUrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = epcRedirectGuard;
/**
 * epcRedirect — PRODUCTDEV-6030. The EvedPay Cards experience moved to the v3 shell
 * ("EvedPay Cards (new)", /payments/evedpay-cards). Every OLD EPC link still points here:
 * email deep links (login?returnUrl=/d/…), the approval-widget URL constants, the
 * ApprovalDashboard server redirect, and internal $router.push calls. This module intercepts
 * those navigations at the router level and forwards the browser to the equivalent route in
 * the v3 shell, so no core (email builder) deploy is needed and links in already-sent emails
 * keep working.
 *
 * Deliberately NOT intercepted: plain /d/Dashboard/MyDashboard (without cardId / cardRefillId /
 * cardFundsId) — many non-EPC emails deep-link the dashboard.
 *
 * Mapping mirrors Eved.Frontend/src/clientPages/EvedPayCards/utils/legacyEpcRedirect.ts —
 * keep the two in sync.
 */

var NEW_BASE = '/payments/evedpay-cards';
var MAIN_DASHBOARD = '/dashboard/Dashboard/MainDashboard';

/** EvedPayCardAccounts.ID is a uniqueidentifier — account ids in links are GUIDs. */
var GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** decodeURIComponent that survives malformed input and (up to) double encoding. */
function safeDecode(value) {
  var out = value;
  for (var i = 0; i < 2 && /%[0-9a-fA-F]{2}/.test(out); i++) {
    try {
      out = decodeURIComponent(out);
    } catch (e) {
      break;
    }
  }
  return out;
}

/** Parse `a=1&b=2` into a lowercase-keyed map (values keep their casing, e.g. CARD123). */
function parseParams(queryString) {
  var params = {};
  if (!queryString) return params;
  var pairs = queryString.split('&');
  for (var i = 0; i < pairs.length; i++) {
    if (!pairs[i]) continue;
    var eq = pairs[i].indexOf('=');
    var key = (eq >= 0 ? pairs[i].slice(0, eq) : pairs[i]).toLowerCase();
    var value = eq >= 0 ? pairs[i].slice(eq + 1) : '';
    if (key && !(key in params)) params[key] = value;
  }
  return params;
}

/** approve/decline from the email's Is{Approve|Reject}…FromEmail=true flags. */
function pickAction(params) {
  for (var key in params) {
    if (!params.hasOwnProperty(key)) continue;
    if (String(params[key]).toLowerCase() !== 'true') continue;
    if (/^isapprove\w*fromemail$/.test(key)) return 'approve';
    if (/^isreject\w*fromemail$/.test(key)) return 'decline';
  }
  return null;
}

/**
 * Whether the new EPC tab's v3 routes exist for the acting user. The backend menu includes the
 * EPC module for admins/reconcile-close users, and for plain EvedPayCardUser holders ONLY when
 * they actually hold a card — verified live: EvedPayCardUser alone without a card gets no tab
 * (its routes would 404). When in doubt we return false: the v3 standalone envelope-approval page
 * and main dashboard work for everyone. Reads the user from the app instance, falling back to the
 * shared-origin localStorage (`eved-user` carries `user.HasEvedPayCard` when the v3 shell
 * populated it).
 */
function hasEpcTabAccess() {
  var access = readUserAccess();
  if (!access.perms) return false;
  function has(p) {
    return access.perms.indexOf(p) !== -1;
  }
  if (has('EvedPayCardAdministrator') || has('EvedPayCardViewReconcileClose')) return true;
  return has('EvedPayCardUser') && access.hasCard;
}

/**
 * PRODUCTDEV-9009: an ApprovalDashboard holder with no EvedPay Cards tab. Core confines them to the
 * Approval Dashboard, so their envelope links must stay on the navless envelope page.
 */
function isApprovalDashboardRestricted() {
  var perms = readUserAccess().perms;
  return !!perms && perms.indexOf('ApprovalDashboard') !== -1 && !hasEpcTabAccess();
}

/** The acting user's permissions (null when unknown) and HasEvedPayCard. */
function readUserAccess() {
  var perms = null;
  var hasCard = false;
  try {
    var vm = global.app && global.app.$user && global.app.$user.$;
    perms = vm && vm.userPermissions;
    var stored = JSON.parse(global.localStorage.getItem('eved-user') || '{}');
    if (!perms) perms = stored && stored.userPermissions;
    hasCard = !!(stored && stored.user && stored.user.HasEvedPayCard);
  } catch (e) {
    perms = perms || null;
  }
  return {
    perms: Array.isArray(perms) ? perms.map(String) : null,
    hasCard: hasCard
  };
}

/**
 * Envelope deep link. EPC users → the new envelope detail (id-agnostic `all` scope). Users
 * without EPC tab access → the v3 standalone envelope-approval page (PRODUCTDEV-6079; switched
 * over from the dashboard widget in PRODUCTDEV-9027). ApprovalDashboard users keep the dashboard
 * widget.
 */
function envelopeRoute(params, epcTabAccess, approvalDashboardRestricted) {
  var envId = (params['envelopeid'] || '').trim();
  if (!envId || !/^[\w-]+$/.test(envId)) return null;
  var action = pickAction(params);
  if (approvalDashboardRestricted) {
    var dashQuery = 'approvalItem=' + encodeURIComponent('ENVELOPE' + envId);
    if (action) dashQuery += '&approvalAction=' + action;
    return MAIN_DASHBOARD + '?' + dashQuery;
  }
  var route = epcTabAccess ? NEW_BASE + '/all/envelopes/' + envId : '/payments/envelope-approval/' + envId;
  if (action === 'approve') route += '?approve=1';
  if (action === 'decline') route += '?decline=1';
  return route;
}

/**
 * Translate an old EPC route (`/d/…` / `/i/…` fullPath, possibly percent-encoded) into the
 * v3 hash-route string, or null when the URL is not an old-EPC target.
 */
function translateEpcRoute(fullPath, options) {
  if (typeof fullPath !== 'string' || !fullPath) return null;
  var epcTabAccess = !(options && options.epcTabAccess === false);
  var approvalDashboardRestricted = !!(options && options.approvalDashboardRestricted);
  var target = safeDecode(fullPath).trim();
  if (target.charAt(0) === '#') target = target.slice(1);
  if (target.charAt(0) !== '/') target = '/' + target;
  var qIdx = target.indexOf('?');
  var pathPart = (qIdx >= 0 ? target.slice(0, qIdx) : target).replace(/\/+$/, '');
  var params = parseParams(qIdx >= 0 ? target.slice(qIdx + 1) : '');

  // `/i/…` ≡ `/d/…`; the iframe-era widget constant doubles the Programs segment.
  var norm = pathPart.replace(/^\/(d|i)\//i, '/d/').replace(/^\/d\/Programs\/Programs\//i, '/d/Programs/');

  // Card / refill / funds approval emails → the v3 dashboard's approval widget (same backend
  // list, same prefixed item ids CARD{id} / REFILL{id} / FUNDS{id}).
  if (/^\/d\/Dashboard\/MyDashboard$/i.test(norm)) {
    var item = params['cardid'] || params['cardrefillid'] || params['cardfundsid'];
    if (!item) return null; // plain MyDashboard is not EPC's to redirect
    var action = pickAction(params);
    var query = 'approvalItem=' + encodeURIComponent(item);
    if (action) query += '&approvalAction=' + action;
    return MAIN_DASHBOARD + '?' + query;
  }
  if (/^\/d\/EnvelopeApprovalDashboard$/i.test(norm)) {
    if (approvalDashboardRestricted) return null;
    return envelopeRoute(params, epcTabAccess) || (epcTabAccess ? NEW_BASE + '/all/tables/envelopes' : MAIN_DASHBOARD);
  }
  var match = norm.match(/^\/d\/Programs\/>?Card(?:(-[a-z-]+)|\/([a-z-]+))?$/i);
  if (!match) return null;
  var section = (match[1] ? match[1].slice(1) : match[2] || '').toLowerCase();

  // No EPC tab access → its v3 routes aren't registered (direct navigation would 404).
  // Envelope links go to the standalone approval page; everything else lands on the main dashboard.
  if (!epcTabAccess && section !== 'envelopes') {
    return MAIN_DASHBOARD;
  }
  switch (section) {
    case 'list':
      var acct = (params['accountid'] || '').trim();
      // Verified: email AccountId == dbo.EvedPayCardAccounts.ID (uniqueidentifier) == Platform
      // account.id — a GUID. Unknown ids fall back to the tab root (shell canonicalizes).
      return GUID_RE.test(acct) ? NEW_BASE + '/' + acct : NEW_BASE;
    case 'transactions':
      return NEW_BASE + '/all/tables/transactions';
    case 'history':
      return NEW_BASE + '/all/tables/history';
    case 'envelopes':
      return envelopeRoute(params, epcTabAccess, approvalDashboardRestricted) || (epcTabAccess ? NEW_BASE + '/all/tables/envelopes' : MAIN_DASHBOARD);
    // '', cards, accounts, approval, account-statements and anything unknown → the tab root.
    default:
      return NEW_BASE;
  }
}

/**
 * The v3 shell base URL for the CURRENT environment, derived from where this app is running
 * (verified against the core config transforms):
 *   https://portal.eved.com/{env}/index.html#/  →  https://portal.eved.com/{env}-v3/index.html#
 *   https://web.eved.com/#/          (prod)     →  https://web.eved.com/-v3/index.html#
 *   local (local.evedonline.eved.com / localhost) → https://local.evedonline.eved.com/dev-v3#
 * Returns null when the environment can't be recognized (then we do NOT redirect).
 */
function getV3BaseUrl(loc) {
  var l = loc || global.location;
  if (!l || !l.hostname) return null;
  var host = l.hostname.toLowerCase();
  if (host === 'local.evedonline.eved.com' || host === 'localhost' || host === '127.0.0.1') {
    return 'https://local.evedonline.eved.com/dev-v3#';
  }
  if (host === 'web.eved.com') {
    return l.protocol + '//' + l.host + '/-v3/index.html#';
  }
  if (host === 'portal.eved.com') {
    // First path segment is the environment folder (e.g. /qainternaldemo/index.html).
    var seg = (l.pathname || '/').split('/').filter(function (s) {
      return !!s;
    })[0];
    if (!seg) return null;
    return l.protocol + '//' + l.host + '/' + seg + '-v3/index.html#';
  }
  return null;
}

/**
 * Router guard: register BEFORE checkAuth (`router.beforeEach(epcRedirectGuard)`).
 * Forwards old-EPC navigations to the v3 shell — via window.top when this app is embedded in
 * the v3 LegacyPage iframe (same-origin in every deployed env; the iframe is not sandboxed).
 */
function epcRedirectGuard(to, from, next) {
  var route = translateEpcRoute(to.fullPath, {
    epcTabAccess: hasEpcTabAccess(),
    approvalDashboardRestricted: isApprovalDashboardRestricted()
  });
  if (!route) return next();
  var base = getV3BaseUrl(global.location);
  if (!base) return next();
  var dest = base + route;
  try {
    if (global.self !== global.top) {
      global.top.location.href = dest;
    } else {
      global.location.href = dest;
    }
  } catch (e) {
    global.location.href = dest;
  }
  next(false);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "3EmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-additional-users-overlay"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"addUsers"}},[_vm._v("Additional Users")]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("Select users to have access to this card.")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select an Eved user...","options":_vm.filteredUsers,"track-by":"Id","checkboxes":false,"server-search":"","label":"Name","multiple":""},on:{"input":function (o) { return _vm.$emit('additionalUsers', _vm.additionalUsers = o); },"open":_vm.onOpenUsers,"scroll-bottom":function () { return _vm.loadUsers(false); },"search":_vm.onUserSearch},model:{value:(_vm.additionalUsers),callback:function ($$v) {_vm.additionalUsers=$$v},expression:"additionalUsers"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3NN2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"PVzb44F4L8tyQzGVyO_O","Dell":"_34chlOskAj3TcYDeB9p4c","Abbott":"_1cyrm5Sbrlq8RErMi9U7EV","Gap":"UFp-z3hx_ioAlhQ0NLTz9","Allstate":"ZoE3mIDi2pmVuKvE-2Kdx","Asurion":"_3yf2lZa9vyPMJV72-KCVfw","Invitae":"_1RrXhQL6tTugzgAWlVXGIT","JWE":"aXaVH3HGGXEmzak11FW6J"};

/***/ }),

/***/ "3ON/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_EvedPay_otpCardRevealMixin__ = __webpack_require__("vF8d");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_modules_EvedPay_otpCardRevealMixin__["a" /* default */]],
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      passcode: ''
    };
  },
  computed: {
    last4: function last4() {
      return this.card.CardNumber || '****';
    },
    formattedExpirationDate: function formattedExpirationDate() {
      var exp = this.card.ExpirationDate || '';
      if (!exp) {
        return '••/••';
      }
      var match = exp.match(/\/Date\((\d+)\)\//);
      var d = match ? new Date(parseInt(match[1])) : new Date(exp);
      if (isNaN(d.getTime())) {
        return exp;
      }
      var mm = ('0' + (d.getMonth() + 1)).slice(-2);
      var yy = String(d.getFullYear()).slice(-2);
      return mm + '/' + yy;
    },
    displayNameOnCard: function displayNameOnCard() {
      var nameOnCard = (this.card.NameOnCard || '').trim();
      return nameOnCard || this.card.Holder || '';
    }
  },
  methods: {
    getCardId: function getCardId() {
      return this.card.Id;
    },
    getAccountId: function getAccountId() {
      return this.card.AccountId;
    },
    getPasscode: function getPasscode() {
      return this.passcode;
    },
    resetPasscodeInput: function resetPasscodeInput() {
      this.passcode = '';
    },
    onPasscodeInput: function onPasscodeInput() {
      this.passcode = this.passcode.replace(/[^0-9]/g, '').slice(0, 6);
      if (this.passcode.length === 6 && !this.verifying) {
        this.verifyOtp();
      }
    }
  }
});

/***/ }),

/***/ "3Tf6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attachments_details_vue__ = __webpack_require__("Ky1X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d743460c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attachments_details_vue__ = __webpack_require__("hFsW");
function injectStyle (ssrContext) {
  __webpack_require__("2umB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d743460c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attachments_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d743460c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attachments_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Zh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receipt-folder-container"},[_vm._t("title"),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"navless-layout-header"},[_vm._t("navbar",function(){return [_c('ed-button',{attrs:{"to":_vm.$routerHistory.previous().path}},[_c('i',{staticClass:"fal fa-chevron-left"}),_vm._v("\n         \n        Back\n      ")])]})],2):_vm._e(),_vm._v(" "),(!_vm.featureFlags.receiptScanPrefill)?_c('div',{staticClass:"feature-disabled"},[_c('p',[_vm._v("Receipt folder feature is not available.")])]):(_vm.receipts && !_vm.receipts.length && !_vm.isLoading)?_c('div',{staticClass:"no-data"},[_c('div',[_c('i',{staticClass:"icon fas fa-folder-open"}),_vm._v(" "),_c('h3',[_vm._v("No Receipts")]),_vm._v(" "),_c('p',[_vm._v("No receipts in your folder yet. Upload a receipt without picking a transaction, or tap \"Save for later\" during upload, and it'll land here for you to claim.")]),_vm._v(" "),_c('ed-button',{staticClass:"upload-cta",on:{"click":_vm.handleUploadClick}},[_vm._v("Submit Receipt")])],1)]):(_vm.isLoading)?_c('div',{staticClass:"loading-state"},[_c('p',[_vm._v("Loading receipts...")])]):_c('div',{on:{"touchstart":_vm.onPullStart,"touchmove":_vm.onPullMove,"touchend":_vm.onPullEnd}},[(_vm.isMobile)?_c('div',{staticClass:"pull-indicator",style:({ height: _vm.pullDistance + 'px', opacity: Math.min(_vm.pullDistance / 60, 1) })},[_c('div',{staticClass:"pull-indicator-content"},[(_vm.isRefreshing)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):(_vm.pullDistance >= 60)?_c('i',{staticClass:"fas fa-arrow-up"}):_c('i',{staticClass:"fas fa-arrow-down"}),_vm._v(" "),(_vm.isRefreshing)?_c('span',[_vm._v("Refreshing...")]):(_vm.pullDistance >= 60)?_c('span',[_vm._v("Release to refresh")]):_c('span',[_vm._v("Pull to refresh")])])]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"refresh-controls"},[_c('ed-button',{attrs:{"disabled":_vm.isRefreshing},on:{"click":_vm.handleRefresh}},[_vm._v("\n        "+_vm._s(_vm.isRefreshing ? 'Refreshing...' : 'Refresh')+"\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"sort-controls"},[_c('label',{staticClass:"sort-controls__label"},[_vm._v("Sort by:\n        "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortBy),expression:"sortBy"}],staticClass:"sort-controls__select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sortBy=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.fetchReceipts]}},[_c('option',{attrs:{"value":"UploadedAt"}},[_vm._v("Most recent upload")]),_vm._v(" "),_c('option',{attrs:{"value":"TransactionDate"}},[_vm._v("Receipt date")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.receipts),function(receipt){return _c('div',{key:receipt.receiptScanId,staticClass:"receipt-row",class:{ 'is-processing': receipt.status === 'Processing', 'is-highlighted': receipt.receiptScanId === _vm.highlightedReceiptId }},[(_vm.isMobile)?_c('div',{staticClass:"swipe-container"},[(_vm.canMutateReceipt(receipt))?_c('div',{staticClass:"swipe-delete-action",on:{"click":function($event){return _vm.handleDelete(receipt)}}},[_c('i',{staticClass:"fas fa-trash"}),_vm._v(" "),_c('span',[_vm._v("Delete")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"swipe-content",style:(_vm.getSwipeStyle(receipt.receiptScanId)),on:{"touchstart":function($event){_vm.canMutateReceipt(receipt) && _vm.onRowSwipeStart($event, receipt)},"touchmove":function($event){_vm.canMutateReceipt(receipt) && _vm.onRowSwipeMove($event, receipt)},"touchend":function($event){_vm.canMutateReceipt(receipt) && _vm.onRowSwipeEnd($event, receipt)}}},[_c('ed-notice',{staticClass:"receipt-notice"},[_c('div',{staticClass:"receipt-content"},[_c('div',{staticClass:"receipt-thumbnail"},[(_vm.imageUrlCache[receipt.receiptScanId])?_c('img',{staticClass:"receipt-thumbnail-img",attrs:{"src":_vm.imageUrlCache[receipt.receiptScanId],"alt":""},on:{"error":function($event){return _vm.onThumbnailError(receipt)}}}):_c('i',{staticClass:"icon fas fa-receipt"})]),_vm._v(" "),_c('div',{staticClass:"receipt-details"},[_c('div',{staticClass:"file-name"},[_c('strong',[_vm._v(_vm._s(receipt.originalFileName))])]),_vm._v(" "),_c('div',{staticClass:"upload-date"},[_vm._v("\n                  "+_vm._s(_vm.formatDate(receipt.createdAt))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"ocr-summary"},[(receipt.merchantName)?_c('span',{staticClass:"merchant"},[_vm._v(_vm._s(receipt.merchantName))]):_vm._e(),_vm._v(" "),(receipt.totalAmount)?_c('span',{staticClass:"total"},[_c('v-money',[_vm._v(_vm._s(receipt.totalAmount))])],1):_vm._e()]),_vm._v(" "),(receipt.topCandidate)?_c('div',{staticClass:"top-candidate-hint"},[_c('small',[_vm._v("\n                    Suggested: "+_vm._s(receipt.topCandidate.merchantName)+"\n                    "),(receipt.topCandidate.amount)?_c('span',[_c('v-money',[_vm._v(_vm._s(receipt.topCandidate.amount))])],1):_vm._e()])]):_vm._e(),_vm._v(" "),(receipt.warnings && receipt.warnings.length)?_c('div',{staticClass:"warnings-badge"},[_c('span',{staticClass:"badge"},[_vm._v(_vm._s(receipt.warnings.length)+" warning"),(receipt.warnings.length > 1)?_c('span',[_vm._v("s")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"receipt-actions"},[_c('div',{staticClass:"status-badge"},[_c('span',{staticClass:"badge badge-success"},[_vm._v("Saved")])]),_vm._v(" "),_c('div',{staticClass:"action-buttons"},[_c('ed-button',{staticClass:"claim-btn",attrs:{"disabled":!_vm.canMutateReceipt(receipt),"title":_vm.readOnlyTooltip(receipt)},on:{"click":function($event){return _vm.handleClaim(receipt)}}},[_vm._v("\n                    Claim\n                  ")])],1)])])])],1)]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('ed-notice',{staticClass:"receipt-notice"},[_c('div',{staticClass:"receipt-content"},[_c('div',{staticClass:"receipt-thumbnail"},[_c('i',{staticClass:"icon fas fa-receipt"})]),_vm._v(" "),_c('div',{staticClass:"receipt-details"},[_c('div',{staticClass:"file-name"},[_c('strong',[_vm._v(_vm._s(receipt.originalFileName))])]),_vm._v(" "),_c('div',{staticClass:"upload-date"},[_vm._v("\n              "+_vm._s(_vm.formatDate(receipt.createdAt))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"ocr-summary"},[(receipt.merchantName)?_c('span',{staticClass:"merchant"},[_vm._v(_vm._s(receipt.merchantName))]):_vm._e(),_vm._v(" "),(receipt.totalAmount)?_c('span',{staticClass:"total"},[_c('v-money',[_vm._v(_vm._s(receipt.totalAmount))])],1):_vm._e()]),_vm._v(" "),(receipt.topCandidate)?_c('div',{staticClass:"top-candidate-hint"},[_c('small',[_vm._v("\n                Suggested: "+_vm._s(receipt.topCandidate.merchantName)+"\n                "),(receipt.topCandidate.amount)?_c('span',[_c('v-money',[_vm._v(_vm._s(receipt.topCandidate.amount))])],1):_vm._e()])]):_vm._e(),_vm._v(" "),(receipt.warnings && receipt.warnings.length)?_c('div',{staticClass:"warnings-badge"},[_c('span',{staticClass:"badge"},[_vm._v(_vm._s(receipt.warnings.length)+" warning"),(receipt.warnings.length > 1)?_c('span',[_vm._v("s")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"receipt-actions"},[_c('div',{staticClass:"status-badge"},[_c('span',{staticClass:"badge badge-success"},[_vm._v("Saved")])]),_vm._v(" "),_c('div',{staticClass:"action-buttons"},[_c('ed-button',{staticClass:"claim-btn",attrs:{"disabled":!_vm.canMutateReceipt(receipt),"title":_vm.readOnlyTooltip(receipt)},on:{"click":function($event){return _vm.handleClaim(receipt)}}},[_vm._v("\n                Claim\n              ")]),_vm._v(" "),(_vm.canMutateReceipt(receipt))?_c('button',{staticClass:"receipt-row-delete-btn",attrs:{"type":"button","aria-label":"Delete receipt","title":"Delete receipt"},on:{"click":function($event){return _vm.handleDelete(receipt)}}},[_c('i',{staticClass:"fas fa-times"})]):_vm._e()],1)])])]):_vm._e()],1)}),_vm._v(" "),(!_vm.isMobile && _vm.totalPages > 1)?_c('div',{staticClass:"pagination-controls"},_vm._l((_vm.totalPages),function(page){return _c('button',{key:page,staticClass:"page-btn",class:{ active: _vm.currentPage === page },on:{"click":function($event){return _vm.goToPage(page)}}},[_vm._v("\n        "+_vm._s(page)+"\n      ")])}),0):_vm._e(),_vm._v(" "),(_vm.isMobile && _vm.hasMorePages)?_c('div',{ref:"infiniteScrollTrigger",staticClass:"infinite-scroll-trigger"},[(!_vm.isLoadingMore)?_c('small',[_vm._v("Scroll to load more")]):_c('small',[_vm._v("Loading more receipts...")])]):_vm._e()],2),_vm._v(" "),_c('candidate-selector',{attrs:{"show":_vm.showCandidateSelector,"receipt-scan-id":_vm.selectedReceiptId,"candidates":_vm.selectorCandidates,"is-mobile":_vm.isMobile,"row-version":_vm.selectorRowVersion,"auto-linked":_vm.selectorAutoLinked,"claim-mode":true},on:{"claim-selected":_vm.handleClaimSelected,"claim-error":_vm.handleClaimError,"save-to-folder":_vm.handleSaveToFolder,"close":_vm.closeCandidateSelector}}),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showDeleteConfirm,"title":"Delete Receipt","primary-button":'Confirm',"secondary-button":"Cancel","type":"medium"},on:{"confirm":_vm.confirmDelete,"close":_vm.closeDeleteConfirm}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("Delete this receipt?")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3d8/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* eslint no-multi-spaces: 0 */
/* eslint no-unused-vars : 0 */
/* eslint key-spacing    : 0 */


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      nextLabel: 'Next',
      nextEndpoint: '',
      lastStep: false,
      attachedFile: null,
      uploadFileError: ''
    };
  },
  mounted: function mounted() {
    this.$refs.steps.reset();
    // this.enterStep()
  },
  methods: {
    /**
     * onEnterStep
     */
    enterStep: function enterStep(payload) {
      var _this = this;
      var vm = this;
      var from = payload && payload.from;
      var to = payload && payload.to;
      var fromEndpoint = from && from.$el.querySelector('form') && from.$el.querySelector('form').getAttribute('endpoint');
      var toEndpoint = to && to.$attrs.endpoint;
      var requestPayload = {
        filePath: this.$refs.steps.$el.getAttribute('file-id'),
        userId: vm.$user.$.user.UserID,
        vendorId: vm.$user.$.data.VendorID,
        vci: vm.$user.$.user.VCI,
        map: from ? JSON.stringify(from.$attrs.payload) : undefined
      };
      if (toEndpoint && from.section !== to.section) {
        this.api.post(toEndpoint, requestPayload).then(function (r) {
          if (r && r.data && to.$attrs.data && vm[to.$attrs.data]) {
            vm[to.$attrs.data] = r.data;

            // reset errors
            _this.errors = null;

            // set pendingData to prevent leaving the wizard
            vm.$store.state.pendingData = true;
          }
        });
      }
      this._afterEnterStep();
      if (to || payload === null) {
        var stepSlug = to && ~to.href.indexOf('/d/') && to.href.split('/d/')[1].replace(/(\/|-)/g, ' ').replace('#', ' > ');
        payload && __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].GENERIC.WIZARD.ENTERED_STEP, stepSlug);
      }

      // onEnterStep callback
      if (to && to.$attrs.callback && typeof vm[to.$attrs.callback] === 'function') {
        vm[to.$attrs.callback]();
      }

      // endpoint feedback
      if (from && payload && payload.response && from.$attrs.feedback && typeof vm[from.$attrs.feedback] !== 'undefined') {
        vm[from.$attrs.feedback] = payload.response.data || null;
      }
    },
    /**
     * afterEnterStep
     */
    _afterEnterStep: function _afterEnterStep() {
      var _this2 = this;
      var step = this.$refs.steps.getActiveTab();
      this.$nextTick(function () {
        var currentStep = _this2.$refs.steps.getActiveTab();

        // update next label
        _this2.nextLabel = currentStep && (currentStep.$attrs['button-label'] || currentStep.$attrs['optional']) || 'Next';

        // check if last step
        _this2.lastStep = _this2.nextLabel === 'Ok';
        if (_this2.lastStep) {
          // EventBus.$emit(Eved.GENERIC.WIZARD.SUCCESS)
        }
      });
      if (typeof this.afterEnterStep === 'function') this.afterEnterStep();
    },
    /**
     * onExitStep
     */
    proceed: function proceed() {
      var steps = this.$refs.steps;
      var activeStep = steps.getActiveTab();
      var form = activeStep && activeStep.$el.querySelector('form');
      var valid = true;
      this.nextEndpoint = form ? form.getAttribute('endpoint') : '';
      // check if file selected
      this.attachedFile = this.attachedFile || [];
      if (activeStep) {
        // if step is optional (ie. error review)
        // skip to first step
        if (activeStep.optional) {
          // reset errors
          this.errors = null;
          steps.reset();
          __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].GENERIC.WIZARD.RESET, activeStep.optional);
        }

        // mark invalid step
        if (form) {
          form.className = form.checkValidity() ? '' : 'invalid';
        }
      }
      if (activeStep.$attrs.validate && typeof this[activeStep.$attrs.validate] === 'function') {
        valid = this[activeStep.$attrs.validate]();
      }

      // proceed to next step
      valid && form && form.checkValidity() && steps.goToNextTab(this.uploadFileValid);
    }
  },
  computed: {
    // File upload error message handler
    uploadFileValid: function uploadFileValid() {
      var message = ''; // 'Nothing selected'

      if (this.attachedFile && this.attachedFile[0]) {
        var file = this.attachedFile[0];
        var error = file.error;
        if (file.success === true && file.response) {
          this.$refs.steps.$el.setAttribute('file-id', file.response);
        }
        switch (error) {
          case 'extension':
            message = 'Wrong format';
            break;
          case 'denied':
            message = 'Server could not be reached';
            break;
        }
        if (!file.error && file.success) {
          __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].GENERIC.WIZARD.UPLOADED_FILE, this.$refs.header.title);
        }
        this.uploadFileError = message;
        return !file.error;
      }
      this.uploadFileError = message;
      return false || this.attachedFile === null;
    }
  }
});

/***/ }),

/***/ "3gv2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-title-nav',
  props: {
    title: String,
    subtitle: String,
    reference: Boolean,
    tabs: Array,
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      sticky: this.fixed,
      backButton: false,
      backReference: '/' + this.$router.currentRoute.params.namespace + '/' + global.app.backReference
    };
  },
  methods: {
    navigateBack: function navigateBack() {
      // function to go back a page
    },
    setSticky: function setSticky(e) {
      if (typeof this.breakPoint !== 'undefined') {
        this.sticky = e.target.scrollTop > this.breakPoint - 9;
        if (this.sticky) {
          this.nextSibling && this.nextSibling.classList.add('sticky');
        } else {
          this.nextSibling && this.nextSibling.classList.remove('sticky');
        }
      }
    },
    getToolbar: function getToolbar() {
      this.nextSibling = this.$el.nextElementSibling;
      if (~this.nextSibling.className.indexOf('toolbar') && ~this.nextSibling.className.indexOf('sticky')) {
        //
      } else {
        this.nextSibling = null;
      }
    }
  },
  computed: {
    hasOverview: function hasOverview() {
      return this.$slots.overview;
    },
    hasAction: function hasAction() {
      return this.$slots.action;
    },
    backToTitle: function backToTitle() {
      return global.app.backReferenceTitle;
    },
    hasTabs: function hasTabs() {
      return this.$slots.tabs || this.tabs && this.tabs.length;
    },
    backReferenceTitle: function backReferenceTitle() {
      return global.app.backReferenceTitle ? this.$t('to') + ' ' + this.$t(this.backToTitle) : '';
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$refs.toolbar.classList.remove('sticky');
    if (this.fixed) {
      this.$nextTick(function () {
        _this.breakPoint = _this.$el.offsetTop + 5;
      });
    }

    // this.getToolbar()

    var viewport = document.querySelector('.main-panel');
    viewport.removeEventListener('scroll', this.setSticky);
    viewport.addEventListener('scroll', this.setSticky);
  },
  destroyed: function destroyed() {
    var viewport = document.querySelector('.main-panel');
    viewport.removeEventListener('scroll', this.setSticky);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "3haI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-flex active"},[_c('ed-section',{staticClass:"no-flex active no-border",attrs:{"title":" ","subtitle":" ","wide":"","full-width":""}},[_c('ed-form',{attrs:{"submit-visible":false}},[_c('div',{staticClass:"col-md-5 col-md-offset-7 no-pad"},[(_vm.emailSettings.FundingAddress)?_c('funding-address',{attrs:{"model":_vm.emailSettings.FundingAddress,"showEdit":true},on:{"changeAddress":function (d) { return _vm.$emit('changeAddress', d); }}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("To")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("\n            "+_vm._s(_vm.emailSettings.To)+"\n          ")])]),_vm._v(" "),_c('ed-input',{attrs:{"field-label":"CC","required":false,"name":"apfile_cc"},on:{"input":_vm.emitChanges},model:{value:(_vm.emailSettings.Cc),callback:function ($$v) {_vm.$set(_vm.emailSettings, "Cc", $$v)},expression:"emailSettings.Cc"}}),_vm._v(" "),_c('ed-input',{attrs:{"field-label":"BCC","required":false,"name":"apfile_bcc"},on:{"input":_vm.emitChanges},model:{value:(_vm.emailSettings.Bcc),callback:function ($$v) {_vm.$set(_vm.emailSettings, "Bcc", $$v)},expression:"emailSettings.Bcc"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Subject")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('span',{staticClass:"small col-md-10"},[_vm._v("\n              "+_vm._s(_vm.emailSettings.Subject)+"\n            ")])])]),_vm._v(" "),(_vm.emailSettings.CanReplaceAuditFile)?_c('replace-ap-file',{attrs:{"apFile":_vm.getReplaceAuditFileModel(),"token":_vm.token}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"well small clear email-body",domProps:{"innerHTML":_vm._s(_vm.emailSettings.EmailBody)}}),_vm._v(" "),_c('ed-textarea',{attrs:{"field-label":"Add a custom message","required":false,"name":"apfile_message"},on:{"input":_vm.emitChanges},model:{value:(_vm.emailSettings.Message),callback:function ($$v) {_vm.$set(_vm.emailSettings, "Message", $$v)},expression:"emailSettings.Message"}}),_vm._v(" "),_vm._l((_vm.emailSettings.Warnings),function(warning){return _c('div',{key:warning},[_c('p',[_vm._v(_vm._s(warning))])])}),_vm._v(" "),_c('ed-upload',{class:{loading: !_vm.uploadFinished},attrs:{"field-label":"Additional Documentation","button-label":"Upload File","readonly":"","multiple":true,"postAction":_vm.api.env + _vm.api.$.upload.uploadFile,"uploadAuto":true,"data":_vm.uploadData,"required":false,"showHelptipIcon":false,"helptipHeader":"","name":"apfile_additional_files"},on:{"input":_vm.createAttachments}})],2)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3jx6":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Approvals/Approval-history/index.vue": "hcet",
	"./Approvals/Approval-list/index.vue": "Rdqf",
	"./Approvals/Approval-rule/index.vue": "JWhq",
	"./BusinessUnitsAndCostCenters/BU-CC-list/index.vue": "5HOM",
	"./BusinessUnitsAndCostCenters/BU-and-CC-settings/index.vue": "Lfy/",
	"./BusinessUnitsAndCostCenters/BU-list/index.vue": "t2M6",
	"./BusinessUnitsAndCostCenters/CC-list/index.vue": "eJx6",
	"./Dashboard/index.vue": "kb2E",
	"./Dashboard/widgets/ApprovalNeeded/index.vue": "/Blb",
	"./Dashboard/widgets/CategorySpend/index.vue": "pgOF",
	"./Dashboard/widgets/CurrentInvoices/index.vue": "oePj",
	"./Dashboard/widgets/CurrentPrograms/index.vue": "T7Wz",
	"./Dashboard/widgets/HotelSpend/index.vue": "CquV",
	"./Dashboard/widgets/ImmediatePaymentEscrows/index.vue": "dp0g",
	"./Dashboard/widgets/InvoicePaymentStatus/index.vue": "1lw4",
	"./Dashboard/widgets/News/index.vue": "+aHG",
	"./Dashboard/widgets/PaymentsBySupplierType/index.vue": "EO3P",
	"./Dashboard/widgets/ProgramBudget/index.vue": "yjLw",
	"./Dashboard/widgets/RecentUpdates/index.vue": "i2x5",
	"./Dashboard/widgets/Shortcuts/index.vue": "rR4Q",
	"./DashboardWrapper/index.vue": "RTk+",
	"./EvedPay/index.vue": "0zcJ",
	"./FundingInvoiceAndAPSettings/APFileTemplates/index.vue": "BvCo",
	"./FundingInvoiceAndAPSettings/FundingAddresses/index.vue": "YYsc",
	"./FundingInvoiceAndAPSettings/index.vue": "D0AX",
	"./I2P/index.vue": "MIoL",
	"./Import/index.vue": "F73h",
	"./Maps/index.vue": "8t2p",
	"./Payment/index.vue": "neG2",
	"./Programs/Card-accounts/index.vue": "F02B",
	"./Programs/Card-approval/index.vue": "C/fH",
	"./Programs/Card-cards/index.vue": "z3J+",
	"./Programs/Card-envelopes/index.vue": "CDWW",
	"./Programs/Card-list/index.vue": "AJog",
	"./Programs/Card-transactions/index.vue": "AAet",
	"./Programs/Card/index.vue": "h+dw",
	"./Programs/Commissions/index.vue": "TywN",
	"./Programs/Expense-approval/index.vue": "oZ/f",
	"./Programs/Expense-list/index.vue": "Zb4+",
	"./Programs/Invoice-AP/index.vue": "xIs/",
	"./Programs/Invoice-funding/index.vue": "2yrk",
	"./Programs/Invoice-payments-made/index.vue": "+wVm",
	"./Programs/Invoice-payments-received/index.vue": "hV+i",
	"./Programs/Invoice-received-cta/index.vue": "Caey",
	"./Programs/Invoice-received/index.vue": "buef",
	"./Programs/Invoice-sent-cta/index.vue": "4KMk",
	"./Programs/Invoice-sent/index.vue": "jUNV",
	"./Programs/PO-approval/index.vue": "jESG",
	"./Programs/PO-cta/index.vue": "NpfO",
	"./Programs/PO-received/index.vue": "mfm8",
	"./Programs/PO-sent/index.vue": "eWBy",
	"./Programs/Program-list/index.vue": "9cNB",
	"./Programs/Program-received/index.vue": "fBhN",
	"./Programs/Program-sent/index.vue": "31lu",
	"./Programs/RFP-received/index.vue": "E90O",
	"./Programs/RFP-sent/index.vue": "XniG",
	"./Programs/Scopes/index.vue": "iYzi",
	"./Programs/Work-orders/index.vue": "mZZH",
	"./Programs/client-invoices-cta/index.vue": "YWpP",
	"./Programs/client-invoices-payments/index.vue": "qG8u",
	"./Programs/client-invoices/index.vue": "CASk",
	"./Programs/index.vue": "aDuC",
	"./Reports/index.vue": "0/CK"
};
function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
};
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e/* lazy-once context */(0).then(function() {
		var id = map[req];
		if(!(id + 1)) // check for number or string
			throw new Error("Cannot find module '" + req + "'.");
		return id;
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "3jx6";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "3nd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,attrs:{"id":"layout"}},[_c('div',{staticClass:"wrapper centered",class:{ 'nav-open' : _vm.navOpened }},[_c('sidebar',{attrs:{"open":_vm.navOpened}}),_c('div',{staticClass:"main-panel",class:{ 'loading' : _vm.loading }},[_c('navigation',{on:{"toggleSideBar":_vm.toggleSideBar}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"col-md-12"},[_vm._t("default")],2)])]),_c('md-footer'),(_vm.navOpened)?_c('div',{staticClass:"close-layer",on:{"click":_vm.onCloseLayerClick}}):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "40N4":
/***/ (function(module, exports) {

module.exports = {"POConditionDTO":"PO","InvoiceConditionDTO":"Invoice","EvedPayCardConditionDTO":"Eved Pay Card","ScopeConditionDTO":"Scope","ExpenseConditionDTO":"Expense","ProgramBudgetConditionDTO":"Program Budget","AdjustmentAmountConditionDTO":"Adjustment Amount","TotalAmountConditionDTO":"Total Amount","CategoryConditionDTO":"Category","CostCenterConditionDTO":"Cost Center","DivisionConditionDTO":"Division","ItemOwnerConditionDTO":"Item Owner","MeetingTypeConditionDTO":"Meeting Type","BusinessUnitConditionDTO":"Business Unit","RequestApprovalActionDTO":"Request Approval From","NotifyApprovalActionDTO":"Notify","ProgramTeamMemberConditionDTO":"Program Team Member","SupplierEvedPayStatusConditionDTO":"EvedPay Status","DiscountPaymentTermsConditionDTO":"Discounted Payment Terms","PreCommitConditionDTO":"PO Created Date","SupplierLocationConditionDTO":"Supplier Location","SupplierOrganizationTypeConditionDTO":"Supplier Organization Type"}

/***/ }),

/***/ "472K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_he__ = __webpack_require__("t02m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var statuses = {
  'EvedPay': 'evedpay',
  'EvedPay+': 'evedpay',
  'Non-EvedPay': 'not-evedpay'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object,
    hasOnlyP2PPrograms: Boolean,
    isEoadmin: Boolean
  },
  data: function data() {
    return {
      supplier: null,
      suppliers: [],
      bankAccount: '',
      currencyCode: '',
      originalSuppliers: [],
      displayEvedPayStatus: false,
      displayBankAccount: false,
      evedPayStatus: '',
      supplierDifferentCurrency: false,
      disableSupplier: function disableSupplier(supplier) {
        var disableSupp = supplier !== null || this.hasOnlyP2PPrograms;
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('disableSupplier', disableSupp);
        return disableSupp;
      },
      label: function label(status) {
        return statuses[status] || 'default-status';
      }
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.ADDED_NEW_SUPPLIER);
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.ADDED_NEW_SUPPLIER, this.onAddedNewSupplier);
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.REMOVE_SUPPLIER);
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.REMOVE_SUPPLIER, this.removeSupplier);
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.CURRENCY_SELECTED);
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.CURRENCY_SELECTED, this.onUpdateCurrency);
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('checkEoNumber', this.model.Supplier.SupplierVCI);
    this.he = __WEBPACK_IMPORTED_MODULE_3_he___default.a;
  },
  activated: function activated() {
    var _this = this;
    this.$nextTick(function () {
      _this.updateEvedPayStatus();
      _this.fetchBankAccount(_this.model.Supplier.SupplierVCI, _this.model.CurrencyCode);
    });
  },
  computed: {
    isP2PInvoice: function isP2PInvoice() {
      return this.model.InvoiceWorkflow && this.model.InvoiceWorkflow.indexOf('P2PInvoice') !== -1;
    },
    supplierComboPlaceholder: function supplierComboPlaceholder() {
      return this.isP2PInvoice || this.hasOnlyP2PPrograms ? 'Please select PO first' : 'Start typing to search for your supplier';
    }
  },
  methods: {
    updateEvedPayStatus: function updateEvedPayStatus() {
      var _this2 = this;
      this.displayEvedPayStatus = false;
      this.evedPayStatus = '';
      if (this.model.Supplier) {
        this.api.forms.post(this.api.$.invoice.i2p.supplierEvedPayStatus, {
          supplierId: this.model.SupplierId || 0,
          nonEvedEmail: this.model.Supplier.EmailAddress
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this2.evedPayStatus = r.data.Data;
            if (_this2.evedPayStatus) {
              _this2.displayEvedPayStatus = true;
              if (_this2.evedPayStatus !== 'EvedPay' && _this2.evedPayStatus !== 'EvedPay+') {
                _this2.supplierDifferentCurrency = false;
              }
            }
          }
        });
      }
    },
    //
    fetchSuppliersOnOpen: function fetchSuppliersOnOpen() {
      var _this3 = this;
      this.suppliers.length || this.api.forms.post(this.api.$.invoice.suppliers, {
        q: '',
        invoiceId: this.model.PaymentInvoiceId
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          _this3.suppliers = JSON.parse(r.data.Data);
          _this3.originalSuppliers = JSON.parse(r.data.Data);
        }
      }).catch(function (e) {
        return console.warn(e);
      });
      //
    },
    fetchBankAccount: function fetchBankAccount(supplierEoNumber, currency) {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var results;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this4.isEoadmin || supplierEoNumber === 0)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _this4.displayBankAccount = false;
              _this4.bankAccount = '';
              _context.next = 6;
              return _this4.api.post(_this4.api.$.invoice.suppliersBankAccount, {
                supplierEoNumber: supplierEoNumber,
                currency: currency
              });
            case 6:
              results = _context.sent;
              if (results && results.data) {
                _this4.bankAccount = results.data.Data;
                _this4.currencyCode = currency;
                _this4.displayBankAccount = !!_this4.bankAccount;
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchSuppliers: function fetchSuppliers(query) {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var results;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this5.api.forms.post(_this5.api.$.invoice.suppliers, {
                q: query || '',
                invoiceId: _this5.model.PaymentInvoiceId
              });
            case 2:
              results = _context2.sent;
              if (results && results.data && results.data.Data) {
                _this5.suppliers = JSON.parse(results.data.Data);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    restoreSuppliers: function restoreSuppliers() {
      this.suppliers = utils.copy(this.originalSuppliers);
    },
    removeSupplier: function removeSupplier() {
      this.supplier = null;
      this.supplierDifferentCurrency = false;
      this.$emit('supplierRemoved', null);
      this.model.Errors.SupplierMissing = false;
    },
    selectedSupplier: function selectedSupplier(e) {
      this.model.SupplierId = e.Value.VendorId;
      this.model.SupplierVci = e.Value.VendorVCI;
      this.model.SupplierName = e.Value.SupplierName;
      this.model.SupplierUserId = e.Value.ContactVendorUserId;
      this.model.DiscountPaymentTermID = e.Value.DiscountPaymentTermId;
      this.model.DiscountName = e.Value.DiscountName;
      this.model.DiscountDisplayName = e.Value.DiscountDisplayName;
      this.model.DaysNo = e.Value.DiscountDaysNo;
      this.model.Supplier.VendorID = e.Value.VendorId;
      this.model.Supplier.VendorUserID = e.Value.ContactVendorUserId;
      this.model.Supplier.SupplierName = e.Value.CompanyName;
      this.model.Supplier.SupplierContactName = e.Value.SupplierName;
      this.model.Supplier.SupplierVCI = e.Value.Vci;
      this.model.Supplier.SupplierZIP = e.Value.SupplierZIP;
      this.model.Supplier.EmailAddress = e.Value.SupplierEmail;
      this.model.Supplier.SupplierPhone = e.Value.SupplierPhone;
      this.model.Supplier.VendorType = e.Value.VendorType;
      this.model.Supplier.HasDefaultImmediatePayment = e.Value.HasDefaultImmediatePayment;
      this.model.Supplier.WithholdingTaxPercent = e.Value.WithholdingTaxPercent;
      this.model.Supplier.Currencies = e.Value.Currencies;
      this.model.Supplier.SupplierAddress1 = e.Value.Address;
      this.model.Supplier.SupplierAddress2 = e.Value.Address2;
      this.model.Supplier.SupplierCity = e.Value.City;
      this.model.Supplier.CountryName = e.Value.CountryName;
      this.model.Supplier.SupplierRegion = e.Value.Region;
      this.model.Supplier.SupplierState = e.Value.State;
      this.model.Errors.SupplierMissing = false;
      this.updateEvedPayStatus();
      if (this.model.CurrencyCode) {
        if (this.model.Supplier.VendorID > 0 && this.model.Supplier.Currencies && this.model.Supplier.Currencies.indexOf(this.model.CurrencyCode) === -1) {
          this.supplierDifferentCurrency = true;
        } else {
          this.supplierDifferentCurrency = false;
        }
      }
      this.$emit('supplierSelected', this.getSupplierSelectedModel(this.model, e.Value.Vci));
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('checkEoNumber', this.model.Supplier.SupplierVCI);
      this.fetchBankAccount(e.Value.Vci, this.model.CurrencyCode);
    },
    onUpdateCurrency: function onUpdateCurrency(e) {
      this.currencyCode = e.data.code;
      if (this.supplier && this.supplier.Value && this.supplier.Value.Vci) {
        this.fetchBankAccount(this.supplier.Value.Vci, this.currencyCode);
      }
      if (this.supplier && this.supplier.Value.VendorId > 0 && (this.evedPayStatus === 'EvedPay' || this.evedPayStatus === 'EvedPay+') && this.supplier.Value.Currencies.indexOf(e.data.code) === -1) {
        this.supplierDifferentCurrency = true;
      } else {
        this.supplierDifferentCurrency = false;
      }
    },
    onAddedNewSupplier: function onAddedNewSupplier(e) {
      var suppInfo = e.data;
      var supplierInfoVM = suppInfo.SupplierInfoVM;
      var cardInfo = suppInfo.CardInfo;
      var logo = null;
      if (cardInfo.logoPath && cardInfo.Logo) {
        logo = cardInfo.logoPath + cardInfo.Logo;
      } else {
        logo = cardInfo.defaultImg;
      }
      var newSupplier = {
        Key: suppInfo.VendorId,
        Value: {
          CompanyName: supplierInfoVM.SupplierName,
          ContactVendorUserId: suppInfo.VendorUserID,
          DefaultEmailImage: cardInfo.defaultEmailImg,
          DefaultImage: cardInfo.defaultImg,
          DefaultPhoneImage: cardInfo.defaultPhoneImg,
          Logo: logo,
          MyVendorTempEONumber: 0,
          NonEvedTempEoNumber: 0,
          SupplierEmail: supplierInfoVM.EmailAddress,
          SupplierName: supplierInfoVM.SupplierContactName,
          SupplierPhone: supplierInfoVM.SupplierPhone,
          VatGstId: supplierInfoVM.VatGstId,
          SupplierAddress1: supplierInfoVM.SupplierAddress1,
          SupplierAddress2: supplierInfoVM.SupplierAddress2,
          SupplierCity: supplierInfoVM.SupplierCity || this.model.Supplier.SupplierCity,
          City: supplierInfoVM.SupplierCity || this.model.Supplier.SupplierCity,
          State: supplierInfoVM.SupplierState,
          SupplierRegion: supplierInfoVM.SupplierRegion,
          SupplierZIP: supplierInfoVM.SupplierZIP,
          CountryName: supplierInfoVM.SupplierCountryName || this.model.Supplier.CountryName,
          VendorType: supplierInfoVM.VendorType,
          HasDefaultImmediatePayment: supplierInfoVM.HasDefaultImmediatePayment,
          Currencies: supplierInfoVM.Currencies,
          Vci: suppInfo.VendorVCI,
          VendorId: suppInfo.VendorId
        }
      };
      this.supplier = newSupplier;
      this.model.SupplierId = suppInfo.VendorId;
      this.model.SupplierName = supplierInfoVM.SupplierName;
      this.model.SupplierUserId = suppInfo.VendorUserID;
      this.model.DiscountPaymentTermID = supplierInfoVM.DiscountPaymentTermID;
      this.model.DiscountName = supplierInfoVM.DiscountName;
      this.model.DiscountDisplayName = supplierInfoVM.DiscountDisplayName;
      this.model.DaysNo = supplierInfoVM.DiscountDaysNo;

      // Supplier model
      this.model.Supplier = _objectSpread(_objectSpread({}, this.model.Supplier), supplierInfoVM);
      this.model.Errors.SupplierMissing = false;
      this.updateEvedPayStatus();
      if (suppInfo.VendorId > 0 && suppInfo.InvoiceCurrencyCode && supplierInfoVM.Currencies && supplierInfoVM.Currencies.indexOf(suppInfo.InvoiceCurrencyCode) === -1) {
        this.supplierDifferentCurrency = true;
      } else {
        this.supplierDifferentCurrency = false;
      }
      this.$emit('supplierSelected', this.getSupplierSelectedModel(this.model, suppInfo.VendorVCI, suppInfo.IsInitSupplier));
      this.fetchBankAccount(this.model.Supplier.SupplierVCI, this.model.CurrencyCode);
    },
    getSupplierSelectedModel: function getSupplierSelectedModel(supplierInfoVM, vci, isInitSupplier) {
      return {
        SupplierInfoVM: supplierInfoVM,
        Vci: vci,
        IsInitSupplier: isInitSupplier
      };
    },
    getLabel: function getLabel(option) {
      return option.Value.CompanyName + (option.Value.Vci ? '(' + option.Value.Vci + ')' : '');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "494k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  InitialInvoiceAmount: 0,
  InitialInvoiceCurrencyCode: null,
  InvoiceCurrencyCode: null,
  CurrentInvoicedAmount: 0,
  InvoiceId: 0,
  DueTime: null
});

/***/ }),

/***/ "49K6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules__ = __webpack_require__("vZ0M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_legacy_auth__ = __webpack_require__("mnjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json__ = __webpack_require__("ZVSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__item__ = __webpack_require__("ynfE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Navigation_navbar_search__ = __webpack_require__("XU2j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Navigation_navbar_right__ = __webpack_require__("P4e5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var allowedModules = __WEBPACK_IMPORTED_MODULE_1__core_legacy_auth__["a" /* default */].allowedModules;
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    open: Boolean
  },
  components: {
    Item: __WEBPACK_IMPORTED_MODULE_3__item__["a" /* default */],
    NavbarSearch: __WEBPACK_IMPORTED_MODULE_4__components_Navigation_navbar_search__["a" /* default */],
    NavbarRight: __WEBPACK_IMPORTED_MODULE_5__components_Navigation_navbar_right__["a" /* default */]
  },
  created: function created() {
    this.allowedModules = allowedModules.get;
  },
  computed: {
    namespace: function namespace() {
      return global.config.namespace || 'd';
    },
    tabs: function tabs() {
      var tabs = this.sitemap || (this.namespace !== 'd' ? this.namespace === '404' ? this.allowedModules : this.allowedModules /* Modules */ : this.allowedModules);
      return tabs;
    }
  },
  data: function data() {
    return {
      section: function section(tab, subTab, subKey) {
        // if (Modules[tab].notImplemented) return subTab
        var url = __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab] ? __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack && ((__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack[subTab] || {}).name || __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].pack[subTab]) || this.tabs[tab].subtabs && this.tabs[tab].subtabs[subKey] : '';
        if (this.tabs[tab].subtabs && global.config.namespace) {
          return subKey;
        }
        return url;
      },
      sectionNamespace: function sectionNamespace(tab, subTab, subKey) {
        if (global.config.namespace) return global.config.namespace;
        return __WEBPACK_IMPORTED_MODULE_0__components_modules__["a" /* default */][tab] && !__WEBPACK_IMPORTED_MODULE_0__components_modules__["a" /* default */][tab].entry && !__WEBPACK_IMPORTED_MODULE_0__components_modules__["a" /* default */][tab].notImplemented || __WEBPACK_IMPORTED_MODULE_0__components_modules__["a" /* default */][tab + '/' + this.section(tab, subTab, subKey)] || __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].subtabs && __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].subtabs[subTab] ? 'd' : 'i';
      }
    };
  },
  methods: {
    linkClicked: function linkClicked() {
      this.$emit('linkClicked');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "4AHt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_26vwRik0l3q4pd5c4VQFoj","Dell":"_2crU2xjHRhHQStoNKNlDNk","Abbott":"_2JItizpw-jla1o6Js74sFE","Gap":"_1oLhP1mT7eN0fuOxjl3aOD","Allstate":"_2GUyO-HWWdsOm-roTJpn6A","Asurion":"_341ftVXxU6BiFGmBtI01Hq","Invitae":"_2hFt98PeC1ANfd77lvEe_s","JWE":"_3NkgRdH_TgBs6H7gBDOG9v"};

/***/ }),

/***/ "4CTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_ON_TAB_CLICK; });
var EVENT_ON_TAB_CLICK = 'onTabClick';

/***/ }),

/***/ "4DzP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1_z_oI0pUTH0HIeo2KmIbg","Dell":"_1_fTd8AHm4FJV-sp0tepcU","Abbott":"_2wyPwILfkSUnLtI0hkfAMp","Gap":"_3ceZizZ7_LBeH8pCin1ONt","Allstate":"_1YHxl9F995MkW-JWoTyrqj","Asurion":"_1bV9qqB4DuKlC2ssM4xSZA","Invitae":"_2I87KimdzsdJwbMzgEn5TE","JWE":"_23nJMe6L-o_Ks3ogDo_-HV"};

/***/ }),

/***/ "4HWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return include; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json__ = __webpack_require__("ZVSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json__);
// module packer

// import notFound from '@/components/GeneralViews/NotFound.vue'

var include = function include(pack) {
  var bundle = {};
  var modules = __WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json___default.a[pack].pack;
  Object.keys(modules).forEach(function (key) {
    var module = modules[key];
    var normalizedModule = module.replace('>', '');
    var modulePath = module.replace('/', '-');
    bundle[module] = function () {
      return __webpack_require__("3jx6")("./".concat(pack, "/").concat(normalizedModule, "/index.vue"));
    };
    bundle[modulePath] = function () {
      return __webpack_require__("3jx6")("./".concat(pack, "/").concat(modulePath.replace('>', ''), "/index.vue"));
    };
    bundle[module + '/create'] = function () {
      return __webpack_require__("kT8D")("./".concat(pack, "/").concat(normalizedModule, "/create.vue")).catch(function (e) {
        console.warn('Not found');
        global.app.$router.push(global.app.$routerHistory.previous().path);
        global.app.$loading = false;
        throw new Error('page not found');
      }).catch(function (e) {
        //
        if (!global.pageNotFound) {
          global.pageNotFound = true;
          global.app.$notifications.notify({
            type: 'plain',
            icon: 'exclamation-circle',
            message: global.app.$i18n.t('pageNotSupported'),
            placement: {
              from: 'top',
              align: 'center'
            }
          });
        }
      });
    };
  });
  return bundle;
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "4KMk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("XUrf");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8f6f90c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("/Z1n");
function injectStyle (ssrContext) {
  __webpack_require__("KOC9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f8f6f90c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8f6f90c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4LcA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_ApprovalNeeded_approve_dialog__ = __webpack_require__("u8Yq");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'ApproveAll',
  data: function data() {
    return {
      loading: false,
      dataUrl: null,
      approveUrl: null,
      showApproveDialog: false,
      cards: []
    };
  },
  computed: {
    hasData: function hasData() {
      return this.cards !== null && this.cards.length > 0;
    }
  },
  created: function created() {
    this.reload();
  },
  methods: {
    reload: function reload() {
      var _this = this;
      this.loading = true;
      this.api.get(this.api.$.dashboard.widgetInfo + '/2845D6A6-F692-493C-83DF-BACD8D349BC8', {}).then(function (rd) {
        _this.dataUrl = rd.data.endPoint;
        _this.approveUrl = _this.dataUrl.replace(/GetApprovalNeededList/, 'Approve');
        var params = _this.$route.query.batchId > 0 ? {
          params: {
            batchId: +_this.$route.query.batchId
          }
        } : {};
        _this.api.get(_this.dataUrl, params).then(function (r) {
          _this.cards = r.data.items;
          if (_this.hasData) {
            _this.showApproveDialog = true;
          }
        }).finally(function () {
          _this.loading = false;
        });
      });
    },
    doApprove: function doApprove(reason) {
      var _this2 = this;
      this.loading = true;
      this.api.post(this.approveUrl, {
        list: this.getIdsList(),
        reason: reason,
        batchId: this.$route.query.batchId > 0 ? this.$route.query.batchId : null
      }).finally(function () {
        _this2.loading = false;
        _this2.gotoDashboard();
      });
    },
    gotoDashboard: function gotoDashboard() {
      this.$router.push('/home');
    },
    getIdsList: function getIdsList() {
      return this.cards.map(function (item) {
        return item.Id;
      });
    }
  },
  components: {
    approveDialog: __WEBPACK_IMPORTED_MODULE_0__widgets_ApprovalNeeded_approve_dialog__["default"]
  }
});

/***/ }),

/***/ "4QeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WidgetOptions__ = __webpack_require__("eiQj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],
  props: ['widget', 'options'],
  data: function data() {
    return {
      isMenuOpen: false,
      showSettings: false
    };
  },
  computed: {
    minimized: function minimized() {
      return this.widget.isCollapsed;
    },
    buttons: function buttons() {
      return this.widget.actions;
    },
    hasOptions: function hasOptions() {
      return this.widget.variables.length > 1;
    }
  },
  components: {
    WidgetOptions: __WEBPACK_IMPORTED_MODULE_2__WidgetOptions__["default"]
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$on('widgetSettingsClose', this.hideSettingsDialog);
  },
  methods: {
    closeMenu: function closeMenu() {
      this.isMenuOpen = false;
    },
    toggleCollapse: function toggleCollapse() {
      this.closeMenu();
      this.$emit('toggleCollapse');
    },
    showSettingsDialog: function showSettingsDialog() {
      this.closeMenu();
      this.removeTopClass();
      this.showSettings = true;
      this.$parent.$el.classList.toggle('top');
      this.bringWidgetToFront();
    },
    hideSettingsDialog: function hideSettingsDialog() {
      this.showSettings = false;
      this.$parent.$el.classList.remove('top');
    },
    bringWidgetToFront: function bringWidgetToFront() {
      this.removeTopClass();
      this.$parent.$el.classList.add('alternateTop');
    },
    removeTopClass: function removeTopClass() {
      var element = document.querySelector('.alternateTop');
      if (element) element.classList.remove('alternateTop');
    },
    buttonAction: function buttonAction(action) {
      this.closeMenu();
      if (action.action.includes('ReportDetails')) {
        __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$emit('updateNavigatedAwayFrom', this.widget.id);
      }
    },
    set: function set(v) {
      this.$emit('set', v);
    }
  }
});

/***/ }),

/***/ "4SHw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-custom-cell ag-cell-qty",class:[_vm.invalidClass, _vm.infoMessage || _vm.warningMessage ? "info-message" : ""]},[_c('div',{staticClass:"ag-custom-cell-value"},[_vm._v(_vm._s(_vm.moneyValue))]),_vm._v("  "),(_vm.infoMessage && !_vm.totalsRow)?_c('i',{staticClass:"far fa-info-circle info-icon",attrs:{"title":_vm.infoMessage}}):_vm._e(),(_vm.warningMessage)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.validationMessage),expression:"validationMessage"}],staticClass:"fas fa-exclamation-circle info-icon error-icon"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Su7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__ = __webpack_require__("jfA3");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e5a6c9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__ = __webpack_require__("a4zV");
function injectStyle (ssrContext) {
  __webpack_require__("csE1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67e5a6c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e5a6c9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4XWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_user__ = __webpack_require__("uduW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login_accounts__ = __webpack_require__("i+5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_sass_themes_index_scss__ = __webpack_require__("DOYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_sass_themes_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_sass_themes_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layouts__ = __webpack_require__("r4/r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules__ = __webpack_require__("vZ0M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_GeneralViews_NotFound_vue__ = __webpack_require__("pqHe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_LegacyContainer__ = __webpack_require__("jIfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_loading_indicators__ = __webpack_require__("WFO1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_legacy_auth__ = __webpack_require__("mnjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_site_map_map_json__ = __webpack_require__("ZVSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_site_map_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__core_site_map_map_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_LegacyContainer_legacyRouter__ = __webpack_require__("IYIA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_LegacyContainer_routeOldLinks__ = __webpack_require__("a8Xb");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */















// import tour              from '@/components/tour'

var allowedModules = __WEBPACK_IMPORTED_MODULE_11__core_legacy_auth__["a" /* default */].allowedModules;
var Components = null;
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Accounts: __WEBPACK_IMPORTED_MODULE_3__components_Login_accounts__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    Components = __WEBPACK_IMPORTED_MODULE_6__components_modules__["a" /* default */].__get();
    // tour.init()

    __WEBPACK_IMPORTED_MODULE_13__components_LegacyContainer_legacyRouter__["a" /* default */].methods.polyfillParent.call(this);
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var fromModule = getModule(from);
    var moduleContext = this.$refs.currentModule;
    this.$loading = false;

    //
    this.$store.state.gridExpandOffset = {};
    if (fromModule && typeof fromModule.beforeLeave === 'function' && to.path !== from.path) {
      !fromModule.beforeLeave.apply(moduleContext) ? this.$notifications.notify({
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        timeout: 0,
        message: "Are you sure you want to navigate away ?",
        dismiss: 'Yes',
        discard: 'No',
        goto: null,
        onClose: function onClose(dismiss) {
          if (dismiss) {
            //
            next();
          } else if (dismiss === null) {
            //
          }
        }
      }) : next();
    } else {
      next();
    }
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_1__core_feature_flags_feature_flags__["a" /* default */].legacyViewDisabled && document.referrer.indexOf('noSwitchAccount') === -1) __WEBPACK_IMPORTED_MODULE_14__components_LegacyContainer_routeOldLinks__["a" /* routeOldLinks */].call(this, this.$route);
  },
  mounted: function mounted() {
    if (global.config.enableThemes) this.applyTheme();
    this.switchAccountAfterLogin = this.$refs.accounts.switchAccountAfterLogin;
  },
  computed: {
    themeNamespace: function themeNamespace() {
      if (global.config.enableThemes && global.config.namespace) {
        return global.config.namespace + ' default';
      }
      if (__WEBPACK_IMPORTED_MODULE_2__core_user__["a" /* default */].get() && __WEBPACK_IMPORTED_MODULE_2__core_user__["a" /* default */].get().theme && __WEBPACK_IMPORTED_MODULE_4__assets_sass_themes_index_scss___default.a[__WEBPACK_IMPORTED_MODULE_2__core_user__["a" /* default */].get().theme]) {
        return __WEBPACK_IMPORTED_MODULE_4__assets_sass_themes_index_scss___default.a[__WEBPACK_IMPORTED_MODULE_2__core_user__["a" /* default */].get().theme];
      }
      return 'default';
    },
    layout: function layout() {
      var app = this._self;
      var route = app.$route;
      var module = Components[route.params.page || route.name];

      // always use `navless` layout on `create` action
      if (route.params.action === 'create') return __WEBPACK_IMPORTED_MODULE_5__components_Layouts__["a" /* default */].navless;
      if (route.params.section && Components[route.params.page + '/' + route.params.section]) {
        module = Components[route.params.page + '/' + route.params.section];
      }
      if (module && module.layout) {
        return __WEBPACK_IMPORTED_MODULE_5__components_Layouts__["a" /* default */][module.layout].default;
      } else {
        // return Layouts.default
        if (global.config.layout) return __WEBPACK_IMPORTED_MODULE_5__components_Layouts__["a" /* default */][global.config.layout].default || __WEBPACK_IMPORTED_MODULE_5__components_Layouts__["a" /* default */].default.default;
        return __WEBPACK_IMPORTED_MODULE_5__components_Layouts__["a" /* default */].other.default;
      }
    }
  },
  data: function data() {
    return {
      featureFlags: __WEBPACK_IMPORTED_MODULE_1__core_feature_flags_feature_flags__["a" /* default */],
      hasAccounts: true,
      switchAccountAfterLogin: false,
      showLeaveConfirmation: false,
      className: '',
      refName: '',
      module: function module(fromRoute) {
        var app = this._self;
        var route = fromRoute || app.$route;
        skipToSubmodule.call(this);
        var module = getModule(route);
        // check allowed
        if (module && module.notAllowed) return __WEBPACK_IMPORTED_MODULE_8__components_GeneralViews_NotFound_vue__["a" /* default */];

        // if (module.notImplemented) return notImplemented

        // legacy modules
        global.app.currentModule = app.$root.currentModule = (route.params.section || route.params.page || route.name).split('-')[0];
        if (route.params.namespace === 'i' || module && module.notImplemented && module.notImplemented !== 'yet') {
          return __WEBPACK_IMPORTED_MODULE_9__components_LegacyContainer__["a" /* default */];
        }
        this.className = module && module.legacy ? 'legacy' : '';
        if (module) {
          module.on('afterLoad', function () {
            __WEBPACK_IMPORTED_MODULE_10__core_loading_indicators__["a" /* default */].hook.stop.call(app); /* ; tour.show(route) */
          }).on('beforeLoad', function () {
            return __WEBPACK_IMPORTED_MODULE_10__core_loading_indicators__["a" /* default */].hook.start.call(app);
          });
          global.app.backReference = this.refName = module.reference || '';
          global.Intercom && global.Intercom('update', _objectSpread(_objectSpread({}, global.intercomSettings), {}, {
            last_request_at: parseInt(new Date().getTime() / 1000)
          }));

          //
          var beforeLeaveHook = (module.module || module).beforeLeave;
          if (typeof beforeLeaveHook === 'function') {
            // app.$store.state.pendingData = !beforeLeaveHook()
            window.addEventListener('beforeunload', beforeLeave);
            // console.log('attached hook')
          } else {
            // console.log('detached hook')
            window.removeEventListener('beforeunload', beforeLeave);
          }
          return module.module || module;
        } else {
          return route.params.section ? __WEBPACK_IMPORTED_MODULE_9__components_LegacyContainer__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__components_GeneralViews_NotFound_vue__["a" /* default */];
        }
      }
    };
  },
  methods: {
    applyTheme: function applyTheme() {
      //
      var theme = document.querySelector('.' + this.themeNamespace);
      var themeId = null;
      if (theme) {
        /* if (theme.currentStyle) {
          themeId = theme.currentStyle['-content']
        } else {
          themeId = getComputedStyle(theme).content
        } */
        themeId = getComputedStyle(theme, ':before').content;
        themeId = themeId && themeId.replace(/"/g, '');
        theme.className += ' ' + themeId;
      }
    },
    doNext: function doNext() {}
  }
});
function beforeLeave(e) {
  var moduleContext = document.querySelector('.theme.skin').__vue__.$refs.currentModule;
  var moduleHook = !document.querySelector('.theme.skin').__vue__.module(__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].currentRoute).beforeLeave.apply(moduleContext);
  // e.preventDefault()
  if (moduleHook) {
    e.returnValue = '';
  }
}

/**
 * Returns the module based on route
 *
 * @param {object} route - current route
 * @returns {object} module
 */
function getModule(route) {
  var module = Components[route.params.page || route.name];
  var allowed = allowedModules.get[route.params.page];

  // docs
  if (route.params.namespace === 'docs' && !module) {
    // return notImplemented
  }

  // pack submodule action
  if (module && module.pack && route.params.action) {
    module = Components[route.params.section + '-' + route.params.action] || Components[route.params.section + (route.params.action ? '/' + route.params.action : '')] || Components[route.params.page + '/' + route.params.section.replace('>', '') + (route.params.action ? '/' + route.params.action : '')];
  }
  // pack submodule
  if (module && module.pack && route.params.section) {
    module = Components[route.params.section];
  }

  // submodule
  if (route.params.section && Components[route.params.page + '/' + route.params.section]) {
    module = Components[route.params.page + '/' + route.params.section];
  }

  // config sitemap
  if (route.params.section && global.config.namespace && global.config.sitemap && global.config.sitemap[global.config.namespace] && global.config.sitemap[global.config.namespace][route.params.page] && global.config.sitemap[global.config.namespace][route.params.page].subtabs && global.config.sitemap[global.config.namespace][route.params.page].subtabs[route.params.section]) {
    module = Components[route.params.page + '/' + route.params.section];
  }
  if (!(allowed && allowed.entry)) {
    if (module) module.notImplemented = Components[route.params.page] ? Components[route.params.page].notImplemented : false;
  }
  return module;
}

/**
 * Navigates to first module in pack or to configured entry point
 */
function skipToSubmodule() {
  if (this.$router.currentRoute.params.namespace === 'docs') return;
  var route = this.$router.currentRoute;
  var module = Components[route.params.page || route.name];
  var allowed = allowedModules.get[route.params.page];
  var submodules = __WEBPACK_IMPORTED_MODULE_12__core_site_map_map_json___default.a[route.params.page] && __WEBPACK_IMPORTED_MODULE_12__core_site_map_map_json___default.a[route.params.page].pack || null;
  var subtabs = Components[route.params.page] && Components[route.params.page].notImplemented || Components[route.params.page] && Components[route.params.page].pack;
  if (allowed && allowed.entry && !route.params.section) {
    this.$router.push(allowed.entry);
    return;
  }
  if (!module || !allowed) return __WEBPACK_IMPORTED_MODULE_8__components_GeneralViews_NotFound_vue__["a" /* default */];
  if (!allowed.subtabs) return;
  var first = allowed.subtabs[Object.keys(allowed.subtabs)[0]];
  var firstModule = submodules /* && !module.notImplemented */ ? submodules[first] && submodules[first].name || submodules[first] : first && first.name || first;

  //
  var defaultModule = submodules && Object.keys(submodules).filter(function (k) {
    return ~k.indexOf('#');
  })[0].replace('#', '');
  var namespace = Components[firstModule] && !module.notImplemented ? 'd' : 'i';
  if (defaultModule && !route.params.section) {
    this.$router.push('/' + namespace + '/' + route.params.page + "/?goto=".concat(defaultModule));
  }
  if (firstModule && allowed && !route.params.section && subtabs) {
    var gotopage = route.query.goto ? "?goto=".concat(route.query.goto) : '';
    var url = '/' + namespace + '/' + route.params.page + '/' + firstModule + '/' + gotopage;
    this.$router.push(url);
  }
  if (module && module.entry && !route.params.section) {
    this.$router.push(module.entry);
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "4Z6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar-search',
  data: function data() {
    return {
      searchText: ''
    };
  }
});

/***/ }),

/***/ "4Zn2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-header",attrs:{"data-background-color":_vm.backgroundColor}},[(!!_vm.icon)?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),(!!_vm.faIcon)?_c('i',{class:_vm.faIcon}):_vm._e()]),_c('div',{staticClass:"card-content"},[_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.title))]),_c('h3',{staticClass:"title"},[_vm._t("content")],2)]),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"stats"},[_vm._t("footer")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4jeW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4lSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layour-default",attrs:{"id":"layout"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4xzk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony default export */ __webpack_exports__["a"] = ({
  'DisplayName': {
    label: 'Available Statements',
    compose: filePath,
    width: 10
  },
  'CreatedDate': '_',
  'AccountId': '_',
  'PathWithName': '_',
  'StartDate': '_',
  'EndDate': '_'
});
function filePath(p) {
  if (!p.data) return '';
  return "<a title=\"Open ".concat(p.value, "\"\n             href=\"").concat(global.app.api.$.privateResources).concat(p.data.PathWithName, "\"\n             target=\"_blank\"\n             rel=\"noopener noreferrer\"\n             data-action=\"goto\">\n             ").concat(p.value, "\n         </a>");
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "4zVd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-custom-cell"},[(_vm.params.colDef.cellClass === "amount")?_c('v-money',{ref:"detailsMoneys",attrs:{"currency":_vm.params.data && _vm.params.data.CurrencyCode}},[_vm._v(_vm._s(_vm.params.value))]):_c('div',{staticClass:"ag-detail-cell-value"},[(_vm.params.colDef.detailsRender)?_c(_vm.params.colDef.detailsRender,{tag:"component",attrs:{"params":_vm.params}}):_c('span',[_vm._v(_vm._s(_vm.params.value))])],1),_vm._v("  "),(_vm.params.colDef.hasDetails && _vm.detailsCondition)?_c('i',{class:("fal fa-" + (_vm.shownDetails ? "minus" : "plus") + "-circle ag-row-expand-icon"),on:{"click":_vm.showDetails}}):_vm._e(),(_vm.shownDetails)?_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.hideDetails),expression:"hideDetails"}],staticClass:"ag-row-details",class:{ "shown": _vm.shownDetails },style:(_vm.position)},[_c('i',{staticClass:"ag-row-expand-close fal fa-times",style:(_vm.closeIconPosition),on:{"click":_vm.showDetails}}),_c('div',{staticClass:"ag-row-details-content col-md-12",style:(_vm.contentPosition)},[_c('div',{ref:"body",staticClass:"ag-row-expanded-body"},[(_vm.shownDetails && _vm.loadedDetails)?_c(_vm.params.comps,{tag:"component",attrs:{"model":_vm.detailsModel,"currency":this.params.context.currencyCode}},[_c('div',{staticClass:"details",attrs:{"slot":"body"},slot:"body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlDetails)}})])]):_vm._e()],1)])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4zWp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object,
    showEdit: Boolean
  },
  data: function data() {
    return {
      showModal: false,
      modelCopy: _objectSpread(_objectSpread({}, this.model), {}, {
        country: {
          CountryID: 0,
          CountryName: this.model.CountryName
        },
        state: {
          StateID: 0,
          StateName: this.model.StateOrRegionName
        },
        Region: this.model.StateOrRegionName
      }),
      USstates: [{
        StateID: 0,
        StateName: this.model.StateOrRegionName
      }],
      USoriginalStates: [],
      canadaStates: [{
        StateID: 0,
        StateName: this.model.StateOrRegionName
      }],
      originalCanadaStates: [],
      countries: [{
        CountryID: 0,
        CountryName: this.model.CountryName
      }],
      originalCountries: [],
      counter: 0
    };
  },
  methods: {
    save: function save() {
      this.modelCopy.CityStateZip = "".concat(this.modelCopy.CityName, ", ").concat(this.modelCopy.StateName || this.modelCopy.Region);
      if (this.modelCopy.CityStateZip.trim() === ',') this.modelCopy.CityStateZip = '';
      this.modelCopy.CityStateZip += ' ' + this.modelCopy.ZipCode;
      this.$emit('changeAddress', this.modelCopy);
      this.model = this.modelCopy;
      this.showModal = false;
    },
    fetchCountriesOnOpen: function fetchCountriesOnOpen() {
      var _this = this;
      if (this.countries.length && this.countries[0].CountryID !== 0) {} else {
        this.api.forms.post(this.api.$.profile.getAllCountries, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this.countries = r.data.Data;
            _this.originalCountries = r.data.Data;
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    fetchCountries: function fetchCountries(value) {
      var _this2 = this;
      this.counter || this.api.forms.post(this.api.$.profile.getAllCountries, {
        q: value || ''
      }).then(function (r) {
        _this2.counter = 0;
        if (r && r.data && r.data.Data) {
          _this2.countries = r.data.Data;
        }
      }).catch(function (e) {
        console.warn(e);
        _this2.counter = 0;
      });
      this.counter = 1;
    },
    restoreCountries: function restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries);
      }
    },
    isUS: function isUS() {
      return this.modelCopy.country.CountryName === 'United States';
    },
    GetStatesUSURL: function GetStatesUSURL() {
      return this.api.$.profile.getAllStates;
    },
    isCanada: function isCanada() {
      return this.modelCopy.country.CountryName === 'Canada';
    },
    GetStatesCanadaURL: function GetStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates;
    },
    // Fetch States on OPEN
    fetchUSStatesOnOpen: function fetchUSStatesOnOpen() {
      var url = this.GetStatesUSURL();
      this.fetchStatesOnOpen(this.USstates, url);
    },
    fetchCanadaStatesOnOpen: function fetchCanadaStatesOnOpen() {
      var url = this.GetStatesCanadaURL();
      this.fetchStatesOnOpen(this.canadaStates, url);
    },
    fetchStatesOnOpen: function fetchStatesOnOpen(states, url) {
      var _this3 = this;
      if (states.length && states[0].StateID !== 0 && (this.isCanada() || this.isUS())) {} else {
        this.api.forms.post(url, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this3.mapStatesDataOnOpen(r.data.Data);
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    mapStatesDataOnOpen: function mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USstates = this.USoriginalStates = data;
      } else {
        this.canadaStates = this.originalCanadaStates = data;
      }
    },
    // Fetch States on search text
    fetchUSStates: function fetchUSStates(value) {
      var url = this.GetStatesUSURL();
      this.fetchStates(value, url);
    },
    fetchCanadaStates: function fetchCanadaStates(value) {
      var url = this.GetStatesCanadaURL();
      this.fetchStates(value, url);
    },
    fetchStates: function fetchStates(value, url) {
      var _this4 = this;
      this.counter || this.api.forms.post(url, {
        q: value || ''
      }).then(function (r) {
        _this4.counter = 0;
        if (r && r.data && r.data.Data) {
          _this4.mapStatesDataOnFetch(r.data.Data);
        }
      }).catch(function (e) {
        console.warn(e);
        _this4.counter = 0;
      });
      this.counter = 1;
    },
    mapStatesDataOnFetch: function mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USstates = data;
      } else {
        this.canadaStates = data;
      }
    },
    // Restore States
    restoreUSStates: function restoreUSStates() {
      this.restoreStates(this.USstates, this.USoriginalStates);
    },
    restoreCanadaStates: function restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates);
    },
    restoreStates: function restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates);
      }
    },
    countrySelected: function countrySelected(e) {
      this.resetState(e.CountryName);
      this.modelCopy.CountryName = e.CountryName;
      this.modelCopy.CountryID = e.CountryID;
    },
    resetState: function resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.modelCopy.StateId = 0;
        this.modelCopy.StateName = '';
        this.modelCopy.Region = '';
      } else {
        this.originalCountryName = countryName;
      }
    }
  },
  computed: {
    entityName: function entityName() {
      return this.model.Venue.replace('_', '');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "51B0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Shared display/grouping logic for the EvedPay mobile transaction lists
// (transactions.vue and cardtransactions.vue). Both screens render the same row
// anatomy and the same display buckets — keeping the logic here prevents the
// bucket names, colors, and sort order from drifting between the two.
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    transactionStatusColor: function transactionStatusColor(status, reconcileStatus) {
      if (status === 'In Envelope' && reconcileStatus === 'Approved' || ['Exported', 'Posted'].includes(status) && ['Coded', 'Approved'].includes(reconcileStatus)) {
        return 'alt';
      } else if (['Open', 'Returned', 'In Envelope'].includes(status) && reconcileStatus === 'Open') {
        return 'warn';
      } else if (status === 'Declined') {
        return 'danger';
      } else if (status === 'Pending' && reconcileStatus === 'Open') {
        return 'info';
      } else if (['Open', 'Returned', 'In Envelope', 'Pending'].includes(status) && reconcileStatus === 'Coded') {
        return 'alt';
      } else {
        return 'info';
      }
    },
    headerText: function headerText(transaction) {
      var status = transaction.status;
      var reconcileStatus = transaction.reconcileStatus;
      if (status === 'In Envelope' && reconcileStatus === 'Approved' || ['Exported', 'Posted'].includes(status) && ['Coded', 'Approved'].includes(reconcileStatus) || ['Open', 'Returned', 'In Envelope', 'Pending'].includes(status) && reconcileStatus === 'Coded') {
        return 'Completed';
      }
      if (status === 'Declined') {
        return 'Declined';
      }
      if (status === 'Pending' && reconcileStatus === 'Open') {
        return 'Pending';
      }
      if (['Open', 'Returned', 'In Envelope'].includes(status) && reconcileStatus === 'Open') {
        return 'Reconcile';
      }
      return "".concat(status, " - ").concat(reconcileStatus);
    },
    sortByDisplayGroup: function sortByDisplayGroup() {
      var _this = this;
      if (!Array.isArray(this.transactions)) {
        return;
      }
      // The server orders by its own TransactionGroup buckets, which lump several display groups
      // together (notably Pending and Reconcile rows share the "5_Open" bucket because both have
      // ReconciliationStatus "Open"), so rows from different headerText() groups arrive interleaved
      // by date and the compare-to-previous showHeader() renders the same header repeatedly. Group
      // by the display header here so each header appears exactly once, in a fixed order.
      var order = {
        Reconcile: 0,
        Pending: 1,
        Completed: 2,
        Declined: 3
      };
      var rankOf = function rankOf(h) {
        return Object.prototype.hasOwnProperty.call(order, h) ? order[h] : 99;
      };
      this.transactions.sort(function (a, b) {
        var ha = _this.headerText(a);
        var hb = _this.headerText(b);
        var diff = rankOf(ha) - rankOf(hb);
        if (diff !== 0) {
          return diff;
        }
        if (ha < hb) {
          return -1;
        }
        if (ha > hb) {
          return 1;
        }
        return 0;
      });
    },
    showHeader: function showHeader(transaction, index) {
      if (index === 0) return true;
      var previousTransaction = this.transactions[index - 1];
      return this.headerText(transaction) !== this.headerText(previousTransaction);
    },
    redirectTransaction: function redirectTransaction(transaction) {
      var query = _objectSpread({}, this.$route.query);
      delete query.receiptScanId;
      query.transactionid = transaction.id;
      this.$router.push({
        path: '/evedpay/transactiondetails',
        query: query
      });
    }
  }
});

/***/ }),

/***/ "59tI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("49K6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33faa01a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("MnJJ");
function injectStyle (ssrContext) {
  __webpack_require__("hywn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33faa01a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33faa01a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Azj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('grid',{ref:"PairedBUCCGrid",attrs:{"model":_vm.getModel,"name":"","label":"Pair","desc":"","views":false,"layout":"frame","search":"","endpoint":_vm.api.$.BUAndCC.getBusinessUnitsAndCostCenters,"actions":_vm.actions,"remove-many":"","fit-columns":"","editFullRowOnAdd":true},on:{"removeRow":_vm.removePair,"removeRows":_vm.removePairs,"changeRow":_vm.editPair}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.addBUCC}},[_vm._v("Add BU & CC Pair")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5GFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"layout-snippet layout-columns"},_vm._l((_vm.layoutCols-1),function(n){return _c('span',{staticClass:"block",class:{ gutter: n % _vm.config+1 === 1, faded: n > _vm.config }},[_c('span',[_vm._v("█")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5HOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("uODl");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04a14a93_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("5Azj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04a14a93_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5KP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAnyOptionAvailable())?_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.closeMenu),expression:"closeMenu"}],class:{ "open": _vm.isMenuOpen, "dropdown": true, "pull-right": true },attrs:{"slot":"top"},slot:"top"},[_c('i',{staticClass:"far fa-ellipsis-v dropdown-toggle dots-icon",staticStyle:{"font-size":"20px"},attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":function($event){_vm.isMenuOpen = !_vm.isMenuOpen}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMenuOpen),expression:"isMenuOpen"}],staticClass:"dropdown-menu dropdown-menu-right",attrs:{"aria-labelledby":"dropdownMenuButton"}},[(_vm.hasAccountPermission('EvedPayCardAdministrator') && _vm.card.CardStatus === 'Inactive')?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.showDeleteCard = true, _vm.toggleCollapse()}}},[_vm._v("Delete Card")])]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') && _vm.card.CardStatus === 'Active' && !_vm.isPoolFunding(_vm.card))?_c('li',[(_vm.card.PendingRequest == 0)?_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.showAddFunds = true, _vm.toggleCollapse()}}},[_vm._v("Add Funds")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') && _vm.card.CardStatus === 'Active' && !_vm.isPoolFunding(_vm.card))?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.showReturnFundsToAccount = true, _vm.toggleCollapse()}}},[_vm._v("Return Funds To Account")])]):_vm._e(),_vm._v(" "),(!_vm.hasAccountPermission('EvedPayCardAdministrator') && _vm.card.CardStatus === 'Active' && !_vm.isPoolFunding(_vm.card))?_c('li',[(_vm.card.PendingRequest == 0)?_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.showAddFunds = true, _vm.toggleCollapse(), _vm.requestFunds = true}}},[_vm._v("Request Funds")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') && _vm.card.CardStatus === 'Active')?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.showCardAdditionalUsers = true, _vm.toggleCollapse()}}},[_vm._v("Additional Users")])]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') && _vm.card.CardStatus === 'Active' && !_vm.isPoolFunding(_vm.card))?_c('li',[(!_vm.card.RefillSettings.HasRefillRequest)?_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":_vm.toggleCollapseAndShowRefill}},[_vm._v("Refill Settings")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isPoolFunding(_vm.card) && _vm.hasAccountPermission('EvedPayCardAdministrator') && _vm.card.CardStatus === 'Active')?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":_vm.toggleCollapseAndShowDailySpendLimit}},[_vm._v("Daily Spend Limit")])]):_vm._e(),_vm._v(" "),(_vm.accountSettings.AccountingSystem.SyncEvedPayCards && _vm.card.CardStatus === 'Active' && (_vm.hasAccountPermission('EvedPayCardAdministrator') || _vm.isCardHolder))?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.showAccountingSystemSettings = true, _vm.toggleCollapse()}}},[_vm._v("PSL+ Settings")])]):_vm._e(),_vm._v(" "),((_vm.hasAccountPermission('EvedPayCardViewReconcileClose') || _vm.isCardHolder) && _vm.card.CardStatus === 'Active')?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":_vm.resendNewCardEmail}},[_vm._v("\n        Resend E-mail to Cardholder\n      ")])]):_vm._e(),_vm._v(" "),((_vm.card.CardStatus === 'Active' || _vm.card.CardStatus === 'Locked' || _vm.card.CardStatus === 'Locked - Lost/Stolen') && _vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":_vm.lockCard}},[_vm._v("\n        "+_vm._s(_vm.card.CardStatus === 'Active' ? 'Lock Card' : 'Unlock Card')+"\n      ")])]):_vm._e(),_vm._v(" "),(_vm.isCardHolder && _vm.card.CardStatus === 'Active')?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.showShowCardNumber = true, _vm.toggleCollapse()}}},[_vm._v("Card Number")])]):_vm._e(),_vm._v(" "),(_vm.isCardHolder && _vm.card.CardStatus === 'Active')?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.showCardSetPIN.showModal = true, _vm.toggleCollapse()}}},[_vm._v("Change PIN")])]):_vm._e(),_vm._v(" "),(_vm.card.CardStatus === 'Active' && _vm.card.IsPhysicalCard === false)?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":_vm.toggleCollapseAndShowRequestPhysicalCard}},[_vm._v("Request Physical Card")])]):_vm._e(),_vm._v(" "),(_vm.card.CardStatus === 'Active')?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":_vm.lostStolenCard}},[_vm._v("Report Lost or Stolen")])]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardViewReconcileClose') && _vm.card.CardStatus === 'Active')?_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"},on:{"click":_vm.closeCard}},[_vm._v("\n        Close Card\n      ")])]):_vm._e()]),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (this.card.Id) + "/set-as-deleted"),"title":"Delete Card","show":_vm.showDeleteCard,"validation":"","primary-button":"Delete"},on:{"close":function($event){_vm.showDeleteCard = false},"validate":_vm.deleteCard,"confirm":function($event){return _vm.deleteCard()}}},[_c('DeleteCard',{attrs:{"slot":"body"},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (this.card.Id) + "/refill-settings"),"title":"Refill Settings","show":_vm.isRefillOpen.showModal,"primary-button":"Save","validation":""},on:{"close":function($event){_vm.isRefillOpen.showModal = false},"validate":function($event){return _vm.$refs.cardRefillComponent.doRefill(_vm.isRefillOpen)}}},[_c('RefillSettings',{ref:"cardRefillComponent",attrs:{"slot":"body","card":_vm.card},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (this.card.Id) + "/daily-spend-limit"),"title":"Daily Spend Limit","show":_vm.isDailySpendLimitOpen.showModal,"primary-button":"Save","validation":""},on:{"close":function($event){_vm.isDailySpendLimitOpen.showModal = false},"validate":function($event){return _vm.$refs.cardDailySpendLimitComponent.save(_vm.isDailySpendLimitOpen)}}},[_c('CardDailySpendLimit',{ref:"cardDailySpendLimitComponent",attrs:{"slot":"body","card":_vm.card},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":_vm.loadingEndpoint,"title":_vm.requestFunds ? 'Request Funds' : 'Add Funds',"show":_vm.showAddFunds,"validation":"","primary-button":_vm.requestFunds ? 'Request' : 'Add'},on:{"close":function($event){_vm.showAddFunds = false, _vm.requestFunds = false},"validate":_vm.addFunds,"confirm":function($event){return _vm.addFunds()}}},[_c('CardAddFunds',{attrs:{"slot":"body","addFundsError":this.addFundsErrors,"balance":_vm.account.Available},on:{"fundingAmount":function (value) { return _vm.fundingAmount = value; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (this.card.Id) + "/accounting-system-settings"),"title":'PSL+ Settings',"primary-button":"Save","show":_vm.showAccountingSystemSettings,"validation":""},on:{"validate":_vm.handlePslSettingsSave,"close":function($event){_vm.showAccountingSystemSettings = false}}},[_c('AccountingSystemSettings',{ref:"accountingSystemSettingsCmp",attrs:{"slot":"body","card":_vm.card,"accountSettings":_vm.accountSettings},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (this.card.Id) + "/" + (this.cardStatus)),"title":_vm.modalTitle,"show":_vm.showCardStatus.showModal,"primary-button":"Submit","type":"medium","validation":"","primary-button-disabled":_vm.isCardStatusSubmitDisabled},on:{"close":_vm.closeCardStatusModal,"validate":function($event){return _vm.$refs.cardStatusComponent.changeStatus(_vm.cardStatus, _vm.showCardStatus)}}},[_c('CardStatus',{ref:"cardStatusComponent",attrs:{"slot":"body","status":_vm.cardStatus,"cards":[_vm.card],"division":_vm.division,"is-eved-admin":_vm.isEvedAdmin},on:{"helpDeskTicketNumber":function (v) { return _vm.helpDeskTicketNumber = v; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (this.card.Id) + "/request-physical-card"),"title":"Request Physical Card","show":_vm.showRequestPhysicalCardOpen.showModal,"primary-button":"Request","validation":""},on:{"close":function($event){_vm.showRequestPhysicalCardOpen.showModal = false},"validate":function($event){return _vm.$refs.physicalCardComponent.requestPhysicalCard(_vm.showRequestPhysicalCardOpen)}}},[_c('RequestPhysicalCard',{ref:"physicalCardComponent",attrs:{"slot":"body","card":_vm.card.Id,"divisionId":_vm.card.Account.DivisionId,"account":_vm.account},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Card Number","show":_vm.showShowCardNumber,"primary-button":"false","secondary-button":"false","type":"compact"},on:{"close":_vm.closeShowCardNumber}},[_c('ShowCardNumber',{ref:"showCardNumberComponent",attrs:{"slot":"body","card":_vm.cardForShowNumber},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (this.card.Id) + "/additional-users"),"title":"Additional Users","show":_vm.showCardAdditionalUsers,"primary-button":"Save"},on:{"close":function($event){_vm.showCardAdditionalUsers = false},"confirm":_vm.updateAdditionalUsers}},[_c('CardAdditionalUsers',{attrs:{"slot":"body","divisionId":_vm.card.Account.DivisionId,"cardId":_vm.card.Id,"cardHolderId":_vm.card.Holder.Id},on:{"additionalUsers":function (o) { return _vm.additionalUsers = o; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (this.card.Id) + "/set-pin"),"title":"Change PIN","show":_vm.showCardSetPIN.showModal,"primary-button":"Submit","validation":""},on:{"close":function($event){_vm.showCardSetPIN.showModal = false},"validate":function($event){return _vm.$refs.cardPinComponent.changePIN(undefined, undefined, _vm.showCardSetPIN)}}},[_c('CardPIN',{ref:"cardPinComponent",attrs:{"slot":"body","card":_vm.card},on:{"pinChangeSuccess":_vm.showSuccessToast},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (this.card.Id) + "/remove-funds"),"title":"Return Funds to Account","show":_vm.showReturnFundsToAccount,"primary-button":"Submit","validation":""},on:{"close":function($event){_vm.showReturnFundsToAccount = false},"validate":_vm.doReturnFunds,"confirm":function($event){return _vm.doReturnFunds()}}},[_c('ReturnFunds',{ref:"returnFundsComponent",attrs:{"slot":"body","card":_vm.card},on:{"returnFunds":function (value) { return _vm.returnFunds = value; }},slot:"body"})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5T3O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-flex active"},[_c('ed-section',{staticClass:"no-flex active",attrs:{"title":_vm.getTitle,"wide":"","full-width":""}},[_c('span',{attrs:{"slot":"description"},slot:"description"},[_c('div',{staticClass:"col-md-4 no-pad"},[_vm._v("\n        "+_vm._s(_vm.getSubtitle)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p',{staticClass:"col-md-9 no-pad"},[_vm._v("\n          For "+_vm._s(_vm.settings.divisionOrBUName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 no-pad"},[_c('grid',{key:_vm.initialLoad + _vm.fundingCurrencyChanged,ref:"PaymentInvoices",class:{ simple: true },attrs:{"layout":"frame","subtitle":"Subtitle Items","label":"Item","search":false,"allow-export":false,"export-btn":false,"checkboxes":false,"disable-filter":"","views":false,"pinning":false,"sorting":false,"dragRows":false,"fit-columns":true,"show-column-selector":false,"auto-height":"auto-height","model":_vm.gridModel,"data":_vm.invoices,"actions":_vm.actions,"rowDetailsComponent":_vm.settings.displayDivisionOnExpand ? _vm.InvoiceDetailsWithDivisionComponent : _vm.InvoiceDetailsComponent,"remove-many":"remove-many","clone-many":"clone-many","customDeleteManyButton":true,"totals":true,"total":_vm.getTotal,"name":"payment_invoices","uid":(_vm.uid + "-" + (_vm.settings.divisionOrBUName)),"canShowNotifications":!_vm.settings.isStep2},on:{"changeRow":_vm.updateEventAmount}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5V0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* harmony default export */ __webpack_exports__["a"] = (function (modules, users) {
  if (users.type.SELLER) {
    if (modules['Products']) {
      modules['Programs'].subtabs = _objectSpread({
        'Products': {
          label: '#Products',
          subtabs: modules['Products'].subtabs
        }
      }, modules['Programs'].subtabs);
    }
    modules['Programs'].alias = 'Actions';
    if (modules['Programs'].subtabs) {
      if (modules['Programs'].subtabs['RFPs']) {
        modules['Programs'].entry = '/i/Programs/RFP-received/';
      } else if (modules['Programs'].subtabs['POs']) {
        modules['Programs'].entry = '/i/Programs/PO-received/';
      } else if (modules['Programs'].subtabs['Products']) {
        modules['Programs'].entry = '/d/Programs/Products/MyProduct';
      }
    }
    delete modules['Programs'].subtabs['Invoices'];
    delete modules['Products'];
    modules['Dashboard'].title = 'Summary of payments and recent activity';
    modules['Dashboard'].subtitle = users.user.CompanyName;
  }
  return modules;
});

/***/ }),

/***/ "5WIk":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "5anu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-custom-cell ag-cell-percent",class:{ "invalid": _vm.invalidPercent}},[_c('div',{staticClass:"ag-custom-cell-value"},[_vm._v(_vm._s(_vm.percentValue))]),_vm._v("  ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5cCA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refill-overlay"},[_c('p',{staticClass:"small"},[_vm._v("\n    The account balance will be reloaded with the Refill Amount whenever it dips\n    below this Refill Threshold.\n  ")]),_vm._v(" "),_c('ed-input',{attrs:{"type":"money","amount":"","field-label":"Refill Threshold"},model:{value:(_vm.RefillSettings.RefillThreshold),callback:function ($$v) {_vm.$set(_vm.RefillSettings, "RefillThreshold", $$v)},expression:"RefillSettings.RefillThreshold"}}),_vm._v(" "),_c('ed-input',{attrs:{"type":"money","amount":"","field-label":"Refill Amount"},model:{value:(_vm.RefillSettings.RefillAmount),callback:function ($$v) {_vm.$set(_vm.RefillSettings, "RefillAmount", $$v)},expression:"RefillSettings.RefillAmount"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5cJS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row content"},[_c('div',{staticClass:"summary well small col-md-12"},[_c('table',{staticClass:"col-md-12"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('v-money',{attrs:{"currency":_vm.currency,"name":"intial_total_amount"}},[_vm._v(_vm._s(_vm.model.InitialInvoiceAmount))])],1),_vm._v(" "),_c('td',[_c('v-money',{attrs:{"currencu":_vm.currency,"name":"current_invoiced_amount"}},[_vm._v(_vm._s(_vm.model.CurrentInvoicedAmount))])],1),_vm._v(" "),_c('td',[_c('v-money',{attrs:{"currency":_vm.currency,"name":"budget_balance"}},[_vm._v(_vm._s(_vm.balance))])],1),_vm._v(" "),_c('td',[_c('span',{attrs:{"name":"due"}},[_vm._v(_vm._s(_vm.getTimeDue))])])])])]),_vm._v(" "),_c('div',{staticClass:"clear"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td',[_vm._v("Total Invoiced Amount")]),_vm._v(" "),_c('td',[_vm._v("Line Items Total")]),_vm._v(" "),_c('td',[_vm._v("Balance")]),_vm._v(" "),_c('td',[_vm._v("Due")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',[_c('td',[_vm._v("Total Invoiced Amount")]),_vm._v(" "),_c('td',[_vm._v("Line Items Total")]),_vm._v(" "),_c('td',[_vm._v("Balance")]),_vm._v(" "),_c('td',[_vm._v("Due")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5cYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wrapper"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:({ content: _vm.tooltipContent }),expression:"{ content: tooltipContent }",modifiers:{"bottom":true}}],style:({ color: _vm.isRejected ? 'red' : 'inherit' })},[_vm._v("\n    "+_vm._s(_vm.displayValue)+"\n    "),(_vm.isRejected)?_c('i',{staticClass:"fas fa-info-circle"}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5i/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"iWmAF5zkbxLd47XWE2fG8","Dell":"_1cds4pQ8szDaF-ad-4U4IJ","Abbott":"_1FXClvydPN07ABWDV1Tj8r","Gap":"_2YY-UkXNZNrVhVt8vHqHVs","Allstate":"_3EQjqAcHDYeFACnF96423i","Asurion":"ImZG0hc-v8J7C5JUqRYNx","Invitae":"_29avmB0YuM_A-0slzHwnab","JWE":"_3on4gMjB_j46WMWf_wHqHb"};

/***/ }),

/***/ "5mev":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardRefill_vue__ = __webpack_require__("Edt7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_971b0c18_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardRefill_vue__ = __webpack_require__("GPqQ");
function injectStyle (ssrContext) {
  __webpack_require__("Z88T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-971b0c18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardRefill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_971b0c18_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardRefill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5u/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('Grid',{ref:"grid",attrs:{"name":_vm.$t("EvedPay Cards"),"desc":"Manage accounts, cards and transactions","search":"","search-placeholder":"My Accounts","sort":{ Division: "asc" },"endpoint":_vm.api.$.evedpaycard.accounts,"alias":"PaymentInvoiceList_SentInvoices","legacy":"","fit-columns":"","tabs":_vm.tabs,"footer":"","totals":"","xadditional-filters":"additionalFilters","filter":_vm.defaultFilter},on:{"selectedRows":_vm.rowSelected}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('AddFunding',{attrs:{"accountId":_vm.selectedObj.Id,"ids":_vm.selectedRows,"disabled":_vm.actionDisabled('addFunding'),"tooltip":_vm.actionDisabledReason('addFunding')},on:{"success":_vm.refresh}}):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('refillSettings')),expression:"actionDisabledReason('refillSettings')"}],attrs:{"button-class":"btn btn-actionbar","ids":_vm.selectedRows,"disabled":_vm.actionDisabled('refillSettings')},on:{"click":function () {_vm.accountRefillSettings.Visible = true},"success":_vm.refresh}},[_vm._v("\n        REFILL SETTINGS\n      ")]):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"form-group no-margin",attrs:{"slot":"additionalLabel"},slot:"additionalLabel"},[_c('i',{staticClass:"fas fa-exclamation"}),_vm._v(" "),_c('span',[_vm._v(" ")]),_vm._v(" "),_c('label',[_vm._v("Click column headers to apply filters")])])]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"EvedPay Account Refill Settings","show":_vm.accountRefillSettings.Visible,"primary-button":"Save","primaryButtonDisabled":_vm.accountRefillSettings.ActionDisabled,"validation":""},on:{"close":function($event){_vm.accountRefillSettings.Visible = false, _vm.accountRefillSettings.ActionDisabled = true},"validate":function($event){return _vm.$refs.accountRefillSettingsComponent.save()}}},[_c('AccountRefillSettings',{ref:"accountRefillSettingsComponent",attrs:{"slot":"body","accountId":_vm.selectedObj.Id},on:{"success":function($event){_vm.accountRefillSettings.Visible = false},"loaded":function($event){_vm.accountRefillSettings.ActionDisabled = false}},slot:"body"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5uK1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"MsAaWL5wGsb5f0SOjmPcl","Dell":"_2XJmHjngbmxJsxfh0m6S9Q","Abbott":"_3pbhkoi9sdyC48rvn7M77d","Gap":"_1vtuByf5wbHc6aZiHPr8Sv","Allstate":"fg6e_p6Mi9MNf_LjkOp6","Asurion":"_1SrSm-_EPGwDKraeu_cV5x","Invitae":"LyhPiaA0ZhT8JjHjKfrl6","JWE":"_6nHEUw3r5jzKYHh8Faeiu"};

/***/ }),

/***/ "5vF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{ref:"header",attrs:{"title":_vm.$t("Funding Statement and AP Settings")}},[_c('span',{attrs:{"slot":"action"},slot:"action"},[(_vm.$routerHistory.hasHistory() && _vm.$route.query["back-to"])?_c('router-link',{attrs:{"to":{ path: _vm.$routerHistory.previous().path, hash: "" }}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("  "+_vm._s(_vm.$t('Back') + ' ' + _vm.$t('to') + ' ' + _vm.$t(_vm.$route.query['back-to'])))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('ed-section',{staticClass:"active clear"},[_c('br'),_vm._v(" "),_c('div',[_c('ed-checkbox',{attrs:{"options":_vm.useTemplates,"name":"same_day_deposit_check","required":""},on:{"click":_vm.changeHasFundingInvAndAPSetting}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 no-pad"},[_c('h4',[_vm._v("Funding Addresses")]),_vm._v(" "),_c('span',[_vm._v("\n            Addresses below will be shown as the Bill To address in the Funding Statement PDF\n          ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('FundingAddresses'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("AP File Templates")]),_vm._v(" "),_c('span',[_vm._v("\n            Below is the current list of AP File templates\n          ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('APFileTemplates')],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5wL5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5y3O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpenEnvelope_vue__ = __webpack_require__("62U+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e8d328a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpenEnvelope_vue__ = __webpack_require__("gR0X");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpenEnvelope_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e8d328a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpenEnvelope_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5zl1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_items_list_vue__ = __webpack_require__("hrZ7");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b9bc00_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_items_list_vue__ = __webpack_require__("seUR");
function injectStyle (ssrContext) {
  __webpack_require__("AtGW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51b9bc00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_items_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b9bc00_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_items_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "62U+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__core_events_events__);


//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    openEnvelope: function openEnvelope() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var envelope;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.params && _this.params.data && _this.params.data.EnvelopeId)) {
                _context.next = 6;
                break;
              }
              _context.next = 3;
              return _this.getEnvelope(_this.params.data.EnvelopeId);
            case 3:
              _context.t0 = _context.sent;
              _context.next = 7;
              break;
            case 6:
              _context.t0 = _this.params.data;
            case 7:
              envelope = _context.t0;
              _context.next = 10;
              return _this.updateUrlWithEnvelopeId(envelope.Id);
            case 10:
              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.EVEDPAY_CARDS.OPEN_ENVELOPE, envelope);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getEnvelope: function getEnvelope(envelopeId) {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this2.api.forms.post(_this2.api.$.evedpaycard.envelopes, {
                sort: 'CreatedDate',
                dir: 'ASC',
                start: 0,
                limit: 100,
                isLiveGrid: true,
                filter: JSON.stringify({
                  'EnvelopeId': envelopeId,
                  searchTerm: ''
                })
              });
            case 3:
              response = _context2.sent;
              if (!(response && response.data)) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", response.data.Data[0]);
            case 6:
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.error('Error while retrieving envelopes:', _context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 8]]);
      }))();
    },
    updateUrlWithEnvelopeId: function updateUrlWithEnvelopeId(envelopeId) {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var basePath, queryParam, newUrl;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              basePath = '';
              if (_this3.$user.$.userPermissions.includes('ApprovalDashboard')) {
                basePath = '#/d/EnvelopeApprovalDashboard';
              } else {
                basePath = '#/d/Programs/>Card/envelopes';
              }
              queryParam = "EnvelopeId=".concat(envelopeId);
              newUrl = "".concat(basePath, "?").concat(queryParam);
              window.history.pushState({}, '', newUrl);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
});

/***/ }),

/***/ "63Rj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "66+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddSupplier',
  /* mandatory field */
  props: {
    model: Object,
    invoiceId: Number,
    eventHub: Object,
    operation: String
  },
  data: function data() {
    if (this.operation === 'edit') {
      return {
        formData: {
          supplierName: this.model.supplier.companyName,
          supplierId: this.model.supplier.id,
          supplierVATGSTId: this.model.supplier.vatGstCode,
          supplierContact: this.model.supplier.contactName,
          emailAddress: this.model.supplier.email,
          phone: this.model.supplier.phone,
          address1: this.model.supplier.address.address1,
          address2: this.model.supplier.address.address2,
          city: this.model.supplier.address.city,
          postalCode: this.model.supplier.address.zipCode,
          country: this.model.supplier.address.country,
          state: {
            StateID: 0,
            StateName: this.model.supplier.address.state
          },
          canadaState: {
            StateID: 0,
            StateName: this.model.supplier.address.state
          },
          region: this.model.supplier.address.region
        },
        USstates: [],
        canadaStates: [],
        countries: [],
        show: true,
        validation: true,
        title: 'Edit Supplier',
        doDisplaySupplierNameError: false,
        doDisplaySupplierContactError: false,
        doDisplayEmailError: false,
        doDisplayPhoneError: false,
        doDisplayCountryError: false,
        counter: 0,
        disableControls: false
      };
    } else {
      return {
        formData: {
          supplierName: '',
          supplierId: '',
          supplierVATGSTId: '',
          supplierContact: '',
          emailAddress: '',
          phone: '',
          address1: '',
          address2: '',
          city: '',
          postalCode: '',
          originalCountryName: '',
          country: '',
          state: {
            StateID: 0,
            StateName: ''
          },
          canadaState: {
            StateID: 0,
            StateName: ''
          },
          region: ''
        },
        USstates: [],
        USoriginalStates: [],
        canadaStates: [],
        originalCanadaStates: [],
        countries: [],
        originalCountries: [],
        show: true,
        validation: true,
        title: 'Add New Supplier',
        doDisplaySupplierNameError: false,
        doDisplaySupplierContactError: false,
        doDisplayEmailError: false,
        doDisplayPhoneError: false,
        doDisplayCountryError: false,
        counter: 0,
        disableControls: false
      };
    }
  },
  methods: {
    fetchCountriesOnOpen: function fetchCountriesOnOpen() {
      var _this = this;
      if (this.countries.length) {} else {
        this.api.forms.post(this.api.$.profile.getAllCountries, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this.countries = r.data.Data;
            _this.originalCountries = r.data.Data;
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    fetchCountries: function fetchCountries(value) {
      var _this2 = this;
      this.counter || this.api.forms.post(this.api.$.profile.getAllCountries, {
        q: value || ''
      }).then(function (r) {
        _this2.counter = 0;
        if (r && r.data && r.data.Data) {
          _this2.countries = r.data.Data;
        }
      }).catch(function (e) {
        console.warn(e);
        _this2.counter = 0;
      });
      this.counter = 1;
    },
    restoreCountries: function restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries);
      }
    },
    isUS: function isUS() {
      return this.formData.country && this.formData.country.CountryName === 'United States';
    },
    GetStatesUSURL: function GetStatesUSURL() {
      return this.api.$.profile.getAllStates;
    },
    isCanada: function isCanada() {
      return this.formData.country && this.formData.country.CountryName === 'Canada';
    },
    GetStatesCanadaURL: function GetStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates;
    },
    // Fetch States on OPEN
    fetchUSStatesOnOpen: function fetchUSStatesOnOpen() {
      var url = this.GetStatesUSURL();
      this.fetchStatesOnOpen(this.USstates, url);
    },
    fetchCanadaStatesOnOpen: function fetchCanadaStatesOnOpen() {
      var url = this.GetStatesCanadaURL();
      this.fetchStatesOnOpen(this.canadaStates, url);
    },
    fetchStatesOnOpen: function fetchStatesOnOpen(states, url) {
      var _this3 = this;
      if (states.length && (this.isCanada() || this.isUS())) {} else {
        this.api.forms.post(url, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this3.mapStatesDataOnOpen(r.data.Data);
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    mapStatesDataOnOpen: function mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USstates = this.USoriginalStates = data;
      } else {
        this.canadaStates = this.originalCanadaStates = data;
      }
    },
    // Fetch States on search text
    fetchUSStates: function fetchUSStates(value) {
      var url = this.GetStatesUSURL();
      this.fetchStates(value, url);
    },
    fetchCanadaStates: function fetchCanadaStates(value) {
      var url = this.GetStatesCanadaURL();
      this.fetchStates(value, url);
    },
    fetchStates: function fetchStates(value, url) {
      var _this4 = this;
      this.counter || this.api.forms.post(url, {
        q: value || ''
      }).then(function (r) {
        _this4.counter = 0;
        if (r && r.data && r.data.Data) {
          _this4.mapStatesDataOnFetch(r.data.Data);
        }
      }).catch(function (e) {
        console.warn(e);
        _this4.counter = 0;
      });
      this.counter = 1;
    },
    mapStatesDataOnFetch: function mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USstates = data;
      } else {
        this.canadaStates = data;
      }
    },
    // Restore States
    restoreUSStates: function restoreUSStates() {
      this.restoreStates(this.USstates, this.USoriginalStates);
    },
    restoreCanadaStates: function restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates);
    },
    restoreStates: function restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates);
      }
    },
    emailChanged: function emailChanged() {
      var _this5 = this;
      this.doDisplayEmailError = false;
      var supplierInfo = {
        EmailAddress: this.formData.emailAddress,
        InvoiceId: this.getInvoiceId
      };
      this.api.forms.post(this.api.$.invoice.i2p.getSupplierFromAddSupplierButton, {
        supplier: supplierInfo
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          var response = JSON.parse(r.data.Data);
          _this5.populateFormData(response);
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    populateFormData: function populateFormData(data) {
      if (data.CompanyName !== null && data.OutSideNewSupplier !== 'Yes') {
        this.formData = {
          supplierName: data.CompanyName,
          supplierId: data.SupplierIDCode,
          supplierVATGSTId: data.SupplierVatGstId,
          supplierContact: data.SupplierContact,
          emailAddress: data.SupplierContactEmail,
          phone: data.Phone,
          address1: data.Address,
          address2: data.Address2,
          city: data.City,
          postalCode: data.Zip,
          originalCountryName: data.CountryName,
          country: {
            'CountryID': data.CountryID,
            'CountryName': data.CountryName
          },
          state: {
            StateID: data.isCanada === 'False' && data.StateID || 0,
            StateName: data.isCanada === 'False' && data.State || ''
          },
          canadaState: {
            StateID: data.isCanada === 'True' && data.StateID || 0,
            StateName: data.isCanada === 'True' && data.State || ''
          },
          region: data.Region
        };
        this.disableControls = true;
      } else {
        this.disableControls = false;
      }
    },
    onClose: function onClose() {
      this.eventHub.$emit('onCloseAddSupplier', {});
      this.show = false;
    },
    onSave: function onSave() {
      if (!this.isValid()) return;
      var supplierInfoVM = this.getSupplierInfoVM();
      this.getSupplier(supplierInfoVM);
      this.show = false;
    },
    getSupplier: function getSupplier(supplierInfoVM) {
      var _this6 = this;
      this.api.forms.post(this.api.$.invoice.i2p.getSupplierFromAddSupplierButton, {
        supplier: supplierInfoVM
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          var response = JSON.parse(r.data.Data);
          _this6.populateFormData(response);
          var info = {
            SupplierInfoVM: _this6.getSupplierInfoVM(),
            VendorId: response.VendorId || response.VendorWithVendorsID || 0,
            VendorUserID: response.VendorUserID || 0,
            VendorVCI: response.VendorVCI || 0,
            CardInfo: JSON.parse(response.SupplierCardInfo)
          };
          __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].I2P.ADDED_NEW_SUPPLIER, info);
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    getSupplierInfoVM: function getSupplierInfoVM() {
      return {
        SupplierName: this.formData.supplierName,
        SupplierID: this.formData.supplierId,
        SupplierVatGstID: this.formData.supplierVATGSTId,
        SupplierContactName: this.formData.supplierContact,
        EmailAddress: this.formData.emailAddress,
        SupplierPhone: this.formData.phone,
        SupplierAddress1: this.formData.address1,
        SupplierAddress2: this.formData.address2,
        SupplierCity: this.formData.city,
        SupplierZIP: this.formData.postalCode,
        SupplierCountryID: this.formData.country.CountryID,
        CountryName: this.formData.country.CountryName,
        SupplierStateID: this.isUS() ? this.formData.state.StateID : 0,
        SupplierRegion: this.isCanada() ? this.formData.canadaState.StateName : this.formData.region,
        State: this.formData.state.StateName,
        InvoiceId: this.invoiceId
      };
    },
    isValid: function isValid() {
      var result = true;
      if (!(this.formData.supplierName.length && this.formData.supplierName.length > 0)) {
        this.doDisplaySupplierNameError = true;
        result = false;
      }
      if (!(this.formData.supplierContact && this.formData.supplierContact.length && this.formData.supplierContact.length > 0)) {
        this.doDisplaySupplierContactError = true;
        result = false;
      }
      if (!(this.formData.emailAddress.length && this.formData.emailAddress.length > 0)) {
        this.doDisplayEmailError = true;
        result = false;
      } else {
        if (!this.validateEmail(this.formData.emailAddress)) {
          this.doDisplayEmailError = true;
          result = false;
        }
      }
      return result;
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    countrySelected: function countrySelected(e) {
      this.doDisplayCountryError = false;
      this.resetState(e.CountryName);
    },
    resetState: function resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.formData.state = {
          StateID: 0,
          StateName: ''
        };
        this.formData.canadaState = {
          StateID: 0,
          StateName: ''
        };
        this.formData.region = '';
      } else {
        this.originalCountryName = countryName;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "66e7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navless-layout-header"},[_vm._t("navbar",function(){return [_c('ed-button',{attrs:{"to":_vm.$routerHistory.previous().path}},[_c('i',{staticClass:"fal fa-chevron-left"}),_vm._v("\n         \n        Back\n      ")]),_vm._v(" "),(_vm.cardRejected)?_c('span',{staticClass:"center-span"},[_vm._v(_vm._s(_vm.cards.createdDate ? 'EvedPay... ' + _vm.moment(_vm.cards.createdDate).format(_vm.dateFormat) : ''))]):_vm._e()]})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.cardRejected)?_c('div',{key:_vm.cards.id,attrs:{"endpoint":_vm.api.$.evedpaycard.cards}},[(_vm.cards.rejectReason)?_c('div',[_c('ed-notice',{attrs:{"type":"danger","icon":"fas fa-exclamation-triangle"}},[_vm._v("\n        "+_vm._s(_vm.cards.rejectReason ? _vm.cards.rejectReason : '')+"\n      ")])],1):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.cardRejected)?_c('div',{attrs:{"endpoint":_vm.api.$.evedpaycard.transactions}},[_vm._t("title"),_vm._v(" "),(_vm.cards)?_c('div',{key:_vm.cards.id,staticClass:"center"},[_c('h3',[_c('v-money',[_vm._v(_vm._s(_vm.cards.spent))])],1),_vm._v(" "),_c('h4',[_vm._v("Balance: "),_c('v-money',[_vm._v(_vm._s(_vm.cards.balance))])],1),_vm._v(" "),_c('h4',[_c('router-link',{attrs:{"to":{ path: '/evedpay/details', query: Object.assign({}, _vm.$route.query, {cardid: _vm.cardId}) }}},[_vm._v(" CARD DETAILS")])],1)]):_vm._e(),_vm._v(" "),(_vm.transactions && !_vm.transactions.length)?_c('div',{staticClass:"no-data"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.transactions),function(transaction,i){return _c('div',{on:{"click":function () { return _vm.redirectTransaction(transaction); }}},[(_vm.showHeader(transaction, i))?_c('h6',[_vm._v("\n        "+_vm._s(_vm.headerText(transaction))+"\n      ")]):_vm._e(),_vm._v(" "),_c('ed-notice',{staticClass:"transaction",attrs:{"type":_vm.transactionStatusColor(transaction.status, transaction.reconcileStatus)}},[_c('p',{staticClass:"amount"},[_c('v-money',[_vm._v(_vm._s(transaction.amount))])],1),_vm._v(" "),_c('p',{staticClass:"merchant"},[_vm._v(_vm._s(transaction.merchant))]),_vm._v(" "),(transaction.status === 'Pending')?_c('div',{staticClass:"col-xs-9",staticStyle:{"padding":"0"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.moment(transaction.date).format(_vm.dateFormat))+" | Pending")])]):_c('div',{staticClass:"col-xs-9",staticStyle:{"padding":"0"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.moment(transaction.date).format(_vm.dateFormat)))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3 text-right",staticStyle:{"padding-right":"2px"}},[(transaction.receipt !== null)?_c('i',{staticClass:"fas fa-camera",staticStyle:{"color":"#4A90E2"}}):_vm._e()])])],1)})],2):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"color":"white","margin":"0px","height":"27px"}},[_vm._v("t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"icon fas fa-list"}),_vm._v(" "),_c('h3',[_vm._v("No Transactions")]),_vm._v(" "),_c('p',[_vm._v("Your transactions will appear here")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "69Xe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"title":"Receipt Folder","show":_vm.show,"primary-button":"ADD","primary-button-disabled":!_vm.selectedReceiptId || _vm.isProcessing,"secondary-button":"CANCEL","type":"medium"},on:{"close":_vm.handleClose,"confirm":_vm.handleAdd}},[_c('div',{staticClass:"receipt-folder-picker-body",class:{ loading: _vm.isProcessing },attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"picker-subtitle"},[_vm._v("Select a receipt to attach to this transaction.")]),_vm._v(" "),(!_vm.featureFlags.receiptScanPrefill)?_c('div',{staticClass:"feature-disabled"},[_c('p',[_vm._v("Receipt folder is not available.")])]):(_vm.isLoading)?_c('div',{staticClass:"loading-state"},[_c('p',[_vm._v("Loading receipts...")])]):(!_vm.receipts || !_vm.receipts.length)?_c('div',{staticClass:"empty-state"},[_c('p',[_vm._v("No receipts in your folder. Upload a receipt without picking a transaction to add it here.")])]):_c('div',{staticClass:"receipt-picker"},[_c('strong',{staticClass:"receipt-label"},[_vm._v("Receipt")]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closePanel),expression:"closePanel"}],staticClass:"receipt-dropdown"},[_c('button',{staticClass:"receipt-dropdown-trigger",class:{ 'is-expanded': _vm.isExpanded },attrs:{"type":"button","aria-haspopup":"listbox","aria-expanded":_vm.isExpanded ? 'true' : 'false'},on:{"click":_vm.togglePanel}},[(_vm.selectedReceipt)?[_c('div',{staticClass:"receipt-thumbnail receipt-thumbnail-trigger"},[_c('i',{staticClass:"icon fas fa-receipt"})]),_vm._v(" "),_c('div',{staticClass:"receipt-meta receipt-meta-trigger"},[_c('div',{staticClass:"merchant"},[_vm._v(_vm._s(_vm.displayMerchant(_vm.selectedReceipt)))]),_vm._v(" "),_c('div',{staticClass:"receipt-date"},[_vm._v(_vm._s(_vm.formatDate(_vm.displayDate(_vm.selectedReceipt))))])]),_vm._v(" "),_c('div',{staticClass:"amount amount-trigger"},[(_vm.selectedReceipt.totalAmount != null)?_c('v-money',[_vm._v(_vm._s(_vm.selectedReceipt.totalAmount))]):_c('span',[_vm._v("--")])],1)]:_c('span',{staticClass:"receipt-dropdown-placeholder"},[_vm._v("Select a receipt...")]),_vm._v(" "),_c('i',{staticClass:"fas fa-chevron-down receipt-dropdown-caret"})],2),_vm._v(" "),(_vm.isExpanded)?_c('div',{staticClass:"receipt-dropdown-panel",attrs:{"role":"listbox"}},[_vm._l((_vm.receipts),function(receipt){return _c('div',{key:receipt.receiptScanId,staticClass:"receipt-row",class:{ 'is-selected': _vm.selectedReceiptId === receipt.receiptScanId },attrs:{"role":"option","aria-selected":_vm.selectedReceiptId === receipt.receiptScanId ? 'true' : 'false'},on:{"click":function($event){return _vm.onRowClick(receipt)}}},[_c('div',{staticClass:"receipt-thumbnail"},[_c('i',{staticClass:"icon fas fa-receipt"})]),_vm._v(" "),_c('div',{staticClass:"receipt-meta"},[_c('div',{staticClass:"merchant"},[_vm._v(_vm._s(_vm.displayMerchant(receipt)))]),_vm._v(" "),_c('div',{staticClass:"receipt-date"},[_vm._v(_vm._s(_vm.formatDate(_vm.displayDate(receipt))))])]),_vm._v(" "),_c('div',{staticClass:"amount"},[(receipt.totalAmount != null)?_c('v-money',[_vm._v(_vm._s(receipt.totalAmount))]):_c('span',[_vm._v("--")])],1)])}),_vm._v(" "),(_vm.totalPages > 1)?_c('div',{staticClass:"pagination-controls"},_vm._l((_vm.totalPages),function(p){return _c('button',{key:p,staticClass:"page-btn",class:{ active: _vm.currentPage === p },attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.goToPage(p)}}},[_vm._v("\n              "+_vm._s(p)+"\n            ")])}),0):_vm._e()],2):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6NlY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReconciliationStatus_vue__ = __webpack_require__("SN9C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_569dcf12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReconciliationStatus_vue__ = __webpack_require__("Pr2y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReconciliationStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_569dcf12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReconciliationStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6RsF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_6t6ByxUJb7jG_HMAA5a2Q","Dell":"_3A1tX88nhx4Mgmhha2F_bT","Abbott":"AplTOO5nAeHoTfAdqyf8G","Gap":"_3NZ2BZacXG3LFL3VkviLdA","Allstate":"_3PnGWX2kLp6W7NgNBsRI3j","Asurion":"_2JA7DFP6FQPkg_d2tChPjx","Invitae":"XzhMLYoVu_xFNBba4mdbE","JWE":"nuxkYS-HIweM3kvNK7aHu"};

/***/ }),

/***/ "6SW0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["b"] = setUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = setUserSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_user__ = __webpack_require__("uduW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_legacy_auth_gotoV3__ = __webpack_require__("UYvm");



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var AuthUser = {};
var SKIP_GET_USER_SETTINGS_FOR_RETURN_URLS = [
  // 'ApprovalDashboard'
];
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Connects to login enpoint
   *
   * @param {object}   data - request payload
   * @param {function} [cb] - callback function
   */
  login: function login(data, cb) {
    /** Set payload as form-data */
    var credentials = new FormData();
    credentials.append('user', data.username);
    credentials.append('pass', data.password);
    return this.$user.login(credentials);
  },
  autoLogin: function autoLogin(sk, cb) {
    return this.$user.login.call(this, {
      sk: sk
    });
  },
  /**
   * Init user in application with reponse from endpoint
   *
   * @param {object}   response - endpoint response
   */
  init: function init(response) {
    var _arguments = arguments,
      _this = this;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee() {
      var redirect, wait, vm, authUser, route, skipGetUserSettings, absoluteUrl;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            redirect = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : true;
            wait = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : false;
            vm = _this;
            authUser = AuthUser;
            route = _this.$router.currentRoute;
            skipGetUserSettings = SKIP_GET_USER_SETTINGS_FOR_RETURN_URLS.some(function (r) {
              return (route.query.returnUrl || '').includes(r);
            });
            vm.loginEndpoint = vm.api.$.login;
            if (!response.sk) {
              _context.next = 26;
              break;
            }
            /** Store logged in user */
            _this.$user.init(response, authUser);
            _this.$store.state.isLoggedIn = true;
            __WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].set(authUser);
            if (!(authUser.type === 'nobody')) {
              _context.next = 23;
              break;
            }
            if (wait) {
              _context.next = 17;
              break;
            }
            _this.api.get(_this.api.$.initLegacy, {
              params: {
                sk: response.sk
              }
            }); // init legacy app
            skipGetUserSettings ? setUserSettings.call(vm, {
              data: {
                CompanySettings: {}
              }
            }, authUser, response, redirect) : _this.api.get(_this.api.$.settings.my.settings).then(function (settings) {
              return setUserSettings.call(vm, settings, authUser, response, redirect);
            });
            _context.next = 21;
            break;
          case 17:
            _context.next = 19;
            return _this.api.get(_this.api.$.initLegacy, {
              params: {
                sk: response.sk
              }
            });
          case 19:
            _context.next = 21;
            return _this.api.get(_this.api.$.settings.my.settings).then(function (settings) {
              return setUserSettings.call(vm, settings, authUser, response, redirect);
            });
          case 21:
            _context.next = 24;
            break;
          case 23:
            _this.api.get(_this.api.$.settings.my.settings).then(function (settings) {
              var prevPath = _this.$routerHistory.previous().path || '';
              var returnUrl = route.query.returnUrl;
              var legacyUrl = prevPath.indexOf('goToPage=') >= 0 ? prevPath : null;
              setUserSettings.call(vm, settings, authUser, response, false);
              if (window.location.href.indexOf('mfa-setup') === -1 && global.config.layout !== 'mobile') {
                __WEBPACK_IMPORTED_MODULE_5__core_legacy_auth_gotoV3__["a" /* navigateToV3 */].call(vm, response.sk, legacyUrl || returnUrl);
              }
            });
          case 24:
            _context.next = 27;
            break;
          case 26:
            if (response.returnUrl) {
              absoluteUrl = response.returnUrl && response.returnUrl.indexOf('http') > -1;
              if (absoluteUrl) {
                global.location.href = response.returnUrl;
              }
              /** User not authenticated */
            } else {
              _this.$store.state.isLoggedIn = false;
            }
          case 27:
            /** Endpoint returned an error */
            if (response.error) {
              _this.loginError.message = response.error;
            }
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  /**
   * Handles enpoint error
   *
   * @param {object} error - endpoint error
   */
  handle: function handle(error) {
    console.warn('Error logging user ', error);
  },
  /**
   * Redirects
   *
   */
  auth: function auth() {
    var user = __WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].get();

    /** If not authorized go to login */
    if (user === null || user === undefined) {
      this.$router.push('/login');

      /** If authorized as admin go to admin */
    } else if (typeof user.data !== 'undefined' && user.data && typeof user.data.role_id !== 'undefined' && user.data.role_id === 'ADMIN') {
      this.$router.push('/admin');

      /** If authorized go to home by default */
    } else {
      this.$router.push('/home');
    }
  }
});
function setUser(response, authUser) {
  authUser = authUser || AuthUser;
  this.$user.init(response, authUser);
  this.$store.state.isLoggedIn = true;
  __WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].set(authUser);
}
function setUserSettings(settings, authUser, response) {
  var redirect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  authUser = authUser || AuthUser;
  if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(settings.data) !== 'object') return;

  // delete settings.data.UserLogin
  global.localStorage.setItem('sessionSettings', JSON.stringify(settings.data));
  var evedUserSettingsCopy = {};
  try {
    evedUserSettingsCopy = JSON.parse(global.localStorage.getItem('evedUserSettings'));
  } catch (e) {
    evedUserSettingsCopy = {};
  }
  global.localStorage.setItem('evedUserSettings', JSON.stringify(_objectSpread(_objectSpread({}, evedUserSettingsCopy), settings.data.CompanySettings)));
  this.$user.$.settings = this.$user.settings;
  __WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].checkSession();

  /** Role based routing */
  // if (authUser.type === 'admin') {
  //   // TODO:
  //   // admin old link
  //   // this.$user.logout(true)
  //   const returnUrl = this.$router.currentRoute.query.returnUrl || ''
  //   if (~returnUrl.indexOf('/d')) {
  //     this.$router.push(returnUrl)
  //     return
  //   }
  //   window.location.replace(`${this.api.env}/../?page=admin.MainPage`)
  //   return
  // }
  if (authUser.data && typeof authUser.data.role_id !== 'undefined' && authUser.data.role_id === 'ADMIN') {
    this.$router.push('/admin');
  } else {
    var absoluteUrl = response.returnUrl && response.returnUrl.indexOf('http') > -1;
    if (absoluteUrl) {
      global.location.href = response.returnUrl;
    } else {
      //
      var returnUrl = this.$router.currentRoute.query.returnUrl;
      if (!redirect) return;
      if (returnUrl) {
        console.log('going to', returnUrl);
        if (~returnUrl.indexOf('/d')) {
          this.$router.push(returnUrl);
          return;
        }
        if (~returnUrl.indexOf('/i')) {
          this.$router.push(returnUrl);
          return;
        }
        if (~returnUrl.indexOf('/evedpay')) {
          this.$router.push(returnUrl);
          window.location.reload();
          return;
        }
        if (returnUrl.indexOf('http') > -1) {
          global.location.href = returnUrl;
          return;
        }
        var goToPage = this.$router.currentRoute.query.returnUrl.split('__')[0];
        var tab = this.$router.currentRoute.query.returnUrl.split('__')[1];
        if (goToPage !== '0' && tab !== '0') {
          this.$router.push({
            name: '_allLegacy',
            query: {
              goToPage: goToPage,
              tab: tab,
              param: this.$router.currentRoute.query.returnUrl.split('__')[2],
              sk: this.$router.currentRoute.query.sk
            }
          });
        } else {
          this.$router.push('/home');
        }
      } else {
        this.$router.push(response.returnUrl || '/home');
      }
    }
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "6XR1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_components_edCheckbox_checkbox__ = __webpack_require__("+qQe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Check: __WEBPACK_IMPORTED_MODULE_0__core_components_edCheckbox_checkbox__["default"]
  },
  props: {
    model: Object,
    details: Function,
    compute: Function,
    discount: Boolean,
    context: Object,
    endpoint: String
  },
  computed: {
    hasTotal: function hasTotal() {
      return typeof this.model.totalTaxes !== 'undefined' && this.details;
    }
  },
  data: function data() {
    return {
      ctx: this.context || this.$parent,
      loading: false
    };
  },
  methods: {
    taxInput: function taxInput(val) {
      if (!val) {
        this.model.isChecked = false;
      } else {
        this.model.isChecked = val;
      }
    },
    useTax: function useTax(tax) {
      tax.value = '';
      this.computeTaxValue(tax);
    },
    resetTax: function resetTax(tax) {
      var _this = this;
      var taxComp = this.$refs.taxPercentages;
      tax.percentage = null;
      this.loading = true;
      this.compute().then(function () {
        taxComp.amountValue = '';
        _this.loading = false;
      });
    },
    resetDiscount: function resetDiscount(model) {
      var discountComp = this.$refs.discountPercentage;
      model.discountPercent = null;
      this.compute().then(function () {
        discountComp.amountValue = '';
      });
    },
    computeTaxValue: function computeTaxValue(tax) {
      var taxComp = this.$refs.taxValues;
      var taxCompPercent = this.$refs.taxPercentages;
      if (!tax.percentage) {
        tax.value = '';
        tax.percentage = null;
      } else {
        tax.value = 0;
      }
      this.resetComps(tax, taxComp, taxCompPercent);
    },
    computeDiscountValue: function computeDiscountValue(model) {
      var discountComp = this.$refs.discountValue;
      var discountCompPercent = this.$refs.discountPercentage;
      if (!model.discountPercent) {
        model.discountAmount = '';
        model.discountPercent = null;
      }
      this.resetComps({
        percentage: model.discountPercent
      }, discountComp, discountCompPercent);
    },
    resetComps: function resetComps(comp, value, percent) {
      value.$el.setAttribute('endpoint', this.ctx.computeItemTotalEndpoint);
      this.compute().then(function () {
        value.$el.removeAttribute('endpoint');
        value.formatMoney();
        if (!comp.percentage) {
          percent.amountValue = '';
        }
      });
    }
  }
});

/***/ }),

/***/ "6hc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Grid_cells_actions__ = __webpack_require__("ayPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__("/yid");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__core_events_events__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */]
  },
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_2__model___default.a,
      actions: [__WEBPACK_IMPORTED_MODULE_1__components_Grid_cells_actions__["g" /* remove */]]
    };
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__core_events_events___default.a.BU_CC.REFRESH, function (r) {
      _this.refresh();
    });
  },
  methods: {
    editCC: function editCC(payload, success, fail) {
      //
      if (!this.validCC(payload.data)) {
        fail('Invalid Cost Center');
      } else {
        this.api.post(this.api.$.BUAndCC.saveCostCenter, payload.data).then(function (r) {
          return success(r);
        }).catch(function (e) {
          return fail();
        });
      }
    },
    removeCC: function removeCC(payload, success, fail) {
      //
      var id = +payload.data.CostCenterId;
      this.api.delete(this.api.$.BUAndCC.deleteCostCenter + '/' + id, id).then(function (r) {
        return success();
      }).catch(function (e) {
        return fail('Something went wrong. Cannot delete the Cost Center');
      });
    },
    removeCCs: function removeCCs(payload) {
      //
      var costCentersIds = [];
      payload.rows.forEach(function (element) {
        costCentersIds.push(element.data.CostCenterId);
      });
      var p = {
        IDs: costCentersIds
      };
      this.api.post(this.api.$.BUAndCC.deleteCostCenters, p).then(this.validateDeleteCCs);
    },
    validCC: function validCC(data) {
      var isValid = false;
      if (data.CostCenterNo && data.CostCenterNo.trim() !== '') {
        isValid = true;
      }
      return isValid;
    },
    addCC: function addCC() {
      this.$refs.CostCentersGrid.addRow({});
    },
    refresh: function refresh() {
      this.$refs.CostCentersGrid.quickSearch();
      this.$refs.CostCentersGrid.onSelectAll(false);
    },
    validateDeleteCCs: function validateDeleteCCs(r) {
      if (r.data.Errors.length !== 0) {
        alert('Something went wrong. Cannot delete the Cost Centers.');
      }
      __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__core_events_events___default.a.BU_CC.REFRESH);
    }
  }
});

/***/ }),

/***/ "6o4z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6oxs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6roY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object
  },
  data: function data() {
    return {
      approvalUsersData: []
    };
  },
  methods: {
    getApprovalUsers: function getApprovalUsers() {
      var _this = this;
      this.api.get(this.api.$.evedpaycard.approvalUsers, {
        params: {
          cardId: this.model.Id
        }
      }).then(function (response) {
        _this.approvalUsersData = response.data.filter(function (user) {
          return user.IsCurrentAction === true;
        });
      }).catch(function (error) {
        console.error('There was a problem with the approval users request:', error);
      });
    }
  },
  created: function created() {
    this.getApprovalUsers();
  }
});

/***/ }),

/***/ "6v8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"priority-tag"},[_c('span',{class:_vm.tagClass,attrs:{"title":_vm.tag}},[_vm._v(_vm._s(_vm.tag))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6wBp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6zic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters_list__ = __webpack_require__("qf/r");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    List: __WEBPACK_IMPORTED_MODULE_0__filters_list__["a" /* default */]
  },
  data: function data() {
    return {
      shownDetails: false,
      loadedDetails: false,
      details: '',
      tooltip: ''
    };
  },
  computed: {
    position: function position() {
      return {
        // 'min-width': '93%',
        // width: this.cell.style.width
      };
    },
    showCaret: function showCaret() {
      var editable = this.params.colDef.columnEditable;
      return !(this.params.data || {})._disabled && this.val && editable;
    },
    placeholder: function placeholder() {
      return this.params.colDef.headerName;
    },
    empty: function empty() {
      return !this.params.value && this.params.node.rowPinned !== 'bottom';
    }
  },
  created: function created() {
    //
    this.colApi = this.params.api && this.params.api.columnController;
    this.cell = this.params.eGridCell;
    this.cell.style.overflow = 'visible';
    this.params.editMode = true;
    this.cell.className = this.cell.className.replace(' ag-cell-list-expanded', '') + ' ag-cell-list-expanded';
    this.val = this.params.formatValue(this.params.value);
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var textW = _this.$refs.optionLabel && _this.$refs.optionLabel.getBoundingClientRect().width;
      var wrapperW = _this.$refs.optionWrapper && _this.$refs.optionWrapper.clientWidth - 35;
      if (textW && wrapperW) {
        _this.tooltip = textW > wrapperW ? _this.val : null;
      }
    });
  },
  methods: {
    showDetails: function showDetails(e) {
      var _this2 = this;
      if (!this.showCaret) return;
      this.shownDetails = !this.shownDetails;
      this.params.context.shownPopover = this.shownDetails;
      this.getSelected();
      this.$nextTick(function () {
        _this2.$refs.list && _this2.$refs.list.$emit('showDetails', _this2.shownDetails);
      });
    },
    getSelected: function getSelected() {
      var _this3 = this;
      if (this.params.colDef.options && this.shownDetails) {
        this.params.colDef.options.map(function (key) {
          key.status = key.label === _this3.params.value;
          key.isDisabled = _this3.params.colDef.selectedOptions && _this3.params.colDef.selectedOptions.filter(function (o) {
            return +o[_this3.params.colDef.trackBy.selectedOptionTrackBy] === +key[_this3.params.colDef.trackBy.optionTrackBy];
          }).length > 0;
        });
      }
    },
    edit: function edit(v) {
      this.params.setValue(v.text || v.label || v.name || '');
      this.params.value = v.label;
      this.val = this.params.formatValue(this.params.value);
      this.params.context.data && this.params.context.gridOptions.api.refreshInfiniteCache();
    },
    refresh: function refresh() {
      //
      this.shownDetails = false;
    }
  }
});

/***/ }),

/***/ "76Oe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_money_vue__ = __webpack_require__("afLu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06161ce6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_money_vue__ = __webpack_require__("pd+q");
function injectStyle (ssrContext) {
  __webpack_require__("X1gQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_money_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06161ce6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_money_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7D5Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceiptFolder_vue__ = __webpack_require__("ilgz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_026e8f53_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceiptFolder_vue__ = __webpack_require__("3Zh2");
function injectStyle (ssrContext) {
  __webpack_require__("HoRU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-026e8f53"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceiptFolder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_026e8f53_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceiptFolder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7F1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_charts_RenderComponent__ = __webpack_require__("NGTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_Dashboard_helpers_scrollbarHelper_js__ = __webpack_require__("7yCl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar_css_perfect_scrollbar_css__ = __webpack_require__("m5D7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_charts_helper_formatter__ = __webpack_require__("7VNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_charts_helper_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__core_charts_helper_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_user__ = __webpack_require__("uduW");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * Chart widget
 * @module components/mdChartWidget
 *
 */

// import sample from '@/components/_modules/Dashboard/templates/demo.json'








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'md-chart-widget',
  props: {
    id: {
      type: String,
      required: true
    },
    title: String,
    type: {
      // Line | Pie | Bar | Area
      type: String,
      default: 'Line',
      validator: function validator(val) {
        return ['Line', 'Pie', 'Bar', 'Area'].indexOf(val) >= 0;
      }
    },
    widget: Object,
    backgroundColor: {
      type: String,
      default: 'none'
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    data: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    },
    dataSource: String,
    animation: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasTitleSlot: function hasTitleSlot() {
      return !!this.$slots['title'];
    },
    visibleSeries: function visibleSeries() {
      if (this.chartType === 'Pie') return [this.chartData.series];
      if (this.chartData.series) return this.chartData.series;else return null;
    },
    hasSmallLegend: function hasSmallLegend() {
      return this.customSettings.hasSmallLegend;
    },
    getBackText: function getBackText() {
      return this.customSettings.backText || 'Back';
    },
    getSmallLegendData: function getSmallLegendData() {
      if (this.chartData.series.length === 0 || !this.showSmallLegend || this.chartData.series[0] === null) return;else {
        var series = [];
        this.chartData.series.forEach(function (ser) {
          var type = ser.type;
          ser.data.forEach(function (dt) {
            series.push({
              name: dt.name,
              type: type,
              color: dt.color
            });
          });
        });
        return series;
      }
    },
    showTitleOnBack: function showTitleOnBack() {
      if (this.drillDownFilterValue !== this.drillDownFilterText) return this.drillDownFilterValue;
      return null;
    },
    showChart: function showChart() {
      if (!this.chartData.series[0] && this.showEmpty) return false;else return true;
    },
    getChartHeightStyle: function getChartHeightStyle() {
      if (!this.loading) return '';
      var h = this.widget.h * 45;
      if (this.widget.h === this.heights.MAX_ROWS) h += 45;
      return 'height: ' + h + 'px;';
    },
    getDateText: function getDateText() {
      var startD = global.moment(this.widget._dateFilter[0]).format(global.app.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat);
      var endD = global.moment(this.widget._dateFilter[1]).format(global.app.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat);
      return 'Showing ' + startD + ' to ' + endD;
    },
    getNoDataIcon: function getNoDataIcon() {
      if (this.chartType === 'Pie') return 'fal fa-chart-pie';else return 'fal fa-chart-bar';
    },
    last1MonthClasses: function last1MonthClasses() {
      return ['dateSelectorTX', this.widget && (this.widget.dateRangeFilter.dateRange === 'Last1Month' || this.widget.dateRangeFilter.dateRange === 'last1Month') ? 'active' : ''];
    },
    last3MonthsClasses: function last3MonthsClasses() {
      return ['dateSelectorTX', this.widget && (this.widget.dateRangeFilter.dateRange === 'Last3Months' || this.widget.dateRangeFilter.dateRange === 'last3Months') ? 'active' : ''];
    },
    customIntervalClasses: function customIntervalClasses() {
      return ['dateSelectorTX', this.widget && this.widget.dateRangeFilter.dateRange !== 'Last1Month' && this.widget.dateRangeFilter.dateRange !== 'Last3Months' && this.widget.dateRangeFilter.dateRange !== 'last1Month' && this.widget.dateRangeFilter.dateRange !== 'last3Months' ? 'active' : ''];
    }
  },
  data: function data() {
    var _this = this;
    return {
      chartId: function chartId(chart, i) {
        return chart && chart.data ? "".concat(_this.id, "-").concat(chart.type, "-").concat(i) : _this.id;
      },
      widgetId: function widgetId(chart, i) {
        return _this.id;
      },
      chartData: this.data,
      rawData: [],
      chartType: this.type,
      loading: false,
      showBack: false,
      showChartHeaderRow: false,
      chartHeaderTitle: null,
      showEmpty: false,
      showLegend: this.showLegend,
      showSmallLegend: this.showSmallLegend,
      showInChartLegend: this.showInChartLegend,
      drillDownFilterText: this.drillDownFilterText,
      selectedIndex: null,
      customSettings: this.customSettings,
      tooltipStyle: {
        null: true
      },
      tooltipData: [],
      isDrilledDown: false,
      drilldownValue: null,
      needsRefresh: false,
      companySettings: {},
      seq: 0,
      seq2: 0,
      durations: 500,
      durations2: 500,
      delays: 80,
      delays2: 80,
      maxMultiplier: 1.2,
      heights: {
        MIN_ROWS: 8,
        MAX_ROWS: 8,
        NA_ROWS: 5,
        EX_MAX_ROWS: 20
      },
      dataPoint: function dataPoint(data, y) {
        if (_this.chartComponent && _this.chartComponent.chartInfo && _this.chartComponent.chartInfo.length) {
          return _this.chartInfo[y];
        }
        return data.series[0].data && data.series[0].data[y] || data.series[0][y];
      },
      dataPointfromChart: function dataPointfromChart(data, y) {
        if (_this.chartComponent && data.series && data.series.length) {
          if (_this.chartComponent.chartType === 'Pie' && data.labelData.length) {
            return data.labelData[y];
          }
          return data.series[0][y] || data.series[y];
        }
        return data.series[0].data && data.series[0].data[y] || data.series[0][y];
      },
      thousandsFormat: function thousandsFormat(val, currency) {
        return __WEBPACK_IMPORTED_MODULE_7__core_charts_helper_formatter___default.a.thousandsFormatter(val) + ' ' + currency;
      }
    };
  },
  created: function created() {
    var _this2 = this;
    this.companySettings = __WEBPACK_IMPORTED_MODULE_8__core_user__["a" /* default */].getCompanySettings();
    this.chartComponent = this.initRenderComponent();
    this.showEmpty = false;
    this.$on('childRedraw', function () {
      _this2.needsRefresh = true;
    });
    this.$on('redraw', function () {
      _this2.init(_this2.drawChart);
    });
    this.$on('scrollIntoView', this.load);
  },
  updated: function updated() {
    var _this3 = this;
    if (this.needsRefresh) {
      this.$nextTick(function () {
        _this3.init(_this3.drawChart);
      });
      this.needsRefresh = false;
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initRenderComponent: function initRenderComponent() {
      var chart = {};
      if (this.widget.chartComponent) {
        chart = new __WEBPACK_IMPORTED_MODULE_2__core_charts_RenderComponent__["a" /* RenderComponent */](this.widget.chartComponent);
        this.chartType = chart.chartType;
        this.showLegend = chart.showLegend;
        this.showSmallLegend = chart.showSmallLegend;
        this.showInChartLegend = chart.showInChartLegend;
        this._options = chart.chartOpts || this.options;
        if (this._options.customSettings.chartGroupValue === 'Program') {
          this._options.customSettings.chartGroupValue = this.companySettings.ProgramLabel ? this.companySettings.ProgramLabel : 'Program';
        }
        this.customSettings = this._options.customSettings;
      }
      return chart;
    },
    isIE: function isIE() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf('MSIE ');
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
        return true;
      }
      return false;
    },
    showEmptyChart: function showEmptyChart() {
      this.showEmpty = true;
      this.loading = false;
      this.chartData.series = [null];
    },
    resetState: function resetState() {
      this.showEmpty = true;
      this.loading = false;
      this.widthPixelBase = this.$el.clientWidth / this.widthId;
      this.drilldownValue = null;
      this.drillDownFilterText = null;
      this.selectedIndex = null;
      this.isDrilledDown = false;
      this.showBack = false;
      this.originalData = utils.copy(this.chartData);
      this.originalInfo = utils.copy(this.chartInfo);
      if (this.customSettings.hasDrillDown) this.chartComponent.drillDownReturn.call(this, this);
    },
    load: function load() {
      var _this4 = this;
      this.loading = true;
      if (this.dataSource) {
        this.showEmpty = false;
        this.api.get(this.dataSource).then(function (r) {
          _this4.widget.reqDraw = false;
          _this4.widget.isDrawn = true;
          _this4.rawData = r.data.ChartData || [];
          _this4.chartData = r.data.ChartData.length ? _this4.chartComponent.chartData(_this4.widget, r.data.ChartData) : {
            series: []
          };
          _this4.chartInfo = r.data.ChartData.length ? _this4.chartComponent.chartInfo(_this4.widget, r.data.ChartData) : [];
          _this4.resetState();
          _this4.$nextTick(function () {
            if (!r.data.ChartData.length) _this4.reqHeightAdjust('NA');else {
              if (_this4.widget.h !== _this4.heights.MAX_ROWS) _this4.reqHeightAdjust('OK');
              _this4.init(_this4.drawChart);
            }
          });
        }).catch(function (e) {
          _this4.showEmptyChart();
        });
      } else {
        this.showEmptyChart();
      }
    },
    reqHeightAdjust: function reqHeightAdjust(state) {
      var _this5 = this;
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$emit('updateWidgetHeight', {
          wId: _this5.widget.id,
          height: 1,
          state: state,
          alt: -1
        });
      });
    },
    drawChart: function drawChart(chart, type) {
      var _this6 = this;
      switch (type) {
        case 'Line':
          this.animation && this.startAnimationForLineChart(chart);
          break;
        case 'Bar':
          this.animation && this.startAnimationForBarChart(chart);
          break;
        case 'Pie':
          this.animation && this.startAnimationForPieChart(chart);
          break;
      }
      chart.on('created', function (chart) {
        if (_this6.showChart) {
          _this6.loading = false;
          _this6.drawChartLines(chart);
          var ctChart = _this6.$el.querySelector('.ct-chart');
          if (_this6.chartComponent.chartType !== 'Pie') {
            Object(__WEBPACK_IMPORTED_MODULE_3__components_modules_Dashboard_helpers_scrollbarHelper_js__["a" /* initScrollbar */])(_this6, '.card-chart');
          } else {
            _this6.$el.querySelector('.ct-chart').classList.add('card-pie-chart');
            _this6.$el.querySelector('.ct-interaction-on').addEventListener('mouseover', __WEBPACK_IMPORTED_MODULE_6_lodash_throttle___default()(_this6.showTooltip, 300));
            if (chart.options.customSettings.hasDrillDown === true) {
              _this6.$el.querySelector('.inChartLegend .legend').addEventListener('click', _this6.drillDown);
            }
          }
          _this6.$el.querySelector('.card-chart').addEventListener('mouseover', __WEBPACK_IMPORTED_MODULE_6_lodash_throttle___default()(_this6.showTooltip, 300));
          ctChart.classList.add('events-on');
          var element = _this6.$el.querySelector("[widgetId='" + _this6.id + "']");
          if (element && chart.options.customSettings.hasDrillDown === true) element.addEventListener('click', _this6.drillDown);
        }
        _this6.widget.reqDraw = false;
        _this6.widget.isDrawn = true;
      });
    },
    drawChartLines: function drawChartLines(chart) {
      var _this7 = this;
      if (chart.options.targetLine) {
        this.drawVLines(chart, chart.options.targetLine);
      }
      if (chart.options.vLines) {
        Array.prototype.forEach.call(chart.options.vLines, function (line) {
          _this7.drawVLines(chart, line);
        });
      }
    },
    drawVLines: function drawVLines(chart, line) {
      var tline = chart.chartRect.x1 + chart.chartRect.width() * (line.value + Math.abs(chart.bounds.min)) / chart.bounds.range;
      chart.svg.elem('line', {
        x1: tline,
        x2: tline,
        y1: chart.chartRect.y1,
        y2: chart.chartRect.y2,
        stroke: line.color
      }, line.class);
    },
    init: function init(callback) {
      var _this8 = this;
      var idSelector = "#".concat(this.id);
      var type = this.chartType;
      var showGr = false;
      // Apply area to area chart
      if (type === 'Area') {
        type = 'Line';
        this.options.showArea = true;
      }
      if (type !== 'Pie') {
        // apply basic defaults
        this.tooltipData = [];
        this.options.showGridBackground = true;
        this.options.chartPadding = {
          top: 15,
          right: 10,
          bottom: 0,
          left: 0
        };
        this.options.axisY = _objectSpread(_objectSpread({}, this.options.axisY), {}, {
          labelOffset: {
            x: 0,
            y: 5
          }
        });
      }
      if (!this.chartData.series[0] && this.ps) this.ps.destroy();
      this.fullTooltipData = this.chartData.tooltipData || null;
      // Draw chart for each series of different type

      this.chartData.series.forEach(function (series, i) {
        var id = "#".concat(_this8.chartId(series, i));
        var chdt = utils.copy(_this8.chartData);
        var data = {
          labels: i === 0 ? chdt.labels : null,
          series: series.data,
          stackBars: series.stackBars || false,
          maxValue: series.maxValue,
          minValue: series.minValue,
          barSpace: series.barSpace,
          minHeight: series.minHeight,
          labelData: series.labelData || _this8.chartData.labelData || null
        };
        // Create alias and update chart options
        var op = _this8._options;
        if (type !== 'Pie') {
          showGr = i === 0;
          op.axisY.showGrid = showGr;
          op.axisY.showLabel = showGr;
          op.vLines = series.vLines || null;
          op.stackBars = data.stackBars;
          if (op.customSettings.dynamicWidth) op.width = _this8.calculateWidth(data);
          if (op.customSettings.dynamicHeight) op.height = _this8.calculateHeight(data);
          if (op.customSettings.recalculateGridMax) {
            var newRange = _this8.calculateGridRange(data.maxValue || chdt.maxValue || 0, data.minValue || chdt.minValue || 0);
            op.high = newRange.high;
            op.low = newRange.low;
          }
        } else {
          if (op.customSettings.isGaugeChart) op.total = chdt.total * 2;
          op.showLabel = false;
        }
        _this8.showChartHeaderRow = op.customSettings.showTotal || false;
        if (_this8.showChartHeaderRow) _this8.chartHeaderLabel = op.customSettings.showTotalValue || 'Total';
        _this8.chartHeaderTitle = _this8.getchartHeaderTitle(op.customSettings.chartGroupValue);
        // Generate Chart
        var chart = _this8.$Chartist[series.type || type](series.data ? id : idSelector, series.data ? data : chdt, op);
        callback(chart, series.type || type);
      });
    },
    getchartHeaderTitle: function getchartHeaderTitle(input) {
      if (!input) return null;else if (input.startsWith('FromFilter')) {
        var filterName = input.split(':')[1];
        var variable = this.widget.variables.filter(function (s) {
          if (s.name === filterName) return s.value[0];
        });
        var varDef = this.widget.variableDefinitions.filter(function (vd) {
          if (vd.name === filterName) return vd;
        })[0].items.filter(function (va) {
          if (va.key === variable[0].value[0]) return va.label;
        });
        return varDef[0].label;
      }
      return input;
    },
    calculateWidth: function calculateWidth(dataIn) {
      var barSpace = 100;
      var cardWidh = this.$el.clientWidth;
      var barCount = dataIn.labels ? dataIn.labels.length : dataIn.series[0].value.length;
      var width = barSpace * barCount < cardWidh ? cardWidh : barSpace * barCount;
      return width + 'px';
    },
    calculateGridRange: function calculateGridRange(max, min) {
      var result = {
        low: 0,
        high: 0
      };
      if (max === 0 && min === 0) max = 100;
      result.high = max <= 0 ? 20 / 100 * min * -1 : max * 1.4;
      result.low = min >= 0 ? 10 / 100 * max * -1 : min * 1.4;
      return result;
    },
    calculateHeight: function calculateHeight(dataIn) {
      var barSpace = dataIn.barSpace || 40;
      var minHeight = dataIn.minHeight || 65;
      var padding = 20;
      var barCount = dataIn.labels ? dataIn.labels.length : dataIn.series[0].value.length;
      var height = barSpace * barCount + padding;
      return (height > minHeight ? height : minHeight) + padding + 'px';
    },
    startAnimationForLineChart: function startAnimationForLineChart(chart) {
      var _this9 = this;
      chart.on('draw', function (data) {
        if (data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 0,
              dur: _this9.durations,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: _this9.$Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === 'point') {
          _this9.seq++;
          data.element.animate({
            opacity: {
              begin: 0,
              dur: _this9.durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
        if (data.type === 'line') {
          var lineColor = data.series.color ? data.series.color : null;
          if (lineColor) {
            data.element.attr({
              style: "stroke: ".concat(lineColor, "; stroke-width: 1px")
            });
          }
        }
      });
      this.seq = 0;
    },
    startAnimationForBarChart: function startAnimationForBarChart(chart) {
      var _this10 = this;
      chart.on('draw', function (data) {
        if (data.type === 'label' && data.axis.units.pos === 'y') {
          if (data.element._node.children && _this10.chartComponent.components.axisY) {
            data.element._node.children[0].innerHTML = '<span></span>';
            new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
              render: function render(h) {
                return h(_this10.chartComponent.components.axisY, {
                  props: {
                    value: data.text
                  }
                });
              }
            }).$mount(data.element._node.children[0].children[0]);
          }
        }
        if (data.type === 'bar') {
          var isVertical = chart.options.horizontalBars || false;
          var customizedChart = data.series.color;
          var label = customizedChart ? '' : _this10.chartData.labels[data.index].replace(/ /g, '');
          var barWidth = customizedChart ? data.series.width : data.series.length > 6 ? '30px' : '12%';
          var barColor = customizedChart ? data.series.color : null;
          _this10.seq2++;
          if (data.series.xModifier) {
            var x1 = data.element._node.x1.baseVal.value;
            var x2 = data.element._node.x2.baseVal.value;
            var nx2 = (x2 - x1) * data.series.xModifier;
            data.element._node.x2.baseVal.value += nx2;
            data.x2 += nx2;
          }
          var animationDefinitionVert = {
            x2: {
              begin: 0,
              dur: _this10.durations,
              from: data.x1,
              to: data.x2,
              easing: 'ease'
            },
            opacity: {
              begin: 0,
              dur: _this10.durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          };
          var animationDefinitionHor = {
            y2: {
              begin: 0,
              dur: _this10.durations,
              from: data.y1,
              to: data.y2,
              easing: 'ease'
            },
            opacity: {
              begin: 0,
              dur: _this10.durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          };
          var labelData = data.series.labelData;
          data.element.animate(isVertical ? animationDefinitionVert : animationDefinitionHor, false);
          if (!data.series.color) {
            data.element.attr({
              class: "".concat(data.element._node.className.baseVal.trim().replace(/color-(\d+)?/, ''), " color-").concat(_this10.colorStep(_this10.seq2, label, 1), " color-").concat(label),
              style: "stroke-width: ".concat(barWidth, "; pointer-events:all; cursor: ").concat(_this10.chartComponent.drillDown && !_this10.showBack ? 'pointer' : 'default'),
              dataLabel: "".concat(_this10.chartData.labels[data.index])
            });
          } else {
            data.element.attr({
              class: "".concat(data.element._node.className.baseVal.trim().replace(/color-(\d+)?/, ''), " color-").concat(label),
              style: "stroke-width: ".concat(labelData && labelData[data.index] === 'No Budget' ? '2px' : barWidth, "; pointer-events:all; stroke:").concat(barColor, "; cursor: ").concat(_this10.chartComponent.drillDown && !_this10.showBack ? 'pointer' : 'default'),
              dataLabel: "".concat(_this10.chartData.labels[data.index])
            });
          }
          var ignoreLabel = data.series.ignoreLabel;
          if (!ignoreLabel || labelData) {
            // labels on bars
            var barLabel;
            var barLabelTextSpan;
            var verticalOffset = isVertical ? 0 : 10;
            var labelText = labelData ? labelData[data.index] : ignoreLabel === false ? data.series.metadata.barLabels[data.index] : data.value.y;
            var negativeValue = labelText.toString().indexOf('-') === 0;
            var redOn = negativeValue || labelText.toString().indexOf('!$red$!') === 0;
            labelText = labelText.replace('!$red$!', '');
            if (negativeValue && !isVertical) verticalOffset = (verticalOffset + 5) * -1;
            if (labelText && isVertical) labelText += ' ' + (labelText === 'No Budget' ? '' : _this10.$parent.$parent.currency);
            var barHorizontalCenter = isVertical ? data.element._node.ownerSVGElement.clientWidth - 50 : data.x1;
            var barVerticalCenter = data.y2 - verticalOffset;
            data.element.attr({
              label: labelText
            }, 'ct:series');
            barLabel = new _this10.$Chartist.Svg('text');
            barLabelTextSpan = new _this10.$Chartist.Svg('tspan');
            barLabelTextSpan.text(labelText);
            barLabelTextSpan.attr({
              class: 'ct-interaction-on',
              dataLabel: "".concat(_this10.chartData.labels[data.index])
            });
            barLabel.append(barLabelTextSpan);
            barLabel.attr({
              x: barHorizontalCenter - (labelData ? 20 : 0),
              y: barVerticalCenter,
              width: barWidth,
              dataLabel: "".concat(_this10.chartData.labels[data.index]),
              class: 'ct-label ct-interaction-on',
              style: redOn ? 'fill: red' : '',
              'text-anchor': 'middle'
            });
            data.group.append(barLabel);
            if (_this10.chartComponent.components.dataLabel) {
              new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
                render: function render(h) {
                  return h(_this10.chartComponent.components.dataLabel, {
                    props: {
                      value: labelText
                    }
                  });
                }
              }).$mount(barLabel._node.childNodes[0]);
            }
          }
          _this10.updateChartVisuals(isVertical);
        }
      });
      // this.seq2 = 0
      this.seq2 = 0;
    },
    startAnimationForPieChart: function startAnimationForPieChart(chart) {
      var _this11 = this;
      chart.on('draw', function (data) {
        if (data.type === 'slice') {
          var pathLength = data.element._node.getTotalLength();
          data.element.attr({
            'stroke-dasharray': pathLength + 'px ' + pathLength + 'px'
          });
          var animationDefinition = {
            'stroke-dashoffset': {
              id: 'anim' + data.index,
              dur: _this11.durations / 3,
              from: -pathLength + 'px',
              to: '0px',
              fill: 'freeze'
            }
          };
          if (data.index !== 0) {
            animationDefinition['stroke-dashoffset'].begin = 'anim' + (data.index - 1) + '.end';
          }
          _this11.seq2++;
          data.element.attr({
            'stroke-dashoffset': -pathLength + 'px'
          });
          data.element.animate(animationDefinition, false);
        }
        var label = _this11.chartData.labels[data.index].replace(/ /g, '');
        data.element.attr({
          class: "".concat(data.element._node.className.baseVal.trim().replace(/color-(\d+)?/, ''), " color-").concat(_this11.colorStep(_this11.seq2, label, 1), " color-").concat(label),
          style: "pointer-events:all; cursor: ".concat(_this11.chartComponent.drillDown && !_this11.showBack ? 'pointer' : 'default'),
          dataLabel: "".concat(_this11.chartData.labels[data.index]),
          dataValue: "".concat(_this11.chartData.series[data.index])
        });
      });
      this.seq2 = 0;
    },
    showTooltip: function showTooltip(e) {
      if (!this.chartComponent.components.tooltip) return;
      var value = e.target.getAttribute('dataLabel');
      var ctChart = this.$el.querySelector('.ct-chart');
      ctChart.addEventListener('mouseleave', this.resetTooltip);
      this.$el.querySelector('.card-chart').addEventListener('mouseleave', this.resetTooltip);
      if (value) {
        var lb = this.chartData.labels;
        var index = lb.indexOf(value);
        var row = lb[index];
        if (this.selectedIndex === 0 || this.selectedIndex !== index) {
          this.populateTooltipData(row, index, e);
        }
        this.emitTooltipEvent(e);
        ctChart.addEventListener('mousemove', this.moveTooltip);
      } else {
        this.$el.querySelector('.card-chart').removeEventListener('mouseleave', this.resetTooltip);
        ctChart.removeEventListener('mousemove', this.moveTooltip);
        this.resetTooltip();
      }
    },
    moveTooltip: function moveTooltip(e) {
      var tt = document.getElementById('chart-Tooltip').firstElementChild;
      if (tt && this.hasTooltipData) {
        tt.style.left = e.pageX + 15 + 'px';
        tt.style.top = e.pageY + 15 + 'px';
      }
    },
    populateTooltipData: function populateTooltipData(row, index, e) {
      var cs = this.chartComponent.chartOpts.customSettings;
      var ft = this.fullTooltipData;
      if (ft) {
        this.tooltipData = {
          data: ft.metadata,
          helpText: ft.helpText
        };
        this.tooltipData.data.forEach(function (entry, i) {
          entry.content = Array.isArray(ft.data[i]) ? ft.data[i][index] : ft.data[i];
        });
        this.hasTooltipData = true;
        if (this.tooltipData.data[0].content === 'Other Hotel Chains') this.tooltipData.helpText = '';
        this.tooltipStyle = {
          top: "".concat(window.scrollY + e.pageY + 15, "px"),
          left: "".concat(e.pageX + 15, "px"),
          'margin-left': "-".concat(e.target.style['stroke-width']),
          width: cs.tooltip.width,
          position: 'fixed'
        };
        this.selectedIndex = index;
      } else return;
    },
    resetTooltip: function resetTooltip() {
      if (this.hasTooltipData) {
        this.tooltipStyle = {
          null: true
        };
        this.tooltipData = [];
        this.selectedIndex = null;
        this.hasTooltipData = false;
        this.emitTooltipEvent();
      }
    },
    emitTooltipEvent: function emitTooltipEvent(e) {
      __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$emit('showChartTooltip', {
        type: this.chartComponent.components.tooltip,
        style: this.tooltipStyle,
        tooltipData: this.tooltipData,
        currency: this.$parent.$parent.currency,
        hasData: this.hasTooltipData
      });
    },
    handleDate: function handleDate() {
      var _this12 = this;
      this.$parent.$parent.$refs.datepick.togglePopup();
      this.$nextTick(function () {
        _this12.$parent.$parent.$refs.datepick.$el.classList.toggle('picker-top');
      });
    },
    setDate1Month: function setDate1Month() {
      this.$parent.$parent.$refs.datepick.setPreset('Last1Month');
    },
    setDate3Months: function setDate3Months() {
      this.$parent.$parent.$refs.datepick.setPreset('Last3Months');
    },
    drillDown: function drillDown(e) {
      if (this.isDrilledDown) return;
      var value;
      var row;
      var index;
      this.loading = true;
      if ((e.target.nodeName.toLowerCase() === 'line' || e.target.nodeName.toLowerCase() === 'path') && e.target.getAttribute('ct:value') || e.target.classList.contains('ct-interaction-on')) {
        this.resetTooltip();
        value = e.target.getAttribute('dataLabel');
        var dataValue = e.target.getAttribute('dataValue') || (this.isIE ? e.target.childElementCount === 3 ? e.target.childNodes[2].getAttribute('dataValue') : null : e.target.childElementCount === 3 ? e.target.children[2].getAttribute('dataValue') : null);
        if (value === 'Other Hotel Chains' || dataValue === '0') {
          this.loading = false;
          return;
        }
        row = this.rawData.filter(function (row) {
          return ~row.indexOf(value);
        })[0];
        index = this.rawData.indexOf(row);
        this.showBack || drillDown.call(this);
      } else {
        if (typeof e === 'number') {
          index = e;
          row = this.rawData[index];
          this.showBack || drillDown.call(this);
          this.resetTooltip();
        }
      }
      this.selectedIndex = index;
      function drillDown() {
        this.executeDrilldown(value);
      }
    },
    executeDrilldown: function executeDrilldown(value) {
      if (typeof this.chartComponent.drillDown === 'function') {
        this.tooltipStyle = {
          null: true
        };
        this.tooltipData = [];
        this.isDrilledDown = true;
        this.drilldownValue = value;
        this.chartData = utils.copy(this.originalData);
        this.chartInfo = utils.copy(this.originalInfo);
        this.drillDownFilterValue = value;
        this.drillDownFilterText = this.getDrilldownDisplayValue(value);
        this.showBack = true;
        this.customSettings.hasDrillDown = false;
        this.$parent.isDisabled = true;
        this.resetTooltip();
        this.chartComponent.drillDown.call(this, this, value);
      }
    },
    getDrilldownDisplayValue: function getDrilldownDisplayValue(value) {
      if (value.length > 40) return value.slice(0, 25) + '...';else return value;
    },
    goBack: function goBack() {
      if (typeof this.chartComponent.drillDownReturn === 'function') {
        this.loading = true;
        this.chartData = utils.copy(this.originalData);
        this.chartInfo = utils.copy(this.originalInfo);
        this.showBack = false;
        this.selectedIndex = null;
        this.isDrilledDown = false;
        this.drilldownValue = null;
        this.customSettings.hasDrillDown = true;
        this.needsRefresh = true;
        this.$parent.isDisabled = false;
        this.chartComponent.drillDownReturn.call(this, this);
      }
    },
    handleResize: function handleResize() {
      this.seq = 0;
      this.seq2 = 0;
    },
    updateChartVisuals: function updateChartVisuals(isVertical) {
      var hTextLabels = document.querySelectorAll('.ct-label.ct-horizontal.ct-end:not([title])');
      var vTextLabels = document.querySelectorAll('.ct-label.ct-vertical.ct-start:not([title])');
      var hGridLines = document.querySelectorAll('.ct-grid.ct-vertical');
      this.updateGridLines(hGridLines);
      this.updateLabels(vTextLabels, false, true);
      this.updateLabels(hTextLabels, isVertical, false);
    },
    updateGridLines: function updateGridLines(elems) {
      Array.prototype.forEach.call(elems, function (line) {
        line.setAttribute('x1', 2);
      });
    },
    updateLabels: function updateLabels(divs, hideAction, isVertical) {
      var maxLen = isVertical ? 35 : 34;
      Array.prototype.forEach.call(divs, function (span) {
        if (hideAction === true) {
          span.setAttribute('style', 'display: none');
        } else {
          var content = span.textContent;
          if (content.length >= maxLen) {
            span.textContent = content.slice(0, maxLen - 2) + '...';
            span.setAttribute('title', content);
            span.setAttribute('style', 'pointer-events:all');
          }
        }
      });
    },
    colorStep: function colorStep(point, label, base, offset) {
      var step = this.chartData.series[0] && this.chartData.series[0].length > 10 ? 0 : 1 || 0;
      var colors = this.chartComponent.colors || {};
      var colIndex = colors[label] ? colors[label] : (point % 15 === base ? base : point % 15 + step) + (offset || 0);
      return colIndex;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("RMJP")))

/***/ }),

/***/ "7L00":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__ = __webpack_require__("X3jq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_receiptScan_receiptScanPoller__ = __webpack_require__("N9pM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_Programs_Card_transactions_ReceiptImageViewer_vue__ = __webpack_require__("38ON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus__ = __webpack_require__("Usg1");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var READY_STATUSES = ['ReadyForMatch', 'Matched', 'Submitted', 'FolderSaved'];
/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpaysubmitreceipt',
  components: {
    ReceiptImageViewer: __WEBPACK_IMPORTED_MODULE_5__components_modules_Programs_Card_transactions_ReceiptImageViewer_vue__["a" /* default */]
  },
  data: function data() {
    return {
      receiptScanId: this.$route.query.receiptScanId || null,
      scan: null,
      imageUrl: null,
      imageContentType: null,
      imageErrored: false,
      busy: false,
      errorMessage: null,
      selectedCandidate: null,
      merchant: '',
      amount: null,
      transactionDate: null,
      category: '',
      poller: null
    };
  },
  computed: {
    moment: function moment() {
      return global.moment;
    },
    candidates: function candidates() {
      return this.scan && this.scan.matchCandidates || [];
    },
    formattedAmount: function formattedAmount() {
      if (this.amount == null || isNaN(this.amount)) return '—';
      var n = Number(this.amount);
      var sign = n < 0 ? '-' : '';
      return sign + '$' + Math.abs(n).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    formattedDate: function formattedDate() {
      if (!this.transactionDate) return '—';
      return this.moment(this.transactionDate).format('MMM DD YYYY');
    },
    isReady: function isReady() {
      return !!(this.scan && READY_STATUSES.indexOf(this.scan.status) >= 0);
    },
    hasNoPrefill: function hasNoPrefill() {
      return !this.merchant && this.amount == null && !this.transactionDate;
    },
    previewContentType: function previewContentType() {
      // getImage's contentType wins; fall back to the scan DTO's FileInfo. Both
      // carry the stored upload content-type — needed so PDF receipts (library
      // picker accepts application/pdf) hit the viewer's iframe branch instead
      // of rendering as a broken <img>.
      return this.imageContentType || this.scan && this.scan.fileInfo && this.scan.fileInfo.contentType || null;
    }
  },
  created: function created() {
    if (this.receiptScanId) {
      this.fetchScan();
    } else {
      this.errorMessage = 'No receipt selected. Capture or pick a receipt first.';
    }
  },
  watch: {
    // Tell mobile.vue to drop the "Uploading receipt…" overlay the moment we
    // actually have something to show — either the candidates (isReady) or an
    // error message. Until then the overlay covers the empty SubmitReceipt body
    // so the user never sees a blank page during the 10–20s Photon scan.
    isReady: function isReady(ready) {
      if (ready) {
        __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$emit('submit-receipt-ready');
      }
    },
    errorMessage: function errorMessage(msg) {
      if (msg) {
        __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$emit('submit-receipt-ready');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.poller) {
      this.poller.cancel();
      this.poller = null;
    }
  },
  methods: {
    // Initial candidate selection: pre-select the backend-suggested candidate, or NOTHING when
    // none cleared the confidence floor (PRODUCTDEV-5475). Replaces the old `suggested || cs[0]`
    // fallback, which confidently pre-selected the top noise candidate on a no-match receipt.
    pickInitialCandidate: function pickInitialCandidate(candidates) {
      return (candidates || []).find(function (c) {
        return c.isSuggested;
      }) || null;
    },
    fetchScan: function fetchScan() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var r, cs;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getStatus(_this.receiptScanId);
            case 3:
              r = _context.sent;
              _this.scan = r;
              _this.applyPrefill(r);
              _this.loadImage();
              if (_this.isReady) {
                _context.next = 10;
                break;
              }
              // Scan still in flight — start polling and let the progress UI render.
              // candidates / selection are populated by the poller's onDone callback.
              _this.startPolling();
              return _context.abrupt("return");
            case 10:
              cs = r && r.matchCandidates || [];
              _this.selectedCandidate = _this.pickInitialCandidate(cs);
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              _this.errorMessage = 'Could not load receipt. Please try again.';
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 14]]);
      }))();
    },
    startPolling: function startPolling() {
      if (this.poller) return;
      var self = this;
      this.poller = Object(__WEBPACK_IMPORTED_MODULE_4__core_receiptScan_receiptScanPoller__["a" /* default */])({
        receiptScanId: this.receiptScanId,
        contextHint: {
          source: 'submitReceipt'
        },
        onDone: function onDone(result) {
          self.poller = null;
          // Use the poller's final getStatus payload directly — `result.data` is the
          // full response from the last poll cycle. The previous implementation made
          // a second getStatus call here, which left the 3-step progress card on
          // screen for an extra ~1s while the (already-known) ready data round-tripped
          // back from Platform. That was the "second loading screen" the user saw.
          var scanData = result && result.data;
          if (!scanData) {
            self.errorMessage = 'Could not load receipt. Please try again.';
            return;
          }
          self.scan = scanData;
          self.applyPrefill(scanData);
          self.loadImage();
          var cs = scanData.matchCandidates || [];
          self.selectedCandidate = self.pickInitialCandidate(cs);
        },
        onError: function onError(error) {
          self.poller = null;
          if (error.type === 'scan_failed') {
            self.errorMessage = 'Scan failed. Please try uploading the receipt again.';
          } else if (error.type === 'timeout' || error.type === 'unreachable') {
            self.errorMessage = 'Scan is taking longer than expected. Save the receipt to your folder and try matching later.';
          } else {
            self.errorMessage = 'Error scanning receipt. Please try again.';
          }
        }
      });
      this.poller.start();
    },
    applyPrefill: function applyPrefill(data) {
      var autoFill = data && data.autoFill || data && data.autoFillJson || {};
      this.merchant = autoFill.MerchantName || autoFill.merchantName || data && data.merchant || '';
      var amountObj = autoFill.amount || autoFill.Amount;
      if (amountObj && amountObj.total != null) {
        this.amount = amountObj.total;
      } else if (autoFill.PhotonTotal != null) {
        this.amount = autoFill.PhotonTotal;
      } else if (autoFill.photonTotal != null) {
        this.amount = autoFill.photonTotal;
      } else {
        this.amount = (data && data.amount) != null ? data.amount : null;
      }
      this.transactionDate = autoFill.TransactionDate || autoFill.transactionDate || data && data.transactionDate || null;
      this.category = autoFill.Category || autoFill.category || '';
    },
    loadImage: function loadImage() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var r;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getImage(_this2.receiptScanId);
            case 3:
              r = _context2.sent;
              if (r && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(r) === 'object') {
                _this2.imageUrl = r.presignedUrl || r.url || null;
                _this2.imageContentType = r.contentType || null;
              } else if (typeof r === 'string') {
                _this2.imageUrl = r;
              }
              // No URL and nothing previously loaded → show the viewer's "Image
              // unavailable" fallback instead of an endless spinner. A failed refresh
              // keeps an already-loaded image on screen.
              _this2.imageErrored = !_this2.imageUrl;
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              _this2.imageErrored = !_this2.imageUrl;
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 8]]);
      }))();
    },
    isSelected: function isSelected(candidate) {
      return this.selectedCandidate && this.selectedCandidate.legacyTransactionId === candidate.legacyTransactionId;
    },
    // Status colour for the left stripe. The ranker only returns receiptable (Open/Pending)
    // candidates and MatchCandidateDto carries no per-candidate status field, so the stripe is
    // always yellow. The previous green/red branches keyed off candidate.transactionStatus,
    // which the API never serves — dead code. If MatchCandidateDto ever exposes TransactionStatus
    // (the data exists on EvedPayCardTransactionReadModel; Platform PR #35502), re-introduce the
    // green (Reconciled/Matched) / red (Denied/Rejected) mapping here.
    statusColor: function statusColor() {
      return 'yellow';
    },
    formatCurrency: function formatCurrency(amount, currencyCode) {
      if (typeof amount !== 'number') return '$0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode || 'USD'
      }).format(amount);
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return 'N/A';
      var d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return global.moment(d).format('MMM DD YYYY');
    },
    onSubmit: function onSubmit() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!_this3.selectedCandidate || !_this3.scan)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _this3.busy = true;
              _this3.errorMessage = null;
              _context3.prev = 4;
              _context3.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].matchToTransaction(_this3.receiptScanId, _this3.selectedCandidate.legacyTransactionId, _this3.scan.rowVersion);
            case 7:
              // Pass receiptScanId alongside transactionid so ReconcileTransaction.tryApplyReceiptScanPrefill()
              // can read it from $route.query and fill the form from the Photon extraction (Amount, line items,
              // mismatch detection). Without this query param, the prefill mixin no-ops and the user sees an
              // empty form despite the OCR having extracted the data.
              _this3.$router.push({
                path: '/evedpay/transactiondetails',
                query: {
                  transactionid: _this3.selectedCandidate.legacyTransactionId,
                  receiptScanId: _this3.receiptScanId
                }
              });
              _context3.next = 13;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](4);
              _this3.errorMessage = 'Failed to match receipt. Please try again.';
            case 13:
              _context3.prev = 13;
              _this3.busy = false;
              return _context3.finish(13);
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[4, 10, 13, 16]]);
      }))();
    },
    onSaveForLater: function onSaveForLater() {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this4.scan) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              _this4.busy = true;
              _this4.errorMessage = null;
              _context4.prev = 4;
              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].saveToFolder(_this4.receiptScanId, _this4.scan && _this4.scan.rowVersion || '');
            case 7:
              // Spec (Ticket 5): "the user can be returned to the page they started from
              // … and a small message appears at the bottom of the app confirming the action".
              // Return to /evedpay/cards (FAB origin) and surface the confirmation toast.
              _this4.$notifications.notify({
                type: 'info',
                message: 'Image Added to Receipt Folder',
                placement: {
                  from: 'bottom',
                  align: 'center'
                }
              });
              _this4.$router.push({
                path: '/evedpay/cards'
              });
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](4);
              _this4.errorMessage = 'Could not save receipt. Please try again.';
            case 14:
              _context4.prev = 14;
              _this4.busy = false;
              return _context4.finish(14);
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[4, 11, 14, 17]]);
      }))();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "7Mbz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var DEFAULT_ROW_HEIGHT = 35;
var DEFAULT_HEIGHT = 120;
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      htmlDetails: '',
      shownDetails: false,
      loadedDetails: false,
      details: [Object, String],
      contentBodyHeight: DEFAULT_HEIGHT
    };
  },
  computed: {
    /* shownDetails() {
      return this.params.data._expanded || this._shownDetails
    }, */
    position: function position() {
      return {
        left: "-".concat(this.cell.offsetLeft + this.colApi.leftWidth, "px"),
        width: (this.params.column.pinned ? this.colApi.leftWidth : this.colApi.bodyWidth + this.colApi.rightWidth + this.colApi.leftWidth) + 'px',
        height: "".concat(this.contentBodyHeight - DEFAULT_ROW_HEIGHT, "px")
      };
    },
    contentPosition: function contentPosition() {
      return {
        marginLeft: this.params.column.pinned ? 0 : this.colApi.scrollPosition + 'px'
      };
    },
    closeIconPosition: function closeIconPosition() {
      return {
        display: this.params.column.colId === 'details' ? 'none' : 'block',
        marginLeft: !this.params.column.pinned ? this.colApi.scrollPosition + this.colApi.rightWidth + this.colApi.scrollWidth - 30 + 'px' : this.colApi.rightWidth + this.colApi.leftWidth - 20 + 'px'
      };
    },
    detailsModel: function detailsModel() {
      return this.details;
    },
    detailsCondition: function detailsCondition() {
      return this.params && this.params.data && this.params.detailsCondition && this.params.detailsCondition(this.params);
    }
  },
  created: function created() {
    var detailsLocation = this.getDetailsLocation();
    this.colApi = this.params.api.columnController;
    this.cell = this.params.eGridCell;
    this.cell.style.overflow = 'visible';
    if (detailsLocation === 'local') {
      this.getDetails();
    }
    this.shownDetails = this.params.data && this.params.data._expanded;
  },
  mounted: function mounted() {
    this.shownDetails && this.doExpand(true);
  },
  methods: {
    showDetails: function showDetails() {
      this.shownDetails = !this.shownDetails;
      // this.params.context.shownDetails = this.shownDetails

      !this.loadedDetails && this.getDetails();
      if (this.getDetailsLocation() === 'local') {
        this.doExpand();
      }
    },
    getDetailsLocation: function getDetailsLocation() {
      return this.params.colDef.hasDetails;
    },
    hideDetails: function hideDetails() {
      if (!this.params.context.data) {
        this.shownDetails = !this.shownDetails;
      }
    },
    getDetails: function getDetails() {
      var _this = this;
      var detailsLocation = this.getDetailsLocation();

      // local
      if (detailsLocation === 'local') {
        this.details = this.params.data;
        this.loadedDetails = true;
      } else {
        // remote
        var apiPath = detailsLocation.split('.');
        var path = this.api.$[apiPath[0]][apiPath[1]];
        this.api.forms.post("".concat(path).concat(this.params.colDef.detailsParamsURL && this.params.colDef.detailsParamsURL(this.params)), {
          // id: this.params.data[this.params.colDef.uid],
          gridID: this.params.context.alias
        }).then(function (r) {
          _this.details = r.data;
          _this.loadedDetails = true;
          _this.doExpand();
        });
      }
    },
    computeHeight: function computeHeight() {
      this.contentBodyHeight = this.$refs.body ? this.$refs.body.clientHeight + DEFAULT_ROW_HEIGHT + 40 : this.contentBodyHeight;

      //
      // this.cell.parentNode.setAttribute('data-computed-height', this.contentBodyHeight)
    },
    doExpand: function doExpand(reset) {
      var _this2 = this;
      this.cell.parentNode.className = this.cell.parentNode.className.replace(' ag-row-expanded', '') + (this.shownDetails ? ' ag-row-expanded' : '');
      this.cell.className = this.cell.className.replace(' ag-cell-expanded', '') + (this.shownDetails ? ' ag-cell-expanded' : '');
      this.$nextTick(function () {
        _this2.computeHeight();
        typeof _this2.shownDetails !== 'undefined' && _this2.params.context.$emit('expandedRow', {
          expanded: _this2.shownDetails,
          index: _this2.params.rowIndex,
          height: _this2.contentBodyHeight - DEFAULT_ROW_HEIGHT,
          reset: reset
        });
      });
    }
  }
});

/***/ }),

/***/ "7QHX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("7Y0a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abe643f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("7Zzx");
function injectStyle (ssrContext) {
  __webpack_require__("2CAy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7abe643f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abe643f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7VNZ":
/***/ (function(module, exports) {

exports.thousandsFormatter = function (num) {
  var isNegative = false;
  var formattedNumber = num;
  if (num < 0) {
    isNegative = true;
  }
  num = Math.abs(num);
  if (num >= 1000000000) {
    formattedNumber = (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
  } else if (num >= 1000000) {
    formattedNumber = (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  } else if (num >= 1000) {
    formattedNumber = (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  } else {
    var rounded = Math.round(num);
    formattedNumber = rounded === 1000 ? '1K' : rounded;
  }
  if (isNegative) {
    formattedNumber = '-' + formattedNumber;
  }
  return formattedNumber.toString();
};
exports.moneyGetSymbol = function (currencyCode) {
  switch (currencyCode) {
    case 'USD':
      return '$';
    case 'EUR':
      return '€';
    case 'GBP':
      return '£';
  }
  return '';
};
exports.usNumberFormat = function (value, precision) {
  if (typeof precision === 'undefined') precision = 2;
  value = value + '';
  var sign = '';
  if (value.indexOf('-') === 0) {
    sign = '-';
    value = value.replace('-', '');
  }
  var n = value.replace(/[ ,!-,$]/g, '');
  var c = precision;
  var d = '.';
  var t = ',';
  c = isNaN(c = Math.abs(c)) ? 2 : c;
  d = d === undefined ? ',' : d;
  t = t === undefined ? '.' : t;
  var i = parseInt(n = (+n || 0).toFixed(c)) + '';
  var j = (j = i.length) > 3 ? j % 3 : 0;
  var result = (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
  return sign + result;
};
exports.getArrayMaxValue = function (arr) {
  var max = parseFloat(arr[0]);
  var len = arr.length;
  for (var i = 1; i < len; i++) {
    var v = parseFloat(arr[i]);
    max = v > max ? v : max;
  }
  return max;
};
exports.getArrayMinValue = function (arr) {
  var min = parseFloat(arr[0]);
  var len = arr.length;
  for (var i = 1; i < len; i++) {
    var v = parseFloat(arr[i]);
    min = v < min ? v : min;
  }
  return min;
};
exports.getArrayAverage = function (arr) {
  var sum = parseFloat(arr[0]);
  var len = arr.length;
  for (var i = 1; i < len; i++) {
    sum += parseFloat(arr[i]);
  }
  var avg = sum / len;
  return avg;
};
exports.getMoneyFormatedValue = function (value, currency) {
  var fval = this.usNumberFormat(value, this.getPrecision(currency));
  return fval + ' ' + currency;
};
exports.getPrecision = function (currency) {
  if (currency === 'JPY') return 0;else return 2;
};

/***/ }),

/***/ "7XmN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllocationSection_vue__ = __webpack_require__("BrnE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_619734f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllocationSection_vue__ = __webpack_require__("gyKt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllocationSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_619734f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllocationSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Y0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_money_format__ = __webpack_require__("5BCb");
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * MONEY OBJECT
 *
 * This module handles money data types.
 *
 * @package ValueObjects
 */


var rates = {};
var fxRates = null;

// const OFX = 'cd82cbc2ae3a4c2b829b1bcc1aeca51b'
var defaultCurrency = 'USD';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-money',
  alias: 'money',
  components: {
    MoneyFormat: __WEBPACK_IMPORTED_MODULE_0_vue_money_format__["a" /* default */]
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    currency: {
      type: String
    },
    code: {
      type: Boolean
    },
    supplementalPrecision: {
      type: Number,
      default: 0
    },
    locale: {
      type: String,
      default: 'en'
    },
    skipConversion: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    symbol: function symbol() {
      return this.getSymbol();
    },
    _currency: function _currency() {
      var context = document.querySelector('.module') && document.querySelector('.module').__vue__ || {};
      var parent = this.$parent || {};
      return this.currency || parent.currency || context.currency || defaultCurrency;
    }
  },
  data: function data() {
    return {
      parsedValue: 0,
      negative: false,
      nil: false,
      _locale: null,
      formatted: '',
      rates: {}
    };
  },
  beforeCreate: function beforeCreate() {
    /* if (!fxRates) {
      fxRates = this.api.g.get(`https://openexchangerates.org/api/latest.json?app_id=${OFX}`)
        .then(r => {
          fxRates = r.data.rates
          // this.parsedValue = this.parse()
          // setTimeout(this.render)
        })
      //
    } */
    // fxRates = fxRates || this.api.g.get(`https://openexchangerates.org/api/latest.json?app_id=${OFX}`)
    fxRates = {};
  },
  created: function created() {
    var _this = this;
    fxRates.then && fxRates.then(function (r) {
      fxRates = r.data.rates;
      _this.render();
    });
  },
  mounted: function mounted() {
    this.parsedValue = this.parse();
    // this.render()
  },
  updated: function updated() {
    this.render();
  },
  methods: {
    parse: function parse() {
      var value = this.$el.querySelector('.value').innerText || this.value;
      var rate = fxRates[this._currency] || rates[this._currency] || 1;
      var absValue = null;
      value = +value * (this.skipConversion ? 1 : rate);
      this.negative = value < 0;
      this.nil = value === 0;
      absValue = Math.abs(value);

      // multipliers
      /* if (Math.abs(value) > 1000000) {
        absValue = absValue / 1000000
        this.multiplier = 'M'
      }
      if (Math.abs(value) > 1000000000) {
        absValue = absValue / 1000000
        this.multiplier = 'B'
      } */

      return absValue;
    },
    getRate: function getRate(currency, skip) {
      var _currency = currency || this._currency;
      var _skip = skip || this.skipConversion;
      return _skip ? 1 : fxRates[_currency] || rates[_currency] || 1;
    },
    getSymbol: function getSymbol() {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this._currency
      }).format(0).replace('.00', '').replace(',00', '').replace('0', '').trim();
    },
    render: function render() {
      var el = this.$el.querySelector('.money');
      var SYM = this.symbol;
      var NEGATIVE_FIRST = "".concat(SYM, "(");
      var NEGATIVE_LAST = ") ".concat(SYM);
      var symbolFirst = !isNaN(el.innerText.trim().substr(-1));
      this.parsedValue = this.parse();
      if (this.negative) {
        this.formatted = (symbolFirst ? '' : '(') + el.innerHTML.replace(SYM, symbolFirst ? NEGATIVE_FIRST : NEGATIVE_LAST).replace(/&nbsp;/g, '').trim() + (symbolFirst ? ')' : '');
      } else {
        var value = this.parsedValue ? el.innerHTML.replace(/&nbsp;/g, '') : el.innerText;
        this.formatted = SYM.length > 2 ? value.replace(SYM, !symbolFirst ? "".concat(SYM, " ") : " ".concat(SYM)) : value;
        // this.formatted = el.innerHTML.replace(/&nbsp;/g, '')
      }
    }
  }
});

/***/ }),

/***/ "7Zzx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"money",class:{ negative: _vm.negative, nil: _vm.nil, lazy: _vm.$root.loading },attrs:{"title":_vm.formatted}},[_c('span',{staticClass:"value"},[_vm._t("default")],2),_c('money-format',{staticClass:"money",attrs:{"value":_vm.parsedValue,"locale":_vm.locale,"currency-code":_vm._currency,"subunits-value":false,"hide-subunits":false,"supplemental-precision":_vm.supplementalPrecision}}),_c('span',{staticClass:"formatted"},[_vm._v(_vm._s(_vm.formatted))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7bSZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.name,attrs:{"id":"layout"}},[_c('div',{staticClass:"wrapper centered"},[_c('div',{staticClass:"main-panel",class:{ 'loading' : _vm.loading }},[_c('div',{staticClass:"auth-layout-wrapper"},[_c('div',{staticClass:"auth-header"}),_c('div',{staticClass:"auth-top"},[_c('div',{staticClass:"container-fluid"},[_c('ed-button',{staticClass:"pull-right btn btn-actionbar- btn-success",class:{ invisible: _vm.isLoggedIn },attrs:{"href":_vm.env + "/SignUp"}},[_vm._v("Sign-up")]),_vm._m(0)],1)]),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"auth-main-body col-md-4 col-md-offset-4 offset-md-4 col-sm-8 col-sm-offset-2 offset-sm-2"},[_vm._t("default")],2)])]),_vm._m(1)]),_c('md-footer',{staticClass:"visible"})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__("zwB3"),"height":"44"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-md-offset-4 offser-md-4 text-right- text-center"},[_c('div',{staticClass:"logo- partner-"},[_c('p',{staticClass:"row"},[_c('br'),_c('br'),_c('img',{staticStyle:{"cursor":"pointer","height":"40px","width":"auto","border-radius":"4px","box-shadow":"0 1px 6px rgba(0,0,0,0.25)"},attrs:{"id":"assuranceCardSeal","src":"https://produs-ccs-assurancecard-service.sgsonline.net/img/thumb.png","onclick":"javascript:window.open('https://produs-ccs-assurancecard-service.sgsonline.net/assurancecard/be8e7fbc4499573f9c0088ceb2764691963efb6620c58fb42c6f7104e6fc6247/assurancecard', 'assurance_card', 'location=no, menubar=no, resizable=yes, scrollbars=yes, width=500, height=535, top=100, left=100'); return false;","alt":"VikingCloud Assurance Card","title":"VikingCloud Assurance Card","border":"0"}})]),_c('p',{staticClass:"row"},[_c('br')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7dKZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dawn-panel"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"dawn-panel",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"dawn-panel-top"},[_c('span',{staticClass:"close-icon",on:{"click":_vm.close}},[_c('i',{staticClass:"fal fa-times"})])]),_c('div',{staticClass:"dawn-panel-header"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]),_vm._t("body"),_c('div',{staticClass:"dawn-panel-footer text-right"},[_vm._t("footer"),(!_vm.hasSlotFooter)?_c('div',[(_vm.secondaryButton != 'false')?_c('ed-button',{staticClass:"btn btn-secondary",on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.secondaryButton))]):_vm._e(),(_vm.primaryButton != 'false')?_c('ed-button',{staticClass:"btn btn-primary",on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.primaryButton))]):_vm._e()],1):_vm._e()],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7dgW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReverseApFile_vue__ = __webpack_require__("8VMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cae1c6e2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReverseApFile_vue__ = __webpack_require__("vuhK");
function injectStyle (ssrContext) {
  __webpack_require__("/HVE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cae1c6e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReverseApFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cae1c6e2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReverseApFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7npE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("oNa7");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37fbdff5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("fKL7");
function injectStyle (ssrContext) {
  __webpack_require__("HF8s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37fbdff5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7yCl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initScrollbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__ = __webpack_require__("HMpe");

var resetScroll = function resetScroll(ctx, selector) {
  ctx.$el.querySelector(selector).scrollLeft = 0;
  ctx.$el.querySelector(selector).scrollTop = 0;
  ctx.ps.update(ctx.$el.querySelector(selector));
};
var initScrollbar = function initScrollbar(ctx, selector) {
  var viewport = ctx.$el.querySelector(selector);
  if (ctx.ps && !ctx.ps.isAlive) {
    ctx.ps.destroy();
    ctx.ps = null;
    ctx.ps = new __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__["a" /* default */](viewport, {
      minScrollbarLength: 20
    });
  } else if (ctx.ps) resetScroll(ctx, selector);else {
    ctx.ps = new __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__["a" /* default */](viewport, {
      minScrollbarLength: 20
    });
  }
  viewport.addEventListener('wheel', function (e) {
    // viewport.scrollTop += e.deltaY
    e.preventDefault();
  });
};

/***/ }),

/***/ "7yIU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoreActions_vue__ = __webpack_require__("toiP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59364e3b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MoreActions_vue__ = __webpack_require__("e4wH");
function injectStyle (ssrContext) {
  __webpack_require__("Urgo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59364e3b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoreActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59364e3b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MoreActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "81Tg":
/***/ (function(module, exports) {

module.exports = {"data":"user","user":"person","token":"sk","username":"username","name":"fullname","permissions":"roles","modules":"menu","type":"type","subscription":"subscription","domain":"marketTypeID","billpay":"billpay","p2p":"p2p","theme":"theme","claims":"permissions","userPermissions":"userPermissions","flags":"flags","created":"dateCreated","settings":"settings","dateFormat":"dateFormat","hasPC":"hasPC","invoicePrefHidden":"invoicePrefHidden","isDell":"isDell","hasBankAccount":"hasBankAccount"}

/***/ }),

/***/ "84UZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__money__ = __webpack_require__("7QHX");

// import address from 'address'

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__money__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__money__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__money__["a" /* default */].alias, __WEBPACK_IMPORTED_MODULE_0__money__["a" /* default */]);
    // Vue.component(address.name, address)
  }
});

/***/ }),

/***/ "86dO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_api_receiptScans__ = __webpack_require__("X3jq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_Programs_Card_transactions_ReceiptImageViewer_vue__ = __webpack_require__("38ON");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CandidateSelector',
  components: {
    ReceiptImageViewer: __WEBPACK_IMPORTED_MODULE_3__components_modules_Programs_Card_transactions_ReceiptImageViewer_vue__["a" /* default */]
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // optional — modal is hidden via :show until a scan is in flight
    receiptScanId: {
      type: String
    },
    candidates: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    rowVersion: {
      type: String,
      default: null
    },
    autoLinked: {
      type: Boolean,
      default: false
    },
    claimMode: {
      type: Boolean,
      default: false
    },
    autoFill: {
      type: Object,
      default: null
    },
    // True while the Photon scan is in flight — render skeletons for OCR + table.
    loading: {
      type: Boolean,
      default: false
    },
    // Optional client-side objectURL for the receipt the user just uploaded.
    // When set, takes precedence over the backend-fetched `receiptImageUrl` so the
    // receipt is visible immediately when the modal opens (before the BE image
    // fetch resolves). Caller is responsible for `URL.revokeObjectURL` on close.
    localImageUrl: {
      type: String,
      default: null
    },
    // MIME type of `localImageUrl` (e.g. 'application/pdf', 'image/png'). Drives
    // whether the receipt area renders <img> or <embed>. <img> can't display PDFs.
    localImageContentType: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      selectedCandidate: null,
      dismissedAutoLink: false,
      isMatching: false,
      isSavingToFolder: false,
      receiptImageUrl: null,
      receiptImageError: false,
      SKELETON_ROW_COUNT: 3
    };
  },
  // `_imageRequestSeq` is assigned directly on the instance (not declared in
  // data) so it stays non-reactive — Vue 2 skips proxying `_`-prefixed keys,
  // and keeping it off data() also avoids template-binding mistakes. Used as a
  // request sequence counter so a late fetchReceiptImage response from a prior
  // open can't overwrite the current one (reopen-close-reopen race).
  created: function created() {
    this._imageRequestSeq = 0;
  },
  computed: {
    actionInFlight: function actionInFlight() {
      return this.isMatching || this.isSavingToFolder;
    },
    // Prefer the caller-supplied local objectURL (instant render at modal-open)
    // over the BE-fetched presigned URL. They reference the same bytes — once the
    // BE image arrives we could swap to it, but keeping the local one is cheaper
    // and visually identical.
    displayImageUrl: function displayImageUrl() {
      return this.localImageUrl || this.receiptImageUrl;
    },
    ocrMerchant: function ocrMerchant() {
      return this.autoFill && this.autoFill.merchantName ? this.autoFill.merchantName : null;
    },
    ocrDate: function ocrDate() {
      var d = this.autoFill && this.autoFill.transactionDate;
      if (!d) return null;
      try {
        var dt = new Date(d);
        var mm = String(dt.getMonth() + 1).padStart(2, '0');
        var dd = String(dt.getDate()).padStart(2, '0');
        return mm + '/' + dd + '/' + dt.getFullYear();
      } catch (e) {
        return d;
      }
    },
    ocrAmount: function ocrAmount() {
      if (!this.autoFill || !this.autoFill.amount) return null;
      var total = this.autoFill.amount.total;
      if (typeof total !== 'number') return null;
      var currency = this.autoFill.amount.currencyCode || 'USD';
      // PRODUCTDEV-5783 — thousand separators on the Receipt Data amount (e.g. "1,452.50 USD").
      return total.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' ' + currency;
    }
  },
  watch: {
    show: function show(newVal) {
      if (newVal) {
        if (this.candidates && this.candidates.length > 0) {
          var suggested = this.candidates.find(function (c) {
            return c.isSuggested;
          });
          // Pre-select only the floor-clearing suggestion; none → select nothing so the user
          // picks, instead of confidently pre-selecting the top noise candidate (PRODUCTDEV-5475).
          this.selectedCandidate = suggested || null;
        }
        this.fetchReceiptImage();
      } else {
        this.receiptImageUrl = null;
        this.receiptImageError = false;
      }
    },
    candidates: function candidates(newVal) {
      var _this = this;
      if (!newVal || newVal.length === 0) {
        this.selectedCandidate = null;
        return;
      }
      // Preserve the user's current selection when the candidates list refreshes
      // (e.g. a poll tick) and their pick is still present. Resetting unconditionally
      // clobbers a deliberate user choice.
      if (this.selectedCandidate && newVal.find(function (c) {
        return c.legacyTransactionId === _this.selectedCandidate.legacyTransactionId;
      })) {
        return;
      }
      var suggested = newVal.find(function (c) {
        return c.isSuggested;
      });
      this.selectedCandidate = suggested || null;
    }
  },
  methods: {
    formatCurrency: function formatCurrency(amount, currencyCode) {
      if (typeof amount !== 'number') {
        return '$0.00';
      }
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode || 'USD'
      }).format(amount);
    },
    // PRODUCTDEV-5783 — show the card's optional custom "Name on Card" in gray under the
    // cardholder name, mirroring the transactions grid. Only when present AND different from
    // the holder (matches Card-cards/CardHolder.vue).
    showNameOnCard: function showNameOnCard(candidate) {
      var name = (candidate && candidate.nameOnCard ? candidate.nameOnCard : '').trim();
      var holder = (candidate && candidate.cardholderName ? candidate.cardholderName : '').trim();
      return !!name && name !== holder;
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) {
        return 'N/A';
      }
      var date = new Date(dateStr);
      if (isNaN(date.getTime())) {
        return dateStr;
      }
      var momentDateFormat = this.$root.getUser && this.$root.getUser.sessionSettings && this.$root.getUser.sessionSettings.DateAndTimeFormats && this.$root.getUser.sessionSettings.DateAndTimeFormats.MomentDateFormat || 'MM-DD-YYYY';
      return global.moment(date).format(momentDateFormat);
    },
    formatConfidence: function formatConfidence(confidence) {
      if (typeof confidence === 'number') {
        var pct = confidence > 1 ? confidence : confidence * 100;
        return Math.round(pct);
      }
      return confidence;
    },
    confidenceClass: function confidenceClass(confidence) {
      var conf = typeof confidence === 'number' ? confidence : 0;
      var normalized = conf > 1 ? conf / 100 : conf;
      if (normalized >= 0.90) {
        return 'confidence-high';
      } else if (normalized >= 0.70) {
        return 'confidence-medium';
      }
      return 'confidence-low';
    },
    handleMatch: function handleMatch() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var capturedReceiptScanId, capturedLegacyTxId, capturedRowVersion, errorEvent, status, conflictMsg, failMsg;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this2.selectedCandidate) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!_this2.actionInFlight) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              // Capture state to locals BEFORE the await — ed-modal's confirm() fires
              // 'close' synchronously after 'confirm' (edModal/index.vue:161-163), and
              // handleClose() resets selectedCandidate/receiptScanId/rowVersion. When
              // the await resumes, `this.selectedCandidate` is null, and reading
              // `.legacyTransactionId` off it throws a TypeError. The catch's
              // error.response-less branch then misclassifies that as a Network error
              // and fires emit('match-error') → DELETE on the just-matched scan.
              capturedReceiptScanId = _this2.receiptScanId;
              capturedLegacyTxId = _this2.selectedCandidate.legacyTransactionId;
              capturedRowVersion = _this2.rowVersion;
              _this2.isMatching = true;
              // Tell the parent a match is in flight so handleCandidateSelectorClose
              // (which fires from ed-modal's auto-close on @confirm) skips its
              // dispose-on-cancel path. Emit synchronously before the await so the
              // flag is set before the close event reaches the parent.
              _this2.$emit('match-attempt', {
                receiptScanId: capturedReceiptScanId
              });
              _context.prev = 9;
              if (!_this2.claimMode) {
                _context.next = 16;
                break;
              }
              _context.next = 13;
              return __WEBPACK_IMPORTED_MODULE_2__core_api_receiptScans__["b" /* default */].claimReceipt(capturedReceiptScanId, capturedLegacyTxId, capturedRowVersion);
            case 13:
              _this2.$emit('claim-selected', {
                receiptScanId: capturedReceiptScanId,
                legacyTransactionId: capturedLegacyTxId
              });
              _context.next = 19;
              break;
            case 16:
              _context.next = 18;
              return __WEBPACK_IMPORTED_MODULE_2__core_api_receiptScans__["b" /* default */].matchToTransaction(capturedReceiptScanId, capturedLegacyTxId, capturedRowVersion);
            case 18:
              _this2.$emit('match-selected', {
                receiptScanId: capturedReceiptScanId,
                legacyTransactionId: capturedLegacyTxId
              });
            case 19:
              if (!_this2.claimMode) {
                _this2.handleClose();
              }
              _context.next = 26;
              break;
            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](9);
              errorEvent = _this2.claimMode ? 'claim-error' : 'match-error';
              if (_context.t0.response) {
                status = _context.t0.response.status;
                if (status === 403) {
                  _this2.$notifications.notify({
                    type: 'danger',
                    message: 'You no longer have access to this receipt',
                    placement: {
                      from: 'top',
                      align: 'center'
                    }
                  });
                  _this2.$emit(errorEvent, {
                    status: status,
                    message: 'You no longer have access to this receipt'
                  });
                } else if (status === 409) {
                  conflictMsg = _this2.claimMode ? 'Receipt state changed — pick again' : 'This receipt has already been matched';
                  _this2.$notifications.notify({
                    type: 'warning',
                    message: conflictMsg,
                    placement: {
                      from: 'top',
                      align: 'center'
                    }
                  });
                  _this2.$emit(errorEvent, {
                    status: status,
                    message: conflictMsg
                  });
                } else {
                  failMsg = _this2.claimMode ? 'Failed to claim receipt. Please try again.' : 'Failed to match receipt. Please try again.';
                  _this2.$notifications.notify({
                    type: 'danger',
                    message: failMsg,
                    placement: {
                      from: 'top',
                      align: 'center'
                    }
                  });
                  _this2.$emit(errorEvent, {
                    status: status,
                    message: _context.t0.response.statusText || 'Unknown error'
                  });
                }
              } else {
                _this2.$notifications.notify({
                  type: 'danger',
                  message: 'Network error. Please check your connection and try again.',
                  placement: {
                    from: 'top',
                    align: 'center'
                  }
                });
                _this2.$emit(errorEvent, {
                  status: 0,
                  message: 'Network error'
                });
              }
            case 26:
              _context.prev = 26;
              _this2.isMatching = false;
              return _context.finish(26);
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[9, 22, 26, 29]]);
      }))();
    },
    handleSaveToFolder: function handleSaveToFolder() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this3.actionInFlight) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this3.isSavingToFolder = true;
              _context2.prev = 3;
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_2__core_api_receiptScans__["b" /* default */].saveToFolder(_this3.receiptScanId, _this3.rowVersion);
            case 6:
              _this3.$emit('save-to-folder', {
                receiptScanId: _this3.receiptScanId
              });
              _this3.$notifications.notify({
                // 'info' keeps the notification chrome neutral (no colored border) — the green
                // visual is carried entirely by the inline fa-check-circle icon, which is a
                // solid green tick-in-circle glyph.
                type: 'info',
                message: '<i class="fas fa-check-circle" style="color: #5cb85c; margin-right: 8px;"></i>Receipt added to Receipt Folder',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _this3.handleClose();
              _context2.next = 15;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);
              console.error('Error saving to folder:', _context2.t0);
              _this3.$notifications.notify({
                type: 'danger',
                message: 'Failed to save receipt. Please try again.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            case 15:
              _context2.prev = 15;
              _this3.isSavingToFolder = false;
              return _context2.finish(15);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 11, 15, 18]]);
      }))();
    },
    handleClose: function handleClose() {
      // Reset state
      this.selectedCandidate = null;
      this.dismissedAutoLink = false;
      this.isMatching = false;
      this.isSavingToFolder = false;
      this.receiptImageUrl = null;
      this.receiptImageError = false;
      this.$emit('close');
    },
    fetchReceiptImage: function fetchReceiptImage() {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var seq, res;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (_this4.receiptScanId) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              // Bump the sequence and stash locally. Any later await-resume on a stale
              // request (modal closed and reopened on a new scan) finds seq !== current
              // and bails before writing receiptImageUrl, which prevents a stale image
              // from landing in the new context.
              seq = ++_this4._imageRequestSeq;
              _this4.receiptImageError = false;
              _context3.prev = 4;
              _context3.next = 7;
              return __WEBPACK_IMPORTED_MODULE_2__core_api_receiptScans__["b" /* default */].getImage(_this4.receiptScanId);
            case 7:
              res = _context3.sent;
              if (!(seq !== _this4._imageRequestSeq || !_this4.show)) {
                _context3.next = 10;
                break;
              }
              return _context3.abrupt("return");
            case 10:
              if (res && res.presignedUrl) {
                _this4.receiptImageUrl = res.presignedUrl;
              } else {
                _this4.receiptImageError = true;
              }
              _context3.next = 19;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](4);
              if (!(seq !== _this4._imageRequestSeq || !_this4.show)) {
                _context3.next = 17;
                break;
              }
              return _context3.abrupt("return");
            case 17:
              console.error('Failed to fetch receipt image:', _context3.t0);
              _this4.receiptImageError = true;
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[4, 13]]);
      }))();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "87ps":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_charts_components_tooltip_standard__ = __webpack_require__("Ik2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_charts_helper_formatter__ = __webpack_require__("7VNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_charts_helper_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__core_charts_helper_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_chartColors__ = __webpack_require__("CRMk");



/* harmony default export */ __webpack_exports__["a"] = ({
  showLegend: false,
  showSmallLegend: true,
  chartOpts: getOptions(),
  chartData: function chartData(widget, data) {
    return getChartData(data);
  },
  chartInfo: function chartInfo(widget, data) {
    return getChartInfo(data, 0);
  },
  components: {
    tooltip: __WEBPACK_IMPORTED_MODULE_0__core_charts_components_tooltip_standard__["a" /* default */]
  }
});
function getOptions() {
  var baseCustSet = {
    chartGroupValue: 'Program',
    multipleSeries: true,
    dynamicHeight: true,
    hasDrillDown: false,
    showTotal: true,
    showTotalValue: 'Budget Used',
    recalculateGridMax: true,
    tooltip: {
      tooltipType: 'standard',
      width: '220px'
    }
  };
  var baseOpts = {
    customSettings: baseCustSet,
    stackBars: true,
    horizontalBars: true,
    seriesBarDistance: 20,
    labelInterpolationFnc: function labelInterpolationFnc(value) {
      return value[1];
    },
    fullWidth: false,
    targetLine: {
      value: 0,
      class: 'ct-target-line'
    },
    axisY: {
      position: 'start',
      labelOffset: {
        x: 2,
        y: 2
      },
      scaleMinSpace: 40,
      offset: 125,
      showLabel: true,
      labelInterpolationFnc: function labelInterpolationFnc(value) {
        return value;
      }
    },
    chartPadding: {
      top: 5,
      right: 50,
      bottom: 5,
      left: 5
    }
  };
  return baseOpts;
}
function getChartInfo(dataIn, pos) {
  var result = [];
  dataIn.forEach(function (elem) {
    var gdPos = result.findIndex(function (k) {
      return k[0] === elem[pos];
    });
    if (gdPos === -1) result.push(elem[pos]);
  });
  return result.map(function (k) {
    return k[0];
  });
}
function getChartData(data) {
  var ProgramName = 0;
  var RevisedBudget = 1;
  var BudgetBalance = 2;
  var TotalProgramPOAmount = 3;
  var TotalProgramExpenseAmount = 4;
  var POTotalLessVatGst = 5;
  var ExpenseTotalLessVatGst = 6;
  var IncludeExpenseInBudget = 7;
  var ExcludeVATFromBudget = 8;
  var CostPerAttendee = 9;
  var BudgetPerAttendee = 10;
  var config = {};
  if (data.length === 2) {
    config = data[1];
    data.pop();
  }
  var sortedData = data.sort(function (b, a) {
    var av = a[RevisedBudget];
    var bv = b[RevisedBudget];
    if (av < bv) return 1;
    if (av > bv) return -1;
    return 0;
  });
  var hasPerAttendeeCols = sortedData[0].length === 11;
  var revisedBudget = sortedData.map(function (k) {
    return k[RevisedBudget];
  });
  var fullBudget = [];
  var posP = [];
  var expP = [];
  var labelData = [];
  var pos = sortedData.map(function (k) {
    return k[ExcludeVATFromBudget] ? k[POTotalLessVatGst] : k[TotalProgramPOAmount];
  });
  var expenses = sortedData.map(function (k) {
    return k[IncludeExpenseInBudget] ? k[ExcludeVATFromBudget] ? k[ExpenseTotalLessVatGst] : k[TotalProgramExpenseAmount] : 0;
  });
  var hasExpenses = false;
  var isOverbudget = false;
  for (var i = 0, n = expenses.length; i < n; i++) {
    if (expenses[i] !== 0) {
      hasExpenses = true;
    }
    expP.push(Math.floor(expenses[i] / revisedBudget[i] * 100) || 0);
  }
  for (var _i = 0, _n = pos.length; _i < _n; _i++) {
    posP.push(Math.floor(pos[_i] / revisedBudget[_i] * 100));
  }
  for (var _i2 = 0, _n2 = revisedBudget.length; _i2 < _n2; _i2++) {
    fullBudget.push(100);
    var overBudget = posP[_i2] + (expP[_i2] || 0) > 100;
    var label = (overBudget ? '!$red$! ' : '') + (posP[_i2] + (expP[_i2] || 0) + '% of ' + __WEBPACK_IMPORTED_MODULE_1__core_charts_helper_formatter___default.a.thousandsFormatter(revisedBudget[_i2]));
    if (posP[_i2] + (expP[_i2] || 0) < 0) {
      posP[_i2] = 0;
      expP[_i2] = 0;
    }
    if (overBudget) {
      var total = posP[_i2] + (expP[_i2] || 0);
      posP[_i2] = posP[_i2] / total * 100;
      expP[_i2] = (expP[_i2] || 0) / total * 100;
    }
    isOverbudget = overBudget;
    labelData.push(revisedBudget[_i2] === 0 ? 'No Budget' : label);
  }
  var maxValue = 100;
  var minValue = 0;
  var dataSeries = [];
  dataSeries.push({
    name: 'POs/Invoices',
    value: posP,
    ignoreLabel: true,
    color: isOverbudget ? __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_chartColors__["a" /* default */].red : __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_chartColors__["a" /* default */].blue,
    width: '15px'
  });
  if (hasExpenses) {
    dataSeries.push({
      name: 'Expenses',
      value: expP,
      ignoreLabel: true,
      color: __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_chartColors__["a" /* default */].purple,
      width: '15px'
    });
  }
  var budgetChart = {
    type: 'Bar',
    stackBars: false,
    ignoreForCharts: false,
    data: [{
      name: 'Remaining Budget',
      value: fullBudget,
      ignoreLabel: true,
      color: __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_chartColors__["a" /* default */].greyLight,
      width: '15px',
      labelData: labelData
    }]
  };
  var consumptionChart = {
    type: 'Bar',
    stackBars: true,
    ignoreForCharts: false,
    data: dataSeries
  };
  var tooltipMetadata = getTooltipMetaData(hasExpenses, hasPerAttendeeCols, config.POsOrInvoicesLabel);
  var tooltipCData = {
    helpText: null,
    metadata: tooltipMetadata,
    data: [sortedData.map(function (k) {
      return k[ProgramName];
    }), sortedData.map(function (k) {
      return k[RevisedBudget].toFixed(2);
    }), sortedData.map(function (k) {
      return (k[ExcludeVATFromBudget] ? k[POTotalLessVatGst] : k[TotalProgramPOAmount]).toFixed(2);
    }), sortedData.map(function (k) {
      return k[BudgetBalance].toFixed(2);
    })]
  };
  if (hasPerAttendeeCols) {
    tooltipCData.data.push(sortedData.map(function (k) {
      return k[BudgetPerAttendee] === 0 ? null : k[BudgetPerAttendee];
    }));
    tooltipCData.data.push(sortedData.map(function (k) {
      return k[CostPerAttendee] === 0 ? null : k[CostPerAttendee];
    }));
  }
  if (hasExpenses) {
    tooltipCData.data.push(sortedData.map(function (k) {
      return (k[IncludeExpenseInBudget] ? k[ExcludeVATFromBudget] ? k[ExpenseTotalLessVatGst] : k[TotalProgramExpenseAmount] : 0).toFixed(2);
    }));
  }
  return {
    labels: sortedData.map(function (k) {
      return k[ProgramName];
    }),
    series: [budgetChart, consumptionChart],
    tooltipData: tooltipCData,
    maxValue: maxValue,
    minValue: minValue
  };
}
function getTooltipMetaData(hasExpenses, hasPerAttendeeCols, posOrInvoicesLabel) {
  var tooltipMetadata = [{
    label: '',
    type: 'title',
    format: ''
  }, {
    label: 'Revised Budget',
    type: 'main',
    format: 'currency'
  }, {
    label: posOrInvoicesLabel || 'POs/Invoices',
    type: 'main',
    format: 'currency'
  }, {
    label: 'Remaining Budget',
    type: 'secondary',
    format: 'currency'
  }];
  if (hasPerAttendeeCols) {
    tooltipMetadata.push({
      label: 'Budget Per Attendee',
      type: 'secondary',
      format: 'currency'
    });
    tooltipMetadata.push({
      label: 'Cost Per Attendee',
      type: 'secondary',
      format: 'currency'
    });
  }
  if (hasExpenses) tooltipMetadata.push({
    label: 'Expenses',
    type: 'main',
    format: 'currency'
  });
  return tooltipMetadata;
}

/***/ }),

/***/ "8JoW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_vue__ = __webpack_require__("0pAm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4d5e9ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_text_vue__ = __webpack_require__("1KxB");
function injectStyle (ssrContext) {
  __webpack_require__("RNN8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4d5e9ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4d5e9ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8LDB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_6dKXWKzAoW0oiWxdT69l8","Dell":"gJvAh53OpWHZAtYdXHWFW","Abbott":"_2AWX4n_xistsZg8HoDrEkU","Gap":"_1C_M7pc7CQrtJiHzZFTx46","Allstate":"_2Uk3yi56t9iC0y7VFI9BDG","Asurion":"_1a_kOcgGQdVOMV3EzcE9fy","Invitae":"_2ZNvUMftea0IqQJMpbbBtZ","JWE":"_1etT3V_es_tcVflbJHnzrW"};

/***/ }),

/***/ "8S0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

var getInitials = function getInitials(username) {
  var parts = username.split(/[ -]/);
  var initials = '';
  for (var i = 0; i < parts.length; i++) {
    initials += parts[i].charAt(0);
  }
  if (initials.length > 3 && initials.search(/[A-Z]/) !== -1) {
    initials = initials.replace(/[a-z]+/g, '');
  }
  initials = initials.substr(0, 3).toUpperCase();
  return initials;
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-avatar',
  props: {
    username: {
      type: String
    },
    initials: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    color: {
      type: String
    },
    customStyle: {
      type: Object
    },
    inline: {
      type: Boolean
    },
    size: {
      type: Number,
      default: 50
    },
    src: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: true
    },
    lighten: {
      type: Number,
      default: 80
    },
    parser: {
      type: Function,
      default: getInitials,
      validator: function validator(parser) {
        return typeof parser('John', getInitials) === 'string';
      }
    }
  },
  data: function data() {
    return {
      backgroundColors: ['#F44336', '#FF4081', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', /* '#FFEB3B' , */'#FFC107', '#FF9800', '#FF5722', '#795548', '#9E9E9E', '#607D8B'],
      imgError: false
    };
  },
  mounted: function mounted() {
    if (!this.isImage) {
      this.$emit('avatar-initials', this.username, this.userInitial);
    }
  },
  computed: {
    background: function background() {
      if (!this.isImage) {
        return this.backgroundColor || this.randomBackgroundColor(this.username.length, this.backgroundColors);
      }
    },
    fontColor: function fontColor() {
      if (!this.isImage) {
        return this.color || this.lightenColor(this.background, this.lighten);
      }
    },
    isImage: function isImage() {
      return !this.imgError && Boolean(this.src);
    },
    style: function style() {
      var style = {
        display: this.inline ? 'inline-block' : 'block',
        width: "".concat(this.size, "px"),
        height: "".concat(this.size, "px"),
        borderRadius: this.rounded ? '50%' : 0,
        lineHeight: "".concat(this.size + Math.floor(this.size / 20), "px"),
        fontWeight: 'bold',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        userSelect: 'none'
      };
      var imgBackgroundAndFontStyle = {
        background: "transparent url('".concat(this.src, "') no-repeat scroll 0% 0% / ").concat(this.size, "px ").concat(this.size, "px content-box border-box")
      };
      var initialBackgroundAndFontStyle = {
        backgroundColor: this.background,
        font: "".concat(Math.floor(this.size / 2.5), "px/").concat(this.size, "px Helvetica, Arial, sans-serif"),
        color: this.fontColor
      };
      var backgroundAndFontStyle = this.isImage ? imgBackgroundAndFontStyle : initialBackgroundAndFontStyle;
      Object.assign(style, backgroundAndFontStyle);
      return style;
    },
    userInitial: function userInitial() {
      if (!this.isImage) {
        var initials = this.initials || this.parser(this.username, getInitials);
        return initials;
      }
      return '';
    }
  },
  methods: {
    initial: getInitials,
    onImgError: function onImgError(evt) {
      this.imgError = true;
    },
    randomBackgroundColor: function randomBackgroundColor(seed, colors) {
      return colors[seed % colors.length];
    },
    lightenColor: function lightenColor(hex, amt) {
      // From https://css-tricks.com/snippets/javascript/lighten-darken-color/
      var usePound = false;
      if (hex[0] === '#') {
        hex = hex.slice(1);
        usePound = true;
      }
      var num = parseInt(hex, 16);
      var r = (num >> 16) + amt;
      if (r > 255) r = 255;else if (r < 0) r = 0;
      var b = (num >> 8 & 0x00FF) + amt;
      if (b > 255) b = 255;else if (b < 0) b = 0;
      var g = (num & 0x0000FF) + amt;
      if (g > 255) g = 255;else if (g < 0) g = 0;
      return (usePound ? '#' : '') + (g | b << 8 | r << 16).toString(16);
    }
  }
});

/***/ }),

/***/ "8SbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.closeExportSelector),expression:"closeExportSelector"}],staticClass:"export-selector dropdown",class:{ open : _vm.isExportSelectorOpened }},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('Export Data'),expression:"'Export Data'",modifiers:{"bottom":true}}],staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"},on:{"click":function($event){$event.preventDefault();return _vm.openExportSelector.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-table"})]),_c('div',{staticClass:"dropdown-menu dropdown-menu-right"},[_c('div',{staticClass:"export selector grid-filter"},[_c('p',{staticClass:"column-title"},[_vm._v("Export"),_c('ed-select',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('Choose between exporting only visible columns or all columns'),expression:"'Choose between exporting only visible columns or all columns'",modifiers:{"bottom":true}}],staticClass:"inline small tiny label-right",attrs:{"field-label":"Columns","hide-optional":"","options":_vm.exportOptions,"label":"label","open-direction":"over"},model:{value:(_vm.exportOption),callback:function ($$v) {_vm.exportOption=$$v},expression:"exportOption"}})],1),_c('div',{staticClass:"container-"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v("Download as:")]),_c('ul',{staticClass:"types"},_vm._l((_vm.types),function(type){return _c('li',[_c('a',{staticClass:"type",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.doExport(type)}}},[_c('i',{staticClass:"icon",class:_vm.Types[type].icon}),_vm._v(_vm._s(_vm.Types[type].label))])])}),0)])])])])]),_c('iframe',{staticClass:"export-frame",attrs:{"frameborder":"0","src":_vm.exportUri}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8USW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("E1GH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56715e8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("1oXU");
function injectStyle (ssrContext) {
  __webpack_require__("bvG0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56715e8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8V/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"add-supplier-page"},[_c('ed-title-nav',{ref:"header",attrs:{"title":_vm.$t('Add Supplier'),"subtitle":_vm.$t("Notify Eved's Help Desk that you need a supplier to create an EvedPay account or to be added to your network")}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('br'),_vm._v(" "),_c('form',{staticClass:"col-md-12",on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},_vm._l((_vm.invite),function(supplier,i){return _c('ed-section',{key:i,staticClass:"no-border",attrs:{"title":"Supplier Invitation","wide":""}},[(i === 0)?_c('span',{attrs:{"slot":"description"},slot:"description"},[_vm._v("\n            The supplier will receive an email letting them know that your company uses EvedPay!\n            Eved's merchant services team will assist them with the sign-up process if they\n            don't already have an account.\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[(_vm.$v.$invalid && _vm.$v.$dirty)?_c('div',{staticClass:"error-summary panel panel-danger panel-side no-icon"},[_c('div',{staticClass:"panel-heading"}),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',[_vm._v("\n                  All fields are required unless labeled 'optional'\n                ")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading.8",value:(_vm.api.$.supplier.customFields),expression:"api.$.supplier.customFields",modifiers:{"8":true}}],staticClass:"form-group list"},[_c('transition-group',{attrs:{"name":"field"}},_vm._l((_vm.mapFields),function(field,index){return _c('div',{key:_vm.hash(field),staticClass:"form-group list",attrs:{"data-field":field.key}},[_c(field.type,_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.shouldBeVisible(field)),expression:"shouldBeVisible(field)"}],ref:"fields",refInFor:true,tag:"component",staticClass:"full-width list",attrs:{"field-label":field.label,"type":field.nativeType,"maxlength":field.maxLength,"placeholder":" ","required":field.required,"optional":field.optional,"error":_vm.$v.Supplier[field.key] && _vm.$v.Supplier[field.key].$error,"helptip-header":"","helptip-body":_vm.validationMessage(field),"options":_vm.fieldOptions(field),"track-by":"text","button-label":"Upload File","button-position":"bottom","post-action":_vm.api.env + field.dataSource.url,"headers":_vm.headers,"upload-auto":true,"multiple":_vm.multiple(field),"readonly":field.type === _vm.FIELD_TYPES.file ? true : false,"show-helptip-icon":false,"endpoint":field.type === _vm.FIELD_TYPES.file ? field.dataSource.url : null,"openEndpoint":field.dataSource.url,"label":"text","integer":field.integer,"xserver-search":"field.serverSearch","xsearch":"query => fetchOptions(field, query)"},on:{"open":function($event){return _vm.fetchOptions(field)},"select":function () { _vm.selectOption(field) },"hook:created":function($event){return _vm.update(field)},"hook:beforeCreate":function($event){return _vm.beforeCreateField(field)}},model:{value:(supplier[field.key]),callback:function ($$v) {_vm.$set(supplier, field.key, $$v)},expression:"supplier[field.key]"}},'component',_vm.meta(field.key, index, field),false)),_vm._v(" "),(_vm.shouldShowInfo(field).label)?_c('div',{staticClass:"alternate"},[_c('label',[_vm._v("\n                      "+_vm._s(field.label)+"\n                      "),(!field.required)?_c('em',{staticClass:"optional-field-label"},[_vm._v(" - optional")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info-field"},[_c('em',[_vm._v("Select "),_c('strong',[_vm._v(_vm._s(_vm.shouldShowInfo(field).label))]),_vm._v(" "+_vm._s(_vm.shouldShowInfo(field).meta))])])]):_vm._e()],1)}),0),_vm._v(" "),_c('transition-group',{attrs:{"name":"field","duration":1000}},[(_vm.customFields.length && !_vm.loading)?_c('div',{key:"submit"},[_c('br'),_vm._v(" "),_c('ed-button',{staticClass:"cta alt",class:{ invalid: _vm.$v.$invalid && _vm.$v.$dirty, disabled: !_vm.canSubmit },attrs:{"disabled":!_vm.canSubmit,"endpoint":_vm.submitAction},on:{"click":_vm.send}},[_vm._v("\n                    "+_vm._s(_vm.$t("Send"))+"\n                  ")])],1):_c('small',{key:"wait"},[_vm._v(" "+_vm._s(null && _vm.$t("Wait a second..."))+" ")])])],1)])])}),1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8VMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Toolbar__ = __webpack_require__("fGtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FundingAddress_vue__ = __webpack_require__("OA49");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReverseApFile',
  components: {
    toolbar: __WEBPACK_IMPORTED_MODULE_3__Toolbar__["a" /* default */],
    FundingAddress: __WEBPACK_IMPORTED_MODULE_4__components_FundingAddress_vue__["a" /* default */]
  },
  data: function data() {
    var id = Number((this.$route.query || {}).id || 0);
    return {
      id: id,
      busy: false,
      apiApFileUrl: '',
      fundingAddressModel: null,
      form: {
        fundingAddress: ""
      },
      email: {
        to: '',
        cc: '',
        bcc: '',
        subject: "",
        message: ""
      },
      apFileName: '',
      fundingInvoiceId: 0,
      replacedApFile: null,
      showApReplace: false,
      apReplaceNotes: '',
      apUploadFinished: true,
      apAttachmentFiles: null,
      apAttachmentMissingError: false,
      apDisplayUploadError: false,
      apUploadError: '',
      customMessage: '',
      extraFiles: []
    };
  },
  computed: {
    apUploadSettings: function apUploadSettings() {
      return {
        folder: 'Temp/',
        token: this.$user.sessionSettings.AspxToken,
        fileType: 'excel/csv',
        renameFile: this.apFileName
      };
    },
    apFileUrl: function apFileUrl() {
      return this.apiApFileUrl || '/ProgramFusion/GenerateAuditFile?auditFileID=' + this.id;
    },
    apFileLinkText: function apFileLinkText() {
      return this.apFileName || 'Open AP File';
    },
    extraFileNames: function extraFileNames() {
      return Array.prototype.map.call(this.extraFiles || [], function (f) {
        return f.name;
      });
    },
    messageHtml: function messageHtml() {
      var raw = this.email && this.email.message || '';
      var escaped = raw.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      var withLinks = escaped.replace(/([\w.+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g, '<a href="mailto:$1">$1</a>');
      return withLinks.replace(/\n/g, '<br/>');
    }
  },
  created: function created() {
    this.loadData(true);
  },
  methods: {
    loadData: function loadData(isReversal) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var _yield$_this$api$get, r, formatted;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _this.busy = true;
              _context.next = 4;
              return _this.api.get(_this.api.$.payment.getReversalOrCorrectApFileInfo, {
                params: {
                  apFileId: _this.id,
                  isReversal: isReversal
                }
              });
            case 4:
              _yield$_this$api$get = _context.sent;
              r = _yield$_this$api$get.data;
              _this.fundingAddressModel = _this.normalizeAddressModel(r.FundingAddress) || _this.fundingAddressModel;
              formatted = _this.formatFundingAddress(_this.fundingAddressModel) || _this.form.fundingAddress;
              _this.form.fundingAddress = formatted;
              _this.email.to = r.To || _this.email.to;
              _this.email.cc = typeof r.Cc === 'string' ? r.Cc : _this.email.cc;
              _this.email.subject = r.Subject || _this.email.subject;
              _this.email.message = _this.cleanBackendMessage(r.EmailBody || '');
              _this.apiApFileUrl = r.APFileUrl || _this.apiApFileUrl;
              _this.apFileName = r.AuditFileNumber || _this.apFileName;
              _this.fundingInvoiceId = r.FundingInvoiceId;
              _this.id = r.ApFileId;
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](0);
              console.warn('Failed to load AP reversal info', _context.t0);
            case 22:
              _context.prev = 22;
              _this.busy = false;
              return _context.finish(22);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 19, 22, 25]]);
      }))();
    },
    onChangeAddress: function onChangeAddress(addr) {
      if (typeof addr === 'string') {
        this.form.fundingAddress = addr;
      } else {
        this.fundingAddressModel = this.normalizeAddressModel(addr);
        this.form.fundingAddress = this.formatFundingAddress(this.fundingAddressModel);
      }
    },
    normalizeAddressModel: function normalizeAddressModel(addr) {
      if (!addr) return null;
      if (typeof addr === 'string') {
        try {
          return JSON.parse(addr);
        } catch (e) {
          return {
            Raw: addr
          };
        }
      }
      return addr;
    },
    isJson: function isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    formatFundingAddress: function formatFundingAddress(addr) {
      if (!addr) return '';
      if (addr.Raw && typeof addr.Raw === 'string') return addr.Raw;
      if (typeof addr === 'string') return addr;
      var parts = [addr.Name || addr.Company, addr.Address1, addr.Address2, [addr.City, addr.State || addr.Province, addr.PostalCode].filter(Boolean).join(', '), addr.Country].filter(Boolean);
      return parts.join('\n');
    },
    onApClose: function onApClose() {
      this.showApReplace = false;
      this.apAttachmentFiles = [];
      this.apReplaceNotes = '';
      this.apAttachmentMissingError = false;
    },
    apIsValid: function apIsValid() {
      var valid = this.apAttachmentFiles && this.apAttachmentFiles.length > 0;
      this.apAttachmentMissingError = !valid;
      return valid;
    },
    onApSave: function onApSave() {
      if (!this.apIsValid()) return;
      this.doReplaceApFile();
    },
    onApUploadComplete: function onApUploadComplete(e) {
      var _this2 = this;
      var completed = e.filter(function (item) {
        return item.success || !item.success && item.response && typeof item.response === 'string' && !_this2.isJson(item.response);
      });
      if (completed.length >= 1) this.apAttachmentMissingError = false;
      if (completed.length === e.length) {
        this.apUploadFinished = true;
        e.forEach(function (item) {
          var resp = null;
          if (item.success && item.response) {
            try {
              resp = JSON.parse(item.response);
              _this2.apUploadError = resp && resp.uploadError ? resp.uploadError : '';
            } catch (err) {
              _this2.apUploadError = '';
            }
          }
          if (!item.success) _this2.apUploadError = 'Upload request failed';
        });
        if (this.apUploadError) this.apDisplayUploadError = true;
        this.apAttachmentFiles = e.filter(function (item) {
          try {
            return item.success && JSON.parse(item.response).success;
          } catch (err) {
            return false;
          }
        });
      } else {
        this.apUploadFinished = false;
      }
    },
    doReplaceApFile: function doReplaceApFile() {
      var _this3 = this;
      var uploadedFile = '';
      var fileName = '';
      if (this.apAttachmentFiles && this.apAttachmentFiles.length > 0) {
        var fileItem = this.apAttachmentFiles[0];
        try {
          var resp = JSON.parse(fileItem.response);
          if (resp && resp.success) {
            uploadedFile = resp.file;
            fileName = resp.fileName || fileItem.name;
          }
        } catch (e) {
          console.warn('Failed to parse upload response', e);
        }
      }
      this.api.post(this.api.$.payment.replaceApFile, {
        auditFileId: this.auditFileId || this.id || 0,
        uploadedFile: uploadedFile,
        additionalNote: this.apReplaceNotes
      }).then(function () {
        _this3.apFileName = fileName;
        _this3.onApClose();
      }).catch(function (err) {
        _this3.apUploadError = 'Replace AP File failed';
        _this3.apDisplayUploadError = true;
        console.warn('Replace AP File error', err);
      });
    },
    cleanBackendMessage: function cleanBackendMessage(html) {
      if (!html) return '';
      var s = String(html);
      s = s.replace(/<br\s*\/?>/gi, '\n');
      s = s.replace(/<a[^>]*href=["']mailto:([^"']+)["'][^>]*>[\s\S]*?<\/a>/gi, '$1');
      s = s.replace(/<\/?[^>]+>/g, '');
      s = s.replace(/&nbsp;/gi, ' ').replace(/&amp;/gi, '&').replace(/&lt;/gi, '<').replace(/&gt;/gi, '>').replace(/&quot;/gi, '"').replace(/&#39;/g, "'");
      s = s.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
      return s;
    },
    triggerExtra: function triggerExtra() {
      this.$refs.extraInput && this.$refs.extraInput.click();
    },
    onExtraFiles: function onExtraFiles(e) {
      this.extraFiles = e.target.files || [];
    },
    cancel: function cancel() {
      this.$router.push('/i/Programs/Invoice-AP/');
    },
    send: function send() {
      var _this4 = this;
      this.busy = true;
      var fd = new FormData();
      fd.append('isReversal', true);
      var auditFile = {
        FundingInvoiceId: this.fundingInvoiceId || 0,
        AuditFileId: this.id || 0,
        Subject: this.email.subject || '',
        To: this.email.to || '',
        Bcc: this.email.bcc || '',
        Cc: this.email.cc || '',
        Message: this.email.message || '',
        EmailBody: this.rawEmailBody || this.email.message || '',
        AuditFileNumber: this.apFileName || '',
        FundingAddress: this.fundingAddressModel || {}
      };
      var _appendFormData = function appendFormData(data) {
        var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        for (var key in data) {
          if (!data.hasOwnProperty(key)) continue;
          var value = data[key];
          var formKey = root ? root + '.' + key : key;
          if (value === null || value === undefined) continue;
          if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(value) === 'object' && !(value instanceof File)) {
            _appendFormData(value, formKey);
          } else {
            fd.append('auditFile.' + formKey, value);
          }
        }
      };
      _appendFormData(auditFile);
      if (this.extraFiles && this.extraFiles.length) {
        for (var i = 0; i < this.extraFiles.length; i++) {
          fd.append('auditFile.Attachments', this.extraFiles[i]);
        }
      }
      this.api.post(this.api.$.payment.sendReversalOrCorrectedApFile, fd).then(function () {
        return _this4.cancel();
      }).catch(function (err) {
        return console.warn('Send reversal failed', err);
      }).finally(function () {
        _this4.busy = false;
      });
    }
  }
});

/***/ }),

/***/ "8byk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.discount)?_c('div',{staticClass:"line"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{ref:"discountPercentage",attrs:{"symbol":"%","amount":"","autoselect":"","name":"discount_percent"},on:{"change":function () { return _vm.computeDiscountValue(_vm.model); }},model:{value:(_vm.model.discountPercent),callback:function ($$v) {_vm.$set(_vm.model, "discountPercent", _vm._n($$v))},expression:"model.discountPercent"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("    ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{ref:"discountValue",attrs:{"amount":"","type":"money","autoselect":"","negative":"","currency":_vm.ctx.currency,"name":"discount_amount"},on:{"change":function () { return _vm.resetDiscount(_vm.model); }},model:{value:(_vm.model.discountAmount),callback:function ($$v) {_vm.$set(_vm.model, "discountAmount", $$v)},expression:"model.discountAmount"}})],1)]):_c('div',{staticClass:"line"},[_c('hr',{staticClass:"clear separator col-md-8"}),_vm._v(" "),_c('div',{staticClass:"name col-md-4"},[(typeof _vm.model.isChecked !== 'undefined')?_c('check',{attrs:{"option-label":_vm.model.name,"option-status":_vm.model.isChecked,"name":_vm.model.name,"id":_vm.ctx.getTaxId(_vm.model.name)},on:{"change-status":function () { return _vm.useTax(_vm.model); },"input":_vm.taxInput}}):_c('label',[_vm._v(_vm._s(_vm.model.name))])],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{ref:"taxPercentages",class:{ 'not-used': !_vm.model.isChecked && !_vm.hasTotal, 'loading list': _vm.loading },attrs:{"symbol":"%","amount":"","autoselect":"","disabled":!_vm.model.isChecked && !_vm.hasTotal,"name":_vm.ctx.getNamePercent(_vm.model.name),"supplementalPrecision":6},on:{"change":function () { return _vm.computeTaxValue(_vm.model); }},model:{value:(_vm.model.percentage),callback:function ($$v) {_vm.$set(_vm.model, "percentage", _vm._n($$v))},expression:"model.percentage"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("    ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-2",class:{ 'col-md-2': _vm.hasTotal, 'col-md-2': !_vm.hasTotal }},[_c('ed-input',{ref:"taxValues",class:{ 'not-used': !_vm.model.isChecked && !_vm.hasTotal },attrs:{"amount":"","type":"money","autoselect":"","currency":_vm.ctx.currency,"disabled":!_vm.model.isChecked && !_vm.hasTotal,"name":_vm.ctx.getNameAmount(_vm.model.name),"supplementalPrecision":6},on:{"change":function () { return _vm.resetTax(_vm.model); }},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}})],1),_vm._v(" "),(_vm.hasTotal)?_c('a',{staticClass:"col-xs-12 col-md-2 text-right totals",attrs:{"href":"#","name":_vm.ctx.getNameLink(_vm.model.name)},on:{"click":function($event){$event.preventDefault();return _vm.details(_vm.model)}}},[_c('v-money',{staticClass:"solid",attrs:{"currency":_vm.ctx.currency,"supplementalPrecision":6}},[_vm._v(_vm._s(_vm.model.totalTaxes))])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name col-xs-12 col-md-4",attrs:{"name":"discountLabel"}},[_c('label',{staticClass:"text"},[_vm._v("Discount")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8und":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{attrs:{"title":_vm.$t('Payments'),"subtitle":_vm.$t('Manage Invoices & Payments'),"tabs":_vm.tabs}}),_vm._v(" "),_c('legacy-container',{attrs:{"url":_vm.url}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8vDI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('a',{staticClass:"row-action",attrs:{"href":"javascript:;"},on:{"click":_vm.openAddReceipt}},[_c('i',{staticClass:"fas fa-camera",style:({ color: _vm.color })})]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Submit Receipt","show":_vm.showAddReceipt,"primary-button-disabled":_vm.primaryButtonDisabled,"primary-button":"Submit","type":"medium","validation":""},on:{"close":_vm.handleClose,"validate":_vm.handleConfirm}},[_c('div',{staticClass:"add-receipt-overlay",class:{ loading: _vm.receiptUploadInProgress },attrs:{"slot":"body"},slot:"body"},[(_vm.featureFlags.receiptScanPrefill)?[(_vm.uploadingReceipt)?[_c('label',[_c('strong',[_vm._v("Uploading")])]),_vm._v(" "),_c('div',{staticClass:"receipt-upload-progress"},[_c('div',{staticClass:"receipt-upload-progress-track"},[_c('div',{staticClass:"receipt-upload-progress-fill",style:({ width: _vm.uploadProgressPct + '%' })})]),_vm._v(" "),_c('span',{staticClass:"receipt-upload-progress-label"},[_vm._v(_vm._s(_vm.uploadProgressPct)+"%")])])]:[_c('label',[_c('strong',[_vm._v("Receipt")])]),_vm._v(" "),(_vm.pendingReceiptFile || _vm.attachedFile)?_c('div',{staticClass:"receipt-file-chip"},[_c('i',{staticClass:"fas",class:_vm.chipIconClass}),_vm._v(" "),_c('a',{staticClass:"receipt-file-chip-name",attrs:{"href":_vm.chipFileUrl || undefined,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.chipFileName))]),_vm._v(" "),(_vm.chipFileSize)?_c('span',{staticClass:"receipt-file-chip-size"},[_vm._v(_vm._s(_vm.chipFileSize))]):_vm._e(),_vm._v(" "),(_vm.canManageReceipts)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Remove'),expression:"'Remove'"}],staticClass:"receipt-file-chip-remove",attrs:{"href":"javascript:;"},on:{"click":_vm.clearPendingFile}},[_c('i',{staticClass:"fas fa-times-circle"})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"receipt-scan-actions"},[(!_vm.receiptCaptureDisabled && _vm.receiptScanModeLoaded)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(!_vm.canManageReceipts ? _vm.permissionTooltip : ((_vm.pendingReceiptFile || _vm.attachedFile || _vm.pendingFolderScanId) ? 'Remove the current receipt to upload a different one' : '')),expression:"!canManageReceipts ? permissionTooltip : ((pendingReceiptFile || attachedFile || pendingFolderScanId) ? 'Remove the current receipt to upload a different one' : '')"}]},[_c('button',{staticClass:"receipt-action-button",attrs:{"type":"button","disabled":!_vm.canManageReceipts || !!(_vm.pendingReceiptFile || _vm.attachedFile || _vm.pendingFolderScanId)},on:{"click":_vm.openFolderPicker}},[_vm._v("\n                ADD FROM RECEIPT FOLDER\n              ")])]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(!_vm.canManageReceipts ? _vm.permissionTooltip : ((_vm.pendingReceiptFile || _vm.attachedFile || _vm.pendingFolderScanId) ? 'Remove the current receipt to upload a different one' : '')),expression:"!canManageReceipts ? permissionTooltip : ((pendingReceiptFile || attachedFile || pendingFolderScanId) ? 'Remove the current receipt to upload a different one' : '')"}]},[_c('button',{staticClass:"receipt-action-button",attrs:{"type":"button","disabled":!_vm.canManageReceipts || !!(_vm.pendingReceiptFile || _vm.attachedFile || _vm.pendingFolderScanId)},on:{"click":_vm.triggerFileInput}},[_vm._v("\n                UPLOAD NEW RECEIPT\n              ")])])]),_vm._v(" "),((_vm.pendingReceiptFile || _vm.pendingFolderScanId) && !_vm.receiptCaptureDisabled && !_vm.disabled)?_c('div',{staticClass:"replace-coding-alert"},[_c('span',{staticClass:"replace-coding-alert-text"},[_vm._v("Coding stays unchanged on Submit — Scan to update it from this receipt.")]),_vm._v(" "),_c('a',{staticClass:"replace-coding-alert-action",attrs:{"href":"javascript:;"},on:{"click":_vm.rescanReceipt}},[_vm._v("Scan Receipt")])]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"additional-documents"},[_c('label',[_c('strong',[_vm._v("Additional Documents")])]),_vm._v(" "),_vm._l((_vm.additionalDocuments),function(doc,docIndex){return _c('div',{key:("doc-" + docIndex),staticClass:"receipt-file-chip"},[_c('i',{staticClass:"fas",class:_vm.documentIconClass(doc)}),_vm._v(" "),_c('a',{staticClass:"receipt-file-chip-name",attrs:{"href":(doc.path || doc._blobUrl) || undefined,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(doc.name))]),_vm._v(" "),(doc.size)?_c('span',{staticClass:"receipt-file-chip-size"},[_vm._v(_vm._s(_vm.formatFileSize(doc.size)))]):_vm._e(),_vm._v(" "),(_vm.canManageReceipts)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Remove'),expression:"'Remove'"}],staticClass:"receipt-file-chip-remove",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeDocument(docIndex)}}},[_c('i',{staticClass:"fas fa-times-circle"})]):_vm._e()])}),_vm._v(" "),(_vm.canManageReceipts)?_c('div',{staticClass:"receipt-scan-actions"},[_c('button',{staticClass:"receipt-action-button",attrs:{"type":"button"},on:{"click":_vm.uploadNewDocument}},[_vm._v("UPLOAD FILE")])]):_vm._e()],2),_vm._v(" "),_c('input',{ref:"receiptUploadInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"application/pdf, image/png, image/jpeg"},on:{"change":_vm.handleFileSelected}}),_vm._v(" "),_c('ReceiptFolderPicker',{attrs:{"show":_vm.showFolderPicker,"is-processing":_vm.folderPickerIsProcessing},on:{"select":_vm.handleFolderSelect,"close":_vm.closeFolderPicker}})]:[_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("Accepted formats: pdf, png, jpg, jpeg")]),_vm._v(" "),_c('div',{staticClass:"receipt-upload-legacy"},[_c('ed-upload',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(!(_vm.isUserAdmin || _vm.isDraft) && _vm.disabled ? _vm.permissionTooltip : ''),expression:"!(isUserAdmin || isDraft) && disabled ? permissionTooltip : ''"}],class:{loading: !_vm.uploadFinished},attrs:{"button-label":"Upload New Receipt","readonly":"","multiple":false,"postAction":_vm.api.env + _vm.api.$.evedpaycard.receipt,"uploadAuto":true,"canOpenFile":true,"headers":{Authorization: "Bearer " + _vm.token},"disabled":!(_vm.isUserAdmin || _vm.isDraft) && _vm.disabled,"name":"attachment_upload","accept":"application/pdf, image/png, image/jpeg","extensions":"pdf,png,jpg,jpeg"},on:{"input":_vm.createAttachments},model:{value:(_vm.uploaderFiles),callback:function ($$v) {_vm.uploaderFiles=$$v},expression:"uploaderFiles"}})],1)]],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8veb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9+bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('grid',{ref:"APFileTemplatesGrid",attrs:{"label":"Ap File Template","model":_vm.getModel,"name":"","desc":"","search":"","views":false,"resizing":false,"layout":"frame","endpoint":_vm.api.$.FundingInvoiceAndApSetting.getAPFileTemplates,"actions":_vm.actions,"checkboxes":false,"fit-columns":"","footer":""},on:{"changeRow":_vm.editAPFileTemplates,"editRow":function($event){return _vm.openEditAPFileTemplate($event)}}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"})]),_vm._v(" "),(_vm.showEditAPFileTemplate)?_c('EditAPFileTemplate',{attrs:{"model":_vm.apFileTemplateModel,"showModal":_vm.showEditAPFileTemplate},on:{"close":function($event){_vm.showEditAPFileTemplate = false},"save":_vm.onSave}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9+wP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tabs = function tabs() {
  return [MANAGE_PRODUCTS, MY_MEDIA, MANAGE_RESELLERS];
};
/* harmony default export */ __webpack_exports__["a"] = ({
  get tabs() {
    return tabs();
  }
});

//
var MANAGE_PRODUCTS = {
  label: 'Manage Products',
  href: {
    params: {
      page: 'Programs',
      section: 'Products',
      action: 'MyProduct'
    }
  }
};
var MY_MEDIA = {
  label: 'My Media',
  href: {
    params: {
      page: 'Programs',
      section: 'Products',
      action: 'MyMedia'
    }
  }
};
var MANAGE_RESELLERS = {
  label: 'Manage Resellers',
  href: {
    params: {
      page: 'Programs',
      section: 'Products',
      action: 'ManageReseller'
    }
  }
};

/***/ }),

/***/ "94BA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "97IH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEditFundingAddress_vue__ = __webpack_require__("LYfl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a74720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEditFundingAddress_vue__ = __webpack_require__("kFIn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEditFundingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a74720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEditFundingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9953":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snapshot_vue__ = __webpack_require__("X6A2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9a09bea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snapshot_vue__ = __webpack_require__("07Tp");
function injectStyle (ssrContext) {
  __webpack_require__("IUe+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9a09bea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snapshot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9a09bea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snapshot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9AbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_components_mdNotification__ = __webpack_require__("37qm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'md-notifications',
  components: {
    MdNotification: __WEBPACK_IMPORTED_MODULE_0__core_components_mdNotification__["a" /* default */]
  },
  data: function data() {
    return {
      notifications: this.$notifications.state
    };
  },
  methods: {
    removeNotification: function removeNotification(index) {
      this.$notifications.removeNotification(index);
    },
    onClose: function onClose(dismiss, notification, index) {
      // if native event do not send any data
      if (typeof notification.onClose === 'function') {
        // notification.onClose(dismiss ? dismiss.target ? null : dismiss : null)
        notification.onClose(dismiss ? dismiss.target ? undefined : dismiss : dismiss === '' ? '' : null);
      }
      this.removeNotification(index);
    }
  }
});

/***/ }),

/***/ "9Mkd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APFileTemplatesModel__ = __webpack_require__("P1lf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Grid_cells_actions__ = __webpack_require__("ayPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditAPFileTemplate_vue__ = __webpack_require__("zS+p");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_2__components_Grid__["a" /* default */],
    EditAPFileTemplate: __WEBPACK_IMPORTED_MODULE_5__EditAPFileTemplate_vue__["a" /* default */]
  },
  data: function data() {
    return {
      Model: __WEBPACK_IMPORTED_MODULE_3__APFileTemplatesModel__["a" /* default */],
      actions: [__WEBPACK_IMPORTED_MODULE_4__components_Grid_cells_actions__["c" /* edit */]],
      showEditAPFileTemplate: false,
      apFileTemplateModel: {
        Name: '',
        Divisions: [],
        BusinessUnits: []
      }
    };
  },
  computed: {
    getModel: function getModel() {
      return __WEBPACK_IMPORTED_MODULE_3__APFileTemplatesModel__["a" /* default */].get();
    }
  },
  created: function created() {},
  methods: {
    editAPFileTemplates: function editAPFileTemplates() {},
    openEditAPFileTemplate: function openEditAPFileTemplate(apFileTemplate) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var hasAPSettingsByBU, divisions, businessUnits;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              hasAPSettingsByBU = false;
              _context.next = 3;
              return _this.api.get(_this.api.$.FundingInvoiceAndApSetting.hasAPSettingsByBU).then(function (response) {
                hasAPSettingsByBU = response.data.Data;
              });
            case 3:
              divisions = [];
              _context.next = 6;
              return _this.api.get(_this.api.$.FundingInvoiceAndApSetting.getSelectedAPTemplateDivisions, {
                params: {
                  auditFileTemplateId: apFileTemplate.data && apFileTemplate.data.AuditFileTemplateId || 0
                }
              }).then(function (response) {
                divisions = response && response.data && response.data.Data;
              });
            case 6:
              businessUnits = [];
              if (!hasAPSettingsByBU) {
                _context.next = 10;
                break;
              }
              _context.next = 10;
              return _this.api.get(_this.api.$.FundingInvoiceAndApSetting.getSelectedAPTemplateBusinessUnits, {
                params: {
                  auditFileTemplateId: apFileTemplate.data && apFileTemplate.data.AuditFileTemplateId || 0
                }
              }).then(function (response) {
                businessUnits = response && response.data && response.data.Data;
              });
            case 10:
              _this.apFileTemplateModel = {
                AuditFileTemplateId: apFileTemplate.data.AuditFileTemplateId,
                Name: apFileTemplate.data.Name,
                HasAPSettingsByBU: hasAPSettingsByBU,
                Divisions: divisions,
                BusinessUnits: businessUnits
              };
              _this.showEditAPFileTemplate = true;
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    refreshTable: function refreshTable() {
      this.$refs.APFileTemplatesGrid.quickSearch();
      this.$refs.APFileTemplatesGrid.onSelectAll(false);
    },
    onSave: function onSave() {
      this.showEditAPFileTemplate = false;
      this.refreshTable();
    }
  }
});

/***/ }),

/***/ "9Npz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("body"),_vm._v(" "),_c('div',{staticClass:"approvals"},[_c('ul',{staticClass:"col-md-12"},_vm._l((_vm.approvalUsersData),function(user){return _c('li',{key:user.id},[_vm._v("\n        "+_vm._s(user.FirstName)+" "+_vm._s(user.LastName)+"\n      ")])}),0),_vm._v(" "),_c('br',{staticStyle:{"clear":"both"}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9QHg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2-Ekz3U-pIs7IBZQ-JsnS","Dell":"_20lWgr4dG7PfgPZ_v7TvN_","Abbott":"_3d7axc_fvHW8ir9YyfpQmk","Gap":"_1f3EnZpcudVT2ltFNhj8eE","Allstate":"_2tyBzu0oOhc5sdQun-Zora","Asurion":"_2ybx33D9aGZJ_4gvlB5d7g","Invitae":"_122HghlT_Qgob8F4FgMG-T","JWE":"aabT2DyKkXJOf5mUuZiUw"};

/***/ }),

/***/ "9Qp5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.fieldLabel)?_c('label',[_vm._v(_vm._s(_vm.fieldLabel)),(_vm.required)?_c('span',[_vm._v(" *")]):_vm._e(),_c('div',{staticClass:"helptip-wrapper"},[(_vm.helptipBody)?_c('span',{staticClass:"helptip-icon",on:{"click":function($event){return _vm.toggleHelp()}}},[_c('i',{class:[_vm.showHelp ? _vm.hideIcon : _vm.showIcon]})]):_vm._e(),(_vm.helptipBody && _vm.showHelp || _vm.helptipBody && _vm.error)?_c('ed-input-tooltip',{class:{"error-message": _vm.error},attrs:{"helptipHeader":_vm.helptipHeader,"errorTip":_vm.error,"helptipBody":_vm.helptipBody}}):_vm._e()],1)]):_vm._e(),_c('div',{staticClass:"form-inline d-flex justify-content-between"},[_vm._t("field1"),_vm._t("field2")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9W0U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"FvZnhkgQZEVZLLXjJByUJ","Dell":"_28btQ_7zFCX_TVbQBfzmnt","Abbott":"_2DECXW-82v8QxlXSS7-Wfw","Gap":"_1dWj6e0kW4hiKwWt0_6QLP","Allstate":"_3X5GbSC0YDhTXV_gbfvKsI","Asurion":"_3Udk7YkuuLQ9dcN_xeUHiz","Invitae":"_3PP1SkkOxfPatKaNV8t_qY","JWE":"jrLWpwaNh_a_rVaN0lA0d"};

/***/ }),

/***/ "9W4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_data_skybox__ = __webpack_require__("Bn3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_js__ = __webpack_require__("jly4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_Invoices_tabs__ = __webpack_require__("Q++R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_legacy_auth_users__ = __webpack_require__("dl2l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_Invoices_actions_cancel__ = __webpack_require__("pV7Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_Invoices_actions_edit_invoice__ = __webpack_require__("UwY+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_Invoices_statuses__ = __webpack_require__("nBkH");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import EditInvoice from '@/components/_modules/Invoices/actions/edit'
// import ExportInvoice from '@/components/_modules/Invoices/actions/export'



var additionalFilters = __WEBPACK_IMPORTED_MODULE_9__components_modules_Invoices_statuses__["k" /* default */].additionalFilters,
  filters = __WEBPACK_IMPORTED_MODULE_9__components_modules_Invoices_statuses__["k" /* default */].filters,
  isActiveFilter = __WEBPACK_IMPORTED_MODULE_9__components_modules_Invoices_statuses__["k" /* default */].isActiveFilter;
var defaultFilter = [];
var cancelTooltip = 'Please select an invoice.';
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DataSkybox: __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_data_skybox__["a" /* default */],
    Grid: __WEBPACK_IMPORTED_MODULE_3__components_Grid__["a" /* default */],
    // EditInvoice,
    // ExportInvoice,
    CancelInvoice: __WEBPACK_IMPORTED_MODULE_7__components_modules_Invoices_actions_cancel__["a" /* default */],
    EditInvoiceForSupplier: __WEBPACK_IMPORTED_MODULE_8__components_modules_Invoices_actions_edit_invoice__["a" /* default */]
  },
  data: function data() {
    return {
      additionalFilters: additionalFilters,
      defaultFilter: this.$route.query.filter ? filters(this.$route.query.filter.split(',')) : filters(defaultFilter),
      statuses: __WEBPACK_IMPORTED_MODULE_9__components_modules_Invoices_statuses__["m" /* metaStatuses */],
      model: __WEBPACK_IMPORTED_MODULE_4__model_js__["a" /* default */],
      tabs: __WEBPACK_IMPORTED_MODULE_5__components_modules_Invoices_tabs__["a" /* default */].tabs,
      rowClasses: {
        'negative-amount': function negativeAmount(params) {
          return (params.data || {}).TotalAmount < 0;
        }
      },
      selectedRows: [],
      selectedAll: null,
      asyncCancelInvoiceDisabledReason: cancelTooltip
    };
  },
  watch: {
    '$route.query.filter': function $routeQueryFilter(value, oldValue) {
      if (value && value !== oldValue) {
        this.$refs.grid.gridOptions.api.setFilterModel(null);
        this.defaultFilter = filters(value.split(','), {}, this.$route.query.filter && this.$route.query.filter.split(','));
        this.$refs.grid.gridOptions.api.setFilterModel(this.defaultFilter);
      }
    }
  },
  computed: {
    cancelInvoiceDisabled: function cancelInvoiceDisabled() {
      return !!this.cancelInvoiceDisabledReason;
    },
    cancelInvoiceDisabledReason: function cancelInvoiceDisabledReason() {
      if (this.selectedRows.length > 1) {
        return 'You can only cancel one invoice at a time.';
      }
      if (this.selectedRows.length === 0) {
        return cancelTooltip;
      }

      // if (isCancelled(this.selectedRows)) {
      //   return 'The selected invoice is already cancelled.'
      // }
      return this.asyncCancelInvoiceDisabledReason;
    },
    selectedId: function selectedId() {
      return this.selectedRows && this.selectedRows[0] && this.selectedRows[0].data && this.selectedRows[0].data.PaymentInvoiceID;
    }
  },
  methods: {
    rowSelected: function rowSelected(event) {
      if (typeof event === 'boolean') {
        this.selectedAll = event;
      } else {
        this.selectedRows = event;
        this.fetchCancelReason();
      }
    },
    refresh: function refresh() {
      this.$refs.grid.refreshGrid();
    },
    handleStatusFilter: function handleStatusFilter(status) {
      this.$router.push({
        query: {
          filter: undefined
        }
      });
      this.$refs.grid.gridOptions.api.setFilterModel(filters([status], this.$route.query.filter ? {} : this.$refs.grid.gridOptions.api.getFilterModel()));
    },
    statusActive: function statusActive(status) {
      if (!this.$refs.grid) return {};
      return isActiveFilter(status, this.$refs.grid.gridOptions.api.getFilterModel(), this.$route.query.filter && this.$route.query.filter.split(','));
    },
    fetchCancelReason: function fetchCancelReason() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var tooltip, reason;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.selectedRows.length || _this.selectedRows.length > 1)) {
                _context.next = 3;
                break;
              }
              _this.asyncCancelInvoiceDisabledReason = cancelTooltip;
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return _this.api.forms.post(_this.api.$.invoice.list.canCancelInvoice, {
                id: _this.selectedId
              });
            case 5:
              tooltip = _context.sent;
              reason = __WEBPACK_IMPORTED_MODULE_9__components_modules_Invoices_statuses__["i" /* cannotCancelReasons */][tooltip.data.SuccessMessage];
              _this.asyncCancelInvoiceDisabledReason = reason || '';
              return _context.abrupt("return", reason);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    redirectToList: function redirectToList() {
      if (__WEBPACK_IMPORTED_MODULE_6__core_legacy_auth_users__["a" /* default */].type.BS) {
        this.$router.replace('/i/Programs/Invoice-received/?goto=PaymentInvoice%2FSentInvoiceList');
      }
    }
  },
  activated: function activated() {
    this.redirectToList();
  },
  created: function created() {
    this.redirectToList();
  }
});

/***/ }),

/***/ "9ZZd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-card-overlay"},[_c('p',[_vm._v("This card will be deleted.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9cNB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("mWEp");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303d32ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("v84C");
function injectStyle (ssrContext) {
  __webpack_require__("q3WB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-303d32ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303d32ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9cRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("title")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9fEx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-wrapper shadowBox",class:{ seen: _vm.onScrollIntoView() }},[_c('div',{staticClass:"widget-header"},[_c('span',{staticClass:"widget-title"},[_vm._v(_vm._s(_vm.value.label || _vm.settings.title || _vm.title))]),_c('span',{staticClass:"widget-action-icons"},[_c('div',{staticClass:"widget-filters"},[(_vm.value.dateRangeFilter.active && !_vm.isCollapsed)?_c('ed-datepicker',{ref:"datepick",staticClass:"widget-filters inline padded marginReset no-drag",attrs:{"range":"","compact":"","confirm":"Apply","hidden":""},on:{"input":function($event){return _vm.updateDateFilter(_vm.value, $event)},"inputRange":function($event){return _vm.updateDateFilter(_vm.value, $event)},"confirm":function($event){return _vm.applyDateRangeFilter(_vm.value)},"toggle-popup":function($event){return _vm.toggleDateFilter(_vm.value)},"close-popup":function($event){return _vm.closeDateFilter(_vm.value)},"click":_vm.bringWidgetToFront},model:{value:(_vm.value._dateFilter),callback:function ($$v) {_vm.$set(_vm.value, "_dateFilter", $$v)},expression:"value._dateFilter"}}):_vm._e()],1),_c('span',{staticClass:"pull-right"},[_c('WidgetSettingsMenu',{attrs:{"widget":_vm.value,"options":_vm.settings},on:{"toggleCollapse":_vm.toggleCollapse,"set":_vm.set}})],1)])]),(_vm.reqDraw)?_c('div',[_c('div',{ref:"widgetContent",staticClass:"widget-body no-drag",class:{ 'hidden': _vm.isCollapsed }},[_vm._t("content")],2)]):_vm._e(),(_vm.hasFooter && !_vm.isCollapsed)?_c('div',{staticClass:"widget-footer"},[_c('div',{staticClass:"bottom-buttons"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9fMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  notImplemented: true
});

/***/ }),

/***/ "9hMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reject_all_vue__ = __webpack_require__("c16a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc29f860_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reject_all_vue__ = __webpack_require__("YYHp");
function injectStyle (ssrContext) {
  __webpack_require__("K7FF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reject_all_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc29f860_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reject_all_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9mTN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CompanySettings: {
    AllocateCategories: '',
    IsRequiredCategRefID: '',
    AllocateVAT: '',
    DaysNo: 0,
    DisplayBudgetStep: '',
    OverrideSupplierPaymentTerms: '',
    RequireAttachment: '',
    HasCostCenter: '',
    HasBusinessUnit: '',
    UseBusinessUnitAndCostCenterMapping: ''
  }
});

/***/ }),

/***/ "9p7v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hide),expression:"!hide"}],staticClass:"md-notification col-xs-11 col-sm-3 alert open",class:[_vm.placement.from, _vm.placement.align, ("alert-" + _vm.type), _vm.withIcon, _vm.position ? "small" : ""],style:(_vm.position || _vm.customPosition),attrs:{"data-notify":"container","role":"alert","data-notify-position":"top-center"}},[(_vm.allowDismiss)?_c('button',{staticClass:"close",attrs:{"type":"button","aria-hidden":"true","data-notify":"dismiss"},on:{"click":_vm.close}},[_c('i',{staticClass:"fal fa-times"})]):_vm._e(),(!!_vm.icon)?_c('i',{staticClass:"fas alert-icon",class:"fa-" + _vm.icon}):_vm._e(),(!!_vm.heading)?_c('span',{attrs:{"data-notify":"title"}},[_c('strong',[_vm._v(_vm._s(_vm.heading))]),_c('br'),_c('br')]):_vm._e(),_vm._t("message",function(){return [(!!_vm.message)?_c('span',{attrs:{"data-notify":"message"},domProps:{"innerHTML":_vm._s(_vm.$t(_vm.message))}}):_vm._e(),(!!_vm.dismiss)?_c('span',[_c('br')]):_vm._e(),(_vm.target !== "_blank" && _vm.goto)?_c('ed-button',{staticClass:"btn def",attrs:{"buttonClass":"btn-actionbar","href":_vm.goto || "#"},on:{"click":function($event){return _vm.close("")}}},[_vm._v(_vm._s(_vm.$t('Save a draft first')))]):_vm._e(),(!!_vm.dismiss)?_c('ed-button',{staticClass:"btn",attrs:{"buttonClass":"btn-actionbar","href":_vm.goto === null ? "#" + _vm.$route.fullPath : _vm.goto || "#"},on:{"click":function($event){$event.preventDefault();return _vm.close(_vm.dismiss)}}},[_vm._v(_vm._s(_vm.$t(_vm.dismiss)))]):_vm._e(),(_vm.goto === null || _vm.goto === "")?_c('ed-button',{staticClass:"btn danger",attrs:{"buttonClass":"btn-actionbar","href":_vm.goto === null ? "#" + _vm.$route.fullPath : _vm.goto === "" ? undefined : _vm.goto || "#"},on:{"click":function($event){return _vm.close(null)}}},[_vm._v(_vm._s(_vm.$t(_vm.discard)))]):_vm._e()]}),(_vm.progressbar)?_c('div',{staticClass:"progress",attrs:{"data-notify":"progressbar"}},[_c('div',{staticClass:"progress-bar `progress-bar-${type}`",staticStyle:{"width":"0%"},attrs:{"role":"progressbar","aria-valuenow":"0","aria-valuemin":"0","aria-valuemax":"100"}})]):_vm._e(),(!!_vm.url)?_c('a',{attrs:{"href":"url","target":"target","data-notify":"url"}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9ta/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_readOnlyError__ = __webpack_require__("KyYW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_readOnlyError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_readOnlyError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__I2P_components_TheToolbar__ = __webpack_require__("u9q6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);





function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { Eved, EventBus } from '@/event-bus'


var Supplier = {
  //
};
var FIELD_TYPES = {
  number: 'ed-input',
  textarea: 'ed-textarea',
  text: 'ed-input',
  email: 'ed-input',
  select: 'ed-select',
  date: 'ed-datepicker',
  file: 'ed-upload'
};
var opIn = function opIn(value, collection) {
  return !!~collection.indexOf(value);
};
var opNotIn = function opNotIn() {
  return !opIn.apply(void 0, arguments);
};
var operators = {
  'IN': opIn,
  'NOT IN': opNotIn
};
var fieldMapper = function fieldMapper(field) {
  return _objectSpread(_objectSpread({}, field.constructor.name === 'Object' ? field : {}), {}, {
    type: FIELD_TYPES[field.type] || field.type || FIELD_TYPES['text'],
    nativeType: field.type === 'number' ? 'text' : field.type || 'text',
    key: field.name || field.key || (field.label || field).replace && (field.label || field).replace(/ /g, ''),
    label: getLabel(field.label || field),
    required: field.required || (field.validation || {}).required,
    dependency: (field.validation || {}).dependencies[0],
    integer: field.type === 'number',
    multiple: field.multiple,
    // serverSearch: field.serverSearch,
    serverOptions: field.multiple && field.type === 'select' && (field.dataSource || {}).url
  });
};
var getLabel = function getLabel(label) {
  var labels = global.app.$user.sessionSettings.CompanySettings.Labels;
  var tokens = label.match(/\{\{\w+\}\}/g);
  var r = label;
  tokens && tokens.forEach(function (token) {
    var label = token.replace('{{', '').replace('}}', '');
    r = r.replace(token, labels[label]);
  });
  return r;
};
var fieldsWithPreselectedValues = ['AssignedDivisions'];
var additionalFields = [
  //
];

// const prevalidateFields = [
//   'Email'
// ]

var TEMPLATE_FIELD = 'templateName';
var validEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddSupplier',
  components: {
    toolbar: __WEBPACK_IMPORTED_MODULE_5__I2P_components_TheToolbar__["a" /* default */]
  },
  created: function created() {
    this.getCustomFields();
    // this.getPaymentTerms()
    this.Supplier = this.invite[0];
  },
  mounted: function mounted() {
    //
  },
  beforeLeave: function beforeLeave() {
    return this.check();
  },
  data: function data() {
    var _this = this;
    return {
      FIELD_TYPES: FIELD_TYPES,
      //
      headers: {
        'Authorization': "Bearer ".concat(this.$user.sessionSettings.Token)
      },
      submitAction: '',
      canSubmit: true,
      invite: [utils.copy(Supplier)],
      options: {},
      Supplier: null,
      sentInvite: false,
      showCancelBtn: false,
      customFields: [],
      counter: 0,
      loading: false,
      lastUpdatedKey: '',
      hash: function hash(field) {
        var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.invite[0];
        var hash = field.key + /* this.options.length + */field.validation.dependencies.map(function (d) {
          return (form[d.name] || {}).text;
        }).join('-') + _this.counter;
        // field.hash = field.hash || hash
        return hash;
      },
      shouldBeVisible: function shouldBeVisible(field) {
        var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.invite[0];
        var dependencies = !!field.validation.dependencies.length;
        field.validation.unresolvedDependencies = [];
        return !dependencies || field.validation.dependencies.some(function (dependency) {
          var dependsOn = form[dependency.name];
          var dependsOnValue = (dependsOn || {}).text;
          var collection = dependency.values;
          var resolved = operators[dependency.operator](dependsOnValue, collection) || !collection.length;
          if (resolved) {
            field.validation.unresolvedDependencies.push(dependency.name);
          }
          return dependsOnValue && resolved;
        });
      },
      shouldShowInfo: function shouldShowInfo(field) {
        var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.invite[0];
        if (_this.loading) return false;
        var info = '';
        if (field.type === FIELD_TYPES.file) {
          var dependsOn = field.validation.unresolvedDependencies[0];
          var dependsOnLabel = (_this.mapFields.find(function (customField) {
            return customField.name === dependsOn;
          }) || {}).label;
          var dependsOnValue = dependsOn && (form[dependsOn] || {}).text;
          info = !dependsOnValue && {
            label: dependsOnLabel,
            meta: dependsOn === (field.validation.dependencies[0] || {}).name ? 'first' : ''
          };
        }
        return info;
      },
      validationMessage: function validationMessage(field) {
        return _this.$v.Supplier[field.key] && _this.$v.Supplier[field.key].$error ? field.description || "Please fill in ".concat(_this.$v.Supplier[field.key].validationRule === false && _this.$v.Supplier[field.key].$model ? 'a valid' : 'the', " ").concat(field.label) : field.description;
      }
    };
  },
  validations: function validations() {
    return {
      Supplier: _objectSpread({}, this.validationRules)
    };
  },
  computed: {
    mapFields: function mapFields() {
      return this.customFields.map(fieldMapper);
    },
    validationRules: function validationRules() {
      var _this2 = this;
      var validations = {};
      this.mapFields.forEach(function (field) {
        validations[field.key] = field.required ? {
          isValid: function isValid(v) {
            return !_this2.shouldBeVisible(field) ? true : field.nativeType === 'email' ? Object(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"])(v) && validEmail.test(String(v)) : Object(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"])(v);
          }
        } : {
          isValid: function isValid(v) {
            return !_this2.shouldBeVisible(field) ? true : field.nativeType === 'email' ? typeof v !== 'undefined' && validEmail.test(String(v)) : true;
          }
        };
      });
      return validations;
    }
  },
  methods: {
    send: function send() {
      var _this3 = this;
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log(this.mapToSend(this.invite[0]));
        return;
      }
      this.api.post(this.submitAction, this.mapToSend(this.invite[0])).then(function (r) {
        _this3.counter++;
        _this3.showConfirmation();
        _this3.cancel();
        _this3.prefillCustomFields(_this3.formFields);
      }).catch(function (e) {
        _this3.showError(e.response);
      });
    },
    preSend: function preSend(field) {
      var _this4 = this;
      var fieldEl = document.querySelector("[data-field=".concat(field));

      // if (!~prevalidateFields.indexOf(field)) {
      //   return
      // }

      fieldEl.classList.add('loading');
      this.api.post(this.submitAction, this.mapToSend(this.invite[0])).then(function (r) {
        fieldEl.classList.remove('loading');
      }).catch(function (e) {
        fieldEl.classList.remove('loading');
        _this4.showError(e.response);
      });
    },
    meta: function meta(field, index) {
      var hasTemplateField = this.customFields.find(function (f) {
        return f.name === TEMPLATE_FIELD;
      });
      if (field !== TEMPLATE_FIELD && hasTemplateField && !this.Supplier[TEMPLATE_FIELD]) {
        this.canSubmit = false;
        return {
          disabled: true,
          class: 'dim disabled'
        };
      } else {
        if (this.Supplier[TEMPLATE_FIELD]) {
          this.canSubmit = true;
        }
      }
    },
    showConfirmation: function showConfirmation() {
      this.invite[0].Email && this.$notifications.notify({
        message: "An invitation has been sent to ".concat(this.invite[0].SupplierName || '', " (").concat(this.invite[0].Email, ")"),
        type: 'info',
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    },
    showError: function showError(r) {
      this.invite[0].Email && r.data.error && r.data.error.name === 'ValidationError' && this.$notifications.notify({
        timeout: 10000,
        message: r.data.error.message,
        type: 'info-warn',
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    },
    addMore: function addMore() {
      this.showCancelBtn = this.emptyInvite();
      this.invite.push(Supplier);
    },
    cancel: function cancel() {
      // this.invite = [ utils.copy(Supplier) ]
      this.emptySupplier(this.invite[0]);
      document.querySelector('.main-panel').scrollTo(0, 0);
      this.$v.$reset();
    },
    emptySupplier: function emptySupplier(obj) {
      var fields = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(this.mapFields), additionalFields);
      fields.forEach(function (field) {
        if (field.key) {
          obj[field.key] = null;
        }
      });
      obj.MeetingDate = null;
    },
    validate: function validate() {
      //
    },
    check: function check() {
      return this.invite.filter(this.validateSupplier).length || this.emptyInvite() || this.sentInvite;
    },
    emptyInvite: function emptyInvite() {
      return this.invite.length === 1 && !this.invite[0].supplier && !this.invite[0].fullName && !this.invite[0].email;
    },
    validateSupplier: function validateSupplier(supplier) {
      return supplier.supplier && supplier.fullName && supplier.email;
    },
    getCustomFields: function getCustomFields(templateName) {
      var _this5 = this;
      templateName = templateName || '';
      var params = templateName !== '' ? {
        params: {
          templateName: templateName
        }
      } : {};
      this.api.get(this.api.$.supplier.customFields, params).then(function (r) {
        if (r.data && r.data.form) {
          _this5.submitAction = r.data.form.action;
          _this5.customFields = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(r.data.form.fieldsets[0].fields), additionalFields);

          //
          _this5.formFields = r.data.form.fieldsets[0].fields;
          _this5.prefillCustomFields(_this5.formFields);
        }
      });
    },
    prefillCustomFields: function prefillCustomFields(fields) {
      var _this6 = this;
      fields.map(function (field) {
        if (field.values.length) {
          if (field.type === 'select') {
            if (field.name !== TEMPLATE_FIELD) {
              _this6.invite[0][field.name] = {
                value: 0,
                text: field.values[0]
              };
            }
          } else {
            _this6.invite[0][field.name] = field.values[0];
          }
        }
      });
    },
    fetchOptions: function fetchOptions(field, i) {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee() {
        var options;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this7.options[field.key] && _this7.options[field.key].length && !field.dataSource.queryParameters.length // &&
              // !field.serverSearch
              )) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return _this7.api.get(field.dataSource.url + '?' + _this7.query(field, _this7.invite[0], i));
            case 4:
              options = _context.sent;
              options && options.data ? _this7.options[field.key] = options.data : void 0;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    update: function update(field) {
      if (this.options[field.key]) {
        // console.log('creating', field.key)
      }
    },
    selectOption: function selectOption(field) {
      var isServerOptions = field.serverOptions;
      var shouldRefreshFields = !isServerOptions;
      if (shouldRefreshFields) {
        this.counter++;
      }
      this.clearDependencies(field);
    },
    clearDependencies: function clearDependencies(field) {
      var _this8 = this;
      var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.invite[0];
      this.lastUpdatedKey = field.name;
      if (this.lastUpdatedKey === TEMPLATE_FIELD) {
        this.$nextTick(function () {
          _this8.getCustomFields(_this8.Supplier[TEMPLATE_FIELD].value);
        });
      }
      if (field.type === FIELD_TYPES.select) {
        Object.keys(form).forEach(function (f) {
          var customField = _this8.customFields.find(function (f) {
            return ~f.dataSource.queryParameters.indexOf(field.name);
          });
          if (customField) {
            form[customField.name] = null;
            delete form[customField.name];
          }
        });
      }
    },
    beforeCreateField: function beforeCreateField(field, force) {
      var _this9 = this;
      if (!field.serverSearch && force === undefined && (!this.shouldBeVisible(field) || field.dataSource.url === '')) return;

      // File fields
      if (field.type === FIELD_TYPES.file || field.type === 'file') {
        this.api.get(field.dataSource.url + '?' + this.query(field, this.invite[0])).then(function (options) {
          if (options && options.data) {
            _this9.invite[0][field.name] = _this9.mapAttachments(options.data);
            _this9.options[field.key] = options.data;
          }
          if (force) {
            _this9.$forceUpdate();
          }
        });
      }
      if (field.integer) {
        if (this.lastUpdatedKey === TEMPLATE_FIELD || !this.Supplier[TEMPLATE_FIELD]) {
          this.loading = true;
          this.api.get(field.dataSource.url + '?' + this.query(field, this.invite[0])).then(function (options) {
            if (options && typeof options.data !== 'undefined') {
              _this9.$set(_this9.Supplier, field.key, options.data);
            }
            _this9.loading = false;
          });
        }
      }
      if (field.serverOptions && fieldsWithPreselectedValues.indexOf(field.key) > -1) {
        if (this.lastUpdatedKey === TEMPLATE_FIELD || !this.Supplier[TEMPLATE_FIELD]) {
          this.loading = true;
          this.$loading = true;
          this.api.get(field.dataSource.url + '?' + this.query(field, this.invite[0])).then(function (options) {
            if (options && typeof options.data !== 'undefined') {
              _this9.$set(_this9.Supplier, field.key, options.data);
              _this9.options[field.key] = options.data;
            }
            _this9.loading = false;
            _this9.$loading = false;
          });
        }
      }
    },
    query: function query(field, form) {
      var q = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var query = '';
      if (field.serverSearch) {
        query += "q=".concat(q);
      }
      field.dataSource.queryParameters.map(function (param) {
        var value = (form[param] || {}).text || form[param];
        query += value ? "&".concat(param, "=").concat(encodeURIComponent(value)) : '';
      });
      return query;
    },
    fieldOptions: function fieldOptions(field) {
      // console.log('rendering options for', field.key)
      if (!this.shouldBeVisible(field)) return [];
      if (this.options[field.key]) return field.options || this.options[field.key] || [];

      // this.options[field.key] ||
      this.$set(this.options, field.key, []);

      // File fields
      if (field.type === FIELD_TYPES.file) {
        this.$set(this.Supplier, field.key, []);
      }
    },
    multiple: function multiple(field) {
      return field.multiple;
    },
    mapAttachments: function mapAttachments(files) {
      var attachments = [];
      for (var f in files) {
        if (files.hasOwnProperty(f)) {
          var entry = files[f];
          attachments.push({
            fileObject: true,
            id: entry.id,
            name: entry.name,
            file: entry.file,
            path: entry.path,
            type: entry.type,
            size: entry.size * 1024,
            success: true,
            readonly: true
          });
        }
      }
      return attachments;
    },
    mapToSend: function mapToSend(o) {
      var _this10 = this;
      var output = [];
      Object.keys(o).forEach(function (k) {
        var customField = _this10.customFields.find(function (field) {
          return field.name === k;
        }) || {};
        output.push({
          name: k,
          multiple: customField.multiple,
          type: customField.type,
          values: o[k] && o[k] !== 'undefined' ? o[k].map ? o[k].map(function (k) {
            return multiselectOrFiles(k, customField);
          }) : [o[k].text || o[k]] : []
        });
      });
      return output;
      function fileId(file) {
        // upload endpoint returns application/json, so the upload component already
        // parsed file.response into an object; only JSON.parse when it's still a string
        var response = file.response;
        if (typeof response === 'string') {
          try {
            response = JSON.parse(response);
          } catch (e) {
            response = {};
          }
        }
        return response && response.id || file.id;
      }
      function multiselectOrFiles(k, field) {
        var isFilesField = field.type === 'file';
        if (isFilesField) {
          return fileId(k);
        } else {
          return k.value;
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("RMJP")))

/***/ }),

/***/ "9twA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-filter"},[(!_vm.params.editMode)?_c('p',{staticClass:"column-title"},[_vm._v(_vm._s(_vm.columnTitle))]):_vm._e(),_c('ed-input',{ref:'input',attrs:{"placeholder":_vm.t("Search"),"xautofocus":"","search":""},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_c('ul',{staticClass:"list",class:{ "edit": _vm.params.editMode },attrs:{"endpoint":_vm.api.$.common.optionsFilter}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_c('ed-checkbox',{attrs:{"options":_vm.filteredOptions},on:{"click":_vm.click}})],1),(!_vm.params.editMode)?_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.apply}},[_vm._v(_vm._s(_vm.t("Apply")))]):_vm._e(),_vm._v(" \n "),(!_vm.params.editMode)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.clear.apply(null, arguments)}}},[_c('u',[_vm._v(_vm._s(_vm.t("clear filter")))])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9unJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A1we":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_39jeH9gYo0vxzrE-QTHRnM","Dell":"U4F1rhxFNh0z3S9JDMZ7K","Abbott":"_1ZrrmjYhdJVW6lsRq9jmq1","Gap":"_1HlzGfvAjpbJCuGetmFyFF","Allstate":"_1EsX609WE52P1Io0urBWTX","Asurion":"_3ZC9GkIDDlu6SZV5Ns83q_","Invitae":"_2BXtbAhEOIBxnCEoWVLkEc","JWE":"_1L5EQbwxa-GOm82hWKSXFa"};

/***/ }),

/***/ "AAet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("tfQj");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32904a53_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("CQuN");
function injectStyle (ssrContext) {
  __webpack_require__("fOEW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32904a53"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32904a53_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AD2D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-button',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    disabled: Boolean,
    href: String,
    to: String,
    buttonClass: {
      type: String,
      default: 'btn btn-primary'
    }
  }
});

/***/ }),

/***/ "AHE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_components_edTabNav_edTab_vue__ = __webpack_require__("DGG8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules__ = __webpack_require__("vZ0M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */
/* eslint no-unused-vars : 0 */
/* eslint key-spacing    : 0 */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-tab-nav',
  components: {
    'ed-tab': __WEBPACK_IMPORTED_MODULE_0__core_components_edTabNav_edTab_vue__["default"]
  },
  props: {
    workflow: {
      type: Boolean,
      default: false
    },
    wide: {
      type: Boolean,
      default: false
    },
    steps: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    activeTab: Object,
    callback: Function,
    bottomTabs: Boolean
  },
  data: function data() {
    return {
      tabs: [],
      lastTabIdx: {},
      tabClass: function tabClass(tab) {
        return {
          'is-active text-color line-color': tab.isActive,
          'is-completed text-color line-color': tab.isCompleted || this.steps,
          'optional': tab.optional,
          'valid': tab.valid
        };
      }
    };
  },
  computed: {
    //
    tabList: function tabList() {
      return this.options || this.tabs;
    }
  },
  created: function created() {
    if (!this.options.length) {
      this.tabs = this.$children;
    }
    this.legacy = true || __WEBPACK_IMPORTED_MODULE_1__components_modules__["a" /* default */][this.$route.params.page] && __WEBPACK_IMPORTED_MODULE_1__components_modules__["a" /* default */][this.$route.params.page].notImplemented;
  },
  mounted: function mounted() {
    // go to active tab
    // this.goToTab()
    this.goToActiveTab();
  },
  updated: function updated() {
    //
    this.updateLegacyTabs();
  },
  methods: {
    clickTab: function clickTab(tab) {
      if (typeof this.activeTab.isValid === 'boolean') {
        if (this.activeTab.isValid) {
          this.callback(tab, true);
        } else {
          this.lastTabIdx = this.options.indexOf(tab);
          this.callback(tab, true);
        }
      }
      if (typeof this.activeTab.isValid === 'function') {
        if (this.activeTab.isValid()) {
          this.callback(tab, true);
        } else {
          this.lastTabIdx = this.options.indexOf(tab);
        }
      }
      console.log('end');
    },
    goToTab: function goToTab() {
      var _this = this;
      var tabHash = this.$route.hash;
      this.tabs.forEach(function (tab) {
        return tab.section === tabHash && _this.selectTab(tab);
      });
    },
    selectTab: function selectTab(activeTab, previous) {
      var _this2 = this;
      var vm = this;
      var allowRouteChange = false;

      // reference to previously selected tab
      var previouslySelectedTab = this.getActiveTab();
      var prev = previous || previouslySelectedTab;
      var endpoint = prev && prev.$el.querySelector('form') && prev.$el.querySelector('form').getAttribute('no-submit') === null && prev.$el.querySelector('form').getAttribute('endpoint');
      var tabToActivate = null;
      this.tabs.forEach(function (tab, i) {
        var prevTab = i === 0 ? vm.tabs[0] : vm.tabs[i - 1];
        var prevTabValid = i === 0 || prevTab.$el.querySelector('form') && prevTab.$el.querySelector('form').checkValidity() || prevTab.optional && !prevTab.$attrs.errors;
        var tabValid = prev && prev.$el.querySelector('form') && prev.$el.querySelector('form').checkValidity();
        var noErrors = activeTab.optional && !activeTab.$attrs.errors;
        var check = _this2.$attrs.check;
        if ((!_this2.$attrs.steps || check) && activeTab && activeTab.href === tab.href) {
          //
          // select tab
          // if previous tab is valid
          if (prevTabValid && !noErrors) {
            tabToActivate = tab;
            allowRouteChange = true;
          }

          // skip tab
          // if tab is optional and has no errors
          if (noErrors && tabValid) {
            var nextTab = vm.tabs[i + 1];
            nextTab.valid = true;
            vm.selectTab(nextTab, previouslySelectedTab);
            return;
          }
        } else {
          tab.isActive = false;
        }
      });
      if (tabToActivate && vm.findPrevTab()) {
        if (tabToActivate.section === vm.findPrevTab().section) {
          vm.findPrevTab().valid && activateTab();
        }
        // return
      }
      if (endpoint && (!previouslySelectedTab || previouslySelectedTab.section !== activeTab.section) && (previouslySelectedTab && activeTab.optional || !activeTab.optional)) {
        // let requestPayload = previouslySelectedTab && previouslySelectedTab.$attrs.payload
        var requestPayload = prev.$attrs.payload;
        var requestPayloadType = prev.$attrs.payloadType;
        if (requestPayload) {
          requestPayload = {
            map: requestPayloadType === 'json' ? requestPayload : JSON.stringify(requestPayload),
            filePath: vm.$el.getAttribute('file-id'),
            userId: vm.$user.$.user.UserID,
            vendorId: vm.$user.$.data.VendorID,
            vci: vm.$user.$.user.VCI
          };
        }

        // !previouslySelectedTab && vm.api.post(endpoint, requestPayload)
        (tabToActivate && tabToActivate.optional || vm.findPrevTab(tabToActivate) && vm.findPrevTab(tabToActivate).optional || vm.findPrevTab(tabToActivate) && typeof vm.findPrevTab(tabToActivate).$attrs.additional !== 'undefined') && vm.api.post(endpoint, requestPayload).then(activateTab).catch(function (e) {
          return console.warn(e, 'Server error');
        });
      } else {
        activateTab();
      }
      function activateTab(response) {
        if (activeTab && allowRouteChange) {
          var errorsTab = vm.findPrevTab(tabToActivate);

          // inject feedback response
          vm.$emit('tabSelected', {
            response: response,
            from: prev
          });
          vm.$nextTick(function () {
            var errors = errorsTab && errorsTab.optional && errorsTab.$attrs.errors;
            var _tabToActivate = /* response && !response.data ? vm.findNextTab(tabToActivate) : */tabToActivate;
            var _activeTab = /* response && !response.data ? vm.findNextTab(activeTab) : */activeTab;
            if (errors) {
              _tabToActivate = errorsTab;
              _activeTab = errorsTab;
              tabToActivate.valid = false;
            }

            // activate tab
            _tabToActivate.isActive = true;
            // _tabToActivate.valid = true

            // change route
            vm.$router.push({
              hash: _activeTab.section
            });

            // emit event
            vm.$emit('tabSelected', {
              from: prev,
              to: _activeTab
            });
          });
        }
      }
    },
    goToNextTab: function goToNextTab() {
      var vm = this;
      var nextTabIndex = null;
      this.tabs.forEach(function (tab, i) {
        if (tab.isActive && i < vm.tabs.length - 1) {
          // tab.isActive = false
          nextTabIndex = i + 1;
          return false;
        }
      });
      nextTabIndex && vm.selectTab(vm.tabs[nextTabIndex]);
    },
    findNextTab: function findNextTab(ofTab) {
      var vm = this;
      var nextTabIndex = null;
      this.tabs.forEach(function (tab, i) {
        if (ofTab && ofTab.section === tab.section && i > 0) {
          nextTabIndex = i + 1;
          return false;
        } else if (tab.isActive) {
          nextTabIndex = i + 1;
        }
      });
      return nextTabIndex && vm.tabs[nextTabIndex];
    },
    findPrevTab: function findPrevTab(ofTab) {
      var _this3 = this;
      var vm = this;
      var prevTabIndex = null;
      this.tabs.forEach(function (tab, i) {
        if (ofTab && ofTab.section === tab.section && i > 0) {
          prevTabIndex = i - 1;
          return false;
        } else if (tab.href === '#' + _this3.$route.fullPath) {
          prevTabIndex = i - 1;
        }
      });
      return prevTabIndex !== null && vm.tabs[prevTabIndex];
    },
    reset: function reset() {
      this.tabs.forEach(function (tab) {
        return tab.isActive = false;
      });
      this.selectTab(this.tabs[0]);
      this.$emit('tabSelected');
    },
    goToActiveTab: function goToActiveTab() {
      var _this4 = this;
      if (!this.legacy || !this.$attrs.steps) {
        this.tabs.forEach(function (tab) {
          if (tab.isActive) {
            _this4.$router.replace(tab.section);
            return;
          }
        });
      }
    },
    getActiveTab: function getActiveTab() {
      var activeTab = null;
      if (this.legacy) {
        this.tabs.forEach(function (tab) {
          if (tab.isActive) {
            activeTab = tab;
          }
        });
      }
      return activeTab;
    },
    updateLegacyTabs: function updateLegacyTabs() {
      var _this5 = this;
      var vm = this;
      if (this.legacy) {
        this.tabs.forEach(function (tab, i) {
          var prevTab = i === 0 ? vm.tabs[0] : vm.tabs[i - 1];
          var prevTabValid = i === 0 || prevTab.$el.querySelector('form') && prevTab.$el.querySelector('form').checkValidity();
          var tabValid = i === 0 || tab.$el.querySelector('form') && tab.$el.querySelector('form').checkValidity();
          if (prevTabValid) prevTab.valid = true;
          tab.isActive = tab.href === '#' + _this5.$route.fullPath && (!_this5.$attrs.steps || prevTabValid || prevTab.optional && !prevTab.$attrs.errors);
        });
      }
    }
  }
});

/***/ }),

/***/ "AJog":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("nPXZ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_197f5084_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Zhsm");
function injectStyle (ssrContext) {
  __webpack_require__("FLix")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-197f5084"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_197f5084_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AOcX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e17f9910_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__ = __webpack_require__("9cRi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e17f9910_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AOjR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model__ = __webpack_require__("i+Nj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Grid_cells_actions__ = __webpack_require__("ayPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddEditFundingAddress_vue__ = __webpack_require__("97IH");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_2__components_Grid__["a" /* default */],
    AddEditFundingAddress: __WEBPACK_IMPORTED_MODULE_5__AddEditFundingAddress_vue__["a" /* default */]
  },
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_3__model___default.a,
      actions: [__WEBPACK_IMPORTED_MODULE_4__components_Grid_cells_actions__["c" /* edit */], __WEBPACK_IMPORTED_MODULE_4__components_Grid_cells_actions__["g" /* remove */]],
      showAddEditAddress: false,
      fundingAddressModel: {
        newAddress: {},
        edit: false,
        HasAPSettingsByBU: false
      }
    };
  },
  created: function created() {},
  methods: {
    openAddEditAddress: function openAddEditAddress(item) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var newAddress, divisions, businessUnits, hasAPSettingsByBU, data;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              newAddress = {};
              divisions = [];
              businessUnits = [];
              hasAPSettingsByBU = false;
              _context.next = 6;
              return _this.api.get(_this.api.$.FundingInvoiceAndApSetting.hasAPSettingsByBU).then(function (response) {
                hasAPSettingsByBU = response.data.Data;
              });
            case 6:
              if (!(typeof item !== 'undefined')) {
                _context.next = 19;
                break;
              }
              data = item.data;
              if (!hasAPSettingsByBU) {
                _context.next = 13;
                break;
              }
              _context.next = 11;
              return _this.api.get(_this.api.$.FundingInvoiceAndApSetting.getSelectedBusinessUnits, {
                params: {
                  vendorAddressId: item && item.data && item.data.VendorAddressId || 0
                }
              }).then(function (response) {
                businessUnits = response.data.Data;
              });
            case 11:
              _context.next = 15;
              break;
            case 13:
              _context.next = 15;
              return _this.api.get(_this.api.$.FundingInvoiceAndApSetting.getSelectedDivisions, {
                params: {
                  vendorAddressId: item && item.data && item.data.VendorAddressId || 0
                }
              }).then(function (response) {
                divisions = response.data.Data;
              });
            case 15:
              newAddress = {
                VendorAddressId: data.VendorAddressId,
                FundingEntityName: data.Name,
                EntityLegalName: data.EntityLegalName,
                EIN: data.EIN,
                Address: data.Address,
                Address2: data.Address2,
                Country: {
                  CountryName: data.Country,
                  CountryID: data.CountryId
                },
                City: data.City,
                ZipCode: data.Zip,
                VatId: data.VatNo,
                State: {
                  StateID: data.StateId,
                  StateName: data.StateName
                },
                CanadaState: {
                  StateName: data.StateAndRegion
                },
                Region: data.Region,
                Email: data.Email,
                Divisions: divisions,
                BusinessUnits: businessUnits
              };
              _this.fundingAddressModel.edit = true;
              _context.next = 21;
              break;
            case 19:
              newAddress = {
                VendorAddressId: 0,
                FundingEntityName: '',
                EntityLegalName: '',
                EIN: '',
                Address: '',
                Address2: '',
                Country: {
                  CountryName: '',
                  CountryID: 0
                },
                State: {
                  StateID: 0,
                  StateName: ''
                },
                CanadaState: {
                  StateID: 0,
                  StateName: ''
                },
                Region: '',
                City: '',
                ZipCode: '',
                VatId: '',
                Email: '',
                Divisions: divisions,
                BusinessUnits: businessUnits
              };
              _this.fundingAddressModel.edit = false;
            case 21:
              _this.fundingAddressModel.newAddress = newAddress;
              _this.fundingAddressModel.HasAPSettingsByBU = hasAPSettingsByBU;
              _this.showAddEditAddress = true;
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    removeFundingAddress: function removeFundingAddress(payload, success, fail) {
      var id = +payload.data.VendorAddressId;
      this.api.delete(this.api.$.FundingInvoiceAndApSetting.deleteFundingAddress + '/' + id, id).then(function (r) {
        return success();
      }).catch(function (e) {
        return fail('Something went wrong. Cannot delete the Funding Address');
      });
    },
    removeMultipleFundingAddresses: function removeMultipleFundingAddresses(payload) {
      var _this2 = this;
      var ids = [];
      payload.rows.forEach(function (element) {
        ids.push(element.data.VendorAddressId);
      });
      var param = {
        IDs: ids
      };
      this.api.post(this.api.$.FundingInvoiceAndApSetting.deleteFundingAddresses, param).then(function (r) {
        return _this2.validateDeleteFundingAddresses(r);
      });
    },
    validateDeleteFundingAddresses: function validateDeleteFundingAddresses(r) {
      if (r.data.Errors.length !== 0) {
        alert('Something went wrong. Cannot delete the Funding Addresses.');
      }
      this.refreshTable();
    },
    refreshTable: function refreshTable() {
      this.$refs.FundingAddressesGrid.quickSearch();
      this.$refs.FundingAddressesGrid.onSelectAll(false);
    },
    onSave: function onSave() {
      this.showAddEditAddress = false;
      this.refreshTable();
    }
  }
});

/***/ }),

/***/ "ARJM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav",class:_vm.navClasses},[_c('li',[(_vm.checkLogin)?_c('router-link',{staticClass:"dropdown-toggle",attrs:{"to":"/","data-toggle":"dropdown"}},[_c('i',{staticClass:"fas fa-home"}),_c('p',{staticClass:"hidden-lg hidden-md"},[_vm._v("Dashboard")])]):_vm._e()],1),(_vm.checkLogin)?_c('li',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.closeDropdown),expression:"closeDropdown"}],staticClass:"dropdown",class:{ open : _vm.isDropdownOpened }},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"},on:{"click":function($event){$event.preventDefault();return _vm.openDropdown.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-bell"}),_c('span',{staticClass:"notification"},[_vm._v("98")]),_c('p',{staticClass:"hidden-lg hidden-md"},[_vm._v("Notifications")])]),_vm._m(0)]):_vm._e(),(_vm.checkLogin)?_c('li',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.closeProfileDropdown),expression:"closeProfileDropdown"}],staticClass:"dropdown",class:{ open : _vm.isProfileDropdownOpened }},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"},on:{"click":function($event){$event.preventDefault();return _vm.openProfileDropdown.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-user"}),_c('p',{staticClass:"hidden-lg hidden-md"},[_vm._v("Profile")]),_c('span',[_vm._v(_vm._s(this.$user.email || 'Welcome !'))])]),(_vm.checkLogin)?_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(this.$user.email))])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t('My Profile')))])]),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$t('Logout')))])])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Mike John responded to your email")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("You have 5 new tasks")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("You're now friend with Andrew")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Another Notification")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Another One")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AbMF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendApFile_vue__ = __webpack_require__("pb7G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7941cccb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendApFile_vue__ = __webpack_require__("3haI");
function injectStyle (ssrContext) {
  __webpack_require__("kf6H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7941cccb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendApFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7941cccb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendApFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AfCT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"kcF-2-FUmQiVyB3FkPkc1","Dell":"_194vvTTTlkUhQi0MOg0wWn","Abbott":"_1QhdOMHnVUCWsik3KCKfGi","Gap":"_12rXqqHswBbZNE02Cc07fT","Allstate":"_1uH4J3nG27qORHw8JcS5Cn","Asurion":"_1qzVQ-Ca-QdU_vAX-YFj6G","Invitae":"_24RZgzbRpCbO5T9hriDsY9","JWE":"_2XDnHO400vMYqVjLk-MloG"};

/***/ }),

/***/ "AfI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_Invoices_tabs__ = __webpack_require__("Q++R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LegacyContainer__ = __webpack_require__("jIfZ");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LegacyContainer: __WEBPACK_IMPORTED_MODULE_1__components_LegacyContainer__["a" /* default */]
  },
  data: function data() {
    return {
      tabs: __WEBPACK_IMPORTED_MODULE_0__components_modules_Invoices_tabs__["a" /* default */].tabs
    };
  },
  computed: {
    url: function url() {
      return 'PaymentInvoice/RemitPayment/' + this.$router.currentRoute.params.action;
    }
  }
});

/***/ }),

/***/ "AgGS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_public_vue__ = __webpack_require__("wpZr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bab7a97_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_public_vue__ = __webpack_require__("PFVT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_public_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bab7a97_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_public_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AjDp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_requestPhysicalCard_vue__ = __webpack_require__("x2QA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15738940_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_requestPhysicalCard_vue__ = __webpack_require__("l7FX");
function injectStyle (ssrContext) {
  __webpack_require__("15rp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15738940"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_requestPhysicalCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15738940_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_requestPhysicalCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Apf7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_statuses__ = __webpack_require__("nBkH");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var PendingOrApprovedOrSubmitted = function PendingOrApprovedOrSubmitted(status) {
  return ~[__WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_statuses__["f" /* PENDING */], __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_statuses__["h" /* SUBMITTED */], __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_statuses__["a" /* APPROVED */], __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_statuses__["c" /* OVERDUE */]].indexOf(status);
};
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tooltip: '',
      PAID: __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_statuses__["d" /* PAID */],
      PARTIALLY: __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_statuses__["e" /* PARTIALLY */],
      SUBMITTED: __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_statuses__["h" /* SUBMITTED */]
    };
  },
  computed: {
    statuses: function statuses() {
      var metaStatus = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(new Set(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(this.paymentStatuses)));
      return this.params.data ? metaStatus.some(PendingOrApprovedOrSubmitted) && metaStatus.filter(PendingOrApprovedOrSubmitted) || metaStatus : [];
    },
    paymentStatuses: function paymentStatuses() {
      return this.params.value ? this.params.value.replace(' - ', ' ').split(' ') : [];
    },
    showRejectedTooltip: function showRejectedTooltip() {
      return this.paymentStatuses[0] === __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_statuses__["b" /* DECLINED */] || this.paymentStatuses[1] === __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_statuses__["g" /* REJECTED */];
    }
  },
  methods: {
    fetchTooltip: function fetchTooltip() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var tooltip;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.tooltip) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", _this.tooltip);
            case 2:
              _context.next = 4;
              return _this.api.forms.post(_this.api.$.invoice.rejectReason, {
                PaymentInvoiceID: _this.params.data['PaymentInvoiceID'],
                gridID: _this.params.context.alias
              });
            case 4:
              tooltip = _context.sent;
              _this.tooltip = tooltip.data || '';
              return _context.abrupt("return", tooltip.data);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

/***/ }),

/***/ "AqYs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Ar5I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Arx1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2SruK3_hpSP4BislclFQHP","Dell":"_2K7MK4da8v0zAyOR1_v6bY","Abbott":"_6XV2JmsTqJZYe1C8AcPTR","Gap":"_3D-o1waWlIiEiYzZTV7iUu","Allstate":"_2lQWTAeZhVrh5C4PbyUjwg","Asurion":"_3X5w09Fh86oD5bwJYFpFKq","Invitae":"Fe8TBv9RjnrHUksmAXPAh","JWE":"Mt6I2YDbi04vXf4C42jQ4"};

/***/ }),

/***/ "AtGW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2qN_vI_4VHa2ZfNXNKQ3Le","Dell":"dBupJRh4F1kC6nj77rral","Abbott":"_1dmkKgMbJBg4SUKLukR4ue","Gap":"_2gt_zuoDUTuIbFxYiKAsKo","Allstate":"_30dcfAfw9ly76F4XRoUI8e","Asurion":"_3Oj-E5O26fdJ2EHXXCKS3k","Invitae":"_22genJG5iUGFW4Wu7WhG4v","JWE":"_7CjIjxHizDa4SfrGN60CR"};

/***/ }),

/***/ "B4WM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B6Ul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"title":'Create New ' + _vm.singularize(this.$root.getUser.settings.Labels.DivisionName),"show":_vm.show,"primary-button":"Create","type":"small-medium","validation":""},on:{"close":function($event){return _vm.$emit('close')},"validate":_vm.addDivision,"confirm":_vm.addDivision}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.singularize(this.$root.getUser.settings.Labels.DivisionName))+" Name")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"divisionName","error":_vm.divisionNameIncomplete || _vm.duplicateDivisionNameError,"maxlength":"100"},on:{"input":function (o) { _vm.division.Name = o; _vm.divisionNameIncomplete = false; _vm.duplicateDivisionNameError = false; }},model:{value:(_vm.division.Name),callback:function ($$v) {_vm.$set(_vm.division, "Name", $$v)},expression:"division.Name"}}),_vm._v(" "),(_vm.duplicateDivisionNameError)?_c('div',{staticClass:"error-message"},[_vm._v("\n        A division with this name already exists. Please choose a different name.\n      ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('ed-textarea',{attrs:{"field-label":_vm.singularize(this.$root.getUser.settings.Labels.DivisionName) + ' Description',"rows":4,"error":_vm.descriptionIncomplete,"required":false,"hideOptional":true},on:{"input":function (o) {
          _vm.division.Description = o.length > 1000 ? o.substring(0, 1000) : o;
          _vm.descriptionIncomplete = false;
        }},model:{value:(_vm.division.Description),callback:function ($$v) {_vm.$set(_vm.division, "Description", $$v)},expression:"division.Description"}})],1),_vm._v(" "),_c('p',{staticClass:"label-text"},[_vm._v("Products")]),_vm._v(" "),_c('div',{staticClass:"form-group-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.division.AllowEvedAP),expression:"division.AllowEvedAP"}],attrs:{"type":"checkbox","id":"EvedAP"},domProps:{"checked":Array.isArray(_vm.division.AllowEvedAP)?_vm._i(_vm.division.AllowEvedAP,null)>-1:(_vm.division.AllowEvedAP)},on:{"change":function($event){var $$a=_vm.division.AllowEvedAP,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.division, "AllowEvedAP", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.division, "AllowEvedAP", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.division, "AllowEvedAP", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"small-checkbox",attrs:{"for":"EvedAP"}},[_vm._v("Eved AP")])]),_vm._v(" "),(this.$root.getUser.settings.HasEvedPayCards)?_c('div',{staticClass:"form-group-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.division.AllowEvedPayCards),expression:"division.AllowEvedPayCards"}],attrs:{"type":"checkbox","id":"EvedPayCard"},domProps:{"checked":Array.isArray(_vm.division.AllowEvedPayCards)?_vm._i(_vm.division.AllowEvedPayCards,null)>-1:(_vm.division.AllowEvedPayCards)},on:{"change":function($event){var $$a=_vm.division.AllowEvedPayCards,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.division, "AllowEvedPayCards", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.division, "AllowEvedPayCards", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.division, "AllowEvedPayCards", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"small-checkbox",attrs:{"for":"EvedPayCard"}},[_vm._v("EvedPay Card")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Entity")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"smaller","font-style":"italic"},attrs:{"slot":"additionalText"},slot:"additionalText"},[_vm._v("\n          "+_vm._s(("If the EIN is different for this " + (_vm.singularize(this.$root.getUser.settings.Labels.DivisionName)) + ", please\n          select New\n          Entity and complete the section below"))+"\n        ")]),_vm._v(" "),_c('ed-select',{attrs:{"options":[].concat( _vm.entities ),"label":"Name","name":"entityDropdown","track-by":"Id","error":_vm.entityIncomplete},on:{"input":_vm.handleEntitySelection,"open":_vm.getEntity},model:{value:(_vm.selectEntity),callback:function ($$v) {_vm.selectEntity=$$v},expression:"selectEntity"}})],1)]),_vm._v(" "),_c('div',[_c('p',{staticClass:"bold"},[_vm._v("New Entity Set Up ")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"smaller","font-style":"italic"},attrs:{"slot":"additionalText"},slot:"additionalText"},[_vm._v("\n        Provide the EIN and Bill To address for the new entity\n      ")])]),_vm._v(" "),_c('div',{staticClass:"vertical-line"},[_c('div',{staticClass:"margin-left"},[_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.isNewEntity }},[_c('label',{attrs:{"for":"name"}},[_vm._v("Employer Identification Number (EIN)")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"ein","error":_vm.duplicateEINError || _vm.einIncomplete,"maxlength":"50"},on:{"input":function (o) { _vm.division.EIN = o; }},model:{value:(_vm.division.EIN),callback:function ($$v) {_vm.$set(_vm.division, "EIN", $$v)},expression:"division.EIN"}})],1),_vm._v(" "),(_vm.duplicateEINError)?_c('div',{staticClass:"error-message"},[_vm._v("\n          A EIN with this name already exists. Please choose a different name.\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.isNewEntity }},[_c('ed-select',{attrs:{"field-label":"Country","placeholder":"Select a country...","options":_vm.countries,"label":"CountryName","track-by":"CountryID","openEndpoint":_vm.api.$.profile.getAllCountries,"required":"","name":"country"},on:{"select":function($event){return _vm.countrySelected($event)},"open":_vm.fetchCountriesOnOpen,"keyup":_vm.fetchCountries,"close":_vm.restoreCountries},model:{value:(_vm.formData.country),callback:function ($$v) {_vm.$set(_vm.formData, "country", $$v)},expression:"formData.country"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.isNewEntity }},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"name","error":_vm.nameIncomplete,"placeholder":"Name","maxlength":"40"},on:{"input":function (o) { _vm.mailingAddress.name = o; this$1.nameIncomplete = false; }},model:{value:(_vm.mailingAddress.name),callback:function ($$v) {_vm.$set(_vm.mailingAddress, "name", $$v)},expression:"mailingAddress.name"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.isNewEntity }},[_c('label',{attrs:{"for":"address"}},[_vm._v("Address")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"address","error":_vm.addressIncomplete,"placeholder":"Address","maxlength":"26"},on:{"input":function (o) { _vm.mailingAddress.line1 = o; this$1.addressIncomplete = false; }},model:{value:(_vm.mailingAddress.line1),callback:function ($$v) {_vm.$set(_vm.mailingAddress, "line1", $$v)},expression:"mailingAddress.line1"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.isNewEntity }},[_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","field-label":"Address Line 2","id":"addressLine2","placeholder":"Address Line 2"},on:{"input":function (o) { return _vm.mailingAddress.line2 = o; }},model:{value:(_vm.mailingAddress.line2),callback:function ($$v) {_vm.$set(_vm.mailingAddress, "line2", $$v)},expression:"mailingAddress.line2"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.isNewEntity }},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-item"},[_c('label',{attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"city","error":_vm.cityIncomplete,"placeholder":"City","maxlength":"25"},on:{"input":function (o) { _vm.mailingAddress.city = o; this$1.cityIncomplete = false; }},model:{value:(_vm.mailingAddress.city),callback:function ($$v) {_vm.$set(_vm.mailingAddress, "city", $$v)},expression:"mailingAddress.city"}})],1),_vm._v(" "),_c('div',{staticClass:"input-group-item margin-left"},[(_vm.isUS())?_c('ed-select',{attrs:{"options":_vm.USstates,"label":"StateName","error":_vm.stateIncomplete,"track-by":"StateID","name":"us_states","field-label":"State","required":""},on:{"input":function (o) { _vm.mailingAddress.state = o; this$1.stateIncomplete = false; },"open":_vm.fetchUSStatesOnOpen,"keyup":_vm.fetchUSStates,"close":_vm.restoreUSStates},model:{value:(_vm.formData.state),callback:function ($$v) {_vm.$set(_vm.formData, "state", $$v)},expression:"formData.state"}}):_vm._e(),_vm._v(" "),(_vm.isCanada())?_c('ed-select',{attrs:{"placeholder":"Select a region","options":_vm.canadaStates,"label":"StateName","disabled":_vm.disableControls,"error":_vm.canadaStateIncomplete,"name":"canada_states","field-label":"State/Region","required":""},on:{"input":function (o) { _vm.mailingAddress.canadaState = o; this$1.canadaStateIncomplete = false; },"open":_vm.fetchCanadaStatesOnOpen,"keyup":_vm.fetchCanadaStates,"close":_vm.restoreCanadaStates},model:{value:(_vm.formData.canadaState),callback:function ($$v) {_vm.$set(_vm.formData, "canadaState", $$v)},expression:"formData.canadaState"}}):_vm._e(),_vm._v(" "),(!_vm.formData.country || (!_vm.isCanada() && !_vm.isUS()))?_c('ed-input',{attrs:{"placeholder":"Select a region","disabled":_vm.disableControls,"name":"state_region","field-label":"State/Region","required":""},on:{"input":function (o) { _vm.mailingAddress.region = o; this$1.stateIncomplete = false; }},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"input-group-item margin-left"},[_c('label',{attrs:{"for":"zipCode"}},[_vm._v("Zip Code")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"zipCode","error":_vm.zipCodeIncomplete,"placeholder":"Zip Code"},on:{"input":function (o) { _vm.mailingAddress.zip = o; this$1.zipCodeIncomplete = false; }},model:{value:(_vm.mailingAddress.zip),callback:function ($$v) {_vm.$set(_vm.mailingAddress, "zip", $$v)},expression:"mailingAddress.zip"}})],1)])])])]),_vm._v(" "),(this.$root.getUser.settings.HasEvedPayCards && _vm.division.AllowEvedPayCards)?_c('div',[_c('p',{staticClass:"bold"},[_vm._v("PEX Set Up ")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"smaller","font-style":"italic"},attrs:{"slot":"additionalText"},slot:"additionalText"},[_vm._v("\n        If a new entity is being created, please use this link to...\n      ")]),_vm._v(" "),_c('div',[_c('a',{staticClass:"link-with-icon",attrs:{"href":"https://start.pexcard.com/get-started?partnersOfPex=Eved","target":"_blank"}},[_vm._v("\n          Set Up Entity with PEX\n        ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-share-square custom-icon-color"})])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B8oi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_lang__ = __webpack_require__("pe4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_perfect_scrollbar__ = __webpack_require__("HMpe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['init'],
  beforeCreate: function beforeCreate() {
    this.api = global.app.api;
  },
  data: function data() {
    return {
      options: [],
      test: '',
      formattedList: null,
      text: '',
      columnTitle: '',
      errorMessage: '',
      fxOptions: [{
        label: 'Convert results to selected currency',
        value: 'Convert-'
      }, {
        label: 'Filter results to selected currency',
        value: 'Filter-'
      }, {
        label: 'Keep results in original currency',
        value: 'Keep-'
      }],
      fxOption: {},
      currency: {}
    };
  },
  computed: {
    filteredOptions: function filteredOptions() {
      var _this = this;
      if (!this.params.editMode) this.$nextTick(this.updateScroll);
      if (this.options) {
        return this.options.filter(function (option) {
          option.label.toLowerCase().includes(_this.text.toLowerCase()) ? option.hide = false : option.hide = true;
          return true;
        });
      }
    }
  },
  created: function created() {
    this.params = this.params || this.init;
    var column = this.params.colDef;
    this.columnTitle = column.headerName;
    this.init && this.fetchOptions();
  },
  mounted: function mounted() {
    //
  },
  methods: {
    afterGuiAttached: function afterGuiAttached() {
      var _this2 = this;
      this.fetchOptions();
      if (!this.params.editMode) {
        var viewport = this.$el.querySelector('.list');
        setTimeout(function () {
          return _this2.ps = new __WEBPACK_IMPORTED_MODULE_1_perfect_scrollbar__["a" /* default */](viewport, {
            minScrollbarLength: 20
          });
        });
      }
      this.fxOption = this.fxOptions[2];
    },
    t: function t(key) {
      return __WEBPACK_IMPORTED_MODULE_0__lang_lang__["a" /* i18n */].t(key);
    },
    clearOptions: function clearOptions(key) {
      return (key.status = false) && 0 || key;
    },
    getModel: function getModel() {
      return {
        filter: this.formattedList || this.text && '',
        type: 'Currency'
      };
    },
    setModel: function setModel(model) {
      if (model && model.filter) {
        this.text = model.filter;
      }
      if (model === null) {
        this.text = '';
        this.formattedList = null;
        this.options.forEach(function (option) {
          return option.status = false;
        });
      }
    },
    isFilterActive: function isFilterActive() {
      return this.text !== null && this.text !== undefined && this.text !== '' && false;
    },
    fetchOptions: function fetchOptions() {
      var _this3 = this;
      var list = this;
      var column = this.params.colDef;
      var options = [];
      if (column.options) {
        //
        this.options = this.params.editMode ? column.options : column.options.map(typeof column.closeFilter === 'undefined' ? this.clearOptions : function (k) {
          return k;
        });
      } else {
        //
        // Fetch the options from the api
        //
        this.api.forms.post(this.api.$.settings.currenciesFilter, {
          q: ''
        }).then(function (r) {
          if (r) {
            var $list = r.data.Data;
            $list && $list.filter(function (k, v) {
              return options.push({
                label: k.Value,
                value: k.Key,
                status: false
              });
            });
            _this3.options = options;
            column.options = options;
          } else {
            list.errorMessage = 'Try again later';
          }
        });
      }
    },
    getOptions: function getOptions() {
      if (this.fxOption.value === 'Keep-') return null;
      if (this.fxOption.value && this.currency.value) {
        return "".concat(this.fxOption.value).concat(this.currency.value);
      }
    },
    apply: function apply() {
      this.formattedList = this.getOptions();
      this.params.filterChangedCallback();
    },
    clear: function clear() {
      this.setModel(null);
    },
    updateScroll: function updateScroll() {
      this.ps && this.ps.update();
    },
    // edit
    click: function click(e) {
      this.$emit('click', e);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "B9jb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cookie; });
var cookie = {
  get: function get(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
};

/***/ }),

/***/ "BIgX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mfa)?_c('div',{staticClass:"login mfa"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Log In Securely')))]),_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.mfaOriginText())+".")]),_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.$t('Please enter it below'))+".")]),_c('form',{staticClass:"form",attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.checkMfa.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('ed-input',{staticClass:"col-md-7",attrs:{"name":"code","hide-optional":"","field-label":_vm.$t("One-time code"),"autocomplete":"off"},model:{value:(_vm.mfaData.code),callback:function ($$v) {_vm.$set(_vm.mfaData, "code", $$v)},expression:"mfaData.code"}})],1),_c('div',{staticClass:"text-right"},[_c('ed-button',{staticClass:"alt",attrs:{"button-class":"btn btn-secondary","type":"button","value":"cancel"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('Cancel')))]),_vm._v(" "),_c('ed-button',{attrs:{"button-class":"btn btn-primary","type":"submit","value":"next","endpoint":_vm.loginEndpoint}},[_vm._v(_vm._s(_vm.$t('Next')))])],1)])]):_c('div',{staticClass:"login"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('login.cta')))]),_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.loginUser.apply(null, arguments)}}},[_c('ed-input',{attrs:{"name":"username","hide-optional":"","type":"email","field-label":_vm.$t("login.Email"),"placeholder":_vm.$t("login.emailHint")},model:{value:(_vm.loginDetails.username),callback:function ($$v) {_vm.$set(_vm.loginDetails, "username", $$v)},expression:"loginDetails.username"}}),_c('ed-input',{attrs:{"name":"password","hide-optional":"","type":"password","show-password":"","field-label":_vm.$t("login.Password"),"placeholder":_vm.$t("login.passwordHint")},model:{value:(_vm.loginDetails.password),callback:function ($$v) {_vm.$set(_vm.loginDetails, "password", $$v)},expression:"loginDetails.password"}}),_c('ed-checkbox',{attrs:{"options":_vm.remember}}),_c('div',{staticClass:"text-right"},[_c('div',{staticClass:"pull-left login-message"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.forgotPassword.apply(null, arguments)}}},[_vm._v("Forgot your password?")])]),_c('button',{staticClass:"btn btn-primary float-right- pull-right-",attrs:{"type":"submit","value":"login","endpoint":_vm.loginEndpoint}},[_vm._v(_vm._s(_vm.$t('login.button')))])]),(_vm.loginError.message)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.loginError.message))}})]):_vm._e()],1),_c('ed-modal',{staticClass:"middle",attrs:{"submitEndpoint":_vm.api.$.settings.my.resetPassword,"show":_vm.showForgotPassword,"title":"","subtitle":"Enter the e-mail address associated with your account to have your password reset.","primaryButton":"Submit","secondaryButton":"false","type":"small","validation":""},on:{"close":function($event){_vm.showForgotPassword = false},"validate":_vm.submitForgotPassword}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('ed-input',{class:_vm.emailValidation,attrs:{"type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)]),_c('ed-modal',{staticClass:"middle",attrs:{"submitEndpoint":_vm.api.$.settings.my.resetPassword,"show":_vm.showFeedback,"title":"","subtitle":_vm.feedbackMessage,"primaryButton":"Ok","secondaryButton":"false"},on:{"confirm":function($event){_vm.showFeedback = false},"close":function($event){_vm.showFeedback = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BMDR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-primary-nav',
  data: function data() {
    return {
      menuClosed: false,
      showMenu: 'nav-menu-show',
      hideMenu: 'nav-menu-hide',
      active: 'active',
      items: [],
      activeParentLink: {}
    };
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.menuClosed = !this.menuClosed;
    }
  },
  created: function created() {
    var _this = this;
    this.$router.options.routes.forEach(function (route) {
      if (route.meta) {
        _this.items.push({
          name: route.name,
          path: route.path
        });
      }
    });
  },
  computed: {
    subNav: function subNav() {
      var _this2 = this;
      var found = this.$router.options.routes.find(function (route) {
        return route.name === _this2.$route.matched[0].name;
      });
      if (found) {
        return found.children;
      }
    }
  }
});

/***/ }),

/***/ "BOmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_percent_vue__ = __webpack_require__("Fw3C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d83498_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_percent_vue__ = __webpack_require__("5anu");
function injectStyle (ssrContext) {
  __webpack_require__("2OBO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_percent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d83498_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_percent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BRZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("YRQz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631d881a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GyNV");
function injectStyle (ssrContext) {
  __webpack_require__("JfIr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631d881a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BUe5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],attrs:{"button-class":"btn btn-actionbar","ids":_vm.ids,"disabled":_vm.disabled},on:{"click":function($event){return _vm.showModal(_vm.showAddFunding)}}},[_vm._v("\n    Add Funding\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Add Funding","show":_vm.showAddFunding,"primary-button":"Add"},on:{"close":function($event){_vm.showModal(_vm.showAddFunding), _vm.fundingAmount = ''},"confirm":_vm.addFunds}},[_c('div',{staticClass:"add-funding-overlay",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Add a one-time amount to this EvedPay Card Account")]),_vm._v(" "),_c('label',[_vm._v("Funding Amount")]),_vm._v(" "),_c('ed-input',{attrs:{"type":"money","amount":""},on:{"input":function (value) { return _vm.fundingAmount = value; }},model:{value:(_vm.fundingAmount),callback:function ($$v) {_vm.fundingAmount=$$v},expression:"fundingAmount"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BegE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__ = __webpack_require__("HMpe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-panel',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: String,
    primaryButton: {
      type: String,
      default: 'Ok'
    },
    secondaryButton: {
      type: String,
      default: 'Cancel'
    }
  },
  data: function data() {
    return {
      body: null,
      footer: null
    };
  },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  },
  mounted: function mounted() {
    var _this = this;
    var viewport = this.$el;
    this.psViewport = new __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__["a" /* default */](viewport, {
      minScrollbarLength: 20,
      wheelPropagation: false
    });
    document.addEventListener('keydown', function (e) {
      if (_this.show && e.keyCode === 27) {
        _this.close();
      }
    });
  },
  updated: function updated() {
    this.psViewport.update();
  },
  computed: {
    hasSlotFooter: function hasSlotFooter() {
      return this.$slots.footer;
    }
  }
});

/***/ }),

/***/ "BgeU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"VaeQ2KUfBQ2jsvQ2XrhXa","Dell":"_1ysq0ZHFJk1afLbruD5mft","Abbott":"_2ydf79pW_HEiNhbS1rsXxP","Gap":"MsC2OhdyTB04FbkjNqYyt","Allstate":"HF18u7WkZv4K34HWHy_5s","Asurion":"UeXFlFLMzV4vCXTFPNQTI","Invitae":"_2to_WR_-PVRmhkVBjEdS_h","JWE":"_1pBcX8ko9Zxei98cp0mMxe"};

/***/ }),

/***/ "BhPO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wrapper"},[_vm._l((_vm.statuses),function(status,i){
var _obj;
return _c('span',{staticClass:"badge active",class:( _obj = {}, _obj[status.toLowerCase()] = true, _obj['has-more'] =  _vm.statuses.length > 1, _obj['last'] =  i === _vm.statuses.length - 1, _obj )},[(_vm.params.data['HasProcessedPayments'])?_c('a',{attrs:{"target":"_blank","href":((_vm.api.env) + "/PaymentInvoice/GetRemittancePdf?invoiceId=" + (_vm.params.data['Id'])),"title":"Click for Remittance file"}},[_vm._v("\n      "+_vm._s(status)+"\n      "),(i === _vm.statuses.length - 1)?_c('i',{staticClass:"fal fa-file-alt"}):_vm._e()]):_c('span',[_vm._v(_vm._s(status))])])}),_vm._v(" "),(_vm.showRejectedTooltip)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.fetchTooltip, loadingContent: '...' }),expression:"{ content: fetchTooltip, loadingContent: '...' }"}],staticClass:"fas fa-question-circle"}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bhkm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var modules = {};
var files = __webpack_require__("234v");
files.keys().forEach(function (fileName) {
  var name = fileName.replace('./', '').replace('.vue', '');
  var file = files(fileName);
  modules[file.alias || name] = file;
});
/* harmony default export */ __webpack_exports__["a"] = (modules);

/***/ }),

/***/ "Bn3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_data_skybox_vue__ = __webpack_require__("VhKI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_669e8b71_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_data_skybox_vue__ = __webpack_require__("FdMy");
function injectStyle (ssrContext) {
  __webpack_require__("DdQI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-669e8b71"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_data_skybox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_669e8b71_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_data_skybox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BrnE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object,
    error: Boolean,
    helptipBody: String,
    displayAllocationError: Boolean
  },
  data: function data() {
    return {
      allocationLabel: '',
      options: [],
      allocations: [],
      type: '',
      allocationModel: {
        costCenters: [],
        pairs: []
      },
      allocation: {},
      selectedType: ['allocationSelectedType'],
      slotName: '',
      allocationSectionModel: {
        hasAllocationSection: this.show,
        isAllocationSelected: false,
        hasAllocationForScan: false
      }
    };
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].I2P.UPDATE_ALLOCATION_MODEL);
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].I2P.UPDATE_ALLOCATION_MODEL, function (e) {
      _this.bindAllocations(e.data);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].I2P.INIT_ALLOCATION_MODEL);
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].I2P.INIT_ALLOCATION_MODEL, function (e) {
      _this.initAllocations(e.data);
    });
  },
  computed: {
    show: function show() {
      return this.allocations !== null && this.allocations !== undefined && this.allocations.length > 1;
    }
  },
  methods: {
    setAllocationType: function setAllocationType(e) {
      switch (this.selectedType[0]) {
        case '1':
          this.allocationSectionModel.hasAllocationForScan = true;
          break;
        case '2':
          this.allocationModel.costCenters = [];
          this.allocationModel.pairs = [];
          this.allocation = {};
          this.allocationSectionModel.hasAllocationForScan = false;
          break;
      }
      this.allocationSectionModel.hasAllocationSection = true;
      this.allocationSectionModel.isAllocationSelected = true;
      this.$emit('allocationForScanSelected', this.allocationSectionModel);
    },
    initAllocations: function initAllocations(data) {
      this.allocation = {};
      this.allocationModel.costCenters = [];
      this.allocationModel.pairs = [];
      if (data.type === 'Pairs') {
        this.bindPairLabels();
      } else {
        this.bindCostCenterLabels();
      }
      this.allocationSectionModel.hasAllocationSection = true;
      this.allocationSectionModel.isAllocationSelected = true;
      if (data.hasMultipleAllocation) {
        this.allocationSectionModel.hasAllocationForScan = false;
        this.selectedType = [this.options[1].id];
      } else if (data.selectedOption) {
        this.allocationSectionModel.hasAllocationForScan = true;
        this.selectedType = [this.options[0].id];
        this.allocationSelected({
          key: data.selectedOption.Key,
          value: data.selectedOption.Value,
          additionalNo: data.AdditionalNo
        });
      }
      this.$emit('allocationForScanSelected', this.allocationSectionModel);
    },
    bindAllocations: function bindAllocations(data) {
      this.allocation = {};
      var costCenters = data.costCenters;
      var pairs = data.pairs;
      if (costCenters !== null && costCenters !== undefined && costCenters.length > 1) {
        this.allocations = costCenters;
        this.bindCostCenterLabels();
        this.allocationSectionModel.hasAllocationSection = true;
        this.allocationSectionModel.isAllocationSelected = false;
      } else if (pairs !== null && pairs !== undefined && pairs.length > 1) {
        this.allocations = pairs;
        this.bindPairLabels();
        this.allocationSectionModel.hasAllocationSection = true;
        this.allocationSectionModel.isAllocationSelected = false;
      } else {
        this.allocations = [];
        this.allocationForScanSelected = false;
        this.allocationSectionModel.hasAllocationSection = false;
        this.allocationSectionModel.isAllocationSelected = false;
      }
      this.$emit('allocationForScanSelected', this.allocationSectionModel);
    },
    bindCostCenterLabels: function bindCostCenterLabels() {
      this.type = 'CostCenter';
      this.allocationLabel = 'Cost Center';
      this.options = [{
        label: 'One Cost Center',
        id: '1',
        status: false,
        additionalInfo: true,
        slotName: 'additionalInfo_1'
      }, {
        label: 'Multiple Cost Centers',
        id: '2',
        status: false,
        additionalInfo: true,
        slotName: 'additionalInfo_2'
      }];
    },
    bindPairLabels: function bindPairLabels() {
      this.type = 'Pairs';
      this.allocationLabel = 'Business Unit & Cost Center';
      this.options = [{
        label: 'One Business Unit & Cost Center',
        id: '1',
        status: false,
        additionalInfo: true,
        slotName: 'additionalInfo_1'
      }, {
        label: 'Multiple Business Unit & Cost Centers ',
        id: '2',
        status: false,
        additionalInfo: true,
        slotName: 'additionalInfo_2'
      }];
    },
    allocationSelected: function allocationSelected(e) {
      this.allocation = e;
      switch (this.type) {
        case 'CostCenter':
          this.allocationModel.costCenters = [e];
          break;
        case 'Pairs':
          this.allocationModel.pairs = [e];
          break;
      }
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].I2P.ADD_CC_FOR_SCAN, this.allocationModel);
    }
  }
});

/***/ }),

/***/ "BtDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubmitReceipt_vue__ = __webpack_require__("7L00");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b03b9048_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubmitReceipt_vue__ = __webpack_require__("OyNi");
function injectStyle (ssrContext) {
  __webpack_require__("4jeW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b03b9048"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubmitReceipt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b03b9048_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubmitReceipt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BvCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("9Mkd");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eff97c90_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("9+bc");
function injectStyle (ssrContext) {
  __webpack_require__("D7n7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eff97c90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eff97c90_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Bw9g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_export_data_vue__ = __webpack_require__("hPWr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5badda23_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_export_data_vue__ = __webpack_require__("8SbH");
function injectStyle (ssrContext) {
  __webpack_require__("G94L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5badda23"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_export_data_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5badda23_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_export_data_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BwHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_supplier_model_js__ = __webpack_require__("xth5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import tabs from './tabs'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */]
  },
  data: function data() {
    return {
      SupplierModel: __WEBPACK_IMPORTED_MODULE_1__models_supplier_model_js__["a" /* default */],
      defaultView: {
        label: 'Pending Certificates',
        filter: {
          ShouldBeVerified: 'Yes'
        },
        icon: 'far fa-clock'
      }
      // tabs: tabs.tabs
    };
  },
  activated: function activated() {
    if (!this.created) {
      this.$refs.InsuranceSuppliersGrid.quickSearch();
    }
  },
  deactivated: function deactivated() {
    this.created = false;
  },
  created: function created() {
    this.created = true;
  }
});

/***/ }),

/***/ "C1Tj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","disabled":_vm.disabled,"name":_vm.$parent.name,"id":_vm.$parent.inputId || _vm.$parent.name,"accept":_vm.$parent.accept,"webkitdirectory":_vm.$parent.directory && _vm.$parent.features.directory,"directory":_vm.$parent.directory && _vm.$parent.features.directory,"multiple":_vm.$parent.multiple && _vm.$parent.features.html5},on:{"change":_vm.change}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C9Nq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CCob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rejectReason: '',
      showReject: false
    };
  },
  created: function created() {},
  props: {
    ids: null,
    disabled: false,
    tooltip: '',
    selectedRows: [],
    card: [],
    buttonClass: {
      type: String,
      default: 'btn btn-actionbar col-md-12'
    }
  },
  methods: {
    approveOrReject: function approveOrReject() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var cardId, payload, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (_this.selectedRows && _this.selectedRows.length > 0) {
                cardId = _this.selectedRows[0].data.Id;
              } else {
                cardId = _this.card.Id;
              }
              payload = {
                cardsData: JSON.stringify([{
                  Id: cardId,
                  RejectReason: _this.rejectReason
                }])
              };
              _context.next = 5;
              return _this.api.post(_this.api.$.evedpaycard.approveOrReject, payload);
            case 5:
              response = _context.sent;
              if (response.data) {
                _context.next = 10;
                break;
              }
              throw new Error('Error during the request');
            case 10:
              _this.$emit('success', cardId);
            case 11:
              if (response.status === 200) {
                _this.showReject = false;
              }
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ "CDWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("KD8Q");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d027165a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("QGwT");
function injectStyle (ssrContext) {
  __webpack_require__("wvul")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d027165a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d027165a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CHSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{ref:"header",attrs:{"title":_vm.$t("Approval Settings")}},[_c('span',{attrs:{"slot":"action"},slot:"action"},[(_vm.$routerHistory.hasHistory() && _vm.$route.query["back-to"])?_c('router-link',{attrs:{"to":{ path: _vm.$routerHistory.previous().path, hash: "" }}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_c('span',[_vm._v("  "+_vm._s(_vm.$t('Back') + ' ' + _vm.$t('to') + ' ' + _vm.$t(_vm.$route.query['back-to'])))])]):_vm._e()],1)]),_c('div',{staticClass:"container-fluid"},[_c('ed-section',{staticClass:"active clear no-flex settings-section"},[_c('h4',[_vm._v("Email Settings")]),_c('label',{staticClass:"col-md-12 no-pad"},[_c('div',{staticClass:"col-md-3 field-label"},[_c('strong',[_vm._v("Allow users to reply to approval notifications to approve and decline items:")])]),_c('div',{staticClass:"col-md-9"},[_c('ed-checkbox',{staticClass:"text",attrs:{"options":[{
              label: " ",
              status: _vm.settingsCopy.EnableReplyToEmail
            }]},on:{"click":_vm.canReplyToEmailSetting},model:{value:(_vm.settingsCopy.EnableReplyToEmail),callback:function ($$v) {_vm.$set(_vm.settingsCopy, "EnableReplyToEmail", $$v)},expression:"settingsCopy.EnableReplyToEmail"}})],1)]),_c('div',{staticClass:"clear"}),(_vm.displayApprovalNoteSettings)?_c('div',{staticClass:"approval-note"},[_c('h4',[_vm._v("Approval Note Settings")]),_c('label',{staticClass:"col-md-12 no-pad"},[_c('div',{staticClass:"col-md-3 field-label"},[_c('strong',[_vm._v("Require Invoice Approval Notes:")])]),_c('div',{staticClass:"col-md-9"},[_c('ed-checkbox',{staticClass:"text",attrs:{"options":[{
                label: " ",
                status: _vm.isRequiredApprovalNote
              }]},on:{"click":_vm.saveApprovalNoteSettings},model:{value:(_vm.isRequiredApprovalNote),callback:function ($$v) {_vm.isRequiredApprovalNote=$$v},expression:"isRequiredApprovalNote"}})],1)]),_c('label',{staticClass:"col-md-12 no-pad"},[_c('div',{staticClass:"col-md-3 field-label"},[_c('strong',[_vm._v("    Require comment from submitter only")])]),_c('div',{staticClass:"col-md-9"},[_c('ed-checkbox',{staticClass:"text",attrs:{"options":[{
                label: " ",
                status: _vm.requireCommentFromSubmitterOnly
              }],"disabled":_vm.disableSecondApprovalNoteCheckbox},on:{"click":_vm.saveApprovalNoteSettings},model:{value:(_vm.requireCommentFromSubmitterOnly),callback:function ($$v) {_vm.requireCommentFromSubmitterOnly=$$v},expression:"requireCommentFromSubmitterOnly"}})],1)]),_c('div',{staticClass:"col-md-3 field-label"},[_c('label',[_c('strong',[_vm._v("Approval Note Form Label:")])])]),_c('div',{staticClass:"col-md-4"},[_c('ed-input',{attrs:{"required":"true","fieldLabel":"","error":_vm.approvalNoteError,"helptip-body":_vm.approvalNoteError && "Please fill in Approval Note." || ""},on:{"change":_vm.saveApprovalNoteSettings},model:{value:(_vm.approvalNoteLabel),callback:function ($$v) {_vm.approvalNoteLabel=$$v},expression:"approvalNoteLabel"}})],1),_c('div',{staticClass:"clear"}),_c('div',{staticClass:"col-md-3 field-label"},[_c('label',[_c('strong',[_vm._v("Submit Invoice Approval Note Prefilled Text:")])])]),_c('div',{staticClass:"col-md-4"},[_c('ed-textarea',{attrs:{"rows":"5","fieldLabel":""},on:{"change":_vm.saveApprovalNoteSettings},model:{value:(_vm.approvalNotePlaceholder),callback:function ($$v) {_vm.approvalNotePlaceholder=$$v},expression:"approvalNotePlaceholder"}})],1),_c('div',{staticClass:"clear"})]):_vm._e(),_c('div',{staticClass:"col-md-12 no-pad"},[_c('ed-modal',{attrs:{"show":_vm.showModal,"title":_vm.title,"subtitle":_vm.subtitle,"primaryButton":"SAVE","primaryButtonDisabled":_vm.primaryButtonDisabled,"type":"large","validation":""},on:{"show":_vm.open,"close":_vm.closeModal,"validate":_vm.save}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('approval-rule',{attrs:{"legacy":"true","layout":"small"}})],1)]),_c('h4',[_vm._v("Approval Rules")]),_c('grid',{ref:"ApprovalRuleGrid",attrs:{"model":_vm.model,"name":"","desc":"","search":"","layout":"frame","endpoint":_vm.api.$.approval.getApprovalRules}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.disableSingleButton},on:{"click":function($event){return _vm.openRule(_vm.ruleId, true)}}},[_vm._v("Edit")]),_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.disableSingleButton},on:{"click":function($event){return _vm.openDeleteModal(_vm.ruleId)}}},[_vm._v("Delete")]),_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":function($event){return _vm.openRule(0, false)}}},[_vm._v("Add Rule")])],1)]),_c('ed-modal',{attrs:{"show":_vm.showDeleteRuleModal,"title":"","subtitle":"Are you sure you want to delete this rule?","primaryButton":"Yes","secondaryButton":"No","type":"small"},on:{"close":function($event){_vm.showDeleteRuleModal = false},"confirm":function($event){return _vm.deleteRule()}}}),_c('br'),_c('h4',[_vm._v("Approval Rules History        ")]),_c('approval-history')],1),_c('div',{staticClass:"clear"}),_c('br')])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CJ12":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3OSaAJhnmdyqhjhEM6Y8UQ","Dell":"_31f3b4P5NM5U0TdRZb_DYa","Abbott":"_3i4K-4zDEh3UJHu0gFlhvX","Gap":"_1cvzyR5WzSXk-jMqzYbzMx","Allstate":"_2IO0KVHc6_VwIkh3i34IDS","Asurion":"_2A1PAoPpBuv6LE6jnHy9pK","Invitae":"_1gdm7RAVbyTyGD8rQZfxFA","JWE":"_1cU4GXoZm1xjSlSidi1JiL"};

/***/ }),

/***/ "CMu3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3jeTPuApeeBO4FLa3e_NJk","Dell":"_2aMtlvRmzJyXSXIMPEGvuY","Abbott":"_3X-dDJXQhAcOhgT_typSWe","Gap":"_3q25twqrvmTzTmzyBcPDR0","Allstate":"_2OPli4pVIhIWjVHz6fsql","Asurion":"_1bAck1G5-D7IYqGiHR6P_D","Invitae":"mFfTn2Q0Z0EPJdE7sHvNy","JWE":"_1ZvOsSX945S-SpkflYe5E3"};

/***/ }),

/***/ "CQuN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(!_vm.showCreateEnvelope)?_c('Grid',{ref:"grid",attrs:{"name":_vm.$t("EvedPay Cards"),"desc":"Manage accounts, cards and transactions","search":"true","search-placeholder":"My Transactions","resizing":"false","endpoint":_vm.api.$.evedpaycard.transactions,"sort":_vm.sort,"legacy":"","footer":"","row-classes":_vm.rowClasses,"tabs":_vm.tabs,"alias":"EvedPayCards","no-tooltip-fields":_vm.noTooltipFields,"filter":{},"totals":""},on:{"selectedRows":_vm.rowSelected}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[(_vm.receiptScanEnabled && _vm.anyScanEnabled)?_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.uploadingReceipt},on:{"click":_vm.openReceiptUpload}},[_vm._v("\n        SUBMIT RECEIPT\n      ")]):_vm._e(),_vm._v(" "),_c('input',{ref:"receiptUploadInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.handleReceiptFileSelected}}),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('createEnvelope')),expression:"actionDisabledReason('createEnvelope')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.cardActionDisabled('createEnvelope')},on:{"click":_vm.createEnvelope}},[_vm._v("\n        CREATE ENVELOPE\n      ")]),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('reconcile')),expression:"actionDisabledReason('reconcile')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.cardActionDisabled('reconcile')},on:{"click":function($event){return _vm.showModal(_vm.showReconcile)}}},[_vm._v("\n        RECONCILE\n      ")])],1),_vm._v(" "),_c('span',{staticClass:"form-group no-margin",attrs:{"slot":"additionalLabel"},slot:"additionalLabel"},[_c('i',{staticClass:"fas fa-exclamation"}),_vm._v(" "),_c('span',[_vm._v(" ")]),_vm._v(" "),_c('label',[_vm._v("Click column headers to apply filters")])])]):_vm._e(),_vm._v(" "),(_vm.showCreateEnvelope)?_c('CreateEnvelope',{attrs:{"title":"CREATE ENVELOPE","initial-rows":_vm.selectedRows,"envelope":_vm.envelope},on:{"success":function($event){_vm.showCreateEnvelope=!_vm.showCreateEnvelope; _vm.selectedRows = []; _vm.$router.push('/d/Programs/>Card/envelopes')},"backToTransactions":function($event){_vm.showCreateEnvelope=!_vm.showCreateEnvelope; _vm.updateUrlBackToTransactionsPage(); _vm.selectedRows = []; _vm.envelope = {}},"fields-updated":_vm.handleFieldsUpdated}}):_vm._e(),_vm._v(" "),_c('CandidateSelector',{attrs:{"show":_vm.showCandidateSelector,"receipt-scan-id":_vm.candidateSelectorReceiptId,"candidates":_vm.candidateSelectorCandidates,"row-version":_vm.candidateSelectorRowVersion,"auto-linked":_vm.candidateSelectorAutoLinked,"auto-fill":_vm.candidateSelectorAutoFill,"is-mobile":false,"claim-mode":false,"loading":_vm.candidateSelectorLoading,"local-image-url":_vm.candidateSelectorLocalImageUrl,"local-image-content-type":_vm.candidateSelectorLocalImageType},on:{"match-attempt":_vm.handleMatchAttempt,"match-selected":_vm.handleMatchSelected,"match-error":_vm.handleMatchError,"save-to-folder":_vm.handleSaveToFolder,"close":_vm.handleCandidateSelectorClose}}),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Submit Receipt","show":_vm.showSubmitReceiptModal,"primary-button":"Submit","primaryButtonDisabled":!_vm.pendingReceiptFile || _vm.uploadingReceipt,"type":"medium","validation":""},on:{"close":_vm.closeSubmitReceiptModal,"validate":_vm.confirmSubmitReceipt}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',{staticStyle:{"margin-bottom":"18px","white-space":"nowrap"}},[_vm._v("Upload an image of a receipt and it will be matched to a transaction and coded automatically.")]),_vm._v(" "),(_vm.uploadingReceipt)?[_c('label',[_c('strong',[_vm._v("Uploading")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"8px","padding":"12px 0 24px"}},[_c('div',{staticStyle:{"flex":"1","height":"8px","background":"#F5F5F5","border-radius":"100px","overflow":"hidden"}},[_c('div',{style:({ width: _vm.uploadProgressPct + '%', height: '100%', background: '#1890FF', borderRadius: '100px' })})]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"Roboto, sans-serif","font-size":"14px","line-height":"22px","color":"rgba(0, 0, 0, 0.85)","width":"32px","text-align":"right"}},[_vm._v(_vm._s(_vm.uploadProgressPct)+"%")])])]:[_c('label',[_c('strong',[_vm._v("Receipt")])]),_vm._v(" "),(!_vm.pendingReceiptFile)?_c('div',[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar"},on:{"click":_vm.triggerReceiptFileInput}},[_vm._v("\n            UPLOAD NEW RECEIPT\n          ")])],1):_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"10px","padding":"12px 8px","border-bottom":"1px solid rgba(0,0,0,0.08)","margin-bottom":"28px"}},[_c('i',{staticClass:"fas",class:_vm.pendingReceiptIcon.iconClass,style:({ color: _vm.pendingReceiptIcon.color, fontSize: '18px' })}),_vm._v(" "),_c('a',{staticStyle:{"color":"#4a90e2","text-decoration":"underline","flex":"1","font-size":"12px"},attrs:{"href":_vm.pendingReceiptObjectUrl || undefined,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.pendingReceiptFile.name))]),_vm._v(" "),_c('span',{staticStyle:{"color":"#999","font-size":"12px"}},[_vm._v(_vm._s(_vm.formatFileSize(_vm.pendingReceiptFile.size)))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Remove'),expression:"'Remove'"}],staticStyle:{"line-height":"0"},attrs:{"href":"javascript:;"},on:{"click":_vm.clearPendingReceiptFile}},[_c('i',{staticClass:"fas fa-times-circle",staticStyle:{"color":"#888","font-size":"18px"}})])])]],2)]),_vm._v(" "),_c('ed-modal',{attrs:{"type":_vm.fields && _vm.fields.length > 0 && _vm.fields[0] && _vm.fields[0].length > 0 ? 'extra-large' : 'medium-large',"title":"Reconcile Transaction","show":_vm.showReconcile,"primary-button":(_vm.isUserAdmin || _vm.reconcileAction !== 'view') ? 'Save' : 'false',"primaryButtonDisabled":!_vm.uploadFinished,"secondary-button":"Cancel","validation":""},on:{"close":function($event){_vm.showModal(_vm.showReconcile); _vm.closeReconcile()},"validate":_vm.saveAndReconcile}},[(_vm.transaction && _vm.transaction.data)?_c('Reconcile',{key:_vm.transaction.data.Id,ref:"reconcileComp",attrs:{"slot":"body","transaction":_vm.transaction,"fields-incomplete":{ receiptIncomplete: _vm.receiptIncomplete, descriptionIncomplete: _vm.descriptionIncomplete },"reconcile-action":_vm.reconcileAction,"receipt-edit-allowed":_vm.receiptEditAllowed},on:{"reconcile-created":_vm.handleReconcileCreated,"fields-updated":_vm.handleFieldsUpdated,"mediaFilesPathUpdated":_vm.updateMediaFilesPath,"attachmentsUpdated":_vm.updateAttachmentsFiles,"additional-documents-updated":_vm.updateAdditionalDocuments,"split-amounts":_vm.handleSplitAmounts,"description-text":_vm.handleDescriptionText,"uploadFinished":_vm.handleUploadFinished},slot:"body"}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CRMk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

var chartColors = {
  purple: '#51226c',
  purpleLight1: '#61407a',
  purpleLight2: '#a686c9',
  blue: '#009FCC',
  blueLight: '#60b8d1',
  blueLight1: '#8cc9da',
  blueLight2: '#cde2e8',
  green: '#a9d85f',
  greenLight1: '#bee187',
  greenLight2: '#d4ebaf',
  red: '#E02630',
  redLight: '#ffcacc',
  orange: '#ffba15',
  organgeLight: '#ffdf94',
  grey: '#b3b3b3',
  greyDark: '#4d4d4d',
  greyLight: '#CCCCCC',
  yellowish: '#ffba15'
};
/* harmony default export */ __webpack_exports__["a"] = (chartColors);

/***/ }),

/***/ "CRvx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeDueComp_vue__ = __webpack_require__("ispy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21dc922c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeDueComp_vue__ = __webpack_require__("6v8b");
function injectStyle (ssrContext) {
  __webpack_require__("Me+w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21dc922c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeDueComp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21dc922c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeDueComp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CZwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Queue_vue__ = __webpack_require__("Gjoa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407485cb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Queue_vue__ = __webpack_require__("fLOW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Queue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407485cb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Queue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CqA7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{ "loading dawn-card": _vm.files && _vm.files[0] && _vm.files[0].active }},[(_vm.fieldLabel)?_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.fieldLabel)),(!_vm.required && !_vm.hideOptional)?_c('em',{staticClass:"optional"},[_vm._v(" - optional")]):_vm._e(),_vm._v("  ")]):_vm._e(),(!_vm.noButton && _vm.buttonPosition === "top")?_c('upload-component',_vm._b({ref:"upload",attrs:{"auto":true,"multiple":_vm.multiple,"drop":true,"button-label":_vm.buttonLabel},on:{"input-file":_vm.inputFile},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},'upload-component',_vm.$props,false)):_vm._e(),_c('span',{staticClass:"helptip-wrapper"},[(_vm.helptipBody)?_c('span',{staticClass:"helptip-icon",class:{ invisible: !_vm.showHelptipIcon },on:{"click":function($event){return _vm.toggleHelp()}}},[_c('i',{class:[_vm.showHelp ? _vm.hideIcon : _vm.showIcon]})]):_vm._e(),(_vm.helptipBody && _vm.showHelp || _vm.helptipBody && _vm.error)?_c('ed-input-tooltip',{class:{ "error-message" : _vm.error },attrs:{"helptipHeader":_vm.helptipHeader,"errorTip":_vm.error,"helptipBody":_vm.helptipBody}}):_vm._e()],1),_c('div',{staticClass:"dawn-file-list-wrapper"},_vm._l((_vm.files),function(file,index){return _c('div',{key:file.id,staticClass:"dawn-file-list",class:{ editing: _vm.isEditing(file), "list-only": _vm.noButton }},[_c('span',{staticClass:"dawn-file-icon",domProps:{"innerHTML":_vm._s(_vm.fileIcon(file.type))}}),(_vm.noButton || (_vm.canOpenFile && file.path))?_c('a',{staticClass:"small",attrs:{"href":file.path,"target":_vm.target || "_blank"},on:{"click":function (e) { return _vm.$emit("open-file", {e: e, path: file.path, file: file}); }}},[_vm._v(_vm._s(file.name))]):_c('input',{directives:[{name:"focus",rawName:"v-focus.lazy",value:(_vm.checkIndex(index)),expression:"checkIndex(index)",modifiers:{"lazy":true}},{name:"model",rawName:"v-model",value:(file.name),expression:"file.name"}],staticClass:"file-upload-item-input",attrs:{"readonly":_vm.readonly},domProps:{"value":(file.name)},on:{"focus":function($event){return _vm.toggleEdit(file)},"blur":function($event){return _vm.toggleEdit(file)},"input":function($event){if($event.target.composing){ return; }_vm.$set(file, "name", $event.target.value)}}}),_c('span',{staticClass:"dawn-file-size"},[_vm._v(_vm._s(_vm.formatBytes(file.size, 0)))]),(!_vm.noButton)?_c('span',{staticClass:"dawn-remove-file",attrs:{"disabled":file.readonly},on:{"click":function($event){$event.preventDefault();return (function () { return file.readonly || _vm.$refs.upload.remove(file); }).apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-times-circle"})]):_vm._e()])}),0),(!_vm.noButton && _vm.buttonPosition === "bottom")?_c('upload-component',_vm._b({ref:"upload",attrs:{"auto":true,"multiple":_vm.multiple,"drop":true,"button-label":_vm.buttonLabel},on:{"input-file":_vm.inputFile},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},'upload-component',_vm.$props,false)):_vm._e(),_vm._t("additionalText")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CquV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("s/4v");
/* empty harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Cshb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("body"),_vm._v(" "),_c('div',{staticClass:"approvals"},[_c('ul',{staticClass:"col-md-12"},_vm._l((_vm.approvalUsersData),function(user){return _c('li',{key:user.id},[_vm._v("\n        "+_vm._s(user.FirstName)+" "+_vm._s(user.LastName)+"\n      ")])}),0),_vm._v(" "),_c('br',{staticStyle:{"clear":"both"}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ctys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-card-number"},[_c('div',{staticClass:"card-preview-container"},[_c('div',{staticClass:"card-preview"},[_c('img',{attrs:{"src":"https://d1a4bxjw35af21.cloudfront.net/images_en/eved-pay-logo.svg","alt":"EvedPay Logo"}}),_vm._v(" "),_c('div',{staticClass:"card-number-row"},[_c('p',{staticClass:"card-number"},[_vm._v("\n          "+_vm._s(_vm.revealed ? _vm.formattedCardNumber : '•••• •••• •••• ' + _vm.last4)+"\n          "),(_vm.revealed)?_c('span',{staticClass:"copy-icon-card",attrs:{"title":"Copy card number"},on:{"click":_vm.copyCardNumber}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"x":"9","y":"9","width":"13","height":"13","rx":"2","ry":"2"}}),_c('path',{attrs:{"d":"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"}})])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-details-row"},[_c('div',{staticClass:"card-field"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"card-value"},[_vm._v(_vm._s(_vm.formattedExpirationDate))])]),_vm._v(" "),_c('div',{staticClass:"card-field"},[_vm._m(1),_vm._v(" "),_c('p',{staticClass:"card-value"},[_vm._v(_vm._s(_vm.revealed ? _vm.cardDetails.CVV : '•••'))])])])])]),_vm._v(" "),(_vm.state === 'INITIAL')?_c('div',[_c('p',{staticClass:"otp-message"},[_vm._v("\n      "+_vm._s(_vm.otpInstructionMessage)+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn-show-card",attrs:{"disabled":_vm.sending},on:{"click":_vm.sendOtp}},[_vm._v("\n      "+_vm._s(_vm.sending ? 'Sending...' : 'Show Card Number')+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.state === 'ENTER_CODE')?_c('div',[_c('div',{staticClass:"passcode-section"},[_c('label',{staticClass:"passcode-label"},[_vm._v("Passcode")]),_vm._v(" "),_c('p',{staticClass:"passcode-hint"},[_vm._v(_vm._s(_vm.otpPasscodeHint))]),_vm._v(" "),(_vm.otpErrorMessage)?_c('p',{staticClass:"otp-error-message"},[_vm._v(_vm._s(_vm.otpErrorMessage))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passcode),expression:"passcode"}],staticClass:"form-control passcode-input",attrs:{"type":"text","maxlength":"6","inputmode":"numeric","pattern":"[0-9]*","disabled":_vm.verifying || _vm.codeExhausted},domProps:{"value":(_vm.passcode)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.passcode=$event.target.value},_vm.onPasscodeInput]}}),_vm._v(" "),(!_vm.hideResend && _vm.canResend)?_c('p',{staticClass:"resend-link",on:{"click":_vm.resendOtp}},[_vm._v("\n        Didn't receive it? "),_c('a',{attrs:{"href":"#"}},[_vm._v("Resend Code")])]):(!_vm.hideResend)?_c('p',{staticClass:"resend-cooldown"},[_vm._v("\n        Resend available in "+_vm._s(_vm.resendCountdown)+"s\n      ")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-detail-fields"},[_c('div',{staticClass:"detail-field"},[_c('div',{staticClass:"detail-label"},[_vm._v("Account Address")]),_vm._v(" "),(_vm.revealed && _vm.cardAddress)?_c('div',{staticClass:"detail-value"},[_vm._v("\n        "+_vm._s(_vm.cardAddress.Address1)),_c('br'),_vm._v("\n        "+_vm._s(_vm.cardAddress.City)+", "+_vm._s(_vm.cardAddress.State && _vm.cardAddress.State.Code)+" "+_vm._s(_vm.cardAddress.Zip)+"\n      ")]):_c('div',{staticClass:"detail-value"},[_c('span',{staticClass:"skeleton"})])]),_vm._v(" "),_c('div',{staticClass:"detail-field"},[_c('div',{staticClass:"detail-label"},[_vm._v("Name on Card")]),_vm._v(" "),_c('div',{staticClass:"detail-value"},[_vm._v(_vm._s(_vm.displayNameOnCard))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"card-label"},[_c('small',[_vm._v("VALID THRU")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"card-label"},[_c('small',[_vm._v("CVV")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CuX/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_user__ = __webpack_require__("uduW");
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */
/* eslint no-undef       : 0 */
/* eslint camelcase      : 0 */


/* harmony default export */ __webpack_exports__["a"] = ({
  setup: function setup() {
    //
  },
  logout: function logout() {
    // window.embedded_svc && embedded_svc.liveAgentAPI.endChat()
    window.embedded_svc && window.embedded_svc.liveAgentAPI.clearSession();
    document.getElementById('salesforceChatBot') && document.getElementById('salesforceChatBot').remove();
  },
  init: function init() {
    if (window.salesforceInit) return;
    if (window.self !== window.top) return;
    var initESW = function initESW(gslbBaseURL) {
      embedded_svc.settings.displayHelpButton = true;
      embedded_svc.settings.language = '';
      embedded_svc.settings.enabledFeatures = ['LiveAgent'];
      embedded_svc.settings.entryFeature = 'LiveAgent';
      var user = __WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].get();
      var firstName = user.user && user.user.FirstName;
      var email = user.user && user.user.Email;
      var customerType = user.data && parseInt(user.data.MarketTypeID) === 3 ? 'supplier' : 'corporate';
      embedded_svc.settings.extraPrechatFormDetails = [{
        'label': 'First Name',
        'value': firstName,
        'transcriptFields': ['First_Name__c'],
        'displayToAgent': true
      }, {
        'label': 'Email',
        'value': email,
        'transcriptFields': ['Email__c'],
        'displayToAgent': true
      }, {
        'label': 'Customer Type',
        'value': customerType,
        'transcriptFields': ['Customer_Type__c'],
        'displayToAgent': true
      }];
      embedded_svc.init('https://eved.my.salesforce.com', 'https://eved.my.site.com/Client', gslbBaseURL, '00DA0000000JnaI', 'Chat_Team', {
        baseLiveAgentContentURL: 'https://c.la4-c1-ia5.salesforceliveagent.com/content',
        deploymentId: '5725c000000LLN9',
        buttonId: '5735c000000LMO4',
        baseLiveAgentURL: 'https://d.la4-c1-ia5.salesforceliveagent.com/chat',
        eswLiveAgentDevName: 'Chat_Team',
        isOfflineSupportEnabled: true
      });
    };
    if (!window.embedded_svc && !window.salesforceInit) {
      var s = document.createElement('script');
      s.setAttribute('id', 'salesforceChatBot');
      s.setAttribute('src', 'https://eved.my.salesforce.com/embeddedservice/5.0/esw.min.js');
      s.onload = function () {
        if (!embedded_svc) {
          setTimeout(function () {
            initESW(null);
          }, 1000);
        } else {
          initESW(null);
        }
      };
      document.body.appendChild(s);
    } else {
      if (!embedded_svc) {
        setTimeout(function () {
          initESW('https://service.force.com');
        }, 1000);
      } else {
        initESW('https://service.force.com');
      }
    }
    window.salesforceInit = true;
  }
});

/***/ }),

/***/ "CvWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__ = __webpack_require__("X3jq");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReceiptFolderPicker',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isProcessing: {
      type: Boolean,
      default: false
    },
    // When the host supplies the transaction being reconciled, the folder search is
    // ranked by match score against it (Platform auto-orders the result set). Desktop
    // callers omit it (default null) so the body param is absent and ordering is unchanged.
    transactionId: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      featureFlags: __WEBPACK_IMPORTED_MODULE_2__core_feature_flags_feature_flags__["a" /* default */],
      receipts: [],
      isLoading: false,
      selectedReceiptId: null,
      currentPage: 1,
      pageSize: 25,
      totalPages: 1,
      isExpanded: false
    };
  },
  directives: {
    clickOutside: {
      bind: function bind(el, binding) {
        el.__vueClickOutside__ = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener('click', el.__vueClickOutside__);
      },
      unbind: function unbind(el) {
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      }
    }
  },
  computed: {
    moment: function moment() {
      return global.moment;
    },
    selectedReceipt: function selectedReceipt() {
      var _this = this;
      if (!this.selectedReceiptId || !this.receipts) return null;
      return this.receipts.find(function (r) {
        return r.receiptScanId === _this.selectedReceiptId;
      }) || null;
    }
  },
  watch: {
    show: function show(newVal) {
      if (newVal) {
        this.selectedReceiptId = null;
        this.currentPage = 1;
        this.isExpanded = false;
        this.fetchReceipts();
      } else {
        this.isExpanded = false;
      }
    }
  },
  methods: {
    displayMerchant: function displayMerchant(receipt) {
      return receipt && (receipt.merchantName || receipt.originalFileName) || 'Receipt';
    },
    // Photon-extracted receipt date when available, otherwise the upload date (PRODUCTDEV-5783).
    displayDate: function displayDate(receipt) {
      return receipt && (receipt.receiptDate || receipt.createdAt);
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return 'N/A';
      var fmt = this.$user && this.$user.sessionSettings && this.$user.sessionSettings.DateAndTimeFormats && this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat || 'MM-DD-YYYY';
      try {
        return this.moment(dateStr).format(fmt);
      } catch (e) {
        return dateStr;
      }
    },
    // The folder only ever lists the current user's own receipts, so every row is selectable.
    canSelectReceipt: function canSelectReceipt(receipt) {
      return !!receipt;
    },
    togglePanel: function togglePanel() {
      this.isExpanded = !this.isExpanded;
    },
    closePanel: function closePanel() {
      this.isExpanded = false;
    },
    onRowClick: function onRowClick(receipt) {
      if (!this.canSelectReceipt(receipt)) return;
      this.selectedReceiptId = receipt.receiptScanId;
      this.isExpanded = false;
    },
    fetchReceipts: function fetchReceipts() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, totalCount;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.isLoading = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].searchReceipts({
                status: 'FolderSaved',
                matchAgainstLegacyTransactionId: _this2.transactionId
              }, _this2.currentPage, _this2.pageSize);
            case 4:
              result = _context.sent;
              _this2.receipts = result.items || [];
              totalCount = result.totalCount || 0;
              _this2.totalPages = Math.ceil(totalCount / _this2.pageSize) || 1;
              _context.next = 15;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.error('Failed to load folder receipts:', _context.t0);
              _this2.$notifications.notify({
                type: 'danger',
                message: 'Failed to load receipts',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _this2.receipts = [];
            case 15:
              _context.prev = 15;
              _this2.isLoading = false;
              return _context.finish(15);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 10, 15, 18]]);
      }))();
    },
    goToPage: function goToPage(page) {
      this.currentPage = page;
      this.selectedReceiptId = null;
      this.fetchReceipts();
    },
    handleAdd: function handleAdd() {
      if (!this.selectedReceiptId || this.isProcessing) return;
      // Pass the folder row's own metadata so the reconcile chip has the real file size,
      // name and type even when the S3 byte-fetch is unavailable (PRODUCTDEV-5783 — the
      // chip previously showed 0 bytes whenever that fetch was blocked).
      var r = this.selectedReceipt;
      this.$emit('select', {
        receiptScanId: this.selectedReceiptId,
        sizeBytes: r ? r.sizeBytes : null,
        originalFileName: r ? r.originalFileName : null,
        contentType: r ? r.contentType : null
      });
    },
    handleClose: function handleClose() {
      this.selectedReceiptId = null;
      this.isExpanded = false;
      this.$emit('close');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "CxRe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("bwoT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ab58417_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("glzZ");
function injectStyle (ssrContext) {
  __webpack_require__("h8Cl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ab58417_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D/uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEmbedded || !_vm.featureFlags.legacyViewDisabled)?_c('div',{staticClass:"content legacy-container",class:{ 'has-nav': _vm.legacyNav.title }},[(_vm.$route.query["back-to"])?_c('ed-title-nav',{attrs:{"title":_vm.$t(_vm.$route.query["back-to"])}},[_c('span',{attrs:{"slot":"action"},slot:"action"},[_c('router-link',{attrs:{"to":_vm.backTo}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_c('span',[_vm._v("  "+_vm._s(_vm.$t('Back') + ' ' + _vm.$t('to') + ' ' + _vm.$t(_vm.$route.query['back-to'])))])])],1)]):_vm._e(),(_vm.legacyNav.title)?_c('ed-title-nav',{attrs:{"fixed":false,"title":_vm.$t(_vm.legacyNav.title),"subtitle":_vm.$t(_vm.legacyNav.subtitle)}}):_vm._e(),_c('div',{ref:"dialogContainer"},[_c('a',{attrs:{"href":"#","id":"opendialog_hidden"},on:{"click":function($event){$event.preventDefault();return _vm.openNewFormatDialog.apply(null, arguments)}}})]),_c('div',{staticClass:"content",class:_vm.iframeLoading,attrs:{"id":"iframe"}},[_c('iframe',{key:_vm.getModule(true),attrs:{"id":"MainPageFrame","name":"NetFrame","height":"100%","width":"100%","frameborder":"0","scrolling":"auto","src":_vm.getModule()},on:{"load":_vm.updateHash}})])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D0AX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("xFEX");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190333a8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("5vF4");
function injectStyle (ssrContext) {
  __webpack_require__("SDGU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-190333a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190333a8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "D1Zk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compressReceiptImage */
// Canvas-based receipt image compression. Used at every Submit Receipt entry
// point to keep upload payloads small without adding a runtime dependency.
//
// Behavior:
//   - Images (png/jpg/jpeg): downscale to MAX_LONGEST_SIDE if larger, re-encode
//     as JPEG at QUALITY. We always re-encode (not just downscale) because
//     phone cameras emit very large JPEGs even at modest dimensions; JPEG q=0.8
//     on Canvas is essentially indistinguishable for receipt photos.
//   - PDFs and anything else: passthrough unchanged. PDF re-encoding is out of
//     scope and would need a separate dep.
//
// Failure mode: if Canvas/Image/URL aren't available (very old browser) or the
// image fails to decode, we return the original file untouched so the upload
// path still works. Callers always get a File back.

var MAX_LONGEST_SIDE = 2048;
var QUALITY = 0.8;
var COMPRESSIBLE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
var COMPRESSIBLE_EXTENSIONS = ['jpg', 'jpeg', 'png'];
function getExtension(name) {
  if (!name) return '';
  var parts = name.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
}
function shouldCompress(file) {
  if (!file) return false;
  if (file.type && COMPRESSIBLE_TYPES.indexOf(file.type.toLowerCase()) !== -1) {
    return true;
  }
  // Some mobile pickers leave file.type empty — fall back to extension.
  return COMPRESSIBLE_EXTENSIONS.indexOf(getExtension(file.name)) !== -1;
}
function computeTargetDimensions(width, height) {
  var longest = Math.max(width, height);
  if (longest <= MAX_LONGEST_SIDE) {
    return {
      width: width,
      height: height
    };
  }
  var scale = MAX_LONGEST_SIDE / longest;
  return {
    width: Math.round(width * scale),
    height: Math.round(height * scale)
  };
}
function renameToJpeg(name) {
  if (!name) return 'receipt.jpg';
  var lastDot = name.lastIndexOf('.');
  if (lastDot === -1) return name + '.jpg';
  return name.substring(0, lastDot) + '.jpg';
}

// Compress an image File and return a new File. PDFs and unknowns pass through.
// Resolves with the original file on any failure — never throws to the caller.
function compressReceiptImage(file) {
  return new Promise(function (resolve) {
    if (!shouldCompress(file)) {
      resolve(file);
      return;
    }
    if (typeof window === 'undefined' || !window.URL || !window.URL.createObjectURL) {
      resolve(file);
      return;
    }
    var objectUrl = window.URL.createObjectURL(file);
    var img = new window.Image();
    var cleanup = function cleanup() {
      try {
        window.URL.revokeObjectURL(objectUrl);
      } catch (e) {}
    };
    img.onload = function () {
      var target = computeTargetDimensions(img.naturalWidth || img.width, img.naturalHeight || img.height);
      var canvas = document.createElement('canvas');
      canvas.width = target.width;
      canvas.height = target.height;
      var ctx = canvas.getContext('2d');
      if (!ctx) {
        cleanup();
        resolve(file);
        return;
      }
      ctx.drawImage(img, 0, 0, target.width, target.height);
      canvas.toBlob(function (blob) {
        cleanup();
        if (!blob) {
          resolve(file);
          return;
        }
        // Never return a larger artifact than we started with — for already-tiny
        // images JPEG re-encoding can slightly inflate the bytes.
        if (blob.size >= file.size) {
          resolve(file);
          return;
        }
        try {
          var compressed = new File([blob], renameToJpeg(file.name), {
            type: 'image/jpeg',
            lastModified: Date.now()
          });
          resolve(compressed);
        } catch (err) {
          // Edge / older browsers without File constructor — return the blob
          // wrapped to look enough like a File for FormData purposes.
          blob.name = renameToJpeg(file.name);
          blob.lastModified = Date.now();
          resolve(blob);
        }
      }, 'image/jpeg', QUALITY);
    };
    img.onerror = function () {
      cleanup();
      resolve(file);
    };
    img.src = objectUrl;
  });
}
/* harmony default export */ __webpack_exports__["a"] = (compressReceiptImage);

/***/ }),

/***/ "D53q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{ref:"header",attrs:{"title":_vm.$t("Import " + _vm.programLabel + " Data")}},[_c('span',{attrs:{"slot":"action"},slot:"action"},[(_vm.$root.legacySubtab)?_c('router-link',{attrs:{"to":"/d/Admin/Import"}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_c('span',[_vm._v("  "+_vm._s(_vm.$t('Back') + ' ' + _vm.$t('to') + ' ' + _vm.$t(_vm.$root.legacySubtab)))])]):_vm._e()],1)]),_c('div',{staticClass:"container-fluid"},[_c('ed-section',{staticClass:"active",attrs:{"offset":""}},[_c('ed-tab-nav',{ref:"steps",staticClass:"col-md-12 steps uniform",attrs:{"steps":"","wide":"","check":_vm.uploadFileValid},on:{"tabSelected":_vm.enterStep}},[_c('ed-tab',{attrs:{"title":"Import File"}},[_c('ed-section',{staticClass:"col-md-9 active",attrs:{"offset":"4"}},[_c('h5',[_vm._v("Import your "+_vm._s(_vm.programLabel.toLowerCase())+" data file")]),_c('p',[_vm._v("Imports will update existing or create new "+_vm._s(_vm.programsLabel.toLowerCase())+" based on looking at\nthe "+_vm._s(_vm.programLabel)+" IDs of existing "+_vm._s(_vm.programsLabel)+" in Eved.\nFields in the "+_vm._s(_vm.programLabel)+" Information, Build Agenda, Cost Centers & Budget,\nand Team Tab sections in the "+_vm._s(_vm.programLabel)+" module can be added or updated with this import.")]),_c('p',[_vm._v("If the imported data has more than one tab, the first tab will be imported.")]),_c('p',[_vm._v("Column heading must begin on Row 1.")]),_c('p',[_vm._v("Accepted file formats are .xls and .xlsx")]),_c('ed-form',{attrs:{"endpoint":_vm.api.env + _vm.api.$.program.upload,"no-submit":"","submit-visible":false}},[_c('ed-upload',{attrs:{"button-label":"Browse","helptipHeader":"Error","helptipBody":_vm.uploadFileError,"error":!_vm.uploadFileValid,"showHelptipIcon":false,"required":"","upload-auto":"","accept":"application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet","extensions":"xls,xlsx"},model:{value:(_vm.attachedFile),callback:function ($$v) {_vm.attachedFile=$$v},expression:"attachedFile"}})],1)],1)],1),_c('ed-tab',{attrs:{"title":"Match Columns","endpoint":_vm.api.$.program.import,"data":"data","payload":_vm.data.FieldsMap,"feedback":"errors","validate":"checkMatched"}},[_c('ed-section',{staticClass:"col-md-12 active"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('p',[_vm._v("Use the table below to match the Column Headers from Row 1 of\nyour uploaded file to match to your "+_vm._s(_vm.programLabel)+" Fields in Eved.")]),_c('p',[_vm._v("Required fields are indicated with an "),_c('strong',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(". All required fields must have\na column matched to them to move to Step 3.")])]),_c('p'),_c('ed-form',{staticClass:"col-md-10 col-md-offset-1",attrs:{"endpoint":_vm.api.$.program.create,"submit-visible":false}},[_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.FieldsMap && _vm.data.FieldsMap[0].FieldName !== null),expression:"data.FieldsMap && data.FieldsMap[0].FieldName !== null"}],staticClass:"table table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "+_vm._s(_vm.programLabel)+" Field")]),_c('th',[_c('br'),_vm._v(" Column Header in File")])])]),_c('tbody',_vm._l((_vm.updateMatches(_vm.data.FieldsMap, _vm.data.ImportedColumns)),function(field,index){return _c('tr',{class:{ "required": field.IsRequired && !(field.Columns && field.Columns.length) }},[_c('td',[_vm._v(_vm._s(field.FieldName)+" "),_c('strong',{staticClass:"text-danger"},[_vm._v(_vm._s(field.IsRequired ? '*' : ''))])]),_c('td',[_c('ed-select',{attrs:{"options":_vm.getImportedColumns(index),"value":_vm.columnName(field.Columns, field.Type === "List"),"customLabel":_vm.columnName,"required":field.IsRequired},on:{"select":function($event){return _vm.handleMultimatch(field, $event)},"open":function($event){return _vm.fetchImportedColumns(_vm.data.ImportedColumns, index)}},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('ed-select-options',{attrs:{"thumbnails":""}},[_c('span',{attrs:{"slot":"row1"},slot:"row1"},[_c('kbd',[_vm._v(_vm._s(props.option.Letter))]),_vm._v("  "),_c('span',[_vm._v(_vm._s(props.option.Name || '[None]'))])])])]}}],null,true)},[(field.Columns && field.Columns.length === 1 && field.Type !== "List")?_c('a',{attrs:{"slot":"clear","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeMatch(field)}},slot:"clear"},[_c('i',{staticClass:"fas fa-times-circle add-icon"})]):_vm._e()]),(field.Type && field.Columns)?_c('div',{staticClass:"additional-match"},_vm._l((field.Columns),function(column){return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-6"},[_c('kbd',{staticClass:"pull-left"},[_vm._v(_vm._s(column.Letter))]),_c('small',{staticClass:"col-md-10"},[_vm._v(_vm._s(column.Name || "[None]"))])]),(_vm.initDetails(column, field))?_c('div',{staticClass:"col-md-5"},[_c('ed-select',{staticClass:"inline small",attrs:{"options":_vm.titles,"label":"Text","placeholder":"Title","openEndpoint":_vm.api.$.program.titles},on:{"open":_vm.fetchTitles},model:{value:(column.Details.Title),callback:function ($$v) {_vm.$set(column.Details, "Title", $$v)},expression:"column.Details.Title"}}),_c('ed-select',{staticClass:"inline small",attrs:{"options":_vm.permissions,"placeholder":"Permission","multiple":"","checkboxes":"","openEndpoint":_vm.api.$.program.permissions},on:{"open":_vm.fetchPermissions},model:{value:(column.Details.Permission),callback:function ($$v) {_vm.$set(column.Details, "Permission", $$v)},expression:"column.Details.Permission"}})],1):_vm._e(),_c('small',{staticClass:"col-md-1"},[_c('a',{staticClass:"pull-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeColumn(column, field)}}},[_c('i',{staticClass:"fas fa-times-circle"})])]),_c('br',{staticClass:"clear"}),_c('br')])}),0):_vm._e()],1)])}),0)])])],1)],1),_c('ed-tab',{attrs:{"title":"Review Errors","optional":"Import corrected file","errors":_vm.errors,"callback":"gotErrors"}},[_c('ed-section',{staticClass:"col-md-11 active"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('p',[_vm._v("The table below shows the errors in your file. Please correct\nthese errors in your file and return to step 1 to upload the\ncorrected file.")])]),_c('p'),_c('p'),_c('table',{staticClass:"table table-bordered col-md-10 col-md-offset-1"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Row")]),_c('th',[_vm._v("Column")]),_c('th',[_vm._v("Data")]),_c('th',[_vm._v("Column Header")]),_c('th',[_vm._v(_vm._s(_vm.programLabel)+" Field")]),_c('th',[_vm._v("Error Reason")])])]),_c('tbody',_vm._l((_vm.errors),function(error,i){return _c('tr',[_c('td',[_vm._v(_vm._s(error.Row))]),_c('td',[_vm._v(_vm._s(error.Column))]),_c('td',[_vm._v(_vm._s(error.Data))]),_c('td',[_vm._v(_vm._s(error.ColumnHeader))]),_c('td',[_vm._v(_vm._s(error.FieldName))]),_c('td',[_vm._v(_vm._s(error.ErrorReason))])])}),0)])])],1),_c('ed-tab',{attrs:{"title":"Finalize","button-label":"Ok"}},[_c('ed-section',{staticClass:"col-md-9 active"},[_c('div',{staticClass:"col-md-12 col-md-offset-4"},[_c('h3',[_vm._v("Import Successfully Initiated\n "),_c('i',{staticClass:"success inline"})]),_c('p',[_vm._v("No errors were found in your file and your "+_vm._s(_vm.programLabel.toLowerCase())+" data is being imported now.\nYou'll receive an email shortly when the import is complete and all data is updated in Eved.")]),_c('p'),_c('p'),_c('p')])])],1)],1)],1),(_vm.lastStep)?_c('ed-button',{staticClass:"pull-right btn btn-primary",attrs:{"to":"/d/Admin/Import"}},[_vm._v("Ok")]):_vm._e(),(!_vm.lastStep)?_c('ed-button',{staticClass:"pull-right",attrs:{"disabled":!_vm.uploadFileValid || !_vm.attachedFile},on:{"click":_vm.proceed}},[_vm._v(_vm._s(_vm.$t(_vm.nextLabel)))]):_vm._e(),(!_vm.lastStep)?_c('ed-button',{staticClass:"pull-right btn btn-secondary",attrs:{"to":"/d/Admin/Import"}},[_vm._v(_vm._s(_vm.$t('Cancel')))]):_vm._e(),_c('ed-modal',{attrs:{"show":_vm.notAllRequiredMatched,"title":"Check Unmatched Column Headers","subtitle":"Please match all required " + _vm.programLabel + " Fields to Column Headers in order to move on to the next step.","primaryButton":"Ok","secondaryButton":"false"},on:{"close":function($event){_vm.notAllRequiredMatched = false}}}),_c('ed-modal',{attrs:{"show":_vm.notAllMatched,"title":"Check Unmatched Column Headers","subtitle":"Not all of your Column Headers are matched to " + _vm.programLabel + " Fields. Do you still want to continue to the next step?","primaryButton":"Yes","secondaryButton":"No"},on:{"close":function($event){_vm.notAllMatched = false},"confirm":_vm.skipMatch}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D7n7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DEhj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3n2pKHtJ-NXwflQkYTPr4W","Dell":"_1VZ55aS9_yNKUzdr-0137L","Abbott":"_2EAqmHlisDkGv7xw5_UqVX","Gap":"_1wa-SxI1I8ss2SXV602v29","Allstate":"p74x_LJ8x5QVVb3ibW6ht","Asurion":"y7IpBLdvw6DGLOdxC1ING","Invitae":"_372w_MpVXg7mn4QI1Xin3e","JWE":"yW0731vVLcyCgSDgeJOit"};

/***/ }),

/***/ "DF+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.to && _vm.to.indexOf("javascript") < 0)?_c('a',_vm._b({on:{"click":function($event){return _vm.$emit("click", $event)}}},'a',_vm.$props,false),[_c('router-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2)],1):(!!_vm.href)?_c('a',_vm._b({class:_vm.buttonClass,on:{"click":function($event){return _vm.$emit("click", $event)}}},'a',_vm.$props,false),[_vm._t("default")],2):_c('button',_vm._b({staticClass:"dawn-button",class:_vm.buttonClass,on:{"click":function($event){return _vm.$emit("click", $event)}}},'button',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DGG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edTab_vue__ = __webpack_require__("YizL");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e713f18_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_edTab_vue__ = __webpack_require__("0SPT");
function injectStyle (ssrContext) {
  __webpack_require__("+rGs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e713f18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e713f18_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_edTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DI5E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funding-overlay"},[_c('p',{staticClass:"small"},[_vm._v("Your request will be sent to your card administrator for approval.")]),_vm._v(" "),_c('label',[_vm._v("Current Balance")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-money',{staticClass:"small",attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.balance))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Funding Amount")]),_vm._v(" "),_c('ed-input',{attrs:{"type":"money","amount":"","error":_vm.addFundsError},on:{"input":function (value) { return _vm.$emit('fundingAmount', value); }},model:{value:(_vm.fundingAmount),callback:function ($$v) {_vm.fundingAmount=$$v},expression:"fundingAmount"}},[(_vm.addFundsError)?_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n      "+_vm._s(_vm.errorMessage)+":\n      "),_c('strong',[_c('v-money',[_vm._v(_vm._s(_vm.balance))])],1)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DOYI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_44vjvuS3Oil-hlLi7LJQI","Dell":"_1okrxgyjxZQz1CozBDDQ6f","Abbott":"_3183STVklriKgFRvSvfduL","Gap":"gG0gL1pVK0RIla5yccNyr","Allstate":"_1-ovuHK9WFX-zzY2Fudctc","Asurion":"_33_b_gHdZSbHcexjg6xH-p","Invitae":"_1TuCzs2p_Xv85fJmfgE3qe","JWE":"_3aNUgWy0JsFK92m-ffyfWs"};

/***/ }),

/***/ "DQZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FundingAddress_vue__ = __webpack_require__("OA49");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MakePayment',
  components: {
    FundingAddress: __WEBPACK_IMPORTED_MODULE_1__components_FundingAddress_vue__["a" /* default */]
  },
  props: {
    model: Object,
    divisionKey: Number,
    achInfo: String
  },
  created: function created() {
    this.setPaymentMethodName();
  },
  data: function data() {
    return {
      paymentNotes: '',
      paymentMethods: [{
        Key: 1,
        Value: 'EvedPay'
      }]
    };
  },
  computed: {
    paymentMethod: function paymentMethod() {
      return this.paymentMethods[0];
    },
    formatAddress: function formatAddress(str) {
      return str.toString().replace('##', '<br />');
    },
    getFundingAddressOptions: function getFundingAddressOptions() {
      if (this.model.FundingAddresses) {
        for (var addr in this.model.FundingAddresses) {
          if (typeof addr.Value === 'string') {
            addr.Value = JSON.parse(addr.Value);
          }
        }
      }
      return this.model.FundingAddresses;
    }
  },
  methods: {
    fieldChanged: function fieldChanged() {
      this.$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].PAYMENT.DIVISION_FIELDS_CHANGES, {
        divisionName: this.model.DivisionName,
        note: this.paymentNotes
      });
    },
    setPaymentMethodName: function setPaymentMethodName() {
      var pm = 'EvedPay';
      if (this.achInfo !== '') {
        pm += ' **** ' + this.achInfo;
      }
      this.paymentMethods[0].Value = pm;
    },
    getFundingAddressLabel: function getFundingAddressLabel(option) {
      return option && option.Value && option.Value.Name ? option.Value.Name : '';
    }
  }
});

/***/ }),

/***/ "DRAn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DRjV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1SVUa1xfAjR1-jd53ZDB7h","Dell":"_20D4i0dipRpHIZEb9eMC8","Abbott":"_1HHk9GS1wuUeLmvkX1WRgR","Gap":"_1MHlqxUBFNWTRc0JRVkuHw","Allstate":"_1xwZuC9byxY53sHRA1cjjs","Asurion":"gZF-twRfCSrWDfvh8rrKT","Invitae":"_1A3jeiQPjAmAaTEyRLvuj4","JWE":"_2ekiLD63D0LnNvTdnvfbqw"};

/***/ }),

/***/ "DRsI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{staticClass:"invoice-email-form",attrs:{"title":"Invoice Email","show":_vm.show,"type":"small-medium"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"invoice-email-form",attrs:{"slot":"body"},slot:"body"},[_c('div',[_c('router-link',{staticClass:"open-link",attrs:{"to":{ path: '/d/Invoice/review-email', query: { invoiceId: _vm.paymentInvoiceId } },"target":"_blank"}},[_c('i',{staticClass:"fa fa-share-square"}),_vm._v(" Open in new tab\n        ")])],1),_vm._v(" "),_c('div',[_c('p',{staticClass:"email-label"},[_vm._v("Sender")]),_vm._v(" "),_c('p',{staticClass:"email-content"},[_vm._v(_vm._s(_vm.emailData.FromEmail))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"email-label"},[_vm._v("Subject")]),_vm._v(" "),_c('p',{staticClass:"email-content"},[_vm._v(_vm._s(_vm.emailData.Subject))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"email-label"},[_vm._v("Date")]),_vm._v(" "),_c('p',{staticClass:"email-content"},[_vm._v(_vm._s(_vm.formatDate(_vm.emailData.ReceivedDate)))])]),_vm._v(" "),_c('div',[_c('div',[_c('p',{staticClass:"email-label"},[_vm._v("Body")]),_vm._v(" "),_c('div',{staticClass:"email-list",domProps:{"innerHTML":_vm._s(_vm.emailData.OriginalBodyHtml)}})])]),_vm._v(" "),_c('div',[_c('div')])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n      CLOSE\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DRvl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceDetailsWithDivision_vue__ = __webpack_require__("f/R8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0913818e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceDetailsWithDivision_vue__ = __webpack_require__("UnLI");
function injectStyle (ssrContext) {
  __webpack_require__("9QHg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0913818e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceDetailsWithDivision_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0913818e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceDetailsWithDivision_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DWoL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2nL0-ZxA1ZJlYGXP7hWohv","Dell":"_1MvyuEMdOItqvKMRYTtMQA","Abbott":"_2M9L7-J-hdOdPHb9nlDtbT","Gap":"_13YUv9c70daFUP6pQuorrO","Allstate":"l3lRi_iweQPfyCUJCgPK5","Asurion":"_2iEInX776M7WQX9N52ouH-","Invitae":"d2iiHuGR_wn0EEQFXlBdY","JWE":"Pkp7zI4_Js_g-vSpzxoUa"};

/***/ }),

/***/ "DaOO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_9fT0-rLTS88599i_55Y3y","Dell":"hy0iYyxT5GWybHQwiUZWr","Abbott":"_14kcIQqDBdaHR_X5RE4IjE","Gap":"_9koQTUlmQDh7xfHArJKt_","Allstate":"_132dBZsOlx8BM-cClhvAw3","Asurion":"_2bEWmOzRq68qb2fUMmdap-","Invitae":"_2BHP_wO6BSWSaRyZmm7wST","JWE":"_2VDdYazH7ZeK7HJ3yIb90Z"};

/***/ }),

/***/ "Db+P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3-FkKb_SYJf7uzaEkIyQLd","Dell":"cwQOjf1zxFgtFLnFAzt9Q","Abbott":"_2BT9vFulbDRIqwbLz-0O0U","Gap":"_19n6ilZgpeEkCMLNfbJZro","Allstate":"_2m4mbamiRuXlqzm2umHgV4","Asurion":"_2hWR2lKlay0O0QNA1cJbRh","Invitae":"_10hczuHx0th_a1_boqbE9B","JWE":"_1RlCF5q-oox_lnoj9lVo4U"};

/***/ }),

/***/ "DdQI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dju2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgogICAgPHBhdGggZD0iTSAxNiAzIEMgOC44MzIxNDI5IDMgMyA4LjgzMjE0MjkgMyAxNiBDIDMgMjMuMTY3ODU3IDguODMyMTQyOSAyOSAxNiAyOSBDIDIzLjE2Nzg1NyAyOSAyOSAyMy4xNjc4NTcgMjkgMTYgQyAyOSA4LjgzMjE0MjkgMjMuMTY3ODU3IDMgMTYgMyB6IE0gMTYgNSBDIDIyLjA4Njk3NyA1IDI3IDkuOTEzMDIzMSAyNyAxNiBDIDI3IDIyLjA4Njk3NyAyMi4wODY5NzcgMjcgMTYgMjcgQyA5LjkxMzAyMzEgMjcgNSAyMi4wODY5NzcgNSAxNiBDIDUgOS45MTMwMjMxIDkuOTEzMDIzMSA1IDE2IDUgeiBNIDE0LjUxMzY3MiAxMi43ODcxMDkgTCAxMS44MDQ2ODggMTQuOTE3OTY5IEMgMTEuNDc1Njg3IDE0LjA5Mzk2OSAxMC42MDA3NjYgMTMuMzI0MjE5IDkuMzg0NzY1NiAxMy4zMjQyMTkgTCA3LjA2ODM1OTQgMTMuMzI0MjE5IEwgNy4wNjgzNTk0IDE4LjQ4NjMyOCBMIDkuMzgyODEyNSAxOC40ODYzMjggQyAxMC40NzM4MTMgMTguNDg2MzI4IDExLjQxMzY4NyAxNy44MzE1NzggMTEuODA0Njg4IDE2Ljg5MjU3OCBMIDE0LjUxMzY3MiAxOS4wMjM0MzggTCAxNy40NzY1NjIgMTYuNjkzMzU5IEwgMTcuNDc4NTE2IDE4LjQ4NDM3NSBMIDIxLjA3NDIxOSAxOC40ODQzNzUgTCAyMS4wNzQyMTkgMTYuOTc0NjA5IEwgMTkuMjgxMjUgMTYuOTc0NjA5IEwgMTkuMjgxMjUgMTMuMzIyMjY2IEwgMTcuNDc4NTE2IDEzLjMyMjI2NiBMIDE3LjQ3ODUxNiAxNS4xMTUyMzQgTCAxNC45OTQxNDEgMTcuMDY2NDA2IEwgMTQuNTE3NTc4IDE2LjY5MTQwNiBMIDE2Ljk5ODA0NyAxNC43NDAyMzQgTCAxNS45OTQxNDEgMTMuOTUxMTcyIEwgMTMuNTEzNjcyIDE1LjkwMjM0NCBMIDEzLjAzNzEwOSAxNS41MjkyOTcgTCAxNS41MTk1MzEgMTMuNTc2MTcyIEwgMTQuNTEzNjcyIDEyLjc4NzEwOSB6IE0gMjEuNTUwNzgxIDEzLjMyNDIxOSBMIDIxLjU1MDc4MSAxOC40ODYzMjggTCAyNS4xNDY0ODQgMTguNDg2MzI4IEwgMjUuMTQ2NDg0IDE2Ljk3ODUxNiBMIDIzLjM1MzUxNiAxNi45Nzg1MTYgTCAyMy4zNTM1MTYgMTMuMzI0MjE5IEwgMjEuNTUwNzgxIDEzLjMyNDIxOSB6IE0gOC44MDI3MzQ0IDE0LjgwODU5NCBMIDkuMjAzMTI1IDE0LjgwODU5NCBDIDkuODU4MTI1IDE0LjgwODU5NCAxMC4zMjIyNjYgMTUuMjA0MjUgMTAuMzIyMjY2IDE1LjkwNjI1IEMgMTAuMzIyMjY2IDE2LjY3MDI1IDkuODAxMzU5NCAxNy4wMDM5MDYgOS4xOTMzNTk0IDE3LjAwMzkwNiBMIDguODAyNzM0NCAxNy4wMDM5MDYgTCA4LjgwMjczNDQgMTQuODA4NTk0IHoiIGZpbGw9IiMwMDAwMDAiIHN0cm9rZT0ibm9uZSIgZmlsbC1ydWxlPSJub256ZXJvIiAvPgo8L3N2Zz4K"

/***/ }),

/***/ "DmJx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1QwNKgSIQAZGzye2ua897A","Dell":"_2NKOH16jOL0iOFUCCmRyTB","Abbott":"_2SwOJpwhmuH8hRWyE0lTcX","Gap":"IkRKtjVNSmm0a688FNLJU","Allstate":"_1cKdE5sU94EpAlFarqXN_G","Asurion":"_2YxzKPrlDZ4QKwDiv8SYu1","Invitae":"_1QJ3-J2Fa-44DroL_HJIfB","JWE":"_2DnogfrLJwDLgf7CkuK8m_"};

/***/ }),

/***/ "E15f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"NUpbH1lH6vJB332FUY-Z-","Dell":"_3iZoVGEC-dD-2I7MzlgVK9","Abbott":"_3b1S8Ox0xz8314hWXuC3T9","Gap":"_1DUvyIVZKKF4dOQGm6Zcgk","Allstate":"_3dHn4uBw9l0sCepbSJE_W_","Asurion":"_1txzPg6jTJi1VeKp9JCfVW","Invitae":"_2f5a7s4B8NxKVz2PLHm2CT","JWE":"_2t7c4FE2-qNcZegSyAryC-"};

/***/ }),

/***/ "E1GH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__("Ku5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adapters__ = __webpack_require__("Nv6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_exporter__ = __webpack_require__("oYUa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__export_data__ = __webpack_require__("Bw9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__column_selector__ = __webpack_require__("RR0Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__header__ = __webpack_require__("T67l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_perfect_scrollbar__ = __webpack_require__("HMpe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar_css_perfect_scrollbar_css__ = __webpack_require__("m5D7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_sass_grid_theme_scss__ = __webpack_require__("Om/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_sass_grid_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_sass_grid_theme_scss__);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * Grid module
 * @module components/Grid
 *
 */





// plugins





// skins



var ALL_ROWS_SELECTED = 1;
var NO_ROWS_SELECTED = 0;
var ROW_HEIGHT = 35;
var HEADER_HEIGHT = 40;
var EXPANDED_ROW_HEIGHT = 120;
var BOTTOM_PADDING = 55;
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    uid: {
      type: String,
      default: function _default() {
        return "grid-".concat(this._uid);
      }
    },
    name: String,
    // grid name that shows in the rendered title and in search placeholders
    label: String,
    // text representation of the entity
    desc: String,
    // grid description that shows in the rendered subtitle
    alias: String,
    // name used for retrieving grid bound data from backend
    endpoint: String,
    // url to retrieve data from (@link module:core/api and @link module:core/api/map)
    endpointPayloadType: {
      type: String,
      default: 'form'
    },
    endpointMethod: {
      type: String,
      default: 'post'
    },
    permissions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    screen: String,
    // screen/tab name to retrieve data from (@link module:core/api/map)
    model: Object,
    // column model (either passed or exported by refering/parent module)
    search: Boolean,
    // grid has top search bar displayed or not
    searchPlaceholder: String,
    // Default Current View text and search placeholder
    tabs: Array,
    // additional tabs
    allowExport: {
      type: Boolean,
      // allow data to be exported (@link module:components/Grid/export-data)
      default: true
    },
    exportUri: String,
    // path to endpoint from where to retrieve export data
    views: {
      type: Boolean,
      // grid has multiple views (sets of filtered data) (@link module:components/Grid/views)
      default: true
    },
    checkboxes: {
      type: Boolean,
      // rows can be selected
      default: true
    },
    hideSelectAll: {
      type: Boolean // hides select all
    },
    sorting: {
      type: Boolean,
      // columns have sorting enabled
      default: true
    },
    pinning: {
      type: Boolean,
      // columns can be pinned
      default: false
    },
    reordering: Boolean,
    // columns can be reordered
    resizing: Boolean,
    // columns can be resized
    visibility: Boolean,
    // grid has column selector (@link module:components/Grid/column-selector)
    footer: Boolean,
    // grid has footer
    legacy: Boolean,
    layout: {
      type: String,
      // grid layout (page, frame,small, widget)
      default: function _default() {
        if (~this.$parent.$parent.$vnode.tag.indexOf('-widget')) {
          return 'widget';
        }
        return 'page';
      },
      validator: function validator(val) {
        return ['page', 'frame', 'small', 'widget'].indexOf(val) >= 0;
      }
    },
    filter: Object,
    // initial filter
    onlyVisibleColumns: Boolean,
    defaultView: Object,
    // default view (filter set)
    customViews: Boolean,
    // allows to customize views
    sort: Object,
    // initial sort
    disableFilter: Boolean,
    data: Array,
    // row data
    actions: Array,
    // row actions
    autoHeight: Boolean,
    // grid expands/contracts to fit rows
    fitColumns: Boolean,
    // columns expand/contract to fit grid width

    dragRows: Boolean,
    removeMany: Boolean,
    validateRemoveMany: {
      type: Function,
      default: undefined
    },
    cloneMany: Boolean,
    validateCloneMany: {
      type: Function,
      default: undefined
    },
    undo: Boolean,
    editable: {
      // this is true when all columns are editable
      type: Boolean,
      default: undefined
    },
    editFullRowOnAdd: Boolean,
    // this should be used when the grid is not editable at all (none of the colums is editable)
    totals: Boolean,
    total: [Number, String, Object],
    totalsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableErrorMessage: Boolean,
    helptipHeader: String,
    helptipBody: String,
    currencyCode: String,
    rowDetailsComponent: Object,
    showColumnSelector: {
      type: Boolean,
      default: true
    },
    rowClasses: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    additionalFilters: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    canRemoveDefaultFilter: Boolean,
    resetNotifications: 0,
    canShowNotifications: Boolean,
    noTooltipFields: {
      type: Array,
      default: []
    }
  },
  computed: {
    Notifications: function Notifications() {
      return this.$notifications.state;
    },
    getSize: function getSize() {
      return this.data && this.autoHeight ? {
        width: '100%',
        'height': "".concat(this.data && (this.data.length + 1) * ROW_HEIGHT + HEADER_HEIGHT + BOTTOM_PADDING + this.expandedRows * EXPANDED_ROW_HEIGHT + this.expandOffset, "px"),
        'min-height': '80px'
      } : {
        width: '100%',
        height: "".concat(HEADER_HEIGHT + ROW_HEIGHT * 10.5, "px") // '650px'
      };
    },
    quickSearchPlaceholder: function quickSearchPlaceholder() {
      var t = this.$t;
      return this.currentView ? "".concat(t('Search'), " ").concat(this.currentView && this.currentView.Label) : this.searchPlaceholder ? "".concat(t('Search'), " ").concat(t(this.searchPlaceholder)) : t('Search');
    },
    currency: function currency() {
      return this.currencyCode || this.$parent.currency;
    },
    viewToBeSavedValid: function viewToBeSavedValid() {
      var _this = this;
      var matchSavedViews = this.savedViews.map(function (k) {
        return k.Label;
      }).filter(function (k) {
        return k === _this.viewToBeSaved.label;
      });
      return !matchSavedViews.length;
    },
    backendSavedViews: function backendSavedViews() {
      return this.savedViews.length > 1 && this.savedViews[0] && this.savedViews[0].FilterJson;
    }
  },
  data: function data() {
    return {
      /**
       * Used for top quick search across all columns (@link method:quickSearch)
       */
      noOfRecords: 0,
      shownDetails: (this.$store.state.gridExpandOffset || {})[this.uid] || false,
      shownPopover: false,
      loading: true,
      searchTerm: '',
      currentView: null,
      currentViewChanged: false,
      doNotShowOverlay: false,
      filters: [],
      savedViews: [],
      viewToBeSaved: {
        label: ''
      },
      allRowsSelected: null,
      selectedRows: [],
      unSelectedRows: [],
      updatedCells: [],
      expandedRows: 0,
      noOfExpandedRows: 0,
      expandOffset: (this.$store.state.gridExpandOffset || {})[this.uid] || 0,
      permissionsMix: Object.keys(this.permissions).length === 0 ? this.$user.$.claims || [] : this.permissions,
      totalsInvalid: false,
      canShowNotifications: true,
      pendingRequests: 0,
      cellToFocus: {}
    };
  },
  created: function created() {
    var _this2 = this;
    this.initSavedViews();
    this.initModel();
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.LANGUAGE_CHANGED, this.updateLocales);
    this.$on('redraw', function () {
      return _this2.ps.update();
    });
    this.$on('expandedRow', this.expandedRow);
  },
  updated: function updated() {
    this.loading = false;
  },
  beforeMount: function beforeMount() {
    this.initGrid();
  },
  beforeDestroy: function beforeDestroy() {
    this.$notifications.removeAll();
  },
  mounted: function mounted() {
    this.initScrollbar();
    this.attachSelectAllRows();
    this.attachActions();
    this.initDragDrop();
    this.initToggleButton();
  },
  methods: {
    noResults: function noResults() {
      return this.gridOptions.api && this.gridOptions.api.rowRenderer.lastRenderedRow < 0;
    },
    validateCells: function validateCells() {
      var invalidCell = this.$el.querySelector('.ag-custom-cell.invalid-amount');
      invalidCell && invalidCell.__vue__.notify(true);
      return invalidCell;
    },
    initToggleButton: function initToggleButton() {
      var _this3 = this;
      var button = this.$el.querySelector('.actions-bar [toggle]') && this.$el.querySelector('.actions-bar [toggle]').__vue__;
      if (button) {
        var columns = button.$attrs.toggle;
        var text = this.toggleButtonText || button.$el.getAttribute('data-toggle-text') || button.$el.innerText;
        this.toggledColumns = columns;
        this.toggleButtonText = text;
        var toggleTextInfo = {
          button: button,
          text: text,
          columns: columns
        };
        button.$el.setAttribute('data-toggle-text', button.$el.innerText);
        this.toggleText(toggleTextInfo);
        button.$el.onclick = function (event) {
          _this3.toggleColumns(columns);
          _this3.toggleText(toggleTextInfo);
        };
      }
    },
    toggleText: function toggleText(toggleTextInfo) {
      var visible = this.toggleColumns(toggleTextInfo.columns, null);
      toggleTextInfo.button.$el.innerText = visible ? "Hide ".concat(toggleTextInfo.text) : "Show ".concat(toggleTextInfo.text);
    },
    /**
     * Get any draft data from storage
     *
     */
    checkDraftData: function checkDraftData() {
      if (this.checkDraftData.alreadyChecked || !this.gridOptions.datasource.loaded) return;
      var grid = this;
      if (localStorage.getItem('evedDraftData') && JSON.parse(localStorage.getItem('evedDraftData')).draft === this.endpoint) {
        //
        this.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: {
            from: 'top',
            align: 'center'
          },
          timeout: 0,
          message: "".concat(this.$t('You have unsaved data. Restore ?')),
          dismiss: this.$t('Yes'),
          goto: null,
          onClose: function onClose(dismiss) {
            if (dismiss) {
              grid.restoreDraft();
            } else if (dismiss === null) {
              localStorage.removeItem('evedDraftData');
            }
          }
        });
        // don't check again
        this.checkDraftData.alreadyChecked = true;
      }
    },
    restoreDraft: function restoreDraft() {
      var data = JSON.parse(localStorage.getItem('evedDraftData')).data;
      data && this.gridOptions.api.forEachNode(function (node) {
        if (data[node.rowIndex]) {
          data[node.rowIndex].data.draft = true;
          node.setData(data[node.rowIndex].data);
        }
      });
      this.keepRestoringDraft = true;
    },
    /**
     * Get saved views from backend
     *
     */
    initSavedViews: function initSavedViews() {
      var _this4 = this;
      if (this.alias) {
        this.loading = true;
        this.api.forms.post(this.api.$.common.filterViews, {
          action: 'list',
          Alias: this.alias
        }).then(function (r) {
          _this4.loading = false;
          if (r && r.data.Data) {
            var defaultView = null;
            _this4.defViewIndex = 0;
            _this4.savedViews = r.data.Data.length ? r.data.Data : [{}];
            _this4.savedViews.map(function (k, i) {
              k.Label === '~last.Search=' && (_this4.defViewIndex = i);
              if (k.IsDefault) {
                defaultView = k;
              }
            });
            _this4.savedViews[_this4.defViewIndex].Label = _this4.label || 'All ' + (_this4.searchPlaceholder || _this4.name);
            _this4.savedViews[_this4.defViewIndex].icon = 'fas fa-eye';
            if (_this4.defaultView) {
              _this4.defViewIndex++;
              _this4.savedViews.splice(0, 0, {
                Label: _this4.defaultView.label,
                FilterJson: JSON.stringify(_this4.defaultView.filter),
                icon: _this4.defaultView.icon
              });
            }
            if (defaultView) {
              _this4.currentView = defaultView;
              _this4.currentView.icon = _this4.defaultView.icon;
              _this4.savedViews[0].icon = null;
            } else {
              _this4.currentView = _this4.savedViews[0];
            }
            if (_this4.filter) {
              _this4.gridOptions.api.setFilterModel(_this4.filter);
              _this4.isInitialFilter = true;
            } else {
              _this4.applySavedFilter(_this4.currentView);
            }
            if (_this4.sort) {
              _this4.gridOptions.api.setSortModel(__WEBPACK_IMPORTED_MODULE_3__adapters__["c" /* Model */].sort(_this4.sort));
            }
          } else {
            // Notification message
            // (probably session expired)
            _this4.$store.commit('updateSessionValidity', null);
          }
        });
      } else {
        this.loading = false;
      }
    },
    /**
     * Apply saved view (filter)
     *
     */
    applySavedFilter: function applySavedFilter(filter) {
      var _this5 = this;
      this.currentViewChanged = true;
      if (this.gridOptions.api) {
        this.gridOptions.api.setFilterModel(null);
        this.gridOptions.api.setFilterModel(__WEBPACK_IMPORTED_MODULE_3__adapters__["b" /* Filter */].mixout.call(this, filter.FilterJson, this.$parent.model || this.model));
        var columnsToShow = filter.FilterJson && JSON.parse(filter.FilterJson).ColumnsToShow;
        if (columnsToShow) {
          this.$nextTick(function () {
            _this5.gridOptions.columnApi.getAllColumns().map(function (column) {
              if (column.colDef.headerName !== '_') {
                var visible = columnsToShow.indexOf(column.colId) > -1;
                _this5.gridOptions.columnApi.setColumnVisible(column.colId, visible);
                _this5.$refs.columnSelector.toggleColumn(column, visible);
              }
            });
          });
        }
      }
    },
    /**
     * Save a view (filter)
     *
     */
    saveView: function saveView() {
      var _this6 = this;
      this.api.forms.post(this.api.$.common.filterViews, {
        action: 'save',
        UGFID: 0,
        Label: this.viewToBeSaved.label,
        Alias: this.alias,
        FilterJson: JSON.stringify(this.getCurrentView()),
        SortJson: '{}'
      }).then(function (r) {
        _this6.savedViews.push({
          UGFID: r.data.UGFID,
          Label: _this6.viewToBeSaved.label,
          FilterJson: JSON.stringify(_this6.getCurrentView())
        });
        _this6.currentView = {
          Label: _this6.viewToBeSaved.label
        };
        _this6.viewToBeSaved = {
          label: '',
          FilterJson: '{}'
        };
        _this6.$refs.currentViewList.deactivate();
      });
    },
    /**
     * Update a view (filter)
     *
     */
    updateView: function updateView() {
      var _this7 = this;
      this.api.forms.post(this.api.$.common.filterViews, {
        action: 'save',
        UGFID: this.currentView.UGFID,
        Label: '',
        Alias: this.alias,
        FilterJson: JSON.stringify(this.getCurrentView()),
        SortJson: '{}'
      }).then(function (r) {
        //
        _this7.$refs.currentViewList.deactivate();
      });
    },
    /**
     * Set a view as default (filter)
     *
     */
    setDefaultView: function setDefaultView(view) {
      var _this8 = this;
      if (!this.customViews) return;
      this.currentView.icon = null;
      this.api.forms.post(this.api.$.common.filterViews, {
        action: 'setDefault',
        UGFID: view.UGFID,
        Alias: this.alias
      }).then(function (r) {
        _this8.currentView.endpoint = null;
        _this8.currentView = _this8.savedViews[_this8.savedViews.indexOf(view)];
        _this8.currentView.icon = _this8.defaultView.icon;
        // this.applySavedFilter(this.currentView)

        _this8.$refs.currentViewList.deactivate();
      });
    },
    /**
     * Remove a view (filter)
     *
     */
    removeView: function removeView(view) {
      var _this9 = this;
      this.api.forms.post(this.api.$.common.filterViews, {
        action: 'delete',
        UGFID: view.UGFID,
        Alias: this.alias
      }).then(function (r) {
        _this9.savedViews.splice(_this9.savedViews.indexOf(view), 1);
        _this9.currentView = _this9.savedViews[0];
        // this.applySavedFilter(this.savedViews[0])

        _this9.$refs.currentViewList.deactivate();
      });
    },
    /**
     * Get the filters and/or columns
     *
     */
    getCurrentView: function getCurrentView() {
      var filters = __WEBPACK_IMPORTED_MODULE_3__adapters__["b" /* Filter */].mixin(this.gridOptions.api.getFilterModel());
      var columns = this.gridOptions.columnApi.getAllDisplayedColumns().filter(function (column) {
        return column.colDef.headerName !== '_';
      }).map(function (column) {
        return column.colId;
      });
      return _objectSpread(_objectSpread({}, filters), {}, {
        ColumnsToShow: columns
      });
    },
    /**
     * Maps backend model (exported by refering/parent module) to column model
     *
     */
    initModel: function initModel() {
      var model = this.$parent.model || this.model || {};
      var actions = this.$parent.actions || this.actions || [];
      this.columnDefs = __WEBPACK_IMPORTED_MODULE_3__adapters__["c" /* Model */].mixin(model, actions, this);

      // default column
      this.defaultColumn = this.model ? Object.keys(this.model)[1] : this.columnDefs[1].field;
    },
    /**
     * Binds grid options and endpoint
     *
     */
    initGrid: function initGrid() {
      var _this10 = this;
      var grid = this;
      this.gridOptions = {
        context: this,
        headerHeight: HEADER_HEIGHT,
        // header height (px)
        rowHeight: ROW_HEIGHT,
        // row height (px)
        getRowHeight: function getRowHeight(p) {
          p.node.expanded ? _this10.noOfExpandedRows++ : _this10.noOfExpandedRows--;
          if (p.node.expanded) return EXPANDED_ROW_HEIGHT;
          return p.node.rowPinned ? HEADER_HEIGHT : ROW_HEIGHT;
        },
        rowClassRules: this.rowClass(this),
        defaultColDef: {
          suppressMovable: !this.reordering,
          headerComponentFramework: __WEBPACK_IMPORTED_MODULE_7__header__["a" /* default */],
          // enableCellChangeFlash   : true,
          unSortIcon: true,
          // always show sort icon
          checkboxSelection: this.checkboxes ? this.isFirstColumn // enable checkbox row selector
          : false
          /**
           * Selecting all rows is not supported for virtual scrolling
           * (@link method:attachSelectAllRows)
           */
          // headerCheckboxSelection : this.isFirstColumn
        },
        editType: this.editFullRowOnAdd ? 'fullRow' : undefined,
        singleClickEdit: this.editable !== false,
        stopEditingWhenGridLosesFocus: true,
        processRowPostCreate: function processRowPostCreate(p) {
          return _this10.processRow(p, _this10);
        },
        columnDefs: this.columnDefs,
        // column model

        pinning: this.pinning,
        // suppress animations for moving/pinning columns (avoids flicker in IE)
        // suppressColumnMoveAnimation: true,
        // suppressAnimationFrame: true,

        enableFilter: true,
        // enable column filtering ui
        rowModelType: this.data ? null : 'infinite',
        // enable virtual scrolling
        rowData: this.data,
        pinnedBottomRowData: this.totals ? this.getTotals() : null,
        maxBlocksInCache: 2,
        // cache only 2 sets of data(pages)
        cacheBlockSize: 100,
        // default of 100 rows per set of data(page)
        enableServerSideSorting: !this.data,
        // sorting on backend
        enableServerSideFilter: !this.data,
        // filtering on backend
        enableSorting: this.sorting,
        sortingOrder: ['asc', 'desc'],
        datasource: this.data ? null : __WEBPACK_IMPORTED_MODULE_3__adapters__["a" /* Data */].fetch(this),
        // fetch data from backend

        rowSelection: 'multiple',
        // selectable rows
        rowDeselection: false,
        suppressRowClickSelection: true,
        // onSelectionChanged        : this.onSelectRow,
        onRowSelected: this.onSelectRow,
        onDisplayedColumnsChanged: this.onColumnsVisibleChanged,
        onColumnVisible: this.onColumnVisibilityChanged,
        // onVirtualColumnsChanged   : this.onColumnsDisplayedChanged,

        onFilterChanged: this.handleFilters,
        // filter callbacks for external filtering
        onModelUpdated: this.data || this.onDataLoaded,
        // data loaded callback

        postProcessPopup: this.handlePopups,
        // popups behavior

        onCellEditingStarted: this.handleCellEdit,
        onCellValueChanged: this.handleInlineEdit,
        // inline editing
        onRowValueChanged: this.handleInlineEditRow,
        // inline editing

        overlayNoRowsTemplate: "<div>\n                                      <i class=\"icon far fa-times-circle\"></i>\n                                      <p t-key=\"Nothing to show\">".concat(this.$t('Nothing to show'), "</p>\n                                    </div>"),
        onBodyScroll: this.onViewportChanged,
        onGridReady: this.fitColumns && function (params) {
          grid.autoFitColumns();
          // grid.updatePs()
        }
      };
    },
    autoFitColumns: function autoFitColumns() {
      var visibleColumns = this.$refs.columnSelector ? this.$refs.columnSelector.columnsList.filter(function (k) {
        return !k.hide && k.headerName !== '_';
      }).length : 0;
      this.fitColumns && visibleColumns <= 10 && this.gridOptions.api && this.gridOptions.api.sizeColumnsToFit();
      this.updatePs();
    },
    updatePs: function updatePs() {
      var _this11 = this;
      this.$nextTick(function () {
        return _this11.ps.update();
      });
    },
    refreshGrid: function refreshGrid() {
      this.quickSearch();
      this.onSelectAll(false);
    },
    /**
     * Refresh cache to trigger datasource reload with new @link data:searchTerm
     *
     */
    quickSearch: function quickSearch() {
      var quickFilter = {
        key: 'quickSearch',
        label: this.searchTerm
      };
      if (this.data) {
        this.gridOptions.api.setQuickFilter(this.searchTerm);
      } else {
        this.gridOptions.api.refreshInfiniteCache();
      }
      var quickFilterIndex = this.filters.findIndex(function (filter) {
        return filter.key === quickFilter.key;
      });

      // replace the quick filter in the filters bar
      if (this.searchTerm) {
        ~quickFilterIndex && this.filters.splice(quickFilterIndex, 1);
        this.filters.push(quickFilter);
      } else {
        ~quickFilterIndex && this.filters.splice(quickFilterIndex, 1);
      }
    },
    isFirstColumn: function isFirstColumn(params) {
      var displayedColumns = params.columnApi.getAllDisplayedColumns();
      var firstKey = this.dragRows ? 1 : 0;
      var thisIsFirstColumn = displayedColumns[firstKey] === params.column;
      return thisIsFirstColumn;
    },
    onColumnVisibilityChanged: function onColumnVisibilityChanged(params) {
      this.initToggleButton();
      var columnHeaderElement = params.column && this.$el.querySelector('[col-id="' + params.column.colId + '"]');
      if (!columnHeaderElement) return;

      // update select all state
      if (this.allRowsSelected) {
        columnHeaderElement.querySelector('.ag-checkbox-checked').classList.remove('ag-hidden');
        columnHeaderElement.querySelector('.ag-checkbox-unchecked').classList.add('ag-hidden');
      }

      //
      this.fitColumns && this.gridOptions.api.sizeColumnsToFit();
    },
    onColumnsVisibleChanged: function onColumnsVisibleChanged() {
      this.autoFitColumns();
    },
    onColumnsDisplayedChanged: function onColumnsDisplayedChanged(params) {
      //
    },
    toggleColumns: function toggleColumns(columns, check) {
      var visible = true;
      var _iterator = _createForOfIteratorHelper(columns),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var column = _step.value;
          if (this.gridOptions.columnApi.getColumn(column) && !this.gridOptions.columnApi.getColumn(column).visible) {
            visible = false;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (check !== null) {
        this.gridOptions.columnApi.setColumnsVisible(columns, !visible);
      } else {
        //
      }
      return visible;
    },
    onSelectAll: function onSelectAll(checked) {
      // select/deselect all rows and persist selections
      this.allRowsSelected = checked;
      this.restoreRowSelections(checked);

      // reset selection
      if (!checked) {
        this.selectedRows = [];
        this.unSelectedRows = [];
        this.allRowsSelected = this.gridOptions.api.getSelectedRows().length === 0 ? null : this.allRowsSelected;
        //
        __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ALL);
        this.$emit('selectedRows', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.SELECTED_ALL);
        this.$emit('selectedRows', true);

        // redraw totals
        if (this.gridOptions && this.gridOptions.api && this.totals && this.allRowsSelected) {
          this.gridOptions.api.redrawRows({
            rowNodes: [this.gridOptions.api.getPinnedBottomRow(0)]
          });
        }
      }
    },
    onSelectRow: function onSelectRow(event) {
      var selected = this.gridOptions && this.gridOptions.api && this.gridOptions.api.getSelectedNodes();
      this.$emit('selectedRows', selected);

      // redraw totals
      if (this.gridOptions && this.gridOptions.api && this.totals && this.selectedRows !== ALL_ROWS_SELECTED && this.selectedRows !== NO_ROWS_SELECTED) {
        this.gridOptions.api.redrawRows({
          rowNodes: [this.gridOptions.api.getPinnedBottomRow(0)]
        });
      }

      // emit UNSELECTED_ALL if unselecting last selected row
      if (selected && !selected.length) {
        this.onSelectAll(false);
      }
      if ((this.selectedRows === ALL_ROWS_SELECTED || this.selectedRows === NO_ROWS_SELECTED) && event.node.selected && this.allRowsSelected || !event.node.selected && this.allRowsSelected === false || !event.node.selected && this.allRowsSelected === null && !this.selectedRows.length) return;
      if (event.node.selected) {
        // remove any selected rows from the unselected list
        this.unSelectedRows.length && this.unSelectedRows.splice(this.unSelectedRows.indexOf(event.node.data), 1);
        //
      } else {
        // add unselected rows to the unselected list
        this.selectedRows === ALL_ROWS_SELECTED ? this.unSelectedRows.push(event.node.data) : null;
        this.allRowsSelected = false;
        //
      }

      // reset selected rows list
      this.selectedRows = this.allRowsSelected === true ? ALL_ROWS_SELECTED : this.allRowsSelected === false ? NO_ROWS_SELECTED : this.gridOptions.api ? this.gridOptions.api.getSelectedRows() : NO_ROWS_SELECTED;
      if (this.selectedRows === NO_ROWS_SELECTED) {
        this.selectedRows = [];
      }

      //
      this.selectedRows.length && __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.SELECTED_ITEM, this.selectedRows);
      this.unSelectedRows.length && __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ITEM, this.unSelectedRows);
    },
    onDataLoaded: function onDataLoaded() {
      // get draft
      this.checkDraftData();
      this.keepRestoringDraft && this.restoreDraft();

      // this.restoreRowSelections(this.allRowsSelected)

      /* !this.viewportReady && */
      this.autoFitColumns();
      if (!this.value) {
        this.noOfRecords = this.gridOptions.api.rowModel.infiniteCache.virtualRowCount;
      }

      // adding new row
      if (this.addedRow) {
        this.addRow();
        delete this.addedRow;
      }
    },
    /**
     * Restores selected rows
     *
     */
    restoreRowSelections: function restoreRowSelections(checked) {
      this.gridOptions.api.forEachNode(function (node) {
        node.setSelected(checked);
      });
    },
    /**
     * Handle popups behavior
     *
     */
    handlePopups: function handlePopups(p) {
      var filterInstance = p.column.gridApi.getFilterInstance(p.column.colDef.field).component.$refs.input;

      // reset auto filter
      p.column.colDef.auto = false;

      // hook transitions
      if (p.column.colDef.closeFilter) {
        p.ePopup.className = 'ag-menu fade out';
        p.ePopup.style.display = 'none';
        p.column.colDef.closeFilter = false;
      } else {
        p.ePopup.className = 'ag-menu fade in';
      }

      // autofocus search input
      if (filterInstance.$refs.input) {
        filterInstance.$refs.input.focus();
      }

      // ref to column filter trigger for filter editing
      p.column.colDef.menuTrigger = p.eventSource;

      // FIXME: (hide other stuck filter components)
      setTimeout(function () {
        global.jQuery('.ag-menu.fade.in').length > 1 && global.jQuery('.ag-menu.fade.in:first').remove();
      }, 100);
    },
    /**
     * Handle filters from the top filters bar
     *
     */
    handleFilters: function handleFilters(e) {
      var _this12 = this;
      var appliedFilters = e.api.getFilterModel();
      var filters = [];
      var quickFilter = {
        key: 'quickSearch',
        label: this.searchTerm
      };
      if (this.data && this.gridOptions.api.filterManager.quickFilter) {
        filters[0] = quickFilter;
      }
      Object.keys(appliedFilters).forEach(function (filter) {
        var filterLabel = appliedFilters[filter].filter;
        var formattedLabel = appliedFilters[filter].formattedFilter;
        var column = _this12.gridOptions.columnApi.getColumn(filter);
        if (filterLabel || formattedLabel) {
          if (column.colDef.source) {
            filterLabel = (formattedLabel || filterLabel).replace(/_/g, ', ');
          } else {
            filterLabel = (formattedLabel || filterLabel).replace(/_/g, ' - ');
          }
        }
        if (appliedFilters[filter].filter && column.visible) {
          // ~this.additionalFilters.indexOf(filter) ||
          filters.push({
            key: filter,
            label: filterLabel,
            column: column.colDef.headerName
          });
        }
        if (_this12.searchTerm) {
          filters.push(quickFilter);
        }
      });
      this.filters = utils.copy(filters);

      // hide filter
      setTimeout(function () {
        var lastFilter = filters.pop();
        lastFilter = lastFilter ? lastFilter.key : null;
        var lastFilteredColumn = _this12.gridOptions.columnApi && _this12.gridOptions.columnApi.getColumn(lastFilter) ? _this12.gridOptions.columnApi.getColumn(lastFilter).colDef : null;
        if (lastFilter && lastFilteredColumn) {
          if (!_this12.isInitialFilter) {
            lastFilteredColumn.closeFilter = true;
            lastFilteredColumn.menuTrigger && lastFilteredColumn.menuTrigger.click();
          }
          _this12.isInitialFilter = false;
        }
      }, 500);
    },
    /**
     * Edit a filter (trigger corresponding filter)
     *
     */
    editFilter: function editFilter(filter) {
      var _this13 = this;
      if (filter.key === 'quickSearch') {
        var input = this.$refs.quickSearch.$refs.input;
        input.focus();
        input.setSelectionRange(0, input.value.length);
      } else {
        this.gridOptions.api.ensureColumnVisible(filter.key);
        setTimeout(function () {
          _this13.$refs.grid.$el.querySelector("[col-id=\"".concat(filter.key, "\"] .header-label")).click();
        }, 150);
      }
    },
    /**
     * Remove individual filters
     *
     */
    removeFilter: function removeFilter(filter) {
      // remove the quick search filter
      if (filter.key === 'quickSearch') {
        this.filters.splice(this.filters.indexOf(filter), 1);
        this.searchTerm = '';
        this.quickSearch();
      } else {
        var filterComponent = this.gridOptions.api.getFilterInstance(filter.key);
        // remove column filter
        filterComponent.setModel(null);

        // apply filters
        this.gridOptions.api.onFilterChanged();

        // remove from list
        this.filters.splice(this.filters.indexOf(filter), 1);

        // reset current view
        if (!this.filters.length) {
          this.currentView = this.savedViews[this.defViewIndex || 1];
        }
      }
    },
    /**
     * Remove all filters
     *
     */
    removeFilters: function removeFilters() {
      // reset current view
      this.currentView = this.savedViews[this.defViewIndex || 1];

      // reset any url filters
      this.$router.push({
        query: {
          filter: undefined
        }
      });

      // reset quick search
      this.searchTerm = '';
      this.gridOptions.api.setQuickFilter(null);
      this.gridOptions.api.setFilterModel(null);
      if (this.filter && !this.canRemoveDefaultFilter) {
        this.gridOptions.api.setFilterModel(this.filter);
        this.doNotShowOverlay = true;
      }
    },
    /**
     * Cell editing
     *
     */
    handleCellEdit: function handleCellEdit(p) {
      var row = p.rowIndex;
      var column = p.column.colId;
      var cell = p.api.rowRenderer.rowCompsByIndex[row].cellComps[column];
      var inputElement = cell.cellEditor.eHtmlElement;
      var maxLength = p.column.colDef.maxLength;
      maxLength && inputElement.setAttribute('maxlength', maxLength);
      var decimals = p.column.colDef.decimals;
      if (decimals) {
        inputElement.oninput = function (e) {
          var value = e.target.value;
          var number = utils.numeric.getNumberFromString(value);
          number = utils.numeric.setMaxNumberOfDigits(number, 2);
          inputElement.value = number;
        };
      }
      this.cellToFocus = {
        row: row,
        column: column
      };
    },
    /**
     * Inline editing
     *
     */
    handleInlineEdit: function handleInlineEdit(p) {
      var _this14 = this;
      if (this.editFullRowOnAdd) {
        return;
      }
      if (p.newValue !== p.oldValue && Number(p.newValue) !== p.oldValue) {
        /* this.updatedCells[p.rowIndex] = {
          initialValue: p.oldValue,
          value: p.newValue,
          data: p.data
        }
        this.$store.state.pendingData = {
          draft: this.endpoint,
          endpoint: this.endpoint ? this.endpoint.replace('Get', 'Save') : '',
          data: this.updatedCells
        } */
        var row = this.gridOptions.api.getDisplayedRowAtIndex(p.rowIndex);
        var success = function success(meta) {
          return _this14.editedRow(_objectSpread(_objectSpread({}, p), {}, {
            response: meta
          }), typeof meta === 'boolean' ? meta : true);
        };
        var failure = function failure(meta) {
          return _this14.editedRow(p, meta);
        };
        var done = function done() {
          setTimeout(function () {
            _this14.$parent.$children[0].gridOptions.api.startEditingCell({
              rowIndex: _this14.cellToFocus.row,
              colKey: _this14.cellToFocus.column
            });
          });
        };
        this.$emit('changeRow', {
          index: p.rowIndex,
          data: p.data,
          oldValue: p.oldValue,
          columnId: p.column.colId
        }, success, failure, done);
        row.alreadyEdited = p.data._invalid;
      }
    },
    /**
     * Inline editing row
     *
     */
    handleInlineEditRow: function handleInlineEditRow(p) {
      var _this15 = this;
      var success = function success(meta) {
        return _this15.editedRow(_objectSpread(_objectSpread({}, p), {}, {
          response: meta
        }), typeof meta === 'boolean' ? meta : true);
      };
      var failure = function failure(meta) {
        return _this15.editedRow(p, meta);
      };
      if ((p.data.draft || p.data._new) && !p.node.alreadyEdited) {
        this.$emit('changeRow', {
          index: p.rowIndex,
          data: p.data
        }, success, failure);
      }
      p.data._invalid = false;
      p.node.setData(p.data);
    },
    updateLocales: function updateLocales() {
      var grid = this;
      document.querySelectorAll('[t-key]').forEach(function (el) {
        el.innerHTML = grid.$t(el.getAttribute('t-key'));
      });
    },
    /**
     * Bind PerfectScrollbar to viewport
     *
     */
    initScrollbar: function initScrollbar() {
      var viewport = this.$el.querySelector('.ag-body-viewport');
      var actionsViewport = this.$el.querySelector('.ag-pinned-right-cols-viewport');
      this.ps = new __WEBPACK_IMPORTED_MODULE_8_perfect_scrollbar__["a" /* default */](viewport, {
        minScrollbarLength: 20,
        mouseWheelSpeed: 30
      });
      this.actionsPs = new __WEBPACK_IMPORTED_MODULE_8_perfect_scrollbar__["a" /* default */](actionsViewport, {
        minScrollbarLength: 20,
        mouseWheelSpeed: 30
      });

      /* viewport.addEventListener('wheel', e => {
        actionsViewport.scrollTop += e.deltaY
        e.preventDefault()
      }) */
    },
    initDragDrop: function initDragDrop() {
      var _this16 = this;
      //
      if (!this.dragRows) return;
      var viewport = this.$el.querySelector('.ag-pinned-left-cols-viewport');
      var rowClone = null;
      var rowFrom = null;
      var dragFromIndex = null;
      var grid = this;
      viewport.addEventListener('dragstart', function (e) {
        var id = e.target.getAttribute('comp-id');
        var row = _this16.$el.querySelector(".ag-body-viewport [comp-id=\"".concat(id, "\"]"));
        // rowClone = e.target.cloneNode(true)
        rowClone = row.cloneNode(true);
        rowClone.classList.add('row-ghost');
        rowClone.style.width = "".concat(row.clientWidth, "px");
        rowFrom = e.target;
        rowClone.classList.add('ag-row-dragging');
        // rowClone.style.visibility = 'visible'
        document.body.appendChild(rowClone);
        e.dataTransfer.setDragImage && e.dataTransfer.setDragImage(rowClone, 0, 0);
        e.dataTransfer.setData('text/plain', rowClone);
        e.target.classList.add('drag-over');
        dragFromIndex = rowFrom.getAttribute('row-index');
      });
      viewport.addEventListener('dragover', function (e) {
        var id = e.target.parentNode.getAttribute('comp-id');
        e.preventDefault();
        e.stopPropagation();
        // e.target.parentNode.classList.add('drag-enter')
        _this16.$el.querySelectorAll("[comp-id=\"".concat(id, "\"]")).forEach(function (el) {
          return el.classList.add('drag-enter');
        });
      });
      viewport.addEventListener('dragleave', function (e) {
        var id = e.target.parentNode.getAttribute('comp-id');
        e.preventDefault();
        e.stopPropagation();
        // e.target.parentNode.classList.remove('drag-enter')
        _this16.$el.querySelectorAll("[comp-id=\"".concat(id, "\"]")).forEach(function (el) {
          return el.classList.remove('drag-enter');
        });
      });
      viewport.addEventListener('dragend', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dragFromIndex = null;

        // rowClone.parentNode.removeChild(rowClone)
      });
      viewport.addEventListener('drop', function (e) {
        var id = e.target.parentNode.getAttribute('comp-id');
        e.preventDefault();
        e.stopPropagation();
        var node = e.target.parentNode;
        grid.onDropRow(dragFromIndex, node.getAttribute('row-index'));
        rowFrom.classList.remove('drag-over');
        // node.classList.remove('drag-enter')
        _this16.$el.querySelectorAll("[comp-id=\"".concat(id, "\"]")).forEach(function (el) {
          return el.classList.remove('drag-enter');
        });
      });
    },
    onViewportChanged: function onViewportChanged(e) {
      if (!this.viewportReady) {
        this.ps.update();
        this.actionsPs.update();
      }
      if (e.left === -1) this.viewportReady = true;
    },
    /**
     * Enables selecting all rows
     *
     */
    attachSelectAllRows: function attachSelectAllRows() {
      var _this17 = this;
      this.$el.querySelector('.ag-header').onclick = function (event) {
        if (~event.target.className.indexOf('-checkbox-')) {
          var toggle = event.target.className.indexOf('unchecked') > -1;
          _this17.onSelectAll(toggle);
        }
      };
    },
    /**
     * Enables row actions
     *
     */
    attachActions: function attachActions() {
      var _this18 = this;
      this.$el.querySelector('.ag-root').onclick = function (event) {
        var action = event.target.getAttribute('data-action');
        var id = event.target.getAttribute('data-id');
        var key = event.target.getAttribute('data-key');
        var index = event.target.getAttribute('data-index');
        action && _this18["".concat(action, "Row")] && _this18["".concat(action, "Row")](id, index, key);
      };
    },
    updateRowData: function updateRowData(rowData) {
      this.gridOptions.api.setRowData(rowData || this.data);
    },
    expandRow: function expandRow(id, index, key) {
      var _this19 = this;
      var row = this.gridOptions.api.getDisplayedRowAtIndex(+index);
      row.expanded = !row.expanded;
      row.data._expanded = row.expanded;
      row.setData(row.data);
      this.$el.querySelector('.ag-floating-bottom').classList.add('animated');
      this.$el.querySelector('.ag-floating-bottom').style.opacity = '0';
      row.setRowHeight(row.expanded ? EXPANDED_ROW_HEIGHT + ROW_HEIGHT : ROW_HEIGHT);
      // row.expanded ? this.expandedRows++ : this.expandedRows--

      this.$nextTick(function () {
        _this19.shownDetails = _this19.noOfExpandedRows; // this.expandedRows
        _this19.gridOptions.api.onRowHeightChanged();
        _this19.$el.querySelector('.ag-floating-bottom').style.cssText = '';
        _this19.$el.querySelector('.ag-floating-bottom').classList.add('fadeIn');
      });

      // trigger default details
      var expandAction = this.gridOptions.api.rowRenderer.rowCompsByIndex[+index].eBodyRow.querySelector('[col-id="details"]').querySelector('.ag-row-expand-icon');
      expandAction && expandAction.click();
    },
    expandedRow: function expandedRow(p) {
      // collapse all other rows
      if (!this.data) {
        this.gridOptions.api.forEachNode(function (node) {
          node.expanded = false;
          node.data._expanded = false;
          node.setData(node.data);
          node.setRowHeight(ROW_HEIGHT);
        });
      }
      var row = this.gridOptions.api.getDisplayedRowAtIndex(p.index);
      row.expanded = p.expanded;
      row.setRowHeight(this.gridOptions.rowHeight + (row.expanded ? p.height : 0));
      this.expandOffset = this.expandOffset + (p.reset ? 0 : p.height) * (row.expanded ? 1 : -1);
      this.$store.state.gridExpandOffset = this.$store.state.gridExpandOffset || {};
      this.$store.state.gridExpandOffset[this.uid] = this.expandOffset;
      this.gridOptions.api.onRowHeightChanged();
    },
    addRow: function addRow(data) {
      var _this20 = this;
      if (!this.gridOptions.api.getDisplayedRowCount()) {
        this.data = [data];
        this.gridOptions.api.refreshInfiniteCache();
      }
      var row = this.gridOptions.api.getDisplayedRowAtIndex(0);
      if (row) {
        this.gridOptions.api.insertItemsAtIndex(0, [this.addedRow || data]);
        row = this.gridOptions.api.getDisplayedRowAtIndex(0);
        row.data._new = true;
        row.setData(row.data);
        setTimeout(function () {
          _this20.gridOptions.api.startEditingCell({
            rowIndex: 0,
            colKey: _this20.defaultColumn
          });
        });
        this.$emit('addRow');
      } else {
        this.gridOptions.api.ensureIndexVisible(0);
        this.addedRow = data;
      }
    },
    cloneRow: function cloneRow(data, index, key) {
      var grid = this;
      var success = function success() {
        return grid.gridOptions.api.refreshInfiniteCache();
      };
      if (!index) {
        this.gridOptions.api.forEachNode(function (node) {
          if (node.selected) {
            index = Number(node.id);
          }
        });
      }
      var row = this.gridOptions.api.getDisplayedRowAtIndex(+index);
      var rowCopy = utils.copy(row.data);
      rowCopy._expanded = false;
      this.gridOptions.api.insertItemsAtIndex(++index, [rowCopy]);
      row = this.gridOptions.api.getDisplayedRowAtIndex(index);
      row.data._new = true;
      row.setData(row.data);
      this.$emit('cloneRow', index, success);
    },
    cloneRows: function cloneRows() {
      var toBeCloned = [];
      var grid = this;
      this.gridOptions.api.forEachNode(function (node) {
        node.selected && toBeCloned.push(node);
      });
      var errmsg = '';
      if (typeof this.validateCloneMany !== 'undefined') errmsg = this.validateCloneMany(toBeCloned);
      if (errmsg != null && errmsg !== '') {
        this.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: {
            from: 'top',
            align: 'center'
          },
          message: errmsg,
          dismiss: 'OK',
          timeout: 0
        });
      } else {
        var success = function success() {
          return grid.gridOptions.api.refreshInfiniteCache();
        };
        grid.$emit('cloneRows', {
          rows: toBeCloned
        }, success);
      }
    },
    editRow: function editRow(data, index, key) {
      var _this21 = this;
      var row = this.gridOptions.api.getDisplayedRowAtIndex(index);

      // row.data._new  = true
      // row.data.draft = true
      row._editing = true;
      // row.setData(row.data)

      this.editable === true && setTimeout(function () {
        _this21.gridOptions.api.startEditingCell({
          rowIndex: +index,
          colKey: key || _this21.defaultColumn
        });
      });
      this.$emit('editRow', {
        index: index,
        data: row.data
      });

      //
      // this.$router.push({ query: {wa: 'details'} })
    },
    editedRow: function editedRow() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var meta = arguments.length > 1 ? arguments[1] : undefined;
      var row = this.gridOptions.api.getDisplayedRowAtIndex(payload.rowIndex);
      var errors = payload.response && payload.response.data && payload.response.data.Errors || [];
      if (errors && errors.length > 0 && payload.response.status === 200) {
        meta = false;
        global.app.$notifications.notify({
          type: 'plain',
          icon: 'times-octagon',
          message: "Error\n            <br><strong>".concat(errors[0].Message || 'Something went wrong', "</strong>\n            <br><a class=\"btn btn-xs btn-actionbar\" target=\"_blank\" href=\"https://www.eved.com/contact-us/\">Report this</a>"),
          timeout: 0,
          placement: {
            from: 'top',
            align: 'center'
          }
        });
      }
      if (meta === true) {
        // mark as saved and remove draft/new flag
        row.data._saved = true;
        row.data._invalid = false;
        row.data._new = false;
        row.data.draft = false;
        var model = payload.response && payload.response.data && payload.response.data.Data || {};

        // set ids
        row.data = _objectSpread(_objectSpread({}, row.data), model);
        row.setData(row.data);
        this.gridOptions.api.refreshCells({
          rowNodes: [row],
          force: true
        });

        // remove saved flag after 5 sec.
        setTimeout(function () {
          row.data._saved = false;
          row.setData(row.data);
        }, 5000);
      } else {
        //
        if (row.data._new) {
          // row.data.draft = false
          row.data.draft = true;
          row.data._invalid = true;
          row.setData(row.data);
          return;
        } else {
          row.data.draft = false;
          row.data._invalid = true;
          row.setData(row.data);
        }
      }
    },
    removeRow: function removeRow(data, index, meta) {
      var grid = this;
      var row = this.gridOptions.api.getDisplayedRowAtIndex(index);
      var success = function success(meta) {
        return grid.removeRow(true, index, meta);
      };
      var failure = function failure(meta) {
        return grid.removeRow(false, index, meta);
      };
      if (data === true) {
        if (this.undo || meta) {
          row.data._deleted = !row.data._deleted;
          row.setData(row.data);
        } else {
          this.gridOptions.api.refreshInfiniteCache();
        }
        return;
      }
      if (data === false) {
        // row.data._deleted = !row.data._deleted
        // row.setData(row.data)

        this.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: {
            from: 'top',
            align: 'center'
          },
          timeout: 0,
          message: "Error: ".concat(meta || '[unspecified]', ". Retry ?"),
          dismiss: 'Yes',
          discard: 'No',
          goto: null,
          onClose: function onClose(dismiss) {
            if (dismiss) {
              //
              !row.data._deleted ? grid.$emit('removeRow', {
                index: index,
                data: data
              }, success, failure) : grid.$emit('restoreRow', {
                index: index,
                data: data
              });
            } else if (dismiss === null) {
              //
              row.data._deleted = !row.data._deleted;
              row.setData(row.data);
            }
          }
        });
        return;
      }
      if (row.data._deleted === true) {
        this.removeRow(true, index, 'undo');
        return;
      }
      var _data = data;
      var dataOffset = grid.checkboxes ? 3 : 2;
      if (meta === 'Id' || data === 'undefined') {
        _data = "\n                 ".concat(row.data[grid.columnDefs[dataOffset].field], "\n                 ").concat(row.data[grid.columnDefs[dataOffset + 1].field] || '', "\n                 ").concat(row.data[grid.columnDefs[dataOffset + 2].field] || '', "\n                ");
      }

      //
      this.$notifications.notify({
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        timeout: 0,
        message: "Are you sure you want to delete <br/>\n                  <em>".concat(grid.label || meta, "</em> <strong>").concat(_data, "</strong> ?"),
        dismiss: 'Yes',
        discard: 'No',
        goto: null,
        onClose: function onClose(dismiss) {
          if (dismiss) {
            //
            row.setSelected(false);
            if (row.data._new) {
              grid.gridOptions.api.refreshInfiniteCache();
            } else {
              !row.data._deleted ? grid.$emit('removeRow', {
                index: index,
                data: row.data
              }, success, failure) : grid.$emit('restoreRow', {
                index: index,
                data: row.data
              });
            }
          } else if (dismiss === null) {
            //
          }
        }
      });
    },
    removeRows: function removeRows() {
      var toBeDeleted = [];
      var newItemsToBeRemoved = 0;
      var grid = this;
      this.gridOptions.api.forEachNode(function (node) {
        node.selected && !node.data._new && toBeDeleted.push(node);
        node.selected && node.data._new && newItemsToBeRemoved++;
      });
      var errmsg = '';
      if (typeof this.validateRemoveMany !== 'undefined') errmsg = this.validateRemoveMany(toBeDeleted);
      if (errmsg != null && errmsg !== '') {
        this.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: {
            from: 'top',
            align: 'center'
          },
          message: errmsg,
          dismiss: 'OK',
          timeout: 0
        });
      } else {
        var success = function success() {
          return grid.gridOptions.api.refreshInfiniteCache();
        };
        this.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: {
            from: 'top',
            align: 'center'
          },
          timeout: 0,
          message: "Are you sure you want to delete ".concat(toBeDeleted.length + newItemsToBeRemoved, " items ?"),
          dismiss: 'Yes',
          discard: 'No',
          goto: null,
          onClose: function onClose(dismiss) {
            if (dismiss) {
              //
              toBeDeleted.forEach(function (row) {
                row.data._deleted = true;
                row.setData(row.data);
                row.setSelected(false);
              });
              grid.$emit('removeRows', {
                rows: toBeDeleted
              }, success);
            } else if (dismiss === null) {
              //
            }
          }
        });
      }
    },
    rowClass: function rowClass(grid) {
      var actionable = grid.model ? grid.model.$$actionable : null;
      return _objectSpread({
        'new': 'data._new',
        'editing': 'data.draft',
        'pending': 'data._pending',
        'loading': 'data._loading',
        'saved': 'data._saved',
        'invalid': 'data.entireRowInvalid || data._invalid',
        'deleted': 'data._deleted',
        'disabled': 'data._disabled',
        'expanded': 'data._expanded',
        'not-actionable': function notActionable(params) {
          return typeof actionable === 'function' && !actionable({
            data: params.data
          });
        }
      }, grid.rowClasses);
    },
    processRow: function processRow(params, grid) {
      //
      if (!grid.dragRows) return;
      if (params.eRow) {
        var $row = params.ePinnedLeftRow;
        $row.draggable = true;
      }
    },
    onDropRow: function onDropRow(srcIdx, destIdx) {
      var from = this.gridOptions.api.getDisplayedRowAtIndex(+srcIdx);
      var to = this.gridOptions.api.getDisplayedRowAtIndex(+destIdx);
      var fromData = from.data;
      from.setData(to.data);
      to.setData(fromData);
      this.$emit('dropRow', {
        from: +srcIdx,
        to: +destIdx
      });
    },
    /**
     * Exporter
     *
     */
    exportList: function exportList() {
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.EXPORT, this.selectedRows);
      this.gridOptions.api.exportDataAsCsv();
    },
    getTotals: function getTotals() {
      return this.totalsData ? [this.totalsData] : [{}];
    }
  },
  components: {
    AgGridVue: __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    ExportData: __WEBPACK_IMPORTED_MODULE_5__export_data__["a" /* default */],
    ColumnSelector: __WEBPACK_IMPORTED_MODULE_6__column_selector__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("RMJP")))

/***/ }),

/***/ "E1Ga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    rows: Array
  },
  data: function data() {
    return {
      showModal: false,
      modalContent: ''
    };
  },
  methods: {
    validateInvoices: function validateInvoices() {
      var _this = this;
      if (!this.rows || this.rows.length > 1) {
        this.modalContent = 'Payment can only be made for one credit invoice at a time. Please deselect all invoices except for one and try again.';
        this.showModal = true;
      } else {
        this.api.forms.post(this.api.$.invoice.list.validateRemitPayment, {
          isAllSelected: false,
          selection: JSON.stringify([this.rows[0].data.PaymentInvoiceID]),
          filter: '',
          paymentType: 'remit'
        }).then(function (result) {
          if (result && result.data) {
            if (result.data.SuccessMessage !== 'Success') {
              _this.modalContent = result.data.Data;
              _this.showModal = true;
            } else {
              _this.redirectToRemitPayment();
            }
          }
        });
      }
    },
    redirectToRemitPayment: function redirectToRemitPayment() {
      if (this.rows && this.rows.length === 1) {
        this.$router.push('/d/Invoices/remit-payment/' + this.rows[0].data.PaymentInvoiceID);
      }
    }
  }
});

/***/ }),

/***/ "E2Ix":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("4CTm");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-tab',
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    icon: String
  },
  methods: {
    onTabClick: function onTabClick(tabId) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* EVENT_ON_TAB_CLICK */], tabId);
    }
  }
});

/***/ }),

/***/ "E3YO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mdButton__ = __webpack_require__("UJym");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mdCard__ = __webpack_require__("kxvb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mdFormGroupInput__ = __webpack_require__("PTlP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdTab__ = __webpack_require__("sMu0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mdStatsWidget__ = __webpack_require__("kcXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mdTable__ = __webpack_require__("vJB6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mdBlockquote__ = __webpack_require__("CxRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mdChartWidget__ = __webpack_require__("KMvX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__edAvatar__ = __webpack_require__("LDBD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__edForm__ = __webpack_require__("zjcM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__edButton__ = __webpack_require__("deUd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__edInput__ = __webpack_require__("jkX1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__edInputTooltip__ = __webpack_require__("7npE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__edSelect__ = __webpack_require__("+WA9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__edSelect_selectOptions__ = __webpack_require__("Jd1Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__edSelectList__ = __webpack_require__("Iexc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__edDatepicker__ = __webpack_require__("sRHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__edCheckbox__ = __webpack_require__("SUkm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__edRadio__ = __webpack_require__("IhfB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__edTextarea__ = __webpack_require__("UBhi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__edUpload__ = __webpack_require__("jAzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__edMetaNav__ = __webpack_require__("YKxx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__edPrimaryNav__ = __webpack_require__("WvIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__edTitleNav__ = __webpack_require__("R4zt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__edTabNav__ = __webpack_require__("a4Sf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__edTabNav_edTab__ = __webpack_require__("DGG8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__edModal__ = __webpack_require__("nIm4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__edCard__ = __webpack_require__("UNRQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__edNotice__ = __webpack_require__("FjPf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__edPanel__ = __webpack_require__("2iRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__edSection__ = __webpack_require__("uovb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__edBox__ = __webpack_require__("M+wV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__edSwitch__ = __webpack_require__("opr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__edFieldGroup__ = __webpack_require__("aj2A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__edSlider__ = __webpack_require__("FQOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__edWidget__ = __webpack_require__("Wd+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__core_directives__ = __webpack_require__("hPVU");





































/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.use(__WEBPACK_IMPORTED_MODULE_36__core_directives__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__mdButton__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__mdButton__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__mdCard__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__mdCard__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__mdFormGroupInput__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__mdFormGroupInput__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__mdTab__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__mdTab__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_4__mdStatsWidget__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__mdStatsWidget__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_5__mdTable__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__mdTable__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_6__mdBlockquote__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__mdBlockquote__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_7__mdChartWidget__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__mdChartWidget__["a" /* default */]);
    Vue.component('t-span', {
      template: "<span v-if='!isSvg'><slot></slot></span>\n                 <tspan v-else><slot></slot></tspan>",
      data: function data() {
        return {
          isSvg: false
        };
      },
      mounted: function mounted() {
        if (this.$el.parentNode.viewportElement) {
          this.isSvg = true;
        }
      }
    });
    Vue.component(__WEBPACK_IMPORTED_MODULE_8__edAvatar__["default"].name, __WEBPACK_IMPORTED_MODULE_8__edAvatar__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_9__edForm__["default"].name, __WEBPACK_IMPORTED_MODULE_9__edForm__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_10__edButton__["default"].name, __WEBPACK_IMPORTED_MODULE_10__edButton__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_11__edInput__["default"].name, __WEBPACK_IMPORTED_MODULE_11__edInput__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_12__edInputTooltip__["default"].name, __WEBPACK_IMPORTED_MODULE_12__edInputTooltip__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_13__edSelect__["default"].name, __WEBPACK_IMPORTED_MODULE_13__edSelect__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_14__edSelect_selectOptions__["default"].name, __WEBPACK_IMPORTED_MODULE_14__edSelect_selectOptions__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_15__edSelectList__["default"].name, __WEBPACK_IMPORTED_MODULE_15__edSelectList__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_16__edDatepicker__["default"].name, __WEBPACK_IMPORTED_MODULE_16__edDatepicker__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_17__edCheckbox__["default"].name, __WEBPACK_IMPORTED_MODULE_17__edCheckbox__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_18__edRadio__["default"].name, __WEBPACK_IMPORTED_MODULE_18__edRadio__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_19__edTextarea__["default"].name, __WEBPACK_IMPORTED_MODULE_19__edTextarea__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_20__edUpload__["default"].name, __WEBPACK_IMPORTED_MODULE_20__edUpload__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_21__edMetaNav__["default"].name, __WEBPACK_IMPORTED_MODULE_21__edMetaNav__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_22__edPrimaryNav__["default"].name, __WEBPACK_IMPORTED_MODULE_22__edPrimaryNav__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_23__edTitleNav__["default"].name, __WEBPACK_IMPORTED_MODULE_23__edTitleNav__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_24__edTabNav__["default"].name, __WEBPACK_IMPORTED_MODULE_24__edTabNav__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_25__edTabNav_edTab__["default"].name, __WEBPACK_IMPORTED_MODULE_25__edTabNav_edTab__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_26__edModal__["default"].name, __WEBPACK_IMPORTED_MODULE_26__edModal__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_27__edCard__["default"].name, __WEBPACK_IMPORTED_MODULE_27__edCard__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_28__edNotice__["default"].name, __WEBPACK_IMPORTED_MODULE_28__edNotice__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_29__edPanel__["default"].name, __WEBPACK_IMPORTED_MODULE_29__edPanel__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_30__edSection__["default"].name, __WEBPACK_IMPORTED_MODULE_30__edSection__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_31__edBox__["default"].name, __WEBPACK_IMPORTED_MODULE_31__edBox__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_32__edSwitch__["default"].name, __WEBPACK_IMPORTED_MODULE_32__edSwitch__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_33__edFieldGroup__["default"].name, __WEBPACK_IMPORTED_MODULE_33__edFieldGroup__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_34__edSlider__["default"].name, __WEBPACK_IMPORTED_MODULE_34__edSlider__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_35__edWidget__["default"].name, __WEBPACK_IMPORTED_MODULE_35__edWidget__["default"]);
  }
});

/***/ }),

/***/ "E5ao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddUser_vue__ = __webpack_require__("fn8K");


function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// "5000" -> "5,000.00" for the "Max limit 5,000.00 USD" help text and the validation message.
var formatUsdAmount = function formatUsdAmount(value) {
  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddUser: __WEBPACK_IMPORTED_MODULE_3__AddUser_vue__["a" /* default */]
  },
  data: function data() {
    return {
      formData: {
        city: '',
        postalCode: '',
        originalCountryName: '',
        country: '',
        state: {
          StateID: 0,
          StateName: ''
        },
        canadaState: {
          StateID: 0,
          StateName: ''
        },
        region: ''
      },
      USstates: [],
      USoriginalStates: [],
      canadaStates: [],
      originalCanadaStates: [],
      countries: [],
      initialLoad: '',
      dailySpendLimit: '',
      // PRODUCTDEV-5946/5889: the PEX business settings for the Daily Spend Limit field, fetched when the
      // modal opens (fetchDailySpendLimitSettings). Optional until the real values load (never
      // over-restrict on a fetch in flight); cap null = no cap known - NO $5,000 guess, the cap
      // pre-validation and help text are skipped and the backend/PEX enforce the real rules on save.
      isDailySpendLimitRequired: false,
      maxDailySpendLimit: null,
      dailySpendLimitError: '',
      RefillSettings: {
        RefillAmount: null,
        RefillThreshold: null
      },
      originalCountries: [],
      show: true,
      selectUser: '',
      selectDivision: '',
      disableControls: false,
      physicalCard: false,
      users: [],
      showAddCard: false,
      savingCardInProgress: false,
      showAddUser: false,
      mailingAddress: {},
      addObjectUser: {
        Holder: {
          Mobile: {}
        }
      },
      divisions: [],
      selectedDivisionId: 0,
      selectedAccountId: '',
      rushOrder: false,
      initialLoadError: false,
      cardHolderPhoneNumberError: false,
      holderIncomplete: false,
      countryIncomplete: false,
      nameIncomplete: false,
      addressIncomplete: false,
      cityIncomplete: false,
      stateIncomplete: false,
      zipCodeIncomplete: false,
      errorMessage: 'The amount cannot be greater than the available funds.',
      errorPhoneMessage: 'The phone number cannot contain characters other than digits.',
      errorGLCode: false,
      errorMessageGLCode: 'Required',
      nameOnCard: '',
      nameOnCardError: false,
      errorMessageNameOnCard: '',
      pageSize: 50,
      card: {
        users: [],
        pageIndex: 0,
        hasMore: true,
        isLoading: false,
        searchTerm: ''
      },
      admin: {
        users: [],
        pageIndex: 0,
        hasMore: true,
        isLoading: false,
        searchTerm: ''
      },
      hasData: false
    };
  },
  computed: {
    isPoolFunding: function isPoolFunding() {
      return !!(this.accountSettings && this.accountSettings.IsPoolFunding);
    },
    dateFormat: function dateFormat() {
      var dateSettings = this.$root.getUser.sessionSettings.DateAndTimeFormats;
      return dateSettings.MomentDateFormat || 'MM/DD/YYYY';
      // return dateSettings.JsDateFormat || dateSettings.JsDateFormatCompany || dateSettings.JsDateFormatDefault || ''
    },
    rushDisabledReason: function rushDisabledReason() {
      if (this.account.Available <= 0) {
        return 'Insufficient funds available for rush shipping.';
      }
      return '';
    },
    initialLoadDisabledReason: function initialLoadDisabledReason() {
      if (this.account.Available <= 0) {
        return 'No funds available. The card will be created with $0.00';
      }
      return '';
    },
    // PRODUCTDEV-5946: the "Max limit 5,000.00 USD" help text under the Daily Spend Limit field,
    // driven by the PEX per-account cap fetched when the modal opens. PRODUCTDEV-5889: no cap known ->
    // no help text (never show a guessed number).
    maxLimitHelpText: function maxLimitHelpText() {
      return this.maxDailySpendLimit ? "Max limit ".concat(formatUsdAmount(this.maxDailySpendLimit), " USD") : '';
    }
  },
  watch: {
    showAddCard: function showAddCard(newVal, oldVal) {
      if (newVal) {
        this.populateFormData(this.formData);
        // PRODUCTDEV-5946: refresh the PEX business rules for the Daily Spend Limit field on every open.
        this.fetchDailySpendLimitSettings();
      }
    },
    // PRODUCTDEV-5946 (red-team): the open-time fetch above early-returns while the parent's
    // accountSettings request is still in flight (isPoolFunding is false until it resolves). When the
    // flag flips true with the modal already open, fetch now - otherwise a required Daily Spend Limit
    // would silently stay optional/$5,000 for that modal session.
    isPoolFunding: function isPoolFunding(newVal) {
      if (newVal && this.showAddCard) {
        this.fetchDailySpendLimitSettings();
      }
    }
  },
  props: {
    divisionId: '',
    accountId: '',
    divisionName: 'Division',
    divisionsName: 'Divisions',
    account: Object,
    accountSettings: Object
  },
  methods: {
    // PRODUCTDEV-5946: keep the payload mapping (null when blank - never 0 implicitly) and live-validate
    // against the PEX business rules while typing, mirroring CardDailySpendLimit.vue.
    onDailySpendLimitInput: function onDailySpendLimitInput(o) {
      this.dailySpendLimit = o;
      this.addObjectUser.DailySpendLimit = o === '' || o == null ? null : +o;
      this.validateDailySpendLimit(o);
    },
    // PRODUCTDEV-5946: inline validation for the Daily Spend Limit field. A blank value is allowed only
    // when the account does not require a limit; $0.00 and above-cap values are always rejected. The
    // backend applies the same rules, so a bypassed frontend still cannot save an invalid value.
    validateDailySpendLimit: function validateDailySpendLimit(value) {
      var amount = value === '' || value == null ? null : +value;
      if (amount == null) {
        if (this.isDailySpendLimitRequired) {
          this.dailySpendLimitError = 'Daily Spend Limit is required.';
          return false;
        }
      } else if (amount <= 0) {
        this.dailySpendLimitError = 'Daily Spend Limit must be greater than $0.00';
        return false;
      } else if (this.maxDailySpendLimit && amount > this.maxDailySpendLimit) {
        // PRODUCTDEV-5889: cap check only when the backend reported a real cap - no guessed $5,000.
        this.dailySpendLimitError = "Daily Spend Limit must be less than or equal to $".concat(formatUsdAmount(this.maxDailySpendLimit));
        return false;
      }
      this.dailySpendLimitError = '';
      return true;
    },
    // PRODUCTDEV-5946: the PEX business rules for the Daily Spend Limit field (required flag + cap),
    // fetched once per modal open (and again after picking a division in the division-select flow).
    // PRODUCTDEV-5889: a failure no longer falls back to guessed rules - required stays false and the
    // cap stays null (no cap pre-validation, no help text). The backend blocks the add anyway when it
    // cannot load the PEX rules itself, so a bypassed/failed fetch cannot create an invalid card.
    fetchDailySpendLimitSettings: function fetchDailySpendLimitSettings() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var divisionId, response, cap;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              divisionId = _this.divisionId || _this.selectedDivisionId;
              if (!(!_this.isPoolFunding || !divisionId)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.prev = 3;
              _context.next = 6;
              return _this.api.get("evedpaycards/accounts/".concat(divisionId, "/daily-spend-limit-settings-by-division"));
            case 6:
              response = _context.sent;
              if (response.status === 200 && response.data) {
                cap = +response.data.MaxDailySpendLimit;
                if (Number.isFinite(cap) && cap > 0) {
                  _this.maxDailySpendLimit = cap;
                }
                _this.isDailySpendLimitRequired = response.data.IsDailySpendLimitRequired === true;
              }
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              console.warn(_context.t0);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 10]]);
      }))();
    },
    addCard: function addCard() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var trimmedNameOnCard, payload, poolUser, shippingInfo, response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.savingCardInProgress = true;
              if (_this2.isValidCardForSaving()) {
                _context2.next = 4;
                break;
              }
              _this2.savingCardInProgress = false;
              return _context2.abrupt("return");
            case 4:
              if (_this2.addObjectUser.AccountOrGlCode) {
                _this2.addObjectUser.AccountOrGlCode = _this2.addObjectUser.AccountOrGlCode.trim();
              }
              trimmedNameOnCard = (_this2.nameOnCard || '').trim();
              _context2.prev = 6;
              if (_this2.isPoolFunding) {
                // Pool funding: no Initial Load / Refill Settings; carry the optional Daily Spend Limit
                // (null when blank — never 0). initialLoad is never sent in pool mode.
                poolUser = _objectSpread({}, _this2.addObjectUser);
                delete poolUser.initialLoad;
                payload = _objectSpread(_objectSpread({
                  AccountID: _this2.accountId ? _this2.accountId : _this2.selectedAccountId
                }, poolUser), {}, {
                  IsPhysicalCard: _this2.physicalCard,
                  DailySpendLimit: _this2.dailySpendLimit === '' || _this2.dailySpendLimit == null ? null : +_this2.dailySpendLimit,
                  NameOnCard: trimmedNameOnCard || null
                });
              } else {
                payload = _objectSpread(_objectSpread({
                  AccountID: _this2.accountId ? _this2.accountId : _this2.selectedAccountId
                }, _this2.addObjectUser), {}, {
                  IsPhysicalCard: _this2.physicalCard,
                  RefillSettings: _this2.RefillSettings,
                  NameOnCard: trimmedNameOnCard || null
                });
              }
              if (_this2.physicalCard) {
                shippingInfo = {
                  Shipping: {
                    IsRush: _this2.rushOrder,
                    Name: _this2.mailingAddress.name,
                    Address: {
                      Country: {
                        Id: 186
                      },
                      Address1: _this2.mailingAddress.line1,
                      Address2: _this2.mailingAddress.line2,
                      City: _this2.mailingAddress.city,
                      State: {
                        Id: _this2.mailingAddress.state.StateID
                      },
                      Zip: _this2.mailingAddress.zip
                    }
                  }
                };
                payload = _objectSpread(_objectSpread({}, payload), shippingInfo);
              }
              _context2.next = 11;
              return _this2.api.post(_this2.api.$.evedpaycard.list, payload);
            case 11:
              response = _context2.sent;
              if (response.data) {
                _context2.next = 15;
                break;
              }
              _this2.savingCardInProgress = false;
              throw new Error('Error during the request');
            case 15:
              _this2.$emit('success');
              _this2.initialLoadError = false;
              _this2.cardHolderPhoneNumberError = false;
              _this2.holderIncomplete = false;
              _this2.countryIncomplete = false;
              _this2.nameIncomplete = false;
              _this2.addressIncomplete = false;
              _this2.cityIncomplete = false;
              _this2.stateIncomplete = false;
              _this2.zipCodeIncomplete = false;
              _this2.errorGLCode = false;
              _this2.nameOnCardError = false;
              _this2.showAddCard = false;
              _this2.showAddUser = false;
              _context2.next = 35;
              break;
            case 31:
              _context2.prev = 31;
              _context2.t0 = _context2["catch"](6);
              _this2.savingCardInProgress = false;
              console.error('Error during the request:', _context2.t0);
            case 35:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[6, 31]]);
      }))();
    },
    isValidCardForSaving: function isValidCardForSaving() {
      if (!this.selectUser) {
        this.holderIncomplete = true;
        return false;
      } else {
        this.holderIncomplete = false;
      }
      if (this.initialLoad < 0 || this.initialLoad > this.account.Available) {
        this.initialLoadError = true;
        return false;
      } else {
        this.initialLoadError = false;
      }

      // PRODUCTDEV-5946: block submit while the Daily Spend Limit violates the PEX business rules
      // (empty when required, $0.00, above the account's cap).
      if (this.isPoolFunding && !this.validateDailySpendLimit(this.dailySpendLimit)) {
        return false;
      }
      if (/\D/.test(this.addObjectUser.Holder.Mobile.PhoneNumber)) {
        this.cardHolderPhoneNumberError = true;
        return false;
      } else {
        this.cardHolderPhoneNumberError = false;
      }
      var trimmedNameOnCard = (this.nameOnCard || '').trim();
      if (trimmedNameOnCard) {
        if (trimmedNameOnCard.length > 23) {
          this.errorMessageNameOnCard = 'Name on Card must be 23 characters or less.';
          this.nameOnCardError = true;
          return false;
        }
        if (!/^[A-Za-z0-9 .,&'-]+$/.test(trimmedNameOnCard)) {
          this.errorMessageNameOnCard = "Name on Card may only include letters, numbers and the following punctuation symbols: . , - & '";
          this.nameOnCardError = true;
          return false;
        }
        // PEX requires both FirstName and LastName, so we need a space to split the custom name.
        // A single-word name would otherwise be paired with the holder's last name on the card.
        var spaceIdx = trimmedNameOnCard.indexOf(' ');
        if (spaceIdx <= 0 || spaceIdx >= trimmedNameOnCard.length - 1) {
          this.errorMessageNameOnCard = 'Name on Card must include a first and last name separated by a space.';
          this.nameOnCardError = true;
          return false;
        }
        this.nameOnCardError = false;
      } else {
        this.nameOnCardError = false;
      }
      if (this.addObjectUser.HasAccountingSystemSync) {
        this.addObjectUser.AccountOrGlCode = (this.addObjectUser.AccountOrGlCode || '').trim();
        if (!this.addObjectUser.AccountOrGlCode.trim()) {
          this.errorGLCode = true;
          return false;
        } else {
          this.errorGLCode = false;
        }
      } else {
        this.errorGLCode = false;
      }
      if (this.physicalCard) {
        if (!this.formData.country) {
          this.countryIncomplete = true;
          return false;
        } else {
          this.countryIncomplete = false;
        }
        if (!this.name) {
          this.nameIncomplete = true;
          return false;
        } else {
          this.nameIncomplete = false;
        }
        if (!this.address) {
          this.addressIncomplete = true;
          return false;
        } else {
          this.addressIncomplete = false;
        }
        if (!this.city) {
          this.cityIncomplete = true;
          return false;
        } else {
          this.cityIncomplete = false;
        }
        if (this.isUS()) {
          if (!this.formData.state || !this.formData.state.StateID) {
            this.stateIncomplete = true;
            return false;
          } else {
            this.stateIncomplete = false;
          }
        }
        if (!this.zipCode) {
          this.zipCodeIncomplete = true;
          return false;
        } else {
          this.zipCodeIncomplete = false;
        }
      }
      return true;
    },
    onOpenCard: function onOpenCard() {
      this.card.searchTerm = '';
      this.loadUsers('card', true);
    },
    onOpenAdmin: function onOpenAdmin() {
      this.admin.searchTerm = '';
      this.loadUsers('admin', true);
    },
    loadUsers: function loadUsers(type) {
      var _arguments = arguments,
        _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var reset, loader, _yield$_this3$api$get, data, Items, HasMore, mapped;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              reset = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              loader = _this3[type];
              if (!loader.isLoading) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              if (reset) {
                loader.pageIndex = 0;
                loader.users = [];
                loader.hasMore = true;
              }
              if (loader.hasMore) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return");
            case 7:
              loader.isLoading = true;
              _context3.prev = 8;
              _context3.next = 11;
              return _this3.api.get(_this3.api.$.divisionUsers, {
                params: {
                  divisionId: _this3.divisionId || _this3.selectedDivisionId,
                  pageIndex: loader.pageIndex,
                  pageSize: _this3.pageSize,
                  searchTerm: loader.searchTerm
                }
              });
            case 11:
              _yield$_this3$api$get = _context3.sent;
              data = _yield$_this3$api$get.data;
              Items = data.Items, HasMore = data.HasMore;
              mapped = Items.sort(function (a, b) {
                return "".concat(a.FirstName, " ").concat(a.LastName).localeCompare("".concat(b.FirstName, " ").concat(b.LastName));
              }).map(function (u) {
                return {
                  Id: u.VendorUserId,
                  Name: "".concat(u.FirstName, " ").concat(u.LastName),
                  Mobile: {
                    CountryCode: u.Mobile.CountryCode || 'US',
                    PhoneCode: u.Mobile.PhoneCode || '+1',
                    PhoneNumber: u.Mobile.PhoneNumber || ''
                  },
                  DateOfBirth: global.moment(u.DateOfBirth).format(_this3.$root.getUser.sessionSettings.DateAndTimeFormats.MomentDateFormat)
                };
              });
              loader.users = reset ? mapped : loader.users.concat(mapped);
              loader.hasMore = HasMore;
              loader.pageIndex += 1;
              _this3.hasData = true;
              _context3.next = 25;
              break;
            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](8);
              console.error('loadUsers error', _context3.t0);
              _this3.hasData = false;
            case 25:
              _context3.prev = 25;
              loader.isLoading = false;
              return _context3.finish(25);
            case 28:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[8, 21, 25, 28]]);
      }))();
    },
    showModal: function showModal(showAddCard) {
      if (!this.initialLoadError && !this.holderIncomplete) {
        this.showAddCard = !showAddCard;
        this.resetModalFields();
      }
      this.showAddCard = !showAddCard;
      this.resetModalFields();
      this.savingCardInProgress = false;
    },
    showModalUser: function showModalUser(showAddUser) {
      this.showAddUser = !showAddUser;
    },
    closeAddUserModal: function closeAddUserModal() {
      this.showAddUser = false;
    },
    filterAdminOptions: function filterAdminOptions(option) {
      if (this.addObjectUser.Holder && this.addObjectUser.Holder.Id) {
        return option.Id !== this.addObjectUser.Holder.Id;
      } else {
        return false;
      }
    },
    resetModalFields: function resetModalFields() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.formRef.reset();
        _this4.selectUser = '';
        _this4.selectUsers = [];
        _this4.physicalCard = false;
        _this4.formData.state = '';
        _this4.formData.canadaState = '';
        _this4.selectDivision = '';
        _this4.selectedDivisionId = 0;
        _this4.mailingAddress = {};
        _this4.addObjectUser = {
          Holder: {
            Mobile: {}
          }
        };
        _this4.selectedAccountId = '';
        _this4.initialLoad = '';
        _this4.dailySpendLimit = '';
        _this4.dailySpendLimitError = '';
        _this4.RefillSettings = {
          RefillAmount: null,
          RefillThreshold: null
        };
        _this4.nameOnCard = '';
        _this4.initialLoadError = false;
        _this4.cardHolderPhoneNumberError = false;
        _this4.holderIncomplete = false;
        _this4.countryIncomplete = false;
        _this4.nameIncomplete = false;
        _this4.addressIncomplete = false;
        _this4.cityIncomplete = false;
        _this4.stateIncomplete = false;
        _this4.zipCodeIncomplete = false;
        _this4.errorGLCode = false;
        _this4.nameOnCardError = false;
      });
    },
    fetchCountriesOnOpen: function fetchCountriesOnOpen() {
      var _this5 = this;
      if (this.countries.length) {} else {
        this.api.forms.post(this.api.$.profile.getAllCountries, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this5.countries = r.data.Data;
            _this5.originalCountries = r.data.Data;
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    onCountrySelect: function onCountrySelect(_ref) {
      var dialCode = _ref.dialCode,
        iso2 = _ref.iso2;
      this.addObjectUser.Holder.Mobile.CountryCode = iso2;
      this.addObjectUser.Holder.Mobile.PhoneCode = '+' + dialCode;
    },
    onSelectUser: function onSelectUser(user) {
      // Switching holders must clear the previously typed Name on Card; otherwise the input
      // re-disables but the value persists in data and leaks into the next holder's payload.
      this.nameOnCard = '';
      this.nameOnCardError = false;
      if (!user) {
        this.addObjectUser.Holder = {
          Mobile: {}
        };
        return;
      }
      this.addObjectUser.Holder = user;
      this.initialLoadError = false;
      this.cardHolderPhoneNumberError = false;
      var phoneCode = user.Mobile.PhoneCode.replace(/\+/, '');
      this.$refs.countryCodeComponent.choose({
        iso2: user.Mobile.CountryCode,
        dialCode: phoneCode
      });
    },
    fetchCountries: function fetchCountries(value) {
      var _this6 = this;
      this.counter || this.api.forms.post(this.api.$.profile.getAllCountries, {
        q: value || ''
      }).then(function (r) {
        _this6.counter = 0;
        if (r && r.data && r.data.Data) {
          _this6.countries = r.data.Data;
        }
      }).catch(function (e) {
        console.warn(e);
        _this6.counter = 0;
      });
      this.counter = 1;
    },
    fetchUserDivisions: function fetchUserDivisions() {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.divisions = [];
              if (_this7.accountId === '') {
                _this7.api.get(_this7.api.$.evedpaycard.division).then(function (response) {
                  if (response && response.data) {
                    var _iterator = _createForOfIteratorHelper(response.data),
                      _step;
                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var account = _step.value;
                        _this7.divisions.push({
                          Id: account.DivisionId,
                          Name: account.DivisionName,
                          AccountId: account.AccountId
                        });
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                  }
                }).catch(function (error) {
                  console.warn(error);
                });
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    restoreCountries: function restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries);
      }
    },
    isUS: function isUS() {
      return this.formData.country && this.formData.country.CountryName === 'United States';
    },
    GetStatesUSURL: function GetStatesUSURL() {
      return this.api.$.profile.getAllStates;
    },
    isCanada: function isCanada() {
      return this.formData.country && this.formData.country.CountryName === 'Canada';
    },
    GetStatesCanadaURL: function GetStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates;
    },
    // Fetch States on OPEN
    fetchUSStatesOnOpen: function fetchUSStatesOnOpen() {
      var url = this.GetStatesUSURL();
      this.fetchStatesOnOpen(this.USstates, url);
    },
    fetchCanadaStatesOnOpen: function fetchCanadaStatesOnOpen() {
      var url = this.GetStatesCanadaURL();
      this.fetchStatesOnOpen(this.canadaStates, url);
    },
    fetchStatesOnOpen: function fetchStatesOnOpen(states, url) {
      var _this8 = this;
      if (states.length && (this.isCanada() || this.isUS())) {} else {
        this.api.forms.post(url, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this8.mapStatesDataOnOpen(r.data.Data);
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    mapStatesDataOnOpen: function mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USstates = this.USoriginalStates = data;
      } else {
        this.canadaStates = this.originalCanadaStates = data;
      }
    },
    // Fetch States on search text
    fetchUSStates: function fetchUSStates(value) {
      var url = this.GetStatesUSURL();
      this.fetchStates(value, url);
    },
    fetchCanadaStates: function fetchCanadaStates(value) {
      var url = this.GetStatesCanadaURL();
      this.fetchStates(value, url);
    },
    fetchStates: function fetchStates(value, url) {
      var _this9 = this;
      this.counter || this.api.forms.post(url, {
        q: value || ''
      }).then(function (r) {
        _this9.counter = 0;
        if (r && r.data && r.data.Data) {
          _this9.mapStatesDataOnFetch(r.data.Data);
        }
      }).catch(function (e) {
        console.warn(e);
        _this9.counter = 0;
      });
      this.counter = 1;
    },
    mapStatesDataOnFetch: function mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USstates = data;
      } else {
        this.canadaStates = data;
      }
    },
    // Restore States
    restoreUSStates: function restoreUSStates() {
      this.restoreStates(this.USstates, this.USoriginalStates);
    },
    restoreCanadaStates: function restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates);
    },
    restoreStates: function restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates);
      }
    },
    populateFormData: function populateFormData(data) {
      if (data.CompanyName !== null) {
        this.formData = {
          city: data.City,
          postalCode: data.Zip,
          originalCountryName: data.CountryName,
          country: {
            'CountryID': 186,
            'CountryName': 'United States'
          },
          state: {
            StateID: data.isCanada === 'False' && data.StateID || 0,
            StateName: data.isCanada === 'False' && data.State || ''
          },
          canadaState: {
            StateID: data.isCanada === 'True' && data.StateID || 0,
            StateName: data.isCanada === 'True' && data.State || ''
          },
          region: data.Region
        };
        this.disableControls = true;
      } else {
        this.disableControls = false;
      }
    },
    countrySelected: function countrySelected(e) {
      this.doDisplayCountryError = false;
      this.resetState(e.CountryName);
    },
    resetState: function resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.formData.state = {
          StateID: 0,
          StateName: ''
        };
        this.formData.canadaState = {
          StateID: 0,
          StateName: ''
        };
        this.formData.region = '';
      } else {
        this.originalCountryName = countryName;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("RMJP")))

/***/ }),

/***/ "E7hm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'Has Receipt': {
    icon: 'fas fa-camera',
    color: '#4A90E2'
  },
  'No Receipt': {
    icon: 'fas fa-camera',
    color: '#989898'
  }
});

/***/ }),

/***/ "EK88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardAdditionalUsers_vue__ = __webpack_require__("F6OC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea4d933e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardAdditionalUsers_vue__ = __webpack_require__("3EmP");
function injectStyle (ssrContext) {
  __webpack_require__("EaCK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea4d933e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardAdditionalUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea4d933e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardAdditionalUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EO3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("+HLh");
/* empty harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Ea+1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_store__ = __webpack_require__("dgq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_api_env_json__ = __webpack_require__("hcMa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_api_env_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__core_api_env_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_api_map_json__ = __webpack_require__("m/F2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_api_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__core_api_map_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_user__ = __webpack_require__("uduW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_api_mobileWebview__ = __webpack_require__("a45c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_legacy_auth_index_vue__ = __webpack_require__("mnjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_loading_indicators__ = __webpack_require__("WFO1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Login_loginService__ = __webpack_require__("6SW0");


/* eslint no-multi-spaces: 0 */
/* eslint no-unused-vars : 0 */
/* eslint key-spacing    : 0 */












__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__core_loading_indicators__["a" /* default */]);
var _HTML_ = 'text/html';
var _JS_ = 'application/javascript';
var _JSON_ = 'application/json';
var backend = function backend(response) {
  return {
    is: function is(type) {
      return response.headers['content-type'] && response.headers['content-type'].indexOf(type) > -1;
    },
    getError: function getError(identifier) {
      var el = document.createElement('html');
      var selector = identifier || '[style="color:maroon"]';
      el.innerHTML = response.data;
      var query = el.querySelector(selector);
      return query ? query.innerHTML : '';
    }
  };
};

// Nothing strips ?token= from the route, so a deep-link token the server has already
// rejected would otherwise be retried on every request for the life of the session.
var staleUrlToken = null;
var usableUrlToken = function usableUrlToken() {
  var route = global.app && global.app.$router && global.app.$router.currentRoute;
  var urlToken = route && route.query && route.query.token;
  return urlToken && urlToken !== staleUrlToken ? urlToken : null;
};

// Re-runs the handshake with the persisted token so loginService repopulates $user. Swapping
// the header alone leaves a cold-started webview authorised but user-less, and several
// EvedPay screens dereference $user.$ unguarded.
var retryWithPersistedToken = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(request, openApiToken) {
    var r, moduleContext;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          request.headers['Authorization'] = "Bearer ".concat(openApiToken);
          _context.next = 3;
          return global.app.api.post('open-api/user/login', undefined, {
            usePersistedToken: true
          });
        case 3:
          r = _context.sent;
          if (!(r.data || r.data === '')) {
            _context.next = 8;
            break;
          }
          moduleContext = document.querySelector('.theme.public').__vue__.$refs.currentModule;
          _context.next = 8;
          return __WEBPACK_IMPORTED_MODULE_12__components_Login_loginService__["a" /* default */].init.call(moduleContext, r.data, false, true);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function retryWithPersistedToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var Report = function Report(e) {
  // const url = error.request.responseURL.replace(process.env.NET_GATEWAY, '')
  // console.warn(`On ${new Date()}, ${global.app.$user.email} reported ${error} in ${url} from ${global.app.$route.path}`)
};

// Eved.Frontend env files are the canonical source for Platform hosts. Do not
// add qaproduction/sandbox/admin-team/reporting-team/workflow-team Platform
// hostnames here until Christi confirms they are valid for Eved.Web routing.
var platformEnvironmentMap = {
  'prod': 'https://platform.eved.com/api',
  'production': 'https://platform.eved.com/api',
  'qa': 'https://qa-platform.eved.com/api',
  'qainternaldemo': 'https://qa-platform.eved.com/api',
  'qainternaldemoevedonline.': 'https://qa-platform.eved.com/api',
  'qaproduction': 'https://qa-platform.eved.com/api',
  'qaproductionevedonline.': 'https://qa-platform.eved.com/api',
  'dev': 'https://qa-platform.eved.com/api'
};
var platformGateway = function platformGateway(baseURL, environment) {
  return platformEnvironmentMap[environment] || baseURL;
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Eved',
  getUser: __WEBPACK_IMPORTED_MODULE_8__core_user__["a" /* default */].$,
  install: function install(Vue) {
    __WEBPACK_IMPORTED_MODULE_8__core_user__["a" /* default */].init();

    /** Set axios alias */
    Vue.prototype.$http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;

    /** Set env api url */
    var environment = '';
    if (global.location.host === __WEBPACK_IMPORTED_MODULE_6__core_api_env_json___default.a.main) {
      environment = '';
    } else {
      environment = __WEBPACK_IMPORTED_MODULE_6__core_api_env_json___default.a[global.location.pathname.split('/')[1]] || __WEBPACK_IMPORTED_MODULE_6__core_api_env_json___default.a._default;
    }
    // console.log('environment is', environment || env._default)

    var baseEnv = "https://local.eved.com/evednetwork";
    var baseEnvL = "https://local.eved.com/api/v2";
    var basePlatformEnv = platformGateway("https://platform.eved.com/api", environment);
    if (false) {
      baseEnv = baseEnv.replace(/https?/, 'https').replace(env._default, "".concat(environment));
      baseEnvL = baseEnvL.replace(/https?/, 'https').replace(env._default, "".concat(environment));
    } else {
      var envPrefix =  true ? '' : env._default;
      baseEnv = baseEnv.replace(__WEBPACK_IMPORTED_MODULE_6__core_api_env_json___default.a._default, "".concat(envPrefix).concat("evedonline."));
      baseEnvL = baseEnvL.replace(__WEBPACK_IMPORTED_MODULE_6__core_api_env_json___default.a._default, "".concat(envPrefix).concat("evedonline."));
    }

    /** Set api instance */
    var API = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
      baseURL: baseEnv,
      withCredentials: true,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    API.env = baseEnv.replace(__WEBPACK_IMPORTED_MODULE_6__core_api_env_json___default.a._default, environment);
    API._env = environment;

    /**
     * Set instance for endpoints that require form data
     *
     */
    API.forms = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
      baseURL: baseEnv,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json, text/javascript, */*',
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: {},
      withCredentials: true,
      timeout: 30000
    });
    API.platform = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
      baseURL: basePlatformEnv,
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    API.platform.env = basePlatformEnv;

    /** Intercept request payload and URL encode it */
    API.forms.interceptors.request.use(/*#__PURE__*/function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(request) {
        var openApiToken, urlToken, r, moduleContext;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              openApiToken = localStorage.openApiToken;
              urlToken = usableUrlToken();
              if (!urlToken) {
                _context2.next = 25;
                break;
              }
              request.headers['Authorization'] = "Bearer ".concat(urlToken);
              _context2.prev = 4;
              _context2.next = 7;
              return global.app.api.post('open-api/user/login');
            case 7:
              r = _context2.sent;
              if (!(r.data || r.data === '')) {
                _context2.next = 15;
                break;
              }
              // Persisted before init, which awaits further requests that can fail on their
              // own. Losing the token there would send every later request back through the
              // handshake with nothing to fall back on.
              localStorage.openApiToken = urlToken;
              moduleContext = document.querySelector('.theme.public').__vue__.$refs.currentModule;
              _context2.next = 13;
              return __WEBPACK_IMPORTED_MODULE_12__components_Login_loginService__["a" /* default */].init.call(moduleContext, r.data, false, true);
            case 13:
              _context2.next = 16;
              break;
            case 15:
              global.app.$user.$ = JSON.parse(localStorage.evedUser || '{}');
            case 16:
              _context2.next = 25;
              break;
            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](4);
              // A stale deep-link token must not outrank a persisted one that still authorises.
              staleUrlToken = urlToken;
              if (!(!openApiToken || openApiToken === urlToken)) {
                _context2.next = 23;
                break;
              }
              throw _context2.t0;
            case 23:
              _context2.next = 25;
              return retryWithPersistedToken(request, openApiToken);
            case 25:
              // attach csrf
              request.headers['__RequestVerificationToken'] = __WEBPACK_IMPORTED_MODULE_5__components_store__["a" /* store */].state.isLoggedIn && __WEBPACK_IMPORTED_MODULE_5__components_store__["a" /* store */].state.csrf;
              __WEBPACK_IMPORTED_MODULE_11__core_loading_indicators__["a" /* default */].hook.start(request);
              request.data = __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(request.data);

              // proxy
              if (global.location.protocol === 'https:') {
                request.baseURL = Object({"NODE_ENV":"production","PORTAL_ENV":false,"BASE":"https://eved.com","LEGACY_SUBDOMAIN":"evedonline.","PHP_GATEWAY":"https://local.eved.com/api/v2","NET_GATEWAY":"https://local.eved.com/evednetwork","PLATFORM_GATEWAY":"https://platform.eved.com/api","PHP_GATEWAY_FEATURE":"https://local.eved.com/api/v2","NET_GATEWAY_FEATURE":"https://local.eved.com/evednetwork","PUBLIC_PATH":"eved-dawn/dist","INTERCOM_APP":"a4gh1g5t","GA":"UA-6992574-5","PLATFORM_URL":"https://platform.eved.com","FEATURE_RECEIPT_SCAN_PREFILL":"true"}).NET_PROXY ? request.baseURL.replace("https://local.eved.com/evednetwork", Object({"NODE_ENV":"production","PORTAL_ENV":false,"BASE":"https://eved.com","LEGACY_SUBDOMAIN":"evedonline.","PHP_GATEWAY":"https://local.eved.com/api/v2","NET_GATEWAY":"https://local.eved.com/evednetwork","PLATFORM_GATEWAY":"https://platform.eved.com/api","PHP_GATEWAY_FEATURE":"https://local.eved.com/api/v2","NET_GATEWAY_FEATURE":"https://local.eved.com/evednetwork","PUBLIC_PATH":"eved-dawn/dist","INTERCOM_APP":"a4gh1g5t","GA":"UA-6992574-5","PLATFORM_URL":"https://platform.eved.com","FEATURE_RECEIPT_SCAN_PREFILL":"true"}).NET_PROXY) : request.baseURL;
                request.baseURL = baseEnv.replace(__WEBPACK_IMPORTED_MODULE_6__core_api_env_json___default.a._default, environment);
              }
              return _context2.abrupt("return", request);
            case 30:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[4, 18]]);
      }));
      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    API.platform.interceptors.request.use(/*#__PURE__*/function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3(request) {
        var currentRoute, urlToken;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              currentRoute = global.app && global.app.$router && global.app.$router.currentRoute;
              urlToken = currentRoute && currentRoute.query && currentRoute.query.token;
              if (urlToken) {
                request.headers['Authorization'] = "Bearer ".concat(urlToken);
              } else if (__WEBPACK_IMPORTED_MODULE_5__components_store__["a" /* store */].state.isLoggedIn && global.app.$user && global.app.$user.sessionSettings && global.app.$user.sessionSettings.Token) {
                request.headers['Authorization'] = "Bearer ".concat(global.app.$user.sessionSettings.Token);
              }
              if (request.baseURL && request.baseURL.match(/\/api\/?$/) && request.url && request.url.indexOf('api/') === 0) {
                request.url = request.url.replace(/^api\//, '');
              }
              __WEBPACK_IMPORTED_MODULE_11__core_loading_indicators__["a" /* default */].hook.start(request);
              return _context3.abrupt("return", request);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    API.platform.interceptors.response.use(function (response) {
      __WEBPACK_IMPORTED_MODULE_11__core_loading_indicators__["a" /* default */].hook.stop(response);
      return response;
    }, function (error) {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_11__core_loading_indicators__["a" /* default */].hook.stop(error);
      }, 100);
      return Promise.reject(error);
    });

    /**
     * Hook into api calls for handling loading indicators and notifications
     *
     */
    API.interceptors.request.use(/*#__PURE__*/function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4(request) {
        var openApiToken, urlToken, isAuthorizing, r, moduleContext;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              openApiToken = localStorage.openApiToken;
              urlToken = usableUrlToken();
              if (!(request.usePersistedToken && openApiToken)) {
                _context4.next = 6;
                break;
              }
              request.headers['Authorization'] = "Bearer ".concat(openApiToken);
              _context4.next = 34;
              break;
            case 6:
              if (!urlToken) {
                _context4.next = 33;
                break;
              }
              request.headers['Authorization'] = "Bearer ".concat(urlToken);
              isAuthorizing = request.url === 'open-api/user/login';
              if (isAuthorizing) {
                _context4.next = 31;
                break;
              }
              _context4.prev = 10;
              _context4.next = 13;
              return global.app.api.post('open-api/user/login');
            case 13:
              r = _context4.sent;
              if (!(r.data || r.data === '')) {
                _context4.next = 21;
                break;
              }
              // Persisted before init, which awaits further requests that can fail on their
              // own. Losing the token there would send every later request back through the
              // handshake with nothing to fall back on.
              localStorage.openApiToken = urlToken;
              moduleContext = document.querySelector('.theme.public').__vue__.$refs.currentModule;
              _context4.next = 19;
              return __WEBPACK_IMPORTED_MODULE_12__components_Login_loginService__["a" /* default */].init.call(moduleContext, r.data, false, true);
            case 19:
              _context4.next = 22;
              break;
            case 21:
              global.app.$user.$ = JSON.parse(localStorage.evedUser || '{}');
            case 22:
              _context4.next = 31;
              break;
            case 24:
              _context4.prev = 24;
              _context4.t0 = _context4["catch"](10);
              // A stale deep-link token must not outrank a persisted one that still authorises.
              staleUrlToken = urlToken;
              if (!(!openApiToken || openApiToken === urlToken)) {
                _context4.next = 29;
                break;
              }
              throw _context4.t0;
            case 29:
              _context4.next = 31;
              return retryWithPersistedToken(request, openApiToken);
            case 31:
              _context4.next = 34;
              break;
            case 33:
              if (__WEBPACK_IMPORTED_MODULE_5__components_store__["a" /* store */].state.isLoggedIn && global.app.$user && global.app.$user.sessionSettings && global.app.$user.sessionSettings.Token) {
                request.headers['Authorization'] = "Bearer ".concat(global.app.$user.sessionSettings.Token);
              } else if (openApiToken) {
                // Mobile flow: after the urlToken handshake, the urlToken is persisted to
                // localStorage.openApiToken (above) but isLoggedIn/sessionSettings may not be
                // populated on subsequent internal navigations that drop the ?token= query.
                // Fall back to the persisted token so legacy JWT-validated controllers don't 500.
                request.headers['Authorization'] = "Bearer ".concat(openApiToken);
              }
            case 34:
              request.headers['__RequestVerificationToken'] = __WEBPACK_IMPORTED_MODULE_5__components_store__["a" /* store */].state.isLoggedIn && __WEBPACK_IMPORTED_MODULE_5__components_store__["a" /* store */].state.csrf;
              if (request.url !== global.app.api.$.ping) {
                __WEBPACK_IMPORTED_MODULE_11__core_loading_indicators__["a" /* default */].hook.start(request);
              }

              // proxy
              if (global.location.protocol === 'https:') {
                request.url = Object({"NODE_ENV":"production","PORTAL_ENV":false,"BASE":"https://eved.com","LEGACY_SUBDOMAIN":"evedonline.","PHP_GATEWAY":"https://local.eved.com/api/v2","NET_GATEWAY":"https://local.eved.com/evednetwork","PLATFORM_GATEWAY":"https://platform.eved.com/api","PHP_GATEWAY_FEATURE":"https://local.eved.com/api/v2","NET_GATEWAY_FEATURE":"https://local.eved.com/evednetwork","PUBLIC_PATH":"eved-dawn/dist","INTERCOM_APP":"a4gh1g5t","GA":"UA-6992574-5","PLATFORM_URL":"https://platform.eved.com","FEATURE_RECEIPT_SCAN_PREFILL":"true"}).PHP_PROXY ? request.url.replace("https://local.eved.com/api/v2", Object({"NODE_ENV":"production","PORTAL_ENV":false,"BASE":"https://eved.com","LEGACY_SUBDOMAIN":"evedonline.","PHP_GATEWAY":"https://local.eved.com/api/v2","NET_GATEWAY":"https://local.eved.com/evednetwork","PLATFORM_GATEWAY":"https://platform.eved.com/api","PHP_GATEWAY_FEATURE":"https://local.eved.com/api/v2","NET_GATEWAY_FEATURE":"https://local.eved.com/evednetwork","PUBLIC_PATH":"eved-dawn/dist","INTERCOM_APP":"a4gh1g5t","GA":"UA-6992574-5","PLATFORM_URL":"https://platform.eved.com","FEATURE_RECEIPT_SCAN_PREFILL":"true"}).PHP_PROXY) : request.url;
                request.url = Object({"NODE_ENV":"production","PORTAL_ENV":false,"BASE":"https://eved.com","LEGACY_SUBDOMAIN":"evedonline.","PHP_GATEWAY":"https://local.eved.com/api/v2","NET_GATEWAY":"https://local.eved.com/evednetwork","PLATFORM_GATEWAY":"https://platform.eved.com/api","PHP_GATEWAY_FEATURE":"https://local.eved.com/api/v2","NET_GATEWAY_FEATURE":"https://local.eved.com/evednetwork","PUBLIC_PATH":"eved-dawn/dist","INTERCOM_APP":"a4gh1g5t","GA":"UA-6992574-5","PLATFORM_URL":"https://platform.eved.com","FEATURE_RECEIPT_SCAN_PREFILL":"true"}).NET_PROXY ? request.url.replace("https://local.eved.com/evednetwork", Object({"NODE_ENV":"production","PORTAL_ENV":false,"BASE":"https://eved.com","LEGACY_SUBDOMAIN":"evedonline.","PHP_GATEWAY":"https://local.eved.com/api/v2","NET_GATEWAY":"https://local.eved.com/evednetwork","PLATFORM_GATEWAY":"https://platform.eved.com/api","PHP_GATEWAY_FEATURE":"https://local.eved.com/api/v2","NET_GATEWAY_FEATURE":"https://local.eved.com/evednetwork","PUBLIC_PATH":"eved-dawn/dist","INTERCOM_APP":"a4gh1g5t","GA":"UA-6992574-5","PLATFORM_URL":"https://platform.eved.com","FEATURE_RECEIPT_SCAN_PREFILL":"true"}).NET_PROXY) : request.url;
                request.url = request.url.replace(__WEBPACK_IMPORTED_MODULE_6__core_api_env_json___default.a._default, environment);
                request.baseURL = request.baseURL.replace(__WEBPACK_IMPORTED_MODULE_6__core_api_env_json___default.a._default, environment);
              }

              // map environment to other api environments
              if (~request.url.indexOf('http') && ~request.url.indexOf('api.')) {
                request.url = request.url.replace('://', "://".concat(environment.replace("evedonline.", '').replace(/\./g, '-')));
              }
              if (~request.url.indexOf('//') === 0 && ~request.url.indexOf('api.')) {
                request.url = "".concat(global.location.protocol).concat(request.url.replace(request.baseURL, ''));
              }
              if (~request.url.indexOf('{ENV}')) {
                request.url = request.url.replace('{ENV}', global.app.api._env.replace("evedonline.", '').replace(/\./g, '-'));
              }
              return _context4.abrupt("return", request);
            case 41:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[10, 24]]);
      }));
      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }());
    API.interceptors.response.use(function (response) {
      __WEBPACK_IMPORTED_MODULE_11__core_loading_indicators__["a" /* default */].hook.stop(response);

      // Invalid session
      if (response.request.responseURL.indexOf(global.app.api.$.expired) > -1 && response.request.responseURL.indexOf(encodeURIComponent('/Account/SignOutUser').replace(/%../g, function (m) {
        return m.toLowerCase();
      })) === -1) {
        global.app.$user.logout();
        return response;
      }

      /** If session expired */
      if (typeof response.data === 'string') {
        if (response.data.indexOf('session has expired') > -1 && response.request.responseURL !== global.app.api.$.ping && response.request.responseURL !== global.app.api.$.session &&
        // response.request.responseURL === global.app.api.$.expired &&
        response.request.responseURL !== global.app.api.$.login && response.request.responseURL !== global.app.api.$.logout) {
          if (global.app.$route.path === '/login') return response;
          /* global.app.$notifications.notify({
            type: 'plain',
            icon: 'times-octagon',
            message: `${global.app.$t('Session Expired')}`,
            dismiss: global.app.$t('Login'),
            timeout: 0,
            placement: { from: 'top', align: 'center' },
            onClose: function (dismiss) {
              if (dismiss) {
                global.app.$user.logout()
              }
            }
          }) */
          global.app.$user.logout();
          return response;
        }
      }

      /** If returned html, asume error */
      if (backend(response).is(_HTML_) && backend(response).getError()) {
        // Notification message
        global.app.$notifications.notify({
          type: 'warning',
          icon: 'times-octagon',
          message: backend(response).getError() + "<br><a href=\"#\">Report this</a>",
          timeout: 30000,
          placement: {
            from: 'bottom',
            align: 'right'
          }
        });
      }
      return response;
    }, function (error) {
      /** Handle generic errors */
      // let target = error.response && error.response.config.url.replace(process.env.NET_GATEWAY, '').replace(/\//g, ' ')

      // Unauthorized
      if (error.response.status === 401) {
        // The mobile shell owns its own login, and a webview session recovers through the
        // persisted token on the next request. Tearing the session down here would strand it
        // on a page whose credentials it cannot submit, with $user and the back-history gone.
        if (!Object(__WEBPACK_IMPORTED_MODULE_9__core_api_mobileWebview__["a" /* default */])()) {
          global.app.$user.logout();
        }
        return Promise.reject(error);
      }
      var validationError = error.response && error.response.data.error && error.response.data.error.name && error.response.data.error.name === 'ValidationError';

      // EvedPay card endpoints send errors as a bare array ([{ Message }]), not { Errors: [...] } - read both (SPRT-18672)
      var errorData = error.response && error.response.data;
      var errorMessage = errorData && errorData.Errors && errorData.Errors[0] && errorData.Errors[0].Message || Array.isArray(errorData) && errorData[0] && errorData[0].Message || 'Something went wrong';
      if (error && !validationError && !JSON.parse(error.response.config.data || '{}').preventError) {
        // Notification message
        global.app.$notifications.notify({
          type: 'plain',
          icon: 'times-octagon',
          message: "Error\n            <br><strong>".concat(errorMessage, "</strong>\n            <br><a class=\"btn btn-xs btn-actionbar\" target=\"_blank\" href=\"https://www.eved.com/contact-us/\">Report this</a>"),
          timeout: 0,
          placement: {
            from: 'top',
            align: 'center'
          }
        });
      }
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_11__core_loading_indicators__["a" /* default */].hook.stop(error);
      }, 100);

      /** Handle server errors */
      if (error.response && error.response.status === 500) {
        // TODO: notify here
        return Promise.reject(error);
      } else {
        return Promise.reject(error);
      }
    });
    API.forms.interceptors.response = API.interceptors.response;
    Vue.prototype.api = API;
    Vue.prototype.api.$ = __WEBPACK_IMPORTED_MODULE_7__core_api_map_json___default.a;
    Vue.prototype.api.$.ping = baseEnvL + '/ping';
    Vue.prototype.api.$.login = '/Account/IdentityLogin';
    Vue.prototype.api.$.initLegacy = '/../api/v2/initLegacy';
    Vue.prototype.api.$.Login = '/Login/';
    Vue.prototype.api.$.logout = baseEnvL + '/signout';
    Vue.prototype.api.$.Logout = baseEnv + '/Account/SignOutUser';
    Vue.prototype.api.$.session = baseEnv + '/Sched/Welcome';
    Vue.prototype.api.$.expired = '/Account/IdentityLogin?ReturnUrl=';
    Vue.prototype.api.$.privateResources = API.env + '/Storage/private/';
    Vue.component(__WEBPACK_IMPORTED_MODULE_10__core_legacy_auth_index_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__core_legacy_auth_index_vue__["a" /* default */]);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "EaCK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EbYq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'md-stats-widget',
  props: {
    icon: String,
    faIcon: String,
    backgroundColor: String,
    title: String
  }
});

/***/ }),

/***/ "Edt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getRefillSettings();
  },
  computed: {
    // Surface the custom Name on Card next to the legal holder ("Jane Doe | John Smith") when it is set
    // and meaningfully differs (case-insensitive); otherwise show the legal name unchanged. Holder may be
    // a plain string (grid selection) or an object with .Name, so normalise both. See PRODUCTDEV-5553.
    holderDisplay: function holderDisplay() {
      var legalName = this.card && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(this.card.Holder) === 'object' ? this.card.Holder.Name || '' : this.card && this.card.Holder || '';
      var nameOnCard = (this.card && this.card.NameOnCard || '').trim();
      if (!nameOnCard || nameOnCard.toLowerCase() === legalName.trim().toLowerCase()) {
        return legalName;
      }
      if (!legalName.trim()) {
        return nameOnCard;
      }
      return "".concat(nameOnCard, " | ").concat(legalName);
    }
  },
  methods: {
    doRefill: function doRefill(showModal) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.card.Id) {
                _context.next = 11;
                break;
              }
              _context.prev = 1;
              _context.next = 4;
              return _this.api.patch("evedpaycards/".concat(_this.card.Id, "/refill-settings"), {
                RefillSettings: _this.RefillSettings
              });
            case 4:
              response = _context.sent;
              if (response.status === 200) {
                showModal.showModal = false;
                __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('refill', _this.card.Id);
              } else {
                console.log('Failed to refill');
              }
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    getRefillSettings: function getRefillSettings() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this2.card.Id) {
                _context2.next = 11;
                break;
              }
              _context2.prev = 1;
              _context2.next = 4;
              return _this2.api.get("evedpaycards/".concat(_this2.card.Id, "/refill-settings"));
            case 4:
              response = _context2.sent;
              if (response.status === 200) {
                _this2.RefillSettings = response.data;
              }
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              console.log(_context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 8]]);
      }))();
    }
  },
  props: {
    card: Object
  },
  data: function data() {
    return {
      RefillSettings: {
        RefillAmount: null,
        RefillThreshold: null
      }
    };
  }
});

/***/ }),

/***/ "EiP9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ex2o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  display: false,
  headerLabel: '',
  columns: [],
  errors: []
});

/***/ }),

/***/ "ExUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"show":_vm.show,"title":_vm.title,"primary-button":"Save","secondary-button":"Cancel","validation":_vm.validation,"primaryButtonDisabled":_vm.saveButtonDisabled,"closeOnEsc":true,"name":"add_fees_discounts"},on:{"close":_vm.onClose,"validate":_vm.onSave}},[_c('div',{staticClass:"content",attrs:{"slot":"body"},slot:"body"},[_c('ed-form',{staticClass:"col-md-12 no-pad",attrs:{"submit-visible":false}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ed-select',{attrs:{"field-label":"Category","placeholder":_vm.categoryPlaceholder,"options":_vm.categories,"required":"required","label":"text","track-by":"text","group-label":"label","group-values":"options","error":_vm.doDisplayCategoryError,"helptip-header":_vm.doDisplayCategoryError ? 'Error' : '',"helptip-body":_vm.doDisplayCategoryError ? 'Please select a category' : '',"name":"category"},on:{"select":function($event){return _vm.categorySelected($event)}},model:{value:(_vm.formData.draftItem.category),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "category", $$v)},expression:"formData.draftItem.category"}})],1)]),_vm._v(" "),(_vm.showOneBusinessUnit)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-md-4"},[_vm._v("Business Unit")]),_vm._v(" "),_c('span',{staticClass:"col-md-8 small",attrs:{"name":"one_bu_name"}},[_vm._v(_vm._s(_vm.businessUnit.name))])]):_vm._e(),_vm._v(" "),(_vm.showBusinessUnits)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ed-select',{attrs:{"field-label":"Business Unit","placeholder":"Select business unit","options":_vm.businessUnits,"required":"required","label":"name","track-by":"key","error":_vm.doDisplayBusinessUnitError,"helptip-header":_vm.doDisplayBusinessUnitError ? 'Error' :'',"helptip-body":_vm.doDisplayBusinessUnitError ? 'Please select a Business Unit' : '',"name":"business_units"},on:{"select":function($event){return _vm.businessUnitSelected($event)}},model:{value:(_vm.formData.draftItem.businessUnit),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "businessUnit", $$v)},expression:"formData.draftItem.businessUnit"}})],1)]):_vm._e(),_vm._v(" "),(_vm.showOneCostCenter)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-md-4"},[_vm._v("Cost Center")]),_vm._v(" "),_c('span',{staticClass:"col-md-8 small",attrs:{"name":"one_cc_name"}},[_vm._v("\n          "+_vm._s(_vm.costCenter.name ? _vm.getCostCenterName(_vm.costCenter) : _vm.costCenter.code)+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.showCostCenters)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ed-select',{attrs:{"field-label":"Cost Center","placeholder":"Select a Cost Center","options":_vm.costCenters,"required":"required","label":"name","track-by":"code","customLabel":_vm.getCostCenterName,"error":_vm.doDisplayCostCenterError,"helptip-header":_vm.doDisplayCostCenterError ? 'Error' : '',"helptip-body":_vm.doDisplayCostCenterError ? 'Please select a Cost Center' : '',"name":"cost_centers"},on:{"select":function($event){return _vm.costCenterSelected($event)}},model:{value:(_vm.formData.draftItem.costCenter),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "costCenter", $$v)},expression:"formData.draftItem.costCenter"}})],1)]):_vm._e(),_vm._v(" "),(_vm.showOneCostCenterWithBusinessUnit)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-md-4"},[_vm._v("Business Unit and Cost Center")]),_vm._v(" "),_c('span',{staticClass:"col-md-8 small",attrs:{"name":"one_bu_cc_pair_name"}},[_vm._v(_vm._s(_vm.businessUnitsWithCostCenter.name))])]):_vm._e(),_vm._v(" "),(_vm.showMixCostCentersWithBusinessUnits)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ed-select',{attrs:{"field-label":"Business Unit and Cost Center","placeholder":"Select business unit and cost center pair","options":_vm.businessUnitsWithCostCenters,"required":"required","label":"name","track-by":"key","error":_vm.doDisplayMixCostCenterWithBusinessUnitError,"helptip-header":_vm.doDisplayMixCostCenterWithBusinessUnitError ? 'Error' : '',"helptip-body":_vm.doDisplayMixCostCenterWithBusinessUnitError ? 'Please select a Business Unit with Cost Center' : '',"name":"bu_cc_pairs"},on:{"select":function($event){return _vm.businessUnitWithCostCenter($event)}},model:{value:(_vm.formData.draftItem.pairedBusinessUnitAndCostCenter),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "pairedBusinessUnitAndCostCenter", $$v)},expression:"formData.draftItem.pairedBusinessUnitAndCostCenter"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ed-textarea',{attrs:{"field-label":"Description","placeholder":"","name":"description"},model:{value:(_vm.formData.draftItem.description),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "description", $$v)},expression:"formData.draftItem.description"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('custom-fields',{ref:"feeCustomFieldsRef",attrs:{"endpoint":_vm.api.$.invoice.i2p.itemCustomFields,"queryParameters":{invoiceId: _vm.model.PaymentInvoiceId, divisionId: _vm.model.DivisionID},"values":_vm.itemCustomFields}})],1)]),_vm._v(" "),(_vm.formData.draftItem.category.amountTypes !== null)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('ed-select',{attrs:{"field-label":"Amount","options":_vm.amountTypes,"required":"required","label":"text","track-by":"amountType","error":_vm.doDisplayAmountTypeError,"helptip-header":_vm.doDisplayAmountTypeError ? 'Error' : '',"helptip-body":_vm.doDisplayAmountTypeError ? 'Please select an amount type' : '',"name":"amount_types"},on:{"select":function($event){return _vm.amountTypeSelected($event)}},model:{value:(_vm.formData.draftItem.amountType),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "amountType", $$v)},expression:"formData.draftItem.amountType"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[(_vm.enterAmountSelected)?_c('ed-input',{attrs:{"empty-field-label":true,"type":"money","currency":_vm.currency,"amount":"","autoselect":"","name":"amount_selected"},model:{value:(_vm.formData.draftItem.amountTypeValue),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "amountTypeValue", $$v)},expression:"formData.draftItem.amountTypeValue"}}):_c('ed-input',{attrs:{"empty-field-label":true,"amount":"","symbol":"%","autoselect":"","name":"amount_percent"},model:{value:(_vm.formData.draftItem.amountTypeValue),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "amountTypeValue", $$v)},expression:"formData.draftItem.amountTypeValue"}})],1)]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EyOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"show":_vm.show,"title":_vm.title,"primary-button":"Save","secondary-button":"Cancel","type":"medium","validation":_vm.validation,"closeOnEsc":true},on:{"close":_vm.onClose,"validate":_vm.onSave}},[_c('div',{staticClass:"content",attrs:{"slot":"body"},slot:"body"},[_c('ed-form',{staticClass:"col-md-12 no-pad",attrs:{"submit-visible":false}},[_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('ed-input',{attrs:{"field-label":"Supplier name","required":"required","placeholder":"Enter the name of the supplier","error":_vm.doDisplaySupplierNameError,"helptip-header":_vm.doDisplaySupplierNameError && 'Error' || '',"helptip-body":_vm.doDisplaySupplierNameError && 'Please fill in supplier name' || '',"disabled":_vm.disableControls,"name":"supplier_name"},on:{"change":function($event){_vm.doDisplaySupplierNameError = false}},model:{value:(_vm.formData.supplierName),callback:function ($$v) {_vm.$set(_vm.formData, "supplierName", $$v)},expression:"formData.supplierName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('ed-input',{attrs:{"field-label":"Supplier ID","placeholder":"Enter the supplier's ID","disabled":_vm.disableControls,"name":"supplier_id"},model:{value:(_vm.formData.supplierId),callback:function ($$v) {_vm.$set(_vm.formData, "supplierId", $$v)},expression:"formData.supplierId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('ed-input',{attrs:{"field-label":"Supplier VAT/GST ID","placeholder":"Enter the supplier's VAT/GST ID","name":"supplier_vat"},model:{value:(_vm.formData.supplierVATGSTId),callback:function ($$v) {_vm.$set(_vm.formData, "supplierVATGSTId", $$v)},expression:"formData.supplierVATGSTId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('ed-input',{attrs:{"field-label":"Supplier Contact Name","required":"required","error":_vm.doDisplaySupplierContactError,"helptip-header":_vm.doDisplaySupplierContactError &&  'Error' || '',"helptip-body":_vm.doDisplaySupplierContactError && 'Please fill in supplier contact' || '',"disabled":_vm.disableControls,"placeholder":"Enter the name of the supplier's representative","name":"supplier_contact_name"},on:{"change":function($event){_vm.doDisplaySupplierContactError = false}},model:{value:(_vm.formData.supplierContact),callback:function ($$v) {_vm.$set(_vm.formData, "supplierContact", $$v)},expression:"formData.supplierContact"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('ed-input',{attrs:{"field-label":"Email Address","required":"required","placeholder":"Enter the supplier's email address","error":_vm.doDisplayEmailError,"helptip-header":_vm.doDisplayEmailError &&  'Error' || '',"helptip-body":_vm.doDisplayEmailError && 'Please fill in email' || '',"name":"supplier_email"},on:{"change":_vm.emailChanged},model:{value:(_vm.formData.emailAddress),callback:function ($$v) {_vm.$set(_vm.formData, "emailAddress", $$v)},expression:"formData.emailAddress"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('h5',{staticClass:"col-md-12 section-title"},[_vm._v("Supplier Information")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('ed-input',{attrs:{"field-label":"Phone","placeholder":"Enter the supplier's phone number","error":_vm.doDisplayPhoneError,"helptip-header":_vm.doDisplayPhoneError &&  'Error' || '',"helptip-body":_vm.doDisplayPhoneError && 'Please fill in phone' || '',"disabled":_vm.disableControls,"name":"supplier_phone"},on:{"change":function($event){_vm.doDisplayPhoneError = false}},model:{value:(_vm.formData.phone),callback:function ($$v) {_vm.$set(_vm.formData, "phone", $$v)},expression:"formData.phone"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('ed-input',{attrs:{"field-label":"Address 1","placeholder":"Enter the supplier's first address","disabled":_vm.disableControls,"name":"supplier_address1"},model:{value:(_vm.formData.address1),callback:function ($$v) {_vm.$set(_vm.formData, "address1", $$v)},expression:"formData.address1"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('ed-input',{attrs:{"field-label":"Address 2","placeholder":"Enter the supplier's second address","disabled":_vm.disableControls,"name":"supplier_address2"},model:{value:(_vm.formData.address2),callback:function ($$v) {_vm.$set(_vm.formData, "address2", $$v)},expression:"formData.address2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('ed-input',{attrs:{"field-label":"City","placeholder":"Enter the supplier's city","disabled":_vm.disableControls,"name":"supplier_city"},model:{value:(_vm.formData.city),callback:function ($$v) {_vm.$set(_vm.formData, "city", $$v)},expression:"formData.city"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[(_vm.isUS())?_c('ed-select',{attrs:{"field-label":"State","placeholder":"Select a state","options":_vm.USstates,"label":"StateName","track-by":"StateID","disabled":_vm.disableControls,"name":"us_states"},on:{"open":_vm.fetchUSStatesOnOpen,"keyup":_vm.fetchUSStates,"close":_vm.restoreUSStates},model:{value:(_vm.formData.state),callback:function ($$v) {_vm.$set(_vm.formData, "state", $$v)},expression:"formData.state"}}):_vm._e(),_vm._v(" "),(_vm.isCanada())?_c('ed-select',{attrs:{"field-label":"State/Region","placeholder":"Select a region","options":_vm.canadaStates,"label":"StateName","disabled":_vm.disableControls,"name":"canada_states"},on:{"open":_vm.fetchCanadaStatesOnOpen,"keyup":_vm.fetchCanadaStates,"close":_vm.restoreCanadaStates},model:{value:(_vm.formData.canadaState),callback:function ($$v) {_vm.$set(_vm.formData, "canadaState", $$v)},expression:"formData.canadaState"}}):_vm._e(),_vm._v(" "),(!_vm.formData.country || !_vm.isCanada() && !_vm.isUS())?_c('ed-input',{attrs:{"field-label":"State/Region","placeholder":"Select a region","disabled":_vm.disableControls,"name":"state_region"},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('ed-input',{attrs:{"field-label":"Postal/Zip Code","placeholder":"Enter the supplier's zip","disabled":_vm.disableControls,"name":"supplier_postal_zip"},model:{value:(_vm.formData.postalCode),callback:function ($$v) {_vm.$set(_vm.formData, "postalCode", $$v)},expression:"formData.postalCode"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('ed-select',{attrs:{"field-label":"Country","placeholder":"Select a country...","options":_vm.countries,"label":"CountryName","track-by":"CountryID","openEndpoint":_vm.api.$.profile.getAllCountries,"error":_vm.doDisplayCountryError,"helptip-header":_vm.doDisplayCountryError && 'Error' || '',"helptip-body":_vm.doDisplayCountryError && 'Please select a country' || '',"disabled":_vm.disableControls,"name":"supplier_country"},on:{"select":function($event){return _vm.countrySelected($event)},"open":_vm.fetchCountriesOnOpen,"keyup":_vm.fetchCountries,"close":_vm.restoreCountries},model:{value:(_vm.formData.country),callback:function ($$v) {_vm.$set(_vm.formData, "country", $$v)},expression:"formData.country"}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F+SX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LineItemStore_js__ = __webpack_require__("PJql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AllocateToBUCCPair',
  props: {
    model: Object,
    eventHub: Object,
    dependencies: Object,
    eventUniqueId: String
  },
  data: function data() {
    return {
      formData: {
        draftItem: {
          buCCPair: {}
        }
      },
      show: true,
      title: 'Allocate to Business Unit and Cost Center',
      validation: true,
      buCCPairs: [],
      selectedRows: [],
      selectedItemNames: [],
      doDisplayError: false
    };
  },
  created: function created() {
    var dialog = this;
    this.title = 'Allocate to Business Unit and Cost Center';
    this.selectedRows = this.model.selectedRows;
    this.selectedItemNames = this.model.selectedRows.map(function (item) {
      return item.data.name;
    });
    this.store().getCostCentersBusinessUnits(this.model.programId).then(function (response) {
      dialog.bindBUCCPairs(response.data);
    });
  },
  methods: {
    buCCPairsSelected: function buCCPairsSelected(e) {
      this.formData.draftItem.buCCPair = {
        key: e.key,
        name: e.name
      };
      this.doDisplayError = false;
    },
    store: function store() {
      return new __WEBPACK_IMPORTED_MODULE_0__LineItemStore_js__["a" /* default */](this.api);
    },
    onClose: function onClose() {
      this.show = false;
    },
    onSave: function onSave() {
      var _this = this;
      if (!this.isValid()) return;
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$emit('onSaveAllocateToBUCCPair', {
        data: {
          buCCPair: this.formData.draftItem.buCCPair,
          itemsToUpdate: this.selectedRows.map(function (item) {
            return item.rowIndex;
          }),
          eventUniqueId: this.eventUniqueId
        }
      });
      this.$nextTick(function () {
        _this.show = false;
      });
    },
    isValid: function isValid() {
      if (this.formData.draftItem.buCCPair && JSON.stringify(this.formData.draftItem.buCCPair) !== JSON.stringify({}) && this.formData.draftItem.buCCPair.name) {
        this.doDisplayError = false;
        return true;
      }
      this.doDisplayError = true;
      return false;
    },
    bindBUCCPairs: function bindBUCCPairs(data) {
      var buCCPairs = data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits;
      if (buCCPairs !== null && buCCPairs !== undefined && buCCPairs.length > 0) {
        this.buCCPairs = buCCPairs;
        if (this.selectedRows.length === 1) {
          var selectedPair = this.selectedRows[0].data.costCenterAndBusinessUnit;
          var pair = {
            key: selectedPair.costCenterAndBusinessUnitKey,
            name: selectedPair.costCenterAndBusinessUnitName
          };
          this.formData.draftItem.buCCPair = {
            key: pair.key,
            name: pair.name
          };
        }
      }
    }
  }
});

/***/ }),

/***/ "F/un":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  PO: {
    programDetails: {
      uniqueId: null
    },
    uniqueId: '',
    supplier: {},
    supplierContacts: [],
    events: [{
      lineItems: [],
      uniqueId: '',
      total: '',
      fees: '',
      taxes: '',
      discounts: '',
      subtotal: ''
    }],
    currency: {
      code: 'USD',
      symbol: '$',
      decimalPlaces: 2
    },
    currencySelected: false,
    total: '0',
    billTo: {},
    preparedBy: {},
    companyInfo: {},
    vat: 0,
    gst: 0
  },
  taxes: [],
  fees: []
});

/***/ }),

/***/ "F02B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Ud1h");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77edea6c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("5u/y");
function injectStyle (ssrContext) {
  __webpack_require__("DaOO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77edea6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77edea6c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "F1G1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1P5kK8eTV0VANjRuWwG8b5","Dell":"_1lGAfhl1ecWwA2j6HMeHKa","Abbott":"xY3x_Y5qu4HR5vFo7qlxK","Gap":"_15TsZCsyhoWmBKm9tBnN4Z","Allstate":"_1dpIWsJkRaaRCFy1EY_Zyg","Asurion":"_2pBfMjEmOzPvRCLqrH-6T7","Invitae":"_2UqNTD59nMCIwAGZ3dYP5q","JWE":"_2TrrhxvIMh2Wt_q3GTOyc8"};

/***/ }),

/***/ "F3oP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deepClone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);

/**
 * Returns a deeply cloned object without reference.
 * Copied from Vuex.
 * @type {Object}
 */
function deepClone(obj) {
  if (Array.isArray(obj)) {
    return obj.map(deepClone);
  } else if (obj && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(obj) === 'object') {
    var cloned = {};
    var keys = Object.keys(obj);
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i];
      cloned[key] = deepClone(obj[key]);
    }
    return cloned;
  } else {
    return obj;
  }
}

/***/ }),

/***/ "F6OC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      additionalUsers: [],
      userLoader: {
        items: [],
        pageIndex: 0,
        hasMore: true,
        isLoading: false,
        searchTerm: ''
      }
    };
  },
  props: {
    divisionId: {
      type: [String, Number],
      required: true
    },
    cardId: String,
    cardHolderId: String
  },
  computed: {
    filteredUsers: function filteredUsers() {
      var _this = this;
      return this.userLoader.items.filter(function (u) {
        return u.Id !== _this.cardHolderId;
      }).sort(function (a, b) {
        return a.Name.localeCompare(b.Name);
      });
    }
  },
  methods: {
    onOpenUsers: function onOpenUsers() {
      this.userLoader.searchTerm = '';
      this.loadUsers(true);
    },
    onUserSearch: function onUserSearch(term) {
      this.userLoader.searchTerm = term;
      this.loadUsers(true);
    },
    loadUsers: function loadUsers() {
      var _arguments = arguments,
        _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var reset, loader, _yield$_this2$api$get, data, Items, HasMore, mapped;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              reset = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              loader = _this2.userLoader;
              if (!loader.isLoading) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              if (reset) {
                loader.pageIndex = 0;
                loader.items = [];
                loader.hasMore = true;
              }
              if (loader.hasMore) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              loader.isLoading = true;
              _context.prev = 8;
              _context.next = 11;
              return _this2.api.get(_this2.api.$.divisionUsers, {
                params: {
                  divisionId: _this2.divisionId,
                  pageIndex: loader.pageIndex,
                  pageSize: 50,
                  searchTerm: loader.searchTerm
                }
              });
            case 11:
              _yield$_this2$api$get = _context.sent;
              data = _yield$_this2$api$get.data;
              Items = data.Items, HasMore = data.HasMore;
              mapped = Items.map(function (item) {
                return {
                  Id: item.VendorUserId,
                  Name: item.FirstName + ' ' + item.LastName
                };
              });
              loader.items = reset ? mapped : loader.items.concat(mapped);
              loader.hasMore = HasMore;
              loader.pageIndex += 1;
              _context.next = 23;
              break;
            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](8);
              console.error('loadUsers error', _context.t0);
            case 23:
              _context.prev = 23;
              loader.isLoading = false;
              return _context.finish(23);
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[8, 20, 23, 26]]);
      }))();
    },
    getAdditionalUsers: function getAdditionalUsers() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this3.cardId) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return _this3.api.get("evedpaycards/".concat(_this3.cardId, "/additional-users"));
            case 5:
              result = _context2.sent;
              if (result.data) {
                _this3.additionalUsers = result.data;
                _this3.$emit('additionalUsers', _this3.additionalUsers);
              }
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              console.error('error fetching additional users', _context2.t0);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 9]]);
      }))();
    }
  },
  created: function created() {
    var _this4 = this;
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _this4.loadUsers(true);
            _context3.next = 3;
            return _this4.getAdditionalUsers();
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }
});

/***/ }),

/***/ "F6Ut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.editMode)?_c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F6wb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_edMetaNav__ = __webpack_require__("YKxx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Layouts_auth__ = __webpack_require__("UmH6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_legacy_auth_gotoV3__ = __webpack_require__("UYvm");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var loginPaths = ['/login', '/login?mfa', '/login/mfasetup'];
var hideSwitchAccount;
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Layout: __WEBPACK_IMPORTED_MODULE_2__components_Layouts_auth__["default"]
  },
  data: function data() {
    return {
      search: '',
      showSwitchAccount: typeof this.$route.query.switchAccount !== 'undefined' || this.$route.name === 'switchaccount',
      accountToBeSet: null,
      switchAccountAfterLoginEnabled: true
    };
  },
  created: function created() {
    hideSwitchAccount = window.location.search.includes('noSwitchAccount') || document.referrer.includes('noSwitchAccount');
  },
  mounted: function mounted() {
    if (hideSwitchAccount) {
      __WEBPACK_IMPORTED_MODULE_3__core_legacy_auth_gotoV3__["b" /* navigateToV3Home */].call(this);
    }
  },
  computed: {
    accounts: function accounts() {
      var _this = this;
      var userCompanies = this.$user.sessionSettings ? this.$user.sessionSettings.UserCompanies : {};
      return Object.keys(userCompanies).map(function (company) {
        return {
          id: company,
          name: userCompanies[company],
          type: _this.$user.$.domain
        };
      });
    },
    hasAccounts: function hasAccounts() {
      return this.accounts.length > 1 && ((loginPaths.indexOf(this.$routerHistory.previous().path) !== -1 || !hideSwitchAccount && (this.$routerHistory.previous().path || '').startsWith('/login')) && this.switchAccountAfterLoginEnabled || this.showSwitchAccount);
    },
    currentCompany: function currentCompany() {
      return this.$user.$.data.CompanyName;
    },
    currentEmail: function currentEmail() {
      return this.$user.email;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    filteredAccounts: function filteredAccounts() {
      var _this2 = this;
      var r = this.accounts.filter(function (account) {
        return account.name.toLowerCase().includes(_this2.search.toLowerCase());
      });
      r = r.sort(function (a, b) {
        if (a.name < b.name) return -1;else if (a.name > b.name) return 1;
        return 0;
      });
      return r;
    },
    switchAccountAfterLogin: function switchAccountAfterLogin() {
      return this.accounts.length > 1 && (!hideSwitchAccount && (this.$routerHistory.previous().path || '').startsWith('/login') || this.$route.name === 'switchaccount') && this.switchAccountAfterLoginEnabled;
    }
  },
  watch: {
    '$route.query.switchAccount': function $routeQuerySwitchAccount(value) {
      this.showSwitchAccount = typeof value !== 'undefined';
    }
  },
  methods: {
    switchAccount: __WEBPACK_IMPORTED_MODULE_1__core_components_edMetaNav__["default"].methods.switchAccount,
    setAccount: function setAccount(account) {
      var _this3 = this;
      var close = function close() {
        _this3.switchAccountAfterLoginEnabled = false;
        _this3.showSwitchAccount = false;
        _this3.closeAccountsModal();
        _this3.$emit('dismiss');
      };
      this.accountToBeSet = account.id;
      if (account.name === this.currentCompany) {
        close();
      }
      setTimeout(function () {
        close();
        _this3.accountToBeSet = null;
      }, 1000);
    },
    closeAccountsModal: function closeAccountsModal() {
      this.$router.push({
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          switchAccount: undefined
        })
      });
    }
  }
});

/***/ }),

/***/ "F73h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("rNB3");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef1fc08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("l77O");
function injectStyle (ssrContext) {
  __webpack_require__("ks+p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ef1fc08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef1fc08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FKdl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',
  props: {
    checked: Boolean,
    value: null,
    optionIndex: Number,
    optionLabel: String,
    optionValue: null,
    name: String,
    disabled: Boolean,
    hasAdditionalInfo: Boolean,
    slotName: String
  },
  computed: {
    _optionStatus: function _optionStatus() {
      return this.optionStatus;
    },
    _optionLabel: function _optionLabel() {
      return this.optionName;
    },
    _optionIndex: function _optionIndex() {
      return this.optionIndex;
    }
  },
  methods: {
    chooseRadio: function chooseRadio() {
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["b" /* EventBus */].$emit('chooseRadio', {
        'idx': this._optionIndex,
        'status': !this._optionStatus
      });
      //
      this.$emit('choose-radio');
    }
  }
});

/***/ }),

/***/ "FLix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2QfUZ6NJ35YuA5SV5rIqlp","Dell":"_2l27SbAHtJuWkyEvuyQncq","Abbott":"_3t17gW7KGjpHvm5HM72h0y","Gap":"_2Ce-zlku_xh9dr_dtB5CNL","Allstate":"_3-BJCzR4u6a612tNzDPqPX","Asurion":"_3QDo1HAC6FSYj3KRdfO8Uz","Invitae":"_1ZJtbpEMFne4-MXAftuDKe","JWE":"HWjrKLxLdAXPuHA9pJI3c"};

/***/ }),

/***/ "FQOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0C6f");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0940a049_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("hwsh");
function injectStyle (ssrContext) {
  __webpack_require__("4AHt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0940a049"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0940a049_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FbFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qty_vue__ = __webpack_require__("gE0V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_435c024b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_qty_vue__ = __webpack_require__("4SHw");
function injectStyle (ssrContext) {
  __webpack_require__("DmJx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qty_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_435c024b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_qty_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fcpc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvelopeStatus_vue__ = __webpack_require__("ybql");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8eb312f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvelopeStatus_vue__ = __webpack_require__("S+iE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvelopeStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8eb312f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvelopeStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FdMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview col-md-12"},[_c('ed-card',{staticClass:"overview-card",attrs:{"footer-button":"false"}},[(!_vm.hasData)?_c('div',{staticClass:"soft-text loading-text",attrs:{"slot":"body"},slot:"body"},[_c('span'),_vm._v("Loading summary ...\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasData)?_c('div',{staticClass:"soft-text",staticStyle:{"margin-top":"-20px !important"},attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"col-md-3"},[_c('div',[_vm._v("Most Recent Payment")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.headerData.MostRecentPaymentDate)+" - "+_vm._s(_vm.headerData.MostRecentPayAmount))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',[_vm._v("Next Payment Due")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.headerData.NextPayDue))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',[_vm._v("Open Invoices")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.headerData.OpenInvoices)+" invoices - "+_vm._s(_vm.headerData.OpenInvoicesAmount))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',[_vm._v("Overdue Invoices")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.headerData.OverdueInvoices)+" invoices - "+_vm._s(_vm.headerData.OverdueInvoicesAmount))])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fepw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{ active : _vm.active },attrs:{"role":"presentation"}},[_c('a',{attrs:{"href":"#","aria-controls":_vm.id,"role":"tab","data-toogle":"tab"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onTabClick(_vm.id)}}},[(!!_vm.icon)?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(_vm._s(_vm.name)),_c('div',{staticClass:"ripple-container"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FjPf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("NnNH");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22531eef_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("T7ac");
function injectStyle (ssrContext) {
  __webpack_require__("DWoL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22531eef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22531eef_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Fke0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RejectCardDailySpendLimit_vue__ = __webpack_require__("ZndQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bb2a57a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RejectCardDailySpendLimit_vue__ = __webpack_require__("eTmq");
function injectStyle (ssrContext) {
  __webpack_require__("c1xZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9bb2a57a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RejectCardDailySpendLimit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bb2a57a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RejectCardDailySpendLimit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fp7m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"ajCe2IuP9Tw9N-mGF5540","Dell":"_37mtDLTc_6tNDvjWCw4Usg","Abbott":"-pS2pCcmW_b8yxGu0V09N","Gap":"_3pHLMMRjCzr1YSo7aUr2Zl","Allstate":"_3WvRlH2U1TRcUVrtjO2B_6","Asurion":"_2Qkrk6vSYPJQxWVxtjBTzG","Invitae":"_1dziG2MMWPJJyg5llMDYOZ","JWE":"j3COdiJiPdpd73nSq2y4s"};

/***/ }),

/***/ "FqzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentPriorityTag_vue__ = __webpack_require__("rTkR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3fab85_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentPriorityTag_vue__ = __webpack_require__("dECR");
function injectStyle (ssrContext) {
  __webpack_require__("Sdg6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentPriorityTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3fab85_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentPriorityTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fv83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'md-button',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    disabled: Boolean,
    href: String
  }
});

/***/ }),

/***/ "FvOR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"A-lVsAr0XWeugauDGa2a3","Dell":"_2gWKGAOSx5G7eB86ZRYm1Q","Abbott":"rAZBeMamsxg-hzl9KT8Z6","Gap":"_14nQpygICeDFQBa0ld71-k","Allstate":"_1kXRU0O23j_4zupNTk10ds","Asurion":"ZVu7vm1dXNq8X7ZJ-vAmv","Invitae":"_2og-l3SzCvx2nE9Tyf9_Ic","JWE":"_3z9DDPM8Ujqby7j_Kq-zTj"};

/***/ }),

/***/ "Fw3C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
      invalidPercent: false
    };
  },
  computed: {
    //
    percentValue: function percentValue() {
      return this.params.node.rowPinned === 'bottom' ? '' : "".concat(+this.params.value || 0, " %");
    }
  }
});

/***/ }),

/***/ "G0m8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-flex active"},[_vm._t("default"),_vm._v(" "),_c('div',{ref:"addLineItemDialogContainer"}),_vm._v(" "),_vm._l((_vm.model.PO.events),function(event,index){return (event.lineItems)?_c('ed-section',{key:index,staticClass:"no-flex active pad",attrs:{"wide":""}},[_vm._t("top"),_vm._v(" "),_c('div',{staticClass:"section-title"},[_c('span',{staticClass:"h5"},[_vm._v(_vm._s(_vm.getGridTitle(event)))]),_vm._v(" "),_c('div',{staticClass:"pull-right small"})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('grid',{key:_vm.gridKey + _vm.itemsHash(event.lineItems),ref:"lineItems",refInFor:true,class:{ simple: false },attrs:{"layout":"frame","subtitle":((_vm.model.PO.uniqueId) + " " + (event.name) + " Items"),"label":"Item","search":"search","allow-export":false,"export-btn":true,"checkboxes":true,"actions":_vm.itemsActions,"views":false,"pinning":false,"sorting":false,"dragRows":true,"fit-columns":true,"show-column-selector":true,"auto-height":"auto-height","rowClasses":{'line-item-row': function (params) { return !(params.data || {}).isFeeDiscountItem && (params.data || {}).poQuantity; },
          'readonly-row': function (params) { return (params.data || {}).isQuantityReadonly; },
          'hide-units': function (params) { return !(params.data || {}).isFeeDiscountItem && +(params.data || {}).poUnits <= 0; }},"model":_vm.gridModel,"data":event.lineItems,"rowDetailsComponent":_vm.itemDetailsComponent,"remove-many":true,"clone-many":true,"customDeleteManyButton":true,"validate-remove-many":_vm.validateRemoveMany,"validate-clone-many":_vm.validateCloneMany,"currency-code":_vm.currency,"totals":"totals","total":_vm.getGridTotal(event),"enableErrorMessage":_vm.invoiceSettings.IsSameDayDeposit,"helptip-header":"","helptip-body":_vm.sameDayValidationError,"name":"line items"},on:{"editRow":function($event){return _vm.openEditItem($event, event)},"changeRow":_vm.refresh,"removeRow":_vm.removeRow,"removeRows":_vm.removeRows,"cloneRow":_vm.cloneRow,"cloneRows":_vm.cloneRows,"dropRow":function($event){return _vm.reorderItemsInList($event, event)},"selectedRows":_vm.rowSelected}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[(_vm.useSavingsFields && !_vm.isP2PInvoiceWithEditItem)?_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"toggle":_vm.savingsFields}},[_vm._v("Cost Savings\n          ")]):_vm._e(),_vm._v(" "),(!_vm.isP2PInvoice)?_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"name":"add_item"},on:{"click":function($event){return _vm.checkIfCurrencyIsSelected(event, 'AddItem')}}},[_vm._v("Add Line Item\n          ")]):_vm._e(),_vm._v(" "),_vm._t("buttons",null,{"event":event})],2),_vm._v(" "),_c('span',{attrs:{"slot":"selectionButtons"},slot:"selectionButtons"},[(_vm.useBUorCCorPair && !_vm.isP2PInvoice)?_c('span',[(_vm.allocateToCostCenter)?_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"name":"allocate_to_CC"},on:{"click":function($event){return _vm.openAllocateToCostCenterDialog(event)}}},[_vm._v("Allocate to Cost Center\n            ")]):_vm._e(),_vm._v(" "),(_vm.allocateToBUCCPair)?_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"name":"allocate_to_CCBU_Pair"},on:{"click":function($event){return _vm.openAllocateToBUCCPairDialog(event)}}},[_vm._v("Allocate to BU and CC\n            ")]):_vm._e()],1):_vm._e()])]),_vm._v(" "),(event.lineItems.length)?_c('br'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clear"})],2):_vm._e()}),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showCurrencyError,"title":"","primaryButton":"false","secondaryButton":"Ok","type":"small","name":"currency_error"},on:{"close":function($event){_vm.showCurrencyError = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_c('br'),_vm._v("Please select the Invoice Currency in order to add items to this invoice.")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G2an":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighAllocationSection_vue__ = __webpack_require__("MxJD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ac9f5be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HighAllocationSection_vue__ = __webpack_require__("TIsV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighAllocationSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ac9f5be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HighAllocationSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G94L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3REt7QfBOqKYsJG2ExK0F4","Dell":"_5tAp7aImPL0cOfUT75ahm","Abbott":"_2ycJoiZwho_0S2Dk-gaTJf","Gap":"_3cbqYnUVI3DxIFGt-f3h9W","Allstate":"zbXsWNxrZkBCdGbXbjqpa","Asurion":"dyKy4y9-J1hfcbbTlXLjA","Invitae":"_1HpgTYDlXzjr26FkLQy5Ex","JWE":"_2v4L7I7PHjOLeBtgJ6KpWh"};

/***/ }),

/***/ "GDnQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object,
    showModal: Boolean
  },
  data: function data() {
    return {
      doDisplayEmailError: false,
      doDisplayDivisionsError: false,
      doDisplayBUSelect: this.model.HasAPSettingsByBU,
      doDisplayBUError: false,
      divisions: this.model.Divisions,
      businessUnits: this.model.BusinessUnits,
      payload: {
        AuditFileTemplateId: this.model.AuditFileTemplateId || 0
      }
    };
  },
  methods: {
    isValid: function isValid() {
      var result = true;
      if (this.divisions && this.divisions.length <= 0) {
        this.doDisplayDivisionsError = true;
        result = false;
      }
      return result;
    },
    onSave: function onSave() {
      var _this = this;
      if (!this.isValid()) return;
      var AuditFileTemplateDTO = {
        AuditFileTemplateId: this.model.AuditFileTemplateId,
        Name: this.model.Name
      };
      var param = {
        AuditFileTemplateDTO: AuditFileTemplateDTO,
        DivisionsIds: this.divisions,
        BusinessUnitIds: this.businessUnits
      };
      this.api.post(this.api.$.FundingInvoiceAndApSetting.updateAPFileTemplate, param).then(function (response) {
        _this.$emit('save');
      });
    },
    selectDivision: function selectDivision() {
      this.doDisplayDivisionsError = false;
    }
  }
});

/***/ }),

/***/ "GIZD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1t2av3MEEKlaFcQjJHquQg","Dell":"_2PeyWA_CRpw9joPvokHn3t","Abbott":"_1oYyXheXLdQKW6w1A4vnTu","Gap":"_2xxouMrXRzbEc4zA8ZIYBU","Allstate":"_3wKF-Al3ClhOqTic5E-k__","Asurion":"htDIx3lLMAmxmYMzZD56J","Invitae":"_2ZS6jLKSe9RIybc9LoOwwd","JWE":"_1IVV7ksliXYZr3sjrwICj4"};

/***/ }),

/***/ "GKK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"show":_vm.show,"title":_vm.title,"type":"medium","validation":_vm.validation,"primaryButtonDisabled":_vm.saveButtonDisabled,"closeOnEsc":true},on:{"close":_vm.onClose,"validate":_vm.onSave}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',[_c('section',[_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"heading col-md-4 no-pad"},[_c('label',[_vm._v(" Taxes")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-md-2"},[_c('label',[_vm._v(" Percent")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("    ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-md-2"},[_c('label',[_vm._v(" Amount")])])]),_vm._v(" "),_vm._l((_vm.formData.model.taxes),function(tax,index){return _c('tax-line',{key:tax.name,ref:"taxLine",refInFor:true,staticClass:"row",attrs:{"model":tax,"index":index,"compute":_vm.computeDraftFeeTotal,"context":_vm.vm}})}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8 text-right",attrs:{"name":"fee_taxes_popup_subtotal"}},[_c('strong',[_c('small',[_vm._v("\n                Subtotal:  \n                "),_c('v-money',{attrs:{"currency":_vm.model.currency.code,"supplementalPrecision":6}},[_vm._v(_vm._s(_vm.formData.model.totalTaxes))])],1)])])])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GPqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refill-overlay"},[_c('p',{staticClass:"small"},[_vm._v("\n    A balance dipping below a set Refill Threshold will trigger an additional\n    Refill Amount added to the card.\n  ")]),_vm._v(" "),(_vm.card.Holder)?_c('div',[_c('label',[_vm._v("Card Holder")]),_vm._v(" "),_c('br'),_vm._v("\n    "+_vm._s(_vm.holderDisplay)+"\n  ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('ed-input',{attrs:{"type":"money","amount":"","field-label":"Refill Threshold"},model:{value:(_vm.RefillSettings.RefillThreshold),callback:function ($$v) {_vm.$set(_vm.RefillSettings, "RefillThreshold", $$v)},expression:"RefillSettings.RefillThreshold"}}),_vm._v(" "),_c('ed-input',{attrs:{"type":"money","amount":"","field-label":"Refill Amount"},model:{value:(_vm.RefillSettings.RefillAmount),callback:function ($$v) {_vm.$set(_vm.RefillSettings, "RefillAmount", $$v)},expression:"RefillSettings.RefillAmount"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GQh2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1uwr4S73LBTYaw-AgfVCAQ","Dell":"_3f3uUeyxg2XwrGFAZgXNTy","Abbott":"_3pQaIpnjsQ87pU4BXPWTnr","Gap":"_3J75BYC0PKf7dq3puzMsEo","Allstate":"_3UfiVfMsLEdNvQCV_4avEa","Asurion":"_17DQSrB6ZrfzJO2rLc97Ej","Invitae":"jj21IUl5ijYA3BFR4lR6P","JWE":"_8OjWaD_NDGfn50GwDTbhH"};

/***/ }),

/***/ "GV2d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"VnR2CNERpHpXxSmSBlFKI","Dell":"_2tMo0a40Ps5CWDaFrpH8a0","Abbott":"_1WJ6iB9iy_PMnVz0EjEqhN","Gap":"_270j6YPKpZZ12FrhkNzuyP","Allstate":"_1_9EvLE6qj7EhAnIOFGA05","Asurion":"UXyIP91bTjYmBggSb0bDa","Invitae":"_2yo0RdDBrqN2pA6vK3U1Bn","JWE":"_2qSoWE8CmWmNZYKhpCBEKg"};

/***/ }),

/***/ "Ga5e":
/***/ (function(module, exports) {

module.exports = {"Roles":"Roles","TeamTabRoles":"Team Tab Roles","Users":"Users","UsersTitles":"User Titles","Result":"Result"}

/***/ }),

/***/ "GeiN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attachments_details_vue__ = __webpack_require__("U4r4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a6113c5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attachments_details_vue__ = __webpack_require__("9Npz");
function injectStyle (ssrContext) {
  __webpack_require__("6oxs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a6113c5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attachments_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a6113c5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attachments_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gjoa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_scan_invoice_model_js__ = __webpack_require__("f8kt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabs__ = __webpack_require__("xp7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_back__ = __webpack_require__("tdUP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */],
    back: __WEBPACK_IMPORTED_MODULE_4__Components_back__["a" /* default */]
  },
  data: function data() {
    return {
      ScanInvoiceModel: __WEBPACK_IMPORTED_MODULE_1__models_scan_invoice_model_js__["a" /* default */],
      paymentInvoiceId: 0,
      disableScanInvoiceButton: true,
      disableReviewButton: true,
      tabs: __WEBPACK_IMPORTED_MODULE_3__tabs__["a" /* default */].tabs
    };
  },
  created: function created() {
    var _this = this;
    // handle Edit Button availability
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.SELECTED_ITEM).$on(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.SELECTED_ITEM, function (r) {
      _this.handleButtons(r);
    });
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ITEM).$on(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ITEM, function (r) {
      _this.handleButtons(r);
    });
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.SELECTED_ALL).$on(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.SELECTED_ALL, function (r) {
      _this.handleButtons(r);
    });
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ALL).$on(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ALL, function (r) {
      _this.handleButtons(r);
    });
  },
  computed: {
    getModel: function getModel() {
      return __WEBPACK_IMPORTED_MODULE_1__models_scan_invoice_model_js__["a" /* default */].get();
    }
  },
  methods: {
    scanInvoice: function scanInvoice(paymentInvoiceId) {
      var _this2 = this;
      this.api.post(this.api.$.admin.scannerIsAssignedToInvoice, {
        paymentInvoiceId: paymentInvoiceId,
        scannerId: global.app.$user.$.user.UserID
      }).then(function (r) {
        if (r.data) {
          alert('The invoice has already been assigned');
        } else {
          _this2.refresh();
          // Redirect to Upload Invoice PAGE
          _this2.$router.push('/d/Invoice/upload?invoiceId=' + paymentInvoiceId + '&from=eoadmin');
          // this.redirectToUploadInvoicePage(paymentInvoiceId)
        }
      });
    },
    reviewInvoice: function reviewInvoice(paymentInvoiceId) {
      var _this3 = this;
      this.api.post(this.api.$.admin.validateReviewInvoiceAction, {
        paymentInvoiceId: paymentInvoiceId,
        reviewerUserId: global.app.$user.$.user.UserID
      }).then(function (r) {
        if ((r.data || '') !== '') {
          global.app.$notifications.notify({
            alert: true,
            type: 'plain',
            icon: 'exclamation-circle',
            placement: {
              from: 'top',
              align: 'center'
            },
            timeout: 0,
            message: r.data
          });
        } else {
          _this3.refresh();
          _this3.$router.push('/d/Invoice/upload?invoiceId=' + paymentInvoiceId + '&from=eoadmin');
        }
      });
    },
    redirectToUploadInvoicePage: function redirectToUploadInvoicePage(paymentInvoiceId) {
      window.location.reload(this.$router.replace('/d/InvoiceToPay/upload?invoiceId=' + paymentInvoiceId));
    },
    refresh: function refresh() {
      this.$refs.ScanInvoiceGrid.quickSearch();
      this.$refs.ScanInvoiceGrid.onSelectAll(false);
    },
    handleButtons: function handleButtons(r) {
      if (r && r.data && r.data.length === 1) {
        this.enableButtons(false);
        this.paymentInvoiceId = r.data[0].PaymentInvoiceId;
      } else {
        this.enableButtons(true);
        this.paymentInvoiceId = 0;
      }
    },
    enableButtons: function enableButtons(state) {
      this.disableScanInvoiceButton = state;
      this.disableReviewButton = state;
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ALL);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "GpSt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2LNXQQB4ru9QJVfeTryRW-","Dell":"_3013MxIRdv_cQGc9jCwxwS","Abbott":"_1uKcnBN59UwssSKJmVSDL4","Gap":"GERzLXqRgkEkLXkflWQzP","Allstate":"bgwAT5s4QDV7OxNfnBHEX","Asurion":"tUZtCAWGq88L4SUlD1hwq","Invitae":"_2sXhOhemd6xAOvE4WrInQE","JWE":"UC9js96RTCQhXkbQsyiKa"};

/***/ }),

/***/ "Gt4f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/logo-light.8c9d9c2.png";

/***/ }),

/***/ "GyNV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid-"},[_c('div',{staticClass:"footer-bar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('nav',{staticClass:"text-right"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.eved.com/privacy-policy/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('Privacy Policy')))])]),_c('li',[_c('a',{attrs:{"href":"https://www.eved.com/terms-of-use/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('Terms of Use')))])]),_c('li',[_c('a',{attrs:{"href":"https://www.eved.com/about-us/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('About Us')))])]),_c('li',[_c('a',{attrs:{"href":"https://www.eved.com/contact-us/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('Contact Us')))])])])])]),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"copyright"},[_vm._v("Copyright ©2007-"+_vm._s(_vm.year)+" Eved LLC.\nAll Rights Reserved. (US Patent No.: US 9,734,467 B2).\nEvedPay Visa® Prepaid Card Solutions are hosted by\nPEX, Prepaid Expense Solutions, and are issued by Fifth Third Bank, N.A.,\nMember FDIC, or The Bancorp Bank, N.A., Member FDIC, pursuant to a license\nfrom Visa U.S.A. Inc. and may be used everywhere Visa prepaid cards are accepted.\n"),_c('br'),_vm._v("\nPlease see the back of your card for its issuing bank.")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H0PG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"FsF5Bse04YYpfOSuCZBAM","Dell":"_1cCqBQIIGREo_uBsXEvXOv","Abbott":"_3DyQcZjVGDDf6HrozOyvtT","Gap":"_2uPMIfTQ95Zt4dnaGpyFTX","Allstate":"BkEJwZid6vUVeg4lpCgn1","Asurion":"_29qfqmyVAMXtJwgmLB8m7y","Invitae":"_26yQzaporKQuTxXvuTkaqH","JWE":"_1TdXvFn58EqRebGhvMKdyk"};

/***/ }),

/***/ "H5uL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_vue__ = __webpack_require__("KZ6B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a697ea6a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_date_vue__ = __webpack_require__("zEw2");
function injectStyle (ssrContext) {
  __webpack_require__("RHeX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a697ea6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a697ea6a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_date_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H6Ol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-filter"},[(!_vm.params.editMode)?_c('p',{staticClass:"column-title"},[_vm._v(_vm._s(_vm.columnTitle))]):_vm._e(),_c('ed-input',{ref:'input',attrs:{"placeholder":_vm.t("Search"),"search":""},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_c('ed-radio',{attrs:{"name":"fxOption","options":_vm.fxOptions},on:{"click":function($event){return _vm.$nextTick(_vm.updateScroll)}},model:{value:(_vm.fxOption),callback:function ($$v) {_vm.fxOption=$$v},expression:"fxOption"}}),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.fxOption.value !== "Keep-"),expression:"fxOption.value !== \"Keep-\""}],staticClass:"list",class:{ "edit": _vm.params.editMode },attrs:{"endpoint":_vm.api.$.settings.currenciesFilter}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_c('ed-radio',{attrs:{"name":"currencyOption","options":_vm.filteredOptions},on:{"click":_vm.click},model:{value:(_vm.currency),callback:function ($$v) {_vm.currency=$$v},expression:"currency"}})],1),(!_vm.params.editMode)?_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.apply}},[_vm._v(_vm._s(_vm.t("Apply")))]):_vm._e(),_vm._v(" \n "),(!_vm.params.editMode)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.clear.apply(null, arguments)}}},[_c('u',[_vm._v(_vm._s(_vm.t("clear filter")))])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HD5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2RjYwzP7aKS0nUtfq8UdKo","Dell":"_27jUxNxboA3AFQa7TqbqXP","Abbott":"_2J70_8KFidrpBLeUeLWw_M","Gap":"WZioYTgNZrPe2FGNTgEdF","Allstate":"_3f7q54qaHoZZYOpyBYDMSt","Asurion":"_1J5SL96fpAKboj4MeW_sDW","Invitae":"_2_nZ6OsD7MQH6c54fJcBOF","JWE":"_2Sgriv-3O6cuqNz3N2fa8C"};

/***/ }),

/***/ "HF8s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3Q5RPpMcvjGySyIj7_TtdC","Dell":"_3PjN3LfOjnurzYQfuU3VZF","Abbott":"_2hjhICBDJQ0Q_E1agvyE5e","Gap":"_3sMTKJ4Crn_u3O-_OVketk","Allstate":"_3eg_U80rOeg-bpG2MDbMiG","Asurion":"_3Ya77XSEVkosjy92WYkyY6","Invitae":"_1_SQ8LK0QsuCUqFBXgKjNj","JWE":"evHDR8RQX1S7DGGbQ8TQ0"};

/***/ }),

/***/ "HLWf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return copy; });
// copy
var copy = function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
};

/***/ }),

/***/ "HP22":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_32dt8EeI0hEog-m4RFpgd2","Dell":"_3vfaoZJOhBAAuCylEwDUSx","Abbott":"_1dEn4_Ju7T5lbngu2CpYXz","Gap":"_3QpDcOSzIKaNDZZ9xl1DyR","Allstate":"keIg7Fsj7ROY8PwKhHyOT","Asurion":"_3aOFkFeoMbiAKETg6sxyy2","Invitae":"_3-dhxTJxR7rde7Knm63r89","JWE":"_22-yarY9KOP9MPHSf_qUh-"};

/***/ }),

/***/ "HZnV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__core_events_events__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    OpenReconcile: function OpenReconcile() {
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_1__core_events_events___default.a.EVEDPAY_CARDS.OPEN_RECONCILE, this.params.data);
    }
  }
});

/***/ }),

/***/ "HePg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RejectEnvelope_vue__ = __webpack_require__("X3Rw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d91f97e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RejectEnvelope_vue__ = __webpack_require__("aPPL");
function injectStyle (ssrContext) {
  __webpack_require__("ORH0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d91f97e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RejectEnvelope_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d91f97e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RejectEnvelope_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hfpp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hj+U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hn6R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_Programs_Card_transactions_ReconciliationStatus_vue__ = __webpack_require__("6NlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_Programs_Card_transactions_TransactionStatus_vue__ = __webpack_require__("+IqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OpenReconcile__ = __webpack_require__("OHRD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_Programs_Card_envelopes_OpenEnvelope_vue__ = __webpack_require__("5y3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_Programs_Card_cards_CardHolder_vue__ = __webpack_require__("rMOU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Grid_cells_actions__ = __webpack_require__("ayPo");






/* harmony default export */ __webpack_exports__["a"] = ({
  'TransactionNumber': {
    label: 'Transaction',
    render: __WEBPACK_IMPORTED_MODULE_2__OpenReconcile__["a" /* default */],
    width: 120
  },
  'FusionVersionNumber': {
    label: 'Expense',
    width: 120,
    visible: false
  },
  'CardNumber': {
    label: 'Card',
    compose: maskedCardNumber,
    width: 100
  },
  'Division': {
    label: 'Division',
    getter: getDivisionLink,
    width: 180
  },
  'Holder': {
    label: 'Card Holder',
    render: __WEBPACK_IMPORTED_MODULE_4__components_modules_Programs_Card_cards_CardHolder_vue__["a" /* default */],
    width: 120
  },
  NameOnCard: '_',
  'Merchant': {
    label: 'Merchant',
    visible: false,
    width: 120
  },
  'SupplierNameCombined': {
    label: 'Supplier',
    compose: supplierName,
    width: 120
  },
  'TransactionDateFormatted': {
    label: 'Date',
    width: 90
  },
  'Amount': {
    label: 'Amount',
    width: 120,
    infoMessageIcon: 'fas fa-info-circle grey-icon',
    infoMessage: function infoMessage(params) {
      return params.data.IsFeeOnAccount ? 'Rush orders do not count against the card balance' : null;
    },
    f: 'data.Amount'
  },
  'TransactionStatus': {
    label: 'Transaction Status',
    source: 'TransactionsList',
    render: __WEBPACK_IMPORTED_MODULE_1__components_modules_Programs_Card_transactions_TransactionStatus_vue__["a" /* default */],
    width: 120
  },
  'ReconciliationStatus': {
    label: 'Reconciliation Status',
    source: 'TransactionsList',
    render: __WEBPACK_IMPORTED_MODULE_0__components_modules_Programs_Card_transactions_ReconciliationStatus_vue__["a" /* default */],
    width: 140
  },
  'EnvelopeNumber': {
    label: 'Envelope',
    render: __WEBPACK_IMPORTED_MODULE_3__components_modules_Programs_Card_envelopes_OpenEnvelope_vue__["a" /* default */],
    width: 120
  },
  'APFile': {
    label: 'AP File',
    compose: apFileLink,
    width: 120
  },
  'ProgramName': {
    label: 'Program',
    width: 120
  },
  AccountId: '_'
});
function maskedCardNumber(card) {
  if (card && card.data && card.data.CardNumber) {
    return '****' + card.data.CardNumber;
  } else {
    return '****';
  }
}
function supplierName(column) {
  if (column && column.data) {
    if (!(column.data.Supplier || column.data.NonEvedSupplier)) {
      return "<span title=\"".concat(column.data.Merchant, "\" style=\"color: #989898;\">").concat(column.data.Merchant, "</span>");
    }
    return column.data.SupplierNameCombined;
  }
  return '';
}
function getDivisionLink(params) {
  if (params && params.data && params.data.AccountId) {
    params.node.uri = params.colDef.uri = "#/d/Programs/>Card/list?AccountId=".concat(params.data.AccountId);
    params.value = params.data.Division;
    params.noTooltip = true;
    return __WEBPACK_IMPORTED_MODULE_5__components_Grid_cells_actions__["f" /* gotoCustom */].template(params);
  } else {
    return '';
  }
}
function apFileLink(p) {
  if (!p.data) return '';
  var apFileId = p.data.ApFileId;
  var url = "".concat(global.app.api.env, "/AccountPayable/GenerateEvedPayCardAPFile?apFileId=").concat(apFileId);
  return "<a title=\"Open AP File\" href=\"".concat(url, "\" target=\"_blank\">").concat(p.value, "</a>");
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "HnSJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'md-card',
  props: {
    title: String,
    category: String,
    hasTable: Boolean,
    backgroundColor: String,
    cardClass: String
  },
  computed: {
    hasHeaderSlot: function hasHeaderSlot() {
      return !!this.$slots['header'];
    }
  }
});

/***/ }),

/***/ "HoRU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3sZd89r5r1A4Uc4pe-FB83","Dell":"_2g4dmjc5DzEEgB0MHrwgZm","Abbott":"_1rorYNmB4a1jCU7nXVEq-4","Gap":"_3TirAbnL2IeFYHqmm_OgW-","Allstate":"_3RnZtZoXaqC-aYhwIgz1sg","Asurion":"-ya_oP8-zlEg0uwYniSlf","Invitae":"_1fm3g0BKNA2aSPePevcvJI","JWE":"_3d8yg6O_1a5IJ26mmko_9z"};

/***/ }),

/***/ "HpCA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__items_list__ = __webpack_require__("5zl1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_info__ = __webpack_require__("vFKZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showModal: Boolean,
    rejectText: String,
    list: Array,
    programLabel: String
  },
  data: function data() {
    return {
      reason: '',
      notifySupplier: false,
      error: false,
      notifySupplierOption: [{
        label: 'Notify Supplier',
        status: this.notifySupplier
      }]
    };
  },
  computed: {
    rejectLabelGerundLowerCase: function rejectLabelGerundLowerCase() {
      return 'declining';
    },
    title: function title() {
      return 'You are about to ' + (this.rejectText || '').toLowerCase() + (this.list.length === 1 ? ' this item' : ' these items');
    },
    subtitle: function subtitle() {
      return 'Enter your reason for ' + this.rejectLabelGerundLowerCase + (this.list.length === 1 ? ' this item' : ' these items');
    },
    isEvedPayCardPresent: function isEvedPayCardPresent() {
      return this.list.some(function (item) {
        return item.NeedsApproval.includes('Add Card Request') || item.NeedsApproval.includes('Funds Request') || item.NeedsApproval.includes('Refill Setting') || item.NeedsApproval.includes('EvedPay Envelope') || item.NeedsApproval.includes('ER');
      });
    }
  },
  methods: {
    onShow: function onShow() {
      this.reason = '';
      this.notifySupplier = false;
      this.notifySupplierOption[0].status = false;
      this.error = false;
    },
    changeNotifySupplier: function changeNotifySupplier(e) {
      if (!e.status) {
        this.notifySupplier = false;
      } else {
        this.notifySupplier = true;
      }
    },
    validate: function validate() {
      this.error = this.reason === '';
    },
    reject: function reject() {
      this.validate();
      if (this.error) {
        this.$refs.reasonInput.$refs.input.focus();
      } else {
        this.$emit('reject', this.reason, this.notifySupplier);
        this.$emit('close');
      }
    }
  },
  components: {
    itemsList: __WEBPACK_IMPORTED_MODULE_0__items_list__["default"],
    userInfo: __WEBPACK_IMPORTED_MODULE_1__user_info__["default"]
  }
});

/***/ }),

/***/ "HrSB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return transform; });
var transform = function transform(map) {
  return {
    labels: map.ChartData.map(function (k) {
      return k[0];
    }),
    series: [map.ChartData.map(function (k) {
      return k[1];
    })]
  };
};

/***/ }),

/***/ "Ht71":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__ = __webpack_require__("ShAN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6631366d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__ = __webpack_require__("gQZR");
function injectStyle (ssrContext) {
  __webpack_require__("Uzrj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6631366d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6631366d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hv0d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changePin_vue__ = __webpack_require__("fpte");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a4c0d99_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changePin_vue__ = __webpack_require__("ssMi");
function injectStyle (ssrContext) {
  __webpack_require__("Y2Ci")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a4c0d99"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changePin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a4c0d99_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changePin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HxX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__radio_vue__ = __webpack_require__("z01l");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-radio',
  props: {
    fieldLabel: String,
    value: null,
    name: String,
    options: Array,
    disabled: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    error: Boolean,
    helptipHeader: String,
    helptipBody: String
  },
  components: {
    'radio': __WEBPACK_IMPORTED_MODULE_0__radio_vue__["default"]
  },
  created: function created() {
    this.hasKey = this.value && this.value.constructor === Array && this.$attrs['track-by'];
  },
  methods: {
    set: function set(v) {
      this.$emit('select');
      this.$emit('input', this.hasKey ? [v[this.hasKey]] : v);
      this.$emit('click');
    },
    checked: function checked(option) {
      if (this.hasKey) {
        return this.value.indexOf(option[this.hasKey]) >= 0;
      }
    }
  }
});

/***/ }),

/***/ "I1Ww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasNews && _vm.newsLoaded)?_c('div',{staticClass:"scroller"},_vm._l((_vm.newsData),function(newsEntry,i){return _c('div',{key:i,class:{ 'news-entry bottom-border': i < (_vm.newsData.length - 1), 'news-entry' : i === (_vm.newsData.length - 1)  }},[_c('ed-span',{staticClass:"news-title text-data",on:{"click":function($event){return _vm.handleClick(newsEntry)}}},[_vm._v(_vm._s(newsEntry.Title))]),_vm._v(" "),_c('ed-span',{staticClass:"news-date text-data"},[_vm._v(_vm._s(newsEntry.CreatedDateFormatted))])],1)}),0):_vm._e(),_vm._v(" "),(!_vm.newsLoaded)?_c('div',{staticClass:"empty-holder"},[_c('span',{staticClass:"news-loading"}),_vm._v(" Loading News ...\n ")]):_vm._e(),_vm._v(" "),(!_vm.hasNews && _vm.newsLoaded)?_c('div',{staticClass:"empty-holder"},[_vm._m(0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fal fa-lg fa-newspaper"}),_vm._v(" "),_c('span',[_c('p',{staticClass:"bold"},[_vm._v("No Recent Posts")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("Platform updates and company")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("messages will appear here")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I2Tf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("vKsb");

var NotificationStore = {
  state: [],
  notify: function notify(notification) {
    var newNotification = notification.alert ? !this.state.filter(function (n) {
      return n.heading === notification.heading;
    }).length : !this.state.filter(function (n) {
      return n.message === notification.message;
    }).length;
    newNotification && this.state.push(notification);
  },
  removeNotification: function removeNotification(index) {
    this.state.splice(index, 1);
    global.pageNotFound = false;
  },
  removeById: function removeById(id) {
    var _this = this;
    // const notification = this.state.findIndex(notification => notification.id === id)
    // this.state[notification] && this.state.splice(notification, 1)
    // this.state = this.state.filter(notification => notification.id !== id)
    var indexes = [];
    this.state.map(function (n, i) {
      n.id === id ? indexes.push(i) : null;
    });
    indexes.sort(function (a, b) {
      return a - b;
    });
    indexes.forEach(function (n, i) {
      return _this.state.splice(n - i, 1);
    });
  },
  showById: function showById(id) {
    var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    // const notification = this.state.filter(notification => notification.id === id)[0]
    // notification ? notification.hide = !show : null
    var notification = this.state.findIndex(function (notification) {
      return notification.id === id;
    });
    this.state[notification] ? this.state[notification].hide = !show : null;
  },
  errorState: function errorState() {
    return this.state.filter(function (n) {
      return n.component;
    }).length > 0;
  },
  showFirst: function showFirst() {
    var first = this.state.filter(function (n) {
      return n.component;
    })[0];
    first ? first.hide = false : null;
  },
  getLast: function getLast() {
    var errors = this.state.filter(function (n) {
      return n.component;
    });
    return errors[errors.length - 1] || {};
  },
  removeAll: function removeAll() {
    this.state.splice(0);
  },
  reset: function reset() {
    this.state = [];
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Object.defineProperty(Vue.prototype, '$notifications', {
      get: function get() {
        return NotificationStore;
      }
    });
    Vue.component('MdNotifications', __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "I31w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__("cS7h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__("BRZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sidebar__ = __webpack_require__("59tI");
//
//
//
//
//
//
//
//
//
//
//
//




function perfNow() {
  return window.performance && window.performance.now ? window.performance.now() : Date.now();
}
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation__["a" /* default */],
    MdFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_2__components_Sidebar__["a" /* default */]
  },
  props: ['reference'],
  data: function data() {
    return {
      name: 'layout-navigation',
      sidebarToggled: false,
      isInIframe: window.self !== window.top,
      // Observers
      resizeObserver: null,
      mutationObserver: null,
      // Target elements
      slotEl: null,
      modalEl: null,
      // Size state
      lastSent: {
        h: 0,
        w: 0
      },
      lastChangeTs: 0,
      initialBurstCount: 0,
      // Timers / flags
      pollInterval: null,
      reconnectInterval: null,
      destroyed: false,
      rafHandle: 0,
      // History hook backups
      origPushState: null,
      origReplaceState: null
    };
  },
  computed: {
    navOpened: function navOpened() {
      return this.sidebarToggled;
    },
    loading: function loading() {
      return this.$loading;
    }
  },
  mounted: function mounted() {
    this.bootstrap();
  },
  activated: function activated() {
    this.bootstrap();
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanup();
  },
  methods: {
    /* ---------- Initialization ---------- */bootstrap: function bootstrap() {
      var _this = this;
      if (!this.isInIframe) return;
      this.adjustShell();
      this.installMessageListener();
      this.setupContentObservers();
      this.installNavigationHooks();
      this.startReconnectWatcher();
      this.startPollingFallback();
      // Initial burst to ensure parent captures early size
      for (var i = 0; i < 3; i++) {
        setTimeout(function () {
          return _this.postSize();
        }, 60 * (i + 1));
      }
      // Post again after potential async layout settling
      setTimeout(function () {
        return _this.postSize();
      }, 500);
    },
    adjustShell: function adjustShell() {
      var _this2 = this;
      this.$nextTick(function () {
        var mainPanel = _this2.$el.querySelector('.main-panel');
        if (mainPanel) mainPanel.style.overflow = 'hidden';
      });
    },
    /* ---------- Navigation Hooks ---------- */installNavigationHooks: function installNavigationHooks() {
      if (!this.origPushState && window.history && window.history.pushState) {
        this.origPushState = window.history.pushState;
      }
      if (!this.origReplaceState && window.history && window.history.replaceState) {
        this.origReplaceState = window.history.replaceState;
      }
      var self = this;
      function afterNav() {
        // Reset burst so we aggressively re-measure after navigation
        self.initialBurstCount = 0;
        // Immediate measurement to capture shrink ASAP
        self.postSize();
        // Debounced follow-up
        self.postSizeDebounced();
        // Additional delayed re-measurements for late-rendering content
        self.scheduleBurst([100, 250, 500, 800, 1200]);
        // Notify parent
        try {
          window.parent.postMessage({
            type: 'navigated'
          }, '*');
        } catch (e) {}
      }

      // Patch pushState
      if (this.origPushState) {
        try {
          window.history.pushState = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            var r = self.origPushState.apply(this, args);
            afterNav();
            return r;
          };
        } catch (e) {}
      }

      // Patch replaceState
      if (this.origReplaceState) {
        try {
          window.history.replaceState = function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            var r = self.origReplaceState.apply(this, args);
            afterNav();
            return r;
          };
        } catch (e) {}
      }
      window.addEventListener('popstate', afterNav);
      window.addEventListener('hashchange', afterNav);

      // Vue router (best-effort)
      var vueGlobal = window.__VUE__ || window.__VUE_APP__ || window.app;
      var possibleRouter = vueGlobal && vueGlobal.$router || window.__VUE_ROUTER__ || this.$router;
      if (possibleRouter && !possibleRouter.__evedSizeHooked) {
        try {
          possibleRouter.afterEach(function () {
            return afterNav();
          });
          possibleRouter.__evedSizeHooked = true;
        } catch (e) {}
      }
    },
    /* ---------- PostMessage Listener ---------- */installMessageListener: function installMessageListener() {
      var _this3 = this;
      if (this.onMessage) window.removeEventListener('message', this.onMessage);
      this.onMessage = function (e) {
        if (e && e.data && e.data.type === 'request-size') {
          _this3.postSizeDebounced();
        }
      };
      window.addEventListener('message', this.onMessage);
    },
    /* ---------- Observers & Polling ---------- */setupContentObservers: function setupContentObservers() {
      var _this4 = this;
      if (this.destroyed) return;
      var el = this.$el.querySelector('.content.module');
      if (!el) {
        requestAnimationFrame(function () {
          return _this4.setupContentObservers();
        });
        return;
      }
      var modalEl = document.querySelector('.dawn-modal-container');
      if (this.slotEl === el && this.modalEl === modalEl) return;
      this.disconnectObservers();
      this.slotEl = el;
      this.modalEl = modalEl;
      if (window.ResizeObserver) {
        this.resizeObserver = new window.ResizeObserver(function () {
          _this4.postSizeDebounced();
        });
        this.resizeObserver.observe(el);
        if (modalEl) {
          this.resizeObserver.observe(modalEl);
        }
      }
      if (window.MutationObserver) {
        this.mutationObserver = new window.MutationObserver(function () {
          _this4.postSizeDebounced();
        });
        this.mutationObserver.observe(el, {
          childList: true,
          subtree: true,
          attributes: true
        });
        if (modalEl) {
          this.mutationObserver.observe(modalEl, {
            childList: true,
            subtree: true,
            attributes: true
          });
        }
      }
      el.querySelectorAll('img,iframe,video,object,embed,picture source').forEach(function (node) {
        node.addEventListener('load', _this4.postSizeDebounced, {
          passive: true
        });
      });
      if (modalEl) {
        modalEl.querySelectorAll('img,iframe,video,object,embed,picture source').forEach(function (node) {
          node.addEventListener('load', _this4.postSizeDebounced, {
            passive: true
          });
        });
      }
      this.postSize();
    },
    startReconnectWatcher: function startReconnectWatcher() {
      var _this5 = this;
      if (this.reconnectInterval) clearInterval(this.reconnectInterval);
      this.reconnectInterval = setInterval(function () {
        if (_this5.destroyed) return;
        var current = _this5.$el.querySelector('.content.module');
        var currentModal = document.querySelector('.dawn-modal-container');
        if (current && current !== _this5.slotEl || currentModal !== _this5.modalEl) {
          _this5.setupContentObservers();
          _this5.postSizeDebounced();
        }
      }, 1000);
    },
    startPollingFallback: function startPollingFallback() {
      var _this6 = this;
      if (this.pollInterval) clearInterval(this.pollInterval);
      this.pollInterval = setInterval(function () {
        if (_this6.destroyed) return;
        if (perfNow() - _this6.lastChangeTs > 3000) {
          _this6.postSize();
        }
      }, 1500);
    },
    disconnectObservers: function disconnectObservers() {
      if (this.resizeObserver) {
        try {
          this.resizeObserver.disconnect();
        } catch (e) {}
        this.resizeObserver = null;
      }
      if (this.mutationObserver) {
        try {
          this.mutationObserver.disconnect();
        } catch (e) {}
        this.mutationObserver = null;
      }
    },
    /* ---------- Cleanup ---------- */cleanup: function cleanup() {
      this.destroyed = true;
      this.disconnectObservers();
      if (this.pollInterval) clearInterval(this.pollInterval);
      if (this.reconnectInterval) clearInterval(this.reconnectInterval);
      window.removeEventListener('message', this.onMessage);
      window.removeEventListener('popstate', this.postSizeDebounced);
      window.removeEventListener('hashchange', this.postSizeDebounced);
      cancelAnimationFrame(this.rafHandle);
      if (this.origPushState) {
        try {
          window.history.pushState = this.origPushState;
        } catch (e) {}
      }
      if (this.origReplaceState) {
        try {
          window.history.replaceState = this.origReplaceState;
        } catch (e) {}
      }
    },
    /* ---------- UI Interactions ---------- */toggleSideBar: function toggleSideBar() {
      this.sidebarToggled = !this.sidebarToggled;
      this.postSizeDebounced();
    },
    onCloseLayerClick: function onCloseLayerClick() {
      this.toggleSideBar();
    },
    /* ---------- Measurement & Posting ---------- */openDropdownBottom: function openDropdownBottom() {
      var bottom = 0;
      document.querySelectorAll('.dawnSelect__content-wrapper, .dawnSelect .toolbar').forEach(function (el) {
        if (!el.offsetParent) return; // closed (v-show)
        bottom = Math.max(bottom, el.getBoundingClientRect().bottom + window.pageYOffset);
      });
      return bottom ? Math.ceil(bottom + 20) : 0;
    },
    measureSize: function measureSize() {
      if (!this.slotEl) return {
        height: 0,
        width: 0
      };
      var rect = this.slotEl.getBoundingClientRect();
      var styles = window.getComputedStyle(this.slotEl);
      var marginTop = parseFloat(styles.marginTop) || 0;
      var marginBottom = parseFloat(styles.marginBottom) || 0;
      var height = Math.ceil(rect.height + marginTop + marginBottom);
      if (this.modalEl) {
        var modalRect = this.modalEl.getBoundingClientRect();
        var modalStyles = window.getComputedStyle(this.modalEl);
        var modalMarginTop = parseFloat(modalStyles.marginTop) || 0;
        var modalMarginBottom = parseFloat(modalStyles.marginBottom) || 0;
        var modalPaddingTop = parseFloat(modalStyles.paddingTop) || 0;
        var modalPaddingBottom = parseFloat(modalStyles.paddingBottom) || 0;
        var modalHeight = Math.ceil(modalRect.height + modalMarginTop + modalMarginBottom + modalPaddingTop + modalPaddingBottom + 20);
        height = Math.max(height, modalHeight);
      }

      // An open dropdown (e.g. the approval-rule user picker with its Apply button) overflows its
      // fixed-height field without growing any box, so without this the iframe is sized short and
      // the parent's footer covers the bottom of the dropdown (SPRT-19141).
      height = Math.max(height, this.openDropdownBottom());
      if (!height || height < 40) {
        height = Math.max(this.slotEl.scrollHeight, this.modalEl ? this.modalEl.scrollHeight : 0, document.documentElement ? document.documentElement.scrollHeight : 0, document.body ? document.body.scrollHeight : 0);
      }
      var width = Math.max(this.slotEl.scrollWidth, this.modalEl ? this.modalEl.scrollWidth : 0, document.documentElement ? document.documentElement.scrollWidth : 0);
      return {
        height: height,
        width: width
      };
    },
    postSize: function postSize() {
      if (!this.slotEl || !this.isInIframe) return;
      var _this$measureSize = this.measureSize(),
        height = _this$measureSize.height,
        width = _this$measureSize.width;
      var shrinking = height < this.lastSent.h;
      var changed = Math.abs(height - this.lastSent.h) > 2 || Math.abs(width - this.lastSent.w) > 2;
      if (shrinking || changed || this.initialBurstCount < 5) {
        window.parent.postMessage({
          type: 'resize',
          data: "if_height=".concat(height, "&if_width=").concat(width)
        }, '*');
        window.parent.postMessage({
          type: 'resize',
          data: {
            height: height,
            width: width
          }
        }, '*');
        this.lastSent = {
          h: height,
          w: width
        };
        this.lastChangeTs = perfNow();
        this.initialBurstCount++;
      }
    },
    postSizeDebounced: function postSizeDebounced() {
      var _this7 = this;
      cancelAnimationFrame(this.rafHandle);
      this.rafHandle = requestAnimationFrame(function () {
        _this7.$nextTick(function () {
          return _this7.postSize();
        });
      });
    },
    scheduleBurst: function scheduleBurst() {
      var _this8 = this;
      var delays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      delays.forEach(function (ms) {
        setTimeout(function () {
          if (!_this8.destroyed) _this8.postSize();
        }, ms);
      });
    }
  }
});

/***/ }),

/***/ "I6uD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_grid_layout__ = __webpack_require__("3OQN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_grid_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_grid_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__new__ = __webpack_require__("Xuxg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__ = __webpack_require__("gk3X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_charts_components_chart_tooltip__ = __webpack_require__("2jaw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets__ = __webpack_require__("Bhkm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_LegacyContainer_routeOldLinks__ = __webpack_require__("a8Xb");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dashboard',
  components: {
    GridLayout: __WEBPACK_IMPORTED_MODULE_2_vue_grid_layout___default.a.GridLayout,
    GridItem: __WEBPACK_IMPORTED_MODULE_2_vue_grid_layout___default.a.GridItem,
    ChartTooltip: __WEBPACK_IMPORTED_MODULE_7__core_charts_components_chart_tooltip__["a" /* default */],
    NewDashboard: __WEBPACK_IMPORTED_MODULE_3__new__["a" /* default */]
  },
  data: function data() {
    return {
      ROW_HEIGHT: __WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["c" /* ROW_HEIGHT */],
      MIN_ROWS: __WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["b" /* MIN_ROWS */],
      MAX_ROWS: __WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["a" /* MAX_ROWS */],
      newDashboard: true,
      newAction: 'Create Dashboard',
      dashboardResolved: null,
      id: null,
      widgets: [],
      offset: 0
    };
  },
  activated: function activated() {
    this.widgets = [];
    this.dashboardResolved = false;
    this.getDashboard(true);
  },
  created: function created() {
    var _this = this;
    this.getDashboard();
    __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on('updateNavigatedAwayFrom', function (r) {
      _this.taintedWidget = r;
    });
    __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on('widgetCollapseStateChanged', function (r) {
      _this.updateWidgetCollapseState(r.data.wId, r.data.pos);
    });
    __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on('updateWidgetHeight', function (r) {
      _this.updateWidgetHeight(r.data.wId, r.data.height, r.data.alt, r.data.state || null);
    });
    __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on('updateWidgetHeightSimple', function (r) {
      _this.updateWidgetHeightSimple(r.data.wId, r.data.height, r.data.explicitS || null);
    });
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.params.page === 'Dashboard' && from.params.page === 'Reports') {
        if (this.taintedWidget) {
          this.getDashboardWidget(this.id, this.taintedWidget.data);
        }
        this.taintedWidget = null;
      }
    }
  },
  mounted: function mounted() {
    this.bindScroll();
    this.bindResize();
  },
  methods: {
    /**
     * Get dashboard
     *
     */
    getDashboard: function getDashboard(activated) {
      var _this2 = this;
      if (__WEBPACK_IMPORTED_MODULE_9__core_feature_flags_feature_flags__["a" /* default */].legacyViewDisabled) {
        __WEBPACK_IMPORTED_MODULE_10__components_LegacyContainer_routeOldLinks__["a" /* routeOldLinks */].call(this, this.$route, '', false);
      }
      this.api.get(this.api.$.dashboard.container).then(function (r) {
        if (r.data && r.data[0] && r.data[0].id) {
          _this2.id = r.data[0].id;
          _this2.getDashboardWidgets(_this2.id, activated);
          _this2.newAction = 'Add Widgets';
        } else {
          _this2.dashboardResolved = true;
        }
      });
    },
    /**
     * Get dashboard widgets based on id
     *
     */
    getDashboardWidgets: function getDashboardWidgets(id, activated) {
      var _this3 = this;
      var source = id ? ["".concat(this.api.$.dashboard.widgets, "/").concat(id)] : ["".concat(this.api.$.dashboard.getData)];
      var fetch = id ? this.api.get : this.api.post;
      fetch.apply(void 0, source).then(function (r) {
        if (r.data) {
          _this3.widgets = _this3.mix(r.data);
          _this3.dashboardResolved = true;
          activated && __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$emit('DASHBOARD_READY');
        }
      });
    },
    updateWidgetHeightSimple: function updateWidgetHeightSimple(wId, heightInPX, explicitS) {
      var desiredH = 0;
      if (explicitS) desiredH = explicitS;else desiredH = Math.ceil(heightInPX / (__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["c" /* ROW_HEIGHT */] + 10)) - 1;
      this.updateWidgetHeight(wId, desiredH, -1, null);
    },
    setDesiredWidgetHeight: function setDesiredWidgetHeight(widget, state) {
      var desiredH = 0;
      if (state === 'OK') desiredH = Object(__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["g" /* getWidgetSize */])(widget.renderComponent).MIN_ROWS;else if (state === 'NA') desiredH = Object(__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["g" /* getWidgetSize */])(widget.renderComponent).NA_ROWS;else if (state === 'EX') desiredH = Object(__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["g" /* getWidgetSize */])(widget.renderComponent).EX_MAX_ROWS;
      widget.storedHeight = desiredH;
      return desiredH - 1;
    },
    updateWidgetHeight: function updateWidgetHeight(wId, offset, alt, state) {
      var _this4 = this;
      var widget = this.getWigetById(wId);
      var widgetSizes = Object(__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["g" /* getWidgetSize */])(widget.renderComponent);
      var maxHeight = widgetSizes.MAX_ROWS;
      if (state) {
        offset = this.setDesiredWidgetHeight(widget, state);
        var upDownMod = widgetSizes.NA_ROWS > widgetSizes.MAX_ROWS ? 1 : -1;
        if (state === 'NA') {
          alt = upDownMod * widgetSizes.MAX_ROWS + 1;
        } else alt = upDownMod * widgetSizes.NA_ROWS + 1;
      }
      if (widget.h !== 1 + offset) {
        offset = offset > maxHeight ? maxHeight : offset;
        if (this.widgets.length !== 0) {
          var affectedWidgets = this.widgets.filter(function (w) {
            return w.x === widget.x && w.y > widget.y;
          });
          affectedWidgets.forEach(function (wgt) {
            wgt.y += offset + alt;
          });
        }
        this.$nextTick(function () {
          offset = widget.isCollapsed ? 1 : 1 + offset;
          widget.h = offset;
          if (_this4.$refs.gridLayout) {
            _this4.$refs.gridLayout.eventBus.$emit('resizeEvent', 'resizeend', widget.i, widget.x, widget.y, offset, widget.w);
          }
        });
      }
      this.dashboardResolved = true;
    },
    getWigetById: function getWigetById(wId) {
      var widgetIndex = this.widgets.findIndex(function (w) {
        return w.id === wId;
      });
      return this.widgets[widgetIndex];
    },
    updateWidgetCollapseState: function updateWidgetCollapseState(wId, newState) {
      var widget = this.getWigetById(wId);
      var originalHeight = widget.isCollapsed ? widget.storedHeight || Object(__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["g" /* getWidgetSize */])(widget.renderComponent).MIN_ROWS : widget.h;
      widget.isCollapsed = newState[0].dockInfo.isCollapsed;
      var offset = !widget.isCollapsed ? originalHeight - 1 : (originalHeight - 1) * -1;
      this.updateWidgetHeight(wId, offset, 0);
    },
    getDashboardWidget: function getDashboardWidget(cId, wId) {
      var _this5 = this;
      if (cId) {
        var source = ["".concat(this.api.$.dashboard.widget, "/").concat(cId, "/").concat(wId)];
        var fetch = this.api.get;
        fetch.apply(void 0, source).then(function (r) {
          if (r.data) {
            _this5.reloadWidget(wId, r.data[0]);
            _this5.dashboardResolved = true;
          }
        });
      }
    },
    /**
     * Set dashboard settings
     *
     */
    setDashboard: function setDashboard(id, payload) {
      this.api.put("".concat(this.api.$.dashboard.widgets), payload);
    },
    /**
     * Creates a new dashboard
     *
     */
    create: function create(widgets) {
      this.widgets = widgets;
    },
    /**
     * Creates a new widget
     *
     */
    addWidget: function addWidget() {
      if (this.newDashboard) {
        this.newDashboard = false;
        this.id && this.$refs.newWidget && this.$refs.newWidget.showModules();
      } else {
        this.$refs.newWidget.showModules();
      }
    },
    /**
     * Gets the widget title
     *
     */
    getTitle: function getTitle(widget) {
      return widget.settings && widget.settings.title || widget.title || widget.id;
    },
    /**
     * Clones widget
     *
     */
    cloned: function cloned(widget, payload) {
      var _this6 = this;
      var widgetClone = deepClone(widget);
      var layoutRows = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(this.widgets.map(function (w) {
        return w.y;
      })));
      widgetClone.title = (widget.label || widget.id) + ' [copy]';
      widgetClone.settings.title = widgetClone.title;
      widgetClone.label = widgetClone.title;
      widgetClone.id = payload.id || widget.id + '1';
      widgetClone.i = this.widgets.length + 1 + '';
      widgetClone.y = layoutRows + 1;
      widgetClone._dateFilter = [new Date(widget.dateRangeFilter.startDate), new Date(widget.dateRangeFilter.endDate)];
      this.$nextTick(function () {
        _this6.widgets.push(widgetClone);
        if (payload.id) {
          _this6.getDashboardWidget(_this6.id, payload.id);
        }
      });
    },
    /**
     * Removes widget
     *
     */
    removed: function removed(widget, i) {
      var adjacentWidget = this.widgets[i - 1 >= 0 ? i - 1 : i + 1];

      // remove widget
      this.widgets.splice(this.widgets.indexOf(widget), 1);
      if (this.widgets.length) {
        this.redraw(adjacentWidget);
      }
    },
    /**
     * Changes widget position in layout
     *
     */
    moved: function moved(widget, i, newX, newY) {
      var availablePositions = [0, 6];
      var isValidPosition = availablePositions.indexOf(newX) >= 0;
      this.$el.querySelector('.vue-grid-placeholder').setAttribute('data-valid', isValidPosition);
      var position = [{
        widgetId: widget.id,
        dockInfo: {
          dockRow: newY,
          dockOrder: isValidPosition ? newX : this.closest(newX, availablePositions),
          isCollapsed: widget.isCollapsed
        }
      }];
      this.$nextTick(function () {
        widget.x = position[0].dockInfo.dockOrder;
      });
      this.setDashboard(this.id, position);
    },
    reloadChart: function reloadChart(widget) {
      var widgetChart = this.$refs.charts.filter(function (r) {
        return r.id === "W-".concat(widget.id);
      })[0];
      widgetChart && widgetChart.$emit('scrollIntoView');
    },
    /**
     * Redraws chart/grid inside widget
     *
     */
    redraw: function redraw(widget, i) {
      var _this7 = this;
      var widgetComp = widget.component && this.$refs.comps.filter(function (r) {
        return r.$attrs.id === "".concat(widget.id, "-comp");
      })[0];
      var widgetCompGrid = widgetComp && ~widgetComp.$children[0].$vnode.tag.indexOf('-grid') && widgetComp.$children[0];
      if (widgetCompGrid) {
        widgetCompGrid.$emit('redraw');
      }
      if (this.$refs.widgets[i]) this.$refs.widgets[i].startWO = widget.w;
      this.$nextTick(function () {
        _this7.snapToWidth(widget, i);
      });
      // reset drag/resize placeholder
      this.$el.querySelector('.vue-grid-placeholder').setAttribute('data-valid', true);
    },
    resizeFromHandle: function resizeFromHandle(widget, i, newH, newW) {
      var availableWidths = getAvailableWidths(widget);
      this.$el.querySelector('.vue-grid-placeholder').setAttribute('data-valid', availableWidths.indexOf(newW) >= 0);
      this.$refs.widgets[i].startW = widget.w;
    },
    snapToWidth: function snapToWidth(widget, i) {
      var _this8 = this;
      var availableWidths = getAvailableWidths(widget);
      var snappedWidth = this.closest(widget.w, availableWidths);
      var $widget = this.$refs.widgets[i];
      widget.w = snappedWidth;
      if ($widget && ($widget.startW !== snappedWidth || $widget.startWO !== $widget.startW)) {
        this.$nextTick(function () {
          var widgetChart = _this8.$refs.charts.filter(function (r) {
            return r.id === "W-".concat(widget.id);
          })[0];
          widgetChart && widgetChart.$emit('redraw');
          $widget.$emit('resize');
        });
      }
    },
    closest: function closest(value, list) {
      var v = list[0];
      var d = Math.abs(value - v);
      for (var i = 0; i < list.length; i++) {
        var c = Math.abs(value - list[i]);
        if (d > c) {
          d = c;
          v = list[i];
        }
      }
      return v;
    },
    reloadWidget: function reloadWidget(wId, newData) {
      var widget = this.getWigetById(wId);
      widget.variables = newData.variables;
      widget._dateFilter = [new Date(newData.dateRangeFilter.startDate), new Date(newData.dateRangeFilter.endDate)];
      widget.title = newData.label;
      widget.isCollapsed = newData.dockInfo.isCollapsed;
      widget.reqDraw = true;
      widget.h = !widget.isCollapsed ? Object(__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["g" /* getWidgetSize */])(widget.renderComponent).MIN_ROWS : 1;
      widget.mh = Object(__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["g" /* getWidgetSize */])(widget.renderComponent).MAX_ROWS;
      widget.reportFilters = newData.reportFilters;
      widget.settings = {
        title: newData.title,
        details: {
          label: '',
          action: ''
        }
      };
      widget.actions = newData.buttons.map(function (button) {
        button.ref = button.action;
        button.status = button.visible;
        return button;
      });
      this.saved(widget);
      this.taintedWidget = null;
    },
    /**
     * Saves widget settings
     *
     */
    saved: function saved(widget) {
      this.reloadChart(widget);
    },
    /**
     * Prepares the layout
     *
     */
    mix: function mix(widgets) {
      return widgets.map(function (widget) {
        // TODO: extract to function
        widget.x = widget.dockInfo.dockOrder;
        widget.y = widget.dockInfo.dockRow;
        widget.isCollapsed = widget.dockInfo.isCollapsed;
        widget.reqDraw = true;
        widget.w = __WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["f" /* WIDTHS */][widget.variables.filter(function (k) {
          return k.name === 'Width';
        })[0].value];
        widget.h = !widget.isCollapsed ? Object(__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["g" /* getWidgetSize */])(widget.renderComponent).MIN_ROWS : 1;
        widget.mh = Object(__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["g" /* getWidgetSize */])(widget.renderComponent).MAX_ROWS;
        widget.i = "".concat(widget.id);
        widget._dateFilter = [new Date(widget.dateRangeFilter.startDate), new Date(widget.dateRangeFilter.endDate)];
        widget.title = widget.label;
        widget.settings = {
          title: widget.title,
          details: {
            label: '',
            action: ''
          }
        };
        widget.actions = widget.buttons.map(function (button) {
          button.ref = button.action;
          button.status = button.visible;
          return button;
        });
        widget.component = __WEBPACK_IMPORTED_MODULE_8__widgets__["a" /* default */][widget.renderComponent];
        return widget;
      });
    },
    isResizable: function isResizable(widget) {
      return widget.variableDefinitions && widget.variableDefinitions[0].items.length > 1;
    },
    /**
     * Passes scroll offset to widgets
     * to trigger lazy load
     *
     */
    bindScroll: function bindScroll() {
      document.querySelector('.main-panel').addEventListener('scroll', __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default()(this.handleScroll, 400));
    },
    handleScroll: function handleScroll(e) {
      this.offset = e.target.scrollTop;
    },
    /**
     * Updates innerHeight
     *
     */
    bindResize: function bindResize() {
      window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default()(this.handleResize, 1000));
    },
    handleResize: function handleResize(e) {
      this.$root.innerHeight = window.innerHeight;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off('updateWidgetHeight');
    __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off('updateWidgetHeightSimple');
  }
});

//
function getAvailableWidths(widget) {
  return widget.variableDefinitions ? widget.variableDefinitions[0].items.map(function (k) {
    return __WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["f" /* WIDTHS */][k.key];
  }) : Object.keys(__WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["f" /* WIDTHS */]).map(function (k) {
    return __WEBPACK_IMPORTED_MODULE_4__widgets_SharedComponents_constants__["f" /* WIDTHS */][k];
  });
}

/**
 * Returns a deeply cloned object without reference.
 * Copied from Vuex.
 * @type {Object}
 */
function deepClone(obj) {
  if (Array.isArray(obj)) {
    return obj.map(deepClone);
  } else if (obj && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(obj) === 'object') {
    var cloned = {};
    var keys = Object.keys(obj);
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i];
      cloned[key] = deepClone(obj[key]);
    }
    return cloned;
  } else {
    return obj;
  }
}

/***/ }),

/***/ "IIRD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isRejected: function isRejected() {
      return this.params.value.toLowerCase() === 'rejected' || this.params.value.toLowerCase() === 'declined';
    },
    displayValue: function displayValue() {
      return this.params.value === 'Rejected' ? 'Declined' : this.params.value;
    },
    tooltipContent: function tooltipContent() {
      return !this.isRejected ? this.params.value : this.getRejectionReason();
    }
  },
  methods: {
    getRejectionReason: function getRejectionReason() {
      return 'Decline Reason: ' + this.params.data.RejectionReason;
    }
  }
});

/***/ }),

/***/ "IJVW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return utils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__core_events_events__);


var utils = {
  enableSaveButton: function enableSaveButton(_enableSaveButton) {
    if (_enableSaveButton) {
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_1__core_events_events___default.a.APPROVAL_RULE.ENABLE_SAVE_BUTTON);
    }
  }
};

/***/ }),

/***/ "IS7y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      emailData: {}
    };
  },
  created: function created() {
    var _this = this;
    var invoiceId = this.$route.query.invoiceId;
    if (!invoiceId) {
      console.warn('Invoice ID is missing');
      return;
    }
    this.api.get("".concat(this.api.$.invoice.reviewEmail, "/").concat(invoiceId)).then(function (response) {
      _this.emailData = response.data;
    }).catch(function (ex) {
      return console.error('Error fetching review email:', ex);
    });
  },
  methods: {
    closeWindow: function closeWindow() {
      window.close();
    },
    formatDate: function formatDate(dateString) {
      if (!dateString) return '';
      var timestamp = parseInt(dateString.match(/\d+/)[0], 10);
      return new Date(timestamp).toLocaleString();
    }
  }
});

/***/ }),

/***/ "IUe+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3YIXCQkfTr_TWSuY6qD8RB","Dell":"_1aXL9EjWGuiJ-iprLCiOjV","Abbott":"_352HDAG3oTaQICqkTKX-E5","Gap":"_3ruGqaHkRxjcI96czjn9uD","Allstate":"E8TeF2SL-KY66hp5DH2Jj","Asurion":"_3WqsYu1jbxDmRtrtcsm8LW","Invitae":"_2d4_g5XTkFwgEpbkQHI89K","JWE":"_1ccScelObmAKBDOIA_Sv0i"};

/***/ }),

/***/ "IVb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-box',
  props: {
    title: String,
    subtitle: String
  }
});

/***/ }),

/***/ "IYIA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_legacyRouter_vue__ = __webpack_require__("RlAP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67913ffc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_legacyRouter_vue__ = __webpack_require__("2Yud");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_legacyRouter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67913ffc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_legacyRouter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ibr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"txn-details-page"},[_vm._t("title"),_vm._v(" "),_c('div',[_c('div',{staticClass:"navless-layout-header"},[_vm._t("navbar",function(){return [_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"fal fa-chevron-left"}),_vm._v("\n           \n          "+_vm._s(_vm.cannotBeReconciled || _vm.transactionComplete ? 'Back' : 'Cancel')+"\n        ")]),_vm._v(" "),(!_vm.cannotBeReconciled && (_vm.isUserAdmin || _vm.reconcileAction !== 'view'))?_c('a',{staticClass:"submit-btn",class:{ 'submit-btn--saving': _vm.isSaving || !_vm.uploadFinished },attrs:{"href":"javascript:;"},on:{"click":_vm.confirm}},[_c('strong',[_vm._v("Done")])]):_vm._e()]})],2),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.cannotBeReconciled)?_c('div',[_c('br'),_vm._v(" "),_c('ed-notice',{attrs:{"type":"danger","icon":"fas fa-exclamation-circle"}},[_vm._v("\n        Transaction Declined: "+_vm._s(_vm.transaction.data.DeclineReason)+"\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.transaction.data.Id)?_c('div',{staticClass:"card"},[_c('ed-notice',{staticClass:"card"},[_c('div',{staticClass:"details"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"overflow-merchant"},[_c('strong',[_vm._v(_vm._s(_vm.transaction.data.merchant))])]),_vm._v(" "),_c('p',[_c('small',[_vm._v(_vm._s(_vm.moment(_vm.transaction.data.date).format('YYYY-MM-DD')))])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('p',{staticStyle:{"text-align":"right"}},[_c('strong',[_c('v-money',[_vm._v(_vm._s(_vm.transaction.data.amount))])],1)])])])])])],1):_vm._e(),_vm._v(" "),(_vm.transactionComplete)?_c('div',[_c('br'),_vm._v(" "),_c('ed-notice',{attrs:{"type":"alt","icon":"fas fa-check-circle"}},[_vm._v("\n        This transaction was submitted in envelope "+_vm._s(_vm.transaction.data.EnvelopeNumber)+"\n      ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"txn-chip"},[_c('span',{staticClass:"txn-chip__stripe"}),_vm._v(" "),_c('div',{staticClass:"txn-chip__body"},[_c('div',{staticClass:"txn-chip__top"},[_c('span',{staticClass:"txn-chip__merchant"},[_vm._v(_vm._s(_vm.transaction.data.merchant))]),_vm._v(" "),_c('span',{staticClass:"txn-chip__amount"},[_c('v-money',[_vm._v(_vm._s(_vm.transaction.data.amount))])],1)]),_vm._v(" "),_c('div',{staticClass:"txn-chip__date"},[_vm._v("\n          "+_vm._s(_vm.formatChipDate(_vm.transaction.data.date))+"\n        ")])])]),_vm._v(" "),(_vm.cannotBeReconciled)?_c('div',[_c('p',[_c('strong',[_vm._v("Card Holder")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.transaction.data.Holder))])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Card Number")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.transaction.data.CardNumber))])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.divisionName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.transaction.data.Division))])])]):_vm._e(),_vm._v(" "),(!_vm.cannotBeReconciled)?_c('div',[(_vm.transaction.data.DivisionId)?_c('Reconcile',{ref:"reconcileComp",staticClass:"reconcile-form",attrs:{"transaction":_vm.transaction,"fields-incomplete":{ receiptIncomplete: _vm.receiptIncomplete, descriptionIncomplete: _vm.descriptionIncomplete },"wrong-split-total":_vm.wrongSplitTotal,"reconcile-action":_vm.reconcileAction,"receipt-edit-allowed":_vm.receiptEditAllowed,"is-mobile":_vm.isMobile},on:{"reconcile-created":_vm.handleReconcileCreated,"fields-updated":_vm.handleFieldsUpdated,"mediaFilesPathUpdated":_vm.updateMediaFilesPath,"attachmentsUpdated":_vm.updateAttachmentsFiles,"additional-documents-updated":_vm.updateAdditionalDocuments,"split-amounts":_vm.handleSplitAmounts,"description-text":_vm.handleDescriptionText,"uploadFinished":_vm.handleUploadFinished}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('br'),_c('br')])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iddi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-form',
  props: {
    formHeader: String,
    submitClass: {
      type: String,
      default: 'btn btn-primary'
    },
    submitText: {
      type: String,
      default: 'Submit'
    },
    submitVisible: {
      type: Boolean,
      default: true
    },
    endpoint: String
  },
  methods: {
    submitForm: function submitForm(endpoint) {
      _this.api.forms.post(endpoint /*, data */).then(function (res) {}).catch(function (err) {
        return console.error(err);
      });
    }
  }
});

/***/ }),

/***/ "Iexc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("vs3s");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23fca74e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("eDUl");
function injectStyle (ssrContext) {
  __webpack_require__("2WLZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23fca74e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23fca74e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IhfB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("HxX2");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d15449_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("PDTq");
function injectStyle (ssrContext) {
  __webpack_require__("0Okf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d15449_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Ik2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltip_standard_vue__ = __webpack_require__("p0jD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48324bf4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tooltip_standard_vue__ = __webpack_require__("pB8L");
function injectStyle (ssrContext) {
  __webpack_require__("zl3+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48324bf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltip_standard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48324bf4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tooltip_standard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IowB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllocationStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__("Z60a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__("C9uT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__("lQbo");






var api = new __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */]();
var AllocationStore = /*#__PURE__*/function () {
  function AllocationStore(api) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AllocationStore);
    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(this, "state", {});
    this.api = api;
  }
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AllocationStore, [{
    key: "getPurchaseOrderItems",
    value: function () {
      var _getPurchaseOrderItems = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee(allocationParameter) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.api.post(api.GetPurchaseOrderItems(), {
                allocationParameter: allocationParameter
              });
            case 2:
              response = _context.sent;
              return _context.abrupt("return", response.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getPurchaseOrderItems(_x) {
        return _getPurchaseOrderItems.apply(this, arguments);
      }
      return getPurchaseOrderItems;
    }()
  }]);
}();


/***/ }),

/***/ "Ivkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Layouts_shell__ = __webpack_require__("O5l0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Layouts_shell_public__ = __webpack_require__("AgGS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LegacyContainer_legacyRouter__ = __webpack_require__("IYIA");
/* eslint no-multi-spaces: 0 */





/* harmony default export */ __webpack_exports__["a"] = ({
  shell: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__components_Layouts_shell__["a" /* default */]),
  publicShell: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2__components_Layouts_shell_public__["a" /* default */]),
  legacy: __WEBPACK_IMPORTED_MODULE_3__components_LegacyContainer_legacyRouter__["a" /* default */]
});

/***/ }),

/***/ "J7rH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JBez":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3oeObszFW0AuQ8pej7lQOq","Dell":"_3qcG6GMCN1-Y8aEjCcJdHC","Abbott":"_1QkAvigfnUfgLEiDSh5BMf","Gap":"_4ttKILkN5yWsi8MOpch4_","Allstate":"_3Rfg47K_vEY057o2M8Nal7","Asurion":"_1X66AYfSjZmZWCqVfsj4aV","Invitae":"_2DBI9BRzGlLL5twYu8pv0B","JWE":"_2Y-H_agac0b-fTCXJ3Xum7"};

/***/ }),

/***/ "JD12":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_7jNG4HN2qNnHn5Rd5BOyn","Dell":"_3LHkVeYR9SLQ2xTUvSuFdm","Abbott":"_2T_X3QwFMdLQg-4mPeeuFi","Gap":"_2_mFuglw_dCViOqh9X9THO","Allstate":"_2MDB6gJMJES9D4YS8kZZaO","Asurion":"_3l8Q_-YP9gpqvvM3hDmEQV","Invitae":"AFPa9C_Y5PZASWZgvTCMd","JWE":"_3EN6d0yz9kXuz6QfPUqFZO"};

/***/ }),

/***/ "JFv1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('grid',{ref:"ApprovalHistoryGrid",attrs:{"name":"","desc":"","checkboxes":false,"views":false,"layout":"frame","search":"","endpoint":_vm.api.$.approval.getApprovalRulesHistory}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JHbF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object,
    errors: Object,
    invoiceModelCurrencies: Array,
    isFundingCurrencyDifferent: Boolean
  },
  activated: function activated() {
    var _this = this;
    this.$nextTick(function () {
      _this.approvalCheckboxOptions[0].status = false;
      _this.paymentDate = new Date();
      _this.emitChanges();
    });
  },
  deactivated: function deactivated() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.currency = {};
      _this2.model.usdEquivalent = 0;
      _this2.paymentDate = new Date();
      _this2.approvalCheckboxOptions.status = false;
    });
  },
  data: function data() {
    return {
      currency: {},
      paymentDate: new Date(),
      approvalCheckboxOptions: [{
        label: 'I agree to the payment(s) specified below.',
        status: false
      }],
      paymentNonUSDMessage: 'The Funding Equivalent listed below is based on the current indicative currency rate through Eved. ' + 'A delay in submitting these payments through the site may cause the funding equivalent amount due to vary from what is currently displayed. ' + 'The final funding equivalent and amount due for payment will show in your receipt and statement email.'
    };
  },
  computed: {
    isFundingCurrencySameOnPaymentRun: function isFundingCurrencySameOnPaymentRun() {
      if (this.invoiceModelCurrencies) {
        return this.invoiceModelCurrencies.length === 1 && this.invoiceModelCurrencies[0] === this.currency.Key;
      }
      return false;
    },
    getTitle: function getTitle() {
      return this.model.displayUSDEquivalent ? 'Payment Information' // Post
      : 'Funding Information'; // Make
    },
    getDescription: function getDescription() {
      return this.model.displayUSDEquivalent ? 'Enter the USD Equivalent and the schedule payment date for all the selected invoices.' // Post
      : this.model.displayFundingCurrencies ? 'Enter the funding currency for all the selected invoices.' : ''; // Make
    },
    datepickerShortcuts: function datepickerShortcuts() {
      var today = {
        key: 'today',
        label: 'Today'
      };
      var yesterday = {
        key: 'yesterday',
        label: 'Yesterday'
      };
      if (this.model.disablePaymentDate) {
        return [];
      } else if (this.model.hideDatePickerYesterdayLink) {
        return [today];
      } else {
        return [today, yesterday];
      }
    }
  },
  methods: {
    selectFundingCurrency: function selectFundingCurrency(e) {
      this.currency = e;
      this.errors.FundingCurrency = false;
      this.emitChanges();
    },
    checkApprovalCheckbox: function checkApprovalCheckbox(e) {
      this.errors.ApprovalCheckboxError = false;
      this.emitChanges(utils.constants.invoice.ApprovalCheckbox);
    },
    usdEquivalentChanged: function usdEquivalentChanged(e) {
      this.emitChanges();
    },
    paymentDateChanged: function paymentDateChanged() {
      this.errors.PaymentDateMissing = false;
      this.emitChanges();
    },
    emitChanges: function emitChanges(from) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].PAYMENT.FUNDING_INFO_CHANGED, {
        CurrencyCode: this.currency.Key,
        CurrencyName: this.currency.Value,
        Approval: this.approvalCheckboxOptions[0].status,
        USDEquivalent: parseFloat(this.model.usdEquivalent) || 0,
        PaymentDate: this.paymentDate,
        From: from
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "JJzH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_itemDetails_vue__ = __webpack_require__("kzaK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b17bf5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_itemDetails_vue__ = __webpack_require__("v3UP");
function injectStyle (ssrContext) {
  __webpack_require__("lwZO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22b17bf5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_itemDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b17bf5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_itemDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JKEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_details__ = __webpack_require__("GeiN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_Programs_Card_envelopes_EnvelopeStatus_vue__ = __webpack_require__("Fcpc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OpenEnvelope__ = __webpack_require__("5y3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_Programs_Card_cards_CardHolder_vue__ = __webpack_require__("rMOU");




/* harmony default export */ __webpack_exports__["a"] = ({
  'EnvelopeNumber': {
    label: 'Envelope',
    render: __WEBPACK_IMPORTED_MODULE_2__OpenEnvelope__["a" /* default */],
    width: 130
  },
  CardNumber: {
    label: 'Card Number',
    compose: maskedCardNumber,
    width: 120
  },
  'Holder': {
    label: 'Card Holder',
    render: __WEBPACK_IMPORTED_MODULE_3__components_modules_Programs_Card_cards_CardHolder_vue__["a" /* default */],
    width: 120
  },
  NameOnCard: '_',
  'Transactions': {
    label: 'Transactions',
    width: 120
  },
  'Amount': {
    label: 'Amount',
    type: 'money',
    f: 'data.Amount',
    width: 130
  },
  'StartDateFormatted': {
    label: 'Start Date',
    width: 120
  },
  'EndDateFormatted': {
    label: 'End Date',
    width: 120
  },
  'EnvelopeStatus': {
    label: 'Status',
    source: 'EnvelopeList',
    render: __WEBPACK_IMPORTED_MODULE_1__components_modules_Programs_Card_envelopes_EnvelopeStatus_vue__["a" /* default */],
    width: 140
  },
  'WaitingApproval': {
    label: 'Waiting Approval',
    details: 'local',
    detailsCondition: showAttachmentsExpandIcon,
    detailsParamsURL: getAttachmentsDetailsParams,
    detailsComp: __WEBPACK_IMPORTED_MODULE_0__attachments_details__["a" /* default */],
    width: 120
  },
  'ProgramName': {
    label: 'Program',
    width: 120
  },
  'BusinessUnit': {
    label: 'Business Unit',
    width: 130
  },
  'APFile': {
    label: 'AP File',
    compose: apFileLink,
    width: 120
  },
  'TransactionNo': {
    label: 'Transaction No',
    width: 120
  },
  'AccountId': '_',
  'CreatedDate': '_',
  'CreatedByUserID': '_',
  'CreatedByUser': '_',
  'RejectionReason': '_'
});
function maskedCardNumber(card) {
  if (card && card.data && card.data.CardNumber) {
    return '****' + card.data.CardNumber;
  } else {
    return '****';
  }
}
function showAttachmentsExpandIcon(params) {
  return parseInt(params.data.WaitingApproval) > 0;
}
function getAttachmentsDetailsParams(params) {
  return "?envelopeId=".concat(params.data.Id);
}
function apFileLink(p) {
  if (!p.data) return '';
  var apFileId = p.data.ApFileId;
  var url = "".concat(global.app.api.env, "/AccountPayable/GenerateEvedPayCardAPFile?apFileId=").concat(apFileId);
  return "<a title=\"Open AP File\" href=\"".concat(url, "\" target=\"_blank\">").concat(p.value, "</a>");
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "JNij":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      formData: {
        city: '',
        postalCode: '',
        originalCountryName: '',
        country: '',
        state: {
          StateID: 0,
          StateName: ''
        },
        canadaState: {
          StateID: 0,
          StateName: ''
        },
        region: ''
      },
      USstates: [],
      USoriginalStates: [],
      canadaStates: [],
      originalCanadaStates: [],
      countries: [],
      originalCountries: [],
      mailingAddress: {},
      addObjectUser: {},
      rushOrder: false,
      requireReceiptDescription: false,
      allowRushPhysicalCards: false,
      errors: {}
    };
  },
  created: function created() {
    this.resetFields();
    this.getDivisionSettings();
    this.populateFormData(this.formData);
  },
  props: {
    card: Object,
    divisionId: '',
    cardDivisionId: '',
    account: Object
  },
  computed: {
    rushDisabledReason: function rushDisabledReason() {
      if (this.account && this.account.Available <= 0) {
        return 'Insufficient funds available for rush shipping.';
      }
      return '';
    }
  },
  methods: {
    requestPhysicalCard: function requestPhysicalCard(showModal) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var isValid, response, userFriendlyErrorMessage, errorDataString, firstBracketIndex, secondBracketIndex, colonIndex, endOfMessagePeriod, endOfMessageParenthesis, endOfMessageIndex, detailedMessage;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              isValid = _this.validateForm();
              if (isValid) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return _this.api.post("evedpaycards/request-physical-card", {
                preventError: true,
                Shipping: {
                  IsRush: _this.rushOrder,
                  Name: _this.mailingAddress.name,
                  Address: {
                    Country: {
                      Id: 186
                    },
                    Address1: _this.mailingAddress.line1,
                    Address2: _this.mailingAddress.line2,
                    City: _this.mailingAddress.city,
                    State: {
                      Id: _this.mailingAddress.state.StateID
                    },
                    Zip: _this.mailingAddress.zip
                  },
                  CardIds: _this.card
                }
              });
            case 6:
              response = _context.sent;
              if (response.status === 200) {
                showModal.showModal = false;
                __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit('physicalCardRequested', _this.card);
                _this.$emit('success');
              } else {
                console.error('Error requesting physical card:', response);
              }
              _context.next = 16;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.error('Exception while requesting physical card:', _context.t0);
              userFriendlyErrorMessage = 'An unexpected error occurred. Please try again.';
              if (_context.t0.response && _context.t0.response.data) {
                errorDataString = JSON.stringify(_context.t0.response.data);
                firstBracketIndex = errorDataString.indexOf('['); // searching for the first bracket in the message
                secondBracketIndex = errorDataString.indexOf('[', firstBracketIndex + 1); // when the first bracket is found, search for the second one
                if (secondBracketIndex !== -1) {
                  colonIndex = errorDataString.indexOf(':', secondBracketIndex); // after the second bracket is found, look for the colon -> from there the message for the user starts
                  if (colonIndex !== -1) {
                    endOfMessagePeriod = errorDataString.indexOf('.', colonIndex); // end when the first period is found
                    endOfMessageParenthesis = errorDataString.indexOf('(', colonIndex); // or end when the first parethesis is found
                    endOfMessageIndex = errorDataString.length; // min index if both are found
                    if (endOfMessagePeriod !== -1 && endOfMessageParenthesis !== -1) {
                      endOfMessageIndex = Math.min(endOfMessagePeriod, endOfMessageParenthesis);
                      // if only period is found
                    } else if (endOfMessagePeriod !== -1) {
                      endOfMessageIndex = endOfMessagePeriod;
                      // if only parenthesis is found
                    } else if (endOfMessageParenthesis !== -1) {
                      endOfMessageIndex = endOfMessageParenthesis;
                    }
                    // extract and trim the detailed error message
                    detailedMessage = errorDataString.substring(colonIndex + 1, endOfMessageIndex).trim();
                    userFriendlyErrorMessage = detailedMessage;
                    // remove any trailing parenthesis from the error message
                    if (userFriendlyErrorMessage.endsWith('(')) {
                      userFriendlyErrorMessage = userFriendlyErrorMessage.slice(0, -1).trim();
                    }
                  }
                }
              }
              alert(userFriendlyErrorMessage);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 10]]);
      }))();
    },
    getDivisionSettings: function getDivisionSettings() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var divisionIDToUse;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.programs = [];
              divisionIDToUse = _this2.divisionId ? _this2.divisionId : _this2.cardDivisionId;
              _this2.api.post('Settings/GetDivision', {
                divisionID: divisionIDToUse
              }).then(function (response) {
                if (response && response.data) {
                  var responseData = JSON.parse(response.data.Data);
                  var evedPayCardAccountSettingsObj = JSON.parse(responseData.evedPayCardAccountSettings);
                  _this2.allowRushPhysicalCards = evedPayCardAccountSettingsObj.AllowRushPhysicalCards;
                }
              }).catch(function (error) {
                console.warn(error);
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    resetFields: function resetFields() {
      this.rushOrder = false;
      this.mailingAddress = {};
      this.name = '';
      this.address = '';
      this.addressLine2 = '';
      this.city = '';
      this.formData.state = '';
      this.formData.canadaState = '';
      this.formData.region = '';
      this.zipCode = '';
    },
    fetchCountriesOnOpen: function fetchCountriesOnOpen() {
      var _this3 = this;
      if (this.countries.length) {} else {
        this.api.forms.post(this.api.$.profile.getAllCountries, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this3.countries = r.data.Data;
            _this3.originalCountries = r.data.Data;
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    fetchCountries: function fetchCountries(value) {
      var _this4 = this;
      this.counter || this.api.forms.post(this.api.$.profile.getAllCountries, {
        q: value || ''
      }).then(function (r) {
        _this4.counter = 0;
        if (r && r.data && r.data.Data) {
          _this4.countries = r.data.Data;
        }
      }).catch(function (e) {
        console.warn(e);
        _this4.counter = 0;
      });
      this.counter = 1;
    },
    fetchUserDivisions: function fetchUserDivisions() {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.divisions = [];
              if (_this5.accountId === '') {
                _this5.api.get(_this5.api.$.evedpaycard.division).then(function (response) {
                  if (response && response.data) {
                    var _iterator = _createForOfIteratorHelper(response.data),
                      _step;
                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var account = _step.value;
                        _this5.divisions.push({
                          Id: account.DivisionId,
                          Name: account.DivisionName
                        });
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                  }
                }).catch(function (error) {
                  console.warn(error);
                });
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    restoreCountries: function restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries);
      }
    },
    isUS: function isUS() {
      return this.formData.country && this.formData.country.CountryName === 'United States';
    },
    GetStatesUSURL: function GetStatesUSURL() {
      return this.api.$.profile.getAllStates;
    },
    isCanada: function isCanada() {
      return this.formData.country && this.formData.country.CountryName === 'Canada';
    },
    GetStatesCanadaURL: function GetStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates;
    },
    // Fetch States on OPEN
    fetchUSStatesOnOpen: function fetchUSStatesOnOpen() {
      var url = this.GetStatesUSURL();
      this.fetchStatesOnOpen(this.USstates, url);
    },
    fetchCanadaStatesOnOpen: function fetchCanadaStatesOnOpen() {
      var url = this.GetStatesCanadaURL();
      this.fetchStatesOnOpen(this.canadaStates, url);
    },
    fetchStatesOnOpen: function fetchStatesOnOpen(states, url) {
      var _this6 = this;
      if (states.length && (this.isCanada() || this.isUS())) {} else {
        this.api.forms.post(url, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this6.mapStatesDataOnOpen(r.data.Data);
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    mapStatesDataOnOpen: function mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USstates = this.USoriginalStates = data;
      } else {
        this.canadaStates = this.originalCanadaStates = data;
      }
    },
    // Fetch States on search text
    fetchUSStates: function fetchUSStates(value) {
      var url = this.GetStatesUSURL();
      this.fetchStates(value, url);
    },
    fetchCanadaStates: function fetchCanadaStates(value) {
      var url = this.GetStatesCanadaURL();
      this.fetchStates(value, url);
    },
    fetchStates: function fetchStates(value, url) {
      var _this7 = this;
      this.counter || this.api.forms.post(url, {
        q: value || ''
      }).then(function (r) {
        _this7.counter = 0;
        if (r && r.data && r.data.Data) {
          _this7.mapStatesDataOnFetch(r.data.Data);
        }
      }).catch(function (e) {
        console.warn(e);
        _this7.counter = 0;
      });
      this.counter = 1;
    },
    mapStatesDataOnFetch: function mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USstates = data;
      } else {
        this.canadaStates = data;
      }
    },
    // Restore States
    restoreUSStates: function restoreUSStates() {
      this.restoreStates(this.USstates, this.USoriginalStates);
    },
    restoreCanadaStates: function restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates);
    },
    restoreStates: function restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates);
      }
    },
    populateFormData: function populateFormData(data) {
      if (data.CompanyName !== null) {
        this.formData = {
          city: data.City,
          postalCode: data.Zip,
          originalCountryName: data.CountryName,
          country: {
            'CountryID': 186,
            'CountryName': 'United States'
          },
          state: {
            StateID: data.isCanada === 'False' && data.StateID || 0,
            StateName: data.isCanada === 'False' && data.State || ''
          },
          canadaState: {
            StateID: data.isCanada === 'True' && data.StateID || 0,
            StateName: data.isCanada === 'True' && data.State || ''
          },
          region: data.Region
        };
        this.disableControls = true;
      } else {
        this.disableControls = false;
      }
    },
    countrySelected: function countrySelected(e) {
      this.doDisplayCountryError = false;
      this.resetState(e.CountryName);
    },
    resetState: function resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.formData.state = {
          StateID: 0,
          StateName: ''
        };
        this.formData.canadaState = {
          StateID: 0,
          StateName: ''
        };
        this.formData.region = '';
      } else {
        this.originalCountryName = countryName;
      }
    },
    validateForm: function validateForm() {
      this.errors = {};
      if (!this.mailingAddress.name || !this.mailingAddress.name.trim()) {
        this.errors.name = 'Name is required.';
      }
      if (!this.mailingAddress.line1 || !this.mailingAddress.line1.trim()) {
        this.errors.line1 = 'Address is required.';
      }
      if (!this.mailingAddress.city || !this.mailingAddress.city.trim()) {
        this.errors.city = 'City is required.';
      }
      if (this.isUS() && (!this.mailingAddress.state || !this.mailingAddress.state.StateID)) {
        this.errors.state = 'State is required.';
      }
      if (!this.mailingAddress.zip || !this.mailingAddress.zip.trim()) {
        this.errors.zip = 'Zip Code is required.';
      }
      var isValid = Object.keys(this.errors).length === 0;
      return isValid;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "JTeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar-right',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],
  props: {
    mobile: Boolean
  },
  data: function data() {
    return {
      isDropdownOpened: false,
      isProfileDropdownOpened: false
    };
  },
  computed: {
    navClasses: function navClasses() {
      return this.mobile ? ['nav-mobile-menu'] : ['navbar-nav', 'navbar-right'];
    },
    checkLogin: function checkLogin() {
      return this.$store.state.isLoggedIn;
    }
  },
  methods: {
    logout: function logout() {
      this.closeProfileDropdown();
      this.$user.logout();
    },
    openDropdown: function openDropdown() {
      this.isDropdownOpened = !this.isDropdownOpened;
    },
    closeDropdown: function closeDropdown() {
      if (this.isDropdownOpened) {
        this.isDropdownOpened = false;
      }
    },
    openProfileDropdown: function openProfileDropdown() {
      this.isProfileDropdownOpened = !this.isProfileDropdownOpened;
    },
    closeProfileDropdown: function closeProfileDropdown() {
      if (this.isProfileDropdownOpened) {
        this.isProfileDropdownOpened = false;
      }
    }
  }
});

/***/ }),

/***/ "JTu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String
  },
  computed: {
    today: function today() {
      return global.moment(new Date()).format(global.app.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "JWhq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("OfG2");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa61f40a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("w3aj");
function injectStyle (ssrContext) {
  __webpack_require__("SmCn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa61f40a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa61f40a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JaKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Grid_cells_actions__ = __webpack_require__("ayPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_line_item__ = __webpack_require__("XqGA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_itemDetails__ = __webpack_require__("JJzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventsSection_EventsSection_js__ = __webpack_require__("kXYG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialogs_LineItem_AddLineItem_vue__ = __webpack_require__("WVzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dialogs_LineItem_AddFeesDiscountItem_vue__ = __webpack_require__("Ptug");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dialogs_LineItem_AllocateToCC_vue__ = __webpack_require__("mITd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs_LineItem_AllocateToBUCCPair_vue__ = __webpack_require__("Oq/g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dialogs_LineItem_LineItemStore_js__ = __webpack_require__("PJql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__core_events_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("7+uW");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */














var eventHub = new __WEBPACK_IMPORTED_MODULE_14_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_2__components_Grid__["a" /* default */]
  },
  props: {
    model: Object,
    dependencies: Object,
    events: Object,
    programId: Number,
    invoiceId: Number,
    settings: Object,
    isP2PInvoice: Boolean,
    buyerVendorId: Number,
    useSavingsFields: Boolean,
    invoiceSettings: Object,
    decouplingSettings: Object,
    qtyAndUnitsOnPO: [Object, Array]
  },
  computed: {
    customItemsLabel: function customItemsLabel() {
      return 'Add Fees/Discount';
    },
    isP2PInvoiceWithEditItem: function isP2PInvoiceWithEditItem() {
      return this.isP2PInvoice && this.settings.AllowEditItem;
    },
    currency: function currency() {
      return this.model.PO.currency.code;
    },
    currencyObj: function currencyObj() {
      return this.model.PO.currency;
    },
    itemsActions: function itemsActions() {
      return [__WEBPACK_IMPORTED_MODULE_3__components_Grid_cells_actions__["d" /* expand */], __WEBPACK_IMPORTED_MODULE_3__components_Grid_cells_actions__["c" /* edit */], __WEBPACK_IMPORTED_MODULE_3__components_Grid_cells_actions__["a" /* clone */], __WEBPACK_IMPORTED_MODULE_3__components_Grid_cells_actions__["g" /* remove */]];
    },
    useBUorCCorPair: function useBUorCCorPair() {
      return this.settings && (this.settings.HasBusinessUnit || this.settings.HasCostCenter || this.settings.UseBusinessUnitAndCostCenterMapping);
    },
    gridModel: function gridModel() {
      return __WEBPACK_IMPORTED_MODULE_4__models_line_item__["a" /* default */].get(this.programCategories, this.useSavingsFields, this.isP2PInvoice, this.settings, this.model.PO.currency.code);
    },
    gridKey: function gridKey() {
      return this.programId + ' ' + +this.useSavingsFields + ' ' + this.model.PO.currency.code;
    }
  },
  data: function data() {
    return {
      LineItem: __WEBPACK_IMPORTED_MODULE_4__models_line_item__["a" /* default */],
      itemDetailsComponent: __WEBPACK_IMPORTED_MODULE_5__components_itemDetails__["a" /* default */],
      programCategories: [],
      itemModal: {
        display: false,
        categories: [],
        businssUnitAndCostCenters: [],
        units: []
      },
      doDisplayNoEventError: false,
      eventsSectionData: new __WEBPACK_IMPORTED_MODULE_6__EventsSection_EventsSection_js__["a" /* default */](this.dependencies),
      showCurrencyError: false,
      allocateToCostCenter: false,
      allocateToBUCCPair: false,
      selectedRows: [],
      savingsFields: ['unitPriceSGR', 'unitPricePreferredRate', 'unitPriceNegotiatedRate'],
      sameDayValidationError: 'Negative amounts are not allowed for ' + utils.constants.invoice.SameDayLabel.toLowerCase() + ' deposit invoices.',
      orderedItems: {},
      itemsHash: function itemsHash(items) {
        return items.map(function (item) {
          return item.itemKey + item.totalWithTaxesAndFees || '';
        }).join('');
      }
    };
  },
  methods: {
    store: function store() {
      return new __WEBPACK_IMPORTED_MODULE_11__dialogs_LineItem_LineItemStore_js__["a" /* default */](this.api);
    },
    hasMoreThanOneEvent: function hasMoreThanOneEvent() {
      return this.model.PO.events && this.model.PO.events.length > 1;
    },
    getGridTotal: function getGridTotal(_event) {
      return this.isP2PInvoice && _event && this.hasMoreThanOneEvent() ? _event.total : this.model.PO.total;
    },
    getGridTitle: function getGridTitle(_event) {
      return 'Line Items' + (this.isP2PInvoice && _event && this.hasMoreThanOneEvent() ? ' for ' + _event.name : '');
    },
    reorderItemsInList: function reorderItemsInList(listOrderChangeDetails, event) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var sourceLineItem, targetLineItem, i, j;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              sourceLineItem = event.lineItems.filter(function (x) {
                return +x.listOrder - 1 === listOrderChangeDetails.from;
              })[0];
              targetLineItem = event.lineItems.filter(function (x) {
                return +x.listOrder - 1 === listOrderChangeDetails.to;
              })[0];
              if (sourceLineItem && targetLineItem) {
                sourceLineItem.listOrder = +targetLineItem.listOrder;
              }

              // move item up in the grid
              if (listOrderChangeDetails.from > listOrderChangeDetails.to) {
                for (i = listOrderChangeDetails.from; i > listOrderChangeDetails.to; i--) {
                  event.lineItems[i] = event.lineItems[i - 1];
                  event.lineItems[i].listOrder = +event.lineItems[i].listOrder + 1;
                }
                event.lineItems[listOrderChangeDetails.to] = sourceLineItem;
              }
              // move item down in the grid
              if (listOrderChangeDetails.from < listOrderChangeDetails.to) {
                for (j = listOrderChangeDetails.from; j < listOrderChangeDetails.to; j++) {
                  event.lineItems[j] = event.lineItems[j + 1];
                  event.lineItems[j].listOrder = +event.lineItems[j].listOrder - 1;
                }
                event.lineItems[listOrderChangeDetails.to] = sourceLineItem;
              }
              _context.next = 7;
              return _this.recalculatePo();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    checkIfCurrencyIsSelected: function checkIfCurrencyIsSelected(event, modalToOpen) {
      var canAddEditItem = this.model.PO.currencySelected || this.isP2PInvoiceWithEditItem;
      if (canAddEditItem) {
        if (modalToOpen === 'AddItem') {
          this.openLineItemDialog(event);
        }
        if (modalToOpen === 'AddFeesDiscount') {
          this.openFeeOrDiscountItemDialog(event);
        }
      } else {
        this.showCurrencyError = true;
      }
    },
    recalculatePo: function recalculatePo() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var previousPOTotalAmount;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              previousPOTotalAmount = +_this2.model.PO.total;
              _context2.next = 3;
              return _this2.eventsSectionData.recalculatePoAndReturnIt(_this2.model.PO, _this2.settings, _this2.isP2PInvoiceWithEditItem);
            case 3:
              _this2.model.PO = _context2.sent;
              _this2.model.PO.events = _this2.store().getEventsWithOrderedLineItems(_this2.model.PO.events);
              __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_13__core_events_events___default.a.I2P.UPDATE_SNAPSHOT, {
                total: +_this2.model.PO.total,
                totalVATGST: _this2.getTotalVATGST(),
                programCurrencyCode: _this2.model.PO.programDetails.currencyCode
              });
              if (_this2.settings.EditingInvoiceScan) {
                __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_13__core_events_events___default.a.I2P.UPDATE_INVOICE_SCAN_SNAPSHOT, {
                  total: +_this2.model.PO.total,
                  invoiceCurrencyCode: _this2.currencyObj.code
                });
              }
              if (_this2.isP2PInvoiceWithEditItem) {
                __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_13__core_events_events___default.a.I2P.PO_AMOUNT_CHANGED, {
                  total: +_this2.model.PO.total,
                  previousTotal: previousPOTotalAmount
                });
              }
              _this2.updateLineItemGrids();
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getTotalVATGST: function getTotalVATGST() {
      var _this3 = this;
      var totalVATGST = 0;
      this.model.PO.events.map(function (ev) {
        totalVATGST += +_this3.model.PO.events[0].vat + +_this3.model.PO.events[0].gst;
      });
      return totalVATGST;
    },
    openEditItem: function openEditItem(item, event) {
      if (item.data.isFeeDiscountItem) {
        this.openFeeOrDiscountItemDialog(event, item.data);
      } else {
        this.selectedLineItem = item.data;
        this.itemModal.editMode = true;
        this.openLineItemDialog(event, item.data);
      }
    },
    refresh: function refresh(item, success, fail, done) {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.updateFeesPerItem(item);
              _this4.validateItem(item);
              if (!_this4.useSavingsFields) {
                _context3.next = 7;
                break;
              }
              _context3.next = 5;
              return _this4.store().computeSavingsItemTotal(item.data, _this4.currencyObj).then(function (response) {
                _this4.afterComputeTotals(item.data, response);
              });
            case 5:
              _context3.next = 9;
              break;
            case 7:
              _context3.next = 9;
              return _this4.store().computeItemTotal(item.data, _this4.currencyObj).then(function (response) {
                _this4.afterComputeTotals(item.data, response);
              });
            case 9:
              _context3.next = 11;
              return _this4.recalculatePo();
            case 11:
              done();
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    afterComputeTotals: function afterComputeTotals(itemData, response) {
      var newItem = this.store().populateTotalsOnItem(itemData, response.data.lineItem, this.decouplingSettings);

      // TBD: currently only for i2p invoices the line items can be changed inline in the table
      this.model.PO.events[0].lineItems.map(function (item) {
        if (Number(item.listOrder) === Number(newItem.listOrder)) {
          item = newItem;
        }
        return item;
      });
    },
    validateItem: function validateItem(item) {
      if (item.data.entireRowInvalid) {
        item.data._invalid = 'true';
      }
      if (!item.data.name || item.data.name.trim() === '') {
        item.data._invalid = 'true';
      } else {
        item.data._invalid = '';
      }
      if (Number(item.data.unitPrice) === 0) {
        item.data._invalid = 'true';
      } else {
        item.data._invalid = '';
      }
    },
    updateFeesPerItem: function updateFeesPerItem(item) {
      if (item.columnId === 'quantity') {
        if (item.data.quantity !== item.oldValue) {
          item.data.fees.map(function (fee) {
            if (parseInt(fee.valuePerItem) !== 0) {
              fee.value = item.data.quantity * fee.valuePerItem;
            }
          });
        }
      }
    },
    validateRemoveMany: function validateRemoveMany(payload) {
      // Item Type ID - Fee: 2, Discount: 3
      var hasFee = this.hasAutoGeneratedItemsByType(payload, 2);
      var hasDiscount = this.hasAutoGeneratedItemsByType(payload, 3);
      if (hasFee && !hasDiscount) {
        return 'The Payment Processing Fee cannot be deleted.';
      } else if (hasDiscount && !hasFee) {
        return 'The Early Payment Discount cannot be deleted.';
      } else if (hasFee && hasDiscount) {
        return 'These items cannot be deleted.';
      } else if (this.isP2PInvoiceWithEditItem && !this.hasOnlyTaxes(payload)) {
        return 'Only fees/taxes can be deleted.';
      }
      return '';
    },
    validateCloneMany: function validateCloneMany(payload) {
      // Item Type ID - Fee: 2, Discount: 3
      var hasFee = this.hasAutoGeneratedItemsByType(payload, 2);
      var hasDiscount = this.hasAutoGeneratedItemsByType(payload, 3);
      if (hasFee && !hasDiscount) {
        return 'The Payment Processing Fee cannot be duplicated.';
      } else if (hasDiscount && !hasFee) {
        return 'The Early Payment Discount cannot be duplicated.';
      } else if (hasFee && hasDiscount) {
        return 'These items cannot be duplicated.';
      } else if (this.isP2PInvoiceWithEditItem && !this.hasOnlyTaxes(payload)) {
        return 'Only fees/taxes can be duplicated.';
      }
      return '';
    },
    hasOnlyTaxes: function hasOnlyTaxes(items) {
      // check if only taxes/fees were selected
      var valid = true;
      items.map(function (item) {
        if (parseInt(item.data.itemTypeId) !== 1) {
          valid = false;
        }
      });
      return valid;
    },
    hasAutoGeneratedItemsByType: function hasAutoGeneratedItemsByType(payload, itemTypeId) {
      var hasItems = false;
      payload.map(function (item) {
        if (item.data.isAutoGenerated && parseInt(item.data.itemTypeId) === itemTypeId) {
          hasItems = true;
        }
      });
      return hasItems;
    },
    getEventForDeletedItem: function getEventForDeletedItem(itemDeleted) {
      if (!itemDeleted) return null;
      var resultEvent = null;
      this.model.PO.events.map(function (ev) {
        if (ev.lineItems.indexOf(itemDeleted) > -1) {
          resultEvent = ev;
        }
      });
      return resultEvent;
    },
    removeRow: function removeRow(payload, success, fail) {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var poEvent;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this5.canDeletedOrDuplicateItem(+payload.index)) {
                _context4.next = 11;
                break;
              }
              poEvent = _this5.getEventForDeletedItem(payload.data);
              if (!(poEvent == null)) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              // reorder listOrder property
              _this5.decreaseListOrderAfterRemove(poEvent, +payload.index);

              // remove
              poEvent.lineItems.splice(+payload.index, 1);
              success();
              _context4.next = 9;
              return _this5.recalculatePo();
            case 9:
              _context4.next = 12;
              break;
            case 11:
              _this5.showWrongActionOnItemError('deleted');
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    removeRows: function removeRows(payload, success) {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5() {
        var itemsToDelete, poEvent, indexOfItemsToRemove;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              itemsToDelete = payload.rows.map(function (k) {
                return k.data;
              });
              poEvent = null; // reorder listOrder property
              indexOfItemsToRemove = [];
              if (itemsToDelete.length > 0) {
                poEvent = _this6.getEventForDeletedItem(itemsToDelete[0]);
                poEvent && poEvent.lineItems.map(function (item, index) {
                  if (itemsToDelete.indexOf(item) > -1 && !item.isAutoGenerated && /* taxes/fees generated from backend are not editable */
                  _this6.canDeletedOrDuplicateItem(index)) {
                    indexOfItemsToRemove.push(+item.listOrder);
                  }
                });
              }
              if (!(indexOfItemsToRemove.length > 0)) {
                _context5.next = 9;
                break;
              }
              // invers order
              indexOfItemsToRemove.sort(function (a, b) {
                return b - a;
              });
              indexOfItemsToRemove.map(function (idx) {
                _this6.decreaseListOrderAfterRemove(poEvent, idx);
              });
              _context5.next = 10;
              break;
            case 9:
              return _context5.abrupt("return");
            case 10:
              // remove the items
              _this6.model.PO.events.map(function (ev) {
                ev.lineItems = ev.lineItems.filter(function (item) {
                  return itemsToDelete.indexOf(item) <= -1;
                });
              });
              success();
              _context5.next = 14;
              return _this6.recalculatePo();
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    rowSelected: function rowSelected(event) {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee6() {
        var buCC, missingPairAndCC, isProcessingFeeItem, programHasPairs, programHasCC;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.selectedRows = event;
              if (event && event.length > 0 && event[0].data && event[0].data.costCenterAndBusinessUnit) {
                buCC = event[0].data.costCenterAndBusinessUnit;
                missingPairAndCC = !buCC.costCenterAndBusinessUnitKey && !buCC.costCenterAndBusinessUnitName && !buCC.costCenterNo && !buCC.costCenterName;
                isProcessingFeeItem = _this7.settings.UseOneCostCenterOrPair && !_this7.model.PO.allocateProcessingFeeToEveryCostCenter && event[0].data && event[0].data.isAutoGenerated && event[0].data.feeTypeId > 0;
                if (missingPairAndCC) {
                  if (_this7.settings) {
                    _this7.allocateToBUCCPair = _this7.settings.UseBusinessUnitAndCostCenterMapping && (!_this7.settings.UseOneCostCenterOrPair || isProcessingFeeItem);
                    _this7.allocateToCostCenter = !_this7.settings.UseBusinessUnitAndCostCenterMapping && _this7.settings.HasCostCenter && (!_this7.settings.UseOneCostCenterOrPair || isProcessingFeeItem);
                  }
                } else {
                  programHasPairs = buCC.costCenterAndBusinessUnitKey || buCC.costCenterAndBusinessUnitName;
                  programHasCC = buCC.costCenterNo || buCC.costCenterName;
                  _this7.allocateToBUCCPair = programHasPairs && _this7.settings && _this7.settings.UseBusinessUnitAndCostCenterMapping && (!_this7.settings.UseOneCostCenterOrPair || isProcessingFeeItem);
                  _this7.allocateToCostCenter = programHasCC && !_this7.allocateToBUCCPair && _this7.settings && _this7.settings.HasCostCenter && (!_this7.settings.UseOneCostCenterOrPair || isProcessingFeeItem);
                }
              }
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    cloneRow: function cloneRow(rowIdx, success, b) {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this8.clone(rowIdx);
              success();
              _context7.next = 4;
              return _this8.recalculatePo();
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    clone: function clone(rowIndex) {
      if (this.canDeletedOrDuplicateItem(rowIndex - 1)) {
        var maxListOrder = this.calculateMaxListOrder();
        var rowJsontoClone = utils.copy(this.model.PO.events[0].lineItems[rowIndex - 1]);
        rowJsontoClone.itemKey = undefined;
        rowJsontoClone.listOrder = Number(maxListOrder) + 1;
        rowJsontoClone._expanded = false;
        this.model.PO.events[0].lineItems.push(rowJsontoClone);
      } else {
        this.showWrongActionOnItemError('duplicated');
      }
    },
    calculateMaxListOrder: function calculateMaxListOrder() {
      var maxListOrder = -1;
      this.model.PO.events[0].lineItems.map(function (item) {
        if (Number(item.listOrder) > maxListOrder) {
          maxListOrder = Number(item.listOrder);
        }
        return item;
      });
      return maxListOrder;
    },
    canDeletedOrDuplicateItem: function canDeletedOrDuplicateItem(itemIndex) {
      var item = this.model.PO.events[0].lineItems[itemIndex];
      if (item && item.itemTypeId === null && this.isP2PInvoiceWithEditItem) {
        return false;
      }
      return true;
    },
    showWrongActionOnItemError: function showWrongActionOnItemError(action) {
      var msg = action === 'allocation' ? 'Allocation cannot be changed for Payment Processing Fee' : 'Only taxes can be ' + action;
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        timeout: 0,
        message: msg
      });
    },
    cloneRows: function cloneRows(payload, success, b) {
      var _this9 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              payload && payload.rows && payload.rows.length > 0 && payload.rows.map(function (item) {
                // taxes/fees generated from backend are not editable
                if (!item.data.isAutoGenerated) {
                  var rowIdx = Number(item.id);
                  _this9.clone(rowIdx + 1);
                }
                return item;
              });
              success();
              _context8.next = 4;
              return _this9.recalculatePo();
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    decreaseListOrderAfterRemove: function decreaseListOrderAfterRemove(poEvent, removedItemIndex) {
      poEvent && poEvent.lineItems.map(function (lineItem, index) {
        if (+lineItem.listOrder > +removedItemIndex) {
          lineItem.listOrder = +lineItem.listOrder - 1;
        }
        return lineItem;
      });
    },
    openFeeOrDiscountItemDialog: function openFeeOrDiscountItemDialog(event, draftItem) {
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_14_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_8__dialogs_LineItem_AddFeesDiscountItem_vue__["a" /* default */]);
      var itemModal = {
        programId: +this.programId,
        invoiceId: +this.invoiceId,
        currency: this.currencyObj
      };
      if (draftItem) {
        this.itemModal.editMode = true;
        itemModal.draftItem = JSON.parse(JSON.stringify(draftItem));
        itemModal.draftItem.amountType = {
          amountType: null,
          text: null
        };
      } else {
        this.itemModal.editMode = false;
      }
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: itemModal,
          dependencies: this.dependencies,
          eventHub: eventHub,
          eventId: event.uniqueId,
          programId: this.programId
        }
      });
      instance.$slots.default = [];
      instance.$mount();
      this.$refs.addLineItemDialogContainer.appendChild(instance.$el);
    },
    openLineItemDialog: function openLineItemDialog(event, draftItem) {
      if (draftItem) {
        this.itemModal.editMode = true;
      } else {
        this.itemModal.editMode = false;
      }
      var itemModal = {
        programUniqueId: this.model.PO.programDetails.uniqueId,
        taxes: this.model.taxes ? JSON.parse(JSON.stringify(this.model.taxes)) : '',
        fees: this.model.fees ? JSON.parse(JSON.stringify(this.model.fees)) : '',
        totalWithTaxesAndFees: 0,
        categories: '',
        currency: this.currencyObj,
        useSupplementalPrecision: this.settings.CurrenciesWithSupplementalPrecision.indexOf(this.currencyObj.code) !== -1,
        unitPrice: '',
        quantity: '',
        units: this.model.units ? JSON.parse(JSON.stringify(this.model.fees)) : '',
        poUniqueId: this.itemModal.editMode ? this.model.PO.uniqueId : 'PO',
        programId: this.programId,
        invoiceId: this.invoiceId,
        supplierVci: this.model.PO.supplier.vci,
        supplierCountry: this.model.PO.supplier.address.country,
        vatGstPercentagesPerCountry: this.settings.VatGstPercentagesPerCountry,
        events: this.model.PO.events,
        buyerVendorId: this.buyerVendorId,
        useSavingsFields: this.useSavingsFields && !this.isP2PInvoiceWithEditItem,
        IsRequiredCategRefID: this.settings.IsRequiredCategRefID,
        canEditOnlyPrice: this.isP2PInvoiceWithEditItem,
        checkQuantitiesAgainstPO: this.isP2PInvoiceWithEditItem && !this.settings.AllowInvoiceToExceedPOQty
      };
      if (draftItem) {
        itemModal.draftItem = JSON.parse(JSON.stringify(draftItem));
        if (this.isP2PInvoiceWithEditItem && this.decouplingSettings) {
          var poPricingPerItem = this.decouplingSettings.filter(function (itm) {
            return itm.itemId === itemModal.draftItem.itemKey;
          });
          if (poPricingPerItem) {
            poPricingPerItem = poPricingPerItem[0];
            itemModal.maxThreshold = {
              quantity: poPricingPerItem.poQuantity,
              units: poPricingPerItem.poUnits,
              unitPrice: draftItem.maxUnitPrice,
              totalAmount: draftItem.maxTotalAmount,
              excludeTaxes: poPricingPerItem.excludeTaxes
            };
          }
        }
      }
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_14_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_7__dialogs_LineItem_AddLineItem_vue__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: itemModal,
          dependencies: this.dependencies,
          eventHub: eventHub,
          eventId: event.uniqueId
        }
      });
      instance.$slots.default = [];
      instance.$mount();
      this.$refs.addLineItemDialogContainer.appendChild(instance.$el);
    },
    canAllocateBuAndCc: function canAllocateBuAndCc() {
      var canAllocate = true;
      if (this.model.PO.allocateProcessingFeeToEveryCostCenter) {
        this.selectedRows.map(function (itm) {
          if (itm.data.isAutoGenerated && +itm.data.itemTypeId === 2 /* fee */) {
            canAllocate = false;
          }
        });
      }
      return canAllocate;
    },
    openAllocateToCostCenterDialog: function openAllocateToCostCenterDialog(event) {
      // validate
      var canAllocate = this.canAllocateBuAndCc();
      if (canAllocate) {
        var itemModal = {
          programId: this.programId,
          selectedRows: this.selectedRows
        };
        var ComponentClass = __WEBPACK_IMPORTED_MODULE_14_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_9__dialogs_LineItem_AllocateToCC_vue__["a" /* default */]);
        var instance = new ComponentClass({
          propsData: {
            type: 'primary',
            model: itemModal,
            dependencies: this.dependencies,
            eventHub: eventHub,
            eventUniqueId: event.uniqueId
          }
        });
        instance.$slots.default = [];
        instance.$mount();
        this.$refs.addLineItemDialogContainer.appendChild(instance.$el);
      } else {
        this.showWrongActionOnItemError('allocation');
      }
    },
    openAllocateToBUCCPairDialog: function openAllocateToBUCCPairDialog(event) {
      // validate
      var canAllocate = this.canAllocateBuAndCc();
      if (canAllocate) {
        var itemModal = {
          programId: this.programId,
          selectedRows: this.selectedRows
        };
        var ComponentClass = __WEBPACK_IMPORTED_MODULE_14_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_10__dialogs_LineItem_AllocateToBUCCPair_vue__["a" /* default */]);
        var instance = new ComponentClass({
          propsData: {
            type: 'primary',
            model: itemModal,
            dependencies: this.dependencies,
            eventHub: eventHub,
            eventUniqueId: event.uniqueId
          }
        });
        instance.$slots.default = [];
        instance.$mount();
        this.$refs.addLineItemDialogContainer.appendChild(instance.$el);
      } else {
        this.showWrongActionOnItemError('allocation');
      }
    },
    getEventByUniqueId: function getEventByUniqueId(uniqueId) {
      return this.model.PO.events.filter(function (ev) {
        return ev.uniqueId === uniqueId;
      })[0];
    },
    onSaveLineItem: function onSaveLineItem(item) {
      var _this10 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee9() {
        var poEvent, selectedLineItem, _selectedLineItem;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              item = item && item.data;
              if (_this10.itemModal.editMode === false) {
                poEvent = _this10.getEventByUniqueId(item.eventUniqueId);
                selectedLineItem = {};
                selectedLineItem.listOrder = poEvent.lineItems.length + 1;
                selectedLineItem.isFeeDiscountItem = false;
                selectedLineItem = _this10.eventsSectionData.mapLineItemPropertiesFromSourceToTargetForCreate(selectedLineItem, item.data);
                poEvent.lineItems.push(selectedLineItem);
              } else {
                _selectedLineItem = _this10.selectedLineItem;
                _this10.eventsSectionData.mapLineItemPropertiesFromSourceToTargetForEdit(_selectedLineItem, item.data);
                _this10.selectedLineItem._pending = true;
                _this10.selectedLineItem._loading = true;
                _this10.updateLineItemGrids();
              }
              _context9.next = 4;
              return _this10.recalculatePo();
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    onSaveAllocateToCC: function onSaveAllocateToCC(p) {
      var _this11 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee10() {
        var costCenterSelected, itemsIndexToUpdate, poEvent;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              p = p && p.data;
              costCenterSelected = p.data.costCenter;
              itemsIndexToUpdate = p.data.itemsToUpdate;
              poEvent = _this11.getEventByUniqueId(p.data.eventUniqueId);
              poEvent && itemsIndexToUpdate && itemsIndexToUpdate.map(function (idx) {
                var lineItem = poEvent.lineItems[idx];
                if (lineItem) {
                  lineItem.costCenterAndBusinessUnit.costCenterNo = costCenterSelected.code;
                  lineItem.costCenterAndBusinessUnit.costCenterName = costCenterSelected.name;
                  lineItem.costCenterAndBusinessUnit.costCenterId = +costCenterSelected.costCenterId;
                }
                return 0;
              });
              _context10.next = 7;
              return _this11.recalculatePo();
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    onSaveAllocateToBUCCPair: function onSaveAllocateToBUCCPair(p) {
      var _this12 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee11() {
        var buCCPairSelected, itemsIndexToUpdate, poEvent;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              p = p && p.data;
              buCCPairSelected = p.data.buCCPair;
              itemsIndexToUpdate = p.data.itemsToUpdate;
              poEvent = _this12.getEventByUniqueId(p.data.eventUniqueId);
              poEvent && itemsIndexToUpdate && itemsIndexToUpdate.map(function (index) {
                var lineItem = poEvent.lineItems[index];
                if (lineItem) {
                  if (lineItem.pairedBusinessUnitAndCostCenter) {
                    lineItem.pairedBusinessUnitAndCostCenter.key = buCCPairSelected.key;
                    lineItem.pairedBusinessUnitAndCostCenter.name = buCCPairSelected.name;
                    lineItem.pairedBusinessUnitAndCostCenter.businessUnitId = +buCCPairSelected.businessUnitId;
                    lineItem.pairedBusinessUnitAndCostCenter.costCenterId = +buCCPairSelected.costCenterId;
                    lineItem.pairedBusinessUnitAndCostCenter.programBusinessUnitAndCostCenterId = +buCCPairSelected.programBusinessUnitAndCostCenterId;
                  }
                  if (lineItem.costCenterAndBusinessUnit) {
                    lineItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey = buCCPairSelected.key;
                    lineItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName = buCCPairSelected.name;
                    lineItem.costCenterAndBusinessUnit.businessUnitId = +buCCPairSelected.businessUnitId;
                    lineItem.costCenterAndBusinessUnit.costCenterId = +buCCPairSelected.costCenterId;
                    lineItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = +buCCPairSelected.programBusinessUnitAndCostCenterId;
                  }
                  lineItem.useBusinessUnitAndCostCenterMapping = true;
                }
                return 0;
              });
              _context11.next = 7;
              return _this12.recalculatePo();
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    onSaveFeeOrDiscountItem: function onSaveFeeOrDiscountItem(item) {
      var _this13 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee12() {
        var event, selectedItem;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              item = item && item.data;
              event = _this13.model.PO.events.filter(function (x) {
                return x.uniqueId === item.eventId;
              })[0];
              selectedItem = {};
              if (!_this13.itemModal.editMode) {
                selectedItem.listOrder = event.lineItems.length + 1;
                event.lineItems.push(selectedItem);
              } else {
                selectedItem = event.lineItems.filter(function (x) {
                  return +x.listOrder === +item.data.listOrder;
                })[0];
              }
              selectedItem = _this13.eventsSectionData.getLineItemListElementFromFeeDiscount(selectedItem, item.data);
              selectedItem._disabled = true;
              _this13.recalculatePo();
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    onCloseAddLineItem: function onCloseAddLineItem() {
      //
    },
    onCloseAddFeeOrDiscountItem: function onCloseAddFeeOrDiscountItem() {
      //
    },
    updateLineItemGrids: function updateLineItemGrids() {
      if (this.$refs.lineItems) {
        for (var i = 0; i < this.$refs.lineItems.length; i++) {
          this.$refs.lineItems[i].updateRowData();
          this.$refs.lineItems[i].onSelectAll(false);
        }
      }
    }
  },
  created: function created() {
    var _this14 = this;
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            _this14.store().getLineItemLists(_this14.programId, _this14.invoiceId).then(function (response) {
              response && response.data && response.data.categories.map(function (item) {
                return _this14.programCategories.push(item);
              });
            });
            if (_this14.model.PO && (_this14.model.PO.events[0] && _this14.model.PO.events[0].lineItems && _this14.model.PO.events[0].lineItems.length > 0 || _this14.invoiceSettings.IsScanning && _this14.settings.EditingInvoiceScan)) {
              _this14.model.PO.currencySelected = true;
              _this14.showCurrencyError = false;
            }

            /* NOT USED
            EventBus.$off('onCloseAddLineItem')
            EventBus.$on('onCloseAddLineItem', this.onCloseAddLineItem)
             EventBus.$off('onCloseAddFeeOrDiscountItem')
            EventBus.$on('onCloseAddFeeOrDiscountItem', this.onCloseAddFeeOrDiscountItem) */

            __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off('onSaveLineItem');
            __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$on('onSaveLineItem', _this14.onSaveLineItem);
            __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off('onSaveAllocateToCC');
            __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$on('onSaveAllocateToCC', _this14.onSaveAllocateToCC);
            __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off('onSaveAllocateToBUCCPair');
            __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$on('onSaveAllocateToBUCCPair', _this14.onSaveAllocateToBUCCPair);
            __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off('onSaveFeeOrDiscountItem');
            __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$on('onSaveFeeOrDiscountItem', _this14.onSaveFeeOrDiscountItem);
            __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_13__core_events_events___default.a.I2P.RECALCULATE_PO);
            __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_13__core_events_events___default.a.I2P.RECALCULATE_PO, _this14.recalculatePo);
            _context13.next = 14;
            return _this14.recalculatePo();
          case 14:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off('onCloseAddLineItem');
    __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off('onSaveLineItem');
    __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off('onCloseAddFeeOrDiscountItem');
    __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off('onSaveFeeOrDiscountItem');
    __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off('onSaveAllocateToBUCCPair');
    __WEBPACK_IMPORTED_MODULE_12__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_13__core_events_events___default.a.I2P.RECALCULATE_PO);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "Jd1Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectOptions_vue__ = __webpack_require__("TRth");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d0eeae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_selectOptions_vue__ = __webpack_require__("0eis");
function injectStyle (ssrContext) {
  __webpack_require__("2y1t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d0eeae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_selectOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JdvM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      closeObj: {},
      selectedTransaction: '',
      transactions: [],
      showAddTransaction: false,
      fullTransactionObject: {}
    };
  },
  props: {
    selectedRows: Array,
    selectedProgram: Object,
    envelopeId: String,
    // PRODUCTDEV-8800: lower case, e.g. "expense report".
    envelopeTerm: {
      type: String,
      default: 'envelope'
    }
  },
  created: function created() {},
  methods: {
    getTransactions: function getTransactions() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, existingTransactionIds;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.api.forms.post(_this.api.$.evedpaycard.transactions, {
                sort: 'TransactionDate',
                dir: 'DESC',
                start: 0,
                limit: 100,
                isLiveGrid: true,
                filter: JSON.stringify({
                  'CardId': _this.selectedRows[0].data.CardId,
                  'ProgramId': _this.selectedProgram && Object.keys(_this.selectedProgram).length !== 0 ? _this.selectedProgram.Id : '',
                  'Screen': 'AddTransaction',
                  'TransactionEnvelopeId': _this.envelopeId,
                  searchTerm: ''
                })
              });
            case 3:
              response = _context.sent;
              if (response && response.data && response.data.Data) {
                existingTransactionIds = _this.selectedRows.map(function (row) {
                  return row.data.Id;
                });
                _this.transactions = response.data.Data.filter(function (transaction) {
                  return !existingTransactionIds.includes(transaction.Id);
                }).map(function (transaction) {
                  return {
                    value: transaction.Id,
                    label: "".concat(transaction.Merchant, " - ").concat(_this.formatDate(transaction.TransactionDate), " - ").concat(transaction.FormattedAmount),
                    transactionData: {
                      data: transaction
                    }
                  };
                });
                _this.resetModal();
              }
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error('Error while retrieving transactions:', _context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    showModal: function showModal(showAddTransaction) {
      this.showAddTransaction = !showAddTransaction;
      this.resetModal();
      if (this.showAddTransaction) {
        this.getTransactions();
      }
    },
    formatDate: function formatDate(dateString) {
      var dateInMilliseconds = parseInt(dateString.match(/\d+/)[0]);
      var formattedDate = new Date(dateInMilliseconds);
      var month = (formattedDate.getMonth() + 1).toString().padStart(2, '0');
      var day = formattedDate.getDate().toString().padStart(2, '0');
      var year = formattedDate.getFullYear();
      return "".concat(month, "/").concat(day, "/").concat(year);
    },
    handleTransactionChange: function handleTransactionChange() {
      this.fullTransactionObject = this.selectedTransaction && this.selectedTransaction.transactionData;
    },
    resetModal: function resetModal() {
      this.fullTransactionObject = {};
      this.selectedTransaction = '';
    }
  }
});

/***/ }),

/***/ "Jepp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chartist__ = __webpack_require__("715g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chartist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transform__ = __webpack_require__("HrSB");


/* harmony default export */ __webpack_exports__["a"] = ({
  Chartist: __WEBPACK_IMPORTED_MODULE_0_chartist___default.a,
  install: function install(Vue) {
    /** Chartist setip */
    Object.defineProperty(Vue.prototype, '$Chartist', {
      get: function get() {
        this.$root.Chartist.utils = {
          transform: __WEBPACK_IMPORTED_MODULE_1__transform__["a" /* transform */]
        };
        return this.$root.Chartist;
      }
    });
  }
});

/***/ }),

/***/ "JfIr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2DG1DAinDDZqWTNmY2Ew-_","Dell":"_2OOI7gc-h5DRWo0krzah0O","Abbott":"svYApCdZK5fFqm-jWTIU1","Gap":"_2uZ3IsoBc2o-lQSa5d4iI0","Allstate":"_1KOqhbyRx9kgkuGgXKFLUm","Asurion":"Izi8ce3L8wftmbgEd7ka0","Invitae":"UuuC6890vlO5h1f4PiRlL","JWE":"_1k0Yra1HMIBK_9OfnwdtOM"};

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jpw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__("NM/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__("naW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__option_type__ = __webpack_require__("Ga5e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__option_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__option_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_type__ = __webpack_require__("40N4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__context_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__team_tab_type__ = __webpack_require__("/C9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__team_tab_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__team_tab_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__condition_type__ = __webpack_require__("hPWI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__condition_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__condition_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__operator_type__ = __webpack_require__("bA1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__operator_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__operator_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__option_rules__ = __webpack_require__("1P/l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__option_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__option_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__core_events_events__);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var approvalRuleUtils = __webpack_require__("IJVW");
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    conditions: Object,
    label: String,
    rule: Object,
    conditionOptions: Object,
    existingOperator: String
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_8__event_bus__["b" /* EventBus */].$on('rootOptionChanged', function (limitation) {
      _this.setIfSelectionLimitations();
    });
    this.processConditions();
    __WEBPACK_IMPORTED_MODULE_8__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_9__core_events_events___default.a.APPROVAL_RULE.VALIDATE_COMPONENTS, this.validateRule);
  },
  // solution from this link does not work
  // https://stackoverflow.com/questions/45399302/stop-receiving-events-from-destroyed-child-component
  beforeDestroy: function beforeDestroy() {
    this.componentDestroyed = true;
  },
  computed: {
    conditionOperators: function conditionOperators() {
      return this.conditionOptions.Operators ? this.conditionOptions.Operators : [];
    },
    conditionAdditionalOperators: function conditionAdditionalOperators() {
      return this.conditionOptions.AdditionalOperators ? this.conditionOptions.AdditionalOperators : [];
    },
    discountsConditions: function discountsConditions() {
      return ['Overridden'];
    },
    preCommitConditions: function preCommitConditions() {
      return ['Pre-Commit'];
    },
    supplierLocationConditions: function supplierLocationConditions() {
      return ['Domestic', 'Foreign'];
    },
    supplierOrganizationTypeConditions: function supplierOrganizationTypeConditions() {
      return ['Company', 'Individual'];
    },
    operatorModel: function operatorModel() {
      if (this.rule && this.rule.Operator) {
        return this.rule.Operator === 'And' ? this.operators[0] : this.operators[1];
      }
    },
    programLabel: function programLabel() {
      return global.app.$user.sessionSettings.CompanySettings.ProgramLabel;
    },
    // PRODUCTDEV-8800: client term for "Envelope", from GetUserSettings
    envelopeTerm: function envelopeTerm() {
      var settings = global.app.$user.sessionSettings.CompanySettings || {};
      var term = settings.Labels && settings.Labels.EnvelopeTerm || settings.EnvelopeTerm;
      return typeof term === 'string' && term ? term : 'Envelope';
    }
  },
  data: function data() {
    var _this2 = this;
    return {
      processedConditions: [],
      operators: ['All child conditions below are true (AND)', 'Any child conditions below are true (OR)'],
      list: utils.collection.list,
      max: utils.collection.max,
      condOptions: [],
      showDeleteModal: false,
      deleteTarget: null,
      contextType: __WEBPACK_IMPORTED_MODULE_3__context_type___default.a,
      xsi: '@xsi:type',
      text: '#text',
      contextTypeMap: Object.keys(__WEBPACK_IMPORTED_MODULE_3__context_type___default.a),
      operatorTypeMap: Object.keys(__WEBPACK_IMPORTED_MODULE_6__operator_type___default.a),
      resultOptions: {},
      values: function values(condition) {
        var result = [];
        if (condition.Values) {
          var valuesList = condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue] && _this2.list(condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue]).length > 0 && _this2.list(condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue]).map(function (value) {
            var name = _this2.conditionTypeMap.filter(function (key) {
              return key === value.Value['#text'];
            })[0] ? __WEBPACK_IMPORTED_MODULE_5__condition_type___default.a[value.Value['#text']] : value.Value['#text'];
            value = {
              Name: _this2.formatEnvelopeLabel(name),
              SaveName: name,
              Id: parseInt(value.Id)
            };
            return value;
          }) || [];
          result.push({
            label: __WEBPACK_IMPORTED_MODULE_3__context_type___default.a[condition[_this2.xsi]],
            type: 'Result',
            options: valuesList
          });
        }
        if (condition.Roles) {
          var roles = condition.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role] && _this2.list(condition.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role]).filter(function (key) {
            return key.IsTeamTabRole === 'false' && key.IsUserTitle !== 'true';
          }).map(function (role) {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId)
            };
            return role;
          }) || [];
          var teamTabRoles = condition.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role] && _this2.list(condition.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role]).filter(function (key) {
            return key.IsTeamTabRole === 'true';
          }).map(function (role) {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId),
              Key: role.TeamTabRole
            };
            return role;
          }) || [];
          var usersTitles = condition.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role] && _this2.list(condition.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role]).filter(function (key) {
            return key.IsUserTitle === 'true';
          }).map(function (role) {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId)
            };
            return role;
          }) || [];
          result.push({
            label: __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['Roles'],
            type: 'Roles',
            options: roles
          });
          result.push({
            label: __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['TeamTabRoles'],
            type: 'TeamTabRoles',
            options: teamTabRoles
          });
          result.push({
            label: __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['UsersTitles'],
            type: 'UsersTitles',
            options: usersTitles
          });
        }
        if (condition.Users) {
          var users = condition.Users[__WEBPACK_IMPORTED_MODULE_1__type___default.a.user] && _this2.list(condition.Users[__WEBPACK_IMPORTED_MODULE_1__type___default.a.user]).map(function (user) {
            user = {
              Name: user.FirstName + ' ' + user.LastName,
              Id: parseInt(user.UserID)
            };
            return user;
          }) || [];
          result.push({
            label: __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['Users'],
            type: 'Users',
            options: users
          });
        }
        return result;
      },
      __selectedGlobalOptions: [],
      conditionTypeMap: Object.keys(__WEBPACK_IMPORTED_MODULE_5__condition_type___default.a),
      type: __WEBPACK_IMPORTED_MODULE_1__type___default.a,
      operatorType: __WEBPACK_IMPORTED_MODULE_6__operator_type___default.a,
      optionRules: __WEBPACK_IMPORTED_MODULE_7__option_rules___default.a,
      componentDestroyed: false
    };
  },
  methods: {
    validateRule: function validateRule() {
      var _this3 = this;
      if (!this.componentDestroyed) {
        var valid = true;

        // verify condition values
        if (this.conditions && this.conditions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.condition] && this.list(this.conditions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.condition]).length > 0) {
          var conditionsList = this.list(this.conditions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.condition]);
          conditionsList.map(function (condition) {
            // verify first 2 dropdowns on condition line
            if (!condition['@xsi:type'] || !condition.Operator) {
              valid = false;
            } else {
              // verify if any value is set on condition
              if (condition.Values && condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue] && _this3.list(condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue]).length > 0) {
                var valuesList = _this3.list(condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue]);
                valuesList.map(function (valueItem) {
                  if (!valueItem.Value || !valueItem.Value['#text']) {
                    valid = false;
                  }
                });
              } else {
                // verify if any role/user is set on condition
                var missingRoles = false;
                var missingUsers = false;
                if (!condition.Roles || condition.Roles && (!condition.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role] || _this3.list(condition.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role]).length === 0)) {
                  missingRoles = true;
                }
                // verify if any user is set on condition
                if (!condition.Users || condition.Users && (!condition.Users[__WEBPACK_IMPORTED_MODULE_1__type___default.a.user] || _this3.list(condition.Users[__WEBPACK_IMPORTED_MODULE_1__type___default.a.user]).length === 0)) {
                  missingUsers = true;
                }
                if (missingRoles && missingUsers) {
                  valid = false;
                }
              }
            }
            var payload = {
              Id: condition.Id,
              valid: valid
            };
            __WEBPACK_IMPORTED_MODULE_8__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_9__core_events_events___default.a.APPROVAL_RULE.VALIDATION_COMPLETED, payload);
          });
        }
        if (!valid) {
          this.invalidateConditionBlock();
        } else {
          this.resetConditionBlock();
        }
      }
    },
    invalidateConditionBlock: function invalidateConditionBlock() {
      if (this.$refs.conditionRow && this.$refs.conditionRow.classList) {
        this.$refs.conditionRow.classList.add('invalid');
      }
    },
    resetConditionBlock: function resetConditionBlock() {
      if (this.$refs.conditionRow && this.$refs.conditionRow.classList) {
        this.$refs.conditionRow.classList.remove('invalid');
      }
    },
    getContextLabel: function getContextLabel(option, label) {
      if (option[label] === 'Division') {
        return this.$user.$.settings['DivisionName'];
      } else if (option[label] === __WEBPACK_IMPORTED_MODULE_3__context_type___default.a['MeetingTypeConditionDTO']) {
        return global.app.$user.sessionSettings.CompanySettings.Labels.MeetingTypeLabel;
      }
      return option[label];
    },
    applyConditionContext: function applyConditionContext(condition, index) {
      var _this4 = this;
      // get context options
      var rootOp = this.conditionOptions && this.conditionOptions.RootOptions;
      var ops = this.conditionOptions && this.conditionOptions.Options;
      condition.__selectedOptions = [];
      condition.__selectedContextType = '';
      condition.__o = [{}];
      condition.__selectedOp = [];
      condition.conditionValues = [];
      // this.__selectedGlobalOptions = []
      // apply context options (root level)
      if (this.$parent && this.$parent.isRoot) {
        if (rootOp) {
          rootOp.map(function (o, index) {
            condition.conditionValues.push({
              label: _this4.$t(_this4.formatLabel(__WEBPACK_IMPORTED_MODULE_3__context_type___default.a[o])),
              values: o === condition['@xsi:type'] ? _this4.values(condition) : [{
                label: '',
                options: []
              }]
            });
            if (o === condition['@xsi:type']) {
              condition.__selectedContextType = condition.conditionValues[index];
              _this4.setThenSelectionLimitations(condition);
            }
          });
        }
        // apply context options
      } else {
        if (ops) {
          // limitate IF options based on what was selected on WHEN condition
          this.conditionOptions = this.limitateOptions(this.conditionOptions);
          this.conditionOptions.Options.map(function (o, index) {
            condition.conditionValues.push({
              label: _this4.$t(__WEBPACK_IMPORTED_MODULE_3__context_type___default.a[o]),
              values: o === condition['@xsi:type'] ? _this4.values(condition) : [{
                label: '',
                options: []
              }]
            });
            if (o === condition['@xsi:type']) {
              condition.__selectedContextType = condition.conditionValues[index];
            }
          });
        }
      }

      // set initial values
      // TODO: get default group
      this.markGroupOptions({
        data: '{"Roles": []}'
      }, condition, true);
      return condition;
    },
    limitateOptions: function limitateOptions(conditionOptions) {
      // get original options from $store
      this.conditionOptions.Options = utils.copy(this.$store.state.originalConditionOptions.options);
      var _iterator = _createForOfIteratorHelper(conditionOptions.Options.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_step.value, 2),
            i = _step$value[0],
            value = _step$value[1];
          if (!this.$store.state[__WEBPACK_IMPORTED_MODULE_7__option_rules___default.a.InvoiceSelected] && !this.$store.state[__WEBPACK_IMPORTED_MODULE_7__option_rules___default.a.PoSelected]) {
            if (value === __WEBPACK_IMPORTED_MODULE_1__type___default.a.evedPayStatus) {
              conditionOptions.Options.splice(i, 1);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return conditionOptions;
    },
    /*
     * 1. init condition model
     */
    processConditions: function processConditions() {
      var vm = this;
      this.__selectedGlobalOptions = [];
      // set conditon model
      this.processedConditions = this.list(utils.copy(this.conditions)[__WEBPACK_IMPORTED_MODULE_1__type___default.a.condition]).map(function (condition, index) {
        condition = vm.applyConditionContext(condition, index);
        return condition;
      });
    },
    /*
     * 2. fetch all options
     */
    getConditionOptions: function getConditionOptions(condition, e) {
      var vm = this;
      var endpoint = this.getEndpoint(condition);
      var payload = this.getPayload(condition);
      // call api
      endpoint && this.api.forms.post(endpoint, payload).then(function (r) {
        if (r && r.data) {
          vm.markGroupOptions(r, condition, false);
        }
      });
    },
    /*
     * 3. mark existing options
     */
    markGroupOptions: function markGroupOptions(r, condition, isInitiallySetting) {
      var _this5 = this;
      //
      var resultObj = JSON.parse(r.data);
      var selectedType = Object.keys(resultObj).length === 1 && !isInitiallySetting ? __WEBPACK_IMPORTED_MODULE_3__context_type___default.a[condition[this.xsi]] : null;
      selectedType = this.formatLabel(selectedType);
      var initialSelected = condition.__selectedContextType.values ? condition.__selectedContextType.values.map(flagSaved).reduce(function (selectedOptions, value) {
        return selectedOptions.concat(value);
      }, []) : [];
      var newCondition = [{
        label: '',
        values: [{
          label: '',
          options: []
        }]
      }];
      resultObj = resultObj.constructor === Array ? {
        Result: resultObj
      } : resultObj;
      Object.keys(resultObj).map(function (key, i) {
        var res = resultObj[key].map(function (k) {
          k.Uid = k.Id + '_' + key + '_' + condition.__selectedContextType.label;
          k.Type = key;
          k.SaveName = _this5.formatProgramLabel(k.Name);
          k.Name = _this5.formatEnvelopeLabel(k.SaveName);
          return k;
        });
        newCondition = condition.conditionValues.filter(function (v) {
          return v.label === selectedType || v.label === __WEBPACK_IMPORTED_MODULE_3__context_type___default.a[condition['@xsi:type']];
        })[0];
        condition.__selectedOptions = condition.__selectedOptions.length ? condition.__selectedOptions : initialSelected;
        if (isInitiallySetting) {
          condition.__selectedOp = utils.copy(condition.__selectedOptions);
        }
        condition.__selectedOptions.map(function (option) {
          if (_this5.__selectedGlobalOptions.filter(function (o) {
            return o.Uid === option.Uid;
          }).length === 0 && (isInitiallySetting ? true : condition.__selectedOp.filter(function (o) {
            return o.Uid === option.Uid;
          }).length !== 0)) {
            _this5.__selectedGlobalOptions.push(option);
          }
        });
        if (newCondition) {
          var useHierarchyApproval = _this5.$user.$.companySettings && _this5.$user.$.companySettings.UseHierarchyApproval;
          var validOption = !useHierarchyApproval && key !== 'UsersTitles' || useHierarchyApproval && (!_this5.$store.state[__WEBPACK_IMPORTED_MODULE_7__option_rules___default.a.ProgramBudgetSelected] && key !== 'UsersTitles' || _this5.$store.state[__WEBPACK_IMPORTED_MODULE_7__option_rules___default.a.ProgramBudgetSelected]);
          if (validOption) {
            if (newCondition.values[i]) {
              newCondition.values[i].label = selectedType || __WEBPACK_IMPORTED_MODULE_2__option_type___default.a[key];
              newCondition.values[i].options = res;
            } else {
              newCondition.values.push({
                label: selectedType || __WEBPACK_IMPORTED_MODULE_2__option_type___default.a[key],
                options: res
              });
            }
          }
        }
      });
      this.setThenSelectionLimitations(condition);
      newCondition && this.setOptions(condition, newCondition);
      function flagSaved(val) {
        return val.options.map(function (k) {
          k.Uid = k.Id + '_' + (selectedType !== null ? __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['Result'] : val.type) + '_' + condition.__selectedContextType.label;
          k.Type = selectedType !== null ? __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['Result'] : val.type;
          // k.Key = k.Key
          return k;
        });
      }
    },
    setThenSelectionLimitations: function setThenSelectionLimitations(condition) {
      if (this.$parent.isRoot) {
        // The Notify action should be available only if on the WHEN section I chose the PO
        this.$store.state[__WEBPACK_IMPORTED_MODULE_7__option_rules___default.a.PoSelected] = condition['@xsi:type'] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.po;

        // When selecting the Closed/Cancelled option for PO condition only the Notify action should appear
        var cancelledLimitation = false;
        var closedLimitation = false;
        condition.__selectedOptions.map(function (option) {
          if (option.Name === __WEBPACK_IMPORTED_MODULE_5__condition_type___default.a.Closed) {
            closedLimitation = true;
          }
          if (option.Name === __WEBPACK_IMPORTED_MODULE_5__condition_type___default.a.Cancelled) {
            cancelledLimitation = true;
          }
        });
        this.$store.state[__WEBPACK_IMPORTED_MODULE_7__option_rules___default.a.PoCancelledClosedSelected] = condition['@xsi:type'] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.po && cancelledLimitation && closedLimitation && condition.__selectedOptions.length === 2 || (cancelledLimitation && !closedLimitation || !cancelledLimitation && closedLimitation) && condition.__selectedOptions.length === 1;
        this.$store.state[__WEBPACK_IMPORTED_MODULE_7__option_rules___default.a.InvoiceSelected] = condition['@xsi:type'] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.invoice;
        this.$store.state[__WEBPACK_IMPORTED_MODULE_7__option_rules___default.a.ProgramBudgetSelected] = condition['@xsi:type'] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.programBudget;
      }
    },
    setIfSelectionLimitations: function setIfSelectionLimitations() {
      var _this6 = this;
      // The EvedPay Status option should be available
      // only if the PO/INVOICE option was selected on WHEN condition
      if (this.$store.state[__WEBPACK_IMPORTED_MODULE_7__option_rules___default.a.PoSelected] || this.$store.state[__WEBPACK_IMPORTED_MODULE_7__option_rules___default.a.InvoiceSelected]) {
        var alreadyContainsItem = false;
        this.processedConditions.map(function (condition) {
          condition.conditionValues.map(function (conditionValue) {
            if (conditionValue.label === _this6.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.evedPayStatus]) {
              alreadyContainsItem = true;
            }
          });
          if (!alreadyContainsItem && !_this6.$parent.isRoot) {
            condition.conditionValues.push({
              label: _this6.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.evedPayStatus],
              values: [{
                label: '',
                options: []
              }]
            });
          }
          return condition;
        });
      } else {
        // remove EvedPay Status option from IF condition context
        this.processedConditions.map(function (condition) {
          var _iterator2 = _createForOfIteratorHelper(condition.conditionValues.entries()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_step2.value, 2),
                i = _step2$value[0],
                value = _step2$value[1];
              if (value.label === _this6.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.evedPayStatus]) {
                condition.conditionValues.splice(i, 1);
                break;
              }
            }
            // if there are conditions with EvedPay Status option selected then reset them
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (condition.__selectedContextType.label === _this6.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.evedPayStatus]) {
            _this6.resetConditionLine(condition, {
              label: '',
              values: [{
                label: '',
                options: []
              }]
            });
          }

          // remove Discount Payment Terms
          var _iterator3 = _createForOfIteratorHelper(condition.conditionValues.entries()),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_step3.value, 2),
                _i = _step3$value[0],
                _value = _step3$value[1];
              if (_value.label === _this6.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.discountPaymentTerms]) {
                condition.conditionValues.splice(_i, 1);
                break;
              }
            }
            // if there are conditions with Discount Payment Terms option selected then reset them
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          if (condition.__selectedContextType.label === _this6.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.discountPaymentTerms]) {
            _this6.resetConditionLine(condition, {
              label: '',
              values: [{
                label: '',
                options: []
              }]
            });
          }

          // remove Pre-Commit
          var _iterator4 = _createForOfIteratorHelper(condition.conditionValues.entries()),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _step4$value = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_step4.value, 2),
                _i2 = _step4$value[0],
                _value2 = _step4$value[1];
              if (_value2.label === _this6.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.preCommit]) {
                condition.conditionValues.splice(_i2, 1);
                break;
              }
            }
            // if there are conditions with Pre-commit option selected then reset them
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          if (condition.__selectedContextType.label === _this6.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.preCommit]) {
            _this6.resetConditionLine(condition, {
              label: '',
              values: [{
                label: '',
                options: []
              }]
            });
          }
          if (condition.__selectedContextType.label === _this6.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.supplierLocation]) {
            _this6.resetConditionLine(condition, {
              label: '',
              values: [{
                label: '',
                options: []
              }]
            });
          }
          if (condition.__selectedContextType.label === _this6.contextType[__WEBPACK_IMPORTED_MODULE_1__type___default.a.supplierOrganizationType]) {
            _this6.resetConditionLine(condition, {
              label: '',
              values: [{
                label: '',
                options: []
              }]
            });
          }
          return condition;
        });
      }
    },
    //
    getEndpoint: function getEndpoint(condition) {
      var endpoint = '';
      switch (condition['@xsi:type']) {
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.po:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.invoice:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.expense:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.scope:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.evedPay:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.programBudget:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.evedPayStatus:
          endpoint = this.api.$.approval.getConditionOptions;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.division:
          endpoint = this.api.$.approval.getDivisions;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.businessUnit:
          endpoint = this.api.$.approval.getBusinessUnits;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.costCenter:
          endpoint = this.api.$.approval.getCostCenters;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.meetingType:
          endpoint = this.api.$.approval.getMeetingTypes;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.category:
          endpoint = this.api.$.approval.getCategories;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.itemOwner:
          endpoint = this.api.$.approval.getItemOwnerValues;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.programTeamMember:
          // TBD in the future
          break;
      }
      return endpoint;
    },
    getPayload: function getPayload(condition) {
      var payload = {};
      switch (condition['@xsi:type']) {
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.po:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.invoice:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.expense:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.scope:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.evedPay:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.programBudget:
        case __WEBPACK_IMPORTED_MODULE_1__type___default.a.evedPayStatus:
          payload = {
            type: condition['@xsi:type']
          };
          break;
      }
      return payload;
    },
    setDiscountsConditionOptions: function setDiscountsConditionOptions(condition, e) {
      this.enableSaveButton();
      condition.Users = null;
      condition.Roles = null;
      condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue] = [{
        Id: 0,
        Value: {
          '@xsi:type': 'xsd:string',
          '#text': e
        },
        'CurrencyId': '1',
        'CurrencyCode': 'USD'
      }];

      // this.rootOptionsChangedEvent(condition)

      var updatedCondition = utils.copy(condition);
      this.updateCondition(condition.Id, updatedCondition);
    },
    setPreCommitConditionOptions: function setPreCommitConditionOptions(condition, e) {
      this.enableSaveButton();
      condition.Users = null;
      condition.Roles = null;
      condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue] = [{
        Id: 0,
        Value: {
          '@xsi:type': 'xsd:string',
          '#text': e
        },
        'CurrencyId': '1',
        'CurrencyCode': 'USD'
      }];

      // this.rootOptionsChangedEvent(condition)

      var updatedCondition = utils.copy(condition);
      this.updateCondition(condition.Id, updatedCondition);
    },
    setSupplierLocationConditionOptions: function setSupplierLocationConditionOptions(condition, e) {
      this.enableSaveButton();
      condition.Users = null;
      condition.Roles = null;
      condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue] = [{
        Id: 0,
        Value: {
          '@xsi:type': 'xsd:string',
          '#text': e
        },
        'CurrencyId': '1',
        'CurrencyCode': 'USD'
      }];
      var updatedCondition = utils.copy(condition);
      this.updateCondition(condition.Id, updatedCondition);
    },
    setSupplierOrganizationTypeConditionOptions: function setSupplierOrganizationTypeConditionOptions(condition, e) {
      this.enableSaveButton();
      condition.Users = null;
      condition.Roles = null;
      condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue] = [{
        Id: 0,
        Value: {
          '@xsi:type': 'xsd:string',
          '#text': e
        },
        'CurrencyId': '1',
        'CurrencyCode': 'USD'
      }];
      var updatedCondition = utils.copy(condition);
      this.updateCondition(condition.Id, updatedCondition);
    },
    getTeamTabType: function getTeamTabType(searchKey) {
      var _this7 = this;
      var result = searchKey;
      Object.keys(__WEBPACK_IMPORTED_MODULE_4__team_tab_type___default.a).map(function (key) {
        var keyF = key.replace('[placeholder]', _this7.programLabel);
        if (keyF === searchKey) {
          result = __WEBPACK_IMPORTED_MODULE_4__team_tab_type___default.a[key];
        }
      });
      return result;
    },
    setConditionOptions: function setConditionOptions(condition, e) {
      var _this8 = this;
      this.enableSaveButton();
      var simpleList = [];
      var RolesList = [];
      var UsersList = [];
      condition.__selectedOptions.map(function (selectedOption) {
        if (_this8.__selectedGlobalOptions.filter(function (o) {
          return o.Uid === selectedOption.Uid;
        }).length === 0) {
          _this8.__selectedGlobalOptions.push(selectedOption);
        }
        _this8.processedConditions.map(function (processedCondition) {
          if (processedCondition.Id !== condition.Id) {
            processedCondition.__selectedOptions.map(function (option, index) {
              if (option.Uid === selectedOption.Uid) {
                processedCondition.__selectedOptions.splice(index, 1);
              }
              return option;
            });
            return processedCondition;
          }
        });
        switch (selectedOption.Type) {
          case __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['Roles']:
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: _this8.getTeamTabType(_this8.programLabel + ' Owner'),
              // Program Owner
              CustomTitleId: 0,
              Name: selectedOption.Name,
              IsTeamTabRole: 'false',
              IsUserTitle: 'false'
            });
            break;
          case 'TeamTabRoles':
            var teamTabText = '';
            if (selectedOption.Key === _this8.getTeamTabType('Meeting Requestor')) {
              teamTabText = _this8.getTeamTabType('Meeting Requestor');
            } else {
              if (selectedOption.Id >= 0) {
                teamTabText = _this8.getTeamTabType(selectedOption.Name);
              } else {
                teamTabText = _this8.getTeamTabType('Custom Title');
              }
            }
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: teamTabText,
              CustomTitleId: selectedOption.Id >= 0 ? selectedOption.Id : -1 * selectedOption.Id,
              Name: selectedOption.Name,
              IsTeamTabRole: 'true',
              IsUserTitle: 'false'
            });
            break;
          case __WEBPACK_IMPORTED_MODULE_2__option_type___default.a['Users']:
            UsersList.push({
              UserID: selectedOption.Id,
              RoleID: 0,
              FirstName: selectedOption.Name.split(' ')[0],
              LastName: selectedOption.Name.split(' ')[1]
            });
            break;
          case 'UsersTitles':
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: _this8.getTeamTabType(_this8.programLabel + ' Owner'),
              // Program Owner
              CustomTitleId: 0,
              Name: selectedOption.Name,
              IsTeamTabRole: 'false',
              IsUserTitle: 'true'
            });
            break;
          default:
            // PRODUCTDEV-8800: save the name without the envelope term
            var saveName = selectedOption.SaveName || selectedOption.Name;
            var text = _this8.conditionTypeMap.filter(function (key) {
              return __WEBPACK_IMPORTED_MODULE_5__condition_type___default.a[key] === saveName;
            })[0] ? _this8.conditionTypeMap.filter(function (key) {
              return __WEBPACK_IMPORTED_MODULE_5__condition_type___default.a[key] === saveName;
            })[0] : saveName;
            simpleList.push({
              Id: selectedOption.Id,
              Value: {
                '@xsi:type': 'xsd:string',
                '#text': text
              },
              'CurrencyId': '1',
              'CurrencyCode': 'USD'
            });
            break;
        }
      });
      if (condition.__selectedContextType.label !== __WEBPACK_IMPORTED_MODULE_3__context_type___default.a.ItemOwnerConditionDTO) {
        if (simpleList.length > 0) {
          if (!condition.Values) {
            condition.Values = {};
          }
          condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue] = simpleList.length === 1 ? simpleList[0] : simpleList;
        } else {
          condition.Values = null;
        }
        condition.Roles = null;
        condition.Users = null;
      } else {
        if (RolesList.length > 0) {
          if (!condition.Roles) {
            condition.Roles = {};
          }
          condition.Roles[__WEBPACK_IMPORTED_MODULE_1__type___default.a.role] = RolesList.length === 1 ? RolesList[0] : RolesList;
        } else {
          condition.Roles = null;
        }
        if (UsersList.length > 0) {
          if (!condition.Users) {
            condition.Users = {};
          }
          condition.Users[__WEBPACK_IMPORTED_MODULE_1__type___default.a.user] = UsersList.length === 1 ? UsersList[0] : UsersList;
        } else {
          condition.Users = null;
        }
        condition.Values = null;
      }
      var updatedCondition = utils.copy(condition);
      var copyselectedOp = utils.copy(condition.__selectedOp);
      this.__selectedGlobalOptions.map(function (option) {
        if (copyselectedOp.filter(function (o) {
          return o.Uid === option.Uid;
        }).length !== 0 && condition.__selectedOptions.filter(function (o) {
          return o.Uid === option.Uid;
        }).length === 0) {
          _this8.__selectedGlobalOptions.splice(_this8.__selectedGlobalOptions.indexOf(option), 1);
        }
      });
      condition.__selectedOp = utils.copy(condition.__selectedOptions);
      this.rootOptionsChangedEvent(condition);
      this.updateCondition(condition.Id, updatedCondition);
    },
    updateCondition: function updateCondition(conditionId, updatedCondition) {
      delete updatedCondition.__selectedOptions;
      delete updatedCondition.__selectedContextType;
      delete updatedCondition.__o;
      delete updatedCondition.conditionValues;
      delete updatedCondition.__selectedOp;
      var payload = {
        Id: conditionId,
        Condition: updatedCondition
      };
      this.$emit('updateCondition', payload);
    },
    setOptions: function setOptions(condition, e) {
      condition.__o = e.values;
      e.values = [{
        label: '',
        options: []
      }];
    },
    resetConditionLine: function resetConditionLine(condition, e) {
      var _this9 = this;
      this.enableSaveButton();
      var copyselectedOp = utils.copy(condition.__selectedOp);
      var copyselectedOptions = utils.copy(condition.__selectedOptions);
      this.__selectedGlobalOptions.map(function (option) {
        if (copyselectedOp.filter(function (o) {
          return o.Uid === option.Uid;
        }).length !== 0 && copyselectedOptions.filter(function (o) {
          return o.Uid === option.Uid;
        }).length !== 0) {
          _this9.__selectedGlobalOptions.splice(_this9.__selectedGlobalOptions.indexOf(option));
        }
      });
      if (this.$parent.isRoot) {
        condition.Operator = __WEBPACK_IMPORTED_MODULE_6__operator_type___default.a.Is;
      } else {
        condition.Operator = null;
      }
      condition.__selectedOptions = [];
      condition.__selectedContextType = '';
      condition.__o = [{}];
      condition.__selectedOp = [];
      condition[this.xsi] = this.contextTypeMap.filter(function (key) {
        return _this9.formatLabel(__WEBPACK_IMPORTED_MODULE_3__context_type___default.a[key]) === e.label;
      })[0];
      if (condition[this.xsi] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.itemOwner) {
        condition.Values = null;
        condition.Roles = {
          RoleDTO: null
        };
        condition.Users = {
          UserDTO: null
        };
      } else {
        condition.Values = {
          ConditionValueDTO: {
            Id: 0,
            Value: {
              '@xsi:type': 'xsd:string',
              '#text': ''
            },
            'CurrencyId': '1',
            'CurrencyCode': 'USD'
          }
        };
      }
      if (condition[this.xsi] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.amount || condition[this.xsi] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.adjustmentAmount) {
        condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue].Value[this.xsi] = 'xsd:double';
        condition.Operator = __WEBPACK_IMPORTED_MODULE_6__operator_type___default.a.Is;
      }
      if (condition.AdditionalOperator) {
        delete condition.AdditionalOperator;
      }
      if (condition[this.xsi] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.discountPaymentTerms) {
        this.setDiscountsConditionOptions(condition, this.discountsConditions[0]);
      }
      if (condition[this.xsi] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.preCommit) {
        this.setPreCommitConditionOptions(condition, this.preCommitConditions[0]);
      }
      if (condition[this.xsi] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.supplierLocation) {
        this.setSupplierLocationConditionOptions(condition, this.supplierLocationConditions[0]);
      }
      if (condition[this.xsi] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.supplierOrganizationType) {
        this.setSupplierOrganizationTypeConditionOptions(condition, this.supplierOrganizationTypeConditions[0]);
      }
      this.rootOptionsChangedEvent(condition);
      this.setOptions(condition, e);
      var updatedCondition = utils.copy(condition);
      this.updateCondition(condition.Id, updatedCondition);
    },
    rootOptionsChangedEvent: function rootOptionsChangedEvent(condition) {
      this.setThenSelectionLimitations(condition);
      __WEBPACK_IMPORTED_MODULE_8__event_bus__["b" /* EventBus */].$emit('rootOptionChanged');
    },
    changeConditionOperator: function changeConditionOperator(condition, e) {
      if (condition[this.xsi] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.amount || condition[this.xsi] === __WEBPACK_IMPORTED_MODULE_1__type___default.a.adjustmentAmount) {
        condition.AdditionalOperator = this.operatorTypeMap.filter(function (key) {
          return __WEBPACK_IMPORTED_MODULE_6__operator_type___default.a[key] === e;
        })[0];
        condition.Operator = __WEBPACK_IMPORTED_MODULE_6__operator_type___default.a['Is'];
      } else {
        condition.Operator = this.operatorTypeMap.filter(function (key) {
          return __WEBPACK_IMPORTED_MODULE_6__operator_type___default.a[key] === e;
        })[0];
        delete condition.AdditionalOperator;
      }
      var updatedCondition = utils.copy(condition);
      this.updateCondition(condition.Id, updatedCondition);
      this.enableSaveButton();
    },
    changeConditionAmount: function changeConditionAmount(condition, e) {
      condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue].Value['#text'] = e;
      condition.Values[__WEBPACK_IMPORTED_MODULE_1__type___default.a.conditionValue].Value['@xsi:type'] = 'xsd:double';
      var updatedCondition = utils.copy(condition);
      this.updateCondition(condition.Id, updatedCondition);
      this.enableSaveButton();
    },
    changeOperator: function changeOperator(e) {
      this.rule.Operator = e === this.operators[0] ? 'And' : 'Or';
      var updatedOperator = utils.copy(this.rule.Operator);
      this.$emit('changeOperator', updatedOperator);
      this.enableSaveButton();
    },
    deleteConditionModal: function deleteConditionModal(condition) {
      this.showDeleteModal = true;
      this.deleteTarget = condition;
    },
    deleteConditionLine: function deleteConditionLine() {
      var _this10 = this;
      this.processedConditions.splice(this.processedConditions.indexOf(this.deleteTarget), 1);
      this.deleteTarget.__selectedOp.map(function (option) {
        if (_this10.__selectedGlobalOptions.filter(function (o) {
          return o.Uid === option.Uid;
        }).length !== 0) {
          var index = _this10.__selectedGlobalOptions.map(function (op) {
            return op.Uid;
          }).indexOf(option.Uid);
          _this10.__selectedGlobalOptions.splice(index, 1);
        }
      });
      this.$emit('deleteLine', this.deleteTarget);
      this.enableSaveButton();
    },
    copyConditionLine: function copyConditionLine(conditionLineId, index) {
      var newCondition = utils.copy(this.processedConditions[index]);
      var id = this.max(this.$store.state.approvalRuleIds.conditionIds) + 1;
      newCondition.Id = id;
      this.$store.state.approvalRuleIds.conditionIds.push(id);
      var sanitizedNewCondition = utils.copy(newCondition);
      delete sanitizedNewCondition.__selectedOptions;
      delete sanitizedNewCondition.__selectedContextType;
      delete sanitizedNewCondition.__o;
      delete sanitizedNewCondition.conditionValues;
      delete sanitizedNewCondition.__selectedOp;
      this.processedConditions.splice(index + 1, 0, newCondition);
      this.$emit('copyLine', sanitizedNewCondition);
      this.enableSaveButton();
    },
    addCondition: function addCondition(newCondition) {
      newCondition.Id = this.max(this.$store.state.approvalRuleIds.conditionIds) + 1;
      this.$store.state.approvalRuleIds.conditionIds.push(newCondition.Id);
      var newCond = utils.copy(newCondition);
      if (this.processedConditions.constructor === Array) {
        this.processedConditions.push(this.applyConditionContext(newCond));
        var sanitizedNewCondition = utils.copy(newCondition);
        delete sanitizedNewCondition.__selectedOptions;
        delete sanitizedNewCondition.__selectedContextType;
        delete sanitizedNewCondition.__o;
        delete sanitizedNewCondition.conditionValues;
        delete sanitizedNewCondition.__selectedOp;
        this.$emit('addLine', sanitizedNewCondition);
        return;
      }
    },
    enableSaveButton: function enableSaveButton() {
      approvalRuleUtils.utils.enableSaveButton(!this.$store.state.enableSaveButton);
    },
    formatLabel: function formatLabel(value) {
      return this.formatEnvelopeLabel(this.formatProgramLabel(value));
    },
    formatProgramLabel: function formatProgramLabel(value) {
      if (typeof value !== 'string') return value;
      return value.replace('Program', this.programLabel);
    },
    // PRODUCTDEV-8800: display only, the saved value stays "Envelope Submitted"
    formatEnvelopeLabel: function formatEnvelopeLabel(value) {
      return value === 'Envelope Submitted' ? "".concat(this.envelopeTerm, " Submitted") : value;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("RMJP")))

/***/ }),

/***/ "Jvju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabs__ = __webpack_require__("9+wP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LegacyContainer__ = __webpack_require__("jIfZ");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LegacyContainer: __WEBPACK_IMPORTED_MODULE_1__components_LegacyContainer__["a" /* default */]
  },
  data: function data() {
    return {
      tabs: __WEBPACK_IMPORTED_MODULE_0__tabs__["a" /* default */].tabs
    };
  },
  computed: {
    url: function url() {
      return this.$route.params.action;
    }
  },
  methods: {
    gotoTab: function gotoTab() {
      this.$router.push(this.tabs[0].href);
    }
  },
  created: function created() {
    this.gotoTab();
  },
  activated: function activated() {
    this.gotoTab();
  }
});

/***/ }),

/***/ "K40X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__);



function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      formData: {
        city: '',
        postalCode: '',
        originalCountryName: '',
        country: '',
        state: {
          StateID: 0,
          StateName: ''
        },
        canadaState: {
          StateID: 0,
          StateName: ''
        },
        region: ''
      },
      USstates: [],
      USoriginalStates: [],
      canadaStates: [],
      originalCanadaStates: [],
      countries: [],
      originalCountries: [],
      mailingAddress: {},
      addObjectUser: {},
      rushOrder: false,
      requireReceiptDescription: false,
      allowRushPhysicalCards: false,
      errors: {},
      selectedCards: []
    };
  },
  created: function created() {
    this.resetFields();
    this.getDivisionSettings();
    this.populateFormData(this.formData);
    this.setSelectedCardsFromList();
  },
  props: {
    card: Object,
    divisionId: '',
    cardDivisionId: '',
    filteredCards: Array,
    list: Array,
    account: Object
  },
  watch: {
    list: {
      immediate: true,
      handler: function handler(newList) {
        this.setSelectedCardsFromList();
      }
    },
    isRushDisabled: function isRushDisabled(disabled) {
      if (disabled) {
        this.rushOrder = false;
      }
    }
  },
  computed: {
    sortedFilteredCards: function sortedFilteredCards() {
      if (!this.filteredCards) return [];
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default()(this.filteredCards).sort(function (a, b) {
        var getDateFromString = function getDateFromString(dateString) {
          var match = /\/Date\((\d+)\)\//.exec(dateString);
          return match ? new Date(parseInt(match[1], 10)) : new Date();
        };
        return getDateFromString(b.CreatedDate) - getDateFromString(a.CreatedDate);
      });
    },
    allCardIds: function allCardIds() {
      if (this.sortedFilteredCards && this.sortedFilteredCards.length) {
        return this.sortedFilteredCards.map(function (card) {
          return card.Id;
        });
      }
      if (this.list && this.list.length) {
        return this.list.map(function (cardNode) {
          return cardNode.data.Id;
        });
      }
      return [];
    },
    selectAll: {
      get: function get() {
        return this.allCardIds.length > 0 && this.selectedCards.length === this.allCardIds.length;
      },
      set: function set(checked) {
        this.selectedCards = checked ? __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default()(this.allCardIds) : [];
      }
    },
    underfundedAccountNames: function underfundedAccountNames() {
      var _this = this;
      var items = this.list || [];
      var names = items.filter(function (item) {
        var data = item && item.data;
        if (!data || !_this.selectedCards.includes(data.Id)) return false;
        return typeof data.AccountBalance === 'number' && data.AccountBalance <= 0;
      }).map(function (item) {
        return item.data.Division;
      }).filter(Boolean);
      return Array.from(new Set(names));
    },
    isRushDisabled: function isRushDisabled() {
      if (this.account && this.account.Available <= 0) {
        return true;
      }
      return this.underfundedAccountNames.length > 0;
    },
    rushDisabledReason: function rushDisabledReason() {
      if (this.account && this.account.Available <= 0) {
        return 'Insufficient funds available for rush shipping.';
      }
      if (this.underfundedAccountNames.length > 0) {
        return "The following accounts have insufficient funds available for rush shipping: ".concat(this.underfundedAccountNames.join(', '), ".");
      }
      return '';
    }
  },
  methods: {
    // Surface the custom Name on Card next to the legal holder ("Jane Doe | John Smith") when set and
    // meaningfully different (case-insensitive); otherwise the legal name only. Holder is an object with
    // FirstName/LastName from the card list feed, or a plain string from grid rows. See PRODUCTDEV-5553.
    holderDisplay: function holderDisplay(holder, nameOnCard) {
      var legalName = holder && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(holder) === 'object' ? "".concat(holder.FirstName || '', " ").concat(holder.LastName || '').trim() : (holder || '').trim();
      var customName = (nameOnCard || '').trim();
      if (!customName || customName.toLowerCase() === legalName.toLowerCase()) {
        return legalName;
      }
      if (!legalName) {
        return customName;
      }
      return "".concat(customName, " | ").concat(legalName);
    },
    requestPhysicalCard: function requestPhysicalCard(showModal) {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee() {
        var isValid, cardIds, response, userFriendlyErrorMessage, errorDataString, firstBracketIndex, secondBracketIndex, colonIndex, endOfMessagePeriod, endOfMessageParenthesis, endOfMessageIndex, detailedMessage;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              isValid = _this2.validateForm();
              if (isValid) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              cardIds = _this2.selectedCards;
              _context.next = 7;
              return _this2.api.post("evedpaycards/request-physical-card", {
                preventError: true,
                Shipping: {
                  IsRush: _this2.rushOrder,
                  Name: _this2.mailingAddress.name,
                  Address: {
                    Country: {
                      Id: 186
                    },
                    Address1: _this2.mailingAddress.line1,
                    Address2: _this2.mailingAddress.line2,
                    City: _this2.mailingAddress.city,
                    State: {
                      Id: _this2.mailingAddress.state.StateID
                    },
                    Zip: _this2.mailingAddress.zip
                  },
                  CardIds: cardIds
                }
              });
            case 7:
              response = _context.sent;
              if (response.status === 200) {
                showModal.showModal = false;
                _this2.$emit('success');
              } else {
                console.error('Error requesting physical card:', response);
              }
              _context.next = 17;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              console.error('Exception while requesting physical card:', _context.t0);
              userFriendlyErrorMessage = 'An unexpected error occurred. Please try again.';
              if (_context.t0.response && _context.t0.response.data) {
                errorDataString = JSON.stringify(_context.t0.response.data);
                firstBracketIndex = errorDataString.indexOf('['); // searching for the first bracket in the message
                secondBracketIndex = errorDataString.indexOf('[', firstBracketIndex + 1); // when the first bracket is found, search for the second one
                if (secondBracketIndex !== -1) {
                  colonIndex = errorDataString.indexOf(':', secondBracketIndex); // after the second bracket is found, look for the colon -> from there the message for the user starts
                  if (colonIndex !== -1) {
                    endOfMessagePeriod = errorDataString.indexOf('.', colonIndex); // end when the first period is found
                    endOfMessageParenthesis = errorDataString.indexOf('(', colonIndex); // or end when the first parethesis is found
                    endOfMessageIndex = errorDataString.length; // min index if both are found
                    if (endOfMessagePeriod !== -1 && endOfMessageParenthesis !== -1) {
                      endOfMessageIndex = Math.min(endOfMessagePeriod, endOfMessageParenthesis);
                      // if only period is found
                    } else if (endOfMessagePeriod !== -1) {
                      endOfMessageIndex = endOfMessagePeriod;
                      // if only parenthesis is found
                    } else if (endOfMessageParenthesis !== -1) {
                      endOfMessageIndex = endOfMessageParenthesis;
                    }
                    // extract and trim the detailed error message
                    detailedMessage = errorDataString.substring(colonIndex + 1, endOfMessageIndex).trim();
                    userFriendlyErrorMessage = detailedMessage;
                    // remove any trailing parenthesis from the error message
                    if (userFriendlyErrorMessage.endsWith('(')) {
                      userFriendlyErrorMessage = userFriendlyErrorMessage.slice(0, -1).trim();
                    }
                  }
                }
              }
              alert(userFriendlyErrorMessage);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 11]]);
      }))();
    },
    setSelectedCardsFromList: function setSelectedCardsFromList() {
      this.selectedCards = (this.list || this.filteredCards || []).map(function (cardNode) {
        return cardNode && cardNode.data ? cardNode.data.Id : cardNode.Id;
      });
    },
    getDivisionSettings: function getDivisionSettings() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var divisionIDToUse;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.programs = [];
              divisionIDToUse = _this3.divisionId ? _this3.divisionId : _this3.cardDivisionId;
              _this3.api.post('Settings/GetDivision', {
                divisionID: divisionIDToUse
              }).then(function (response) {
                if (response && response.data) {
                  var responseData = JSON.parse(response.data.Data);
                  var evedPayCardAccountSettingsObj = JSON.parse(responseData.evedPayCardAccountSettings);
                  _this3.allowRushPhysicalCards = evedPayCardAccountSettingsObj.AllowRushPhysicalCards;
                }
              }).catch(function (error) {
                console.warn(error);
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    resetFields: function resetFields() {
      this.rushOrder = false;
      this.mailingAddress = {};
      this.name = '';
      this.address = '';
      this.addressLine2 = '';
      this.city = '';
      this.formData.state = '';
      this.formData.canadaState = '';
      this.formData.region = '';
      this.zipCode = '';
    },
    fetchCountriesOnOpen: function fetchCountriesOnOpen() {
      var _this4 = this;
      if (this.countries.length) {} else {
        this.api.forms.post(this.api.$.profile.getAllCountries, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this4.countries = r.data.Data;
            _this4.originalCountries = r.data.Data;
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    fetchCountries: function fetchCountries(value) {
      var _this5 = this;
      this.counter || this.api.forms.post(this.api.$.profile.getAllCountries, {
        q: value || ''
      }).then(function (r) {
        _this5.counter = 0;
        if (r && r.data && r.data.Data) {
          _this5.countries = r.data.Data;
        }
      }).catch(function (e) {
        console.warn(e);
        _this5.counter = 0;
      });
      this.counter = 1;
    },
    fetchUserDivisions: function fetchUserDivisions() {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this6.divisions = [];
              if (_this6.accountId === '') {
                _this6.api.get(_this6.api.$.evedpaycard.division).then(function (response) {
                  if (response && response.data) {
                    var _iterator = _createForOfIteratorHelper(response.data),
                      _step;
                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var account = _step.value;
                        _this6.divisions.push({
                          Id: account.DivisionId,
                          Name: account.DivisionName
                        });
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                  }
                }).catch(function (error) {
                  console.warn(error);
                });
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    restoreCountries: function restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries);
      }
    },
    isUS: function isUS() {
      return this.formData.country && this.formData.country.CountryName === 'United States';
    },
    GetStatesUSURL: function GetStatesUSURL() {
      return this.api.$.profile.getAllStates;
    },
    isCanada: function isCanada() {
      return this.formData.country && this.formData.country.CountryName === 'Canada';
    },
    GetStatesCanadaURL: function GetStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates;
    },
    // Fetch States on OPEN
    fetchUSStatesOnOpen: function fetchUSStatesOnOpen() {
      var url = this.GetStatesUSURL();
      this.fetchStatesOnOpen(this.USstates, url);
    },
    fetchCanadaStatesOnOpen: function fetchCanadaStatesOnOpen() {
      var url = this.GetStatesCanadaURL();
      this.fetchStatesOnOpen(this.canadaStates, url);
    },
    fetchStatesOnOpen: function fetchStatesOnOpen(states, url) {
      var _this7 = this;
      if (states.length && (this.isCanada() || this.isUS())) {} else {
        this.api.forms.post(url, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this7.mapStatesDataOnOpen(r.data.Data);
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    mapStatesDataOnOpen: function mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USstates = this.USoriginalStates = data;
      } else {
        this.canadaStates = this.originalCanadaStates = data;
      }
    },
    // Fetch States on search text
    fetchUSStates: function fetchUSStates(value) {
      var url = this.GetStatesUSURL();
      this.fetchStates(value, url);
    },
    fetchCanadaStates: function fetchCanadaStates(value) {
      var url = this.GetStatesCanadaURL();
      this.fetchStates(value, url);
    },
    fetchStates: function fetchStates(value, url) {
      var _this8 = this;
      this.counter || this.api.forms.post(url, {
        q: value || ''
      }).then(function (r) {
        _this8.counter = 0;
        if (r && r.data && r.data.Data) {
          _this8.mapStatesDataOnFetch(r.data.Data);
        }
      }).catch(function (e) {
        console.warn(e);
        _this8.counter = 0;
      });
      this.counter = 1;
    },
    mapStatesDataOnFetch: function mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USstates = data;
      } else {
        this.canadaStates = data;
      }
    },
    // Restore States
    restoreUSStates: function restoreUSStates() {
      this.restoreStates(this.USstates, this.USoriginalStates);
    },
    restoreCanadaStates: function restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates);
    },
    restoreStates: function restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates);
      }
    },
    populateFormData: function populateFormData(data) {
      if (data.CompanyName !== null) {
        this.formData = {
          city: data.City,
          postalCode: data.Zip,
          originalCountryName: data.CountryName,
          country: {
            'CountryID': 186,
            'CountryName': 'United States'
          },
          state: {
            StateID: data.isCanada === 'False' && data.StateID || 0,
            StateName: data.isCanada === 'False' && data.State || ''
          },
          canadaState: {
            StateID: data.isCanada === 'True' && data.StateID || 0,
            StateName: data.isCanada === 'True' && data.State || ''
          },
          region: data.Region
        };
        this.disableControls = true;
      } else {
        this.disableControls = false;
      }
    },
    countrySelected: function countrySelected(e) {
      this.doDisplayCountryError = false;
      this.resetState(e.CountryName);
    },
    resetState: function resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.formData.state = {
          StateID: 0,
          StateName: ''
        };
        this.formData.canadaState = {
          StateID: 0,
          StateName: ''
        };
        this.formData.region = '';
      } else {
        this.originalCountryName = countryName;
      }
    },
    validateForm: function validateForm() {
      this.errors = {};
      if (!this.mailingAddress.name || !this.mailingAddress.name.trim()) {
        this.errors.name = 'Name is required.';
      }
      if (!this.mailingAddress.line1 || !this.mailingAddress.line1.trim()) {
        this.errors.line1 = 'Address is required.';
      }
      if (!this.mailingAddress.city || !this.mailingAddress.city.trim()) {
        this.errors.city = 'City is required.';
      }
      if (this.isUS() && (!this.mailingAddress.state || !this.mailingAddress.state.StateID)) {
        this.errors.state = 'State is required.';
      }
      if (!this.mailingAddress.zip || !this.mailingAddress.zip.trim()) {
        this.errors.zip = 'Zip Code is required.';
      }
      var isValid = Object.keys(this.errors).length === 0;
      return isValid;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "K6zE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_value_objects_money_index_vue__ = __webpack_require__("7QHX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_edInputTooltip_index_vue__ = __webpack_require__("7npE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var lastValue = '';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-input',
  props: {
    currency: String,
    negative: Boolean,
    fieldLabel: String,
    rightLabel: Boolean,
    emptyFieldLabel: Boolean,
    hideOptional: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    maxlength: {
      type: Number,
      default: 255
    },
    dir: String,
    required: Boolean,
    autofocus: Boolean,
    autoselect: Boolean,
    name: String,
    disabled: Boolean,
    error: Boolean,
    placeholder: String,
    conditionalText: String,
    value: [String, Number],
    helpText: String,
    showPassword: Boolean,
    updateButton: Boolean,
    helptipHeader: String,
    helptipBody: String,
    symbol: String,
    search: Boolean,
    searchBox: Boolean,
    amount: {
      type: Boolean,
      default: false
    },
    supplementalPrecision: {
      type: Number,
      default: 0
    },
    integer: Boolean,
    onlyNumbers: Boolean
  },
  components: {
    'v-money': __WEBPACK_IMPORTED_MODULE_0__core_value_objects_money_index_vue__["a" /* default */],
    'ed-input-tooltip': __WEBPACK_IMPORTED_MODULE_1__core_components_edInputTooltip_index_vue__["default"]
  },
  directives: {
    focus: {
      inserted: function inserted(el, binding) {
        if (binding.value) el.focus();else el.blur();
      },
      componentUpdated: function componentUpdated(el, binding) {
        if (binding.modifiers.lazy) {
          if (Boolean(binding.value) === Boolean(binding.oldValue)) {
            return;
          }
        }
        if (binding.value) el.focus();else el.blur();
      }
    }
  },
  data: function data() {
    return {
      focused: false,
      fieldType: this.type,
      symbolWidth: '',
      amountValue: utils.copy(this.value || null),
      moneyValue: utils.copy(this.value || 0),
      amountValueWasChanged: false,
      moneyPlaceholder: this.conditionalText || this.placeholder
    };
  },
  created: function created() {
    if (this.amount && this.amountValue) {
      this.formatAmount(this.value);
      this.formatMoney();
    }
    if (this.updateButton) lastValue = lastValue || this.value;
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.showMoneyValue();
      _this.getSymbolPadding();
      _this.$nextTick(function () {
        _this.moneyPlaceholder = _this.setMoneyPlaceholder();
        _this.formatMoney();
      });
    });
  },
  updated: function updated() {
    if (!this.moneyPlaceholder) {
      this.moneyPlaceholder = this.setMoneyPlaceholder();
    }
    if (!this.focused && !this.negative) {
      this.formatMoney();
    }
  },
  watch: {
    value: function value(oldV, newV) {
      if (this.amount) {
        if (this.amountValueWasChanged === true) {
          // this.formatAmount(utils.copy(this.value || null))
        } else {
          if (+oldV !== +newV) {
            this.amountValue = this.value;
          }
          if (this.type === 'money') {
            this.moneyValue = this.value;
          }
          this.focused || this.$nextTick(this.formatMoney);
        }
        this.amountValueWasChanged = false;
      }
    },
    currency: function currency() {
      // this.formatAmount(utils.copy(this.value || null))
      this.formatMoney();
    },
    conditionalText: function conditionalText() {
      this.moneyPlaceholder = this.setMoneyPlaceholder();
      this.formatMoney();
    }
  },
  computed: {
    setDir: function setDir() {
      if (this.type === 'number' && this.dir !== 'ltr') {
        return 'rtl';
      } else {
        return 'ltr';
      }
    },
    setType: function setType() {
      return this.fieldType;
    },
    setValue: function setValue() {
      if (this.conditionalText) {
        return null;
      }
      if (this.amount) {
        return this.amountValue;
      } else {
        return this.value;
      }
    },
    nilMoney: function nilMoney() {
      return Math.floor(this.setValue) === 0;
    },
    negativeMoney: function negativeMoney() {
      return this.setValue < 0;
    }
  },
  methods: {
    focusInput: function focusInput() {
      this.$refs.input.focus();
    },
    getSymbolPadding: function getSymbolPadding() {
      if (this.symbol) {
        var symbolHolder = this.$refs.symbolWrapper.clientWidth + 10;
        this.symbolWidth = 'paddingRight: ' + symbolHolder + 'px';
      }
    },
    getDigits: function getDigits() {
      var digits = 2;
      if (this.supplementalPrecision === 1) digits = 3;else if (this.supplementalPrecision === 2) digits = 4;else if (this.supplementalPrecision === 6) digits = 8;
      return digits;
    },
    updateInput: function updateInput(value) {
      if (this.onlyNumbers) {
        var onlyNumbers = (value.match(/\d+/g) || []).join('');
        this.$refs.input.value = onlyNumbers;
        this.$emit('input', onlyNumbers);
        return;
      }
      if (this.integer) {
        this.$refs.input.value |= parseInt(value) || 0;
        this.$emit('input', parseInt(value) || 0);
        return;
      }
      if (this.updateButton) lastValue = value || lastValue;
      if (this.amount) {
        var number = utils.numeric.getNumberFromString(value);
        number = utils.numeric.setMaxNumberOfDigits(number, this.getDigits());
        this.$emit('input', number);
        this.amountValue = number;
      } else {
        this.$emit('input', value);
      }
    },
    updateKeyUp: function updateKeyUp(value) {
      if (this.amount) {
        this.amountValue = value;
      }
      this.$emit('keyup', value);
    },
    changeValue: function changeValue(value) {
      if (this.amount) {
        var number = utils.numeric.getNumberWithDecimals(value, this.getDigits());
        this.$emit('change', number);
        this.formatAmount(number);
        this.amountValueWasChanged = true;
      } else {
        this.$emit('change', value);
      }
    },
    formatAmount: function formatAmount(value) {
      value = "".concat(value) === '-' ? 0 : value;
      value = utils.numeric.getNumberWithDecimals("".concat(value), this.getDigits());
      value = value ? parseFloat(value, 10) : 0;
      // value = value.toLocaleString(utils.locale.getLang(), {minimumFractionDigits: 2, maximumFractionDigits: 2})
      this.amountValue = value === 0 ? '' : value;
    },
    formatMoney: function formatMoney() {
      var _this2 = this;
      if (this.type === 'money') {
        // value was changed without user input
        if (this.value !== this.amountValue) {
          this.amountValue = this.value;
        }
        this.amountValue = this.negative && this.amountValue > 0 ? this.amountValue * -1 : this.amountValue;
        this.moneyValue = this.amountValue % 1 === 0 ? +this.amountValue : this.amountValue;
        this.$nextTick(function () {
          _this2.setRefsInputValue();
          _this2.$nextTick(function () {
            _this2.setRefsInputValue();
          });
        });
      }
    },
    setRefsInputValue: function setRefsInputValue() {
      if (this.$refs.input) {
        this.$refs.input.value = this.conditionalText ? '' : this.$refs.money && this.$refs.money.formatted.trim();
      }
    },
    showMoneyValue: function showMoneyValue() {
      if (this.type === 'money') {
        this.$refs.input.value = this.negative ? Math.abs(this.moneyValue) : this.moneyValue;
      }
    },
    togglePassword: function togglePassword() {
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password';
      this.$refs.input.setAttribute('type', this.fieldType);
      this.$refs.input.focus();
    },
    emitBlur: function emitBlur(event) {
      if (this.updateButton && this.value === '') {
        this.$emit('input', lastValue);
        this.valueData = lastValue;
      }
      this.$emit('focus', event.target.value);
      this.focused = false;
    },
    emitFocus: function emitFocus(event) {
      var _this3 = this;
      if (this.amount) {
        // let number = utils.numeric.getNumberWithDecimals(event.target.value)

        // edit money value (unformatted)
        if (this.type === 'money') {
          this.showMoneyValue();
        } else {
          // this.amountValue = number
        }
      }
      if (this.type === 'money' && this.amount && this.amountValue === null) {
        this.showMoneyValue();
      }
      this.$emit('focus', event.target.value);
      this.focused = true;
      this.getSymbolPadding();
      if (!+this.amountValue && this.amount) {
        this.$refs.input.value = '';
      }
      if (this.autoselect) {
        this.$nextTick(function () {
          _this3.$refs.input.setSelectionRange(0, _this3.$refs.input.value.length);
        });
      }
    },
    emitFocusOut: function emitFocusOut(event) {
      if (this.amount) {
        this.formatAmount(event.target.value);
        this.formatMoney();
      }
      this.$emit('focusout', event.target.value);
    },
    emitUpdate: function emitUpdate() {
      this.$emit('update');
    },
    emitMousedown: function emitMousedown(e) {
      this.$emit('mousedown', e);
    },
    setMoneyPlaceholder: function setMoneyPlaceholder() {
      return this.conditionalText || this.placeholder || this.$refs.moneyPlaceholder && this.$refs.moneyPlaceholder.formatted.trim();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "K7FF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1qnLwOh5Dfsmxk9T5qbrfm","Dell":"_3vW1QfE_eCKBBqE8Hze6x3","Abbott":"OP4sOAkNtGtj8wP29lIdq","Gap":"_1vKYkb_k5yHAI-Ko_7H_zR","Allstate":"g5Enn5111C-O96mqFFSVP","Asurion":"_24zXOpdBs6IH2lPzh_NMbD","Invitae":"_297urzoEVC9YjOER_uyGLq","JWE":"_3r48wooHuTVylttxpbjpB8"};

/***/ }),

/***/ "KBZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{ref:"header",attrs:{"title":_vm.$t("Import Expense Data")}},[_c('span',{attrs:{"slot":"action"},slot:"action"},[(_vm.$root.legacySubtab)?_c('router-link',{attrs:{"to":"/d/Admin/Import"}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_c('span',[_vm._v("  "+_vm._s(_vm.$t('Back') + ' ' + _vm.$t('to') + ' ' + _vm.$t(_vm.$root.legacySubtab)))])]):_vm._e()],1)]),_c('div',{staticClass:"container-fluid"},[_c('ed-section',{staticClass:"active",attrs:{"offset":""}},[_c('ed-tab-nav',{ref:"steps",staticClass:"col-md-12 steps uniform",attrs:{"steps":"","wide":"","check":_vm.uploadFileValid},on:{"tabSelected":_vm.enterStep}},[_c('ed-tab',{attrs:{"title":"Import File"}},[_c('ed-section',{staticClass:"col-md-9 active",attrs:{"offset":"4"}},[_c('h5',[_vm._v("Import your expense data file")]),_c('p',[_vm._v("Imports will update existing or create new expenses based on looking at\nthe Expense IDs of existing expenses in Eved.\nFields in the Expense Information, Supplier Information,\nand Bill To sections in the Expense module can be added or updated with this import.")]),_c('p',[_vm._v("If the imported data has more than one tab, the first tab will be imported.")]),_c('p',[_vm._v("Column heading must begin on Row 1.")]),_c('p',[_vm._v("Accepted file formats are .xls and .xlsx")]),_c('ed-form',{attrs:{"endpoint":_vm.api.env + _vm.api.$.expense.upload,"no-submit":"","submit-visible":false}},[_c('ed-upload',{attrs:{"button-label":"Browse","helptipHeader":"Error","helptipBody":_vm.uploadFileError,"error":!_vm.uploadFileValid,"showHelptipIcon":false,"required":"","upload-auto":"","accept":"application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet","extensions":"xls,xlsx"},model:{value:(_vm.attachedFile),callback:function ($$v) {_vm.attachedFile=$$v},expression:"attachedFile"}})],1)],1)],1),_c('ed-tab',{attrs:{"title":"Match Columns","endpoint":_vm.api.$.expense.import,"data":"data","payload":_vm.data.fieldsMap,"payloadType":"json","feedback":"errors","validate":"checkMatched"}},[_c('ed-section',{staticClass:"col-md-12 active"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('p',[_vm._v("Use the table below to match the Column Headers from Row 1 of\nyour uploaded file to match to your Expense Fields in Eved.")]),_c('p',[_vm._v("Required fields are indicated with an "),_c('strong',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(". All required fields must have\na column matched to them to move to Step 3.")])]),_c('p'),_c('ed-form',{staticClass:"col-md-10 col-md-offset-1",attrs:{"endpoint":_vm.api.$.expense.create,"submit-visible":false}},[_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.fieldsMap && _vm.data.fieldsMap[0].fieldName !== null),expression:"data.fieldsMap && data.fieldsMap[0].fieldName !== null"}],staticClass:"table table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticClass:"col-md-3"},[_c('br'),_vm._v(" Expense Field")]),_c('th',[_c('br'),_vm._v(" Column Header in File")])])]),_c('tbody',_vm._l((_vm.updateMatches(_vm.data.fieldsMap, _vm.data.importedColumns)),function(field,index){return _c('tr',{class:{ "required": field.isRequired && !(field.columns && field.columns.length) }},[_c('td',[_vm._v(_vm._s(field.label)+" "),_c('strong',{staticClass:"text-danger"},[_vm._v(_vm._s(field.isRequired ? '*' : ''))])]),_c('td',[_c('ed-select',{attrs:{"options":_vm.getImportedColumns(index),"value":_vm.columnName(field.columns, field.type === "list"),"customLabel":_vm.columnName,"required":field.isRequired},on:{"select":function($event){return _vm.handleMultimatch(field, $event)},"open":function($event){return _vm.fetchImportedColumns(_vm.data.importedColumns, index)}},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('ed-select-options',{attrs:{"thumbnails":""}},[_c('span',{attrs:{"slot":"row1"},slot:"row1"},[_c('kbd',[_vm._v(_vm._s(props.option.letter))]),_vm._v("  "),_c('span',[_vm._v(_vm._s(props.option.name || '[None]'))])])])]}}],null,true)},[(field.columns && field.columns.length === 1 && field.type !== "list")?_c('a',{attrs:{"slot":"clear","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeMatch(field)}},slot:"clear"},[_c('i',{staticClass:"fas fa-times-circle add-icon"})]):_vm._e()]),(field.type && field.columns)?_c('div',{staticClass:"additional-match"},_vm._l((field.columns),function(column){return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-6"},[_c('kbd',{staticClass:"pull-left"},[_vm._v(_vm._s(column.letter))]),_c('small',{staticClass:"col-md-10"},[_vm._v(_vm._s(column.name || "[None]"))])]),(_vm.initDetails(column, field))?_c('div',{staticClass:"col-md-5"},[_c('ed-select',{staticClass:"inline small",attrs:{"options":_vm.titles,"label":"text","placeholder":"Title","openEndpoint":_vm.api.$.expense.titles},on:{"open":_vm.fetchTitles,"select":function($event){return _vm.setDetails("title", column, $event)}}}),_c('ed-select',{staticClass:"inline small",attrs:{"options":_vm.permissions,"placeholder":"Permission","multiple":"","checkboxes":"","openEndpoint":_vm.api.$.expense.permissions},on:{"open":_vm.fetchPermissions,"select":function($event){return _vm.setDetails("permission", column, $event)}}})],1):_vm._e(),_c('small',{staticClass:"col-md-1"},[_c('a',{staticClass:"pull-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeColumn(column, field)}}},[_c('i',{staticClass:"fas fa-times-circle"})])]),_c('br',{staticClass:"clear"}),_c('br')])}),0):_vm._e()],1)])}),0)])])],1)],1),_c('ed-tab',{attrs:{"title":"Review Errors","optional":"Import corrected file","errors":_vm.errors}},[_c('ed-section',{staticClass:"col-md-11 active"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('p',[_vm._v("The table below shows the errors in your file. Please correct\nthese errors in your file and return to step 1 to upload the\ncorrected file.")])]),_c('p'),_c('p'),_c('table',{staticClass:"table table-bordered col-md-10 col-md-offset-1"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Row")]),_c('th',[_vm._v("Column")]),_c('th',[_vm._v("Data")]),_c('th',[_vm._v("Column Header")]),_c('th',[_vm._v("Expense Field")]),_c('th',[_vm._v("Error Reason")])])]),_c('tbody',_vm._l((_vm.errors),function(error,i){return _c('tr',[_c('td',[_vm._v(_vm._s(error.row))]),_c('td',[_vm._v(_vm._s(error.column))]),_c('td',[_vm._v(_vm._s(error.data))]),_c('td',[_vm._v(_vm._s(error.columnHeader))]),_c('td',[_vm._v(_vm._s(error.fieldName))]),_c('td',[_vm._v(_vm._s(error.errorReason))])])}),0)])])],1),_c('ed-tab',{attrs:{"title":"Finalize","button-label":"Ok"}},[_c('ed-section',{staticClass:"col-md-9 active"},[_c('div',{staticClass:"col-md-12 col-md-offset-4"},[_c('h3',[_vm._v("Import Successfully Initiated\n "),_c('i',{staticClass:"success inline"})]),_c('p',[_vm._v("No errors were found in your file and your expense data is being imported now.\nYou'll receive an email shortly when the import is complete and all data is updated in Eved.")]),_c('p'),_c('p'),_c('p')])])],1)],1)],1),(_vm.lastStep)?_c('ed-button',{staticClass:"pull-right btn btn-primary",attrs:{"to":"/d/Admin/Import"}},[_vm._v("Ok")]):_vm._e(),(!_vm.lastStep)?_c('ed-button',{staticClass:"pull-right",attrs:{"disabled":!_vm.uploadFileValid || !_vm.attachedFile},on:{"click":_vm.proceed}},[_vm._v(_vm._s(_vm.$t(_vm.nextLabel)))]):_vm._e(),(!_vm.lastStep)?_c('ed-button',{staticClass:"pull-right btn btn-secondary",attrs:{"to":"/d/Admin/Import"}},[_vm._v(_vm._s(_vm.$t('Cancel')))]):_vm._e(),_c('ed-modal',{attrs:{"show":_vm.notAllRequiredMatched,"title":"Check Unmatched Column Headers","subtitle":"Please match all required Expense Fields to Column Headers in order to move on to the next step.","primaryButton":"Ok","secondaryButton":"false"},on:{"close":function($event){_vm.notAllRequiredMatched = false}}}),_c('ed-modal',{attrs:{"show":_vm.notAllMatched,"title":"Check Unmatched Column Headers","subtitle":"Not all of your Column Headers are matched to Expense Fields. Do you still want to continue to the next step?","primaryButton":"Yes","secondaryButton":"No"},on:{"close":function($event){_vm.notAllMatched = false},"confirm":_vm.skipMatch}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KD6I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return collection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);

var collection = {
  list: function list(_list) {
    return _list && _list.constructor === Object ? [_list] : _list;
  },
  max: function max(list) {
    return Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(list));
  },
  isEmpty: function isEmpty(obj) {
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        return false;
      }
    }
    return true;
  }
};

/***/ }),

/***/ "KD8Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_js__ = __webpack_require__("JKEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddTransactionNumber_vue__ = __webpack_require__("0cyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_Dashboard_widgets_ApprovalNeeded_approve_dialog__ = __webpack_require__("u8Yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RejectEnvelope_vue__ = __webpack_require__("HePg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_Programs_Card_list_ApprovalNeededUsers_vue__ = __webpack_require__("ygWI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_Programs_Card_envelopes_tabs__ = __webpack_require__("LfIE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_Programs_Card_transactions_CreateEnvelope_vue__ = __webpack_require__("coox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__envelopeTerm__ = __webpack_require__("i/Pq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__core_events_events__);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












// import { backToMap } from '@/components/Layouts/navless'
var backToMap = {
  'EnvelopeApprovalDashboard': '/ApprovalDashboard'
};
var cancelTooltip = 'Please select an envelope.';

// reload page after browser back pressed
function handlePopState(event) {
  if (document.location.href.includes('envelopes')) {
    window.location.reload();
  }
}
window.addEventListener('popstate', handlePopState);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_2__components_Grid__["a" /* default */],
    AddTransactionNumber: __WEBPACK_IMPORTED_MODULE_4__AddTransactionNumber_vue__["a" /* default */],
    ApprovalNeededUsers: __WEBPACK_IMPORTED_MODULE_7__components_modules_Programs_Card_list_ApprovalNeededUsers_vue__["a" /* default */],
    ApproveDialog: __WEBPACK_IMPORTED_MODULE_5__components_modules_Dashboard_widgets_ApprovalNeeded_approve_dialog__["default"],
    RejectEnvelope: __WEBPACK_IMPORTED_MODULE_6__RejectEnvelope_vue__["a" /* default */],
    CreateEnvelope: __WEBPACK_IMPORTED_MODULE_9__components_modules_Programs_Card_transactions_CreateEnvelope_vue__["a" /* default */]
  },
  data: function data() {
    var _this = this;
    return {
      model: __WEBPACK_IMPORTED_MODULE_3__model_js__["a" /* default */],
      sort: {
        CreatedDate: 'desc'
      },
      tabs: __WEBPACK_IMPORTED_MODULE_8__components_modules_Programs_Card_envelopes_tabs__["a" /* default */].tabs,
      selectedAll: null,
      selectedRows: [],
      showApprovalUsers: false,
      approvalUsersData: {},
      showApproveDialog: false,
      isApproving: false,
      showCreateEnvelope: false,
      creatingAPFile: false,
      pushingToAccountingSystem: false,
      accountSettings: [],
      loadingAccountSettings: false,
      envelope: {},
      highlightedEnvelopeId: '',
      rowClasses: {
        'row-highlight': function rowHighlight(params) {
          return (params.data && params.data.Id) === _this.highlightedEnvelopeId;
        }
      },
      noTooltipFields: ['EnvelopeNumber', 'EnvelopeStatus'],
      waitingApprovalStatuses: ['Open - Waiting Approval', 'Exported - Waiting Approval', 'Posted - Waiting Approval'],
      rejectedStatuses: ['Rejected', 'Declined', 'Exported - Rejected', 'Posted - Rejected', 'Exported - Declined', 'Posted - Declined']
    };
  },
  created: function created() {
    var _this2 = this;
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
      var envelope;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.programName = _this2.singularize(_this2.$root.getUser.settings.Labels.ProgramLabel);
            _this2.model.ProgramName.label = _this2.programName;
            if (!_this2.$root.getUser.settings.HasBusinessUnit) {
              delete _this2.model.BusinessUnit;
            }
            __WEBPACK_IMPORTED_MODULE_11__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_12__core_events_events___default.a.EVEDPAY_CARDS.OPEN_ENVELOPE);
            __WEBPACK_IMPORTED_MODULE_11__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_12__core_events_events___default.a.EVEDPAY_CARDS.OPEN_ENVELOPE, function (envelope) {
              _this2.envelope = envelope.data;
              _this2.showCreateEnvelope = true;
            });
            if (!_this2.$route.query.EnvelopeId) {
              _context.next = 12;
              break;
            }
            _context.next = 8;
            return _this2.getEnvelope(_this2.$route.query.EnvelopeId, _this2.isFromDashboard);
          case 8:
            envelope = _context.sent;
            if (_this2.isFromDashboard) {
              envelope.FromDashboard = true;
            }
            _context.next = 12;
            return __WEBPACK_IMPORTED_MODULE_11__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_12__core_events_events___default.a.EVEDPAY_CARDS.OPEN_ENVELOPE, envelope);
          case 12:
            _this2.highlightedEnvelopeId = localStorage.getItem('row-highlight');
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  activated: function activated() {
    this.showCreateEnvelope = false;
    this.envelope = {};
    this.highlightedEnvelopeId = '';
    localStorage.setItem('row-highlight', '');
    this.redrawRows();
  },
  computed: {
    // PRODUCTDEV-8800: the opened envelope's division term, else the client's.
    createEnvelopeTitle: function createEnvelopeTitle() {
      return "CREATE ".concat(Object(__WEBPACK_IMPORTED_MODULE_10__envelopeTerm__["a" /* envelopeTermFor */])(this.envelope).singular.toUpperCase());
    },
    isFromDashboard: function isFromDashboard() {
      return this.$route.params.page === 'EnvelopeApprovalDashboard' || this.$route.query.fromDashboard === 'true';
    },
    showApproveButton: function showApproveButton() {
      return this.isUserInApprovalList();
    },
    showRejectButton: function showRejectButton() {
      return this.isUserInApprovalList();
    }
  },
  watch: {
    showCreateEnvelope: function showCreateEnvelope(newValue) {
      if (newValue) {
        this.highlightedEnvelopeId = this.envelope.Id;
      }
    }
  },
  methods: {
    approveOrReject: function approveOrReject(envelopes) {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isApproving = true;
              _context2.prev = 1;
              payload = {
                envelopesData: envelopes
              };
              _context2.next = 5;
              return _this3.api.post(_this3.api.$.evedpaycard.approveOrRejectEnvelope, payload);
            case 5:
              response = _context2.sent;
              if (response.data) {
                _context2.next = 8;
                break;
              }
              throw new Error('Error during the request');
            case 8:
              _this3.showApproveDialog = false;
              _this3.refresh();
              _context2.next = 15;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);
            case 15:
              _context2.prev = 15;
              _this3.isApproving = false;
              return _context2.finish(15);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 12, 15, 18]]);
      }))();
    },
    doApprove: function doApprove() {
      var envelopes = this.selectedRows.map(function (r) {
        return r.data;
      });
      this.approveOrReject(envelopes);
    },
    transformRows: function transformRows(rows) {
      var _this4 = this;
      return rows.map(function (r) {
        var amount = parseFloat(r.data.Amount).toFixed(2);
        var row = {
          NeedsApproval: _this4.waitingApprovalStatuses.includes(r.data.EnvelopeStatus) ? 'EvedPay Envelope' : '',
          Amount: amount + ' USD'
        };
        return row;
      });
    },
    getApprovalUsers: function getApprovalUsers(envelopeId) {
      var _this5 = this;
      this.api.get(this.api.$.evedpaycard.approvalUsersForEnvelope, {
        params: {
          envelopeId: envelopeId
        }
      }).then(function (response) {
        _this5.approvalUsersData = response.data;
      }).catch(function (error) {
        console.error('There was a problem with the approval users request:', error);
      });
    },
    isUserInApprovalList: function isUserInApprovalList() {
      var currentUserID = this.$root.getUser.$.user.UserID;
      if (Array.isArray(this.approvalUsersData)) {
        return this.approvalUsersData.some(function (user) {
          return user.Id === currentUserID && user.IsCurrentAction;
        });
      }
      return false;
    },
    handleButtonClick: function handleButtonClick(envelopeId) {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this6.getApprovalUsers(envelopeId);
            case 3:
              _this6.showApprovalUsers = true;
              _context3.next = 9;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              console.error('There was a problem handling the button click:', _context3.t0);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 6]]);
      }))();
    },
    getAccountSettings: function getAccountSettings(divisionId) {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this7.accountSettings[divisionId]) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              _this7.loadingAccountSettings = true;
              _context4.prev = 3;
              _context4.next = 6;
              return _this7.api.get("evedpaycards/accounts/".concat(divisionId, "/settings-by-division"));
            case 6:
              response = _context4.sent;
              if (response.status === 200) {
                _this7.accountSettings[divisionId] = response.data;
              }
              _context4.next = 13;
              break;
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](3);
              console.log(_context4.t0);
            case 13:
              _context4.prev = 13;
              _this7.loadingAccountSettings = false;
              return _context4.finish(13);
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[3, 10, 13, 16]]);
      }))();
    },
    singularize: function singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value;
    },
    exportEnvelope: function exportEnvelope() {
      window.open("".concat(this.api.env, "/evedpaycards/envelope/export/").concat(this.selectedRows[0].data.Id), '_blank');
    },
    createAPFile: function createAPFile() {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this8.creatingAPFile = true;
              payload = {
                envelopeIds: _this8.selectedRows.map(function (r) {
                  return r.data.Id;
                })
              };
              _context5.next = 4;
              return _this8.api.post(_this8.api.$.evedpaycard.createAPFile, payload);
            case 4:
              response = _context5.sent;
              if (response.data) {
                _context5.next = 10;
                break;
              }
              _this8.creatingAPFile = false;
              throw new Error('Error during the request');
            case 10:
              _this8.creatingAPFile = false;
              _this8.refresh();
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    pushToAccountingSystem: function pushToAccountingSystem() {
      var _this9 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this9.pushingToAccountingSystem = true;
              _context6.next = 3;
              return _this9.api.put("evedpaycards/envelope/push-to-accounting-system", {
                envelopeIds: _this9.selectedRows.map(function (r) {
                  return r.data.Id;
                })
              });
            case 3:
              response = _context6.sent;
              if (!(response.status !== 200)) {
                _context6.next = 9;
                break;
              }
              _this9.pushingToAccountingSystem = false;
              throw new Error('Error during the request');
            case 9:
              _this9.pushingToAccountingSystem = false;
              _this9.$notifications.notify({
                message: "The envelope(s) data has been sent to PSL+.",
                type: 'info',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _this9.refresh();
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    rowSelected: function rowSelected(event) {
      if (typeof event === 'boolean') {
        this.selectedAll = event;
      } else {
        this.selectedRows = event;
        if (this.highlightedEnvelopeId.length > 0 && !this.showCreateEnvelope && this.selectedRows.length > 0) {
          this.highlightedEnvelopeId = '';
          localStorage.setItem('row-highlight', '');
          this.redrawRows();
        }
        if (this.selectedRows.length === 1) {
          this.envelope = this.selectedRows[0].data;
          this.getApprovalUsers(this.envelope.Id);
          this.isUserInApprovalList();
          this.getAccountSettings(this.envelope.DivisionId);
        }
      }
    },
    envelopeActionDisabled: function envelopeActionDisabled(actionName) {
      return !!this.actionDisabledReason(actionName);
    },
    getEnvelope: function getEnvelope(envelopeId, FromDashboard) {
      var _this10 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return _this10.api.forms.post(_this10.api.$.evedpaycard.envelopes, {
                sort: 'CreatedDate',
                dir: 'ASC',
                start: 0,
                limit: 100,
                isLiveGrid: true,
                filter: JSON.stringify({
                  'EnvelopeId': envelopeId,
                  'Screen': FromDashboard ? 'Dashboard' : undefined,
                  searchTerm: ''
                })
              });
            case 3:
              response = _context7.sent;
              if (!(response && response.data)) {
                _context7.next = 6;
                break;
              }
              return _context7.abrupt("return", response.data.Data[0]);
            case 6:
              _context7.next = 11;
              break;
            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              console.error('Error while retrieving envelopes:', _context7.t0);
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 8]]);
      }))();
    },
    actionDisabledReason: function actionDisabledReason(actionName) {
      if (this.selectedRows.length === 0) {
        return cancelTooltip;
      }
      if (actionName === 'exportEnvelope') {
        if (this.selectedRows.length !== 1) {
          return 'You can only export one envelope at a time.';
        } else if (this.selectedRows.length === 1) {
          if (this.selectedRows[0].data.EnvelopeStatus === 'Draft') {
            return 'You cannot export draft envelopes.';
          }
          if (this.rejectedStatuses.includes(this.selectedRows[0].data.EnvelopeStatus)) {
            return 'You cannot export rejected envelopes.';
          }
        }
      }
      if (actionName === 'addTransactionNumber') {
        if (this.selectedRows.length === 0) {
          return 'Select an envelope.';
        }
        if (this.selectedRows.length === 1 && this.selectedRows[0].data.TransactionNo !== null) {
          return 'Envelope already has a transaction number.';
        }
        var hasTransactionNo = this.selectedRows.some(function (row) {
          return row.data.TransactionNo !== null;
        });
        var hasOtherStatus = this.selectedRows.some(function (row) {
          return row.data.EnvelopeStatus !== 'Exported - Approved' && row.data.EnvelopeStatus !== 'Exported - Waiting Approval';
        });
        var firstApFileId = this.selectedRows[0].data.ApFileId;
        var sameApFileId = this.selectedRows.every(function (row) {
          return row.data.ApFileId === firstApFileId;
        });
        if (hasTransactionNo || hasOtherStatus || !sameApFileId) {
          return 'All selected envelopes must be in the same AP File and without a Transaction Number.';
        }
      }
      if (actionName === 'createAPFile') {
        if (this.creatingAPFile) {
          return 'Creating AP File...';
        }
        if (this.selectedRows.length > 0) {
          var _iterator = _createForOfIteratorHelper(this.selectedRows),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var row = _step.value;
              if (row.data.APFile !== '' || row.data.EnvelopeStatus === 'Draft' || this.rejectedStatuses.includes(row.data.EnvelopeStatus)) {
                return 'You can only select envelopes that are not drafts, not rejected, and do not have an AP file.';
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          var _iterator2 = _createForOfIteratorHelper(this.selectedRows),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _row = _step2.value;
              if (!_row.data.CanGenerateAPFileWithoutApproval && _row.data.EnvelopeStatus !== 'Open - Approved') {
                return 'One or more envelopes need to be approved first.';
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
      if (actionName === 'pushToAccountingSystemAction') {
        if (this.pushingToAccountingSystem) {
          return 'Pushing to PSL+...';
        }
        if (this.selectedRows.length > 0) {
          var divisionLabel = this.$root.getUser.settings.Labels.DivisionName;
          var _iterator3 = _createForOfIteratorHelper(this.selectedRows),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _row2 = _step3.value;
              var accountSettings = this.accountSettings[_row2.data.DivisionId];
              if (!accountSettings || !accountSettings.AccountingSystem || accountSettings.AccountingSystem.SyncEvedPayCardEnvelopes !== true) {
                return "\"PSL+ Integration - Sync Envelope data\" is unchecked on one or more ".concat(divisionLabel);
              }
              if (!_row2.data.CardNumberKeyForAccountingSystem) {
                return 'Please first push card to PSL+ or assign the corresponding card number in PSL+ to the existing EVED card.';
              }
              if (_row2.data.EnvelopeStatus === 'Draft' || this.rejectedStatuses.includes(_row2.data.EnvelopeStatus)) {
                return 'You can only select envelopes that are not drafts or rejected.';
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }
      if (this.selectedRows.length > 0) {
        var _iterator4 = _createForOfIteratorHelper(this.selectedRows),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _row3 = _step4.value;
            if (!this.waitingApprovalStatuses.includes(_row3.data.EnvelopeStatus) && (actionName === 'approve' || actionName === 'reject')) {
              return 'You can only select envelopes awaiting approval.';
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      if (this.selectedRows.length > 1 && actionName === 'envelope') {
        return 'You can only open one envelope at a time.';
      }
    },
    updateUrlBackToEnvelopesPage: function updateUrlBackToEnvelopesPage() {
      if (this.isFromDashboard && window.parent !== window) {
        window.parent.postMessage({
          type: 'LEGACY_GO_TO_DASHBOARD'
        }, '*');
        return;
      }
      var page = this.$route.params.page;
      if (backToMap[page]) {
        window.location.href = "".concat(this.api.env).concat(backToMap[page]);
      } else {
        window.history.pushState({}, '', '#/d/Programs/>Card/envelopes');
      }
    },
    refresh: function refresh() {
      this.$refs.grid.refreshGrid();
    },
    redrawRows: function redrawRows() {
      this.$refs.grid.gridOptions.api.redrawRows();
    }
  }
});

/***/ }),

/***/ "KHPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options"},[_c('div',{staticClass:"col-md-12"},[_c('a',{staticClass:"close-icon",attrs:{"href":"#"},on:{"click":_vm.closeOptions}},[_c('i',{staticClass:"fal fa-fw fa-times"})]),_c('h4',[_c('i',{staticClass:"fas fa-cog"}),_vm._v("  "+_vm._s(_vm.options.title)+" Settings")]),_c('ed-form',{attrs:{"submit-visible":false}},[_vm._l((_vm.availableSettings),function(option,i){return (option.placement === _vm.placeholders.settings)?_c('div',{key:i,staticClass:"option-group"},[(option.label && _vm.relevantToDisplay(option))?_c('p',{staticClass:"option-label"},[_c('strong',[_vm._v(_vm._s(option.label))])]):_vm._e(),(option.type === "currencySelector")?_c(_vm.optionComponent(option.type),{tag:"component",staticClass:"inline stretch list col-md-7",attrs:{"name":option.name,"options":_vm.currencies,"placeholder":_vm.getValue(i, "currencies"),"label":"label","track-by":"key"},on:{"select":function($event){return _vm.setValue($event, i)}},model:{value:(_vm.settings[i].value),callback:function ($$v) {_vm.$set(_vm.settings[i], "value", $$v)},expression:"settings[i].value"}}):_vm._e(),(_vm.relevantToDisplay(option) && option.type !== "currencySelector")?_c(_vm.optionComponent(option.type),{tag:"component",staticClass:"inline stretch list col-md-7",attrs:{"name":option.name,"options":option.items,"placeholder":_vm.getValue(i),"label":"label","track-by":"key"},on:{"select":function($event){return _vm.setValue($event, i)}},model:{value:(_vm.settings[i].value),callback:function ($$v) {_vm.$set(_vm.settings[i], "value", $$v)},expression:"settings[i].value"}}):_vm._e(),_c('div',{staticClass:"clear"})],1):_vm._e()}),_c('div',{staticClass:"option-group"},[(_vm._value.reportFilters && _vm._value.reportFilters.length > 0)?_c('p',{staticClass:"option-label"},[_c('strong',[_vm._v("Report Settings")]),_c('ul',_vm._l((_vm._value.reportFilters),function(item,i){return _c('li',{key:i},[_c('span',[_vm._v(_vm._s(item.key)+": "+_vm._s(item.value))])])}),0)]):_vm._e()])],2)],1),_c('div',{staticClass:"clear"}),_c('div',{staticClass:"text-center"},[_c('ed-button',{attrs:{"endpoint":_vm.operations.savePending && _vm.endpoint},on:{"click":_vm.set}},[_vm._v("Save Widget")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KHxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{'loading': _vm.loading},style:(_vm.getChartHeightStyle)},[_c('div',{staticClass:"chart-header no-drag"},[(_vm.widget.dateRangeFilter.active)?_c('div',{staticClass:"date-row"},[_c('span',{staticClass:"section left"},[_c('span',{staticClass:"dateText"},[_vm._v(_vm._s(_vm.getDateText))])]),_c('span',{staticClass:"section right"},[_c('span',{class:_vm.last1MonthClasses,attrs:{"title":"Date Interval"},on:{"click":_vm.setDate1Month}},[_vm._v("1 - Month")]),_c('span',{staticClass:"dateSelector-v-divider"}),_c('span',{class:_vm.last3MonthsClasses,attrs:{"title":"Date Interval"},on:{"click":_vm.setDate3Months}},[_vm._v("3 - Months")]),_c('span',{staticClass:"dateSelector-v-divider"}),_c('span',{class:_vm.customIntervalClasses,attrs:{"title":"Date Interval"},on:{"click":_vm.handleDate}},[_vm._v("Custom")])])]):_vm._e(),(_vm.showChartHeaderRow && _vm.showChart && !_vm.showInChartLegend)?_c('div',{staticClass:"header-row"},[_c('span',{staticClass:"section left"},[(_vm.showBack)?_c('span',{staticClass:"back-action"},[_c('a',{staticClass:"fas back-button chart-back",attrs:{"href":"#","title":_vm.showTitleOnBack},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.drillDownFilterText))])]):_vm._e(),(!_vm.showBack && _vm.chartHeaderTitle)?_c('span',{staticClass:"chartHeaderText"},[_vm._v(_vm._s(_vm.chartHeaderTitle))]):_vm._e()]),(_vm.showChartHeaderRow)?_c('span',{staticClass:"section right"},[(this.widget.dateRangeFilter.active)?_c('span',{staticClass:"chartHeaderText"},[_vm._v(_vm._s(_vm.chartHeaderLabel))]):_vm._e()]):_vm._e()]):_vm._e()]),_c('div',{staticClass:"card-header card-chart",class:{ 'card-chart-tall': !_vm.showLegend, 'noData': !_vm.showChart},style:(_vm.customSettings.containterStyle),attrs:{"data-background-color":_vm.backgroundColor}},[(!_vm.showChart)?_c('div',{staticClass:"empty"},[_c('h3',{staticClass:"text-center"},[_c('br'),_c('i',{class:_vm.getNoDataIcon}),_c('br'),_c('p',{staticClass:"noData bold"},[_vm._v("No Results Found")]),_c('p',{staticClass:"noData light"},[_vm._v("Try changing the date range or filters")])])]):_vm._l((_vm.visibleSeries),function(chartCt,i){return _c('div',{staticClass:"ct-chart",class:{ 'hidden': !_vm.showChart },attrs:{"id":_vm.chartId(chartCt, i),"widgetId":_vm.widgetId(chartCt, i)}})}),(_vm.showInChartLegend && _vm.showChart)?_c('div',{staticClass:"inChartLegend"},[(!_vm.loading)?_c('div',{staticClass:"inChartLegendHead"},[_c('span',{staticClass:"section left"},[(_vm.showBack)?_c('span',{staticClass:"back-action"},[_c('a',{staticClass:"fas back-button chart-back",attrs:{"href":"#","title":_vm.showTitleOnBack},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.drillDownFilterText))])]):_vm._e(),(!_vm.showBack && _vm.chartHeaderTitle)?_c('span',{staticClass:"chartHeaderText"},[_vm._v(_vm._s(_vm.chartHeaderTitle))]):_vm._e()]),(_vm.showChartHeaderRow)?_c('span',{staticClass:"section right"},[(this.widget.dateRangeFilter.active)?_c('span',{staticClass:"chartHeaderText"},[_vm._v(_vm._s(_vm.chartHeaderLabel))]):_vm._e()]):_vm._e()]):_vm._e(),_c('dl',{staticClass:"legend"},_vm._l((_vm.chartData && _vm.chartData.labels),function(label,y){return _c('dt',{staticClass:"item ct-interaction-on",class:{ selected: _vm.selectedIndex === y },attrs:{"dataLabel":label}},[_c('span',{staticClass:"swatch events-off",class:("color-" + (_vm.colorStep(y, label, 0, 1)))}),_c('a',{staticClass:"key events-off"},[_vm._v(_vm._s(label))]),(_vm.chartComponent.components.labelValue)?_c(_vm.chartComponent.components.labelValue,{tag:"component",staticClass:"value events-off",attrs:{"currency":_vm.$parent.$parent.currency,"value":_vm.dataPointfromChart(_vm.chartData, y)}}):_c('a',{staticClass:"value events-off",attrs:{"dataLabel":label,"dataValue":_vm.dataPointfromChart(_vm.chartData, y)}},[_vm._v(_vm._s(_vm.thousandsFormat(_vm.dataPointfromChart(_vm.chartData, y), _vm.$parent.$parent.currency))+" ")])],1)}),0)]):_vm._e()],2),(_vm.showLegend && _vm.isDrilledDown)?_c('div',{staticClass:"card-content"},[(!_vm.hasTitleSlot && _vm.title)?_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("title"),_c('p',{staticClass:"category"},[_vm._t("subTitle")],2)],2):_vm._e(),(_vm.showChart)?_c('div',{staticClass:"card-footer",style:(!_vm.showInChartLegend ? "" : "border-color: white")}):_vm._e(),(_vm.showSmallLegend)?_c('div',{staticClass:"legend-small"},[_c('div',{staticClass:"legend"},_vm._l((_vm.getSmallLegendData && _vm.getSmallLegendData),function(series,y){return _c('div',{staticClass:"item no-border"},[_c('span',{staticClass:"swatch",class:{'line': series.type === 'Line'},style:({"background-color": series.color})}),_c('a',{staticClass:"key"},[_vm._v(_vm._s(series.name))])])}),0),(_vm.showLegend)?_c('div',{staticClass:"stats"},[_vm._t("footer",function(){return [_c('dl',{staticClass:"legend"},_vm._l((_vm.chartData && _vm.chartData.labels),function(label,y){return (y < 5)?_c('dt',{staticClass:"item",class:{ selected: _vm.selectedIndex === y }},[_c('span',{staticClass:"swatch",class:("color-" + (_vm.colorStep(y, label, 0, 1)))}),_c('a',{staticClass:"key"},[_vm._v(_vm._s(label))]),(_vm.chartComponent.components.labelValue)?_c(_vm.chartComponent.components.labelValue,{tag:"component",staticClass:"value",attrs:{"currency":_vm.$parent.currency,"value":_vm.dataPoint(_vm.chartData, y)}}):_c('a',{staticClass:"value"},[_vm._v(_vm._s(_vm.dataPoint(_vm.chartData, y)))])],1):_vm._e()}),0)]})],2):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KMZP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KMvX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("7F1v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ea45ac0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("KHxi");
function injectStyle (ssrContext) {
  __webpack_require__("RJEM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ea45ac0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ea45ac0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KOC9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3eE7oFLYo-7-Wq3lUmdbI4","Dell":"_2JThzgTSq76bQxFoUNBPVg","Abbott":"_2zFOJA01znU0Om7vxpzxJX","Gap":"_9IexqVFFSnce8mJ3mezEi","Allstate":"_1D5vZbz5vzsw2KKZ0e53sf","Asurion":"_3Yc8DOlxkctaetzeW9WY7b","Invitae":"_2sv5KcS8KdKV4EWk4W_--L","JWE":"_4Xf3X9mQLnO_4Waab8QEW"};

/***/ }),

/***/ "KSS+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LineItemStore_js__ = __webpack_require__("PJql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AllocateToCC',
  props: {
    model: Object,
    eventHub: Object,
    dependencies: Object,
    eventUniqueId: String
  },
  data: function data() {
    return {
      formData: {
        draftItem: {
          selectedCostCenter: {}
        }
      },
      show: true,
      title: 'Allocate to Cost Center',
      validation: true,
      costCenters: [],
      selectedRows: [],
      selectedItemNames: [],
      doDisplayCostCenterError: false
    };
  },
  created: function created() {
    var dialog = this;
    this.title = 'Allocate to Cost Center';
    this.selectedRows = this.model.selectedRows;
    this.selectedItemNames = this.model.selectedRows.map(function (item) {
      return item.data.name;
    });
    this.store().getCostCentersBusinessUnits(this.model.programId).then(function (response) {
      dialog.bindCostCenters(response.data);
    });
  },
  methods: {
    getCostCenterName: function getCostCenterName(option) {
      return option.name ? option.name.indexOf(option.code) === -1 ? option.code + ' (' + option.name + ')' : option.name : option.code;
    },
    costCenterSelected: function costCenterSelected(e) {
      this.formData.draftItem.selectedCostCenter = {
        code: e.code,
        name: e.name,
        key: e.key
      };
      this.doDisplayCostCenterError = false;
    },
    store: function store() {
      return new __WEBPACK_IMPORTED_MODULE_0__LineItemStore_js__["a" /* default */](this.api);
    },
    onClose: function onClose() {
      this.show = false;
    },
    onSave: function onSave() {
      var _this = this;
      if (!this.isValid()) return;
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$emit('onSaveAllocateToCC', {
        data: {
          costCenter: this.formData.draftItem.selectedCostCenter,
          itemsToUpdate: this.selectedRows.map(function (item) {
            return item.rowIndex;
          }),
          eventUniqueId: this.eventUniqueId
        }
      });
      this.$nextTick(function () {
        _this.show = false;
      });
    },
    isValid: function isValid() {
      if (this.formData.draftItem.selectedCostCenter && JSON.stringify(this.formData.draftItem.selectedCostCenter) !== JSON.stringify({}) && this.formData.draftItem.selectedCostCenter.key && this.formData.draftItem.selectedCostCenter.name) {
        this.doDisplayCostCenterError = false;
        return true;
      }
      this.doDisplayCostCenterError = true;
      return false;
    },
    bindCostCenters: function bindCostCenters(data) {
      var costCenters = data.costCentersAndBusinessUnit.costCenters;
      if (costCenters !== null && costCenters !== undefined && costCenters.length > 0) {
        this.costCenters = costCenters;
        if (this.selectedRows.length === 1) {
          var selectedCC = this.selectedRows[0].data.costCenterAndBusinessUnit;
          var cc = {
            key: selectedCC.costCenterNo,
            name: selectedCC.costCenterName
          };
          cc.code = costCenters.filter(function (item) {
            return item.name === selectedCC.costCenterName && item.key === selectedCC.costCenterNo;
          })[0].code || '';
          this.formData.draftItem.selectedCostCenter = {
            key: cc.key,
            name: cc.name,
            code: cc.code
          };
        }
      }
    }
  }
});

/***/ }),

/***/ "KT2o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__ = __webpack_require__("oFCi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa21099c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__ = __webpack_require__("rjke");
function injectStyle (ssrContext) {
  __webpack_require__("Ykzl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa21099c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa21099c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KWFF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    divisionKey: Number,
    model: Object,
    paymentMethods: Object,
    userToken: String
  },
  created: function created() {
    var _this = this;
    this.$nextTick(function () {
      _this.selectFirstCostCenter();
      _this.initEvents();
    });
  },
  activated: function activated() {
    this.errors.PaidByMissing = false;
    this.errors.PaymentMethodMissing = false;
    this.errors.ReferenceNoMissing = false;
    this.errors.CostCenterMissing = false;
    this.initEvents();
  },
  deactivated: function deactivated() {
    this.paidBy = {};
    this.paymentMethod = {};
    this.costCenter = {};
    this.attachment = {};
    this.referenceNo = '';
    this.paymentNotes = '';
  },
  computed: {
    displayCostCenters: function displayCostCenters() {
      return this.model.CostCenters.length > 0 && this.isCreditCardMethod;
    },
    isCreditCardMethod: function isCreditCardMethod() {
      return this.paymentMethod && this.paymentMethod.Value && this.paymentMethod.Value.indexOf('Credit Card') === 0;
    }
  },
  data: function data() {
    return {
      uploadFinished: true,
      uploadData: {
        token: this.userToken
      },
      paymentNotes: '',
      referenceNo: '',
      attachment: {},
      costCenter: {},
      paymentMethod: {},
      paidBy: {},
      paidByOptions: [{
        Key: 1,
        Value: 'Paid by MSP'
      }, {
        Key: 2,
        Value: 'Paid Outside of MSP'
      }],
      errors: {
        PaidByMissing: false,
        PaymentMethodMissing: false,
        ReferenceNoMissing: false,
        CostCenterMissing: false
      }
    };
  },
  methods: {
    initEvents: function initEvents() {
      var _this2 = this;
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].PAYMENT.VALIDATE_POST_PAYMENT_FIELDS + this.divisionKey);
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].PAYMENT.VALIDATE_POST_PAYMENT_FIELDS + this.divisionKey, function (e) {
        _this2.validate();
      });
    },
    validate: function validate() {
      var data = this.getChanges();
      if (this.model.DisplayPaidBy && data.paidBy === '') {
        this.errors.PaidByMissing = true;
      } else {
        this.errors.PaidByMissing = false;
      }

      // Payment Method
      if (data.paymentMethodId === 0) {
        this.errors.PaymentMethodMissing = true;
      } else {
        this.errors.PaymentMethodMissing = false;
      }

      // Reference No
      if (data.referenceNo === '') {
        this.errors.ReferenceNoMissing = true;
      } else {
        this.errors.ReferenceNoMissing = false;
      }

      // Cost Center
      if (data.validateCostCenter && data.costCenterId === 0) {
        this.errors.CostCenterMissing = true;
      } else {
        this.errors.CostCenterMissing = false;
      }
    },
    selectFirstCostCenter: function selectFirstCostCenter() {
      if (this.model.CostCenters && this.model.CostCenters.length === 1) {
        this.costCenter = this.model.CostCenters[0];
        this.emitChanges();
      }
    },
    paymentMethodChanged: function paymentMethodChanged(e) {
      this.paymentMethod = e; // TODO: remove
      this.emitChanges();
    },
    paidByChanged: function paidByChanged(e) {
      this.paidBy = e;
      this.emitChanges();
    },
    costCenterChanged: function costCenterChanged(e) {
      this.costCenter = e;
      this.emitChanges();
    },
    saveAttachment: function saveAttachment(e) {
      var completedFiles = e.filter(function (item) {
        return item.success ||
        // files uploaded with success
        !item.success && item.response && typeof item.response === 'string' && !utils.json.valid(item.response);
      } // files where requested failed
      );
      if (completedFiles.length === e.length) {
        this.uploadFinished = true;
        this.attachment = e.map(function (item) {
          var uploadError = '';
          var itemResponse = null;
          if (item.success && item.response) {
            itemResponse = JSON.parse(item.response);
            uploadError = itemResponse && itemResponse.uploadError ? itemResponse.uploadError : '';
          }
          if (!item.success) {
            uploadError = 'Upload request failed';
          }
          if (uploadError) {
            // TODO: display upload error: 'File "' + item.name + '": ' + uploadError
          } else {
            return {
              AttachmentName: item.name,
              AttachmentSize: item.size,
              AttachmentFile: itemResponse ? itemResponse.file : item.file || '',
              AttachmentId: item.id || 0,
              AttachmentPath: itemResponse ? itemResponse.path : ''
            };
          }
        }).shift();
      }
      this.emitChanges();
    },
    getChanges: function getChanges() {
      return {
        divisionOrBUName: this.model.DivisionOrBUName,
        note: this.paymentNotes || '',
        attachment: this.attachment,
        referenceNo: this.referenceNo || '',
        costCenterId: parseInt(this.costCenter && this.costCenter.Key) || 0,
        validateCostCenter: this.displayCostCenters,
        paidBy: this.paidBy && this.paidBy.Key || '',
        paymentMethodId: parseInt(this.paymentMethod && this.paymentMethod.Key) || 0
      };
    },
    emitChanges: function emitChanges() {
      var data = this.getChanges();
      this.updateValidation(data);
      this.$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].PAYMENT.DIVISION_FIELDS_CHANGES, data);
    },
    updateValidation: function updateValidation(data) {
      if (data.paymentMethodId > 0) {
        this.errors.PaymentMethodMissing = false;
      }
      if ((data.referenceNo || '') !== '') {
        this.errors.ReferenceNoMissing = false;
      }
      if (data.validateCostCenter && (parseInt(data.costCenterId) || 0) !== 0) {
        this.errors.CostCenterMissing = false;
      }
      if ((data.paidBy || '') !== '') {
        this.errors.PaidByMissing = false;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "KXg4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MakePayment_vue__ = __webpack_require__("DQZf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d71b88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MakePayment_vue__ = __webpack_require__("pfsV");
function injectStyle (ssrContext) {
  __webpack_require__("vvpf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24d71b88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MakePayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d71b88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MakePayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KZ6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_lang__ = __webpack_require__("pe4m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var defaultFormat = 'MM/DD/YYYY';
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      date: null,
      range: null,
      dateFormat: global.app.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat,
      formattedRange: null,
      columnTitle: ''
    };
  },
  created: function created() {
    this.columnTitle = this.params.colDef.headerName;
  },
  methods: {
    t: function t(key) {
      return __WEBPACK_IMPORTED_MODULE_0__lang_lang__["a" /* i18n */].t(key);
    },
    getModel: function getModel() {
      return {
        filter: this.range,
        formattedFilter: this.formattedRange
      };
    },
    setModel: function setModel(model) {
      if (model && model.filter) {
        this.date = model.filter;
      }
      if (model === null) {
        this.date = null;
        this.range = null;
        this.formattedRange = null;
      }
    },
    isFilterActive: function isFilterActive() {
      return this.date !== null && this.date !== undefined && this.date !== '';
    },
    setRange: function setRange(value) {
      var start = global.moment(this.date && this.date[0]).format(defaultFormat);
      var end = global.moment(this.date && this.date[1]).format(defaultFormat);
      // this.range = value
      this.range = "".concat(start, "_").concat(end);
    },
    setFormattedDate: function setFormattedDate(value) {
      var start = global.moment(value.start).format(this.dateFormat);
      var end = global.moment(value.end).format(this.dateFormat);
      this.formattedRange = "".concat(start, "_").concat(end);
    },
    apply: function apply() {
      this.params.filterChangedCallback();
    },
    clear: function clear() {
      this.setModel(null);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "KgQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"OmlGqE4Y5akyNryrxGflJ","Dell":"_3GOHmxbDb8CpecVgrgdVAT","Abbott":"_6KVWdg8nWurMZkAGbw-w9","Gap":"_3WWbxai4VinGCUxVwAsnQC","Allstate":"_2CE5L5LfpLBk2gDIWvwSTM","Asurion":"_2dB1Cnz2Sa0XxT0psHQ0hn","Invitae":"_2BM54tCSCDRx_fvjA0WmbV","JWE":"_1Y3wcZZZnjlPQYKdGo1g8J"};

/***/ }),

/***/ "KmXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-tab-nav',{staticClass:"uniform",attrs:{"workflow":""}},[_c('ed-tab',{attrs:{"title":"Completed Agenda","completed":true,"icon":['fal', 'list-alt']}},[_c('project-agenda')],1),_c('ed-tab',{attrs:{"title":"Project Information","active":true,"icon":['fal', 'clipboard']}},[_c('project-information')],1),_c('ed-tab',{attrs:{"title":"Clients","completed":true,"icon":['fal', 'address-book']}},[_c('project-clients')],1),_c('ed-tab',{attrs:{"title":"Services","icon":['fal', 'shopping-basket']}},[_c('p',[_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.create}},[_vm._v("Create!")])],1)]),_c('ed-tab',{attrs:{"title":"Design & Layout","icon":['fal', 'paint-brush']}},[_c('project-design')],1),_c('ed-tab',{attrs:{"title":"Project Settings","icon":['fal', 'rocket']}},[_c('project-settings')],1)],1),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ed-button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showModal1 = true}}},[_vm._v("Launch Modal 1")]),_c('ed-modal',{attrs:{"show":_vm.showModal1,"title":"Budget Information","subtitle":"Tell us about your budget."},on:{"close":function($event){_vm.showModal1 = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('program-list',{attrs:{"legacy":"true","layout":"small"}})],1)])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kn9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"request-batch-overlay"},[_c('div',{staticClass:"virtual-cards-section"},[_c('p',{staticClass:"description-text"},[_vm._v("Select one or more virtual cards to order a batch of physical cards.")]),_vm._v(" "),_c('h5',{staticStyle:{"font-weight":"bold !important"}},[_vm._v("Virtual Cards")]),_vm._v(" "),(_vm.allCardIds.length)?_c('div',{staticClass:"select-all-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],attrs:{"type":"checkbox","id":"selectAllCards"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,null)>-1:(_vm.selectAll)},on:{"change":function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"selectAllCards"}},[_vm._v("Select All")])]):_vm._e(),_vm._v(" "),(_vm.sortedFilteredCards && _vm.sortedFilteredCards.length)?_c('div',{staticClass:"virtual-cards-list"},_vm._l((_vm.sortedFilteredCards),function(card){return _c('div',{key:card.Id,staticClass:"virtual-card-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCards),expression:"selectedCards"}],attrs:{"type":"checkbox"},domProps:{"value":card.Id,"checked":Array.isArray(_vm.selectedCards)?_vm._i(_vm.selectedCards,card.Id)>-1:(_vm.selectedCards)},on:{"change":function($event){var $$a=_vm.selectedCards,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=card.Id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedCards=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedCards=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedCards=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.holderDisplay(card.Holder, card.NameOnCard))+" "+_vm._s(card.CardNumber))])])}),0):_vm._e(),_vm._v(" "),(_vm.list && _vm.list.length)?_c('div',{staticClass:"virtual-cards-list"},_vm._l((_vm.list),function(cardNode){return _c('div',{key:cardNode.data.Id,staticClass:"virtual-card-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCards),expression:"selectedCards"}],attrs:{"type":"checkbox"},domProps:{"value":cardNode.data.Id,"checked":Array.isArray(_vm.selectedCards)?_vm._i(_vm.selectedCards,cardNode.data.Id)>-1:(_vm.selectedCards)},on:{"change":function($event){var $$a=_vm.selectedCards,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=cardNode.data.Id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedCards=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedCards=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedCards=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.holderDisplay(cardNode.data.Holder, cardNode.data.NameOnCard))+" "+_vm._s(cardNode.data.CardNumber))])])}),0):_vm._e()]),_vm._v(" "),_c('p',[_vm._v("Provide a mailing address to send the selected cards.")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"country"}},[_vm._v("Country")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select a country...","options":_vm.countries,"label":"CountryName","track-by":"CountryID","openEndpoint":_vm.api.$.profile.getAllCountries,"error":_vm.doDisplayCountryError,"helptip-header":_vm.doDisplayCountryError && 'Error' || '',"helptip-body":_vm.doDisplayCountryError && 'Please select a country' || '',"disabled":_vm.disableControls,"name":"supplier_country"},on:{"input":function (o) { return _vm.mailingAddress.country = o; },"select":function($event){return _vm.countrySelected($event)},"open":_vm.fetchCountriesOnOpen,"keyup":_vm.fetchCountries,"close":_vm.restoreCountries},model:{value:(_vm.formData.country),callback:function ($$v) {_vm.$set(_vm.formData, "country", $$v)},expression:"formData.country"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"name","placeholder":"Name","maxlength":"40"},on:{"input":function (o) { return _vm.mailingAddress.name = o; }},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),(_vm.errors.name)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.name))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"address"}},[_vm._v("Address")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"address","placeholder":"Address","maxlength":"26"},on:{"input":function (o) { return _vm.mailingAddress.line1 = o; }},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),(_vm.errors.line1)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.line1))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","field-label":"Address Line 2","id":"addressLine2","placeholder":"Address Line 2","maxlength":"26"},on:{"input":function (o) { return _vm.mailingAddress.line2 = o; }},model:{value:(_vm.addressLine2),callback:function ($$v) {_vm.addressLine2=$$v},expression:"addressLine2"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"city","placeholder":"City","maxlength":"25"},on:{"input":function (o) { return _vm.mailingAddress.city = o; }},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}}),_vm._v(" "),(_vm.errors.city)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.city))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-item"},[_c('label',{attrs:{"for":"state"}},[_vm._v("State")]),_vm._v(" "),(_vm.isUS())?_c('ed-select',{attrs:{"options":_vm.USstates,"label":"StateName","track-by":"StateID","name":"us_states"},on:{"input":function (o) { return _vm.mailingAddress.state = o; },"open":_vm.fetchUSStatesOnOpen,"keyup":_vm.fetchUSStates,"close":_vm.restoreUSStates},model:{value:(_vm.formData.state),callback:function ($$v) {_vm.$set(_vm.formData, "state", $$v)},expression:"formData.state"}}):_vm._e(),_vm._v(" "),(_vm.isCanada())?_c('ed-select',{attrs:{"placeholder":"Select a region","options":_vm.canadaStates,"label":"StateName","disabled":_vm.disableControls,"name":"canada_states"},on:{"input":function (o) { return _vm.mailingAddress.state = o; },"open":_vm.fetchCanadaStatesOnOpen,"keyup":_vm.fetchCanadaStates,"close":_vm.restoreCanadaStates},model:{value:(_vm.formData.canadaState),callback:function ($$v) {_vm.$set(_vm.formData, "canadaState", $$v)},expression:"formData.canadaState"}}):_vm._e(),_vm._v(" "),(!_vm.formData.country || !_vm.isCanada() && !_vm.isUS())?_c('ed-input',{attrs:{"placeholder":"Select a region","disabled":_vm.disableControls,"name":"state_region"},on:{"input":function (o) { return _vm.mailingAddress.state = o; }},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}}):_vm._e(),_vm._v(" "),(_vm.errors.state)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.state))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"input-group-item"},[_c('label',{attrs:{"for":"zipCode"}},[_vm._v("Zip Code")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"zipCode","placeholder":"Zip Code","maxlength":"5"},on:{"input":function (o) { return _vm.mailingAddress.zip = o; }},model:{value:(_vm.zipCode),callback:function ($$v) {_vm.zipCode=$$v},expression:"zipCode"}}),_vm._v(" "),(_vm.errors.zip)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.zip))]):_vm._e()],1)])]),_vm._v(" "),(this.allowRushPhysicalCards)?_c('hr'):_vm._e(),_vm._v(" "),(this.allowRushPhysicalCards)?_c('div',{staticClass:"form-group",class:{ 'is-disabled-field': _vm.isRushDisabled }},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n        For a fee, physical cards can be sent via expedited shipping.\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.rushDisabledReason),expression:"rushDisabledReason"}],staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rushOrder),expression:"rushOrder"}],attrs:{"type":"checkbox","id":"rushOrder","disabled":_vm.isRushDisabled},domProps:{"checked":Array.isArray(_vm.rushOrder)?_vm._i(_vm.rushOrder,null)>-1:(_vm.rushOrder)},on:{"change":function($event){var $$a=_vm.rushOrder,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rushOrder=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rushOrder=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rushOrder=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"small",attrs:{"for":"rushOrder"}},[_vm._v("Rush shipment of this physical card order")])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"rushOrder"}},[_vm._v("Rush Order - "),_c('span',{staticClass:"optional-text"},[_vm._v("optional")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kq2q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{ 'label-floating' : _vm.labelFloating }},[(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.type === 'textarea')?_c('textarea',_vm._b({staticClass:"form-control",on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'textarea',_vm.$props,false)):_c('input',_vm._b({staticClass:"form-control",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$props,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KuSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    config: null,
    layoutCols: {
      type: Number,
      default: 12
    }
  }
});

/***/ }),

/***/ "KvOe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1-B5TyvvVYsi-BtRDLGtSu","Dell":"_2yiPWClRVVj-dbcUBDK8cN","Abbott":"_2wNTd69NrkXHV0YjQKIhLb","Gap":"_1iTRg-_fJFTSgpsdxcR_aF","Allstate":"_2KNXfzgxbuS5CBjynSC3MO","Asurion":"_1rmswZ_MMYE57HROq_r9r6","Invitae":"_3AKyg1aTh38JXMUsYVEXRY","JWE":"_1eBG1Xcj3ktHUBWWV0ZUVv"};

/***/ }),

/***/ "Ky1X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object
  },
  data: function data() {
    return {
      attachments: []
    };
  },
  methods: {
    getAttachmentPath: function getAttachmentPath(item) {
      return this.api.$.privateResources + 'MediaFiles/' + item.AttachmentFile;
    }
  },
  created: function created() {
    if (this.model && this.model.Data) {
      var data = JSON.parse(this.model.Data);
      this.attachments = data.Attachments;
    }
  }
});

/***/ }),

/***/ "L4ZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_site_map__ = __webpack_require__("xwEy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_search__ = __webpack_require__("XU2j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navbar_right__ = __webpack_require__("P4e5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['reference'],
  data: function data() {
    return {
      featureFlags: __WEBPACK_IMPORTED_MODULE_0__core_feature_flags_feature_flags__["a" /* default */],
      config: global.config,
      tabsClass: {
        value: ''
      }
    };
  },
  computed: {
    checkLogin: function checkLogin() {
      return this.$store.state.isLoggedIn;
    }
  },
  components: {
    SiteMap: __WEBPACK_IMPORTED_MODULE_1__core_site_map__["a" /* default */],
    NavbarSearch: __WEBPACK_IMPORTED_MODULE_2__navbar_search__["a" /* default */],
    NavbarRight: __WEBPACK_IMPORTED_MODULE_3__navbar_right__["a" /* default */]
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$emit('toggleSideBar');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "L7GG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return json; });
var json = {
  valid: function valid(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
};

/***/ }),

/***/ "L8OT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['context', 'headerCheckbox'],
  computed: {
    tooltip: function tooltip() {
      return this.headerCheckbox ? 'Click to select all rows' : 'Select this row for more actions';
    },
    offset: function offset() {
      return (this.context || {}).dragRows;
    }
  },
  methods: {
    click: function click() {
      var checkbox = elCheckbox.call(this);
      checkbox.click();
    },
    hover: function hover() {
      var checkbox = elCheckbox.call(this);
      checkbox.className += ' hover';
    },
    blur: function blur() {
      var checkbox = elCheckbox.call(this);
      checkbox.className = checkbox.className.replace(' hover', '');
    }
  }
});
function elCheckbox() {
  var checkbox = this.headerCheckbox ? '[class^="ag-checkbox-"]:not(.ag-hidden) .ag-icon' : '.ag-selection-checkbox .ag-icon:not(.ag-hidden)';
  return (this.headerCheckbox || this.params.eGridCell).querySelector("".concat(checkbox));
}

/***/ }),

/***/ "L9A4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen content"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-generic"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-generic"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper- wrapper-full-page- section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("You've found a loophole")]),_vm._v(" "),_c('h3',{staticClass:"title"},[_c('i',{staticClass:"fas fa-bullhorn"}),_vm._v("   But it seems that this page doesn't lead anywhere")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LBCZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1Pkd3eGSovkQYpXkLTqvzu","Dell":"_3TJBBpCOhCOIYXjQMSF2fl","Abbott":"_3xLICnoYHmTzDtVX2KZcZn","Gap":"_2sBX-lZYjaEZlrpj1AL7mD","Allstate":"_2zMwUzsHlPgC7XdUiSzZ1G","Asurion":"_3Mqp1kJ6zTCpEPI3hpE6he","Invitae":"_2eSH1wfTvhwqpe88peNWoV","JWE":"_1sdvLL6ImRzyulpheOPdrw"};

/***/ }),

/***/ "LDBD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("8S0J");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8062f09e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("aC/2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8062f09e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LTwu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1y6sBAXqZGzYDxXOHcWrj2","Dell":"_1TsMhWf7TTXdRRcv7WY0J8","Abbott":"_1ctcIDr1FZU3GnLiNZ_Oh3","Gap":"HWO61-BRXAN-_nPwLaJmn","Allstate":"i3HNhXL7MaOTH0Zwzh0h","Asurion":"_1LutVxPOsxLPkips7BkGS6","Invitae":"UScvx1IInurjn31FyJvNH","JWE":"_1o4P5kfWMpVLcWskwnAja-"};

/***/ }),

/***/ "LYfl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object,
    showModal: Boolean
  },
  data: function data() {
    return {
      statesRegions: [],
      fundingAddress: this.model.newAddress,
      countries: [],
      originalCountries: [],
      USStates: [],
      USOriginalStates: [],
      canadaStates: [],
      originalCanadaStates: [],
      counter: 0,
      doDisplayDivisionsError: false,
      doDisplayBUError: false,
      doDisplayFundingEntityNameError: false,
      doDisplayEmailError: false,
      hasAPSettingsByBU: this.model.HasAPSettingsByBU,
      payload: {
        VendorAddressId: this.model.newAddress.VendorAddressId || 0
      },
      divisions: this.model.edit ? this.model.newAddress.Divisions : [],
      businessUnits: this.model.edit ? this.model.newAddress.BusinessUnits : []
    };
  },
  computed: {
    title: function title() {
      return this.model.edit ? 'Edit Funding Address' : 'Add Funding Address';
    }
  },
  methods: {
    selectDivision: function selectDivision() {
      this.doDisplayDivisionsError = false;
    },
    selectBusinessUnit: function selectBusinessUnit() {
      this.doDisplayBUError = false;
    },
    fetchCountriesOnOpen: function fetchCountriesOnOpen() {
      var _this = this;
      if (this.countries.length) {} else {
        this.api.forms.post(this.api.$.profile.getAllCountries, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this.countries = r.data.Data;
            _this.originalCountries = r.data.Data;
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    fetchCountries: function fetchCountries(value) {
      var _this2 = this;
      this.counter || this.api.forms.post(this.api.$.profile.getAllCountries, {
        q: value || ''
      }).then(function (r) {
        _this2.counter = 0;
        if (r && r.data && r.data.Data) {
          _this2.countries = r.data.Data;
        }
      }).catch(function (e) {
        console.warn(e);
        _this2.counter = 0;
      });
      this.counter = 1;
    },
    restoreCountries: function restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries);
      }
    },
    countrySelected: function countrySelected(e) {
      this.doDisplayCountryError = false;
      this.resetState(e.CountryName);
    },
    resetState: function resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.model.newAddress.state = {
          StateID: 0,
          StateName: ''
        };
        this.model.newAddress.CanadaState = {
          StateID: 0,
          StateName: ''
        };
        this.model.newAddress.region = '';
      } else {
        this.originalCountryName = countryName;
      }
    },
    // Fetch States on search text
    fetchUSStates: function fetchUSStates(value) {
      var url = this.getStatesUSURL();
      this.fetchStates(value, url);
    },
    getStatesUSURL: function getStatesUSURL() {
      return this.api.$.profile.getAllStates;
    },
    getStatesCanadaURL: function getStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates;
    },
    fetchCanadaStates: function fetchCanadaStates(value) {
      var url = this.getStatesCanadaURL();
      this.fetchStates(value, url);
    },
    fetchStates: function fetchStates(value, url) {
      var _this3 = this;
      this.counter || this.api.forms.post(url, {
        q: value || ''
      }).then(function (r) {
        _this3.counter = 0;
        if (r && r.data && r.data.Data) {
          _this3.mapStatesDataOnFetch(r.data.Data);
        }
      }).catch(function (e) {
        console.warn(e);
        _this3.counter = 0;
      });
      this.counter = 1;
    },
    mapStatesDataOnFetch: function mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USStates = data;
      } else {
        this.canadaStates = data;
      }
    },
    // Fetch States on OPEN
    fetchUSStatesOnOpen: function fetchUSStatesOnOpen() {
      var url = this.getStatesUSURL();
      this.fetchStatesOnOpen(this.USStates, url);
    },
    fetchCanadaStatesOnOpen: function fetchCanadaStatesOnOpen() {
      var url = this.getStatesCanadaURL();
      this.fetchStatesOnOpen(this.canadaStates, url);
    },
    fetchStatesOnOpen: function fetchStatesOnOpen(states, url) {
      var _this4 = this;
      if (states.length && (this.isCanada() || this.isUS())) {} else {
        this.api.forms.post(url, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this4.mapStatesDataOnOpen(r.data.Data);
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    mapStatesDataOnOpen: function mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USStates = this.USOriginalStates = data;
      } else {
        this.canadaStates = this.originalCanadaStates = data;
      }
    },
    // Restore States
    restoreUSStates: function restoreUSStates() {
      this.restoreStates(this.USStates, this.USOriginalStates);
    },
    restoreCanadaStates: function restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates);
    },
    restoreStates: function restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates);
      }
    },
    isCanada: function isCanada() {
      return this.model.newAddress.Country && this.model.newAddress.Country.CountryName === 'Canada';
    },
    isUS: function isUS() {
      return this.model.newAddress.Country && this.model.newAddress.Country.CountryName === 'United States';
    },
    onSave: function onSave() {
      var _this5 = this;
      if (!this.isValid()) return;
      var VendorAddressDTO = {
        VendorAddressId: this.model.newAddress.VendorAddressId,
        Name: this.model.newAddress.FundingEntityName,
        EntityLegalName: this.model.newAddress.EntityLegalName,
        Address: this.model.newAddress.Address,
        Address2: this.model.newAddress.Address2,
        CountryId: this.model.newAddress.Country.CountryID,
        Country: this.model.newAddress.Country.CountryName,
        StateId: this.isUS() ? this.model.newAddress.State.StateID : null,
        StateName: this.isUS() ? this.model.newAddress.State.StateName : '',
        Region: this.isCanada() ? this.model.newAddress.CanadaState.StateName : this.model.newAddress.Region,
        City: this.model.newAddress.City,
        Zip: this.model.newAddress.ZipCode,
        VatNo: this.model.newAddress.VatId,
        EIN: this.model.newAddress.EIN,
        Email: this.model.newAddress.Email || ''
      };
      var param = {
        VendorAddressDTO: VendorAddressDTO,
        DivisionsIds: this.divisions,
        BusinessUnitIds: this.businessUnits
      };
      if (!this.model.edit) {
        this.api.post(this.api.$.FundingInvoiceAndApSetting.saveFundingAddress, param).then(function (r) {
          _this5.$emit('save');
        });
      } else {
        this.api.post(this.api.$.FundingInvoiceAndApSetting.updateFundingAddress, param).then(function (r) {
          _this5.$emit('save');
        });
      }
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validateMultiemails: function validateMultiemails(emails) {
      var multiEmails = emails.split(';');
      for (var i = 0; i < multiEmails.length; i++) {
        if (!this.validateEmail(multiEmails[i])) {
          return false;
        }
      }
      return true;
    },
    isValid: function isValid() {
      var result = true;
      if (!(this.model.newAddress.FundingEntityName.length && this.model.newAddress.FundingEntityName.length > 0)) {
        this.doDisplayFundingEntityNameError = true;
        result = false;
      }
      if (!(this.model.newAddress.Email.length && this.model.newAddress.Email.length > 0) || !this.validateMultiemails(this.model.newAddress.Email)) {
        this.doDisplayEmailError = true;
        result = false;
      }
      if (!this.hasAPSettingsByBU && this.divisions && this.divisions.length <= 0) {
        this.doDisplayDivisionsError = true;
        result = false;
      }
      if (this.hasAPSettingsByBU && this.businessUnits && this.businessUnits.length <= 0) {
        this.doDisplayBUError = true;
        result = false;
      }
      return result;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "LZPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReplaceApFile_vue__ = __webpack_require__("lW6o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1721b168_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReplaceApFile_vue__ = __webpack_require__("UftQ");
function injectStyle (ssrContext) {
  __webpack_require__("aISH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1721b168"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReplaceApFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1721b168_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReplaceApFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LfIE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tabs = function tabs() {
  return [ACCOUNTS, CARDS, TRANSACTIONS, ENVELOPES];
};
/* harmony default export */ __webpack_exports__["a"] = ({
  get tabs() {
    return tabs();
  }
});
var ACCOUNTS = {
  label: 'Accounts',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: undefined
    }
  }
};
var CARDS = {
  label: 'Cards',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: 'cards'
    }
  }
};
var TRANSACTIONS = {
  label: 'Transactions',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: 'transactions'
    }
  }
};
var ENVELOPES = {
  label: 'Envelopes',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: 'envelopes'
    }
  }
};

/***/ }),

/***/ "Lfy/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("VOe2");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4e6ee2c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("jIjg");
function injectStyle (ssrContext) {
  __webpack_require__("MKaH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4e6ee2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4e6ee2c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LnE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      card: []
    };
  },
  props: {
    approvalUsersData: Object
  },
  computed: {
    hasNextAssignedApprovers: function hasNextAssignedApprovers() {
      return this.approvalUsersData.some(function (user) {
        return !user.IsCurrentAction;
      });
    }
  },
  methods: {},
  created: function created() {}
});

/***/ }),

/***/ "LqNp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"c6093eaMLNJ4Se0fNYuS4","Dell":"zq_wXpsd0DfkHpIaw3Vfa","Abbott":"EfVR0gXCOfVehDj_LM1At","Gap":"_2sHHt__u5NhYNz2eNT5asn","Allstate":"_2qU9VJXXxElB4PzueXs4k1","Asurion":"r3iBqRKLW0vHfZGCU3G-u","Invitae":"H9p9Esi__hZY8824nt6od","JWE":"_3plNknd3M5ZLHRN8VqMhzT"};

/***/ }),

/***/ "Lqvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{ref:"header",attrs:{"title":_vm.$t("Import Invoice Data")}},[_c('span',{attrs:{"slot":"action"},slot:"action"},[(_vm.$root.legacySubtab)?_c('router-link',{attrs:{"to":"/d/Admin/Import"}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_c('span',[_vm._v("  "+_vm._s(_vm.$t('Back') + ' ' + _vm.$t('to') + ' ' + _vm.$t(_vm.$root.legacySubtab)))])]):_vm._e()],1)]),_c('div',{staticClass:"container-fluid"},[_c('ed-section',{staticClass:"active",attrs:{"offset":""}},[_c('ed-tab-nav',{ref:"steps",staticClass:"col-md-12 steps uniform",attrs:{"steps":"","wide":"","check":_vm.uploadFileValid},on:{"tabSelected":_vm.enterStep}},[_c('ed-tab',{attrs:{"title":"Import File"}},[_c('ed-section',{staticClass:"wide-section -col-md-9 active",attrs:{"offset":"0"}},[_c('h5',[_vm._v("Import your invoice data file")]),_c('p',[_vm._v("Imports will update existing or create new invoices based on looking at\nthe Invoice IDs of existing invoices in Eved.\nFields in the Invoice Information, Supplier Information,\nand Items sections in the Invoices module can be added or updated with this import.")]),_c('p',[_vm._v("If the imported data has more than one tab, the first tab will be imported.")]),_c('p',[_vm._v("Column heading must begin on Row 1.")]),_c('p',[_vm._v("Accepted file formats are .xls and .xlsx")]),_c('ed-form',{staticClass:"col-md-12 no-pad",attrs:{"endpoint":_vm.api.env + _vm.api.$.invoice.upload,"no-submit":"","submit-visible":false}},[_c('ed-upload',{attrs:{"button-label":"Browse","helptipHeader":"Error","helptipBody":_vm.uploadFileError,"error":!_vm.uploadFileValid,"showHelptipIcon":false,"required":_vm.requiredInvoiceUpload,"upload-auto":"","accept":"application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet","extensions":"xls,xlsx"},model:{value:(_vm.attachedFile),callback:function ($$v) {_vm.attachedFile=$$v},expression:"attachedFile"}})],1)],1)],1),_c('ed-tab',{attrs:{"title":"Match Columns","endpoint":_vm.api.$.invoice.import,"data":"data","payload":_vm.data.fieldsMap,"feedback":"errors","validate":"checkMatched"}},[_c('ed-section',{staticClass:"col-md-12 active"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('p',[_vm._v("Use the table below to match the Column Headers from Row 1 of\nyour uploaded file to match to your Invoice Fields in Eved.")]),_c('p',[_vm._v("Required fields are indicated with an "),_c('strong',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(". All required fields must have\na column matched to them to move to Step 3.")])]),_c('p'),_c('ed-form',{staticClass:"col-md-12 -col-md-offset-1",attrs:{"endpoint":_vm.api.$.invoice.validate,"submit-visible":false}},[_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.fieldsMap && _vm.data.fieldsMap[0].FieldName !== null),expression:"data.fieldsMap && data.fieldsMap[0].FieldName !== null"}],staticClass:"table table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticClass:"col-md-3"},[_c('br'),_vm._v(" Invoice Field")]),_c('th',[_c('br'),_vm._v(" Column Header in File")])])]),_c('tbody',_vm._l((_vm.updateMatches(_vm.data.fieldsMap, _vm.data.importedColumns)),function(field,index){return _c('tr',{class:{ "required": field.IsRequired && !(field.Columns && field.Columns.length) }},[_c('td',[_vm._v(_vm._s(field.FieldName)+" "),_c('strong',{staticClass:"text-danger"},[_vm._v(_vm._s(field.IsRequired ? '*' : ''))])]),_c('td',[_c('ed-select',{attrs:{"options":_vm.getImportedColumns(index),"value":_vm.columnName(field.Columns, field.Type === "list"),"customLabel":_vm.columnName,"required":field.IsRequired},on:{"select":function($event){return _vm.handleMultimatch(field, $event)},"open":function($event){return _vm.fetchImportedColumns(_vm.data.importedColumns, index)}},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('ed-select-options',{attrs:{"thumbnails":""}},[_c('span',{attrs:{"slot":"row1"},slot:"row1"},[_c('kbd',[_vm._v(_vm._s(props.option.Letter))]),_vm._v("  "),_c('span',[_vm._v(_vm._s(props.option.Name || '[None]'))])])])]}}],null,true)},[(field.Columns && field.Columns.length === 1 && field.Type !== "list")?_c('a',{attrs:{"slot":"clear","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeMatch(field)}},slot:"clear"},[_c('i',{staticClass:"fas fa-times-circle add-icon"})]):_vm._e()]),(field.Type && field.Columns)?_c('div',{staticClass:"additional-match"},_vm._l((field.Columns),function(column){return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-6"},[_c('kbd',{staticClass:"pull-left"},[_vm._v(_vm._s(column.Letter))]),_c('small',{staticClass:"col-md-10"},[_vm._v(_vm._s(column.Name || "[None]"))])]),_c('small',{staticClass:"col-md-1"},[_c('a',{staticClass:"pull-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeColumn(column, field)}}},[_c('i',{staticClass:"fas fa-times-circle"})])]),_c('br',{staticClass:"clear"}),_c('br')])}),0):_vm._e()],1)])}),0)])])],1)],1),_c('ed-tab',{attrs:{"title":"Review Errors","optional":"Import corrected file","errors":_vm.errors}},[_c('ed-section',{staticClass:"col-md-11 active"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('p',[_vm._v("The table below shows the errors in your file. Please correct\nthese errors in your file and return to step 1 to upload the\ncorrected file.")])]),_c('p'),_c('p'),_c('table',{staticClass:"table table-bordered col-md-12 -col-md-offset-1"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Row")]),_c('th',[_vm._v("Column")]),_c('th',[_vm._v("Data")]),_c('th',[_vm._v("Column Header")]),_c('th',[_vm._v("Invoice Field")]),_c('th',[_vm._v("Error Reason")])])]),_c('tbody',_vm._l((_vm.errors),function(error,i){return _c('tr',[_c('td',[_vm._v(_vm._s(error.Row))]),_c('td',[_vm._v(_vm._s(error.Column))]),_c('td',[_vm._v(_vm._s(error.Data))]),_c('td',[_vm._v(_vm._s(error.ColumnHeader))]),_c('td',[_vm._v(_vm._s(error.FieldName))]),_c('td',[_vm._v(_vm._s(error.ErrorReason))])])}),0)])])],1),_c('ed-tab',{attrs:{"title":"Additional Info","endpoint":_vm.api.$.invoice.additional,"data":"invoices","payload":_vm.additionalInfo,"payloadType":"json","additional":"","validate":"checkItems"}},[_c('ed-section',{staticClass:"col-md-12 active"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('p',[_vm._v("Use the table below to complete the additional information for each invoice. You can uncheck any invoices if you do not want to import them. If there are any duplicate alerts, the invoices are automatically unchecked, please revise the existing invoices and decide if you still want to import the invoice.")]),_c('p',[_vm._v("If you need to add a new supplier, click")]),( true)?_c('div',[_c('div',{ref:"addNewSupplierDialogContainer"},[_c('a',{attrs:{"href":"#","name":"add_new_supplier_link"},on:{"click":function($event){$event.preventDefault();return _vm.addNewSupplierClickHandler.apply(null, arguments)}}},[_c('u',[_vm._v("+ Add new supplier")])])])]):_vm._e(),_c('p')]),_c('p'),_c('ed-form',{staticClass:"col-md-12 f-s-14 no-padding",attrs:{"endpoint":_vm.api.$.invoice.create,"submit-visible":false}},[_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.fieldsMap && _vm.data.fieldsMap[0].FieldName !== null),expression:"data.fieldsMap && data.fieldsMap[0].FieldName !== null"}],staticClass:"additional table table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticClass:"col-md-2"},[_c('br'),_vm._v(" Invoice ID")]),_c('th',{staticClass:"col-md-1"},[_c('br'),_vm._v(" Supplier Invoice Number")]),_c('th',{staticClass:"col-md-2"},[_c('br'),_vm._v(" Supplier")]),_c('th',{staticClass:"col-md-2"},[_c('br'),_vm._v(" Program")]),_c('th',[_c('br'),_vm._v(" Item")]),_c('th',{staticClass:"col-md-2"},[_c('br'),_vm._v(" Category")]),_c('th',[_c('br'),_vm._v(" Attachment "),_c('p',{staticClass:"small",staticStyle:{"font-weight":"normal"}},[_vm._v("Accepted file formats are .pdf, .xls and .xlsx")])])])]),_c('tbody',[_vm._l((_vm.getInvoices),function(invoice,i){return [_c('tr',{class:{ "required": !_vm.validItem(invoice, i) }}),_c('td',{class:invoice.loading ? "loading" : "",style:({ "border-bottom": "none", "border-top": _vm.duplicateInvoiceId(invoice, i) ? "none" : undefined })},[(!_vm.duplicateInvoiceId(invoice, i))?_c('span',[_c('span',{staticClass:"small"},[_c('ed-checkbox',{attrs:{"options":[{ label: invoice["InvoiceID"], status: invoice.selected }]},on:{"input":function($event){return _vm.setDetails("selected", invoice, $event, i)}}}),(invoice.Duplicates)?_c('p',[_vm._v(_vm._s(_vm.$t('This might be a duplicate of:'))),_c('br'),_vm._l(((invoice.Duplicates || [{}])),function(duplicate){return _c('span',[_c('a',{attrs:{"href":duplicate.Url,"target":"_blank"}},[_vm._v(_vm._s(duplicate.Text))]),_c('br')])})],2):_vm._e()],1)]):_vm._e(),(invoice.ZipCodeErrors)?_c('span',_vm._l((invoice.ZipCodeErrors),function(zipCodeError){return _c('span',[_c('p',{staticClass:"zip-code-error"},[_vm._v(_vm._s(zipCodeError.Text))]),_c('br')])}),0):_vm._e()]),_c('td',[_vm._v(_vm._s(invoice['SupplierInvoiceNumber']))]),_c('td',{style:({ "border-bottom": "none", "border-top": _vm.duplicateInvoiceId(invoice, i) ? "none" : undefined })},[(!_vm.duplicateInvoiceId(invoice, i))?_c('div',[(invoice.ShowAddSupplierForm)?_c('div',{staticClass:"small"},[_c('p',[_vm._v(_vm._s(invoice.SupplierName))]),_c('p',[_vm._v(_vm._s(invoice.SupplierEmail))]),_c('p',[_vm._v(_vm._s(invoice.SupplierFirstName + ' ' + invoice.SupplierLastName))]),_c('p',[_vm._v(_vm._s(invoice.SupplierPhoneNumber))]),_c('ed-button',{attrs:{"button-class":"btn btn-actionbar"},on:{"click":function($event){return _vm.editSupplier(invoice, i)}}},[_vm._v("Edit")]),_c('ed-modal',{attrs:{"show":invoice.editSupplierModal,"title":("Edit Supplier " + (invoice.SupplierName)),"validation":""},on:{"validate":function($event){return _vm.validateSupplier(invoice, i)},"close":function($event){return _vm.revertSupplier(invoice, i)}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('ed-input',{model:{value:(invoice.SupplierName),callback:function ($$v) {_vm.$set(invoice, "SupplierName", $$v)},expression:"invoice.SupplierName"}}),_c('br'),_c('ed-input',{model:{value:(invoice.SupplierEmail),callback:function ($$v) {_vm.$set(invoice, "SupplierEmail", $$v)},expression:"invoice.SupplierEmail"}}),_c('br'),_c('ed-input',{model:{value:(invoice.SupplierFirstName),callback:function ($$v) {_vm.$set(invoice, "SupplierFirstName", $$v)},expression:"invoice.SupplierFirstName"}}),_c('br'),_c('ed-input',{model:{value:(invoice.SupplierLastName),callback:function ($$v) {_vm.$set(invoice, "SupplierLastName", $$v)},expression:"invoice.SupplierLastName"}}),_c('br'),_c('ed-input',{model:{value:(invoice.SupplierPhoneNumber),callback:function ($$v) {_vm.$set(invoice, "SupplierPhoneNumber", $$v)},expression:"invoice.SupplierPhoneNumber"}}),_c('br')],1)])],1):_vm._e(),(!invoice.ShowAddSupplierForm)?_c('div',[_c('strong',{staticClass:"text-danger"},[_vm._v("*  ")]),_c('ed-select',{key:invoice["ItemName"],staticClass:"category",attrs:{"options":_vm.suppliers,"value":invoice.SupplierKey,"required":invoice.selected,"label":"Text","customLabel":_vm.getSupplierLabel,"track-by":"Key","placeholder":"Supplier","openEndpoint":_vm.api.$.invoice.suppliers},on:{"search":_vm.fetchSuppliers,"open":function($event){return _vm.fetchSuppliers()},"select":function($event){return _vm.changeSupplier(invoice, $event.Value, i)}},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('ed-select-options',{attrs:{"thumbnails":""}},[_c('div',{staticClass:"no-wrap",attrs:{"slot":"row2"},slot:"row2"},[_c('span',{staticClass:"option-strong"},[_c('strong',[_vm._v(_vm._s(_vm.he.decode(props.option.Value.CompanyName)))]),_c('em',{staticClass:"option-em"},[_vm._v("("+_vm._s(props.option.Value.Vci)+")")])]),_c('br'),(props.option.Value.SupplierName)?_c('span',{staticClass:"option-bold"},[_vm._v(_vm._s(_vm.he.decode(props.option.Value.SupplierName)))]):_vm._e(),(props.option.Value.SupplierRequestedName)?_c('span',[_c('br'),_c('i',[_vm._v(_vm._s(props.option.Value.SupplierRequestedName))])]):_vm._e(),(props.option.Value.CountryName)?_c('span',[_c('br'),_c('span',{staticClass:"fas fa-map-marker-alt contact-icon"}),_vm._v(" "+_vm._s(props.option.Value.City + (props.option.Value.State != '' && props.option.Value.State != null ? ' ' + props.option.Value.State : (props.option.Value.Region != '' && props.option.Value.Region != null ? ' ' + props.option.Value.Region : '')) + ' ' + props.option.Value.CountryName))]):_vm._e(),(props.option.Value.BusinessType)?_c('span',[_c('br'),_c('span',{staticClass:"fas fa-briefcase contact-icon"}),_vm._v(" "+_vm._s(props.option.Value.BusinessType))]):_vm._e(),(props.option.Value.SupplierEmail)?_c('span',[_c('br'),_c('span',{staticClass:"fas fa-envelope contact-icon"}),_vm._v(" "+_vm._s(props.option.Value.SupplierEmail))]):_vm._e()])])]}}],null,true)}),(invoice.SupplierContactName)?_c('ed-card',{staticClass:"supplier-card"},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('img',{attrs:{"src":invoice.SupplierLogo,"width":"40"}}),_vm._v(" "),(invoice.SupplierContactName)?_c('span',{staticClass:"option-bold supplier-name"},[_c('strong',[_vm._v(_vm._s(invoice.SupplierName))]),_c('em',{staticClass:"option-em"},[_vm._v("("+_vm._s(invoice.SupplierEONumber)+")")]),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.he.decode(invoice.SupplierContactName)))])]):_vm._e(),(invoice.SupplierRequestedName && invoice.SupplierRequestedName !== "null")?_c('span',[_c('br'),_c('i',[_vm._v(_vm._s(invoice.SupplierRequestedName))])]):_vm._e(),(invoice.SupplierCountryName)?_c('span',[_c('br'),_c('span',{staticClass:"fas fa-map-marker-alt contact-icon"}),_vm._v(" "+_vm._s(invoice.SupplierCity + (invoice.SupplierRegionOrState != '' && invoice.SupplierRegionOrState != null ? ' ' + invoice.SupplierRegionOrState : '') + ' ' + invoice.SupplierCountryName + ' ' + invoice.StoredSupplierZipCode))]):_vm._e(),(invoice.SupplierBusinessType)?_c('span',[_c('br'),_c('span',{staticClass:"fas fa-briefcase contact-icon"}),_vm._v(" "+_vm._s(invoice.SupplierBusinessType))]):_vm._e(),(invoice.SupplierEmail)?_c('span',[_c('br'),_c('span',{staticClass:"fas fa-envelope contact-icon"}),_vm._v(" "+_vm._s(invoice.SupplierEmail))]):_vm._e()]),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(invoice.SupplierIsEvedPay)?_c('a',{staticClass:"label label-info"},[_vm._v("EvedPay ready")]):_vm._e(),_vm._v(" "),(invoice.SupplierVendorType)?_c('a',{staticClass:"label label-info"},[_vm._v(_vm._s(invoice.SupplierVendorType)+" Supplier")]):_vm._e()])]):_vm._e()],1):_vm._e()]):_vm._e()]),_c('td',{style:({ "border-bottom": "none", "border-top": _vm.duplicateInvoiceId(invoice, i) ? "none" : undefined })},[(!_vm.duplicateInvoiceId(invoice, i))?_c('div',[_c('strong',{staticClass:"text-danger"},[_vm._v("*  ")]),_c('ed-select',{key:invoice["ItemName"],staticClass:"category",attrs:{"options":_vm.programs,"value":invoice.ProgramKey,"required":invoice.selected,"label":"Text","customLabel":_vm.getProgramLabel,"track-by":"Key","placeholder":"Program","openEndpoint":_vm.api.$.invoice.list.uploadInvoicePrograms},on:{"search":_vm.fetchPrograms,"open":function($event){return _vm.fetchPrograms()},"select":function($event){return _vm.changeProgram(invoice, $event.Value, i)}},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('ed-select-options',{attrs:{"thumbnails":""}},[_c('div',{attrs:{"slot":"row1"},slot:"row1"},[_c('span',{staticClass:"option-strong"},[_c('strong',[_vm._v(_vm._s(_vm.he.decode(props.option.Value.ProgramName || '')))])]),_c('br'),(props.option.Value.InternalProgramId)?_c('span',{staticClass:"details-text"},[_vm._v(_vm._s(_vm.he.decode(props.option.Value.InternalProgramId)))]):_vm._e()])])]}}],null,true)})],1):_vm._e()]),_c('td',[_vm._v("Item Name: "+_vm._s(invoice['ItemName'])),_c('br'),_c('span',[_vm._v("Item Price: ")]),(_vm.currency)?_c('v-money',{attrs:{"currency":_vm.currency}},[_vm._v(_vm._s(invoice['ItemUnitPrice']))]):_vm._e(),(invoice['ItemValueAddedTax(VAT)Amount'] !== 0)?_c('br'):_vm._e(),(invoice['ItemValueAddedTax(VAT)Amount'] !== 0)?_c('span',[_vm._v("Item VAT: ")]):_vm._e(),(invoice['ItemValueAddedTax(VAT)Amount'] !== 0 && _vm.currency)?_c('v-money',{attrs:{"currency":_vm.currency}},[_vm._v(_vm._s(invoice['ItemValueAddedTax(VAT)Amount']))]):_vm._e(),(invoice['ItemSalesTaxAmount'] !== 0)?_c('br'):_vm._e(),(invoice['ItemSalesTaxAmount'] !== 0)?_c('span',[_vm._v("Item Sales Tax: ")]):_vm._e(),(invoice['ItemSalesTaxAmount'] !== 0 && _vm.currency)?_c('v-money',{attrs:{"currency":_vm.currency}},[_vm._v(_vm._s(invoice['ItemSalesTaxAmount']))]):_vm._e()],1),_c('td',[_c('strong',{staticClass:"text-danger"},[_vm._v("*  ")]),_c('ed-select',{key:invoice["ItemName"],staticClass:"category",attrs:{"options":_vm.categories,"value":invoice.ItemCategory || _vm.invoices.defaultCategory,"required":invoice.selected,"label":"Text","track-by":"Id","placeholder":"Category","openEndpoint":_vm.api.$.invoice.categories},on:{"open":function($event){return _vm.fetchCategories(invoice["InvoiceID"])},"hook:beforeCreate":function($event){return _vm.setDetails("category", invoice, invoice.ItemCategory || _vm.invoices.defaultCategory, i)},"select":function($event){return _vm.setDetails("category", invoice, $event, i)}}})],1),_c('td',{style:({ "border-bottom": "none", "border-top": _vm.duplicateInvoiceId(invoice, i) ? "none" : undefined })},[(!_vm.duplicateInvoiceId(invoice, i))?_c('div',[(_vm.invoices.isAttachmentRequired)?_c('strong',{staticClass:"text-danger"},[_vm._v("*  ")]):_vm._e(),_c('input',{staticStyle:{"opacity":"0","width":"0","padding":"0","border":"0"},attrs:{"type":"text","required":invoice.selected && _vm.invoices.isAttachmentRequired},domProps:{"value":!invoice.uploadFileError ? invoice.attachment : undefined}}),_c('ed-upload',{staticClass:"attachment",class:{ "attached": (invoice.attachment || []).length },attrs:{"button-label":"Browse","postAction":_vm.api.env + _vm.api.$.upload.uploadInvoice,"data":{ token: _vm.invoices.uploadToken },"upload-auto":"","helptipHeader":"Error","helptipBody":invoice.uploadFileError,"error":invoice.uploadFileError,"showHelptipIcon":false,"accept":"application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf","extensions":"xls,xlsx,pdf"},on:{"input":function($event){return _vm.validAttachment(invoice, i)}},model:{value:(invoice.attachment),callback:function ($$v) {_vm.$set(invoice, "attachment", $$v)},expression:"invoice.attachment"}})],1):_vm._e()]),(_vm.shouldDisplayTotal(invoice, i) && invoice.ProcessingFee)?_c('tr',[_c('td',{attrs:{"colspan":"4"}}),_c('td',{attrs:{"colspan":"3"}},[_c('p',[_vm._v("Processing Fee:"),(_vm.currency)?_c('v-money',{attrs:{"currency":_vm.currency}},[_vm._v(_vm._s(invoice.ProcessingFee))]):_vm._e()],1)])]):_vm._e(),(_vm.shouldDisplayTotal(invoice, i))?_c('tr',[_c('td',{attrs:{"colspan":"4"}}),_c('td',{attrs:{"colspan":"3"}},[_c('p',[_c('strong',[_vm._v("Total Invoice Amount:"),(_vm.currency)?_c('v-money',{attrs:{"currency":_vm.currency}},[_vm._v(_vm._s(_vm.totalInvoiceAmount(invoice)))]):_vm._e()],1)])])]):_vm._e()]})],2)])])],1)],1),_c('ed-tab',{attrs:{"title":"Finalize","button-label":"Ok"}},[_c('ed-section',{staticClass:"col-md-9 active"},[_c('div',{staticClass:"col-md-12 col-md-offset-4"},[_c('h3',[_vm._v("Import Successfully Initiated\n "),_c('i',{staticClass:"success inline"})]),_c('p',[_vm._v("No errors were found in your file and your invoice data is being imported now.\nYou'll receive an email shortly when the import is complete and all data is updated in Eved.\nIn case any invoice is not imported, you'll receive an email notification with those as well.")]),_c('p'),_c('p'),_c('p')])])],1)],1)],1),(_vm.lastStep)?_c('ed-button',{staticClass:"pull-right btn btn-primary",attrs:{"to":"/d/Admin/Import"}},[_vm._v("Ok")]):_vm._e(),(!_vm.lastStep)?_c('ed-button',{staticClass:"next-btn pull-right",attrs:{"endpoint":_vm.nextEndpoint,"disabled":!_vm.uploadFileValid || !_vm.attachedFile},on:{"click":_vm.proceed}},[_vm._v(_vm._s(_vm.$t(_vm.nextLabel)))]):_vm._e(),(!_vm.lastStep)?_c('ed-button',{staticClass:"pull-right btn btn-secondary",attrs:{"to":"/d/Admin/Import"}},[_vm._v(_vm._s(_vm.$t('Cancel')))]):_vm._e(),_c('ed-modal',{attrs:{"show":_vm.notAllRequiredMatched,"title":"Check Unmatched Column Headers","subtitle":"Please match all required Invoice Fields to Column Headers in order to move on to the next step.","primaryButton":"Ok","secondaryButton":"false"},on:{"close":function($event){_vm.notAllRequiredMatched = false}}}),_c('ed-modal',{attrs:{"show":_vm.notAllMatched,"title":"Check Unmatched Column Headers","subtitle":"Not all of your Column Headers are matched to Invoice Fields. Do you still want to continue to the next step?","primaryButton":"Yes","secondaryButton":"No"},on:{"close":function($event){_vm.notAllMatched = false},"confirm":_vm.skipMatch}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lrqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_Dashboard_widgets_SharedComponents_WidgetOptions_vue__ = __webpack_require__("eiQj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardRefill_vue__ = __webpack_require__("5mev");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardDailySpendLimit_vue__ = __webpack_require__("eFhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CardAddFunds_vue__ = __webpack_require__("/roU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccountingSystemSettings_vue__ = __webpack_require__("P2/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CardStatus_vue__ = __webpack_require__("1t90");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RequestPhysicalCard_vue__ = __webpack_require__("v86b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardAdditionalUsers_vue__ = __webpack_require__("EK88");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardPIN__ = __webpack_require__("/MqT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ReturnFundsToAccount_vue__ = __webpack_require__("+i84");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DeleteCard_vue__ = __webpack_require__("zXEj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ShowCardNumber_vue__ = __webpack_require__("R8ny");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    WidgetOptions: __WEBPACK_IMPORTED_MODULE_4__components_modules_Dashboard_widgets_SharedComponents_WidgetOptions_vue__["default"],
    RefillSettings: __WEBPACK_IMPORTED_MODULE_5__CardRefill_vue__["a" /* default */],
    CardDailySpendLimit: __WEBPACK_IMPORTED_MODULE_6__CardDailySpendLimit_vue__["a" /* default */],
    CardAddFunds: __WEBPACK_IMPORTED_MODULE_7__CardAddFunds_vue__["a" /* default */],
    AccountingSystemSettings: __WEBPACK_IMPORTED_MODULE_8__AccountingSystemSettings_vue__["a" /* default */],
    CardStatus: __WEBPACK_IMPORTED_MODULE_9__CardStatus_vue__["a" /* default */],
    RequestPhysicalCard: __WEBPACK_IMPORTED_MODULE_10__RequestPhysicalCard_vue__["a" /* default */],
    CardAdditionalUsers: __WEBPACK_IMPORTED_MODULE_11__CardAdditionalUsers_vue__["a" /* default */],
    CardPIN: __WEBPACK_IMPORTED_MODULE_12__CardPIN__["a" /* default */],
    ReturnFunds: __WEBPACK_IMPORTED_MODULE_13__ReturnFundsToAccount_vue__["a" /* default */],
    DeleteCard: __WEBPACK_IMPORTED_MODULE_14__DeleteCard_vue__["a" /* default */],
    ShowCardNumber: __WEBPACK_IMPORTED_MODULE_15__ShowCardNumber_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__["mixin"]],
  props: {
    card: Object,
    account: {},
    accountSettings: Object,
    division: Object
  },
  data: function data() {
    return {
      isMenuOpen: false,
      isRefillOpen: {
        showModal: false
      },
      isDailySpendLimitOpen: {
        showModal: false
      },
      showAddFunds: false,
      showAccountingSystemSettings: false,
      fundingAmount: '',
      addFundsErrors: false,
      requestFunds: false,
      showCardStatus: {
        showModal: false
      },
      cardStatus: '',
      isRequestPhysicalCardOpen: false,
      showCardAdditionalUsers: false,
      showCardSetPIN: {
        showModal: false
      },
      additionalUsers: [],
      modalTitle: '',
      showRequestPhysicalCardOpen: {
        showModal: false
      },
      showReturnFundsToAccount: false,
      returnFunds: '',
      loadingEndpoint: '',
      showDeleteCard: false,
      showShowCardNumber: false,
      helpDeskTicketNumber: ''
    };
  },
  created: function created() {
    this.hasAccountPermission();
  },
  computed: {
    isCardHolder: function isCardHolder() {
      var isCardHolder = this.$user.$.user.UserID === this.card.Holder.Id;
      return isCardHolder;
    },
    cardForShowNumber: function cardForShowNumber() {
      return {
        Id: this.card.Id,
        AccountId: this.card.AccountId,
        CardNumber: this.card.CardNumber,
        Holder: this.card.Holder ? this.card.Holder.Name : '',
        NameOnCard: this.card.NameOnCard || '',
        ExpirationDate: this.card.ExpirationDate || ''
      };
    },
    isEvedAdmin: function isEvedAdmin() {
      return !!(this.$user && this.$user.$ && this.$user.$.user && this.$user.$.user.IsEvedAdmin);
    },
    isCardStatusSubmitDisabled: function isCardStatusSubmitDisabled() {
      var isLockUnlock = this.cardStatus === 'lock' || this.cardStatus === 'unlock';
      return isLockUnlock && this.isEvedAdmin && !this.helpDeskTicketNumber.trim();
    }
  },
  methods: {
    isPoolFunding: function isPoolFunding(card) {
      // PRODUCTDEV-5881: a card follows pool funding rules when its account is Pool - Shared Funds
      // (card.IsPoolFunding) OR it carries the legacy per-card UseAutoCardFunding flag.
      return !!(card && (card.IsPoolFunding || card.UseAutoCardFunding));
    },
    isAnyOptionAvailable: function isAnyOptionAvailable() {
      var hasAdminPermission = this.hasAccountPermission('EvedPayCardAdministrator');
      var canViewReconcileClose = this.hasAccountPermission('EvedPayCardViewReconcileClose');
      var isCardActive = this.card.CardStatus === 'Active' || this.card.CardStatus === 'Inactive' && hasAdminPermission;
      var isCardLockedOrLostStolen = this.card.CardStatus === 'Locked' || this.card.CardStatus === 'Locked - Lost/Stolen';
      var isCardClosed = this.card.CardStatus === 'Closed';
      return hasAdminPermission && (isCardActive || isCardLockedOrLostStolen) ||
      // Admin options when the card is active || locked - lost/stolen
      !hasAdminPermission && isCardActive ||
      // Non-admin options when the card is active
      this.isCardHolder && (isCardActive || isCardLockedOrLostStolen || isCardClosed) ||
      // Cardholder options
      (hasAdminPermission || canViewReconcileClose) && isCardActive // Closing card options
      ;
    },
    showSuccessToast: function showSuccessToast() {
      this.$notifications.notify({
        message: "Pin has been changed successfully for card ".concat(this.card.CardNumber, "!<br>Holder: ").concat(this.card.Holder.Name),
        type: 'info',
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    },
    addFunds: function addFunds() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, _response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.fundingAmount <= 0 || _this.fundingAmount > _this.account.Available)) {
                _context.next = 4;
                break;
              }
              _this.addFundsErrors = true;
              _this.$emit('addFundsError', _this.addFundsErrors);
              return _context.abrupt("return");
            case 4:
              if (!_this.requestFunds) {
                _context.next = 18;
                break;
              }
              _this.loadingEndpoint = "evedpaycards/".concat(_this.card.Id, "/request-funds");
              _context.prev = 6;
              _context.next = 9;
              return _this.api.post("evedpaycards/".concat(_this.card.Id, "/request-funds"), {
                Amount: parseFloat(_this.fundingAmount)
              });
            case 9:
              response = _context.sent;
              if (response.status === 200) {
                _this.$emit('success');
                __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('funds-changed', _this.card.Id);
                _this.addFundsErrors = false;
                _this.showAddFunds = false;
              }
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](6);
              console.error(_context.t0);
            case 16:
              _context.next = 29;
              break;
            case 18:
              _this.loadingEndpoint = "evedpaycards/".concat(_this.card.Id, "/add-funds");
              _context.prev = 19;
              _context.next = 22;
              return _this.api.post("evedpaycards/".concat(_this.card.Id, "/add-funds"), {
                Amount: parseFloat(_this.fundingAmount)
              });
            case 22:
              _response = _context.sent;
              if (_response.status === 200) {
                _this.$emit('success');
                __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('funds-changed', _this.card.Id);
                _this.addFundsErrors = false;
                _this.showAddFunds = false;
              }
              _context.next = 29;
              break;
            case 26:
              _context.prev = 26;
              _context.t1 = _context["catch"](19);
              console.error(_context.t1);
            case 29:
              _this.fundingAmount = '';
              _this.addFundsErrors = false;
            case 31:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 13], [19, 26]]);
      }))();
    },
    doReturnFunds: function doReturnFunds() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (parseFloat(_this2.returnFunds) > 0 && parseFloat(_this2.returnFunds) <= parseFloat(_this2.card.Balance)) {
                _context2.next = 3;
                break;
              }
              alert('Input cannot be 0, negative, or more than the current balance.');
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              _context2.next = 6;
              return _this2.api.post("evedpaycards/".concat(_this2.card.Id, "/remove-funds"), {
                Amount: parseFloat(_this2.returnFunds)
              });
            case 6:
              response = _context2.sent;
              if (response.status === 200) {
                __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('funds-changed', _this2.card.Id);
                _this2.showReturnFundsToAccount = false;
              } else {
                _this2.showReturnFundsToAccount = false;
                alert('Failed to return funds.');
              }
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              console.error(_context2.t0);
            case 13:
              _this2.returnFunds = '';
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 10]]);
      }))();
    },
    deleteCard: function deleteCard() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this3.api.post("evedpaycards/".concat(_this3.card.Id, "/set-as-deleted"));
            case 3:
              response = _context3.sent;
              if (response.status === 200) {
                _this3.$emit('success');
                _this3.showDeleteCard = false;
              }
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }))();
    },
    updateAdditionalUsers: function updateAdditionalUsers() {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _this4.api.patch("evedpaycards/".concat(_this4.card.Id, "/additional-users"), {
                users: _this4.additionalUsers
              });
            case 3:
              response = _context4.sent;
              if (response.status === 200) {
                console.log(response.statusText);
              }
              _context4.next = 10;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              console.error(_context4.t0);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }))();
    },
    lockCard: function lockCard() {
      var _this5 = this;
      this.modalTitle = this.card.CardStatus === 'Active' ? 'Lock Card Activity' : 'Unlock Card Activity';
      this.cardStatus = this.card.CardStatus === 'Active' ? 'lock' : 'unlock';
      this.showCardStatus.showModal = true;
      this.helpDeskTicketNumber = '';
      this.$nextTick(function () {
        _this5.$refs.cardStatusComponent.isActive = _this5.card.CardStatus === 'Locked';
        _this5.$refs.cardStatusComponent.helpDeskTicketNumber = '';
      });
      this.toggleCollapseAndShowCardStatus();
    },
    closeCardStatusModal: function closeCardStatusModal() {
      this.showCardStatus.showModal = false;
      this.helpDeskTicketNumber = '';
      if (this.$refs.cardStatusComponent) {
        this.$refs.cardStatusComponent.helpDeskTicketNumber = '';
      }
    },
    closeCard: function closeCard() {
      this.modalTitle = 'Close EvedPay Cards';
      this.showCardStatus.showModal = true;
      this.cardStatus = 'close';
      this.toggleCollapseAndShowCardStatus();
    },
    resendNewCardEmail: function resendNewCardEmail() {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.isMenuOpen = false;
              _context5.prev = 1;
              _context5.next = 4;
              return _this6.api.post("evedpaycards/".concat(_this6.card.Id, "/resend-new-card-email"));
            case 4:
              response = _context5.sent;
              if (response.status === 200) {
                _this6.$emit('success');
              }
              _context5.next = 11;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);
              console.error(_context5.t0);
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[1, 8]]);
      }))();
    },
    lostStolenCard: function lostStolenCard() {
      this.modalTitle = 'Report Card Lost or Stolen';
      this.showCardStatus.showModal = true;
      this.cardStatus = 'report-lost-or-stolen';
      this.toggleCollapseAndShowCardStatus();
    },
    toggleCollapseAndShowCardStatus: function toggleCollapseAndShowCardStatus() {
      this.toggleCollapse();
      this.toggleCardStatus();
      this.handleClick();
    },
    toggleCollapseAndShowRequestPhysicalCard: function toggleCollapseAndShowRequestPhysicalCard() {
      this.toggleCollapse();
      this.toggleRequestPhysicalCard();
      this.handleClick();
    },
    closeMenu: function closeMenu() {
      this.isMenuOpen = false;
    },
    toggleCollapse: function toggleCollapse() {
      this.closeMenu();
      this.$emit('toggleCollapse');
    },
    toggleRefill: function toggleRefill() {
      this.isRefillOpen.showModal = true;
    },
    toggleCardStatus: function toggleCardStatus() {
      this.showCardStatus.showModal = true;
    },
    toggleRequestPhysicalCard: function toggleRequestPhysicalCard() {
      this.showRequestPhysicalCardOpen.showModal = true;
    },
    toggleSetPin: function toggleSetPin() {
      this.showCardSetPIN.showModal = true;
    },
    hasAccountPermission: function hasAccountPermission(permission) {
      if (this.$user && this.$user.$.userPermissions && this.$user.$.userPermissions.length !== 0) {
        return this.$user.$.userPermissions.includes(permission);
      }
      return false;
    },
    handlePslSettingsSave: function handlePslSettingsSave() {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee6() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.$refs.accountingSystemSettingsCmp.save();
            case 2:
              res = _context6.sent;
              _this7.showAccountingSystemSettings = !res;
              return _context6.abrupt("return", res);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    handleClick: function handleClick(event) {
      if (event) {
        event.preventDefault();
      }
    },
    toggleCollapseAndShowRefill: function toggleCollapseAndShowRefill() {
      this.toggleCollapse();
      this.toggleRefill();
      this.handleClick();
    },
    toggleCollapseAndShowDailySpendLimit: function toggleCollapseAndShowDailySpendLimit() {
      this.toggleCollapse();
      this.isDailySpendLimitOpen.showModal = true;
      this.handleClick();
    },
    closeShowCardNumber: function closeShowCardNumber() {
      this.showShowCardNumber = false;
      if (this.$refs.showCardNumberComponent) {
        this.$refs.showCardNumberComponent.resetOtpState();
      }
    }
  }
});

/***/ }),

/***/ "M+wV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("IVb6");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_129cf3d7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("hbh0");
function injectStyle (ssrContext) {
  __webpack_require__("Arx1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-129cf3d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_129cf3d7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M0rA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_money_vue__ = __webpack_require__("B8oi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e15363e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_money_vue__ = __webpack_require__("H6Ol");
function injectStyle (ssrContext) {
  __webpack_require__("PCds")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e15363e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_money_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e15363e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_money_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M65m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CorrectApFile_vue__ = __webpack_require__("0kLI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec52e56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CorrectApFile_vue__ = __webpack_require__("UMCc");
function injectStyle (ssrContext) {
  __webpack_require__("wVmo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ec52e56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CorrectApFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec52e56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CorrectApFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M6h9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_supplier_vue__ = __webpack_require__("9ta/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fe0c017_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_supplier_vue__ = __webpack_require__("8V/l");
function injectStyle (ssrContext) {
  __webpack_require__("j0TN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fe0c017"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_supplier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fe0c017_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_supplier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M8SE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.href)?_c('a',_vm._b({},'a',_vm.$props,false),[_vm._t("default")],2):_c('button',_vm._b({staticClass:"md-button",on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_704ae073_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("up34");
function injectStyle (ssrContext) {
  __webpack_require__("9W0U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_704ae073_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MIoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("mZDo");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59609d26_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("SlAw");
function injectStyle (ssrContext) {
  __webpack_require__("wWmw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59609d26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59609d26_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MKaH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MLM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_statuses_vue__ = __webpack_require__("Apf7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bfdbf81_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_statuses_vue__ = __webpack_require__("BhPO");
function injectStyle (ssrContext) {
  __webpack_require__("xVGP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bfdbf81"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_statuses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bfdbf81_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_statuses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MU7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"addFeeTaxesDialogContainer"},[_c('ed-modal',{attrs:{"show":_vm.show,"title":_vm.title,"primary-button":"Save","secondary-button":"Cancel","validation":_vm.validation,"closeOnEsc":true,"name":"allocate_bu_cc_pair_popup"},on:{"close":_vm.onClose,"validate":_vm.onSave}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"col-md-10 no-pad"},[_vm._v("\n        Allocate to Business Unit and Cost Center for the following items:\n        "),_vm._l((_vm.selectedItemNames),function(item){return _c('ul',{key:item},[_c('li',[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('div',{staticClass:"row col-md-10 no-pad"},[_c('ed-select',{attrs:{"field-label":"Business Unit and Cost Center","placeholder":"Select a Business Unit and Cost Center","options":_vm.buCCPairs,"required":"required","label":"name","track-by":"key","error":_vm.doDisplayError,"helptip-header":_vm.doDisplayError && 'Error' || '',"helptip-body":_vm.doDisplayError && 'Please select a Business Unit and Cost Center' || '',"name":"allocate_to_cost_centers"},on:{"select":function($event){return _vm.buCCPairsSelected($event)}},model:{value:(_vm.formData.draftItem.buCCPair),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "buCCPair", $$v)},expression:"formData.draftItem.buCCPair"}})],1)],2),_vm._v(" "),_c('div',{staticClass:"clear"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MWvc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-flex active"},[_c('ed-section',{staticClass:"no-flex active",attrs:{"title":"Invoice Information","wide":""}},[_c('span',{attrs:{"slot":"description"},slot:"description"},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")]),_vm._v(" "),_c('ed-form',{staticClass:"col-md-12",attrs:{"submit-visible":false}},[_c('div',{staticClass:"col-md-8"},[(_vm.settings.CompanySettings.EditingInvoiceScan)?_c('div',[_c('div',[_c('label',{staticClass:"control-label"},[_vm._v("Planner")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.model.CreatedByInfo.Name))])]),_vm._v(" "),(_vm.model.CreatedByInfo.Phone)?_c('div',[_c('label',{staticClass:"control-label"},[_vm._v("Planner Phone Number")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.model.CreatedByInfo.Phone))])]):_vm._e(),_vm._v(" "),_c('div',[_c('label',{staticClass:"control-label"},[_vm._v("Planner Email Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.model.CreatedByInfo.Email))])])]):_vm._e(),_vm._v(" "),_c('ed-select',{attrs:{"field-label":_vm.programLabel,"placeholder":"Select a " + _vm.programLabel,"options":_vm.programs,"required":"","customLabel":_vm.getProgramLabel,"openEndpoint":_vm.api.$.invoice.list.uploadInvoicePrograms,"helptipHeader":"","track-by":"Key","error":_vm.model.Errors.ProgramMissing || _vm.model.Errors.ProgramCancelled,"helptip-body":_vm.programSelectErrorMessage,"name":"programs"},on:{"open":_vm.fetchProgramsonOpen,"search":_vm.fetchPrograms,"close":_vm.restorePrograms,"select":function($event){return _vm.selectProgram($event)}},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('ed-select-options',{attrs:{"thumbnails":""}},[_c('div',{attrs:{"slot":"row1"},slot:"row1"},[_c('span',{staticClass:"option-strong"},[_c('strong',[_vm._v(_vm._s(_vm.he.decode(props.option.Value.ProgramName || ''))+" ")])]),_vm._v(" "),_c('br'),_vm._v(" "),(props.option.Value.InternalProgramId)?_c('span',{staticClass:"details-text"},[_vm._v("\n                  "+_vm._s(_vm.he.decode(props.option.Value.InternalProgramId))+"\n                ")]):_vm._e()])])]}}]),model:{value:(_vm.program),callback:function ($$v) {_vm.program=$$v},expression:"program"}}),_vm._v(" "),(_vm.model.ProgramName)?_c('program-budget',{key:_vm.programBudgetData[0].join(''),attrs:{"title":_vm.programBudgetTitle,"currency":_vm.programCurrencyCode,"data":_vm.programBudgetData}}):_vm._e(),_vm._v(" "),(_vm.settings.CompanySettings.EditingInvoiceScan)?_c('div',[_c('label',{staticClass:"control-label"},[_vm._v("\n              Associated "+_vm._s(_vm.singularize(_vm.divisionLabel))+"\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.model.DivisionName))])]):_vm._e(),_vm._v(" "),(_vm.settings.CompanySettings.EditingInvoiceScan)?_c('div',[_c('label',{staticClass:"control-label"},[_vm._v("Associated Bill To Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[(_vm.billToAddress.companyName)?_c('span',[_vm._v(_vm._s(_vm.billToAddress.companyName))]):_vm._e(),_c('br'),_vm._v(" "),(_vm.billToAddress.address.address1)?_c('span',[_vm._v(_vm._s(_vm.billToAddress.address.address1))]):_vm._e(),_c('br'),_vm._v(" "),(_vm.billToAddress.address.city)?_c('span',[_vm._v(_vm._s(_vm.billToAddress.address.city))]):_vm._e(),(_vm.billToAddress.address.state)?_c('span',[_vm._v(", "+_vm._s(_vm.billToAddress.address.state))]):_vm._e(),_vm._v(" "),(_vm.billToAddress.address.zipCode)?_c('span',[_vm._v(_vm._s(_vm.billToAddress.address.zipCode))]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.userHasBothTypeOfDivisions || (_vm.userHasBothTypeOfDivisions && _vm.model.ProgramID > 0))?_c('div',[(_vm.isP2PInvoice)?_c('ed-select',{attrs:{"field-label":"PO","placeholder":"Select PO","options":_vm.purchaseOrders,"required":"","disabled":_vm.disablePO,"customLabel":_vm.getPOLabel,"track-by":"Key","openEndpoint":_vm.api.$.invoice.i2p.purchaseOrders,"error":_vm.model.Errors.POMissing,"helptip-body":_vm.model.Errors.POMissing && "Please select a PO." || "","helptipHeader":"","name":"payment_type"},on:{"open":_vm.fetchPOsOnOpen,"search":_vm.fetchPOs,"close":_vm.restorePOs,"select":function($event){return _vm.selectPurchaseOrder($event)}},scopedSlots:_vm._u([{key:"option",fn:function(POprops){return [_c('ed-select-options',{attrs:{"thumbnails":""}},[_c('div',{attrs:{"slot":"row1"},slot:"row1"},[_c('span',{staticClass:"option-strong"},[_c('strong',[_vm._v(_vm._s(_vm.he.decode(POprops.option.Value.PONumber || ''))+" ")])]),_vm._v(" "),_c('br'),_vm._v(" "),(POprops.option.Value.SupplierName)?_c('span',{staticClass:"details-text"},[_vm._v("\n                    "+_vm._s(_vm.he.decode(POprops.option.Value.SupplierName || ''))+"\n                  ")]):_vm._e(),_vm._v("\n                     -   \n                  "),(POprops.option.Value.CreatedDate)?_c('span',{staticClass:"details-text"},[_vm._v("\n                    "+_vm._s(POprops.option.Value.CreatedDate)+"\n                  ")]):_vm._e()])])]}}],null,false,596650409),model:{value:(_vm.purchaseOrder),callback:function ($$v) {_vm.purchaseOrder=$$v},expression:"purchaseOrder"}}):_vm._e(),_vm._v(" "),_c('supplier',{attrs:{"model":_vm.model,"hasOnlyP2PPrograms":_vm.userHasJustP2PDivisions,"isEoadmin":_vm.settings.CompanySettings.EditingInvoiceScan},on:{"supplierSelected":_vm.onSupplierSelected,"supplierRemoved":_vm.onSupplierRemoved}}),_vm._v(" "),(_vm.addOutofNetworkSuppliersPermission && !_vm.isP2PInvoice)?_c('div',[(_vm.disableAddSupplier === false)?_c('div',{ref:"addNewSupplierDialogContainer"},[_c('a',{attrs:{"href":"#","name":"add_new_supplier_link"},on:{"click":function($event){$event.preventDefault();return _vm.addNewSupplierClickHandler.apply(null, arguments)}}},[_c('u',[_vm._v("+ Add new supplier")])])]):_vm._e(),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('ed-input',{attrs:{"field-label":"Confirm Postal/Zip Code","required":_vm.model.IsRequiredSupplierZipCode,"error":_vm.model.Errors.SupplierZipCodeMissing,"helptip-header":"","helptip-body":_vm.model.Errors.SupplierZipCodeMissing && "Please fill in the Postal/Zip Code." || "","name":"supplier_zip_code"},on:{"input":_vm.handleZipCodeChange},model:{value:(_vm.model.SupplierZipCode),callback:function ($$v) {_vm.$set(_vm.model, "SupplierZipCode", $$v)},expression:"model.SupplierZipCode"}},[_c('p',{staticClass:"additional-text-no-padding",attrs:{"slot":"additionalText"},slot:"additionalText"},[_c('em',[_vm._v("Enter Supplier's Postal/Zip Code as listed on the supplier's invoice")])])]),_vm._v(" "),(_vm.showField('PaymentType'))?_c('ed-select',{attrs:{"field-label":"Payment Type","placeholder":"Select Payment Type","options":_vm.paymentTypes,"required":"","label":"Value","track-by":"Value","openEndpoint":_vm.api.$.invoice.i2p.paymentTypes,"error":_vm.model.Errors.PaymentTypeMissing,"helptip-body":_vm.model.Errors.PaymentTypeMissing && "Please select a Payment Type." || "","helptipHeader":"","name":"payment_type","disabled":_vm.disabledPaymentType},on:{"open":_vm.fetchPaymentTypes,"select":function($event){return _vm.selectPaymentType($event)}},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}}):_vm._e(),_vm._v(" "),(_vm.showPaymentTerm)?_c('ed-select',{attrs:{"field-label":"Discounted Payment Terms","placeholder":"Select Discounted Payment Term","options":_vm.discounts,"required":"","label":"Value","track-by":"Value","openEndpoint":_vm.api.$.invoice.i2p.discounts,"error":_vm.model.Errors.DiscountMissing,"helptip-body":_vm.model.Errors.DiscountMissing && "Please select a Payment Term." || "","helptipHeader":"","name":"payment_term","disabled":_vm.disabledPaymentTerm},on:{"open":_vm.fetchDiscounts,"select":function($event){return _vm.selectDiscount($event)},"remove":function($event){return _vm.removeDiscount($event)}},model:{value:(_vm.discount),callback:function ($$v) {_vm.discount=$$v},expression:"discount"}}):_vm._e(),_vm._v(" "),(_vm.showSameDayDepositCheck)?_c('ed-checkbox',{attrs:{"options":_vm.sameDayDepositOption,"name":"same_day_deposit_check","required":"","helptip-body":_vm.sameDayDepositOption[0].label,"disabled":_vm.disabledSameDayDepositCheck},on:{"click":_vm.changeSameDaySetting}},[_c('p',{staticClass:"additional-text",attrs:{"slot":"additionalText"},slot:"additionalText"},[_c('em',[_vm._v("Requests made after 5pm CT will be processed the next business day")])])]):_vm._e(),_vm._v(" "),_c('ed-datepicker',{attrs:{"field-label":"Invoice Date","placeholder":"Select date","shortcuts":_vm.getDatepickerShortcuts,"required":"","disabled":this.settings.CompanySettings.EditingInvoiceScan && !this.model.IsFromEmailForScanning,"width":"","format":_vm.dateFormat,"error":_vm.model.Errors.InvoiceDateMissing || _vm.model.Errors.InvoiceDateIncomplete,"helptip-body":_vm.model.Errors.InvoiceDateMissing ? "Please select an Invoice Date." : (_vm.model.Errors.InvoiceDateIncomplete ? "Please enter a complete date." : ""),"helptipHeader":"","name":"invoice_date"},on:{"input":_vm.selectInvoiceDate},model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}}),_vm._v(" "),_c('ed-datepicker',{attrs:{"field-label":"Due Date","placeholder":"Select date","required":"","disabled":this.settings.CompanySettings.EditingInvoiceScan,"width":"","format":_vm.dateFormat,"notBefore":this.model.InvoiceDate,"error":_vm.model.Errors.DueDateMissing || _vm.model.Errors.DueDateIncomplete,"helptip-body":_vm.model.Errors.DueDateMissing ? "Please select an Invoice Date." : (_vm.model.Errors.DueDateIncomplete ? "Please enter a complete date." : ""),"helptipHeader":"","name":"due_date"},on:{"input":_vm.selectDueDate},model:{value:(_vm.dueDate),callback:function ($$v) {_vm.dueDate=$$v},expression:"dueDate"}},[(this.model.HasRushPayment)?_c('p',{staticClass:"text-danger",attrs:{"slot":"info"},slot:"info"},[_c('span',[_vm._v("Rush Payment - "+_vm._s(this.rushDays.RushPaymentTermsDays)+" Day Payment Term")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.rushDays.DaysEarlier)+" earlier than the "+_vm._s(this.rushDays.HasDiscountedPaymentTerm ? 'discounted' : 'standard')+" "+_vm._s(this.rushDays.StandardRushPaymentDays)+"-day payment term")])]):_vm._e()]),_vm._v(" "),_c('div',{ref:"requestRushPaymentDialogContainer"}),_vm._v(" "),(this.getInvoiceId !== '0' || !this.settings.CompanySettings.AllowInvoiceScanning || _vm.isP2PInvoice)?_c('ed-input',{attrs:{"field-label":"Supplier Invoice Number","required":this.getInvoiceId !== '0' || !this.settings.CompanySettings.AllowInvoiceScanning || _vm.isP2PInvoice ? _vm.model.ReferenceNoIsRequired : _vm.model.ReferenceNoIsRequired = false,"error":this.getInvoiceId !== '0' || !this.settings.CompanySettings.AllowInvoiceScanning || _vm.isP2PInvoice ? _vm.model.Errors.ReferenceNoMissing : _vm.model.Errors.ReferenceNoMissing = false,"helptip-header":"","helptip-body":_vm.model.Errors.ReferenceNoMissing && "Please fill in a Supplier Invoice Number." || "","name":"reference_no"},on:{"input":function($event){_vm.model.Errors.ReferenceNoMissing = false}},model:{value:(_vm.model.ReferenceNo),callback:function ($$v) {_vm.$set(_vm.model, "ReferenceNo", $$v)},expression:"model.ReferenceNo"}}):_vm._e(),_vm._v(" "),_c('ed-select',{attrs:{"field-label":"Invoice Currency","placeholder":"Select a currency","options":_vm.currencies,"label":"Value","track-by":"Value","required":"","openEndpoint":_vm.api.$.invoice.i2p.currencies,"error":_vm.model.Errors.InvoiceCurrencyMissing,"disabled":_vm.isP2PInvoice,"hidden":_vm.isP2PInvoice,"helptip-body":_vm.model.Errors.InvoiceCurrencyMissing && "Please select an Invoice Currency." || "","helptipHeader":"","name":"invoice_currency"},on:{"select":function($event){return _vm.selectCurrency($event)},"input":_vm.currencyInput,"open":_vm.fetchCurrencies},model:{value:(_vm.currency),callback:function ($$v) {_vm.currency=$$v},expression:"currency"}}),_vm._v(" "),(_vm.useHighLevelAllocation || _vm.isP2PInvoice)?_c('ed-input',{key:_vm.model.ProgramID,attrs:{"field-label":_vm.invoiceAmountLabel,"required":"","amount":"","autoselect":"","type":"money","currency":_vm.model.CurrencyCode,"error":_vm.invoiceError,"helptipHeader":_vm.invoiceAmountHelptipHeader,"name":"invoice_amount","disabled":_vm.disableAmounts || _vm.isP2PInvoiceWithAddTaxesAndEditItems,"conditionalText":_vm.amountConditionalPlaceholder},on:{"change":_vm.changeInvoiceAmount},model:{value:(_vm.model.InvoiceAmount),callback:function ($$v) {_vm.$set(_vm.model, "InvoiceAmount", $$v)},expression:"model.InvoiceAmount"}},[(_vm.invoiceError)?_c('span',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n              "+_vm._s(_vm.invoiceAmountHelptipBody)+"\n              "),(_vm.invoiceAmountHelptipBody && this.model.Errors.InvoiceAmountOutOfRange)?_c('v-money',{staticClass:"solid",attrs:{"currency":_vm.model.CurrencyCode}},[_vm._v("\n                "+_vm._s(_vm.templateNotInvoicedAmount)+"\n              ")]):_vm._e()],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showNeddedFieldsForScanning || _vm.model.IsScanning)?_c('ed-input',{attrs:{"field-label":"Invoice Amount (Including VAT/GST if applicable)","required":"","amount":"","autoselect":"","type":"money","currency":_vm.model.CurrencyCode,"error":_vm.invoiceError,"helptipHeader":_vm.invoiceAmountHelptipHeader,"name":"invoice_initial_amount","disabled":_vm.disableAmounts,"conditionalText":_vm.amountConditionalPlaceholder},on:{"change":_vm.changeInitialTotalAmount},model:{value:(_vm.model.InitialTotalAmount),callback:function ($$v) {_vm.$set(_vm.model, "InitialTotalAmount", $$v)},expression:"model.InitialTotalAmount"}},[(_vm.invoiceError)?_c('span',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n              "+_vm._s(_vm.invoiceAmountHelptipBody)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.useHighLevelAllocation && _vm.settings.CompanySettings.AllocateVAT && !_vm.isP2PInvoice) || _vm.isVatGstRequired)?_c('ed-input',{key:_vm.model.ProgramID,attrs:{"field-label":"VAT/GST","required":_vm.isVatGstRequired,"amount":"","autoselect":"","type":"money","currency":_vm.model.CurrencyCode,"name":"vat_gst_amount","disabled":_vm.disableAmounts,"conditionalText":_vm.amountConditionalPlaceholder},on:{"change":_vm.changeVatGSTAmount},model:{value:(_vm.model.VATGSTAmount),callback:function ($$v) {_vm.$set(_vm.model, "VATGSTAmount", $$v)},expression:"model.VATGSTAmount"}}):_vm._e(),_vm._v(" "),_c('ed-checkbox',{attrs:{"options":_vm.reimbursementOption,"name":"reimbursement_check","required":"","helptip-body":_vm.reimbursementOption[0].label},on:{"click":_vm.changeReimbursementSetting}},[_c('p',{staticClass:"additional-text",attrs:{"slot":"additionalText"},slot:"additionalText"},[_c('em',[_vm._v("Please check this box if this invoice is a reimbursement for a business expense. By checking this box, we will not include these amounts in the supplier's 1099.")])])]),_vm._v(" "),_c('ed-upload',{class:{loading: !_vm.uploadFinished},attrs:{"field-label":_vm.uploadFieldName,"button-label":"Browse","canOpenFile":_vm.settings.CompanySettings.EditingInvoiceScan,"readonly":"","multiple":true,"postAction":_vm.api.env + _vm.api.$.upload.uploadInvoice,"uploadAuto":true,"data":_vm.uploadData,"required":_vm.settings.CompanySettings.RequireAttachment,"error":_vm.model.Errors.AttachmentsMissing,"showHelptipIcon":false,"helptip-body":_vm.model.Errors.AttachmentsMissing && "Please attach at least one PDF file." || "","helptipHeader":"","name":"attachment_upload","noButton":_vm.settings.CompanySettings.EditingInvoiceScan},on:{"input":_vm.createAttachments},model:{value:(_vm.attachedFiles),callback:function ($$v) {_vm.attachedFiles=$$v},expression:"attachedFiles"}},[_c('p',{staticClass:"additional-text text-red",attrs:{"slot":"additionalText"},slot:"additionalText"},[_c('em',[_vm._v("All files attached here will be visible to the supplier. To attach internal documents, use \"Comments & Attachments\".")])])]),_vm._v(" "),(_vm.showNeddedFieldsForScanning)?_c('allocation-section',{key:_vm.model.ProgramID,attrs:{"model":_vm.model,"error":_vm.model.Errors.AllocationTypeMissing,"helptip-body":_vm.model.Errors.AllocationTypeMissing && "Please select an Allocation Type." || "","displayAllocationError":_vm.model.Errors.AllocationMissing,"name":"allocation_section"},on:{"allocationForScanSelected":_vm.onSelectAllocationType}}):_vm._e(),_vm._v(" "),(_vm.settings.CompanySettings.EditingInvoiceScan === false)?_c('ed-textarea',{attrs:{"field-label":"Description","placeholder":"Description","rows":5,"name":"scan_description_textarea"},on:{"input":_vm.onDescriptionChanged},model:{value:(_vm.model.Description),callback:function ($$v) {_vm.$set(_vm.model, "Description", $$v)},expression:"model.Description"}}):_vm._e(),_vm._v(" "),(_vm.settings.CompanySettings.EditingInvoiceScan && _vm.model.Description)?_c('div',[_c('label',[_vm._v("Description")]),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.getDescription))]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.model.DivisionID > 0)?_c('custom-fields',{key:_vm.cFields,ref:"customFieldsRef",attrs:{"endpoint":_vm.api.$.invoice.i2p.customFields,"queryParameters":{invoiceId: _vm.model.PaymentInvoiceId, divisionId: _vm.model.DivisionID, businessUnitId: (_vm.purchaseOrderFromInitParsed && _vm.purchaseOrderFromInitParsed.events[0].lineItems[0] && _vm.purchaseOrderFromInitParsed.events[0].lineItems[0].costCenterAndBusinessUnit.businessUnitId) || _vm.model.BusinessUnitID}},on:{"loaded":_vm.onCustomFieldsLoad}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showUploadError,"title":"Errors","primaryButton":"Ok","type":"medium","name":"show_upload_error"},on:{"close":function($event){return _vm.cloneUploadError()},"confirm":function($event){return _vm.cloneUploadError()}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},_vm._l((_vm.errorMessages),function(message){return _c('p',{key:message},[_vm._v("\n                "+_vm._s(message)+"\n              ")])}),0)]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showConfirmProgramSelected,"title":"","subtitle":_vm.changeProgramMessage,"primaryButton":"Ok","secondaryButton":"Cancel","type":"medium","name":"confirm_program_selected"},on:{"close":function($event){return _vm.changeToPreviousProgram()},"confirm":function($event){return _vm.changeProgram(_vm.program)}}}),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showDiscountDueDateValidationError,"title":"","primaryButton":"false","secondaryButton":"Ok","type":"medium"},on:{"close":function($event){_vm.showDiscountDueDateValidationError=false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_c('br'),_vm._v("You cannot set the due date "+_vm._s(_vm.getDueDateDifferenceInDays)+" days after the invoice date, due to the discounted payment terms that you selected for this invoice. In order to set this due date, you need to change the discounted payment terms for this invoice.")])])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.model.Errors.InvoiceAmountExceededPOThreshold,"title":"","primaryButton":"false","secondaryButton":"Ok","type":"medium"},on:{"close":function($event){_vm.model.Errors.InvoiceAmountExceededPOThreshold=false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_c('br'),_vm._v("The total amount invoiced for this PO cannot exceed the total amount of the PO.")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"clear"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MXIm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programBudget_vue__ = __webpack_require__("/4fP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778e4382_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_programBudget_vue__ = __webpack_require__("oZvA");
function injectStyle (ssrContext) {
  __webpack_require__("o/EM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-778e4382"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programBudget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778e4382_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_programBudget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mb0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_DashboardWrapper__ = __webpack_require__("RTk+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_Dashboard__ = __webpack_require__("kb2E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("NQQ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login_mfa_setup__ = __webpack_require__("WNJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_Programs_create__ = __webpack_require__("a6om");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_Admin_settings__ = __webpack_require__("Ht71");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_Approvals_Approval_list__ = __webpack_require__("Rdqf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_BusinessUnitsAndCostCenters_BU_and_CC_settings__ = __webpack_require__("Lfy/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_FundingInvoiceAndAPSettings__ = __webpack_require__("D0AX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_Import__ = __webpack_require__("F73h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modules_Import_programs__ = __webpack_require__("19h7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modules_Import_expenses__ = __webpack_require__("zlgH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modules_Import_invoices__ = __webpack_require__("dg/a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modules_I2P__ = __webpack_require__("MIoL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modules_InvoiceScan_Queue__ = __webpack_require__("CZwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modules_InvoiceScan_History__ = __webpack_require__("ZrUL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modules_Dashboard_reject_all__ = __webpack_require__("9hMy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modules_Dashboard_approve_all__ = __webpack_require__("2Yta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modules_Payment__ = __webpack_require__("neG2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_modules_Payment_SendApFile__ = __webpack_require__("AbMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_modules_Suppliers_add_supplier__ = __webpack_require__("M6h9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_modules_Network_Insurance_suppliers__ = __webpack_require__("ohQ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_modules_Network_Insurance_suppliers_details__ = __webpack_require__("d5+5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_modules_Programs_Invoice_payments_received__ = __webpack_require__("hV+i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_modules_Programs_Invoice_sent__ = __webpack_require__("jUNV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_modules_Programs_Invoice_sent_cta__ = __webpack_require__("4KMk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_modules_Invoices_suppliers_remit_payment__ = __webpack_require__("vEJA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_modules_Invoices_suppliers_edit_invoice__ = __webpack_require__("+CMy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_modules_Products_Products__ = __webpack_require__("2wGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_modules_Programs_Card_accounts__ = __webpack_require__("F02B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_modules_Programs_Card_cards__ = __webpack_require__("z3J+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_modules_Programs_Card_transactions__ = __webpack_require__("AAet");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_modules_Programs_Card_envelopes__ = __webpack_require__("CDWW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_modules_Programs_Card_list__ = __webpack_require__("AJog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_modules_EvedPay__ = __webpack_require__("0zcJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_modules_EvedPay_cards__ = __webpack_require__("UGg9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_modules_EvedPay_transactions__ = __webpack_require__("fk/s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_modules_EvedPay_cardtransactions__ = __webpack_require__("kaxp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_modules_EvedPay_details__ = __webpack_require__("KT2o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_modules_EvedPay_transactiondetails__ = __webpack_require__("/+ia");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_modules_EvedPay_requestPhysicalCard__ = __webpack_require__("AjDp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_modules_EvedPay_changePin__ = __webpack_require__("Hv0d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_modules_EvedPay_showCardNumber__ = __webpack_require__("NOYx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_modules_EvedPay_requestAddFunds__ = __webpack_require__("2SPK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_modules_EvedPay_ReceiptFolder__ = __webpack_require__("7D5Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_modules_EvedPay_SubmitReceipt__ = __webpack_require__("BtDX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_modules_I2P_ReviewEmailPage__ = __webpack_require__("0nwC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_modules_Payment_ReverseApFile__ = __webpack_require__("7dgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_modules_Payment_CorrectApFile__ = __webpack_require__("M65m");
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * Used for configuring bundles and white-listing modules
 *
 * @returns {Object.<Promise>} default - list of modules that need to be served in separate bundles
 * @param {string} [property]          - module alias (alias for route path also)
 * @param {string} webpackChunkName    - bundle name
 * @param {string} import(arg)         - path to module
 *
 */

















































/* harmony default export */ __webpack_exports__["a"] = ({
  // EvedPay
  EvedPay: {
    module: __WEBPACK_IMPORTED_MODULE_34__components_modules_EvedPay__["default"],
    layout: 'mobile'
  },
  'evedpay/cards': {
    module: __WEBPACK_IMPORTED_MODULE_35__components_modules_EvedPay_cards__["a" /* default */],
    layout: 'mobile'
  },
  'evedpay/transactions': {
    module: __WEBPACK_IMPORTED_MODULE_36__components_modules_EvedPay_transactions__["a" /* default */],
    layout: 'mobile'
  },
  'evedpay/cardtransactions': {
    module: __WEBPACK_IMPORTED_MODULE_37__components_modules_EvedPay_cardtransactions__["a" /* default */],
    layout: 'mobile'
  },
  'evedpay/details': {
    module: __WEBPACK_IMPORTED_MODULE_38__components_modules_EvedPay_details__["a" /* default */],
    layout: 'mobile'
  },
  'evedpay/transactiondetails': {
    module: __WEBPACK_IMPORTED_MODULE_39__components_modules_EvedPay_transactiondetails__["a" /* default */],
    layout: 'mobile'
  },
  'evedpay/requestcard': {
    module: __WEBPACK_IMPORTED_MODULE_40__components_modules_EvedPay_requestPhysicalCard__["a" /* default */],
    layout: 'mobile'
  },
  'evedpay/changepin': {
    module: __WEBPACK_IMPORTED_MODULE_41__components_modules_EvedPay_changePin__["a" /* default */],
    layout: 'mobile'
  },
  'evedpay/shownumber': {
    module: __WEBPACK_IMPORTED_MODULE_42__components_modules_EvedPay_showCardNumber__["a" /* default */],
    layout: 'mobile'
  },
  'evedpay/loadfunds': {
    module: __WEBPACK_IMPORTED_MODULE_43__components_modules_EvedPay_requestAddFunds__["a" /* default */],
    layout: 'mobile'
  },
  'evedpay/receiptfolder': {
    module: __WEBPACK_IMPORTED_MODULE_44__components_modules_EvedPay_ReceiptFolder__["a" /* default */],
    layout: 'mobile'
  },
  'evedpay/submitreceipt': {
    module: __WEBPACK_IMPORTED_MODULE_45__components_modules_EvedPay_SubmitReceipt__["a" /* default */],
    layout: 'mobile'
  },
  // Login module
  Login: {
    module: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */],
    layout: 'auth'
  },
  MfaSetup: {
    module: __WEBPACK_IMPORTED_MODULE_3__components_Login_mfa_setup__["a" /* default */],
    layout: 'auth'
  },
  // Reject all module
  RejectAll: {
    module: __WEBPACK_IMPORTED_MODULE_16__components_modules_Dashboard_reject_all__["a" /* default */],
    layout: 'main'
  },
  // Approve all module
  ApproveAll: {
    module: __WEBPACK_IMPORTED_MODULE_17__components_modules_Dashboard_approve_all__["a" /* default */],
    layout: 'main'
  },
  // Programs module (currenly marked as notImplemented)
  Programs: {
    notImplemented: 'yet',
    pack: utils.include('Programs'),
    module: function module() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "aDuC"));
    },
    layout: 'main'
  },
  // generic
  'Programs/create': {
    module: __WEBPACK_IMPORTED_MODULE_4__components_modules_Programs_create__["default"],
    layout: 'navless'
  },
  // Reporting module (currenly marked as notImplemented)
  Reports: {
    notImplemented: true,
    module: function module() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "0/CK"));
    }
  },
  // Network module (currenly marked as notImplemented)
  // Network  : () => import(/* webpackChunkName: "other" */ './Maps'),
  Network: {
    entry: '/i/Network/SupplierNetwork/'
  },
  'Network/add-supplier': {
    module: __WEBPACK_IMPORTED_MODULE_20__components_modules_Suppliers_add_supplier__["a" /* default */]
  },
  'Network/insurance-management': {
    module: __WEBPACK_IMPORTED_MODULE_21__components_modules_Network_Insurance_suppliers__["a" /* default */]
  },
  'Network/insurance-view-details': {
    module: __WEBPACK_IMPORTED_MODULE_22__components_modules_Network_Insurance_suppliers_details__["a" /* default */],
    layout: 'navless'
  },
  // Dashboards module (-currenly marked as notImplemented-)
  Dashboard: {
    layout: 'main'
  },
  'Dashboard/My': {
    module: __WEBPACK_IMPORTED_MODULE_0__components_modules_DashboardWrapper__["default"],
    layout: 'main'
  },
  'Dashboard/MyDashboard': {
    module: __WEBPACK_IMPORTED_MODULE_1__components_modules_Dashboard__["default"],
    layout: 'main'
  },
  // Administration module (partly implemented)
  Admin: {
    entry: '/d/Admin/Settings/'
  },
  'Admin/Settings': __WEBPACK_IMPORTED_MODULE_5__components_modules_Admin_settings__["a" /* default */],
  'Admin/Approval-list': __WEBPACK_IMPORTED_MODULE_6__components_modules_Approvals_Approval_list__["default"],
  'Admin/BusinessUnitsAndCostCenters': __WEBPACK_IMPORTED_MODULE_7__components_modules_BusinessUnitsAndCostCenters_BU_and_CC_settings__["default"],
  'Admin/FundingInvoiceAndAPFileTemplate': __WEBPACK_IMPORTED_MODULE_8__components_modules_FundingInvoiceAndAPSettings__["default"],
  // Import module (part of Admin)
  'Admin/Import': __WEBPACK_IMPORTED_MODULE_9__components_modules_Import__["default"],
  'Import/Programs': __WEBPACK_IMPORTED_MODULE_10__components_modules_Import_programs__["a" /* default */],
  'Import/Expenses': __WEBPACK_IMPORTED_MODULE_11__components_modules_Import_expenses__["a" /* default */],
  'Import/Invoices': __WEBPACK_IMPORTED_MODULE_12__components_modules_Import_invoices__["a" /* default */],
  // (currenly marked as notImplemented)
  // Invoices : { notImplemented: true },
  Products: {
    notImplemented: true
  },
  Company: {
    notImplemented: true
  },
  'InvoiceToPay/upload': __WEBPACK_IMPORTED_MODULE_13__components_modules_I2P__["default"],
  'Invoice/upload': {
    module: __WEBPACK_IMPORTED_MODULE_13__components_modules_I2P__["default"],
    layout: 'navless'
  },
  'Payment/submit': __WEBPACK_IMPORTED_MODULE_18__components_modules_Payment__["default"],
  'Payment/apfile': __WEBPACK_IMPORTED_MODULE_19__components_modules_Payment_SendApFile__["a" /* default */],
  // Invoice Scanning
  'InvoiceScan/queue': {
    module: __WEBPACK_IMPORTED_MODULE_14__components_modules_InvoiceScan_Queue__["a" /* default */],
    layout: 'navless'
  },
  'InvoiceScan/history': {
    module: __WEBPACK_IMPORTED_MODULE_15__components_modules_InvoiceScan_History__["a" /* default */],
    layout: 'navless'
  },
  // Supplier Invoices
  Invoices: {
    entry: '/d/Invoices/sent'
  },
  'Invoices/payments': __WEBPACK_IMPORTED_MODULE_23__components_modules_Programs_Invoice_payments_received__["default"],
  'Invoices/sent': __WEBPACK_IMPORTED_MODULE_24__components_modules_Programs_Invoice_sent__["default"],
  'Invoices/action-required': __WEBPACK_IMPORTED_MODULE_25__components_modules_Programs_Invoice_sent_cta__["default"],
  'Invoices/remit-payment': __WEBPACK_IMPORTED_MODULE_26__components_modules_Invoices_suppliers_remit_payment__["a" /* default */],
  'Invoices/edit': __WEBPACK_IMPORTED_MODULE_27__components_modules_Invoices_suppliers_edit_invoice__["a" /* default */],
  'Programs/Products': __WEBPACK_IMPORTED_MODULE_28__components_modules_Products_Products__["a" /* default */],
  'Programs/Card/accounts': __WEBPACK_IMPORTED_MODULE_29__components_modules_Programs_Card_accounts__["default"],
  'Programs/Card/cards': __WEBPACK_IMPORTED_MODULE_30__components_modules_Programs_Card_cards__["default"],
  'Programs/Card/transactions': __WEBPACK_IMPORTED_MODULE_31__components_modules_Programs_Card_transactions__["default"],
  'Programs/Card/envelopes': __WEBPACK_IMPORTED_MODULE_32__components_modules_Programs_Card_envelopes__["default"],
  'EnvelopeApprovalDashboard': {
    module: __WEBPACK_IMPORTED_MODULE_32__components_modules_Programs_Card_envelopes__["default"],
    layout: 'navless'
  },
  'Programs/Card/list': __WEBPACK_IMPORTED_MODULE_33__components_modules_Programs_Card_list__["default"],
  'Invoice/review-email': {
    module: __WEBPACK_IMPORTED_MODULE_46__components_modules_I2P_ReviewEmailPage__["a" /* default */],
    layout: 'navless'
  },
  'Programs/Invoice-AP/reverse': __WEBPACK_IMPORTED_MODULE_47__components_modules_Payment_ReverseApFile__["a" /* default */],
  'Programs/Invoice-AP/correct': __WEBPACK_IMPORTED_MODULE_48__components_modules_Payment_CorrectApFile__["a" /* default */]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "Me+w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"ai2TNbLtbfAsCetWYUTUp","Dell":"_3qGBd6hE7KKUGk_BwLvXxX","Abbott":"_26qRMg3hZvfqeP0bjx6KbW","Gap":"MOaB6mrWmQSaiqENgdwZI","Allstate":"_3rKxBPAki1Tsh2kBJQTklf","Asurion":"_3BAjzqGrWUVLteS1jEWiAC","Invitae":"_1zni34c763k5s4AP2k9Njc","JWE":"_1eZNBe2vWj8pPOrKldWkwW"};

/***/ }),

/***/ "MgPI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_data_skybox__ = __webpack_require__("Bn3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_js__ = __webpack_require__("iXO6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_Programs_Card_accounts_tabs__ = __webpack_require__("cUQy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_Programs_Card_list_CardStatus_vue__ = __webpack_require__("1t90");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_Dashboard_widgets_ApprovalNeeded_approve_dialog__ = __webpack_require__("u8Yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_Programs_Card_list_RejectCard_vue__ = __webpack_require__("QAUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modules_Programs_Card_list_ApprovalNeededUsers_vue__ = __webpack_require__("ygWI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modules_Programs_Card_list_AddCard_vue__ = __webpack_require__("11RA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modules_Programs_Card_list_RequestPhysicalCard_vue__ = __webpack_require__("v86b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modules_Programs_Card_list_RequestPhysicalBatch_vue__ = __webpack_require__("oDR5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modules_Programs_Card_list_CardAddFunds_vue__ = __webpack_require__("/roU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modules_Programs_Card_list_ReturnFundsToAccount_vue__ = __webpack_require__("+i84");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modules_Programs_Card_list_CardRefill_vue__ = __webpack_require__("5mev");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modules_Programs_Card_list_CardDailySpendLimit_vue__ = __webpack_require__("eFhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modules_Programs_Card_list_AccountingSystemSettings_vue__ = __webpack_require__("P2/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_modules_Programs_Card_list_CardAdditionalUsers_vue__ = __webpack_require__("EK88");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_modules_Programs_Card_list_ShowCardNumber_vue__ = __webpack_require__("R8ny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_modules_Invoices_actions_cancel__ = __webpack_require__("pV7Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_modules_Invoices_actions_edit_invoice__ = __webpack_require__("UwY+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_modules_Invoices_statuses__ = __webpack_require__("nBkH");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















// import users from '@/core/legacy-auth/users'




var additionalFilters = __WEBPACK_IMPORTED_MODULE_23__components_modules_Invoices_statuses__["k" /* default */].additionalFilters,
  filters = __WEBPACK_IMPORTED_MODULE_23__components_modules_Invoices_statuses__["k" /* default */].filters,
  isActiveFilter = __WEBPACK_IMPORTED_MODULE_23__components_modules_Invoices_statuses__["k" /* default */].isActiveFilter;
var defaultFilter = [];
var cancelTooltip = 'Please select a card.';
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DataSkybox: __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_data_skybox__["a" /* default */],
    Grid: __WEBPACK_IMPORTED_MODULE_3__components_Grid__["a" /* default */],
    CancelInvoice: __WEBPACK_IMPORTED_MODULE_21__components_modules_Invoices_actions_cancel__["a" /* default */],
    EditInvoiceForSupplier: __WEBPACK_IMPORTED_MODULE_22__components_modules_Invoices_actions_edit_invoice__["a" /* default */],
    CardStatus: __WEBPACK_IMPORTED_MODULE_7__components_modules_Programs_Card_list_CardStatus_vue__["a" /* default */],
    ApprovalNeededUsers: __WEBPACK_IMPORTED_MODULE_10__components_modules_Programs_Card_list_ApprovalNeededUsers_vue__["a" /* default */],
    AddCard: __WEBPACK_IMPORTED_MODULE_11__components_modules_Programs_Card_list_AddCard_vue__["a" /* default */],
    RequestPhysicalCard: __WEBPACK_IMPORTED_MODULE_12__components_modules_Programs_Card_list_RequestPhysicalCard_vue__["a" /* default */],
    RequestPhysicalBatch: __WEBPACK_IMPORTED_MODULE_13__components_modules_Programs_Card_list_RequestPhysicalBatch_vue__["a" /* default */],
    ApproveDialog: __WEBPACK_IMPORTED_MODULE_8__components_modules_Dashboard_widgets_ApprovalNeeded_approve_dialog__["default"],
    RejectCard: __WEBPACK_IMPORTED_MODULE_9__components_modules_Programs_Card_list_RejectCard_vue__["a" /* default */],
    CardAddFunds: __WEBPACK_IMPORTED_MODULE_14__components_modules_Programs_Card_list_CardAddFunds_vue__["a" /* default */],
    ReturnFunds: __WEBPACK_IMPORTED_MODULE_15__components_modules_Programs_Card_list_ReturnFundsToAccount_vue__["a" /* default */],
    RefillSettings: __WEBPACK_IMPORTED_MODULE_16__components_modules_Programs_Card_list_CardRefill_vue__["a" /* default */],
    CardDailySpendLimit: __WEBPACK_IMPORTED_MODULE_17__components_modules_Programs_Card_list_CardDailySpendLimit_vue__["a" /* default */],
    AccountingSystemSettings: __WEBPACK_IMPORTED_MODULE_18__components_modules_Programs_Card_list_AccountingSystemSettings_vue__["a" /* default */],
    CardAdditionalUsers: __WEBPACK_IMPORTED_MODULE_19__components_modules_Programs_Card_list_CardAdditionalUsers_vue__["a" /* default */],
    ShowCardNumber: __WEBPACK_IMPORTED_MODULE_20__components_modules_Programs_Card_list_ShowCardNumber_vue__["a" /* default */]
  },
  data: function data() {
    return {
      additionalFilters: additionalFilters,
      defaultFilter: this.$route.query.filter ? filters(this.$route.query.filter.split(',')) : filters(defaultFilter),
      statuses: __WEBPACK_IMPORTED_MODULE_23__components_modules_Invoices_statuses__["m" /* metaStatuses */],
      model: __WEBPACK_IMPORTED_MODULE_5__model_js__["a" /* default */],
      tabs: __WEBPACK_IMPORTED_MODULE_6__components_modules_Programs_Card_accounts_tabs__["a" /* default */].tabs,
      sort: {
        CardNumber: 'desc'
      },
      rowClasses: {
        'negative-amount': function negativeAmount(params) {
          return (params.data || {}).TotalAmount < 0;
        }
      },
      selectedRows: [],
      selectedObj: [],
      selectedAll: null,
      asyncCancelInvoiceDisabledReason: cancelTooltip,
      hasData: false,
      cardsList: [{}],
      showShowCardNumber: false,
      showCardStatus: {
        showModal: false
      },
      helpDeskTicketNumber: '',
      showAddCard: false,
      showRequestPhysicalCardOpen: {
        showModal: false
      },
      showRequestPhysicalBatchOpen: {
        showModal: false
      },
      mailingAddress: {},
      cardStatus: '',
      divisionName: '',
      divisionsName: '',
      objDivisionId: null,
      modalTitle: '',
      showApprovalUsers: false,
      approvalUsersData: {},
      showApproveDialog: false,
      noTooltipFields: ['CardStatus'],
      addFundsErrors: false,
      showAddFunds: false,
      fundingAmount: 0,
      showReturnFundsToAccount: false,
      returnFunds: '',
      isRefillOpen: {
        showModal: false
      },
      isDailySpendLimitOpen: {
        showModal: false
      },
      accountSettings: [],
      loadingAccountSettings: false,
      showAccountingSystemSettings: false,
      showCardAdditionalUsers: false,
      additionalUsers: []
    };
  },
  watch: {
    '$route.query.filter': function $routeQueryFilter(value, oldValue) {
      if (value && value !== oldValue) {
        this.$refs.grid.gridOptions.api.setFilterModel(null);
        this.defaultFilter = filters(value.split(','), {}, this.$route.query.filter && this.$route.query.filter.split(','));
        this.$refs.grid.gridOptions.api.setFilterModel(this.defaultFilter);
      }
    }
  },
  computed: {
    isEvedAdmin: function isEvedAdmin() {
      return !!(this.$user && this.$user.$ && this.$user.$.user && this.$user.$.user.IsEvedAdmin);
    },
    isCardStatusSubmitDisabled: function isCardStatusSubmitDisabled() {
      var isLockUnlock = this.cardStatus === 'lock' || this.cardStatus === 'unlock';
      return isLockUnlock && this.isEvedAdmin && !this.helpDeskTicketNumber.trim();
    },
    accountBalance: function accountBalance() {
      if (this.selectedObj.length && this.selectedObj[0]) {
        return this.selectedObj[0].AccountBalance;
      }
      return {};
    },
    processedSelectedObj: function processedSelectedObj() {
      return this.selectedObj[0] || {};
    },
    cardForShowNumber: function cardForShowNumber() {
      var obj = this.processedSelectedObj;
      return {
        Id: obj.Id,
        AccountId: obj.AccountId,
        CardNumber: obj.CardNumber,
        Holder: obj.Holder || '',
        NameOnCard: obj.NameOnCard || '',
        ExpirationDate: obj.ExpirationDate || ''
      };
    },
    selectedId: function selectedId() {
      return this.selectedRows && this.selectedRows[0] && this.selectedRows[0].data && this.selectedRows[0].data.PaymentInvoiceID;
    },
    lockUnlockButtonText: function lockUnlockButtonText() {
      if (this.selectedObj.length > 0) {
        var cardStatus = this.selectedObj[0].CardStatus;
        switch (cardStatus) {
          case 'Active':
            return 'Lock Card';
          case 'Locked':
            return 'Unlock Card';
          case 'Locked - Lost/Stolen':
            return 'Unlock Card';
          case 'Closed':
            return 'Lock Card';
          default:
            return 'Lock Card';
        }
      }
      return 'Lock Card';
    },
    showApproveButton: function showApproveButton() {
      return this.isUserInApprovalList();
    },
    showRejectButton: function showRejectButton() {
      return this.isUserInApprovalList();
    }
  },
  methods: {
    addFunds: function addFunds() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.fundingAmount <= 0 || _this.fundingAmount > _this.selectedObj[0].AccountBalance)) {
                _context.next = 4;
                break;
              }
              _this.addFundsErrors = true;
              _this.$emit('addFundsError', _this.addFundsErrors);
              return _context.abrupt("return");
            case 4:
              _context.prev = 4;
              _context.next = 7;
              return _this.api.post("evedpaycards/".concat(_this.selectedObj[0].Id, "/add-funds"), {
                Amount: parseFloat(_this.fundingAmount)
              });
            case 7:
              response = _context.sent;
              if (response.status === 200) {
                _this.$emit('success');
                _this.addFundsErrors = false;
                _this.showAddFunds = false;
                _this.refresh();
              }
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              console.error(_context.t0);
            case 14:
              _this.fundingAmount = '';
              _this.addFundsErrors = false;
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 11]]);
      }))();
    },
    doReturnFunds: function doReturnFunds() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (parseFloat(_this2.returnFunds) > 0 && parseFloat(_this2.returnFunds) <= parseFloat(_this2.selectedObj[0].Balance)) {
                _context2.next = 3;
                break;
              }
              alert('Input cannot be 0, negative, or more than the current balance.');
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              _context2.next = 6;
              return _this2.api.post("evedpaycards/".concat(_this2.selectedObj[0].Id, "/remove-funds"), {
                Amount: parseFloat(_this2.returnFunds)
              });
            case 6:
              response = _context2.sent;
              if (response.status === 200) {
                _this2.showReturnFundsToAccount = false;
                _this2.refresh();
              } else {
                _this2.showReturnFundsToAccount = false;
                alert('Failed to return funds.');
              }
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              console.error(_context2.t0);
            case 13:
              _this2.returnFunds = '';
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 10]]);
      }))();
    },
    updateAdditionalUsers: function updateAdditionalUsers() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this3.api.patch("evedpaycards/".concat(_this3.selectedObj[0].Id, "/additional-users"), {
                users: _this3.additionalUsers
              });
            case 3:
              response = _context3.sent;
              if (response.status === 200) {
                _this3.refresh();
                console.log(response.statusText);
              }
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }))();
    },
    approveOrReject: function approveOrReject(cardId) {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              payload = {
                cardsData: JSON.stringify([{
                  Id: cardId
                }])
              };
              _context4.next = 4;
              return _this4.api.post(_this4.api.$.evedpaycard.approveOrReject, payload);
            case 4:
              response = _context4.sent;
              if (response.data) {
                _context4.next = 7;
                break;
              }
              throw new Error('Error during the request');
            case 7:
              _this4.showApproveDialog = false;
              _this4.refresh();
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](0);
              console.error(_context4.t0);
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 11]]);
      }))();
    },
    doApprove: function doApprove() {
      this.approveOrReject(this.selectedRows[0].data.Id);
    },
    transformRows: function transformRows(rows) {
      return rows.map(function (r) {
        var amount = parseFloat(r.data.InitialLoad).toFixed(2);
        var row = {
          NeedsApproval: r.data.CardStatus === 'Pending Approval' ? 'EvedPay Card' : '',
          Amount: amount + ' USD'
        };
        return row;
      });
    },
    handlePslSettingsSave: function handlePslSettingsSave() {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.$refs.accountingSystemSettingsCmp.save();
            case 2:
              res = _context5.sent;
              _this5.showAccountingSystemSettings = !res;
              return _context5.abrupt("return", res);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getApprovalUsers: function getApprovalUsers(cardId) {
      var _this6 = this;
      this.api.get(this.api.$.evedpaycard.approvalUsers, {
        params: {
          cardId: cardId
        }
      }).then(function (response) {
        _this6.approvalUsersData = response.data;
      }).catch(function (error) {
        console.error('There was a problem with the approval users request:', error);
      });
    },
    isUserInApprovalList: function isUserInApprovalList() {
      var currentUserID = this.$root.getUser.$.user.UserID;
      if (Array.isArray(this.approvalUsersData)) {
        return this.approvalUsersData.some(function (user) {
          return user.Id === currentUserID && user.IsCurrentAction;
        });
      }
      return false;
    },
    getAccountSettings: function getAccountSettings(divisionId) {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!_this7.accountSettings[divisionId]) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              _this7.loadingAccountSettings = true;
              _context6.prev = 3;
              _context6.next = 6;
              return _this7.api.get("evedpaycards/accounts/".concat(divisionId, "/settings-by-division"));
            case 6:
              response = _context6.sent;
              if (response.status === 200) {
                _this7.accountSettings[divisionId] = response.data;
              }
              _context6.next = 13;
              break;
            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](3);
              console.log(_context6.t0);
            case 13:
              _context6.prev = 13;
              _this7.loadingAccountSettings = false;
              return _context6.finish(13);
            case 16:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[3, 10, 13, 16]]);
      }))();
    },
    handleButtonClick: function handleButtonClick(cardId) {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return _this8.getApprovalUsers(cardId);
            case 3:
              _this8.showApprovalUsers = true;
              _context7.next = 9;
              break;
            case 6:
              _context7.prev = 6;
              _context7.t0 = _context7["catch"](0);
              console.error('There was a problem handling the button click:', _context7.t0);
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 6]]);
      }))();
    },
    getButtonClass: function getButtonClass() {
      if (this.selectedRows.length >= 0) {
        return 'btn btn-actionbar';
      } else {
        return 'btn btn-actionbar col-md-12';
      }
    },
    hasAccountPermission: function hasAccountPermission(permission) {
      if (this.$user && this.$user.$.userPermissions && this.$user.$.userPermissions.length !== 0) {
        return this.$user.$.userPermissions.includes(permission);
      }
      return false;
    },
    cardActionDisabled: function cardActionDisabled(actionName) {
      if (actionName !== 'close' && actionName !== 'requestPhysicalCard' && this.selectedRows.length > 1) {
        return true;
      }
      return !!this.actionDisabledReason(actionName);
    },
    actionDisabledReason: function actionDisabledReason(actionName) {
      var userId = this.$user.$.user.UserID;
      if (this.selectedRows.length > 1 && actionName !== 'close' && actionName !== 'requestPhysicalCard') {
        switch (actionName) {
          case 'edit':
            return 'You can only edit one card at a time.';
          case 'holdActivity':
            return 'You can only lock/unlock a single card at a time.';
          case 'showCardNumber':
            return 'You can only show the card number for one card at a time.';
          case 'addFunds':
            return 'You can only add funds for one card at a time.';
          case 'returnFunds':
            return 'You can only return funds for one card at a time.';
          case 'reportLostStolen':
            return 'You can only report a single card as being lost/stolen at a time.';
          case 'additionalUsers':
            return 'You can only add additional users for a single card at a time.';
          case 'refillSettings':
            return 'You can only update the refill settings for one card at a time.';
          case 'dailySpendLimit':
            return 'You can only update the daily spend limit for one card at a time.';
          case 'editAccountingSystemSettings':
            return 'You can only update the card settings for one card at a time.';
          default:
            return cancelTooltip;
        }
      }
      if (this.selectedObj.some(function (card) {
        return card.CardStatus !== 'Pending Approval';
      }) && (actionName === 'approve' || actionName === 'reject') && actionName !== 'requestPhysicalCard') {
        return 'You can select cards that are waiting for the approval process.';
      }
      if (this.selectedObj.some(function (card) {
        return card.CardStatus === 'Locked';
      }) && actionName !== 'holdActivity' && actionName !== 'requestPhysicalCard') {
        return 'This card is locked.';
      }
      if (this.selectedObj.some(function (card) {
        return card.CardStatus === 'Closed';
      }) && actionName !== 'requestPhysicalCard') {
        return 'One or more cards are already closed.';
      }
      if (this.selectedObj.some(function (card) {
        return card.CardStatus === 'Locked - Lost/Stolen';
      }) && actionName !== 'holdActivity' && actionName !== 'requestPhysicalCard') {
        return 'This card is Lost/Stolen. Contact Help Desk for further assistance.';
      }
      if (this.selectedObj.some(function (card) {
        return card.CardStatus !== 'Active' || card.IsPhysicalCard === true;
      }) && actionName === 'requestPhysicalCard') {
        return 'Only Active cards that have not had a physical card ordered can be requested.';
      }
      if (this.selectedObj.some(function (card) {
        return card.CardStatus !== 'Active';
      }) && actionName === 'showCardNumber') {
        return 'Card number is only available for active cards.';
      }
      if (this.selectedObj.some(function (card) {
        return card.HolderUserId !== userId;
      }) && actionName === 'showCardNumber') {
        return 'You are not the card holder.';
      }
      if (this.selectedObj.some(function (card) {
        return card.CardStatus === 'Processing';
      })) {
        return 'Please wait for the card to be processed!';
      }
      if (this.selectedObj.some(function (card) {
        return card.CardStatus === 'Inactive';
      })) {
        return 'This card is Inactive, please select another.';
      }
      if (this.selectedObj.some(function (card) {
        return card.CardStatus === 'Pending Approval';
      }) && (actionName !== 'approve' || actionName !== 'reject')) {
        return 'This card is Pending Approval, please select another.';
      }
      if (this.selectedObj.some(function (card) {
        return card.CardStatus === 'Rejected';
      })) {
        return 'This card is declined.';
      }
      // SPRT-18637: block a 2nd funding request while one is still awaiting approval (otherwise it double-allocates and the request gets stuck unapproved)
      if (actionName === 'addFunds' && this.selectedObj.some(function (card) {
        return card.Pending > 0;
      })) {
        return 'A funding request is already pending approval.';
      }
      if (actionName === 'editAccountingSystemSettings' && this.selectedRows.length === 1) {
        var accountSettings = Array.isArray(this.accountSettings) ? this.accountSettings[this.selectedObj[0].DivisionId] : this.accountSettings;
        if (!accountSettings || !accountSettings.AccountingSystem || accountSettings.AccountingSystem.SyncEvedPayCards !== true) {
          return '"PSL+ Integration - Sync Card data" is unchecked.';
        }
      }
      // PRODUCTDEV-5573: per-card pool funding gating (reads card.IsPoolFunding off the grid row).
      if ((actionName === 'addFunds' || actionName === 'returnFunds' || actionName === 'refillSettings') && this.selectedObj.some(function (card) {
        return card.IsPoolFunding;
      })) {
        return "Not available for 'Pool Funding' Allocation Type";
      }
      if (actionName === 'dailySpendLimit' && this.selectedObj.some(function (card) {
        return !card.IsPoolFunding;
      })) {
        return "Daily Spend Limit is not available for 'Per Card Funding' Allocation Type";
      }
      if (this.selectedRows.length === 0) {
        return cancelTooltip;
      }
    },
    rowSelected: function rowSelected(event) {
      var _this9 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (typeof event === 'boolean') {
                _this9.selectedAll = event;
              } else {
                _this9.selectedRows = event;
                _this9.fetchCancelReason();
                _this9.getApprovalUsers(_this9.selectedRows[0].data.Id);
                _this9.isUserInApprovalList();
              }
              if (!(_this9.selectedRows.length > 0)) {
                _context8.next = 8;
                break;
              }
              _this9.selectedObj = _this9.selectedRows.map(function (card) {
                return card.data;
              });
              _this9.objDivisionId = _this9.selectedObj[0].DivisionId;
              _context8.next = 6;
              return _this9.getAccountSettings(_this9.objDivisionId);
            case 6:
              _context8.next = 9;
              break;
            case 8:
              _this9.selectedObj = [];
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    refresh: function refresh() {
      this.$refs.grid.refreshGrid();
    },
    handleStatusFilter: function handleStatusFilter(status) {
      this.$router.push({
        query: {
          filter: undefined
        }
      });
      this.$refs.grid.gridOptions.api.setFilterModel(filters([status], this.$route.query.filter ? {} : this.$refs.grid.gridOptions.api.getFilterModel()));
    },
    statusActive: function statusActive(status) {
      if (!this.$refs.grid) return {};
      return isActiveFilter(status, this.$refs.grid.gridOptions.api.getFilterModel(), this.$route.query.filter && this.$route.query.filter.split(','));
    },
    fetchCancelReason: function fetchCancelReason() {
      var _this10 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee9() {
        var tooltip, reason;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!(!_this10.selectedRows.length || _this10.selectedRows.length > 1)) {
                _context9.next = 3;
                break;
              }
              _this10.asyncCancelInvoiceDisabledReason = cancelTooltip;
              return _context9.abrupt("return");
            case 3:
              _context9.next = 5;
              return _this10.api.forms.post(_this10.api.$.invoice.list.canCancelInvoice, {
                id: _this10.selectedId
              });
            case 5:
              tooltip = _context9.sent;
              reason = __WEBPACK_IMPORTED_MODULE_23__components_modules_Invoices_statuses__["i" /* cannotCancelReasons */][tooltip.data.SuccessMessage];
              _this10.asyncCancelInvoiceDisabledReason = reason || '';
              return _context9.abrupt("return", reason);
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    singularize: function singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value;
    },
    lockCard: function lockCard() {
      var _this11 = this;
      if (this.selectedObj.length > 0) {
        var selectedCard = this.selectedObj[0];
        this.modalTitle = selectedCard.CardStatus === 'Active' ? 'Lock Card Activity' : 'Unlock Card Activity';
        this.cardStatus = selectedCard.CardStatus === 'Active' ? 'lock' : 'unlock';
        this.showCardStatus.showModal = true;
        this.helpDeskTicketNumber = '';
        this.$nextTick(function () {
          _this11.$refs.cardStatusComponent.isActive = selectedCard.CardStatus === 'Locked';
          _this11.$refs.cardStatusComponent.helpDeskTicketNumber = '';
        });
      }
    },
    closeCardStatusModal: function closeCardStatusModal() {
      this.showCardStatus.showModal = false;
      this.helpDeskTicketNumber = '';
      if (this.$refs.cardStatusComponent) {
        this.$refs.cardStatusComponent.helpDeskTicketNumber = '';
      }
    },
    lostStolen: function lostStolen() {
      this.modalTitle = 'Report Card Lost or Stolen';
      this.showCardStatus.showModal = true;
      this.cardStatus = 'report-lost-or-stolen';
    },
    closeCard: function closeCard() {
      this.modalTitle = 'Close EvedPay Card';
      this.showCardStatus.showModal = true;
      this.cardStatus = 'close';
    },
    closeShowCardNumber: function closeShowCardNumber() {
      this.showShowCardNumber = false;
      if (this.$refs.showCardNumberComponent) {
        this.$refs.showCardNumberComponent.resetOtpState();
      }
    }
  },
  created: function created() {
    this.divisionName = this.singularize(this.$root.getUser.settings.Labels.DivisionName);
    this.divisionsName = this.$root.getUser.settings.Labels.DivisionsName;
    this.model.Division.label = this.divisionName;
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off('status-changed');
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on('status-changed', this.refresh);
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off('physicalCardRequested');
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on('physicalCardRequested', this.refresh);
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off('refill');
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on('refill', this.refresh);
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off('dailySpendLimit');
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on('dailySpendLimit', this.refresh);
    this.hasAccountPermission();
  }
});

/***/ }),

/***/ "Mhyw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgogICAgPHBhdGggZD0iTSAxNiAzIEMgOC44MzIxNDI5IDMgMyA4LjgzMjE0MjkgMyAxNiBDIDMgMjMuMTY3ODU3IDguODMyMTQyOSAyOSAxNiAyOSBDIDIzLjE2Nzg1NyAyOSAyOSAyMy4xNjc4NTcgMjkgMTYgQyAyOSA4LjgzMjE0MjkgMjMuMTY3ODU3IDMgMTYgMyB6IE0gMTYgNSBDIDIyLjA4Njk3NyA1IDI3IDkuOTEzMDIzMSAyNyAxNiBDIDI3IDIyLjA4Njk3NyAyMi4wODY5NzcgMjcgMTYgMjcgQyA5LjkxMzAyMzEgMjcgNSAyMi4wODY5NzcgNSAxNiBDIDUgOS45MTMwMjMxIDkuOTEzMDIzMSA1IDE2IDUgeiBNIDE0LjUxMzY3MiAxMi43ODcxMDkgTCAxMS44MDQ2ODggMTQuOTE3OTY5IEMgMTEuNDc1Njg3IDE0LjA5Mzk2OSAxMC42MDA3NjYgMTMuMzI0MjE5IDkuMzg0NzY1NiAxMy4zMjQyMTkgTCA3LjA2ODM1OTQgMTMuMzI0MjE5IEwgNy4wNjgzNTk0IDE4LjQ4NjMyOCBMIDkuMzgyODEyNSAxOC40ODYzMjggQyAxMC40NzM4MTMgMTguNDg2MzI4IDExLjQxMzY4NyAxNy44MzE1NzggMTEuODA0Njg4IDE2Ljg5MjU3OCBMIDE0LjUxMzY3MiAxOS4wMjM0MzggTCAxNy40NzY1NjIgMTYuNjkzMzU5IEwgMTcuNDc4NTE2IDE4LjQ4NDM3NSBMIDIxLjA3NDIxOSAxOC40ODQzNzUgTCAyMS4wNzQyMTkgMTYuOTc0NjA5IEwgMTkuMjgxMjUgMTYuOTc0NjA5IEwgMTkuMjgxMjUgMTMuMzIyMjY2IEwgMTcuNDc4NTE2IDEzLjMyMjI2NiBMIDE3LjQ3ODUxNiAxNS4xMTUyMzQgTCAxNC45OTQxNDEgMTcuMDY2NDA2IEwgMTQuNTE3NTc4IDE2LjY5MTQwNiBMIDE2Ljk5ODA0NyAxNC43NDAyMzQgTCAxNS45OTQxNDEgMTMuOTUxMTcyIEwgMTMuNTEzNjcyIDE1LjkwMjM0NCBMIDEzLjAzNzEwOSAxNS41MjkyOTcgTCAxNS41MTk1MzEgMTMuNTc2MTcyIEwgMTQuNTEzNjcyIDEyLjc4NzEwOSB6IE0gMjEuNTUwNzgxIDEzLjMyNDIxOSBMIDIxLjU1MDc4MSAxOC40ODYzMjggTCAyNS4xNDY0ODQgMTguNDg2MzI4IEwgMjUuMTQ2NDg0IDE2Ljk3ODUxNiBMIDIzLjM1MzUxNiAxNi45Nzg1MTYgTCAyMy4zNTM1MTYgMTMuMzI0MjE5IEwgMjEuNTUwNzgxIDEzLjMyNDIxOSB6IE0gOC44MDI3MzQ0IDE0LjgwODU5NCBMIDkuMjAzMTI1IDE0LjgwODU5NCBDIDkuODU4MTI1IDE0LjgwODU5NCAxMC4zMjIyNjYgMTUuMjA0MjUgMTAuMzIyMjY2IDE1LjkwNjI1IEMgMTAuMzIyMjY2IDE2LjY3MDI1IDkuODAxMzU5NCAxNy4wMDM5MDYgOS4xOTMzNTk0IDE3LjAwMzkwNiBMIDguODAyNzM0NCAxNy4wMDM5MDYgTCA4LjgwMjczNDQgMTQuODA4NTk0IHoiIGZpbGw9IiNmZmZmZmYiIHN0cm9rZT0ibm9uZSIgZmlsbC1ydWxlPSJub256ZXJvIiAvPgo8L3N2Zz4K"

/***/ }),

/***/ "Mktf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.name, _vm.isInIframe ? "embedded" : ""],attrs:{"id":"layout"}},[_c('div',{staticClass:"wrapper centered",class:{ 'nav-open' : _vm.navOpened }},[_c('sidebar',{attrs:{"open":_vm.navOpened},on:{"linkClicked":_vm.toggleSideBar}}),_c('div',{staticClass:"main-panel",class:{ 'loading' : _vm.loading }},[(!_vm.isInIframe)?_c('ed-meta-nav'):_vm._e(),(!_vm.isInIframe)?_c('navigation',{attrs:{"reference":_vm.reference},on:{"toggleSideBar":_vm.toggleSideBar}}):_vm._e(),_vm._t("default"),(!_vm.isInIframe)?_c('md-footer'):_vm._e(),(_vm.navOpened)?_c('div',{staticClass:"close-layer",on:{"click":_vm.onCloseLayerClick}}):_vm._e()],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MlyN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pointer: 0,
      selectedPointer: 0,
      pointerDirty: false
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: true
    },
    optionHeight: {
      type: Number,
      default: 32
    }
  },
  computed: {
    pointerPosition: function pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    selectedPointerPosition: function selectedPointerPosition() {
      return this.selectedPointer * this.optionHeight;
    },
    visibleElements: function visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions: function filteredOptions() {
      this.pointerAdjust();
    },
    isOpen: function isOpen() {
      this.pointerDirty = false;
    }
  },
  methods: {
    optionHighlight: function optionHighlight(index, option) {
      return {
        'multiselect__option--highlight': index === this.pointer && this.showPointer,
        'multiselect__option--selected': this.isSelected(option),
        'dawnSelect--disabled': this.isDisabled(option)
      };
    },
    addPointerElement: function addPointerElement() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Enter',
        key = _ref.key;
      /* istanbul ignore else */
      if (this.filteredOptions.length > 0) {
        this.select(this.filteredOptions[this.pointer], key);
      }
      this.pointerReset();
    },
    pointerForward: function pointerForward() {
      /* istanbul ignore else */
      if (this.pointer < this.filteredOptions.length - 1) {
        this.pointer++;
        /* istanbul ignore next */
        if (this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight) {
          this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight;
        }
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer].$isLabel) this.pointerForward();
      }
      this.pointerDirty = true;
    },
    pointerBackward: function pointerBackward() {
      if (this.pointer > 0) {
        this.pointer--;
        /* istanbul ignore else */
        if (this.$refs.list.scrollTop >= this.pointerPosition) {
          this.$refs.list.scrollTop = this.pointerPosition;
        }
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer].$isLabel) this.pointerBackward();
      } else {
        /* istanbul ignore else */
        if (this.filteredOptions[0].$isLabel) this.pointerForward();
      }
      this.pointerDirty = true;
    },
    pointerReset: function pointerReset() {
      /* istanbul ignore else */
      if (!this.closeOnSelect) return;
      this.pointer = 0;
      /* istanbul ignore else */
      if (this.$refs.list) {
        this.$refs.list.scrollTop = 0;
      }
    },
    pointerAdjust: function pointerAdjust() {
      /* istanbul ignore else */
      if (this.pointer >= this.filteredOptions.length - 1) {
        this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0;
      }
    },
    pointerSet: function pointerSet(index) {
      this.pointer = index;
      this.pointerDirty = true;
    },
    selectedPointerSet: function selectedPointerSet(index, option) {
      var _this = this;
      this.selectedPointer = this.options.findIndex(function (o) {
        return o[_this.trackBy] === option[_this.trackBy];
      });
    }
  }
});

/***/ }),

/***/ "MnJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",attrs:{"data-color":"purple"}},[_vm._m(0),_c('div',{staticClass:"sidebar-wrapper"},[_c('ul',{staticClass:"nav"},_vm._l((_vm.tabs),function(tab,key){return _c('item',{key:key,attrs:{"title":_vm.$t(tab.alias || key),"href":"/" + _vm.namespace + "/" + key,"icon":"fas fa-arrow-circle-right"},on:{"click":_vm.linkClicked}},_vm._l((tab.subtabs),function(subTab,subKey){return _c('a',{key:subKey,attrs:{"title":_vm.$t(subKey),"href":"#/" + _vm.sectionNamespace(key, subTab, subKey) + "/" + key + "/" + _vm.section(key, subTab, subKey) + "/"},on:{"click":_vm.linkClicked}},[_vm._v(_vm._s(subKey))])}),0)}),1)]),_c('div',{staticClass:"sidebar-background"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text",attrs:{"href":"http://www.eved.com"}},[_c('img',{attrs:{"src":__webpack_require__("AqYs"),"height":"35"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MxJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Grid_cells_actions__ = __webpack_require__("ayPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AllocationsSection_AllocationsStore_js__ = __webpack_require__("IowB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus__ = __webpack_require__("Usg1");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_2__components_Grid__["a" /* default */]
  },
  props: {
    model: Object,
    currencyCode: String,
    invoiceAmount: Number,
    vatAmount: Number,
    additionalNoRequired: Boolean
  },
  data: function data() {
    var _this = this;
    return {
      allocations: [],
      subtotal: '0',
      formulas: {
        'Percent': function Percent(percent) {
          return Math.round(_this.totalInvoiceAmount * percent / 100 * 100) / 100;
        },
        'Amount': function Amount(amount) {
          return Math.round(amount * 100 / _this.totalInvoiceAmount * 100) / 100;
        }
      },
      columnToUpdate: {
        'Amount': 'Percent',
        'Percent': 'Amount'
      },
      validateNumeric: {
        'Percent': function Percent() {
          return true;
        },
        'Amount': function Amount() {
          return true;
        }
      },
      totalInvoiceAmount: 0,
      validAllocations: true
    };
  },
  watch: {
    invoiceAmount: function invoiceAmount() {
      this.updateHighLevelGrid();
    },
    vatAmount: function vatAmount() {
      this.updateHighLevelGrid();
    }
  },
  computed: {
    actions: function actions() {
      return [__WEBPACK_IMPORTED_MODULE_3__components_Grid_cells_actions__["g" /* remove */]];
    }
  },
  created: function created() {
    this.updateTotal();
    this.setTotalInvoiceAmount();
    this.setValidTotalForGrid();
  },
  methods: {
    store: function store() {
      return new __WEBPACK_IMPORTED_MODULE_4__AllocationsSection_AllocationsStore_js__["a" /* default */](this.api);
    },
    add: function add() {
      var item = {
        'Id': '',
        'Name': '',
        'Amount': '0',
        'Percent': '0',
        'AdditionalNo': ''
      };
      this.model.AllocationList.splice(0, 0, item);
      this.updateGrid();
    },
    changeRow: function changeRow(item, type) {
      this.validateRow(item.data);
      this.validateNumericFields(item);
      this.updateAllocation(item);
      this.handleRoundingIssues();
      this.updateAdditionalNo(item);
      this.changeAllocation();
    },
    validateNumericFields: function validateNumericFields(item) {
      if (this.validateNumeric[item.columnId] && this.validateNumeric[item.columnId]()) {
        if (isNaN(item.data[item.columnId])) {
          item.data[item.columnId] = 0;
        }
      }
    },
    validateRow: function validateRow(item) {
      var isValid = true;
      if (item.Name === '') {
        item._invalid = 'true';
        isValid = false;
      }
      if (this.additionalNoRequired && !item.AdditionalNo) {
        item._invalid = 'true';
        isValid = false;
      }
      if (isValid) {
        item._invalid = '';
      }
    },
    updateAllocation: function updateAllocation(item) {
      if (this.formulas[item.columnId] && this.totalInvoiceAmount) {
        item.data[this.columnToUpdate[item.columnId]] = this.formulas[item.columnId](+Number(item.data[item.columnId]));
      }
    },
    updateAdditionalNo: function updateAdditionalNo(item) {
      var allocation = this.model.SelectionList.filter(function (modelItem) {
        return modelItem.Value === item.data.Name;
      })[0];
      if (allocation) {
        if (item.columnId === 'Name') {
          item.data.AdditionalNo = allocation.AdditionalNo;
          item.data.Id = allocation.Key;
        }
      }
    },
    updateAllAllocations: function updateAllAllocations() {
      var _this2 = this;
      this.model.AllocationList.map(function (item) {
        var newItem = {};
        newItem.columnId = 'Percent';
        newItem.data = item;
        _this2.updateAllocation(newItem);
        item = newItem;
        return item;
      });
      this.handleRoundingIssues();
      this.changeAllocation();
    },
    // (CORP-239) Handle rounding issues by tampering total allocated to last category
    // https://evedllc.atlassian.net/browse/WORKFLOW-239
    handleRoundingIssues: function handleRoundingIssues() {
      var _this3 = this;
      var sumOfPercent = 0;
      var sumOfAmount = 0;
      this.model.AllocationList.map(function (item) {
        if (item.Percent) {
          sumOfPercent += Number(item.Percent);
        }
        if (item.Amount) {
          sumOfAmount += Number(item.Amount);
        }
      });
      if (sumOfPercent === 100) {
        if (sumOfAmount !== this.totalInvoiceAmount) {
          var sumToUpdate = this.totalInvoiceAmount - sumOfAmount;
          // update last allocation
          this.model.AllocationList.map(function (item, index) {
            if (index === _this3.model.AllocationList.length - 1) {
              item.Amount = (Number(item.Amount) + sumToUpdate).toFixed(2);
            }
          });
        }
      }
    },
    changeAllocation: function changeAllocation() {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this4.updateTotal();
              payload = {
                Type: _this4.model.Type,
                Allocation: _this4.model.AllocationList,
                ValidAllocations: _this4.checkAllocationsAreValid()
              };
              _this4.updateGrid();
              __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* Eved */].I2P.CHANGE_ALLOCATION, payload);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    checkAllocationsAreValid: function checkAllocationsAreValid() {
      var _this5 = this;
      var valid = true;
      this.model.AllocationList.map(function (item) {
        _this5.validateRow(item);
        if (item._invalid === 'true') {
          valid = false;
        }
      });
      return valid;
    },
    updateGrid: function updateGrid() {
      this.$refs.allocations && this.$refs.allocations.updateRowData();
    },
    removeRow: function removeRow(payload, success, fail) {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this6.model.AllocationList.splice(+payload.index, 1);
              _context2.next = 3;
              return _this6.changeAllocation();
            case 3:
              success();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    removeRows: function removeRows(payload, success) {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var itemsToDelete, indexesOfItemsToDelete;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              itemsToDelete = payload.rows.map(function (k) {
                return k.data;
              });
              indexesOfItemsToDelete = [];
              _this7.model.AllocationList.map(function (item, index) {
                if (itemsToDelete.indexOf(item) > -1) {
                  indexesOfItemsToDelete.push(index);
                }
              });
              indexesOfItemsToDelete.map(function (item, index) {
                _this7.model.AllocationList.splice(item - index, 1);
              });
              _context3.next = 6;
              return _this7.changeAllocation();
            case 6:
              _this7.updateGrid();
              success();
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    updateTotal: function updateTotal() {
      var total = 0;
      var totalPercent = 0;
      this.model.AllocationList.forEach(function (item) {
        if (item.Amount) {
          total = total + +item.Amount;
        }
        if (item.Percent) {
          totalPercent += Number(item.Percent);
        }
      });
      this.subtotal = +total;
      this.model.TotalPercent = totalPercent;
      this.setValidTotalForGrid();
    },
    updateHighLevelGrid: function updateHighLevelGrid() {
      // For: Category Allocation grid
      // Percentage and Amount is calculated based on Amount - VATGST

      this.setTotalInvoiceAmount();
      this.updateGrid();
      this.updateAllAllocations();
    },
    setTotalInvoiceAmount: function setTotalInvoiceAmount() {
      if (!isNaN(this.invoiceAmount)) {
        if (!isNaN(this.vatAmount)) {
          this.totalInvoiceAmount = this.invoiceAmount - this.vatAmount;
        } else {
          this.totalInvoiceAmount = this.invoiceAmount;
        }
      }
    },
    setValidTotalForGrid: function setValidTotalForGrid() {
      if (this.model.GridModel.Amount.validSum) {
        this.model.GridModel.Amount.validSum.value = this.totalInvoiceAmount;
      }
    }
  }
});

/***/ }),

/***/ "N313":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__("BRZl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MdFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer__["a" /* default */]
  },
  data: function data() {
    return {
      name: 'layout-auth ' + (this.$route.query.sk ? 'loading' : ''),
      env: this.api.env
    };
  },
  computed: {
    loading: function loading() {
      return this.$loading;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.state.isLoggedIn || typeof this.$route.query.mfa !== 'undefined' || !!~this.$route.path.indexOf('mfa-');
    }
  }
});

/***/ }),

/***/ "N3ql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkbox',
  props: {
    value: [Boolean, Array],
    optionIndex: Number,
    optionLabel: String,
    optionStatus: Boolean,
    name: String,
    disabled: Boolean,
    removeOnly: Boolean,
    error: Boolean,
    icon: String,
    iconColor: String
  },
  data: function data() {
    return {
      tooltip: ''
    };
  },
  computed: {
    _optionStatus: function _optionStatus() {
      return this.optionStatus;
    },
    _optionLabel: function _optionLabel() {
      return this.optionName;
    },
    _optionIndex: function _optionIndex() {
      return this.optionIndex;
    }
  },
  mounted: function mounted() {
    this.tooltip = this.$refs.optionLabel.getBoundingClientRect().width > this.$refs.optionWrapper.clientWidth - 10 ? this.optionLabel : null;
  },
  methods: {
    changeStatus: function changeStatus(e) {
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit('changeStatus', {
        'idx': this._optionIndex,
        'status': !this._optionStatus,
        'value': e.target.checked
      });
      //
      this.$emit('change-status', e.target.checked);
      this.$emit('input', e.target.checked || '');
      e.target.checked && __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].GENERIC.SELECTED_CHECKBOX, this.optionLabel);
    },
    remove: function remove() {
      this.changeStatus({
        target: {
          checked: false
        }
      });
    }
  }
});

/***/ }),

/***/ "N7mj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FundingInformation_vue__ = __webpack_require__("JHbF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06463ab8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FundingInformation_vue__ = __webpack_require__("hn0m");
function injectStyle (ssrContext) {
  __webpack_require__("yA1C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06463ab8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FundingInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06463ab8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FundingInformation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N89l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  props: {
    rejectionReason: ''
  },
  methods: {},
  created: function created() {}
});

/***/ }),

/***/ "N9pM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_api_httpPlatform__ = __webpack_require__("03tc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_api_receiptScans__ = __webpack_require__("X3jq");



// Backoff was [1000, 2000, 3000] — that capped detection latency at 3s, which the
// user perceived as the "Scanning your receipt" progress card lingering for ~1s on
// average after Photon actually finished. Halved across the board: first poll 500ms,
// then 750ms, then 1000ms thereafter. Worst-case gap drops from 3s to 1s; average
// drops from ~1.5s to ~500ms — at the cost of ~2x as many polls per scan (~12-13
// over a 15s scan instead of ~7), which Platform's getStatus easily handles.
var BACKOFF_SCHEDULE = [500, 750, 1000];
var POLL_TIMEOUT_MS = 60000;
var SCANNING_LONG_THRESHOLD_MS = 15000;
var STATUS_UPLOADING = 'Uploading';
var STATUS_SCANNING_SHORT = 'ScanningShort';
var STATUS_SCANNING_LONG = 'ScanningLong';
var STATUS_POLLING_TIMEOUT = 'PollingTimeout';
var STATUS_COMPLETE = 'Complete';
var STATUS_FAILED = 'Failed';
var STATUS_PLATFORM_UNREACHABLE = 'PlatformUnreachable';
function createReceiptScanPoller(options) {
  var receiptScanId = options.receiptScanId;
  var contextHint = options.contextHint || {};
  var onStateChange = options.onStateChange || function () {};
  var onDone = options.onDone || function () {};
  var onError = options.onError || function () {};
  var httpPlatform = options.httpPlatform || __WEBPACK_IMPORTED_MODULE_0__core_api_httpPlatform__["a" /* default */];
  var receiptScansApi = options.receiptScansApi || __WEBPACK_IMPORTED_MODULE_1__core_api_receiptScans__["b" /* default */];
  var pollIndex = 0;
  var timerId = null;
  var timeoutId = null;
  var cancelled = false;
  var running = false;
  var startedAt = null;
  // Per-cycle controller so cleanup() can abort the in-flight axios request
  // (otherwise the pending getStatus resolves through httpPlatform's 3-retry
  // backoff before noticing it was cancelled).
  var controller = null;
  // Extra retry budget for transient 5xx/network errors that get past the
  // httpPlatform retry interceptor (3 attempts). Capped low so we don't
  // compound budgets.
  var transientRetryCount = 0;
  var TRANSIENT_RETRY_CAP = 2;
  var DEFAULT_429_RETRY_MS = 5000;
  function getDelay() {
    var idx = pollIndex < BACKOFF_SCHEDULE.length ? pollIndex : BACKOFF_SCHEDULE.length - 1;
    return BACKOFF_SCHEDULE[idx];
  }
  function resolveStatus(serverStatus, elapsed) {
    if (serverStatus === 'ReadyForMatch' || serverStatus === 'Matched' || serverStatus === 'FolderSaved') {
      return STATUS_COMPLETE;
    }
    if (serverStatus === 'Failed' || serverStatus === 'Cancelled') {
      return STATUS_FAILED;
    }
    if (serverStatus === 'Uploaded' || serverStatus === 'Scanning') {
      return elapsed >= SCANNING_LONG_THRESHOLD_MS ? STATUS_SCANNING_LONG : STATUS_SCANNING_SHORT;
    }
    return STATUS_UPLOADING;
  }
  function poll() {
    if (cancelled) {
      return;
    }
    var elapsed = Date.now() - startedAt;
    if (elapsed >= POLL_TIMEOUT_MS) {
      onStateChange(STATUS_POLLING_TIMEOUT);
      onError({
        type: 'timeout',
        message: 'Polling timed out after ' + POLL_TIMEOUT_MS + 'ms'
      });
      cleanup();
      return;
    }
    controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var requestConfig = controller ? {
      signal: controller.signal
    } : undefined;
    receiptScansApi.getStatus(receiptScanId, requestConfig).then(function (data) {
      if (cancelled) {
        return;
      }

      // Reset transient budget on any successful response.
      transientRetryCount = 0;
      var status = resolveStatus(data.status, elapsed);
      onStateChange(status, data);
      if (status === STATUS_COMPLETE) {
        onDone({
          receiptScanId: receiptScanId,
          status: data.status,
          autoLinked: data.autoLinked || false,
          matchCandidates: data.matchCandidates || [],
          autoFill: data.autoFill || null,
          warnings: data.warnings || [],
          contextHint: contextHint,
          // Full getStatus response — lets consumers skip an extra round-trip when
          // they need fields not in the curated payload above (e.g. rowVersion,
          // merchant, transactionDate, amount). Non-breaking addition: prior
          // consumers that destructure the curated keys continue to work.
          data: data
        });
        cleanup();
        return;
      }
      if (status === STATUS_FAILED) {
        onError({
          type: 'scan_failed',
          message: 'Receipt scan failed',
          data: data
        });
        cleanup();
        return;
      }
      pollIndex++;
      timerId = setTimeout(poll, getDelay());
    }).catch(function (error) {
      if (cancelled) {
        return;
      }

      // 401 — token rotation / auth failure. Signal caller and stop; the poller
      // doesn't try to re-auth.
      if (error.response && error.response.status === 401) {
        onError({
          type: 'auth_failure',
          message: 'Authentication failed',
          error: error
        });
        cleanup();
        return;
      }

      // 429 — respect Retry-After if present, otherwise back off ~5s. Keep polling.
      if (error.response && error.response.status === 429) {
        var retryAfterHeader = error.response.headers && (error.response.headers['retry-after'] || error.response.headers['Retry-After']);
        var retryAfterMs = DEFAULT_429_RETRY_MS;
        if (retryAfterHeader) {
          var parsed = parseInt(retryAfterHeader, 10);
          if (!isNaN(parsed) && parsed > 0) {
            retryAfterMs = parsed * 1000;
          }
        }
        timerId = setTimeout(poll, retryAfterMs);
        return;
      }

      // 5xx / network blip — httpPlatform's retry interceptor already attempted
      // 3 retries with backoff. Give the poller one or two extra attempts before
      // surfacing as unreachable.
      if (httpPlatform.isPlatformSentinelError(error)) {
        if (transientRetryCount < TRANSIENT_RETRY_CAP) {
          transientRetryCount++;
          timerId = setTimeout(poll, getDelay());
          return;
        }
        onStateChange(STATUS_PLATFORM_UNREACHABLE);
        onError({
          type: 'unreachable',
          message: 'Platform unreachable',
          error: error
        });
        cleanup();
        return;
      }

      // Other 4xx / structural — tear down.
      onError({
        type: 'poll_error',
        message: 'Polling error',
        error: error
      });
      cleanup();
    });
  }
  function cleanup() {
    running = false;
    if (controller) {
      try {
        controller.abort();
      } catch (e) {/* AbortController.abort never throws in normal browsers; defensive */}
      controller = null;
    }
    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  }
  return {
    start: function start() {
      if (running) {
        return;
      }
      running = true;
      cancelled = false;
      pollIndex = 0;
      startedAt = Date.now();
      poll();
    },
    cancel: function cancel() {
      cancelled = true;
      cleanup();
    }
  };
}
createReceiptScanPoller.STATUS_UPLOADING = STATUS_UPLOADING;
createReceiptScanPoller.STATUS_SCANNING_SHORT = STATUS_SCANNING_SHORT;
createReceiptScanPoller.STATUS_SCANNING_LONG = STATUS_SCANNING_LONG;
createReceiptScanPoller.STATUS_POLLING_TIMEOUT = STATUS_POLLING_TIMEOUT;
createReceiptScanPoller.STATUS_COMPLETE = STATUS_COMPLETE;
createReceiptScanPoller.STATUS_FAILED = STATUS_FAILED;
createReceiptScanPoller.STATUS_PLATFORM_UNREACHABLE = STATUS_PLATFORM_UNREACHABLE;
/* harmony default export */ __webpack_exports__["a"] = (createReceiptScanPoller);

/***/ }),

/***/ "NGTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__("C9uT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__("Z60a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__("HrSB");



var DEFAULT_CHART_TRANSFORM = __WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transform */];
var DEFAULT_CHART_TYPE = 'Line';
var DEFAULT_CHART_OPTIONS = {
  customSettings: {
    containterStyle: '',
    showSmallLegend: false,
    showInChartLegend: false,
    recalculateGridMax: false,
    chartInfoTooltip: false,
    multipleSeries: false,
    hasDrillDown: false,
    tooltip: {
      width: '120px',
      topOffset: 0,
      leftOffset: 0
    }
  },
  showGridBackground: true,
  dynamicWidth: false,
  axisX: {
    showGrid: false
  },
  axisY: {
    labelOffset: {
      x: 0,
      y: 10
    }
  },
  // low: 0,
  // high: 1000,
  chartPadding: {
    top: 16,
    right: 10,
    bottom: 0,
    left: 0
  }
};
var RenderComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function RenderComponent(chart) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, RenderComponent);
  this.chartType = chart.chartType || DEFAULT_CHART_TYPE;
  this.chartData = chart.chartData || DEFAULT_CHART_TRANSFORM;
  this.chartInfo = chart.chartInfo || [];
  this.chartOpts = chart.chartOpts || DEFAULT_CHART_OPTIONS;
  this.colors = chart.colors || {};
  this.showLegend = chart.showLegend || false;
  this.showSmallLegend = chart.showSmallLegend || false;
  this.showInChartLegend = chart.showInChartLegend || false;
  this.components = chart.components;
  this.drillDown = chart.drillDown;
  this.drillDownReturn = chart.drillDownReturn;
  this.customSettings = chart.chartOpts.customSettings || DEFAULT_CHART_OPTIONS.customSettings;
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_store__ = __webpack_require__("dgq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_lang__ = __webpack_require__("pe4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_async_computed__ = __webpack_require__("JJ92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_api__ = __webpack_require__("Ea+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_components__ = __webpack_require__("E3YO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_components_mdNotifications_install__ = __webpack_require__("I2Tf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_charts__ = __webpack_require__("Jepp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_country_code_select__ = __webpack_require__("XsFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_country_code_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_country_code_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__core_value_objects__ = __webpack_require__("84UZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sass_main_scss__ = __webpack_require__("JD12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sass_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_sass_main_scss__);
/* eslint no-multi-spaces: 0 */

global.config = global.config || {
  enableThemes: true
};

// Vue









// Core







// Value objects


// Libraries


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.warnHandler = function (msg, vm, trace) {
  if (~msg.indexOf('Error compiling template')) __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('warning', {
    msg: msg
  });else console.warn(msg, trace);
};

// Install
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_async_computed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__core_api__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__core_components__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__core_components_mdNotifications_install__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__core_charts__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_country_code_select___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__core_value_objects__["a" /* default */]);

// Boot
__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */].boot({
  Vue: __WEBPACK_IMPORTED_MODULE_1_vue__["default"],
  App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__components_store__["a" /* store */],
  i18n: __WEBPACK_IMPORTED_MODULE_6__lang_lang__["a" /* i18n */],
  API: __WEBPACK_IMPORTED_MODULE_9__core_api__["a" /* default */],
  Charts: __WEBPACK_IMPORTED_MODULE_12__core_charts__["a" /* default */]
});

// Version
global.version = "1.0.0";
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "NOYx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showCardNumber_vue__ = __webpack_require__("tzLG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602da145_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showCardNumber_vue__ = __webpack_require__("X8qE");
function injectStyle (ssrContext) {
  __webpack_require__("AfCT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-602da145"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showCardNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602da145_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showCardNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NQQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("slco");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c35c350_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("BIgX");
function injectStyle (ssrContext) {
  __webpack_require__("OcfT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c35c350_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NWtK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-file',
  props: {
    disabled: Boolean
  },
  methods: {
    change: function change(e) {
      this.$destroy();
      this.$parent.addInputFile(e.target);
      // eslint-disable-next-line
      new this.constructor({
        parent: this.$parent,
        el: this.$el
      });
    }
  }
});

/***/ }),

/***/ "NdDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper"},[(_vm.hasData)?_c('div',{staticClass:"scroller"},[_c('div',_vm._l((_vm.groups),function(group,g){return _c('div',{key:g,staticClass:"cards-group"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(group.header))]),_vm._v(" "),_vm._l((group.cards),function(card,i){return _c('card',{key:i,attrs:{"id":("card-" + i),"card":card}})})],2)}),0)]):_vm._e(),_vm._v(" "),(this.loading)?_c('div',{staticClass:"empty-holder"},[_c('span',{staticClass:"updates-loading"}),_vm._v(" Loading recent updates ...\n    ")]):_vm._e(),_vm._v(" "),(!this.loading && !_vm.hasData)?_c('div',{staticClass:"empty-holder"},[_c('i',{staticClass:"fal fa-calendar-alt"}),_vm._v(" "),_vm._m(0)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('p',{staticClass:"bold"},[_vm._v("No Recent Updates")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("No activity in the past two weeks")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nie0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{attrs:{"title":_vm.$t('Payments'),"subtitle":_vm.$t('Manage Invoices & Payments'),"tabs":_vm.tabs}}),_vm._v(" "),_c('legacy-container',{attrs:{"url":_vm.url}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NnNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-notice',
  props: {
    type: {
      type: String,
      default: 'info',
      validator: function validator(val) {
        return ~['', 'alt', 'info', 'success', 'warn', 'danger'].indexOf(val);
      }
    },
    icon: {
      type: String,
      default: ''
    },
    message: String
  }
});

/***/ }),

/***/ "Nv6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Model; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_types__ = __webpack_require__("b1cv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cells_actions__ = __webpack_require__("ayPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MoreActions__ = __webpack_require__("7yIU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cells_checkboxProxy__ = __webpack_require__("aLD8");


/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */






/**
 * Filter constructor
 * @method mixin   - flattens `filterModel`
 * @method request - returns request filter parameters
 *
 */
var Filter = {
  /**
   * @param   {Object} model  - `filterModel`
   * @param   {String} search - quick filter text
   * @returns {Object} filter - flattened (key, val) filter
   */
  mixin: function mixin(model, search, screen) {
    var filter = {};
    model && Object.keys(model).forEach(function (key) {
      model[key].filter ? model[key].type ? filter[model[key].type] = model[key].filter : filter[key] = model[key].filter : null;
    });
    filter.searchTerm = search;
    filter.Screen = screen;
    return filter;
  },
  mixout: function mixout(string, model) {
    if (!string) return null;
    var gridApi = this.gridOptions.columnApi;
    var filter = JSON.parse(string);
    var filterModel = {};
    Object.keys(filter).forEach(function (key) {
      if (model[key] || model["*".concat(key)]) {
        filterModel[key] = {
          filter: filter[key]
        };
        gridApi.getColumn(key).colDef.auto = true;
      }
    });
    return filterModel;
  },
  /**
   * @param   {Object} params - grid state `params`
   * @returns {Object} params - request parameters
   */
  request: function request(params) {
    // const DEFAULT_SORT_COLUMN = 'CreatedDateStr'
    // const DEFAULT_SORT_DIRECTION = 'DESC'

    var sortColumn = params.sortModel.length ? params.sortModel[0].colId : null;
    var sortDirection = params.sortModel.length ? params.sortModel[0].sort.toUpperCase() : null;
    var columnsToLoad;
    if (this.onlyVisibleColumns) {
      var _ref;
      var dependencyColumns = [];
      var idColumn = this.gridOptions.api.columnController.allDisplayedColumns.map(function (column) {
        return column.colDef.uid;
      }).filter(function (column) {
        return column;
      });
      var visibleColumns = this.gridOptions.api.columnController.allDisplayedColumns.filter(function (column) {
        return !column.colDef.action;
      }).map(function (column) {
        column.colDef.dataColumn && dependencyColumns.push(column.colDef.dataColumn.split(','));
        return column.colId;
      });
      columnsToLoad = (_ref = []).concat.apply(_ref, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(idColumn).concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(visibleColumns), dependencyColumns));
      columnsToLoad = columnsToLoad.filter(function (value, i, self) {
        return self.indexOf(value) === i;
      }).join(',');
    }
    return {
      sort: sortColumn,
      dir: sortDirection,
      start: params.startRow || 0,
      limit: 100,
      isLiveGrid: true,
      getJustVisibleColumns: columnsToLoad && this.onlyVisibleColumns,
      filter: JSON.stringify(Filter.mixin(params.filterModel, params.search, params.screen)),
      columnsToLoad: columnsToLoad
    };
  }
};

/**
 * Column model constructor
 * @method mixin  - maps model to `columnDefs`
 * @method header - mixins filters into column model
 *
 */
var Model = {
  /**
   * @param   {Object} model      - backend column model
   * @returns {Array} columnModel - mapped model
   */
  mixin: function mixin(model, actions, grid) {
    var columnModel = [];
    var uid = null;

    // drag handle
    grid.dragRows && columnModel.push({
      action: 'checkbox',
      field: "action-".concat(__WEBPACK_IMPORTED_MODULE_3__cells_actions__["b" /* drag */].name),
      pinned: 'left',
      // cellRenderer: drag.template,
      cellRendererFramework: grid.$root.constructor.extend({
        template: renderComponent(__WEBPACK_IMPORTED_MODULE_3__cells_actions__["b" /* drag */].template)
      }),
      width: 13,
      headerName: '_',
      suppressSorting: true,
      suppressSizeToFit: true
    });
    grid.checkboxes || columnModel.push({
      action: true,
      // pinned: 'right',
      width: 10,
      headerName: '_',
      suppressSorting: true,
      suppressSizeToFit: true
    });

    // fixed (pinned) row selection
    grid.checkboxes && columnModel.push({
      action: grid.dragRows ? true : 'checkbox',
      pinned: 'left',
      width: 30,
      cellRendererFramework: grid.$root.constructor.extend(__WEBPACK_IMPORTED_MODULE_5__cells_checkboxProxy__["a" /* default */]),
      headerName: '_',
      suppressSorting: true,
      suppressSizeToFit: true
    });
    model && Object.keys(model).forEach(function (key, i) {
      var column = key.substr(0, 2) !== '$$' && model[key];
      if (column) {
        var label = model[key] && model[key].label || model[key];
        var columnWidth = grid && grid.fitColumns ? column.width : column.width > 200 ? column.width / 2 : column.width;
        var _key = key.replace('*', '');
        uid = key.charAt(0) === '*' ? _key : uid;
        var colType = __WEBPACK_IMPORTED_MODULE_2__data_types__["a" /* default */].parseType(column, key);
        var isDetailsColumn = column.label === '+';
        columnModel.push({
          tooltipField: grid.noTooltipFields && grid.noTooltipFields.includes(key) ? null : key,
          uid: column.uid || columnModel[0] && columnModel[0].field,
          headerName: label,
          suppressSorting: typeof column.sortable !== 'undefined' ? !column.sortable : isDetailsColumn,
          suppressSizeToFit: column.fixed || isDetailsColumn,
          action: isDetailsColumn,
          width: columnWidth || (i === 1 ? isDetailsColumn ? 1 : 330 : isDetailsColumn ? 1 : 200),
          field: _key,
          hide: typeof column.visible !== 'undefined' && !column.visible || label === '_',
          // cellRenderer : ~label.indexOf('Date') ? DataTypes.date.column : null,
          // editable     : !column.details && column.editable,
          notEditableIf: column.notEditableIf,
          columnEditable: column.editable,
          editable: function editable(params) {
            if (column.notEditableIf && column.notEditableIf.f && params.node.data[column.notEditableIf.f]) return;
            if (params.node.rowPinned === 'bottom' || params.colDef.options || params.node.data._disabled || isDetailsColumn) return;
            if (grid.editable === false) return false;
            return grid.editable === true ? true : column.editable === true || params.node.data._new || params.node.data.draft;
          },
          cellClassRules: {
            'disabled': function disabled(params) {
              return (column.notEditableIf && column.notEditableIf.f ? params.data[column.notEditableIf.f] : false) || column.editable === false || params.data && params.data._disabled === true;
            },
            'editable': function editable(params) {
              return (column.notEditableIf && column.notEditableIf.f ? !params.data[column.notEditableIf.f] : true) && column.editable === true && params.data && params.data._disabled !== true || grid.editable === true && !isDetailsColumn;
            }
          },
          filterFramework: __WEBPACK_IMPORTED_MODULE_2__data_types__["a" /* default */].parseType(column).filter,
          // cellRenderer          : column.uri ? goto.template : null,
          cellRendererFramework: (column.render ? grid.$root.constructor.extend(column.render) : null) || (column.details ? __WEBPACK_IMPORTED_MODULE_2__data_types__["a" /* default */].details : __WEBPACK_IMPORTED_MODULE_2__data_types__["a" /* default */].parseType(column).cell) || (column.uri ? grid.$root.constructor.extend({
            template: renderComponent(__WEBPACK_IMPORTED_MODULE_3__cells_actions__["e" /* goto */].template)
          }) : null),
          cellRendererParams: column.details ? {
            comps: column.detailsComp || grid.rowDetailsComponent,
            detailsCondition: typeof column.detailsCondition === 'undefined' ? function () {
              return true;
            } : column.detailsCondition
          } : null,
          hasDetails: column.details,
          detailsParamsURL: column.detailsParamsURL,
          detailsRender: column.detailsRender,
          // valueFormatter        : p => p.value || label,

          filterParams: {
            applyButton: true,
            clearButton: true,
            newRowsAction: 'keep'
          },
          nowrap: column.nowrap,
          source: column.source,
          uri: column.uri,
          tooltip: column.tooltip,
          onclick: column.onclick,
          options: column.options,
          valueFormatter: function valueFormatter(p) {
            return p.node.rowPinned === 'bottom' ? grid.totalsData[p.colDef.field] : typeof column.compose === 'function' ? column.compose(p) : p.value;
          },
          f: column.f,
          valueGetter: column.getter || column.f,
          className: colType.type || column.type,
          cellClass: colType.type || column.type,
          selectedOptions: column.selectedOptions,
          trackBy: column.trackBy,
          validSum: column.validSum,
          currency: column.currency,
          minTotalThreshold: column.minTotalThreshold,
          maxTotalThreshold: column.maxTotalThreshold,
          minThreshold: column.minThreshold,
          maxThreshold: column.maxThreshold,
          maxLength: column.maxLength,
          validationCol: column.validationCol,
          infoMessage: function infoMessage(params) {
            return typeof column.infoMessage === 'function' ? column.infoMessage(params) : column.infoMessage;
          },
          infoMessageIcon: column.infoMessageIcon,
          showDefaultEmpty: column.showDefaultEmpty,
          alias: column.alias,
          useSupplementalPrecision: column.useSupplementalPrecision || false,
          decimals: column.decimals
        });
      }
    });
    uid = uid || columnModel[0].field;
    if (model.$$view) {
      columnModel.push({
        uid: uid,
        uri: model.$$view.uri,
        action: true,
        cellClass: 'hover-action action-view',
        cellRenderer: __WEBPACK_IMPORTED_MODULE_3__cells_actions__["h" /* view */].template,
        width: 100,
        headerName: '_',
        label: model.$$view.label,
        suppressSorting: true,
        suppressSizeToFit: true
      });
    }
    var lastColumnEditable = model[Object.keys(model).slice(-1)] && model[Object.keys(model).slice(-1)].editable;
    if (actions && actions.length) {
      lastColumnEditable && columnModel.push({
        action: true,
        // pinned: 'right',
        width: 60,
        headerName: '_',
        suppressSorting: true,
        suppressSizeToFit: true
      });
      var actionsExceptExpand = actions.filter(function (action) {
        return action.name !== 'expand';
      });
      var actionsOnlyExpand = actions.filter(function (action) {
        return action.name === 'expand';
      });

      // generic dropdown menu container for actions
      columnModel.push({
        uid: uid,
        action: true,
        field: "more-actions",
        headerName: '_',
        suppressSorting: true,
        suppressSizeToFit: true,
        width: 1,
        cellRendererFramework: grid.$root.constructor.extend(__WEBPACK_IMPORTED_MODULE_4__MoreActions__["a" /* default */]),
        cellRendererParams: {
          actions: actionsExceptExpand.map(function (action) {
            return {
              uid: uid,
              action: true,
              field: "action-".concat(action.name),
              pinned: action.name === 'expand' ? 'left' : null,
              // cellRenderer: action.template,
              cellRendererFramework: grid.$root.constructor.extend({
                template: renderComponent(action.template)
              }),
              tpl: renderComponent(action.template),
              cellRendererParams: {
                actionable: function actionable(params) {
                  return action.name === 'expand' || typeof model.$$actionable === 'function' && model.$$actionable({
                    data: params.data,
                    action: action
                  }) ? true : null || model.$$actionable === true || typeof model.$$actionable === 'undefined' || !model.$$actionable && null;
                }
              },
              headerName: '_',
              suppressSorting: true,
              suppressSizeToFit: true,
              width: action.name === 'expand' ? 35 : 1
            };
          })
        }
      });
      columnModel.push.apply(columnModel, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(actionsOnlyExpand.map(function (action) {
        return {
          uid: uid,
          action: true,
          field: "action-".concat(action.name),
          pinned: action.name === 'expand' ? 'left' : null,
          // cellRenderer: action.template,
          cellRendererFramework: grid.$root.constructor.extend({
            template: renderComponent(action.template)
          }),
          cellRendererParams: {
            actionable: function actionable(params) {
              return action.name === 'expand' || typeof model.$$actionable === 'function' && model.$$actionable({
                data: params.data,
                action: action
              }) ? true : null || model.$$actionable === true || typeof model.$$actionable === 'undefined' || !model.$$actionable && null;
            }
          },
          headerName: '_',
          suppressSorting: true,
          suppressSizeToFit: true,
          width: action.name === 'expand' ? 35 : 1
        };
      })));
    } else {
      columnModel.push({
        action: true,
        // pinned: 'right',
        width: 40,
        headerName: '_',
        suppressSorting: true
        // suppressSizeToFit: true
      });
    }
    return columnModel;
    function renderComponent(renderFn) {
      return "<span v-if='(typeof params.actionable === \"function\" ? params.actionable(params) : true) && !params.node.rowPinned'>\n        ".concat(renderFn({
        node: {
          rowPinned: false
        },
        rowIndex: 'params.rowIndex',
        colDef: {
          uid: 'params.colDef.uid',
          uri: 'params.colDef.uri',
          onclick: 'params.colDef.onclick'
        },
        data: {
          'params.colDef.uid': 'params.data && params.data[params.colDef.uid]',
          'params.colDef.uri': 'params.data && params.data[params.colDef.uri]'
        },
        value: '{{params.value}}',
        text: 'params.value'
      }, grid).replace(/data-/g, ':data-').replace(':data-action', 'data-action').replace(/href/g, ':href'), "\n      </span>");
    }
  },
  /**
   * @param   {Object} model      - backend column model
   * @param   {Object} params     - grid state `params`
   * @returns {Array} columnModel - mapped model
   */
  header: function header(model, params, sort) {
    var columns = [];
    var sortedColumns = [];
    model && Object.keys(model).forEach(function (key, index) {
      var _key = key.replace('*', '');

      // set sorting
      if (params.sortModel.length && params.sortModel[0].colId === _key || sort && sort[key]) {
        sortedColumns.push({
          column: index,
          dir: sort && sort[key] || params.sortModel[0].sort
        });
      }
      columns.push({
        data: _key,
        name: '',
        searchable: true,
        orderable: true,
        search: {
          value: params.filterModel[_key] && params.filterModel[_key].filter || '',
          regex: false
        }
      });
    });
    return {
      draw: 1,
      columns: columns,
      order: sortedColumns,
      start: params.startRow || 0,
      length: 100,
      search: {
        value: params.search,
        regex: false
      }
    };
  },
  sort: function sort(model) {
    var sortModel = [];
    model && Object.keys(model).forEach(function (key) {
      sortModel.push({
        colId: key,
        sort: model[key]
      });
    });
    return sortModel;
  }
};

/**
 * Remote datasource
 * @method fetch - binds `getRows` to api request
 *
 */
var Data = {
  /**
   * @param   {Object} grid               - vue instance
   * @returns {Object} `datasource` model - grid datasource settings
   */
  fetch: function fetch(grid) {
    return {
      rowCount: null,
      getRows: function getRows(params) {
        //
        grid.gridOptions.api && grid.gridOptions.api.hideOverlay();
        if (!grid.savedViews.length && grid.alias) return;
        var legacy = grid.$parent.$vnode.data.class ? grid.$parent.$vnode.data.class.indexOf('legacy') > -1 : grid.legacy;
        var payload = null;
        params.search = grid.searchTerm;
        params.screen = grid.screen;
        if (legacy) {
          payload = Filter.request.call(grid, params);
        } else {
          payload = Model.header(grid.model || grid.$parent.model, params); // , grid.sort)
        }
        if (grid.data) {
          //
          params.successCallback(grid.data, grid.data.length);
        } else {
          var api = grid.endpointPayloadType === 'form' ? grid.api.forms : grid.api;
          var initialSort = !grid.sort || !legacy && grid.sort && payload.order.length || legacy && grid.sort && payload.sort;
          //
          if (grid.currentViewChanged) {
            grid.currentViewChanged = false;
            return;
          }
          !initialSort || api[grid.endpointMethod](grid.endpoint, payload).then(function (response) {
            if (response && response.data && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(response.data) === 'object') {
              //
              grid.pendingRequests--;
              if (response.data.recordsFiltered || response.data.Count) {
                params.successCallback(response.data.data || response.data.Data, response.data.recordsFiltered || response.data.Count);
                if (JSON.parse(response.data.ExtraInfo || '{}').Totals && grid.totals) {
                  grid.totalsData = JSON.parse(response.data.ExtraInfo || '{}').Totals;
                  grid.gridOptions.api.setPinnedBottomRowData([grid.totalsData]);
                }
              } else {
                params.successCallback([], 0);
                grid.pendingRequests || grid.gridOptions.api && grid.gridOptions.api.showNoRowsOverlay();
                if (grid.doNotShowOverlay) {
                  grid.gridOptions.api && grid.gridOptions.api.hideOverlay();
                  grid.doNotShowOverlay = false;
                }
                grid.updateLocales();
              }
              grid.gridOptions.datasource.loaded = true;
              grid.ps.update();
            } else {
              // Notification message
              // (probably session expired)
              if (typeof response.data === 'string') {
                if (response.data.indexOf('session has expired')) {
                  grid.$store.commit('updateSessionValidity', null);
                }
              }
            }
          }).catch(function (error) {
            console.warn(error);

            // Notification message
            global.app.$notifications.notify({
              type: 'warning',
              icon: 'notifications',
              message: error.message,
              placement: {
                from: 'bottom',
                align: 'right'
              }
            });
          }) && grid.pendingRequests++;
        }
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "O5l0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("4XWU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bac1129a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("w8kC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bac1129a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OA49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FundingAddress_vue__ = __webpack_require__("4zWp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87452da6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FundingAddress_vue__ = __webpack_require__("PBkm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FundingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87452da6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FundingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OHRD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpenReconcile_vue__ = __webpack_require__("HZnV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33062124_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpenReconcile_vue__ = __webpack_require__("nY8T");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpenReconcile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33062124_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpenReconcile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OQaH":
/***/ (function(module, exports) {

module.exports = {"InvoiceDetail/:invoiceId":"payments/PaymentInvoice/ReceivedInvoiceList/PaymentInvoiceView/:invoiceId?from=/payments/PaymentInvoice/ReceivedInvoiceList","InvoiceDetail--:invoiceId":"payments/PaymentInvoice/ReceivedInvoiceList/PaymentInvoiceView/:invoiceId?from=/payments/PaymentInvoice/ReceivedInvoiceList","ScopeOfService--View--:poId":"payments/QqSentPurchaseOrder/view/:poId?from=/payments/QqSentPurchaseOrder","d/approve-all":"dashboard/Dashboard/MainDashboard/?web=1&path=/d/approve-all","d/reject-all":"dashboard/Dashboard/MainDashboard/?web=1&path=/d/reject-all","ProgramDashboard/ProgramDashboard/:programId":"payments/programs/view/:programId","ProgramDashboard--ProgramDashboard--:programId":"payments/programs/view/:programId","ProgramFusion--BudgetAndCostCenter--:programId":"payments/programs/view/:programId/?from=/payments/ProgramList&legacy=/ProgramFusion/BudgetAndCostCenter/:programId","RfpList/RfpsOnProgram/:programId":"payments/ProgramList?path=RfpList/RfpsOnProgram/:programId","QqSentPurchaseOrder/QqSentPurchaseOrder/:programId":"payments/ProgramList?path=QqSentPurchaseOrder/QqSentPurchaseOrder/:programId","Program/ProgramFileCabinet/:programId":"payments/ProgramList?path=Program/ProgramFileCabinet/:programId","ProgramTeam/Team/:programId":"payments/ProgramList?path=ProgramTeam/Team/:programId","Scope/ScopeList/:programId":"payments/ProgramList?path=Scope/ScopeList/:programId","PaymentInvoice/ProgramInvoiceList/:programId":"payments/ProgramList?path=PaymentInvoice/ProgramInvoiceList/:programId","Expense/Expense/:programId":"payments/ProgramList?path=Expense/Expense/:programId","Reconcile/ReconcileTab/:programId":"payments/ProgramList?path=Reconcile/ReconcileTab/:programId","History/ProgramHistoryList/:programId":"payments/ProgramList?path=History/ProgramHistoryList/:programId","d/Dashboard":"dashboard/Dashboard/MainDashboard"}

/***/ }),

/***/ "ORH0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OW+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.featureFlags.legacyViewDisabled)?_c('header',{staticClass:"dawn-meta-nav"},[_c('div',{class:{ 'loading-mask' : _vm.$root.masked }}),_c('div',{staticClass:"container-fluid"},[_c('ul',{staticClass:"meta-nav-menu"},[_c('li',{staticClass:"meta-nav-item"},[_c('a',{attrs:{"href":_vm.helpsite(),"target":"_blank"}},[_c('i',{staticClass:"fas fa-question-circle"}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(' Help Center')))])])]),_vm._v(" \n|\n "),_c('li',{staticClass:"meta-nav-item"},[_c('a',{attrs:{"href":_vm.notificationsCenter},on:{"click":_vm.toggleNotifications}},[_c('i',{staticClass:"fas fa-bell animated",attrs:{"endpoint":_vm.api.$.common.notifications}}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Notifications')))]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.newEvents.length),expression:"newEvents.length"}],staticClass:"notif"})]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.newEvents.length),expression:"newEvents.length"}],staticClass:"notification"},[_vm._v(_vm._s(_vm.newEvents.length))]),(_vm.showNotifications)?_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.toggleNotifications),expression:"toggleNotifications"}],staticClass:"meta-nav-dropdown notifications arrow"},[_c('i',{staticClass:"fa fa-caret-up"}),_c('ul',{staticClass:"meta-nav-dropdown-menu"},[_vm._l((_vm.events),function(notification){return _c('li',{staticClass:"meta-nav-dropdown-item",on:{"click":_vm.toggleNotifications}},[_c('a',{attrs:{"href":"#/i/Admin/UserNotification/GetNotificationCenter?notificationId=" + notification.AppNotificationId + "&fromPage=NotificationPopUp"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(notification.Title))]),_c('span',{staticClass:"desc"},[_vm._v(_vm._s(notification.CreatedDateFormatted))])])])}),_c('li',[_vm._v("   "),_c('ed-button',{attrs:{"button-class":"btn btn-actionbar-primary","href":"#/i/Admin/UserNotification/GetNotificationCenter"},on:{"click":_vm.toggleNotifications}},[_vm._v("Notification Center")])],1)],2)]):_vm._e()]),_vm._v(" \n|"),_c('li',{staticClass:"meta-nav-item meta-nav-user meta-nav-dropdown"},[_c('a',{on:{"click":_vm.toggleDropdown}},[_c('i',{staticClass:"fas fa-user-circle"}),_vm._v(" "),(_vm.hasAccounts || _vm.hasEoAdminAccount)?_c('span',[_vm._v(_vm._s(_vm.currentCompany)+"  -  ")]):_vm._e(),_c('span',{staticClass:"title"},[_vm._v(_vm._s(this.$user.email || 'Welcome !'))])]),(_vm.showDropdown)?_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.toggleDropdown),expression:"toggleDropdown"}],staticClass:"meta-nav-dropdown"},[_c('ul',{staticClass:"meta-nav-dropdown-menu"},[_c('li',{staticClass:"meta-nav-dropdown-title"},[_c('span',{staticClass:"close-icon",on:{"click":_vm.toggleDropdown}})]),(_vm.hasAccounts)?void 0:_vm._e(),_c('li',{staticClass:"meta-nav-dropdown-item",on:{"click":_vm.toggleDropdown}},[_c('a',{attrs:{"href":"#/i/Admin/GeneralSettings/ConfigureUserProfile"}},[_vm._v(_vm._s(_vm.$t('My Profile')))])]),_c('li',{staticClass:"meta-nav-dropdown-item",on:{"click":_vm.toggleDropdown}},[_c('a',{attrs:{"href":"#/i/Admin/GeneralSettings/GeneralSettings"}},[_vm._v(_vm._s(_vm.$t('My Settings')))])]),(_vm.hasEoAdminAccount)?[_c('li',{staticClass:"meta-nav-dropdown-item",on:{"click":_vm.toggleDropdown}},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.switchToEoAdminAccount()}}},[_vm._v(_vm._s(_vm.$t('Back to EO Admin')))])])]:_vm._e(),(_vm.hasAccounts)?[_c('li',{staticClass:"meta-nav-dropdown-item no-action-",on:{"click":_vm.toggleDropdown}},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.switchAccount()}}},[_vm._v(_vm._s(_vm.$t('Switch Accounts')))])])]:_vm._e(),_c('li',{staticClass:"meta-nav-dropdown-item",on:{"click":_vm.toggleDropdown}},[_c('a',{attrs:{"href":"#/login"},on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$t('Logout')))])])],2)]):_vm._e()])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OcfT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2JYNdJluc-XbyE4gt_UXs1","Dell":"lRJdVP9YVlPb6GuOu7Y9w","Abbott":"_3SVQecxo4kUHyeppnzwitN","Gap":"_1Sua4zIhTOzPFvU5igje3S","Allstate":"_3JVpeekpWc1SwqJ91Glg4T","Asurion":"_37MR4mkDp7v0ltK2TE8ACI","Invitae":"sKzw8YGDRFaXDgnEV4AC_","JWE":"_3npEoUdOITe4e1yJvxjp-j"};

/***/ }),

/***/ "OfG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule__ = __webpack_require__("p19q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__("naW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__core_events_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_components_edCheckbox_checkbox__ = __webpack_require__("+qQe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__route_values__ = __webpack_require__("1SGE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__route_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__route_values__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var approvalRuleUtils = __webpack_require__("IJVW");
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Rule: __WEBPACK_IMPORTED_MODULE_0__rule__["a" /* default */],
    Checkbox: __WEBPACK_IMPORTED_MODULE_4__core_components_edCheckbox_checkbox__["default"]
  },
  computed: {
    children: function children() {
      return this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children && this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule] ? this.list(this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule]) : null;
    },
    optionsAvailable: function optionsAvailable() {
      return this.options.Options;
    }
  },
  data: function data() {
    return {
      dragStarted: false,
      useParallelApprovalRoutes: false,
      approvalRule: {
        '@xmlns:xsd': 'http://www.w3.org/2001/XMLSchema',
        '@xmlns:xsi': 'http://www.w3.org/2001/XMLSchema-instance',
        RuleDTO: {
          Id: 0,
          Operator: 'Or',
          Conditions: {
            ConditionDTO: {
              Id: 0,
              Values: {
                ConditionValueDTO: null
              }
            }
          },
          Actions: null,
          Children: null
        }
      },
      type: __WEBPACK_IMPORTED_MODULE_1__type___default.a,
      list: utils.collection.list,
      options: {},
      actionOptions: {},
      name: '',
      ruleId: 0,
      maxRoutesValues: [],
      routeValues: [],
      routesValues: __WEBPACK_IMPORTED_MODULE_5__route_values___default.a,
      allRoutesAreUsed: true
    };
  },
  created: function created() {
    var _this = this;
    // initialize Rule Array Ids
    this.$store.state.approvalRuleIds = {
      ruleIds: [],
      conditionIds: [],
      actionIds: []
    };
    this.$store.state.routeNumbers = [];

    // capture Save Rule event
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.SAVED).$on(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.SAVED, function (r) {
      _this.validateRule();
    });

    // capture Open Rule event
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.OPENED).$on(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.OPENED, function (r) {
      _this.openRule(r);
    });
    var validRule = true;
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.VALIDATION_COMPLETED, function (r) {
      var index = _this.$store.state.SaveIds && _this.$store.state.SaveIds.indexOf(r.data.Id.toString());
      if (validRule) {
        validRule = r.data.valid;
      }
      if (index > -1 && _this.$store.state.SaveIds) {
        _this.$store.state.SaveIds.splice(index, 1);
      }
      // save rule just when there are no elements to validate
      if (_this.$store.state.SaveIds && _this.$store.state.SaveIds.length === 0) {
        if (validRule) {
          _this.$store.state.SaveIds = null;
          _this.saveRule();
        } else {
          alert('Please complete all required fields to successfully save your rule.');
          validRule = true;
        }
      }
    });
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.UPDATE_RULE.MOVE_RULE).$on(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.UPDATE_RULE.MOVE_RULE, this.moveRule);
    Object.keys(this.routesValues.maxRoutes).forEach(function (key, val) {
      _this.maxRoutesValues.push({
        id: _this.routesValues.maxRoutes[key],
        label: key
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.VALIDATION_COMPLETED);
  },
  methods: {
    changeUsingParallelRoutes: function changeUsingParallelRoutes(e) {
      this.useParallelApprovalRoutes = e;
      if (!e) {
        this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].MaxRoutes = null;
      } else {
        this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].MaxRoutes = this.MaxRoutes.id;
      }
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit('usingParallelRoutesChanged', e);
      this.enableSaveButton();
    },
    setOptions: function setOptions(obj) {
      var contexts = JSON.parse(obj);
      if (contexts) {
        this.options = contexts.ConditionOptions;
        this.actionOptions = contexts.ActionOptions;
        this.$store.state.originalActionOptions = {
          options: utils.copy(contexts.ActionOptions.Options),
          additionalOptions: utils.copy(contexts.ActionOptions.AdditionalOptions)
        };
        this.$store.state.originalConditionOptions = {
          options: utils.copy(contexts.ConditionOptions.Options)
        };
      }
    },
    validateRule: function validateRule() {
      this.allRoutesAreUsed = true;
      if (this.useParallelApprovalRoutes) {
        for (var i = 1; i <= parseInt(this.MaxRoutes.id); i++) {
          if (this.$store.state.routeNumbers.filter(function (routeNumber) {
            return routeNumber === i;
          }).length === 0) {
            this.allRoutesAreUsed = false;
          }
        }
      }
      // check if name is set on modal
      if (!this.name) {
        alert('Cannot save rule. Rule Name is empty.');
        this.$refs.RuleName.$refs.input.focus();
      } else if (!this.allRoutesAreUsed) {
        alert("Please select at least one time each route number from one to the selected parallel routes' number.");
      } else {
        this.approvalRule.name = this.name;
        // get all child component ids (ruleIds, conditionIds, actionIds)
        this.$store.state.SaveIds = [];
        this.getAllIdsIntoStore(this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule]);
        __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.VALIDATE_COMPONENTS);
      }
    },
    getAllIdsIntoStore: function getAllIdsIntoStore(rule) {
      var _this2 = this;
      // insert rule ids for validation purpose
      if (rule && rule.Id) {
        this.$store.state.SaveIds.push(rule.Id.toString());
      }

      // insert condition ids for validation purpose
      if (rule.Conditions && rule.Conditions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.condition] && this.list(rule.Conditions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.condition]).length > 0) {
        var conditionsList = this.list(rule.Conditions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.condition]);
        conditionsList.map(function (condition) {
          _this2.$store.state.SaveIds.push(condition.Id.toString());
        });
      }

      // insert action ids for validation purpose
      if (rule.Actions && rule.Actions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.action] && this.list(rule.Actions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.action]).length > 0) {
        var actionsList = this.list(rule.Actions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.action]);
        actionsList.map(function (action) {
          _this2.$store.state.SaveIds.push(action.Id.toString());
        });
      }
      if (rule.Children && rule.Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule]) {
        var rules = this.list(rule.Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule]);
        rules.map(function (localRule) {
          if (localRule) {
            _this2.getAllIdsIntoStore(localRule);
          }
        });
      }
    },
    saveRule: function saveRule() {
      var rule = {
        ArrayOfRuleDTO: this.approvalRule
      };
      var payload = {
        ruleId: this.ruleId,
        ruleName: this.name,
        ruleJSON: JSON.stringify(rule)
      };
      this.api.forms.post(this.api.$.approval.saveRule, payload).then(this.setMessage);
    },
    setMessage: function setMessage(r) {
      var isValid = r.data.IsValid;
      var message = r.data.ItemError.Message;
      if (isValid !== true) {
        alert(message);
        switch (r.data.ItemError.Area) {
          case 'Rule Name':
            this.$refs.RuleName.$refs.input.focus();
            break;
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.VALIDATION_PASSED);
        __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.REFRESH);
      }
    },
    openRule: function openRule(r) {
      if (r && r.data) {
        var ruleId = r.data.id;

        // new rule
        if (ruleId === 0) {
          this.name = '';
          // request to backend. Insert a deleted new line in ApprovalRule table whenever a new rule must be added
          // request will return the id of the new added rule to complete rule/condition/action ids on frontend
          this.api.forms.post(this.api.$.approval.getNewRuleId).then(this.setRuleId);
        } else {
          // existing rule
          this.ruleId = ruleId;
          // Get Rule from DB
          var payload = {
            ruleId: ruleId
          };
          this.api.forms.post(this.api.$.approval.getRule, payload).then(this.setRule);
        }
      } else {
        alert('Error. Invalid response.');
      }
    },
    setRuleId: function setRuleId(r) {
      if (r && r.data !== '') {
        var id = r.data.RuleId;
        if (id) {
          this.ruleId = id;
          var firstConditionId = id * 10;
          var firstActionId = id * 100 - 1;
          this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Id = id;
          this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Conditions[__WEBPACK_IMPORTED_MODULE_1__type___default.a.condition].Id = firstConditionId;
          this.setRoutes(this);
          this.$store.state.approvalRuleIds.ruleIds.push(id);
          this.$store.state.approvalRuleIds.conditionIds.push(firstConditionId);
          this.$store.state.approvalRuleIds.actionIds.push(firstActionId);
        }

        // Get condition and action context options
        this.setOptions(r.data.ContextOptions);
      } else {
        alert('Error. Cannot create Id for new rule');
      }
    },
    setRule: function setRule(r) {
      if (r && r.data !== '') {
        var rule = JSON.parse(r.data.Rule);
        this.name = rule.Name;
        var ruleJSON = JSON.parse(rule.ConditionsJSON);
        this.approvalRule = ruleJSON.ArrayOfRuleDTO;
        this.setRoutes(this);

        // Get condition and action context options
        this.setOptions(r.data.ContextOptions);
      } else {
        alert('Error. Cannot get rule from database');
      }
    },
    updateMaxRoutes: function updateMaxRoutes(e) {
      var _this3 = this;
      this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].MaxRoutes = e.id;
      this.routeValues = [];
      Object.keys(this.routesValues.routeNumber).forEach(function (key, val) {
        if (key === 'All' || _this3.routesValues.routeNumber[key] <= e.id) {
          _this3.routeValues.push({
            id: _this3.routesValues.routeNumber[key],
            label: key
          });
        }
      });
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit('updateMaxRoutesChanged', e.id);
      this.enableSaveButton();
    },
    setRoutes: function setRoutes(vm) {
      if (typeof vm.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].MaxRoutes !== 'undefined' && vm.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].MaxRoutes !== null) {
        vm.MaxRoutes = {
          label: vm.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].MaxRoutes.toString(),
          id: vm.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].MaxRoutes
        };
      } else {
        vm.MaxRoutes = {
          label: '2',
          id: 2
        };
        vm.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].MaxRoutes = null;
      }
      vm.useParallelApprovalRoutes = typeof vm.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].MaxRoutes !== 'undefined' && vm.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].MaxRoutes !== null;
      Object.keys(vm.routesValues.routeNumber).forEach(function (key, val) {
        if (key === 'All' || vm.routesValues.routeNumber[key] <= vm.MaxRoutes.id) {
          vm.routeValues.push({
            id: vm.routesValues.routeNumber[key],
            label: key
          });
        }
      });
    },
    changeRuleName: function changeRuleName() {
      this.enableSaveButton();
    },
    enableSaveButton: function enableSaveButton() {
      approvalRuleUtils.utils.enableSaveButton(!this.$store.state.enableSaveButton);
    },
    moveRule: function moveRule(r) {
      if (this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children && this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule]) {
        // transform all RuleDTO and Children properties to array
        this.updateRulesBeforeMoving();

        // find rule to move
        var ruleToMove = this.findInArrayAndExecAction(this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule], r.data.fromRuleId, 'find');

        // find destination rule
        if (ruleToMove) {
          this.findInArrayAndExecAction(this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule], r.data.toRuleId, 'move', ruleToMove);
        }
      }
    },
    updateRulesBeforeMoving: function updateRulesBeforeMoving() {
      if (!Array.isArray(this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule])) {
        this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule] = [this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule]];
      }
      this.approvalRule[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule].map(function (item) {
        if (item.Children && item.Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule] && !Array.isArray(item.Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule])) {
          item.Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule] = [item.Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule]];
        }
      });
    },
    findInArrayAndExecAction: function findInArrayAndExecAction(arr, ruleIdToFind, action, param) {
      var _this4 = this;
      var node;
      // loop rules
      if (arr && Array.isArray(arr)) {
        arr.some(function (item, key) {
          if (+item.Id === ruleIdToFind) {
            node = _this4.executeActionOnArray(action, arr, key, param);
            return true;
          } else if (item.Children && item.Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule]) {
            // loop children
            node = _this4.findInArrayAndExecAction(item.Children[__WEBPACK_IMPORTED_MODULE_1__type___default.a.rule], ruleIdToFind, action, param);
            if (node) return true;
          }
          return false;
        });
      }
      return node;
    },
    executeActionOnArray: function executeActionOnArray(action, arr, key, param) {
      switch (action) {
        case 'find':
          return arr.splice(key, 1).shift();
        case 'move':
          arr.splice(key, 0, param);
          break;
      }
      return false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "OkuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.cancel()}}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("  Back")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Om/+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3w4sJYsJAro4xuhk0b_H0q","Dell":"_3j3McerSIKRhA0JI9Ti3HH","Abbott":"_2qz7T-vZktqxIk5M7iZDnp","Gap":"_1TFHl8l0Lgj5dz3dqteBOz","Allstate":"_3-IxeCjuJ4Jjc07uTZOuW7","Asurion":"_3iJs68s-gk9JnEB9EA2e05","Invitae":"_2EkyzUM3wodn5q0fZaNFMq","JWE":"_3WUGrrLVEac4z8YvPIn_ZK"};

/***/ }),

/***/ "Oq/g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllocateToBUCCPair_vue__ = __webpack_require__("F+SX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117fea7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllocateToBUCCPair_vue__ = __webpack_require__("MU7Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllocateToBUCCPair_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117fea7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllocateToBUCCPair_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Os5Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OyNi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navless-layout-header"},[_vm._t("navbar",function(){return [_c('ed-button',{attrs:{"to":_vm.$routerHistory.previous().path}},[_c('i',{staticClass:"fal fa-chevron-left"}),_vm._v("\n         \n        Back\n      ")])]})],2),_vm._v(" "),(_vm.errorMessage && !_vm.isReady)?_c('div',{staticClass:"submit-receipt__error"},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):(_vm.scan && _vm.isReady)?_c('div',{staticClass:"submit-receipt"},[_c('div',{staticClass:"submit-receipt__section"},[_c('h4',{staticClass:"submit-receipt__section-label"},[_vm._v("Image")]),_vm._v(" "),_c('ReceiptImageViewer',{attrs:{"image-url":_vm.imageUrl,"content-type":_vm.previewContentType,"errored":_vm.imageErrored,"wrap-height":"476px"}})],1),_vm._v(" "),_c('div',{staticClass:"submit-receipt__data-card"},[_c('h4',{staticClass:"submit-receipt__data-card-title"},[_vm._v("Receipt Data")]),_vm._v(" "),(_vm.hasNoPrefill)?_c('p',{staticClass:"submit-receipt__data-card-fallback"},[_vm._v("\n        Scan didn't extract data — proceed to match or save for later.\n      ")]):[_c('div',{staticClass:"submit-receipt__row"},[_c('div',{staticClass:"submit-receipt__field"},[_c('span',{staticClass:"submit-receipt__label"},[_vm._v("Merchant")]),_vm._v(" "),_c('span',{staticClass:"submit-receipt__value"},[_vm._v(_vm._s(_vm.merchant || '—'))])]),_vm._v(" "),_c('div',{staticClass:"submit-receipt__field submit-receipt__field--right"},[_c('span',{staticClass:"submit-receipt__label"},[_vm._v("Amount")]),_vm._v(" "),_c('span',{staticClass:"submit-receipt__value"},[_vm._v(_vm._s(_vm.formattedAmount))])])]),_vm._v(" "),_c('div',{staticClass:"submit-receipt__field"},[_c('span',{staticClass:"submit-receipt__label"},[_vm._v("Transaction Date")]),_vm._v(" "),_c('span',{staticClass:"submit-receipt__value"},[_vm._v(_vm._s(_vm.formattedDate))])])]],2),_vm._v(" "),_c('button',{staticClass:"submit-receipt__folder-cta",attrs:{"type":"button","disabled":_vm.busy},on:{"click":_vm.onSaveForLater}},[_vm._v("\n      ADD TO RECEIPT FOLDER\n    ")]),_vm._v(" "),_c('h4',{staticClass:"submit-receipt__section-label"},[_vm._v("Link to transaction")]),_vm._v(" "),(_vm.candidates.length)?_c('div',{staticClass:"submit-receipt__candidates"},_vm._l((_vm.candidates),function(candidate){return _c('button',{key:candidate.legacyTransactionId,staticClass:"submit-receipt__candidate",class:{ 'is-selected': _vm.isSelected(candidate) },attrs:{"type":"button","data-status":_vm.statusColor(candidate)},on:{"click":function($event){_vm.selectedCandidate = candidate}}},[_c('span',{staticClass:"submit-receipt__candidate-stripe",attrs:{"data-status":_vm.statusColor(candidate)}}),_vm._v(" "),_c('span',{staticClass:"submit-receipt__candidate-body"},[_c('span',{staticClass:"submit-receipt__candidate-top"},[_c('span',{staticClass:"submit-receipt__candidate-merchant"},[_vm._v(_vm._s(candidate.merchantName || '—'))]),_vm._v(" "),_c('span',{staticClass:"submit-receipt__candidate-amount"},[_vm._v(_vm._s(_vm.formatCurrency(candidate.amount, candidate.currencyCode)))])]),_vm._v(" "),_c('span',{staticClass:"submit-receipt__candidate-date"},[_vm._v(_vm._s(_vm.formatDate(candidate.transactionDate)))])]),_vm._v(" "),_c('span',{staticClass:"submit-receipt__candidate-rail"},[_c('span',{staticClass:"submit-receipt__candidate-dot",class:{ 'is-selected': _vm.isSelected(candidate) }})])])}),0):_c('div',{staticClass:"submit-receipt__empty"},[_vm._v("\n      No open or pending transactions to match. Save the receipt to your folder for later.\n    ")]),_vm._v(" "),_c('button',{staticClass:"submit-receipt__submit",attrs:{"type":"button","disabled":!_vm.selectedCandidate || _vm.busy},on:{"click":_vm.onSubmit}},[_vm._v("\n      "+_vm._s(_vm.busy ? 'Working…' : 'Submit')+"\n    ")]),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"submit-receipt__error"},[_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P1lf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return {
      'AuditFileTemplateId': {
        label: '_'
      },
      '*Name': {
        label: 'AP File Template Name',
        width: 300
      },
      'HasVATSeparateString': {
        label: 'Detailed VAT',
        width: 90,
        source: true,
        options: [{
          text: 'Yes',
          status: true
        }, {
          text: 'No',
          status: true
        }],
        editable: false
      }
    };
  }
});

/***/ }),

/***/ "P2/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountingSystemSettings_vue__ = __webpack_require__("+9Xe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5237f1c5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountingSystemSettings_vue__ = __webpack_require__("sGLf");
function injectStyle (ssrContext) {
  __webpack_require__("neRZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5237f1c5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountingSystemSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5237f1c5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountingSystemSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P4e5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_right_vue__ = __webpack_require__("JTeQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b96f75be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_right_vue__ = __webpack_require__("ARJM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_right_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b96f75be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_right_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P68F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P7S6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PBkm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Funding Bill To Address")]),_vm._v(" "),(_vm.showEdit)?_c('ed-button',{attrs:{"button-class":"btn btn-actionbar"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Edit")]):_vm._e(),_vm._v(" "),(_vm.model.Venue)?_c('span',{staticClass:"small"},[_c('br'),_vm._v(_vm._s(_vm.entityName))]):_vm._e(),_vm._v(" "),(_vm.model.Address)?_c('span',{staticClass:"small"},[_c('br'),_vm._v(_vm._s(_vm.model.Address))]):_vm._e(),_vm._v(" "),(_vm.model.Address2)?_c('span',{staticClass:"small"},[_c('br'),_vm._v(_vm._s(_vm.model.Address2))]):_vm._e(),_vm._v(" "),(_vm.model.CityStateZip)?_c('span',{staticClass:"small"},[_c('br'),_vm._v(_vm._s(_vm.model.CityStateZip))]):_vm._e(),_vm._v(" "),(_vm.model.CountryName)?_c('span',{staticClass:"small"},[_c('br'),_vm._v(_vm._s(_vm.model.CountryName))]):_vm._e(),_vm._v(" "),(_vm.model.VatNo)?_c('span',{staticClass:"small"},[_c('br'),_vm._v("VAT ID: "+_vm._s(_vm.model.VatNo))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showModal,"title":"Edit Address"},on:{"confirm":_vm.save,"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',[_c('ed-input',{attrs:{"field-label":"Entity","required":""},model:{value:(_vm.modelCopy.Venue),callback:function ($$v) {_vm.$set(_vm.modelCopy, "Venue", $$v)},expression:"modelCopy.Venue"}})],1),_vm._v(" "),_c('div',[_c('ed-input',{attrs:{"field-label":"Address","required":""},model:{value:(_vm.modelCopy.Address),callback:function ($$v) {_vm.$set(_vm.modelCopy, "Address", $$v)},expression:"modelCopy.Address"}})],1),_vm._v(" "),_c('div',[_c('ed-input',{attrs:{"field-label":"Address 2"},model:{value:(_vm.modelCopy.Address2),callback:function ($$v) {_vm.$set(_vm.modelCopy, "Address2", $$v)},expression:"modelCopy.Address2"}})],1),_vm._v(" "),_c('div',[_c('ed-select',{attrs:{"hide-optional":"","field-label":"Country","placeholder":"Select a country","options":_vm.countries,"label":"CountryName","track-by":"CountryID","openEndpoint":_vm.api.$.profile.getAllCountries,"name":"supplier_country"},on:{"select":function (o) { _vm.countrySelected(o) },"open":_vm.fetchCountriesOnOpen,"keyup":_vm.fetchCountries,"close":_vm.restoreCountries},model:{value:(_vm.modelCopy.country),callback:function ($$v) {_vm.$set(_vm.modelCopy, "country", $$v)},expression:"modelCopy.country"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 no-pad"},[_c('ed-input',{attrs:{"field-label":"City","hide-optional":""},model:{value:(_vm.modelCopy.CityName),callback:function ($$v) {_vm.$set(_vm.modelCopy, "CityName", $$v)},expression:"modelCopy.CityName"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[(_vm.isUS())?_c('ed-select',{attrs:{"hide-optional":"","field-label":"State","placeholder":"Select a state","options":_vm.USstates,"label":"StateName","track-by":"StateID","name":"us_states"},on:{"open":_vm.fetchUSStatesOnOpen,"keyup":_vm.fetchUSStates,"close":_vm.restoreUSStates,"select":function (o) { _vm.modelCopy.StateName = o.StateName; _vm.modelCopy.StateId = o.StateID }},model:{value:(_vm.modelCopy.state),callback:function ($$v) {_vm.$set(_vm.modelCopy, "state", $$v)},expression:"modelCopy.state"}}):_vm._e(),_vm._v(" "),(_vm.isCanada())?_c('ed-select',{attrs:{"hide-optional":"","field-label":"State/Region","placeholder":"Select a region","options":_vm.canadaStates,"label":"StateName","name":"canada_states"},on:{"open":_vm.fetchCanadaStatesOnOpen,"keyup":_vm.fetchCanadaStates,"close":_vm.restoreCanadaStates,"select":function (o) { return _vm.modelCopy.StateName = o.StateName; }},model:{value:(_vm.modelCopy.state),callback:function ($$v) {_vm.$set(_vm.modelCopy, "state", $$v)},expression:"modelCopy.state"}}):_vm._e(),_vm._v(" "),(!_vm.modelCopy.CountryName || !_vm.isCanada() && !_vm.isUS())?_c('ed-input',{attrs:{"hide-optional":"","field-label":"State/Region","placeholder":"Select a region","name":"state_region"},model:{value:(_vm.modelCopy.Region),callback:function ($$v) {_vm.$set(_vm.modelCopy, "Region", $$v)},expression:"modelCopy.Region"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 no-pad"},[_c('ed-input',{attrs:{"field-label":"ZIP Code","hide-optional":""},model:{value:(_vm.modelCopy.ZipCode),callback:function ($$v) {_vm.$set(_vm.modelCopy, "ZipCode", $$v)},expression:"modelCopy.ZipCode"}})],1),_vm._v(" "),_c('div',[_c('label',[_vm._v("VAT: "),_c('br'),_vm._v(" "),_c('ed-input',{model:{value:(_vm.modelCopy.VatNo),callback:function ($$v) {_vm.$set(_vm.modelCopy, "VatNo", $$v)},expression:"modelCopy.VatNo"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PCds":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2TOigRuyXophKES4a-29Mk","Dell":"rkfqkZ3p3NkvKZnHSVACe","Abbott":"_1oF7EsKc5fkVuGo1BqtaIO","Gap":"_204WtY90HsErJzxq9rurc1","Allstate":"_2Wp1fz2q1L2Ow7CEfGAb1_","Asurion":"nMIzEUxC4WjnbZcUSJ1z2","Invitae":"_31BIhfuRgZrQLHHsD_JAHw","JWE":"_1IeDyLRqlfM57wv-NRCrX9"};

/***/ }),

/***/ "PDTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group dawn-radio-group",class:{ error: _vm.error }},[(_vm.fieldLabel)?_c('label',{staticClass:"control-label",class:{ error: _vm.error }},[_vm._v(_vm._s(_vm.fieldLabel)),(_vm.required)?_c('span',[_vm._v(" *")]):_vm._e()]):_vm._e(),(_vm.helptipBody && _vm.error)?_c('ed-input-tooltip',{class:{ "error-message": _vm.error },attrs:{"helptipHeader":_vm.helptipHeader,"errorTip":_vm.error,"helptipBody":_vm.helptipBody}}):_vm._e(),_vm._l((_vm.options),function(option,i){return _c('radio',{directives:[{name:"show",rawName:"v-show",value:(!option.hide),expression:"!option.hide"}],key:i,attrs:{"name":_vm.name,"option-index":i,"option-label":option.label,"option-value":option,"checked":_vm.checked(option),"track-by":_vm.$attrs["track-by"],"hasAdditionalInfo":option.additionalInfo,"slotName":option.slotName,"error":_vm.error},on:{"choose-radio":function($event){return _vm.set(option)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._t("icon",null,{"slot":"icon","value":option.value}),_vm._t(option.slotName,null,{"slot":option.slotName,"value":option.value,"slotName":option.slotName})],2)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PFVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme public skin--",class:_vm.themeNs},[_c('keep-alive',[_c(_vm.layout,{tag:"component",staticClass:"layout"},[_c(_vm.module(),{ref:"currentModule",tag:"component",staticClass:"module",class:_vm.className})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PG8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.validateInvoices()}}},[_vm._v("Remit Payment\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showModal,"title":"","xsubtitle":"","primaryButton":"OK","secondaryButton":"false"},on:{"close":function($event){_vm.showModal = false}}},[_c('span',{attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"col-md-8 lh15"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.modalContent)}})]),_vm._v(" "),_c('div',{staticClass:"clear"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PJql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__("Z60a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__("C9uT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__("lQbo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__ = __webpack_require__("xmRq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);








var api = new __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */]();
var ItemStore = /*#__PURE__*/function () {
  function ItemStore(api) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ItemStore);
    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(this, "state", {});
    this.api = api;
  }
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ItemStore, [{
    key: "getLineItemLists",
    value: function () {
      var _getLineItemLists = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee(programId, invoiceId) {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.getDropDownListForItems(programId, invoiceId, true));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getLineItemLists(_x, _x2) {
        return _getLineItemLists.apply(this, arguments);
      }
      return getLineItemLists;
    }()
  }, {
    key: "getDropDownListForItems",
    value: function () {
      var _getDropDownListForItems = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee2(programId, invoiceId, loadAllData) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(programId <= 0)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", '');
            case 2:
              response = '';
              _context2.next = 5;
              return this.api.get(api.DropDownsListForItem(), {
                params: {
                  programId: programId,
                  invoiceId: invoiceId,
                  loadAllData: loadAllData
                }
              });
            case 5:
              response = _context2.sent;
              response.data = JSON.parse(JSON.stringify(response));
              return _context2.abrupt("return", response.data);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getDropDownListForItems(_x3, _x4, _x5) {
        return _getDropDownListForItems.apply(this, arguments);
      }
      return getDropDownListForItems;
    }()
  }, {
    key: "getCostCentersBusinessUnits",
    value: function () {
      var _getCostCentersBusinessUnits = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee3(programId, invoiceId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(programId <= 0)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", '');
            case 2:
              response = '';
              _context3.next = 5;
              return this.api.get(api.GetCostCentersBusinessUnits(), {
                params: {
                  programId: programId,
                  invoiceId: invoiceId
                }
              });
            case 5:
              response = _context3.sent;
              response.data = JSON.parse(JSON.stringify(response));
              return _context3.abrupt("return", response.data);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getCostCentersBusinessUnits(_x6, _x7) {
        return _getCostCentersBusinessUnits.apply(this, arguments);
      }
      return getCostCentersBusinessUnits;
    }()
  }, {
    key: "getLineItemTaxes",
    value: function () {
      var _getLineItemTaxes = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee4(supplierVci, categoryId, currencyCode, events) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              response = '';
              _context4.next = 3;
              return this.api.get(api.GetSupplierTaxes(), {
                params: {
                  supplierEoNumber: supplierVci,
                  categoryId: categoryId,
                  currencyCode: currencyCode,
                  events: events
                }
              });
            case 3:
              response = _context4.sent;
              response.data = JSON.parse(JSON.stringify(response));
              return _context4.abrupt("return", response.data);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getLineItemTaxes(_x8, _x9, _x10, _x11) {
        return _getLineItemTaxes.apply(this, arguments);
      }
      return getLineItemTaxes;
    }()
  }, {
    key: "getLineItemFees",
    value: function () {
      var _getLineItemFees = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee5(supplierVci, categoryId, currencyCode, events, buyerVendorId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              response = '';
              _context5.next = 3;
              return this.api.post(api.GetSupplierFees(), {
                supplierEoNumber: supplierVci,
                categoryId: categoryId,
                currencyCode: currencyCode,
                events: events,
                buyerVendorId: buyerVendorId
              });
            case 3:
              response = _context5.sent;
              response.data = JSON.parse(JSON.stringify(response));
              return _context5.abrupt("return", response.data);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getLineItemFees(_x12, _x13, _x14, _x15, _x16) {
        return _getLineItemFees.apply(this, arguments);
      }
      return getLineItemFees;
    }()
  }, {
    key: "getFeesAndDiscountItemData",
    value: function () {
      var _getFeesAndDiscountItemData = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee6(programId, invoiceId) {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.getDropDownListForItems(programId, invoiceId, false));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getFeesAndDiscountItemData(_x17, _x18) {
        return _getFeesAndDiscountItemData.apply(this, arguments);
      }
      return getFeesAndDiscountItemData;
    }()
  }, {
    key: "computeItemTotal",
    value: function () {
      var _computeItemTotal = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee7(lineItem, currency) {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.api.post(api.ComputeLineItemTotals(), {
                lineItem: lineItem,
                currency: currency
              }));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function computeItemTotal(_x19, _x20) {
        return _computeItemTotal.apply(this, arguments);
      }
      return computeItemTotal;
    }()
  }, {
    key: "computeSavingsItemTotal",
    value: function () {
      var _computeSavingsItemTotal = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee8(lineItem, currency) {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this.api.post(api.SavingsComputeLineItemTotals(), {
                lineItem: lineItem,
                currency: currency
              }));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function computeSavingsItemTotal(_x21, _x22) {
        return _computeSavingsItemTotal.apply(this, arguments);
      }
      return computeSavingsItemTotal;
    }()
  }, {
    key: "computeFeeTotal",
    value: function () {
      var _computeFeeTotal = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee9(fee, currency) {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", this.api.post(api.ComputeFeeTotals(), {
                fee: fee,
                currency: currency
              }));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function computeFeeTotal(_x23, _x24) {
        return _computeFeeTotal.apply(this, arguments);
      }
      return computeFeeTotal;
    }()
  }, {
    key: "GetInvoiceTotalAmount",
    value: function () {
      var _GetInvoiceTotalAmount = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee10(amount, vatAmount, fromCurrencyCode, toCurrencyCode) {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", this.api.post(api.GetInvoiceTotalAmount(), {
                amount: amount,
                vatAmount: vatAmount,
                fromCurrencyCode: fromCurrencyCode,
                toCurrencyCode: toCurrencyCode
              }));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function GetInvoiceTotalAmount(_x25, _x26, _x27, _x28) {
        return _GetInvoiceTotalAmount.apply(this, arguments);
      }
      return GetInvoiceTotalAmount;
    }()
  }, {
    key: "GetAmount",
    value: function () {
      var _GetAmount = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee11(amount, invoiceId, fromCurrencyCode, toCurrencyCode) {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.api.post(api.GetAmount(), {
                amount: amount,
                invoiceId: invoiceId,
                fromCurrencyCode: fromCurrencyCode,
                toCurrencyCode: toCurrencyCode
              }));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function GetAmount(_x29, _x30, _x31, _x32) {
        return _GetAmount.apply(this, arguments);
      }
      return GetAmount;
    }()
  }, {
    key: "populateTotalsOnFee",
    value: function populateTotalsOnFee(fee, feeWithTotals) {
      var _loop = function _loop(i) {
        var computedTax = feeWithTotals.taxes.find(function (tax) {
          return tax.name === fee.taxes[i].name;
        });
        if (computedTax) {
          fee.taxes[i].value = computedTax.value;
          fee.taxes[i].totalTaxes = computedTax.totalTaxes;
        }
      };
      for (var i = 0; i < fee.taxes.length; i++) {
        _loop(i);
      }
      fee.totalTaxes = feeWithTotals.totalTaxes;
      return fee;
    }
  }, {
    key: "populateTotalsOnItem",
    value: function populateTotalsOnItem(lineItem, itemWithTotals, qtyAndUnitsOnPO) {
      lineItem.total = itemWithTotals.total;
      lineItem.discountAmount = itemWithTotals.discountAmount;
      lineItem.discountPercent = itemWithTotals.discountPercent;
      lineItem.subtotal = itemWithTotals.subtotal;
      lineItem.totalTaxes = itemWithTotals.totalTaxes;
      lineItem.totalFees = itemWithTotals.totalFees;
      lineItem.totalVAT = itemWithTotals.totalVAT;
      lineItem.totalGST = itemWithTotals.totalGST;
      lineItem.totalTaxesForFees = itemWithTotals.totalTaxesForFees;
      lineItem.totalWithTaxesAndFees = itemWithTotals.totalWithTaxesAndFees;
      lineItem.unitPriceSGR = itemWithTotals.unitPriceSGR;
      lineItem.unitPricePreferredRate = itemWithTotals.unitPricePreferredRate;
      lineItem.unitPriceNegotiatedRate = itemWithTotals.unitPriceNegotiatedRate;
      lineItem.totalSGR = itemWithTotals.totalSGR;
      lineItem.totalPreferredRate = itemWithTotals.totalPreferredRate;
      lineItem.totalNegotiatedRate = itemWithTotals.totalNegotiatedRate;
      if (lineItem.isFeeDiscountItem) {
        lineItem.taxTypeId = itemWithTotals.taxTypeId;
        lineItem.feeTypeId = itemWithTotals.feeTypeId;
        lineItem.customTypeId = itemWithTotals.customTypeId;
        lineItem.costCenterAndBusinessUnit.businessUnitId = itemWithTotals.businessUnitId;
        lineItem.costCenterAndBusinessUnit.costCenterId = itemWithTotals.costCenterId;
        lineItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = itemWithTotals.programBusinessUnitAndCostCenterId;
      }
      var _loop2 = function _loop2(i) {
        var computedTax = itemWithTotals.taxes.find(function (tax) {
          return tax.name === lineItem.taxes[i].name;
        });
        if (computedTax) {
          lineItem.taxes[i].value = computedTax.value;
          lineItem.taxes[i].totalTaxes = computedTax.totalTaxes;
        }
      };
      for (var i = 0; i < lineItem.taxes.length; i++) {
        _loop2(i);
      }
      var _loop3 = function _loop3(_i) {
        var computedFee = itemWithTotals.fees.find(function (fee) {
          return fee.name === lineItem.fees[_i].name;
        });
        if (computedFee) {
          lineItem.fees[_i].value = computedFee.value;
          lineItem.fees[_i].totalTaxes = computedFee.totalTaxes;
          lineItem.fees[_i].taxes = utils.copy(computedFee.taxes);
        }
      };
      for (var _i = 0; _i < lineItem.fees.length; _i++) {
        _loop3(_i);
      }

      // update PO qty remaining fields per item
      if (qtyAndUnitsOnPO && qtyAndUnitsOnPO.length > 0) {
        lineItem = this.updateItemAmountsOnDecoupling(lineItem, qtyAndUnitsOnPO, {
          ItemKey: lineItem.itemKey,
          Quantity: lineItem.quantity,
          Units: lineItem.units
        });
      }
      return lineItem;
    }
  }, {
    key: "getEventsWithOrderedLineItems",
    value: function getEventsWithOrderedLineItems(events) {
      if (events && events.length > 0) {
        events.map(function (ev) {
          if (ev.lineItems && ev.lineItems.length > 0) {
            ev.lineItems = ev.lineItems.sort(function (a, b) {
              if (Number(a.listOrder) < Number(b.listOrder)) return -1;else if (Number(a.listOrder) > Number(b.listOrder)) return 1;
              return 0;
            });
          }
        });
      }
      return events;
    }
  }, {
    key: "keepItemCustomFields",
    value: function keepItemCustomFields(targetEvents, sourceEvents) {
      if (targetEvents && targetEvents.length > 0 && sourceEvents && sourceEvents.length > 0) {
        targetEvents.map(function (ev) {
          if (ev.lineItems && ev.lineItems.length > 0) {
            var sourceEvent = sourceEvents.filter(function (e) {
              return e.uniqueId === ev.uniqueId;
            });
            if (sourceEvent && sourceEvent.length > 0) {
              ev.lineItems.map(function (itm) {
                var sourceItem = sourceEvent[0].lineItems.filter(function (i) {
                  return Number(i.listOrder) === Number(itm.listOrder);
                });
                if (sourceItem && sourceItem.length > 0) {
                  itm.customFields = sourceItem[0].customFields || [];
                }
              });
            }
          }
        });
      }
      return targetEvents;
    }
  }, {
    key: "updateItemsForI2PInvoiceOnEdit",
    value: function updateItemsForI2PInvoiceOnEdit(poEvents, invoiceItems) {
      if (poEvents && poEvents.length > 0 && invoiceItems && invoiceItems.length > 0) {
        poEvents.map(function (ev) {
          if (ev.lineItems && ev.lineItems.length > 0) {
            ev.lineItems.map(function (poItem) {
              // TODO: improve searching by ItemKey (must be updated on invoice after PO api call)
              var invItem = invoiceItems && invoiceItems.filter(function (v) {
                return +v.ListOrder === +poItem.listOrder;
              });
              if (invItem && invItem.length > 0) {
                invItem = invItem[0];

                // TODO: move to backend
                if (!invItem.CustomFields) invItem.CustomFields = [];
                for (var i = 0; i < invItem.CustomFields.length; i++) {
                  invItem.CustomFields[i] = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["mapKeys"])(invItem.CustomFields[i], function (v, k) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["camelCase"])(k);
                  });
                }
                poItem.invoiceItemKey = invItem.ItemKey;
                poItem.customFields = invItem.CustomFields;
              }
            });
          }
        });
      }
      return poEvents;
    }

    // create invoice updates
  }, {
    key: "updateEventsOnCreate",
    value: function updateEventsOnCreate(poEvents, invoicedItems, qtyAndUnitsOnPO) {
      var _this = this;
      if (poEvents && poEvents.length > 0) {
        poEvents.map(function (ev) {
          if (ev.lineItems && ev.lineItems.length > 0) {
            ev.lineItems.map(function (poItem) {
              // update item
              poItem = _this.updateItemAmountsOnDecoupling(poItem, qtyAndUnitsOnPO);
              var itemSettings = qtyAndUnitsOnPO.filter(function (v) {
                return v.itemId === poItem.itemKey;
              })[0];
              var canExceedPOQty = itemSettings ? itemSettings.canExceedPOQty : false;
              if (!poItem.isAutoGenerated) {
                poItem.quantity = canExceedPOQty && poItem.isFeeDiscountItem && !poItem.isQuantityReadonly ? 1 : poItem.remainingQuantity;
                poItem.units = poItem.remainingUnits;
                poItem.unitPrice = poItem.isQuantityReadonly ? 0 : poItem.poUnitPrice;
              }

              // taxes update
              var invItem = invoicedItems && invoicedItems.filter(function (v) {
                return v.Id === poItem.itemKey;
              });
              if (invItem && invItem.length > 0) {
                invItem = invItem[0];
                poItem = _this.updateItemFeesAndTaxesWithRemainingAmount(poItem, invItem);
              }
              if (poItem.isQuantityReadonly) {
                poItem = _this.resetItemAmountsToZero(poItem);
              }
            });
          }
        });
      }
      return poEvents;
    }

    // edit invoice updates
  }, {
    key: "getEventsWithChangesFromInvoice",
    value: function getEventsWithChangesFromInvoice(poEvents, invoiceItems, qtyAndUnitsOnPO) {
      var _this2 = this;
      if (poEvents && poEvents.length > 0) {
        poEvents.map(function (ev) {
          if (ev.lineItems && ev.lineItems.length > 0) {
            // remove processing fees from PO; the ones saved at invoice level will be displayed
            // https://evedllc.atlassian.net/browse/PRODUCTDEV-1596
            var hasPFOnPO = ev.lineItems.some(function (i) {
              return i.isAutoGenerated && i.feeTypeId > 0;
            });
            ev.lineItems = ev.lineItems.filter(function (i) {
              return !(i.isAutoGenerated && i.feeTypeId > 0);
            });
            ev.lineItems.map(function (poItem) {
              // update item
              var invItem = invoiceItems && invoiceItems.filter(function (v) {
                return v.Id === poItem.itemKey;
              });
              if (invItem && invItem.length > 0) {
                invItem = invItem[0];

                // populate new columns for P2P invoice
                poItem = _this2.updateItemAmountsOnDecoupling(poItem, qtyAndUnitsOnPO, invItem);
                if (invItem.Name !== '') {
                  poItem.listOrder = invItem.ListOrder || poItem.listOrder;
                }

                // update amounts with changes from invoice
                poItem.quantity = invItem.Quantity;
                poItem.units = invItem.Units;
                poItem.unitPrice = invItem.UnitPrice;
                poItem.amountTypeValue = invItem.AmountTypeValue;
                poItem.discountAmount = invItem.DiscountAmount;
                poItem.discountPercent = invItem.DiscountPercent;
                poItem.subtotal = invItem.Subtotal;
                poItem.total = invItem.TotalAmount;
                poItem.taxCode = invItem.TaxCode;

                // TODO: move in backend
                if (!invItem.CustomFields) invItem.CustomFields = [];
                for (var i = 0; i < invItem.CustomFields.length; i++) {
                  invItem.CustomFields[i] = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["mapKeys"])(invItem.CustomFields[i], function (v, k) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["camelCase"])(k);
                  });
                }
                poItem.customFields = invItem.CustomFields;

                // taxes update
                poItem = _this2.updateItemFeesAndTaxes(poItem, invItem);
              } else {
                poItem = _this2.updateItemAmountsOnDecoupling(poItem, qtyAndUnitsOnPO);
                poItem.quantity = 0;
                poItem.units = 0;
                poItem.unitPrice = poItem.poUnitPrice;
                poItem.amountTypeValue = 0;
                poItem.discountAmount = 0;
                poItem.discountPercent = 0;
                poItem.subtotal = 0;
                poItem.total = 0;
                if (poItem.remainingQuantity === 0 && poItem.itemTypeId !== null) {
                  poItem = _this2.resetItemAmountsToZero(poItem);
                }
              }
            });

            // add items saved on invoice
            invoiceItems && invoiceItems.map(function (ii) {
              if (ii.Id === __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].defaultUniqueId) {
                ev.lineItems.push(_this2.mapInvoiceItemToPOItem(ii, ev, hasPFOnPO));
              }
            });
          }
        });

        // make sure listOrder was set correctly on items
        if (poEvents && poEvents.length !== 0) {
          poEvents = this.getEventsWithOrderedLineItems(poEvents);
          var listOrder = 1;
          poEvents[0].lineItems.map(function (item) {
            if (+item.listOrder !== listOrder) {
              item.listOrder = listOrder;
            }
            listOrder++;
          });
        }
      }
      return poEvents;
    }
  }, {
    key: "getDifferenceOrZero",
    value: function getDifferenceOrZero(amountOnPO, amountOnInv) {
      return amountOnPO > amountOnInv ? amountOnPO - amountOnInv : 0;
    }
  }, {
    key: "updateItemFeesAndTaxesWithRemainingAmount",
    value: function updateItemFeesAndTaxesWithRemainingAmount(poItem, invItem) {
      var _this3 = this;
      // update taxes
      if (poItem.taxes && poItem.taxes.length > 0) {
        poItem.taxes.map(function (poTax) {
          var invTax = invItem.Taxes.filter(function (v) {
            return v.TaxTypeId === poTax.taxTypeId;
          });
          if (invTax && invTax.length > 0) {
            invTax = invTax[0];
            poTax.percentage = invTax.Percent;
            poTax.value = _this3.getDifferenceOrZero(poTax.value, invTax.Amount);
            poTax.isChecked = (invTax.Amount || 0) !== 0;
          }
        });
      }

      // update fees
      if (poItem.fees && poItem.fees.length > 0) {
        poItem.fees.map(function (poFee) {
          var invFee = invItem.Fees.filter(function (v) {
            return v.FeeTypeId === poFee.feeTypeId;
          });
          if (invFee && invFee.length > 0) {
            invFee = invFee[0];

            // will be skipped when fee is by percent and only the taxes per fee will be updated
            if ((Number(invFee.Percent) || 0) !== 0 || (Number(invFee.Amount) || 0) !== 0) {
              poFee.percentage = invFee.Percent;
              poFee.value = _this3.getDifferenceOrZero(poFee.value, invFee.Amount);
            }
            poFee.totalTaxes = 0;
            if (poFee.taxes && poFee.taxes.length > 0) {
              poFee.taxes.map(function (fTax) {
                if (invFee.Taxes) {
                  var invTax = invFee.Taxes.filter(function (v) {
                    return v.TaxTypeId === fTax.taxTypeId;
                  });
                  if (invTax && invTax.length > 0) {
                    invTax = invTax[0];
                    fTax.percentage = invTax.Percent;
                    fTax.value = _this3.getDifferenceOrZero(fTax.value, invTax.Amount);
                    fTax.isChecked = (invTax.Amount || 0) !== 0;
                  }
                }
                poFee.totalTaxes += Number(fTax.value);
              });
            }
          }
        });
      }
      return poItem;
    }
  }, {
    key: "updateItemFeesAndTaxes",
    value: function updateItemFeesAndTaxes(poItem, invItem) {
      // update taxes
      if (poItem.taxes && poItem.taxes.length > 0) {
        poItem.taxes.map(function (poTax) {
          var invTax = invItem.Taxes.filter(function (v) {
            return v.TaxTypeId === poTax.taxTypeId;
          });
          if (invTax && invTax.length > 0) {
            invTax = invTax[0];
            poTax.percentage = invTax.Percent;
            poTax.value = invTax.Amount;
            poTax.isChecked = (invTax.Amount || 0) !== 0;
          }
        });
      }

      // update fees
      if (poItem.fees && poItem.fees.length > 0) {
        poItem.fees.map(function (poFee) {
          var invFee = invItem.Fees.filter(function (v) {
            return v.FeeTypeId === poFee.feeTypeId;
          });
          if (invFee && invFee.length > 0) {
            invFee = invFee[0];
            poFee.percentage = invFee.Percent;
            poFee.value = invFee.Amount;
            poFee.totalTaxes = invFee.TotalTaxesAmount || poFee.totalTaxes;
            if (poFee.taxes && poFee.taxes.length > 0) {
              poFee.taxes.map(function (fTax) {
                if (invFee.Taxes) {
                  var invTax = invFee.Taxes.filter(function (v) {
                    return v.TaxTypeId === fTax.taxTypeId;
                  });
                  if (invTax && invTax.length > 0) {
                    invTax = invTax[0];
                    fTax.percentage = invTax.Percent;
                    fTax.value = invTax.Amount;
                    fTax.isChecked = (invTax.Amount || 0) !== 0;
                  }
                }
              });
            }
          }
        });
      }
      return poItem;
    }
  }, {
    key: "mapInvoiceItemToPOItem",
    value: function mapInvoiceItemToPOItem(invItem, _event, hasPFOnPO) {
      var usePairs = _event.lineItems[0].useBusinessUnitAndCostCenterMapping;
      return {
        amountTypeId: invItem.AmountTypeId,
        amountTypeValue: invItem.AmountTypeValue || invItem.UnitPrice,
        costCenterAndBusinessUnit: {
          costCenterId: invItem.CostCenterId,
          costCenterNo: invItem.CostCenterNo,
          costCenterName: invItem.CostCenterName,
          businessUnitId: invItem.BusinessUnitId,
          businessUnitName: invItem.BusinessUnitName,
          costCenterAndBusinessUnitKey: usePairs ? invItem.ProgramBUAndCCId + '_' + invItem.BusinessUnitName + '_' + invItem.CostCenterNo : '',
          costCenterAndBusinessUnitName: usePairs ? invItem.BusinessUnitName + '_' + invItem.CostCenterNo + '(' + invItem.CostCenterName + ')' : '',
          programBusinessUnitAndCostCenterId: invItem.ProgramBUAndCCId
        },
        hasBusinessUnit: invItem.CostCenterId > 0,
        hasCostCenter: invItem.businessUnitId > 0,
        customTypeId: invItem.CustomTypeId,
        description: invItem.Description,
        internalNote: invItem.InternalNote,
        feeTypeId: invItem.FeeTypeId,
        fees: [],
        isAutoGenerated: invItem.IsAutoGenerated,
        entireRowInvalid: invItem.isAutoGenerated && invItem.feeTypeId > 0 && !hasPFOnPO,
        isFeeDiscountItem: invItem.ItemTypeId !== null,
        itemKey: __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].defaultUniqueId,
        invoiceItemKey: invItem.ItemKey || __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].defaultUniqueId,
        itemTypeId: invItem.ItemTypeId,
        listOrder: invItem.ListOrder,
        name: invItem.Name,
        quantity: invItem.Quantity,
        subtotal: invItem.Subtotal,
        taxTypeId: invItem.TaxTypeId,
        taxes: [],
        total: invItem.TotalAmount,
        totalAmount: invItem.TotalAmount,
        totalWithTaxesAndFees: invItem.TotalAmount,
        unitPrice: invItem.UnitPrice,
        useBusinessUnitAndCostCenterMapping: usePairs,
        maxUnitPrice: __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].maxAmount,
        // no limit for fees/taxes added on invoice
        taxCode: invItem.TaxCode
      };
    }
  }, {
    key: "resetItemAmountsToZero",
    value: function resetItemAmountsToZero(item) {
      item.amountTypeValue = 0;
      item.unitPrice = 0;
      item.total = 0;
      return item;
    }
  }, {
    key: "updateItemAmountsOnDecoupling",
    value: function updateItemAmountsOnDecoupling(lineItem, decouplingSettings, invoiceItem) {
      // !!!
      var settings = decouplingSettings && decouplingSettings.filter(function (v) {
        return v.itemId === lineItem.itemKey;
      });
      if (settings && settings.length > 0) {
        settings = settings[0];
        lineItem.invoiceItemKey = settings.itemKey;
        lineItem.poQuantity = settings.poQuantity;
        lineItem.poUnits = settings.poUnits;
        lineItem.poUnitPrice = settings.poUnitPrice;
        var editedQty = invoiceItem && invoiceItem.Quantity || +settings.quantity;
        var editedUnits = invoiceItem && invoiceItem.Units || +settings.units;
        if (editedQty === 0 && invoiceItem && !lineItem.isAutoGenerated) {
          lineItem.quantity = 0;
          lineItem.units = 0;
          lineItem.amountTypeValue = 0;
        }
        if (settings.canExceedPOQty) {
          lineItem = this.updateItemWithCheckByAmount(lineItem, settings, editedQty);
        } else {
          lineItem = this.updateItemWithCheckByQty(lineItem, settings, editedQty, editedUnits);
        }
      } else {
        // items added on invoice
        lineItem.invoiceItemKey = invoiceItem && invoiceItem.ItemKey;
        lineItem.maxUnitPrice = __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].maxAmount;
        lineItem.maxTotalAmount = __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].maxAmount;
      }
      return lineItem;
    }
  }, {
    key: "updateItemWithCheckByQty",
    value: function updateItemWithCheckByQty(lineItem, settings, editedQty, editedUnits) {
      // reset to 0 taxes and fees added by amount
      if (settings.initialQuantity === 0 && settings.remainingQuantity < settings.poQuantity) {
        if (lineItem.taxes && lineItem.taxes.length > 0) {
          lineItem.taxes.map(function (t) {
            if (!t.percentage) {
              t.value = 0;
            }
          });
        }
        if (lineItem.fees && lineItem.fees.length > 0) {
          lineItem.fees.map(function (f) {
            if (!f.percentage) {
              f.value = 0;
              if (f.taxes && f.taxes.length > 0) {
                f.taxes.map(function (ft) {
                  if (!ft.percentage) {
                    ft.value = 0;
                  }
                });
              }
            }
          });
        }
      }

      // = PO Qty - Invoiced Qty - (Edited Qty - Last Saved Qty)
      lineItem.remainingQuantity = settings.poQuantity - settings.invoicedQuantity - (editedQty - (settings.initialQuantity || 0));
      lineItem.remainingUnits = settings.poUnits - settings.invoicedUnits - (editedUnits - (settings.initialUnits || 0));
      lineItem.maxQuantity = settings.poQuantity - settings.invoicedQuantity + settings.initialQuantity;
      lineItem.maxUnitPrice = lineItem.isFeeDiscountItem ? __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].maxAmount : settings.poUnitPrice;
      lineItem.maxTotalAmount = __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].maxAmount;
      if (lineItem.remainingQuantity < 0) lineItem.remainingQuantity = 0;
      if (lineItem.remainingUnits < 0) lineItem.remainingUnits = 0;
      lineItem.isQuantityReadonly = lineItem.remainingQuantity === 0 && editedQty === 0;
      lineItem.isUnitsReadonly = lineItem.isQuantityReadonly;
      return lineItem;
    }
  }, {
    key: "updateItemWithCheckByAmount",
    value: function updateItemWithCheckByAmount(lineItem, settings, editedQty) {
      lineItem.maxUnitPrice = lineItem.isFeeDiscountItem // && settings.excludeTaxes
      ? __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].maxAmount : settings.poUnitPrice;
      lineItem.maxTotalAmount = this.getMaxTotalAmount(lineItem, settings);
      // set min validation threshold only for Discount items
      lineItem.minTotalAmount = !lineItem.isAutoGenerated && lineItem.totalWithTaxesAndFees < 0 ? settings.poTotalAmount : Number(lineItem.total) < 0 ? Number(lineItem.total) : 0;

      // when excluding taxes the total without taxes will be validated instead of Total Price column
      lineItem.totalToValidate = !lineItem.isFeeDiscountItem && settings.excludeTaxes ? settings.totalToValidate || lineItem.total : null;
      lineItem.hideQtyWhenZero = !lineItem.isFeeDiscountItem;
      if (lineItem.hideQtyWhenZero && Number(lineItem.quantity) === 0) {
        lineItem.totalTaxes = 0;
        lineItem.totalFees = 0;
        lineItem.totalTaxesForFees = 0;
        lineItem.total = 0;
        lineItem.totalWithTaxesAndFees = 0;
      }

      // display available amount on taxes/fees/discount
      if (lineItem.isFeeDiscountItem && !lineItem.isAutoGenerated) {
        if (Number(lineItem.total) !== 0 && Number(lineItem.amountTypeId) === 1) {
          var prevAmount = lineItem.amountTypeValue;
          lineItem.amountTypeValue = this.getRemainingTotalAmountPerItem(false, settings);
          if (Number(lineItem.itemTypeId) === 3) {
            // Discount: amount must be positive
            lineItem.amountTypeValue = Math.abs(lineItem.amountTypeValue);
          } else {
            // keep positive po item amount when excluding taxes is ON and remaining amount is negative
            if (Number(prevAmount) > 0 && Number(lineItem.amountTypeValue) < 0) {
              lineItem.amountTypeValue = prevAmount;
            }
          }
          lineItem.unitPrice = lineItem.amountTypeValue;
        }
      }
      lineItem.remainingQuantity = 0;
      lineItem.remainingUnits = 0;
      lineItem.maxQuantity = __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].maxAmount;
      lineItem.isQuantityReadonly = !lineItem.isAutoGenerated && editedQty === 0 && (settings.poTotalAmount >= 0 && settings.poTotalAmount <= settings.invoicedTotalAmount || settings.poTotalAmount < 0 && settings.poTotalAmount >= settings.invoicedTotalAmount);
      lineItem.isUnitsReadonly = lineItem.isQuantityReadonly;
      return lineItem;
    }
  }, {
    key: "getMaxTotalAmount",
    value: function getMaxTotalAmount(lineItem, qtySettings) {
      var maxTotalAmount = lineItem.totalWithTaxesAndFees < 0 ? 0 : __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].maxAmount;
      if (!lineItem.isAutoGenerated && lineItem.totalWithTaxesAndFees >= 0) {
        if (lineItem.isFeeDiscountItem /* && qtySettings.excludeTaxes */) {
          // taxes are ignored, can enter any amount
          maxTotalAmount = __WEBPACK_IMPORTED_MODULE_6__models_line_item_constants__["a" /* default */].maxAmount;
        } else {
          maxTotalAmount = this.getRemainingTotalAmountPerItem(qtySettings.excludeTaxes, qtySettings);
        }
      }
      return maxTotalAmount;
    }
  }, {
    key: "getRemainingTotalAmountPerItem",
    value: function getRemainingTotalAmountPerItem(excludeTaxes, settings) {
      var result = excludeTaxes ? settings.poTotalAmountWithoutTaxes - settings.invoicedTotalWithoutTaxes + settings.initialTotalWithoutTaxes : settings.poTotalAmount - settings.invoicedTotalAmount + settings.initialTotalAmount;
      return parseFloat(result.toFixed(4));
    }
  }, {
    key: "getDecouplingSettingsPerItem",
    value: function getDecouplingSettingsPerItem(poEvents, invoiceItems, settings) {
      var result = [];
      if (poEvents && poEvents.length > 0) {
        poEvents.map(function (ev) {
          if (ev.lineItems && ev.lineItems.length > 0) {
            ev.lineItems.map(function (poItem) {
              var invItem = invoiceItems && invoiceItems.filter(function (v) {
                return v.Id === poItem.itemKey;
              });
              if (invItem && invItem.length > 0) invItem = invItem[0];
              var poUnitPrice = poItem.isFeeDiscountItem ? poItem.amountTypeValue : poItem.unitPrice;
              result.push({
                itemId: poItem.itemKey,
                itemKey: invItem.ItemKey,
                quantity: invItem && invItem.Quantity || 0,
                units: invItem && invItem.Units || 0,
                unitPrice: invItem && invItem.UnitPrice || 0,
                totalToValidate: invItem && settings.ExcludeTaxes ? invItem.TotalAmountWithoutTaxes : null,
                poQuantity: Number(poItem.quantity || 0),
                poUnits: Number(poItem.units || 0),
                poUnitPrice: Number(poUnitPrice || 0),
                poTotalAmount: poItem.totalWithTaxesAndFees,
                poTotalAmountWithoutTaxes: poItem.total,
                invoicedQuantity: invItem && invItem.InvoicedQuantity || 0,
                invoicedUnits: invItem && invItem.InvoicedUnits || 0,
                invoicedTotalAmount: invItem && invItem.InvoicedTotalAmount || 0,
                invoicedTotalWithoutTaxes: invItem && invItem.InvoicedTotalWithoutTaxes || 0,
                initialQuantity: invItem && invItem.Quantity || 0,
                initialUnits: invItem && invItem.Units || 0,
                initialTotalAmount: invItem && invItem.TotalAmount || 0,
                initialTotalWithoutTaxes: invItem && invItem.TotalAmountWithoutTaxes || 0,
                canExceedPOQty: settings.AllowExceedPOQty,
                excludeTaxes: settings.ExcludeTaxes
              });
            });
          }
        });
      }
      return result;
    }
  }]);
}();

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "POux":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PSwI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticStyle:{"margin-bottom":"10px"},attrs:{"button-class":_vm.buttonClass,"ids":_vm.ids,"disabled":_vm.disabled},on:{"click":function($event){_vm.showReject = true}}},[_vm._v("\n    Decline\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Decline Card Refill Settings","show":_vm.showReject,"validation":"","primary-button":"Decline","primaryButtonClass":"btn btn-danger","modalEndpoint":_vm.api.$.evedpaycard.approveOrRejectCardRefill},on:{"close":function($event){_vm.showReject = false, _vm.rejectReason = ''},"confirm":function($event){return _vm.approveOrRejectCardRefill()},"validate":_vm.approveOrRejectCardRefill}},[_c('div',{staticClass:"reject-card-refill-overlay",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Provide a reason for declining the card refill settings.")]),_vm._v(" "),_c('label',[_vm._v("Reason")]),_vm._v(" "),_c('ed-input',{attrs:{"type":"text"},on:{"input":function (value) { return _vm.rejectReason = value; }},model:{value:(_vm.rejectReason),callback:function ($$v) {_vm.rejectReason=$$v},expression:"rejectReason"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PTlP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("yApK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1686a2fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Kq2q");
function injectStyle (ssrContext) {
  __webpack_require__("6o4z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1686a2fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PXXQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_remit_payment_vue__ = __webpack_require__("E1Ga");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0901a54e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_remit_payment_vue__ = __webpack_require__("PG8B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_remit_payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0901a54e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_remit_payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PZSu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_edTabNav_wizardMixin__ = __webpack_require__("3d8/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import customTypes from './types.json'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImportPrograms',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_components_edTabNav_wizardMixin__["a" /* default */]],
  methods: {
    /**
     * Updates matched column/columns list
     */
    handleMultimatch: function handleMultimatch(field, value) {
      if (field.Type === 'List') {
        field.Columns = field.Columns || [];
        field.Columns.push(value);
      } else {
        field.Columns = [value];
      }
      this.$forceUpdate();
    },
    /**
     * Removes 1:1 match
     */
    removeMatch: function removeMatch(field) {
      field.Columns = [];
      this.$forceUpdate();
    },
    /**
     * Removes 1:* match
     */
    removeColumn: function removeColumn(column, field) {
      field && field.Columns.splice(field.Columns.indexOf(column), 1);
      this.$forceUpdate();
    },
    /**
     * Gets permissions list
     */
    fetchPermissions: function fetchPermissions() {
      var _this = this;
      this.permissions.length || this.api(this.api.$.program.permissions).then(function (r) {
        _this.permissions = r.data || [];
      });
    },
    /**
     * Gets titles list
     */
    fetchTitles: function fetchTitles() {
      var _this2 = this;
      this.titles.length || this.api(this.api.$.program.titles).then(function (r) {
        _this2.titles = r.data || [];
      });
    },
    /**
     * Checks if required/all fields are matched
     */
    checkMatched: function checkMatched() {
      if (this.data.FieldsMap[0].FieldName !== null) {
        var allRequiredMatched = this.data.FieldsMap.filter(function (field) {
          return field.IsRequired && !(field.Columns && field.Columns.length);
        }).length === 0;
        var allMatched = this.canSkip || this.data.FieldsMap.filter(function (field) {
          return !field.IsRequired && !(field.Columns && field.Columns.length);
        }).length === 0;
        this.notAllRequiredMatched = !allRequiredMatched;
        this.notAllMatched = allRequiredMatched && !allMatched;
        if (!allRequiredMatched) {
          __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].GENERIC.WIZARD.INVALID, this.$refs.header.title);
        }
        return allRequiredMatched && allMatched;
      }
    },
    /**
     * Can proceed to next step if not all not required are matched
     */
    skipMatch: function skipMatch() {
      this.canSkip = true;
      this.proceed();
      this.canSkip = false;
    },
    gotErrors: function gotErrors() {
      // EventBus.$emit(Eved.GENERIC.WIZARD.ERRORS, this.errors)
    },
    /**
     * Callback after each step
     */
    afterEnterStep: function afterEnterStep() {
      // Activate Admin menu
      global.Page.showTabs('Admin', 'Import', '#d', null);

      // reset any pending data
      this.$store.state.pendingData = null;
    }
  },
  created: function created() {
    this.ImportedColumns = [];
  },
  data: function data() {
    return {
      canSkip: false,
      notAllMatched: false,
      notAllRequiredMatched: false,
      data: {
        FieldsMap: [{
          FieldName: null,
          IsRequired: true,
          Columns: []
        }],
        ImportedColumns: []
      },
      errors: null,
      permissions: [],
      titles: [],
      /**
       * Column match label
       */
      columnName: function columnName(option, multiple) {
        if (!option) return;
        if (option.length === 0) return '';

        //
        if (multiple === false) {
          return option;
        }

        // 1:* match
        if (multiple) return option && option.length + ' selected';

        // 1:1 match - [LETTER] NAME
        return option && typeof option === 'string' ? option : "[".concat(option.Letter || option[0] && option[0].Letter, "] ").concat(option.Name || option[0] && option[0].Name || '[None]');
      },
      /**
       * Set details for custom matches
       */
      initDetails: function initDetails(column, field) {
        if (field.Alias === 'Collaborators') {
          column.Details = column.Details || {};
        }
        return field.Alias === 'Collaborators';
      },
      /**
       * Enables/disables unselected/selected columns
       */
      updateMatches: function updateMatches(fields, columns) {
        if (!columns.length) return fields;
        var matchedFields = fields.map(function (field) {
          return field.Columns;
        }).reduce(function (fields, columns) {
          return (fields || []).concat(columns);
        }).filter(function (columns) {
          return columns;
        }).map(function (column) {
          return column.Letter;
        });
        columns = columns.map(function (column) {
          if (~matchedFields.indexOf(column.Letter)) {
            column.$isDisabled = true;
          } else {
            delete column.$isDisabled;
          }
          return column;
        });
        return fields;
      },
      /**
       * Only inject options @open dropdown
       * to avoid performance bottlenecks
       * when rendering large sets
       */
      fetchImportedColumns: function fetchImportedColumns(columns, index) {
        this.$set(this.ImportedColumns, index, columns);
        this.$forceUpdate();
      },
      getImportedColumns: function getImportedColumns(index) {
        return this.ImportedColumns[index] || [];
      }
    };
  },
  computed: {
    programLabel: function programLabel() {
      var settings = JSON.parse(window.localStorage.getItem('sessionSettings'));
      return settings.CompanySettings.ProgramLabel;
    },
    programsLabel: function programsLabel() {
      var settings = JSON.parse(window.localStorage.getItem('sessionSettings'));
      return settings.CompanySettings.ProgramsLabel;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Pej/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_charts_components_money__ = __webpack_require__("TQ2p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_charts_components_tooltip_standard__ = __webpack_require__("Ik2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter__ = __webpack_require__("7VNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__ = __webpack_require__("CRMk");




/* harmony default export */ __webpack_exports__["a"] = ({
  // chartType: 'Bar',
  showLegend: false,
  showSmallLegend: true,
  chartOpts: getOptions(),
  chartData: function chartData(widget, data) {
    return getChartData(data);
  },
  chartInfo: function chartInfo(widget, data) {
    return getChartInfo(data, 0);
  },
  drillDown: function drillDown(ctx, value, index) {
    return executeDrillDown(ctx, value, index);
  },
  drillDownReturn: function drillDownReturn(ctx) {
    return reverseDrillDown(ctx);
  },
  components: {
    labelValue: __WEBPACK_IMPORTED_MODULE_0__core_charts_components_money__["a" /* default */],
    tooltip: __WEBPACK_IMPORTED_MODULE_1__core_charts_components_tooltip_standard__["a" /* default */]
  }
});
function getOptions() {
  var baseCustSet = {
    chartGroupValue: 'Category',
    containterStyle: '',
    hasDrillDown: true,
    recalculateGridMax: true,
    dynamicHeight: true,
    showTotal: true,
    multipleSeries: true,
    tooltip: {
      tooltipType: 'standard',
      width: '200px'
    }
  };
  var baseOpts = {
    customSettings: baseCustSet,
    lineSmooth: true,
    stackBars: true,
    horizontalBars: true,
    seriesBarDistance: 18,
    labelInterpolationFnc: function labelInterpolationFnc(value) {
      return value[0];
    },
    showPoint: false,
    targetLine: {
      value: 0,
      class: 'ct-target-line'
    },
    fullWidth: false,
    axisY: {
      position: 'start',
      labelOffset: {
        x: 2,
        y: 1
      },
      scaleMinSpace: 15,
      showGrid: true,
      showLabel: true,
      offset: 130,
      labelInterpolationFnc: function labelInterpolationFnc(value) {
        return value;
      }
    },
    chartPadding: {
      top: 5,
      right: 25,
      bottom: 5,
      left: 5
    }
  };
  return baseOpts;
}
function getChartInfo(dataIn, pos) {
  var result = [];
  dataIn.forEach(function (elem) {
    var gdPos = result.findIndex(function (k) {
      return k[0] === elem[pos];
    });
    if (gdPos === -1) result.push(elem[pos]);
  });
  return result.map(function (k) {
    return k[0];
  });
}
function getChartData(data) {
  var labelsGrouped = [];
  var totalSpend = 0;
  data.forEach(function (elem) {
    if (elem[0] !== '') {
      var gdPos = labelsGrouped.findIndex(function (k) {
        return k[0] === elem[0];
      });
      if (gdPos === -1) {
        labelsGrouped.push([elem[0], elem[2], [0, 0, 0]]);
        totalSpend += elem[2];
        var labelPos = labelsGrouped.findIndex(function (k) {
          return k[0] === elem[0];
        });
        if (elem[3] === 'Preferred') labelsGrouped[labelPos][2][0] = elem[2];else if (elem[3] === 'Approved') labelsGrouped[labelPos][2][1] = elem[2];else labelsGrouped[labelPos][2][2] = elem[2];
      } else {
        labelsGrouped[gdPos][1] += elem[2];
        totalSpend += elem[2];
        if (elem[3] === 'Preferred') labelsGrouped[gdPos][2][0] += elem[2];else if (elem[3] === 'Approved') labelsGrouped[gdPos][2][1] += elem[2];else labelsGrouped[gdPos][2][2] += elem[2];
      }
    }
  });
  var sortedData = labelsGrouped.slice(0);
  sortedData.sort(function (a, b) {
    return a[1] - b[1];
  });
  var totals = sortedData.map(function (k) {
    return k[1];
  });
  var maxValue = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayMaxValue(totals);
  var minValue = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayMinValue(totals);
  var avgTot = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayAverage(totals);
  var seriesGrouped = sortedData.map(function (k) {
    return k[2];
  });
  totals = sortedData.map(function (k) {
    return __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.thousandsFormatter(k[1]);
  });
  return {
    total: totalSpend.toFixed(2),
    labels: sortedData.map(function (k) {
      return k[0];
    }),
    series: [{
      type: 'Bar',
      stackBars: true,
      maxValue: maxValue,
      minValue: minValue,
      barSpace: 36,
      minHeight: 90,
      vLines: [{
        name: 'Avg Spend',
        value: avgTot,
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].purple,
        class: 'ct-value-line'
      }],
      ignoreForCharts: false,
      data: [{
        name: 'Preferred',
        value: seriesGrouped.map(function (k) {
          return k[0].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].blueLight,
        width: '25px',
        ignoreLabel: true
      }, {
        name: 'Approved',
        value: seriesGrouped.map(function (k) {
          return k[1].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].green,
        width: '25px',
        ignoreLabel: true
      }, {
        name: 'Other',
        value: seriesGrouped.map(function (k) {
          return k[2].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].purple,
        width: '25px',
        ignoreLabel: false,
        metadata: {
          barLabels: totals
        }
      }]
    }],
    tooltipData: {
      helpText: 'Click on the bar to show subcategory spend details.',
      metadata: tooltipMetadata,
      data: [sortedData.map(function (t) {
        return t[0];
      }), seriesGrouped.map(function (k) {
        return k[0].toFixed(2);
      }), seriesGrouped.map(function (k) {
        return k[1].toFixed(2);
      }), seriesGrouped.map(function (k) {
        return k[2].toFixed(2);
      }), seriesGrouped.map(function (k) {
        return (k[0] + k[1] + k[2]).toFixed(2);
      }), avgTot, seriesGrouped.map(function (k) {
        return ((k[0] + k[1] + k[2]) * 100 / totalSpend).toFixed(2);
      })]
    }
  };
}
function getChartDataDrilled(dataIn, value) {
  if (dataIn.length === 0) return {
    labels: null,
    series: []
  };
  var labelsGrouped = [];
  dataIn.forEach(function (subcat) {
    if (subcat[0] === value) {
      var label = subcat[1];
      if (label === null || label === '') label = 'No Subcategory';
      var pos = labelsGrouped.findIndex(function (k) {
        return k[0] === label;
      });
      if (pos === -1) {
        labelsGrouped.push([label, subcat[2], subcat[5], subcat[4]]);
      } else {
        labelsGrouped[pos][1] += subcat[2];
        labelsGrouped[pos][2] += subcat[5];
        labelsGrouped[pos][3] += subcat[4];
      }
    }
  });
  var sortedData = labelsGrouped.slice(0);
  sortedData.sort(function (a, b) {
    return a[1] - b[1];
  });
  var firstBar = sortedData.map(function (k) {
    return k[1].toFixed(2);
  });
  var secondBar = sortedData.map(function (k) {
    return (k[2] / k[3]).toFixed(2);
  });
  var firstBarAvg = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayAverage(firstBar);
  var sec = sortedData.reduce(function (r, a) {
    return a.map(function (b, i) {
      return (r[i] || 0) + b;
    });
  }, []);
  var secondBarAvg = (sec[2] / sec[3]).toFixed(2);
  var max1 = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayMaxValue(firstBar);
  var min1 = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayMinValue(firstBar);
  var max2 = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayMaxValue(secondBar);
  var min2 = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayMinValue(secondBar);
  var xMod = getXModifier(max1, max2);
  return {
    labels: sortedData.map(function (k) {
      return k[0];
    }),
    series: [{
      type: 'Bar',
      hasTooltipData: true,
      stackBars: false,
      maxValue: max1,
      minValue: min1 < min2 * xMod ? min1 : min2 * xMod,
      barSpace: 50,
      minHeight: 70,
      ignoreForCharts: false,
      vLines: [{
        name: 'Avg Spend',
        value: firstBarAvg,
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].purple,
        class: 'ct-value-line'
      }, {
        name: 'Overall Avg Price Per Unit',
        value: secondBarAvg * xMod,
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].green,
        class: 'ct-value-line'
      }],
      backgroundChart: false,
      data: [{
        name: 'Total Spend',
        value: firstBar,
        ignoreLabel: false,
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].purple,
        width: '13px',
        metadata: {
          barLabels: firstBar.map(function (k) {
            return __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.thousandsFormatter(k);
          })
        }
      }, {
        name: 'Avg Price Per Unit',
        value: secondBar,
        ignoreLabel: true,
        xModifier: xMod,
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].green,
        width: '13px'
      }]
    }],
    tooltipData: {
      metadata: tooltipMedatadaDrilled,
      data: [sortedData.map(function (k) {
        return k[0];
      }), firstBar, secondBar, firstBarAvg, secondBarAvg]
    }
  };
}
function executeDrillDown(ctx, value) {
  var catName = value;
  var fullData = ctx.rawData.filter(function (row) {
    return ~row.indexOf(catName);
  });
  var newChartData = getChartDataDrilled(fullData, value);
  ctx.chartData = newChartData;
  ctx.chartInfo = newChartData.labels;
  ctx.chartComponent.chartOpts.stackBars = false;
  ctx.chartComponent.chartOpts.customSettings.hasDrillDown = false;
  ctx.chartComponent.chartOpts.customSettings.tooltip = {
    width: '235px',
    topOffset: -10,
    leftOffset: 50
  };
  ctx.$emit('childRedraw');
}
function reverseDrillDown(ctx) {
  ctx.chartComponent.chartOpts = getOptions();
  ctx.$emit('childRedraw');
}
function getXModifier(c1, c2) {
  var diff = c1 / c2;
  var result = diff / 2;
  return result;
}
var tooltipMetadata = [{
  label: '',
  type: 'title',
  format: ''
}, {
  label: 'Preferred',
  type: 'main',
  format: 'currency'
}, {
  label: 'Approved',
  type: 'main',
  format: 'currency'
}, {
  label: 'Other',
  type: 'main',
  format: 'currency'
}, {
  label: 'Total Spend',
  type: 'main',
  format: 'currency'
}, {
  label: 'Avg Spend',
  type: 'secondary',
  format: 'currency'
}, {
  label: '% of Total',
  type: 'secondary',
  format: 'percentage'
}];
var tooltipMedatadaDrilled = [{
  label: '',
  type: 'title',
  format: ''
}, {
  label: 'Total Spend',
  type: 'main',
  format: 'currency'
}, {
  label: 'Avg Price Per Unit',
  type: 'main',
  format: 'currency'
}, {
  label: 'Avg Spend',
  type: 'secondary',
  format: 'currency'
}, {
  label: 'Overall Avg Price Per Unit',
  type: 'secondary',
  format: 'currency'
}];

/***/ }),

/***/ "PhN0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-custom-header",class:_vm.params.column.colDef.className},[(_vm.params.displayName !== "_")?_c('a',{staticClass:"header-label",class:{ disabled: _vm.disabled, nowrap: _vm.params.column.colDef.nowrap === false },attrs:{"title":_vm.params.displayName,"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showMenu($event)}}},[_vm._v(_vm._s(_vm.params.displayName)),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.appliedFilters))])]):_vm._e(),(_vm.params.enableSorting)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.tooltip(_vm.sortState)),expression:"tooltip(sortState)",modifiers:{"bottom":true}}],staticClass:"fas ag-header-sort-icon",class:_vm.sortState,on:{"click":_vm.sortColumn}},[_c('i',{staticClass:"fas fa-caret-up",class:_vm.params.column.sort}),_c('br'),_c('i',{staticClass:"fas fa-caret-down",class:_vm.params.column.sort})]):_vm._e(),(!_vm.params.column.colDef.action && _vm.params.api.gridOptionsWrapper.gridOptions.pinning)?_c('i',{staticClass:"fas fa-thumbtack pull-right ag-pin-column-icon",class:{ "active": _vm.params.column.pinned, "last": _vm.isLast },on:{"click":_vm.pinColumn}}):_vm._e(),(_vm.headerCheckbox)?_c('checkbox-proxy',{attrs:{"header-checkbox":_vm.headerCheckbox,"context":_vm.params.context}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pr2y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.node.rowPinned !== 'bottom')?_c('span',{staticClass:"wrapper"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.params.value),expression:"params.value",modifiers:{"bottom":true}}]},[(_vm.hasReceipt)?_c('i',{staticClass:"fas fa-camera",staticStyle:{"color":"#4A90E2"}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.params.value)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PtKW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    editMode: function editMode() {
      return this.$route.params.page === 'edit';
    }
  }
});

/***/ }),

/***/ "Ptug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFeesDiscountItem_vue__ = __webpack_require__("aWMy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69792fde_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFeesDiscountItem_vue__ = __webpack_require__("ExUt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFeesDiscountItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69792fde_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFeesDiscountItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pu0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("gk3X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Layouts_snippets_columns__ = __webpack_require__("XC3F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['options', 'value'],
  components: {
    LayoutSnippet: __WEBPACK_IMPORTED_MODULE_2__components_Layouts_snippets_columns__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    this.defaultModuleWidthOptions = [{
      label: '100%',
      value: 12
    }, {
      label: '66%',
      value: 8
    }, {
      label: '50%',
      value: 6
    }, {
      label: '33%',
      value: 4
    }];
  },
  created: function created() {
    this._value = this._value || utils.copy(this.value);
    this._value.label = this._value.label || this.vm.title;
    this.endpoint = "".concat(this.api.$.dashboard.widget, "/").concat(this.value.id);
    this.moduleWidthOptions = this.value.variableDefinitions ? this.value.variableDefinitions[0].items.map(function (option) {
      return {
        label: option.label,
        value: __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* WIDTHS */][option.key]
      };
    }) : this.defaultModuleWidthOptions;
  },
  data: function data() {
    return {
      placeholders: __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* SETTING_PLACEHOLDERS */],
      vm: _objectSpread({}, utils.copy(this.options)),
      operations: {
        savePending: false,
        clonePending: false,
        deletePending: false
      },
      widthInvalid: false,
      availableSettings: this.value.variableDefinitions || [],
      settings: this.value.variables && utils.copy(this.value.variables) || []
    };
  },
  computed: {
    moduleWidth: {
      get: function get() {
        return this.getWidth();
      },
      set: function set(v) {
        this._value.w = v.value;
        this.pickedWidth = true;

        // update width
        if (this.settings[0]) {
          this.settings[0].value = this.getWidthKey(v.value);
        }
      }
    },
    currencies: function currencies() {
      return global.app.$user.sessionSettings.Currencies;
    }
  },
  methods: {
    set: function set() {
      var _this = this;
      // set width
      if (this.pickedWidth) {
        // do not update width immediately
        // this.value.w = this._value.w
        this.pickedWidth = false;
      }
      this._value.variables = this.settings;
      this.$nextTick(function () {
        _this.operations.savePending = true;
        _this.$emit('set', _objectSpread({
          value: _this._value,
          moduleWidth: _this.getWidth()
        }, utils.copy(_this.vm)));
      });
    },
    closeOptions: function closeOptions() {
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('widgetSettingsClose', this);
    },
    getValue: function getValue(i, from) {
      var _this2 = this;
      var option = from ? this[from].filter(function (k) {
        return k.key === _this2.settings[i].value[0];
      }) : this.availableSettings[i].items.filter(function (k) {
        return k.key === _this2.settings[i].value[0];
      });
      return option && option[0] && option[0].label;
    },
    setValue: function setValue(v, i) {
      var _this3 = this;
      v && this.$nextTick(function () {
        _this3.settings[i].value = [v.key];
      });
    },
    clone: function clone() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.operations.clonePending = true;
        _this4.$parent.$emit('clone');
      });
    },
    remove: function remove() {
      var _this5 = this;
      this.$nextTick(function () {
        _this5.operations.deletePending = true;
        _this5.$parent.$emit('remove');
      });
    },
    getWidth: function getWidth() {
      var _this6 = this;
      var option = this.moduleWidthOptions && this.moduleWidthOptions.filter(function (k) {
        return k.value === _this6._value.w;
      })[0];
      var width = {
        label: option ? option.label : '%',
        value: this._value.w
      };
      if (this.settings && this.settings[0]) {
        if (option) {
          this.widthInvalid = false;
          this.settings[0].value = this.getWidthKey(option.value);
        } else {
          this.widthInvalid = true;
        }
        return this.settings[0].value && width;
      } else {
        return width;
      }
    },
    optionComponent: function optionComponent(type) {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* SELECTOR_COMPONENTS */][type]);
    },
    relevantToDisplay: function relevantToDisplay(option) {
      var relevantOption = option.items.length !== 1 && this.optionComponent(option.type) !== 'ed-radio';
      return relevantOption;
    },
    getWidthKey: function getWidthKey(value) {
      return Object.keys(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* WIDTHS */]).filter(function (k) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* WIDTHS */][k] === value;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "PvP1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('grid',{ref:"grid",attrs:{"name":_vm.$t('EvedPay Cards'),"desc":"Manage accounts, cards and transactions","search":"true","search-placeholder":"My Cards","sort":_vm.sort,"resizing":"false","endpoint":_vm.api.$.evedpaycard.cards,"views":true,"alias":"PaymentInvoiceList_SentInvoices","legacy":"","tabs":_vm.tabs,"row-classes":_vm.rowClasses,"footer":"","totals":"","no-tooltip-fields":_vm.noTooltipFields,"xadditional-filters":_vm.additionalFilters,"filter":_vm.defaultFilter,"can-remove-default-filter":""},on:{"selectedRows":_vm.rowSelected}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('addFunds')),expression:"actionDisabledReason('addFunds')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('addFunds')},on:{"success":_vm.refresh,"click":function () {_vm.showAddFunds = true}}},[_vm._v("\n        Add Funds\n      ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('additionalUsers')),expression:"actionDisabledReason('additionalUsers')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('additionalUsers')},on:{"success":_vm.refresh,"click":function () {_vm.showCardAdditionalUsers = true}}},[_vm._v("\n        Additional Users\n      ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('returnFunds')),expression:"actionDisabledReason('returnFunds')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('returnFunds')},on:{"success":_vm.refresh,"click":function () {_vm.showReturnFundsToAccount = true}}},[_vm._v("\n        Return Funds to Account\n      ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('refillSettings')),expression:"actionDisabledReason('refillSettings')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('refillSettings')},on:{"success":_vm.refresh,"click":function () { _vm.isRefillOpen.showModal = true }}},[_vm._v("\n        Refill Settings\n      ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('dailySpendLimit')),expression:"actionDisabledReason('dailySpendLimit')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('dailySpendLimit')},on:{"success":_vm.refresh,"click":function () { _vm.isDailySpendLimitOpen.showModal = true }}},[_vm._v("\n        Daily Spend Limit\n      ")]):_vm._e(),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.loadingAccountSettings || _vm.actionDisabledReason('editAccountingSystemSettings')),expression:"loadingAccountSettings || actionDisabledReason('editAccountingSystemSettings')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.loadingAccountSettings || _vm.cardActionDisabled('editAccountingSystemSettings')},on:{"success":_vm.refresh,"click":function () { _vm.showAccountingSystemSettings = true }}},[_vm._v("\n        PSL+ Settings\n      ")]),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('holdActivity')),expression:"actionDisabledReason('holdActivity')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('holdActivity')},on:{"success":_vm.refresh,"click":_vm.lockCard}},[_vm._v("\n        "+_vm._s(_vm.lockUnlockButtonText)+"\n      ")]):_vm._e(),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('reportLostStolen')),expression:"actionDisabledReason('reportLostStolen')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('reportLostStolen')},on:{"success":_vm.refresh,"click":_vm.lostStolen}},[_vm._v("\n        Report Lost or Stolen\n      ")]),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') || _vm.hasAccountPermission('EvedPayCardViewReconcileClose'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('showCardNumber')),expression:"actionDisabledReason('showCardNumber')"}],staticClass:"btn btn-actionbar",attrs:{"id":_vm.selectedRows,"disabled":_vm.cardActionDisabled('showCardNumber')},on:{"click":function () {_vm.showShowCardNumber = true}}},[_vm._v("\n        Card Number\n      ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('requestPhysicalCard')),expression:"actionDisabledReason('requestPhysicalCard')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.cardActionDisabled('requestPhysicalCard')},on:{"success":_vm.refresh,"click":function () {_vm.showRequestPhysicalBatchOpen.showModal = true}}},[_vm._v("\n        REQUEST PHYSICAL BATCH\n      ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardViewReconcileClose'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('close')),expression:"actionDisabledReason('close')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('close')},on:{"success":_vm.refresh,"click":_vm.closeCard}},[_vm._v("\n        Close Card\n      ")]):_vm._e(),_vm._v(" "),(_vm.showApproveButton && _vm.selectedRows.length)?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('approve')),expression:"actionDisabledReason('approve')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.cardActionDisabled('approve')},on:{"success":_vm.refresh,"click":function($event){_vm.showApproveDialog = true}}},[_vm._v("\n        Approve\n      ")]):_vm._e(),_vm._v(" "),(_vm.showRejectButton && _vm.selectedRows.length)?_c('RejectCard',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('reject')),expression:"actionDisabledReason('reject')"}],attrs:{"disabled":_vm.cardActionDisabled('reject'),"selected-rows":_vm.selectedRows,"button-class":_vm.getButtonClass()},on:{"success":_vm.refresh}}):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('span',{staticClass:"form-group no-margin",attrs:{"slot":"additionalLabel"},slot:"additionalLabel"},[_c('i',{staticClass:"fas fa-exclamation"}),_vm._v(" "),_c('span',[_vm._v(" ")]),_vm._v(" "),_c('label',[_vm._v("Click column headers to apply filters")])])]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Card Number","show":_vm.showShowCardNumber,"primary-button":"false","secondary-button":"false","type":"compact"},on:{"close":_vm.closeShowCardNumber}},[_c('ShowCardNumber',{ref:"showCardNumberComponent",attrs:{"slot":"body","card":_vm.cardForShowNumber},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":"evedpaycards/request-physical-card","title":"Request Physical Card Batch","show":_vm.showRequestPhysicalBatchOpen.showModal,"primary-button":"Request","validation":""},on:{"close":function($event){_vm.showRequestPhysicalBatchOpen.showModal = false},"validate":function($event){return _vm.$refs.physicalCardComponent.requestPhysicalCard(_vm.showRequestPhysicalBatchOpen)}}},[(_vm.selectedRows.length)?_c('RequestPhysicalBatch',{ref:"physicalCardComponent",attrs:{"slot":"body","list":_vm.selectedRows,"divisionId":_vm.selectedRows[0].data.DivisionId},on:{"success":_vm.refresh},slot:"body"}):_vm._e()],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/" + (this.cardStatus)),"title":_vm.modalTitle,"show":_vm.showCardStatus.showModal,"primary-button":"Submit","type":"medium","validation":"","primary-button-disabled":_vm.isCardStatusSubmitDisabled},on:{"close":_vm.closeCardStatusModal,"validate":function($event){return _vm.$refs.cardStatusComponent.changeStatus(_vm.cardStatus, _vm.showCardStatus)}}},[_c('CardStatus',{ref:"cardStatusComponent",attrs:{"slot":"body","status":_vm.cardStatus,"cards":_vm.selectedObj,"is-eved-admin":_vm.isEvedAdmin},on:{"helpDeskTicketNumber":function (v) { return _vm.helpDeskTicketNumber = v; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Approval Needed","show":_vm.showApprovalUsers,"primary-button":"Close","secondary-button":"false"},on:{"close":function($event){_vm.showApprovalUsers = false}}},[_c('ApprovalNeededUsers',{attrs:{"slot":"body","approvalUsersData":_vm.approvalUsersData},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/add-funds"),"title":"Add Funds","show":_vm.showAddFunds,"validation":"","primary-button":"Add"},on:{"close":function($event){_vm.showAddFunds = false},"validate":_vm.addFunds,"confirm":function($event){return _vm.addfunds()}}},[_c('CardAddFunds',{attrs:{"slot":"body","addFundsError":this.addFundsErrors,"balance":_vm.accountBalance},on:{"fundingAmount":function (value) { return _vm.fundingAmount = value; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/additional-users"),"title":"Additional Users","show":_vm.showCardAdditionalUsers,"primary-button":"Save"},on:{"close":function($event){_vm.showCardAdditionalUsers = false},"confirm":_vm.updateAdditionalUsers}},[_c('CardAdditionalUsers',{attrs:{"slot":"body","divisionId":_vm.processedSelectedObj.DivisionId,"cardId":_vm.processedSelectedObj.Id,"cardHolderId":_vm.processedSelectedObj.HolderUserId},on:{"additionalUsers":function (o) { return _vm.additionalUsers = o; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/remove-funds"),"title":"Return Funds to Account","show":_vm.showReturnFundsToAccount,"primary-button":"Submit","validation":""},on:{"close":function($event){_vm.showReturnFundsToAccount = false},"validate":_vm.doReturnFunds,"confirm":function($event){return _vm.doReturnFunds()}}},[_c('ReturnFunds',{attrs:{"slot":"body","card":_vm.processedSelectedObj},on:{"returnFunds":function (value) { return _vm.returnFunds = value; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/refill-settings"),"title":"Refill Settings","show":_vm.isRefillOpen.showModal,"primary-button":"Save","validation":""},on:{"close":function($event){_vm.isRefillOpen.showModal = false},"validate":function($event){return _vm.$refs.cardRefillComponent.doRefill(_vm.isRefillOpen)}}},[_c('RefillSettings',{ref:"cardRefillComponent",attrs:{"slot":"body","card":_vm.processedSelectedObj},on:{"refillSuccess":_vm.showRefillToast},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/daily-spend-limit"),"title":"Daily Spend Limit","show":_vm.isDailySpendLimitOpen.showModal,"primary-button":"Save","validation":""},on:{"close":function($event){_vm.isDailySpendLimitOpen.showModal = false},"validate":function($event){return _vm.$refs.cardDailySpendLimitComponent.save(_vm.isDailySpendLimitOpen)}}},[_c('CardDailySpendLimit',{ref:"cardDailySpendLimitComponent",attrs:{"slot":"body","card":_vm.processedSelectedObj},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/accounting-system-settings"),"title":'PSL+ Settings',"primary-button":"Save","show":_vm.showAccountingSystemSettings,"validation":""},on:{"validate":_vm.handlePslSettingsSave,"close":function($event){_vm.showAccountingSystemSettings = false}}},[_c('AccountingSystemSettings',{ref:"accountingSystemSettingsCmp",attrs:{"slot":"body","card":_vm.processedSelectedObj,"accountSettings":_vm.accountSettings[_vm.objDivisionId]},slot:"body"})],1),_vm._v(" "),_c('ApproveDialog',{attrs:{"showModal":_vm.showApproveDialog,"list":_vm.transformRows(_vm.selectedRows),"programLabel":_vm.programLabel,"cardApproval":""},on:{"approve":_vm.doApprove,"close":function () { _vm.showApproveDialog = false }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pyxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d6fa30_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_default_vue__ = __webpack_require__("4lSa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d6fa30_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_default_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Q++R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tabs = function tabs() {
  return [PAYMENTS, SENT_INVOICES, ACTION_REQUIRED];
};
/* harmony default export */ __webpack_exports__["a"] = ({
  get tabs() {
    return tabs();
  }
});

//
var PAYMENTS = {
  label: 'Payments',
  href: {
    params: {
      page: 'Invoices',
      section: 'payments'
    }
  }
};
var SENT_INVOICES = {
  label: 'Invoices',
  href: {
    params: {
      page: 'Invoices',
      section: 'sent'
    }
  }
};
var ACTION_REQUIRED = {
  label: 'Action Required',
  href: {
    params: {
      page: 'Invoices',
      section: 'action-required'
    }
  }
};

/***/ }),

/***/ "Q/y2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q5Cs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extendedBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_google_analytics__ = __webpack_require__("v90g");
// import events from '@/core/events/events'

var extendedBus = function extendedBus(bus) {
  //
  var eventSource = bus.$emit;
  var eventSink = bus.$on;
  // const eventOnce = bus.$once
  // const eventOff = bus.$off

  function emitEvent(event, payload) {
    return eventSource.call(bus, event, payload);
  }
  function onEvent(event, cb) {
    return eventSink.call(bus, event, cb);
  }
  /* function onceEvent (event, cb) {
    return eventOnce.call(bus, event, cb)
  } */
  /* function offEvent (event, cb) {
    return eventOff.call(bus, event, cb)
  } */

  //
  __WEBPACK_IMPORTED_MODULE_0__components_google_analytics__["a" /* default */].init();
  __WEBPACK_IMPORTED_MODULE_0__components_google_analytics__["a" /* default */].setup();
  bus.$emit = function (event, payload, source) {
    var trackToGoogleAnalytics = false;
    var _source = source || {
      name: global.app.currentModule
    };
    var _payload = {
      target: _source.name || source,
      data: payload
    };
    if (event) {
      //
      if (event.charAt(0) === '%') {
        event = event.substr(1);
        trackToGoogleAnalytics = true;
      }
      emitEvent.call(bus, event, _payload);

      //
      trackToGoogleAnalytics && __WEBPACK_IMPORTED_MODULE_0__components_google_analytics__["a" /* default */].track(_payload.target, event, payload);
      console.info('emitted', event, 'from', _source.name, 'with payload', _payload);
    } else {
      console.warn('this event is undefined');
    }
  };
  bus.$on = function (event, cb, sink, once) {
    console.info("attached ".concat(once ? 'once' : ''), event, 'with', cb.name);
    onEvent.call(bus, event, function (payload) {
      var _sink = sink && sink.default || {};
      console.info("received ".concat(once ? 'once' : ''), event, _sink.name ? 'in' : '', _sink.name ? _sink.name : '', 'with payload', payload);
      if (typeof cb === 'function') {
        cb(payload);
      }

      // once && offEvent.call(bus, event)
    });
  };

  /* bus.$once = function (event, cb, sink) {
    // bus.$on(event, cb, sink, true)
  }
   bus.$off = function (event, cb) {
    console.log('detached', event)
     offEvent.call(bus, event, cb)
  } */

  return bus;
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Q8hK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.tooltip),expression:"tooltip",modifiers:{"bottom":true}}],class:["wrapper", _vm.headerCheckbox ? "from-header" : "", _vm.offset ? "offset" : ""],on:{"click":_vm.click,"mouseenter":_vm.hover,"mouseleave":_vm.blur}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QAQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("6zic");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5671c511_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("SB93");
function injectStyle (ssrContext) {
  __webpack_require__("TabU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5671c511_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QAUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RejectCard_vue__ = __webpack_require__("CCob");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_269cd52c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RejectCard_vue__ = __webpack_require__("RoUj");
function injectStyle (ssrContext) {
  __webpack_require__("lQ8Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-269cd52c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RejectCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_269cd52c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RejectCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QCk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getSettings();
  },
  methods: {
    save: function save() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.api.patch("evedpaycards/accounts/".concat(_this.accountId, "/refill-settings"), {
                RefillSettings: _this.RefillSettings
              });
            case 3:
              response = _context.sent;
              if (response.status === 200) {
                _this.$emit('success');
              } else {
                console.log('Failed to refill. ' + response.status);
              }
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    getSettings: function getSettings() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this2.api.get("evedpaycards/accounts/".concat(_this2.accountId, "/refill-settings"));
            case 3:
              response = _context2.sent;
              if (response.status === 200) {
                _this2.RefillSettings = response.data;
                _this2.$emit('loaded');
              }
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    }
  },
  props: {
    accountId: Number
  },
  data: function data() {
    return {
      RefillSettings: {
        RefillAmount: null,
        RefillThreshold: null
      }
    };
  }
});

/***/ }),

/***/ "QGwT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(!_vm.showCreateEnvelope && _vm.isFromDashboard)?_c('p',{attrs:{"endpoint":_vm.api.$.evedpaycard.envelopes}},[_c('br'),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),(!_vm.showCreateEnvelope)?_c('grid',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFromDashboard),expression:"!isFromDashboard"}],ref:"grid",attrs:{"name":_vm.$t("EvedPay Cards"),"desc":"Manage accounts, cards and transactions","search":"true","search-placeholder":"My Envelopes","resizing":"false","endpoint":_vm.api.$.evedpaycard.envelopes,"sort":_vm.sort,"row-classes":_vm.rowClasses,"fit-columns":"","legacy":"","footer":"","totals":"","tabs":_vm.tabs,"alias":"EvedPayCards","no-tooltip-fields":_vm.noTooltipFields,"filter":{}},on:{"selectedRows":_vm.rowSelected}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[(_vm.showApproveButton)?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('approve')),expression:"actionDisabledReason('approve')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.envelopeActionDisabled('approve')},on:{"success":_vm.refresh,"click":function($event){_vm.showApproveDialog = true}}},[_vm._v("\n        Approve\n      ")]):_vm._e(),_vm._v(" "),(_vm.showRejectButton)?_c('RejectEnvelope',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('reject')),expression:"actionDisabledReason('reject')"}],attrs:{"disabled":_vm.envelopeActionDisabled('reject'),"envelope":_vm.envelope,"selected-rows":_vm.selectedRows},on:{"success":_vm.refresh}}):_vm._e(),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('createAPFile')),expression:"actionDisabledReason('createAPFile')"}],attrs:{"button-class":"btn btn-actionbar","disabled":_vm.envelopeActionDisabled('createAPFile')},on:{"click":_vm.createAPFile}},[_vm._v("\n        CREATE AP FILE\n      ")]),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('exportEnvelope')),expression:"actionDisabledReason('exportEnvelope')"}],attrs:{"button-class":"btn btn-actionbar","disabled":_vm.envelopeActionDisabled('exportEnvelope')},on:{"click":_vm.exportEnvelope}},[_vm._v("\n        EXPORT ENVELOPE\n      ")]),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.loadingAccountSettings || _vm.actionDisabledReason('pushToAccountingSystemAction')),expression:"loadingAccountSettings || actionDisabledReason('pushToAccountingSystemAction')"}],attrs:{"button-class":"btn btn-actionbar","disabled":_vm.loadingAccountSettings || _vm.envelopeActionDisabled('pushToAccountingSystemAction')},on:{"click":_vm.pushToAccountingSystem}},[_vm._v("\n        PUSH TO PSL+\n      ")]),_vm._v(" "),_c('AddTransactionNumber',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('addTransactionNumber')),expression:"actionDisabledReason('addTransactionNumber')"}],attrs:{"selected-rows":_vm.selectedRows,"disabled":_vm.envelopeActionDisabled('addTransactionNumber')},on:{"success":_vm.refresh}})],1),_vm._v(" "),_c('span',{staticClass:"form-group no-margin",attrs:{"slot":"additionalLabel"},slot:"additionalLabel"},[_c('i',{staticClass:"fas fa-exclamation"}),_vm._v(" "),_c('span',[_vm._v(" ")]),_vm._v(" "),_c('label',[_vm._v("Click column headers to apply filters")])])]):_vm._e(),_vm._v(" "),(_vm.showCreateEnvelope)?_c('CreateEnvelope',{attrs:{"title":_vm.createEnvelopeTitle,"editEnvelope":true,"envelope":_vm.envelope},on:{"success":function($event){_vm.showCreateEnvelope=!_vm.showCreateEnvelope; _vm.updateUrlBackToEnvelopesPage(); _vm.envelope = {}},"backToTransactions":function($event){_vm.showCreateEnvelope=!_vm.showCreateEnvelope; _vm.updateUrlBackToEnvelopesPage(); _vm.envelope = {}}}}):_vm._e(),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Approval Needed","show":_vm.showApprovalUsers,"primary-button":"Close","secondary-button":"false"},on:{"close":function($event){_vm.showApprovalUsers = false}}},[_c('ApprovalNeededUsers',{attrs:{"slot":"body","approvalUsersData":_vm.approvalUsersData},slot:"body"})],1),_vm._v(" "),_c('ApproveDialog',{attrs:{"showModal":_vm.showApproveDialog,"list":_vm.transformRows(_vm.selectedRows),"programLabel":_vm.programLabel,"loading":_vm.isApproving,"envelopeApproval":""},on:{"approve":_vm.doApprove,"close":function () { _vm.showApproveDialog = false }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QTCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_lang__ = __webpack_require__("pe4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__ = __webpack_require__("HMpe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listIcons__ = __webpack_require__("E7hm");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['init'],
  beforeCreate: function beforeCreate() {
    this.api = global.app.api;
  },
  data: function data() {
    return {
      options: [],
      test: '',
      formattedList: null,
      text: '',
      columnTitle: '',
      errorMessage: ''
    };
  },
  computed: {
    filteredOptions: function filteredOptions() {
      var _this = this;
      if (!this.params.editMode) this.$nextTick(this.updateScroll);
      if (this.options) {
        var ddOpt = this.options.filter(function (option) {
          if (_this.text !== '' && _this.text.trim() !== '' && _this.text !== null) {
            (option.label || option.text || option.name).toLowerCase().includes(_this.text.toLowerCase()) ? option.hide = false : option.hide = true;
          } else {
            option.hide = false;
          }
          if (!_this.params.editMode) {
            option.isDisabled = false;
          }
          return true;
        }).filter(function (o) {
          return !o.hasOwnProperty('hide') || o.hasOwnProperty('hide') && o.hide === false;
        });
        return ddOpt.slice(0, 500);
      }
    }
  },
  created: function created() {
    this.params = this.params || this.init;
    var column = this.params.colDef;
    this.columnTitle = column.headerName;
    this.init && this.fetchOptions();
    this.$on('showDetails', this.showDetails);
  },
  mounted: function mounted() {
    //
  },
  methods: {
    showDetails: function showDetails(e) {
      if (e) {
        this.afterGuiAttached();
      }
    },
    afterGuiAttached: function afterGuiAttached() {
      var _this2 = this;
      this.fetchOptions();
      // if (!this.params.editMode) {
      var viewport = this.$el.querySelector('.list');
      this.ps || setTimeout(function () {
        return _this2.ps = new __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__["a" /* default */](viewport, {
          minScrollbarLength: 20
        });
      });
      // }
    },
    t: function t(key) {
      return __WEBPACK_IMPORTED_MODULE_1__lang_lang__["a" /* i18n */].t(key);
    },
    clearOptions: function clearOptions(key) {
      return (key.status = false) && 0 || key;
    },
    getModel: function getModel() {
      // this.text = ''
      return {
        filter: this.formattedList || this.text
      };
    },
    setModel: function setModel(model) {
      if (model && model.filter) {
        // this.text = model.filter
        this.formattedList = model.filter;
      }
      if (model === null) {
        this.text = '';
        this.formattedList = null;
        this.options.forEach(function (option) {
          return option.status = false;
        });
      }
    },
    isFilterActive: function isFilterActive() {
      return this.text !== null && this.text !== undefined && this.text !== '' || this.formattedList && this.formattedList.length;
    },
    isActiveOption: function isActiveOption(option) {
      return this.formattedList.split('_').indexOf(option.label) > -1;
    },
    fetchOptions: function fetchOptions() {
      var _this3 = this;
      var list = this;
      var column = this.params.colDef;
      var options = [];
      if (column.options && column.options.length) {
        this.options = this.params.editMode ? column.options : column.options.map(typeof column.closeFilter === 'undefined' ? this.clearOptions : function (k) {
          return k;
        });
        this.options = this.options.map(function (option) {
          return _objectSpread(_objectSpread({}, option), {}, {
            label: option.text || option.name || option.Value || option.label || ''
          });
        });

        //
        this.options.forEach(function (option) {
          if (_this3.formattedList) {
            option.status = _this3.isActiveOption(option);
          }
        });
      } else {
        //
        // Fetch the options from the api
        //
        this.api.forms.post(this.api.$.common.optionsFilter, {
          grid: column.source,
          item: column.field
        }).then(function (r) {
          if (r) {
            var html = r.data.html;
            var $list = global.jQuery(html).find('li label');
            $list.filter(function (k, v) {
              return options.push({
                icon: v.getAttribute('data-icon') || (__WEBPACK_IMPORTED_MODULE_3__listIcons__["a" /* default */][v.innerHTML] || {}).icon,
                iconColor: v.getAttribute('data-color') || (__WEBPACK_IMPORTED_MODULE_3__listIcons__["a" /* default */][v.innerHTML] || {}).color,
                label: v.innerHTML,
                status: list.params.editMode ? v.innerHTML === list.params.value : _this3.getModel().filter ? _this3.isActiveOption({
                  label: v.innerHTML
                }) : false
              });
            });
            _this3.options = options;
            column.options = options;
          } else {
            list.errorMessage = 'Try again later';
          }
        });
      }
    },
    getOptions: function getOptions() {
      return this.options.filter(function (option) {
        return option.status;
      }).map(function (option) {
        return option.label;
      }).join('_');
    },
    doesFilterPass: function doesFilterPass(params) {
      var _this4 = this;
      return this.formattedList.split('_').filter(function (option) {
        return option.toLowerCase() === params.data[_this4.params.column.colId].toLowerCase();
      }).length;
    },
    apply: function apply() {
      this.formattedList = this.getOptions();
      this.params.filterChangedCallback();
    },
    clear: function clear() {
      this.setModel(null);
    },
    updateScroll: function updateScroll() {
      this.ps && this.ps.update();
    },
    // edit
    click: function click(e) {
      this.$emit('click', e);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "QW1W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1-WTDwjxwe1dC5--Ju2Xl0","Dell":"_2ai04wqLLhwOnHKKPVXdg-","Abbott":"_1ZAlDDUENftccRkI8soQ0G","Gap":"wn8qfvyjA7MA2GsDmTfm5","Allstate":"CG8fckuV0zmVv9TQiWl4S","Asurion":"_2a72X2FiTmioA-rgN7wsJv","Invitae":"_1eY1X3cG3GvHWk2IrBiBVY","JWE":"XwJHwJJCSCtDtXNlzrxj5"};

/***/ }),

/***/ "QYmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-tab"},[(!_vm.hasTabSlot)?_c('nav-tabs',{attrs:{"tabs":_vm.tabs},on:{"onTabClick":_vm.onTabClick}}):_vm._e(),_vm._t("tab"),_c('div',{staticClass:"tab-content"},[(!_vm.hasTabContent)?_vm._t("default"):_vm._e(),_vm._t("content")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QZqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading-indicators',
  install: function install(Vue) {
    /** Set global loading indicator */
    Object.defineProperty(Vue.prototype, '$loading', {
      get: function get() {
        return this.$root.loading;
      },
      set: function set(value) {
        this.$root.loading = value;
      }
    });

    /** Set global mask */
    Object.defineProperty(Vue.prototype, 'masked', {
      get: function get() {
        return this.$root.masked;
      },
      set: function set(value) {
        this.$root.masked = value;
      }
    });
  },
  /**
   * Hooks for loading indicators
   *
   */
  hook: {
    start: function start(request) {
      var spots = [];
      if (request && request.url) {
        var url = request.url.replace('{ENV}', '');
        url = url.split('?')[0];
        spots = global.jQuery("[endpoint=\"".concat(url, "\"]"));
      }
      if (spots.length) {
        spots.addClass('loading');
      } else {
        ;
        ((this.$loading ? this : null) || global.app).$loading = true;
      }
    },
    stop: function stop(response) {
      var url = '';
      ((this.$loading ? this : null) || global.app).$loading = false;
      if (response && response.config.url) {
        global.jQuery("[endpoint^=\"".concat(response.config.url, "\"]")).removeClass('loading');
        url = response.config.url.replace(response.config.baseURL, '').replace("://".concat(global.app.api._env), '://').replace("//".concat(global.app.api._env), '//').replace(~global.app.api.env.indexOf('//evedonline') ? /\/\/evedonline\./ : /\/\/(.+)evedonline\./, '//local.evedonline.');
        url = url.split('?')[0];
        global.jQuery("[endpoint^=\"".concat(url, "\"]")).removeClass('loading');
      } else {
        if (response && response.request.responseURL) {
          global.jQuery("[endpoint^=\"".concat(response.request.responseURL, "\"]")).removeClass('loading');
          url = response.request.responseURL.replace(response.config.baseURL, '').replace(/\/\/(.+)evedonline\./, ~global.app.api.env.indexOf('//evedonline') ? '//evedonline.' : '//local.evedonline.');
          global.jQuery("[endpoint^=\"".concat(url, "\"]")).removeClass('loading');
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "QeL4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/logo-dark.4cbd62e.jpg";

/***/ }),

/***/ "Qnfj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.switchAccountAfterLogin)?_c('layout',{staticClass:"layout"}):_vm._e(),_vm._v(" "),_c('ed-modal',{class:['accounts-modal', !_vm.switchAccountAfterLogin ? 'not-on-top' : ''],attrs:{"show":_vm.hasAccounts,"title":"","primaryButton":"false","secondaryButton":"false","close-on-click-away":""},on:{"close":_vm.closeAccountsModal}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[(_vm.switchAccountAfterLogin)?_c('h3',{staticClass:"title text-center"},[_vm._v("You’re signed in.")]):_c('h3',{staticClass:"title text-center"},[_vm._v("Switch Accounts")]),_vm._v(" "),_c('p',{staticClass:"text text-center"},[_vm._v(_vm._s(_vm.currentEmail))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("You have multiple accounts with this email address. Select the account you would like to access.")]),_vm._v(" "),_c('ed-input',{staticClass:"search",attrs:{"placeholder":_vm.$t("Search Accounts"),"search-box":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('ul',{staticClass:"list"},_vm._l((_vm.filteredAccounts),function(account){return _c('li',{staticClass:"item list form-group",class:{ disabled: _vm.accountToBeSet && _vm.accountToBeSet !== account.id },attrs:{"endpoint":_vm.accountToBeSet === account.id ? _vm.api.$.settings.my.switch : undefined},on:{"click":function($event){_vm.setAccount(account); _vm.switchAccount(account)}}},[_c('p',[_vm._v(_vm._s(account.name))]),_vm._v(" "),_c('span',[(account.name === _vm.currentCompany)?_c('i',{staticClass:"far fa-check pull-right"}):_vm._e()])])}),0)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QsJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Log In Securely')))]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.$t('To log in to your Eved account, you will need to set up multifactor authentication'))+".")]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.$t('You will be sent a code each time you log in from a new device'))+".")]),_vm._v(" "),_c('form',{staticClass:"form",attrs:{"autocomplete":"false"},on:{"submit":function($event){$event.preventDefault();return _vm.setupMfa.apply(null, arguments)}}},[_c('div',{},[_c('ed-radio',{attrs:{"name":"mfa-option","field-label":_vm.$t('How would you like to receive your code?'),"options":_vm.mfaOptions,"track-by":"id"},model:{value:(_vm.mfaOption),callback:function ($$v) {_vm.mfaOption=$$v},expression:"mfaOption"}},[_c('div',{staticClass:"row col-md10",attrs:{"slot":"phoneNumber"},slot:"phoneNumber"},[_c('em',{staticClass:"small"},[_vm._v("\n            "+_vm._s(_vm.$t('Provide your phone number below'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"phoneInput"},[_c('vue-country-code',{staticClass:"dropdown",attrs:{"disabled":!_vm.mfaOption || _vm.mfaOption.preference !== 'SMS_MFA',"disabledFetchingCountry":true,"enabledCountryCode":true,"preferredCountries":['us', 'gb', 'cn']},on:{"onSelect":_vm.onCountrySelect}}),_vm._v(" "),_c('ed-input',{attrs:{"disabled":!_vm.mfaOption || _vm.mfaOption.preference !== 'SMS_MFA',"maxlength":"26","error":!_vm.validMfaSetup.phoneNumber && !_vm.phone.number},on:{"change":_vm.updatePhone},model:{value:(_vm.phone.number),callback:function ($$v) {_vm.$set(_vm.phone, "number", $$v)},expression:"phone.number"}}),_vm._v(" "),_c('div',{staticClass:"phoneHint"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.mfaOption && _vm.mfaOption.preference === 'SMS_MFA' && !_vm.isVerificationSuccessful),expression:"mfaOption && mfaOption.preference === 'SMS_MFA' && !isVerificationSuccessful"}],staticClass:"notVerified",attrs:{"title":"Phone number is not verified, click next to verify"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.mfaOption && _vm.mfaOption.preference === 'SMS_MFA' && _vm.isVerificationSuccessful),expression:"mfaOption && mfaOption.preference === 'SMS_MFA' && isVerificationSuccessful"}],staticClass:"Verified",attrs:{"title":"Phone number was verified, click next to login"}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('ed-button',{staticClass:"alt",attrs:{"button-class":"btn btn-secondary","type":"button","value":"cancel"},on:{"click":_vm.cancel}},[_vm._v("\n        "+_vm._s(_vm.$t('Cancel'))+"\n      ")]),_vm._v("\n       \n      "),_c('ed-button',{attrs:{"button-class":"btn btn-primary","type":"submit","value":"next","disabled":!_vm.mfaOption}},[_vm._v("\n        "+_vm._s(_vm.$t('Next'))+"\n      ")])],1)]),_vm._v(" "),_c('ed-modal',{ref:"CHECK_EMAIL_CODE",attrs:{"title":"","type":"small"},on:{"close":function($event){_vm.$refs['CHECK_EMAIL_CODE'].show = false}}},[_c('div',{attrs:{"slot":"footer"},slot:"footer"}),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Please enter the code received via e-mail")]),_vm._v(" "),_c('ed-input',{model:{value:(_vm.mfaChallenge.code),callback:function ($$v) {_vm.$set(_vm.mfaChallenge, "code", $$v)},expression:"mfaChallenge.code"}}),_vm._v(" "),_c('ed-button',{on:{"click":_vm.verifySetup}},[_vm._v(_vm._s(_vm.$t('Verify')))])],1)]),_vm._v(" "),_c('ed-modal',{ref:"CHECK_SMS_CODE",attrs:{"title":"","type":"small"},on:{"close":function($event){_vm.$refs['CHECK_SMS_CODE'].show = false}}},[_c('div',{attrs:{"slot":"footer"},slot:"footer"}),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Please enter the code received via SMS")]),_vm._v(" "),_c('ed-input',{model:{value:(_vm.mfaChallenge.code),callback:function ($$v) {_vm.$set(_vm.mfaChallenge, "code", $$v)},expression:"mfaChallenge.code"}}),_vm._v(" "),_c('ed-button',{on:{"click":_vm.verifySetup}},[_vm._v(_vm._s(_vm.$t('Verify')))])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QtZ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    disabled: Boolean,
    ids: Array
  },
  data: function data() {
    return {
      showModal: false
    };
  },
  computed: {
    id: function id() {
      return this.ids[0] && this.ids[0].data.PaymentInvoiceID;
    },
    name: function name() {
      return this.ids[0] && this.ids[0].data.InvoiceNumber;
    }
  },
  created: function created() {
    //
  },
  methods: {
    validateCancelInvoice: function validateCancelInvoice() {
      var _this = this;
      this.api.forms.post(this.api.$.invoice.list.canCancelInvoice, {
        id: this.id
      }).then(function (result) {
        if (result && result.data) {
          if (result.data.Errors && result.data.Errors.length) {
            alert(result.data.Errors[0].Message);
          } else {
            _this.showModal = true;
          }
        }
      });
    },
    cancelInvoice: function cancelInvoice() {
      var _this2 = this;
      this.api.forms.post(this.api.$.invoice.list.cancelInvoice, {
        id: this.id
      }).then(function (result) {
        if (result && result.data && result.data.SuccessMessage === 'Success') {
          _this2.$notifications.notify({
            message: "You have successfully cancelled invoice ".concat(_this2.ids[0].data.InvoiceNumber),
            type: 'info',
            placement: {
              from: 'top',
              align: 'center'
            }
          });
          _this2.$emit('success', _this2.ids[0].data);
        }
      });
    }
  }
});

/***/ }),

/***/ "QuRR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_tab_vue__ = __webpack_require__("E2Ix");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3cc591_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nav_tab_vue__ = __webpack_require__("Fepw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_tab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3cc591_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nav_tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qy6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__("NM/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Supplier_vue__ = __webpack_require__("Xi8K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dialogs_InviteSupplierDialog_vue__ = __webpack_require__("hWew");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dialogs_AddEditSupplier_vue__ = __webpack_require__("hVxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RequestRushPayment_vue__ = __webpack_require__("zseC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AllocationSection_vue__ = __webpack_require__("7XmN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_programBudget__ = __webpack_require__("MXIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__core_events_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_components_Form_customFields_vue__ = __webpack_require__("eFeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api__ = __webpack_require__("lQbo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_he__ = __webpack_require__("t02m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__models_program_constants__ = __webpack_require__("mo7C");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var api = new __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */]();

// import debounce from 'lodash/debounce'


var eventHub = new __WEBPACK_IMPORTED_MODULE_9_vue__["default"]();
var FIELDS = {
  SupplierInvoiceNumber: 'SupplierInvoiceNumber'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'invoiceInformation',
  props: {
    model: Object,
    divisionLabel: String,
    purchaseOrderForBillTo: String,
    settings: Object,
    user: Object,
    useHighLevelAllocation: Boolean,
    maxInvoiceAmount: Number,
    initialInvoiceAmount: [Number, String]
  },
  components: {
    supplier: __WEBPACK_IMPORTED_MODULE_3__Supplier_vue__["a" /* default */],
    allocationSection: __WEBPACK_IMPORTED_MODULE_7__AllocationSection_vue__["a" /* default */],
    ProgramBudget: __WEBPACK_IMPORTED_MODULE_8__components_programBudget__["a" /* default */],
    customFields: __WEBPACK_IMPORTED_MODULE_12__core_components_Form_customFields_vue__["default"]
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.MAP_INVOICE_INFORMATION_FIELDS);
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.MAP_INVOICE_INFORMATION_FIELDS, function (e) {
      _this.mapExistingItems();
    });
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.MAP_DEFAULT_PAYMENT_TYPE_DISCOUNT);
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.MAP_DEFAULT_PAYMENT_TYPE_DISCOUNT, function (e) {
      _this.mapExistingPaymentTypeAndDiscount(e);
    });
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$off('disableSupplier');
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$on('disableSupplier', this.disableSupplier);
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$off('closeRushPayment');
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$on('closeRushPayment', this.onCloseRushPaymentDialog);
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$off('saveRushPayment');
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$on('saveRushPayment', this.onSaveRushPaymentDialog);
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.CONFIRM_PROGRAM_SELECTED);
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.CONFIRM_PROGRAM_SELECTED, this.confirmProgramSelected);
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.PO_AMOUNT_CHANGED);
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.PO_AMOUNT_CHANGED, this.onPOAmountChanged);
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.UPDATE_PO_MODEL_COMPLETED);
    __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.UPDATE_PO_MODEL_COMPLETED, this.continueSelectPurchaseOrder);
    this.he = __WEBPACK_IMPORTED_MODULE_14_he___default.a;
    this.purchaseOrderFromInitParsed = this.parsePO(this.purchaseOrderForBillTo);
  },
  data: function data() {
    return {
      FIELDS: FIELDS,
      title: '',
      attachedFiles: null,
      program: null,
      previousProgram: {},
      previousInvoiceWorkflow: '',
      programDetails: null,
      programs: [],
      originalPrograms: [],
      showConfirmProgramSelected: false,
      programCurrencyCode: 'USD',
      paymentType: null,
      paymentTypes: [],
      discount: null,
      discounts: [{
        key: 0,
        value: 'No Discount',
        name: 'No Discount',
        daysNo: 0
      }],
      currency: null,
      currencies: [],
      puchaseOrder: null,
      invoiceDate: this.model.InvoiceDate ? this.setDate(this.model.InvoiceDate) : this.model.InvoiceDate,
      dueDate: this.model.InvoiceDate ? this.setDueDate(this.model.InvoiceDate, this.paymentTermsDays) : this.model.DueDate,
      disableAddSupplier: false,
      addOutofNetworkSuppliersPermission: this.user.hasAddOutofNetworkSuppliersPerm,
      dateFormat: this.user.dateFormat,
      paymentTermsDays: this.settings.CompanySettings.DaysNo,
      uploadData: {
        token: this.user.token
      },
      oneDay: 24 * 60 * 60 * 1000,
      // hours*minutes*seconds*milliseconds
      rushDays: {
        RushPaymentTermsDays: null,
        StandardRushPaymentDays: null,
        DaysEarlier: null,
        HasDiscountedPaymentTerm: false
      },
      showUploadError: false,
      uploadFinished: true,
      errorMessages: [],
      purchaseOrder: null,
      purchaseOrderFromInitParsed: this.parsePO(this.purchaseOrderForBillTo),
      purchaseOrders: [],
      originalPurchaseOrders: [],
      notInvoicedAmount: null,
      templateNotInvoicedAmount: null,
      invoiceAmountHelptipHeader: '',
      P2PisNotMapped: true,
      sameDayDepositOption: [{
        label: utils.constants.invoice.SameDayLabel + ' Deposit Payment Requested',
        status: this.model.IsSameDayDeposit
      }],
      reimbursementOption: [{
        label: 'Is this a reimbursement?',
        status: this.model.IsReimbursement
      }],
      disabledSameDayDepositCheck: this.model.isEditInit && this.model.TotalPaidAmount !== 0,
      disabledPaymentType: this.model.isEditInit && this.model.IsSameDayDeposit && this.model.TotalPaidAmount !== 0,
      showDiscountDueDateValidationError: false,
      dueDateToValidate: null,
      isInitSupplier: false,
      programLabel: global.app.$user.sessionSettings.CompanySettings.ProgramLabel,
      selectedPO: {},
      programBudgetData: [[]],
      customFieldsLoaded: false,
      cFields: 0,
      excludeVATFromBudget: null
    };
  },
  computed: {
    billToAddress: function billToAddress() {
      if (this.purchaseOrderFromInitParsed) {
        return this.purchaseOrderFromInitParsed.billTo;
      }
    },
    programBudgetTitle: function programBudgetTitle() {
      return this.programLabel + ' Budget'; // Program Budget
    },
    // SPRT-18874: the cancelled block wins over "please select" — a program IS selected, it just cannot
    // be invoiced against.
    programSelectErrorMessage: function programSelectErrorMessage() {
      if (this.model.Errors.ProgramCancelled) return __WEBPACK_IMPORTED_MODULE_15__models_program_constants__["a" /* default */].cancelledProgramMessage;
      if (this.model.Errors.ProgramMissing) return 'Please select a ' + this.programLabel + '.';
      return '';
    },
    changeProgramMessage: function changeProgramMessage() {
      return this.useHighLevelAllocation ? 'Changing the ' + this.programLabel + ' will delete all the allocations you have built in this invoice. Are you sure you want to change the ' + this.programLabel.toLowerCase() + '?' : 'Changing the ' + this.programLabel + ' will delete all the line items you have built in this invoice. Are you sure you want to change the ' + this.programLabel.toLowerCase() + '?';
    },
    getDatepickerShortcuts: function getDatepickerShortcuts() {
      return !this.settings.CompanySettings.EditingInvoiceScan ? [{
        key: 'today',
        label: 'Today'
      }, {
        key: 'yesterday',
        label: 'Yesterday'
      }] : [];
    },
    currencySelected: function currencySelected() {
      return this.currency && this.currency.Value !== '' && this.currency.Key !== 0;
    },
    purchaseOrderSelected: function purchaseOrderSelected() {
      return !(this.model.InvoiceWorkflow && this.model.InvoiceWorkflow.indexOf('P2PInvoice') !== -1) || this.purchaseOrder && !isNaN(parseInt(this.purchaseOrder.Key));
    },
    disableAmounts: function disableAmounts() {
      return !this.currencySelected || !this.purchaseOrderSelected;
    },
    isP2PInvoiceWithAddTaxesAndEditItems: function isP2PInvoiceWithAddTaxesAndEditItems() {
      return this.isP2PInvoice && this.settings.CompanySettings.AllowEditItem;
    },
    userHasBothTypeOfDivisions: function userHasBothTypeOfDivisions() {
      return this.user.workflowTypeStatus === 'Both';
    },
    amountConditionalPlaceholder: function amountConditionalPlaceholder() {
      if (!this.disableAmounts) {
        return '';
      } else {
        return this.isP2PInvoice ? 'Please select PO first' : 'Please select Invoice Currency first';
      }
    },
    isP2PInvoice: function isP2PInvoice() {
      return this.model.InvoiceWorkflow && this.model.InvoiceWorkflow.indexOf('P2PInvoice') !== -1 || this.userHasJustP2PDivisions;
    },
    // use instead of this.useHighLevelAllocation
    isHighLevelAllocation: function isHighLevelAllocation() {
      return this.model.InvoiceWorkflow && this.model.InvoiceWorkflow.indexOf('I2PWithHighLevelAllocation') !== -1;
    },
    userHasJustP2PDivisions: function userHasJustP2PDivisions() {
      return this.user.WorkflowTypeStatus === ''; /* Only P2P divisions */
    },
    invoiceAmountHelptipBody: function invoiceAmountHelptipBody() {
      if (this.model.Errors.InvoiceAmountMissing || this.model.Errors.InitialTotalAmountMissing) {
        return 'Please fill in an Invoice Amount.';
      } else {
        if (this.model.Errors.InvoiceAmountOutOfRange) {
          if (this.notInvoicedAmount === 0) {
            this.templateNotInvoicedAmount = this.maxInvoiceAmount;
            if (this.templateNotInvoicedAmount >= 0) {
              return 'Invoice Amount must be less than: ';
            } else {
              return 'Invoice Amount must be greater than: ';
            }
          } else if (this.notInvoicedAmount > 0) {
            if (this.model.InvoiceAmount > this.maxInvoiceAmount) {
              this.templateNotInvoicedAmount = this.maxInvoiceAmount;
              return 'Invoice Amount must be less than: ';
            }
            if (this.model.InvoiceAmount < 0) {
              this.templateNotInvoicedAmount = 0;
              return 'Invoice Amount must be greater than: ';
            }
          } else if (this.notInvoicedAmount < 0) {
            if (this.model.InvoiceAmount > 0) {
              this.templateNotInvoicedAmount = 0;
              return 'Invoice Amount must be less than: ';
            }
            if (this.model.InvoiceAmount < this.maxInvoiceAmount) {
              this.templateNotInvoicedAmount = this.maxInvoiceAmount;
              return 'Invoice Amount must be greater than: ';
            }
          }
        } else {
          if (this.model.Errors.InvoiceAmountNegative) {
            return 'Negative amounts are not allowed for ' + utils.constants.invoice.SameDayLabel.toLowerCase() + ' deposit invoices.';
          }
        }
      }
      return '';
    },
    invoiceAmountLabel: function invoiceAmountLabel() {
      return 'Invoice Amount (Including VAT/GST if applicable)';
    },
    invoiceError: function invoiceError() {
      return this.model.Errors.InvoiceAmountOutOfRange || this.model.Errors.InvoiceAmountMissing || this.model.Errors.InvoiceAmountNegative || this.model.Errors.InitialTotalAmountMissing;
    },
    disablePO: function disablePO() {
      return this.isP2PInvoice && this.model.POid > 0 && (this.invoiceIsSaved() || this.getInvoiceId > 0 || this.$route.query.fusionPoId > 0);
    },
    showSameDayDepositCheck: function showSameDayDepositCheck() {
      return this.settings.CompanySettings.AllowSameDayDeposit;
    },
    sameDayText: function sameDayText() {
      return this.model.IsSameDayDeposit ? utils.constants.invoice.SameDayLabel + ' ' : '';
    },
    getInvoiceId: function getInvoiceId() {
      return this.$route.query.invoiceId;
    },
    showNeddedFieldsForScanning: function showNeddedFieldsForScanning() {
      return !this.isHighLevelAllocation && !this.isP2PInvoice && this.settings.CompanySettings.AllowInvoiceScanning === true && this.settings.CompanySettings.EditingInvoiceScan === false && (this.isCreateInvoice() || this.model.IsDraft);
    },
    isVatGstRequired: function isVatGstRequired() {
      return this.showNeddedFieldsForScanning && this.excludeVATFromBudget === true;
    },
    showAllocationSection: function showAllocationSection() {
      return this.useHighLevelAllocation === false && this.settings.CompanySettings.AllowInvoiceScanning === true;
    },
    description: function description() {
      var defaultMessage = "Specify your supplier's invoice information below and click Submit when complete.";
      if (this.settings.CompanySettings.EditingInvoiceScan) {
        defaultMessage = 'The planner entered this information when submitting the invoice.';
      }
      if (this.settings.CompanySettings.AllowInvoiceScanning && this.model.ProgramID > 0 && !this.isP2PInvoice && !this.useHighLevelAllocation) {
        defaultMessage += " The line items from the upload will be captured and processed within 1 business day, " + "and you will receive an email when the invoice is ready for approval.";
      }
      return defaultMessage;
    },
    uploadFieldName: function uploadFieldName() {
      return this.settings.CompanySettings.EditingInvoiceScan ? 'Supplier Invoice' : 'Attach Invoice';
    },
    showPaymentTerm: function showPaymentTerm() {
      return this.settings.CompanySettings.UseDiscounts && !this.useHighLevelAllocation && (!this.isP2PInvoice || this.isP2PInvoice && this.model.DiscountPaymentTermID > 0);
    },
    disabledPaymentTerm: function disabledPaymentTerm() {
      return this.isP2PInvoice || this.model.isEditInit && this.model.TotalPaidAmount !== 0;
    },
    getDueDateDifferenceInDays: function getDueDateDifferenceInDays() {
      if (this.dueDateToValidate !== null) {
        return this.getDatesDifferenceInDays(this.model.InvoiceDate, this.dueDateToValidate);
      }
      return 0;
    },
    getDescription: function getDescription() {
      return this.model.Description || 'None';
    },
    showField: function showField() {
      var _this2 = this;
      return function (name) {
        return _this2.customFieldsLoaded && !_this2.$refs.customFieldsRef.hideField(name);
      };
    }
  },
  methods: {
    parsePO: function parsePO(purchaseOrderForBillTo) {
      if (!purchaseOrderForBillTo) {
        return '';
      }
      return JSON.parse(purchaseOrderForBillTo);
    },
    singularize: function singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value;
    },
    handleZipCodeChange: function handleZipCodeChange() {
      this.model.Errors.SupplierZipCodeMissing = false;
      this.$emit('supplier-zip-code-changed', this.model.SupplierZipCode);
    },
    onDescriptionChanged: function onDescriptionChanged(e) {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.model.Description = e;
      });
    },
    createAttachments: function createAttachments(e) {
      var _this4 = this;
      var completedFiles = e.filter(function (item) {
        return item.success ||
        // files uploaded with success
        !item.success && item.response && typeof item.response === 'string' && !_this4.isJson(item.response);
      } // files where requested failed
      );
      if (completedFiles.length >= 1) {
        this.model.Errors.AttachmentsMissing = false;
      }
      if (completedFiles.length === e.length) {
        this.uploadFinished = true;
        var attachments = e.map(function (item) {
          var uploadError = '';
          var itemResponse = null;
          if (item.success && item.response) {
            itemResponse = JSON.parse(item.response);
            uploadError = itemResponse && itemResponse.uploadError ? itemResponse.uploadError : '';
          }
          if (!item.success) {
            uploadError = 'Upload request failed';
          }
          if (uploadError) {
            _this4.errorMessages.push('File "' + item.name + '": ' + uploadError);
          } else {
            return {
              AttachmentName: item.name,
              AttachmentSize: item.size,
              AttachmentFile: itemResponse ? itemResponse.file : item.file || '',
              AttachmentId: item.id || 0,
              AttachmentPath: itemResponse ? itemResponse.path : '',
              ReadOnly: item.readonly || false
            };
          }
        });
        this.showUploadError = this.errorMessages.length > 0;
        try {
          this.attachedFiles = this.attachedFiles.filter(function (item) {
            return item.success && (!item.response && item.name ||
            // take existing items from edit
            JSON.parse(item.response).success // take new added items
            );
          });
        } catch (ee) {
          console.log(ee);
        }
        attachments = attachments.filter(function (item) {
          return item;
        });
        this.model.Attachments = attachments.map(function (item) {
          if (isNaN(item.AttachmentId)) {
            item.AttachmentId = 0;
          }
          return item;
        });
      } else {
        this.uploadFinished = false;
      }
    },
    isJson: function isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    cloneUploadError: function cloneUploadError() {
      this.showUploadError = false;
      this.errorMessages = [];
    },
    setDate: function setDate(date) {
      var d = new Date(date);
      // WFSPRT-634: timezone fix
      if (global.moment(date).format('MM/DD/YYYY') !== global.moment(d).format('MM/DD/YYYY') && d.getTimezoneOffset() !== 0) {
        d = new Date(d.getTime() + d.getTimezoneOffset() * 60000);
      }
      return d;
    },
    onSupplierSelected: function onSupplierSelected(e) {
      // on init due date should not be changed
      this.isInitSupplier = e.IsInitSupplier || false;
      this.updateDueDateOnSelectSupplier(e.SupplierInfoVM.SupplierId);
      this.setDiscountWithDefaultFromSupplier(e.SupplierInfoVM);
      if (this.showSameDayDepositCheck) {
        this.resetSameDayDepositOption(!this.model.IsDraft && typeof this.model.IsSameDayDeposit !== 'undefined' ? this.model.IsSameDayDeposit : e.SupplierInfoVM.Supplier.HasDefaultImmediatePayment);
      }

      // reset
      this.isInitSupplier = false;

      // pass event to parent
      this.$emit('supplierSelected', e);
    },
    setEmptyDiscount: function setEmptyDiscount() {
      this.discount = {
        Key: 0,
        Value: 'No Discount',
        Name: 'No Discount',
        DaysNo: this.settings.CompanySettings.DefaultDaysNo
      };
    },
    setDiscountWithDefaultFromSupplier: function setDiscountWithDefaultFromSupplier(info) {
      if (info.DiscountPaymentTermID > 0) {
        this.discount = {
          Key: info.DiscountPaymentTermID,
          Value: info.DiscountDisplayName,
          Name: info.DiscountName,
          DaysNo: info.DaysNo
        };
      } else {
        this.setEmptyDiscount();
      }
      this.updateDiscountAndDueDate(this.discount.Key, this.discount.Name, this.discount.DaysNo, true);
    },
    onSupplierRemoved: function onSupplierRemoved(e) {
      this.paymentTermsDays = this.settings.CompanySettings.DefaultDaysNo;
      this.setEmptyDiscount();
      this.updateDueDate(this.model.InvoiceDate, this.paymentTermsDays);
      this.resetSameDayDepositOption();

      // pass data to parent (index.vue)
      this.$emit('supplierRemoved', e);
    },
    disableSupplier: function disableSupplier(e) {
      this.disableAddSupplier = e.data;
    },
    isCreateInvoice: function isCreateInvoice() {
      return parseInt(this.$route.query.invoiceId) <= 0 || isNaN(parseInt(this.$route.query.invoiceId));
    },
    mapExistingItems: function mapExistingItems() {
      this.notInvoicedAmount = this.model.NotInvoicedAmount;
      this.mapExistingProgram();
      this.mapExistingCurrency();
      this.mapExistingPaymentType();
      this.mapExistingDiscount();
      this.mapExistingDateFields();
      this.mapExistingAttachments();
      if (this.isP2PInvoice) {
        this.mapExistingPOs();
      }
    },
    mapExistingPaymentTypeAndDiscount: function mapExistingPaymentTypeAndDiscount(e) {
      if (e && e.data) {
        this.paymentTypes = e.data.paymentTypes;
        this.discounts = e.data.discounts;
      }
      this.mapExistingPaymentType();
      this.mapExistingDiscount();
    },
    mapExistingProgram: function mapExistingProgram() {
      if (this.model) {
        this.program = {
          Key: this.model.ProgramID,
          Value: {
            ProgramName: __WEBPACK_IMPORTED_MODULE_14_he___default.a.decode(this.model.ProgramName),
            InternalProgramId: this.model.InternalProgramId ? __WEBPACK_IMPORTED_MODULE_14_he___default.a.decode(this.model.InternalProgramId) : '',
            DivisionId: this.model.DivisionID
          }
        };
        this.programCurrencyCode = this.model.ProgramCurrencyCode;
        this.loadRemainingProgramBudget(this.model.ProgramID);
        if (this.isP2PInvoice) {
          if (this.model.POid > 0) {
            this.P2PisNotMapped = false;
          } else if (this.P2PisNotMapped) {
            this.getPOS(true, this.model.POid);
          }
        } else if (this.isCreateInvoice() && this.model.ProgramID) {
          this.fetchCurrencies();
        }
        this.setAllocationSectionModel(this.model.ProgramID);
      }
    },
    mapExistingPOs: function mapExistingPOs() {
      if (this.model) {
        this.purchaseOrder = {
          Key: this.model.POid,
          Value: {
            PONumber: this.model.PONumber,
            SupplierName: this.model.SupplierName,
            CreatedDate: this.model.POCreatedDate ? global.moment(this.model.POCreatedDate).format(this.dateFormat) : ''
          }
        };
      }
    },
    mapExistingCurrency: function mapExistingCurrency() {
      if (this.isCreateInvoice() && !this.isP2PInvoice) {
        this.currency = {
          Key: 0,
          Value: null
        };
      } else {
        this.mapSelectedCurrency();
      }
    },
    mapSelectedCurrency: function mapSelectedCurrency() {
      if (this.model) {
        this.currency = {
          Key: this.model.CurrencyID,
          Value: this.model.CurrencyName,
          Symbol: this.model.CurrencySymbol,
          DecimalPlaces: this.model.CurrencyDecimalPlaces
        };
      }
    },
    mapExistingPaymentType: function mapExistingPaymentType() {
      if (this.model) {
        this.paymentType = {
          Key: this.model.PaymentTypeID,
          Value: this.model.PaymentType
        };
      }
    },
    mapExistingDiscount: function mapExistingDiscount() {
      if (this.model) {
        this.discount = {
          Key: this.model.DiscountPaymentTermID,
          Value: this.model.DiscountDisplayName,
          Name: this.model.DiscountName,
          DaysNo: this.settings.CompanySettings.DaysNo
        };
      }
    },
    mapExistingDateFields: function mapExistingDateFields() {
      if (this.model) {
        this.isCreateInvoice() && !this.model.isEditInit && this.selectInvoiceDate(this.model.InvoiceDate);
        this.selectDueDate(this.model.DueDate);
        __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.DUE_DATE_COMPUTED_ON_INIT, {
          dueDate: this.model.DueDate
        });
      }
    },
    mapExistingAttachments: function mapExistingAttachments() {
      if (this.model && this.model.Attachments) {
        var attachments = [];
        for (var f in this.model.Attachments) {
          if (this.model.Attachments.hasOwnProperty(f)) {
            var entry = this.model.Attachments[f];
            attachments.push({
              fileObject: true,
              id: entry.AttachmentId,
              name: entry.AttachmentName,
              file: entry.AttachmentFile,
              path: entry.AttachmentPath,
              type: entry.AttachmentType,
              size: entry.AttachmentSize,
              readonly: entry.ReadOnly,
              success: true
            });
          }
        }
        this.attachedFiles = attachments;
      }
    },
    fetchProgramsonOpen: function fetchProgramsonOpen() {
      var _this5 = this;
      this.programs.length || this.api.forms.post(this.api.$.invoice.list.uploadInvoicePrograms, {
        q: '',
        onlyI2PInvoices: false,
        invoiceId: this.getInvoiceId
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          var parsedPrograms = _this5.splitProgramDetails(r.data.Data);
          _this5.programs = parsedPrograms;
          _this5.originalPrograms = utils.copy(parsedPrograms);
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    splitProgramDetails: function splitProgramDetails(programsWithDetails) {
      var newPrograms = [];
      programsWithDetails.map(function (program) {
        var elements = program.Value.split('##');
        var newProgram = {
          Key: program.Key,
          Value: {
            ProgramName: elements[0],
            InternalProgramId: elements[1] ? elements[1] : ''
          }
        };
        newPrograms.push(newProgram);
      });
      return newPrograms;
    },
    fetchPOsOnOpen: function fetchPOsOnOpen() {
      this.purchaseOrders.length || this.getPOS();
    },
    getPOS: function getPOS(getPOSWhenProgramSelected, POId) {
      var _this6 = this;
      this.api.forms.post(this.api.$.invoice.i2p.purchaseOrders, {
        q: '',
        programId: this.model.ProgramID,
        invoiceId: this.getInvoiceId
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          var parsedPOs = _this6.populatePOsInfo(r.data.Data);
          _this6.purchaseOrders = parsedPOs;
          _this6.originalPurchaseOrders = utils.copy(parsedPOs);
          if (getPOSWhenProgramSelected) {
            if (_this6.purchaseOrders.length === 1) {
              _this6.purchaseOrder = utils.copy(_this6.purchaseOrders[0]);
            } else {
              if (POId) {
                var poSelected = _this6.purchaseOrders.filter(function (item) {
                  return item.Key === -1 * Number(POId);
                })[0];
                _this6.purchaseOrder = utils.copy(poSelected);
              }
            }
            if (_this6.purchaseOrder && _this6.purchaseOrder.Key) {
              _this6.selectPurchaseOrder(_this6.purchaseOrder);
            }
            _this6.P2PisNotMapped = false;
          }
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    populatePOsInfo: function populatePOsInfo(POsWithDetails) {
      var _this7 = this;
      var newPurchaseOrders = [];
      POsWithDetails.map(function (po) {
        var newPO = {
          Key: po.POId,
          Value: {
            ProgramId: po.ProgramId,
            PONumber: po.PONumber,
            SupplierName: po.SupplierName,
            SupplierEmail: po.SupplierEmail,
            SupplierId: po.SupplierId,
            SupplierContactName: po.SupplierContactName,
            SupplierPhoneNumber: po.SupplierPhoneNumber,
            CreatedDate: global.moment(po.CreatedDate).format(_this7.dateFormat),
            NotInvoicedAmount: po.NotInvoicedAmount,
            CurrencyID: po.CurrencyID,
            CurrencyName: po.CurrencyName,
            CurrencyNameFormatted: po.CurrencyNameFormatted,
            CurrencySymbol: po.CurrencySymbol,
            DecimalPlaces: po.DecimalPlaces,
            POMasterId: po.POMasterId,
            POId: po.POId,
            IsSavingsPO: po.IsSavingsPO
          }
        };
        newPurchaseOrders.push(newPO);
      });
      return newPurchaseOrders;
    },
    fetchPrograms: function fetchPrograms(query) {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var results;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this8.api.forms.post(_this8.api.$.invoice.list.uploadInvoicePrograms, {
                q: query || '',
                onlyI2PInvoices: false,
                invoiceId: _this8.getInvoiceId
              });
            case 2:
              results = _context.sent;
              if (results && results.data && results.data.Data) {
                _this8.programs = _this8.splitProgramDetails(results.data.Data);
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchPOs: function fetchPOs(query) {
      var _this9 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var results;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this9.api.forms.post(_this9.api.$.invoice.i2p.purchaseOrders, {
                q: query || '',
                programId: _this9.model.ProgramID,
                invoiceId: _this9.getInvoiceId
              });
            case 2:
              results = _context2.sent;
              if (results && results.data && results.data.Data) {
                _this9.purchaseOrders = _this9.populatePOsInfo(results.data.Data);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    restorePrograms: function restorePrograms() {
      this.programs = utils.copy(this.originalPrograms);
    },
    restorePOs: function restorePOs() {
      this.purchaseOrders = utils.copy(this.originalPurchaseOrders);
    },
    selectProgram: function selectProgram(e) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.BEFORE_PROGRAM_SELECTED, e);
    },
    confirmProgramSelected: function confirmProgramSelected(e) {
      if (e.data.canSelectProgram) {
        // update program on PO
        this.changeProgram(e.data.program);
      } else {
        // confirm the program can be changed
        this.showConfirmProgramSelected = true;
      }
    },
    onPOAmountChanged: function onPOAmountChanged(e) {
      if (this.isP2PInvoice && this.settings.CompanySettings.AllowEditItem) {
        this.model.InvoiceAmount = +e.data.total;
        this.$emit(__WEBPACK_IMPORTED_MODULE_11__core_events_events___default.a.I2P.PO_AMOUNT_CHANGED, {
          total: this.model.InvoiceAmount
        });
      }
    },
    changeProgram: function changeProgram(program) {
      this.setInitialProgramData(program);
      this.resetAmountsOnPrgChanged();
      this.getProgramDetails(program.Key);
      this.changeInvoiceAmount();
      this.changeVatGSTAmount();
      this.fetchCurrencies();
      this.mapExistingPaymentTypeAndDiscount();
    },
    setInitialProgramData: function setInitialProgramData(program) {
      this.previousProgram = program;
      this.previousInvoiceWorkflow = this.model.InvoiceWorkflow;
      this.model.ProgramID = program.Key;
      this.model.ProgramName = program.Value.ProgramName;
      this.model.Errors.ProgramMissing = false;
    },
    resetAmountsOnPrgChanged: function resetAmountsOnPrgChanged() {
      this.model.InvoiceAmount = 0;
      this.model.VATGSTAmount = 0;
      this.model.InitialTotalAmount = 0;
    },
    resetFields: function resetFields() {
      this.resetPOCombo();
      this.resetSupplierCombo();
      this.resetSupplierRefId();
      this.resetCurrencyCombo();
      this.model.Errors.SupplierZipCodeMissing = false;
      this.model.Errors.PaymentTypeMissing = false;
      this.model.Errors.DiscountMissing = false;
      this.resetInvoiceAmountErrors();
    },
    resetPOCombo: function resetPOCombo() {
      this.model.POid = 0;
      this.model.PONumber = '';
      this.model.POCreatedDate = null;
      this.purchaseOrder = null;
      this.purchaseOrders = [];
      this.originalPurchaseOrders = [];
      this.model.Errors.POMissing = false;
      __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.REMOVE_P2P_PO);
    },
    resetSupplierCombo: function resetSupplierCombo() {
      __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.REMOVE_SUPPLIER);
    },
    resetSupplierRefId: function resetSupplierRefId() {
      this.model.ReferenceNo = '';
    },
    resetCurrencyCombo: function resetCurrencyCombo() {
      this.model.CurrencyID = 0;
      this.model.CurrencyCode = '';
      this.model.CurrencyName = '';
      this.currency = null;
      this.currencies = [];
      this.model.Errors.InvoiceCurrencyMissing = false;
    },
    resetInvoiceAmountErrors: function resetInvoiceAmountErrors() {
      this.model.Errors.InvoiceAmountMissing = false;
      this.model.Errors.InvoiceAmountOutOfRange = false;
      this.model.Errors.InvoiceAmountNegative = false;
      this.model.Errors.InitialTotalAmountMissing = false;
      this.model.Errors.InvoiceAmountExceededPOThreshold = false;
    },
    changeToPreviousProgram: function changeToPreviousProgram() {
      this.showConfirmProgramSelected = false;
      this.program = this.previousProgram;
    },
    selectPaymentType: function selectPaymentType(e) {
      this.model.PaymentTypeID = e.Key;
      this.model.PaymentType = e.Value;
      this.model.Errors.PaymentTypeMissing = false;
    },
    selectDiscount: function selectDiscount(e) {
      this.updateDiscountAndDueDate(e.Key, e.Name, e.DaysNo);
    },
    removeDiscount: function removeDiscount(e) {
      if (e.Key) {
        this.updateDiscountAndDueDate(0, 'No Discount', this.settings.CompanySettings.DefaultDaysNo);
      }
    },
    updateDiscountAndDueDate: function updateDiscountAndDueDate(id, name, daysNo, skipRecalculatePO) {
      if (id === 0) daysNo = this.settings.CompanySettings.DefaultDaysNo;
      this.model.DiscountPaymentTermID = id;
      this.model.DiscountName = name;
      this.$emit('discountSelected', {
        DiscountPaymentTermID: id,
        DiscountName: name,
        SkipRecalculatePO: skipRecalculatePO
      });

      // update Due Date
      if (!this.model.IsSameDayDeposit) {
        // Discount was deleted, use default payment terms from admin
        if ((daysNo || 0) === 0) {
          daysNo = this.settings.CompanySettings.DefaultDaysNo;
        }
        if ((daysNo || 0) > 0) {
          this.settings.CompanySettings.DaysNo = daysNo;
          this.paymentTermsDays = daysNo;
        }
        if (!this.isInitSupplier) {
          this.updateDueDate(this.model.InvoiceDate, this.paymentTermsDays);
        }
      }
      this.model.Errors.DiscountMissing = false;
    },
    selectPurchaseOrder: function selectPurchaseOrder(poSelected) {
      var _this10 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this10.selectedPO = poSelected;

              // if program was not selected already, we need to prefill it
              if (!(_this10.model.ProgramID === 0 && _this10.program.Key === 0)) {
                _context3.next = 6;
                break;
              }
              _context3.next = 4;
              return _this10.populateProgramCombo(poSelected.Value.ProgramId, poSelected.Value.IsSavingsPO);
            case 4:
              _context3.next = 7;
              break;
            case 6:
              _this10.model.UseSavingsFields = poSelected.Value.IsSavingsPO;
            case 7:
              _this10.getPOSnapshotDetails(poSelected.Value.POId);
              _this10.model.POid = poSelected.Key;
              _this10.model.PONumber = poSelected.Value.PONumber;
              _this10.model.Errors.POMissing = false;
              _context3.next = 13;
              return _this10.getPurchaseOrderJSON(poSelected.Value.PONumber, poSelected.Value.POMasterId);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    continueSelectPurchaseOrder: function continueSelectPurchaseOrder() {
      // Populate Additional Data
      this.populateCurrencyandInvoiceAmount(this.selectedPO);
      this.populateSupplierCombo(this.selectedPO);
    },
    getPurchaseOrderJSON: function getPurchaseOrderJSON(poNumber, poMasterId) {
      var _this11 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = _this11.model.UseSavingsFields ? api.GetSavingsDetails() : api.GetPurchaseOrderDetails();
              _this11.api.get(url, {
                params: {
                  uniqueId: poNumber,
                  userId: _this11.user.buyerUserID,
                  getLastSent: true
                }
              }).then(function (r) {
                if (r && r.data) {
                  _this11.$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.UPDATE_PO_MODEL, {
                    PO: r.data,
                    POMasterID: poMasterId
                  });
                }
              }).catch(function (e) {
                return console.warn(e);
              });
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getPOSnapshotDetails: function getPOSnapshotDetails(poId) {
      var _this12 = this;
      this.api.forms.post(this.api.$.invoice.i2p.getPOSnapshotDetails, {
        poId: poId
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          var P2PSnapshotInfo = JSON.parse(r.data.Data);
          _this12.model.CurrencyCode = P2PSnapshotInfo.CurrencyCode;
          __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.UPDATE_P2P_Snapshot, P2PSnapshotInfo);
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    populateProgramCombo: function populateProgramCombo(programId, isSavingsPO) {
      var _this13 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this13.api.get(_this13.api.$.invoice.i2p.programDetails, {
                params: {
                  programId: programId,
                  invoiceId: _this13.getInvoiceId
                }
              }).then(function (r) {
                if (r && r.data && r.data.Data) {
                  var result = JSON.parse(r.data.Data);
                  if (_this13.isP2PInvoice) {
                    _this13.model.UseSavingsFields = isSavingsPO;
                    result.UseSavingsFields = isSavingsPO;
                  }
                  _this13.processProgramAfterSelectPO(result);
                  _this13.getPOS(true);
                }
              }).catch(function (e) {
                return console.warn(e);
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    processProgramAfterSelectPO: function processProgramAfterSelectPO(result) {
      this.programDetails = JSON.parse(result.ProgramDetails);
      this.program = {
        Key: this.programDetails.ProgramID,
        Value: {
          ProgramName: __WEBPACK_IMPORTED_MODULE_14_he___default.a.decode(this.programDetails.ProgramName),
          InternalProgramId: this.programDetails.InternalProgramID
        }
      };
      this.setInitialProgramData(this.program);
      if (this.programDetails.UniqueId) {
        __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.PROGRAM_SELECTED, result);
      } else {
        alert('Program could not be found');
      }
    },
    populateSupplierCombo: function populateSupplierCombo(poSelected) {
      var _this14 = this;
      this.api.forms.post(this.api.$.invoice.i2p.getSupplierFromAddSupplierButton, {
        supplier: {
          EmailAddress: poSelected.Value.SupplierEmail,
          InvoiceId: this.getInvoiceId
        }
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          var response = JSON.parse(r.data.Data);
          _this14.populateOutSidesupplierData(response, poSelected);
          var info = {
            SupplierInfoVM: _this14.getSupplierInfoVM(response),
            VendorId: response.VendorId || 0,
            VendorUserID: response.VendorUserID || 0,
            VendorVCI: response.VendorVCI || response.VendorTempEONumber || 0,
            CardInfo: JSON.parse(response.SupplierCardInfo),
            InvoiceCurrencyCode: _this14.model.CurrencyCode
          };
          __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.ADDED_NEW_SUPPLIER, info);
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    populateCurrencyandInvoiceAmount: function populateCurrencyandInvoiceAmount(poSelected) {
      var _this15 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this15.populateCurrency(poSelected);
            case 2:
              _this15.populateInvoiceAmount(poSelected);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    populateCurrency: function populateCurrency(poSelected) {
      this.currency = {
        Key: poSelected.Value.CurrencyID,
        Value: poSelected.Value.CurrencyNameFormatted,
        Symbol: poSelected.Value.CurrencySymbol,
        DecimalPlaces: poSelected.Value.DecimalPlaces
      };
      this.selectCurrency(this.currency);
    },
    populateInvoiceAmount: function populateInvoiceAmount(poSelected) {
      if (this.isCreateInvoice()) {
        this.model.InvoiceAmount = poSelected.Value.NotInvoicedAmount;
      }
      this.notInvoicedAmount = Number(poSelected.Value.NotInvoicedAmount);
      this.changeInvoiceAmount();
    },
    populateOutSidesupplierData: function populateOutSidesupplierData(response, poSelected) {
      if (response.OutSideNewSupplier === 'Yes') {
        response.CompanyName = poSelected.Value.SupplierName;
        response.SupplierContact = poSelected.Value.SupplierContactName;
        response.Phone = poSelected.Value.SupplierPhoneNumber;
        response.SupplierContactEmail = poSelected.Value.SupplierEmail;
      }
      return response;
    },
    getSupplierInfoVM: function getSupplierInfoVM(response) {
      return {
        SupplierName: response.CompanyName,
        SupplierID: response.SupplierIDCode,
        SupplierVatGstID: response.SupplierVatGstId,
        SupplierContactName: response.SupplierContact,
        EmailAddress: response.SupplierContactEmail,
        SupplierPhone: response.Phone,
        SupplierAddress1: response.Address,
        SupplierAddress2: response.Address2,
        SupplierCity: response.City,
        SupplierZIP: response.Zip,
        SupplierCountryID: response.CountryID,
        CountryName: response.CountryName,
        DiscountPaymentTermID: response.DiscountPaymentTermID,
        DiscountName: response.DiscountName,
        DiscountDaysNo: response.DiscountDaysNo,
        VendorType: response.VendorType,
        HasDefaultImmediatePayment: response.HasDefaultImmediatePayment,
        WithholdingTaxPercent: response.WithholdingTaxPercent,
        Currencies: response.Currencies,
        InvoiceCurrencyCode: response.InvoiceCurrencyCode
      };
    },
    selectCurrency: function selectCurrency(e) {
      this.model.CurrencyID = e.Key;
      this.model.CurrencyCode = e.Value.indexOf('(') !== -1 ? e.Value.split('(')[1].replace(')', '') : e.Value;
      this.model.CurrencyName = e.Value;
      this.model.Errors.InvoiceCurrencyMissing = false;
      this.emitCurrencyEvent(this.model.CurrencyCode, e.Symbol, e.DecimalPlaces);
    },
    currencyInput: function currencyInput(e) {
      if (e === null) {
        this.emitCurrencyEvent('', '', 2);
      }
    },
    emitCurrencyEvent: function emitCurrencyEvent(code, symbol, decimalPlaces) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.CURRENCY_SELECTED, {
        code: code,
        symbol: symbol,
        decimalPlaces: decimalPlaces
      });
      __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.CURRENCY_SELECTED, {
        code: code,
        symbol: symbol,
        decimalPlaces: decimalPlaces
      });
    },
    parseISODateString: function parseISODateString(dateString) {
      if (typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        var _dateString$split$map = dateString.split('-').map(Number),
          _dateString$split$map2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_dateString$split$map, 3),
          year = _dateString$split$map2[0],
          month = _dateString$split$map2[1],
          day = _dateString$split$map2[2];
        return new Date(year, month - 1, day);
      }
      return dateString;
    },
    parseDate: function parseDate(dateString) {
      var fieldType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'invoiceDate';
      if (!/\d{4}/.test(dateString)) {
        if (fieldType === 'invoiceDate') {
          this.model.Errors.InvoiceDateIncomplete = true;
        } else if (fieldType === 'dueDate') {
          this.model.Errors.DueDateIncomplete = true;
        }
        return null;
      }
      if (fieldType === 'invoiceDate') {
        this.model.Errors.InvoiceDateIncomplete = false;
      } else if (fieldType === 'dueDate') {
        this.model.Errors.DueDateIncomplete = false;
      }
      var date = new Date(dateString);
      return this.setDate(date);
    },
    selectInvoiceDate: function selectInvoiceDate(value) {
      value = this.parseISODateString(value);
      if (value instanceof Date && (value.getFullYear() < 2000 || value.getFullYear() > 2100)) {
        this.model.Errors.InvoiceDateIncomplete = true;
        this.invoiceDate = null;
        return;
      }
      if (typeof value === 'string') {
        value = this.parseDate(value, 'invoiceDate');
        if (!value) {
          this.invoiceDate = null;
          return;
        }
      }
      if (value) {
        this.model.InvoiceDate = this.setDate(value);
        this.updateDueDate(value, this.paymentTermsDays);
        this.rushDays = {};
        this.model.HasRushPayment = false;
        this.model.RushPaymentReason = '';
        if (this.model.IsSameDayDeposit) {
          this.checkRushPayment();
          this.updateDuedDateIfInvoiceDateIsInThePast(value);
        }
      }
      this.model.Errors.InvoiceDateMissing = false;
    },
    updateDuedDateIfInvoiceDateIsInThePast: function updateDuedDateIfInvoiceDateIsInThePast(value) {
      var dueDateValue = this.setImmediateDueDateValue(value);
      dueDateValue && this.updateDueDate(dueDateValue, this.paymentTermsDays);
    },
    setImmediateDueDateValue: function setImmediateDueDateValue(value) {
      if (value) {
        if (this.model.IsSameDayDeposit && this.selectedDateIsInThePast(value)) {
          return new Date();
        }
      }
      return null;
    },
    selectedDateIsInThePast: function selectedDateIsInThePast(date) {
      var now = new Date();
      var selectedDate = new Date(date);
      now.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      if (selectedDate.getTime() < now.getTime()) {
        return true;
      }
      return false;
    },
    getDatesDifferenceInDays: function getDatesDifferenceInDays(startDate, endDate) {
      // create object from string
      if (typeof startDate === 'string') {
        startDate = new Date(startDate);
      } else {
        startDate = this.setDate(startDate);
      }
      if (typeof endDate === 'string') {
        endDate = new Date(endDate);
      } else {
        endDate = this.setDate(endDate);
      }

      // Date without time component
      if (startDate != null && endDate != null) {
        startDate = new Date(startDate.toDateString());
        endDate = new Date(endDate.toDateString());

        // return difference in days
        var diffTime = Math.abs(endDate - startDate);

        // fix daylight savings time difference
        if (startDate.getTimezoneOffset() < 0) {
          // GMT+0200 - rounding is not necessary
          return parseInt(diffTime / (1000 * 60 * 60 * 24));
        } else if (startDate.getTimezoneOffset() > 0) {
          // GMT-0800
          return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }
      }
      return 0;
    },
    selectDueDate: function selectDueDate(value) {
      value = this.parseISODateString(value);
      if (value instanceof Date && (value.getFullYear() < 2000 || value.getFullYear() > 2100)) {
        this.model.Errors.DueDateIncomplete = true;
        this.dueDate = null;
        return;
      }
      if (typeof value === 'string') {
        value = this.parseDate(value, 'dueDate');
        if (!value) {
          this.dueDate = null;
          return;
        }
      }
      if (this.model.DiscountPaymentTermID > 0 && this.getDatesDifferenceInDays(this.model.InvoiceDate, value) > this.paymentTermsDays) {
        this.dueDateToValidate = value;
        value = this.model.DueDate;
        this.showDiscountDueDateValidationError = true;
      }
      if (value) {
        this.dueDate = value;
        this.model.DueDate = value;
        !this.model.isEditInit && this.checkRushPayment();
      }
      this.model.Errors.DueDateMissing = false;
      this.model.Errors.DueDateIncomplete = false;
    },
    checkRushPayment: function checkRushPayment() {
      var initialDueDate = this.model.DueDate;
      var rushDays = this.getRushPaymentDays();
      if (rushDays && rushDays.RushPaymentTermsDays < rushDays.StandardRushPaymentDays) {
        var rushPaymentModel = this.mapRushPaymentInfo(rushDays, initialDueDate);
        this.openRequestRushPaymentDialog(rushPaymentModel);
      } else {
        this.model.HasRushPayment = false;
      }
    },
    mapRushPaymentInfo: function mapRushPaymentInfo(rushDays, initialDueDate) {
      return {
        RushPaymentTermsDays: rushDays.RushPaymentTermsDays,
        StandardRushPaymentDays: rushDays.StandardRushPaymentDays,
        DaysEarlier: rushDays.DaysEarlier,
        HasDiscountedPaymentTerm: rushDays.HasDiscountedPaymentTerm,
        Reason: '',
        InitialDueDate: initialDueDate,
        IsSameDayDeposit: this.model.IsSameDayDeposit
      };
    },
    getRushPaymentDays: function getRushPaymentDays() {
      this.rushDays.RushPaymentTermsDays = Math.round(Math.abs((new Date(this.model.DueDate).getTime() - new Date(this.model.InvoiceDate).getTime()) / this.oneDay));
      this.rushDays.StandardRushPaymentDays = this.paymentTermsDays;
      this.rushDays.DaysEarlier = Math.abs(this.rushDays.StandardRushPaymentDays - this.rushDays.RushPaymentTermsDays);
      this.rushDays.HasDiscountedPaymentTerm = this.discount && this.discount.Key > 0;
      return this.rushDays;
    },
    getProgramDetails: function getProgramDetails(programId) {
      var _this16 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (programId > 0) {
                // SPRT-18874: drop the previous program's verdict before asking about this one. The .catch below
                // swallows a transient failure without ever reaching processProgramDetails, so without this the
                // flag set by an earlier cancelled program would stick and block save/submit on a valid one.
                _this16.model.Errors.ProgramCancelled = false;
                _this16.api.get(_this16.api.$.invoice.i2p.programDetails, {
                  params: {
                    programId: programId,
                    useHighLevelAllocation: _this16.useHighLevelAllocation,
                    invoiceId: _this16.getInvoiceId
                  }
                }).then(function (r) {
                  if (r && r.data && r.data.Data) {
                    var result = JSON.parse(r.data.Data);
                    _this16.processProgramDetails(result);
                    _this16.setAllocationSectionModel(programId);
                  }
                }).catch(function (e) {
                  return console.warn(e);
                });
              }
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    processProgramDetails: function processProgramDetails(result) {
      var _this17 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              // SPRT-18874: refuse a cancelled program the moment it is picked, instead of letting the user fill
              // the whole form and fail at submit. Covers an existing invoice too — this picker has no :disabled
              // binding, so it stays open on edit, and moving a saved invoice onto a cancelled program is what the
              // backend guard refuses. The backend flags only a program the invoice is not already on, so loading
              // an existing invoice whose program was cancelled after the fact is untouched — it stays editable.
              _this17.model.Errors.ProgramCancelled = result.IsProgramCancelled === true;
              if (_this17.model.Errors.ProgramCancelled) {
                _this17.showCancelledProgramError();
              }
              _context8.next = 4;
              return _this17.setWorkflowType(result);
            case 4:
              _this17.settings.CompanySettings.AllowSameDayDeposit = result.AllowSameDayDeposit || false;
              _this17.settings.CompanySettings.RequireAdditionalInvoiceConfirmation = result.RequireAdditionalInvoiceConfirmation || false;
              _this17.settings.CompanySettings.AllowEditItem = result.AllowEditItem || false;
              _this17.settings.CompanySettings.ExcludeTaxesFromPOThreshold = result.ExcludeTaxesFromPOThreshold || false;
              _this17.settings.CompanySettings.AllowInvoiceToExceedPOQty = result.AllowInvoiceToExceedPOQty || false;
              _this17.settings.CompanySettings.AllocateProcessingFeeToEveryCostCenter = result.AllocateProcessingFeeToEveryCostCenter || false;
              _this17.model.IsRequiredSupplierZipCode = result.IsRequiredSupplierZipCode || false;
              _this17.doAdditionalProcessing(result);
              _this17.programDetails = JSON.parse(result.ProgramDetails);
              _this17.model.DivisionID = _this17.programDetails.DivisionID;
              _this17.model.BusinessUnitID = _this17.programDetails.BusinessUnitID;
              _this17.model.DivisionName = result.DivisionName;
              _this17.programCurrencyCode = _this17.programDetails.CurrencyCode;
              _this17.cFields++;
              _this17.loadRemainingProgramBudget(_this17.programDetails.ProgramID);
              if (_this17.programDetails.UniqueId) {
                __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.PROGRAM_SELECTED, result);
              }
            case 20:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    // SPRT-18874
    // Finite timeout, unlike the app's usual `timeout: 0` error alerts. This one goes STALE: switching from
    // a cancelled program to a valid one clears the field error, but a never-closing banner would keep
    // telling the user the program is cancelled until they dismissed it by hand.
    //
    // `heading` is what the notification store dedupes `alert: true` entries by
    // (core/components/mdNotifications/install.js). Without one this banner collided with every other alert
    // on the screen — including the never-closing save error — and whichever was up first swallowed the
    // rest. Same string as index.vue's load-path copy on purpose: those two ARE the same refusal and should
    // dedupe, and they are distinct from 'Invoice not saved'.
    showCancelledProgramError: function showCancelledProgramError() {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        heading: 'Cancelled program',
        timeout: 10000,
        message: __WEBPACK_IMPORTED_MODULE_15__models_program_constants__["a" /* default */].cancelledProgramMessage
      });
    },
    loadRemainingProgramBudget: function loadRemainingProgramBudget(programId) {
      var _this18 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (+programId > 0) {
                _this18.api.forms.post(_this18.api.$.invoice.i2p.remainingBudget, {
                  programId: programId
                }).then(function (r) {
                  if (r && r.data) {
                    _this18.programBudgetData = [[_this18.model.ProgramName, r.data.RevisedBudget, r.data.BudgetBalance,
                    // Remaining Budget
                    r.data.TotalPO,
                    // POs/Invoices
                    r.data.TotalExpense,
                    // Expenses
                    r.data.POTotalLessVatGst, r.data.ExpenseTotalLessVatGst, r.data.IncludeExpenseInBudget, r.data.ExcludeVATFromBudget], {
                      'POsOrInvoicesLabel': _this18.isP2PInvoice ? 'POs' : 'Invoices'
                    }];
                    _this18.excludeVATFromBudget = r.data.ExcludeVATFromBudget;
                  }
                });
              }
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    doAdditionalProcessing: function doAdditionalProcessing(result) {
      result.workflowChanged = result.InvoiceWorkflowStr !== this.previousInvoiceWorkflow;
      if (this.isP2PInvoice || result.workflowChanged) {
        this.resetFields();
      }
      if (this.isP2PInvoice) {
        this.getPOS(true);
      }
    },
    setWorkflowType: function setWorkflowType(result) {
      if (result && result.InvoiceWorkflowStr) {
        this.model.InvoiceWorkflow = utils.copy(result.InvoiceWorkflowStr);
      }
    },
    setAllocationSectionModel: function setAllocationSectionModel(programId) {
      var _this19 = this;
      if (this.showNeddedFieldsForScanning) {
        this.api.get(api.GetAllocations(), {
          params: {
            programId: programId
          }
        }).then(function (response) {
          var data = response.data;
          __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.UPDATE_ALLOCATION_MODEL, data);
          if (_this19.model.scanAllocationOption || _this19.model.hasMultipleAllocation) {
            __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.INIT_ALLOCATION_MODEL, {
              type: _this19.model.allocationType,
              selectedOption: _this19.model.scanAllocationOption,
              hasMultipleAllocation: _this19.model.hasMultipleAllocation
            });
          }
        });
      }
    },
    fetchPaymentTypes: function fetchPaymentTypes() {
      var _this20 = this;
      this.paymentTypes.length || this.api.forms.post(this.api.$.invoice.i2p.paymentTypes, {
        q: '',
        divisionID: this.model.DivisionID
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          _this20.paymentTypes = r.data.Data;
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    fetchDiscounts: function fetchDiscounts() {
      var _this21 = this;
      this.discounts.length > 1 || this.api.forms.post(this.api.$.invoice.i2p.discounts, {
        q: '',
        invoiceId: this.getInvoiceId
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          _this21.discounts = r.data.Data;
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    //
    fetchCurrencies: function fetchCurrencies() {
      var _this22 = this;
      this.currencies.length || this.api.forms.post(this.api.$.invoice.i2p.currencies, {
        q: '',
        programId: this.model.ProgramID,
        invoiceId: this.getInvoiceId
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          _this22.currencies = r.data.Data;
          if (_this22.currencies && _this22.currencies.length === 1) {
            // select first
            _this22.selectCurrency(_this22.currencies[0]);
            _this22.mapSelectedCurrency();
          }
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    addNewSupplierClickHandler: function addNewSupplierClickHandler() {
      if (this.settings.CompanySettings.EditingInvoiceScan) this._openAddEditSupplierModalOldDialog('add');else this._openInviteSupplierModalDialog('add');
    },
    _openInviteSupplierModalDialog: function _openInviteSupplierModalDialog(operation) {
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_9_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4__dialogs_InviteSupplierDialog_vue__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: null,
          invoiceId: this.getInvoiceId,
          eventHub: eventHub,
          operation: operation
        }
      });
      instance.$slots.default = [];
      instance.$mount();
      this.$refs.addNewSupplierDialogContainer.appendChild(instance.$el);
    },
    _openAddEditSupplierModalOldDialog: function _openAddEditSupplierModalOldDialog(operation) {
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_9_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5__dialogs_AddEditSupplier_vue__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: null,
          invoiceId: this.getInvoiceId,
          eventHub: eventHub,
          operation: operation
        }
      });
      instance.$slots.default = [];
      instance.$mount();
      this.$refs.addNewSupplierDialogContainer.appendChild(instance.$el);
    },
    setDueDate: function setDueDate(invoiceDate, daysNo) {
      var dueDate = this.setDate(invoiceDate);
      dueDate.setDate(dueDate.getDate() + daysNo);
      return dueDate;
    },
    updateDueDateOnSelectSupplier: function updateDueDateOnSelectSupplier(supplierId) {
      var _this23 = this;
      this.api.forms.post(this.api.$.invoice.i2p.getInvoiceDueDate, {
        supplierId: supplierId,
        invoiceId: this.getInvoiceId
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          var result = JSON.parse(r.data.Data);
          if (_this23.model.DiscountPaymentTermID > 0) {
            _this23.settings.CompanySettings.DefaultDaysNo = result;
            _this23.paymentTermsDays = _this23.settings.CompanySettings.DaysNo;
          } else {
            _this23.paymentTermsDays = result;
          }
          if (!_this23.isCreateInvoice() && _this23.model.isEditInit) {
            _this23.getRushPaymentDays();
          } else {
            _this23.updateDueDate(_this23.model.InvoiceDate, _this23.paymentTermsDays);
          }
          _this23.model.isEditInit = false;
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    updateDueDate: function updateDueDate(invoiceDate, days) {
      if (invoiceDate) {
        if (this.model.IsSameDayDeposit) {
          // https://evedllc.atlassian.net/browse/WORKFLOW-1223
          // Match Due Date to Invoice Date for Immediate Payment
          days = 0;
        }
        var dueDate = this.setDueDate(invoiceDate, days);
        this.dueDate = dueDate;
        this.model.DueDate = dueDate;
        this.model.HasRushPayment = false;
      }
      this.model.Errors.DueDateMissing = false;
      this.model.Errors.DueDateIncomplete = false;
    },
    openRequestRushPaymentDialog: function openRequestRushPaymentDialog(rushPaymentModel) {
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_9_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_6__RequestRushPayment_vue__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: rushPaymentModel,
          eventHub: eventHub
        }
      });
      instance.$slots.default = [];
      instance.$mount();
      this.$refs.requestRushPaymentDialogContainer && this.$refs.requestRushPaymentDialogContainer.appendChild(instance.$el);
    },
    onCloseRushPaymentDialog: function onCloseRushPaymentDialog(e) {
      if (this.model.IsSameDayDeposit) {
        // reset reset the payment type => reset invoice date and due date
        this.resetPaymentTypeCombo();
        this.resetPaymentTermCombo();
        this.resetSameDayDepositOption();
        this.resetInvoiceDate();
        this.resetDueDate();
      } else {
        this.updateDueDate(this.model.InvoiceDate, this.paymentTermsDays);
      }
      this.model.HasRushPayment = false;
      this.model.RushPaymentReason = '';
    },
    resetPaymentTypeCombo: function resetPaymentTypeCombo() {
      this.paymentType = {
        Key: 0,
        Value: ''
      };
      this.model.PaymentTypeID = 0;
      this.model.PaymentType = '';
    },
    resetPaymentTermCombo: function resetPaymentTermCombo() {
      this.paymentTerm = {
        Key: 0,
        Value: ''
      };
      this.model.DiscountPaymentTermID = 0;
      this.model.DiscountName = '';
    },
    resetSameDayDepositOption: function resetSameDayDepositOption(value) {
      this.sameDayDepositOption[0].status = value;
      this.model.IsSameDayDeposit = value;
    },
    resetInvoiceDate: function resetInvoiceDate() {
      this.invoiceDate = null;
      this.model.InvoiceDate = null;
    },
    resetDueDate: function resetDueDate() {
      // let dueDate = this.setDueDate(null)
      this.dueDate = null;
      this.model.DueDate = null;
    },
    onSaveRushPaymentDialog: function onSaveRushPaymentDialog(e) {
      this.model.RushPaymentReason = e.data;
      this.model.HasRushPayment = true;
    },
    comingFromProgramDashboard: function comingFromProgramDashboard() {
      return this.$route.query.from && this.$route.query.from.toLowerCase().trim() === 'programdashboard';
    },
    comingFromProgramPOList: function comingFromProgramPOList() {
      return this.$route.query.from && this.$route.query.from.toLowerCase().trim() === 'programsentpos';
    },
    invoiceIsSaved: function invoiceIsSaved() {
      return this.model.InvoiceIsSaved || false;
    },
    getProgramLabel: function getProgramLabel(option) {
      return option && option.Value && option.Value.ProgramName ? __WEBPACK_IMPORTED_MODULE_14_he___default.a.decode(option.Value.ProgramName) : '';
    },
    getPOLabel: function getPOLabel(option) {
      return option && option.Value && option.Value.PONumber ? option.Value.PONumber : '';
    },
    changeInvoiceAmount: function changeInvoiceAmount() {
      this.resetInvoiceAmountErrors();
      __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.INVOICE_AMOUNT_CHANGED, {
        amount: this.model.InvoiceAmount,
        notInvoicedAmount: Number(this.notInvoicedAmount)
      });
      // In index.vue InvoiceAmount variable is updated on INVOICE_AMOUNT_CHANGED event.
      // With reactiveness, InvoiceAmount gets updated in HighAllocationSection.vue component (there is a watch on this variable)
      // The invoiceAmount() watch from HighAllocationSection.vue will update all allocations and
      // it will further call: EventBus.$emit(Eved.I2P.CHANGE_ALLOCATION, payload)
    },
    changeInitialTotalAmount: function changeInitialTotalAmount() {
      this.resetInvoiceAmountErrors();
      __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.INVOICE_INITIAL_TOTAL_AMOUNT_CHANGED, {
        amount: this.model.InitialTotalAmount
      });
      __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_11__core_events_events___default.a.I2P.UPDATE_SNAPSHOT, {
        total: +this.model.InitialTotalAmount,
        totalVATGST: +this.model.VATGSTAmount,
        programCurrencyCode: this.programCurrencyCode
      });
    },
    changeVatGSTAmount: function changeVatGSTAmount() {
      __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_10__event_bus__["a" /* Eved */].I2P.VAT_AMOUNT_CHANGED, {
        vatgstAmount: this.model.VATGSTAmount
      });
      // In index.vue VATAmount variable is updated on INVOICE_AMOUNT_CHANGED event.
      // With reactiveness, VATAmount gets updated in HighAllocationSection.vue component (there is a watch on this variable)
      // The vatAmount() watch from HighAllocationSection.vue will update all allocations and
      // it will further call: EventBus.$emit(Eved.I2P.CHANGE_ALLOCATION, payload)
      __WEBPACK_IMPORTED_MODULE_10__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_11__core_events_events___default.a.I2P.UPDATE_SNAPSHOT, {
        total: +this.model.InitialTotalAmount,
        totalVATGST: +this.model.VATGSTAmount,
        programCurrencyCode: this.programCurrencyCode
      });
    },
    changeSameDaySetting: function changeSameDaySetting(e) {
      var _this24 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this24.$emit('changeSameDaySetting', e);
              _context10.next = 3;
              return _this24.resetSameDayDepositOption(e.status);
            case 3:
              if (!e.status) {
                _this24.model.Errors.InvoiceAmountNegative = false;
              }
              _this24.updateDueDate(_this24.model.InvoiceDate, _this24.paymentTermsDays);
              if (_this24.model.InvoiceDate) {
                _this24.checkRushPayment();
                _this24.updateDuedDateIfInvoiceDateIsInThePast(_this24.model.InvoiceDate);
              }
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    changeReimbursementSetting: function changeReimbursementSetting(e) {
      var _this25 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this25.$emit('changeReimbursementSetting', e);
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    onSelectAllocationType: function onSelectAllocationType(e) {
      this.model.IsAllocationSelected = e.isAllocationSelected;
      this.model.HasAllocationSection = e.hasAllocationSection;
      this.model.HasAllocationForScan = e.hasAllocationForScan;
      this.model.Errors.AllocationTypeMissing = false;
      this.model.Errors.AllocationMissing = false;
    },
    onCustomFieldsLoad: function onCustomFieldsLoad() {
      this.customFieldsLoaded = true;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "R4zt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("3gv2");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ba95c3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("VBmV");
function injectStyle (ssrContext) {
  __webpack_require__("FvOR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19ba95c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ba95c3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "R8ny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowCardNumber_vue__ = __webpack_require__("3ON/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c069334_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowCardNumber_vue__ = __webpack_require__("Ctys");
function injectStyle (ssrContext) {
  __webpack_require__("0FyU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c069334"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowCardNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c069334_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowCardNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RFrs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RHeX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2coJtXgzqrice5Ks-tfzGS","Dell":"_2NEIgAKnbediGZYjzJcRXQ","Abbott":"_2dRGxoK36HiOYJ0G2xOYZZ","Gap":"_3SlxHdoQB4OTvX7yig7eKL","Allstate":"yGfhd1y6Y4yiSpftB3WpU","Asurion":"_14uCXc2F40y-3Oq7vzLaPF","Invitae":"SYdB3RHKVVbQTfwuiinhx","JWE":"_dfV9akYM-vZIy2ggxnU8"};

/***/ }),

/***/ "RJEM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3tr9BNxdgfKJleCulJBp-V","Dell":"aDNVcXa3YzG4IMR9Q3bJd","Abbott":"aeys1rw5e8TP2Sg2mWEeq","Gap":"_1iEbYfz8SdnkqfU6UMrtnR","Allstate":"_1PXX1Z5THqygusJI16-zZs","Asurion":"_1wpb9EUeVEk0sM94ztBYEO","Invitae":"_3SpD51WTyANZ-I8QkdoGbb","JWE":"_3H3qHD5qqeOLKutDsf1E-g"};

/***/ }),

/***/ "RMJP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(utils, global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cssProps", function() { return cssProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bundler__ = __webpack_require__("4HWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("lVLm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__copy__ = __webpack_require__("HLWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collection__ = __webpack_require__("KD6I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale__ = __webpack_require__("1uct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__numeric__ = __webpack_require__("mJEd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__date__ = __webpack_require__("Yq9E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__json__ = __webpack_require__("L7GG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("rxf2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__polyfills__ = __webpack_require__("ShG+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__polyfills__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cookie__ = __webpack_require__("B9jb");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "include", function() { return __WEBPACK_IMPORTED_MODULE_0__bundler__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "logger", function() { return __WEBPACK_IMPORTED_MODULE_1__logger__["logger"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "copy", function() { return __WEBPACK_IMPORTED_MODULE_2__copy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "collection", function() { return __WEBPACK_IMPORTED_MODULE_3__collection__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locale", function() { return __WEBPACK_IMPORTED_MODULE_4__locale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "numeric", function() { return __WEBPACK_IMPORTED_MODULE_5__numeric__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "date", function() { return __WEBPACK_IMPORTED_MODULE_6__date__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "json", function() { return __WEBPACK_IMPORTED_MODULE_7__json__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cookie", function() { return __WEBPACK_IMPORTED_MODULE_10__cookie__["a"]; });
var APP = {}; // eslint-disable-line












Object.defineProperty(utils, 'app', {
  get: function get() {
    return APP;
  },
  set: function set(val) {
    APP = val;
  }
});
var cssProps = {
  init: function init() {
    return setTimeout(global.cssVarPoly.init, 450);
  },
  refresh: function refresh() {
    return setTimeout(function () {
      global.cssVarPoly.findCSS();
      global.cssVarPoly.updateCSS();
    }, 450);
  }
};

global.setCookie = function (name, value, exdays, path) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var cValue = escape(value) + (exdays === null ? '' : '; expires=' + exdate.toUTCString());
  path = '/';
  cValue += '; path=/';
  if (typeof path !== 'undefined') {
    cValue += '; path=' + path;
  }
  document.cookie = name + '=' + cValue;
};
global.getCookie = function (name) {
  var i, x, y;
  var ARRcookies = document.cookie.split(';');
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
    x = x.replace(/^\s+|\s+$/g, '');
    if (x === name) {
      return unescape(y);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "RNN8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2yqya-T8i2Z5_FS_v7bBYt","Dell":"wF5k5rQRDUsl-RStsZ36d","Abbott":"_2VxN4TD6LCur0wSIlb9mb8","Gap":"_9gHopKGvhQQtZqpeS-fWZ","Allstate":"E1PPeKkhntetdmzuTbk2m","Asurion":"YN2Xgy-j6Lp3bJhl_xu5G","Invitae":"_2IRHQJjMPPxTSIAGToOJKN","JWE":"_1Mvig2tVRcKHi5G3EeHvmG"};

/***/ }),

/***/ "RNei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_panel_vue__ = __webpack_require__("Tq0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__languages_js__ = __webpack_require__("xTRC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-datepicker',
  props: {
    fieldLabel: String,
    hideOptional: Boolean,
    name: String,
    disabled: Boolean,
    value: null,
    required: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    error: Boolean,
    helptipHeader: String,
    helptipBody: String,
    helpText: String,
    format: String,
    range: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'date'
    },
    width: {
      type: [String, Number],
      default: 210
    },
    placeholder: String,
    lang: {
      type: String,
      default: 'en'
    },
    shortcuts: {
      type: [Boolean, Array],
      default: true
    },
    disabledDays: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    notBefore: {
      default: ''
    },
    notAfter: {
      default: ''
    },
    firstDayOfWeek: {
      default: 7,
      type: Number,
      validator: function validator(val) {
        return val >= 1 && val <= 7;
      }
    },
    minuteStep: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val >= 0 && val <= 60;
      }
    },
    confirm: {
      default: false
    },
    inputClass: {
      type: String,
      default: 'input'
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    fit: Boolean,
    compact: Boolean,
    hidden: Boolean
  },
  data: function data() {
    return {
      focused: false,
      model: null,
      showPopup: false,
      currentValue: this.value,
      position: null,
      ranges: []
    };
  },
  components: {
    'calendar-panel': __WEBPACK_IMPORTED_MODULE_0__calendar_panel_vue__["default"]
  },
  watch: {
    value: {
      handler: function handler(val) {
        if (!this.range) {
          this.currentValue = this.isValidDate(val) ? val : undefined;
        } else {
          this.currentValue = this.isValidRange(val) ? val.slice(0, 2) : [undefined, undefined];
        }
      },
      immediate: true
    },
    showPopup: function showPopup(val) {
      if (val) {
        this.$nextTick(this.displayPopup);
      }
    }
  },
  computed: {
    translation: function translation() {
      return __WEBPACK_IMPORTED_MODULE_1__languages_js__["a" /* default */][this.lang] || __WEBPACK_IMPORTED_MODULE_1__languages_js__["a" /* default */]['en'];
    },
    innerPlaceholder: function innerPlaceholder() {
      return this.placeholder || (this.range ? this.translation.placeholder.dateRange : this.translation.placeholder.date);
    },
    text: function text() {
      if (!this.range && this.isValidDate(this.value)) {
        return this.stringify(this.value);
      }
      if (this.range && this.isValidRange(this.value)) {
        return this.stringify(this.value[0]) + ' → ' + this.stringify(this.value[1]);
      }
      return '';
    }
  },
  methods: {
    changeDate: function changeDate(e) {
      this.$emit('input', e.target.value);
    },
    keyMonitor: function keyMonitor() {
      if (this.$refs.input.value === '') {
        this.$emit('input', '');
      }
    },
    updateDate: function updateDate() {
      var val = this.currentValue;
      if (!this.range && val || this.range && val[0] && val[1]) {
        this.$emit('input', val);
        console.log(this.value, this.currentValue);
        this.$emit('update-date', this.stringify(val[0]) + '_' + this.stringify(val[1]));
      }
    },
    selectShortcut: function selectShortcut(key) {
      var date = null;
      switch (key) {
        case 'today':
          date = global.moment();
          break;
        case 'yesterday':
          date = global.moment().subtract(1, 'day');
          break;
      }
      this.$emit('input', global.moment(date).format('YYYY-MM-DD'));
    },
    confirmDate: function confirmDate() {
      this.updateDate();
      this.closePopup();
      this.$emit('confirm');
    },
    selectDate: function selectDate() {
      if (!this.confirm) {
        this.updateDate();
        if (this.type === 'date' && !this.range) {
          this.closePopup();
        }
      }
    },
    closePopup: function closePopup() {
      this.showPopup = false;
      this.$emit('close-popup');
    },
    togglePopup: function togglePopup() {
      if (this.showPopup) {
        this.$refs.input && this.$refs.input.blur();
        this.showPopup = false;
      } else {
        this.$refs.input && this.$refs.input.focus();
        this.showPopup = true;
      }
    },
    clickIcon: function clickIcon() {
      if (!this.disabled) {
        this.togglePopup();
        this.$emit('toggle-popup');
      }
    },
    formatDate: function formatDate(date, fmt) {
      var map = {
        'M+': date.getMonth() + 1,
        '[Dd]+': date.getDate(),
        '[Hh]+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds()
      };
      var str = fmt.replace(/[Yy]+/g, function (str) {
        return ('' + date.getFullYear()).slice(4 - str.length);
      });
      Object.keys(map).forEach(function (key) {
        str = str.replace(new RegExp(key), function (str) {
          var value = '' + map[key];
          return str.length === 1 ? value : ('00' + value).slice(value.length);
        });
      });
      return str;
    },
    stringify: function stringify(date) {
      var val = date;
      if (typeof val === 'string' && ~val.indexOf('/Date(')) {
        val = val.split('Date(') && val.split('Date(')[1].split(')')[0];
        val = +val;
      }
      return global.moment(val).format(this.format || this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat);
    },
    isValidDate: function isValidDate(date) {
      var val = date;
      if (typeof val === 'string' && ~val.indexOf('/Date(')) {
        val = val.split('Date(') && val.split('Date(')[1].split(')')[0];
        val = +val;
      }
      return !!new Date(val).getTime();
    },
    isValidRange: function isValidRange(date) {
      return Array.isArray(date) && date.length === 2 && this.isValidDate(date[0]) && this.isValidDate(date[1]);
    },
    selectRange: function selectRange(range) {
      var start = global.moment(range.start).format('YYYY-MM-DD');
      var end = global.moment(range.end).format('YYYY-MM-DD');
      this.$emit('input', [start, end]);
      this.$emit('update-date', "".concat(start, "_").concat(end));
      this.$emit('inputRange', {
        start: start,
        end: end,
        preset: range.key
      });
    },
    initRanges: function initRanges() {
      if (Array.isArray(this.shortcuts)) {
        this.ranges = this.shortcuts;
      } else if (this.shortcuts) {
        var hasFiscalYears = this.$user.sessionSettings.FiscalQuarters && this.$user.sessionSettings.FiscalQuarters.length;
        var currentDate = new Date();
        var year = currentDate.getFullYear();
        var month = currentDate.getMonth();
        var day = currentDate.getDate();
        var dow = currentDate.getDay();
        var thisWeekStart = new Date(year, month, day - dow);
        var thisWeekEnd = new Date(year, month, day - dow + 6);
        var thisMonthStart = new Date(year, month, 1);
        var thisMonthEnd = new Date(year, month + 1, 0);
        var last1MonthStart = new Date(year, month - 1, day + 1);
        var last3MonthsStart = new Date(year, month - 3, day + 1);
        this.ranges = [{
          key: 'Today',
          text: 'Today',
          start: currentDate,
          end: currentDate
        }, {
          key: 'ThisWeek',
          text: 'This Week',
          start: thisWeekStart,
          end: thisWeekEnd
        }, {
          key: 'ThisMonth',
          text: 'This Month',
          start: thisMonthStart,
          end: thisMonthEnd
        }, hasFiscalYears ? {
          key: 'ThisQuarter',
          text: 'This Fiscal Quarter',
          start: this.getFiscalQuarter(0).st,
          end: this.getFiscalQuarter(0).end
        } : {
          key: 'ThisQuarter',
          text: 'This Quarter',
          start: this.getQuarterStart(0),
          end: this.getQuarterEnd(0)
        }, hasFiscalYears ? {
          key: 'ThisYear',
          text: 'This Fiscal Year',
          start: this.getFiscalYear(0).st,
          end: this.getFiscalYear(0).end
        } : {
          key: 'ThisYear',
          text: 'This Year',
          start: this.getYearStart(0),
          end: this.getYearEnd(0)
        }, {
          key: 'Last1Month',
          text: '1-Month',
          start: last1MonthStart,
          end: currentDate
        }, {
          key: 'Last3Months',
          text: '3-Months',
          start: last3MonthsStart,
          end: currentDate
        }, hasFiscalYears ? {
          key: 'LastQuarter',
          text: 'Last Fiscal Quarter',
          start: this.getFiscalQuarter(-1).st,
          end: this.getFiscalQuarter(-1).end
        } : {
          key: 'LastQuarter',
          text: 'Last Quarter',
          start: this.getQuarterStart(-1),
          end: this.getQuarterEnd(-1)
        }, hasFiscalYears ? {
          key: 'LastYear',
          text: 'Last Fiscal Year',
          start: this.getFiscalYear(-1).st,
          end: this.getFiscalYear(-1).end
        } : {
          key: 'LastYear',
          text: 'Last Year',
          start: this.getYearStart(-1),
          end: this.getYearEnd(-1)
        }, hasFiscalYears ? {
          key: 'Last2Years',
          text: 'Last 2 Fiscal Years',
          start: this.getFiscalYear(-2).st,
          end: this.getFiscalYear(-1).end
        } : {
          key: 'Last2Years',
          text: 'Last 2 Years',
          start: this.getYearStart(-2),
          end: this.getYearEnd(-1)
        }];
      } else {
        this.ranges = [];
      }
    },
    setPreset: function setPreset(range) {
      for (var i = 0, n = this.ranges.length; i < n; i++) {
        if (this.ranges[i].key === range) {
          this.selectRange(this.ranges[i]);
        }
      }
    },
    moveToPrevRange: function moveToPrevRange() {
      var st = global.moment(this.currentValue[0]);
      var end = global.moment(this.currentValue[1]);
      var abort = false;
      var delta = this.calcDelta();
      switch (delta.deltaUnit) {
        case 'day':
          {
            st.subtract(delta.delta, 'd');
            end.subtract(delta.delta, 'd');
            break;
          }
        case 'month':
          {
            st.subtract(delta.delta, 'M');
            end.subtract(delta.delta, 'M').endOf('month');
            break;
          }
        case 'year':
          {
            st.subtract(delta.delta, 'y');
            end.subtract(delta.delta, 'y');
            break;
          }
        case 'fquarter':
          {
            var fiscalQuarters = this.$user.sessionSettings.FiscalQuarters;
            var n = fiscalQuarters.length;
            for (var i = 0; i < n; i++) {
              var fs = global.moment(fiscalQuarters[i].StartQtr);
              if (st.isSame(fs)) {
                if (i > 0) {
                  st = global.moment(fiscalQuarters[i - 1].StartQtr);
                  end = global.moment(fiscalQuarters[i - 1].EndQtr);
                } else {
                  abort = true;
                }
                break;
              }
            }
            break;
          }
        case 'fyear':
          {
            var _fiscalQuarters = this.$user.sessionSettings.FiscalQuarters;
            var _n = _fiscalQuarters.length;
            for (var _i = 0; _i < _n; _i++) {
              var _fs = global.moment(_fiscalQuarters[_i].StartQtr);
              if (st.isSame(_fs)) {
                var q = [];
                var y = _fiscalQuarters[_i].FiscalYr / 1 - delta.delta;
                for (var j = 0; j < _n; j++) {
                  if (_fiscalQuarters[j].FiscalYr / 1 === y || _fiscalQuarters[j].FiscalYr / 1 === y + delta.delta - 1) {
                    q.push(_fiscalQuarters[j]);
                  }
                }
                if (q.length > 0) {
                  st = global.moment(q[0].StartQtr);
                  end = global.moment(q[q.length - 1].EndQtr);
                } else {
                  abort = true;
                }
                break;
              }
            }
            break;
          }
      }
      if (!abort) {
        this.selectRange({
          start: st.toDate(),
          end: end.toDate()
        });
      }
    },
    moveToNextRange: function moveToNextRange() {
      var st = global.moment(this.currentValue[0]);
      var end = global.moment(this.currentValue[1]);
      var abort = false;
      var delta = this.calcDelta();
      switch (delta.deltaUnit) {
        case 'day':
          {
            st.add(delta.delta, 'd');
            end.add(delta.delta, 'd');
            break;
          }
        case 'month':
          {
            st.add(delta.delta, 'M');
            end.add(delta.delta, 'M').endOf('month');
            break;
          }
        case 'year':
          {
            st.add(delta.delta, 'y');
            end.add(delta.delta, 'y');
            break;
          }
        case 'fquarter':
          {
            var fiscalQuarters = this.$user.sessionSettings.FiscalQuarters;
            var n = fiscalQuarters.length;
            for (var i = 0; i < n; i++) {
              var fs = global.moment(fiscalQuarters[i].StartQtr);
              if (st.isSame(fs)) {
                if (i < n - 1) {
                  st = global.moment(fiscalQuarters[i + 1].StartQtr);
                  end = global.moment(fiscalQuarters[i + 1].EndQtr);
                } else {
                  abort = true;
                }
                break;
              }
            }
            break;
          }
        case 'fyear':
          {
            var _fiscalQuarters2 = this.$user.sessionSettings.FiscalQuarters;
            var _n2 = _fiscalQuarters2.length;
            for (var _i2 = 0; _i2 < _n2; _i2++) {
              var _fs2 = global.moment(_fiscalQuarters2[_i2].StartQtr);
              if (st.isSame(_fs2)) {
                var q = [];
                var y = _fiscalQuarters2[_i2].FiscalYr / 1 + delta.delta;
                for (var j = 0; j < _n2; j++) {
                  if (_fiscalQuarters2[j].FiscalYr / 1 === y || _fiscalQuarters2[j].FiscalYr / 1 === y + delta.delta - 1) {
                    q.push(_fiscalQuarters2[j]);
                  }
                }
                if (q.length > 0) {
                  st = global.moment(q[0].StartQtr);
                  end = global.moment(q[q.length - 1].EndQtr);
                } else {
                  abort = true;
                }
                break;
              }
            }
            break;
          }
      }
      if (!abort) {
        this.selectRange({
          start: st.toDate(),
          end: end.toDate()
        });
      }
    },
    calcDelta: function calcDelta() {
      var fiscalQuarters = this.$user.sessionSettings.FiscalQuarters;
      var n = fiscalQuarters.length;
      var st = global.moment(this.currentValue[0]);
      var end = global.moment(this.currentValue[1]);
      var delta = end.diff(st, 'days') + 1;
      var deltaUnit = 'day';
      if (st.date() === 1 && global.moment(end).endOf('month').date() === end.date()) {
        delta = (end.year() - st.year()) * 12 + end.month() - st.month() + 1;
        deltaUnit = 'month';
      } else if (st.date() === 1 && st.month() === 0 && end.date() === 31 && end.month() === 11) {
        delta = end.year() - st.year() + 1;
        deltaUnit = 'year';
      }
      if (n > 0) {
        var q1 = null;
        var q2 = null;
        for (var i = 0; i < n; i++) {
          if (global.moment(fiscalQuarters[i].StartQtr).isSame(st)) {
            q1 = fiscalQuarters[i];
          }
          if (global.moment(fiscalQuarters[i].EndQtr).isSame(end)) {
            q2 = fiscalQuarters[i];
          }
        }
        if (q1 != null && q2 != null) {
          if (q1.FiscalYr === q2.FiscalYr && q1.FiscalQtr === q2.FiscalQtr) {
            delta = 1;
            deltaUnit = 'fquarter';
          } else if (q1.FiscalQtr === 'Q1' && q2.FiscalQtr === 'Q4') {
            delta = q2.FiscalYr / 1 - q1.FiscalYr / 1 + 1;
            deltaUnit = 'fyear';
          }
        }
      }
      return {
        delta: delta,
        deltaUnit: deltaUnit
      };
    },
    getQuarterStart: function getQuarterStart(offset) {
      var date = new Date();
      var startMonth = Math.floor(date.getMonth() / 3 + offset) * 3;
      return new Date(date.getFullYear(), startMonth, 1);
    },
    getQuarterEnd: function getQuarterEnd(offset) {
      var date = new Date();
      var startMonth = Math.floor(date.getMonth() / 3 + offset) * 3 + 3;
      return new Date(date.getFullYear(), startMonth, 0);
    },
    getYearStart: function getYearStart(offset) {
      var year = new Date().getFullYear();
      return new Date(year + offset, 0, 1);
    },
    getYearEnd: function getYearEnd(offset) {
      var year = new Date().getFullYear();
      return new Date(year + offset, 11, 31);
    },
    getFiscalQuarter: function getFiscalQuarter(offset) {
      var fiscalQuarters = this.$user.sessionSettings.FiscalQuarters;
      var n = fiscalQuarters.length;
      var currentDate = global.moment(new Date());
      for (var i = 0; i < n; i++) {
        var fs = global.moment(fiscalQuarters[i].StartQtr);
        var fe = global.moment(fiscalQuarters[i].EndQtr);
        if (currentDate.isBetween(fs, fe)) {
          if (offset < 0 && i + offset >= 0) {
            fs = global.moment(fiscalQuarters[i + offset].StartQtr);
            fe = global.moment(fiscalQuarters[i + offset].EndQtr);
          }
          return {
            st: fs,
            end: fe
          };
        }
      }
      return {
        st: this.getQuarterStart(offset),
        end: this.getQuarterEnd(offset)
      };
    },
    getFiscalYear: function getFiscalYear(offset) {
      var fiscalQuarters = this.$user.sessionSettings.FiscalQuarters;
      var n = fiscalQuarters.length;
      var currentDate = global.moment(new Date());
      var q = [];
      for (var i = 0; i < n; i++) {
        var fs = global.moment(fiscalQuarters[i].StartQtr);
        var fe = global.moment(fiscalQuarters[i].EndQtr);
        if (currentDate.isBetween(fs, fe)) {
          for (var j = 0; j < n; j++) {
            if (fiscalQuarters[j].FiscalYr / 1 === fiscalQuarters[i].FiscalYr / 1 + offset) {
              q.push(fiscalQuarters[j]);
            }
          }
        }
      }
      if (q.length) {
        return {
          st: global.moment(q[0].StartQtr),
          end: global.moment(q[q.length - 1].EndQtr)
        };
      } else if (offset < 0) {
        return this.getFiscalYear(offset + 1);
      } else {
        return {
          st: this.getYearStart(offset),
          end: this.getYearEnd(offset)
        };
      }
    },
    displayPopup: function displayPopup() {
      // force display position
      if (this.placement) {
        switch (this.placement) {
          case 'top':
            this.position = {
              left: 0,
              bottom: '100%'
            };
            break;
          case 'bottom':
            this.position = {
              left: 0,
              top: '100%'
            };
            break;
          default:
            this.position = {
              left: 0,
              top: 0
            };
        }
        return;
      }
      var dw = document.documentElement.clientWidth;
      var dh = document.documentElement.clientHeight;
      var InputRect = this.$el.getBoundingClientRect();
      var PopupRect = this.$refs.calendar.getBoundingClientRect();
      this.position = {};
      if (dw - InputRect.left < PopupRect.width && InputRect.right < PopupRect.width) {
        this.position.left = 1 - InputRect.left + 'px';
      } else if (InputRect.left + InputRect.width / 2 <= dw / 2) {
        this.position.left = 0;
      } else {
        this.position.right = 0;
      }
      if (InputRect.top <= PopupRect.height + 1 && dh - InputRect.bottom <= PopupRect.height + 1) {
        this.position.top = dh - InputRect.top - PopupRect.height - 1 + 'px';
      } else if (InputRect.top + InputRect.height / 2 <= dh / 2) {
        this.position.top = '100%';
      } else {
        this.position.bottom = '100%';
      }
    }
  },
  created: function created() {
    var val = this.value;
    if (typeof val === 'string' && ~val.indexOf('/Date(')) {
      val = val.split('Date(') && val.split('Date(')[1].split(')')[0];
      this.currentValue = +val;
    }
    this.initRanges();
  },
  directives: {
    focus: {
      inserted: function inserted(el, binding) {
        if (binding.value) el.focus();else el.blur();
      },
      componentUpdated: function componentUpdated(el, binding) {
        if (binding.modifiers.lazy) {
          if (Boolean(binding.value) === Boolean(binding.oldValue)) {
            return;
          }
        }
        if (binding.value) el.focus();else el.blur();
      }
    },
    clickoutside: {
      bind: function bind(el, binding, vnode) {
        el['@clickoutside'] = function (e) {
          if (!el.contains(e.target) && binding.expression && vnode.context[binding.expression]) {
            binding.value();
          }
        };
        document.addEventListener('click', el['@clickoutside'], true);
      },
      unbind: function unbind(el) {
        document.removeEventListener('click', el['@clickoutside'], true);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "RR0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_column_selector_vue__ = __webpack_require__("nleJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1475340_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_column_selector_vue__ = __webpack_require__("S0T1");
function injectStyle (ssrContext) {
  __webpack_require__("k53z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c1475340"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_column_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1475340_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_column_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RTk+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ycoi");
/* empty harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "RWJl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navless-layout-header"},[_vm._t("navbar",function(){return [_c('ed-button',{attrs:{"to":_vm.$routerHistory.previous().path}},[_c('i',{staticClass:"fal fa-chevron-left"}),_vm._v("\n         \n        Back\n      ")]),_vm._v(" "),_c('a',{staticClass:"pull-right list submit-btn",class:{ 'disabled': _vm.isDisabled },on:{"click":_vm.addFunds}},[_c('strong',[_vm._v("Submit")])]),_vm._v(" "),_c('span',{staticClass:"center-span"},[_vm._v(_vm._s(_vm.isUserAdmin ? 'Add Funds' : 'Request Funds'))])]})],2),_vm._v(" "),_c('div',{attrs:{"slot":"body","endpoint":_vm.loadingEndpoint},slot:"body"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("Your request will be sent to your card administrator for approval.")]),_vm._v(" "),(_vm.isUserAdmin)?_c('div',[_c('label',[_vm._v("Current Balance")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-money',{staticClass:"small",attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.accBalance))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1):_vm._e(),_vm._v(" "),_c('label',[_vm._v("Funding Amount")]),_vm._v(" "),_c('ed-input',{attrs:{"type":"money","amount":""},model:{value:(_vm.fundingAmount),callback:function ($$v) {_vm.fundingAmount=$$v},expression:"fundingAmount"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rbff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountRefillSettings_vue__ = __webpack_require__("QCk8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_057a19ba_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountRefillSettings_vue__ = __webpack_require__("5cCA");
function injectStyle (ssrContext) {
  __webpack_require__("agw4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-057a19ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountRefillSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_057a19ba_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountRefillSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rdd0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rdqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("bWaD");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02dff8d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("CHSV");
function injectStyle (ssrContext) {
  __webpack_require__("DRAn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02dff8d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02dff8d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Rj8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_condition_vue__ = __webpack_require__("Jpw2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc1272b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_condition_vue__ = __webpack_require__("+mp+");
function injectStyle (ssrContext) {
  __webpack_require__("+gd8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc1272b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_condition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc1272b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_condition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rjnk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('grid',{ref:"FundingAddressesGrid",attrs:{"label":"Funding Address","model":_vm.model,"name":"","desc":"","search":"","views":false,"resizing":false,"layout":"frame","endpoint":_vm.api.$.FundingInvoiceAndApSetting.getFundingAddresses,"actions":_vm.actions,"remove-many":"","fit-columns":"","footer":""},on:{"editRow":function($event){return _vm.openAddEditAddress($event)},"removeRow":_vm.removeFundingAddress,"removeRows":_vm.removeMultipleFundingAddresses}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.disableSingleButton},on:{"click":function($event){return _vm.openAddEditAddress()}}},[_vm._v("\n            Add New Address\n          ")])],1)]),_vm._v(" "),(_vm.showAddEditAddress)?_c('AddEditFundingAddress',{attrs:{"model":_vm.fundingAddressModel,"showModal":_vm.showAddEditAddress},on:{"close":function($event){_vm.showAddEditAddress = false},"save":_vm.onSave}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RlAP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json__ = __webpack_require__("ZVSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_user__ = __webpack_require__("uduW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_legacy_auth__ = __webpack_require__("mnjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_intercom__ = __webpack_require__("dmNr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_salesforce__ = __webpack_require__("CuX/");
//
//
//
//

/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */




// import { EventBus } from '@/event-bus'



var allowedModules = __WEBPACK_IMPORTED_MODULE_2__core_legacy_auth__["a" /* default */].allowedModules;
/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$route.query.ReturnUrl || this.polyfillParent();
    if (__WEBPACK_IMPORTED_MODULE_1__core_user__["a" /* default */].get() && !this.$route.query.ReturnUrl) {
      this.findPath();
    } else {
      this.gotoLogin();
    }
  },
  methods: {
    /**
     * Provide legacy utility functions to global namespace
     *
     */
    polyfillParent: function polyfillParent() {
      /* this.$nextTick(() => {
        let updateHashCopy = this.updateHash
        if (this.updateHash) {
          this.updateHash = function () {
            EventBus.$emit('navigated', global.frames['NetFrame'].location.href)
            updateHashCopy()
          }
          this.$forceUpdate()
        }
      }) */

      var vm = this;
      if (__WEBPACK_IMPORTED_MODULE_1__core_user__["a" /* default */].get()) {
        // Page
        global.Page = {
          BankAccount: __WEBPACK_IMPORTED_MODULE_1__core_user__["a" /* default */].get().hasBankAccount,
          VendorType: __WEBPACK_IMPORTED_MODULE_1__core_user__["a" /* default */].get().subscription,
          InvoicePrefHidden: __WEBPACK_IMPORTED_MODULE_1__core_user__["a" /* default */].get().invoicePrefHidden,
          MarketTypeHidden: {
            value: __WEBPACK_IMPORTED_MODULE_1__core_user__["a" /* default */].get().domain
          },
          // TODO:
          // check if always 1
          IsCompany: {
            value: 1
          },
          navigateToPage: function navigateToPage(page, keepParams) {
            //
            // console.info('legacy navigateToPage called')
            global.frames['NetFrame'].location.href = "".concat(global.app.api.env, "/").concat(page);
          },
          showTabs: function showTabs(section, tab, param, force) {
            //
            // console.info((tab || section) ? `legacy showTabs called with ${section} ${tab}` : 'cleared legacy tabs')

            // go to Dashboard
            if (section === 'HomeEO') {
              vm.$router.push('/home');
            }
            if (section === 'Commerce' || section === 'Sourcing') {
              // vm.$router.push({ params: { action: '--' } })
            }

            // go to Programs subtab if called with only 'Commerce' section
            if (section === 'Commerce' && !tab && !param) {
              vm.$router.push({
                params: {
                  action: '--'
                }
              });
              vm.$root.legacyTab = 'Commerce';
              vm.$root.legacySubtab = 'Programs';
              return;
            }
            // go to Programs subtab if called with only 'Invoices' section
            if (section === 'Invoices' && !tab && !param) {
              vm.$router.push({
                params: {
                  action: '--'
                }
              });
              vm.$root.legacyTab = 'Invoices';
              vm.$root.legacySubtab = 'Invoices';
              return;
            }

            // php redirects
            if (tab && ~tab.indexOf('common.')) {
              tab = tab.replace('common.', '../?page=common.');
              vm.$router.push({
                params: {
                  action: '--'
                }
              });
            } else {
              // FIXME:
              // added param to be able to navigate back
              if (tab && !param && force !== null) {
                vm.$router.push({
                  params: {
                    action: '__'
                  }
                });
              }
            }

            //
            if (global.frames['NetFrame'] && tab && !param && force !== null) {
              global.frames['NetFrame'].location.href = "".concat(global.app.api.env, "/").concat(tab);
            }
            if (param && section && force !== null) {
              vm.$router.push("/i/".concat(section, "/?goto=").concat(param, "&noRedir=1"));
            }

            // map back legacy php
            if (tab) {
              tab = tab.replace('../?page=', '');
            }

            // make tabs/subtabs active
            vm.$root.legacyTab = section;
            vm.$root.legacySubtab = tab;
          }
        };
        __WEBPACK_IMPORTED_MODULE_3__components_intercom__["a" /* default */].setup();
      }
      global.showOverlay = function () {
        document.body.setAttribute('legacy-modal', true);
        document.querySelector('.dawn-title-nav.sticky') && document.querySelector('.dawn-title-nav.sticky').classList.remove('sticky');
      };
      global.hideOverlay = function () {
        document.body.setAttribute('legacy-modal', false);
      };

      // legacy sticky sidebar
      function stickyScrollHandler($) {
        window.topNavHeight = 145;
        var viewport = document.querySelector('.main-panel');
        viewport && viewport.addEventListener('scroll', function (e) {
          if (!$('body').hasClass('pp-sticky-listen') || document.documentMode) {
            return;
          }
          var $sidebar = $('#iframe iframe').contents().find('.sticky[id]:visible');
          _stick2($sidebar, viewport.scrollTop);
          _resize($sidebar, viewport.scrollTop, -70);
        });
        function _stick2($el, pos) {
          var topOffset = pos > window.topNavHeight ? pos - window.topNavHeight : 0;
          if (topOffset) {
            $el.addClass('floated');
            $('#content').addClass('fixed-bar');
          } else {
            $el.removeClass('floated');
            $('#content').removeClass('fixed-bar');
          }
          $el.css({
            transform: 'translateY(' + topOffset + 'px)'
          });
        }
        function _resize($el, pos, offset, $list) {
          var topOffset = offset || 0;
          if (typeof $list !== 'undefined') {
            $list.css('min-height', $el.height() + 100);
          }
          $el.css({
            height: window.innerHeight - (pos > window.topNavHeight ? topOffset + 70 : window.topNavHeight - pos)
          });
        }
      }
      global.jQuery(function () {
        stickyScrollHandler(global.jQuery);
      });
      __WEBPACK_IMPORTED_MODULE_3__components_intercom__["a" /* default */].init();
      __WEBPACK_IMPORTED_MODULE_4__components_salesforce__["a" /* default */].init();
    },
    /**
     * Handle legacy links
     * Route to corresponding module based on query string parameters
     *
     * @summary Redirect legacy links
     */
    findPath: function findPath() {
      allowedModules.get || allowedModules();
      var route = this.$route.query;
      var tab = route.goToPage;
      var subtab = route.tab;
      var page = route.param || route.id;
      if (subtab && subtab.indexOf('_') > -1) {
        if (__WEBPACK_IMPORTED_MODULE_1__core_user__["a" /* default */].get().domain === '1') {
          page = page.split('_')[1];
          subtab = subtab.split('_')[1];
        } else {
          page = page.split('_')[0];
          subtab = subtab.split('_')[0];
        }
      }
      if (tab === 'app') {
        this.$router.push(subtab);
        return;
      }

      // TODO:
      // this should use original query params (ie. goToPage
      var pageToLoadFromReport = route.pageToLoadFromReport;
      if (pageToLoadFromReport) {
        global.Page.showTabs('Programs', pageToLoadFromReport.split('__')[0], pageToLoadFromReport.split('__')[1]);
        return;
      }
      var tabsMap = Object.keys(allowedModules.get);
      var maintab = tabsMap.filter(function (k) {
        return allowedModules.get[k].label === tab;
      })[0];
      var section = __WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json___default.a[maintab] && __WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json___default.a[maintab].pack && (__WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json___default.a[maintab].pack[subtab] || __WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json___default.a[maintab].pack['#' + subtab]).name;
      if (!(__WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json___default.a[maintab] && __WEBPACK_IMPORTED_MODULE_0__core_site_map_map_json___default.a[maintab].pack)) section = subtab;
      if (page && maintab || section) {
        var prettyPage = page ? page.replace(/\//g, '--') : section;
        this.$router.push({
          name: '_allModules',
          params: {
            namespace: 'i',
            page: maintab,
            section: prettyPage
          }
        });
        return;
      }
      if (tab === 'undefined') {
        this.$router.push('/home');
        return;
      }
      if (maintab) {
        console.log('About to go to', maintab, section);
        this.$router.push({
          name: '_allModules',
          params: {
            namespace: 'd',
            page: maintab,
            section: section
          }
        });
      } else {
        this.$router.push('/home');
      }
    },
    /**
     * Handle external login links
     * If user is not present, redirect to login module
     * with all necessary query string parameters
     *
     * @summary Login from e-mails
     */
    gotoLogin: function gotoLogin() {
      var route = this.$route.query;
      var tab = route.goToPage || '0';
      var subtab = route.tab || '0';
      var page = route.param;
      var sk = route.sk || '';
      var redir = route.redirectUrl;
      var Redir = route.ReturnUrl;
      if (redir) {
        global.location.href = "".concat(this.api.env, "/").concat(redir);
        return;
      }
      if (Redir) {
        if (global.parent.app.$router) {
          global.parent.app.$user.logout(true);
          global.parent.app.$router.push({
            name: 'login',
            query: {
              returnUrl: "".concat(global.parent.location.href),
              noRedir: '1'
            }
          });
        } else {
          this.$router.push({
            name: 'login',
            query: {
              returnUrl: "".concat(this.api.env, "/..").concat(Redir),
              noRedir: '1'
            }
          });
        }
        return;
      }
      var prettyPage = page ? page.replace(/\//g, '--') : '';
      this.$router.push({
        name: 'login',
        query: {
          returnUrl: this.getReturnUrl(tab, subtab, prettyPage),
          sk: sk,
          noRedir: '1'
        }
      });
    },
    getReturnUrl: function getReturnUrl(tab, subtab, prettyPage) {
      if (tab === 'app') {
        return subtab;
      } else {
        return "".concat(tab, "__").concat(subtab, "__").concat(prettyPage);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "RoRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardRejectInfo_vue__ = __webpack_require__("UyIF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cdc4daf_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardRejectInfo_vue__ = __webpack_require__("mmgJ");
function injectStyle (ssrContext) {
  __webpack_require__("XrRE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cdc4daf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardRejectInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cdc4daf_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardRejectInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RoUj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticStyle:{"margin-bottom":"10px"},attrs:{"button-class":_vm.buttonClass,"ids":_vm.ids,"disabled":_vm.disabled},on:{"click":function($event){_vm.showReject = true}}},[_vm._v("\n    Decline\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Decline Card","show":_vm.showReject,"validation":"","primary-button":"Decline","primaryButtonClass":"btn btn-danger","modalEndpoint":_vm.api.$.evedpaycard.approveOrReject},on:{"close":function($event){_vm.showReject = false, _vm.rejectReason = ''},"confirm":function($event){return _vm.approveOrReject()},"validate":_vm.approveOrReject}},[_c('div',{staticClass:"reject-card-overlay",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Provide a reason for declining the card.")]),_vm._v(" "),_c('label',[_vm._v("Reason")]),_vm._v(" "),_c('ed-input',{attrs:{"type":"text"},on:{"input":function (value) { return _vm.rejectReason = value; }},model:{value:(_vm.rejectReason),callback:function ($$v) {_vm.rejectReason=$$v},expression:"rejectReason"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rpzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"show":_vm.showModal,"title":_vm.title,"type":"medium","flat":""},on:{"close":function($event){return _vm.$emit('close')},"beforeshow":_vm.onShow}},[_c('div',{staticClass:"content",attrs:{"slot":"body"},slot:"body"},[_c('itemsList',{attrs:{"list":_vm.list,"programLabel":_vm.programLabel}}),_vm._v(" "),_c('div',{staticClass:"row bottom-row"},[_c('ed-textarea',{ref:"reasonInput",staticClass:"col-md-7 row",attrs:{"field-label":"Reason","placeholder":_vm.subtitle,"maxlength":1000,"rows":4,"required":"","autofocus":"","error":_vm.error},on:{"input":_vm.validate},model:{value:(_vm.reason),callback:function ($$v) {_vm.reason=$$v},expression:"reason"}}),_vm._v(" "),_c('userInfo',{attrs:{"title":_vm.rejectText}}),_vm._v(" "),(!_vm.isEvedPayCardPresent)?_c('ed-checkbox',{staticClass:"col-md-7",attrs:{"options":_vm.notifySupplierOption,"name":"notify_supplier","helptip-body":_vm.notifySupplierOption[0].label},on:{"click":_vm.changeNotifySupplier}}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"buttons clear",attrs:{"slot":"footer"},slot:"footer"},[_c('ed-button',{attrs:{"button-class":"btn btn-default"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('ed-button',{on:{"click":_vm.reject}},[_vm._v(_vm._s(_vm.rejectText))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rs/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_vue__ = __webpack_require__("0R6Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2c8fe0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_action_vue__ = __webpack_require__("yynm");
function injectStyle (ssrContext) {
  __webpack_require__("kU6Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f2c8fe0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2c8fe0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_action_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S+iE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wrapper"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:({ content: _vm.tooltipContent, contentHtml: true }),expression:"{ content: tooltipContent, contentHtml: true }",modifiers:{"bottom":true}}],style:({ color: _vm.isRejected ? 'red' : 'inherit' })},[_vm._v("\n    "+_vm._s(_vm.displayValue)+"\n    "),(_vm.isRejected)?_c('i',{staticClass:"fas fa-info-circle"}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S0T1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('Show/Hide Columns'),expression:"'Show/Hide Columns'",modifiers:{"bottom":true}},{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.closeColumnSelector),expression:"closeColumnSelector"}],staticClass:"column-selector dropdown",class:{ open : _vm.isColumnSelectorOpened }},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"},on:{"click":function($event){$event.preventDefault();return _vm.openColumnSelector.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-columns"})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isColumnSelectorOpened),expression:"isColumnSelectorOpened"}],staticClass:"dropdown-menu"},[_c('div',{staticClass:"column selector grid-filter"},[_c('p',{staticClass:"column-title"},[_vm._v(_vm._s(_vm.t('Show') + '/' + _vm.t('Hide') + ' ' + _vm.t('Columns')))]),_c('ed-input',{ref:'input',attrs:{"placeholder":_vm.t("Search"),"search":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"list col-md-6"},[_c('p',{staticClass:"column-title"},[_vm._v(_vm._s(_vm.t('Hidden') + ' ' + _vm.t('Columns')))]),_c('transition-group',{staticClass:"scroller source",attrs:{"name":"list","tag":"ul","placeholder":_vm.$t("Nothing to show")},on:{"afterEnter":_vm.updateScroll,"afterLeave":_vm.updateScroll}},_vm._l((_vm.filteredColumns),function(column){return (column.hide && _vm.hiddenColumn(column))?_c('li',{key:column.field},[_c('span',[_vm._v(_vm._s(column.headerName))]),_c('ed-button',{staticClass:"btn btn-actionbar add-icon",on:{"click":function($event){return _vm.showColumn(column)}}},[_c('i',{staticClass:"fal fa-chevron-right"})])],1):_vm._e()}),0)],1),_c('div',{staticClass:"list col-md-6"},[_c('p',{staticClass:"column-title"},[_vm._v(_vm._s(_vm.t('Shown') + ' ' + _vm.t('Columns')))]),_c('transition-group',{staticClass:"scroller destination",attrs:{"name":"list","tag":"ul","placeholder":_vm.$t("Nothing to hide")},on:{"afterEnter":_vm.updateScroll,"afterLeave":_vm.updateScroll}},_vm._l((_vm.filteredColumns),function(column){return (!column.hide && _vm.hiddenColumn(column))?_c('li',{key:column.field},[_c('span',[_vm._v(_vm._s(column.headerName))]),_c('i',{staticClass:"fas fa-times-circle add-icon",on:{"click":function($event){return _vm.hideColumn(column)}}})]):_vm._e()}),0)],1)])]),_c('br'),(_vm.invalid)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("You cannot hide all columns.")]):_vm._e(),_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.apply}},[_vm._v(_vm._s(_vm.t('Apply')))]),_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.revert}},[_vm._v(_vm._s(_vm.t('clear.cancel')))]),_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.revertDefault}},[_vm._v(_vm._s(_vm.t('clear.default')))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SB93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-custom-cell ag-cell-list"},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:(_vm.tooltip),expression:"tooltip",modifiers:{"top":true}}],ref:"optionWrapper",staticClass:"trigger",on:{"click":_vm.showDetails}}),_c('div',{staticClass:"ag-custom-cell-value"},[_c('span',{ref:"optionLabel",staticClass:"option-text"},[_vm._v(_vm._s(_vm.val))]),(_vm.empty && _vm.showCaret)?_c('span',{staticClass:"description"},[_vm._v("Select "+_vm._s(_vm.placeholder))]):_vm._e()]),_vm._v("  "),(_vm.showCaret)?_c('i',{staticClass:"fas fa-caret-down ag-row-expand-icon pull-right",attrs:{"xv-tooltip.bottom":"\"Show more options\""},on:{"click":_vm.showDetails}}):_vm._e(),_c('div',{staticClass:"ag-row-details ag-menu fade",class:{ "shown": _vm.shownDetails },style:(_vm.position)},[_c('i',{staticClass:"ag-row-expand-close fal fa-times",on:{"click":_vm.showDetails}}),_c('div',{staticClass:"ag-row-details-content ag-filter"},[(_vm.shownDetails)?_c('list',{ref:"list",attrs:{"init":_vm.params},on:{"click":_vm.edit}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SC5H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2v77-s5CDMmyjSbqJtzRA8","Dell":"_3_IS5Eb4zO4gOtIZ4UCIBg","Abbott":"_1Y3dS7YHiaCHXLVwQ9pKqr","Gap":"_63r008kffgU8AhLImwfNr","Allstate":"_20-k6V_tY2nAtedEqmMBw-","Asurion":"rGEHwTEQ6yzxfn34uBfmK","Invitae":"ogLnvym5-el1-wD1BHmED","JWE":"_16k0xNQASXlfprxLZMkbfc"};

/***/ }),

/***/ "SD9d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_taxLine__ = __webpack_require__("rHCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LineItemStore_js__ = __webpack_require__("PJql");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddFeeTaxes' /* mandatory field */,

  components: {
    TaxLine: __WEBPACK_IMPORTED_MODULE_0__components_taxLine__["a" /* default */]
  },
  props: {
    model: Object,
    eventHub: Object,
    dependencies: Object
  },
  data: function data() {
    var _this = this;
    return {
      vm: this,
      store: function store() {
        return new __WEBPACK_IMPORTED_MODULE_1__LineItemStore_js__["a" /* default */](_this.api);
      },
      formData: {
        model: utils.copy(this.model)
      },
      show: true,
      saveButtonDisabled: false,
      validation: true,
      title: 'Add Taxes on Fee'
    };
  },
  computed: {
    currency: function currency() {
      return this.model.currency.code;
    }
  },
  methods: {
    onClose: function onClose() {
      this.eventHub.$emit('onCloseAddFeeTaxes', {});
      this.show = false;
    },
    onSave: function onSave() {
      this.eventHub.$emit('onAddedFeeTaxes', {
        eventData: this.formData.model
      });
      this.show = false;
    },
    computeDraftFeeTotal: function computeDraftFeeTotal() {
      var _this2 = this;
      var fee = this.formData.model;
      return this.store().computeFeeTotal(fee, this.model.currency).then(function (response) {
        fee = _this2.store().populateTotalsOnFee(fee, response.data.fee);
      });
    },
    getNamePercent: function getNamePercent(name) {
      return name + '_percent';
    },
    getNameAmount: function getNameAmount(name) {
      return name + '_amount';
    },
    getTaxId: function getTaxId(name) {
      return 'item_fee_tax_' + name;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "SDGU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SFkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model__ = __webpack_require__("k9gP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__core_events_events__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */]
  },
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__model___default.a
    };
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.APPROVAL_RULE.REFRESH, function (r) {
      _this.refresh();
    });
  },
  methods: {
    refresh: function refresh() {
      this.$refs.ApprovalHistoryGrid.quickSearch();
      this.$refs.ApprovalHistoryGrid.onSelectAll(false);
    }
  }
});

/***/ }),

/***/ "SLRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardStatus_vue__ = __webpack_require__("IIRD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_168e3ce3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardStatus_vue__ = __webpack_require__("5cYz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_168e3ce3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SN9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    hasReceipt: function hasReceipt() {
      return this.params.data && this.params.data.Receipt !== null;
    }
  }
});

/***/ }),

/***/ "SSWC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3wYKCc2-HFl-uh2JR9z2eM","Dell":"_2spW-se2X1FOcvQ8VEFHp3","Abbott":"R6-gxAE7ZZfFzgZWkjyTF","Gap":"_3PAuICTQ_M8jWwS3kAbE6q","Allstate":"_1wDWxyOuVCVL7hH2wjlwfh","Asurion":"_3RxZvYfhoALZfEvUKJg90X","Invitae":"_2k5bJrwBXnYoZ2W2qRoOgm","JWE":"_2jYa1ih-HdA2eHQhxJANYc"};

/***/ }),

/***/ "SUkm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("bSZ7");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14584210_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("+nXB");
function injectStyle (ssrContext) {
  __webpack_require__("ziuz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14584210_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Sdg6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SeHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer__ = __webpack_require__("BRZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules__ = __webpack_require__("vZ0M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_site_map__ = __webpack_require__("xwEy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__ = __webpack_require__("X3jq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_receiptScan_imageCompression__ = __webpack_require__("D1Zk");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var handleUserScalable = function handleUserScalable() {
  var meta = document.getElementById('layout-viewport');
  var hasEmbed = document.querySelector('iframe[srcdoc*="embed"]');
  if (hasEmbed) {
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.5, user-scalable=1';
  } else {
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0';
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MdFooter: __WEBPACK_IMPORTED_MODULE_2__components_Footer__["a" /* default */],
    SiteMap: __WEBPACK_IMPORTED_MODULE_4__core_site_map__["a" /* default */]
  },
  mounted: function mounted() {
    var currentTab = this.$refs.currentModule.children[0].__vue__;
    this.tabs = currentTab && currentTab.tabs || [];
    handleUserScalable();
  },
  beforeDestroy: function beforeDestroy() {
    // Clean up active poller on component destroy
    if (this.activePoller) {
      this.activePoller.cancel();
      this.activePoller = null;
    }
  },
  beforeCreate: function beforeCreate() {
    var meta = document.createElement('meta');
    meta.id = 'layout-viewport';
    meta.name = 'viewport';
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.5, user-scalable=1';
    document.head.appendChild(meta);
    global.config = {
      namespace: 'evedpay',
      layout: 'mobile',
      title: 'EvedPay',
      sitemap: {
        evedpay: {
          Cards: {
            alias: 'cards',
            subtabs: {
              Cards: 'Cards',
              Transactions: 'Transactions'
            }
          }
        }
      },
      enableThemes: true,
      start: '/evedpay'
    };
  },
  data: function data() {
    return {
      name: 'layout-navless',
      source: null,
      description: '',
      tabs: [],
      showActionSheet: false,
      uploadingReceipt: false,
      activePoller: null,
      // No Receipt Capture (PRODUCTDEV-5475): true only when EVERY division the
      // cardholder holds a card in has receipt scanning disabled. Resolved once on
      // created(); gates the FAB. Defaults false so the FAB shows until proven otherwise.
      receiptCaptureDisabled: false,
      // cardId -> DivisionId for the cardholder's cards (PRODUCTDEV-5475). Populated
      // by resolveReceiptCaptureDisabled() from the same cards fetch. Lets a FAB scan
      // launched from a specific card's page scope its match candidates to that card's
      // Division — mirroring the web desktop flow. Empty until resolved (→ broad pool).
      cardDivisionMap: {}
    };
  },
  computed: {
    loading: function loading() {
      return this.$loading;
    },
    showReceiptFab: function showReceiptFab() {
      if (!__WEBPACK_IMPORTED_MODULE_6__core_feature_flags_feature_flags__["a" /* default */].receiptScanPrefill) {
        return false;
      }
      // No Receipt Capture (PRODUCTDEV-5475): every accessible division disables capture.
      if (this.receiptCaptureDisabled) {
        return false;
      }
      if (this.uploadingReceipt || this.showActionSheet) {
        return false;
      }
      var path = this.$route.path || '';
      // '/details' does NOT match '/transactiondetails' (no leading '/' between compound word) — list it explicitly.
      var hiddenPaths = ['/settings', '/edit', '/details', '/submitreceipt', '/transactiondetails'];
      for (var i = 0; i < hiddenPaths.length; i++) {
        if (path.indexOf(hiddenPaths[i]) !== -1) {
          return false;
        }
      }
      return true;
    },
    pageName: function pageName() {
      var layout = this;
      var page = '';
      if (this.$route.params.section && __WEBPACK_IMPORTED_MODULE_3__components_modules__["a" /* default */][this.$route.params.page + '/' + this.$route.params.section]) {
        page = __WEBPACK_IMPORTED_MODULE_3__components_modules__["a" /* default */][this.$route.params.page + '/' + this.$route.params.section];
      } else {
        page = __WEBPACK_IMPORTED_MODULE_3__components_modules__["a" /* default */][this.$route.params.page];
      }
      if (page) {
        // When module is async, set description after load
        if (page.module && typeof page.module === 'function' && this.$route.params.action && __WEBPACK_IMPORTED_MODULE_3__components_modules__["a" /* default */][this.$route.params.section + '/' + this.$route.params.action]) {
          __WEBPACK_IMPORTED_MODULE_3__components_modules__["a" /* default */][this.$route.params.section + '/' + this.$route.params.action]().then(function (v) {
            if (v) {
              layout.description = v.description;
            }
          });
        }
        return page.module && typeof page.module !== 'function' && ' ' || page.module && page.module.description || (page.module && typeof page.module === 'function' ? '' : '');
      } else {
        return '';
      }
    }
  },
  created: function created() {
    var _this = this;
    if (this.$route.params.page && this.$route.params.section && this.$route.params.action) {
      this.$routerHistory.save(['/' + this.$route.params.namespace + '/' + this.$route.params.page + '/' + this.$route.params.section + '/', '/' + this.$route.params.namespace + '/' + this.$route.params.page + '/' + this.$route.params.section + '/' + this.$route.params.action]);
    }
    this.source = this.$route.query['back-to'] || this.$routerHistory.previous().path;
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$off('openAttachment');
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$on('openAttachment', function () {
      handleUserScalable();
    });
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$off('closeAttachment');
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$on('closeAttachment', function () {
      handleUserScalable();
    });

    // Listen for receipt scan completion
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$off('receipt-scan-started');
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$on('receipt-scan-started', function (payload) {
      _this.handleReceiptScanStarted(payload.data);
    });

    // The "Uploading receipt…" overlay covers the full upload + scan flow now
    // that SubmitReceipt no longer renders its own progress card. SubmitReceipt
    // emits 'submit-receipt-ready' the moment it has something to show —
    // candidates (isReady === true) or an error message — at which point we drop
    // the overlay and the user sees the SubmitReceipt page populated.
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$off('submit-receipt-ready');
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$on('submit-receipt-ready', function () {
      if (_this.uploadingReceipt) {
        _this.uploadingReceipt = false;
      }
    });

    // No Receipt Capture (PRODUCTDEV-5475): only worth resolving when the feature is on
    // (otherwise the FAB is already hidden). Resolves the per-division setting once.
    if (__WEBPACK_IMPORTED_MODULE_6__core_feature_flags_feature_flags__["a" /* default */].receiptScanPrefill) {
      this.resolveReceiptCaptureDisabled();
    }
  },
  methods: {
    cleanup: function cleanup() {
      // this.description = ''
      this.$destroy();
    },
    enterStep: function enterStep(tab) {
      //
    },
    openReceiptActionSheet: function openReceiptActionSheet() {
      this.showActionSheet = true;
    },
    closeActionSheet: function closeActionSheet() {
      this.showActionSheet = false;
    },
    openCamera: function openCamera() {
      this.showActionSheet = false;
      this.$refs.cameraInput.value = '';
      this.$refs.cameraInput.click();
    },
    openLibrary: function openLibrary() {
      this.showActionSheet = false;
      this.$refs.libraryInput.value = '';
      this.$refs.libraryInput.click();
    },
    // Division to scope a FAB scan's match candidates to (PRODUCTDEV-5475). When the
    // FAB is launched from a specific card's page the route carries `?cardid=`, so we
    // scope to that card's Division — the suggested transactions then match the web
    // desktop flow, which always uploads within a Division (account.DivisionId) and
    // sends uploadContextLegacyDivisionId. Global tabs (no cardid, or the map not yet
    // resolved) → null → broad pool (unchanged): there is no single Division to mirror.
    currentUploadDivisionId: function currentUploadDivisionId() {
      var cardId = this.$route && this.$route.query && this.$route.query.cardid;
      if (cardId == null) {
        return null;
      }
      var divisionId = this.cardDivisionMap && this.cardDivisionMap[String(cardId)];
      return divisionId != null ? divisionId : null;
    },
    handleReceiptFile: function () {
      var _handleReceiptFile = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(event) {
        var self, raw, file, formData, idempotencyKey, uploadDivisionId, submitExtra;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              self = this;
              raw = event.target.files && event.target.files[0];
              if (raw) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return Object(__WEBPACK_IMPORTED_MODULE_8__core_receiptScan_imageCompression__["a" /* default */])(raw);
            case 6:
              file = _context.sent;
              formData = new FormData();
              formData.append('file', file);
              idempotencyKey = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0;
                var v = c === 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
              });
              self.uploadingReceipt = true;
              // Mirror the web desktop flow: scope the candidate ranking to the card-in-context's
              // Division when the FAB is launched from a card page (PRODUCTDEV-5475). Omitted on the
              // global tab → broad pool (unchanged). Backend already scopes on this field.
              uploadDivisionId = self.currentUploadDivisionId();
              submitExtra = uploadDivisionId != null ? {
                uploadContextLegacyDivisionId: uploadDivisionId
              } : undefined;
              __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].submitReceipt(formData, idempotencyKey, submitExtra).then(function (data) {
                if (data && data.receiptScanId) {
                  // Keep `uploadingReceipt = true` here so the overlay persists across the
                  // router transition into /evedpay/submitreceipt. handleReceiptScanStarted's
                  // $router.push promise clears it once SubmitReceipt is mounted, eliminating
                  // the brief flash between overlay-hide and the SubmitReceipt progress card.
                  // extended-bus.js auto-wraps payload as { target, data }; emit raw shape so
                  // listener's payload.data resolves to { receiptScanId, source }.
                  __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$emit('receipt-scan-started', {
                    receiptScanId: data.receiptScanId,
                    source: 'mobileFab'
                  });
                } else {
                  // Upload resolved but the response shape is unexpected (no receiptScanId).
                  // Without a toast here the user sees nothing and assumes the tap was lost.
                  self.uploadingReceipt = false;
                  console.error('submitReceipt resolved without receiptScanId', data);
                  self.$notifications.notify({
                    type: 'danger',
                    message: 'Upload returned an unexpected response. Please try again.',
                    placement: {
                      from: 'top',
                      align: 'center'
                    }
                  });
                }
              }).catch(function (error) {
                self.uploadingReceipt = false;
                console.error('submitReceipt rejected', error);
                // PRODUCTDEV-5851 — image couldn't be scanned (e.g. dimensions out of range), but the
                // receipt is still persisted (ReadyForMatch, zero candidates) and returns 422 with its
                // receiptScanId. Continue the same post-scan flow silently so the user can match manually
                // or save to folder. Isolated to this one status — every other error keeps its handling.
                if (error.response && error.response.status === 422 && error.response.data && error.response.data.receiptScanId) {
                  __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$emit('receipt-scan-started', {
                    receiptScanId: error.response.data.receiptScanId,
                    source: 'mobileFab'
                  });
                  return;
                }
                if (error.isPlatformSentinelError) {
                  // Platform is unreachable or 5xx. Surface this explicitly before the
                  // best-effort legacy fallback so the user knows what happened.
                  self.$notifications.notify({
                    type: 'danger',
                    message: 'Platform unavailable — falling back to legacy upload.',
                    placement: {
                      from: 'top',
                      align: 'center'
                    }
                  });
                  self.fallbackLegacyUpload(file);
                  return;
                }
                self.$notifications.notify({
                  type: 'danger',
                  placement: {
                    from: 'top',
                    align: 'center'
                  },
                  timeout: 5000,
                  message: 'Failed to upload receipt. Please try again.'
                });
              });
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleReceiptFile(_x) {
        return _handleReceiptFile.apply(this, arguments);
      }
      return handleReceiptFile;
    }(),
    fallbackLegacyUpload: function fallbackLegacyUpload(file) {
      var self = this;
      var formData = new FormData();
      formData.append('attachment_upload', file);
      var legacyUrl = self.api ? self.api.env + self.api.$.evedpaycard.receipt : null;
      if (!legacyUrl) {
        self.$notifications.notify({
          type: 'danger',
          message: 'Legacy upload endpoint not configured. Receipt was not saved.',
          placement: {
            from: 'top',
            align: 'center'
          }
        });
        return;
      }
      var token = self.$user && self.$user.sessionSettings ? self.$user.sessionSettings.Token : '';
      self.api.post(legacyUrl, formData, {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function () {
        self.$notifications.notify({
          type: 'info',
          message: 'Receipt uploaded via legacy fallback. Scanning is unavailable.',
          placement: {
            from: 'top',
            align: 'center'
          }
        });
      }).catch(function (legacyError) {
        console.error('legacy receipt upload failed', legacyError);
        self.$notifications.notify({
          type: 'danger',
          message: 'Legacy upload failed. Receipt was not saved.',
          placement: {
            from: 'top',
            align: 'center'
          }
        });
      });
    },
    // Handle receipt scan started event. Camera / Library uploads navigate
    // immediately to SubmitReceipt, where the 3-step progress card and poller live.
    // The uploadingReceipt overlay is intentionally held over the route transition —
    // the $route watcher below clears it once the route flips, so the user never sees
    // a blank Cards-page flash between the overlay and the SubmitReceipt progress card.
    handleReceiptScanStarted: function handleReceiptScanStarted(data) {
      if (this.activePoller) {
        this.activePoller.cancel();
        this.activePoller = null;
      }
      var self = this;
      this.$router.push({
        path: '/evedpay/submitreceipt',
        query: {
          receiptScanId: data.receiptScanId
        }
      });
      // Safety net: matches the poller's 60s POLL_TIMEOUT_MS plus a 30s buffer
      // for slow Photon round-trips. If SubmitReceipt never emits the ready event
      // (failed mount, navigation rejected, etc.) the overlay force-clears so it
      // never gets stuck on screen forever.
      setTimeout(function () {
        self.uploadingReceipt = false;
      }, 90000);
    },
    // No Receipt Capture (PRODUCTDEV-5475): hide the FAB only when EVERY division the
    // cardholder holds a card in disables capture. If any division still allows it we
    // keep the FAB — the floating receipt's target division isn't known until it's
    // matched, so we never suppress a legitimate flow. The per-division mode is read
    // from Platform (cardholder-readable; a missing row means capture-enabled). Any
    // fetch failure leaves the FAB visible (safe default).
    resolveReceiptCaptureDisabled: function resolveReceiptCaptureDisabled() {
      var self = this;
      if (!this.api || !this.api.$ || !this.api.$.evedpaycard || !this.api.forms) {
        return;
      }
      return this.api.forms.post(this.api.$.evedpaycard.cards, {
        sort: 'CardGroup',
        dir: 'DESC',
        start: 0,
        limit: 100,
        isLiveGrid: true,
        filter: {
          searchTerm: ''
        }
      }).then(function (r) {
        var cards = r && r.data && Array.isArray(r.data.Data) ? r.data.Data : [];
        // Cache cardId -> DivisionId so a FAB scan launched from a specific card's page
        // can scope its match candidates to that card's Division (PRODUCTDEV-5475),
        // mirroring the web desktop flow. The route's `cardid` equals the card's Id.
        var divMap = {};
        cards.forEach(function (card) {
          if (card && card.Id != null && card.DivisionId != null) {
            divMap[String(card.Id)] = card.DivisionId;
          }
        });
        self.cardDivisionMap = divMap;
        var divisionIds = [];
        cards.forEach(function (card) {
          if (card.DivisionId != null && divisionIds.indexOf(card.DivisionId) === -1) {
            divisionIds.push(card.DivisionId);
          }
        });
        if (!divisionIds.length) {
          return;
        }
        return Promise.all(divisionIds.map(function (divisionId) {
          return __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].getReceiptScanSetting(divisionId).then(function (setting) {
            return setting ? setting.prefillMode : null;
          }).catch(function () {
            return null;
          });
        })).then(function (modes) {
          var resolved = modes.filter(function (m) {
            return m != null;
          });
          // Hide only when every division resolved AND all are no-capture.
          self.receiptCaptureDisabled = resolved.length === divisionIds.length && resolved.length > 0 && resolved.every(function (m) {
            return m === __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["a" /* NO_RECEIPT_CAPTURE_MODE */];
          });
        });
      }).catch(function () {
        // Card fetch failed — leave the FAB visible.
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Sg6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_legacy_auth_users__ = __webpack_require__("dl2l");

/* harmony default export */ __webpack_exports__["a"] = ({
  get legacyViewDisabled() {
    return __WEBPACK_IMPORTED_MODULE_0__core_legacy_auth_users__["a" /* default */].type.BUYER && !__WEBPACK_IMPORTED_MODULE_0__core_legacy_auth_users__["a" /* default */].entity.ENTERPRISE;
  },
  get receiptScanPrefill() {
    return "true" === 'true';
  }
});

/***/ }),

/***/ "ShAN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_user__ = __webpack_require__("uduW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_api_map_json__ = __webpack_require__("m/F2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_api_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__core_api_map_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_mapValues__ = __webpack_require__("94Kh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_pluralize__ = __webpack_require__("wMK+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_pluralize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_legacy_auth__ = __webpack_require__("mnjY");


/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * SETTINGS MODULE
 *
 * This module handles settings for other modules based on user roles.
 *
 * @package Admin
 */









var allowedModules = __WEBPACK_IMPORTED_MODULE_9__core_legacy_auth__["a" /* default */].allowedModules;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_pluralize___default.a);
var cards = [];
var entity = null;
var role = null;
var init = function init() {
  var _settings = null;
  var _data = null;
  if (__WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].get() && __WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].get().data /* && user.get().settings */) {
    _settings = __WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].getCompanySettings();
    _data = __WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].get().data;
    _data.MarketTypeID = parseInt(_data.MarketTypeID);
    _data.MembershipPlanID = parseInt(_data.MembershipPlanID);
    _data.ApplyPartnerCommission = __WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].get().hasPC;
    _data.IsDell = __WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].get().isDell;
  }
  var User = __WEBPACK_IMPORTED_MODULE_6_lodash_mapValues___default()(Object.assign({
    settings: _settings
  }, _data), toBool);
  var ROLE = {
    BASIC: User.type === 'basic',
    NO_ADMIN: true,
    REGIONAL_ADMIN: allow('RegionalAdministration'),
    COMPANY_ADMIN: allow('Administration'),
    FULL_ADMIN: User.type === 'admin'
  };
  var type = {
    BUYER: User.MarketTypeID === 1,
    BS: User.MarketTypeID === 2,
    SELLER: User.MarketTypeID === 3
  };
  var ENTITY = {
    ENTERPRISE: User.IsE360,
    CORPORATE: User.IsFusion,
    SUPPLIER: type.BS || type.SELLER,
    BASIC_BS: type.BS && !User.IsE360 && !User.IsFusion,
    ENTERPRISE_BS: type.BS && User.IsE360 && User.MembershipPlanID === 3,
    CORPORATE_B: type.BUYER && User.IsFusion,
    BASIC_B: type.BUYER && !User.IsFusion
  };
  var SETTINGS = {
    COMPANY: Object.assign({
      //
      _pages: __WEBPACK_IMPORTED_MODULE_6_lodash_mapValues___default()(__WEBPACK_IMPORTED_MODULE_5__core_api_map_json___default.a.settings.company, function (page) {
        return "#/i/Admin".concat(page, "[back]#Settings");
      })
    },
    //
    __WEBPACK_IMPORTED_MODULE_6_lodash_mapValues___default()(User.settings, toBool))
  };
  entity = ENTITY;
  role = ROLE;

  //
  cards = [{
    name: 'Approval Settings',
    status: 'AllowApprovalSettings',
    description: 'Allow users to manage approval rules.',
    configurable: 'Configure',
    icon: ['far', 'check-circle'],
    new: true,
    url: '#/d/Admin/Approval-list[back]',
    endpoint: __WEBPACK_IMPORTED_MODULE_5__core_api_map_json___default.a.settings.company.approval,
    condition: ENTITY.ENTERPRISE || ENTITY.CORPORATE
  }, {
    name: 'Approval Delegation',
    status: 'AllowDelegateApproval',
    description: 'Allow users to delegate approvals.',
    configurable: 'false',
    icon: ['fab', 'telegram-plane'],
    new: false,
    condition: ENTITY.CORPORATE
  }, {
    name: 'Time & Date',
    status: null,
    description: 'Set up time & date.',
    configurable: 'Configure',
    icon: ['far', 'clock'],
    new: false,
    url: SETTINGS.COMPANY._pages.timeDate
  }, {
    name: 'Budget Settings',
    status: null,
    description: 'Customize your budget and VAT/GST settings.',
    configurable: 'Configure',
    icon: ['far', 'usd-circle'],
    new: false,
    url: SETTINGS.COMPANY._pages.budget,
    condition: ENTITY.CORPORATE
  }, {
    name: 'Payments',
    status: null,
    description: 'Set up global payment settings.',
    configurable: 'Configure',
    icon: ['fas', 'credit-card'],
    new: false,
    url: SETTINGS.COMPANY._pages.payment,
    condition: ENTITY.CORPORATE && ROLE.COMPANY_ADMIN
  }, {
    name: 'Tax Authority',
    status: null,
    description: 'Set up and configure Tax Authorities.',
    configurable: 'Configure',
    icon: ['fal', 'percent'],
    new: false,
    url: SETTINGS.COMPANY._pages.taxAuthority,
    condition: !ENTITY.CORPORATE && ENTITY.ENTERPRISE
  }, {
    name: SETTINGS.COMPANY.ProgramLabel + ' Template',
    status: null,
    description: 'Set up and configure ' + SETTINGS.COMPANY.ProgramLabel + ' Templates.',
    configurable: 'Configure',
    icon: ['fas', 'file-alt'],
    new: false,
    url: SETTINGS.COMPANY._pages.programTemplate,
    condition: ENTITY.CORPORATE && !ROLE.REGIONAL_ADMIN
  }, {
    name: 'Email Addresses for Reports',
    status: null,
    description: 'Email Addresses for Reports.',
    configurable: 'Configure',
    icon: ['far', 'envelope'],
    new: false,
    url: SETTINGS.COMPANY._pages.email,
    condition: ENTITY.ENTERPRISE || ENTITY.CORPORATE
  }, {
    name: 'Scope Settings',
    status: null,
    description: 'Customize your Scope of Services settings.',
    configurable: 'Configure',
    icon: ['far', 'file-alt'],
    new: false,
    url: SETTINGS.COMPANY._pages.scope,
    condition: ENTITY.CORPORATE_B
  }, {
    name: ENTITY.CORPORATE ? SETTINGS.COMPANY.ProgramsLabel : 'Program Settings',
    initial: SETTINGS.COMPANY.ProgramsLabel,
    status: null,
    editable: ENTITY.CORPORATE ? 'Rename Setting' : '',
    model: 'ProgramsLabel',
    placeholder: 'Program',
    description: "Customize your [placeholder] and Team Tab settings.",
    configurable: 'Configure',
    icon: ['fas', 'file'],
    new: false,
    url: SETTINGS.COMPANY._pages.program,
    condition: (ENTITY.ENTERPRISE || ENTITY.CORPORATE) && !ROLE.REGIONAL_ADMIN
  }, {
    name: SETTINGS.COMPANY.DivisionName || 'Divisions',
    initial: SETTINGS.COMPANY.DivisionName || 'Divisions',
    status: 'HasDivision',
    editable: 'Rename Setting',
    model: 'DivisionName',
    modelDescription: 'DivisionDescription',
    placeholder: 'Divisions',
    description: "Set up [placeholder] for your company to drive your approvals, reporting and user access.",
    configurable: 'Configure',
    icon: ['fas', 'thumbs-up'],
    new: false,
    url: SETTINGS.COMPANY._pages.division,
    condition: !ROLE.REGIONAL_ADMIN && ENTITY.CORPORATE
  }, {
    name: 'Business Units and Cost Centers',
    status: null,
    description: '                                       ',
    configurable: 'Configure',
    icon: ['fas', 'user'],
    new: false,
    url: '#/d/Admin/BusinessUnitsAndCostCenters[back]',
    condition: !ROLE.REGIONAL_ADMIN && ENTITY.CORPORATE
  }, {
    name: 'Currencies',
    status: 'HasCurrency',
    description: 'Set up global currencies to be used in your ' + SETTINGS.COMPANY.ProgramsLabel.toLowerCase() + '.',
    help: 'Currencies selected here can then be configured as currencies to be processed as payments for invoices in the Payments configuration section.',
    configurable: 'Configure',
    icon: ['far', 'euro-sign'],
    new: false,
    url: SETTINGS.COMPANY._pages.currency,
    condition: !ROLE.REGIONAL_ADMIN && ENTITY.CORPORATE
  }, {
    name: 'ERP',
    status: 'HasERP',
    description: 'Integrate with Enterprise Resource Planning (ERP) software.',
    configurable: 'Configure',
    icon: [],
    new: false,
    url: SETTINGS.COMPANY._pages.erp,
    condition: User.IsDell
  }, {
    name: 'Expenses Customizations',
    status: 'HasExpense',
    description: 'Customize your Expense settings.',
    configurable: 'Configure',
    icon: ['fal', 'credit-card'],
    new: false,
    url: SETTINGS.COMPANY._pages.expense,
    condition: !ROLE.REGIONAL_ADMIN && ENTITY.CORPORATE
  }, {
    name: 'Partners',
    status: 'HasPartnerFunding',
    description: 'Set up partners for funding allocations.',
    configurable: 'Configure',
    icon: ['far', 'handshake'],
    new: false,
    url: SETTINGS.COMPANY._pages.partner,
    condition: !ROLE.REGIONAL_ADMIN && ENTITY.CORPORATE
  }, {
    name: 'Categories',
    status: null,
    description: 'Create and manage custom categories.',
    configurable: 'Configure',
    icon: ['fal', 'list-alt'],
    new: false,
    url: SETTINGS.COMPANY._pages.category,
    condition: ENTITY.CORPORATE
  }, {
    name: 'Sub-Categories',
    status: 'HasSubCategory',
    description: 'Create and manage custom sub-categories.',
    configurable: 'Configure',
    icon: ['fal', 'list-alt'],
    new: false,
    url: SETTINGS.COMPANY._pages.category,
    condition: ENTITY.ENTERPRISE
  }, {
    name: 'Partner Commissions',
    value: User.ApplyPartnerCommission,
    status: 'ApplyPartnerCommission',
    description: 'Set up partner commissions.',
    configurable: 'Configure',
    icon: ['far', 'handshake'],
    new: false,
    url: SETTINGS.COMPANY._pages.partnerCommission,
    condition: ENTITY.ENTERPRISE
  }, {
    name: 'Invoices',
    status: 'HasInvoice',
    description: 'Set up invoice preferences for approvals, terms and rush payments.',
    configurable: 'Configure',
    icon: ['far', 'file-alt'],
    new: false,
    url: SETTINGS.COMPANY._pages.invoice,
    condition: (ENTITY.CORPORATE || ENTITY.ENTERPRISE_BS) && !ROLE.REGIONAL_ADMIN
  }, {
    name: SETTINGS.COMPANY.Labels.MeetingTypesLabel,
    initial: SETTINGS.COMPANY.Labels.MeetingTypesLabel,
    status: 'UseMeetingType',
    editable: 'Rename Setting',
    model: 'MeetingTypesLabel',
    placeholder: 'Meeting Types',
    description: 'Track [placeholder] per ' + SETTINGS.COMPANY.ProgramLabel.toLowerCase() + ' and customize your list of [placeholder].',
    configurable: 'Configure',
    icon: [],
    new: false,
    url: SETTINGS.COMPANY._pages.meetingType,
    condition: ENTITY.CORPORATE && !ROLE.REGIONAL_ADMIN
  }, {
    name: 'Purchase Orders',
    status: 'HasPurchaseOrder',
    description: 'Set up terms, preferences and thresholds within the approval work flow.',
    configurable: 'Configure',
    icon: ['far', 'shopping-cart'],
    new: false,
    url: SETTINGS.COMPANY._pages.po,
    condition: (ENTITY.CORPORATE || ENTITY.ENTERPRISE_BS) && !ROLE.REGIONAL_ADMIN
  }, {
    name: 'Invitation Settings',
    status: null,
    description: 'Choose whether or not you want to automatically accept buyer invitations.',
    configurable: 'Configure',
    icon: ['fas', 'users'],
    new: false,
    url: SETTINGS.COMPANY._pages.invitation,
    condition: ENTITY.SUPPLIER
  }, {
    name: 'Notifications',
    status: null,
    description: 'Set up company notifications.',
    configurable: 'Configure',
    icon: ['far', 'bell'],
    new: false,
    url: ENTITY.ENTERPRISE_BS ? SETTINGS.COMPANY._pages.companyNotification : SETTINGS.COMPANY._pages.notification,
    condition: SETTINGS.COMPANY.HasNotifications && SETTINGS.COMPANY.HasInsuranceModule || !ENTITY.CORPORATE
  }, {
    name: 'Templates',
    status: null,
    description: 'Set up proposal templates.',
    configurable: 'Configure',
    icon: ['far', 'shopping-cart'],
    new: false,
    url: SETTINGS.COMPANY._pages.template,
    condition: ENTITY.ENTERPRISE
  }, {
    name: 'VAT/GST',
    status: 'HasVAT',
    description: 'Set up VAT/GST Identification Numbers.',
    configurable: 'Configure',
    icon: [],
    new: false,
    url: SETTINGS.COMPANY._pages.vat,
    condition: User.IsDell
  }, {
    name: 'Landmarks',
    status: 'UseLandmarks',
    description: 'Add custom locations to allow Distance From searches in the supplier network.',
    configurable: 'Configure',
    icon: ['fal', 'map-pin'],
    new: false,
    url: SETTINGS.COMPANY._pages.landmark,
    condition: ENTITY.ENTERPRISE || ENTITY.CORPORATE
  }, {
    name: 'Accounts Payable Settings',
    status: null,
    description: 'Configure funding addresses and AP File templates.',
    configurable: 'Configure',
    icon: ['far', 'check-circle'],
    new: false,
    url: '#/d/Admin/FundingInvoiceAndAPFileTemplate[back]',
    endpoint: __WEBPACK_IMPORTED_MODULE_5__core_api_map_json___default.a.settings.company.fundingInvAndAPSettings,
    condition: ENTITY.CORPORATE && User.HasAuditFile
  }];
  cards = __WEBPACK_IMPORTED_MODULE_7_lodash_orderBy___default()(cards, [function (card) {
    return card.name.toLowerCase();
  }], ['asc']);
  return SETTINGS.COMPANY;
};
function allow(roleName) {
  return !~getPermissions().indexOf('deny' + roleName);
}
function toBool(v) {
  return v === '1' ? true : v === '0' ? false : v;
}
function getPermissions() {
  var authUser = JSON.parse(window.localStorage.getItem('evedUser'));
  var permissions = [];
  if (authUser && authUser.token && authUser.permissions) {
    permissions = authUser.permissions;
  }
  return permissions;
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Settings',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__["mixin"]],
  created: function created() {
    this.updateSettings();
    if (!role.COMPANY_ADMIN || entity.BASIC_B) {
      this.$router.push('/i/Admin/GeneralSettings/GeneralSettings');
    }
  },
  data: function data() {
    var _this2 = this;
    return {
      settings: cards,
      isDisabled: function isDisabled(setting) {
        if (setting.status === null) return false;
        return typeof setting.value === 'boolean' ? !setting.value : !_this2.$user.$.companySettings[setting.status];
      },
      backUrl: function backUrl(url, setting) {
        return setting.status !== null && !setting.value ? 'javascript:;' : url ? url.replace('[back]', '?back-to=Company Settings') : '';
      },
      subtitle: function subtitle(setting) {
        return !setting.editing ? setting.description.replace(/\[placeholder\]/g, setting.name || setting.placeholder) : setting.description.replace(/\[placeholder\]/g, setting.initial || setting.placeholder);
      }
    };
  },
  methods: {
    // GATED (chore: gate-admin-tab-redesign, ticket 5853) — the Categories "Configure"
    // redesign break-out is temporarily disabled; Configure opens the legacy category page
    // (via `edit`) as it did before. To restore the native redesign page, un-comment the
    // onConfigure method below and set the card's footer button back to
    // @click='onConfigure(setting, $event)'. The native page itself
    // (Eved.Frontend clientPages/Admin/Categories) is left intact.
    // onConfigure(setting, e) {
    //   const embedded = window.self !== window.top
    //   if (embedded && setting.name === 'Categories') {
    //     if (e && e.preventDefault) e.preventDefault()
    //     window.parent.postMessage({ type: 'LEGACY_SHORTCUT_CLICK', button: 'ConfigureCategories' }, '*')
    //     return
    //   }
    //   this.edit(setting)
    // },
    edit: function edit(setting, hide) {
      if (!setting.editable || this.isDisabled(setting)) return;
      if (hide === false && setting.editing === true) {
        setting.name = setting.name + ' ';
        setTimeout(function () {
          setting.name = setting.initial; // setting.name.slice(0, -1)
          setting.editing = false;
        });
      } else {
        setting.name = setting.name + ' ';
        setTimeout(function () {
          setting.name = setting.initial; // setting.name.slice(0, -1)
          setting.editing = true;
        });
      }
    },
    handleEndpoint: function handleEndpoint(setting, e) {
      if (e.button === 0 && ~e.target.className.indexOf('btn-primary')) {
        setting.saving = true;
      }
    },
    change: function change(setting, hide) {
      var vm = this;
      var payload = {
        isAllowed: setting.value
      };
      if (setting.description.indexOf('Team Tab') !== -1 || setting.model === 'MeetingTypesLabel') {
        // pluralize Programs label
        setting.name = global.app.$pluralize(setting.name.trim(), 2);
      }
      var oldSettingsPayload = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({
        SaveType: 'settings'
      }, setting.status, setting.value);
      if (setting.model) {
        oldSettingsPayload[setting.model] = setting.name;
        if (setting.modelDescription) oldSettingsPayload[setting.modelDescription] = '';
      }

      //
      if (!setting.value && setting.status) {
        setting.pending = true;
        global.app.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: {
            from: 'top',
            align: 'center'
          },
          timeout: 0,
          message: "Are you sure you want to turn off your admin settings for <strong>".concat(setting.name, "</strong> ?") + "<br/>" + "This will immediately turn off these settings in your company's account.",
          dismiss: this.$t('Yes'),
          discard: this.$t('No'),
          goto: null,
          onClose: function onClose(dismiss) {
            if (dismiss) {
              //
              save(vm, dismiss);
            } else {
              //
              setting.value = true;
            }
            setting.pending = false;
          }
        });
      } else {
        replaceProgramLabelInTabs(this.settings, setting);
        updateSessionSettings(setting.name, setting.model, this);
        save(this);
      }
      function updateSessionSettings(newKey, model, _this) {
        if (model === 'ProgramsLabel' || model === 'MeetingTypesLabel') {
          var data = JSON.parse(window.localStorage.getItem('evedUser'));
          if (data.modules && data.modules.Commerce && newKey) {
            var newObj = {};
            var oldKey = newKey;
            Object.keys(data.modules.Commerce).map(function (k) {
              if (data.modules.Commerce[k] === 'ProgramList') {
                newObj[newKey] = data.modules.Commerce[k];
                oldKey = k;
              } else {
                newObj[k] = data.modules.Commerce[k];
              }
            });
            if (newKey !== oldKey) {
              data.modules.Commerce = newObj;
              _this.$nextTick(function () {
                global.localStorage.setItem('evedUser', JSON.stringify(data));

                // update cache
                allowedModules();
              });
            }
          }
        }
      }
      function replaceProgramLabelInTabs(allSettings, menuSetting) {
        if (menuSetting.description && menuSetting.description.indexOf('Team Tab') !== -1) {
          var programLabel = global.app.$pluralize(menuSetting.name, 1); // singular
          var programsLabel = global.app.$pluralize(menuSetting.name, 2); // plural

          allSettings.map(function (s) {
            // Program Template
            if (s.name && s.name.indexOf('Template') !== -1) {
              s.name = programLabel + ' Template';
              s.description = 'Set up and configure ' + programLabel + ' Templates.';
            }

            // Currencies
            if (s.name && s.name.indexOf('Currencies') !== -1) {
              s.description = 'Set up global currencies to be used in your ' + programsLabel.toLowerCase() + '.';
            }

            // Meeting Types
            if (s.name && s.name.indexOf('Meeting Types') !== -1) {
              s.description = 'Track ' + s.placeholder + ' per ' + programLabel.toLowerCase() + ' and customize your list of ' + s.placeholder + '.';
            }
          });
        }
      }
      function save(vm, confirmed) {
        if (setting.endpoint) {
          //
          vm.api.forms.post(setting.endpoint, payload).then(revertSettingOnError).catch(revertSettingOnError);
        } else {
          //
          vm.api.forms.post(__WEBPACK_IMPORTED_MODULE_5__core_api_map_json___default.a.settings.company.$, oldSettingsPayload).then(revertSettingOnError).catch(revertSettingOnError);
        }
      }
      function revertSettingOnError(r) {
        if (hide === false && setting.editing === true) {
          setting.name = setting.name + ' ';
          setTimeout(function () {
            setting.name = setting.initial; // setting.name.slice(0, -1)
            setting.editing = false;
          });
        }
        vm.updateSettings(true);
        setting.saving = false;
        setting.initial = setting.name.slice(0, -1);
        if (!r || r.name === 'Error') {
          setting.value = !setting.value;
        }
      }
    },
    updateSettings: function updateSettings(refresh) {
      var _this3 = this;
      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(refresh) === 'object') {
        this.$nextTick(function () {
          global.localStorage.setItem('evedUserSettings', JSON.stringify(refresh));
        });
        return true;
      }
      var persistentSettings = refresh === true ? null : JSON.parse(global.localStorage.getItem('evedUserSettings'));
      this.$user.$.companySettings = refresh === true ? this.settings : persistentSettings || init();
      if (!persistentSettings) {
        // persist settings
        global.localStorage.setItem('evedUserSettings', JSON.stringify(this.$user.$.companySettings));
      } else {
        // default settings
        init();
      }

      // update vm
      // if (!refresh) {
      if (!this.$user.$.settings) {
        this.$user.$.settings = {
          company: null
        };
      }
      this.$user.$.settings.company = persistentSettings && persistentSettings.length && persistentSettings || this.$user.$.settings.company || cards;
      this.settings = this.$user.$.settings.company.map(function (k) {
        k.value = k.value || _this3.$user.$.companySettings[k.status];
        k.saving = false;
        k.editable = k.editable || false;
        k.editing = false;
        return k;
      });
      // }

      return persistentSettings;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "ShG+":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Polyfills **/

/** === CSS vars === **/
// --- https://codepen.io/aaronbarker/pen/MeaRmL
var cssVarPoly = {
  init: function init() {
    if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
      return;
    } else {
      document.querySelector('body').classList.add('cssvars-polyfilled');
    }
    cssVarPoly.ratifiedVars = {};
    cssVarPoly.varsByBlock = {};
    cssVarPoly.oldCSS = {};
    cssVarPoly.findCSS();
    cssVarPoly.updateCSS();
  },
  findCSS: function findCSS() {
    if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) return;
    var styleBlocks = document.querySelectorAll('style:not(.inserted),link[type="text/css"]');
    var counter = 1;
    Array.prototype.forEach.call(styleBlocks, function (block) {
      var theCSS;
      if (block.nodeName === 'STYLE') {
        theCSS = block.innerHTML;
        cssVarPoly.findSetters(theCSS, counter);
      } else if (block.nodeName === 'LINK') {
        cssVarPoly.getLink(block.getAttribute('href'), counter, function (counter, request) {
          cssVarPoly.findSetters(request.responseText, counter);
          cssVarPoly.oldCSS[counter] = request.responseText;
          cssVarPoly.updateCSS();
        });
        theCSS = '';
      }
      if (cssVarPoly.oldCSS) {
        cssVarPoly.oldCSS[counter] = theCSS;
      }
      counter++;
    });
  },
  findSetters: function findSetters(theCSS, counter) {
    if (cssVarPoly.varsByBlock) {
      cssVarPoly.varsByBlock[counter] = theCSS.match(/(--.+:.+;)/g) || [];
    }
  },
  updateCSS: function updateCSS() {
    if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) return;
    cssVarPoly.ratifySetters(cssVarPoly.varsByBlock);
    for (var curCSSID in cssVarPoly.oldCSS) {
      var newCSS = cssVarPoly.replaceGetters(cssVarPoly.oldCSS[curCSSID], cssVarPoly.ratifiedVars);
      if (document.querySelector('#inserted' + curCSSID)) {
        document.querySelector('#inserted' + curCSSID).innerHTML = newCSS;
      } else {
        var style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = newCSS;
        style.classList.add('inserted');
        style.id = 'inserted' + curCSSID;
        document.getElementsByTagName('head')[0].appendChild(style);
      }
    }
  },
  replaceGetters: function replaceGetters(curCSS, varList) {
    for (var theVar in varList) {
      var getterRegex = new RegExp('var\\(\\s*' + theVar + '\\s*\\)', 'g');
      curCSS = curCSS.replace(getterRegex, varList[theVar]);
      var getterRegex2 = new RegExp('var\\(\\s*.+\\s*,\\s*(.+)\\)', 'g');
      var matches = curCSS.match(getterRegex2);
      if (matches) {
        matches.forEach(function (match) {
          curCSS = curCSS.replace(match, match.match(/var\(.+,\s*(.+)\)/)[1]);
        });
      }
    }
    return curCSS;
  },
  ratifySetters: function ratifySetters(varList) {
    for (var curBlock in varList) {
      var curVars = varList[curBlock];
      curVars.forEach(function (theVar) {
        var matches = theVar.split(/:\s*/);
        cssVarPoly.ratifiedVars[matches[0]] = matches[1].replace(/;/, '');
      });
    }
  },
  getLink: function getLink(url, counter, success) {
    var request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.overrideMimeType('text/css;');
    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        if (typeof success === 'function') {
          success(counter, request);
        }
      } else {
        console.warn('an error was returned from:', url);
      }
    };
    request.onerror = function () {
      console.warn('we could not get anything from:', url);
    };
    request.send();
  }
};
global.cssVarPoly = cssVarPoly;

/** === String includes === **/
// --- https://developer.mozilla.org/it/docs/Web/JavaScript/Reference/Global_Objects/String/includes#Polyfill
if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    // eslint-disable-line
    'use strict';

    if (typeof start !== 'number') {
      start = 0;
    }
    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

/** === Array find === **/
// --- https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    // eslint-disable-line
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}

/** === Array forEach === **/
// --- Production steps of ECMA-262, Edition 5, 15.4.4.18
// --- Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function (callback /*, thisArg*/) {
    // eslint-disable-line
    var T, k;
    if (this == null) {
      throw new TypeError('this is null or not defined');
    }

    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = arguments[1];
    }

    // 6. Let k be 0.
    k = 0;

    // 7. Repeat while k < len.
    while (k < len) {
      var kValue;

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator.
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c.
      // c. If kPresent is true, then
      if (k in O) {
        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined.
  };
}

/** === vue-router IE fix === **/
// https://github.com/vuejs/vue-router/issues/1849
if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
  window.addEventListener('hashchange', function () {
    var currentPath = window.location.hash.slice(1);
    if (global.app.$router.currentRoute.path !== currentPath) {
      global.app.$router.push(currentPath);
    }
  }, false);
}

/** === array.findindex IE fix === */
// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    },
    configurable: true,
    writable: true
  });
}
//

/** === string starts with IE fix === */
if (!String.prototype.startsWith) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function value(search, rawPos) {
      var pos = rawPos > 0 ? rawPos | 0 : 0;
      return this.substring(pos, pos + search.length) === search;
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "ShaP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_Invoices_cells_statuses__ = __webpack_require__("MLM4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_Invoices_cells_attachments_details__ = __webpack_require__("3Tf6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_statuses__ = __webpack_require__("nBkH");



/* harmony default export */ __webpack_exports__["a"] = ({
  'InvoiceNumber': {
    label: 'Invoice',
    uid: 'Id',
    uri: '#/i/Invoices/sent/?goto=InvoiceDetail/{{id}}/0/send-action-required',
    onclick: 'setCookie("from_tab", "SentInvoices", "/")',
    width: 190
  },
  'ProgramName': 'Project',
  'InvoiceStatus': {
    label: 'Status',
    source: 'PaymentInvoiceList_SentInvoices'
  },
  'TotalAmount': {
    label: 'Amount',
    getter: __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_statuses__["l" /* hideForCancelledOrRejected */]
  },
  'TotalPayment': 'Total Payments',
  'Balance': 'Balance',
  'ClientName': {
    label: 'Client',
    uid: 'PoSenderVci',
    uri: '#/i/Invoices/Profile{{id}}-{{screen}}',
    tooltip: 'View profile of {{text}}'
  },
  'DueDateWithinFormatted': {
    label: 'Due',
    getter: __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_statuses__["l" /* hideForCancelledOrRejected */]
  },
  'DueDateWithin': '_',
  'MediaCount': {
    label: 'Attachments',
    detailsCondition: showAttachmentsExpandIcon,
    details: 'invoice.getAttachmentsDetails',
    detailsParamsURL: getAttachmentsDetailsParams,
    detailsComp: __WEBPACK_IMPORTED_MODULE_1__components_modules_Invoices_cells_attachments_details__["a" /* default */],
    visible: false
  },
  'CreatedBy': {
    label: 'Created By',
    visible: false
  },
  'CreatedByName': {
    label: 'Created By Name',
    visible: false
  },
  'EventName': {
    label: 'Event',
    visible: false
  },
  'FirstEventEndDateFormatted': {
    label: 'Event End Date',
    visible: false
  },
  'FirstEventStartDateFormatted': {
    label: 'Event Start Date',
    visible: false
  },
  'InvoiceDateFormatted': {
    label: 'Invoice Date',
    visible: false
  },
  'PaymentStatus': {
    label: 'Invoice Status',
    source: 'PaymentInvoiceList_ReceivedInvoices',
    render: __WEBPACK_IMPORTED_MODULE_0__components_modules_Invoices_cells_statuses__["a" /* default */],
    width: 270,
    visible: false
  },
  'PONumber': {
    label: 'PO',
    width: 180,
    visible: false
  },
  'ProgramEndDateFormatted': {
    label: 'Project End Date',
    visible: false
  },
  'ProgramStartDateFormatted': {
    label: 'Project Start Date',
    visible: false
  },
  'TotalReceived': {
    label: 'Received Payments',
    type: 'money',
    visible: false
  },
  'TotalUnprocessed': {
    label: 'Scheduled Payments',
    type: 'money',
    visible: false
  },
  'SupplierIDCode': {
    label: 'Supplier ID',
    visible: false
  },
  'ReferenceCode': {
    label: 'Supplier Invoice Number',
    visible: false
  }
});
function showAttachmentsExpandIcon(params) {
  return params.data.MediaCount > 0;
}
function getAttachmentsDetailsParams(params) {
  return "/".concat(params.data.PaymentInvoiceID, "?") + "&poId=".concat(params.data.POID) + "&poVersionId=".concat(params.data.POVersionID) + "&poType=".concat(params.data.POType) + "&programid=".concat(params.data.ProgramID);
}

/***/ }),

/***/ "SiqJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fileUploadField_vue__ = __webpack_require__("v6dw");



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//

// https://github.com/lian-yue/vue-upload-component/blob/master/docs/views/examples/Full.vue


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-upload-field',
  components: {
    'input-file': __WEBPACK_IMPORTED_MODULE_3__fileUploadField_vue__["default"]
  },
  props: {
    required: Boolean,
    disabled: Boolean,
    inputId: {
      type: String
    },
    name: {
      type: String,
      default: 'file'
    },
    buttonLabel: {
      type: String,
      default: 'Upload'
    },
    accept: {
      type: String
    },
    multiple: {
      type: Boolean
    },
    maximum: {
      type: Number,
      default: function _default() {
        return this.multiple ? 0 : 1;
      }
    },
    addIndex: {
      type: [Boolean, Number]
    },
    directory: {
      type: Boolean
    },
    postAction: {
      type: String
    },
    putAction: {
      type: String
    },
    headers: {
      type: Object,
      default: Object
    },
    data: {
      type: Object,
      default: Object
    },
    timeout: {
      type: Number,
      default: 0
    },
    drop: {
      default: false
    },
    dropDirectory: {
      type: Boolean,
      default: true
    },
    size: {
      type: Number,
      default: 0
    },
    extensions: {
      default: Array
    },
    value: {
      type: Array,
      default: Array
    },
    thread: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      files: this.value,
      features: {
        html5: true,
        directory: false,
        drag: false
      },
      active: false,
      dropActive: false,
      uploading: 0,
      destroy: false,
      editing: false
    };
  },
  mounted: function mounted() {
    var input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    // html5 feature
    if (window.FormData && input.files) {
      // Upload directory feature
      if (typeof input.webkitdirectory === 'boolean' || typeof input.directory === 'boolean') {
        this.features.directory = true;
      }
      // Drag and Drop Feature
      if (this.features.html5 && typeof input.ondrop !== 'undefined') {
        this.features.drop = true;
      }
    } else {
      this.features.html5 = false;
    }

    // files positioning cache
    this.maps = {};
    if (this.files) {
      for (var i = 0; i < this.files.length; i++) {
        var file = this.files[i];
        this.maps[file.id] = file;
      }
    }
    this.$nextTick(function () {
      // Update parent
      if (this.$parent) {
        this.$parent.$forceUpdate();
      }
      // Drag and Drop rendering
      this.watchDrop(this.drop);
    });
  },
  beforeDestroy: function beforeDestroy() {
    // destroyed
    this.destroy = true;
    // set to inactive
    this.active = false;
    this.editing = false;
  },
  computed: {
    /**
     * uploading thread
     * @return {[type]} [description]
     */
    /**
     * upload completed - entire file list uploaded
     * @return {[type]} [description]
     */
    uploaded: function uploaded() {
      var file;
      for (var i = 0; i < this.files.length; i++) {
        file = this.files[i];
        if (file.fileObject && !file.error && !file.success) {
          return false;
        }
      }
      return true;
    },
    className: function className() {
      return ['file-uploads', this.features.html5 ? 'file-uploads-html5' : 'file-uploads-html4', this.features.directory && this.directory ? 'file-uploads-directory' : undefined, this.features.drop && this.drop ? 'file-uploads-drop' : undefined];
    }
  },
  watch: {
    active: function active(_active) {
      this.watchActive(_active);
    },
    dropActive: function dropActive() {
      if (this.$parent) {
        this.$parent.$forceUpdate();
      }
    },
    drop: function drop(value) {
      this.watchDrop(value);
    },
    value: function value(files) {
      if (this.files === files || !files) {
        return;
      }
      this.files = files;
      var oldMaps = this.maps;

      // Rewrite maps cache
      this.maps = {};
      for (var i = 0; i < this.files.length; i++) {
        var file = this.files[i];
        this.maps[file.id] = file;
      }
      // add, update
      for (var key in this.maps) {
        var newFile = this.maps[key];
        var oldFile = oldMaps[key];
        if (newFile !== oldFile) {
          this.emitFile(newFile, oldFile);
        }
      }
      // delete
      for (var _key in oldMaps) {
        if (!this.maps[_key]) {
          this.emitFile(undefined, oldMaps[_key]);
        }
      }
    }
  },
  methods: {
    // Emptied
    clear: function clear() {
      if (this.files.length) {
        var files = this.files;
        this.files = [];
        // Positioning
        this.maps = {};
        // Event
        this.emitInput();
        for (var i = 0; i < files.length; i++) {
          this.emitFile(undefined, files[i]);
        }
      }
      return true;
    },
    // Select
    get: function get(id) {
      if (!id) {
        return false;
      }
      if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(id) === 'object') {
        return this.maps[id.id] || false;
      }
      return this.maps[id] || false;
    },
    // Add to
    add: function add(_files) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.addIndex;
      var files = _files;
      var isArray = files instanceof Array;
      // Not a nested array
      if (!isArray) {
        files = [files];
      }
      // Traverse the canonical object
      var addFiles = [];
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        if (this.features.html5 && file instanceof Blob) {
          file = {
            file: file,
            size: file.size,
            name: file.webkitRelativePath || file.relativePath || file.name || 'unknown',
            type: file.type
          };
        }
        var fileObject = false;
        if (file.fileObject === false) {
          // false
        } else if (file.fileObject) {
          fileObject = true;
        } else if (typeof Element !== 'undefined' && file.el instanceof Element) {
          fileObject = true;
        } else if (typeof Blob !== 'undefined' && file.file instanceof Blob) {
          fileObject = true;
        }
        if (fileObject) {
          file = _objectSpread(_objectSpread({
            fileObject: true,
            size: -1,
            name: 'Filename',
            type: '',
            active: false,
            error: '',
            success: false,
            putAction: this.putAction,
            postAction: this.postAction,
            timeout: this.timeout
          }, file), {}, {
            response: {},
            progress: '0.00',
            speed: 0,
            editing: false
          });
          file.data = _objectSpread(_objectSpread({}, this.data), file.data ? file.data : {});
          file.headers = _objectSpread(_objectSpread({}, this.headers), file.headers ? file.headers : {});
        }
        // Must include id
        if (!file.id) {
          file.id = Math.random().toString(36).substr(2);
        }
        if (this.emitFilter(file, undefined)) {
          continue;
        }
        // The maximum number of restrictions
        if (this.maximum > 1 && addFiles.length + this.files.length >= this.maximum) {
          break;
        }
        addFiles.push(file);
        // The maximum number of restriction
        if (this.maximum === 1) {
          break;
        }
      }
      // No files
      if (!addFiles.length) {
        return false;
      }
      // If 1 is empty
      if (this.maximum === 1) {
        this.clear();
      }
      // Add files
      var newFiles;
      if (index === true || index === 0) {
        newFiles = addFiles.concat(this.files);
      } else if (index) {
        newFiles = addFiles.concat([]);
        newFiles.splice(index, 0, addFiles);
      } else {
        newFiles = this.files.concat(addFiles);
      }
      this.files = newFiles;
      // Positioning
      for (var _i = 0; _i < addFiles.length; _i++) {
        var _file2 = addFiles[_i];
        this.maps[_file2.id] = _file2;
      }
      // Event
      this.emitInput();
      for (var _i2 = 0; _i2 < addFiles.length; _i2++) {
        this.emitFile(addFiles[_i2], undefined);
      }
      return isArray ? addFiles : addFiles[0];
    },
    // Add a form field
    addInputFile: function addInputFile(el) {
      var files = [];
      if (el.files) {
        for (var i = 0; i < el.files.length; i++) {
          var file = el.files[i];
          files.push({
            size: file.size,
            name: file.webkitRelativePath || file.relativePath || file.name,
            type: file.type,
            file: file,
            el: el
          });
        }
      } else {
        files.push({
          name: el.value.replace(/^.*?([^/\\\r\n]+)$/, '$1'),
          el: el
        });
      }
      return this.add(files);
    },
    // Add to DataTransfer
    addDataTransfer: function addDataTransfer(dataTransfer) {
      var _this = this;
      var files = [];
      if (dataTransfer.items && dataTransfer.items.length) {
        var items = [];
        for (var i = 0; i < dataTransfer.items.length; i++) {
          var item = dataTransfer.items[i];
          if (item.getAsEntry) {
            item = item.getAsEntry();
          } else if (item.webkitGetAsEntry) {
            item = item.webkitGetAsEntry();
          } else {
            item = item.getAsFile();
          }
          if (item) {
            items.push(item);
          }
        }
        return new Promise(function (resolve, reject) {
          var _forEach = function forEach(i) {
            var item = items[i];
            // The end of the file number is greater than the maximum number
            if (!item || _this.maximum > 0 && files.length >= _this.maximum) {
              return resolve(_this.add(files));
            }
            _this.getEntry(item).then(function (results) {
              files.push.apply(files, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(results));
              _forEach(i + 1);
            });
          };
          _forEach(0);
        });
      }
      if (dataTransfer.files.length) {
        for (var _i3 = 0; _i3 < dataTransfer.files.length; _i3++) {
          files.push(dataTransfer.files[_i3]);
          if (this.maximum > 0 && files.length >= this.maximum) {
            break;
          }
        }
        return Promise.resolve(this.add(files));
      }
      return Promise.resolve([]);
    },
    // Obtain entry
    getEntry: function getEntry(entry) {
      var _this2 = this;
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return new Promise(function (resolve, reject) {
        if (entry.isFile) {
          entry.file(function (file) {
            resolve([{
              size: file.size,
              name: path + file.name,
              type: file.type,
              file: file
            }]);
          });
        } else if (entry.isDirectory && _this2.dropDirectory) {
          entry.createReader().readEntries(function (entries) {
            var files = [];
            var _forEach2 = function forEach(i) {
              if (!entries[i] || _this2.maximum > 0 && files.length >= _this2.maximum) {
                return resolve(files);
              }
              _this2.getEntry(entries[i], path + entry.name + '/').then(function (results) {
                files.push.apply(files, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(results));
                _forEach2(i + 1);
              });
            };
            _forEach2(0);
          });
        } else {
          resolve([]);
        }
      });
    },
    replace: function replace(id1, id2) {
      var file1 = this.get(id1);
      var file2 = this.get(id2);
      if (!file1 || !file2 || file1 === file2) {
        return false;
      }
      var files = this.files.concat([]);
      var index1 = files.indexOf(file1);
      var index2 = files.indexOf(file2);
      if (index1 === -1 || index2 === -1) {
        return false;
      }
      files[index1] = file2;
      files[index2] = file1;
      this.files = files;
      this.emitInput();
      return true;
    },
    // Remove
    remove: function remove(id) {
      var file = this.get(id);
      if (file) {
        if (this.emitFilter(undefined, file)) {
          return false;
        }
        var files = this.files.concat([]);
        var index = files.indexOf(file);
        if (index === -1) {
          console.error('remove', file);
          return false;
        }
        files.splice(index, 1);
        this.files = files;
        // Positioning
        delete this.maps[file.id];
        // Event
        this.emitInput();
        this.emitFile(undefined, file);
      }
      return file;
    },
    // Updated
    update: function update(id, data) {
      var file = this.get(id);
      if (file) {
        var newFile = _objectSpread(_objectSpread({}, file), data);
        // Disabled must be added error
        if (file.fileObject && file.active && !newFile.active && !newFile.error && !newFile.success) {
          newFile.error = 'abort';
        }
        if (this.emitFilter(newFile, file)) {
          return false;
        }
        var files = this.files.concat([]);
        var index = files.indexOf(file);
        if (index === -1) {
          console.error('update', file);
          return false;
        }
        files.splice(index, 1, newFile);
        this.files = files;
        // Delete old location write new location(already support to modify id)
        delete this.maps[file.id];
        this.maps[newFile.id] = newFile;
        // event
        this.emitInput();
        this.emitFile(newFile, file);
        return newFile;
      }
      return false;
    },
    // Preprocessing event filters
    emitFilter: function emitFilter(newFile, oldFile) {
      var isPrevent = false;
      this.$emit('input-filter', newFile, oldFile, function () {
        isPrevent = true;
        return isPrevent;
      });
      return isPrevent;
    },
    // Processed event distribution
    emitFile: function emitFile(newFile, oldFile) {
      this.$emit('input-file', newFile, oldFile);
      if (newFile && newFile.fileObject && newFile.active && (!oldFile || !oldFile.active)) {
        this.uploading++;
        // activation
        this.$nextTick(function () {
          var _this3 = this;
          setTimeout(function () {
            _this3.upload(newFile).then(function () {
              // eslint-disable-next-line
              newFile = _this3.get(newFile);
              if (newFile && newFile.fileObject) {
                _this3.update(newFile, {
                  active: false,
                  success: !newFile.error
                });
              }
            }).catch(function (e) {
              _this3.update(newFile, {
                active: false,
                success: false,
                error: e.code || e.error || e.message || e
              });
            });
          }, parseInt(Math.random() * 50 + 50, 10));
        });
      } else if ((!newFile || !newFile.fileObject || !newFile.active) && oldFile && oldFile.fileObject && oldFile.active) {
        // stop
        this.uploading--;
      }
      // Automatic continuation of activation
      if (this.active && (Boolean(newFile) !== Boolean(oldFile) || newFile.active !== oldFile.active)) {
        this.watchActive(true);
      }
    },
    emitInput: function emitInput() {
      this.$emit('input', this.files);
    },
    // Upload
    upload: function upload(id) {
      var file = this.get(id);
      // been deleted
      if (!file) {
        return Promise.reject('not_exists');
      }
      // Not a file object
      if (!file.fileObject) {
        return Promise.reject('file_object');
      }
      // Direct error response
      if (file.error) {
        return Promise.reject(file.error);
      }
      // Direct success response
      if (file.success) {
        return Promise.resolve(file);
      }
      // suffix
      var extensions = this.extensions;
      if (extensions && (extensions.length || typeof extensions.length === 'undefined')) {
        if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(extensions) !== 'object' || !(extensions instanceof RegExp)) {
          if (typeof extensions === 'string') {
            extensions = extensions.split(',').map(function (value) {
              return value.trim();
            }).filter(function (value) {
              return value;
            });
          }
          extensions = new RegExp('\\.(' + extensions.join('|').replace(/\./g, '\\.') + ')$', 'i');
        }
        if (file.name.search(extensions) === -1) {
          return Promise.reject('extension');
        }
      }
      // size
      if (this.size > 0 && file.size >= 0 && file.size > this.size) {
        return Promise.reject('size');
      }
      if (this.features.html5 && file.putAction) {
        return this.uploadPut(file);
      } else if (this.features.html5) {
        return this.uploadHtml5(file);
      } else {
        return this.uploadHtml4(file);
      }
    },
    uploadPut: function uploadPut(file) {
      var querys = [];
      var value;
      for (var key in file.data) {
        value = file.data[key];
        if (value !== null && value !== undefined) {
          querys.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
      }
      var queryString = querys.length ? (file.putAction.indexOf('?') === -1 ? '?' : '&') + querys.join('&') : '';
      var xhr = new XMLHttpRequest();
      xhr.open('PUT', file.putAction + queryString);
      return this.uploadXhr(xhr, file, file.file);
    },
    uploadHtml5: function uploadHtml5(file) {
      var form = new window.FormData();
      var value;
      for (var key in file.data) {
        value = file.data[key];
        if (value && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(value) === 'object' && typeof value.toString !== 'function') {
          if (value instanceof File) {
            form.append(key, value, value.name);
          } else {
            form.append(key, JSON.stringify(value));
          }
        } else if (value !== null && value !== undefined) {
          form.append(key, value);
        }
      }
      form.append(this.name, file.file, file.file && file.file.filename || file.name);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', file.postAction);
      return this.uploadXhr(xhr, file, form);
    },
    uploadXhr: function uploadXhr(xhr, _file, body) {
      var _this4 = this;
      var file = _file;
      var speedTime = 0;
      var speedLoaded = 0;

      // allow cookies to be sent cross origin
      xhr.withCredentials = true;

      // progress bar
      xhr.upload.onprogress = function (e) {
        // upload is deleted or not deactivated before it started
        file = _this4.get(file);
        if (!e.lengthComputable || !file || !file.fileObject || !file.active) {
          return;
        }
        // Progress rate updated every second
        var speedTime2 = Math.round(Date.now() / 1000);
        if (speedTime2 === speedTime) {
          return;
        }
        speedTime = speedTime2;
        file = _this4.update(file, {
          progress: (e.loaded / e.total * 100).toFixed(2),
          speed: e.loaded - speedLoaded
        });
        speedLoaded = e.loaded;
      };
      // Check the activation status
      var interval = setInterval(function () {
        file = _this4.get(file);
        if (file && file.fileObject && !file.success && !file.error && file.active) {
          return;
        }
        if (interval) {
          clearInterval(interval);
          interval = false;
        }
        try {
          xhr.abort();
          xhr.timeout = 1;
        } catch (e) {}
      }, 100);
      return new Promise(function (resolve, reject) {
        var complete;
        var fn = function fn(e) {
          // Already handled
          if (complete) {
            return;
          }
          complete = true;
          if (interval) {
            clearInterval(interval);
            interval = false;
          }
          file = _this4.get(file);
          // There is no direct response
          if (!file) {
            return reject('not_exists');
          }
          // Not a file object
          if (!file.fileObject) {
            return reject('file_object');
          }
          // Direct error response
          if (file.error) {
            return reject(file.error);
          }
          // deactivated
          if (!file.active) {
            return reject('abort');
          }
          // direct success response
          if (file.success) {
            return resolve(file);
          }
          var data = {};
          switch (e.type) {
            case 'timeout':
            case 'abort':
              data.error = e.type;
              break;
            case 'error':
              if (!xhr.status) {
                data.error = 'network';
              } else if (xhr.status >= 500) {
                data.error = 'server';
              } else if (xhr.status >= 400) {
                data.error = 'denied';
              }
              break;
            default:
              if (xhr.status >= 500) {
                data.error = 'server';
              } else if (xhr.status >= 400) {
                data.error = 'denied';
              } else {
                data.progress = '100.00';
              }
          }
          if (xhr.responseText) {
            var contentType = xhr.getResponseHeader('Content-Type');
            if (contentType && contentType.indexOf('/json') !== -1) {
              data.response = JSON.parse(xhr.responseText);
            } else {
              data.response = xhr.responseText;
            }
          }
          // Updated
          file = _this4.update(file, data);
          // The error
          if (file.error) {
            return reject(file.error);
          }
          // The response
          return resolve(file);
        };
        // event
        xhr.onload = fn;
        xhr.onerror = fn;
        xhr.onabort = fn;
        xhr.ontimeout = fn;
        // time-out
        if (file.timeout) {
          xhr.timeout = file.timeout;
        }
        // headers
        for (var key in file.headers) {
          xhr.setRequestHeader(key, file.headers[key]);
        }
        // Updated xhr
        file = _this4.update(file, {
          xhr: xhr
        });
        // Start upload
        xhr.send(body);
      });
    },
    uploadHtml4: function uploadHtml4(_file) {
      var _this5 = this;
      var file = _file;
      var onKeydown = function onKeydown(e) {
        if (e.keyCode === 27) {
          e.preventDefault();
        }
      };
      var iframe = document.createElement('iframe');
      iframe.id = 'upload-iframe-' + file.id;
      iframe.name = 'upload-iframe-' + file.id;
      iframe.src = 'about:blank';
      iframe.setAttribute('style', 'width:1px;height:1px;top:-999em;position:absolute; margin-top:-999em;');
      var form = document.createElement('form');
      form.action = file.postAction;
      form.name = 'upload-form-' + file.id;
      form.setAttribute('method', 'POST');
      form.setAttribute('target', 'upload-iframe-' + file.id);
      form.setAttribute('enctype', 'multipart/form-data');
      var value;
      var input;
      for (var key in file.data) {
        value = file.data[key];
        if (value && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(value) === 'object' && typeof value.toString !== 'function') {
          value = JSON.stringify(value);
        }
        if (value !== null && value !== undefined) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          form.appendChild(input);
        }
      }
      form.appendChild(file.el);
      document.body.appendChild(iframe).appendChild(form);
      var getResponseData = function getResponseData() {
        var doc;
        try {
          if (iframe.contentWindow) {
            doc = iframe.contentWindow.document;
          }
        } catch (err) {}
        if (!doc) {
          try {
            doc = iframe.contentDocument ? iframe.contentDocument : iframe.document;
          } catch (err) {
            doc = iframe.document;
          }
        }
        if (doc && doc.body) {
          return doc.body.innerHTML;
        }
        return null;
      };
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          file = _this5.update(file, {
            iframe: iframe
          });
          // file does not exist
          if (!file) {
            return reject('not_exists');
          }
          // Check regularly
          var interval = setInterval(function () {
            file = _this5.get(file);
            if (file && file.fileObject && !file.success && !file.error && file.active) {
              return;
            }
            if (interval) {
              clearInterval(interval);
              interval = false;
            }
            iframe.onabort({
              type: file ? 'abort' : 'not_exists'
            });
          }, 100);
          var complete;
          var fn = function fn(e) {
            // Already handled
            if (complete) {
              return;
            }
            complete = true;
            if (interval) {
              clearInterval(interval);
              interval = false;
            }
            // Close esc event
            document.body.removeEventListener('keydown', onKeydown);
            file = _this5.get(file);
            // no direct response
            if (!file) {
              return reject('not_exists');
            }
            // Not a file object
            if (!file.fileObject) {
              return reject('file_object');
            }
            // direct error response
            if (file.error) {
              return reject(file.error);
            }
            // file is deactivated
            if (!file.active) {
              return reject('abort');
            }
            // direct success response
            if (file.success) {
              return resolve(file);
            }
            var response = getResponseData();
            var data = {};
            switch (e.type) {
              case 'abort':
                data.error = 'abort';
                break;
              case 'error':
                if (file.error) {
                  data.error = file.error;
                } else if (response === null) {
                  data.error = 'network';
                } else {
                  data.error = 'denied';
                }
                break;
              default:
                if (file.error) {
                  data.error = file.error;
                } else if (data === null) {
                  data.error = 'network';
                } else {
                  data.progress = '100.00';
                }
            }
            if (response !== null) {
              if (response && response.substr(0, 1) === '{' && response.substr(response.length - 1, 1) === '}') {
                try {
                  response = JSON.parse(response);
                } catch (err) {}
              }
              data.response = response;
            }
            // Updated
            file = _this5.update(file, data);
            if (file.error) {
              return reject(file.error);
            }
            // response
            return resolve(file);
          };
          // Add Event
          iframe.onload = fn;
          iframe.onerror = fn;
          iframe.onabort = fn;
          // Forbid esc key
          document.body.addEventListener('keydown', onKeydown);
          // submit form
          form.submit();
        }, 50);
      }).then(function (res) {
        iframe.parentNode && iframe.parentNode.removeChild(iframe);
        return res;
      }).catch(function (res) {
        iframe.parentNode && iframe.parentNode.removeChild(iframe);
        return res;
      });
    },
    watchActive: function watchActive(active) {
      var file;
      var index = 0;
      while (file = this.files[index]) {
        index++;
        if (!file.fileObject) {
          // Not a file object
        } else if (active && !this.destroy) {
          if (this.uploading >= this.thread || this.uploading && !this.features.html5) {
            break;
          }
          if (!file.active && !file.error && !file.success) {
            this.update(file, {
              active: true
            });
          }
        } else {
          if (file.active) {
            this.update(file, {
              active: false
            });
          }
        }
      }
      if (this.uploading === 0) {
        this.active = false;
      }
    },
    watchDrop: function watchDrop(_el) {
      var el = _el;
      if (!this.features.drop) {
        return;
      }
      // Remove mount
      if (this.dropElement) {
        try {
          document.removeEventListener('dragenter', this.onDragenter, false);
          document.removeEventListener('dragleave', this.onDragleave, false);
          this.dropElement.removeEventListener('dragover', this.onDragover, false);
          this.dropElement.removeEventListener('drop', this.onDrop, false);
        } catch (e) {}
      }
      if (!el) {
        el = false;
      } else if (typeof el === 'string') {
        el = document.querySelector(el) || this.$root.$el.querySelector(el);
      } else if (el === true) {
        el = this.$parent.$el;
      }
      this.dropElement = el;
      if (this.dropElement) {
        document.addEventListener('dragenter', this.onDragenter, false);
        document.addEventListener('dragleave', this.onDragleave, false);
        this.dropElement.addEventListener('dragover', this.onDragover, false);
        this.dropElement.addEventListener('drop', this.onDrop, false);
      }
    },
    onDragenter: function onDragenter(e) {
      e.preventDefault();
      if (!this.dropActive) {
        this.dropActive = true;
      }
    },
    onDragleave: function onDragleave(e) {
      e.preventDefault();
      if (e.target.nodeName === 'HTML' || e.screenX === 0 && e.screenY === 0 && !e.fromElement && e.offsetX <= 0) {
        this.dropActive = false;
      }
    },
    onDragover: function onDragover(e) {
      e.preventDefault();
    },
    onDrop: function onDrop(e) {
      e.preventDefault();
      this.dropActive = false;
      this.addDataTransfer(e.dataTransfer);
    }
  }
});

/***/ }),

/***/ "Skn6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_39vp9DSMe6eTe9SRO6Ucuw","Dell":"_2QXyoKMGAUDs45ZaiQWagW","Abbott":"_2hEL6nCK7rAabQ2r4U2iyY","Gap":"_3XYu2pADK-N2cJcf95Fa7Y","Allstate":"_1kmcL6RaHpos2w74GOQdFk","Asurion":"_1uv3DtTlHVrb1yiMt_BbEK","Invitae":"_1JvojA0g1UMAnDQW9fe_H8","JWE":"_2Icji82afAUc9XXr7YO4nR"};

/***/ }),

/***/ "SlAw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.useHighLevelAllocation !== null)?_c('div',{staticClass:"i2p-new-page"},[_c('ed-title-nav',{ref:"header",attrs:{"title":_vm.$t('Submit Invoice'),"subtitle":_vm.getSubtitle}},[(_vm.settingsModel.CompanySettings.EditingInvoiceScan)?_c('budget-scan-snapshot',{attrs:{"slot":"overview","model":_vm.budgetScanSnapshotModel},slot:"overview"}):_c('budget-snapshot',{attrs:{"slot":"overview","model":_vm.budgetSnapshotModel},slot:"overview"}),_vm._v(" "),_c('span',{attrs:{"slot":"action"},slot:"action"},[(_vm.$root.legacySubtab && !_vm.showSubmitBatchBtn)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.beforeCancelInvoice}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("  Back")])]):_vm._e()]),_vm._v(" "),_c('TheToolbar',{attrs:{"slot":"toolbar"},slot:"toolbar"},[(_vm.showCommentsBtn)?_c('comments',{attrs:{"invoiceKey":_vm.invoiceInformationModel.InvoiceKey,"paymentInvoiceId":_vm.paymentInvoiceId,"programId":_vm.programId,"userToken":_vm.user.token}}):_vm._e(),_vm._v(" "),(_vm.invoiceInformationModel.IsFromEmailForScanning)?_c('ed-button',{attrs:{"button-class":"btn btn-actionbar"},on:{"click":function($event){return _vm.openReviewEmailModal()}}},[_vm._v("\n                  Review Email\n        ")]):_vm._e(),_vm._v(" "),_c('ReviewEmailModal',{attrs:{"show":_vm.showReviewEmailModal,"emailData":_vm.reviewEmailContent,"paymentInvoiceId":_vm.paymentInvoiceId},on:{"close":_vm.closeReviewEmailModal}}),_vm._v(" "),(!_vm.checkZipMatches && _vm.settingsModel.CompanySettings.EditingInvoiceScan === true && _vm.isEvedSupplier)?_c('ed-button',{attrs:{"button-class":"btn btn-actionbar","endpoint":_vm.api.$.invoice.sendZipMismatchEmail},on:{"click":function($event){return _vm.sendZipMismatchEmail()}}},[_vm._v("\n          Send Zip Mismatch Email\n        ")]):_vm._e(),_vm._v(" "),(_vm.showSaveBtn)?_c('ed-button',{attrs:{"name":"save","disabled":_vm.submitDisabled,"button-class":"btn btn-actionbar"},on:{"click":function($event){return _vm.saveOneInvoice(false)}}},[_vm._v("\n          Save As Draft\n        ")]):_vm._e(),_vm._v(" "),(_vm.showAddAnotherBtn)?_c('ed-button',{attrs:{"name":"add-another","disabled":_vm.submitDisabled,"button-class":"btn btn-actionbar"},on:{"click":function($event){return _vm.submitAndAddAnother()}}},[_vm._v("\n          Add Another Invoice\n        ")]):_vm._e(),_vm._v(" "),(_vm.showSubmitBatchBtn)?_c('ed-button',{staticClass:"alt",attrs:{"name":"submit-batch","disabled":_vm.submitDisabled,"button-class":"btn btn-actionbar"},on:{"click":function($event){return _vm.initSubmitBatch()}}},[_vm._v("\n          Submit Batch\n        ")]):_vm._e(),_vm._v(" "),(!_vm.showSubmitBatchBtn)?_c('ed-button',{staticClass:"alt",attrs:{"name":"submit","disabled":_vm.submitDisabled,"button-class":"btn btn-actionbar"},on:{"click":function($event){return _vm.saveOneInvoice(true)}}},[_vm._v("\n          Submit Invoice\n        ")]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('br'),_vm._v(" "),_c('invoice-information',{ref:"invoiceInformationRef",attrs:{"model":_vm.invoiceInformationModel,"divisionLabel":_vm.divisionLabel,"purchaseOrderForBillTo":_vm.initData.purchaseOrder,"settings":_vm.settingsModel,"user":_vm.user,"useHighLevelAllocation":_vm.useHighLevelAllocation,"maxInvoiceAmount":_vm.maxInvoiceAmount,"initialInvoiceAmount":_vm.invoiceInformationInitialModel.InvoiceAmount},on:{"supplierSelected":_vm.addSupplierData,"supplierRemoved":_vm.removeSupplierData,"currencySelected":_vm.onCurrencySelected,"beforeProgramSelected":_vm.validateProgramSelected,"changeSameDaySetting":_vm.onChangeSameDaySetting,"changeReimbursementSetting":_vm.onChangeReimbursementSetting,"discountSelected":_vm.onDiscountSelected,"updatePOModel":_vm.onUpdatePOModel,"poAmountChanged":_vm.onPOAmountChanged,"supplier-zip-code-changed":_vm.checkIfZipMatches}}),_vm._v(" "),(_vm.showLineItems)?_c('div',[(_vm.canAddLineItems)?_c('line-items-section',{ref:"lineItemsComp",attrs:{"model":_vm.purchaseOrder,"dependencies":_vm.dependencies,"settings":_vm.settingsModel.CompanySettings,"programId":_vm.programId,"invoiceId":_vm.invoiceInformationModel.PaymentInvoiceId,"buyerVendorId":_vm.user.buyerVendorId,"useSavingsFields":_vm.invoiceInformationModel.UseSavingsFields && (!_vm.isP2PInvoice || _vm.isP2PInvoiceWithAddEditItems),"invoiceSettings":_vm.invoiceInformationModel,"isP2PInvoice":_vm.isP2PInvoice,"decouplingSettings":_vm.getDecouplingSettings}}):(_vm.useHighLevelAllocation)?_c('div',[(_vm.showCCAllocations)?_c('high-allocation-section',{attrs:{"model":_vm.ccAllocations,"currencyCode":_vm.currencyCode,"invoiceAmount":_vm.InvoiceAmount}}):_vm._e(),_vm._v(" "),(_vm.showPairsAllocations)?_c('high-allocation-section',{attrs:{"model":_vm.pairsAllocations,"currencyCode":_vm.currencyCode,"invoiceAmount":_vm.InvoiceAmount}}):_vm._e(),_vm._v(" "),(_vm.showCategoryAllocations)?_c('high-allocation-section',{attrs:{"model":_vm.categoriesAllocations,"currencyCode":_vm.currencyCode,"invoiceAmount":_vm.InvoiceAmount,"vatAmount":_vm.VATAmount,"additionalNoRequired":_vm.categRefIdRequired}}):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.settingsModel.CompanySettings.EditingInvoiceScan === false)?_c('div',{staticClass:"content no-flex active"},[_c('ed-section',{staticClass:"no-flex active no-border",attrs:{"title":"Approval","wide":""}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-8"},[_c('label',[_c('strong',[_vm._v("Invoice Approval")])])]),_vm._v(" "),_c('ed-checkbox',{staticClass:"col-md-8",attrs:{"options":_vm.approvalCheckboxOptions,"name":"approve_invoice_checkbox","required":"","error":_vm.approvalCheckboxError,"helptip-body":"Please approve the submission of this invoice to continue","helptip-header":""},on:{"click":_vm.checkApprovalCheckBox}}),_vm._v(" "),(_vm.isCreateInvoice() || _vm.invoiceInformationModel.IsDraft)?_c('div',{staticClass:"col-md-8"},[_c('label',[_c('strong',[_vm._v(_vm._s(_vm.settingsModel.CompanySettings.ApprovalNoteLabel)+" "),(!_vm.settingsModel.CompanySettings.IsApprovalNoteRequired)?_c('span',[_vm._v("- optional")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.settingsModel.CompanySettings.ApprovalNotePlaceholder)?_c('span',[_c('small',[_c('em',[_vm._v("Please complete the statement below")])])]):_vm._e(),_vm._v(" "),_c('ed-textarea',{attrs:{"rows":5,"error":_vm.approvalNoteError,"errorTipBody":"Please enter the Approval Note","errorTipHeader":"","name":"invoice_approval_note_textarea"},on:{"input":_vm.onApprovalNoteChange},model:{value:(_vm.invoiceInformationModel.ApproveNote),callback:function ($$v) {_vm.$set(_vm.invoiceInformationModel, "ApproveNote", $$v)},expression:"invoiceInformationModel.ApproveNote"}})],1):_vm._e()],1)])],1):_vm._e(),_vm._v(" "),(_vm.showAdditionalInvoiceConfirmation)?_c('div',{staticClass:"content no-flex active"},[_c('ed-section',{staticClass:"no-flex active no-border no-margin",attrs:{"title":"Additional Invoice Confirmation","wide":""}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-8"},[_c('label',[_c('strong',[_vm._v("Additional Invoice Confirmation")])])]),_vm._v(" "),_c('ed-checkbox',{staticClass:"col-md-8 line-break",attrs:{"options":_vm.additionalInvoiceConfirmationOptions,"name":"additional_confirm_invoice_checkbox","required":"","error":_vm.additionalInvoiceConfirmationError,"helptip-body":"Please check the additional invoice confirmation","helptip-header":""},on:{"click":_vm.checkAdditionalInvoiceConfirmationBox}})],1)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content no-flex active"},[_c('ed-section',{staticClass:"no-flex active no-border no-margin",attrs:{"title":" ","wide":""}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-5"},[(_vm.showAddAnotherBtn)?_c('ed-button',{staticClass:"cta alt",attrs:{"disabled":_vm.submitDisabled,"button-class":"btn btn-secondary"},on:{"click":function($event){return _vm.submitAndAddAnother()}}},[_vm._v("\n                "+_vm._s(_vm.$t("Add Another Invoice"))+"\n              ")]):_vm._e()],1),_vm._v(" "),(_vm.showSubmitBatchBtn)?_c('div',{staticClass:"col-md-3"},[_c('ed-button',{staticClass:"cta alt",attrs:{"disabled":_vm.submitDisabled},on:{"click":function($event){return _vm.initSubmitBatch()}}},[_vm._v("\n                "+_vm._s(_vm.$t("Submit Batch"))+"\n              ")])],1):_vm._e(),_vm._v(" "),(!_vm.showSubmitBatchBtn)?_c('div',{class:_vm.showAddAnotherBtn ? 'col-md-3' : 'col-md-8'},[(!_vm.checkZipMatches && _vm.settingsModel.CompanySettings.EditingInvoiceScan === true && _vm.isEvedSupplier)?_c('ed-button',{staticClass:"cta alt",staticStyle:{"background-color":"white","color":"#333","border":"1px solid #ccc"},attrs:{"endpoint":_vm.api.$.invoice.sendZipMismatchEmail},on:{"click":function($event){return _vm.sendZipMismatchEmail()}}},[_vm._v("\n                Send Zip Mismatch Email\n              ")]):_vm._e(),_vm._v(" "),_c('ed-button',{staticClass:"cta alt",attrs:{"disabled":_vm.submitDisabled},on:{"click":function($event){return _vm.saveOneInvoice(true)}}},[_vm._v("\n                "+_vm._s(_vm.$t("Submit Invoice"))+"\n              ")])],1):_vm._e()])])],1)],1),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showValidationError,"title":_vm.validationTitle,"primaryButton":"false","secondaryButton":"Ok","type":"small"},on:{"close":_vm.closeValidationError}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_c('br'),_vm._v(_vm._s(_vm.validationErrorTitle))])])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showDuplicateInvoiceStep1 && !_vm.showDuplicateInvoiceStep2,"title":"Duplicate Invoice Warning","primaryButton":"Submit Invoice","secondaryButton":"Cancel","closeOnEsc":true},on:{"close":function($event){_vm.showDuplicateInvoiceStep1 = false},"confirm":function($event){_vm.showDuplicateInvoiceStep2 = true}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("It looks like the invoice you are submitting may be a duplicate.")]),_vm._v(" "),_c('p',[_vm._v("Click here to view the duplicate invoice PDF in a new tab.")]),_vm._v(" "),_vm._l((_vm.duplicateInvoices),function(inv,index){return _c('p',{key:index},[_c('a',{attrs:{"href":_vm.duplicateInvoicePdfUrl(inv.PaymentInvoiceID),"target":"_blank"}},[_vm._v(_vm._s(inv.InvoiceNumber))])])}),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("Please review the potential existing duplicate invoice and then indicate whether you will want to submit this invoice for payment.")]),_vm._v(" "),_c('br')],2)]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showDuplicateInvoiceStep2,"title":"Duplicate Invoice Warning - Confirm Submission","primaryButton":"Submit Invoice","secondaryButton":"Cancel","closeOnEsc":true},on:{"close":function($event){_vm.showDuplicateInvoiceStep2 = false},"confirm":_vm.duplicateInvoiceAction}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("Are you sure you want to submit this duplicate invoice?")]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showOverBudgetWarning,"title":"Invoice Over Budget","primaryButton":"OK","secondaryButton":"EDIT","additionalButton":"CANCEL INVOICE","closeOnEsc":true},on:{"close":function($event){_vm.showOverBudgetWarning = false},"confirm":_vm.confirmOverBudget,"additionalAction":_vm.doCancelInvoiceAction}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('br'),_vm._v(" "),_c('p',[_vm._v("The total amount of the "+_vm._s(_vm.overBudgetModel.Context.toLowerCase().trim())+" puts your "+_vm._s(_vm.programLabel)+" over budget.")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"row small"},[_c('strong',{staticClass:"col-md-6"},[_vm._v("Revised Budget:")]),_vm._v(" "),_c('span',{staticClass:"col-md-6"},[_vm._v("\n            "+_vm._s(_vm.overBudgetModel.RevisedBudgetFormatted)+"\n             \n          ")]),_vm._v(" "),_c('strong',{staticClass:"col-md-6"},[_vm._v("Current Budget Balance:")]),_vm._v(" "),_c('span',{staticClass:"col-md-6"},[_vm._v("\n            "+_vm._s(_vm.overBudgetModel.BalanceFormatted)+"\n             \n          ")]),_vm._v(" "),_c('strong',{staticClass:"col-md-6"},[_vm._v(_vm._s(_vm.overBudgetModel.Context)+" Total:")]),_vm._v(" "),_c('span',{staticClass:"col-md-6"},[_vm._v("\n            "+_vm._s(_vm.overBudgetModel.POAmountFormatted)+"\n             \n          ")]),_vm._v(" "),(_vm.overBudgetModel.ExcludeVATFromBudget)?_c('strong',{staticClass:"col-md-6"},[_vm._v(_vm._s(_vm.overBudgetModel.Context)+" Total less VAT/GST:")]):_vm._e(),_vm._v(" "),(_vm.overBudgetModel.ExcludeVATFromBudget)?_c('span',{staticClass:"col-md-6"},[_vm._v("\n            "+_vm._s(_vm.overBudgetModel.POAmountLessVATFormatted)+"\n             \n          ")]):_vm._e(),_vm._v(" "),_c('strong',{staticClass:"col-md-6"},[_vm._v("Total Over Budget Amount:")]),_vm._v(" "),_c('span',{staticClass:"col-md-6"},[_vm._v("\n            "+_vm._s(_vm.overBudgetModel.POAmountOverBudgetFormatted)+"\n             \n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.overBudgetModel.Message))]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showOverBudgetWarningBeforeSendingToScan,"title":"Invoice Over Budget","primaryButton":"OK","secondaryButton":"CANCEL","closeOnEsc":true},on:{"confirm":_vm.onAcceptOverBudgetWarningBeforeSendingToScan,"close":function($event){_vm.showOverBudgetWarningBeforeSendingToScan = false}}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("The total amount of the invoice puts your "+_vm._s(_vm.programLabel)+" over budget.")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"row small"},[_c('strong',{staticClass:"col-md-6"},[_vm._v("Total Over Budget Amount:")]),_vm._v(" "),_c('span',{staticClass:"col-md-6"},[_c('v-money',{attrs:{"currency":_vm.invoiceInformationModel.ProgramCurrencyCode,"name":"invoice-amount-modal"}},[_vm._v(_vm._s(_vm.overBudgetAmountBeforeSendingToScan))]),_vm._v("\n             \n          ")],1)])])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showSupplierZipCodeWarning,"title":"Postal/Zip Codes do not match","primaryButton":"SUPPLIER IS CORRECT","secondaryButton":"GO BACK","closeOnEsc":true},on:{"confirm":_vm.onAcceptSupplierZipCodeWarning,"close":function($event){_vm.showSupplierZipCodeWarning = false}}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("The Postal/Zip Code you provided is different than the Supplier's Postal/Zip Code in Eved.")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("Please confirm you have selected the correct supplier or click Go Back to return to the invoice submission.")])])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showPendingScanningWarning,"title":"Invoice Submitted","primaryButton":"false","secondaryButton":"Ok","closeOnEsc":true},on:{"close":_vm.closePendingScanningModal,"confirm":_vm.closePendingScanningModal}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("Your invoice has been successfully submitted and it will be scanned in 1 business day.")])])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showDifferentAmountWarning,"title":"Invoice Scanning","primaryButton":"CONFIRM","secondaryButton":"CANCEL","closeOnEsc":true},on:{"close":_vm.onCloseDifferentAmountModal,"confirm":_vm.onConfirmDifferentAmountModal}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("The total amount of the line items is "),_c('v-money',{attrs:{"currency":_vm.currencyCode,"name":"invoice-amount-modal"}},[_vm._v(_vm._s(_vm.purchaseOrder.PO.total))]),_vm._v(".\n        The planner indicated that the invoice needs to be "),_c('v-money',{attrs:{"currency":_vm.currencyCode,"name":"initial-invoice-amount-modal"}},[_vm._v(_vm._s(_vm.invoiceInformationModel.InitialTotalAmount))]),_vm._v(". Are you sure the invoice is correct?")],1)])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showUnitPriceAtZeroWarning,"title":"Unit Price at Zero","primaryButton":"Submit","secondaryButton":"Go Back","closeOnEsc":true},on:{"close":function($event){_vm.showUnitPriceAtZeroWarning = false},"confirm":_vm.onConfirmUnitPriceAtZero}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("One or more line items in the invoice have been set as "),_c('v-money',{attrs:{"currency":_vm.currencyCode,"name":"invoice-amount-modal"}},[_vm._v("0")]),_vm._v(".\n        If that was not intended, select Go Back and enter a new price.")],1)])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.modals.showSubmitBatchConfirmation,"title":"Submit Batch","primaryButton":"Submit","secondaryButton":"Go Back","closeOnEsc":true,"type":"medium"},on:{"show":function($event){return _vm.$refs.batchInvoicesRef.onSelectAll(true)},"close":_vm.onSubmitBatchClose,"confirm":_vm.onSubmitBatchConfirmation}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v(_vm._s(_vm.getBatchPopupMessage))]),_vm._v(" "),_c('grid',{ref:"batchInvoicesRef",class:{ simple: true },attrs:{"layout":"frame","model":_vm.getBatchGridModel,"data":_vm.batch.invoices,"fit-columns":true,"auto-height":true,"disableFilter":true,"checkboxes":true,"hideSelectAll":true,"search":false,"resizing":false,"footer":false},on:{"selectedRows":_vm.onBatchInvoiceSelected}}),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.noOfInvoicesToSubmit)+" invoices will be submitted, "+_vm._s(_vm.noOfDraftInvoicesInBatch)+" saved as a draft")])],1)]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showBudgetAlmostUsedNotification,"title":'Budget balance is less than 20% left',"primaryButton":"false","secondaryButton":"Ok","closeOnEsc":true,"type":"medium"},on:{"close":_vm.closeBudgetAlmostUsedNotification,"confirm":_vm.closeBudgetAlmostUsedNotification}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("Submitting this invoice will bring the budget balance to less than 20%. Please review the "+_vm._s(_vm.programLabel)+" and request additional budget if additional invoices need to be paid to your suppliers.")])])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.modals.showSupplierProvideServicesConfirmation && _vm.purchaseOrder.PO.billTo.address,"title":'Did the supplier provide services in the ' + _vm.purchaseOrder.PO.billTo.address.country + '?',"primaryButton":'Services provided inside the ' + _vm.purchaseOrder.PO.billTo.address.country,"secondaryButton":'Services provided outside the ' + _vm.purchaseOrder.PO.billTo.address.country,"closeOnEsc":true,"type":"medium"},on:{"close":_vm.closeSupplierProvideServicesConfirmation,"confirm":_vm.onSupplierProvideServicesConfirmation}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("Providing services in the "+_vm._s(_vm.purchaseOrder.PO.billTo.address.country)+" means that the Supplier was present in the "+_vm._s(_vm.purchaseOrder.PO.billTo.address.country)+" and physically provided services outlined in their invoice within the US. "),_c('i',[_vm._v("Your selection will help determine whether withholding tax is deducted from the payment.")])])])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.modals.selectSupplierCountry,"title":"Supplier Country","primaryButton":_vm.Submit,"secondaryButton":_vm.Cancel,"validation":"true","closeOnEsc":true,"type":"extra-small"},on:{"close":_vm.closeSupplierCountrySelection,"validate":_vm.onSupplierCountrySelected}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("In order to proceed with this payment, please select the country of the supplier.")]),_vm._v(" "),_c('ed-select',{attrs:{"field-label":"Supplier Country","placeholder":"Select Country","options":_vm.countries,"required":"","label":"Value","track-by":"Value","error":_vm.showCountryMissing,"helptip-body":_vm.showCountryMissing && "Please select a Country." || "","helptipHeader":"","name":"supplier_country"},on:{"open":_vm.fetchCountries,"select":function($event){return _vm.selectCountry($event)}},model:{value:(_vm.supplierCountry),callback:function ($$v) {_vm.supplierCountry=$$v},expression:"supplierCountry"}})],1)])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SmCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1Pprc_mve2VvqlKZb04Ppa","Dell":"_248MRXkPb4wz55fOAdKkeL","Abbott":"_3ZIT0JZzxW4YTqdz1piXX5","Gap":"_1i4ri4FMeRAUAzZu7Qvdo4","Allstate":"_3Kg61uhsly6YrGhgEu9Mya","Asurion":"_3KVvSVSfPF_jnYVKNCq3R5","Invitae":"_1H0WB2OKpMExZcks4n7ZrC","JWE":"_3e4-aRHJsrSNJFsixV4a7q"};

/***/ }),

/***/ "StJP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"show":_vm.showModal,"title":_vm.title,"type":"medium","flat":""},on:{"close":_vm.handleClose}},[_c('div',{staticClass:"content",attrs:{"slot":"body"},slot:"body"},[_c('itemsList',{attrs:{"list":_vm.list.length > 1 ? _vm.filteredList : _vm.list,"programLabel":_vm.programLabel}}),_vm._v(" "),_c('div',{staticClass:"row bottom-row"},[(_vm.atLeastOneItemIsInvoice)?_c('div',{staticClass:"row form-group col-md-7"},[_c('label',[_c('strong',[_vm._v(_vm._s(_vm.approvalNoteLabel)+" "),(!_vm.isReasonRequired)?_c('span',[_vm._v("- optional")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isReasonRequired)?_c('div',[_c('em',[_c('small',[_vm._v("Please add a note confirming that goods and services were received")])]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('ed-textarea',{attrs:{"max-length":1000,"rows":4,"error":_vm.reasonError,"errorTipBody":_vm.reasonErrorMsg,"errorTipHeader":""},on:{"input":_vm.onApprovalNoteChange},model:{value:(_vm.reason),callback:function ($$v) {_vm.reason=$$v},expression:"reason"}})],1):_vm._e(),_vm._v(" "),(_vm.isFirstItemFundsRequest(_vm.list[0]) && _vm.list.length === 1)?_c('userInfo',{attrs:{"title":"Your Approval"}}):_vm._e(),_vm._v(" "),(_vm.list.length > 1)?_c('userInfo',{attrs:{"title":"Your Approval"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"request-funds-approve-container col-md-12"},[(!_vm.isFirstItemFundsRequest(_vm.list[0]) && _vm.list.length === 1)?_c('ed-notice',{staticClass:"request-funds-validation",attrs:{"type":"danger","message":"There are insufficient funds in the account to complete this request.","icon":"fas fa-exclamation-triangle"}}):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.isFirstItemFundsRequest(_vm.list[0]) && _vm.list.length === 1)?_c('div',{staticClass:"buttons clear",attrs:{"slot":"footer"},slot:"footer"},[_c('ed-button',{attrs:{"button-class":"btn btn-default","disabled":_vm.loading},on:{"click":_vm.handleClose}},[_vm._v("Cancel")]),_vm._v(" "),_c('ed-button',{attrs:{"endpoint":_vm.getEndpoint(),"disabled":_vm.loading},on:{"click":_vm.approve}},[_vm._v("Approve")])],1):_vm._e(),_vm._v(" "),(_vm.list.length > 1)?_c('div',{staticClass:"buttons clear",attrs:{"slot":"footer"},slot:"footer"},[_c('ed-button',{attrs:{"button-class":"btn btn-default","disabled":_vm.loading},on:{"click":_vm.handleClose}},[_vm._v("Cancel")]),_vm._v(" "),_c('ed-button',{attrs:{"endpoint":_vm.getEndpoint(),"disabled":_vm.loading},on:{"click":_vm.approve}},[_vm._v("Approve")])],1):_vm._e(),_vm._v(" "),(!_vm.isFirstItemFundsRequest(_vm.list[0]) && _vm.list.length === 1)?_c('div',{staticClass:"buttons clear",attrs:{"slot":"footer"},slot:"footer"},[_c('ed-button',{attrs:{"button-class":"btn btn-default"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T67L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvelopeRejectInfo_vue__ = __webpack_require__("N89l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bde209da_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvelopeRejectInfo_vue__ = __webpack_require__("g3X1");
function injectStyle (ssrContext) {
  __webpack_require__("Os5Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bde209da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvelopeRejectInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bde209da_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvelopeRejectInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T67l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("jX68");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f12d874_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("PhN0");
function injectStyle (ssrContext) {
  __webpack_require__("bsTF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f12d874_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T6gH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2Z-olkV-BWFZciRiad8725","Dell":"_2uMDMeFyPPLMua54Dl_yI5","Abbott":"_3zq67O7pawnGy2csWp8gja","Gap":"_3KihGq7FsOVFBbMsUJMvET","Allstate":"_2RyPEBZTJgxQ6CUfVWw38j","Asurion":"loB_mlsqGjvYP0PSnsUJx","Invitae":"_1EhLjWwH-GPkhLhrhelEfH","JWE":"_2bORtHCAE15xvBHE7TozCw"};

/***/ }),

/***/ "T7Wz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("2Pzm");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2408d8b9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("T9fJ");
function injectStyle (ssrContext) {
  __webpack_require__("LBCZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2408d8b9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2408d8b9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "T7ac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dawn-notification"}},[_c('div',{staticClass:"dawn-notification",class:[_vm.type, !_vm.icon ? 'no-icon' : '']},[_c('div',{staticClass:"icon-wrapper",class:{ 'no-icon': !_vm.icon }},[_c('i',{class:_vm.icon})]),_vm._v(" "),_c('div',{staticClass:"content-wrapper",class:{ 'no-icon': !_vm.icon }},[(!_vm.message)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.message))])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T9fJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[((_vm.items !== null && _vm.loading == false) && (_vm.items.length > 0))?_c('div',[_c('div',{staticClass:"row bottom-border"},[_c('span',{staticClass:"header status"},[_vm._v("Status")]),_vm._v(" "),_c('span',{staticClass:"header program-name"},[_vm._v(_vm._s(_vm.getProgramLabel(false, false))+" Name")]),_vm._v(" "),_c('span',{staticClass:"header budget text-right"},[_vm._v("Budget")]),_vm._v(" "),_c('span',{staticClass:"header budget-balance text-right"},[_vm._v("Budget Balance")])]),_vm._v(" "),(_vm.hasData)?_c('div',{staticClass:"scroller"},[_c('div',_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"row detail"},[_c('span',{staticClass:"status"},[_c('span',{staticClass:"indicator",attrs:{"title":item.ProgramStatusName}},[_vm._v(_vm._s(item.ProgramStatusName))])]),_vm._v(" "),_c('span',{staticClass:"program-name",attrs:{"title":item.ProgramName}},[_c('a',{attrs:{"href":item.Url}},[_vm._v(_vm._s(item.ProgramName))])]),_vm._v(" "),_c('span',{staticClass:"budget text-right",attrs:{"title":item.RevisedBudget}},[_vm._v(_vm._s(item.RevisedBudget))]),_vm._v(" "),_c('span',{staticClass:"budget-balance text-right",attrs:{"tile":item.BudgetBalance}},[_vm._v(_vm._s(item.BudgetBalance))])])}),0)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"empty-holder"},[_c('span',{staticClass:"prog-loading"}),_vm._v(" Loading current "+_vm._s(_vm.getProgramLabel(true, true))+" ...\n    ")]):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.hasData)?_c('div',{staticClass:"empty-holder"},[_c('i',{staticClass:"fal fa-list"}),_vm._v(" "),_c('span',[_c('p',{staticClass:"bold"},[_vm._v("No "+_vm._s(_vm.getProgramLabel(true, false))+" Found")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("No "+_vm._s(_vm.getProgramLabel(true, true))+" are currently open")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TAzg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2ifNspr9UXOz8EXES2Y4lm","Dell":"_1lMWXdCp-SPwfPX8Y9i1mc","Abbott":"_2OnxRir0ycDEVyZ7mwLJDp","Gap":"_2xcRtBuOprB2IEb_1XNiYc","Allstate":"rUfy9ElCIlfDXlpYZi-BN","Asurion":"_2W-GGO3gNXAMCTWU5ZJfKR","Invitae":"Pp-avuVd1OBipapJf3mdj","JWE":"_3Dm-OgH-spHSowUxRhowoV"};

/***/ }),

/***/ "TBEP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  showSubmitBatchConfirmation: false,
  allowDifferentAmount: false,
  allowItemsWithZeroUnitPrice: false,
  showSupplierProvideServicesConfirmation: false,
  selectSupplierCountry: false
});

/***/ }),

/***/ "TEN6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"addFeeTaxesDialogContainer"},[_c('ed-modal',{attrs:{"show":_vm.show,"title":_vm.title,"primary-button":"Save","secondary-button":"Cancel","validation":_vm.validation,"closeOnEsc":true,"name":"allocate_cost_center_popup"},on:{"close":_vm.onClose,"validate":_vm.onSave}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"col-md-10 no-pad"},[_vm._v("\n        Allocate to Cost Center for the following items:\n        "),_vm._l((_vm.selectedItemNames),function(item){return _c('ul',{key:item},[_c('li',[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('div',{staticClass:"row col-md-10 no-pad"},[_c('ed-select',{attrs:{"field-label":"Cost Center","placeholder":"Select a Cost Center","options":_vm.costCenters,"required":"required","label":"name","track-by":"code","customLabel":_vm.getCostCenterName,"error":_vm.doDisplayCostCenterError,"helptip-header":_vm.doDisplayCostCenterError && 'Error' || '',"helptip-body":_vm.doDisplayCostCenterError && 'Please select a Cost Center' || '',"name":"allocate_to_cost_centers"},on:{"select":function($event){return _vm.costCenterSelected($event)}},model:{value:(_vm.formData.draftItem.selectedCostCenter),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "selectedCostCenter", $$v)},expression:"formData.draftItem.selectedCostCenter"}})],1)],2),_vm._v(" "),_c('div',{staticClass:"clear"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TIsV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-flex active"},[_c('ed-section',{key:_vm.model.InvoiceInformation.programId,staticClass:"no-flex active pad",attrs:{"wide":""}},[_c('div',{staticClass:"section-title"},[_c('span',{staticClass:"h5"},[_vm._v(_vm._s(_vm.model.GridTitle)+" Allocation")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"pull-right small"})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('grid',{ref:"allocations",class:{ simple: false },attrs:{"layout":"frame","label":_vm.model.Label,"search":"search","views":false,"pinning":false,"sorting":false,"fit-columns":true,"checkboxes":true,"show-column-selector":false,"auto-height":"auto-height","allow-export":false,"model":_vm.model.GridModel,"data":_vm.model.AllocationList,"totals":"totals","total":_vm.subtotal,"actions":_vm.actions,"currency-code":_vm.currencyCode,"name":"allocations","remove-many":"remove-many"},on:{"changeRow":_vm.changeRow,"removeRow":_vm.removeRow,"removeRows":_vm.removeRows}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"name":"add_allocation"},on:{"click":_vm.add}},[_vm._v("Add\n                ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),_c('br')])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TNwQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"name":"comments"},on:{"click":_vm.getComments}},[_vm._v("\n    Comments & Attachments\n  ")]),_vm._v(" "),_c('ed-panel',{attrs:{"show":_vm.showComments,"title":"Comments & Attachments","name":"comments_panel"},on:{"close":function($event){_vm.showComments=false}}},[_c('div',{staticClass:"content",attrs:{"slot":"body"},slot:"body"},[_c('ed-form',{attrs:{"submit-visible":false}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"comments-section"},_vm._l((_vm.comments),function(item){return _c('div',{key:item.CommentId,staticClass:"comment-item"},[_c('div',{staticClass:"comment-image-placeholder pull-left"},[(!item.LogoPath)?_c('div',{staticClass:"user-initials"},[_vm._v("\n                    "+_vm._s(item.UserInitials)+"\n                  ")]):_c('img',{staticClass:"user-avatar",attrs:{"src":_vm.userAvatar(item),"alt":"Profile Picture"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('label',[_vm._v(_vm._s(item.UserFullName))]),_vm._v(" "),_c('label',{staticClass:"info pull-right"},[_vm._v(_vm._s(item.CreatedDateFormatted))]),_vm._v(" "),(item.Comment !== null && item.Comment.length)?_c('div',{staticClass:"comment-text"},[_vm._v(_vm._s(item.Comment))]):_vm._e(),_vm._v(" "),_c('ed-upload',{attrs:{"value":_vm.getFiles(item.SavedFiles),"no-button":""}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr',{staticClass:"clear"})])}),0),_vm._v(" "),_c('div',[_c('div',{staticClass:"section-title"},[_vm._v("Add Comment")]),_vm._v(" "),_c('ed-upload',{class:{loading: !_vm.uploadFinished},attrs:{"field-label":"Attach File","button-label":"Browse","readonly":"","multiple":true,"postAction":_vm.api.env + _vm.api.$.upload.uploadCommnetFile,"uploadAuto":true,"data":_vm.uploadData,"error":_vm.attachmentsMissing,"helptipBody":"Choose at least one attachment","showHelptipIcon":false,"helptipHeader":"","name":"comments_upload"},on:{"input":_vm.createAttachments},model:{value:(_vm.uploadedAttachments),callback:function ($$v) {_vm.uploadedAttachments=$$v},expression:"uploadedAttachments"}}),_vm._v(" "),_c('ed-textarea',{attrs:{"placeholder":"Comment...","error":_vm.displayCommentError,"rows":5,"name":"comments_textarea"},on:{"input":_vm.commentChanged},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}})],1)])])])],1),_vm._v(" "),_c('div',{staticClass:"buttons",attrs:{"slot":"footer"},slot:"footer"},[_c('ed-button',{staticClass:"pull-left",attrs:{"disabled":!_vm.uploadFinished,"name":"save_comments"},on:{"click":_vm.saveComment}},[_vm._v("Submit")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQ2p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_money_vue__ = __webpack_require__("bD6N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2152252_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_money_vue__ = __webpack_require__("0MDp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_money_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2152252_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_money_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TRth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-select-options',
  props: {
    thumbnails: Boolean
  }
});

/***/ }),

/***/ "TUy4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TabU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1bjwqRxjE0_H399jowuPuN","Dell":"_9gdlI4RyeTihctmnK1hgd","Abbott":"_3-sMwVpgk9KTSuDfnBvuHe","Gap":"_3duREawit9MRsLiGOF95Wb","Allstate":"_2fj5QHs4nQ4-2SRDfqVqry","Asurion":"_2afaA2Z9DmkmDALuNn_OFz","Invitae":"I_y2YBxyo0Ka-iEZ9h9nA","JWE":"_29tFDDRStoDDtQ8_4Aawhp"};

/***/ }),

/***/ "TgOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__("kNBP");
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card',
  props: {
    card: Object
  },
  computed: {
    icon: function icon() {
      return this.getMap(this.card.Type, this.card.Action).icon;
    },
    fragments: function fragments() {
      return __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].tokenize(this.getMap(this.card.Type, this.card.Action).template, this.card);
    },
    when: function when() {
      var date = global.moment(this.card.Date);
      var duration = global.moment.duration(date.diff(new Date()));
      return global.moment.duration(duration).humanize(true);
    }
  },
  methods: {
    getMap: function getMap(type, action) {
      return __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */][type] && __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */][type][action] || __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].default;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Tnpt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tq0g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_panel_vue__ = __webpack_require__("ut3w");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b1372e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_panel_vue__ = __webpack_require__("cNnW");
function injectStyle (ssrContext) {
  __webpack_require__("bKpp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b1372e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_panel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b1372e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Tqan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile",class:_vm.name,attrs:{"id":"layout"}},[_c('div',{staticClass:"wrapper centered"},[_c('div',{staticClass:"main-panel",class:{ 'loading' : _vm.loading }},[_c('div',{staticClass:"navless-layout-wrapper"},[_c('div',{staticClass:"row navless-main-body-wrapper"},[_c('div',{staticClass:"container-fluid"},[_c('div',{ref:"currentModule",staticClass:"navless-main-body col-md-12"},[_vm._t("default")],2)])])]),(_vm.tabs.length)?_c('ed-tab-nav',{ref:"steps",staticClass:"tabs",attrs:{"bottom-tabs":"","wide":"","workflow":""},on:{"tabSelected":_vm.enterStep}},_vm._l((_vm.tabs),function(tab){return _c('ed-tab',{key:tab.label,attrs:{"completed":"","title":tab.label}},[_c(tab.component,{tag:"component"},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(tab.title))])])],1)}),1):_vm._e()],1)]),(_vm.showReceiptFab)?_c('button',{staticClass:"receipt-fab",attrs:{"aria-label":"Submit Receipt"},on:{"click":_vm.openReceiptActionSheet}},[_c('i',{staticClass:"fas fa-camera"})]):_vm._e(),(_vm.showActionSheet)?_c('div',{staticClass:"receipt-action-sheet-overlay",on:{"click":_vm.closeActionSheet}},[_c('div',{staticClass:"receipt-action-sheet",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"action-sheet-card"},[_c('div',{staticClass:"action-sheet-title"},[_vm._v("Submit Receipt")]),_c('button',{staticClass:"action-sheet-option action-sheet-primary",on:{"click":_vm.openCamera}},[_vm._v("Open Camera")]),_c('button',{staticClass:"action-sheet-option",on:{"click":_vm.openLibrary}},[_vm._v("Choose From Library")])]),_c('button',{staticClass:"action-sheet-option action-sheet-cancel",on:{"click":_vm.closeActionSheet}},[_vm._v("Cancel")])])]):_vm._e(),_c('input',{ref:"cameraInput",staticClass:"receipt-file-input",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","capture":"environment"},on:{"change":_vm.handleReceiptFile}}),_c('input',{ref:"libraryInput",staticClass:"receipt-file-input",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.handleReceiptFile}}),(_vm.uploadingReceipt)?_c('div',{staticClass:"receipt-upload-overlay"},[_vm._m(0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receipt-upload-card"},[_c('i',{staticClass:"fas fa-spinner fa-spin receipt-upload-spinner"}),_c('div',{staticClass:"receipt-upload-title"},[_vm._v("Uploading receipt…")]),_c('div',{staticClass:"receipt-upload-subtitle"},[_vm._v("Just a moment.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Trxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_user__ = __webpack_require__("uduW");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    options: function options() {
      return [{
        label: "Transfer to another ".concat(this.divisionName),
        id: '1',
        status: false,
        additionalInfo: true,
        slotName: 'additionalInfo_1'
      }, {
        label: 'Return to customer',
        id: '2',
        status: false,
        additionalInfo: true,
        slotName: 'additionalInfo_2'
      }];
    }
  },
  props: {
    balance: {},
    division: {},
    ids: null,
    disabled: false,
    tooltip: ''
  },
  data: function data() {
    return {
      divisions: [],
      divisionName: '',
      selectOption: {},
      selectedValue: {},
      closeObj: {},
      showCloseAccount: false
    };
  },
  created: function created() {
    this.getDivisionNameToSingularWithLowerCase();
  },
  methods: {
    getUserDivisions: function getUserDivisions() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.divisions = [];
              _this.api.get(_this.api.$.evedpaycard.division).then(function (response) {
                if (response && response.data) {
                  _this.divisions = response.data;
                }
              }).catch(function (error) {
                console.warn(error);
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getDivisionNameToSingularWithLowerCase: function getDivisionNameToSingularWithLowerCase() {
      var divisionName = __WEBPACK_IMPORTED_MODULE_2__core_user__["a" /* default */].get().settings['DivisionName'];
      this.divisionName = divisionName[divisionName.length - 1] === 's' ? divisionName.toLowerCase().slice(0, -1) : divisionName;
    },
    handleRadioInput: function handleRadioInput(option) {
      this.selectedValue = option.id === '1' && this.selectOption ? this.selectOption : this.division;
      this.closeObj = this.selectedValue;
      this.closeObj.funds = this.balance;
      this.selectedValue = {};
    },
    closeAccount: function closeAccount() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var command, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(Object.keys(_this2.closeObj).length !== 0)) {
                _context2.next = 15;
                break;
              }
              command = {
                SourceAccountId: _this2.division.AccountId,
                DestinationAccountId: _this2.closeObj.AccountId,
                Amount: _this2.balance
              };
              _context2.prev = 2;
              _context2.next = 5;
              return _this2.api.post('/evedpaycards/accounts/transfer-funds', command);
            case 5:
              response = _context2.sent;
              if (response.status === 200) {
                console.log('Successful transfer!');
                _this2.$emit('success');
                _this2.initialAmountError = false;
              }
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              console.error('Error during the funds transfer:', _context2.t0);
            case 12:
              _this2.closeObj = {};
              _context2.next = 16;
              break;
            case 15:
              console.log('invalid');
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 9]]);
      }))();
    },
    showModal: function showModal(showCloseAccount) {
      this.showCloseAccount = !showCloseAccount;
    }
  }
});

/***/ }),

/***/ "Txaa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U0Dc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// PRODUCTDEV-5946: "5000" -> "5,000.00" for the "Max limit 5,000.00 USD" help text and the
// less-than-or-equal validation message. Module-scope (not a method) so validateDailySpendLimit stays a
// self-contained value -> result check (the unit specs call it with a bare context object).
var formatUsdAmount = function formatUsdAmount(value) {
  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getDailySpendLimit();
  },
  computed: {
    // PRODUCTDEV-5884: surface the custom Name on Card next to the legal holder
    // ("Name on Card | Legal Name") when set and meaningfully different, mirroring CardRefill.vue
    // and the cards grid (see PRODUCTDEV-5553). Holder may be a plain string or an object with .Name.
    holderDisplay: function holderDisplay() {
      var legalName = this.card && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(this.card.Holder) === 'object' ? this.card.Holder.Name || '' : this.card && this.card.Holder || '';
      var nameOnCard = (this.card && this.card.NameOnCard || '').trim();
      if (!nameOnCard || nameOnCard.toLowerCase() === legalName.trim().toLowerCase()) {
        return legalName;
      }
      if (!legalName.trim()) {
        return nameOnCard;
      }
      return "".concat(nameOnCard, " | ").concat(legalName);
    },
    // PRODUCTDEV-5946: the "Max limit 5,000.00 USD" help text under the field (wording per the
    // PRODUCTDEV-5573 thread), driven by the PEX per-account cap fetched on open. PRODUCTDEV-5889:
    // no cap known -> no help text (never show a guessed number).
    maxLimitHelpText: function maxLimitHelpText() {
      return this.maxDailySpendLimit ? "Max limit ".concat(formatUsdAmount(this.maxDailySpendLimit), " USD") : '';
    }
  },
  methods: {
    notifyError: function notifyError(message) {
      this.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        timeout: 0,
        message: message
      });
    },
    // PRODUCTDEV-5890/5946: inline-validate against the PEX business settings before calling the backend.
    // A blank value (None - the limit clears) is allowed only when the account does not require a limit;
    // $0.00 and above-cap values are rejected with the ticket's messages. Returns true when ok to submit.
    // PRODUCTDEV-5890 (PR #36368 review): validate the passed-in value - the @input payload while typing, or
    // this.DailySpendLimit from save() - rather than driving validation off a watcher. The watcher also fired
    // on the programmatic load in getDailySpendLimit(), so a card whose stored limit legitimately exceeds
    // $5,000 (PEX can raise the cap per business) showed a spurious error the instant the modal opened.
    validateDailySpendLimit: function validateDailySpendLimit(value) {
      var amount = value === '' || value == null ? null : +value;
      if (amount == null) {
        if (this.isDailySpendLimitRequired) {
          this.validationError = 'Daily Spend Limit is required.';
          return false;
        }
      } else if (amount <= 0) {
        this.validationError = 'Daily Spend Limit must be greater than $0.00';
        return false;
      } else if (this.maxDailySpendLimit && amount > this.maxDailySpendLimit) {
        // PRODUCTDEV-5889: the cap check only runs when the backend reported a real cap - no guessed
        // $5,000 anymore. Without one, PEX validates the amount on save and its error is surfaced.
        this.validationError = "Daily Spend Limit must be less than or equal to $".concat(formatUsdAmount(this.maxDailySpendLimit));
        return false;
      }
      this.validationError = '';
      return true;
    },
    // EvedPay card endpoints return a bare array of { Message, StatusCode } (see GetStatusMappedResult).
    // A thrown 4xx carries it on error.response.data; a resolved non-2xx carries it on response.data.
    extractErrorMessage: function extractErrorMessage(errorOrResponse) {
      var data = errorOrResponse && errorOrResponse.response && errorOrResponse.response.data || errorOrResponse && errorOrResponse.data;
      if (data && data.length && data[0] && data[0].Message) {
        return "Daily Spend Limit could not be updated. ".concat(data[0].Message);
      }
      return '';
    },
    save: function save(showModal) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.card.Id) {
                _context.next = 14;
                break;
              }
              if (_this.validateDailySpendLimit(_this.DailySpendLimit)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.prev = 3;
              _context.next = 6;
              return _this.api.patch("evedpaycards/".concat(_this.card.Id, "/daily-spend-limit"), {
                DailySpendLimit: _this.DailySpendLimit === '' || _this.DailySpendLimit == null ? null : +_this.DailySpendLimit,
                // PRODUCTDEV-5890: suppress the global generic "Something went wrong" error toast (the axios
                // interceptor honors preventError on the request body) so the specific PEX/backend message shown
                // below is the only error the user sees. The backend ignores this extra key.
                preventError: true
              });
            case 6:
              response = _context.sent;
              if (response.status === 200) {
                if (showModal) {
                  showModal.showModal = false;
                }
                // PRODUCTDEV-5908: emit the bare card id, exactly like CardRefill ('refill') / CardStatus
                // ('status-changed') / CardSettings ('funds-changed'). The extended event bus wraps the payload as
                // { target, data: <id> }, so the index.vue listener reads cardId.data. (Previously this passed
                // { data: id }, which got double-wrapped; the PRODUCTDEV-5884 unwrap loop in getCardWithDetails
                // masked it - this keeps the emit consistent with the other three approval sections.)
                __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('dailySpendLimit', _this.card.Id);
              } else {
                // PRODUCTDEV-5890: a non-success response (e.g. PEX rejected the value). Show the specific reason
                // and do NOT emit - the tile keeps the previously-saved value so Eved stays in sync with PEX.
                _this.notifyError(_this.extractErrorMessage(response) || 'Failed to save the Daily Spend Limit. Please try again.');
              }
              _context.next = 14;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              console.error(_context.t0);
              // PRODUCTDEV-5890: PEX (or the backend) rejected the change. Surface the specific reason and do NOT
              // emit, so the displayed Daily Spend Limit stays at the previously-saved value (Eved in sync with PEX).
              _this.notifyError(_this.extractErrorMessage(_context.t0) || 'Failed to save the Daily Spend Limit. Please try again.');
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 10]]);
      }))();
    },
    getDailySpendLimit: function getDailySpendLimit() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, cap;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this2.card.Id) {
                _context2.next = 12;
                break;
              }
              _context2.prev = 1;
              _context2.next = 4;
              return _this2.api.get("evedpaycards/".concat(_this2.card.Id, "/daily-spend-limit"));
            case 4:
              response = _context2.sent;
              if (response.status === 200 && response.data) {
                _this2.DailySpendLimit = response.data.DailySpendLimit;
                // PRODUCTDEV-5898/5889: the per-account cap is PEX-controlled; use the backend value for
                // validation. Only accept a positive, finite number - a missing field (NaN), a non-numeric
                // value, 0 or a negative leave the cap at null (no pre-validation, no help text; PEX enforces
                // the real cap on save). No $5,000 guess anymore - a guessed number can be wrong both ways.
                cap = +response.data.MaxDailySpendLimit;
                if (Number.isFinite(cap) && cap > 0) {
                  _this2.maxDailySpendLimit = cap;
                }
                // PRODUCTDEV-5946: whether the account's PEX business settings require a Daily Spend Limit
                // on every card. Strict === true so an absent field keeps the optional default.
                _this2.isDailySpendLimitRequired = response.data.IsDailySpendLimitRequired === true;
              }
              _context2.next = 12;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);
              _this2.notifyError('Failed to load the Daily Spend Limit.');
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 8]]);
      }))();
    }
  },
  props: {
    card: Object
  },
  data: function data() {
    return {
      DailySpendLimit: null,
      validationError: '',
      // PRODUCTDEV-5898/5889: the validation cap, sourced from the backend per account. null = no cap
      // known (still loading, or PEX reported none) - NO $5,000 guess anymore; the cap pre-validation and
      // the "Max limit" help text are simply skipped and PEX enforces the real cap on save (its error is
      // surfaced by save()).
      maxDailySpendLimit: null,
      // PRODUCTDEV-5946: whether the PEX business settings require a Daily Spend Limit on every card.
      // Optional until the fetched value says otherwise, so the field is never over-restricted while loading.
      isDailySpendLimitRequired: false
    };
  }
});

/***/ }),

/***/ "U0nG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_75FMFxiGmmXglkgOn44Jy","Dell":"_2f0xBRrRbjMP69BCs1P0OQ","Abbott":"_34At8Cpgsi2xbUgYzP5Sty","Gap":"ERuKujzdGwWxgiKD3tDyx","Allstate":"_2Qk6anhmM0hzrpvka1WloD","Asurion":"_1E0LGJxV7XdNpqjbHQkFf2","Invitae":"_2VvdNwRYdx0pqqm66uzbFv","JWE":"_2YhVJLg9e8iGXnQtrWz7oA"};

/***/ }),

/***/ "U4r4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object
  },
  data: function data() {
    return {
      approvalUsersData: []
    };
  },
  methods: {
    getApprovalUsers: function getApprovalUsers() {
      var _this = this;
      this.api.get(this.api.$.evedpaycard.approvalUsersForEnvelope, {
        params: {
          envelopeId: this.model.Id
        }
      }).then(function (response) {
        _this.approvalUsersData = response.data.filter(function (user) {
          return user.IsCurrentAction === true;
        });
      }).catch(function (error) {
        console.error('There was a problem with the approval users request:', error);
      });
    }
  },
  created: function created() {
    this.getApprovalUsers();
  }
});

/***/ }),

/***/ "U6b3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_scrollbarHelper_js__ = __webpack_require__("7yCl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'immediate-payment-escrows-wdg-cmp',
  props: {
    widget: Object
  },
  data: function data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    hasData: function hasData() {
      if (this.items !== null && this.items.length > 0) return true;else return false;
    },
    headerDivisionLabel: function headerDivisionLabel() {
      return this.hasData ? this.items[0].DivisionLabel : 'Divisions';
    },
    // Group items by Division Name and return them sorted
    groupedItems: function groupedItems() {
      var groups = this.items.reduce(function (groups, item) {
        var divisionName = item.DivisionName || 'Clientwide';
        if (!groups[divisionName]) {
          groups[divisionName] = [];
        }
        groups[divisionName].push(item);
        return groups;
      }, {});
      return this.sortGroupedItems(groups);
    }
  },
  methods: {
    // Sort the grouped items and prioritize the Company Wide Settings (Division Name null)
    sortGroupedItems: function sortGroupedItems(groups) {
      var sortedKeys = Object.keys(groups).sort(function (a, b) {
        var checkNullDivisionNameInKeyA = groups[a].some(function (item) {
          return item.DivisionName === null;
        });
        var checkNullDivisionNameInKeyB = groups[b].some(function (item) {
          return item.DivisionName === null;
        });
        if (checkNullDivisionNameInKeyA) return -1;
        if (checkNullDivisionNameInKeyB) return 1;
        return a.localeCompare(b);
      });
      return sortedKeys.reduce(function (sortedGroups, key) {
        sortedGroups[key] = groups[key];
        return sortedGroups;
      }, {});
    }
  },
  created: function created() {
    var _this = this;
    this.loading = true;
    this.api.get(this.widget.endPoint, {}).then(function (r) {
      _this.items = r.data.items;
    }).finally(function () {
      _this.loading = false;
      _this.$nextTick(function () {
        var desiredHeight = !_this.hasData ? 1 : getDesiredSize(_this.items.length);
        __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$emit('updateWidgetHeight', {
          wId: _this.widget.id,
          height: desiredHeight,
          alt: -1
        });
        if (_this.items.length > 6) {
          _this.$el.querySelector('.scroller').style.height = '156px';
          Object(__WEBPACK_IMPORTED_MODULE_0__helpers_scrollbarHelper_js__["a" /* initScrollbar */])(_this, '.scroller');
        }
      });
    });
  }
});
function getDesiredSize(len) {
  var res = 1;
  if (len >= 6) return 4;
  switch (len) {
    case 1:
      res = 1;
      break;
    case 2:
    case 3:
      res = 2;
      break;
    case 4:
    case 5:
      res = 3;
      break;
  }
  return res;
}

/***/ }),

/***/ "UBhi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("yVx8");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce3cb3d4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("UD6p");
function injectStyle (ssrContext) {
  __webpack_require__("yVeY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce3cb3d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce3cb3d4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UD6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[((_vm.helptipBody || _vm.errorTipBody) && _vm.focused)?_c('ed-input-tooltip',{class:{ "error-message": _vm.error },attrs:{"helptipHeader":_vm.error ? _vm.errorTipHeader : _vm.helptipHeader,"errorTip":_vm.error,"helptipBody":_vm.error ? _vm.errorTipBody : _vm.helptipBody}}):_vm._e(),_vm._v(" "),(_vm.fieldLabel)?_c('label',{staticClass:"control-label"},[_vm._v("\n    "+_vm._s(_vm.fieldLabel)+"\n    "),(!_vm.required && !_vm.hideOptional)?_c('em',{staticClass:"optional"},[_vm._v("  - optional")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('textarea',_vm._b({directives:[{name:"focus",rawName:"v-focus.lazy",value:(_vm.autofocus),expression:"autofocus",modifiers:{"lazy":true}}],ref:"input",staticClass:"form-control",attrs:{"autofocus":_vm.autofocus,"required":_vm.required},domProps:{"value":_vm.value},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){_vm.value = $event.target.value;_vm.$emit('input', $event.target.value)},"change":function($event){_vm.value = $event.target.value;_vm.$emit('change', $event.target.value)}}},'textarea',_vm.$props,false)),_vm._v(" "),(_vm.maxLength > 0)?_c('span',[_c('span',{staticClass:"textarea-chars"},[_c('i',[_vm._v(_vm._s(_vm.remainingChars))])]),_vm._v(" "),_c('span',{staticClass:"clear"})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UGg9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cards_vue__ = __webpack_require__("V8Ry");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd0cba3e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cards_vue__ = __webpack_require__("i2Zn");
function injectStyle (ssrContext) {
  __webpack_require__("E15f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd0cba3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd0cba3e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UJym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Fv83");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299b6cbe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("M8SE");
function injectStyle (ssrContext) {
  __webpack_require__("kl7m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299b6cbe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UMCc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"i2p-new-page"},[_c('ed-title-nav',{attrs:{"title":'Correct AP File',"subtitle":''}},[_c('span',{attrs:{"slot":"action"},slot:"action"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.cancel()}}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("  Back")])])]),_vm._v(" "),_c('toolbar',{attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar-primary pull-right","disabled":_vm.busy,"name":"send-correct"},on:{"click":function($event){return _vm.send()}}},[_vm._v("SEND")]),_vm._v(" "),_c('ed-button',{attrs:{"button-class":"btn btn-actionbar pull-right","name":"cancel-correct"},on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Cancel")])],1)],1),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"page-two-col"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"right"},[_c('section',{staticClass:"form-shell"},[_c('div',{staticClass:"field"},[(_vm.fundingAddressModel)?_c('funding-address',{attrs:{"model":_vm.fundingAddressModel,"showEdit":true},on:{"changeAddress":_vm.onChangeAddress}}):_c('div',{staticClass:"muted"},[_vm._v("(loading address...)")])],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("To")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email.to),expression:"email.to"}],staticClass:"form-control",attrs:{"type":"email","readonly":""},domProps:{"value":(_vm.email.to)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email, "to", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email.cc),expression:"email.cc"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.email.cc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email, "cc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email.bcc),expression:"email.bcc"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.email.bcc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email, "bcc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Subject")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email.subject),expression:"email.subject"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.email.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email, "subject", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Upload Corrected Funding Statement")]),_vm._v(" "),_c('div',{staticClass:"upload-row"},[_c('button',{staticClass:"btn btn-upload",attrs:{"name":"replace-funding-statement-btn"},on:{"click":function($event){_vm.showFsReplace = true}}},[_vm._v("\n                  UPLOAD FILE\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Attached Funding Statement")]),_vm._v(" "),_c('div',{staticClass:"attached"},[(_vm.fundingStatementUrl)?_c('span',[_c('a',{attrs:{"href":_vm.fundingStatementUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.fundingStatementName))])]):_c('span',{staticClass:"muted"},[_vm._v("(none)")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Upload Corrected AP File")]),_vm._v(" "),_c('div',{staticClass:"upload-row"},[_c('button',{staticClass:"btn btn-upload",attrs:{"name":"replace-ap-file-btn"},on:{"click":function($event){_vm.showApReplace = true}}},[_vm._v("\n                  UPLOAD FILE\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Attached AP File")]),_vm._v(" "),_c('div',{staticClass:"attached"},[(_vm.apFileName)?_c('span',[_c('a',{attrs:{"href":_vm.apFileUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.apFileName))])]):_c('span',{staticClass:"muted"},[_vm._v("(none)")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"msg-box",domProps:{"innerHTML":_vm._s(_vm.messageHtml)}})])])])])])],1),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showApReplace,"title":"Correct AP File","primary-button":"Correct","secondary-button":"Cancel","type":"medium","validation":true,"closeOnEsc":true,"name":"replace_ap_file"},on:{"close":_vm.onApClose,"validate":_vm.onApSave}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"col-md-6 no-pad"},[_c('label',[_vm._v("Current AP File")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.apFileName || '(none)'))]),_vm._v(" "),_c('ed-upload',{class:{ loading: !_vm.apUploadFinished },attrs:{"field-label":"Attachment","button-label":"Upload File","readonly":"","multiple":false,"postAction":_vm.api.env + _vm.api.$.upload.uploadFile,"uploadAuto":true,"data":_vm.apUploadSettings,"required":"","showHelptipIcon":false,"helptipHeader":"","error":_vm.apAttachmentMissingError,"helptip-body":_vm.apAttachmentMissingError && 'Please attach a file.' || '',"name":"ap_file_upload"},on:{"input":_vm.onApUploadComplete},model:{value:(_vm.apAttachmentFiles),callback:function ($$v) {_vm.apAttachmentFiles=$$v},expression:"apAttachmentFiles"}})],1),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.apDisplayUploadError,"title":"","primaryButton":"false","secondaryButton":"Ok","type":"medium","name":"replace_ap_file_upload_error"},on:{"close":function($event){_vm.apDisplayUploadError = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v(_vm._s(_vm.apUploadError))])])]),_vm._v(" "),_c('div',{staticClass:"clear"})],1)]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showFsReplace,"title":"Correct Funding Statement","primary-button":"Correct","secondary-button":"Cancel","type":"medium","validation":true,"closeOnEsc":true,"name":"replace_funding_statement"},on:{"close":_vm.onFsClose,"validate":_vm.onFsSave}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"col-md-6 no-pad"},[_c('label',[_vm._v("Funding Statement")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.fundingStatementName || '(none)'))]),_vm._v(" "),_c('ed-upload',{class:{ loading: !_vm.fsUploadFinished },attrs:{"field-label":"Attachment","button-label":"Upload File","readonly":"","multiple":false,"postAction":_vm.api.env + _vm.api.$.upload.uploadFile,"uploadAuto":true,"data":_vm.fsUploadSettings,"required":"","showHelptipIcon":false,"helptipHeader":"","error":_vm.fsAttachmentMissingError,"helptip-body":_vm.fsAttachmentMissingError && 'Please attach a file.' || '',"name":"funding_statement_upload"},on:{"input":_vm.onFsUploadComplete},model:{value:(_vm.fsAttachmentFiles),callback:function ($$v) {_vm.fsAttachmentFiles=$$v},expression:"fsAttachmentFiles"}})],1),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.fsDisplayUploadError,"title":"","primaryButton":"false","secondaryButton":"Ok","type":"medium","name":"replace_funding_statement_upload_error"},on:{"close":function($event){_vm.fsDisplayUploadError = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v(_vm._s(_vm.fsUploadError))])])]),_vm._v(" "),_c('div',{staticClass:"clear"})],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"left"},[_c('section',{staticClass:"msg-details"},[_c('h4',[_vm._v("Message Details")]),_vm._v(" "),_c('p',[_vm._v("\n              In addition to the selected user, enter the email address of each person\n              or people you would like to copy (CC) or blind carbon copy (BCC) this\n              statement to.\n            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("CC "),_c('span',{staticClass:"optional"},[_vm._v("– optional")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("BCC "),_c('span',{staticClass:"optional"},[_vm._v("– optional")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UNRQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("/rsB");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_580a0976_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("tp8G");
function injectStyle (ssrContext) {
  __webpack_require__("dLa6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-580a0976"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_580a0976_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UYvm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = navigateToV3;
/* harmony export (immutable) */ __webpack_exports__["b"] = navigateToV3Home;
/* harmony export (immutable) */ __webpack_exports__["c"] = newLocation;
function navigateToV3(sk) {
  var _url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  // const url = _url.includes('returnUrl') ? _url.split('?')[0] : _url
  var url = '';
  var alreadyLogginIn = (url || global.window.location.href).indexOf('/login?sk=') >= 0;
  var location = newLocation.call(this, url).replace(alreadyLogginIn ? /\/login\?sk=[a-zA-Z0-9]+/ : '/login', "/login?sk=".concat(sk)).replace('?mfa', '').replace('?returnUrl', '&returnUrl');
  if (window.location.hash === '#/mfa-setup') {
    var _url2 = new URL(location);
    _url2.hash = "/login?sk=".concat(sk, "&returnUrl=").concat(_url);
    location = _url2;
  }
  if (_url.includes('goToPage=')) {
    var _url3 = new URL(location);
    _url3.hash = "/login?sk=".concat(sk, "&returnUrl=").concat(encodeURIComponent(_url));
    location = _url3;
  }
  global.window.location.replace(location);
}
function navigateToV3Home(user) {
  if (this.$user.$.domain !== 1) {
    var _shouldLogin = user && user.sk;
    _shouldLogin ? this.$router.push({
      name: 'login',
      query: {
        sk: user.sk,
        noSwitchAccount: true
      }
    }) : this.$router.push({
      name: 'home'
    });
    return;
  }
  if (this.$router.currentRoute.query.returnUrl || this.$routerHistory.previous().path.indexOf('returnUrl') >= 0) {
    return;
  }
  var location = newLocation.call(this).replace('?noSwitchAccount', '');
  var url = new URL(location);
  var shouldLogin = user && user.sk; // && this.$router.currentRoute.name !== 'switchaccount'
  url.search = shouldLogin ? 'noSwitchAccount' : '';
  url.hash = shouldLogin ? "/login?sk=".concat(user.sk) : '/home';
  global.window.location.replace(url.href);
}
function newLocation(url) {
  var locationPath = url ? new URL(url).pathname : global.window.location.pathname;
  var env = locationPath.split('/')[1].replace('index.html', '');
  var location = '';
  if (env === '') {
    location = (url || global.window.location.href).replace('.com/#', '.com/-v3/index.html#').replace('.com/index.html', '.com/-v3/index.html');
  } else {
    var newEnv = "".concat(this.api._env.replace('evedonline.', '').replace('.', ''), '-v3');
    newEnv = newEnv.replace('local', 'dev');
    location = (url || global.window.location.href).replace(".com/".concat(env), ".com/".concat(newEnv)).replace(".com/".concat(env + '/'), ".com/".concat(newEnv + '/'));
  }
  return location;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Ud1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_data_skybox__ = __webpack_require__("Bn3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_js__ = __webpack_require__("d3mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_Programs_Card_accounts_tabs__ = __webpack_require__("cUQy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_Programs_Card_list_AddFunding_vue__ = __webpack_require__("g8Y0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_Programs_Card_list_CloseAccount_vue__ = __webpack_require__("jACo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TransferFunds_vue__ = __webpack_require__("b75X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_Programs_Card_list_AccountRefillSettings_vue__ = __webpack_require__("Rbff");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modules_Invoices_statuses__ = __webpack_require__("nBkH");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var additionalFilters = __WEBPACK_IMPORTED_MODULE_10__components_modules_Invoices_statuses__["k" /* default */].additionalFilters,
  filters = __WEBPACK_IMPORTED_MODULE_10__components_modules_Invoices_statuses__["k" /* default */].filters,
  isActiveFilter = __WEBPACK_IMPORTED_MODULE_10__components_modules_Invoices_statuses__["k" /* default */].isActiveFilter;
var defaultFilter = [];
var cancelTooltip = 'Please select an account.';
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DataSkybox: __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_data_skybox__["a" /* default */],
    Grid: __WEBPACK_IMPORTED_MODULE_3__components_Grid__["a" /* default */],
    AddFunding: __WEBPACK_IMPORTED_MODULE_6__components_modules_Programs_Card_list_AddFunding_vue__["a" /* default */],
    CloseAccount: __WEBPACK_IMPORTED_MODULE_7__components_modules_Programs_Card_list_CloseAccount_vue__["a" /* default */],
    AccountRefillSettings: __WEBPACK_IMPORTED_MODULE_9__components_modules_Programs_Card_list_AccountRefillSettings_vue__["a" /* default */],
    TransferFunds: __WEBPACK_IMPORTED_MODULE_8__TransferFunds_vue__["a" /* default */]
  },
  data: function data() {
    return {
      additionalFilters: additionalFilters,
      defaultFilter: this.$route.query.filter ? filters(this.$route.query.filter.split(',')) : filters(defaultFilter),
      statuses: __WEBPACK_IMPORTED_MODULE_10__components_modules_Invoices_statuses__["m" /* metaStatuses */],
      model: __WEBPACK_IMPORTED_MODULE_4__model_js__["a" /* default */],
      tabs: __WEBPACK_IMPORTED_MODULE_5__components_modules_Programs_Card_accounts_tabs__["a" /* default */].tabs,
      rowClasses: {
        'negative-amount': function negativeAmount(params) {
          return (params.data || {}).TotalAmount < 0;
        }
      },
      selectedRows: [],
      selectedAll: null,
      asyncCancelInvoiceDisabledReason: cancelTooltip,
      fundingObj: {},
      selectedObj: {},
      accountRefillSettings: {
        Visible: false,
        ActionDisabled: true
      },
      showRefillSettings: false
    };
  },
  watch: {
    '$route.query.filter': function $routeQueryFilter(value, oldValue) {
      if (value && value !== oldValue) {
        this.$refs.grid.gridOptions.api.setFilterModel(null);
        this.defaultFilter = filters(value.split(','), {}, this.$route.query.filter && this.$route.query.filter.split(','));
        this.$refs.grid.gridOptions.api.setFilterModel(this.defaultFilter);
      }
    }
  },
  computed: {},
  methods: {
    rowSelected: function rowSelected(event) {
      if (typeof event === 'boolean') {
        this.selectedAll = event;
      } else {
        this.selectedRows = event;
        this.fetchCancelReason();
      }
      if (this.selectedRows.length === 1) {
        this.selectedObj = this.selectedRows[0].data;
        console.log(this.selectedObj);
      }
    },
    refresh: function refresh() {
      this.$refs.grid.refreshGrid();
    },
    handleStatusFilter: function handleStatusFilter(status) {
      this.$router.push({
        query: {
          filter: undefined
        }
      });
      this.$refs.grid.gridOptions.api.setFilterModel(filters([status], this.$route.query.filter ? {} : this.$refs.grid.gridOptions.api.getFilterModel()));
    },
    statusActive: function statusActive(status) {
      if (!this.$refs.grid) return {};
      return isActiveFilter(status, this.$refs.grid.gridOptions.api.getFilterModel(), this.$route.query.filter && this.$route.query.filter.split(','));
    },
    fetchCancelReason: function fetchCancelReason() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var tooltip, reason;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.selectedRows.length || _this.selectedRows.length > 1)) {
                _context.next = 3;
                break;
              }
              _this.asyncCancelInvoiceDisabledReason = cancelTooltip;
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return _this.api.forms.post(_this.api.$.invoice.list.canCancelInvoice, {
                id: _this.selectedId
              });
            case 5:
              tooltip = _context.sent;
              reason = __WEBPACK_IMPORTED_MODULE_10__components_modules_Invoices_statuses__["i" /* cannotCancelReasons */][tooltip.data.SuccessMessage];
              _this.asyncCancelInvoiceDisabledReason = reason || '';
              return _context.abrupt("return", reason);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    hasAccountPermission: function hasAccountPermission(permission) {
      if (this.$user && this.$user.$.userPermissions && this.$user.$.userPermissions.length !== 0) {
        return this.$user.$.userPermissions.includes(permission);
      }
      return false;
    },
    actionDisabled: function actionDisabled(actionName) {
      return !!this.actionDisabledReason(actionName);
    },
    actionDisabledReason: function actionDisabledReason(actionName) {
      if (this.selectedRows.length > 1) {
        switch (actionName) {
          case 'addFunding':
            return 'You can only add funds for one account at a time.';
          case 'closeAccount':
            return 'You can only close one account at a time.';
          case 'refillSettings':
            return 'You can only refill one account at a time.';
          default:
            return cancelTooltip;
        }
      }
      if (this.selectedRows.length === 0) {
        return cancelTooltip;
      }
    },
    addFunds: function addFunds() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var isImmediate, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this2.fundingObj.amount && _this2.fundingObj.label)) {
                _context2.next = 15;
                break;
              }
              isImmediate = _this2.fundingObj.label === 'Immediate Funding';
              _this2.fundingObj.divisionId = _this2.selectedObj.DivisionId;
              _context2.prev = 3;
              _context2.next = 6;
              return _this2.api.forms.post("evedpaycards/accounts/".concat(_this2.fundingObj.divisionId, "/add-funding"), {
                Amount: parseFloat(_this2.fundingObj.amount),
                IsImmediate: isImmediate
              });
            case 6:
              response = _context2.sent;
              if (response.status === 200) {
                _this2.refresh();
              }
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              console.error(_context2.t0);
            case 13:
              _context2.next = 16;
              break;
            case 15:
              _this2.addFundsError();
            case 16:
              _this2.fundingObj = {};
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 10]]);
      }))();
    },
    addFundsError: function addFundsError() {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        timeout: 0,
        message: 'Please fill out all the fields.'
      });
    },
    singularize: function singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value;
    }
  },
  created: function created() {
    this.divisionsName = this.$root.getUser.settings.Labels.DivisionsName;
    this.divisionName = this.singularize(this.$root.getUser.settings.Labels.DivisionName);
    this.model.Division.label = this.divisionName;
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "UftQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('label',[_vm._v("Attached AP File")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":_vm.auditFileExportUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.apFile.AuditFileNumber))]),_vm._v(" "),_c('ed-button',{attrs:{"button-class":"btn btn-actionbar-primary pull-right","name":"replace-ap-file-btn"},on:{"click":function($event){_vm.show = true}}},[_vm._v(_vm._s('Replace'))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.show,"title":"Replace AP File","primary-button":"Replace","secondary-button":"Cancel","type":"medium","validation":true,"closeOnEsc":true,"name":"replace_ap_file"},on:{"close":_vm.onClose,"validate":_vm.onSave}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"col-md-6 no-pad"},[_c('label',[_vm._v("AP File")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.apFile.AuditFileNumber))]),_vm._v(" "),_c('ed-upload',{class:{loading: !_vm.uploadFinished},attrs:{"field-label":"Attachment","button-label":"Upload File","readonly":"","multiple":false,"postAction":_vm.api.env + _vm.api.$.upload.uploadFile,"uploadAuto":true,"data":_vm.uploadSettings,"required":"","showHelptipIcon":false,"helptipHeader":"","error":_vm.attachmentMissingError,"helptip-body":_vm.attachmentMissingError && "Please attach a file." || "","name":"attachment_upload"},on:{"input":_vm.createAttachments},model:{value:(_vm.attachmentFiles),callback:function ($$v) {_vm.attachmentFiles=$$v},expression:"attachmentFiles"}}),_vm._v(" "),_c('ed-textarea',{attrs:{"field-label":"Payment Notes","required":false,"maxLength":150,"name":"ap_file_notes"},model:{value:(_vm.paymentNotes),callback:function ($$v) {_vm.paymentNotes=$$v},expression:"paymentNotes"}})],1),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.displayUploadError,"title":"","primaryButton":"false","secondaryButton":"Ok","type":"medium","name":"replace_ap_file_upload_error"},on:{"close":function($event){_vm.displayUploadError = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v(_vm._s(_vm.uploadError))])])]),_vm._v(" "),_c('div',{staticClass:"clear"})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uhb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fundingAmount: '',
      showAddFunding: false
    };
  },
  props: {
    ids: null,
    disabled: false,
    tooltip: '',
    accountId: ''
  },
  methods: {
    addFunds: function addFunds() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.fundingAmount) {
                _context.next = 13;
                break;
              }
              _context.prev = 1;
              _context.next = 4;
              return _this.api.post("evedpaycards/accounts/".concat(_this.accountId, "/add-funding"), {
                Amount: parseFloat(_this.fundingAmount),
                IsImmediate: true
              });
            case 4:
              response = _context.sent;
              if (response.status === 200) {
                _this.$emit('success');
              }
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);
            case 11:
              _context.next = 14;
              break;
            case 13:
              _this.addFundsError();
            case 14:
              _this.fundingAmount = '';
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    addFundsError: function addFundsError() {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        timeout: 0,
        message: 'Please fill out all the fields.'
      });
    },
    showModal: function showModal(showAddFunding) {
      this.showAddFunding = !showAddFunding;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "UmH6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auth_vue__ = __webpack_require__("N313");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21005c1a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_auth_vue__ = __webpack_require__("7bSZ");
function injectStyle (ssrContext) {
  __webpack_require__("Y+cd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21005c1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21005c1a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UnLI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"column col-md-3"},[_c('label',[_vm._v(_vm._s(_vm.divisionName))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.model.DivisionName))])]),_vm._v(" "),_c('div',{staticClass:"column col-md-3"},[_c('label',[_vm._v("Invoice Total")]),_vm._v(" "),_c('div',[_c('v-money',{attrs:{"currency":_vm.model.CurrencyCode}},[_vm._v(_vm._s(_vm.model.InvoiceTotalAmount))])],1)]),_vm._v(" "),_c('div',{staticClass:"column col-md-3"},[_c('label',[_vm._v("Payments")]),_vm._v(" "),_c('div',[_c('v-money',{attrs:{"currency":_vm.model.CurrencyCode}},[_vm._v(_vm._s(_vm.model.PaymentsAmount))])],1)]),_vm._v(" "),_c('div',{staticClass:"column col-md-3"},[_c('label',[_vm._v("Balance")]),_vm._v(" "),_c('div',[_c('v-money',{attrs:{"currency":_vm.model.CurrencyCode}},[_vm._v(_vm._s(_vm.model.Balance))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uqyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.className},[_c('span',{staticClass:"btn btn-primary alt",class:{ disabled: _vm.disabled }},[_vm._v(_vm._s(_vm.buttonLabel))]),_c('input-file',{attrs:{"required":_vm.required,"disabled":_vm.disabled}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Urgo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1jOMZeHj9XZ5OAhTYY426S","Dell":"_1IUy_oOluok70VE_vnPa3O","Abbott":"_3953PSlS_rDpkQh_edVgKU","Gap":"_1S3ftMZkGcZE7hW1kZRFnI","Allstate":"_9OZDTP91CHo1K3ejiqoiR","Asurion":"_2y9RNJjfGWBjxbAMZvABRG","Invitae":"_2BqnioyQywrsAasE2JLKfn","JWE":"_1DN2bdpA_SllNUiWUcz672"};

/***/ }),

/***/ "Usg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EventBus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Eved; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__core_events_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_events_extended_bus__ = __webpack_require__("Q5Cs");



var bus = Object(__WEBPACK_IMPORTED_MODULE_2__core_events_extended_bus__["a" /* extendedBus */])(new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());
__WEBPACK_IMPORTED_MODULE_1__core_events_events___default.a.queue = [];
global._EventBus = bus;
var EventBus = bus;
var Eved = __WEBPACK_IMPORTED_MODULE_1__core_events_events___default.a;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Uv1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostPayment_vue__ = __webpack_require__("KWFF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de53696_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostPayment_vue__ = __webpack_require__("klGW");
function injectStyle (ssrContext) {
  __webpack_require__("LqNp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0de53696"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de53696_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostPayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UwY+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_invoice_vue__ = __webpack_require__("mhc2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88e7714a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_invoice_vue__ = __webpack_require__("qlOY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_invoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88e7714a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_invoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uy8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{ "invalid": _vm.error, "hidden": _vm.hidden },attrs:{"id":"dawnSelect__main-wrapper"}},[(_vm.helptipBody && _vm.isOpen || _vm.helptipBody && _vm.error)?_c('ed-input-tooltip',{class:{"error-message": _vm.error},attrs:{"helptipHeader":_vm.helptipHeader,"helptipBody":_vm.helptipBody,"errorTip":_vm.error}}):_vm._e(),(_vm.fieldLabel)?_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.fieldLabel)),(!_vm.required && !_vm.hideOptional)?_c('em',{staticClass:"optional"},[_vm._v(" - optional")]):_vm._e()]):_vm._e(),_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.deactivate),expression:"deactivate"}],staticClass:"dawnSelect",class:{ "dawnSelect--active form-field--active": _vm.isOpen && !_vm.multilist, "dawnSelect--disabled": _vm.disabled, "dawnSelect--above": _vm.isAbove, "dawnSelect--over": _vm.isOver, "dawnSelect--multilist": _vm.multilist },attrs:{"tabindex":_vm.searchable ? -1 : _vm.tabindex},on:{"focus":function($event){return _vm.activate()},"blur":function($event){_vm.searchable ? false : _vm.deactivate()},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();return _vm.pointerForward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();return _vm.pointerBackward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.addPointerElement($event)}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.deactivate()}}},[_vm._t("caret",function(){return [_c('div',{staticClass:"dawnSelect__select",on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggle()}}})]},{"toggle":_vm.toggle}),_c('span',{staticClass:"remove"},[_vm._t("clear",null,{"search":_vm.search})],2),_c('div',{ref:"tags",staticClass:"dawnSelect__tags"},[(_vm.internalValue && _vm.internalValue.length > _vm.limit)?[_c('strong',{staticClass:"dawnSelect__strong",domProps:{"textContent":_vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))}})]:_vm._e(),_c('transition',{attrs:{"name":"dawnSelect__loading"}},[_vm._t("loading",function(){return [_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"dawnSelect__spinner"})]})],2),(_vm.icon)?_c('small',{staticClass:"icon-wrapper"},[_c('i',{staticClass:"icon",class:_vm.icon})]):_vm._e(),(_vm.searchable)?_c('input',_vm._b({directives:[{name:"focus",rawName:"v-focus.lazy",value:(_vm.autofocus),expression:"autofocus",modifiers:{"lazy":true}}],ref:"search",staticClass:"dawnSelect__input",style:(_vm.displayedValueStyle),attrs:{"name":_vm.name,"id":_vm.id,"type":"text","autocomplete":"off","placeholder":_vm.currentOptionLabel || _vm.placeholder,"required":_vm.required,"autofocus":_vm.autofocus,"disabled":_vm.disabled,"tabindex":_vm.tabindex,"readonly":_vm.isOver || _vm.multilist,"title":_vm.displayedValueTitle},domProps:{"value":_vm.isOpen ? _vm.search : _vm.currentOptionLabel},on:{"focus":[function($event){_vm.focused = true},function($event){$event.preventDefault();return _vm.activate()}],"blur":[function($event){_vm.focused = false},function($event){$event.preventDefault();_vm.multilist || _vm.deactivate($event)}],"input":function($event){_vm.updateSearch($event.target.value); _vm.debounceSearching()},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.deactivate()},function($event){return _vm.$emit('keyup', $event.target.value)}],"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.pointerForward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.pointerBackward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.addPointerElement($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }$event.stopPropagation();return _vm.removeLastElement()}]}},'input',_vm.$props,false)):_vm._e(),(!_vm.searchable)?_c('span',{staticClass:"dawnSelect__single",domProps:{"textContent":_vm._s(_vm.currentOptionLabel)},on:{"mousedown":function($event){$event.preventDefault();return _vm.toggle.apply(null, arguments)}}}):_vm._e()],2),_c('transition',{attrs:{"name":"dawnSelect"}},[(!!_vm.multilist)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"dawnSelect__header-wrapper",class:{ empty: !_vm.options.length }},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.options[0] && _vm.options[0][_vm.groupValues]),expression:"options[0] && options[0][groupValues]"}]},[_vm._v(_vm._s(_vm.placeholder))]),_c('ed-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.length > 1),expression:"options.length > 1"}],staticClass:"inline small",attrs:{"options":_vm.options,"label":_vm.groupLabel,"open-direction":"over","id":"groupController"},on:{"select":_vm.selectGroup},model:{value:(_vm.selectedGroup),callback:function ($$v) {_vm.selectedGroup=$$v},expression:"selectedGroup"}}),_c('div',{class:{ "header-wrapper": _vm.$slots.additionalOptions }},[_vm._t("additionalOptions")],2),_c('ed-input',{staticClass:"list-search",attrs:{"placeholder":_vm.$t("Search"),"search":"","value":_vm.search},on:{"input":_vm.updateSearch}})],1):_vm._e()]),_c('transition',{attrs:{"name":"dawnSelect"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"list",staticClass:"dawnSelect__content-wrapper list multilist",class:{ empty: !_vm.options.length },style:({ maxHeight: _vm.optimizedHeight + "px" }),attrs:{"name":_vm.name + "__content-wrapper","endpoint":_vm.$attrs.openEndpoint},on:{"focus":_vm.activate,"mousedown":function($event){$event.preventDefault();}}},[_c('ul',{staticClass:"dawnSelect__content",style:(_vm.contentStyle)},[_c('div',{class:{ "header-wrapper": _vm.$slots.beforeList }},[_vm._t("beforeList")],2),(_vm.multiple && _vm.max === _vm.internalValue.length)?_c('li',[_c('span',{staticClass:"dawnSelect__option"},[_vm._t("maxElements",function(){return [_vm._v("Maximum of "+_vm._s(_vm.max)+" options selected. First remove a selected option to select another.")]})],2)]):_vm._e(),(!_vm.max || _vm.internalValue.length < _vm.max)?_vm._l((_vm.filteredOptions),function(option,index){return _c('li',{key:index,staticClass:"dawnSelect__element"},[(!(option && (option.$isLabel || option.$isDisabled)))?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.optionTooltip(option, index)),expression:"optionTooltip(option, index)",modifiers:{"bottom":true}}],ref:"options",refInFor:true,staticClass:"dawnSelect__option",class:_vm.optionHighlight(index, option),attrs:{"data-select":option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,"data-selected":_vm.selectedLabelText,"data-deselect":_vm.deselectLabelText},on:{"click":function($event){$event.stopPropagation();return _vm.select(option, index)},"mouseenter":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.pointerSet(index)}}},[(_vm.multiple && _vm.checkboxes)?_c('checkbox',{attrs:{"option-status":_vm.isSelected(option)}}):_vm._e(),_vm._t("option",function(){return [(~_vm.getOptionLabel(option).indexOf("|"))?_c('span',{staticClass:"option-text"},[_vm._v(_vm._s(_vm.getOptionLabel(option).split("|")[0])),_c('br'),_vm._v(_vm._s(_vm.getOptionLabel(option).split("|")[1]))]):_c('span',{staticClass:"option-text"},[_vm._v(_vm._s(_vm.getOptionLabel(option)))])]},{"option":option,"search":_vm.search})],2):_vm._e(),(!_vm.multilist && option && (option.$isLabel || option.$isDisabled))?_c('span',{staticClass:"dawnSelect__option dawnSelect__option--disabled",class:_vm.optionHighlight(index, option)},[_vm._t("option",function(){return [_c('span',[_vm._v(_vm._s(_vm.getOptionLabel(option)))])]},{"option":option,"search":_vm.search})],2):_vm._e()])}):_vm._e(),_vm._t("afterList")],2)])]),_c('transition',{attrs:{"name":"dawnSelect"}},[(!_vm.title)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen && (_vm.checkboxes || _vm.multilist)),expression:"isOpen && (checkboxes || multilist)"}],staticClass:"toolbar",class:{ "hide": _vm.checkboxes && !_vm.multilist, "info": !(_vm.options[0] && _vm.options[0][_vm.groupValues]) }},[(_vm.options[0] && _vm.options[0][_vm.groupValues])?_c('ed-button',{staticClass:"btn",attrs:{"buttonClass":"btn-actionbar"},on:{"click":_vm.apply}},[_vm._v("Apply")]):_c('em',[_vm._v("No options")])],1):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"toolbar",style:(_vm.toolbarStyle)},[_c('hr'),_vm._t("toolbar")],2)])],2),(!_vm.checkboxes)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visibleValue.length > 0),expression:"visibleValue.length > 0"}],staticClass:"dawnSelect__tags-wrap"},[_vm._l((_vm.visibleValue),function(option){return [_vm._t("tag",function(){return [_c('span',{staticClass:"dawnSelect__tag"},[_c('span',{domProps:{"textContent":_vm._s(_vm.getOptionLabel(option))}}),_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:("Remove"),expression:"\"Remove\""}],staticClass:"dawnSelect__tag-icon",attrs:{"aria-hidden":"true","tabindex":"1"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.removeElement(option)},"mousedown":function($event){$event.preventDefault();return _vm.removeElement(option)}}})])]},{"option":option,"search":_vm.search,"remove":_vm.removeElement})]})],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UyIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  props: {
    card: Object
  },
  methods: {},
  created: function created() {}
});

/***/ }),

/***/ "Uzrj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3sVbfXchiCq0lKPVPZcBGW","Dell":"_3I1YbrUX0BRCwvbZ5F6r3B","Abbott":"h2jUWWDnE-N6omNNwCVpC","Gap":"_1inT4wJtSpZ2ozlpnQ6aZ2","Allstate":"_3BP93QmRz1Aflu_UaH53Ut","Asurion":"_2OrYuem7kGVC8-sJawWG9V","Invitae":"XyXRDWA1lIKLD94P8apQj","JWE":"_3RRfIseuADhoHVQawQEkAv"};

/***/ }),

/***/ "V1ie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFeeTaxes_vue__ = __webpack_require__("SD9d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42b1ef16_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFeeTaxes_vue__ = __webpack_require__("GKK6");
function injectStyle (ssrContext) {
  __webpack_require__("Skn6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42b1ef16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFeeTaxes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42b1ef16_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFeeTaxes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V8Ry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpaycards',
  data: function data() {
    return {
      cards: null,
      dateFormat: null
    };
  },
  created: function created() {
    this.initializeData();
  },
  computed: {
    moment: function moment() {
      return global.moment;
    }
  },
  methods: {
    initializeData: function initializeData() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchCards();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchCards: function fetchCards() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.api.forms.post(_this2.api.$.evedpaycard.cards, {
                sort: 'CardGroup',
                dir: 'DESC',
                start: 0,
                limit: 100,
                isLiveGrid: true,
                filter: {
                  searchTerm: ''
                }
              }).then(function (r) {
                _this2.cards = (r && r.data && Array.isArray(r.data.Data) ? r.data.Data : []).map(function (card) {
                  return {
                    name: 'EvedPay Card' + "".concat(card.CardNumber ? ' ...' + card.CardNumber : ''),
                    holder: card.Holder,
                    holderUserId: card.HolderUserID,
                    nameOnCard: card.NameOnCard || '',
                    division: card.Division,
                    divisionId: card.DivisionId,
                    initialLoad: card.InitialLoad,
                    refills: card.Refills,
                    pendingRequest: card.Pending,
                    spent: card.Spent,
                    returned: card.ReturnedAmount,
                    balance: card.Balance,
                    id: card.Id,
                    cardNumber: card.CardNumber,
                    accId: card.AccountId,
                    status: card.CardStatus,
                    createdDate: card.CreatedDate
                  };
                });
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    redirectToCardTransactions: function redirectToCardTransactions(card) {
      // Set cardid on the query object AFTER the spread so the tapped card always wins.
      // A cardid placed only in the path is overridden by any stale cardid carried in
      // this.$route.query (vue-router merges the query object over the path's query string),
      // which made every card show the first-opened card's transactions.
      var query = _objectSpread(_objectSpread({}, this.$route.query), {}, {
        cardid: card.id,
        cardNumber: card.cardNumber
      });
      this.$router.push({
        path: '/evedpay/cardtransactions',
        query: query
      });
    },
    headerText: function headerText(card) {
      var status = card.status;
      if (status === 'Locked - Lost/Stolen') {
        return 'Lost/Stolen';
      } else {
        return "".concat(status);
      }
    },
    showCardNameForDifferentStatus: function showCardNameForDifferentStatus(card) {
      var status = card.status;
      this.dateFormat = this.$user && this.$user.sessionSettings && this.$user.sessionSettings.DateAndTimeFormats && this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat ? this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat : 'MM-DD-YYYY';
      var date = this.moment(card.createdDate).format(this.dateFormat);
      if (status === 'Pending Approval' || status === 'Processing' || status === 'Rejected') {
        return 'Card Requested ' + "".concat(date);
      } else {
        return card.name;
      }
    },
    showHeader: function showHeader(card, index) {
      if (index === 0) return true;
      var previousCard = this.cards[index - 1];
      return this.headerText(card) !== this.headerText(previousCard);
    },
    formatCardHolderLine: function formatCardHolderLine(card) {
      var holderName = card && card.holder || '';
      var nameOnCard = (card && card.nameOnCard || '').trim();
      if (nameOnCard && nameOnCard !== holderName.trim()) {
        return "".concat(nameOnCard, " | ").concat(holderName);
      }
      return holderName;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "V8WY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_edTabNav_wizardMixin__ = __webpack_require__("3d8/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import customTypes from './types.json'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImportExpenses',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_components_edTabNav_wizardMixin__["a" /* default */]],
  methods: {
    /**
     * Updates matched column/columns list
     */
    handleMultimatch: function handleMultimatch(field, value) {
      if (field.type === 'list') {
        field.columns = field.columns || [];
        field.columns.push(value);
      } else {
        field.columns = [value];
      }
      this.$forceUpdate();
    },
    /**
     * Removes 1:1 match
     */
    removeMatch: function removeMatch(field) {
      field.columns = [];
      this.$forceUpdate();
    },
    /**
     * Removes 1:* match
     */
    removeColumn: function removeColumn(column, field) {
      field && field.columns.splice(field.columns.indexOf(column), 1);
      this.$forceUpdate();
    },
    /**
     * Gets permissions list
     */
    fetchPermissions: function fetchPermissions() {
      var _this = this;
      this.permissions.length || this.api(this.api.$.expense.permissions).then(function (r) {
        _this.permissions = r.data || [];
      });
    },
    /**
     * Gets titles list
     */
    fetchTitles: function fetchTitles() {
      var _this2 = this;
      this.titles.length || this.api(this.api.$.expense.titles).then(function (r) {
        _this2.titles = r.data || [];
      });
    },
    /**
     * Checks if required/all fields are matched
     */
    checkMatched: function checkMatched() {
      if (this.data.fieldsMap[0].fieldName !== null) {
        var allRequiredMatched = this.data.fieldsMap.filter(function (field) {
          return field.isRequired && !(field.columns && field.columns.length);
        }).length === 0;
        var allMatched = this.canSkip || this.data.fieldsMap.filter(function (field) {
          return !field.isRequired && !(field.columns && field.columns.length);
        }).length === 0;
        this.notAllRequiredMatched = !allRequiredMatched;
        this.notAllMatched = allRequiredMatched && !allMatched;
        if (!allRequiredMatched) {
          __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].EXPENSE.IMPORT.INVALID);
        }
        return allRequiredMatched && allMatched;
      }
    },
    /**
     * Can proceed to next step if not all not required are matched
     */
    skipMatch: function skipMatch() {
      this.canSkip = true;
      this.proceed();
      this.canSkip = false;
    },
    /**
     * Callback after each step
     */
    afterEnterStep: function afterEnterStep(step) {
      // Activate Admin menu
      global.Page.showTabs('Admin', 'Import', '#d', null);

      // reset any pending data
      this.$store.state.pendingData = null;
      if (step) {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].EXPENSE.IMPORT.ENTERED_STEP, step);
      }
    }
  },
  created: function created() {
    this.importedColumns = [];
  },
  data: function data() {
    return {
      canSkip: false,
      notAllMatched: false,
      notAllRequiredMatched: false,
      data: {
        fieldsMap: [{
          fieldName: null,
          isRequired: true,
          columns: []
        }],
        importedColumns: []
      },
      errors: null,
      permissions: [],
      titles: [],
      /**
       * Column match label
       */
      columnName: function columnName(option, multiple) {
        if (!option) return;
        if (option.length === 0) return '';

        //
        if (multiple === false) {
          return option;
        }

        // 1:* match
        if (multiple) return option && option.length + ' selected';

        // 1:1 match - [LETTER] NAME
        return option && typeof option === 'string' ? option : "[".concat(option.letter || option[0] && option[0].letter, "] ").concat(option.name || option[0] && option[0].name || '[None]');
      },
      /**
       * Set details for custom matches
       */
      initDetails: function initDetails(column, field) {
        /* if (field.Alias === 'Collaborators') {
          column.Details = column.Details || {}
        } */

        return field.alias === 'Collaborators';
      },
      setDetails: function setDetails(field, column, value) {
        column.details = column.details || {};
        column.details[field] = value;
      },
      /**
       * Enables/disables unselected/selected columns
       */
      updateMatches: function updateMatches(fields, columns) {
        if (!columns.length) return fields;
        var matchedFields = fields.map(function (field) {
          return field.columns;
        }).reduce(function (fields, columns) {
          return (fields || []).concat(columns);
        }).filter(function (columns) {
          return columns;
        }).map(function (column) {
          return column.letter;
        });
        columns = columns.map(function (column) {
          if (~matchedFields.indexOf(column.letter)) {
            column.$isDisabled = true;
          } else {
            delete column.$isDisabled;
          }
          return column;
        });
        return fields;
      },
      /**
       * Only inject options @open dropdown
       * to avoid performance bottlenecks
       * when rendering large sets
       */
      fetchImportedColumns: function fetchImportedColumns(columns, index) {
        this.$set(this.importedColumns, index, columns);
        this.$forceUpdate();
      },
      getImportedColumns: function getImportedColumns(index) {
        return this.importedColumns[index] || [];
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "VBmV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-navigation"},[_c('div',{ref:"toolbar",staticClass:"dawn-title-nav",class:{ sticky: _vm.sticky }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"title-area"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"page-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),(_vm.hasOverview)?_c('div',{staticClass:"overview-area col-md-6"},[_vm._t("overview")],2):_vm._e(),(_vm.hasTabs)?_c('div',{staticClass:"tabs-area"},[_vm._t("tabs",function(){return _vm._l((_vm.tabs),function(tab,i){return _c('router-link',{key:i,attrs:{"to":tab.href,"active-class":"active"}},[_vm._v(" "+_vm._s(tab.label))])})})],2):_vm._e(),(_vm.hasAction)?_c('div',{staticClass:"action-area text-right"},[_vm._t("action")],2):_vm._e(),(_vm.reference)?_c('div',{staticClass:"action-area text-right"},[_c('router-link',{attrs:{"to":_vm.backReference}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_c('span',[_vm._v(_vm._s(_vm.$t('Back'))+" "+_vm._s(_vm.backReferenceTitle))])])],1):_vm._e()])])]),_vm._t("toolbar")],2),_c('div',{staticClass:"sticky-placeholder",style:({ height: _vm.$refs.toolbar && _vm.sticky ? ((_vm.$refs.toolbar.clientHeight) + "px") : 0 })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VJRP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddReceipt_vue__ = __webpack_require__("WBso");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d40dad6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddReceipt_vue__ = __webpack_require__("8vDI");
function injectStyle (ssrContext) {
  __webpack_require__("f7Z3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d40dad6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddReceipt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d40dad6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddReceipt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VK62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transactionDisplayMixin__ = __webpack_require__("51B0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpaycardtransactions',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__transactionDisplayMixin__["a" /* default */]],
  data: function data() {
    return {
      cardId: this.$route.query.cardid,
      cards: [],
      transactions: null,
      dateFormat: this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat
    };
  },
  created: function created() {
    // Non-reactive token: invalidates in-flight loadCardData() responses that were
    // superseded by a newer call (same pattern as _modules/Programs/Card/index.vue).
    this.loadTokenCounter = 0;
    this.loadCardData();
  },
  // The shell keeps this module alive (Layouts/shell/mobile.vue), so created() runs
  // once. Refetch on every re-entry: a different ?cardid needs different data, and
  // returning from a reconcile must pick up the moved row — this view has no
  // 'transaction-reconciled' listener, so a guarded refetch would show the stale
  // bucket. Same unconditional-refresh-on-activation pattern as
  // _modules/Programs/Card/index.vue.
  activated: function activated() {
    // The first activation fires together with created() on initial mount —
    // skip it to avoid a double fetch.
    if (!this._hasActivatedOnce) {
      this._hasActivatedOnce = true;
      return;
    }
    this.loadCardData();
  },
  computed: {
    moment: function moment() {
      return global.moment;
    },
    card: function card() {
      return this.cards && this.cards.id === this.$route.query.cardid ? this.cards : {};
    },
    cardRejected: function cardRejected() {
      return this.card.rejectReason !== null;
    }
  },
  methods: {
    loadCardData: function loadCardData() {
      var _this = this;
      // Stale-response guard: with the unconditional activated() refetch, two calls
      // can be in flight at once (re-enter card B while card A still loads, or a
      // quick same-card bounce through a reconcile). Only the newest call may
      // assign — otherwise the older snapshot wins and renders the wrong card's
      // rows / the pre-reconcile buckets.
      var token = ++this.loadTokenCounter;
      var CardId = this.$route.query.cardid;
      this.cardId = CardId;
      this.transactions = null;
      this.cards = [];
      this.api.forms.post(this.api.$.evedpaycard.transactions, {
        sort: 'TransactionGroup',
        dir: 'DESC',
        start: 0,
        limit: 1000,
        isLiveGrid: true,
        // Must be a JSON string: the legacy grid reads Request.Form["filter"] and deserializes it.
        // Passed as a raw object, qs.stringify expands it to filter[CardId]=...&filter[searchTerm]=,
        // so the server never sees a "filter" field and skips the CardId filter — returning every
        // card's transactions (the whole division for admins) and leaning entirely on the client filter.
        filter: JSON.stringify({
          CardId: CardId,
          searchTerm: ''
        })
      }).then(function (r) {
        if (token !== _this.loadTokenCounter) {
          return;
        }
        _this.transactions = r.data.Data.filter(function (t) {
          return t.CardId === CardId;
        }).map(function (transaction) {
          return {
            merchant: transaction.Merchant,
            amount: transaction.Amount,
            date: transaction.TransactionDate,
            status: transaction.TransactionStatus,
            id: transaction.Id,
            cardNumber: transaction.CardNumber,
            reconcileStatus: transaction.ReconciliationStatus,
            holderId: transaction.HolderUserId,
            receipt: transaction.Receipt
          };
        });
        // Group rows by display header (Reconcile, Pending, Completed, Declined) so each header
        // renders exactly once — the server's TransactionGroup sort interleaves them. See
        // sortByDisplayGroup().
        _this.sortByDisplayGroup();
      });
      this.api.forms.post(this.api.$.evedpaycard.cards, {
        sort: 'CardNumber',
        dir: 'DESC',
        start: 0,
        limit: 100,
        isLiveGrid: true,
        filter: {
          CardStatus: 'active',
          searchTerm: ''
        }
      }).then(function (r) {
        if (token !== _this.loadTokenCounter) {
          return;
        }
        var matchedCard = r.data.Data.find(function (card) {
          return card.Id === CardId;
        });
        if (matchedCard) {
          _this.cards = {
            name: matchedCard.Name || "EvedPay Card ...".concat(matchedCard.CardNumber),
            holder: matchedCard.Holder,
            holderUserId: matchedCard.HolderUserID,
            division: matchedCard.Division,
            initialLoad: matchedCard.InitialLoad,
            spent: matchedCard.Spent,
            returned: 0,
            balance: matchedCard.Balance,
            id: matchedCard.Id,
            cardNumber: matchedCard.CardNumber,
            rejectReason: matchedCard.RejectionReason,
            createdDate: matchedCard.CreatedDate
          };
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "VOe2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BU_list__ = __webpack_require__("t2M6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CC_list__ = __webpack_require__("eJx6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BU_CC_list__ = __webpack_require__("5HOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_Admin_settings__ = __webpack_require__("Ht71");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_1__components_Grid__["a" /* default */],
    BUList: __WEBPACK_IMPORTED_MODULE_2__BU_list__["default"],
    CCList: __WEBPACK_IMPORTED_MODULE_3__CC_list__["default"],
    BUAndCCList: __WEBPACK_IMPORTED_MODULE_4__BU_CC_list__["default"]
  },
  data: function data() {
    return {
      title: '',
      subtitle: '',
      settings: {},
      settingsCopy: {}
    };
  },
  computed: {
    disablePairedBUCC: function disablePairedBUCC() {
      return !this.settingsCopy.HasBusinessUnit || !this.settingsCopy.HasCostCenter;
    },
    displayBUGrid: function displayBUGrid() {
      return !this.settingsCopy.UseBusinessUnitAndCostCenterMapping && this.settingsCopy.HasBusinessUnit;
    },
    displayCCGrid: function displayCCGrid() {
      return !this.settingsCopy.UseBusinessUnitAndCostCenterMapping && this.settingsCopy.HasCostCenter;
    }
  },
  created: function created() {
    this.settings = this.$user.$.settings; // this.updateSettings()
    this.settingsCopy = utils.copy(this.settings);
  },
  methods: {
    updateSettings: function updateSettings(values) {
      var companySettingsCopy = JSON.parse(global.localStorage.getItem('sessionSettings'));
      var updatedCompanySettings = _objectSpread(_objectSpread({}, companySettingsCopy), {}, {
        CompanySettings: values
      });
      global.localStorage.setItem('sessionSettings', JSON.stringify(updatedCompanySettings));
      this.$user.$.settings = values;
      return __WEBPACK_IMPORTED_MODULE_5__components_modules_Admin_settings__["a" /* default */].methods.updateSettings.call(this, values);
    },
    changeBUSetting: function changeBUSetting(e) {
      var _this = this;
      if (!e.status) {
        this.$nextTick(function () {
          _this.settingsCopy.HasBusinessUnit = true;
          var message = 'Are you sure you want to turn off Business Units ?';
          _this.showWarningMessage('HasBusinessUnit', message);
        });
      } else {
        this.saveSettings();
      }
    },
    changeCCSetting: function changeCCSetting(e) {
      var _this2 = this;
      if (!e.status) {
        this.$nextTick(function () {
          _this2.settingsCopy.HasCostCenter = true;
          var message = 'Are you sure you want to turn off Cost Centers ?';
          _this2.showWarningMessage('HasCostCenter', message);
        });
      } else {
        this.saveSettings();
      }
    },
    changePairedBUAndCCStatus: function changePairedBUAndCCStatus(e) {
      var _this3 = this;
      if (!e.status) {
        this.$nextTick(function () {
          _this3.settingsCopy.UseBusinessUnitAndCostCenterMapping = true;
          var message = 'Are you sure you want to manage your BUs & CCs separately ? The pairs of data from your single table will now show in two separate tables if you select this change.';
          _this3.showWarningMessage('UseBusinessUnitAndCostCenterMapping', message);
        });
      } else {
        this.saveSettings();
      }
    },
    saveSettings: function saveSettings(setting) {
      var _this4 = this;
      var payload = {
        useBU: this.settingsCopy.HasBusinessUnit,
        useCC: this.settingsCopy.HasCostCenter,
        useBUAndCC: this.settingsCopy.UseBusinessUnitAndCostCenterMapping
      };
      this.api.forms.post(this.api.$.BUAndCC.saveSettings, payload).then(function (r) {
        _this4.updateSettings(_this4.settingsCopy);
      }).catch(function (e) {
        _this4.settingsCopy = utils.copy(_this4.settings);
      });
    },
    showWarningMessage: function showWarningMessage(setting, message) {
      var _this5 = this;
      var self = this;
      this.$nextTick(function () {
        _this5.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: {
            from: 'top',
            align: 'center'
          },
          timeout: 0,
          message: message,
          dismiss: 'Yes',
          discard: 'No',
          goto: null,
          onClose: function onClose(dismiss) {
            if (dismiss) {
              self.settingsCopy[setting] = self.settingsCopy[setting] ? false : self.settingsCopy[setting];
              if (!self.settingsCopy.HasCostCenter || !self.settingsCopy.HasBusinessUnit) {
                self.settingsCopy.UseBusinessUnitAndCostCenterMapping = false;
              }
              self.saveSettings(setting);
            }
          }
        });
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "VREj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.$nextTick(function () {
      if (global.app.$user) {
        global.app.$user.logout();
      }
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "VTbA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VhKI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasData: false,
      headerData: []
    };
  },
  created: function created() {
    var _this = this;
    this.api.get(this.api.$.invoice.skybox).then(function (r) {
      if (r.data) {
        _this.headerData = r.data;
        _this.hasData = true;
      }
    });
  }
});

/***/ }),

/***/ "ViMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-check dawn-checkbox",class:{ "inline-": _vm.$parent.$attrs["inline"] !== undefined, "dawn-checkbox--disabled": _vm.disabled }},[_c('label',{ref:"optionWrapper",staticClass:"form-check-label",class:{ "remove-only": _vm.removeOnly }},[(!_vm.removeOnly)?_c('input',_vm._b({staticClass:"form-check-input",attrs:{"id":_vm.optionLabel,"name":_vm.name,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.optionStatus,"value":_vm.optionStatus},on:{"click":_vm.changeStatus}},'input',_vm.$props,false)):_vm._e(),(!_vm.removeOnly)?_c('span',{staticClass:"check-mask"}):_vm._e(),(!_vm.$slots.default)?_c('span',{ref:"optionLabel",staticClass:"text",attrs:{"title":_vm.tooltip}},[(_vm.icon)?_c('i',{class:_vm.icon,style:({ color: _vm.iconColor })}):_vm._e(),(_vm.icon)?_c('span',[_vm._v(" ")]):_vm._e(),_vm._v(_vm._s(_vm.optionLabel)),(_vm.removeOnly)?_c('i',{staticClass:"remove-icon fas fa-times-circle pull-right",on:{"click":_vm.remove}}):_vm._e()]):_c('div',{staticClass:"dawn-checkbox-option-content"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vv+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_Programs_Card_transactions_ReconcileTransaction__ = __webpack_require__("Yqmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_Programs_Card_transactions__ = __webpack_require__("AAet");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_utils_string_js__ = __webpack_require__("dCaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus__ = __webpack_require__("Usg1");



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var transactions = [];
var transactionsMethods = __WEBPACK_IMPORTED_MODULE_4__components_modules_Programs_Card_transactions__["default"].methods;
var reconcileMethods = __WEBPACK_IMPORTED_MODULE_3__components_modules_Programs_Card_transactions_ReconcileTransaction__["a" /* default */].methods;
/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpaytransactiondetails',
  components: {
    Reconcile: __WEBPACK_IMPORTED_MODULE_3__components_modules_Programs_Card_transactions_ReconcileTransaction__["a" /* default */]
  },
  created: function created() {
    var _this = this;
    // Mobile EvedPay surface vs the shared desktop module — gates the mobile-only
    // Reconcile UI (full-screen scan overlay, mobile Additional Documents layout)
    // via the :is-mobile prop. Same detection as ReceiptFolder.vue / CandidateSelector.
    this.isMobile = global.config && global.config.layout === 'mobile';
    this.divisionName = Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_string_js__["a" /* singularize */])(this.$root.getUser.sessionSettings.CompanySettings.Labels.DivisionName);
    this.hasBu = this.$root.getUser.settings.HasBusinessUnit;
    this.hasCc = this.$root.getUser.settings.HasCostCenter;
    this.hasBuAndCcPair = this.$root.getUser.settings.UseBusinessUnitAndCostCenterMapping;
    var Id = this.$route.query.transactionid;
    this.api.forms.post(this.api.$.evedpaycard.transactions, {
      sort: 'TransactionStatus',
      dir: 'ASC',
      start: 0,
      limit: 1000,
      isLiveGrid: true,
      filter: JSON.stringify({
        'Id': Id,
        searchTerm: ''
      })
    }).then(function (r) {
      _this.transactions = r.data.Data.map(function (transaction) {
        return _objectSpread(_objectSpread({}, transaction), {}, {
          merchant: transaction.Merchant,
          amount: transaction.Amount,
          date: transaction.TransactionDate,
          status: transaction.TransactionStatus,
          reconcileStatus: transaction.ReconciliationStatus,
          id: transaction.Id
        });
      });
      _this.transaction.data = _this.transactions[0] || {};
      _this.selectedProgram = {
        Id: _this.transaction.data.ProgramId,
        Name: _this.transaction.data.ProgramName
      };
      _this.handleTransaction(_this.transaction);
      _this.transaction.data.ProgramId && _this.getCategoriesAndBuAndCc(_this.transaction.data.ProgramId);
    });
  },
  data: function data() {
    return {
      transactions: transactions,
      isSaving: false,
      // SPRT-18752 — false while a receipt/file upload is in flight (driven by the
      // ReconcileTransaction `uploadFinished` event, set via handleUploadFinished from
      // the spread-in Card-transactions methods). Gates the Done button so it can't be
      // tapped mid-upload — mirrors the desktop Save button's :primaryButtonDisabled="!uploadFinished".
      uploadFinished: true,
      isMobile: false,
      hasBu: false,
      hasCc: false,
      hasBuAndCcPair: false,
      programs: [],
      programOptions: [],
      businessUnits: [],
      costCenters: [],
      buAndCcPairs: [],
      categories: [],
      supplierIncomplete: false,
      programIncomplete: false,
      requireReceiptDescription: Boolean,
      descriptionIncomplete: false,
      receiptIncomplete: false,
      buAndCcPairIncomplete: [],
      buIncomplete: [],
      ccIncomplete: [],
      categoryIncomplete: [],
      form: [{}],
      selectedProgram: {},
      selectedSupplier: {},
      selectedCategory: [],
      selectedBu: [],
      selectedCc: [],
      selectedBuAndCcPair: [],
      itemIds: [],
      referenceId: [],
      filteredAttachments: [],
      // PRODUCTDEV-5772 — supporting documents, kept separate from filteredAttachments
      // (receipts) so they never feed IsComplete / ReceiptFiles / Reconciliation Status.
      additionalDocumentsFiles: [],
      wrongSplitTotal: false,
      noteText: '',
      selectedCardId: null,
      selectedTransactionId: null,
      hasErrors: false,
      reconcileAction: 'create',
      divisionName: '',
      transaction: {
        data: {}
      },
      waitingApprovalStatuses: ['Open - Waiting Approval', 'Exported - Waiting Approval', 'Posted - Waiting Approval'],
      approvalUsersData: [],
      transactionInEnvelopeStatuses: ['In Envelope', 'Exported', 'Posted'],
      editAuth: null
    };
  },
  computed: {
    cannotBeReconciled: function cannotBeReconciled() {
      return this.transaction.data.status === 'Declined';
    },
    transactionComplete: function transactionComplete() {
      return this.transactionInEnvelopeStatuses.includes(this.transaction.data.status) && (this.transaction.data.reconcileStatus === 'Approved' || this.transaction.data.reconcileStatus === 'Coded');
    },
    moment: function moment() {
      return global.moment;
    },
    programName: function programName() {
      var label = this.$root.getUser.settings.Labels.ProgramLabel;
      return label ? this.singularize(label) : label;
    },
    isUserAdmin: function isUserAdmin() {
      if (this.$user.$.userPermissions.includes('EvedPayCardAdministrator')) {
        return true;
      }
      return false;
    },
    // PRODUCTDEV-5574 — preserves the pre-existing receipt-upload rules. See the matching computed in
    // Card-transactions/index.vue for the rationale.
    receiptEditAllowed: function receiptEditAllowed() {
      if (this.isUserAdmin) return true;
      var t = this.transaction && this.transaction.data;
      if (!t || !t.TransactionStatus) return false;
      var inEnvelopeReadonly = ['In Envelope', 'Exported', 'Posted'].includes(t.TransactionStatus);
      if (!inEnvelopeReadonly) return t.ReconciliationStatus !== 'Approved';
      if (t.EnvelopeStatus === 'Draft') return true;
      if (t.ReconciliationStatus === 'Approved') return false;
      return this.isUserInApprovalList();
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, reconcileMethods), transactionsMethods), {}, {
    confirm: function confirm() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var origin, originPath, cardsQuery, cardId, query;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this2.isSaving || !_this2.uploadFinished)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _this2.isSaving = true;
              _this2.hasErrors = false;
              _context.prev = 4;
              _context.next = 7;
              return transactionsMethods.createReconcile.call(_this2);
            case 7:
              // PRODUCTDEV-5783 — on a successful save, claim any receipt picked from the folder
              // this session (deferred FolderSaved → Matched) so it leaves the folder only on save.
              if (!_this2.hasErrors && _this2.$refs.reconcileComp && typeof _this2.$refs.reconcileComp.claimPendingFolderReceipts === 'function') {
                _this2.$refs.reconcileComp.claimPendingFolderReceipts();
              }
              if (!_this2.hasErrors) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return");
            case 10:
              // Only announce a reconcile once the save actually succeeded — listeners
              // (cardtransactions/transactions/Card-* grids) refetch on this event, so
              // firing it before the hasErrors guard caused a needless refetch + UI churn
              // on a FAILED save.
              __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$emit('transaction-reconciled', _this2.$route.query.transactionid);
              // Prune the receipt-flow segment (submitreceipt + this details page) from the
              // back-button history BEFORE navigating — pushing the landing page on top of
              // it buried those entries, and the landing page's Back then pulled the user
              // straight back into the already-saved flow (same loop goBack had,
              // 2026-06-05). popReceiptFlowHistory also hands back the genuine origin
              // fullPath so the same-destination cases can restore it token-and-all.
              origin = _this2.popReceiptFlowHistory();
              originPath = origin ? origin.split('?')[0] : null; // Receipt-capture (FAB / folder) flow: the user started from the camera or receipt folder,
              // not from a specific card, so after a successful reconcile send them to the Cards tab
              // rather than drilling into one card's list. SubmitReceipt threads a receiptScanId
              // through the query, which marks this flow.
              if (!_this2.$route.query.receiptScanId) {
                _context.next = 24;
                break;
              }
              if (!(originPath === '/evedpay/cards')) {
                _context.next = 17;
                break;
              }
              // The origin WAS the Cards tab — reuse its recorded fullPath (token intact).
              _this2.$router.push({
                path: origin
              });
              return _context.abrupt("return");
            case 17:
              cardsQuery = Object.assign({}, _this2.$route.query);
              delete cardsQuery.transactionid;
              delete cardsQuery.receiptScanId;
              delete cardsQuery.cardid;
              delete cardsQuery.cardNumber;
              _this2.$router.push({
                path: '/evedpay/cards',
                query: cardsQuery
              });
              return _context.abrupt("return");
            case 24:
              // Normal reconcile (opened from a specific card): land on that card's transaction list so the
              // user sees the transaction grouped under "Completed". NOT $router.go(-1): that pops back into
              // /evedpay/submitreceipt and re-triggers the receipt-capture flow. Drop transactionid +
              // receiptScanId from the query so the next page reads fresh and the same scan can't
              // accidentally be re-matched.
              cardId = _this2.transaction.data && _this2.transaction.data.CardId || _this2.$route.query.cardid || _this2.selectedCardId;
              if (!(originPath === '/evedpay/cardtransactions' && (!cardId || origin.indexOf(String(cardId)) !== -1))) {
                _context.next = 28;
                break;
              }
              // Same card list the user came from — restore its recorded fullPath
              // (token + cardNumber intact) instead of pushing a thinner duplicate.
              _this2.$router.push({
                path: origin
              });
              return _context.abrupt("return");
            case 28:
              query = Object.assign({}, _this2.$route.query);
              delete query.transactionid;
              delete query.receiptScanId;
              if (cardId) query.cardid = cardId;
              _this2.$router.push({
                path: '/evedpay/cardtransactions',
                query: query
              });
            case 33:
              _context.prev = 33;
              // Module is kept-alive — reset so the next entry (or a retry after a
              // validation/save error) can save again.
              _this2.isSaving = false;
              return _context.finish(33);
            case 36:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4,, 33, 36]]);
      }))();
    },
    stopSave: function stopSave() {
      this.hasErrors = true;
    },
    // PRODUCTDEV-5772 — supporting documents emitted by ReconcileTransaction, kept
    // separate from filteredAttachments (receipts) and posted as AdditionalDocuments;
    // never part of ReceiptFiles / IsComplete / Reconciliation Status.
    updateAdditionalDocuments: function updateAdditionalDocuments(additionalDocuments) {
      this.additionalDocumentsFiles = additionalDocuments;
    },
    // Figma 538:788 chip date — "Sep 27 2023" style
    formatChipDate: function formatChipDate(value) {
      if (!value) return '';
      var m = global.moment(value);
      return m.isValid() ? m.format('MMM DD YYYY') : '';
    },
    handleTransaction: function handleTransaction(transaction) {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // Reset auth state up-front so a fetch failure or skipped fetch cannot leak the previous
              // transaction's permissions into the current one.
              _this3.editAuth = null;
              if (!(transaction && transaction.data)) {
                _context2.next = 14;
                break;
              }
              _this3.selectedCardId = transaction.data.CardId;
              _this3.selectedTransactionId = transaction.data.Id;
              if (!(transaction.data.EnvelopeId && transaction.data.EnvelopeId !== '00000000-0000-0000-0000-000000000000')) {
                _context2.next = 7;
                break;
              }
              _context2.next = 7;
              return _this3.fetchEditAuth(transaction.data.Id);
            case 7:
              if (!_this3.waitingApprovalStatuses.includes(transaction.data.EnvelopeStatus)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 10;
              return _this3.getApprovalUsers(transaction.data.EnvelopeId);
            case 10:
              _context2.next = 12;
              return _this3.handleReconcileAction(transaction);
            case 12:
              _context2.next = 15;
              break;
            case 14:
              _this3.reconcileAction = 'create';
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleReconcileAction: function handleReconcileAction(transaction) {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var isInEnvelopeByTxStatus;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              isInEnvelopeByTxStatus = _this4.transactionInEnvelopeStatuses.includes(transaction.data.TransactionStatus);
              if (transaction.data.ReconciliationStatus !== 'Open') {
                if (transaction.data.ReconciliationStatus === 'Coded') {
                  if (transaction.data.EnvelopeStatus === 'Draft') {
                    _this4.reconcileAction = 'edit';
                  } else if (!isInEnvelopeByTxStatus || _this4.canEditInEnvelopeFromReconcileModal()) {
                    _this4.reconcileAction = 'edit';
                  } else {
                    _this4.reconcileAction = 'view';
                  }
                } else if (isInEnvelopeByTxStatus && _this4.canEditInEnvelopeFromReconcileModal()) {
                  // PRODUCTDEV-5574 — Approved envelopes (e.g. Open - Approved) remain editable from the
                  // Reconcile modal for authorized roles; per spec they are not editable from the envelope page.
                  _this4.reconcileAction = 'edit';
                } else {
                  _this4.reconcileAction = 'view';
                }
              } else if (isInEnvelopeByTxStatus) {
                if (transaction.data.EnvelopeStatus === 'Draft') {
                  _this4.reconcileAction = 'edit';
                } else if (_this4.canEditInEnvelopeFromReconcileModal()) {
                  _this4.reconcileAction = 'edit';
                } else {
                  _this4.reconcileAction = 'view';
                }
              } else {
                _this4.reconcileAction = 'create';
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchEditAuth: function fetchEditAuth(transactionId) {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _this5.api.get(_this5.api.$.evedpaycard.canEditInEnvelopeTransaction, {
                params: {
                  transactionId: transactionId
                }
              });
            case 3:
              response = _context4.sent;
              _this5.editAuth = response.data || null;
              _context4.next = 12;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              console.error('There was a problem fetching transaction edit authorization:', _context4.t0);
              // Fail closed to view-only, but tell the user why so a transient can-edit
              // failure doesn't read as a silent permission downgrade.
              _this5.editAuth = null;
              _this5.$notifications.notify({
                type: 'plain',
                icon: 'exclamation-circle',
                placement: {
                  from: 'top',
                  align: 'center'
                },
                timeout: 0,
                message: 'We could not verify your edit permissions for this transaction. Please refresh and try again.',
                discard: 'Ok',
                goto: ''
              });
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }))();
    },
    getApprovalUsers: function getApprovalUsers(envelopeId) {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.api.get(_this6.api.$.evedpaycard.approvalUsersForEnvelope, {
                params: {
                  envelopeId: envelopeId
                }
              }).then(function (response) {
                _this6.approvalUsersData = response.data;
              }).catch(function (error) {
                console.error('There was a problem with the approval users request:', error);
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // PRODUCTDEV-5574 — the Reconcile modal does not grant edit access to a Declined-envelope submitter
    // who isn't also a card holder/admin/approver/global admin. That submitter-only path is the
    // envelope page's responsibility (CreateEnvelope.vue editEnvelope flow).
    canEditInEnvelopeFromReconcileModal: function canEditInEnvelopeFromReconcileModal() {
      // ASP.NET MVC's default JsonResult serializes property names as-is (PascalCase),
      // matching the convention used by other endpoints in this controller.
      if (!this.editAuth || !this.editAuth.CanEdit) return false;
      return this.editAuth.IsCardHolder || this.editAuth.IsCardAdmin || this.editAuth.IsApprover || this.editAuth.IsGlobalAdmin;
    },
    // Retained for `receiptEditAllowed`. Receipt-upload follows its OWN pre-existing rules
    // (current-approver-only when in envelope) and must NOT widen with the new edit-auth.
    isUserInApprovalList: function isUserInApprovalList() {
      var currentUserID = this.$root.getUser.$.user.UserID;
      if (Array.isArray(this.approvalUsersData)) {
        return this.approvalUsersData.some(function (user) {
          return user.Id === currentUserID && user.IsCurrentAction;
        });
      }
      return false;
    },
    goBack: function goBack() {
      // Cancel cleanup: release any in-session uploaded scans back to the user's folder
      // so they aren't lost (they were auto-linked to this transaction on upload — without
      // release-to-folder they'd stay Matched, invisible to the folder picker, and
      // unrecoverable). Mirrors Card-transactions/index.vue's closeReconcile cleanup gate.
      // confirm() handles the save path and navigates directly via $router.push, so we
      // never get here after a successful Done — only on Cancel/Back.
      if (this.$refs.reconcileComp && typeof this.$refs.reconcileComp.cleanupUnsavedReceipts === 'function') {
        this.$refs.reconcileComp.cleanupUnsavedReceipts();
      }
      // Module is kept-alive — clear supporting documents so the next entry starts clean.
      this.additionalDocumentsFiles = [];

      // Rewind PAST the whole receipt-capture detour instead of pushing a synthetic
      // per-card entry on top of it. The old push-on-top approach buried the
      // submitreceipt + transactiondetails entries underneath the landing page, so
      // the landing page's Back (= $routerHistory.previous()) pulled the user
      // straight back into the canceled flow — Cancel → card list → Back → stale
      // scan pages → Cancel → … (loop reported 2026-06-05). popReceiptFlowHistory
      // prunes that segment and returns the genuine origin fullPath (token and
      // cardNumber intact — $router.push({ path }) re-parses the query out of the
      // string via vue-router normalizeLocation).
      var target = this.popReceiptFlowHistory();
      if (target) {
        this.$router.push({
          path: target
        });
      } else {
        // No usable origin recorded (deep-link straight into details, or a desktop
        // module route underneath) — fall back to the per-card list. selectedCardId
        // backstops the SubmitReceipt-pushed URLs, which carry no cardid: without
        // it a not-yet-loaded transaction produced a query-less /cardtransactions
        // entry (seen as bare '/evedpay/cardtransactions' in the reported stack).
        var cardId = this.transaction.data && this.transaction.data.CardId || this.$route.query.cardid || this.selectedCardId;
        var query = Object.assign({}, this.$route.query);
        delete query.transactionid;
        delete query.receiptScanId;
        if (cardId) query.cardid = cardId;
        this.$router.push({
          path: '/evedpay/cardtransactions',
          query: query
        });
      }
    },
    // Strip EVERY receipt-flow entry — submitreceipt / receiptfolder /
    // transactiondetails, including the CURRENT page, which always sits on top —
    // from the vue-router-back-button stack (sessionStorage fullPaths), and return
    // the most recent genuine /evedpay/ fullPath (or null when none exists; the
    // flow entries are pruned either way so a later Back can't resurface them).
    //
    // Filtering the WHOLE stack, not just the trailing segment, matters twice over:
    // these pages are never legitimate Back targets (Cancel/Done deliberately route
    // around them), and sessions polluted by the pre-fix push-on-top behavior carry
    // flow entries BURIED under synthetic card-list pushes — a trailing-only walk
    // would leave those reachable. The plugin's own visitedRecently pop only
    // matches EXACT fullPaths within the last FOUR entries, which is why the old
    // computed pushes (thinner query — token/cardNumber lost) never collapsed the
    // stack on their own (loop reported 2026-06-05).
    popReceiptFlowHistory: function popReceiptFlowHistory() {
      var FLOW = /\/evedpay\/(submitreceipt|receiptfolder|transactiondetails)/;
      var rh = this.$routerHistory;
      if (!rh || typeof rh.get !== 'function' || typeof rh.save !== 'function') {
        return null;
      }
      var hist = rh.get() || [];
      var kept = [];
      for (var k = 0; k < hist.length; k++) {
        // Drop flow entries + adjacent exact duplicates the filtering can expose.
        if (!FLOW.test(hist[k]) && kept[kept.length - 1] !== hist[k]) {
          kept.push(hist[k]);
        }
      }
      var last = kept.length ? kept[kept.length - 1] : null;
      if (!last || last.indexOf('/evedpay/') === -1) {
        // No EvedPay origin (deep-link straight into details, or only desktop
        // module routes from the login bounce underneath) — keep what's left and
        // let the caller compute a mobile fallback destination.
        rh.save(kept);
        return null;
      }
      // Drop the target too — writeHistory re-records it when the push lands.
      kept.pop();
      rh.save(kept);
      return last;
    }
  })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "VwEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dialogs_LineItem_LineItemStore_js__ = __webpack_require__("PJql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__core_events_events__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object,
    sectionClass: String
  },
  data: function data() {
    return {
      originalCurrentInvoicedAmount: 0,
      originalCurrentVatGstAmount: 0,
      originalBudgetBalance: 0,
      originalDataIsInitialised: false,
      budgetBalanceInitialSet: false
    };
  },
  created: function created() {
    this.initialiseData();
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__core_events_events___default.a.I2P.UPDATE_SNAPSHOT);
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_2__core_events_events___default.a.I2P.UPDATE_SNAPSHOT, this.updateSnapshot);
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__core_events_events___default.a.I2P.UPDATE_P2P_Snapshot);
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_2__core_events_events___default.a.I2P.UPDATE_P2P_Snapshot, this.updateP2PSnapshot);
  },
  computed: {
    currency: function currency() {
      return this.model.POCurrencyCode || this.model.ProgramCurrencyCode;
    },
    showVATCondition: function showVATCondition() {
      return !this.model.useHighLevelAllocation && this.model.ExcludeVATFromBudget || this.model.useHighLevelAllocation && this.model.ExcludeVATFromBudget && this.model.ShowVatAllocation;
    },
    isP2PInvoice: function isP2PInvoice() {
      return this.model.InvoiceWorkflow && this.model.InvoiceWorkflow.indexOf('P2PInvoice') !== -1;
    },
    snapshotClass: function snapshotClass() {
      var hiddenClass = '';
      if (!this.model.ProgramIsSelected) {
        hiddenClass += 'hidden';
      }
      return hiddenClass;
    },
    budgetBalancePercent: function budgetBalancePercent() {
      return this.model.BudgetBalance <= 0 ? 0 : this.model.BudgetBalance * 100 / this.model.ProgramBudget;
    },
    displayNotice: function displayNotice() {
      return !this.isP2PInvoice && this.budgetBalancePercent < 20;
    },
    noticeMsg: function noticeMsg() {
      var programLabel = global.app.$user.sessionSettings.CompanySettings.ProgramLabel;
      if (this.model.BudgetBalance < 0) return programLabel + ' is over budget.';
      return this.budgetBalancePercent < 20 ? Math.ceil(this.budgetBalancePercent).toFixed(0) + '% of ' + programLabel.toLowerCase() + ' budget remains.' : '';
    }
  },
  methods: {
    store: function store() {
      return new __WEBPACK_IMPORTED_MODULE_1__dialogs_LineItem_LineItemStore_js__["a" /* default */](this.api);
    },
    updateSnapshot: function updateSnapshot(e) {
      // this.setInitialBudgetSnapshot()

      var sentCurrencyCode = e && e.data && e.data.programCurrencyCode;
      if (sentCurrencyCode) {
        this.model.ProgramCurrencyCode = sentCurrencyCode;
      }
      var programCurrency = this.model.ProgramCurrencyCode;
      if (programCurrency && this.model.InvoiceCurrencyCode) {
        if (this.mustInitOnEditMode() && e.data.isP2PWorkflow) {
          this.initP2PData();
        }
        if (this.mustInitOnEditMode()) {
          this.initDataOnEditAndUpdateSnapshot(e.data, programCurrency, this.model.InvoiceCurrencyCode, this.model.OriginalInvoiceCurrencyCode);
        } else {
          this.updateSnapshotWithCurrencyChecks(e.data, programCurrency);
        }
      }
    },
    initP2PData: function initP2PData(data) {
      this.model.initDataForEdit = false;
      this.updateOriginals(0, 0);
    },
    updateSnapshotWithCurrencyChecks: function updateSnapshotWithCurrencyChecks(data, programCurrency) {
      // if the invoice and the program have the same currency, we do not need to convert amounts
      if (programCurrency === this.model.InvoiceCurrencyCode && (!this.model.OriginalInvoiceCurrencyCode || this.model.OriginalInvoiceCurrencyCode && this.model.OriginalInvoiceCurrencyCode === this.model.InvoiceCurrencyCode)) {
        this.updateSnapshotSameCurrency(data);
      } else {
        // make currency conversion
        this.updateSnapshotDifferenctCurrency(data);
      }
    },
    updateSnapshotSameCurrency: function updateSnapshotSameCurrency(data) {
      var totalVATGST = this.model.ExcludeVATFromBudget && data.totalVATGST ? +data.totalVATGST : 0;
      var totalLessVatGst = +data.total - totalVATGST;
      this.updateSnapshotItems(totalVATGST, totalLessVatGst);
    },
    updateSnapshotDifferenctCurrency: function updateSnapshotDifferenctCurrency(data) {
      var _this = this;
      var totalVATGST = 0;
      var total = 0;
      var totalLessVatGst = 0;
      this.store().GetInvoiceTotalAmount(data.total ? +data.total : 0, data.totalVATGST ? +data.totalVATGST : 0, this.model.InvoiceCurrencyCode, this.model.ProgramCurrencyCode).then(function (response) {
        var data = JSON.parse(response.data.Data);
        totalVATGST = _this.model.ExcludeVATFromBudget && data.VatAmount ? data.VatAmount : 0;
        total = data.InvoiceAmount;
        totalLessVatGst = total - totalVATGST;
        _this.updateSnapshotItems(totalVATGST, totalLessVatGst);
      });
    },
    updateSnapshotItems: function updateSnapshotItems(totalVATGST, totalLessVatGst) {
      this.model.CurrentInvoicedAmount = +this.originalCurrentInvoicedAmount + totalLessVatGst;
      this.model.CurrentVatGstAmount = +this.originalCurrentVatGstAmount + totalVATGST;
      this.model.BudgetBalance = +this.originalBudgetBalance - totalLessVatGst; // - (this.model.ExcludeVATFromBudget ? this.model.CurrentVatGstAmount : 0)
      // in case of HighLevelAllocation workflow we need to substract also CurrentVatGstAmount because it is already included in TotalAmount
    },
    mustInitOnEditMode: function mustInitOnEditMode() {
      return this.model.initDataForEdit && this.model.initDataForEdit.toString() === 'true';
    },
    initialiseData: function initialiseData() {
      this.originalCurrentInvoicedAmount = this.model.CurrentInvoicedAmount;
      this.originalCurrentVatGstAmount = this.model.CurrentVatGstAmount;
      this.originalBudgetBalance = this.model.BudgetBalance;
    },
    initDataOnEditAndUpdateSnapshot: function initDataOnEditAndUpdateSnapshot(data, programCurrency, invoiceCurrency, originalCurrency) {
      var _this2 = this;
      this.model.initDataForEdit = false;

      // init data on Edit when we have different currencies
      if (programCurrency !== invoiceCurrency || originalCurrency && invoiceCurrency !== originalCurrency) {
        var totalAmount = 0;
        var totalVATGST = 0;
        var totalLessVatGst = 0;
        this.store().GetInvoiceTotalAmount(data.total ? +data.total : 0, data.totalVATGST ? +data.totalVATGST : 0, invoiceCurrency, programCurrency).then(function (response) {
          var responseData = JSON.parse(response.data.Data);
          totalAmount = +responseData.InvoiceAmount;
          totalVATGST = _this2.model.ExcludeVATFromBudget && +responseData.VatAmount ? +responseData.VatAmount : 0;
          totalLessVatGst = totalAmount - totalVATGST;
          _this2.updateOriginals(totalVATGST, totalLessVatGst);
          _this2.updateSnapshotWithCurrencyChecks(data, programCurrency);
        });
      } else {
        // init data on Edit when we have same currencies
        totalAmount = +data.total;
        totalVATGST = this.model.ExcludeVATFromBudget && data.totalVATGST ? +data.totalVATGST : 0;
        totalLessVatGst = totalAmount - totalVATGST;
        this.updateOriginals(totalVATGST, totalLessVatGst);
      }
    },
    updateOriginals: function updateOriginals(totalVATGST, totalLessVatGst) {
      this.originalCurrentInvoicedAmount = this.model.CurrentInvoicedAmount - totalLessVatGst;
      this.originalCurrentVatGstAmount = this.model.CurrentVatGstAmount - totalVATGST;
      this.originalBudgetBalance = this.model.BudgetBalance + totalLessVatGst;

      // this.setHighLevelBudgetBalance()
    },
    /* setInitialBudgetSnapshot() {
      if (!this.model.InvoiceCurrencyCode) {
        this.setHighLevelBudgetBalance()
        this.budgetBalanceInitialSet = true
      } else {
        if (this.budgetBalanceInitialSet) {
          this.unSetHighLevelBudgetBalance()
          this.budgetBalanceInitialSet = false
        }
      }
    },
     setHighLevelBudgetBalance() {
      if (this.vatHighLevelCondition()) {
        this.model.BudgetBalance -= this.model.CurrentVatGstAmount
      }
    },
     unSetHighLevelBudgetBalance() {
      if (this.vatHighLevelCondition()) {
        this.model.BudgetBalance += this.model.CurrentVatGstAmount
      }
    },
     vatHighLevelCondition() {
      return this.model.useHighLevelAllocation && this.showVATCondition
    },
     reduceVatFromBudgetBalance() {
      return this.model.useHighLevelAllocation && this.model.ExcludeVATFromBudget
    }, */
    updateP2PSnapshot: function updateP2PSnapshot(e) {
      this.model.POCurrencyCode = e.data.CurrencyCode;
      this.model.TotalAmount = e.data.TotalAmount;
      this.model.TotalInvoiceAmount = e.data.TotalInvoiceAmount;
      this.model.ReceivedAmount = e.data.ReceivedAmount;
      this.model.TotalUnprocessed = e.data.TotalUnprocessed;
      this.model.POBalance = e.data.Balance;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "W4pV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"card-holder-cell"},[_c('span',{staticClass:"card-holder-cell__name"},[_vm._v(_vm._s(_vm.holder))]),_vm._v(" "),(_vm.showNameOnCard)?_c('span',{staticClass:"card-holder-cell__name-on-card"},[_vm._v(_vm._s(_vm.nameOnCard))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WBso":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__ = __webpack_require__("X3jq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_receiptScan_imageCompression__ = __webpack_require__("D1Zk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_receiptScan_receiptScanPoller__ = __webpack_require__("N9pM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReceiptFolderPicker_vue__ = __webpack_require__("tGNh");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ReceiptFolderPicker: __WEBPACK_IMPORTED_MODULE_7__ReceiptFolderPicker_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showAddReceipt: false,
      uploaderFiles: [],
      attachedPath: [],
      token: this.$user.sessionSettings.Token,
      color: '#000000',
      initialAttachedFiles: [],
      submitPressed: false,
      uploadFinished: true,
      platformUploadAttempted: false,
      featureFlags: __WEBPACK_IMPORTED_MODULE_6__core_feature_flags_feature_flags__["a" /* default */],
      // PRODUCTDEV-5788 — per-division "No Receipt Capture" gate for this envelope row.
      // Default false (a fetch failure must not hide affordances on an enabled division).
      // When true: hide the folder pick + the "Scan Receipt" rescan prompt so the user
      // can't trigger Photon. The plain Submit path (saveReceiptWithoutScan) already
      // attaches without scanning, so no upload-logic change is needed.
      receiptCaptureDisabled: false,
      // PRODUCTDEV-5788 — false until this row's scan mode resolves; gates the folder button
      // so it doesn't flash in before "No Receipt Capture" is known.
      receiptScanModeLoaded: false,
      // Scan-enabled state (mirrors Card-transactions/index.vue Submit Receipt modal)
      pendingReceiptFile: null,
      // PRODUCTDEV-5804 — object URL for the pending file so the chip link carries a real href
      // (right-click "Open in new tab"). Lifecycle owned by the pendingReceiptFile watcher.
      pendingReceiptObjectUrl: '',
      // PRODUCTDEV-5805 — a receipt picked from the folder is staged (not auto-applied) just
      // like an uploaded file: holds its scan id so the "Scan to update coding" prompt shows and
      // Scan Receipt applies its prefill in the division's mode. Mirrors reconcile's deferred folder rescan.
      pendingFolderScanId: null,
      uploadingReceipt: false,
      uploadProgressPct: 0,
      // PRODUCTDEV-5802 (reopen, Case 4) — old-UI spinner over the modal body +
      // Submit disabled while a plain byte-upload window is in flight (Submit's
      // no-scan receipt save, the folder fetch/re-upload, an additional-document
      // upload). The 4s bar (uploadingReceipt) stays reserved for the Scan flow.
      receiptUploadInProgress: false,
      // Already-attached file (re-opened envelope): show the chip, allow remove.
      attachedFile: null,
      showFolderPicker: false,
      folderPickerIsProcessing: false,
      // PRODUCTDEV-5783 — additional (non-receipt) documents for this row. Display shape
      // (name/size/path/...); emitted to the parent in the Legacy TransactionFile shape.
      additionalDocuments: [],
      // PRODUCTDEV-5783 — modal staging: changes (new receipt, ✕ removal, document add/remove)
      // commit to the parent ONLY on Submit. `dirty` enables Submit; `receiptRemoved` records a
      // staged receipt deletion so Submit can emit []. Cancel reverts everything (no emit).
      dirty: false,
      receiptRemoved: false
    };
  },
  props: {
    rowData: Object,
    incomplete: false,
    attachments: Object,
    // PRODUCTDEV-5783 — already-saved additional documents for this transaction (parent-owned).
    documents: Array,
    disabled: false,
    isDraft: false
  },
  created: function created() {
    var _this = this;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var divisionId, scanSetting;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _this.uploaderFiles = _this.mapUploaderFiles(_this.attachments);
            _this.attachedFile = _this.mapAttachedFile(_this.attachments);
            _this.populateAdditionalDocuments(_this.documents);
            _this.changeIconColor();
            // PRODUCTDEV-5788 — resolve this row's division receipt-scan mode. Default false
            // on any failure so an enabled division never loses its scan affordances.
            divisionId = _this.rowData && _this.rowData.DivisionId;
            if (!(_this.featureFlags.receiptScanPrefill && divisionId != null)) {
              _context.next = 18;
              break;
            }
            _context.prev = 7;
            _context.next = 10;
            return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getScanMode(divisionId);
          case 10:
            scanSetting = _context.sent;
            _this.receiptCaptureDisabled = !!(scanSetting && scanSetting.prefillMode === 'scanning_disabled');
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](7);
            console.warn('Could not fetch receipt-scan mode (defaulting to enabled):', _context.t0);
            _this.receiptCaptureDisabled = false;
          case 18:
            _context.next = 23;
            break;
          case 20:
            _context.prev = 20;
            _context.t1 = _context["catch"](0);
            console.error('Error fetching transaction files:', _context.t1);
          case 23:
            // PRODUCTDEV-5788 — reveal the scan actions once the mode is resolved (or the load
            // settled), so the folder button never flashes before No-Capture is known.
            _this.receiptScanModeLoaded = true;
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 20], [7, 14]]);
    }))();
  },
  watch: {
    // PRODUCTDEV-5804 — own the pending file's object URL lifecycle (revoke old, create new) so the
    // chip link has a stable href. Covers every assignment site to pendingReceiptFile.
    pendingReceiptFile: function pendingReceiptFile(file) {
      if (this.pendingReceiptObjectUrl) {
        URL.revokeObjectURL(this.pendingReceiptObjectUrl);
        this.pendingReceiptObjectUrl = '';
      }
      if (file) this.pendingReceiptObjectUrl = URL.createObjectURL(file);
    },
    incomplete: function incomplete() {
      this.changeIconColor();
    },
    attachments: function attachments(newValues) {
      var _this2 = this;
      this.uploaderFiles = newValues ? newValues.map(function (file) {
        return _this2.mapFile(file);
      }) : {};
      this.attachedFile = this.mapAttachedFile(newValues);
      this.changeIconColor();
    },
    documents: function documents(newValues) {
      this.populateAdditionalDocuments(newValues);
    }
  },
  computed: {
    isUserAdmin: function isUserAdmin() {
      if (this.$user.$.userPermissions.includes('EvedPayCardAdministrator')) {
        return true;
      }
      return false;
    },
    permissionTooltip: function permissionTooltip() {
      return 'You do not have permission to change receipt attachments on this transaction.';
    },
    // PRODUCTDEV-5790 — receipt + additional-document editing is allowed whenever the row is
    // editable, OR for a card admin (or a Draft envelope) even when the row is otherwise
    // read-only (`disabled`). Restores the PRODUCTDEV-4071 admin exception that the V2 UI
    // dropped. submitFiles() persists an admin's locked-row change through update-receipt.
    canManageReceipts: function canManageReceipts() {
      return !this.disabled || this.isUserAdmin || this.isDraft;
    },
    primaryButtonDisabled: function primaryButtonDisabled() {
      if (this.featureFlags.receiptScanPrefill) {
        if (this.uploadingReceipt) return true;
        // PRODUCTDEV-5802 (reopen, Case 4) — a byte-upload is in flight; Submit
        // would race a file that isn't persisted/staged yet.
        if (this.receiptUploadInProgress) return true;
        // PRODUCTDEV-5790 — read-only rows have nothing to submit, EXCEPT a card admin (or a
        // Draft envelope) who can still replace the receipt / add-remove documents. They commit
        // via submitFiles' update-receipt branch, gated on `dirty` below like everyone else.
        if (!this.canManageReceipts) return true;
        // Submit commits ALL staged changes (new receipt, ✕ removal, document add/remove), so
        // it's enabled whenever something is staged. The folder path still commits on pick.
        return !this.dirty;
      }
      return (!this.uploadFinished || this.disabled) && !this.isUserAdmin;
    },
    chipFileName: function chipFileName() {
      if (this.pendingReceiptFile) return this.pendingReceiptFile.name;
      if (this.attachedFile) return this.attachedFile.OriginalName || this.attachedFile.MediaFile;
      return '';
    },
    chipFileSize: function chipFileSize() {
      if (this.pendingReceiptFile) return this.formatFileSize(this.pendingReceiptFile.size);
      return '';
    },
    // PRODUCTDEV-5804 — URL for the chip link's href: pending file → object URL; already-attached → durable path.
    chipFileUrl: function chipFileUrl() {
      if (this.pendingReceiptFile) return this.pendingReceiptObjectUrl;
      if (this.attachedFile) return this.attachedFile.FullPath || this.attachedFile.path || '';
      return '';
    },
    chipIconClass: function chipIconClass() {
      var name = (this.chipFileName || '').toLowerCase();
      if (/\.pdf$/.test(name)) return 'fa-file-pdf';
      if (/\.(png|jpe?g|gif|webp)$/.test(name)) return 'fa-file-image';
      return 'fa-file';
    }
  },
  methods: {
    openAddReceipt: function openAddReceipt() {
      this.showAddReceipt = true;
      this.initialAttachedFiles = this.deepCopy(this.uploaderFiles);
      this.submitPressed = false;
      this.uploadFinished = true;
      this.dirty = false;
      this.receiptRemoved = false;
      // PRODUCTDEV-5805 — start each open clean so a folder receipt staged-but-not-scanned in a
      // prior session doesn't resurface the "Scan to update coding" prompt.
      this.pendingFolderScanId = null;
    },
    // Kept for backward compatibility with the flag-off path that toggles via
    // showModal elsewhere; scan-on opens via openAddReceipt directly.
    showModal: function showModal(showAddReceipt) {
      this.showAddReceipt = !showAddReceipt;
      if (this.showAddReceipt) {
        this.initialAttachedFiles = this.deepCopy(this.uploaderFiles);
        this.submitPressed = false;
        this.uploadFinished = true;
      }
    },
    handleClose: function handleClose() {
      if (this.uploadingReceipt || this.receiptUploadInProgress) return;
      this.showAddReceipt = false;
      this.changeIconColor();
      this.goBackToInitialValue();
      this.resetScanState();
      // PRODUCTDEV-5783 — Cancel reverts staged changes: re-hydrate the receipt + documents
      // from the parent's canonical props (we never emitted, so they're still original).
      if (!this.submitPressed) {
        this.attachedFile = this.mapAttachedFile(this.attachments);
        this.populateAdditionalDocuments(this.documents);
        this.receiptRemoved = false;
        this.dirty = false;
      }
    },
    resetScanState: function resetScanState() {
      this.pendingReceiptFile = null;
      this.pendingFolderScanId = null;
      this.uploadProgressPct = 0;
      this.receiptUploadInProgress = false;
      this.showFolderPicker = false;
      this.folderPickerIsProcessing = false;
      this.cancelUploadProgressBar();
      if (this.$refs.receiptUploadInput) {
        this.$refs.receiptUploadInput.value = '';
      }
    },
    goBackToInitialValue: function goBackToInitialValue() {
      if (!this.submitPressed) {
        this.uploaderFiles = this.initialAttachedFiles;
      }
      this.changeIconColor();
    },
    changeIconColor: function changeIconColor() {
      this.incomplete = this.incomplete && (this.uploaderFiles && this.uploaderFiles.length === 0 || !this.uploaderFiles);
      this.color = this.incomplete ? '#FF0000' : this.uploaderFiles && this.uploaderFiles.length ? '#4A90E2' : '#000000';
    },
    mapUploaderFiles: function mapUploaderFiles(files) {
      var _this3 = this;
      files = files || [];
      var result = [];
      files.forEach(function (file) {
        result.push(_this3.mapFile(file));
      });
      return result;
    },
    mapAttachedFile: function mapAttachedFile(files) {
      if (!files || !files.length) return null;
      return files[0];
    },
    mapFile: function mapFile(file) {
      var parts = file.OriginalName.split('.');
      var extension = '';
      var fileType = '';
      if (parts.length > 1) {
        extension = parts[parts.length - 1].toLowerCase();
      }
      switch (extension) {
        case 'png':
          fileType = 'image/png';
          break;
        case 'pdf':
          fileType = 'application/pdf';
          break;
        case 'jpg':
          fileType = 'image/jpg';
          break;
        case 'jpeg':
          fileType = 'image/jpeg';
          break;
        default:
          fileType = '';
      }
      return {
        name: file.OriginalName,
        type: fileType,
        size: file.SizeBytes,
        file: file.MediaFile,
        mediaFile: file.MediaFile,
        path: file.FullPath,
        pathWithName: file.PathWithName,
        id: file.Id,
        success: true,
        readonly: this.disabled && !this.isUserAdmin
      };
    },
    // ===== Scan-enabled flow =====
    triggerFileInput: function triggerFileInput() {
      if (this.$refs.receiptUploadInput) {
        this.$refs.receiptUploadInput.click();
      }
    },
    handleFileSelected: function handleFileSelected(event) {
      var files = event.target.files;
      if (!files || files.length === 0) return;
      var file = files[0];
      var parts = file.name ? file.name.split('.') : [];
      var extension = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
      var ALLOWED = ['pdf', 'png', 'jpg', 'jpeg'];
      if (ALLOWED.indexOf(extension) === -1) {
        this.showWarningMessage('Please upload a file with one of these extensions: .pdf, .png, .jpg, .jpeg');
        if (this.$refs.receiptUploadInput) {
          this.$refs.receiptUploadInput.value = '';
        }
        return;
      }
      var MAX_FILE_SIZE = 10 * 1024 * 1024;
      if (file.size >= MAX_FILE_SIZE) {
        this.showWarningMessage('File is too large. Please upload a receipt smaller than 10 MB.');
        if (this.$refs.receiptUploadInput) {
          this.$refs.receiptUploadInput.value = '';
        }
        return;
      }
      this.pendingReceiptFile = file;
      this.dirty = true;
    },
    clearPendingFile: function clearPendingFile() {
      this.pendingReceiptFile = null;
      // PRODUCTDEV-5805 — also drop a staged folder receipt so the Scan-to-update prompt hides.
      this.pendingFolderScanId = null;
      if (this.$refs.receiptUploadInput) {
        this.$refs.receiptUploadInput.value = '';
      }
      // PRODUCTDEV-5783 — STAGE the removal: don't emit now (that persisted even on Cancel).
      // `receiptRemoved` makes Submit emit []; Cancel re-hydrates from the parent's props.
      if (this.attachedFile) {
        this.attachedFile = null;
        this.receiptRemoved = true;
      }
      this.dirty = true;
    },
    // ===== PRODUCTDEV-5783 — Additional Documents (mirrors the reconcile modal) =====
    // Supporting files, NOT receipts: never scanned, never enter the receipt/coding flow.
    // Plain Legacy byte-upload (no progress bar); emitted to the parent in TransactionFile shape.
    uploadNewDocument: function uploadNewDocument() {
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'application/pdf, image/png, image/jpeg';
      var self = this;
      input.onchange = /*#__PURE__*/function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2(e) {
          var file, parts, ext, fileType, localObjectUrl, doc, legacy, idx;
          return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                file = e.target.files && e.target.files[0];
                if (file) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return");
              case 3:
                parts = file.name ? file.name.split('.') : [];
                ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
                if (!(['pdf', 'png', 'jpg', 'jpeg'].indexOf(ext) === -1)) {
                  _context2.next = 8;
                  break;
                }
                self.showWarningMessage('Please upload a file with one of these extensions: .pdf, .png, .jpg, .jpeg');
                return _context2.abrupt("return");
              case 8:
                if (!(file.size >= 10 * 1024 * 1024)) {
                  _context2.next = 11;
                  break;
                }
                self.showWarningMessage('File is too large. Please upload a document smaller than 10 MB.');
                return _context2.abrupt("return");
              case 11:
                fileType = ext === 'png' ? 'image/png' : ext === 'pdf' ? 'application/pdf' : ext === 'jpg' ? 'image/jpg' : ext === 'jpeg' ? 'image/jpeg' : file.type || '';
                localObjectUrl = URL.createObjectURL(file); // Optimistic chip; NOT part of the save payload until pathWithName lands.
                doc = {
                  name: file.name,
                  type: fileType,
                  size: file.size,
                  file: '',
                  mediaFile: '',
                  path: localObjectUrl,
                  pathWithName: '',
                  id: '',
                  success: true,
                  readonly: false,
                  _blobUrl: localObjectUrl
                };
                self.additionalDocuments.push(doc);
                // PRODUCTDEV-5802 (reopen, Case 4) — old-UI spinner + Submit disabled
                // while the byte-upload is in flight, so Submit can't commit a document
                // that has no PathWithName yet (it would be silently dropped from the
                // payload by emitAdditionalDocumentsUpdated's filter).
                self.receiptUploadInProgress = true;
                _context2.prev = 16;
                _context2.next = 19;
                return self.uploadReceiptToLegacy(file);
              case 19:
                legacy = _context2.sent;
                if (legacy && legacy.pathWithName) {
                  doc.pathWithName = legacy.pathWithName;
                  doc.mediaFile = legacy.mediaFile;
                  doc.file = legacy.mediaFile;
                  doc.path = legacy.path;
                  // PRODUCTDEV-5783 — staged: commits on Submit, reverts on Cancel. (The backend now
                  // persists documents end-to-end, so Submit is all that's needed.)
                  self.dirty = true;
                } else {
                  idx = self.additionalDocuments.indexOf(doc);
                  if (idx !== -1) self.additionalDocuments.splice(idx, 1);
                  if (doc._blobUrl) URL.revokeObjectURL(doc._blobUrl);
                  self.showWarningMessage('File "' + file.name + '" could not be uploaded. Please try again.');
                }
              case 21:
                _context2.prev = 21;
                self.receiptUploadInProgress = false;
                return _context2.finish(21);
              case 24:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[16,, 21, 24]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
      input.click();
    },
    removeDocument: function removeDocument(index) {
      var doc = this.additionalDocuments[index];
      if (!doc) return;
      if (doc._blobUrl) URL.revokeObjectURL(doc._blobUrl);
      this.additionalDocuments.splice(index, 1);
      // PRODUCTDEV-5783 — staged; commits on Submit, reverts on Cancel.
      this.dirty = true;
    },
    documentIconClass: function documentIconClass(doc) {
      var name = (doc && doc.name || '').toLowerCase();
      if (/\.pdf$/.test(name)) return 'fa-file-pdf';
      if (/\.(png|jpe?g|gif|webp)$/.test(name)) return 'fa-file-image';
      return 'fa-file';
    },
    // Build the Legacy TransactionFile-shaped array (only finalized docs with a
    // pathWithName) and emit to the parent. Keeps each doc's Id so a save that
    // doesn't touch docs re-sends the existing rows and the BE keeps them.
    emitAdditionalDocumentsUpdated: function emitAdditionalDocumentsUpdated() {
      var vendorId = this.$root.getUser.$.data.VendorID;
      var vci = this.$root.getUser.$.data.VCI;
      var emitted = this.additionalDocuments.filter(function (item) {
        return item && item.pathWithName;
      }).map(function (item) {
        return {
          OriginalName: item.name,
          SizeBytes: item.size,
          MediaFile: item.mediaFile,
          AttachmentFile: item.file,
          PathWithName: item.pathWithName,
          FullPath: item.path,
          ReadOnly: item.readonly || false,
          Id: item.id,
          VendorId: vendorId,
          VCI: vci
        };
      });
      this.$emit('additional-documents-updated', emitted);
    },
    // Hydrate the document chips from already-saved docs (parent passes them in).
    populateAdditionalDocuments: function populateAdditionalDocuments(documents) {
      this.additionalDocuments = [];
      if (!Array.isArray(documents)) return;
      var self = this;
      documents.forEach(function (file) {
        var parts = (file.OriginalName || '').split('.');
        var ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
        var fileType = ext === 'png' ? 'image/png' : ext === 'pdf' ? 'application/pdf' : ext === 'jpg' ? 'image/jpg' : ext === 'jpeg' ? 'image/jpeg' : '';
        self.additionalDocuments.push({
          name: file.OriginalName,
          type: fileType,
          size: file.SizeBytes,
          file: file.MediaFile,
          mediaFile: file.MediaFile,
          path: file.FullPath,
          pathWithName: file.PathWithName,
          id: file.Id,
          success: true,
          readonly: false
        });
      });
    },
    openFolderPicker: function openFolderPicker() {
      this.showFolderPicker = true;
    },
    closeFolderPicker: function closeFolderPicker() {
      this.showFolderPicker = false;
      this.folderPickerIsProcessing = false;
    },
    // Folder path: bytes live in Platform S3 only. To keep parity with the
    // upload path's canonical PathWithName (the documented reopen-500 trap if
    // missing), fetch the bytes and re-upload to Legacy, then claim to the
    // row's known transaction. No loading bar — folder pick is already the
    // confirmation; ReceiptFolderPicker shows its own isProcessing state.
    handleFolderSelect: function handleFolderSelect(event) {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var receiptScanId, statusData, imgRes, fileName, contentType, blob, legacyMeta, legacyFile, attachment, status;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              receiptScanId = event && event.receiptScanId;
              if (!(!receiptScanId || _this4.folderPickerIsProcessing || _this4.receiptUploadInProgress)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _this4.folderPickerIsProcessing = true;
              // PRODUCTDEV-5802 (reopen, Case 4) — close the picker right away and show
              // the old-UI spinner over the Submit Receipt modal for the whole
              // fetch/re-upload window, with Submit disabled (receiptUploadInProgress
              // feeds primaryButtonDisabled). Previously the only feedback was the
              // picker's disabled ADD button.
              _this4.closeFolderPicker();
              _this4.receiptUploadInProgress = true;
              _context3.prev = 6;
              _context3.next = 9;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getStatus(receiptScanId);
            case 9:
              statusData = _context3.sent;
              if (!(!statusData || statusData.status !== 'FolderSaved')) {
                _context3.next = 14;
                break;
              }
              _this4.showWarningMessage('Receipt is no longer in the folder — pick another.');
              _this4.receiptUploadInProgress = false;
              return _context3.abrupt("return");
            case 14:
              imgRes = null;
              _context3.prev = 15;
              _context3.next = 18;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getImage(receiptScanId);
            case 18:
              imgRes = _context3.sent;
              _context3.next = 24;
              break;
            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](15);
              console.warn('Could not fetch folder receipt image:', _context3.t0);
            case 24:
              fileName = imgRes && imgRes.fileName || 'Receipt';
              contentType = imgRes && imgRes.contentType || ''; // Pull the bytes through the Platform proxy (/image-bytes) rather than a raw
              // browser fetch of the S3 presigned URL — the proxy is same-origin via the BFF
              // so it isn't subject to the S3 CORS wall that would otherwise leave blob null
              // and hard-refuse the attach.
              blob = null;
              _context3.prev = 27;
              _context3.next = 30;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getImageBytes(receiptScanId);
            case 30:
              blob = _context3.sent;
              if (blob) contentType = blob.type || contentType;
              _context3.next = 37;
              break;
            case 34:
              _context3.prev = 34;
              _context3.t1 = _context3["catch"](27);
              console.warn('Could not fetch folder receipt bytes:', _context3.t1);
            case 37:
              legacyMeta = null;
              if (!blob) {
                _context3.next = 43;
                break;
              }
              legacyFile = new File([blob], fileName, {
                type: blob.type || contentType || 'application/octet-stream'
              });
              _context3.next = 42;
              return _this4.uploadReceiptToLegacy(legacyFile);
            case 42:
              legacyMeta = _context3.sent;
            case 43:
              if (legacyMeta) {
                _context3.next = 47;
                break;
              }
              // Without a Legacy PathWithName we'd reproduce the documented reopen-500.
              // Refuse the attach instead of attaching with an empty path.
              _this4.showWarningMessage('Could not attach receipt — please try again.');
              _this4.receiptUploadInProgress = false;
              return _context3.abrupt("return");
            case 47:
              // PRODUCTDEV-5783 — do NOT claim here. The folder receipt stays FolderSaved (in the
              // folder) until the envelope is SAVED; CreateEnvelope.claimPendingFolderReceipts() runs
              // the deferred FolderSaved -> Matched claim on save success, so cancelling the envelope
              // never strands the scan (mirrors the reconcile flow's deferred claim).
              attachment = _this4.buildAttachment({
                name: fileName,
                type: contentType,
                size: blob ? blob.size : 0,
                mediaFile: legacyMeta.mediaFile,
                pathWithName: legacyMeta.pathWithName,
                path: legacyMeta.path,
                receiptScanId: receiptScanId
              });
              _this4.submitPressed = true;
              _this4.$emit('attachmentsUpdated', [attachment]);
              _this4.$emit('receiptScanId', receiptScanId);
              // PRODUCTDEV-5805 — parity with the upload + reconcile flow: do NOT auto-apply the scan
              // here. Auto-apply both bypassed the division's scan mode (the folder receipt always came
              // back subtotal_and_tax) and skipped the "Scan to update coding" prompt. Stage the folder
              // scan and keep the modal open so that prompt shows; Scan Receipt then applies the prefill
              // in the division's configured mode (see rescanReceipt + fetchPrefill).
              // PRODUCTDEV-5805 FIX — a prior ✕ (clearPendingFile) stages receiptRemoved=true so Submit
              // emits []. Picking a folder receipt SUPERSEDES that removal, so clear the flag. Without
              // this, the folder path (which never sets pendingReceiptFile, so it falls through to the
              // receiptRemoved branch in handleConfirm instead of returning early like the upload path)
              // wipes the just-added receipt on Submit.
              _this4.receiptRemoved = false;
              _this4.pendingFolderScanId = receiptScanId;
              _this4.dirty = true;
              _this4.receiptUploadInProgress = false;
              _this4.$notifications.notify({
                type: 'success',
                message: 'Receipt added from folder',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _this4.changeIconColor();
              _context3.next = 64;
              break;
            case 59:
              _context3.prev = 59;
              _context3.t2 = _context3["catch"](6);
              // PRODUCTDEV-5802 (reopen) — the picker is already closed (closed on ADD),
              // so every error path just lifts the spinner and warns; re-opening the
              // folder is one click away.
              _this4.receiptUploadInProgress = false;
              status = _context3.t2 && _context3.t2.response && _context3.t2.response.status;
              if (status === 409) {
                _this4.showWarningMessage('Receipt state changed — pick another.');
              } else if (status === 403) {
                _this4.showWarningMessage('You no longer have access to this receipt.');
              } else {
                console.error('Folder receipt claim failed:', _context3.t2);
                _this4.showWarningMessage('Failed to add receipt. Please try again.');
              }
            case 64:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[6, 59], [15, 21], [27, 34]]);
      }))();
    },
    // Upload path: Legacy-first byte upload + Platform submit with the row's tx
    // as upload context (auto-link → no ranker) + prefill, all behind the 4s
    // pacing bar from the Card-transactions Submit Receipt modal.
    handleConfirm: function handleConfirm() {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this5.featureFlags.receiptScanPrefill) {
                _context4.next = 20;
                break;
              }
              if (!(_this5.uploadingReceipt || _this5.receiptUploadInProgress)) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              _this5.submitPressed = true;
              // PRODUCTDEV-5805 — Submit resolves the staged folder receipt (the user chose NOT to
              // scan it), so drop the flag that drives the "Scan to update coding" prompt.
              _this5.pendingFolderScanId = null;
              // PRODUCTDEV-5783 — commit staged additional-document changes on every Submit.
              _this5.emitAdditionalDocumentsUpdated();
              if (!_this5.pendingReceiptFile) {
                _context4.next = 10;
                break;
              }
              _context4.next = 9;
              return _this5.saveReceiptWithoutScan();
            case 9:
              return _context4.abrupt("return");
            case 10:
              if (!(_this5.rowData.EnvelopeId && !_this5.isDraft && !_this5.pendingReceiptFile && !_this5.attachedFile)) {
                _context4.next = 13;
                break;
              }
              _this5.$notifications.notify({
                type: 'info-warn',
                message: 'Receipt is required. Please upload at least one file.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              return _context4.abrupt("return");
            case 13:
              // Commit a staged receipt removal (if any), then close.
              if (_this5.receiptRemoved) {
                _this5.$emit('attachmentsUpdated', []);
              }
              // PRODUCTDEV-5826 — no new receipt staged, but an admin may have changed additional
              // documents on a locked envelope. The parent can't save a read-only envelope, so persist
              // here via update-receipt, re-sending the existing receipt so it isn't soft-deleted.
              if (!(_this5.disabled && _this5.isUserAdmin)) {
                _context4.next = 17;
                break;
              }
              _context4.next = 17;
              return _this5.persistLockedAdminUpdate(_this5.attachedFile ? [_this5.attachedFile] : []);
            case 17:
              _this5.showAddReceipt = false;
              _this5.changeIconColor();
              return _context4.abrupt("return");
            case 20:
              // Flag-off legacy path — preserve the original timing: the prior
              // `@confirm` listener auto-closed the modal on click and submitFiles
              // ran "after". Now under `validation` mode the modal won't auto-close,
              // so close FIRST, then run submitFiles so the user sees the same
              // instant-close UX as before.
              _this5.changeIconColor();
              if (!(_this5.rowData.EnvelopeId && (!_this5.newFiles || _this5.newFiles.length === 0) && !_this5.isDraft)) {
                _context4.next = 25;
                break;
              }
              _this5.$notifications.notify({
                type: 'info-warn',
                message: 'Receipt is required. Please upload at least one file.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _this5.showAddReceipt = false;
              return _context4.abrupt("return");
            case 25:
              _this5.showAddReceipt = false;
              _context4.next = 28;
              return _this5.submitFiles();
            case 28:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    submitUploadFlow: function submitUploadFlow() {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
        var file, compressed, self, barDuration, barStart, barComplete, legacyPromise, formData, idempotencyKey, legacyTxId, platformPromise, scanResolvedEarly, legacyMeta, attachment;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              file = _this6.pendingReceiptFile;
              compressed = file;
              _context5.prev = 2;
              _context5.next = 5;
              return Object(__WEBPACK_IMPORTED_MODULE_4__core_receiptScan_imageCompression__["a" /* default */])(file);
            case 5:
              compressed = _context5.sent;
              _context5.next = 11;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](2);
              console.warn('Image compression failed, falling back to original file:', _context5.t0);
            case 11:
              _this6.uploadingReceipt = true;
              _this6.uploadProgressPct = 0;
              self = _this6; // 4s pacing bar — same shape as Card-transactions/index.vue + reconcile.
              // The bar covers the perceived wait; the heavy Photon /api/v4 work
              // (~15s) continues in the background and applies prefill to the row
              // after the modal closes.
              barDuration = 4000;
              barStart = performance.now();
              barComplete = new Promise(function (resolve) {
                var _tick = function tick(now) {
                  var pct = Math.min(100, Math.round((now - barStart) / barDuration * 100));
                  self.uploadProgressPct = pct;
                  if (pct < 100) {
                    self._uploadProgressRaf = requestAnimationFrame(_tick);
                  } else {
                    self._uploadProgressRaf = null;
                    resolve();
                  }
                };
                self._uploadProgressRaf = requestAnimationFrame(_tick);
              });
              legacyPromise = _this6.uploadReceiptToLegacy(compressed);
              formData = new FormData();
              formData.append('file', compressed);
              idempotencyKey = _this6.generateIdempotencyKey(); // Auto-link the Platform receipt to the row's known transaction —
              // skips the ranker/CandidateSelector entirely (per Option D).
              legacyTxId = _this6.rowData && _this6.rowData.Id;
              platformPromise = __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].submitReceipt(formData, idempotencyKey, {
                uploadContextLegacyTransactionId: legacyTxId,
                uploadSurface: 'envelope'
              }).catch(function (err) {
                console.warn('Platform receipt submit failed (legacy still attached):', err);
                return null;
              }); // PRODUCTDEV-5783 — track whether Photon resolves during the bar so we can skip the
              // "scanning" toast + the coding-row skeleton when the data is already in hand at bar end.
              scanResolvedEarly = false;
              platformPromise.then(function () {
                scanResolvedEarly = true;
              });
              _context5.prev = 25;
              _context5.next = 28;
              return barComplete;
            case 28:
              _context5.next = 30;
              return legacyPromise;
            case 30:
              legacyMeta = _context5.sent;
              if (legacyMeta) {
                _context5.next = 36;
                break;
              }
              _this6.showWarningMessage('Receipt upload failed. Please try again.');
              _this6.uploadingReceipt = false;
              _this6.uploadProgressPct = 0;
              return _context5.abrupt("return");
            case 36:
              // Build + emit the attachment now so the row's chip lands at 4s. The
              // ReceiptScanId is patched in when the Platform promise resolves
              // (below), and a follow-up emit pushes the updated attachment.
              attachment = _this6.buildAttachment({
                name: _this6.pendingReceiptFile.name,
                type: _this6.pendingReceiptFile.type,
                size: _this6.pendingReceiptFile.size,
                mediaFile: legacyMeta.mediaFile,
                pathWithName: legacyMeta.pathWithName,
                path: legacyMeta.path,
                receiptScanId: null
              });
              _this6.submitPressed = true;
              _this6.$emit('attachmentsUpdated', [attachment]);

              // Close modal at bar end — matches the Submit Receipt UX. Prefill
              // applies to the row in background when Photon finishes.
              _this6.uploadingReceipt = false;
              _this6.uploadProgressPct = 0;
              _this6.pendingReceiptFile = null;
              _this6.showAddReceipt = false;
              _this6.changeIconColor();

              // PRODUCTDEV-5783 — if Photon already finished during the bar, the prefill is in hand:
              // no "scanning" toast, no skeleton. Otherwise tell the parent to show the coding-row
              // skeleton + a scanning toast until the prefill lands (cleared by scan-ended / receiptScan).
              if (!scanResolvedEarly) {
                _this6.$emit('scan-started');
                _this6.notifyReceipt('info', 'Scanning receipt');
              }

              // Fire prefill application in background. Caught here so an
              // unhandled rejection can't propagate after the modal closed.
              _this6.applyPrefillInBackground(platformPromise, attachment).catch(function (err) {
                console.warn('Background prefill failed:', err);
              });
              _context5.next = 55;
              break;
            case 48:
              _context5.prev = 48;
              _context5.t1 = _context5["catch"](25);
              console.error('Receipt upload flow failed:', _context5.t1);
              _this6.uploadingReceipt = false;
              _this6.uploadProgressPct = 0;
              _this6.cancelUploadProgressBar();
              _this6.showWarningMessage('Receipt upload failed. Please try again.');
            case 55:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[2, 8], [25, 48]]);
      }))();
    },
    // PRODUCTDEV-5783 — Submit path for envelopes: save the staged receipt to Legacy and
    // attach it WITHOUT scanning (coding always exists, so we never auto-run Photon). The user
    // opts into Photon via Rescan. No prefill, no receiptScan emit — coding is left untouched.
    saveReceiptWithoutScan: function saveReceiptWithoutScan() {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
        var file, self, compressed, legacyMeta, attachment;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              file = _this7.pendingReceiptFile;
              if (file) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return");
            case 3:
              // PRODUCTDEV-5802 (reopen, Case 4) — no scan, no progress bar, but the modal
              // now stays OPEN with the old-UI spinner and Submit disabled until the
              // Legacy upload actually lands. Closing immediately (the previous behavior)
              // made the upload invisible — it looked like nothing was happening, and a
              // failure surfaced after the modal was already gone.
              self = _this7;
              _this7.receiptUploadInProgress = true;
              compressed = file;
              _context6.prev = 6;
              _context6.next = 9;
              return Object(__WEBPACK_IMPORTED_MODULE_4__core_receiptScan_imageCompression__["a" /* default */])(file);
            case 9:
              compressed = _context6.sent;
              _context6.next = 15;
              break;
            case 12:
              _context6.prev = 12;
              _context6.t0 = _context6["catch"](6);
              console.warn('Image compression failed, falling back to original file:', _context6.t0);
            case 15:
              _context6.prev = 15;
              _context6.next = 18;
              return _this7.uploadReceiptToLegacy(compressed);
            case 18:
              legacyMeta = _context6.sent;
              if (legacyMeta) {
                _context6.next = 24;
                break;
              }
              self.receiptUploadInProgress = false;
              // handleConfirm pre-set submitPressed; the modal stays open for a retry,
              // so reset it or a later Cancel skips its staged-state revert.
              self.submitPressed = false;
              self.showWarningMessage('Receipt upload failed. Please try again.');
              return _context6.abrupt("return");
            case 24:
              attachment = self.buildAttachment({
                name: file.name,
                type: file.type,
                size: file.size,
                mediaFile: legacyMeta.mediaFile,
                pathWithName: legacyMeta.pathWithName,
                path: legacyMeta.path,
                receiptScanId: null
              });
              self.submitPressed = true;
              self.pendingReceiptFile = null;
              self.$emit('attachmentsUpdated', [attachment]);
              // PRODUCTDEV-5826 — on a locked envelope the parent can't save (read-only), so an admin's
              // new receipt plus any document changes are persisted here via update-receipt. Runs
              // under the PRODUCTDEV-5802 spinner: the modal stays open and Submit disabled until
              // the persist also lands, then closes.
              if (!(self.disabled && self.isUserAdmin)) {
                _context6.next = 31;
                break;
              }
              _context6.next = 31;
              return self.persistLockedAdminUpdate([attachment]);
            case 31:
              self.receiptUploadInProgress = false;
              self.showAddReceipt = false;
              self.changeIconColor();
              _context6.next = 42;
              break;
            case 36:
              _context6.prev = 36;
              _context6.t1 = _context6["catch"](15);
              console.error('Receipt save failed:', _context6.t1);
              // Keep the modal open with the staged file intact so the user can retry.
              // submitPressed was pre-set by handleConfirm; reset it so a later Cancel
              // still reverts staged state.
              self.receiptUploadInProgress = false;
              self.submitPressed = false;
              self.showWarningMessage('Receipt upload failed. Please try again.');
            case 42:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[6, 12], [15, 36]]);
      }))();
    },
    // PRODUCTDEV-5783 — opt-in scan: the user chose to update the coding from the staged
    // receipt. Runs the same Legacy-upload + Photon /api/v4 + prefill flow the receipt used to
    // run automatically on Submit (submitUploadFlow emits attachmentsUpdated + receiptScan).
    rescanReceipt: function rescanReceipt() {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee7() {
        var folderScanId, legacyTxId, divisionId, prefillData;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!_this8.pendingFolderScanId) {
                _context7.next = 14;
                break;
              }
              folderScanId = _this8.pendingFolderScanId;
              _this8.pendingFolderScanId = null;
              legacyTxId = _this8.rowData && _this8.rowData.Id;
              divisionId = _this8.rowData && _this8.rowData.DivisionId;
              _this8.$emit('scan-started');
              _context7.next = 8;
              return _this8.fetchPrefill(folderScanId, divisionId);
            case 8:
              prefillData = _context7.sent;
              if (prefillData) {
                _this8.$emit('receiptScan', {
                  receiptScanId: folderScanId,
                  prefill: prefillData,
                  legacyTransactionId: legacyTxId
                });
              } else {
                _this8.notifyReceipt('info-warn', "Receipt attached, but its details couldn't be read automatically. Please enter the amount split and description manually.");
              }
              _this8.$emit('scan-ended');
              _this8.showAddReceipt = false;
              _this8.changeIconColor();
              return _context7.abrupt("return");
            case 14:
              if (_this8.pendingReceiptFile) {
                _context7.next = 16;
                break;
              }
              return _context7.abrupt("return");
            case 16:
              _this8.submitUploadFlow();
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    // Background continuation after the modal closes: wait for Platform's
    // submitReceipt (sync Photon /api/v4 ~15s), then emit receiptScanId +
    // prefill so CreateEnvelope populates the row's split form + description.
    applyPrefillInBackground: function applyPrefillInBackground(platformPromise, attachment) {
      var _this9 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee8() {
        var legacyTxId, platformData, receiptScanId, prefillData;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              legacyTxId = _this9.rowData && _this9.rowData.Id;
              _context8.next = 3;
              return platformPromise;
            case 3:
              platformData = _context8.sent;
              if (!(!platformData || !platformData.receiptScanId)) {
                _context8.next = 8;
                break;
              }
              // Legacy upload succeeded (the chip is on the row), but Platform/Photon
              // didn't return a scan to code from. Say so instead of failing silently.
              _this9.notifyReceipt('info-warn', "Receipt attached, but its details couldn't be read automatically. Please enter the amount split and description manually.");
              _this9.$emit('scan-ended');
              return _context8.abrupt("return");
            case 8:
              receiptScanId = platformData.receiptScanId; // Patch ReceiptScanId into the chip's attachment so save serializes it.
              attachment.ReceiptScanId = receiptScanId;
              _this9.$emit('attachmentsUpdated', [attachment]);
              _this9.$emit('receiptScanId', receiptScanId);

              // Mirror reconcile's pattern: try the inline /prefill first (Photon is
              // often already done by the time we reach here since submitReceipt is
              // sync). If 409/404/sentinel, fall back to the poller.
              _context8.next = 14;
              return _this9.fetchPrefillWithFallback(receiptScanId);
            case 14:
              prefillData = _context8.sent;
              if (prefillData) {
                _this9.$emit('receiptScan', {
                  receiptScanId: receiptScanId,
                  prefill: prefillData,
                  legacyTransactionId: legacyTxId
                });
              } else {
                // Scan finished but no prefill came back — don't leave the row looking
                // like nothing happened.
                _this9.notifyReceipt('info-warn', "Receipt attached, but its details couldn't be read automatically. Please enter the amount split and description manually.");
              }
              // PRODUCTDEV-5783 — scan finished: clear the coding-row skeleton (the prefill above
              // already populated the rows if it came back).
              _this9.$emit('scan-ended');
            case 17:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    fetchPrefillWithFallback: function fetchPrefillWithFallback(receiptScanId) {
      var _this10 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee9() {
        var prefillData, status, notReady;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getPrefill(receiptScanId);
            case 3:
              prefillData = _context9.sent;
              if (!prefillData) {
                _context9.next = 6;
                break;
              }
              return _context9.abrupt("return", prefillData);
            case 6:
              _context9.next = 15;
              break;
            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](0);
              status = _context9.t0 && _context9.t0.response && _context9.t0.response.status;
              notReady = status === 409 || status === 404 || _context9.t0 && _context9.t0.isPlatformSentinelError;
              if (notReady) {
                _context9.next = 15;
                break;
              }
              console.warn('Prefill fetch failed:', _context9.t0);
              return _context9.abrupt("return", null);
            case 15:
              _context9.next = 17;
              return _this10.waitForPrefill(receiptScanId);
            case 17:
              return _context9.abrupt("return", _context9.sent);
            case 18:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[0, 8]]);
      }))();
    },
    // Poll Photon until terminal state, then fetch prefill once.
    waitForPrefill: function waitForPrefill(receiptScanId) {
      var self = this;
      return new Promise(function (resolve) {
        var poller = Object(__WEBPACK_IMPORTED_MODULE_5__core_receiptScan_receiptScanPoller__["a" /* default */])({
          receiptScanId: receiptScanId,
          contextHint: {
            source: 'AddReceipt'
          },
          onDone: function onDone() {
            self.fetchPrefill(receiptScanId).then(resolve).catch(function () {
              resolve(null);
            });
          },
          onError: function onError(err) {
            console.warn('Receipt scan poller error:', err);
            resolve(null);
          }
        });
        poller.start();
      });
    },
    fetchPrefill: function fetchPrefill(receiptScanId, targetDivisionId) {
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee10() {
        var prefillData, status;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getPrefill(receiptScanId, targetDivisionId);
            case 3:
              prefillData = _context10.sent;
              return _context10.abrupt("return", prefillData || null);
            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10["catch"](0);
              status = _context10.t0 && _context10.t0.response && _context10.t0.response.status;
              if (status !== 409 && status !== 404 && !(_context10.t0 && _context10.t0.isPlatformSentinelError)) {
                console.warn('Prefill fetch failed:', _context10.t0);
              }
              return _context10.abrupt("return", null);
            case 12:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[0, 7]]);
      }))();
    },
    uploadReceiptToLegacy: function uploadReceiptToLegacy(file) {
      var _this11 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee11() {
        var legacyUrl, legacyFormData, resp, body, match, pathWithName, mediaFile;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              legacyUrl = _this11.api && _this11.api.env ? _this11.api.env + _this11.api.$.evedpaycard.receipt : null;
              if (legacyUrl) {
                _context11.next = 3;
                break;
              }
              return _context11.abrupt("return", null);
            case 3:
              legacyFormData = new FormData();
              legacyFormData.append('attachment_upload', file);
              _context11.prev = 5;
              _context11.next = 8;
              return _this11.api.post(legacyUrl, legacyFormData, {
                headers: {
                  'Authorization': 'Bearer ' + _this11.token,
                  'Content-Type': 'multipart/form-data'
                }
              });
            case 8:
              resp = _context11.sent;
              body = resp && resp.data;
              if (typeof body === 'string') {
                try {
                  body = JSON.parse(body);
                } catch (e) {
                  body = null;
                }
              }
              if (!(!body || !body.success || !body.path)) {
                _context11.next = 13;
                break;
              }
              return _context11.abrupt("return", null);
            case 13:
              match = body.path.match(/(ClientData\/.*)/);
              pathWithName = match && match[1] ? match[1] : body.path;
              mediaFile = body.file || pathWithName.split('/').pop();
              return _context11.abrupt("return", {
                path: body.path,
                pathWithName: pathWithName,
                mediaFile: mediaFile
              });
            case 19:
              _context11.prev = 19;
              _context11.t0 = _context11["catch"](5);
              console.warn('Legacy receipt upload failed:', _context11.t0);
              return _context11.abrupt("return", null);
            case 23:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[5, 19]]);
      }))();
    },
    buildAttachment: function buildAttachment(input) {
      var vendorId = this.$root.getUser.$.data.VendorID;
      var vci = this.$root.getUser.$.data.VCI;
      return {
        OriginalName: input.name || 'Receipt',
        SizeBytes: input.size || 0,
        MediaFile: input.mediaFile || '',
        AttachmentFile: input.mediaFile || '',
        Id: '',
        PathWithName: input.pathWithName || '',
        ReadOnly: false,
        VendorId: vendorId,
        FullPath: input.path || '',
        VCI: vci,
        ReceiptScanId: input.receiptScanId || null
      };
    },
    generateIdempotencyKey: function generateIdempotencyKey() {
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
      }
      // RFC4122 v4 fallback for older browsers (Platform requires Guid.TryParse)
      var template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
      return template.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    cancelUploadProgressBar: function cancelUploadProgressBar() {
      if (this._uploadProgressRaf) {
        cancelAnimationFrame(this._uploadProgressRaf);
        this._uploadProgressRaf = null;
      }
    },
    formatFileSize: function formatFileSize(bytes) {
      if (!bytes) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    },
    // ===== Flag-off legacy flow (unchanged) =====
    createAttachments: function createAttachments(e) {
      var _this12 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee13() {
        var completedFiles, uploadedFiles;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              e.forEach(function (x) {
                var parts = x.name.split('.');
                var extension = '';
                if (parts.length > 1) {
                  extension = parts[parts.length - 1];
                }
                if (!['pdf', 'png', 'jpg', 'jpeg'].includes(extension.toLowerCase())) {
                  _this12.uploaderFiles = _this12.uploaderFiles.filter(function (x) {
                    return x.success;
                  });
                  _this12.showWarningMessage("The file \"".concat(x.name, "\" is not compatible. Please upload files with one of the following extensions: .pdf, .png, .jpg, .jpeg"));
                  return;
                }
                var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
                if (x.size >= MAX_FILE_SIZE) {
                  _this12.uploaderFiles = _this12.uploaderFiles.filter(function (x) {
                    return x.size <= MAX_FILE_SIZE;
                  });
                  _this12.showWarningMessage("The file \"".concat(x.name, "\" is too large. Please upload files smaller than 10 MB."));
                  return;
                }
              });
              completedFiles = e.filter(function (item) {
                return item.success ||
                // files uploaded with success
                !item.success && item.response && typeof item.response === 'string' && !_this12.isJson(item.response);
              } // files where requested failed
              );
              if (completedFiles.length === e.length) {
                _this12.uploadFinished = true;
                uploadedFiles = e.map(/*#__PURE__*/function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee12(item) {
                    var uploadError, itemResponse, clientDataPath, mediaFile, receiptScanId, regex, match, filePath, splits, vendorId, VCI;
                    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                      while (1) switch (_context12.prev = _context12.next) {
                        case 0:
                          uploadError = '';
                          itemResponse = null;
                          clientDataPath = '';
                          mediaFile = '';
                          receiptScanId = null;
                          if (!(item.success && item.response)) {
                            _context12.next = 30;
                            break;
                          }
                          itemResponse = JSON.parse(item.response);
                          if (!itemResponse.success) {
                            _context12.next = 29;
                            break;
                          }
                          regex = /(ClientData\/.*)/;
                          match = itemResponse.path.match(regex);
                          if (!(match && match.length > 1)) {
                            _context12.next = 28;
                            break;
                          }
                          filePath = match[1];
                          clientDataPath = filePath.substring(filePath.indexOf('ClientData'));
                          _this12.attachedPath.push(clientDataPath);
                          splits = clientDataPath.split('/');
                          mediaFile = splits[splits.length - 1];

                          // Platform upload: single file only
                          if (!(item.file && item.file instanceof Blob)) {
                            _context12.next = 26;
                            break;
                          }
                          _context12.prev = 17;
                          _context12.next = 20;
                          return _this12.tryPlatformUpload(item.file);
                        case 20:
                          receiptScanId = _context12.sent;
                          if (receiptScanId) {
                            _this12.$emit('receiptScanId', receiptScanId);
                          }
                          _context12.next = 26;
                          break;
                        case 24:
                          _context12.prev = 24;
                          _context12.t0 = _context12["catch"](17);
                        case 26:
                          _context12.next = 29;
                          break;
                        case 28:
                          console.log('No matching files.');
                        case 29:
                          uploadError = itemResponse && itemResponse.uploadError ? itemResponse.uploadError : '';
                        case 30:
                          if (!item.success) {
                            uploadError = 'Upload request failed';
                          }
                          vendorId = _this12.$root.getUser.$.data.VendorID;
                          VCI = _this12.$root.getUser.$.data.VCI;
                          if (!uploadError) {
                            _context12.next = 37;
                            break;
                          }
                          _this12.showWarningMessage('File "' + item.name + '": ' + uploadError);
                          _context12.next = 38;
                          break;
                        case 37:
                          return _context12.abrupt("return", {
                            OriginalName: item.name,
                            SizeBytes: item.size,
                            MediaFile: item.mediaFile ? item.mediaFile : mediaFile || '',
                            AttachmentFile: itemResponse ? itemResponse.file : item.file || '',
                            Id: item.id ? item.id : '',
                            PathWithName: item.pathWithName ? item.pathWithName : itemResponse ? clientDataPath : '',
                            ReadOnly: item.readonly || false,
                            VendorId: vendorId,
                            FullPath: item.path ? item.path : itemResponse.path ? itemResponse.path : '',
                            VCI: VCI,
                            ReceiptScanId: receiptScanId
                          });
                        case 38:
                        case "end":
                          return _context12.stop();
                      }
                    }, _callee12, null, [[17, 24]]);
                  }));
                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                _this12.mediaFilesPath = _this12.attachedPath.join(', ');
                _this12.$emit('mediaFilesPathUpdated', _this12.mediaFilesPath);
                _this12.attachedPath = [];
                try {
                  _this12.uploaderFiles = _this12.uploaderFiles.filter(function (item) {
                    return item.success && (!item.response && item.name ||
                    // take existing items from edit
                    JSON.parse(item.response).success // take new added items
                    );
                  }).map(function (item) {
                    if (item.response) {
                      var response = JSON.parse(item.response);
                      if (response.path) {
                        item.path = response.path; // assign the 'path' property from the response to the item
                      }
                    }
                    return item;
                  });
                } catch (ee) {
                  console.error(ee);
                }

                // Resolve all uploadedFiles promises
                Promise.all(uploadedFiles).then(function (resolvedFiles) {
                  _this12.newFiles = resolvedFiles.filter(function (item) {
                    return item;
                  });
                  _this12.$forceUpdate();
                }).catch(function (err) {
                  console.error('Error processing uploaded files:', err);
                });
              } else {
                _this12.uploadFinished = false;
              }
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    deepCopy: function deepCopy(obj) {
      var _this13 = this;
      if (obj === null || __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(obj) !== 'object') {
        return obj;
      }
      if (Array.isArray(obj)) {
        return obj.map(function (element) {
          return _this13.deepCopy(element);
        });
      }
      var newObj = {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          newObj[key] = this.deepCopy(obj[key]);
        }
      }
      return newObj;
    },
    submitFiles: function submitFiles() {
      var _this14 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee14() {
        var vendorId, payload;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this14.submitPressed = true;
              _this14.$emit('attachmentsUpdated', _this14.newFiles);
              if (!(_this14.disabled && _this14.isUserAdmin)) {
                _context14.next = 14;
                break;
              }
              // PRODUCTDEV-5790 — also carry additional documents so an admin can add/remove them
              // (not just the receipt) on a locked envelope row. The BE keeps docs by Id and
              // soft-deletes any finalized doc not in the list; this.additionalDocuments was
              // hydrated from the saved set on open, so an untouched doc set round-trips unchanged.
              vendorId = _this14.$root.getUser.$.data.VendorID;
              payload = {
                transactionId: _this14.rowData.Id,
                receiptFiles: _this14.newFiles.map(function (f) {
                  return {
                    id: f.Id || '00000000-0000-0000-0000-000000000000',
                    pathWithName: f.PathWithName,
                    originalName: f.OriginalName,
                    mediaFile: f.MediaFile,
                    sizeBytes: f.SizeBytes,
                    vendorId: f.VendorId
                  };
                }),
                additionalDocuments: _this14.additionalDocuments.filter(function (d) {
                  return d && d.pathWithName;
                }).map(function (d) {
                  return {
                    id: d.id || '00000000-0000-0000-0000-000000000000',
                    pathWithName: d.pathWithName,
                    originalName: d.name,
                    mediaFile: d.mediaFile,
                    sizeBytes: d.size,
                    vendorId: d.vendorId || vendorId
                  };
                })
              };
              _context14.prev = 5;
              _context14.next = 8;
              return _this14.api.post(_this14.api.$.evedpaycard.updateReceipt, payload);
            case 8:
              _this14.$notifications.notify({
                type: 'info',
                message: 'Receipt updated successfully',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _context14.next = 14;
              break;
            case 11:
              _context14.prev = 11;
              _context14.t0 = _context14["catch"](5);
              console.error('Error while updating the receipt:', _context14.t0);
            case 14:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[5, 11]]);
      }))();
    },
    // PRODUCTDEV-5826 — persist a receipt/document change made from the ENVELOPE PAGE on a
    // locked (submitted / approved / waiting-approval) envelope. The scan-on Submit path only
    // emits to the parent, but CreateEnvelope can't run its full envelope save while the envelope
    // is read-only, so an admin's change was silently lost (the update-receipt request was never
    // made). Mirror the reconcile modal: POST the narrow update-receipt endpoint directly (coding
    // untouched). Gated on `disabled && isUserAdmin` so Draft / editable envelopes still persist
    // through the normal envelope save (no double-write). Sends the FULL desired receipt +
    // document sets — the BE keeps files by Id and soft-deletes any not in the list, so an
    // untouched set round-trips unchanged. Mirrors submitFiles' flag-off payload.
    persistLockedAdminUpdate: function persistLockedAdminUpdate(receiptFiles) {
      var _this15 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee15() {
        var vendorId, payload;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              vendorId = _this15.$root.getUser.$.data.VendorID;
              payload = {
                transactionId: _this15.rowData.Id,
                receiptFiles: (receiptFiles || []).map(function (f) {
                  return {
                    id: f.Id || '00000000-0000-0000-0000-000000000000',
                    pathWithName: f.PathWithName,
                    originalName: f.OriginalName,
                    mediaFile: f.MediaFile,
                    sizeBytes: f.SizeBytes,
                    vendorId: f.VendorId
                  };
                }),
                additionalDocuments: _this15.additionalDocuments.filter(function (d) {
                  return d && d.pathWithName;
                }).map(function (d) {
                  return {
                    id: d.id || '00000000-0000-0000-0000-000000000000',
                    pathWithName: d.pathWithName,
                    originalName: d.name,
                    mediaFile: d.mediaFile,
                    sizeBytes: d.size,
                    vendorId: d.vendorId || vendorId
                  };
                })
              };
              _context15.prev = 2;
              _context15.next = 5;
              return _this15.api.post(_this15.api.$.evedpaycard.updateReceipt, payload);
            case 5:
              _this15.$notifications.notify({
                type: 'info',
                message: 'Receipt updated successfully',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _context15.next = 11;
              break;
            case 8:
              _context15.prev = 8;
              _context15.t0 = _context15["catch"](2);
              console.error('Error while updating the receipt:', _context15.t0);
            case 11:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[2, 8]]);
      }))();
    },
    isJson: function isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    showWarningMessage: function showWarningMessage(message) {
      var _this16 = this;
      this.$nextTick(function () {
        _this16.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: {
            from: 'top',
            align: 'center'
          },
          timeout: 0,
          message: message,
          discard: 'Ok',
          goto: ''
        });
      });
    },
    // Auto-dismissing toast for receipt-scan progress/outcome (distinct from
    // showWarningMessage, which is a sticky, dismiss-required validation warning).
    notifyReceipt: function notifyReceipt(type, message) {
      this.$notifications.notify({
        type: type,
        message: message,
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    },
    tryPlatformUpload: function tryPlatformUpload(file) {
      var _this17 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee16() {
        var compressed, formData, idempotencyKey, data;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (_this17.featureFlags.receiptScanPrefill) {
                _context16.next = 2;
                break;
              }
              return _context16.abrupt("return", null);
            case 2:
              _context16.prev = 2;
              _context16.next = 5;
              return Object(__WEBPACK_IMPORTED_MODULE_4__core_receiptScan_imageCompression__["a" /* default */])(file);
            case 5:
              compressed = _context16.sent;
              formData = new FormData();
              formData.append('file', compressed);
              idempotencyKey = _this17.generateIdempotencyKey();
              _context16.next = 11;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].submitReceipt(formData, idempotencyKey);
            case 11:
              data = _context16.sent;
              if (!(data && data.receiptScanId)) {
                _context16.next = 15;
                break;
              }
              _this17.platformUploadAttempted = true;
              return _context16.abrupt("return", data.receiptScanId);
            case 15:
              return _context16.abrupt("return", null);
            case 18:
              _context16.prev = 18;
              _context16.t0 = _context16["catch"](2);
              if (!_context16.t0.isPlatformSentinelError) {
                _context16.next = 23;
                break;
              }
              console.warn('Platform receipt upload failed (legacy fallback triggered):', _context16.t0);
              return _context16.abrupt("return", null);
            case 23:
              console.error('Platform receipt upload failed (not a fallback scenario):', _context16.t0);
              _this17.showWarningMessage('File upload to Platform failed. Please try again.');
              throw _context16.t0;
            case 26:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[2, 18]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cancelUploadProgressBar();
    if (this.pendingReceiptObjectUrl) URL.revokeObjectURL(this.pendingReceiptObjectUrl);
  }
});

/***/ }),

/***/ "WFO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("QZqH");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WIwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.editMode)?_c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WNJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mfa_setup_vue__ = __webpack_require__("waef");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5bbc12_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mfa_setup_vue__ = __webpack_require__("QsJX");
function injectStyle (ssrContext) {
  __webpack_require__("tztp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e5bbc12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mfa_setup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5bbc12_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mfa_setup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WQcv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WRyJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1T24GL7pExBbSshrFkh_c_","Dell":"_2sM6ITKvDQETmW5zzbL1xy","Abbott":"_1f7MbW2FRlyw1PhtVSijLZ","Gap":"_2ujolSlkdNHLoA548uRPHO","Allstate":"_2nvvp2jHGlL-6k1fBY8GJP","Asurion":"_2cxJ7xFywTYek4fUotx0Xv","Invitae":"_2z87uOrruI7CTb5SbBd_Pc","JWE":"_2jwvZwqUXIcLuL8Va6P2ce"};

/***/ }),

/***/ "WVzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddLineItem_vue__ = __webpack_require__("XLnX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6da8664_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddLineItem_vue__ = __webpack_require__("pCVi");
function injectStyle (ssrContext) {
  __webpack_require__("cXlN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a6da8664"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddLineItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6da8664_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddLineItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WXkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  Id: {
    label: '_'
  },
  Type: {
    label: 'Type',
    width: 100
  },
  CertificateName: {
    label: 'Certificate Name',
    width: 250
  },
  CreatedDate: {
    label: 'Uploaded Date',
    width: 100
  },
  Actions: {
    label: ' ',
    width: 100,
    sortable: false
  }
});

/***/ }),

/***/ "WYLj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZNc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"grid",attrs:{"name":_vm.$t("Payments"),"desc":"Manage Invoices & Payments","search":"","search-placeholder":"Invoices","views":false,"sort":{ DueDateWithin: "desc", DueDateWithinFormatted: "desc" },"endpoint":_vm.api.$.invoice.list.$,"screen":_vm.api.$.invoice.list.sent,"alias":"PaymentInvoiceList_SentInvoices","legacy":"","tabs":_vm.tabs,"row-classes":_vm.rowClasses,"fit-columns":"","footer":"","xadditional-filters":"additionalFilters","filter":_vm.defaultFilter,"can-remove-default-filter":""},on:{"selectedRows":_vm.rowSelected}},[_c('span',{attrs:{"slot":"overview"},slot:"overview"},[_c('data-skybox')],1),_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[_c('cancel-invoice',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.cancelInvoiceDisabledReason),expression:"cancelInvoiceDisabledReason"}],attrs:{"ids":_vm.selectedRows,"disabled":_vm.cancelInvoiceDisabled},on:{"success":_vm.refresh}})],1),_c('span',{attrs:{"slot":"selectionButtons"},slot:"selectionButtons"},[_c('edit-invoice-for-supplier',{attrs:{"rows":_vm.selectedRows,"fromPage":"sent"}})],1),_c('span',{attrs:{"slot":"additionalLabel"},slot:"additionalLabel"},[_c('div',{staticClass:"form-group no-margin"},[_c('i',{staticClass:"fas fa-exclamation"}),_c('span',[_vm._v(" ")]),_c('label',[_vm._v("Click column headers to apply filters")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WcDs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"xQUTKIuYTjxpACyABjHDt","Dell":"_1xsDrqPMNOl5VfLd7cyIlm","Abbott":"_1lUGIQUgylYWAZHiCdOAj8","Gap":"_2aa0R62cqCXYa8K2IyIp8q","Allstate":"_2PeNB8JbeaEbK8LEwpD8HG","Asurion":"_3dObLFgp2--ALYdSOPyaCU","Invitae":"_2a7IdBBQFhe5ngb5caRdds","JWE":"_1mVTID3hqZou2cxBDyQv16"};

/***/ }),

/***/ "Wd+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ovkd");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_387407f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("9fEx");
function injectStyle (ssrContext) {
  __webpack_require__("5uK1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-387407f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_387407f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WdZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);

//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    containerId: String,
    newDashboard: {
      type: Boolean,
      default: true
    },
    action: {
      type: String,
      default: 'Create Dashboard'
    }
  },
  data: function data() {
    return {
      showModal: false,
      hideGroups: true,
      widgets: null
    };
  },
  mounted: function mounted() {
    this.showModules();
  },
  created: function created() {
    this.getModules();
  },
  methods: {
    getModules: function getModules() {
      var _this = this;
      this.api.get(this.api.$.dashboard.templates).then(function (r) {
        if (r && r.data && r.data.length) {
          _this.widgets = _this.mix(r.data);
          _this.save();
        }
      });
    },
    showModules: function showModules() {
      this.showModal = true;
    },
    create: function create(dashboard) {
      if (dashboard.disabled) {
        return false;
      }
      if (dashboard.custom) {
        this.showModal = true;
        return true;
      }
    },
    save: function save() {
      var _this2 = this;
      var payload = {
        containerType: 0,
        containerSectionId: this.containerId,
        containerSectionLabel: 'Dashboard',
        widgetTypes: this.getSelectedModules(this.widgets)
      };
      this.api.put(this.api.$.dashboard.create, payload).then(function (r) {
        var id = r && r.data && r.data.id || null;
        _this2.$parent.getDashboard(id || _this2.containerId);
      });
    },
    getSelectedModules: function getSelectedModules(modules) {
      return modules.filter(function (module) {
        return module.id;
      }).map(function (module) {
        return module.id;
      });
    },
    mix: function mix(widgetGroups) {
      var flatList = [];
      widgetGroups.forEach(function (group) {
        flatList.push({
          group: group.name
        });
        flatList.push.apply(flatList, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(group.widgets));
      });
      return flatList;
    }
  }
});

/***/ }),

/***/ "WhMl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dawn-page-section",class:{ "wide row no-flex": _vm.wide, "no-title": !_vm.title, "full-width": _vm.fullWidth },attrs:{"endpoint":_vm.$parent.$attrs.endpoint}},[_c('input',{staticClass:"dummy"}),_c('div',{staticClass:"title-area",class:{ "col-md-4": _vm.wide && _vm.title && !_vm.fullWidth }},[_c('h1',{staticClass:"page-title",class:{ "no-title": !_vm.title }},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"page-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),(_vm.$slots.description)?_c('div',{staticClass:"description"},[_vm._t("description")],2):_vm._e()]),_c('div',{staticClass:"page-section-main",class:[_vm.offset, _vm.wide ? _vm.title ? _vm.fullWidth || "col-md-8" : "col-md-12" : ""]},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WvIm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("BMDR");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5887ee6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("b026");
function injectStyle (ssrContext) {
  __webpack_require__("tUBp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5887ee6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5887ee6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Wwqk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row content"},[_c('div',{staticClass:"summary well small col-md-12",class:_vm.snapshotClass},[(!_vm.isP2PInvoice)?_c('table',{staticClass:"col-md-12 mb-5"},[_c('thead',[_c('tr',[_c('td',[_vm._v("Approved Budget")]),_vm._v(" "),_c('td',[_vm._v("Invoiced")]),_vm._v(" "),(_vm.showVATCondition)?_c('td',[_vm._v("VAT/GST")]):_vm._e(),_vm._v(" "),(_vm.model.ShowExpenses)?_c('td',[_vm._v("Expenses")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v("Remaining Budget")])])]),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',[_vm._v("Approved Budget")]),_vm._v(" "),_c('td',[_vm._v("Invoiced")]),_vm._v(" "),(_vm.showVATCondition)?_c('td',[_vm._v("VAT/GST")]):_vm._e(),_vm._v(" "),(_vm.model.ShowExpenses)?_c('td',[_vm._v("Expenses")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v("Remaining Budget")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('v-money',{attrs:{"name":"program_budget"}},[_vm._v(_vm._s(_vm.model.ProgramBudget))])],1),_vm._v(" "),_c('td',[_c('v-money',{attrs:{"name":"current_invoiced_amount"}},[_vm._v(_vm._s(_vm.model.CurrentInvoicedAmount))])],1),_vm._v(" "),(_vm.showVATCondition)?_c('td',[_c('v-money',{attrs:{"name":"vat_allocation"}},[_vm._v(_vm._s(_vm.model.CurrentVatGstAmount + (_vm.model.IncludeExpenseInBudget ? _vm.model.TotalVatGstOnExpense : 0)))])],1):_vm._e(),_vm._v(" "),(_vm.model.ShowExpenses)?_c('td',[_c('v-money',{attrs:{"name":"expense_amount"}},[_vm._v(_vm._s(_vm.model.ExpenseAmount))])],1):_vm._e(),_vm._v(" "),_c('td',[_c('v-money',{attrs:{"name":"budget_balance"}},[_vm._v(_vm._s(_vm.model.BudgetBalance))])],1)])])]):_c('table',{staticClass:"col-md-12 mb-5"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('v-money',{attrs:{"name":"po_total_amount"}},[_vm._v(_vm._s(_vm.model.TotalAmount))])],1),_vm._v(" "),_c('td',[_c('v-money',{attrs:{"name":"po_total_invoice_amount"}},[_vm._v(_vm._s(_vm.model.TotalInvoiceAmount))])],1),_vm._v(" "),_c('td',[_c('v-money',{attrs:{"name":"po_received_amount"}},[_vm._v(_vm._s(_vm.model.ReceivedAmount))])],1),_vm._v(" "),_c('td',[_c('v-money',{attrs:{"currency":_vm.currency,"name":"po_total_unprocessed"}},[_vm._v(_vm._s(_vm.model.TotalUnprocessed))])],1),_vm._v(" "),_c('td',[_c('v-money',{attrs:{"currency":_vm.currency,"name":"po_balance"}},[_vm._v(_vm._s(_vm.model.POBalance))])],1)])])]),_vm._v(" "),(_vm.displayNotice)?_c('ed-notice',{staticClass:"program-spend-widget__notice",attrs:{"type":'warn',"icon":"fas fa-exclamation-triangle"}},[_vm._v("\n      "+_vm._s(_vm.noticeMsg)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clear"})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td',[_vm._v("Total PO")]),_vm._v(" "),_c('td',[_vm._v("Total Invoiced amount")]),_vm._v(" "),_c('td',[_vm._v("Received Payments")]),_vm._v(" "),_c('td',[_vm._v("Scheduled Payments")]),_vm._v(" "),_c('td',[_vm._v("PO Outstanding Balance")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',[_c('td',[_vm._v("Total PO")]),_vm._v(" "),_c('td',[_vm._v("Total Invoiced amount")]),_vm._v(" "),_c('td',[_vm._v("Received Payments")]),_vm._v(" "),_c('td',[_vm._v("Scheduled Payments")]),_vm._v(" "),_c('td',[_vm._v("PO Outstanding Balance")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X1gQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1gYMzVak8qe-_WbynN_n8G","Dell":"_25klbFbmQcqwv_c7y2ATpj","Abbott":"_3vgvFYHf9B0WSjlqpggZYY","Gap":"_2ewRk9l9-vSeeIqMoaGBs7","Allstate":"_1bErL8mrZDR3KJdeUjVOGE","Asurion":"_2xEXl18xGbYJLTzUAawMvj","Invitae":"_2LrT8V1oa22X-8XDpUAk9E","JWE":"P566iygKlTxOu_31DF-na"};

/***/ }),

/***/ "X3Rw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__envelopeTerm__ = __webpack_require__("i/Pq");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rejectReason: '',
      showReject: false,
      isRejecting: false
    };
  },
  created: function created() {},
  props: {
    ids: null,
    disabled: false,
    tooltip: '',
    selectedRows: [],
    envelope: Object
  },
  computed: {
    // PRODUCTDEV-8800: the envelope's division term (the first selected row's, from the list).
    envelopeTerm: function envelopeTerm() {
      var row = this.selectedRows && this.selectedRows.length ? this.selectedRows[0].data : this.envelope;
      return Object(__WEBPACK_IMPORTED_MODULE_2__envelopeTerm__["a" /* envelopeTermFor */])(row);
    }
  },
  methods: {
    approveOrReject: function approveOrReject() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var envelopesData, payload, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.isRejecting) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _this.isRejecting = true;
              _context.prev = 3;
              envelopesData = [];
              if (_this.selectedRows) {
                envelopesData = _this.selectedRows.map(function (row) {
                  return {
                    Id: row.data.Id,
                    RejectReason: _this.rejectReason
                  };
                });
              } else if (_this.envelope) {
                envelopesData.push({
                  Id: _this.envelope.Id,
                  RejectReason: _this.rejectReason
                });
              }
              if (!(envelopesData.length === 0)) {
                _context.next = 8;
                break;
              }
              throw new Error('No data available to approve or reject.');
            case 8:
              payload = {
                envelopesData: envelopesData
              };
              _context.next = 11;
              return _this.api.post(_this.api.$.evedpaycard.approveOrRejectEnvelope, payload);
            case 11:
              response = _context.sent;
              if (response.data) {
                _context.next = 16;
                break;
              }
              throw new Error('Error during the request');
            case 16:
              _this.showReject = false;
              _this.rejectReason = '';
              _this.$emit('success');
            case 19:
              _context.next = 24;
              break;
            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](3);
              console.error(_context.t0);
            case 24:
              _context.prev = 24;
              _this.isRejecting = false;
              return _context.finish(24);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 21, 24, 27]]);
      }))();
    },
    closeModal: function closeModal() {
      if (this.isRejecting) return;
      this.showReject = false;
      this.rejectReason = '';
    },
    showModal: function showModal(showReject) {
      this.showReject = !showReject;
    }
  }
});

/***/ }),

/***/ "X3jq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NO_RECEIPT_CAPTURE_MODE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpPlatform__ = __webpack_require__("03tc");

var pollInstance = __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].create({
  timeout: __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].POLL_TIMEOUT_MS
});

// Per-division scan mode that disables receipt capture (PRODUCTDEV-5475/5788). Set from the
// division-settings "No Receipt Capture" admin radio (Legacy) and persisted to
// platform.ReceiptScanSetting as the canonical value 'scanning_disabled'. The mobile FAB
// (mobile.vue) and the Reconcile capture UI react by hiding scan affordances and uploading
// receipts without sending them to Photon. Any division whose prefillMode equals this is "no capture".
var NO_RECEIPT_CAPTURE_MODE = 'scanning_disabled';
var receiptScansApi = {
  // PRODUCTDEV-5805 — targetDivisionId is the DivisionId of the transaction being reconciled.
  // A folder-picked receipt isn't matched yet, so the BE can't resolve the target division's
  // scan-detail mode without it and would default to subtotal_and_tax. Optional + backward
  // compatible: omit it (e.g. inline-prefill-during-scan) and the BE keeps its existing behavior.
  getPrefill: function getPrefill(receiptScanId, targetDivisionId) {
    return pollInstance.post("/api/v1/receipts/".concat(receiptScanId, "/prefill"), targetDivisionId != null ? {
      targetDivisionId: targetDivisionId
    } : {});
  },
  getStatus: function getStatus(receiptScanId, config) {
    return pollInstance.get("/api/v1/receipts/".concat(receiptScanId), config);
  },
  getImage: function getImage(receiptScanId) {
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].get("/api/v1/receipts/".concat(receiptScanId, "/image"));
  },
  // Streams the raw image bytes through Platform (bypasses S3 CORS). Used by the
  // folder-pick flow to get a Blob for both the local preview and the Legacy
  // re-upload. Returns a Blob directly; size + type are read off the Blob.
  // Wrap in try/catch — 410 Gone means the image was disposed; other errors
  // (401/403/404) fall through the standard axios error handler.
  getImageBytes: function getImageBytes(receiptScanId) {
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].get("/api/v1/receipts/".concat(receiptScanId, "/image-bytes"), {
      responseType: 'blob'
    });
  },
  // Per-division receipt scan mode. Cardholder-readable (server-side ownership check:
  // the division must belong to the caller's client); a missing row resolves to the
  // default mode (capture enabled). Resolves to { legacyAccountId, prefillMode, ... }.
  // Used by mobile to decide whether receipt capture is disabled for a division.
  getReceiptScanSetting: function getReceiptScanSetting(divisionId) {
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].get("/api/v1/receipt-scan-settings/".concat(divisionId));
  },
  submitReceipt: function submitReceipt(formData, idempotencyKey, extra) {
    if (extra) {
      if (extra.uploadContextLegacyTransactionId != null) {
        formData.append('uploadContextLegacyTransactionId', extra.uploadContextLegacyTransactionId);
      }
      if (extra.uploadContextLegacyCardId != null) {
        formData.append('uploadContextLegacyCardId', extra.uploadContextLegacyCardId);
      }
      // DivisionId of the approval channel the user uploaded from (customer-facing
      // naming varies; in code it's a Division). BE narrows the ranker pool to
      // Programs in this Division. Omit when no channel context (mobile, folder).
      if (extra.uploadContextLegacyDivisionId != null) {
        formData.append('uploadContextLegacyDivisionId', extra.uploadContextLegacyDivisionId);
      }
      if (extra.uploadSurface != null) {
        formData.append('uploadSurface', extra.uploadSurface);
      }
    }
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].post('/api/v1/receipts', formData, {
      headers: idempotencyKey ? {
        'Idempotency-Key': idempotencyKey
      } : {}
    });
  },
  cancelScan: function cancelScan(receiptScanId) {
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].post("/api/v1/receipts/".concat(receiptScanId, "/cancel"));
  },
  matchToTransaction: function matchToTransaction(receiptScanId, legacyTransactionId, rowVersion) {
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].post("/api/v1/receipts/".concat(receiptScanId, "/match"), {
      selectedLegacyTransactionId: legacyTransactionId,
      rowVersion: rowVersion || ''
    });
  },
  searchReceipts: function searchReceipts() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
    var body = {
      page: page,
      pageSize: pageSize
    };
    if (filters.status != null) body.status = filters.status;
    if (filters.fromDate != null) body.fromDate = filters.fromDate;
    if (filters.toDate != null) body.toDate = filters.toDate;
    if (filters.uploadContextLegacyTransactionId != null) {
      body.uploadContextLegacyTransactionId = filters.uploadContextLegacyTransactionId;
    }
    // orderBy: 'UploadedAt' | 'TransactionDate' | 'MatchScore' (mapped to SearchReceiptsQuery.OrderBy server-side).
    // sortDirection: 'asc' | 'desc' (default 'desc').
    if (filters.orderBy != null) body.orderBy = filters.orderBy;
    if (filters.sortDirection != null) body.sortDirection = filters.sortDirection;
    // Match-ranking inputs (mobile folder picker). When matchAgainstLegacyTransactionId is set the
    // backend auto-ranks the result set by match score against that transaction; the explicit
    // matchTxn* fields let a caller pass amount/date/merchant directly when there's no txn id.
    if (filters.matchTxnAmount != null) body.matchTxnAmount = filters.matchTxnAmount;
    if (filters.matchTxnDate != null) body.matchTxnDate = filters.matchTxnDate;
    if (filters.matchTxnMerchant != null) body.matchTxnMerchant = filters.matchTxnMerchant;
    if (filters.matchAgainstLegacyTransactionId != null) {
      body.matchAgainstLegacyTransactionId = filters.matchAgainstLegacyTransactionId;
    }
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].post('/api/v1/receipts/search', body);
  },
  saveToFolder: function saveToFolder(receiptScanId, rowVersion) {
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].post("/api/v1/receipts/".concat(receiptScanId, "/save-to-folder"), {
      rowVersion: rowVersion || ''
    });
  },
  claimReceipt: function claimReceipt(receiptScanId, selectedTxId, rowVersion) {
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].post("/api/v1/receipts/".concat(receiptScanId, "/claim"), {
      selectedLegacyTransactionId: selectedTxId,
      rowVersion: rowVersion || ''
    });
  },
  deleteReceipt: function deleteReceipt(receiptScanId) {
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].delete("/api/v1/receipts/".concat(receiptScanId));
  },
  // PRODUCTDEV-5788 — per-division receipt-scan mode. Public, tenant-authorized GET
  // on the int-constrained route. Returns the GetReceiptScanSettingDto incl.
  // `prefillMode` (one of: subtotal_and_tax / total_only / line_items_and_tax /
  // scanning_disabled). A no-row division returns the Platform default.
  getScanMode: function getScanMode(legacyAccountId) {
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].get("/api/v1/receipt-scan-settings/".concat(legacyAccountId));
  },
  // PRODUCTDEV-5788 — tenant-wide "is any division scan-enabled?" check used by the
  // global all-transactions Submit Receipt button (no single division in context).
  // Returns { anyEnabled: true | false }; true iff >=1 in-scope division is not
  // scanning_disabled.
  getAnyScanEnabled: function getAnyScanEnabled() {
    return __WEBPACK_IMPORTED_MODULE_0__httpPlatform__["a" /* default */].get('/api/v1/receipt-scan-settings/any-enabled');
  }
};
/* harmony default export */ __webpack_exports__["b"] = (receiptScansApi);

/***/ }),

/***/ "X6A2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentSnapshot',
  props: {
    model: Object
  },
  computed: {
    paymentsNoLabel: function paymentsNoLabel() {
      return 'Payment' + (this.model.count !== 1 ? 's' : '');
    }
  }
});

/***/ }),

/***/ "X8qE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navless-layout-header"},[_vm._t("navbar",function(){return [_c('ed-button',{attrs:{"to":_vm.$routerHistory.previous().path}},[_c('i',{staticClass:"fal fa-chevron-left"}),_vm._v("\n         \n        Back\n      ")])]})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content",attrs:{"endpoint":_vm.api.$.evedpaycard.cardWithDetails}},[(_vm.card)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-preview-container"},[_c('div',{staticClass:"card-preview"},[_c('img',{attrs:{"src":"https://d1a4bxjw35af21.cloudfront.net/images_en/eved-pay-logo.svg","alt":"EvedPay Logo"}}),_vm._v(" "),_c('div',{staticClass:"card-number-row"},[_c('p',{staticClass:"card-number"},[_vm._v("\n            "+_vm._s(_vm.revealed ? _vm.formattedCardNumber : '•••• •••• •••• ' + _vm.card.cardNumber)+"\n            "),(_vm.revealed)?_c('span',{staticClass:"copy-icon-card",attrs:{"title":"Copy card number"},on:{"click":_vm.copyCardNumber}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"x":"9","y":"9","width":"13","height":"13","rx":"2","ry":"2"}}),_c('path',{attrs:{"d":"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"}})])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-details-row"},[_c('div',{staticClass:"card-field"},[_vm._m(2),_vm._v(" "),_c('p',{staticClass:"card-value"},[_vm._v(_vm._s(_vm.formattedExpirationDate))])]),_vm._v(" "),_c('div',{staticClass:"card-field"},[_vm._m(3),_vm._v(" "),_c('p',{staticClass:"card-value"},[_vm._v(_vm._s(_vm.revealed ? _vm.cardDetails.CVV : '•••'))])])])])]),_vm._v(" "),(_vm.state === 'INITIAL')?_c('div',{staticClass:"otp-section"},[_c('p',{staticClass:"otp-message"},[_vm._v("\n        "+_vm._s(_vm.otpInstructionMessage)+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn-show-card",attrs:{"disabled":_vm.sending},on:{"click":_vm.sendOtp}},[_vm._v("\n        "+_vm._s(_vm.sending ? 'Sending...' : 'Show Card Number')+"\n      ")])]):_vm._e(),_vm._v(" "),(_vm.state === 'ENTER_CODE')?_c('div',{staticClass:"otp-section"},[_c('div',{staticClass:"passcode-section"},[_c('p',{staticClass:"passcode-label"},[_vm._v("Passcode")]),_vm._v(" "),_c('p',{staticClass:"passcode-hint"},[_vm._v(_vm._s(_vm.otpPasscodeHint))]),_vm._v(" "),(_vm.otpErrorMessage)?_c('p',{staticClass:"otp-error-message"},[_vm._v(_vm._s(_vm.otpErrorMessage))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"otp-boxes"},_vm._l((6),function(digit,index){return _c('input',{key:index,ref:'otpInput' + index,refInFor:true,staticClass:"otp-box",attrs:{"type":"text","inputmode":"numeric","pattern":"[0-9]*","maxlength":"1","disabled":_vm.verifying || _vm.codeExhausted},domProps:{"value":_vm.digits[index]},on:{"input":function($event){return _vm.onDigitInput(index, $event)},"keydown":function($event){return _vm.onDigitKeydown(index, $event)},"paste":function($event){return _vm.onPaste($event)}}})}),0),_vm._v(" "),(!_vm.hideResend && _vm.canResend)?_c('p',{staticClass:"resend-link",on:{"click":_vm.resendOtp}},[_vm._v("\n          Didn't receive it? "),_c('a',{attrs:{"href":"#"}},[_vm._v("Resend Code")])]):(!_vm.hideResend)?_c('p',{staticClass:"resend-cooldown"},[_vm._v("\n          Resend available in "+_vm._s(_vm.resendCountdown)+"s\n        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-detail-fields"},[_c('div',{staticClass:"detail-field"},[_c('div',{staticClass:"detail-label"},[_vm._v("Account Address")]),_vm._v(" "),(_vm.revealed && _vm.cardAddress)?_c('div',{staticClass:"detail-value"},[_vm._v("\n          "+_vm._s(_vm.cardAddress.Address1)),_c('br'),_vm._v("\n          "+_vm._s(_vm.cardAddress.City)+", "+_vm._s(_vm.cardAddress.State && _vm.cardAddress.State.Code)+" "+_vm._s(_vm.cardAddress.Zip)+"\n        ")]):_c('div',{staticClass:"detail-value"},[_c('span',{staticClass:"skeleton"})])]),_vm._v(" "),_c('div',{staticClass:"detail-field"},[_c('div',{staticClass:"detail-label"},[_vm._v("Name on Card")]),_vm._v(" "),_c('div',{staticClass:"detail-value"},[_vm._v(_vm._s(_vm.displayNameOnCard))])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"color":"white","margin":"0px","height":"27px"}},[_vm._v("t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"page-title"},[_vm._v("Card Number")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"card-label"},[_c('small',[_vm._v("VALID THRU")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"card-label"},[_c('small',[_vm._v("CVV")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XC3F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_columns_vue__ = __webpack_require__("KuSP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a44926ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_columns_vue__ = __webpack_require__("5GFb");
function injectStyle (ssrContext) {
  __webpack_require__("hRXq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_columns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a44926ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_columns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XEt1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetSettingsMenu_vue__ = __webpack_require__("4QeU");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c8521c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetSettingsMenu_vue__ = __webpack_require__("oCQn");
function injectStyle (ssrContext) {
  __webpack_require__("vuCG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23c8521c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetSettingsMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c8521c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetSettingsMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XLnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_taxLine__ = __webpack_require__("rHCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddFeeTaxes_vue__ = __webpack_require__("V1ie");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LineItemStore_js__ = __webpack_require__("PJql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_components_Form_customFields_vue__ = __webpack_require__("eFeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__("lQbo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */







var api = new __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */]();

var eventHub = new __WEBPACK_IMPORTED_MODULE_6_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddLineItem' /* mandatory field */,

  components: {
    TaxLine: __WEBPACK_IMPORTED_MODULE_0__components_taxLine__["a" /* default */],
    customFields: __WEBPACK_IMPORTED_MODULE_3__core_components_Form_customFields_vue__["default"]
  },
  props: {
    model: Object,
    eventHub: Object,
    dependencies: Object,
    eventId: String
  },
  created: function created() {
    var _this = this;
    eventHub.$on('onCloseAddFeeTaxes', this.onCloseAddFeeTaxes);
    eventHub.$on('onAddedFeeTaxes', this.onAddedFeeTaxes);
    this.showVatGstPercentConfirmation = false;
    this.showVatGstPercentConfirmationWasAccepted = false;
    this.isEdit = false;
    if (this.model.draftItem) {
      this.formData.draftItem = this.model.draftItem;
      this.title = 'Edit Line Item';
      this.isEdit = true;
      this.prefferedRateChanged = true;
      this.negotiatedRateChanged = true;
      this.unitPriceWasChanged = true;
    } else {
      this.formData.draftItem = this.getNewLineItem();
    }
    if (this.model.useSavingsFields) {
      this.computePoTotalEndpoint = api.SavingsPurchaseOrderComputeTotals();
      this.computeItemTotalEndpoint = api.SavingsComputeLineItemTotals().replace('{ENV}', '');
    }
    var dialog = this;
    this.store().getLineItemLists(this.model.programId, this.model.invoiceId, this.isEdit).then(function (response) {
      dialog.bindCostCenterAndBusinessUnit(response.data, _this.isEdit);
      dialog.categories = response.data.categories;
      dialog.formData.draftItem.selectedCategory = dialog.categories.filter(function (category) {
        return category.text === dialog.formData.draftItem.category;
      })[0];
      dialog.model.units = response.data.itemUnits;
      dialog.formData.draftItem.unitTypeModel = dialog.model.units.filter(function (unit) {
        return unit.key === dialog.formData.draftItem.unitType;
      })[0];
      // select default unit
      if (!_this.isEdit && response.data.defaultUnit) {
        _this.unitsChanged(response.data.defaultUnit);
      }
      if (!_this.isEdit) {
        // when supplier or category is changed
        _this.getFeesAndTaxes(dialog.model.supplierVci, 0, dialog.model.currency.code);
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    setTimeout(function () {
      _this2.$refs.productNameField.$refs.input.focus();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.prefferedRateChanged = false;
    this.negotiatedRateChanged = false;
    this.unitPriceWasChanged = false;
    eventHub.$off('onCloseAddFeeTaxes', this.onCloseAddFeeTaxes);
    eventHub.$off('onAddedFeeTaxes', this.onAddedFeeTaxes);
  },
  data: function data() {
    return {
      vm: this,
      showDiscountsFeesTaxes: false,
      formData: {
        toggleAllEventsState: false,
        draftItem: {}
      },
      show: true,
      validation: true,
      computePoTotalEndpoint: api.PurchaseOrderComputeTotals(),
      computeItemTotalEndpoint: api.ComputeLineItemTotals().replace('{ENV}', ''),
      title: 'Add Line Item',
      categories: [],
      bussinessUnitsWithCostCenters: [],
      units: [],
      doDisplayNameError: false,
      doDisplayUnitPriceError: false,
      isCategorySelected: false,
      doDisplayCategoryError: false,
      doDisplayCategRefIdError: false,
      isBusinessUnitAndCostCenterSelected: false,
      doDisplayBusinessUnitAndCostCenterError: false,
      isUnitSelected: false,
      doDisplayUnitsError: false,
      doDisplayUnitsInputError: false,
      showOneCostCenter: false,
      showCostCenters: false,
      showOneBusinessUnit: false,
      showBusinessUnits: false,
      showOneCostCenterWithBusinessUnit: false,
      showMixCostCentersWithBusinessUnits: false,
      isCostCenterSelected: false,
      doDisplayCostCenterError: false,
      isBusinessUnitSelected: false,
      doDisplayBusinessUnitError: false,
      isMixCostCenterWithBusinessUnitSelected: false,
      doDisplayMixCostCenterWithBusinessUnitError: false,
      doDisplayQuantityError: false,
      isEdit: false,
      negotiatedRateWasChanged: false,
      prefferedRateWasChanged: false,
      unitPriceWasChanged: false,
      quantityErrorMsg: '',
      unitsErrorMsg: '',
      unitPriceErrorMsg: '',
      quantityEmptyErrorMsg: 'Please select a quantity',
      quantityThresholdErrorMsgTpl: 'Quantity must be less than or equal to {0}',
      unitsThresholdErrorMsgTpl: 'Units must be less than or equal to {0}',
      unitPriceThresholdErrorMsgTpl: 'Unit price must be less than or equal to {0}',
      unitPriceNonZeroMsg: 'Unit price must not be 0',
      showVatGstPercentConfirmation: false,
      showVatGstPercentConfirmationWasAccepted: false
    };
  },
  computed: {
    disableCategoryRefInput: function disableCategoryRefInput() {
      return !this.dependencies.canEditCategRefId || this.model.canEditOnlyPrice;
    },
    currency: function currency() {
      return this.model.currency.code;
    },
    isRequiredCategRefID: function isRequiredCategRefID() {
      return this.model.IsRequiredCategRefID;
    },
    doDisplayCategRefIdErrorComputed: function doDisplayCategRefIdErrorComputed() {
      return this.doDisplayCategRefIdError;
    },
    supplementalPrecision: function supplementalPrecision() {
      return this.model.useSupplementalPrecision ? 6 /* 8 digits */ : 0; /* 2 digits */
    },
    hasSyncSuppliersToAccountingSystem: function hasSyncSuppliersToAccountingSystem() {
      return global.app.getUser.settings.SyncSuppliersToAccountingSystem;
    }
  },
  methods: {
    getCostCenterName: function getCostCenterName(option, label) {
      return option.name ? option.name.indexOf(option.code) === -1 ? option.code + ' (' + option.name + ')' : option.name : option.code;
    },
    getInternalProgramId: function getInternalProgramId(r) {
      return r.programDetails.uniqueId;
    },
    getTaxId: function getTaxId(name) {
      return 'item_tax_' + name;
    },
    getNamePercent: function getNamePercent(name) {
      return name + '_percent';
    },
    getNameAmount: function getNameAmount(name) {
      return name + '_amount';
    },
    getNameLink: function getNameLink(name) {
      return name + '_link';
    },
    getNewLineItem: function getNewLineItem() {
      var item = {
        productName: '',
        description: '',
        internalNote: '',
        category: '',
        referenceId: '',
        pairedBusinessUnitAndCostCenter: '',
        costCenterAndBusinessUnit: {},
        unit: '',
        taxCode: '',
        unitPrice: '',
        quantity: '1',
        units: '',
        total: '',
        discountAmount: 0,
        discountPercent: '',
        subtotal: 0,
        subtotalTaxes: 0,
        totalTaxes: 0,
        listOrder: 1,
        taxes: JSON.parse(JSON.stringify(this.model.taxes)),
        fees: JSON.parse(JSON.stringify(this.model.fees)),
        totalWithTaxesAndFees: 0,
        selectedFee: {
          taxes: JSON.parse(JSON.stringify(this.model.taxes)) || []
        },
        draftFee: {
          taxes: JSON.parse(JSON.stringify(this.model.taxes))
        },
        displayFeesTaxesModal: false
      };
      if (this.model.useSavingsFields) {
        item.unitPrice = 0;
        item.unitPriceSGR = 0;
        item.unitPriceNegotiatedRate = 0;
        item.unitPricePreferredRate = 0;
        item.totalSGR = 0;
        item.totalPreferredRate = 0;
        item.totalNegotiatedRate = 0;
      }
      return item;
    },
    store: function store() {
      return new __WEBPACK_IMPORTED_MODULE_2__LineItemStore_js__["a" /* default */](this.api);
    },
    onAcceptVatGstPercentConfirmation: function onAcceptVatGstPercentConfirmation() {
      this.showVatGstPercentConfirmation = false;
      this.showVatGstPercentConfirmationWasAccepted = true;
      this.onSave();
    },
    costCenterSelected: function costCenterSelected(e) {
      if (this.showCostCenters) {
        this.isCostCenterSelected = true;
        this.doDisplayCostCenterError = false;
        this.formData.draftItem.costCenterAndBusinessUnit = {
          programBusinessUnitAndCostCenterId: +e.key,
          costCenterNo: e.code,
          costCenterName: e.name,
          costCenterId: +e.costCenterId
        };
      }
    },
    businessUnitSelected: function businessUnitSelected(e) {
      if (this.showBusinessUnits) {
        this.isBusinessUnitSelected = true;
        this.doDisplayBusinessUnitError = false;
        this.formData.draftItem.costCenterAndBusinessUnit = {
          businessUnitName: e.name,
          businessUnitId: +e.businessUnitId
        };
      }
    },
    businessUnitWithCostCenterSelected: function businessUnitWithCostCenterSelected(e) {
      if (this.showMixCostCentersWithBusinessUnits) {
        this.isMixCostCenterWithBusinessUnitSelected = true;
        this.doDisplayMixCostCenterWithBusinessUnitError = false;
        this.formData.draftItem.costCenterAndBusinessUnit = {
          costCenterAndBusinessUnitName: e.name
        };
      }
    },
    bindCostCenterAndBusinessUnit: function bindCostCenterAndBusinessUnit(data, isEdit) {
      var _this3 = this;
      var costCenters = data.costCentersAndBusinessUnit.costCenters;
      var businessUnits = data.costCentersAndBusinessUnit.businessUnits;
      var mixedCostCentersAndBusinessUnits = data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits;
      if (mixedCostCentersAndBusinessUnits !== null && mixedCostCentersAndBusinessUnits !== undefined && mixedCostCentersAndBusinessUnits.length > 0) {
        if (mixedCostCentersAndBusinessUnits.length === 1) {
          this.businessUnitsWithCostCenter = mixedCostCentersAndBusinessUnits[0];
          this.formData.mixedCostCentersAndBusinessUnits = mixedCostCentersAndBusinessUnits[0];
          this.showOneCostCenter = false;
          this.showCostCenters = false;
          this.showOneBusinessUnit = false;
          this.showBusinessUnits = false;
          this.showOneCostCenterWithBusinessUnit = true;
          this.showMixCostCentersWithBusinessUnits = false;
          this.formData.draftItem.pairedBusinessUnitAndCostCenter = mixedCostCentersAndBusinessUnits[0];
          if (!isEdit) {
            this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey = this.businessUnitsWithCostCenter.key;
            this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName = this.businessUnitsWithCostCenter.name;
            this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.businessUnitsWithCostCenter.businessUnitId;
            this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.businessUnitsWithCostCenter.costCenterId;
            this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = +this.businessUnitsWithCostCenter.programBusinessUnitAndCostCenterId;
          } else {
            this.formData.draftItem.pairedBusinessUnitAndCostCenter = {
              key: this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey,
              name: this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName,
              businessUnitId: +this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId,
              costCenterId: +this.formData.draftItem.costCenterAndBusinessUnit.costCenterId,
              programBusinessUnitAndCostCenterId: +this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId
            };
          }
        } else {
          this.businessUnitsWithCostCenters = mixedCostCentersAndBusinessUnits;
          if (this.formData.draftItem.costCenterAndBusinessUnit !== undefined) {
            this.formData.draftItem.pairedBusinessUnitAndCostCenter = this.businessUnitsWithCostCenters.filter(function (businessUnitWithCostCenter) {
              return businessUnitWithCostCenter.key === _this3.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey;
            });
            if (this.formData.draftItem.pairedBusinessUnitAndCostCenter) {
              this.formData.draftItem.pairedBusinessUnitAndCostCenter = this.formData.draftItem.pairedBusinessUnitAndCostCenter[0];
              this.isBusinessUnitAndCostCenterSelected = true;
            }
          }
          this.showOneCostCenter = false;
          this.showCostCenters = false;
          this.showOneBusinessUnit = false;
          this.showBusinessUnits = false;
          this.showOneCostCenterWithBusinessUnit = false;
          this.showMixCostCentersWithBusinessUnits = true;
        }
      } else {
        if (costCenters !== null && costCenters !== undefined && costCenters.length > 0) {
          if (costCenters.length === 1) {
            this.costCenter = costCenters[0];
            this.formData.costCenter = costCenters[0];
            this.showOneCostCenter = true;
            this.showCostCenters = false;
            this.showOneBusinessUnit = false;
            this.showBusinessUnits = false;
            this.showOneCostCenterWithBusinessUnit = false;
            this.showMixCostCentersWithBusinessUnits = false;
            if (!isEdit) {
              this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = this.costCenter.key;
              this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo = this.costCenter.code;
              this.formData.draftItem.costCenterAndBusinessUnit.costCenterName = this.costCenter.name;
              this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = this.costCenter.costCenterId;
            } else {
              this.formData.draftItem.costCenter = {
                key: +this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId,
                code: this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo,
                name: this.formData.draftItem.costCenterAndBusinessUnit.costCenterName,
                costCenterId: +this.formData.draftItem.costCenterAndBusinessUnit.costCenterId
              };
            }
          } else {
            this.costCenters = costCenters;
            this.showOneCostCenter = false;
            this.showCostCenters = true;
            this.showOneBusinessUnit = false;
            this.showBusinessUnits = false;
            this.showOneCostCenterWithBusinessUnit = false;
            this.showMixCostCentersWithBusinessUnits = false;
            if (this.formData.draftItem.costCenterAndBusinessUnit !== undefined) {
              this.formData.draftItem.costCenter = costCenters.filter(function (costCenter) {
                return +costCenter.costCenterId === _this3.formData.draftItem.costCenterAndBusinessUnit.costCenterId;
              });
              // array to object
              if (this.formData.draftItem.costCenter) {
                this.formData.draftItem.costCenter = this.formData.draftItem.costCenter[0];
              }
              if (this.formData.draftItem.costCenter && this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo) {
                this.isCostCenterSelected = true;
              }
            }
          }
        }
        if (businessUnits !== null && businessUnits !== undefined && businessUnits.length > 0) {
          if (businessUnits.length === 1) {
            this.businessUnit = businessUnits[0];
            this.formData.businessUnit = businessUnits[0];
            this.showOneBusinessUnit = true;
            this.showBusinessUnits = false;
            this.showOneCostCenterWithBusinessUnit = false;
            this.showMixCostCentersWithBusinessUnits = false;
            if (!isEdit) {
              this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName = this.businessUnit.name;
              this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = this.businessUnit.businessUnitId;
            } else {
              this.formData.draftItem.businessUnit = {
                key: this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName,
                name: this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName,
                businessUnitId: +this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId
              };
            }
          } else {
            this.businessUnits = businessUnits;
            this.showOneBusinessUnit = false;
            this.showBusinessUnits = true;
            this.showOneCostCenterWithBusinessUnit = false;
            this.showMixCostCentersWithBusinessUnits = false;
            if (this.formData.draftItem.costCenterAndBusinessUnit !== undefined) {
              this.formData.draftItem.businessUnit = businessUnits.filter(function (bu) {
                return bu.key === _this3.formData.draftItem.costCenterAndBusinessUnit.businessUnitName;
              });
              // array to object
              if (this.formData.draftItem.businessUnit) {
                this.formData.draftItem.businessUnit = this.formData.draftItem.businessUnit[0];
              }
              if (this.formData.draftItem.businessUnit && this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName) {
                this.isBusinessUnitSelected = true;
              }
            }
          }
        }
      }
    },
    openAddFeeTaxesDialog: function openAddFeeTaxesDialog(fee) {
      this.formData.draftItem.selectedFee = fee;
      this.formData.draftItem.draftFee = JSON.parse(JSON.stringify(fee));
      this.formData.draftItem.draftFee.currency = this.model.currency;
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_6_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__AddFeeTaxes_vue__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: this.formData.draftItem.draftFee,
          dependencies: this.dependencies,
          eventHub: eventHub
        }
      });
      instance.$slots.default = [];
      instance.$mount();
      this.$refs.addFeeTaxesDialogContainer.appendChild(instance.$el);
    },
    onCloseAddFeeTaxes: function onCloseAddFeeTaxes() {},
    onAddedFeeTaxes: function onAddedFeeTaxes(e) {
      if (this.formData.draftItem.selectedFee) {
        this.formData.draftItem.selectedFee.taxes = e.eventData.taxes;
      }
      this.computeItemTotal();
    },
    onClose: function onClose() {
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('onCloseAddLineItem', {});
      this.show = false;
    },
    onSave: function onSave() {
      var _this4 = this;
      if (!this.isValid()) return;
      if (!this.showVatGstPercentConfirmationWasAccepted && this.model.supplierCountry && this.model.vatGstPercentagesPerCountry && this.model.vatGstPercentagesPerCountry[this.model.supplierCountry]) {
        var itemIsValid = true;
        this.formData.draftItem.taxes.forEach(function (tax) {
          if (tax.isChecked && (tax.name === 'Value Added Tax (VAT)' || tax.name === 'Goods & Services Tax (GST)')) {
            var taxPercent = tax.percentage;
            if (!taxPercent) {
              taxPercent = parseFloat(tax.value) * 100 / _this4.formData.draftItem.subtotal;
            }
            var percentages = _this4.model.vatGstPercentagesPerCountry[_this4.model.supplierCountry];
            var isValid = false;
            for (var i = 0; i < percentages.length; i++) {
              var noOfDecimals = 0;
              if (percentages[i].indexOf('.') >= 0) {
                noOfDecimals = percentages[i].split('.')[1].length;
              }
              if (percentages[i] === parseFloat(taxPercent).toFixed(noOfDecimals)) {
                isValid = true;
              }
            }
            if (!isValid) {
              _this4.showVatGstPercentConfirmation = true;
              itemIsValid = false;
            }
          }
        });
        if (!itemIsValid) return;
      }
      this.formData.draftItem.isFeeDiscountItem = false;
      this.formData.draftItem.unitType = this.formData.draftItem.unitTypeModel.key;
      if (typeof this.formData.draftItem.costCenterAndBusinessUnit === 'undefined') {
        this.formData.draftItem.costCenterAndBusinessUnit = {};
      }
      if (this.showOneCostCenter) {
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = +this.costCenter.key;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo = this.costCenter.code;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterName = this.costCenter.name;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.costCenter.costCenterId;
      } else if (this.formData.draftItem.costCenter) {
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = +this.formData.draftItem.costCenter.key;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo = this.formData.draftItem.costCenter.code;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterName = this.formData.draftItem.costCenter.name;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.formData.draftItem.costCenter.costCenterId;
      }
      if (this.showOneBusinessUnit) {
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName = this.businessUnit.name;
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.businessUnit.businessUnitId;
      } else if (this.formData.draftItem.businessUnit) {
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName = this.formData.draftItem.businessUnit.name;
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.formData.draftItem.businessUnit.businessUnitId;
      }
      if (this.showOneCostCenterWithBusinessUnit) {
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey = this.businessUnitsWithCostCenter.key;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName = this.businessUnitsWithCostCenter.name;
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.businessUnitsWithCostCenter.businessUnitId;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.businessUnitsWithCostCenter.costCenterId;
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = +this.businessUnitsWithCostCenter.programBusinessUnitAndCostCenterId;
        this.formData.draftItem.useBusinessUnitAndCostCenterMapping = true;
      } else if (this.formData.draftItem.pairedBusinessUnitAndCostCenter) {
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey = this.formData.draftItem.pairedBusinessUnitAndCostCenter.key;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName = this.formData.draftItem.pairedBusinessUnitAndCostCenter.name;
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.formData.draftItem.pairedBusinessUnitAndCostCenter.businessUnitId;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.formData.draftItem.pairedBusinessUnitAndCostCenter.costCenterId;
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = +this.formData.draftItem.pairedBusinessUnitAndCostCenter.programBusinessUnitAndCostCenterId;
        this.formData.draftItem.useBusinessUnitAndCostCenterMapping = true;
      } else {
        this.formData.draftItem.useBusinessUnitAndCostCenterMapping = false;
      }
      this.formData.draftItem.customFields = this.$refs.itemCustomFieldsRef.getFields();
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('onSaveLineItem', {
        data: this.formData.draftItem,
        eventUniqueId: this.eventId
      });
      this.$nextTick(function () {
        _this4.show = false;
      });
    },
    sgrChanged: function sgrChanged(value) {
      if (!this.isEdit && !this.prefferedRateWasChanged) {
        this.formData.draftItem.unitPricePreferredRate = value;
        if (!this.negotiatedRateWasChanged) {
          this.formData.draftItem.unitPriceNegotiatedRate = value;
          if (!this.unitPriceWasChanged) {
            this.formData.draftItem.unitPrice = value;
          }
        }
      }
      this.computeItemTotal();
    },
    prefferedRateChanged: function prefferedRateChanged(value) {
      this.prefferedRateWasChanged = true;
      if (!this.isEdit && !this.negotiatedRateWasChanged) {
        this.formData.draftItem.unitPriceNegotiatedRate = value;
        if (!this.unitPriceWasChanged) {
          this.formData.draftItem.unitPrice = value;
        }
      }
      this.computeItemTotal();
    },
    negotiatedRateChanged: function negotiatedRateChanged(value) {
      this.negotiatedRateWasChanged = true;
      if (!this.isEdit && !this.unitPriceWasChanged) {
        this.formData.draftItem.unitPrice = value;
      }
      this.computeItemTotal();
    },
    unitPriceChanged: function unitPriceChanged(value) {
      this.unitPriceWasChanged = true;
      this.doDisplayUnitPriceError = false;
      this.computeItemTotal();
    },
    computeItemTotal: function computeItemTotal() {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        _this5.getComputeItemTotalRequest().then(function (response) {
          _this5.formData.draftItem = _this5.store().populateTotalsOnItem(_this5.formData.draftItem, response.data.lineItem);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getComputeItemTotalRequest: function getComputeItemTotalRequest() {
      if (this.model.useSavingsFields) {
        return this.store().computeSavingsItemTotal(this.formData.draftItem, this.model.currency);
      } else {
        return this.store().computeItemTotal(this.formData.draftItem, this.model.currency);
      }
    },
    categoryChanged: function categoryChanged(category) {
      this.formData.draftItem.category = category.key;
      this.formData.draftItem.selectedCategory = category;
      this.formData.draftItem.referenceId = category.referenceId;
      this.isCategorySelected = true;
      this.doDisplayCategoryError = false;
      if (this.isCategRefIdFilled()) {
        this.doDisplayCategRefIdError = false;
      }
      if (!this.isEdit) {
        var categoryId = this.getCategoryId(category);
        this.getFeesAndTaxes(this.model.supplierVci, categoryId, this.model.currency.code);
      }
    },
    getCategoryId: function getCategoryId(category) {
      var categoryId = category.key;

      // if category.key contains also subcategoryId, select just the categoryId
      var idx = category.key.indexOf('_');
      if (idx && idx > 0) {
        var subcategoryId = category.key.substring(0, idx);
        if (subcategoryId) {
          categoryId = subcategoryId;
        }
      }
      return categoryId;
    },
    unitsChanged: function unitsChanged(unitType) {
      this.isUnitSelected = true;
      this.doDisplayUnitsError = false;
      this.formData.draftItem.unitTypeModel = unitType;
      this.formData.draftItem.unitType = unitType.key;
    },
    quantityChanged: function quantityChanged(quantity) {
      this.doDisplayQuantityError = false;
      this.updateFeesPerItem(quantity);
      this.isQuantityThresholdValid();
    },
    unitsInputChanged: function unitsInputChanged() {
      this.doDisplayUnitsInputError = false;
      this.isUnitsThresholdValid();
    },
    unitPriceInputChanged: function unitPriceInputChanged() {
      this.doDisplayUnitPriceError = false;
      this.isUnitPriceThresholdValid();
    },
    updateFeesPerItem: function updateFeesPerItem(qty) {
      this.formData.draftItem.fees && this.formData.draftItem.fees.map(function (fee) {
        if (parseInt(fee.valuePerItem) !== 0) {
          fee.value = qty * fee.valuePerItem;
        }
      });
    },
    itemNameChanged: function itemNameChanged(name) {
      this.doDisplayNameError = false;
    },
    categoryRefIdChanged: function categoryRefIdChanged(referenceId) {
      this.doDisplayCategRefIdError = false;
      this.formData.draftItem.referenceId = referenceId;
      this.formData.draftItem.selectedCategory.referenceId = referenceId;
    },
    getFeesAndTaxes: function getFeesAndTaxes(supplierVCI, categoryId, currencyCode) {
      this.getTaxes(supplierVCI, categoryId, currencyCode);
      this.getFees(supplierVCI, categoryId, currencyCode);
    },
    getTaxes: function getTaxes(supplierVCI, categoryId, currencyCode) {
      var _this6 = this;
      this.store().getLineItemTaxes(this.model.supplierVci || 0, categoryId || 0, this.model.currency.code).then(function (response) {
        _this6.formData.draftItem.taxes = response.data;
        _this6.computeItemTotal();
      });
    },
    getFees: function getFees(supplierVCI, categoryId, currencyCode) {
      var _this7 = this;
      this.store().getLineItemFees(this.model.supplierVci || 0, categoryId || 0, this.model.currency.code, this.model.events, this.model.buyerVendorId).then(function (response) {
        _this7.formData.draftItem.fees = response.data;
        if (_this7.isQuantitySelected()) {
          _this7.updateFeesPerItem(_this7.formData.draftItem.quantity);
        }
        _this7.computeItemTotal();
      });
    },
    isQuantitySelected: function isQuantitySelected() {
      return this.formData.draftItem && this.formData.draftItem.quantity && this.formData.draftItem.quantity.toString().length && this.formData.draftItem.quantity.toString().length > 0;
    },
    isNameSelected: function isNameSelected() {
      return this.formData.draftItem && this.formData.draftItem.name && this.formData.draftItem.name.trim().length && this.formData.draftItem.name.trim().length > 0;
    },
    isCategRefIdFilled: function isCategRefIdFilled() {
      return this.formData.draftItem && this.formData.draftItem.referenceId && this.formData.draftItem.referenceId.length && this.formData.draftItem.referenceId.length > 0;
    },
    isQuantityThresholdValid: function isQuantityThresholdValid() {
      if (this.model.canEditOnlyPrice && this.model.checkQuantitiesAgainstPO && this.model.maxThreshold) {
        if (Number(this.formData.draftItem.quantity) > this.model.maxThreshold.quantity) {
          this.doDisplayQuantityError = true;
          this.quantityErrorMsg = this.quantityThresholdErrorMsgTpl.replace('{0}', Number(this.model.maxThreshold.quantity));
          return false;
        }
      }
      return true;
    },
    isUnitsThresholdValid: function isUnitsThresholdValid() {
      if (this.model.canEditOnlyPrice && this.model.checkQuantitiesAgainstPO && this.model.maxThreshold) {
        if (Number(this.formData.draftItem.units) > this.model.maxThreshold.units) {
          this.doDisplayUnitsInputError = true;
          this.unitsErrorMsg = this.unitsThresholdErrorMsgTpl.replace('{0}', Number(this.model.maxThreshold.units));
          return false;
        }
      }
      return true;
    },
    isUnitPriceThresholdValid: function isUnitPriceThresholdValid() {
      if (this.model.canEditOnlyPrice && this.model.maxThreshold) {
        if (Number(this.formData.draftItem.unitPrice) > this.model.maxThreshold.unitPrice) {
          this.doDisplayUnitPriceError = true;
          this.unitPriceErrorMsg = this.unitPriceThresholdErrorMsgTpl.replace('{0}', Number(this.model.maxThreshold.unitPrice));
          return false;
        }
      }
      return true;
    },
    isUnitPriceNonZero: function isUnitPriceNonZero() {
      if (!+this.formData.draftItem.unitPrice) {
        this.doDisplayUnitPriceError = true;
        return false;
      }
      return true;
    },
    isValid: function isValid() {
      var result = true;
      if (!this.isNameSelected()) {
        this.doDisplayNameError = true;
        result = false;
      } else {
        this.doDisplayNameError = false;
      }
      if (!this.isQuantitySelected()) {
        this.doDisplayQuantityError = true;
        this.quantityErrorMsg = this.quantityEmptyErrorMsg;
        result = false;
      }
      if (this.model.canEditOnlyPrice && this.model.maxThreshold) {
        if (this.model.checkQuantitiesAgainstPO && (!this.isQuantityThresholdValid() || !this.isUnitsThresholdValid() || !this.isUnitPriceThresholdValid())) {
          result = false;
        } else if (!this.model.checkQuantitiesAgainstPO && !this.isUnitPriceThresholdValid()) {
          result = false;
        }
      }
      if (!this.isUnitPriceNonZero()) {
        result = false;
      }
      if (this.categories !== null && this.categories.length !== null && this.categories.length > 0) {
        if (!this.isCategorySelected && !(this.formData.draftItem && this.formData.draftItem.selectedCategory && this.formData.draftItem.selectedCategory !== null)) {
          this.doDisplayCategoryError = true;
          result = false;
        }
      }
      if (this.model.IsRequiredCategRefID && !this.isCategRefIdFilled()) {
        this.doDisplayCategRefIdError = true;
        result = false;
      } else {
        this.doDisplayCategRefIdError = false;
      }
      if (this.isUnitSelected === false && !(this.formData.draftItem && this.formData.draftItem.unitTypeModel && this.formData.draftItem.unitTypeModel !== null)) {
        this.doDisplayUnitsError = true;
        result = false;
      }
      if (this.showCostCenters) {
        if (!this.isCostCenterSelected && !(this.formData.draftItem && this.formData.draftItem.costCenter && this.formData.draftItem.costCenter !== null && this.formData.draftItem.costCenter.key)) {
          this.doDisplayCostCenterError = true;
          result = false;
        }
      }
      if (this.showBusinessUnits) {
        if (!this.isBusinessUnitSelected && !(this.formData.draftItem && this.formData.draftItem.businessUnit && this.formData.draftItem.businessUnit !== null)) {
          this.doDisplayBusinessUnitError = true;
          result = false;
        }
      }
      if (this.showMixCostCentersWithBusinessUnits) {
        if (!this.isMixCostCenterWithBusinessUnitSelected && !(this.formData.draftItem && this.formData.draftItem.pairedBusinessUnitAndCostCenter && this.formData.draftItem.pairedBusinessUnitAndCostCenter !== null)) {
          this.doDisplayMixCostCenterWithBusinessUnitError = true;
          result = false;
        }
      }
      if (!this.$refs.itemCustomFieldsRef.validate()) {
        result = false;
      }
      return result;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "XNcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_other_vue__ = __webpack_require__("I31w");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56339222_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_other_vue__ = __webpack_require__("Mktf");
function injectStyle (ssrContext) {
  __webpack_require__("63Rj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56339222"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_other_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56339222_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_other_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XU2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_search_vue__ = __webpack_require__("4Z6S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3bd6f76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_search_vue__ = __webpack_require__("jjdZ");
function injectStyle (ssrContext) {
  __webpack_require__("12TM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3bd6f76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XUrf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_js__ = __webpack_require__("ShaP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_tabs__ = __webpack_require__("Q++R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_actions_remit_payment__ = __webpack_require__("PXXQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_Invoices_actions_edit_invoice__ = __webpack_require__("UwY+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */],
    RemitPayment: __WEBPACK_IMPORTED_MODULE_3__components_modules_Invoices_actions_remit_payment__["a" /* default */],
    EditInvoiceForSupplier: __WEBPACK_IMPORTED_MODULE_4__components_modules_Invoices_actions_edit_invoice__["a" /* default */]
  },
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__model_js__["a" /* default */],
      tabs: __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_tabs__["a" /* default */].tabs,
      rowClasses: {
        'negative-amount': function negativeAmount(params) {
          return (params.data || {}).TotalAmount < 0;
        }
      },
      selectedRows: [],
      selectedAll: null
    };
  },
  activated: function activated() {
    this.$refs.grid.refreshGrid();
  },
  methods: {
    rowSelected: function rowSelected(event) {
      if (typeof event !== 'boolean') {
        this.selectedRows = event;
      } else {
        this.selectedAll = event;
        this.selectedRows = [];
      }
    }
  }
});

/***/ }),

/***/ "Xacs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2yzD5LGDQUtvjnNumYhFhj","Dell":"_2RyXrrK4mOlDHTcvi49cTT","Abbott":"_1INFivhxebl3SHdGXaaTWB","Gap":"_9uxBjvjjJBBklx9I7IxEN","Allstate":"_3WpTt6Pf0n3XlKZq5mquxo","Asurion":"_16yJHXsd67ih9Zh54-juBj","Invitae":"_3GdS9mUThJVFImx3hm3Zt_","JWE":"mJV2JiFuPBFIIKRWoygm1"};

/***/ }),

/***/ "XhLg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"ChADGf3xfsF7XggvtxXY_","Dell":"uC5qxyqLcXO7fIj0amUZU","Abbott":"IWaOLNLFEUap-su4PHl3l","Gap":"cSF9ipSXetKHr7wySSK8p","Allstate":"_32hs4ttCLlmonAHU-Y_Owl","Asurion":"_2MPyODsjBuoGqsele07Own","Invitae":"_1DvKK5W9QVTvxTjIj4gd_X","JWE":"_2hv_6YadPCGiejzNchQJLK"};

/***/ }),

/***/ "Xi8K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Supplier_vue__ = __webpack_require__("472K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d25c92_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Supplier_vue__ = __webpack_require__("p81o");
function injectStyle (ssrContext) {
  __webpack_require__("127V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00d25c92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Supplier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d25c92_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Supplier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XqGA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__line_item_constants__ = __webpack_require__("xmRq");

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(categs, showSavingsFields, isP2PInvoice, companySettings, currencyCode) {
    var isP2PInvoiceWithItems = isP2PInvoice && companySettings.AllowEditItem;
    var displayRemainingQty = !(isP2PInvoice && companySettings.AllowInvoiceToExceedPOQty);
    showSavingsFields = showSavingsFields && !isP2PInvoiceWithItems;
    var useSupplementalPrecision = companySettings.CurrenciesWithSupplementalPrecision.indexOf(currencyCode) !== -1;
    return {
      '*name': {
        label: 'Product Name',
        width: showSavingsFields ? 150 : 200,
        editable: !isP2PInvoice
      },
      category: {
        label: 'Category',
        width: 100,
        source: true,
        options: categs,
        compose: categName,
        editable: !isP2PInvoice
      },
      poQuantity: isP2PInvoiceWithItems ? {
        label: 'PO Qty',
        width: 65,
        compose: poQuantityFormat,
        f: poQuantityFormat,
        editable: false,
        type: 'amount text-right'
      } : null,
      poUnits: isP2PInvoiceWithItems ? {
        label: 'PO Units',
        width: showSavingsFields ? 50 : 75,
        compose: poUnitsFormat,
        f: poUnitsFormat,
        editable: false,
        type: 'amount text-right'
      } : null,
      remainingQuantity: isP2PInvoiceWithItems && displayRemainingQty ? {
        label: 'Remaining Qty',
        width: showSavingsFields ? 50 : 100,
        compose: remainingQuantityFormat,
        f: remainingQuantityFormat,
        editable: false,
        type: 'amount text-right'
      } : null,
      quantity: {
        label: isP2PInvoiceWithItems ? 'Invoice Qty' : 'Quantity',
        width: showSavingsFields ? 70 : isP2PInvoiceWithItems ? 90 : 80,
        compose: quantityFormat,
        f: quantityFormat,
        editable: !isP2PInvoice || isP2PInvoiceWithItems,
        notEditableIf: {
          f: 'isQuantityReadonly'
        },
        type: 'qty',
        maxThreshold: isP2PInvoiceWithItems ? {
          value: 0,
          f: 'maxQuantity'
        } : null,
        minThreshold: isP2PInvoiceWithItems ? {
          value: 0
        } : null,
        decimals: 2
      },
      units: {
        label: isP2PInvoiceWithItems ? 'Invoice Units' : 'Units',
        width: showSavingsFields ? 50 : isP2PInvoiceWithItems ? 85 : 80,
        compose: unitsFormat,
        f: unitsFormat,
        editable: !isP2PInvoice || isP2PInvoiceWithItems,
        notEditableIf: {
          f: 'isUnitsReadonly'
        },
        type: 'qty',
        showDefaultEmpty: true,
        maxThreshold: isP2PInvoiceWithItems ? {
          value: 0,
          f: 'poUnits'
        } : null,
        minThreshold: isP2PInvoiceWithItems ? {
          value: 0
        } : null,
        decimals: 2
      },
      unitPriceSGR: showSavingsFields ? {
        label: 'SGR',
        width: 100,
        fixed: true,
        compose: sgrFormat,
        getter: sgrFormat,
        useSupplementalPrecision: useSupplementalPrecision,
        visible: showSavingsFields,
        editable: !isP2PInvoice
      } : null,
      unitPricePreferredRate: showSavingsFields ? {
        label: 'Preferred',
        width: 100,
        fixed: true,
        compose: preferredFormat,
        getter: preferredFormat,
        useSupplementalPrecision: useSupplementalPrecision,
        visible: showSavingsFields,
        editable: !isP2PInvoice
      } : null,
      unitPriceNegotiatedRate: showSavingsFields ? {
        label: 'Negotiated',
        width: 100,
        fixed: true,
        compose: negotiatedFormat,
        getter: negotiatedFormat,
        useSupplementalPrecision: useSupplementalPrecision,
        visible: showSavingsFields,
        editable: !isP2PInvoice
      } : null,
      unitPrice: {
        label: 'Price',
        width: 90,
        compose: priceFormat,
        getter: priceFormat,
        useSupplementalPrecision: useSupplementalPrecision,
        editable: !isP2PInvoice || isP2PInvoiceWithItems,
        maxThreshold: isP2PInvoiceWithItems ? {
          f: 'maxUnitPrice',
          value: 0
        } : null,
        minThreshold: isP2PInvoiceWithItems ? {
          value: -__WEBPACK_IMPORTED_MODULE_0__line_item_constants__["a" /* default */].maxAmount
        } : null
      },
      total: {
        label: 'Total Price',
        compose: totalFormat,
        f: totalFormat,
        validationCol: 'totalToValidate',
        width: isP2PInvoiceWithItems ? 135 : 140,
        fixed: true,
        editable: false,
        alias: isP2PInvoiceWithItems && companySettings.ExcludeTaxesFromPOThreshold ? 'Total Price without taxes' : null,
        maxThreshold: isP2PInvoiceWithItems && companySettings.AllowInvoiceToExceedPOQty ? {
          f: 'maxTotalAmount',
          value: 0
        } : null,
        minTotalThreshold: {
          f: 'minTotalAmount',
          value: 0
        }
      },
      details: {
        label: '+',
        details: 'local'
      },
      $$actionable: function $$actionable(p) {
        return !p.data.isAutoGenerated;
      },
      maxUnitPrice: {
        label: 'Unit Price',
        editable: false,
        visible: false
      },
      maxQuantity: {
        label: 'Quantity',
        editable: false,
        visible: false
      }
    };
  }
});
function totalFormat(params) {
  return params.data.totalWithTaxesAndFees;
}
function categName(params) {
  return params.data && params.data.isFeeDiscountItem === false ? params.value ? params.value.text : '' : '';
}
function sgrFormat(params) {
  if (params.data.isFeeDiscountItem === true) {
    params.data._disabled = true;
    params.data.unitPriceSGR = '';
  }
  return params.data.unitPriceSGR ? parseFloat(params.data.unitPriceSGR) : null;
}
function negotiatedFormat(params) {
  if (params.data.isFeeDiscountItem === true) {
    params.data._disabled = true;
    params.data.unitPriceNegotiatedRate = '';
  }
  return params.data.unitPriceNegotiatedRate ? parseFloat(params.data.unitPriceNegotiatedRate) : null;
}
function preferredFormat(params) {
  if (params.data.isFeeDiscountItem === true) {
    params.data._disabled = true;
    params.data.unitPricePreferredRate = '';
  }
  return params.data.unitPricePreferredRate ? parseFloat(params.data.unitPricePreferredRate) : null;
}
function priceFormat(params) {
  if (params.data.isFeeDiscountItem === true) {
    params.data._disabled = true;
    params.data.unitPrice = params.data.total;
  }
  if (params.data.remainingQuantity && params.data.remainingQuantity === 0) {
    params.data.unitPrice = 0;
    return null;
  }
  return params.data.unitPrice ? parseFloat(params.data.unitPrice) : null;
}
function unitsFormat(params) {
  if (params.data.hideQtyWhenZero && Number(params.data.units) === 0) return null;
  return params.data && params.data.isFeeDiscountItem === true ? '' : params.data.units && Number(params.data.units) !== 0 ? parseFloat(params.data.units) : null;
}
function quantityFormat(params) {
  if (params.data.hideQtyWhenZero && Number(params.data.quantity) === 0) return null;
  return params.data.quantity || params.data.quantity === 0 ? parseFloat(params.data.quantity) : params.data.remainingQuantity === 0 ? 0 : null;
}
function poQuantityFormat(params) {
  return params.data.poQuantity ? parseFloat(params.data.poQuantity) : null;
}
function poUnitsFormat(params) {
  return params.data && params.data.isFeeDiscountItem === true ? '' : params.data.poUnits ? parseFloat(params.data.poUnits) : null;
}
function remainingQuantityFormat(params) {
  return params.data && params.data.isFeeDiscountItem === true ? '' : params.data.remainingQuantity || params.data.remainingQuantity === 0 ? parseFloat(params.data.remainingQuantity) : null;
}

/***/ }),

/***/ "XrRE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xuxg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_vue__ = __webpack_require__("WdZU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6365626c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_new_vue__ = __webpack_require__("Q/y2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6365626c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y+cd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"vPg2PToguhebJyPNMJh2","Dell":"_2-5JEWZHwLn49SUgVm6FV6","Abbott":"_1rTpQPPJcgk3W9rIvy4UJg","Gap":"_3ChYLONsd0a-KUy6isv8e9","Allstate":"_1VQxcjjdvCLrtoDVdPDbsz","Asurion":"_3XHMjvIl4qtIjmHKbhSC2l","Invitae":"_2ouYz16F_VNKzqun8HvDd5","JWE":"dsAoaTCLpqtv133nvBGn9"};

/***/ }),

/***/ "Y2Ci":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1irfMBzjR7232WCk9OfoJ7","Dell":"_2DSAPvw2ONx0Pg5X00Os4-","Abbott":"_2iar3x1giPGQgCSfSMWDCI","Gap":"_1p-RgoKwQgsCcJOiX7Jm","Allstate":"_1T_eKlhV2mwIvPFbk62flI","Asurion":"y5JSZsasTrwj-rvQOBJ21","Invitae":"_3WR27ovZjRw4rkG1RxhIum","JWE":"_2CoUhQMcq5NueKPwGLTb8"};

/***/ }),

/***/ "Y6oM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_37NAmuleAmhPO9PO2nRsu3","Dell":"_1ryCSDfqcvjxjB8ZHcvUmi","Abbott":"_1tmJ6K6hFyQPiEn8NBkGyp","Gap":"bbSIEVwMkQEGjXd8grUTj","Allstate":"_2cAQoOsOJYDRietzUUZR0o","Asurion":"_6XhE2T5-7NSjAcOn7ssEm","Invitae":"_3pl031tceTrrzK5vH3r16","JWE":"_3ke1lARoriVRnoSjim0yCc"};

/***/ }),

/***/ "YKxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("1CWy");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7518437f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("OW+w");
function injectStyle (ssrContext) {
  __webpack_require__("th0X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7518437f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7518437f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YR7Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.card.CardNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.card.Holder.Name))])])]),_vm._v(" "),_c('div',[_vm._m(2),_vm._v(" "),((_vm.showNewPin ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPin),expression:"newPin"}],attrs:{"maxlength":"4","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.newPin)?_vm._i(_vm.newPin,null)>-1:(_vm.newPin)},on:{"input":function($event){return _vm.allowOnlyNumbers('newPin', $event)},"change":function($event){var $$a=_vm.newPin,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.newPin=$$a.concat([$$v]))}else{$$i>-1&&(_vm.newPin=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.newPin=$$c}}}}):((_vm.showNewPin ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPin),expression:"newPin"}],attrs:{"maxlength":"4","type":"radio"},domProps:{"checked":_vm._q(_vm.newPin,null)},on:{"input":function($event){return _vm.allowOnlyNumbers('newPin', $event)},"change":function($event){_vm.newPin=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPin),expression:"newPin"}],attrs:{"maxlength":"4","type":_vm.showNewPin ? 'text' : 'password'},domProps:{"value":(_vm.newPin)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.newPin=$event.target.value},function($event){return _vm.allowOnlyNumbers('newPin', $event)}]}}),_vm._v(" "),_c('i',{class:("toggle-pin-icon " + (_vm.showNewPin ? 'fas fa-eye-slash' : 'fas fa-eye')),on:{"click":_vm.toggleNewPinVisibility}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(3),_vm._v(" "),((_vm.showConfirmPin ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPin),expression:"confirmPin"}],attrs:{"maxlength":"4","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.confirmPin)?_vm._i(_vm.confirmPin,null)>-1:(_vm.confirmPin)},on:{"input":function($event){return _vm.allowOnlyNumbers('confirmPin', $event)},"change":function($event){var $$a=_vm.confirmPin,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.confirmPin=$$a.concat([$$v]))}else{$$i>-1&&(_vm.confirmPin=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.confirmPin=$$c}}}}):((_vm.showConfirmPin ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPin),expression:"confirmPin"}],attrs:{"maxlength":"4","type":"radio"},domProps:{"checked":_vm._q(_vm.confirmPin,null)},on:{"input":function($event){return _vm.allowOnlyNumbers('confirmPin', $event)},"change":function($event){_vm.confirmPin=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPin),expression:"confirmPin"}],attrs:{"maxlength":"4","type":_vm.showConfirmPin ? 'text' : 'password'},domProps:{"value":(_vm.confirmPin)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.confirmPin=$event.target.value},function($event){return _vm.allowOnlyNumbers('confirmPin', $event)}]}}),_vm._v(" "),_c('i',{class:("toggle-pin-icon " + (_vm.showConfirmPin ? 'fas fa-eye-slash' : 'fas fa-eye')),on:{"click":_vm.toggleConfirmPinVisibility}}),_vm._v(" "),(_vm.pinError)?_c('p',{staticClass:"pin-error"},[_vm._v(_vm._s(_vm.pinError))]):_vm._e(),_vm._v(" "),_c('br')])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n    Change your 4-digit pin code to be used for transactions on your EvedPay Card."),_c('br'),_vm._v("\n    Pin requirements:"),_c('br'),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline-start":"20px"}},[_c('li',[_vm._v("not be all the same digit, ex. 1111")]),_vm._v(" "),_c('li',[_vm._v("not be digits in sequence, ex. 1234")]),_vm._v(" "),_c('li',[_vm._v("not match the last four digits of the card number.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Card Number")]),_vm._v(" "),_c('th',[_vm._v("Card Holder")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("New 4-Digit Pin")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Confirm New 4-Digit Pin")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YRQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_lang__ = __webpack_require__("pe4m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      year: new Date().getFullYear(),
      langs: __WEBPACK_IMPORTED_MODULE_0__lang_lang__["c" /* languages */]
    };
  },
  methods: {
    isLang: __WEBPACK_IMPORTED_MODULE_0__lang_lang__["b" /* isLang */],
    setLang: function setLang(lang) {
      Object(__WEBPACK_IMPORTED_MODULE_0__lang_lang__["d" /* loadLanguageAsync */])(lang);
    }
  }
});

/***/ }),

/***/ "YXNu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2grsLUjY1r7lLeP7XaNsSW","Dell":"_3mKbpLnezS-OJFH7pTuHSs","Abbott":"_10_ZYk5xWN-2wZjEnKdtI-","Gap":"_35AKvrqet512mmST0nDmV7","Allstate":"_3a2dVd85Jscv5yK5bxJYoH","Asurion":"_2NJ5GgB1n-yswQWAgRK1id","Invitae":"_1mLR8S5DE4IMhVIV5OPBQL","JWE":"jQ9BAZRv3pV8IdUBVR-lg"};

/***/ }),

/***/ "YYHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"main col-md-6 col-md-offset-3 offset-md-3 col-sm-6 col-sm-offset-3 offset-sm-3"},[(!_vm.loading && !_vm.hasData)?_c('div',[_c('h3',{staticClass:"title"},[_vm._v("There is nothing to "+_vm._s(_vm.rejectText))]),_vm._v(" "),_c('p',{staticClass:"message"},[_vm._v("Please go to dashboard for updated information.")]),_vm._v(" "),_c('ed-button',{staticClass:"pull-right",on:{"click":_vm.gotoDashboard}},[_vm._v("Go to Dashboard")])],1):_c('div',[_vm._v("\n        Loading approval queue ...\n      ")]),_vm._v(" "),_c('rejectDialog',{attrs:{"showModal":_vm.showRejectDialog,"list":_vm.cards,"rejectText":_vm.rejectText},on:{"close":_vm.gotoDashboard,"reject":_vm.doReject}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YYsc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("AOjR");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15722eb0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Rjnk");
function injectStyle (ssrContext) {
  __webpack_require__("6wBp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15722eb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15722eb0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router_back_button__ = __webpack_require__("jB4S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_store__ = __webpack_require__("dgq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_user__ = __webpack_require__("uduW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_epcRedirect__ = __webpack_require__("3BJm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__ = __webpack_require__("Ivkl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_GeneralViews_NotFound_vue__ = __webpack_require__("pqHe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_legacy_auth_logout__ = __webpack_require__("rvuV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Login_accounts__ = __webpack_require__("i+5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang_lang__ = __webpack_require__("pe4m");
/* eslint no-multi-spaces: 0 */







// import Login          from '@/components/Login'





var $t = function $t(key) {
  return __WEBPACK_IMPORTED_MODULE_10__lang_lang__["a" /* i18n */].t(key);
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router_back_button__["a" /* routerHistory */]);
var routes = [
// {
//   name: 'evedpay',
//   path: '/evedpay/:tab?',
//   component: ModulesWrapper.publicShell
// },
{
  name: 'evedpaycards',
  path: '/evedpay/cards',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'evedpaytransactions',
  path: '/evedpay/transactions',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'evedpaycardtransactions',
  path: '/evedpay/cardtransactions/:cardid?',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'evedpaycarddetails',
  path: '/evedpay/details/:cardid?',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'evedpaytransactiondetails',
  path: '/evedpay/transactiondetails/:transactionid?',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'evedpayrequestphysicalcard',
  path: '/evedpay/requestcard',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'evedpayshownumber',
  path: '/evedpay/shownumber',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'evedpaychangepin',
  path: '/evedpay/changepin',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'evedpayrequestaddfunds',
  path: '/evedpay/loadfunds',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'evedpayreceiptfolder',
  path: '/evedpay/receiptfolder',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'evedpaysubmitreceipt',
  path: '/evedpay/submitreceipt',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'login',
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'switchaccount',
  path: '/switch-account',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Login_accounts__["a" /* default */]
}, {
  name: 'mfasetup',
  path: '/mfa-setup',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].publicShell
}, {
  name: 'logout',
  path: '/logout',
  component: __WEBPACK_IMPORTED_MODULE_8__core_legacy_auth_logout__["a" /* default */]
}, {
  name: 'RejectAll',
  path: '/d/reject-all',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].shell
}, {
  name: 'ApproveAll',
  path: '/d/approve-all',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].shell
}, {
  path: '/',
  redirect: '/home'
}, {
  name: 'home',
  path: '/home',
  redirect: global.config && global.config.start || '/d/Dashboard/My'
}, {
  name: '_allLegacy',
  path: '/l',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].legacy
}, {
  path: '/:namespace/:page?/:section?/:action?',
  name: '_allModules',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ModulesWrapper__["a" /* default */].shell,
  meta: {
    requiresAuth: !global.config
  }
}, {
  name: '404',
  path: '/404',
  component: __WEBPACK_IMPORTED_MODULE_7__components_GeneralViews_NotFound_vue__["a" /* default */]
}, {
  name: 'nogo',
  path: '*',
  redirect: '404'
}];
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes,
  checkNotSavedData: checkNotSavedData,
  linkActiveClass: 'active' /*,
                            scrollBehavior (to, from, savedPosition) {
                            //
                            try {
                            document.querySelector('.main-panel').scrollTop = 0
                            } catch (e) {}
                            } */
});

// PRODUCTDEV-6030: old EvedPay-Cards routes (email deep links, widget URLs, internal pushes)
// forward to the redesigned EPC tab in the v3 shell. Registered before checkAuth so the
// post-login `next(returnUrl)` hop is intercepted on its follow-up navigation too.
router.beforeEach(__WEBPACK_IMPORTED_MODULE_5__core_epcRedirect__["a" /* epcRedirectGuard */]);
router.beforeEach(checkAuth);
router.afterEach(__WEBPACK_IMPORTED_MODULE_2_vue_router_back_button__["b" /* writeHistory */]);
router.afterEach(function (to, from) {
  global.Page && global.Page.showTabs && global.Page.showTabs('', '', from.query.noRedir !== '1' ? from.query.goto : null, null);
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/**
 * Hook into routes for checking user authorization
 * before navigation else redirect to login
 * @summary Navigation guard
 */
function checkAuth(to, from, next) {
  // Check authorization and redirect to login if failed
  var user = __WEBPACK_IMPORTED_MODULE_4__core_user__["a" /* default */].get();

  // force iframe reload on only query param change
  if (from.params.namespace === 'i' && to.params.namespace === 'i') {
    if (global.document.getElementById('MainPageFrame')) {
      if (typeof to.query.switchAccount !== 'undefined' || typeof from.query.switchAccount !== 'undefined') {
        //
      } else {
        global.document.getElementById('MainPageFrame').src = global.document.getElementById('MainPageFrame').src;
      }
    }
    if (global.document.getElementById('iframe') && ~to.fullPath.indexOf('?')) {
      if (typeof to.query.switchAccount !== 'undefined' || typeof from.query.switchAccount !== 'undefined') {
        //
      } else {
        global.frames['NetFrame'].location = global.app.api.env + to.fullPath.split(to.params.page)[1];
      }
    }
  }
  // suppress loading on clicking main navigation
  if (router.previousPath === to.path) {
    setTimeout(function () {
      if (global.document.getElementById('iframe')) global.document.getElementById('iframe').className = 'content';
    });
  }
  router.previousPath = from.path;
  if (to.meta.requiresAuth) {
    if (!user || !user.token) {
      next({
        name: 'login'
      });
      // next({name: 'login', query: { returnUrl: to.path, noRedir: 1 }})
    } else {
      checkNotSavedData(to, from, next);
      // next()
    }
  } else {
    if (to.query.sk) {
      next();
    } else {
      if (to.query.returnUrl && user && user.token) {
        next(to.query.returnUrl);
      }
      (from.query.returnUrl || from.query.sk) && (!user || !user.token) ? typeof to.query.mfa !== 'undefined' ? next() : redirectToLogin(to, from, next) : checkNotSavedData(to, from, next);
      // next()
    }
  }
}

/**
 * Hook into routes for checking returnUrl
 * before navigation and redirect acordingly
 * @summary Navigation guard
 */
function redirectToLogin(to, from, cb) {
  if (from.query.noRedir !== '1') {
    cb();
    cb('/login?returnUrl=' + encodeURIComponent(from.query.returnUrl) + '&noRedir=1' + (typeof to.query.mfa !== 'undefined' ? '&mfa' : ''));
  } else {
    cb('/login?returnUrl=' + from.query.returnUrl + '&sk=' + from.query.sk + (typeof to.query.mfa !== 'undefined' ? '&mfa' : ''));
  }
}

/**
 * Hook into routes for checking draft data
 * before navigation and display a notification
 * @summary Navigation guard
 */
function checkNotSavedData(to, from, cb) {
  var pending = __WEBPACK_IMPORTED_MODULE_3__components_store__["a" /* store */].state.pendingData;
  if (global.app.$notifications && pending) {
    global.app.$notifications.notify({
      type: 'plain',
      icon: 'exclamation-circle',
      placement: {
        from: 'top',
        align: 'center'
      },
      timeout: 0,
      message: (pending === true ? "" : "".concat($t('You have unsaved data'), " <br />")) + "".concat($t('Are you sure you want to navigate away ?')),
      dismiss: $t('Yes'),
      target: '_blank',
      goto: "#".concat(to ? to.path : ''),
      onClose: function onClose(dismiss) {
        if (dismiss) {
          __WEBPACK_IMPORTED_MODULE_3__components_store__["a" /* store */].state.pendingData = null;
        } else if (dismiss === '') {
          global.localStorage.setItem('evedDraftData', JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__components_store__["a" /* store */].state.pendingData));
          __WEBPACK_IMPORTED_MODULE_3__components_store__["a" /* store */].state.pendingData = null;
        }
      }
    });
    cb && cb(false);
  } else {
    cb && cb();
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Ybvc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2WTJuH3kBdfPgeHxKMjYtJ","Dell":"_2qv_pzxdBgr447pXMM2IVw","Abbott":"_84YExQ1KqHBmkOFfdGGVi","Gap":"f0HbElKrOyOiRXAgi-CQq","Allstate":"_1rdQjmVOsUeZnwx7Ej2l9m","Asurion":"LDi0nqEEhzfis1Ekt07ff","Invitae":"_1Su4mu7MWLtkRfaSBDQuIe","JWE":"_33YAruodVNFRRJIPNCf-9q"};

/***/ }),

/***/ "YizL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-tab',
  props: {
    title: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    completed: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    icon: Array,
    url: String
  },
  data: function data() {
    return {
      isActive: false,
      isCompleted: false,
      optional: this.$attrs.optional
    };
  },
  beforeCreate: function beforeCreate() {
    this.routeQuery = this.$route.query ? '?' + this.$route.fullPath.split('?')[1] : '';
  },
  computed: {
    href: function href() {
      return this.url || '#' + this.$route.path + '#' + this.title.toLowerCase().replace(/ /g, '-');
    },
    section: function section() {
      return '#' + this.title.toLowerCase().replace(/ /g, '-');
    },
    iconClass: function iconClass() {
      return this.icon[0] + ' fa-' + this.icon[1];
    }
  },
  mounted: function mounted() {
    this.isActive = this.active;
    this.isCompleted = this.completed;
  }
});

/***/ }),

/***/ "Ykzl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1c8iAMDU1VxLX1fMmpo_vr","Dell":"_2xIJ2jtoWuaoFKcmjRW8AR","Abbott":"_3UIlzOmymmJd5zuaiYaE9E","Gap":"_2Y5_7fh6_CmHqeJN97uAN2","Allstate":"_1HisAkfV3VNP3iFMUZ5nSf","Asurion":"_2ITNJ6xyM8bsm24LQB4kSC","Invitae":"nBgUSVNNrVFcxbckJqc","JWE":"_1rDoeHUeb8ttD18agF-t-Q"};

/***/ }),

/***/ "YnYi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2HdbicbQHjT3hULESJ4z66","Dell":"_2eDvvEjmFaY-oR5mGNtodD","Abbott":"_1e7DWvSJekyUXezAYCHAvn","Gap":"FBHdCqa0OuNr9AycWvZjm","Allstate":"_32EBivukPkuSTkUHQ3at9e","Asurion":"_2ozENMvx3MZAwSA09HkgGF","Invitae":"_1jGJcNs-S_ZXk2hKWxPCkk","JWE":"_1acVbnn8rYlT83F-IXO5jz"};

/***/ }),

/***/ "Yq9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return date; });
// date
var date = {
  getTimestamp: function getTimestamp() {
    return +new Date();
  }
};

/***/ }),

/***/ "Yqmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReconcileTransaction_vue__ = __webpack_require__("lqPC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_420a27cc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReconcileTransaction_vue__ = __webpack_require__("aQ4b");
function injectStyle (ssrContext) {
  __webpack_require__("GpSt")
  __webpack_require__("B4WM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-420a27cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReconcileTransaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_420a27cc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReconcileTransaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YqwW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"grid",attrs:{"name":_vm.$t("Payments"),"desc":"Manage Invoices & Payments","search":"","search-placeholder":"Invoices","views":false,"checkboxes":false,"sort":{ PaymentDate: "desc", PaymentDateFormatted: "desc" },"endpoint":_vm.api.$.invoice.payments,"screen":_vm.api.$.invoice.list.paymentsReceived,"alias":"PaymentList_PaymentsReceive","legacy":"","tabs":_vm.tabs,"row-classes":_vm.rowClasses,"fit-columns":"","footer":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z/NV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3kq16tTTx5u5N0KPN9Dl7O","Dell":"_3dNo4HIdrW2BwOWGRrnUuV","Abbott":"punx5GtBuRicItwX8KC3p","Gap":"_2Ei3BgWCBp2nbWzgLze6t","Allstate":"_3gKAvafvyRp-41u-vJRGYZ","Asurion":"_1Tv5kiRP4iSnFIUb_KCalr","Invitae":"_1258MOBN0LMipo9XDwZeUk","JWE":"gLsU0GVnXQhCydSrPD1KC"};

/***/ }),

/***/ "Z88T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZEOY":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Abbott/theme.scss": [
		"jR9n",
		11
	],
	"./Apple/theme.scss": [
		"SRKL",
		10
	],
	"./Dell/theme.scss": [
		"sry/",
		9
	],
	"./default/theme.scss": [
		"rgRc",
		8
	],
	"./docs/theme.scss": [
		"1wCz"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ZEOY";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "ZGyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("lQbo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */


var api = new __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    invoiceKey: [Number, String],
    paymentInvoiceId: Number,
    programId: Number,
    userToken: String
  },
  data: function data() {
    return {
      showComments: false,
      uploadedAttachments: [],
      attachmentsToSave: [],
      comments: [],
      comment: '',
      attachmentsMissing: false,
      uploadFinished: true,
      displayCommentError: false
    };
  },
  computed: {
    uploadData: function uploadData() {
      return {
        token: this.userToken
      };
    }
  },
  methods: {
    userAvatar: function userAvatar(item) {
      return "".concat(item.LogoPath, "?v=").concat(Math.random().toString(36).substring(2, 15));
    },
    getFiles: function getFiles(attachments) {
      var _this = this;
      return attachments ? attachments.map(function (attachment) {
        return {
          name: attachment.AttachmentName,
          file: attachment.AttachmentFile,
          type: attachment.AttachmentType,
          size: attachment.AttachmentSize,
          path: _this.getFilePath(attachment)
        };
      }) : [];
    },
    getFilePath: function getFilePath(file) {
      return this.api.$.privateResources + 'MediaFiles/' + (file.AttachmentPath || '') + (file.AttachmentFile || '');
    },
    createAttachments: function createAttachments(e) {
      var _this2 = this;
      var completedFiles = e.filter(function (item) {
        return item.success;
      });
      if (completedFiles.length >= 1) {
        this.attachmentsMissing = false;
      }
      if (completedFiles.length === e.length) {
        this.uploadFinished = true;
        this.attachmentsToSave = e.map(function (item) {
          var itemResponse = item.response ? JSON.parse(item.response) : '';
          if (itemResponse.uploadError) {
            _this2.errorMessages.push('File "' + item.name + '": ' + itemResponse.uploadError);
          } else {
            return {
              AttachmentName: item.name,
              AttachmentSize: item.size,
              AttachmentFile: itemResponse ? itemResponse.file : item.file || '',
              AttachmentID: item.fileId || 0,
              AttachmentPath: itemResponse ? itemResponse.path : ''
            };
          }
        });

        // this.showUploadError = this.errorMessages.length > 0

        this.uploadedAttachments = this.uploadedAttachments.filter(function (item) {
          return item.response ? JSON.parse(item.response).success : item.success;
        });
      } else {
        this.uploadFinished = false;
      }
    },
    getComments: function getComments() {
      this.showComments = !this.showComments;
      if (this.showComments) {
        this.reset();
        this.doGetComments();
      }
    },
    doGetComments: function doGetComments() {
      var _this3 = this;
      var invoiceKey = this.invoiceKey;
      var paymentInvoiceId = this.paymentInvoiceId;
      return this.api.get(api.GetComments(), {
        params: {
          invoiceKey: invoiceKey,
          paymentInvoiceId: paymentInvoiceId
        }
      }).then(function (e) {
        _this3.comments = e.data;
      });
    },
    reset: function reset() {
      this.comment = '';
      this.uploadedAttachments = [];
    },
    commentChanged: function commentChanged() {
      this.displayCommentError = false;
    },
    validateComment: function validateComment() {
      var isValid = this.comment && this.comment.trim() !== '' || this.uploadedAttachments.length > 0;
      this.displayCommentError = !isValid;
      return isValid;
    },
    saveComment: function saveComment() {
      var _this4 = this;
      if (this.validateComment()) {
        var item = {
          InvoiceKey: this.invoiceKey,
          PaymentInvoiceId: this.paymentInvoiceId,
          ProgramId: this.programId,
          Comment: this.comment,
          Files: this.attachmentsToSave,
          FromPage: 'PaymentInvoice'
        };
        this.comments.push(item);
        this.api.post(api.SaveComments(), {
          item: item
        }).then(function (e) {
          _this4.reset();
          _this4.doGetComments();
        });
      }
    }
  }
});

/***/ }),

/***/ "ZPua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content tree",attrs:{"id":_vm.getId}},[_c('div',{staticClass:"rule-wrapper",style:(_vm.indent)},[_c('div',{ref:"ruleRaw",staticClass:"well well-sm"},[(_vm.label === 'IF' && _vm.dragStarted)?_c('div',{staticClass:"dd-overlay",on:{"drop":_vm.drop,"dragover":_vm.allowDrop,"dragleave":_vm.dragLeave}}):_vm._e(),(_vm.label == 'IF')?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Grab to reorder'),expression:"'Grab to reorder'"}],staticClass:"dd-icon",attrs:{"draggable":""},on:{"dragstart":_vm.dragStart,"drag":_vm.dragging,"dragend":_vm.dragEnd}}):_vm._e(),_c('condition',{ref:"conditionLine",attrs:{"conditions":_vm.conditions,"label":_vm.label,"rule":_vm.self,"conditionOptions":_vm.conditionOptions},on:{"updateCondition":_vm.updateCondition,"copyLine":_vm.copyLine,"deleteLine":_vm.deleteLine,"addLine":_vm.addLine,"changeOperator":_vm.changeOperator}},[_c('div',{staticClass:"col-md-1 text-right fas fa-trash-alt pull-right",attrs:{"slot":"delete-condition"},on:{"click":function($event){return _vm.deleteConditionModal()}},slot:"delete-condition"})]),(_vm.actions && _vm.actions[_vm.type.action])?_c('action',{ref:"actionLine",attrs:{"actions":_vm.actions,"rule":_vm.self,"actionOptions":_vm.actionOptions,"routeValues":_vm.routeValues,"useParallelApprovalRoutes":_vm.useParallelApprovalRoutes},on:{"updateAction":_vm.updateAction,"copyLine":_vm.copyActionLine,"deleteLine":_vm.deleteActionLine,"addActionLine":_vm.addActionLine,"changeOperator":_vm.changeActionOperator}},[_c('div',{staticClass:"col-md-1 text-right fas fa-trash-alt pull-right",attrs:{"slot":"delete-action"},on:{"click":function($event){return _vm.deleteActionModal()}},slot:"delete-action"})]):_vm._e(),_c('div',{staticClass:"toolbar"},[_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":function($event){return _vm.addCondition(_vm.con)}}},[_vm._v("ADD CONDITION")]),(_vm.depth < 2)?_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.addRuleGroup}},[_vm._v("ADD RULE GROUP")]):_vm._e(),_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.addAction}},[_vm._v("ADD ACTION")])],1)],1),_vm._l((_vm.list(_vm.children)),function(child){return _c('rule',{key:child,attrs:{"self":child,"children":child.Children && _vm.list(child.Children[_vm.type.rule]),"depth":_vm.depth + 1,"conditions":child.Conditions !== undefined && child.Conditions,"actions":child.Actions !== undefined && child.Actions,"label":"IF","conditionOptions":_vm.conditionOptions,"actionOptions":_vm.actionOptions,"routeValues":_vm.routeValues,"useParallelApprovalRoutes":_vm.useParallelApprovalRoutes}})})],2),_c('ed-modal',{attrs:{"show":_vm.showDeleteIfGroup,"title":"","subtitle":"Are you sure you want to delete this rule group?","primaryButton":"Yes","secondaryButton":"No","type":"small"},on:{"close":function($event){_vm.showDeleteIfGroup = false},"confirm":_vm.deleteConditionGroup}}),_c('ed-modal',{attrs:{"show":_vm.showDeleteThenGroup,"title":"","subtitle":"Are you sure you want to delete this group of actions?","primaryButton":"Yes","secondaryButton":"No","type":"small"},on:{"close":function($event){_vm.showDeleteThenGroup = false},"confirm":_vm.deleteActionGroup}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZSj5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1eHz2gxKucqDMc5rQL6aEt","Dell":"_1RpR1hb6NALYuqjUZ2Zu8J","Abbott":"_26bgE3kDMeWp3NrUl1-kP6","Gap":"_3EEtYhENUgo15q461lkXDX","Allstate":"bFUvK4ml2CCMN03Ok_Din","Asurion":"_2cPKjIXGWjSaGA4-ZkpEe2","Invitae":"_1gOzFy9RnPyYv_bb3sc-TQ","JWE":"yBAjs1xi9fwuwd3LJEaQz"};

/***/ }),

/***/ "ZVSx":
/***/ (function(module, exports) {

module.exports = {"Dashboard":{"alias":"Dashboard","autoHideSubtabs":true,"subtabs":{"Dashboard":{"alias":"MyDashboard","domain":[1]}}},"Invoices":{"label":"Payments","alias":"sent","autoHideSubtabs":true,"subtabs":{"Invoices":{"alias":"sent"}},"domain":[3]},"Programs":{"label":"Payments","alias":"Commerce","pack":{"ProgramList":"Program-list","#QqManageReceivedContract":"Program-received","QqManageContract":"Program-sent","RfpList/ReceivedList":"RFP-received","RfpList/SentList":"RFP-sent","Scope/ScopeList":"Scopes","QqManagePurchaseOrder":"PO-received","QqSentPurchaseOrder":"PO-sent","PurchaseOrderApproval/PurchaseOrderApproval":"PO-approval","PaymentInvoice/POActionRequired":"PO-cta","QqWorkPurchaseOrder":"Work-orders","Expense/Expense":"Expense-list","Expense/ExpenseApprovalQueue":"Expense-approval","PartnerCommission/Commissions":"Commissions","PaymentInvoice/ReceivedInvoiceList":"Invoice-received","PaymentInvoice/SentInvoiceList":"Invoice-sent","AccountPayable/AccountPayableList":"Invoice-AP","PaymentList/PaymentList?screen=PaymentsReceive":"Invoice-payments-received","PaymentList/PaymentList?screen=PaymentsMade":"Invoice-payments-made","FundingInvoiceList/FundingInvoiceList":"Invoice-funding","PaymentInvoice/InvoicePayment":"Invoice-received-cta","PaymentInvoice/InvoicePayment?screen=PaymentsReceived":"Invoice-sent-cta","ClientInvoice/ClientInvoices":"client-invoices","ClientInvoicePayments":"client-invoices-payments","ActionRequired":"client-invoices-cta","EvedPayCards":">Card","EvedPayTransactions":"Card-transactions","EvedPayApproval":"Card-approval"}},"Network":{"alias":"Sourcing"},"Products":{"alias":"Products","allow":{"MyProducts":"all"},"domain":[2,3]},"Reports":{"alias":"AllReports","allow":{"Reports":"all","ApprovalDashboard":"none"}},"Company":{"alias":"Marketing","allow":{"ManageProfile":"all","ApprovalDashboard":"none"},"subscription":"vendorPremium","domain":[1,2,3]},"Admin":{"alias":"Admin","allow":{"ApprovalDashboard":"none"}}}

/***/ }),

/***/ "ZXaR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTransactionInEnvelope_vue__ = __webpack_require__("JdvM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c57c28ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTransactionInEnvelope_vue__ = __webpack_require__("fSiW");
function injectStyle (ssrContext) {
  __webpack_require__("1WsA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c57c28ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTransactionInEnvelope_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c57c28ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTransactionInEnvelope_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZYxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_user__ = __webpack_require__("uduW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addDivisionModal_vue__ = __webpack_require__("gvZX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_string_js__ = __webpack_require__("dCaq");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    addDivisionModal: __WEBPACK_IMPORTED_MODULE_3__addDivisionModal_vue__["default"]
  },
  alias: 'shortcuts-wdg-cmp',
  name: 'shortcuts',
  isApple: false,
  props: {
    widget: Object
  },
  created: function created() {
    var _this = this;
    var vendorId = global.app.$user.$.data && global.app.$user.$.data.VendorID;
    this.isApple = vendorId / 1 === 44764;
    this.companySettings = __WEBPACK_IMPORTED_MODULE_2__core_user__["a" /* default */].getCompanySettings();
    this.init();
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$off('DASHBOARD_READY').$on('DASHBOARD_READY', function () {
      _this.init();
    });
  },
  data: function data() {
    return {
      buttons: [],
      companySettings: {},
      showModal: false,
      showAddDivision: false
    };
  },
  methods: {
    init: function init() {
      var _this2 = this;
      this.api.get(this.widget.endPoint, {}).then(function (r) {
        _this2.buttons = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(r.data);
        if (_this2.isApple) {
          _this2.buttons = _this2.buttons.filter(function (value, index, arr) {
            return value !== 'CreateProgram' && value !== 'CreatePO';
          });
        }
        _this2.$nextTick(function () {
          if (_this2.buttons.length > 4) {
            __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$emit('updateWidgetHeightSimple', {
              wId: _this2.widget.id,
              height: _this2.$el.clientHeight + 6,
              explicitS: 2
            });
          }
        });
      });
    },
    getProgramLabel: function getProgramLabel() {
      return this.companySettings.ProgramLabel ? this.companySettings.ProgramLabel : 'Program';
    },
    getLabel: function getLabel(button) {
      var label = '';
      switch (button) {
        case 'CreateProgram':
          label = 'Create ' + this.getProgramLabel();
          break;
        case 'CreatePO':
          label = 'Create PO';
          break;
        case 'CreateSavingsPO':
          label = 'Create Savings PO';
          break;
        case 'UploadInvoice':
          label = 'Submit Invoice';
          break;
        case 'AddSupplier':
          label = 'Add Supplier';
          break;
        case 'CreateNewDivision':
          label = 'Create new ' + Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_string_js__["a" /* singularize */])(this.$root.getUser.settings.Labels.DivisionName);
          break;
      }
      var words = label.split(' ');
      var shortLabel = words.length > 3 ? words.slice(0, 3).join(' ') + '...' : label;
      return {
        fullText: label,
        shortText: shortLabel
      };
    },
    handleClick: function handleClick(button) {
      var isEmbedded = window.self !== window.top;
      if (isEmbedded && button !== 'CreateNewDivision') {
        window.parent.postMessage({
          type: 'LEGACY_SHORTCUT_CLICK',
          button: button
        }, '*');
        return;
      }
      switch (button) {
        case 'CreateProgram':
          this.$router.push('/i/Programs/Program-list/?goto=ProgramFusion/ProgramInfo');
          break;
        case 'CreatePO':
          this.$router.push('/i/Programs/PO-sent/?goto=ScopeOfService/Detail/0/1/0');
          break;
        case 'CreateSavingsPO':
          this.$router.push('/i/Programs/PO-sent/?goto=ScopeOfService/Detail/0/1/0/0/0?isHotel=1');
          break;
        case 'UploadInvoice':
          this.$router.push('/d/InvoiceToPay/upload?invoiceId=0&from=myDashboard');
          break;
        case 'AddSupplier':
          this.$router.push('/d/Network/add-supplier/');
          break;
        case 'CreateNewDivision':
          this.showAddDivision = true;
          break;
      }
    },
    isVisible: function isVisible(button) {
      return true;
    },
    closeDivisionModal: function closeDivisionModal() {
      this.showAddDivision = false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Zhsm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(!_vm.showCreateEnvelope)?_c('div',[_c('div',{staticClass:"col-md-12 no-pad"},[_c('ed-title-nav',{staticClass:"title-nav",attrs:{"title":_vm.divName ? ("Account: " + _vm.divName) : 'Account: Loading...'}},[(_vm.hasAccountPermission('EvedPayCardViewReconcileClose') || _vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('span',{attrs:{"slot":"action"},slot:"action"},[_c('router-link',{attrs:{"to":{ params: { namespace: 'd', page: 'Programs', section: '>Card', action: undefined } }}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("   "+_vm._s(_vm.$t('BACK') + ' ' + _vm.$t('TO') + ' ' + _vm.$t('EVEDPAY') + ' ' + _vm.$t('CARDS') + ' ' + _vm.$t(_vm.$route.query['back-to'])))])])],1):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"tabs"},slot:"tabs"},[(_vm.divisions.length > 1)?_c('ed-select',{staticClass:"custom-ed-select",attrs:{"placeholder":'Change Account',"options":_vm.divisions,"label":"DivisionName","track-by":"DivisionId","name":"supplier_user"},on:{"input":function (o) {_vm.redirectCardholder(o.AccountId), _vm.selectDivision = []},"open":_vm.getUserDivisions},model:{value:(_vm.selectDivision),callback:function ($$v) {_vm.selectDivision=$$v},expression:"selectDivision"}}):_vm._e()],1)])],1),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('ed-section',{staticClass:"active clear white"},[_c('div',{staticClass:"col-md-12 no-pad"},[_c('div',{staticClass:"col-md-12 no-pad",staticStyle:{"display":"flex","align-items":"center","gap":"5px"}},[(_vm.hasAccountPermission('EvedPayCardViewReconcileClose') || _vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('label',[_c('strong',[_vm._v("EvedPay Card Account")])]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('AddFunding',{staticStyle:{"margin-left":"auto"},attrs:{"accountId":_vm.account.Id},on:{"success":function($event){return _vm.getAccountData()}}}):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{attrs:{"button-class":"btn btn-actionbar"},on:{"click":function () {_vm.accountRefillSettings.Visible = true}}},[_vm._v("\n              Refill Settings\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardViewReconcileClose') || _vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('div',{staticClass:"overview col-md-12 no-pad"},[_c('ed-card',{staticClass:"overview-card",attrs:{"footer-button":"false"}},[(!_vm.hasData)?_c('div',{staticClass:"soft-text loading-text",attrs:{"slot":"body"},slot:"body"},[_c('span'),_vm._v("Loading account summary ...\n              ")]):_vm._e(),_vm._v(" "),(_vm.hasData)?_c('div',{staticClass:"soft-text",staticStyle:{"margin-top":"-20px !important"},attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"custom-col"},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"1.1em","margin-bottom":"10px"}},[_vm._v("\n                    Account Summary\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"custom-col"},[_c('div',[_vm._v("Funded")]),_vm._v(" "),_c('div',[_c('strong',[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.account.Funded))])],1)])]),_vm._v(" "),_c('div',{staticClass:"custom-col"},[_c('div',[_vm._v("\n                    Allocated to cards\n                    "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Includes fees for Rush Orders'),expression:"'Includes fees for Rush Orders'"}],staticStyle:{"margin-bottom":"10px"}},[_c('i',{staticClass:"fas fa-info-circle",style:({ color: '#808080' })})])]),_vm._v(" "),_c('div',[_c('strong',[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.account.Allocated))])],1)])]),_vm._v(" "),_c('div',{staticClass:"custom-col"},[_c('div',[_vm._v("Available")]),_vm._v(" "),_c('div',[_c('strong',[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.account.Available))])],1)])]),_vm._v(" "),_c('div',{staticClass:"custom-col"},[_c('div',[_vm._v("Pending Funding")]),_vm._v(" "),_c('div',[_c('strong',[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.account.Pending))])],1)])]),_vm._v(" "),_c('br')]):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 no-pad",staticStyle:{"display":"flex","align-items":"center","gap":"5px"}},[_c('label',[_c('strong',[_vm._v("EvedPay Cards")])]),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('AddCard',{staticStyle:{"margin-left":"auto"},attrs:{"divisionId":_vm.account.DivisionId,"accountId":_vm.selectedAccountId,"account":_vm.account,"accountSettings":_vm.accountSettings},on:{"success":_vm.handleCardAdditionSuccess}}):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.requestPhysicalBatchActionDisabledReason('requestPhysicalBatch')),expression:"requestPhysicalBatchActionDisabledReason('requestPhysicalBatch')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.requestPhysicalBatchActionDisabledReason('requestPhysicalBatch')},on:{"click":function () {
                        _vm.showRequestPhysicalBatchOpen.showModal = true;
                        _vm.showRequestPhysicalBatchOpen.dataFlag = 'filtered';
                        _vm.showRequestPhysicalBatchOpen.data = _vm.filteredPhysicalCards;
                      }}},[_vm._v("\n              REQUEST PHYSICAL BATCH\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),(_vm.hasData && Number(_vm.account.Funded) === 0)?_c('div',{staticClass:"prefunding-alert"},[_c('div',{staticClass:"prefunding-alert__title"},[_vm._v("Pre-funding Card Limit")]),_vm._v(" "),_c('div',{staticClass:"prefunding-alert__body"},[_vm._v("Up to 30 cards can be added to this account prior to funding.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-container"},_vm._l((_vm.cardsList),function(card,i){return (card)?_c('ed-card',{key:i,class:_vm.cardClass(card),attrs:{"footer-button":"false"}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[(card.Id)?_c('div',[(card.CardStatus === 'Pending Approval' && card.IsApproved === false && card.IsRejected === false && card.WaitingApproval !== null)?[_c('div',{staticClass:"badge",staticStyle:{"background-color":"#6B04B7"}},[_c('p',[_c('i',{staticClass:"fas fa-credit-card"}),_vm._v("  Add Card Request")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("\n                        "+_vm._s(_vm.formatCardHolderLine(card))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"badge",class:{'na': !card.CardStatus, 'Active': card.CardStatus === 'Active', 'Locked': card.CardStatus === 'Locked', 'Closed': card.CardStatus === 'Closed', 'Expired': card.CardStatus === 'Expired', 'PendingApproval': card.CardStatus === 'Pending Approval', 'Inactive': card.CardStatus === 'Inactive'}},[_vm._v("\n                        "+_vm._s(card.CardStatus || 'N/A')+"\n                      ")]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Users that need to approve the card.'),expression:"'Users that need to approve the card.'"}],staticStyle:{"margin-bottom":"10px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleButtonClick(card.Id, false)}}},[_c('i',{staticClass:"fas fa-question-circle",style:({ color: '#DCDC00' })})]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Daily Spend Limit")]),_vm._v(" "),(card.DailySpendLimit === null || card.DailySpendLimit === undefined)?_c('span',[_vm._v("N/A")]):_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.DailySpendLimit))])],1):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Initial Load")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.InitialLoad))])],1):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Refill Amount")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.RefillSettings.RefillAmount))])],1):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Refill Threshold")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.RefillSettings.RefillThreshold))])],1):_vm._e(),_vm._v(" "),(card.ShowApprovalButtons === true)?_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('ed-button',{staticStyle:{"margin-bottom":"10px"},attrs:{"button-class":"btn btn-actionbar alt col-md-12"},on:{"click":function () { return _vm.approveOrReject(card.Id, 'approve'); }}},[_vm._v("\n                          Approve\n                        ")]),_vm._v(" "),_c('RejectCard',{attrs:{"card":card},on:{"success":function (cardId) { _vm.refreshCardWithDetails(cardId); _vm.getAccountData(); }}})],1):_vm._e(),_vm._v(" "),(card.ShowApprovalButtons === false && card.CardStatus === 'Pending Approval')?_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar col-md-12","disabled":_vm.disabledResendButtons[card.Id]},on:{"click":function () { return _vm.resendCardApprovalEmail(card.Id); }}},[_vm._v("\n                          RESEND APPROVAL\n                        ")])],1):_vm._e()]:[_c('div',{class:_vm.cardApprovalColClass(card)},[(_vm.hasData && card.CardStatus !== 'Processing')?_c('div',[_c('CardSettings',{attrs:{"slot":"body","card":card,"account":_vm.account,"accountSettings":_vm.accountSettings,"division":_vm.division},on:{"success":_vm.handleSuccess},slot:"body"})],1):_vm._e(),_vm._v("\n                        **** **** **** "+_vm._s(card.CardNumber)+"\n                        "),_c('div',[_vm._v("\n                          "+_vm._s(_vm.formatCardHolderLine(card))+"\n                        ")]),_vm._v(" "),_c('div',[_vm._v("\n                          Expires "+_vm._s(_vm.formatDate(card.ExpirationDate))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"badge",class:{'na': !card.CardStatus, 'Active': card.CardStatus === 'Active', 'Locked': card.CardStatus === 'Locked', 'Closed': card.CardStatus === 'Closed', 'Expired': card.CardStatus === 'Expired', 'Rejected': card.CardStatus === 'Rejected', 'Declined': card.CardStatus === 'Declined', 'Inactive': card.CardStatus === 'Inactive'}},[_vm._v("\n                          "+_vm._s(card.CardStatus === 'Rejected' ? 'Declined' : (card.CardStatus || 'N/A'))+"\n                        ")]),_vm._v(" "),(card.RejectReason)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Click to see decline reason'),expression:"'Click to see decline reason'"}],staticStyle:{"margin-bottom":"10px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleButtonClickReject(card.Id)}}},[_c('i',{staticClass:"fas fa-info-circle",style:({ color: '#E70404' })})]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(card.ReconciliationDate)?_c('div',{staticStyle:{"font-style":"italic","font-weight":"lighter"}},[_vm._v("\n                          Reconciled up to "+_vm._s(card.FormattedReconciliationDate)+"\n                        ")]):_vm._e(),_vm._v(" "),(card.ReconciliationDate)?_c('hr'):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Initial Load")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.InitialLoad))])],1):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Refills")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.Refills))])],1):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Pending Request")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.PendingRequest))])],1):_vm._e(),_vm._v(" "),(_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Daily Spend Limit")]),_vm._v(" "),(card.DailySpendLimit === null || card.DailySpendLimit === undefined)?_c('span',[_vm._v("N/A")]):_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.DailySpendLimit))])],1):_vm._e(),_vm._v(" "),(_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Today's Spend")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.TodaysSpend))])],1):_vm._e(),_vm._v(" "),(_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Remaining")]),_vm._v(" "),(card.Remaining === null || card.Remaining === undefined)?_c('span',[_vm._v("N/A")]):_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.Remaining))])],1):_vm._e(),_vm._v(" "),(_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Total Spent")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.Spent))])],1):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Spent")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.Spent))])],1):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_c('strong',[_vm._v("Balance")])]),_vm._v(" "),_c('strong',[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.Balance))])],1)]):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding(card))?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Return to Account")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.Returned))])],1):_vm._e()]),_vm._v(" "),(card.PendingRequest > 0)?_c('div',{staticClass:"middleLine",class:_vm.cardApprovalColClass(card)},[_c('div',{staticClass:"badge",staticStyle:{"background-color":"#6B04B7"}},[_c('p',[_c('i',{staticClass:"fas fa-credit-card"}),_vm._v("  Funds Request")])]),_vm._v(" "),_c('br'),_vm._v("\n                        **** **** **** "+_vm._s(card.CardNumber)+"\n                        "),_c('div',[_vm._v("\n                          "+_vm._s(_vm.formatCardHolderLine(card))+"\n                        ")]),_vm._v(" "),_c('div',[_vm._v("\n                          Expires "+_vm._s(_vm.formatDate(card.ExpirationDate))+"\n                        ")]),_vm._v(" "),((card.PendingRequest > _vm.account.Available && card.ShowApprovalButtons === false) || (card.PendingRequest <= _vm.account.Available && (card.ShowApprovalButtons === true || card.ShowApprovalButtons === false)))?_c('div',{staticClass:"badge",class:{'PendingApproval': 'Pending Approval'}},[_vm._v("\n                          "+_vm._s('Pending Approval')+"\n                        ")]):_vm._e(),_vm._v(" "),((card.PendingRequest > _vm.account.Available && card.ShowApprovalButtons === false) || (card.PendingRequest <= _vm.account.Available && (card.ShowApprovalButtons === true || card.ShowApprovalButtons === false)))?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Users that need to approve the card.'),expression:"'Users that need to approve the card.'"}],staticStyle:{"margin-bottom":"10px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleButtonClick(card.Id, false)}}},[_c('i',{staticClass:"fas fa-question-circle",style:({ color: '#DCDC00' })})]):_vm._e(),_vm._v(" "),(card.PendingRequest > _vm.account.Available  && card.ShowApprovalButtons === true)?_c('div',[_c('i',{staticClass:"fas fa-exclamation-triangle",style:({ color: '#DC0000' })}),_vm._v(" "),_c('span',{staticStyle:{"font-style":"italic"}},[_vm._v("Insufficient Funds")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Funds Request")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.PendingRequest))])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),(card.ShowApprovalButtons === true)?_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('approveValidation', card)),expression:"actionDisabledReason('approveValidation', card)"}],staticStyle:{"margin-bottom":"10px"},attrs:{"button-class":"btn btn-actionbar alt col-md-12","disabled":_vm.cardActionDisabled('approveValidation', card)},on:{"click":function () { return _vm.approveOrRejectEvedPayCardFunding(card.Id, 'approve'); }}},[_vm._v("\n                            Approve\n                          ")]),_vm._v(" "),_c('RejectCardFunding',{attrs:{"card":card},on:{"success":function () { return _vm.refreshCardWithDetails(card.Id); }}})],1):_vm._e(),_vm._v(" "),(card.ShowApprovalButtons === false && card.PendingRequest > 0)?_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar col-md-12","disabled":_vm.disabledResendButtons[((card.Id) + "-funding")]},on:{"click":function () { return _vm.resendCardFundingApprovalEmail(card.Id); }}},[_vm._v("\n                            RESEND APPROVAL\n                          ")])],1):_vm._e(),_vm._v(" "),(card.PendingRequest > _vm.account.Available && card.ShowApprovalButtons === false)?_c('div',[_c('i',{staticClass:"fas fa-exclamation-triangle",style:({ color: '#DC0000' })}),_vm._v(" "),_c('span',{staticStyle:{"font-style":"italic"}},[_vm._v("Insufficient Funds")])]):_vm._e()]):_vm._e(),_vm._v(" "),(card.RefillSettings.HasRefillRequest)?_c('div',{staticClass:"middleLine",class:_vm.cardApprovalColClass(card)},[_c('div',{staticClass:"badge",staticStyle:{"background-color":"#6B04B7"}},[_c('p',[_c('i',{staticClass:"fas fa-credit-card"}),_vm._v("  Refill Settings Request")])]),_vm._v(" "),_c('br'),_vm._v("\n                        **** **** **** "+_vm._s(card.CardNumber)+"\n                        "),_c('div',[_vm._v("\n                          "+_vm._s(_vm.formatCardHolderLine(card))+"\n                        ")]),_vm._v(" "),_c('div',[_vm._v("\n                          Expires "+_vm._s(_vm.formatDate(card.ExpirationDate))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"badge",class:{'PendingApproval': 'Pending Approval'}},[_vm._v("\n                          "+_vm._s('Pending Approval')+"\n                        ")]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Users that need to approve the card.'),expression:"'Users that need to approve the card.'"}],staticStyle:{"margin-bottom":"10px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleButtonClick(card.Id, true)}}},[_c('i',{staticClass:"fas fa-question-circle",style:({ color: '#DCDC00' })})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Refill Amount")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.RefillSettings.RefillAmount))])],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Refill Threshold")]),_vm._v(" "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.RefillSettings.RefillThreshold))])],1),_vm._v(" "),_c('hr'),_vm._v(" "),(card.ShowApprovalButtons === true)?_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('ed-button',{staticStyle:{"margin-bottom":"10px"},attrs:{"button-class":"btn btn-actionbar alt col-md-12"},on:{"click":function () { return _vm.approveOrRejectEvedPayCardRefill(card.Id, 'approve'); }}},[_vm._v("\n                            Approve\n                          ")]),_vm._v(" "),_c('RejectCardRefill',{attrs:{"card":card},on:{"success":function () { return _vm.refreshCardWithDetails(card.Id); }}})],1):_vm._e(),_vm._v(" "),(card.ShowApprovalButtons === false && card.RefillSettings.HasRefillRequest)?_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar col-md-12","disabled":_vm.disabledResendButtons[((card.Id) + "-refill")]},on:{"click":function () { return _vm.resendCardRefillApprovalEmail(card.Id); }}},[_vm._v("\n                            RESEND APPROVAL\n                          ")])],1):_vm._e()]):_vm._e(),_vm._v(" "),(card.HasDailySpendLimitRequest)?_c('div',{staticClass:"middleLine",class:_vm.cardApprovalColClass(card)},[_c('div',{staticClass:"badge",staticStyle:{"background-color":"#6B04B7"}},[_c('p',[_c('i',{staticClass:"fas fa-credit-card"}),_vm._v("  Daily Spend Limit Request")])]),_vm._v(" "),_c('br'),_vm._v("\n                        **** **** **** "+_vm._s(card.CardNumber)+"\n                        "),_c('div',[_vm._v("\n                          "+_vm._s(_vm.formatCardHolderLine(card))+"\n                        ")]),_vm._v(" "),_c('div',[_vm._v("\n                          Expires "+_vm._s(_vm.formatDate(card.ExpirationDate))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"badge",class:{'PendingApproval': 'Pending Approval'}},[_vm._v("\n                          "+_vm._s('Pending Approval')+"\n                        ")]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Users that need to approve the card.'),expression:"'Users that need to approve the card.'"}],staticStyle:{"margin-bottom":"10px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleButtonClick(card.Id, true)}}},[_c('i',{staticClass:"fas fa-question-circle",style:({ color: '#DCDC00' })})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v("Daily Spend Limit")]),_vm._v(" "),(card.PendingDailySpendLimit === null || card.PendingDailySpendLimit === undefined)?_c('span',[_vm._v("None")]):_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.PendingDailySpendLimit))])],1),_vm._v(" "),_c('hr'),_vm._v(" "),(card.ShowDailySpendLimitApprovalButtons === true)?_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('ed-button',{staticStyle:{"margin-bottom":"10px"},attrs:{"button-class":"btn btn-actionbar alt col-md-12"},on:{"click":function () { return _vm.approveOrRejectEvedPayCardDailySpendLimit(card.Id); }}},[_vm._v("\n                            Approve\n                          ")]),_vm._v(" "),_c('RejectCardDailySpendLimit',{attrs:{"card":card},on:{"success":function () { return _vm.refreshCardWithDetails(card.Id); }}})],1):_vm._e(),_vm._v(" "),(card.ShowDailySpendLimitApprovalButtons === false && card.HasDailySpendLimitRequest)?_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar col-md-12","disabled":_vm.disabledResendButtons[((card.Id) + "-dsl")]},on:{"click":function () { return _vm.resendCardDailySpendLimitApprovalEmail(card.Id); }}},[_vm._v("\n                            RESEND APPROVAL\n                          ")])],1):_vm._e()]):_vm._e()]],2):_c('div',{staticClass:"empty-holder"},[_c('i',{staticClass:"fas fa-credit-card"}),_vm._v(" "),_c('span',[_c('br'),_vm._v(" "),_c('p',[_vm._v("No cards have been created for this account.")])])])])]):_vm._e()}),1),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardViewReconcileClose') || _vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('div',{staticClass:"overview col-md-12 no-pad"},[_c('ed-card',{staticClass:"overview-card",attrs:{"footer-button":"false"}},[(!_vm.hasData)?_c('div',{staticClass:"soft-text loading-text",attrs:{"slot":"body"},slot:"body"},[_c('span'),_vm._v("Loading transactions summary ...\n              ")]):_vm._e(),_vm._v(" "),(_vm.hasData)?_c('div',{staticClass:"soft-text",staticStyle:{"margin-top":"-20px !important"},attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"custom-col"},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"1.1em","margin-bottom":"10px"}},[_vm._v("\n                    Transactions Summary\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"custom-col"},[_c('div',[_vm._v("\n                    Total Spent\n                    "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Includes fees for Rush Orders'),expression:"'Includes fees for Rush Orders'"}],staticStyle:{"margin-bottom":"10px"}},[_c('i',{staticClass:"fas fa-info-circle",style:({ color: '#808080' })})])]),_vm._v(" "),_c('div',[_c('strong',[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.account.Spent))])],1)])]),_vm._v(" "),_c('div',{staticClass:"custom-col"},[_c('div',[_vm._v("\n                    Open Transactions\n                    "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Open and Pending transactions'),expression:"'Open and Pending transactions'"}],staticStyle:{"margin-bottom":"10px"}},[_c('i',{staticClass:"fas fa-info-circle",style:({ color: '#808080' })})])]),_vm._v(" "),_c('div',[_c('strong',[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.account.OpenTransactionsAmount))])],1)])]),_vm._v(" "),_c('div',{staticClass:"custom-col"},[_c('div',[_vm._v("\n                    Pending Envelopes\n                    "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Envelopes pending approval and pending export'),expression:"'Envelopes pending approval and pending export'"}],staticStyle:{"margin-bottom":"10px"}},[_c('i',{staticClass:"fas fa-info-circle",style:({ color: '#808080' })})])]),_vm._v(" "),_c('div',[_c('strong',[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.account.PendingEnvelopesAmount))])],1)])]),_vm._v(" "),_c('br')]):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"custom-button",class:{ 'active': _vm.showTransactionsTab },on:{"click":_vm.showTransactions}},[_vm._v("Transactions")]),_vm._v(" "),_c('span',{staticClass:"divider"},[_vm._v("|")]),_vm._v(" "),_c('button',{staticClass:"custom-button",class:{ 'active': _vm.showEnvelopesTab },on:{"click":_vm.showEnvelopes}},[_vm._v("Envelopes")]),_vm._v(" "),_c('span',{staticClass:"divider"},[_vm._v("|")]),_vm._v(" "),_c('button',{staticClass:"custom-button",class:{ 'active': _vm.showCardHistoryTab },on:{"click":_vm.showCardHistory}},[_vm._v("Card History")]),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') || _vm.hasAccountPermission('EvedPayCardViewReconcileClose'))?_c('span',{staticClass:"divider"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') || _vm.hasAccountPermission('EvedPayCardViewReconcileClose'))?_c('button',{staticClass:"custom-button",class:{ 'active': _vm.showCardsTab },on:{"click":_vm.showCards}},[_vm._v("\n              Cards\n            ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('span',{staticClass:"divider"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('button',{staticClass:"custom-button",class:{ 'active': _vm.showAccountStatementsTab },on:{"click":_vm.showAccountStatements}},[_vm._v("\n              Statements\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),(_vm.showTransactionsTab)?_c('div',[_c('Grid',{key:_vm.gridTabKey,ref:"grid",attrs:{"name":_vm.$t('EvedPay Cards Transactions'),"desc":"EvedPay Cards Transactions","model":_vm.modelTransactionsAccount,"search":true,"resizing":false,"layout":"frame","endpoint":_vm.api.$.evedpaycard.transactions,"sort":_vm.sort,"views":false,"row-classes":_vm.rowClasses,"footer":"","legacy":"","alias":"EvedPayCardsTransactions","no-tooltip-fields":_vm.noTooltipFields,"filter":_vm.filter,"totals":""},on:{"selectedRows":_vm.rowSelected}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[(_vm.receiptScanEnabled && _vm.accountScanEnabled)?_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.uploadingReceipt},on:{"click":_vm.openReceiptUpload}},[_vm._v("\n                    SUBMIT RECEIPT\n                  ")]):_vm._e(),_vm._v(" "),_c('input',{ref:"receiptUploadInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.handleReceiptFileSelected}}),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('createEnvelope')),expression:"actionDisabledReason('createEnvelope')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.cardActionDisabled('createEnvelope')},on:{"click":_vm.createEnvelope}},[_vm._v("\n                    CREATE ENVELOPE\n                  ")]),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('reconcile')),expression:"actionDisabledReason('reconcile')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.cardActionDisabled('reconcile')},on:{"click":function($event){return _vm.showModal(_vm.showReconcile)}}},[_vm._v("\n                    RECONCILE\n                  ")])],1)])],1):_vm._e(),_vm._v(" "),(_vm.showEnvelopesTab)?_c('div',[_c('grid',{key:_vm.gridTabKey,ref:"grid",attrs:{"name":_vm.$t('EvedPay Cards Envelopes'),"desc":"EvedPay Cards Envelopes","model":_vm.modelEnvelopes,"search":true,"sort":_vm.sortEnvelopes,"resizing":false,"layout":"frame","endpoint":_vm.api.$.evedpaycard.envelopes,"views":false,"row-classes":_vm.rowClasses,"footer":"","totals":"","legacy":"","alias":"EvedPayCardsEnvelopes","no-tooltip-fields":_vm.noTooltipFields,"filter":_vm.filter},on:{"selectedRows":_vm.rowSelected}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[(_vm.showApproveButton)?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('approve')),expression:"actionDisabledReason('approve')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.cardActionDisabled('approve')},on:{"click":function($event){_vm.showApproveDialog = true}}},[_vm._v("\n                    Approve\n                  ")]):_vm._e(),_vm._v(" "),(_vm.showRejectButton)?_c('RejectEnvelope',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('reject')),expression:"actionDisabledReason('reject')"}],attrs:{"disabled":_vm.cardActionDisabled('reject'),"selected-rows":_vm.selectedRows},on:{"success":_vm.refresh}}):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') || _vm.hasAccountPermission('EvedPayCardViewReconcileClose'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.envelopeActionDisabledReason('createAPFile')),expression:"envelopeActionDisabledReason('createAPFile')"}],attrs:{"button-class":"btn btn-actionbar","disabled":_vm.envelopeActionDisabledReason('createAPFile')},on:{"click":_vm.createAPFile}},[_vm._v("\n                    CREATE AP FILE\n                  ")]):_vm._e(),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.envelopeActionDisabledReason('exportEnvelope')),expression:"envelopeActionDisabledReason('exportEnvelope')"}],attrs:{"button-class":"btn btn-actionbar","disabled":_vm.envelopeActionDisabledReason('exportEnvelope')},on:{"click":_vm.exportEnvelope}},[_vm._v("\n                    EXPORT ENVELOPE\n                  ")]),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.envelopeActionDisabledReason('pushToAccountingSystemAction')),expression:"envelopeActionDisabledReason('pushToAccountingSystemAction')"}],attrs:{"button-class":"btn btn-actionbar","disabled":_vm.envelopeActionDisabledReason('pushToAccountingSystemAction')},on:{"click":_vm.pushToAccountingSystem}},[_vm._v("\n                    PUSH TO PSL+\n                  ")]),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('AddTransactionNumber',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.envelopeActionDisabledReason('addTransactionNumber')),expression:"envelopeActionDisabledReason('addTransactionNumber')"}],attrs:{"selected-rows":_vm.selectedRows,"disabled":_vm.envelopeActionDisabled('addTransactionNumber')},on:{"success":_vm.refresh}}):_vm._e()],1)])],1):_vm._e(),_vm._v(" "),(_vm.showCardHistoryTab)?_c('div',[_c('Grid',{key:_vm.gridTabKey,ref:"grid",attrs:{"name":_vm.$t('EvedPay Cards History'),"desc":"EvedPay Cards History","model":_vm.modelCardHistory,"search":true,"resizing":false,"layout":"frame","endpoint":_vm.api.$.evedpaycard.history,"sort":_vm.sortHistory,"views":false,"footer":"","legacy":"","alias":"EvedPayCardsHistory","filter":_vm.filterHistory,"checkboxes":false,"fit-columns":""}})],1):_vm._e(),_vm._v(" "),(_vm.showCardsTab)?_c('div',[_c('grid',{key:_vm.gridTabKey,ref:"grid",attrs:{"name":_vm.$t('EvedPay Cards'),"desc":"EvedPay Cards","model":_vm.modelCardsAccount,"search":"true","sort":_vm.sortCards,"resizing":false,"layout":"frame","endpoint":_vm.api.$.evedpaycard.cards,"views":false,"alias":"EvedPayCards","legacy":"","footer":"","totals":"","filter":_vm.filterCards},on:{"selectedRows":_vm.rowSelected}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[(_vm.hasAccountPermission('EvedPayCardAdministrator') && !_vm.accountSettings.IsPoolFunding)?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('addFunds')),expression:"actionDisabledReason('addFunds')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('addFunds')},on:{"click":function () {_vm.showAddFunds = true}}},[_vm._v("\n                    Add Funds\n                  ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('additionalUsers')),expression:"actionDisabledReason('additionalUsers')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('additionalUsers')},on:{"click":function () {_vm.showCardAdditionalUsers = true}}},[_vm._v("\n                    Additional Users\n                  ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') && !_vm.accountSettings.IsPoolFunding)?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('returnFunds')),expression:"actionDisabledReason('returnFunds')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('returnFunds')},on:{"click":function () {_vm.showReturnFundsToAccount = true}}},[_vm._v("\n                    Return Funds to Account\n                  ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') && !_vm.accountSettings.IsPoolFunding)?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('refillSettings')),expression:"actionDisabledReason('refillSettings')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('refillSettings')},on:{"click":function () { _vm.isRefillOpen.showModal = true }}},[_vm._v("\n                    Refill Settings\n                  ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') && _vm.accountSettings.IsPoolFunding)?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('dailySpendLimit')),expression:"actionDisabledReason('dailySpendLimit')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('dailySpendLimit')},on:{"click":function () { _vm.isDailySpendLimitOpen.showModal = true }}},[_vm._v("\n                    Daily Spend Limit\n                  ")]):_vm._e(),_vm._v(" "),_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('editAccountingSystemSettings')),expression:"actionDisabledReason('editAccountingSystemSettings')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('editAccountingSystemSettings')},on:{"success":_vm.refresh,"click":function () { _vm.showAccountingSystemSettings = true }}},[_vm._v("\n                    PSL+ Settings\n                  ")]),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('holdActivity')),expression:"actionDisabledReason('holdActivity')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('holdActivity')},on:{"click":_vm.lockCard}},[_vm._v("\n                    "+_vm._s(_vm.lockUnlockButtonText)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('reportLostStolen')),expression:"actionDisabledReason('reportLostStolen')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('reportLostStolen')},on:{"click":_vm.lostStolen}},[_vm._v("\n                    Report Lost or Stolen\n                  ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator') || _vm.hasAccountPermission('EvedPayCardViewReconcileClose'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('showCardNumber')),expression:"actionDisabledReason('showCardNumber')"}],staticClass:"btn btn-actionbar",attrs:{"id":_vm.selectedRows,"disabled":_vm.cardActionDisabled('showCardNumber')},on:{"click":function () {_vm.showShowCardNumber = true}}},[_vm._v("\n                    Card Number\n                  ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardAdministrator'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('requestPhysicalCard')),expression:"actionDisabledReason('requestPhysicalCard')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.cardActionDisabled('requestPhysicalCard')},on:{"click":function () {
                              _vm.showRequestPhysicalBatchOpen.showModal = true;
                              _vm.showRequestPhysicalBatchOpen.dataFlag = 'selected';
                              _vm.showRequestPhysicalBatchOpen.data = _vm.selectedRows;
                            }}},[_vm._v("\n                    REQUEST PHYSICAL BATCH\n                  ")]):_vm._e(),_vm._v(" "),(_vm.hasAccountPermission('EvedPayCardViewReconcileClose'))?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('close')),expression:"actionDisabledReason('close')"}],staticClass:"btn btn-actionbar",attrs:{"ids":_vm.selectedRows,"disabled":_vm.cardActionDisabled('close')},on:{"click":_vm.closeCard}},[_vm._v("\n                    Close Card\n                  ")]):_vm._e(),_vm._v(" "),(_vm.showApproveButton && _vm.selectedRows.length)?_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('approve')),expression:"actionDisabledReason('approve')"}],staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.cardActionDisabled('approve')},on:{"click":function($event){_vm.showApproveDialog = true}}},[_vm._v("\n                    Approve\n                  ")]):_vm._e(),_vm._v(" "),(_vm.showRejectButton && _vm.selectedRows.length)?_c('RejectCard',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.actionDisabledReason('reject')),expression:"actionDisabledReason('reject')"}],attrs:{"disabled":_vm.cardActionDisabled('reject'),"selected-rows":_vm.selectedRows,"button-class":_vm.getButtonClass()},on:{"success":function (cardId) { return _vm.refreshCardWithDetails(cardId); }}}):_vm._e()],1)])],1):_vm._e(),_vm._v(" "),(_vm.showAccountStatementsTab)?_c('div',[_c('Grid',{key:_vm.gridTabKey,ref:"grid",attrs:{"name":_vm.$t('EvedPay Cards Account Statements'),"desc":"EvedPay Cards Account Statements","model":_vm.modelAccountStatements,"search":true,"resizing":false,"layout":"frame","endpoint":_vm.api.$.evedpaycard.statements,"sort":_vm.sortStatements,"views":false,"footer":"","legacy":"","alias":"EvedPayCardsAccountStatements","filter":_vm.filterStatements,"checkboxes":false,"fit-columns":""}})],1):_vm._e()])])],1)]):_vm._e(),_vm._v(" "),(_vm.showCreateEnvelope)?_c('CreateEnvelope',{attrs:{"title":"CREATE ENVELOPE","initial-rows":!_vm.showTransactionsTab ? [] : _vm.selectedRows,"editEnvelope":!_vm.showTransactionsTab,"envelope":_vm.envelope},on:{"fields-updated":_vm.handleFieldsUpdated,"success":function($event){_vm.showCreateEnvelope=!_vm.showCreateEnvelope; _vm.selectedRows = []; _vm.envelope = {}; _vm.showEnvelopes()},"backToTransactions":function($event){_vm.showCreateEnvelope=!_vm.showCreateEnvelope; _vm.updateUrlBackToAccountPage(); _vm.selectedRows = []; _vm.envelope = {}}}}):_vm._e(),_vm._v(" "),_c('CandidateSelector',{attrs:{"show":_vm.showCandidateSelector,"receipt-scan-id":_vm.candidateSelectorReceiptId,"candidates":_vm.candidateSelectorCandidates,"row-version":_vm.candidateSelectorRowVersion,"auto-linked":_vm.candidateSelectorAutoLinked,"auto-fill":_vm.candidateSelectorAutoFill,"is-mobile":false,"claim-mode":false,"loading":_vm.candidateSelectorLoading,"local-image-url":_vm.candidateSelectorLocalImageUrl,"local-image-content-type":_vm.candidateSelectorLocalImageType},on:{"match-attempt":_vm.handleMatchAttempt,"match-selected":_vm.handleMatchSelected,"match-error":_vm.handleMatchError,"save-to-folder":_vm.handleSaveToFolder,"close":_vm.handleCandidateSelectorClose}}),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Submit Receipt","show":_vm.showSubmitReceiptModal,"primary-button":"Submit","primaryButtonDisabled":!_vm.pendingReceiptFile || _vm.uploadingReceipt,"type":"medium","validation":""},on:{"close":_vm.closeSubmitReceiptModal,"validate":_vm.confirmSubmitReceipt}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',{staticStyle:{"margin-bottom":"18px","white-space":"nowrap"}},[_vm._v("Upload an image of a receipt and it will be matched to a transaction and coded automatically.")]),_vm._v(" "),(_vm.uploadingReceipt)?[_c('label',[_c('strong',[_vm._v("Uploading")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"8px","padding":"12px 0 24px"}},[_c('div',{staticStyle:{"flex":"1","height":"8px","background":"#F5F5F5","border-radius":"100px","overflow":"hidden"}},[_c('div',{style:({ width: _vm.uploadProgressPct + '%', height: '100%', background: '#1890FF', borderRadius: '100px' })})]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"Roboto, sans-serif","font-size":"14px","line-height":"22px","color":"rgba(0, 0, 0, 0.85)","width":"32px","text-align":"right"}},[_vm._v(_vm._s(_vm.uploadProgressPct)+"%")])])]:[_c('label',[_c('strong',[_vm._v("Receipt")])]),_vm._v(" "),(!_vm.pendingReceiptFile)?_c('div',[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar"},on:{"click":_vm.triggerReceiptFileInput}},[_vm._v("\n            UPLOAD NEW RECEIPT\n          ")])],1):_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"10px","padding":"12px 8px","border-bottom":"1px solid rgba(0,0,0,0.08)","margin-bottom":"28px"}},[_c('i',{staticClass:"fas",class:_vm.pendingReceiptIcon.iconClass,style:({ color: _vm.pendingReceiptIcon.color, fontSize: '18px' })}),_vm._v(" "),_c('a',{staticStyle:{"color":"#4a90e2","text-decoration":"underline","flex":"1","font-size":"12px"},attrs:{"href":_vm.pendingReceiptObjectUrl || undefined,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.pendingReceiptFile.name))]),_vm._v(" "),_c('span',{staticStyle:{"color":"#999","font-size":"12px"}},[_vm._v(_vm._s(_vm.formatFileSize(_vm.pendingReceiptFile.size)))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Remove'),expression:"'Remove'"}],staticStyle:{"line-height":"0"},attrs:{"href":"javascript:;"},on:{"click":_vm.clearPendingReceiptFile}},[_c('i',{staticClass:"fas fa-times-circle",staticStyle:{"color":"#888","font-size":"18px"}})])])]],2)]),_vm._v(" "),_c('ed-modal',{attrs:{"type":_vm.fields && _vm.fields.length > 0 && _vm.fields[0] && _vm.fields[0].length > 0 ? 'extra-large' : 'medium-large',"title":"Reconcile Transaction","show":_vm.showReconcile,"primary-button":(_vm.isUserAdmin || _vm.reconcileAction !== 'view') ? 'Save' : 'false',"primaryButtonDisabled":!_vm.uploadFinished,"secondary-button":"Cancel","validation":""},on:{"close":function($event){_vm.showModal(_vm.showReconcile); _vm.closeReconcile()},"validate":_vm.saveAndReconcile}},[(_vm.transaction && _vm.transaction.data)?_c('Reconcile',{key:_vm.transaction.data.Id,ref:"reconcileComp",attrs:{"slot":"body","transaction":_vm.transaction,"selected-rows":_vm.selectedRows,"fields-incomplete":{ receiptIncomplete: _vm.receiptIncomplete, descriptionIncomplete: _vm.descriptionIncomplete },"reconcile-action":_vm.reconcileAction,"receipt-edit-allowed":_vm.receiptEditAllowed},on:{"reconcile-created":_vm.handleReconcileCreated,"fields-updated":_vm.handleFieldsUpdated,"mediaFilesPathUpdated":_vm.updateMediaFilesPath,"attachmentsUpdated":_vm.updateAttachmentsFiles,"additional-documents-updated":_vm.updateAdditionalDocuments,"split-amounts":_vm.handleSplitAmounts,"description-text":_vm.handleDescriptionText,"uploadFinished":_vm.handleUploadFinished},slot:"body"}):_vm._e()],1),_vm._v(" "),_c('ed-modal',{attrs:{"title":"EvedPay Account Refill Settings","show":_vm.accountRefillSettings.Visible,"primary-button":"Save","primaryButtonDisabled":_vm.accountRefillSettings.ActionDisabled,"validation":""},on:{"close":function($event){_vm.accountRefillSettings.Visible = false, _vm.accountRefillSettings.ActionDisabled = true},"validate":function($event){return _vm.$refs.accountRefillSettingsComponent.save()}}},[_c('AccountRefillSettings',{ref:"accountRefillSettingsComponent",attrs:{"slot":"body","accountId":_vm.$route.query.AccountId},on:{"success":function($event){_vm.accountRefillSettings.Visible = false},"loaded":function($event){_vm.accountRefillSettings.ActionDisabled = false}},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"type":"medium","title":"Approvers List","show":_vm.showApprovalUsers,"primary-button":"Close","secondary-button":"false"},on:{"close":function($event){_vm.showApprovalUsers = false}}},[_c('ApprovalNeededUsers',{attrs:{"slot":"body","approvalUsersData":_vm.approvalUsersData},slot:"body"})],1),_vm._v(" "),_c('ApproveDialog',{attrs:{"showModal":_vm.showApproveDialog,"list":_vm.transformRows(_vm.selectedRows),"programLabel":_vm.programLabel,"cardApproval":_vm.cardApproval,"envelopeApproval":_vm.envelopeApproval},on:{"approve":_vm.doApprove,"close":function () { _vm.showApproveDialog = false }}}),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Card Decline Reason","show":_vm.showCardRejectInfo,"primary-button":"Close","secondary-button":"false"},on:{"close":function($event){_vm.showCardRejectInfo = false}}},[_c('CardRejectInfo',{attrs:{"slot":"body","card":_vm.card},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Card Number","show":_vm.showShowCardNumber,"primary-button":"false","secondary-button":"false","type":"compact"},on:{"close":_vm.closeShowCardNumber}},[_c('ShowCardNumber',{ref:"showCardNumberComponent",attrs:{"slot":"body","card":_vm.cardForShowNumber},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/" + (this.cardStatus)),"title":_vm.modalTitle,"show":_vm.showCardStatus.showModal,"primary-button":"Submit","type":"medium","validation":"","primary-button-disabled":_vm.isCardStatusSubmitDisabled},on:{"close":_vm.closeCardStatusModal,"validate":function($event){return _vm.$refs.cardStatusComponent.changeStatus(_vm.cardStatus, _vm.showCardStatus)}}},[_c('CardStatus',{ref:"cardStatusComponent",attrs:{"slot":"body","status":_vm.cardStatus,"cards":_vm.selectedObj,"is-eved-admin":_vm.isEvedAdmin},on:{"helpDeskTicketNumber":function (v) { return _vm.helpDeskTicketNumber = v; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/add-funds"),"title":"Add Funds","show":_vm.showAddFunds,"validation":"","primary-button":"Add"},on:{"close":function($event){_vm.showAddFunds = false},"validate":_vm.addFunds,"confirm":function($event){return _vm.addfunds()}}},[_c('CardAddFunds',{attrs:{"slot":"body","addFundsError":this.addFundsErrors,"balance":_vm.account.Available},on:{"fundingAmount":function (value) { return _vm.fundingAmount = value; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/additional-users"),"title":"Additional Users","show":_vm.showCardAdditionalUsers,"primary-button":"Save"},on:{"close":function($event){_vm.showCardAdditionalUsers = false},"confirm":_vm.updateAdditionalUsers}},[_c('CardAdditionalUsers',{attrs:{"slot":"body","divisionId":_vm.processedSelectedObj.DivisionId,"cardId":_vm.processedSelectedObj.Id,"cardHolderId":_vm.processedSelectedObj.HolderUserId},on:{"additionalUsers":function (o) { return _vm.additionalUsers = o; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/remove-funds"),"title":"Return Funds to Account","show":_vm.showReturnFundsToAccount,"primary-button":"Submit","validation":""},on:{"close":function($event){_vm.showReturnFundsToAccount = false},"validate":_vm.doReturnFunds,"confirm":function($event){return _vm.doReturnFunds()}}},[_c('ReturnFunds',{attrs:{"slot":"body","card":_vm.processedSelectedObj},on:{"returnFunds":function (value) { return _vm.returnFunds = value; }},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/refill-settings"),"title":"Refill Settings","show":_vm.isRefillOpen.showModal,"primary-button":"Save","validation":""},on:{"close":function($event){_vm.isRefillOpen.showModal = false},"validate":function($event){return _vm.$refs.cardRefillComponent.doRefill(_vm.isRefillOpen)}}},[_c('RefillSettings',{ref:"cardRefillComponent",attrs:{"slot":"body","card":_vm.processedSelectedObj},on:{"refillSuccess":_vm.showRefillToast},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/daily-spend-limit"),"title":"Daily Spend Limit","show":_vm.isDailySpendLimitOpen.showModal,"primary-button":"Save","validation":""},on:{"close":function($event){_vm.isDailySpendLimitOpen.showModal = false},"validate":function($event){return _vm.$refs.cardDailySpendLimitComponent.save(_vm.isDailySpendLimitOpen)}}},[_c('CardDailySpendLimit',{ref:"cardDailySpendLimitComponent",attrs:{"slot":"body","card":_vm.processedSelectedObj},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":("evedpaycards/" + (_vm.processedSelectedObj.Id) + "/accounting-system-settings"),"title":'PSL+ Settings',"primary-button":"Save","show":_vm.showAccountingSystemSettings,"validation":""},on:{"validate":_vm.handlePslSettingsSave,"close":function($event){_vm.showAccountingSystemSettings = false}}},[_c('AccountingSystemSettings',{ref:"accountingSystemSettingsCmp",attrs:{"slot":"body","card":_vm.processedSelectedObj,"accountSettings":_vm.accountSettings},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"modalEndpoint":_vm.api.$.evedpaycard.list,"title":"Request Physical Card Batch","show":_vm.showRequestPhysicalBatchOpen.showModal,"primary-button":"Request","validation":""},on:{"close":function($event){_vm.showRequestPhysicalBatchOpen.showModal = false},"validate":function($event){return _vm.$refs.physicalCardComponent.requestPhysicalCard(_vm.showRequestPhysicalBatchOpen)}}},[_c('RequestPhysicalBatch',{ref:"physicalCardComponent",attrs:{"slot":"body","filteredCards":_vm.showRequestPhysicalBatchOpen.dataFlag === 'filtered' ? _vm.showRequestPhysicalBatchOpen.data : [],"list":_vm.showRequestPhysicalBatchOpen.dataFlag === 'selected' ? _vm.showRequestPhysicalBatchOpen.data : [],"divisionId":_vm.account.DivisionId,"account":_vm.account},on:{"success":_vm.handleRequestPhysicalSuccess},slot:"body"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZndQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rejectReason: '',
      showReject: false
    };
  },
  created: function created() {},
  props: {
    ids: null,
    disabled: false,
    tooltip: '',
    selectedRows: [],
    card: [],
    buttonClass: {
      type: String,
      default: 'btn btn-actionbar col-md-12'
    }
  },
  methods: {
    approveOrRejectCardDailySpendLimit: function approveOrRejectCardDailySpendLimit() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var cardId, payload, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (_this.selectedRows && _this.selectedRows.length > 0) {
                cardId = _this.selectedRows[0].data.Id;
              } else {
                cardId = _this.card.Id;
              }
              payload = {
                cardsData: JSON.stringify([{
                  Id: cardId,
                  RejectReason: _this.rejectReason
                }])
              };
              _context.next = 5;
              return _this.api.post(_this.api.$.evedpaycard.approveOrRejectCardDailySpendLimit, payload);
            case 5:
              response = _context.sent;
              if (response.data) {
                _context.next = 10;
                break;
              }
              throw new Error('Error during the request');
            case 10:
              _this.$emit('success');
            case 11:
              if (response.status === 200) {
                _this.showReject = false;
              }
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ "ZrUL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__("2Bs7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05426d8f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__("/Dpy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05426d8f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a45c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = isMobileWebviewSession;
/**
 * The EvedPay mobile shell loads the /evedpay routes in a webview and owns its own login,
 * so the SPA must never navigate them to the public login page. The persisted open-api
 * token is what separates that shell from a plain browser on the same route, which still
 * has a working login flow to fall back on.
 */
function isMobileWebviewSession() {
  var route = global.app && global.app.$router && global.app.$router.currentRoute;
  var onWebviewRoute = !!(route && route.path && route.path.indexOf('/evedpay') === 0);
  return onWebviewRoute && !!global.localStorage.openApiToken;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "a4Sf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("AHE1");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c25ba08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("stnh");
function injectStyle (ssrContext) {
  __webpack_require__("CJ12")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c25ba08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c25ba08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "a4zV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root",attrs:{"last":_vm.lastEntry}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('span',{class:{'indicator': true, 'red': (_vm.card.Type === 'Invoice - Rush')}},[_vm._v(_vm._s(_vm.card.Type))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.card.NeedsApproval !== 'Card Request' && !_vm.card.NeedsApproval.includes('Card') && !_vm.card.NeedsApproval.includes('ER'))?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Needs Approval")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.NeedsApproval}},[_c('a',{attrs:{"href":_vm.card.NeedsAprovalLink}},[_vm._v(_vm._s(_vm.card.NeedsApproval))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.fullSupplierName)?_c('span',{staticClass:"item-label"},[_vm._v("Supplier")]):_vm._e(),_c('br'),_vm._v(" "),(_vm.fullSupplierName && _vm.card.SupplierLink)?_c('span',{staticClass:"item",attrs:{"title":_vm.fullSupplierName}},[_c('a',{attrs:{"href":_vm.card.SupplierLink}},[_vm._v(_vm._s(_vm.fullSupplierName))])]):_vm._e(),_vm._v(" "),(_vm.fullSupplierName && !_vm.card.SupplierLink)?_c('span',{staticClass:"item",attrs:{"title":_vm.fullSupplierName}},[_vm._v(_vm._s(_vm.fullSupplierName))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-left col-md-3 onHover"},[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar card-btn primary","href":"#","title":"Approve"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('onApprove')}}},[_vm._v("Approve")]),_vm._v(" "),_c('ed-button',{attrs:{"button-class":"btn btn-actionbar card-btn","href":"#","title":_vm.rejectText},on:{"click":function($event){$event.preventDefault();return _vm.$emit('onReject')}}},[_vm._v(_vm._s(_vm.rejectText))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[(_vm.card.StartDate)?_c('div',[_c('span',{staticClass:"item-label full-line"},[_vm._v("Start")]),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.StartDate}},[_vm._v(_vm._s(_vm.card.StartDate))])]):_vm._e(),_vm._v(" "),(String(_vm.card.IsPoolFunding).toLowerCase() === 'true')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Daily Spend Limit")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.DailySpendLimit}},[_vm._v(_vm._s(_vm.card.DailySpendLimit))])]):(_vm.card.Amount && _vm.card.Type === 'Add Card Request')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Initial Amount")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.Amount}},[_vm._v(_vm._s(_vm.card.Amount))])]):_vm._e(),_vm._v(" "),(_vm.card.Amount && _vm.card.Type === 'Funds Request')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Request Amount")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.Amount}},[_vm._v(_vm._s(_vm.card.Amount))])]):_vm._e(),_vm._v(" "),(_vm.card.CardRefillThreshold && _vm.card.Type === 'Refill Settings Request')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Refill Threshold")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.CardRefillThreshold}},[_vm._v(_vm._s(_vm.card.CardRefillThreshold))])]):_vm._e(),_vm._v(" "),(_vm.card.Amount && _vm.card.Type === 'Refill Settings Request')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Refill Amount")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.Amount}},[_vm._v(_vm._s(_vm.card.Amount))])]):_vm._e(),_vm._v(" "),(_vm.card.BudgetBalance && (_vm.card.Type === 'Add Card Request' || _vm.card.Type === 'Funds Request'))?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Budget Balance")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.BudgetBalance}},[_vm._v(_vm._s(_vm.card.BudgetBalance))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.card.Type !== 'Add Card Request' && _vm.card.Type !== 'Funds Request' && _vm.card.Type !== 'Refill Settings Request' && _vm.card.Type !== 'Envelope Approval' && String(_vm.card.IsPoolFunding).toLowerCase() !== 'true')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Amount")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.Amount}},[_vm._v(_vm._s(_vm.card.Amount))])]):_vm._e(),_vm._v(" "),(_vm.card.CardRefillThreshold && _vm.card.Type === 'Add Card Request')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Refill Threshold")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.CardRefillThreshold}},[_vm._v(_vm._s(_vm.card.CardRefillThreshold))])]):_vm._e(),_vm._v(" "),(_vm.card.CardHolder && (_vm.card.Type === 'Funds Request' || _vm.card.Type === 'Refill Settings Request' || _vm.card.Type === 'Envelope Approval'))?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Card Holder")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item item--holder",attrs:{"title":_vm.holderDisplay}},[_vm._v(_vm._s(_vm.holderDisplay))])]):_vm._e(),_vm._v(" "),(_vm.card.CardRefillAmount && _vm.card.Type === 'Add Card Request')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Refill Amount")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.CardRefillAmount}},[_vm._v(_vm._s(_vm.card.CardRefillAmount))])]):_vm._e(),_vm._v(" "),(_vm.card.CardNumber && (_vm.card.Type === 'Funds Request' || _vm.card.Type === 'Refill Settings Request' || _vm.card.Type === 'Envelope Approval'))?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Card Number")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.CardNumber}},[_vm._v(_vm._s(_vm.card.CardNumber))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.card.Type !== 'Add Card Request' && _vm.card.Type !== 'Funds Request' && _vm.card.Type !== 'Refill Settings Request')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.programLabel))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.ProgramName}},[_c('a',{attrs:{"href":_vm.card.ProgramLink}},[_vm._v(_vm._s(_vm.card.ProgramName))])])]):_vm._e(),_vm._v(" "),(_vm.card.DivisionName && (_vm.card.Type === 'Refill Settings Request' || _vm.card.Type === 'Envelope Approval'))?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.divisionLabel))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.DivisionName}},[_vm._v(_vm._s(_vm.card.DivisionName))])]):_vm._e(),_vm._v(" "),(_vm.card.CardHolder && _vm.card.Type === 'Add Card Request')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Card Holder")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item item--holder",attrs:{"title":_vm.holderDisplay}},[_vm._v(_vm._s(_vm.holderDisplay))])]):_vm._e(),_vm._v(" "),(_vm.card.CardRequestedBy && (_vm.card.Type === 'Add Card Request' || _vm.card.Type === 'Funds Request' || _vm.card.Type === 'Refill Settings Request'))?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Requested By")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.CardRequestedBy}},[_vm._v(_vm._s(_vm.card.CardRequestedBy))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.card.ProgramOwner)?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.programLabel)+" Owner")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.ProgramOwner}},[_vm._v(_vm._s(_vm.card.ProgramOwner))])]):_vm._e(),_vm._v(" "),(_vm.card.EnvelopeNumber && _vm.card.Type === 'Envelope Approval')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Envelope")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.EnvelopeNumber}},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.openEnvelope()}}},[_vm._v(_vm._s(_vm.card.EnvelopeNumber))])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[(_vm.card.EndDate)?_c('div',[_c('span',{staticClass:"item-label full-line"},[_vm._v("End")]),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.EndDate}},[_vm._v(_vm._s(_vm.card.EndDate))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.card.BudgetBalance && _vm.card.Type !== 'Add Card Request' && _vm.card.Type !== 'Funds Request')?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v("Budget Balance")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.BudgetBalance}},[_vm._v(_vm._s(_vm.card.BudgetBalance))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.card.ProgramID)?_c('div',[_c('span',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.programLabel)+" Id")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.ProgramID}},[_c('a',{attrs:{"href":_vm.card.ProgramLink}},[_vm._v(_vm._s(_vm.card.ProgramID))])])]):_vm._e()]),_vm._v(" "),(_vm.useMeetingRequestor)?_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.meetingRequesterName))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item",attrs:{"title":_vm.card.MainContactColumnName}},[_vm._v(_vm._s(_vm.card.MainContactColumnName))])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a6om":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_vue__ = __webpack_require__("kHcj");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e516b6a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_create_vue__ = __webpack_require__("KmXa");
function injectStyle (ssrContext) {
  __webpack_require__("P68F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e516b6a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "a8Xb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routeOldLinks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__("NM/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_legacy_auth_gotoV3__ = __webpack_require__("UYvm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json__ = __webpack_require__("ZVSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redirect_map_json__ = __webpack_require__("OQaH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redirect_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__redirect_map_json__);




// URL redirect mappings
// Keys can contain :id or other parameters which will be extracted and replaced

var DEFAULT_TAB = 'payments';
var DEFAULT_SUBTAB = 'ProgramList';
var isEmbedded = window.self !== window.top;

/**
 * Attempts to match a route path against redirect patterns
 * @param {string} routePath - The current route path
 * @returns {string|null} - The redirect URL or null if no match
 */
function matchRedirectPattern(_routePath) {
  var routePath = decodeURIComponent(_routePath);
  var _loop = function _loop() {
      var _Object$entries$_i = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_Object$entries[_i], 2),
        pattern = _Object$entries$_i[0],
        redirectTo = _Object$entries$_i[1];
      // Convert pattern to regex, replacing :id with capture group
      var regexPattern = pattern.replace(/\//g, '\\/').replace(/:id/g, '(\\d+)').replace(/:(\w+)/g, '([^/]+)');
      var regex = new RegExp(regexPattern);
      var match = routePath.match(regex);
      if (match) {
        // Replace placeholders in redirect URL with captured values
        var redirectUrl = redirectTo;
        var paramNames = (pattern.match(/:\w+/g) || []).map(function (p) {
          return p.slice(1);
        });
        paramNames.forEach(function (paramName, index) {
          redirectUrl = decodeURIComponent(redirectUrl.replace(":".concat(paramName), match[index + 1].replace('--', '/')));
        });

        // if redirectUrl contains multiple '?' replace all but the first with '&'
        var parts = redirectUrl.split('?');
        if (parts.length > 2) {
          redirectUrl = parts[0] + '?' + parts.slice(1).join('&');
        }
        return {
          v: redirectUrl
        };
      }
    },
    _ret;
  for (var _i = 0, _Object$entries = Object.entries(__WEBPACK_IMPORTED_MODULE_3__redirect_map_json___default.a); _i < _Object$entries.length; _i++) {
    _ret = _loop();
    if (_ret) return _ret.v;
  }
  return null;
}
function routeOldLinks(route) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var _isEmbedded = arguments.length > 2 ? arguments[2] : undefined;
  if (typeof _isEmbedded !== 'undefined' ? _isEmbedded : isEmbedded) return;
  var _route$path$split$fil = route.path.split('/').filter(Boolean),
    _route$path$split$fil2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_route$path$split$fil, 1),
    firstSegment = _route$path$split$fil2[0];
  var _route$params = route.params,
    page = _route$params.page,
    section = _route$params.section;
  var url;
  var tab;
  var subTab;
  var _path;
  page = page || firstSegment;
  if (path) {
    _path = path.split('evednetwork/')[1];
  } else {
    var webUrl = window.location.href;
    var _newUrl = new URL(webUrl);
    _newUrl.hash = '';
    // _path = `${newUrl}#${route.fullPath}`
    _path = '#' + decodeURIComponent("".concat(route.fullPath));
  }

  // Check if route matches any redirect pattern
  var redirectMatch = matchRedirectPattern(path || route.fullPath);
  if (redirectMatch) {
    var _redirectMatch$split = redirectMatch.split('?'),
      _redirectMatch$split2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_redirectMatch$split, 2),
      redirectPath = _redirectMatch$split2[0],
      queryString = _redirectMatch$split2[1];
    var redirectUrl = "/".concat(redirectPath).concat(queryString ? '?' + queryString : '');
    var initialQueryString = route.fullPath.split('?')[1] || '';
    if (!queryString) {
      redirectUrl += "?".concat(initialQueryString);
    }
    var _newUrl2 = new URL(__WEBPACK_IMPORTED_MODULE_1__core_legacy_auth_gotoV3__["c" /* newLocation */].call(this));
    _newUrl2.hash = redirectUrl;
    if (_isEmbedded === false) {
      window.top.location.href = _newUrl2.href;
      return;
    }
    window.location.href = _newUrl2.href;
    return;
  }
  var hasReturnUrl = this.$router.currentRoute.query.returnUrl || this.$routerHistory.previous().path && this.$routerHistory.previous().path.indexOf('returnUrl') >= 0;
  // if (document.referrer || hasReturnUrl) return
  if (hasReturnUrl || this.$router.currentRoute.query.sk) return;
  switch (page) {
    case 'Programs':
      tab = 'payments';
      break;
    default:
      tab = DEFAULT_TAB;
  }
  var siteMap = (__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[page] || {}).pack || {};
  var subTabs = Object.keys(siteMap);
  subTab = subTabs.find(function (st) {
    return (siteMap[st].name || '').toLowerCase() === (section || '').toLowerCase();
  });
  subTab = subTab || DEFAULT_SUBTAB;
  var querySrc = path ? "path=".concat(_path) : "v2=".concat(encodeURIComponent(_path));
  url = "/".concat(tab, "/").concat(subTab, "?").concat(querySrc);
  if ((!tab || !subTab) && !_path) {
    return;
  }
  var newUrl = new URL(__WEBPACK_IMPORTED_MODULE_1__core_legacy_auth_gotoV3__["c" /* newLocation */].call(this));
  newUrl.hash = url;

  // window.location.href = newUrl.href
}

/***/ }),

/***/ "aC/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-avatar--wrapper",style:([_vm.style, _vm.customStyle]),attrs:{"aria-hidden":"true"}},[(this.isImage)?_c('img',{staticStyle:{"display":"none"},attrs:{"src":this.src},on:{"error":_vm.onImgError}}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!this.isImage),expression:"!this.isImage"}]},[_vm._v(_vm._s(_vm.userInitial))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aISH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_5IPKHEucmOJ9dUHFyDq2c","Dell":"_3hUQb5SXSikabvNP0G3dGm","Abbott":"_25TEi_J3Ww1LDS8rER-F-8","Gap":"_3Q6qHRSp1g275gH0Msy8jb","Allstate":"_3q-BKwuGsDLEZ7cSfXBqtJ","Asurion":"_3Fn1MzuOieF_Fdsxp93QaR","Invitae":"_2tFU6P7w88EhhVNHzXUH3a","JWE":"_1opZIGBX3GToXbchC610NA"};

/***/ }),

/***/ "aLD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkboxProxy_vue__ = __webpack_require__("L8OT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d004131_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkboxProxy_vue__ = __webpack_require__("Q8hK");
function injectStyle (ssrContext) {
  __webpack_require__("POux")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d004131"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkboxProxy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d004131_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkboxProxy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aPPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticStyle:{"margin-bottom":"10px"},attrs:{"button-class":"btn btn-actionbar","ids":_vm.ids,"disabled":_vm.disabled},on:{"click":function($event){return _vm.showModal(_vm.showReject)}}},[_vm._v("\n    Decline\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"title":("Decline " + (_vm.envelopeTerm.singular)),"show":_vm.showReject,"primary-button":"Decline","primaryButtonClass":"btn btn-danger","loading":_vm.isRejecting},on:{"close":_vm.closeModal,"confirm":_vm.approveOrReject}},[_c('div',{staticClass:"reject-envelope-overlay",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Provide a reason for declining the "+_vm._s(_vm.envelopeTerm.lower)+".")]),_vm._v(" "),_c('label',[_vm._v("Reason")]),_vm._v(" "),_c('ed-input',{attrs:{"type":"text","disabled":_vm.isRejecting},on:{"input":function (value) { return _vm.rejectReason = value; }},model:{value:(_vm.rejectReason),callback:function ($$v) {_vm.rejectReason=$$v},expression:"rejectReason"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aQ4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"formRef"},[(_vm.isMobile && _vm.uploadingScanOverlay)?_c('div',{staticClass:"receipt-scan-overlay"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"reconcile-transaction-overlay col-md-12"},[_c('p',{staticClass:"small"},[_vm._v("Add coding and receipt.")]),_vm._v(" "),(_vm.isInEnvelope)?_c('ed-notice',{staticClass:"in-envelope-notice",attrs:{"type":"alt","icon":"fas fa-info-circle"}},[_vm._v("\n      This transaction is currently assigned to envelope "+_vm._s(_vm.transaction.data.EnvelopeNumber)+".\n      "),(_vm.envelopePostedOrExported)?_c('span',[_vm._v("Editing is no longer available because the envelope has been "+_vm._s(_vm.envelopeBlockedStateLabel)+".")]):(_vm.reconcileAction === 'view')?_c('span',[_vm._v("You don't have permission to edit this transaction from here.")]):_c('span',[_vm._v("The "+_vm._s(_vm.programName.toLowerCase())+" cannot be changed while the transaction is assigned to an envelope.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"overview col-md-12 no-pad"},[_c('ed-card',{staticClass:"overview-card col-md-12",attrs:{"footer-button":"false"}},[_c('div',{staticClass:"soft-text",attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"col-md-2"},[_c('strong',[_vm._v("Card number")]),_vm._v(" "),_c('div',[_c('div',[_vm._v("\n                *"+_vm._s(_vm.transaction.data.CardNumber)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('strong',[_vm._v("Card Holder")]),_vm._v(" "),_c('div',[_c('div',[_vm._v("\n                "+_vm._s(_vm.formatHolderLine(_vm.transaction.data))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Merchant")]),_vm._v(" "),_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.transaction.data.Merchant),expression:"transaction.data.Merchant"}]},[_c('div',{staticClass:"overflow-merchant"},[_vm._v(_vm._s(_vm.transaction.data.Merchant))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('strong',[_vm._v("Date")]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(_vm.formatDate(_vm.transaction.data.TransactionDate)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('strong',[_vm._v("Amount")]),_vm._v(" "),_c('div',[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.transaction.data.Amount))])],1)]),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{staticClass:"middle-band col-md-12 no-pad"},[_c('div',{staticClass:"middle-band-left no-pad col-md-6"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"20px"}},[_c('strong',[_vm._v(_vm._s(_vm.programName))]),_vm._v(" "),_c('ed-select',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.reconcileAction !== 'view' && _vm.transaction.data.TransactionStatus === 'In Envelope' ?
                      ("This transaction is part of an envelope. You can now only change the " + (_vm.programName.toLowerCase()) + " from the envelope.") : ''),expression:"reconcileAction !== 'view' && transaction.data.TransactionStatus === 'In Envelope' ?\n                      `This transaction is part of an envelope. You can now only change the ${ programName.toLowerCase() } from the envelope.` : ''"}],attrs:{"placeholder":("Select a " + (_vm.programName.toLowerCase()) + "..."),"options":_vm.programLoader.items,"track-by":"Id","value":_vm.selectedProgram,"checkboxes":false,"customLabel":function (option) { return option && option.Name ? (option.InternalProgramID ? ((option.Name) + " (" + (option.InternalProgramID) + ")") : option.Name) : ''; },"server-search":"","name":"program","disabled":_vm.reconcileAction === 'view' || (_vm.reconcileAction !== 'view' && _vm.transaction.data.TransactionStatus === 'In Envelope')},on:{"open":_vm.onSelectProgramOpen,"scroll-bottom":function () { return _vm.loadPrograms(false); },"search":_vm.onProgramSearch,"input":_vm.handleProgramInput},model:{value:(_vm.selectedProgram),callback:function ($$v) {_vm.selectedProgram=$$v},expression:"selectedProgram"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('strong',[_vm._v("Supplier")]),_vm._v(" "),_c('ed-select',{staticClass:"custom-dropdown-supplier",attrs:{"placeholder":_vm.supplierPlaceholder,"options":_vm.supplierOptions,"value":_vm.selectedSupplier,"checkboxes":false,"customLabel":_vm.getLabel,"required":"","server-search":"","disabled":true},on:{"open":_vm.fetchSuppliersOnOpen,"search":_vm.fetchSuppliers,"select":_vm.getSelectedSupplier,"input":_vm.handleSupplierSelection},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('ed-select-options',{attrs:{"thumbnails":""}},[_c('div',{staticClass:"option-combo-img",attrs:{"slot":"row1"},slot:"row1"},[_c('img',{attrs:{"slot":"image","src":props.option.Value.Logo,"width":"48"},slot:"image"})]),_vm._v(" "),_c('div',{staticClass:"no-wrap",attrs:{"slot":"row2"},slot:"row2"},[_c('span',{staticClass:"option-strong"},[_c('strong',[_vm._v(_vm._s(_vm.he.decode(props.option.Value.CompanyName))+" ")])]),_vm._v(" "),_c('em',{staticClass:"option-em"},[_vm._v("("+_vm._s(props.option.Value.Vci)+")")]),_vm._v(" "),_c('br'),_vm._v(" "),(props.option.Value.SupplierName)?_c('span',{staticClass:"option-bold"},[_vm._v(" "+_vm._s(_vm.he.decode(props.option.Value.SupplierName)))]):_vm._e(),_vm._v(" "),(props.option.Value.SupplierRequestedName)?_c('span',[_c('br'),_vm._v(" "),_c('i',[_vm._v(_vm._s(props.option.Value.SupplierRequestedName))])]):_vm._e(),_vm._v(" "),(props.option.Value.CountryName)?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"fas fa-map-marker-alt contact-icon"}),_vm._v("  "+_vm._s(props.option.Value.City + (props.option.Value.State != '' && props.option.Value.State != null ? ' ' + props.option.Value.State : (props.option.Value.Region != '' && props.option.Value.Region != null ? ' ' + props.option.Value.Region : '')) + ' ' + props.option.Value.CountryName)+"\n                  ")]):_vm._e(),_vm._v(" "),(props.option.Value.BusinessType)?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"fas fa-briefcase contact-icon"}),_vm._v("  "+_vm._s(props.option.Value.BusinessType)+"\n                  ")]):_vm._e(),_vm._v(" "),(props.option.Value.SupplierEmail)?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"fas fa-envelope contact-icon"}),_vm._v("  "+_vm._s(props.option.Value.SupplierEmail)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(props.option.Value.IsEvedPay)?_c('span',{staticClass:"label supplier-evedpay"},[_vm._v("EvedPay Ready")]):_vm._e(),_vm._v(" "),(props.option.Value.VendorType)?_c('span',{staticClass:"label",class:[("supplier-type-" + (props.option.Value.VendorType))]},[_vm._v(_vm._s(props.option.Value.VendorType)+" Supplier")]):_vm._e()])])]}}]),model:{value:(_vm.selectedSupplier),callback:function ($$v) {_vm.selectedSupplier=$$v},expression:"selectedSupplier"}}),_vm._v(" "),_c('div',{staticClass:"clear"})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 description-field"},[_c('strong',[_vm._v("Description "),(!this.requireReceiptDescription)?_c('span',{staticClass:"optional-text"},[_vm._v("- optional")]):_vm._e()]),_vm._v(" "),_c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.noteText),expression:"noteText"}],staticClass:"description-textarea",attrs:{"rows":"4","disabled":_vm.reconcileAction === 'view'},domProps:{"value":(_vm.noteText)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.noteText=$event.target.value},_vm.handleTextDescription]}}),_vm._v(" "),(_vm.fieldsIncomplete.descriptionIncomplete)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("Please add a description.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 receipt-section",class:{ loading: _vm.receiptUploadInProgress }},[_c('strong',[_vm._v("Receipt")]),_vm._v(" "),(!_vm.receiptScanEnabled)?_c('div',{staticClass:"receipt-upload-legacy"},[_c('ed-upload',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(!_vm.receiptEditAllowed ? _vm.permissionTooltip : ''),expression:"!receiptEditAllowed ? permissionTooltip : ''"}],class:{loading: !_vm.uploadFinished},attrs:{"button-label":"Upload New Receipt","button-position":"bottom","disabled":!_vm.receiptEditAllowed,"readonly":"","multiple":true,"postAction":_vm.api.env + _vm.api.$.evedpaycard.receipt,"uploadAuto":true,"canOpenFile":true,"headers":{Authorization: "Bearer " + _vm.uploadData.token},"name":"attachment_upload","accept":"application/pdf, image/png, image/jpeg","extensions":"pdf,png,jpg,jpeg","xtarget":"transactionAttachment"},on:{"input":_vm.createAttachments,"open-file":_vm.openAttachment},model:{value:(_vm.attachedFiles),callback:function ($$v) {_vm.attachedFiles=$$v},expression:"attachedFiles"}})],1):_vm._e(),_vm._v(" "),(_vm.receiptScanEnabled && _vm.hasAttachment)?_c('div',{staticClass:"receipt-file-chip"},[_c('i',{staticClass:"fas",class:_vm.primaryAttachmentIconClass}),_vm._v(" "),_c('a',{staticClass:"receipt-file-chip-name",attrs:{"href":_vm.previewUrl || undefined,"target":"_blank","rel":"noopener"},on:{"click":_vm.openPrimaryAttachment}},[_vm._v(_vm._s(_vm.previewFileName))]),_vm._v(" "),_c('span',{staticClass:"receipt-file-chip-size"},[_vm._v(_vm._s(_vm.formatBytes(_vm.primaryAttachment && _vm.primaryAttachment.size, 0)))]),_vm._v(" "),(_vm.receiptEditAllowed)?_c('a',{staticClass:"receipt-file-chip-remove",attrs:{"href":"javascript:;","aria-label":"Remove receipt"},on:{"click":_vm.removePrimaryAttachment}},[_c('i',{staticClass:"fas fa-times-circle"})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.receiptScanEnabled && _vm.uploadingReceipt && _vm.reconcileAction !== 'view')?_c('div',{staticClass:"receipt-upload-progress"},[_c('div',{staticClass:"receipt-upload-progress-track"},[_c('div',{staticClass:"receipt-upload-progress-fill",style:({ width: _vm.uploadProgressPct + '%' })})]),_vm._v(" "),_c('span',{staticClass:"receipt-upload-progress-label"},[_vm._v(_vm._s(_vm.uploadProgressPct)+"%")])]):_vm._e(),_vm._v(" "),(_vm.receiptScanEnabled)?_c('div',{staticClass:"receipt-scan-actions"},[(!_vm.receiptCaptureDisabled && _vm.receiptScanModeLoaded)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(!_vm.receiptEditAllowed ? _vm.permissionTooltip : (_vm.hasAttachment ? 'Remove the current receipt to upload a different one' : '')),expression:"!receiptEditAllowed ? permissionTooltip : (hasAttachment ? 'Remove the current receipt to upload a different one' : '')"}]},[_c('button',{staticClass:"receipt-action-button",attrs:{"type":"button","disabled":!_vm.receiptEditAllowed || _vm.hasAttachment},on:{"click":_vm.openFolderPicker}},[_vm._v("Add from receipt folder")])]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(!_vm.receiptEditAllowed ? _vm.permissionTooltip : (_vm.hasAttachment ? 'Remove the current receipt to upload a different one' : '')),expression:"!receiptEditAllowed ? permissionTooltip : (hasAttachment ? 'Remove the current receipt to upload a different one' : '')"}]},[_c('button',{staticClass:"receipt-action-button",attrs:{"type":"button","disabled":!_vm.receiptEditAllowed || _vm.hasAttachment},on:{"click":_vm.uploadNewReceipt}},[_vm._v("Upload new receipt")])])]):_vm._e(),_vm._v(" "),(_vm.receiptScanEnabled && !_vm.receiptCaptureDisabled && _vm.receiptReplacedPendingRescan && _vm.reconcileAction !== 'view')?_c('div',{staticClass:"replace-coding-alert"},[_c('span',{staticClass:"replace-coding-alert-text"},[_vm._v(_vm._s(_vm.replaceCodingMessage))]),_vm._v(" "),_c('a',{staticClass:"replace-coding-alert-action",attrs:{"href":"javascript:;"},on:{"click":_vm.rescanReceipt}},[_vm._v(_vm._s(_vm.replaceCodingActionLabel))])]):_vm._e()]),_vm._v(" "),(_vm.receiptScanEnabled && !_vm.isMobile)?_c('div',{staticClass:"col-md-12 additional-documents",class:{ loading: _vm.documentUploadInProgress }},[_c('strong',[_vm._v("Additional Documents")]),_vm._v(" "),_vm._l((_vm.additionalDocuments),function(doc,docIndex){return _c('div',{key:("doc-" + docIndex),staticClass:"receipt-file-chip"},[_c('i',{staticClass:"fas",class:_vm.documentIconClass(doc)}),_vm._v(" "),_c('a',{staticClass:"receipt-file-chip-name",attrs:{"href":doc.path || undefined,"target":"_blank","rel":"noopener"},on:{"click":function($event){return _vm.openDocument(doc, $event)}}},[_vm._v(_vm._s(doc.name))]),_vm._v(" "),_c('span',{staticClass:"receipt-file-chip-size"},[_vm._v(_vm._s(_vm.formatBytes(doc.size, 0)))]),_vm._v(" "),(_vm.canManageReceipts)?_c('a',{staticClass:"receipt-file-chip-remove",attrs:{"href":"javascript:;","aria-label":"Remove document"},on:{"click":function($event){return _vm.removeDocument(docIndex)}}},[_c('i',{staticClass:"fas fa-times-circle"})]):_vm._e()])}),_vm._v(" "),(_vm.canManageReceipts)?_c('div',{staticClass:"receipt-scan-actions"},[_c('button',{staticClass:"receipt-action-button",attrs:{"type":"button"},on:{"click":_vm.uploadNewDocument}},[_vm._v("Upload file")])]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.receiptScanEnabled && _vm.isMobile)?_c('div',{staticClass:"col-md-12 additional-documents",class:{ loading: _vm.documentUploadInProgress }},[_c('strong',[_vm._v("Additional Documents")]),_vm._v(" "),_vm._l((_vm.additionalDocuments),function(doc,docIndex){return _c('div',{key:("mdoc-" + docIndex),staticClass:"receipt-file-chip"},[_c('i',{staticClass:"fas",class:_vm.documentIconClass(doc)}),_vm._v(" "),_c('a',{staticClass:"receipt-file-chip-name",attrs:{"href":doc.path || undefined,"target":"_blank","rel":"noopener"},on:{"click":function($event){return _vm.openDocument(doc, $event)}}},[_vm._v(_vm._s(doc.name))]),_vm._v(" "),_c('span',{staticClass:"receipt-file-chip-size"},[_vm._v(_vm._s(_vm.formatBytes(doc.size, 0)))]),_vm._v(" "),(_vm.canManageReceipts)?_c('a',{staticClass:"receipt-file-chip-remove",attrs:{"href":"javascript:;","aria-label":"Remove document"},on:{"click":function($event){return _vm.removeDocument(docIndex)}}},[_c('i',{staticClass:"fas fa-times-circle"})]):_vm._e()])}),_vm._v(" "),(_vm.canManageReceipts)?_c('div',{staticClass:"receipt-scan-actions"},[_c('button',{staticClass:"receipt-action-button",attrs:{"type":"button"},on:{"click":_vm.uploadNewDocument}},[_vm._v("UPLOAD FILE")])]):_vm._e()],2):_vm._e()]),_vm._v(" "),(_vm.hasAttachment)?_c('div',{staticClass:"middle-band-right col-md-6 no-pad"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"receipt-preview-panel"},[_c('strong',{staticClass:"receipt-preview-label"},[_vm._v("Receipt")]),_vm._v(" "),_c('ReceiptImageViewer',{attrs:{"image-url":_vm.previewUrl,"content-type":_vm.primaryAttachment && _vm.primaryAttachment.type}})],1)])]):_vm._e()]),_vm._v(" "),(_vm.amountMismatch && _vm.reconcileAction !== 'view')?_c('div',{staticClass:"amount-mismatch-banner"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" "),_c('span',[_vm._v("Amount mismatch — please review your coding.")])]):_vm._e(),_vm._v(" "),(_vm.form)?_c('div',{staticClass:"col-md-12 no-pad coding-section"},[_c('strong',[_vm._v("Coding")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 no-pad"},[_c('table',{staticClass:"full-width-table"},[_c('thead',[_c('tr',[(_vm.reconcileAction !== 'view')?_c('th'):_vm._e(),_vm._v(" "),(_vm.receiptScanEnabled)?_c('th',{staticClass:"description-col"},[_vm._v("Description")]):_vm._e(),_vm._v(" "),(_vm.hasBu && !_vm.hasBuAndCcPair)?_c('th',[_vm._v("Business Units")]):_vm._e(),_vm._v(" "),(_vm.hasCc && !_vm.hasBuAndCcPair)?_c('th',[_vm._v("Cost Centers")]):_vm._e(),_vm._v(" "),(_vm.hasBuAndCcPair)?_c('th',[_vm._v("Bu & Cc")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Category")]),_vm._v(" "),_c('th',[_vm._v("Category Ref ID")]),_vm._v(" "),_vm._l((_vm.form[0]),function(field,index){return _c('th',{key:index},[(field.Key !== 'Amount')?_c('span',[_vm._v(_vm._s(field.Label))]):_vm._e(),_vm._v(" \n              ")])}),_vm._v(" "),_c('th',{staticClass:"amount-col"},[_vm._v("Amount")])],2)]),_vm._v(" "),_c('tbody',[(_vm.codingRowsLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.form),function(row,rowIndex){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.codingRowsLoading),expression:"!codingRowsLoading"}],key:("form-row-" + rowIndex + "-" + _vm.splitCounter)},[(_vm.reconcileAction !== 'view')?_c('td',{staticClass:"split-buttons"},[_c('a',{staticClass:"button row-action",attrs:{"href":"javascript:;"},on:{"click":function($event){(!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) ? _vm.showWarningMessage(("Please select a " + (_vm.programName.toLowerCase()) + " before adding items")) : _vm.toggleSplit(rowIndex)}}},[_vm._v("\n                  + Split\n                ")]),_vm._v("\n                 \n                "),_c('a',{staticClass:"button row-action",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.copySplit(rowIndex)}}},[_vm._v("\n                  Copy\n                ")]),_vm._v("\n                 \n                "),_c('a',{staticClass:"button row-action",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.pasteSplit(rowIndex)}}},[_vm._v("\n                  Paste\n                ")]),_vm._v("\n                 \n                "),(_vm.splitCounter > 1)?_c('a',{staticClass:"button row-action",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeSplit(rowIndex)}}},[_vm._v("\n                  Remove\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.receiptScanEnabled)?_c('td',{staticClass:"description-col"},[(_vm.scanningReceipt)?_c('span',{staticClass:"skeleton skeleton-line skeleton-description"}):_c('ed-input',{staticClass:"no-margin borderless description-input",attrs:{"value":_vm.descriptions[rowIndex],"disabled":_vm.reconcileAction === 'view'},on:{"input":function (value) { return _vm.handleDescription(value, rowIndex); }},model:{value:(_vm.descriptions[rowIndex]),callback:function ($$v) {_vm.$set(_vm.descriptions, rowIndex, $$v)},expression:"descriptions[rowIndex]"}})],1):_vm._e(),_vm._v(" "),(_vm.hasBu && !_vm.hasBuAndCcPair)?_c('td',{directives:[{name:"tooltip",rawName:"v-tooltip",value:((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) ? ("Please select a " + (_vm.programName.toLowerCase()) + " first") :
                          _vm.businessUnits.length === 0 ? ("Please add Business Units to the selected " + (_vm.programName.toLowerCase()) + " before proceeding") : ''),expression:"(!selectedProgram || Object.keys(selectedProgram).length === 0) ? `Please select a ${ programName.toLowerCase() } first` :\n                          businessUnits.length === 0 ? `Please add Business Units to the selected ${ programName.toLowerCase() } before proceeding` : ''"}]},[_c('ed-select',{staticClass:"borderless",style:({ marginBottom: '0' }),attrs:{"placeholder":"Select a BU...","options":_vm.businessUnits,"value":_vm.selectedBu[rowIndex],"checkboxes":false,"label":"name","track-by":"businessUnitId","name":"bu","disabled":_vm.reconcileAction === 'view' || (!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) || _vm.businessUnits.length === 0},on:{"input":function (option) { return _vm.handleBUSelection(option, rowIndex); }},model:{value:(_vm.selectedBu[rowIndex]),callback:function ($$v) {_vm.$set(_vm.selectedBu, rowIndex, $$v)},expression:"selectedBu[rowIndex]"}})],1):_vm._e(),_vm._v(" "),(_vm.hasCc && !_vm.hasBuAndCcPair)?_c('td',{directives:[{name:"tooltip",rawName:"v-tooltip",value:((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) ? ("Please select a " + (_vm.programName.toLowerCase()) + " first") :
                          _vm.costCenters.length === 0 ? ("Please add Cost Centers to the selected " + (_vm.programName.toLowerCase()) + " before proceeding") : ''),expression:"(!selectedProgram || Object.keys(selectedProgram).length === 0) ? `Please select a ${ programName.toLowerCase() } first` :\n                          costCenters.length === 0 ? `Please add Cost Centers to the selected ${ programName.toLowerCase() } before proceeding` : ''"}]},[_c('ed-select',{staticClass:"borderless",style:({ marginBottom: '0' }),attrs:{"placeholder":"Select a CC...","options":_vm.costCenters,"value":_vm.selectedCc[rowIndex],"checkboxes":false,"custom-label":function (o) { return ((o.code) + " (" + (o.name) + ")"); },"track-by":"costCenterId","name":"cc","disabled":_vm.reconcileAction === 'view' || (!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) || _vm.costCenters.length === 0},on:{"input":function (option) { return _vm.handleCCSelection(option, rowIndex); }},model:{value:(_vm.selectedCc[rowIndex]),callback:function ($$v) {_vm.$set(_vm.selectedCc, rowIndex, $$v)},expression:"selectedCc[rowIndex]"}})],1):_vm._e(),_vm._v(" "),(_vm.hasBuAndCcPair)?_c('td',{directives:[{name:"tooltip",rawName:"v-tooltip",value:((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) ? ("Please select a " + (_vm.programName.toLowerCase()) + " first") :
                          _vm.buAndCcPairs.length === 0 ? ("Please add BUs & CCs to the selected " + (_vm.programName.toLowerCase()) + " before proceeding") : ''),expression:"(!selectedProgram || Object.keys(selectedProgram).length === 0) ? `Please select a ${ programName.toLowerCase() } first` :\n                          buAndCcPairs.length === 0 ? `Please add BUs & CCs to the selected ${ programName.toLowerCase() } before proceeding` : ''"}]},[_c('ed-select',{staticClass:"borderless",style:({ marginBottom: '0' }),attrs:{"placeholder":"Select BU & CC...","options":_vm.buAndCcPairs,"value":_vm.selectedBuAndCcPair[rowIndex],"checkboxes":false,"label":"name","track-by":"programBusinessUnitAndCostCenterId","name":"cc","disabled":_vm.reconcileAction === 'view' || (!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) || _vm.buAndCcPairs.length === 0},on:{"input":function (option) { return _vm.handleBuAndCcPairSelection(option, rowIndex); }},model:{value:(_vm.selectedBuAndCcPair[rowIndex]),callback:function ($$v) {_vm.$set(_vm.selectedBuAndCcPair, rowIndex, $$v)},expression:"selectedBuAndCcPair[rowIndex]"}})],1):_vm._e(),_vm._v(" "),_c('td',{directives:[{name:"tooltip",rawName:"v-tooltip",value:((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) ? ("Please select a " + (_vm.programName.toLowerCase()) + " first") :
                          _vm.categories.length === 0 ? ("Please assign Categories to the " + (_vm.divisionName.toLowerCase()) + " of the selected " + (_vm.programName.toLowerCase()) + " before proceeding") : ''),expression:"(!selectedProgram || Object.keys(selectedProgram).length === 0) ? `Please select a ${ programName.toLowerCase() } first` :\n                          categories.length === 0 ? `Please assign Categories to the ${ divisionName.toLowerCase() } of the selected ${ programName.toLowerCase() } before proceeding` : ''"}],staticClass:"predicted-category-cell",class:{ 'has-predicted-coding-icon': _vm.allowPredictiveCoding && _vm.predictedCategory[rowIndex] && _vm.selectedCategory[rowIndex] }},[_c('ed-select',{staticClass:"borderless",style:({ marginBottom: '0' }),attrs:{"placeholder":"Select a Category...","options":_vm.categories,"value":_vm.selectedCategory[rowIndex],"checkboxes":false,"label":"text","track-by":"key","name":"category","disabled":_vm.reconcileAction === 'view' || (!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) || _vm.categories.length === 0},on:{"input":function (option) { return _vm.handleCategorySelection(option, rowIndex); }},model:{value:(_vm.selectedCategory[rowIndex]),callback:function ($$v) {_vm.$set(_vm.selectedCategory, rowIndex, $$v)},expression:"selectedCategory[rowIndex]"}}),_vm._v(" "),(_vm.allowPredictiveCoding && _vm.predictedCategory[rowIndex] && _vm.selectedCategory[rowIndex])?_c('span',{staticClass:"predicted-coding-icon-container"},[_c('predicted-coding-icon')],1):_vm._e()],1),_vm._v(" "),_c('td',{directives:[{name:"tooltip",rawName:"v-tooltip",value:((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) ? ("Please select a " + (_vm.programName.toLowerCase()) + " first") :
                          _vm.categories.length === 0 ? ("Please assign Categories to the " + (_vm.divisionName.toLowerCase()) + " of the selected " + (_vm.programName.toLowerCase()) + " before proceeding") :
                          !_vm.selectedCategory[rowIndex] ? "Please select a category first" : ''),expression:"(!selectedProgram || Object.keys(selectedProgram).length === 0) ? `Please select a ${ programName.toLowerCase() } first` :\n                          categories.length === 0 ? `Please assign Categories to the ${ divisionName.toLowerCase() } of the selected ${ programName.toLowerCase() } before proceeding` :\n                          !selectedCategory[rowIndex] ? `Please select a category first` : ''"}]},[_c('ed-input',{staticClass:"no-margin borderless",attrs:{"placeholder":"Category Ref ID...","value":_vm.referenceId[rowIndex],"disabled":_vm.reconcileAction === 'view' || (!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) || _vm.categories.length === 0 || !_vm.selectedCategory[rowIndex],"maxlength":"50"},on:{"input":function (value) { return _vm.handleReferenceID(value, rowIndex); }},model:{value:(_vm.referenceId[rowIndex]),callback:function ($$v) {_vm.$set(_vm.referenceId, rowIndex, $$v)},expression:"referenceId[rowIndex]"}})],1),_vm._v(" "),_vm._l((row),function(field,fIndex){return [(field.Key !== 'Amount')?_c('td',{key:("field-" + rowIndex + "-" + fIndex)},[(field.Type !== 'select')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(field.Values),expression:"field.Values"}],staticClass:"custom-fields",staticStyle:{"width":"100%","border":"none"},attrs:{"type":"text","size":"1","placeholder":field.Label,"maxlength":"200","disabled":_vm.reconcileAction === 'view'},domProps:{"value":(field.Values)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(field, "Values", $event.target.value)}}}):_vm._e(),_vm._v(" "),(field.Type === 'select')?_c('ed-select',{staticClass:"borderless",staticStyle:{"width":"120px","margin":"0"},attrs:{"placeholder":((field.Label) + "..."),"options":_vm.customOptions[field.Key],"track-by":"value","checkboxes":false,"label":"text","name":"program"},model:{value:(field.Values),callback:function ($$v) {_vm.$set(field, "Values", $$v)},expression:"field.Values"}}):_vm._e()],1):_vm._e()]}),_vm._v(" "),_c('td',{staticClass:"amount-col"},[(_vm.scanningReceipt && _vm.receiptScanEnabled)?_c('span',{staticClass:"skeleton skeleton-line skeleton-amount-cell"}):[(_vm.splitCounter > 1)?_c('ed-input',{key:("amount-input-" + rowIndex + "-" + _vm.splitCounter),staticClass:"money-input borderless",attrs:{"amount":"","type":"money","disabled":_vm.reconcileAction === 'view'},on:{"input":_vm.handleSplitAmounts},model:{value:(row.Amount),callback:function ($$v) {_vm.$set(row, "Amount", $$v)},expression:"row.Amount"}}):_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.form[0] && _vm.form[0].Amount != null ? _vm.form[0].Amount : _vm.transaction.data.Amount))])]],2)],2)})],2)])])]):_vm._e()],1),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Caution","show":_vm.showAlert,"primary-button":'YES',"secondary-button":'NO'},on:{"close":function($event){_vm.showAlert = false, _vm.selectedProgram = _vm.programConfirmPressed ? _vm.programOption : _vm.previousSelectedProgram, _vm.programConfirmPressed = false},"confirm":function($event){_vm.handleProgramChange(_vm.programOption), _vm.programConfirmPressed = true}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Changing the Program will clear the Business Unit, Cost Center, and Category selections on every split row (descriptions and amounts stay). Are you sure?")])])]),_vm._v(" "),_c('iframe',{staticClass:"transaction-attachment",attrs:{"name":"transactionAttachment","id":"transactionAttachment","src":"about:blank"}}),_vm._v(" "),_c('a',{staticClass:"close-attachment-button",on:{"click":_vm.closeAttachment}},[_c('i',{staticClass:"fa fa-times-circle"})]),_vm._v(" "),_c('receipt-folder-picker',{attrs:{"show":_vm.showFolderPicker,"is-processing":_vm.folderPickerIsProcessing,"transaction-id":_vm.isMobile ? String(_vm.transaction.data.Id) : null},on:{"select":_vm.handleFolderPickerSelect,"close":_vm.closeFolderPicker}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receipt-scan-overlay-card"},[_c('i',{staticClass:"fas fa-spinner fa-spin receipt-scan-overlay-spinner"}),_vm._v(" "),_c('div',{staticClass:"receipt-scan-overlay-title"},[_vm._v("Uploading receipt…")]),_vm._v(" "),_c('div',{staticClass:"receipt-scan-overlay-subtitle"},[_vm._v("Just a moment.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"coding-row-skeleton-cell",attrs:{"colspan":"20"}},[_c('span',{staticClass:"skeleton skeleton-line coding-row-skeleton"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aWMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LineItemStore_js__ = __webpack_require__("PJql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_itemTypes__ = __webpack_require__("l2QP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_itemTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__models_itemTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_components_Form_customFields_vue__ = __webpack_require__("eFeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus__ = __webpack_require__("Usg1");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddFeesDiscountItem' /* mandatory field */,

  components: {
    customFields: __WEBPACK_IMPORTED_MODULE_4__core_components_Form_customFields_vue__["default"]
  },
  props: {
    programId: Number,
    eventId: String,
    dependencies: Object,
    eventHub: Object,
    model: Object
  },
  created: function created() {
    var _this = this;
    var isEdit = this.model.draftItem !== null && typeof this.model.draftItem !== 'undefined';
    this.store().getFeesAndDiscountItemData(this.model.programId, this.model.invoiceId).then(function (response) {
      _this.bindCategoriesandAmountTypes(response.data);
      var action = 'Add';
      if (_this.model.draftItem) {
        var category = {};
        _this.categories.forEach(function (option) {
          if (option.options.filter(function (x) {
            return x.text === _this.model.draftItem.name;
          })[0] != null) {
            category = option.options.filter(function (x) {
              return x.text === _this.model.draftItem.name;
            })[0];
          }
        });
        _this.model.draftItem.category = category;
        _this.amountTypes = _this.amountByCategory[_this.model.draftItem.name];
        var amountTypeModel = _this.amountTypes && _this.amountTypes.filter(function (x) {
          return +x.amountType === +_this.model.draftItem.amountTypeId;
        })[0];
        if (amountTypeModel) {
          _this.model.draftItem.amountType.amountType = amountTypeModel.amountType;
          _this.model.draftItem.amountType.text = amountTypeModel.text;
        }
        _this.formData.draftItem = _this.model.draftItem;
        _this.formData.draftItem.isFeeDiscountItem = true;
        action = 'Edit';
      }
      _this.title = action + ' Fee or Discount Item';
      _this.bindCostCenterAndBusinessUnit(response.data, isEdit);
    });
  },
  data: function data() {
    return {
      formData: {
        draftItem: this.getEmptyDraftItem()
      },
      amountByCategory: {},
      show: true,
      saveButtonDisabled: false,
      validation: true,
      title: 'Add Fee or Discount Item',
      amountTypes: [],
      categories: [],
      costCenters: [],
      costCenter: '',
      businessUnits: [],
      businessUnit: '',
      businessUnitsWithCostCenters: [],
      businessUnitsWithCostCenter: '',
      showOneCostCenter: false,
      showCostCenters: false,
      showOneBusinessUnit: false,
      showBusinessUnits: false,
      showOneCostCenterWithBusinessUnit: false,
      showMixCostCentersWithBusinessUnits: false,
      isCategorySelected: false,
      doDisplayCategoryError: false,
      isAmountTypeSelected: false,
      doDisplayAmountTypeError: false,
      isCostCenterSelected: false,
      doDisplayCostCenterError: false,
      isBusinessUnitSelected: false,
      doDisplayBusinessUnitError: false,
      isMixCostCenterWithBusinessUnitSelected: false,
      doDisplayMixCostCenterWithBusinessUnitError: false
    };
  },
  computed: {
    enterAmountSelected: function enterAmountSelected() {
      return this.formData.draftItem.amountType.text === 'Enter Amount';
    },
    currency: function currency() {
      return this.model.currency.code;
    },
    categoryPlaceholder: function categoryPlaceholder() {
      return 'Select Tax/Fee/Other line item';
    },
    itemCustomFields: function itemCustomFields() {
      return this.model && this.model.draftItem && this.model.draftItem.customFields || [];
    }
  },
  methods: {
    getCostCenterName: function getCostCenterName(option, label) {
      return option.name ? option.name.indexOf(option.code) === -1 ? option.code + ' (' + option.name + ')' : option.name : option.code;
    },
    onClose: function onClose() {
      __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$emit('onCloseAddFeeOrDiscountItem', {});
      this.show = false;
    },
    getEmptyDraftItem: function getEmptyDraftItem() {
      return {
        category: {},
        businessUnit: {},
        costCenter: {},
        pairedBusinessUnitAndCostCenter: '',
        costCenterAndBusinessUnit: {},
        description: '',
        amountType: {},
        amount: ''
      };
    },
    onSave: function onSave() {
      if (!this.isValid()) return;

      // update custom line item category
      var category = this.formData.draftItem.category;
      if (category && category.key) {
        this.formData.draftItem.feeTypeId = null;
        this.formData.draftItem.taxTypeId = null;
        this.formData.draftItem.customTypeId = null;
        if (category.key.indexOf('fee') !== -1) {
          this.formData.draftItem.feeTypeId = Number(category.key.replace('fee', ''));
        }
        if (category.key.indexOf('tax') !== -1) {
          this.formData.draftItem.taxTypeId = Number(category.key.replace('tax', ''));
        }
        if (category.key.indexOf('oth') !== -1) {
          this.formData.draftItem.customTypeId = Number(category.key.replace('oth', ''));
        }
      }

      // update allocation
      if (typeof this.formData.draftItem.costCenterAndBusinessUnit === 'undefined') {
        this.formData.draftItem.costCenterAndBusinessUnit = {};
      }
      if (this.showOneCostCenter) {
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = this.costCenter.key;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo = this.costCenter.code;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterName = this.costCenter.name;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.costCenter.costCenterId;
      } else if (this.formData.draftItem.costCenter) {
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = this.formData.draftItem.costCenter.key;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo = this.formData.draftItem.costCenter.code;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterName = this.formData.draftItem.costCenter.name;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.formData.draftItem.costCenter.costCenterId;
      }
      if (this.showOneBusinessUnit) {
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName = this.businessUnit.name;
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.businessUnit.businessUnitId;
      } else if (this.formData.draftItem.businessUnit) {
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName = this.formData.draftItem.businessUnit.name;
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.formData.draftItem.businessUnit.businessUnitId;
      }
      if (this.showOneCostCenterWithBusinessUnit) {
        this.formData.draftItem.useBusinessUnitAndCostCenterMapping = true;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey = this.businessUnitsWithCostCenter.key;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName = this.businessUnitsWithCostCenter.name;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.businessUnitsWithCostCenter.costCenterId;
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.businessUnitsWithCostCenter.businessUnitId;
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = +this.businessUnitsWithCostCenter.programBusinessUnitAndCostCenterId;
      } else if (this.formData.draftItem.pairedBusinessUnitAndCostCenter) {
        this.formData.draftItem.useBusinessUnitAndCostCenterMapping = true;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey = this.formData.draftItem.pairedBusinessUnitAndCostCenter.key;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName = this.formData.draftItem.pairedBusinessUnitAndCostCenter.name;
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.formData.draftItem.pairedBusinessUnitAndCostCenter.costCenterId;
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.formData.draftItem.pairedBusinessUnitAndCostCenter.businessUnitId;
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = +this.formData.draftItem.pairedBusinessUnitAndCostCenter.programBusinessUnitAndCostCenterId;
      } else {
        this.formData.draftItem.useBusinessUnitAndCostCenterMapping = false;
      }
      this.formData.draftItem.customFields = this.$refs.feeCustomFieldsRef.getFields();
      if (!this.formData.draftItem.amountType || !this.formData.draftItem.amountType.amountType) {
        this.formData.draftItem.amountType = {
          amountType: 1 // default amount type
        };
      }
      if (!this.formData.draftItem.amountTypeValue) {
        this.formData.draftItem.amountTypeValue = 0;
      }
      __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$emit('onSaveFeeOrDiscountItem', {
        data: this.formData.draftItem,
        eventId: this.eventId
      });
      this.show = false;
    },
    isValid: function isValid() {
      var result = true;
      if (!this.isCategorySelected === true && this.formData.draftItem.category.text === undefined) {
        this.doDisplayCategoryError = true;
        result = false;
      }
      if (this.formData.draftItem.category.amountTypes !== null && !this.isAmountTypeSelected === true && this.formData.draftItem.amountType.amountType === undefined) {
        this.doDisplayAmountTypeError = true;
        result = false;
      }
      if (this.showCostCenters === true) {
        if (this.isCostCenterSelected === false && !(this.formData.draftItem && this.formData.draftItem.costCenter && this.formData.draftItem.costCenter !== null && this.formData.draftItem.costCenter.key)) {
          this.doDisplayCostCenterError = true;
          result = false;
        }
      }
      if (this.showBusinessUnits === true) {
        if (this.isBusinessUnitSelected === false && this.formData.draftItem.businessUnit.key) {
          this.doDisplayBusinessUnitError = true;
          result = false;
        }
      }
      if (this.showMixCostCentersWithBusinessUnits) {
        if (this.isMixCostCenterWithBusinessUnitSelected === false && !(this.formData.draftItem && this.formData.draftItem.pairedBusinessUnitAndCostCenter && this.formData.draftItem.pairedBusinessUnitAndCostCenter !== null)) {
          this.doDisplayMixCostCenterWithBusinessUnitError = true;
          result = false;
        }
      }
      if (!this.$refs.feeCustomFieldsRef.validate()) {
        result = false;
      }
      return result;
    },
    store: function store() {
      return new __WEBPACK_IMPORTED_MODULE_2__LineItemStore_js__["a" /* default */](this.api);
    },
    groupItemsByType: function groupItemsByType(items, type, map) {
      var groups = [];
      var groupedItems = {};
      var mappedGroupedItems = [];
      items.forEach(function (item) {
        var groupName = item[type];
        if (!~groups.indexOf(groupName)) {
          groups.push(groupName);
          groupedItems[groupName] = [];
        }
        groupedItems[groupName].push(item);
      });
      if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(map) === 'object') {
        Object.keys(groupedItems).forEach(function (key) {
          if (map[key]) {
            mappedGroupedItems.push({
              label: map[key],
              options: groupedItems[key]
            });
          } else {
            var _mappedGroupedItems$f;
            (_mappedGroupedItems$f = mappedGroupedItems.filter(function (item) {
              return item.label === map[map.default];
            })[0].options).push.apply(_mappedGroupedItems$f, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(groupedItems[key]));
          }
        });
        return mappedGroupedItems;
      }
      return groupedItems;
    },
    bindCategoriesandAmountTypes: function bindCategoriesandAmountTypes(data) {
      if (data.feesAndTaxes !== null && data.feesAndTaxes !== undefined) {
        for (var i = 0; i < data.feesAndTaxes.length; i++) {
          var category = data.feesAndTaxes[i];
          this.categories.push(category);
          this.amountByCategory[category.text] = category.amountTypes;
        }
        this.categories = this.groupItemsByType(this.categories, 'itemType', __WEBPACK_IMPORTED_MODULE_3__models_itemTypes___default.a);
      }
    },
    categorySelected: function categorySelected(e) {
      this.amountTypes = this.amountByCategory[e.text];
      if (this.amountTypes) {
        if (this.amountTypes.length === 1) {
          var model = {
            amountType: this.amountTypes[0].amountType,
            text: this.amountTypes[0].text
          };
          this.formData.draftItem.amountType = model;
          this.amountTypeSelected();
        } else {
          var amountTypeEnterAmount = this.amountTypes.filter(function (item) {
            return item.text === 'Enter Amount';
          });
          if (amountTypeEnterAmount && amountTypeEnterAmount.length > 0) {
            var _model = {
              amountType: amountTypeEnterAmount[0].amountType,
              text: amountTypeEnterAmount[0].text
            };
            this.formData.draftItem.amountType = _model;
            this.amountTypeSelected();
          }
        }
      }
      this.isCategorySelected = true;
      this.doDisplayCategoryError = false;
      this.formData.draftItem.category = e;
    },
    amountTypeSelected: function amountTypeSelected(e) {
      this.isAmountTypeSelected = true;
      this.doDisplayAmountTypeError = false;
      if (e) {
        this.formData.draftItem.amountType.amountType = e.amountType;
        this.formData.draftItem.amountType.text = e.text;
      }
    },
    costCenterSelected: function costCenterSelected(e) {
      if (this.showCostCenters) {
        this.isCostCenterSelected = true;
        this.doDisplayCostCenterError = false;
        this.formData.draftItem.costCenterAndBusinessUnit = {
          costCenterNo: e.code,
          costCenterName: e.name,
          costCenterId: +e.costCenterId
        };
      }
    },
    businessUnitSelected: function businessUnitSelected(e) {
      if (this.showBusinessUnits) {
        this.isBusinessUnitSelected = true;
        this.doDisplayBusinessUnitError = false;
        this.formData.draftItem.costCenterAndBusinessUnit = {
          businessUnitName: e.name,
          businessUnitId: +e.businessUnitId
        };
      }
    },
    businessUnitWithCostCenter: function businessUnitWithCostCenter(e) {
      if (this.showMixCostCentersWithBusinessUnits) {
        this.isMixCostCenterWithBusinessUnitSelected = true;
        this.doDisplayMixCostCenterWithBusinessUnitError = false;
      }
    },
    bindCostCenterAndBusinessUnit: function bindCostCenterAndBusinessUnit(data, isEdit) {
      var _this2 = this;
      if (data.costCentersAndBusinessUnit) {
        var costCenters = data.costCentersAndBusinessUnit.costCenters;
        var businessUnits = data.costCentersAndBusinessUnit.businessUnits;
        var mixedCostCentersAndBusinessUnits = data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits;
        if (mixedCostCentersAndBusinessUnits !== null && mixedCostCentersAndBusinessUnits !== undefined && mixedCostCentersAndBusinessUnits.length > 0) {
          if (mixedCostCentersAndBusinessUnits.length === 1) {
            this.businessUnitsWithCostCenter = mixedCostCentersAndBusinessUnits[0];
            this.formData.draftItem.mixedCostCentersAndBusinessUnits = mixedCostCentersAndBusinessUnits[0];
            this.showOneCostCenter = false;
            this.showCostCenters = false;
            this.showOneBusinessUnit = false;
            this.showBusinessUnits = false;
            this.showOneCostCenterWithBusinessUnit = true;
            this.showMixCostCentersWithBusinessUnits = false;
            if (!isEdit) {
              this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey = this.businessUnitsWithCostCenter.key;
              this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName = this.businessUnitsWithCostCenter.name;
              this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.businessUnitsWithCostCenter.businessUnitId;
              this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.businessUnitsWithCostCenter.costCenterId;
              this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = +this.businessUnitsWithCostCenter.programBusinessUnitAndCostCenterId;
            } else {
              this.formData.draftItem.pairedBusinessUnitAndCostCenter = {
                key: this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey,
                name: this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName,
                businessUnitId: +this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId,
                costCenterId: +this.formData.draftItem.costCenterAndBusinessUnit.costCenterId,
                programBusinessUnitAndCostCenterId: +this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId
              };
            }
          } else {
            this.businessUnitsWithCostCenters = mixedCostCentersAndBusinessUnits;
            if (this.formData.draftItem.costCenterAndBusinessUnit !== undefined) {
              this.formData.draftItem.pairedBusinessUnitAndCostCenter = this.businessUnitsWithCostCenters.filter(function (businessUnitWithCostCenter) {
                return businessUnitWithCostCenter.key === _this2.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey;
              });
              if (this.formData.draftItem.pairedBusinessUnitAndCostCenter) {
                this.formData.draftItem.pairedBusinessUnitAndCostCenter = this.formData.draftItem.pairedBusinessUnitAndCostCenter[0];
              }
            }
            this.showOneCostCenter = false;
            this.showCostCenters = false;
            this.showOneBusinessUnit = false;
            this.showBusinessUnits = false;
            this.showOneCostCenterWithBusinessUnit = false;
            this.showMixCostCentersWithBusinessUnits = true;
          }
        } else {
          if (costCenters !== null && costCenters !== undefined && costCenters.length > 0) {
            if (costCenters.length === 1) {
              this.costCenter = costCenters[0];
              this.formData.draftItem.costCenter = costCenters[0];
              this.showOneCostCenter = true;
              this.showCostCenters = false;
              this.showOneCostCenterWithBusinessUnit = false;
              this.showMixCostCentersWithBusinessUnits = false;
              if (!isEdit) {
                this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo = this.costCenter.key;
                this.formData.draftItem.costCenterAndBusinessUnit.costCenterName = this.costCenter.name;
                this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.costCenter.costCenterId;
              } else {
                this.formData.draftItem.costCenter = {
                  key: this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo,
                  name: this.formData.draftItem.costCenterAndBusinessUnit.costCenterName,
                  costCenterId: +this.formData.draftItem.costCenterAndBusinessUnit.costCenterId
                };
              }
            } else {
              this.costCenters = costCenters;
              this.showOneCostCenter = false;
              this.showCostCenters = true;
              this.showOneCostCenterWithBusinessUnit = false;
              this.showMixCostCentersWithBusinessUnits = false;
              if (this.formData.draftItem.costCenterAndBusinessUnit !== undefined) {
                this.formData.draftItem.costCenter = costCenters.filter(function (costCenter) {
                  return costCenter.key === _this2.formData.draftItem.costCenterAndBusinessUnit.costCenterNo;
                });
                // array to object
                if (this.formData.draftItem.costCenter) {
                  this.formData.draftItem.costCenter = this.formData.draftItem.costCenter[0];
                }
                if (this.formData.draftItem.costCenter && this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo) {
                  this.isCostCenterSelected = true;
                }
              }
            }
          }
          if (businessUnits !== null && businessUnits !== undefined && businessUnits.length > 0) {
            if (businessUnits.length === 1) {
              this.businessUnit = businessUnits[0];
              this.formData.draftItem.businessUnit = businessUnits[0];
              this.showOneBusinessUnit = true;
              this.showBusinessUnits = false;
              this.showOneCostCenterWithBusinessUnit = false;
              this.showMixCostCentersWithBusinessUnits = false;
              if (!isEdit) {
                this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName = this.businessUnit.name;
                this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.businessUnit.businessUnitId;
              } else {
                this.formData.draftItem.businessUnit = {
                  key: this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName,
                  name: this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName,
                  businessUnitId: +this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId
                };
              }
            } else {
              this.businessUnits = businessUnits;
              this.showOneBusinessUnit = false;
              this.showBusinessUnits = true;
              this.showOneCostCenterWithBusinessUnit = false;
              this.showMixCostCentersWithBusinessUnits = false;
              if (this.formData.draftItem.costCenterAndBusinessUnit !== undefined) {
                this.formData.draftItem.businessUnit = businessUnits.filter(function (bu) {
                  return bu.key === _this2.formData.draftItem.costCenterAndBusinessUnit.businessUnitName;
                });
                // array to object
                if (this.formData.draftItem.businessUnit) {
                  this.formData.draftItem.businessUnit = this.formData.draftItem.businessUnit[0];
                }
                if (this.formData.draftItem.businessUnit && this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName) {
                  this.isBusinessUnitSelected = true;
                }
              }
            }
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "aeML":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1mKUA1xHssya01caeTqrEg","Dell":"_1TKMi8tIpKmwp22-YpGVj2","Abbott":"_16UIaPYZgZb-sBn-v7caUz","Gap":"_3bPP-C35Wu7ExWyum9gI7n","Allstate":"_1rCkuyfVebv_hnWQXhiEFa","Asurion":"_3zIodGEacKl1Pg23ag9wYy","Invitae":"Cokma0c_YJmVjicCj5CMA","JWE":"_1RWOGp4kijG4T0XpHvxYsV"};

/***/ }),

/***/ "afLu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_value_objects_money__ = __webpack_require__("7QHX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__("OMJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */




// let instance = null

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
      noValue: false,
      invalidSum: false,
      validThreshold: true,
      validMinAmount: true,
      validMaxAmount: true
    };
  },
  computed: {
    selectedItems: function selectedItems() {
      return this.params.context.gridOptions && this.params.context.gridOptions.api ? this.params.context.gridOptions.api.getSelectedNodes().map(function (r) {
        return r.data;
      }) : [];
    },
    //
    totalsRow: function totalsRow() {
      return this.params.node.rowPinned === 'bottom';
    },
    shouldDisplayTotal: function shouldDisplayTotal() {
      return Object.keys(this.params.context.totalsData).length ? this.selectedItems.length || this.params.context.filters.length || !this.totalsRow : true;
    },
    infoMessage: function infoMessage() {
      return this.params.colDef.infoMessage(this.params);
    },
    infoMessageIcon: function infoMessageIcon() {
      return this.params.colDef.infoMessageIcon;
    },
    warningMessage: function warningMessage() {
      return !this.validMinAmount || !this.validMaxAmount;
    },
    moneyValue: function moneyValue() {
      if (this.params.value === null) {
        this.noValue = true;
        return null;
      }
      var items = this.selectedItems;
      var p = this.params;
      var totals = [p.context.value || [], p.colDef.f, p.colDef.field];
      var isTotals = this.totalsRow && p.colDef.f;
      var amountToValidate = p.colDef.validationCol && p.data[p.colDef.validationCol] !== null && !isNaN(p.data[p.colDef.validationCol]) ? p.data[p.colDef.validationCol] : null;
      var total = +p.value || 0;
      var VALUE = amountToValidate !== null ? +amountToValidate : total;
      var sum = this.sum.apply(this, totals);
      this.invalidSum = p.colDef.validSum && p.colDef.validSum.value !== sum;

      // TOTAL validations
      if (!Object(__WEBPACK_IMPORTED_MODULE_2_util__["isNullOrUndefined"])((p.colDef.minTotalThreshold || {}).value)) {
        this.validThreshold = p.colDef.minTotalThreshold.value <= sum;
      }
      if (!Object(__WEBPACK_IMPORTED_MODULE_2_util__["isNullOrUndefined"])((p.colDef.maxTotalThreshold || {}).value)) {
        this.validThreshold = sum < p.colDef.maxTotalThreshold.value;
      }

      // Line validations
      if (!Object(__WEBPACK_IMPORTED_MODULE_2_util__["isNullOrUndefined"])((p.colDef.minThreshold || {}).value) && !isTotals && p.value) {
        if (typeof this.minThreshold !== 'undefined') {
          if (this.minThreshold >= 0) {
            this.validMinAmount = +this.minThreshold < +VALUE;
            this.strictMin = true;
          } else {
            this.validMinAmount = +this.minThreshold <= +VALUE;
          }
          //
          !this.validMinAmount ? this.notify() : this.nextNotification();
        } else {
          this.validMinAmount = true;
        }
      }
      if (!Object(__WEBPACK_IMPORTED_MODULE_2_util__["isNullOrUndefined"])((p.colDef.maxThreshold || {}).value) && !isTotals && p.value) {
        if (typeof this.maxThreshold !== 'undefined') {
          if (this.maxThreshold >= 0) {
            this.validMaxAmount = +VALUE <= +this.maxThreshold;
          } else {
            this.validMaxAmount = +VALUE < +this.maxThreshold;
            this.strictMax = true;
          }
          //
          !this.validMaxAmount && this.notify();
          !this.validMaxAmount && !this.validMinAmount && this.nextNotification();
        } else {
          this.validMaxAmount = true;
        }

        // when auto-correct needs to be implemented use next code:
        // if (!this.validMaxAmount) {
        //   // p.setValue(this.maxThreshold)
        //   // p.data._warning = true
        //   // return this.maxThreshold
        // } else {
        //   // p.data._warning = false
        // }
      }

      // set threshold flag
      if (isTotals) {
        p.context.totalsInvalid = !this.validThreshold;
        this.validMinAmount = true;
        this.validMaxAmount = true;
      }
      return isTotals ? p.context.totalsData && p.context.totalsData[p.colDef.field] && (!items.length || p.context.allRowsSelected) ? p.context.totalsData[p.colDef.field] : sum : total;
    },
    invalidClass: function invalidClass() {
      return {
        'invalid': this.invalidSum,
        'invalid-threshold': !this.validThreshold,
        'invalid-amount': !this.validMinAmount || !this.validMaxAmount
      };
    },
    skipConversion: function skipConversion() {
      // return this.params.node.data._new && !this.params.node.data.draft
      // return this.params.node.data._new
    },
    currencyCode: function currencyCode() {
      return this.params.colDef.currency || this.params.data && this.params.data.CurrencyCode || this.params.context.currency;
    },
    validationMessage: function validationMessage() {
      var column = this.params.colDef.alias || this.params.colDef.headerName;
      var messageTemplateText = '';
      var strictMaxim = this.strictMax ? 'than' : 'than or equal to';
      var strictMinim = this.strictMin ? 'than' : 'than or equal to';
      if (!this.validMaxAmount) {
        messageTemplateText = "\n            <p>\n              ".concat(column, " must be less ").concat(strictMaxim, " <strong><v-money class=\"solid\" currency='").concat(this.currencyCode, "'> ").concat(this.maxThreshold, " </v-money></strong>\n            </p>\n          ");
      } else {
        if (!this.validMinAmount) {
          messageTemplateText = "\n              <p>\n                ".concat(column, " must be greater ").concat(strictMinim, " <strong><v-money class=\"solid\" currency='").concat(this.currencyCode, "'> ").concat(this.minThreshold, " </v-money></strong>\n              </p>\n            ");
        }
      }
      return messageTemplateText && this.currencyCode ? messageTemplateText : null;
    },
    supplementalPrecision: function supplementalPrecision() {
      return this.params.colDef.useSupplementalPrecision ? 6 /* 8 digits */ : 0; /* 2 digits */
    }
  },
  created: function created() {
    // instance = this
    this.setMinMaxAmountForValidation();
  },
  methods: {
    setMinMaxAmountForValidation: function setMinMaxAmountForValidation() {
      this.cell = this.params.eGridCell;
      this.gridRightMargin = this.params.api.gridPanel.ePinnedRightFloatingTop;
      this.setMaxAmountForValidation();
      this.setMinAmountForValidation();
      if (this.maxThreshold < 0 && typeof this.params.colDef.minThresholdRef[this.params.rowIndex] !== 'undefined' && typeof this.params.colDef.maxThresholdRef[this.params.rowIndex] !== 'undefined') {
        this.minThreshold = this.maxThreshold;
        this.maxThreshold = 0;
        this.params.colDef.minThresholdRef[this.params.rowIndex][this.params.colDef.field] = +this.minThreshold;
        this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field] = +this.maxThreshold;
      }
    },
    setMaxAmountForValidation: function setMaxAmountForValidation() {
      // set max threshold for each cell in column
      this.params.colDef.maxThresholdRef = this.params.colDef.maxThresholdRef || [];
      if (typeof this.params.data[this.params.colDef.field] !== 'undefined') {
        this.maxThreshold = typeof this.params.colDef.maxThresholdRef[this.params.rowIndex] !== 'undefined' && !isNaN(this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field]) ? this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field] : this.params.colDef.maxThreshold ? this.params.colDef.maxThreshold &&
        // compute max threshold based on formula / other column
        this.params.colDef.maxThreshold.f && this.params.data[this.params.colDef.maxThreshold.f] ||
        // compute max threshold based on own value
        this.params.data[this.params.colDef.field] ||
        // max threshold specified on column definition
        this.params.colDef.maxThreshold.value ||
        // fallback to 0 max threshold
        0 : null;
        if (typeof this.params.colDef.maxThresholdRef[this.params.rowIndex] === 'undefined') {
          this.params.colDef.maxThresholdRef[this.params.rowIndex] = {};
        }
        this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field] = +this.maxThreshold;
      }
    },
    setMinAmountForValidation: function setMinAmountForValidation() {
      // set min threshold for each cell in column
      this.params.colDef.minThresholdRef = this.params.colDef.minThresholdRef || [];
      if (typeof this.params.data[this.params.colDef.field] !== 'undefined') {
        this.minThreshold = typeof this.params.colDef.minThresholdRef[this.params.rowIndex] !== 'undefined' && !isNaN(this.params.colDef.minThresholdRef[this.params.rowIndex][this.params.colDef.field]) ? this.params.colDef.minThresholdRef[this.params.rowIndex][this.params.colDef.field] : this.params.colDef.minThreshold ? this.params.colDef.minThreshold &&
        // compute min threshold based on formula / other column
        this.params.colDef.minThreshold.f && this.params.data[this.params.colDef.minThreshold.f] ||
        // min threshold specified on column definition
        this.params.colDef.minThreshold.value ||
        // fallback to 0 min threshold
        0 : null;
        if (typeof this.params.colDef.minThresholdRef[this.params.rowIndex] === 'undefined') {
          this.params.colDef.minThresholdRef[this.params.rowIndex] = {};
        }
        this.params.colDef.minThresholdRef[this.params.rowIndex][this.params.colDef.field] = +this.minThreshold;
      }
    },
    notify: function notify(forceShow) {
      //
    },
    notifyComponent: function notifyComponent(messageTemplateText, forceShow) {
      var id = "".concat(this.params.colDef.field, "-").concat(this.params.rowIndex);
      if (forceShow) {
        this.$notifications.showById(id);
      } else {
        this.$notifications.notify({
          id: id,
          type: 'plain',
          timeout: 0,
          allowDismiss: false,
          position: {
            position: 'absolute',
            left: "".concat(this.gridRightMargin.getBoundingClientRect().left, "px"),
            top: "".concat(this.cell.getBoundingClientRect().top, "px"),
            offsetTop: "".concat(this.cell.parentNode.offsetTop + this.cell.clientHeight, "px")
          },
          component: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
            template: messageTemplateText
          }),
          message: "".concat(messageTemplateText, " ").concat(id),
          hide: this.$notifications.getLast().id !== id ? this.$notifications.errorState() : false
        });
      }
    },
    removeNotification: function removeNotification() {
      var remove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    } //
    ,
    nextNotification: function nextNotification() {
      //
    },
    getRate: function getRate(currency, skip) {
      // return instance.$refs.moneys && instance.$refs.moneys.getRate()
      return __WEBPACK_IMPORTED_MODULE_1__core_value_objects_money__["a" /* default */].methods.getRate(currency, skip);
    },
    getTaxes: function getTaxes(item, field) {
      var sumTaxes = 0;
      var taxes = item && item.taxes && item.taxes.length ? item.taxes : item && Object.keys(item).filter(function (k) {
        return ~k.indexOf('taxes_');
      }).map(function (k) {
        return item[k];
      }) || [];
      if (taxes.length && field === 'total') {
        sumTaxes = taxes.reduce(function (taxes, tax) {
          return taxes + (+tax.value || +tax || 0);
        }, 0);
      }
      return sumTaxes;
    },
    getFees: function getFees(item, field) {
      var sumFees = 0;
      var fees = item && item.fees && item.fees.length ? item.fees : item && Object.keys(item).filter(function (k) {
        return ~k.indexOf('fees_');
      }).map(function (k) {
        return item[k];
      }) || [];
      if (fees.length && field === 'total') {
        sumFees = fees.reduce(function (fees, fee) {
          return fees + (+fee.value || +fee || 0);
        }, 0);
      }
      return sumFees;
    },
    getDiscounts: function getDiscounts(item, field) {
      return item && item.discountAmount || 0;
    },
    sum: function sum(items, formula, field) {
      var _this = this;
      // let _formula = formula.replace(/_(\d+)/g, '[$1].value')
      var _formula = formula;
      items = items.length ? items : this.params.context.gridOptions.api && this.params.context.gridOptions.api.getSelectedNodes().map(function (r) {
        return r.data;
      }) || [];
      if (this.params.context.total) {
        if (!isNaN(this.params.context.total)) {
          return parseFloat(parseFloat(this.params.context.total).toFixed(2));
        }
        return this.params.context.total;
      }
      return parseFloat(items.map(function (data) {
        return data._skip ? 0 : +eval(_formula) + _this.getTaxes(data, field) + _this.getFees(data, field) - _this.getDiscounts(data, field) || 0;
      }) // eslint-disable-line
      .reduce(function (a, b) {
        return a + b;
      }, 0).toFixed(2));
    },
    displayMoney: function displayMoney(p) {
      return !(p.node.rowPinned === 'bottom' && !p.value && !p.colDef.f) && !this.noValue && this.shouldDisplayTotal;
    },
    showDetails: function showDetails() {
      this.shownDetails = !this.shownDetails;
    },
    edit: function edit(v) {
      this.params.setValue(v.label);
      this.params.value = v.label;
    },
    refresh: function refresh() {
      //
      this.shownDetails = false;
    }
  }
});

/***/ }),

/***/ "agw4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aj2A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("n/VL");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24c87512_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("9Qp5");
function injectStyle (ssrContext) {
  __webpack_require__("sknG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24c87512"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24c87512_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aliK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    holder: function holder() {
      return this.params && this.params.value || '';
    },
    nameOnCard: function nameOnCard() {
      return (this.params && this.params.data && this.params.data.NameOnCard || '').trim();
    },
    showNameOnCard: function showNameOnCard() {
      return !!this.nameOnCard && this.nameOnCard.toLowerCase() !== (this.holder || '').trim().toLowerCase();
    }
  }
});

/***/ }),

/***/ "ayPo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return edit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return remove; });
/* unused harmony export externalEdit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return view; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return goto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return gotoCustom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return expand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return drag; });
var clone = {
  name: 'clone',
  template: function template(params) {
    if (params.node.rowPinned) return null;
    return "<a data-action='clone'\n               xv-tooltip.bottom=\"'Duplicate'\"\n               data-name=\"'Duplicate'\"\n               data-index='".concat(params.rowIndex, "'\n               data-key='").concat(params.colDef.uid, "'\n               data-id='").concat(params.data && params.data[params.colDef.uid], "'\n               class='far fa-copy'>\n            </a>");
  }
};
var edit = {
  name: 'edit',
  template: function template(params) {
    if (params.node.rowPinned) return null;
    return "<a data-action='edit'\n               xv-tooltip.bottom=\"'Edit'\"\n               data-name=\"'Edit'\"\n               data-index='".concat(params.rowIndex, "'\n               data-key='").concat(params.colDef.uid, "'\n               data-id='").concat(params.data && params.data[params.colDef.uid], "'\n               class='fas fa-pen'>\n            </a>");
  }
};
var remove = {
  name: 'remove',
  template: function template(params) {
    if (params.node.rowPinned) return null;
    return "<a data-action='remove'\n               xv-tooltip.bottom=\"'Remove'\"\n               data-name=\"'Remove'\"\n               data-index='".concat(params.rowIndex, "'\n               data-key='").concat(params.colDef.uid, "'\n               data-id='").concat(params.data && params.data[params.colDef.uid], "'\n               class='fas fa-trash-alt'>\n            </a>");
  }
};
var externalEdit = function externalEdit(url) {
  return {
    name: 'externalEdit',
    template: function template(params) {
      return "<a data-action='external-edit'\n               data-index='".concat(params.rowIndex, "'\n               data-key='").concat(params.colDef.uid, "'\n               data-id='").concat(params.data && params.data[params.colDef.uid], "'\n               class='fas fa-pen'\n               href='").concat(url + (params.data && params.data[params.colDef.uid]) || 'javascript:;', "'>\n            </a>");
    }
  };
};
var view = {
  name: 'view',
  template: function template(params) {
    var target = params.newTab ? ' target = "_blank"' : '';
    return "<a class='dawn-button btn btn-actionbar'\n               data-action='view'\n               data-index='".concat(params.rowIndex, "'\n               data-key='").concat(params.colDef.uid, "'\n               data-id='").concat(params.data && params.data[params.colDef.uid], "'\n               ").concat(target, "\n               href='").concat(params.colDef.uri ? params.colDef.uri.replace('{{env}}', global.app.api.env).replace('{{id}}', params.data && params.data[params.colDef.uid]).replace('{{ProgramID}}', params.data && params.data['ProgramID']) : 'javascript:;', "'>\n            ").concat(params.colDef.label, "\n            </a>");
  }
};
var goto = {
  name: 'goto',
  template: function template(params, ctx) {
    var target = params.newTab ? ' target = "_blank"' : '';
    var tooltip = "(params.colDef.tooltip || 'Open {{text}}').replace('{{text}}', params.data && params.data[params.colDef.field])";
    var _env = ctx ? ctx.$root.api.env : '';
    var _screen = ctx ? ctx.screen : '';
    return "<a data-action='goto'\n               v-tooltip.bottom=\"".concat(tooltip, "\"\n               data-name=\"").concat(tooltip, "\"\n               data-index='").concat(params.rowIndex, "'\n               data-key='").concat(params.colDef.uid, "'\n               data-id='params.data && params.data[params.colDef.uid]'\n               ").concat(target, "\n               :onclick='params.colDef.onclick'\n               href=\"\n                params.colDef.uri\n                ? params.colDef.uri\n                  .replace('{{env}}', '").concat(_env, "')\n                  .replace('{{screen}}', '").concat(_screen, "')\n                  .replace('{{id}}', params.data && params.data[params.colDef.uid])\n                  .replace('{{ProgramID}}', params.data && params.data['ProgramID'])\n                : 'javascript:;'\n               \">\n            ").concat(params.value, "\n            </a>");
  }
};
var gotoCustom = {
  name: 'gotoCustom',
  template: function template(params, ctx) {
    var noTooltip = params.noTooltip ? params.noTooltip : false;
    var target = params.newTab ? ' target = "_blank"' : '';
    var tooltip = (params.colDef.tooltip || 'Open {{text}}').replace('{{text}}', params.data && params.data[params.colDef.field]);
    var _env = ctx ? ctx.$root.api.env : '';
    var _screen = ctx ? ctx.screen : '';
    var tooltipDirective = noTooltip ? '' : "v-tooltip.bottom=\"".concat(tooltip, "\"");
    return "<a data-action='goto'\n               ".concat(tooltipDirective, "\n               data-name=\"").concat(tooltip, "\"\n               data-index='").concat(params.node.rowIndex, "'\n               data-key='").concat(params.colDef.uid, "'\n               data-id='").concat(params.data && params.data[params.colDef.uid], "'\n               ").concat(target, "\n               :onclick='").concat(params.colDef.onclick, "'\n               href=\"").concat(params.colDef.uri ? params.colDef.uri.replace('{{env}}', _env).replace('{{screen}}', _screen).replace('{{id}}', params.data && params.data[params.colDef.uid]).replace('{{ProgramID}}', params.data && params.data['ProgramID']) : 'javascript:;', "\">\n            ").concat(params.value, "\n            </a>");
  }
};
var expand = {
  name: 'expand',
  template: function template(params) {
    if (params.node.rowPinned) return null;
    return "<a data-action='expand'\n               v-tooltip.bottom=\"'Show/Hide Details'\"\n               data-name=\"'Show/Hide Details'\"\n               data-index='".concat(params.rowIndex, "'\n               data-key='").concat(params.colDef.uid, "'\n               data-id='").concat(params.data && params.data[params.colDef.uid], "'\n               class='fas fa-chevron-down'>\n            </a>");
  }
};
var drag = {
  name: 'drag',
  template: function template(params) {
    if (params.node.rowPinned) return null;
    return "<a data-action='drag'\n               v-tooltip.bottom=\"'Move'\"\n               data-name=\"'Move'\"\n               data-index='".concat(params.rowIndex, "'\n               data-key='").concat(params.colDef.uid, "'\n               data-id='").concat(params.data && params.data[params.colDef.uid], "'\n               class='drag-handle'>\n            </a>");
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "azIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(allocations, selectedAllocations) {
    return {
      Id: '_',
      '*Name': {
        label: 'Business Unit & Cost Center',
        width: 120,
        options: allocations,
        source: true,
        compose: allocationName,
        selectedOptions: selectedAllocations,
        trackBy: {
          optionTrackBy: 'Key',
          selectedOptionTrackBy: 'Id'
        }
      },
      AdditionalNo: {
        label: 'Secondary ID',
        width: 90,
        editable: true,
        maxLength: 50
      },
      Percent: {
        label: 'Allocation Percent',
        width: 80,
        editable: true
      },
      Amount: {
        label: 'Allocation Amount',
        width: 80,
        f: 'data.Amount',
        validSum: {
          value: 0
        },
        editable: true
      }
    };
  }
});
function allocationName(params) {
  return params.data && params.data.Name ? params.data.Name : ' ';
}

/***/ }),

/***/ "b026":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dawn-primary-nav-wrapper"},[_c('div',{staticClass:"dawn-primary-nav"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_c('span',{staticClass:"dawn-primary-nav-toggle",on:{"click":_vm.toggleMenu}},[_c('i',{staticClass:"fa fa-bars"})]),_c('ul',{staticClass:"primary-nav-menu",class:[_vm.menuClosed ? _vm.hideMenu : !_vm.menuClosed, _vm.showMenu]},_vm._l((_vm.items),function(item,index){return (item.permissions)?_c('li',{key:index,staticClass:"primary-nav-item-wrapper"},[_c('router-link',{staticClass:"primary-nav-item",attrs:{"to":{path: item.path},"tag":"span","active-class":"active"}},[_vm._v(_vm._s(item.name))])],1):_vm._e()}),0)])]),(_vm.subNav)?_c('div',{staticClass:"dawn-seconday-nav"},[_c('div',{staticClass:"container-fluid"},[_c('ul',{staticClass:"secondary-nav-menu"},_vm._l((_vm.subNav),function(item,index){return _c('li',{staticClass:"secondary-nav-item-wrapper"},[_vm._v(":key='index'"),_c('router-link',{staticClass:"secondary-nav-item",attrs:{"to":{path: item.path},"tag":"span","active-class":"active"}},[_vm._v(_vm._s(item.name))])],1)}),0)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__("AqYs")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b1cv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters_text__ = __webpack_require__("8JoW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters_list__ = __webpack_require__("qf/r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters_date__ = __webpack_require__("H5uL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters_money__ = __webpack_require__("M0rA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__details__ = __webpack_require__("iHeH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cells_list__ = __webpack_require__("QAQz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cells_date__ = __webpack_require__("werl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cells_money__ = __webpack_require__("76Oe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cells_percent__ = __webpack_require__("BOmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cells_qty__ = __webpack_require__("FbFH");
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * Grid data/filter types
 * @module components/Grid/types
 *
 */

var DATE = ['Date', 'Sent', 'Due'];
var MONEY = ['Amount', 'Equivalent', 'Price', 'SGR', 'Negotiated', 'Preferred', 'Total', 'Paid', 'Balance', 'Tax', 'Fee', 'Invoiced', 'Uninvoiced'];
var PERCENT = ['Percent'];
var QTY = ['Quantity', 'Units'];











var Types = {
  /**
   *
   */
  details: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5__details__["a" /* default */]),
  text: {
    cell: null,
    filter: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__filters_text__["a" /* default */])
  },
  list: {
    cell: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_6__cells_list__["a" /* default */]),
    filter: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2__filters_list__["a" /* default */])
  },
  date: {
    cell: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_7__cells_date__["a" /* default */]),
    filter: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_3__filters_date__["a" /* default */]),
    width: 80
  },
  money: {
    type: 'amount',
    column: 'Currency',
    cell: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_8__cells_money__["a" /* default */]),
    filter: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4__filters_money__["a" /* default */])
  },
  percent: {
    type: 'amount',
    cell: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_9__cells_percent__["a" /* default */]),
    filter: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__filters_text__["a" /* default */])
  },
  qty: {
    type: 'amount',
    cell: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_10__cells_qty__["a" /* default */]),
    filter: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__filters_text__["a" /* default */])
  }
};
Types.parseType = function (column, key) {
  return parseColumnType(column, key);
};
/* harmony default export */ __webpack_exports__["a"] = (Types);

//
function isType(text, values, additional) {
  var len = values.length;
  for (var i = len; i--;) {
    if (text && ~text.indexOf(values[i]) || ~(additional || '').indexOf(values[i].toLowerCase())) return true;
  }
}
function parseColumnType(column, key) {
  if (column.type) {
    switch (column.type) {
      case utils.constants.columnType.List:
        return Types.list;
      case utils.constants.columnType.Date:
        return Types.date;
      case utils.constants.columnType.Money:
        return Types.money;
      case utils.constants.columnType.Percent:
        return Types.percent;
      case utils.constants.columnType.Qty:
        return Types.qty;
      case utils.constants.columnType.Text:
        return Types.text;
      default:
        return Types.text;
    }
  } else {
    return getColumnTypeBasedOnColumnName(column, key);
  }
}
function getColumnTypeBasedOnColumnName(column, key) {
  var name = column.label || column;

  // LIST
  if (column.source) return Types.list;

  // DATE
  if (isType(name, DATE)) return Types.date;

  // MONEY
  if (isType(name, MONEY, key)) return Types.money;

  // PERCENT
  if (isType(name, PERCENT)) return Types.percent;

  // QTY
  if (isType(name, QTY)) return Types.qty;

  // default
  return Types.text;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "b75X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferFunds_vue__ = __webpack_require__("p5HV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bb488c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferFunds_vue__ = __webpack_require__("deRi");
function injectStyle (ssrContext) {
  __webpack_require__("Txaa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bb488c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferFunds_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bb488c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferFunds_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bA1O":
/***/ (function(module, exports) {

module.exports = {"All":"All of the following","One":"One of the following","LessThan":"Less Than","LessThanOrEqualTo":"Less Than Or Equal To","GreaterThan":"Greater Than","GreaterThanOrEqualTo":"Greater Than Or Equal To","EqualTo":"Equal To","NotEqualTo":"Not Equal To","Is":"Is","IsNot":"Is Not"}

/***/ }),

/***/ "bD6N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_formatter__ = __webpack_require__("7VNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__helper_formatter__);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: [Number, Object],
    currency: String
  },
  computed: {
    precision: function precision() {
      if (this.currency === 'JPY') return 0;else return 2;
    },
    rounded: function rounded() {
      return this.currency ? __WEBPACK_IMPORTED_MODULE_0__helper_formatter___default.a.usNumberFormat(this.value, this.precision) : this.value;
    }
  }
});

/***/ }),

/***/ "bDlG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attach; });
var attach = function attach() {};

/***/ }),

/***/ "bJnc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'md-table',
  props: {
    columns: Array,
    data: Array,
    type: {
      type: String,
      // default | striped | hover
      default: ''
    }
  },
  computed: {
    tableClass: function tableClass() {
      return "table-".concat(this.type);
    }
  },
  methods: {
    hasValue: function hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue: function itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  }
});

/***/ }),

/***/ "bKpp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_16G2psF8NRNIjBxUaji8Ev","Dell":"_3tPfPqlbkQg0OX0qdjaXzT","Abbott":"_2y165H5JIMA9RTc7Ix7sj_","Gap":"LhRkZi4wMKeU6wPtTJnGU","Allstate":"_2vhpduuleQlcsl0EdZG1JY","Asurion":"_3xmhiLnO41KK7ZvbIxdp_A","Invitae":"_3agOvVrVzTj4CnvUeq6-tz","JWE":"_29Eqe9QVHFemnM7vFugBL8"};

/***/ }),

/***/ "bLAB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_components_edDatepicker__ = __webpack_require__("sRHZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shownDetails: false,
      formattedDate: null
    };
  },
  computed: {
    position: function position() {
      return {
        width: this.cell.style.width
      };
    },
    showCaret: function showCaret() {
      var editable = this.params.colDef.columnEditable;
      return !(this.params.data || {})._disabled && this.formattedDate && editable;
    }
  },
  created: function created() {
    //
    if (this.params.value && ~this.params.value.indexOf('Date(')) {
      this.date = this.params.value.split('Date(') && this.params.value.split('Date(')[1].split(')')[0];
      this.date = new Date(+this.date);
      this.formattedDate = __WEBPACK_IMPORTED_MODULE_0__core_components_edDatepicker__["default"].methods.formatDate(this.date, global.app.$user.sessionSettings.DateAndTimeFormats.DateFormat);
    }

    // already formatted on server-side
    if (~this.params.colDef.field.indexOf('Formatted')) {
      this.formattedDate = this.params.value;
    }
    this.colApi = this.params.api.columnController;
    this.cell = this.params.eGridCell;
    this.cell.style.overflow = 'visible';
    this.params.editMode = true;
    this.cell.className = this.cell.className.replace(' ag-cell-date-expanded', '') + ' ag-cell-date-expanded';
  },
  methods: {
    showDetails: function showDetails() {
      this.shownDetails = !this.shownDetails;
    },
    edit: function edit(v) {
      var formattedDate = __WEBPACK_IMPORTED_MODULE_0__core_components_edDatepicker__["default"].methods.formatDate(v, global.app.$user.sessionSettings.DateAndTimeFormats.DateFormat);
      var date = __WEBPACK_IMPORTED_MODULE_0__core_components_edDatepicker__["default"].methods.formatDate(v, 'YYYY-MM-DD');
      var ts = new Date(date).getTime();
      this.params.setValue("/Date(".concat(ts, ")/"));
      this.formattedDate = formattedDate;
    },
    refresh: function refresh() {
      //
      this.shownDetails = false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "bQmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newPin: '',
      pinError: '',
      confirmPin: '',
      showNewPin: false,
      showConfirmPin: false
    };
  },
  props: {
    card: Object
  },
  methods: {
    validatePin: function validatePin(pin, confirmPin) {
      if (!pin) {
        return 'PIN cannot be empty.';
      }
      if (pin.length !== 4) {
        return 'PIN must be exactly 4 digits.';
      }
      if (!/^\d+$/.test(pin)) {
        return 'PIN must contain only numbers.';
      }
      if (/^(\d)\1+$/.test(pin)) {
        return 'PIN cannot be all the same digit.';
      }
      var numbers = '01234567890';
      var reverseNumbers = '09876543210';
      if (numbers.includes(pin) || reverseNumbers.includes(pin)) {
        return 'PIN cannot contain digits in sequence.';
      }
      if (pin !== confirmPin) {
        this.newPin = '';
        this.confirmPin = '';
        return 'PIN does not match';
      }
      if (this.card.CardNumber === pin) {
        this.newPin = '';
        this.confirmPin = '';
        return 'PIN cannot be similar to the last 4 digits of the card!';
      }
      return '';
    },
    allowOnlyNumbers: function allowOnlyNumbers(field, event) {
      var value = event.target.value;
      if (!/^\d*$/.test(value)) {
        if (field === 'newPin') {
          this.newPin = value.replace(/[^0-9]/g, '');
        } else if (field === 'confirmPin') {
          this.confirmPin = value.replace(/[^0-9]/g, '');
        }
      }
    },
    toggleNewPinVisibility: function toggleNewPinVisibility() {
      this.showNewPin = !this.showNewPin;
    },
    toggleConfirmPinVisibility: function toggleConfirmPinVisibility() {
      this.showConfirmPin = !this.showConfirmPin;
    },
    changePIN: function changePIN() {
      var _arguments = arguments,
        _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var pin, confirmPin, showModal, validationError, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              pin = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this.newPin;
              confirmPin = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this.confirmPin;
              showModal = _arguments.length > 2 ? _arguments[2] : undefined;
              _this.pinError = '';
              validationError = _this.validatePin(pin, confirmPin);
              if (!validationError) {
                _context.next = 8;
                break;
              }
              _this.pinError = validationError;
              return _context.abrupt("return");
            case 8:
              _context.prev = 8;
              if (!(_this.card.Id && pin && confirmPin)) {
                _context.next = 14;
                break;
              }
              _context.next = 12;
              return _this.api.patch("evedpaycards/".concat(_this.card.Id, "/set-pin"), {
                pin: pin
              });
            case 12:
              response = _context.sent;
              if (response.status === 200) {
                showModal.showModal = false;
                _this.$emit('pinChangeSuccess');
              } else {
                _this.pinError = 'Failed to change pin';
              }
            case 14:
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](8);
              _this.pinError = 'Failed to change pin';
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[8, 16]]);
      }))();
    }
  }
});

/***/ }),

/***/ "bSZ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_vue__ = __webpack_require__("+qQe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-checkbox',
  props: {
    value: null,
    defaultValue: Boolean,
    options: Array,
    fieldLabel: String,
    hideOptional: Boolean,
    name: String,
    disabled: Boolean,
    removeOnly: Boolean,
    error: Boolean,
    helptipHeader: String,
    helptipBody: String,
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'checkbox': __WEBPACK_IMPORTED_MODULE_0__checkbox_vue__["default"]
  },
  computed: {
    filteredOptions: function filteredOptions() {
      return this.value;
    }
  },
  data: function data() {
    return {
      localValue: null,
      localOptions: null
    };
  },
  created: function created() {
    this.listModel = this.value && this.value.constructor === Array;
    this.initList();
  },
  methods: {
    initList: function initList() {
      if (typeof this.options === 'undefined') {
        this.modelBased = true;
        this.localOptions = this.value;
      }
    },
    changeStatus: function changeStatus(option, value) {
      option.status = value;
      var _value = value;
      if (this.listModel && !this.modelBased) {
        var copy = this.value.slice();
        var _option = option.key || option;
        value ? copy.indexOf(_option) >= 0 || copy.push(_option) : copy.splice(copy.indexOf(_option), 1);
        _value = copy;
      }
      this.$emit('select');
      if (this.modelBased) {
        this.$emit('input', this.localOptions);
      } else {
        this.$emit('input', _value);
      }
      this.$emit('click', option);
    },
    checked: function checked(option) {
      if (this.listModel && !this.modelBased) {
        return this.value.indexOf(option.key || option) >= 0;
      }
      return typeof option.status === 'undefined' ? this.defaultValue : option.status;
    }
  }
});

/***/ }),

/***/ "bWaD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__("lOj7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Approval_rule__ = __webpack_require__("JWhq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Approval_history__ = __webpack_require__("hcet");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__core_events_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_Admin_settings__ = __webpack_require__("Ht71");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_user__ = __webpack_require__("uduW");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_1__components_Grid__["a" /* default */],
    ApprovalRule: __WEBPACK_IMPORTED_MODULE_3__Approval_rule__["default"],
    ApprovalHistory: __WEBPACK_IMPORTED_MODULE_4__Approval_history__["default"]
  },
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_2__model___default.a,
      showModal: false,
      modalApprovalRuleId: 0,
      disableSingleButton: true,
      ruleId: 0,
      showDeleteRuleModal: false,
      ruleToDelete: 0,
      title: '',
      subtitle: '',
      settings: {},
      settingsCopy: {},
      replyToEmailOptions: [],
      primaryButtonDisabled: false,
      approvalNoteLabel: 'Approval Note',
      approvalNotePlaceholder: '',
      isRequiredApprovalNote: false,
      requireCommentFromSubmitterOnly: false,
      disableSecondApprovalNoteCheckbox: false,
      approvalNoteError: false,
      displayApprovalNoteSettings: false
    };
  },
  created: function created() {
    var _this = this;
    // handle Edit Button availability
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* Eved */].GENERIC.SELECTED_ITEM).$on(__WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* Eved */].GENERIC.SELECTED_ITEM, function (r) {
      _this.handleButtons(r);
    });
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ITEM).$on(__WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ITEM, function (r) {
      _this.handleButtons(r);
    });
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* Eved */].GENERIC.SELECTED_ALL).$on(__WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* Eved */].GENERIC.SELECTED_ALL, function (r) {
      _this.handleButtons(r);
    });
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ALL).$on(__WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* Eved */].GENERIC.UNSELECTED_ALL, function (r) {
      _this.handleButtons(r);
    });
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_6__core_events_events___default.a.APPROVAL_RULE.REFRESH, function (r) {
      _this.refresh();
    });
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_6__core_events_events___default.a.APPROVAL_RULE.VALIDATION_PASSED).$on(__WEBPACK_IMPORTED_MODULE_6__core_events_events___default.a.APPROVAL_RULE.VALIDATION_PASSED, function (r) {
      _this.closeModal();
    });
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_6__core_events_events___default.a.APPROVAL_RULE.ENABLE_SAVE_BUTTON).$on(__WEBPACK_IMPORTED_MODULE_6__core_events_events___default.a.APPROVAL_RULE.ENABLE_SAVE_BUTTON, function (r) {
      _this.enableSaveButton();
    });
    this.initApprovalNoteSection();
    this.settings = this.$user.$.settings; // this.updateSettings()
    this.settingsCopy = utils.copy(this.settings);
    this.approvalNoteError = false;
  },
  methods: {
    updateSettings: function updateSettings(values) {
      var companySettingsCopy = JSON.parse(global.localStorage.getItem('sessionSettings'));
      var updatedCompanySettings = _objectSpread(_objectSpread({}, companySettingsCopy), {}, {
        CompanySettings: values
      });
      global.localStorage.setItem('sessionSettings', JSON.stringify(updatedCompanySettings));
      this.$user.$.settings = values;
      return __WEBPACK_IMPORTED_MODULE_7__components_modules_Admin_settings__["a" /* default */].methods.updateSettings.call(this, values);
    },
    refresh: function refresh() {
      this.$refs.ApprovalRuleGrid.quickSearch();
      this.$refs.ApprovalRuleGrid.onSelectAll(false);
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.$notifications.removeAll();
    },
    enableSaveButton: function enableSaveButton() {
      this.primaryButtonDisabled = false;
      this.$store.state.enableSaveButton = true;
    },
    openRule: function openRule(ruleId, isEdit) {
      if (isEdit) {
        this.title = 'Edit Approval Rule';
        this.subtitle = 'Edit custom rules to trigger approvals.';
        this.primaryButtonDisabled = true;
        this.$store.state.enableSaveButton = false;
      } else {
        this.title = 'Add Approval Rule';
        this.subtitle = 'Add custom rules to trigger approvals.';
        this.primaryButtonDisabled = false;
        this.$store.state.enableSaveButton = true;
      }
      this.modalApprovalRuleId = ruleId;
      this.showModal = true;
    },
    open: function open() {
      var payload = {
        id: this.modalApprovalRuleId
      };
      __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_6__core_events_events___default.a.APPROVAL_RULE.OPENED, payload);
    },
    openDeleteModal: function openDeleteModal(ruleId) {
      this.showDeleteRuleModal = true;
      this.ruleToDelete = ruleId;
    },
    save: function save() {
      __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_6__core_events_events___default.a.APPROVAL_RULE.SAVED);
    },
    deleteRule: function deleteRule() {
      this.showDeleteRuleModal = false;
      if (this.ruleToDelete && this.ruleToDelete > 0) {
        var payload = {
          ruleId: this.ruleToDelete
        };
        this.api.forms.post(this.api.$.approval.deleteRule, payload).then(this.validateDeleteRule);
      } else {
        alert('Cannot delete this rule. Id is undefined');
      }
    },
    validateDeleteRule: function validateDeleteRule(r) {
      if (r.data === false) {
        alert('Something went wrong. Could not delete this rule.');
      } else {
        __WEBPACK_IMPORTED_MODULE_5__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_6__core_events_events___default.a.APPROVAL_RULE.REFRESH);
      }
    },
    handleButtons: function handleButtons(r) {
      if (r && r.data && r.data.length === 1) {
        this.disableSingleButton = false;
        this.ruleId = r.data[0].ApprovalRuleId;
      } else {
        this.disableSingleButton = true;
        this.ruleId = 0;
      }
    },
    canReplyToEmailSetting: function canReplyToEmailSetting(e) {
      if (!e.status) {
        this.settingsCopy.EnableReplyToEmail = false;
      } else {
        this.settingsCopy.EnableReplyToEmail = true;
      }
      this.saveSettings();
    },
    saveSettings: function saveSettings(setting) {
      var _this2 = this;
      var payload = {
        canReply: this.settingsCopy.EnableReplyToEmail
      };
      this.api.forms.post(this.api.$.approval.saveSettings, payload).then(function (r) {
        _this2.updateSettings(_this2.settingsCopy);
      }).catch(function (e) {
        _this2.settingsCopy = utils.copy(_this2.settings);
      });
    },
    initApprovalNoteSection: function initApprovalNoteSection() {
      var _this3 = this;
      var userSettings = __WEBPACK_IMPORTED_MODULE_8__core_user__["a" /* default */].get().data;
      if (userSettings && userSettings.IsE360 === false) {
        this.displayApprovalNoteSettings = true;
        this.api.forms.get(this.api.$.approval.initApprovalNote).then(function (r) {
          _this3.isRequiredApprovalNote = r.data.isRequired;
          _this3.requireCommentFromSubmitterOnly = r.data.requireCommentFromSubmitterOnly;
          _this3.disableSecondApprovalNoteCheckbox = !_this3.isRequiredApprovalNote;
          _this3.approvalNoteLabel = r.data.label;
          _this3.approvalNotePlaceholder = r.data.placeholder;
        });
      } else {
        this.displayApprovalNoteSettings = false;
      }
    },
    isValidApprovalNote: function isValidApprovalNote() {
      if (!this.approvalNoteLabel || this.approvalNoteLabel.trim() === '') {
        this.approvalNoteError = true;
        return false;
      } else {
        this.approvalNoteError = false;
      }
      return true;
    },
    saveApprovalNoteSettings: function saveApprovalNoteSettings() {
      if (!this.isRequiredApprovalNote) {
        this.requireCommentFromSubmitterOnly = false;
        this.disableSecondApprovalNoteCheckbox = true;
      } else {
        this.disableSecondApprovalNoteCheckbox = false;
      }
      if (this.isValidApprovalNote()) {
        this.api.forms.post(this.api.$.approval.saveApprovalNote, {
          isRequired: this.isRequiredApprovalNote,
          requireCommentFromSubmitterOnly: this.requireCommentFromSubmitterOnly,
          label: this.approvalNoteLabel,
          placeholder: this.approvalNotePlaceholder
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "bb1j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1Bnef3cz6UtGhS8aFjg-id","Dell":"_3TYZ-IpFUkOBv1iV-XByl0","Abbott":"_3bpNwiF9bXvHCLFSxvvIMM","Gap":"p67OcXTrR8Qg-X2UcigVk","Allstate":"_3Snn_0lUMMDq4n5QFzt0-O","Asurion":"HG85xGOfIXnc3xYM0Hsnz","Invitae":"_2NfoKxAw0XeaRnHDwZu5EJ","JWE":"tyRQ0M01yU_MZqYVdzqfI"};

/***/ }),

/***/ "bc6u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cards__ = __webpack_require__("UGg9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transactions__ = __webpack_require__("fk/s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings__ = __webpack_require__("AOcX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cardtransactions__ = __webpack_require__("kaxp");
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpay',
  data: function data() {
    return {
      //
      tabs: [{
        label: 'Cards',
        title: 'Active Cards',
        component: __WEBPACK_IMPORTED_MODULE_0__cards__["a" /* default */]
      }, {
        label: 'Transactions',
        title: 'All Transactions',
        component: __WEBPACK_IMPORTED_MODULE_1__transactions__["a" /* default */]
      }, {
        label: 'Settings',
        title: 'Settings',
        component: __WEBPACK_IMPORTED_MODULE_2__settings__["a" /* default */]
      }, {
        label: 'CardTransactions',
        title: 'Card Transactions',
        component: __WEBPACK_IMPORTED_MODULE_3__cardtransactions__["a" /* default */]
      }]
    };
  }
});

/***/ }),

/***/ "bsTF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"UQL1-e0SJyWomBX91Ycmd","Dell":"_1gXs6xJ_kZMt9bE3zklYDm","Abbott":"_2J63Gsu7epPhQaYZVnDQ3y","Gap":"_2TUVXvQh6C6SJ9MRpb0Zie","Allstate":"GrZx9qccGWx9MpSGbJhma","Asurion":"TGQuG2a_gFz2wwZ_fBQFQ","Invitae":"gAVCCj9_JwvEFal4BVVUj","JWE":"_2CU74wjHynSCBEDUYE3Eod"};

/***/ }),

/***/ "bvG0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1KTBm7aFd9zDt3FGWLxxKH","Dell":"ccmxeaDrAw8XRDRSMzlxL","Abbott":"_1cPhk79rejJysIKkPKkQy2","Gap":"_1ty4VIdPkTM6pRxIiXUOth","Allstate":"_3WZf0_aPzU2XeNo8691PtM","Asurion":"_1o-tnThyati0j6gY6dz-3e","Invitae":"xyPICLVE4VfajB3Uguuy9","JWE":"_1gj33XwPt51DlMQ7h7M16L"};

/***/ }),

/***/ "bwoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'md-blockquote',
  props: {
    content: {
      type: String,
      required: true
    },
    author: String
  }
});

/***/ }),

/***/ "bxwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.featureFlags.legacyViewDisabled)?_c('nav',{staticClass:"navbar navbar-primary navbar-transparent- navbar-absolute",class:_vm.tabsClass.value},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse"},on:{"click":_vm.toggleSideBar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_c('span',{staticClass:"icon-bar"}),_c('span',{staticClass:"icon-bar"}),_c('span',{staticClass:"icon-bar"})]),_c('a',{staticClass:"navbar-brand logo",attrs:{"href":"#/home"}},[(!_vm.config.namespace)?_c('img',{attrs:{"src":__webpack_require__("AqYs"),"height":"35"}}):_vm._e(),(_vm.config.title)?_c('p',[_vm._v(_vm._s(_vm.$t(_vm.config.title)))]):_vm._e()])]),_c('div',{staticClass:"collapse navbar-collapse text-right"},[_c('site-map',{attrs:{"reference":_vm.reference,"className":_vm.tabsClass}})],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c16a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_ApprovalNeeded_reject_dialog__ = __webpack_require__("2E/x");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'RejectAll',
  data: function data() {
    return {
      loading: false,
      dataUrl: null,
      rejectUrl: null,
      rejectText: null,
      showRejectDialog: false,
      cards: []
    };
  },
  computed: {
    hasData: function hasData() {
      return this.cards !== null && this.cards.length > 0;
    }
  },
  created: function created() {
    this.reload();
  },
  methods: {
    reload: function reload() {
      var _this = this;
      this.loading = true;
      this.api.get(this.api.$.dashboard.widgetInfo + '/2845D6A6-F692-493C-83DF-BACD8D349BC8', {}).then(function (rd) {
        _this.dataUrl = rd.data.endPoint;
        _this.rejectUrl = _this.dataUrl.replace(/GetApprovalNeededList/, 'Reject');
        var params = _this.$route.query.batchId > 0 ? {
          params: {
            batchId: +_this.$route.query.batchId
          }
        } : {};
        _this.api.get(_this.dataUrl, params).then(function (r) {
          _this.rejectText = 'Decline';
          _this.cards = r.data.items;
          if (_this.hasData) {
            _this.showRejectDialog = true;
          }
        }).finally(function () {
          _this.loading = false;
        });
      });
    },
    gotoDashboard: function gotoDashboard() {
      this.$router.push('/home');
    },
    doReject: function doReject(reason) {
      var _this2 = this;
      this.loading = true;
      this.api.post(this.rejectUrl, {
        list: this.getIdsList(),
        reason: reason
      }).finally(function () {
        _this2.loading = false;
        _this2.gotoDashboard();
      });
    },
    getIdsList: function getIdsList() {
      return this.cards.map(function (item) {
        return item.Id;
      });
    }
  },
  components: {
    rejectDialog: __WEBPACK_IMPORTED_MODULE_0__widgets_ApprovalNeeded_reject_dialog__["default"]
  }
});

/***/ }),

/***/ "c1xZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cEym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper list",attrs:{"endpoint":_vm.widget.endPoint}},[_c('div',{staticClass:"scroller"},[_c('div',{staticClass:"button-holder"},[_vm._l((_vm.buttons),function(button,i){return [(_vm.isVisible(button))?_c('div',{staticClass:"col-md-3"},[_c('ed-button',{key:i,staticClass:"btn btn-actionbar shortcut-btn",attrs:{"title":_vm.getLabel(button).fullText},on:{"click":function($event){return _vm.handleClick(button)}}},[_vm._v("\n            "+_vm._s(_vm.getLabel(button).shortText)+"\n          ")])],1):_vm._e()]})],2)]),_vm._v(" "),_c('addDivisionModal',{attrs:{"show":_vm.showAddDivision},on:{"close":_vm.closeDivisionModal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cMpp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__condition__ = __webpack_require__("Rj8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action__ = __webpack_require__("Rs/e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rule__ = __webpack_require__("p19q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__("naW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__core_events_events__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var approvalRuleUtils = __webpack_require__("IJVW");
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Condition: __WEBPACK_IMPORTED_MODULE_0__condition__["a" /* default */],
    Action: __WEBPACK_IMPORTED_MODULE_1__action__["a" /* default */],
    Rule: __WEBPACK_IMPORTED_MODULE_2__rule__["a" /* default */]
  },
  props: {
    self: Object,
    children: Array,
    depth: Number,
    conditions: Object,
    actions: Object,
    label: String,
    conditionOptions: Object,
    actionOptions: Object,
    routeValues: Array,
    useParallelApprovalRoutes: Boolean
  },
  name: 'rule',
  data: function data() {
    return {
      utils: utils,
      conditionsCopy: utils.copy(this.conditions),
      type: __WEBPACK_IMPORTED_MODULE_3__type___default.a,
      list: utils.collection.list,
      max: utils.collection.max,
      isEmpty: utils.collection.isEmpty,
      showDeleteIfGroup: false,
      showDeleteThenGroup: false,
      componentDestroyed: false,
      dragStarted: false
    };
  },
  created: function created() {
    var rulesArray = this.list(this.self);
    for (var i = 0; i < rulesArray.length; i++) {
      this.$store.state.approvalRuleIds.ruleIds.push(rulesArray[i].Id);
    }
    if (this.conditions && this.conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition]) {
      var conditionsArray = this.list(this.conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition]);
      for (var j = 0; j < conditionsArray.length; j++) {
        this.$store.state.approvalRuleIds.conditionIds.push(conditionsArray[j].Id);
      }
    }
    if (this.actions && this.actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action]) {
      var actionsArray = this.list(this.actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action]);
      for (var k = 0; k < actionsArray.length; k++) {
        this.$store.state.approvalRuleIds.actionIds.push(actionsArray[k].Id);
      }
    }
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_5__core_events_events___default.a.APPROVAL_RULE.VALIDATE_COMPONENTS, this.validateRule);
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on('onDragStarted', this.onDragStarted);
  },
  // solution from this link does not work
  // https://stackoverflow.com/questions/45399302/stop-receiving-events-from-destroyed-child-component
  beforeDestroy: function beforeDestroy() {
    this.componentDestroyed = true;
  },
  computed: {
    getId: function getId() {
      return 'dd-' + this.self.Id;
    },
    indent: function indent() {
      return {
        paddingLeft: "".concat(this.depth ? 20 : 0, "px")
      };
    },
    isRoot: function isRoot() {
      return this.depth === 0;
    },
    newCondition: function newCondition() {
      return {
        Id: 0,
        '@xsi:type': '',
        __selectedOptions: [],
        __selectedContextType: '',
        __o: [{}],
        conditionValues: []
      };
    },
    newAction: function newAction() {
      return {
        Id: 0,
        '@xsi:type': '',
        __selectedOptions: [],
        __selectedContextType: '',
        __o: [{}],
        actionValues: []
      };
    }
  },
  methods: {
    validateRule: function validateRule() {
      if (!this.componentDestroyed) {
        var valid = true;

        // verify general conditions on rule
        if (!this.self.Conditions || this.self.Conditions && (!this.self.Conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition] || this.list(this.self.Conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition]).length === 0)) {
          valid = false;
        }
        if (!this.self.Operator) {
          valid = false;
        }
        if ((!this.self.Children || this.self.Children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule] && Array.isArray(this.self.Children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule]) && this.self.Children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule].length === 0) && (!this.self.Actions || !this.self.Actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action] || this.list(this.self.Actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action]).length === 0)) {
          valid = false;
        }
        if (!valid) {
          this.invalidateConditionBlock();
        } else {
          this.resetConditionBlock();
        }
        var payload = {
          Id: this.self.Id,
          valid: valid
        };
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_5__core_events_events___default.a.APPROVAL_RULE.VALIDATION_COMPLETED, payload);
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('%Saved Approval Rule');
      }
    },
    invalidateConditionBlock: function invalidateConditionBlock() {
      if (this.$refs.ruleRaw && this.$refs.ruleRaw.classList) {
        this.$refs.ruleRaw.classList.add('invalid');
      }
    },
    resetConditionBlock: function resetConditionBlock() {
      if (this.$refs.ruleRaw && this.$refs.ruleRaw.classList) {
        this.$refs.ruleRaw.classList.remove('invalid');
      }
    },
    addLine: function addLine(r) {
      var copyConditions = this.list(this.conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition]);
      copyConditions.push(r);
      this.conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition] = copyConditions.length === 1 ? copyConditions[0] : copyConditions;
    },
    updateCondition: function updateCondition(r) {
      var idToFind = r.Id;
      var updatedCondition = r.Condition;
      var copyConditions = this.list(utils.copy(this.conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition]));
      var updated = false;
      copyConditions = copyConditions.map(function (cond) {
        if (cond.Id === idToFind) {
          cond = updatedCondition;
          updated = true;
        }
        return cond;
      });
      if (updated) {
        this.conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition] = copyConditions.length === 1 ? copyConditions[0] : copyConditions;
      }
      this.$forceUpdate();
    },
    updateAction: function updateAction(r) {
      var idToFind = r.Id;
      var updatedAction = r.Action;
      var copyActions = this.list(utils.copy(this.actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action]));
      var updated = false;
      copyActions = copyActions.map(function (action) {
        if (action.Id === idToFind) {
          action = updatedAction;
          updated = true;
        }
        return action;
      });
      if (updated) {
        this.actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action] = copyActions.length === 1 ? copyActions[0] : copyActions;
      }
    },
    changeOperator: function changeOperator(r) {
      this.Operator = r;
    },
    changeActionOperator: function changeActionOperator(r) {
      this.ActionOperator = r;
    },
    copyLine: function copyLine(r) {
      var copyConditions = this.list(this.conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition]);
      copyConditions.push(r);
      this.conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition] = copyConditions;
    },
    deleteLine: function deleteLine(r) {
      var copyConditions = this.list(this.conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition]);
      copyConditions = copyConditions.filter(function (condition) {
        return condition.Id !== r.Id;
      });
      this.conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition] = copyConditions.length === 1 ? copyConditions[0] : copyConditions;
    },
    addActionLine: function addActionLine(r) {
      var copyActions = this.list(this.actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action]);
      copyActions.push(r);
      this.actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action] = copyActions.length === 1 ? copyActions[0] : copyActions;
    },
    copyActionLine: function copyActionLine(r) {
      var copyActions = this.list(this.actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action]);
      copyActions.push(r);
      this.actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action] = copyActions;
    },
    deleteActionLine: function deleteActionLine(r) {
      var copyActions = this.list(this.actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action]);
      copyActions = copyActions.filter(function (action) {
        return action.Id !== r.Id;
      });
      this.actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action] = copyActions.length === 1 ? copyActions[0] : copyActions;
    },
    deleteConditionModal: function deleteConditionModal() {
      this.showDeleteIfGroup = true;
    },
    deleteActionModal: function deleteActionModal() {
      this.showDeleteThenGroup = true;
    },
    deleteConditionGroup: function deleteConditionGroup() {
      if (this.$parent && this.$parent.self && this.$parent.self.Children && this.$parent.self.Children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule]) {
        var siblings = this.$parent.self.Children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule];
        if (this.list(siblings).length === 1) {
          this.$parent.self.Children = null;
        } else {
          if (this.list(siblings).length > 1) {
            siblings.splice(siblings.indexOf(this.self), 1);
          }
        }
      }
      this.enableSaveButton();
    },
    deleteActionGroup: function deleteActionGroup() {
      this.self.Actions = {};
      delete this.self.ActionOperator;
      this.enableSaveButton();
    },
    addRuleGroup: function addRuleGroup() {
      this.enableSaveButton();
      var newRule = {
        Id: this.max(this.$store.state.approvalRuleIds.ruleIds) + 1,
        Children: null,
        Conditions: {
          ConditionDTO: []
        },
        Actions: {}
      };
      this.newCondition.Id = this.max(this.$store.state.approvalRuleIds.conditionIds) + 1;
      newRule.Conditions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.condition].push(utils.copy(this.newCondition));

      // No rules yet
      if (!this.self.Children) {
        var children = {};
        children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule] = [];
        children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule].push(newRule);
        this.self.Children = children;
        return;
      }

      // Existing rules
      if (this.self.Children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule].constructor === Array) {
        this.self.Children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule].push(newRule);
        return;
      }

      // One rule
      if (this.self.Children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule].constructor === Object) {
        this.self.Children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule] = this.list(this.self.Children[__WEBPACK_IMPORTED_MODULE_3__type___default.a.rule]).concat(newRule);
        return;
      }
    },
    addCondition: function addCondition() {
      this.$refs.conditionLine.addCondition(this.newCondition);
      this.enableSaveButton();
    },
    addAction: function addAction() {
      this.enableSaveButton();
      // No rules yet
      if (this.isEmpty(this.self.Actions) || (this.self.Actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action] && this.self.Actions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action].length === undefined) === undefined) {
        if (this.$store.state.approvalRuleIds.actionIds.length > 0) {
          this.newAction.Id = this.max(this.$store.state.approvalRuleIds.actionIds) + 1;
        } else {
          var firstActionId = this.self.Id * 100;
          this.newAction.Id = firstActionId;
        }
        this.$store.state.approvalRuleIds.actionIds.push(this.newAction.Id);
        var copyNewAction = utils.copy(this.newAction);
        var newActions = {};
        newActions[__WEBPACK_IMPORTED_MODULE_3__type___default.a.action] = copyNewAction;
        this.self.Actions = newActions;
        return;
      } else {
        this.$refs.actionLine.addAction(this.newAction);
      }
    },
    enableSaveButton: function enableSaveButton() {
      approvalRuleUtils.utils.enableSaveButton(!this.$store.state.enableSaveButton);
    },
    onDragStarted: function onDragStarted(payload) {
      if (this) {
        this.dragStarted = payload.data.started;
      }
    },
    dragStart: function dragStart(event) {
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('onDragStarted', {
        started: true
      });

      // make it half transparent
      event.dataTransfer.effectAllowed = 'copyMove';

      // store a ref. on the dragged elem
      var id = this.self.Id;
      var row = document.querySelector("#dd-".concat(id));
      var rowClone = row.cloneNode(true);
      row.classList.add('dd-over-start');
      rowClone.classList.add('dd-ghost');
      rowClone.classList.add('ag-row-dragging');
      rowClone.style.width = "1030px";
      rowClone.id = '';
      document.body.appendChild(rowClone);
      event.dataTransfer.setDragImage && event.dataTransfer.setDragImage(rowClone, 0, 0);
      event.dataTransfer.setData('text/plain', id);
    },
    dragging: function dragging(event) {
      event.preventDefault();
      var id = this.self.Id;
      var row = document.querySelector("#dd-".concat(id));
      row.classList.remove('dd-over-start');
      this.$parent.draggingFromId = id;
    },
    allowDrop: function allowDrop(event) {
      var fromId = this.$parent.$parent.draggingFromId;
      var parentId = this.$parent.self.Id;
      var id = this.self.Id;
      var row = document.querySelector("#dd-".concat(id));
      if (fromId !== parentId) {
        row.classList.add('dd-over');
      } else {
        row.classList.add('dd-over-not-allowed');
      }
      event.preventDefault();
    },
    dragLeave: function dragLeave(event) {
      var id = this.self.Id;
      var row = document.querySelector("#dd-".concat(id));
      row.classList.remove('dd-over');
      row.classList.remove('dd-over-start');
      row.classList.remove('dd-over-not-allowed');
    },
    dragEnd: function dragEnd(event) {
      var id = this.self.Id;
      var row = document.querySelector("#dd-".concat(id));
      row.classList.remove('dd-over');
      row.classList.remove('dd-over-not-allowed');
      event.preventDefault();
      event.stopPropagation();
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('onDragStarted', {
        started: false
      });
    },
    drop: function drop(event) {
      // prevent default action (open as link for some elements)
      event.preventDefault();
      event.stopPropagation();

      // find ID of the dragged elem
      var fromId = +event.dataTransfer.getData('text/plain');
      event.dataTransfer.clearData();
      if (event.target.className === 'dd-overlay' && +this.self.Id !== fromId) {
        var fromNode = document.querySelector('#dd-' + fromId);
        // avoid drop parent before child (error: The new child element contains the parent)
        var canMoveElement = !(this.depth === 2 && fromNode && this.$el.parentNode && fromNode === this.$el.parentNode.parentNode);
        if (fromNode && canMoveElement) {
          // move dragged elem to the selected drop target
          fromNode.parentNode.removeChild(fromNode);
          this.$el.parentNode.insertBefore(fromNode, this.$el);

          // avoid beeing marked as destroyed
          this.componentDestroyed = false;

          // allow rule to be saved
          this.enableSaveButton();

          // update order in RuleDTO object
          __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_5__core_events_events___default.a.APPROVAL_RULE.UPDATE_RULE.MOVE_RULE, {
            fromRuleId: fromId,
            toRuleId: +this.self.Id
          });
        }
      }
      this.dragEnd(event);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "cNnW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},[_c('div',{staticClass:"calendar-header"},[(_vm.currentPanel === 'time')?_c('a',{on:{"click":function($event){_vm.currentPanel = 'date'}}},[_vm._v(_vm._s(_vm.now.toLocaleDateString()))]):[_c('a',{staticClass:"calendar__prev-icon",on:{"click":function($event){return _vm.changeYear(-1)}}},[_vm._v("«")]),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPanel === 'date'),expression:"currentPanel === 'date'"}],staticClass:"calendar__prev-icon",on:{"click":function($event){return _vm.changeMonth(-1)}}},[_vm._v("‹")]),_c('a',{staticClass:"calendar__next-icon",on:{"click":function($event){return _vm.changeYear(1)}}},[_vm._v("»")]),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPanel === 'date'),expression:"currentPanel === 'date'"}],staticClass:"calendar__next-icon",on:{"click":function($event){return _vm.changeMonth(1)}}},[_vm._v("›")]),_c('a',{on:{"click":_vm.showMonths}},[_vm._v(_vm._s(_vm.months[_vm.currentMonth]))]),_vm._v(" "),_c('a',{on:{"click":_vm.showYears}},[_vm._v(_vm._s(_vm.currentYear))])]],2),_c('div',{staticClass:"calendar-content"},[_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPanel === 'date'),expression:"currentPanel === 'date'"}],staticClass:"calendar-table"},[_c('thead',[_c('tr',_vm._l((_vm.days),function(day,index){return _c('th',{key:index},[_vm._v(_vm._s(day))])}),0)]),_c('tbody',_vm._l((_vm.dates),function(row){return _c('tr',_vm._l((row),function(cell){return _c('td',{class:_vm.getDateClasses(cell),attrs:{"title":cell.title},on:{"click":function($event){return _vm.selectDate(cell)}}},[_vm._v(_vm._s(cell.day))])}),0)}),0)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPanel === 'years'),expression:"currentPanel === 'years'"}],staticClass:"calendar-year"},_vm._l((_vm.years),function(year){return _c('a',{class:{'current': _vm.currentYear === year},on:{"click":function($event){return _vm.selectYear(year)}}},[_vm._v(_vm._s(year))])}),0),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPanel === 'months'),expression:"currentPanel === 'months'"}],staticClass:"calendar-month"},_vm._l((_vm.months),function(month,index){return _c('a',{class:{'current': _vm.currentMonth === index},on:{"click":function($event){return _vm.selectMonth(index)}}},[_vm._v(_vm._s(month))])}),0),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPanel === 'time'),expression:"currentPanel === 'time'"}],staticClass:"calendar-time"},_vm._l((_vm.times),function(time,index){return _c('div',{key:index,staticClass:"time-list-wrapper",style:({width: 100 / _vm.times.length + '%' })},[_c('ul',{staticClass:"time-list"},_vm._l((time),function(num){return _c('li',{key:num,staticClass:"time-item",class:_vm.getTimeClasses(num, index),on:{"click":function($event){return _vm.selectTime(num, index)}}},[_vm._v(_vm._s(_vm._f("timeText")(num)))])}),0)])}),0)]),(!_vm.range)?_c('div',{staticClass:"calendar-footer calendar-header"},[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar"},on:{"click":_vm.selectToday}},[_vm._v("Today")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cS7h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("L4ZZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca183d7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("bxwV");
function injectStyle (ssrContext) {
  __webpack_require__("KvOe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ca183d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca183d7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cUQy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tabs = function tabs() {
  return [ACCOUNTS, CARDS, TRANSACTIONS, ENVELOPES];
};
/* harmony default export */ __webpack_exports__["a"] = ({
  get tabs() {
    return tabs();
  }
});
var ACCOUNTS = {
  label: 'Accounts',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: undefined
    }
  }
};
var CARDS = {
  label: 'Cards',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: 'cards'
    }
  }
};
var TRANSACTIONS = {
  label: 'Transactions',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: 'transactions'
    }
  }
};
var ENVELOPES = {
  label: 'Envelopes',
  href: {
    params: {
      page: 'Programs',
      section: '>Card',
      action: 'envelopes'
    }
  }
};

/***/ }),

/***/ "cXFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__("NM/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);





function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var FIELD_TYPES = {
  number: 'ed-input',
  textarea: 'ed-textarea',
  text: 'ed-input',
  email: 'ed-input',
  select: 'ed-select',
  date: 'ed-datepicker',
  file: 'ed-upload'
};
var opIn = function opIn(value, collection) {
  return !!~collection.indexOf(value);
};
var opNotIn = function opNotIn() {
  return !opIn.apply(void 0, arguments);
};
var operators = {
  'IN': opIn,
  'NOT IN': opNotIn
};
var fieldMapper = function fieldMapper(field) {
  return _objectSpread(_objectSpread({}, field.constructor.name === 'Object' ? field : {}), {}, {
    type: FIELD_TYPES[field.type] || field.type || FIELD_TYPES['text'],
    nativeType: field.type === 'number' ? 'text' : field.type || 'text',
    key: field.name || field.key || (field.label || field).replace && (field.label || field).replace(/ /g, ''),
    label: field.label || field,
    required: field.required || (field.validation || {}).required,
    dependency: (field.validation || {}).dependencies[0],
    integer: field.type === 'number'
  });
};
var TEMPLATE_FIELD = 'templateName';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'customFields',
  props: {
    endpoint: String,
    queryParameters: Object,
    values: Array
  },
  created: function created() {
    this.getCustomFields();
  },
  data: function data() {
    var _this = this;
    return {
      FormModel: {},
      formSettings: {},
      FIELD_TYPES: FIELD_TYPES,
      //
      headers: {},
      submitAction: '',
      canSubmit: true,
      options: {},
      sentInvite: false,
      showCancelBtn: false,
      formFields: [],
      counter: 0,
      loading: false,
      lastUpdatedKey: '',
      hash: function hash(field) {
        var hash = field.key + field.validation.dependencies.map(function (d) {
          return (_this.FormModel[d.name] || {}).text;
        }).join('-') + _this.counter;
        // field.hash = field.hash || hash
        return hash;
      },
      shouldBeVisible: function shouldBeVisible(field) {
        if (_this.loading) return false;
        var dependencies = !!field.validation.dependencies.length;
        field.validation.unresolvedDependencies = [];
        return !dependencies || field.validation.dependencies.some(function (dependency) {
          var dependsOn = _this.FormModel[dependency.name];
          var dependsOnValue = (dependsOn || {}).text;
          var collection = dependency.values;
          var resolved = operators[dependency.operator](dependsOnValue, collection) || !collection.length;
          if (resolved) {
            field.validation.unresolvedDependencies.push(dependency.name);
          }
          return dependsOnValue && resolved;
        });
      },
      shouldShowInfo: function shouldShowInfo(field) {
        if (_this.loading) return false;
        var info = '';
        if (field.type === FIELD_TYPES.file) {
          var dependsOn = field.validation.unresolvedDependencies[0];
          var dependsOnLabel = (_this.mapFields.find(function (customField) {
            return customField.name === dependsOn;
          }) || {}).label;
          var dependsOnValue = dependsOn && (_this.FormModel[dependsOn] || {}).text;
          info = !dependsOnValue && {
            label: dependsOnLabel,
            meta: dependsOn === (field.validation.dependencies[0] || {}).name ? 'first' : ''
          };
        }
        return info;
      },
      validationMessage: function validationMessage(field) {
        return _this.$v.FormModel[field.key] && _this.$v.FormModel[field.key].$error ? field.description || "Please fill in ".concat(_this.$v.FormModel[field.key].validationRule === false && _this.$v.FormModel[field.key].$model ? 'a valid' : 'the', " ").concat(field.label) : field.description;
      }
    };
  },
  validations: function validations() {
    return {
      FormModel: _objectSpread({}, this.validationRules)
    };
  },
  computed: {
    mapFields: function mapFields() {
      return this.formFields.filter(function (f) {
        return !f.hidden;
      }).map(fieldMapper);
    },
    validationRules: function validationRules() {
      var _this2 = this;
      var validations = {};
      this.mapFields.forEach(function (field) {
        validations[field.key] = field.required ? {
          isValid: function isValid(v) {
            return !_this2.shouldBeVisible(field) ? true : Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"])(v);
          }
        } : {};
      });
      return validations;
    }
  },
  methods: {
    getQueryString: function getQueryString() {
      var params = this.queryParameters;
      var q = '';
      if (Object.keys(params).length > 0) {
        q = '?' + Object.keys(params).map(function (key) {
          return key + '=' + params[key];
        }).join('&');
      }
      return q;
    },
    getCustomFields: function getCustomFields() {
      var _this3 = this;
      var q = this.getQueryString();
      this.api.get(this.endpoint + q, {}).then(function (r) {
        if (r.data && r.data.form) {
          _this3.formSettings = r.data.form;
          _this3.submitAction = _this3.formSettings.action;
          if (_this3.formSettings.fieldsets && _this3.formSettings.fieldsets[0]) {
            _this3.formFields = _this3.formSettings.fieldsets[0].fields;
            _this3.prefillCustomFields(_this3.formFields);
          }
        }
        _this3.$emit('loaded', {});
      });
    },
    prefillCustomFields: function prefillCustomFields(fields) {
      var _this4 = this;
      fields.map(function (field) {
        // update field.values with last saved data
        if (_this4.values) {
          var savedField = _this4.values.filter(function (i) {
            return i.key === field.key;
          });
          if (savedField && savedField[0] && typeof savedField[0] !== 'undefined') {
            if (field.values.length === 0) {
              field.values.push(savedField[0].value);
            } else {
              field.values[0] = savedField[0].value;
            }
          }
        }
        // populate model
        if (field.values.length) {
          if (field.type === 'select') {
            if (field.name !== TEMPLATE_FIELD) {
              _this4.FormModel[field.name] = {
                value: 0,
                text: field.values[0]
              };
            }
          } else {
            _this4.FormModel[field.name] = field.values[0];
          }
        }
      });
    },
    meta: function meta(fieldKey, index) {
      var hasTemplateField = this.formFields.find(function (f) {
        return f.name === TEMPLATE_FIELD;
      });
      if (fieldKey !== TEMPLATE_FIELD && hasTemplateField && !this.FormModel[TEMPLATE_FIELD]) {
        this.canSubmit = false;
        return {
          disabled: true,
          class: 'dim disabled'
        };
      } else {
        if (this.FormModel[TEMPLATE_FIELD]) {
          this.canSubmit = true;
        }
      }
    },
    showConfirmation: function showConfirmation() {
      this.FormModel.Email && this.$notifications.notify({
        message: "An invitation has been sent to ".concat(this.FormModel.SupplierName || '', " (").concat(this.FormModel.Email, ")"),
        type: 'info',
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    },
    cancel: function cancel() {
      this.emptySupplier(this.FormModel);
      document.querySelector('.main-panel').scrollTo(0, 0);
      this.$v.$reset();
    },
    emptySupplier: function emptySupplier(obj) {
      var fields = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default()(this.mapFields);
      fields.forEach(function (field) {
        if (field.key) {
          obj[field.key] = null;
        }
      });
      obj.MeetingDate = null;
    },
    fetchOptions: function fetchOptions(field, i) {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee() {
        var options;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this5.options[field.key] && _this5.options[field.key].length && !field.dataSource.queryParameters.length)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return _this5.api.get(field.dataSource.url + '?' + _this5.query(field, _this5.FormModel));
            case 4:
              options = _context.sent;
              options && options.data ? _this5.options[field.key] = options.data : void 0;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    update: function update(field) {
      if (this.options[field.key]) {}
    },
    clearDependencies: function clearDependencies(field) {
      var _this6 = this;
      this.lastUpdatedKey = field.name;
      if (this.lastUpdatedKey === TEMPLATE_FIELD) {
        // reset files
        var customField = this.formFields.find(function (f) {
          return f.type === 'file';
        });
        if (customField && this.shouldBeVisible(customField)) {
          this.FormModel[customField.name] = null;
          delete this.FormModel[customField.name];
          this.options[field.key] = null;
          delete this.options[field.key];
          this.$nextTick(function () {
            _this6.beforeCreateField(customField, true);
          });
        }
      }
      if (field.type === FIELD_TYPES.select) {
        Object.keys(this.FormModel).forEach(function (f) {
          var customField = _this6.formFields.find(function (f) {
            return ~f.dataSource.queryParameters.indexOf(field.name);
          });
          if (customField) {
            _this6.FormModel[customField.name] = null;
            delete _this6.FormModel[customField.name];
          }
        });
      }
    },
    beforeCreateField: function beforeCreateField(field, force) {
      var _this7 = this;
      if (force === undefined && (!this.shouldBeVisible(field) || field.dataSource.url === '')) return;

      // File fields
      if (field.type === FIELD_TYPES.file || field.type === 'file') {
        this.api.get(field.dataSource.url + '?' + this.query(field, this.FormModel)).then(function (options) {
          if (options && options.data) {
            _this7.FormModel[field.name] = _this7.mapAttachments(options.data);
            _this7.options[field.key] = options.data;
          }
          if (force) {
            _this7.$forceUpdate();
          }
        });
      }
      if (field.integer) {
        if (this.lastUpdatedKey === TEMPLATE_FIELD || !this.FormModel[TEMPLATE_FIELD]) {
          this.loading = true;
          this.api.get(field.dataSource.url + '?' + this.query(field, this.FormModel)).then(function (options) {
            if (options && options.data) {
              _this7.$set(_this7.FormModel, field.key, options.data);
            }
            _this7.loading = false;
          });
        }
      }
    },
    query: function query(field, form) {
      var query = '';
      field.dataSource.queryParameters.map(function (param) {
        var value = (form[param] || {}).text || form[param];
        query += value ? "&".concat(param, "=").concat(encodeURIComponent(value)) : '';
      });
      return query;
    },
    fieldOptions: function fieldOptions(field) {
      if (!this.shouldBeVisible(field)) return [];
      if (this.options[field.key]) return field.options || this.options[field.key] || [];

      // this.options[field.key] ||
      this.$set(this.options, field.key, []);

      // File fields
      if (field.type === FIELD_TYPES.file) {
        this.$set(this.FormModel, field.key, []);
      }
    },
    multiple: function multiple(field) {
      return field.type === FIELD_TYPES.file;
    },
    mapAttachments: function mapAttachments(files) {
      var attachments = [];
      for (var f in files) {
        if (files.hasOwnProperty(f)) {
          var entry = files[f];
          attachments.push({
            fileObject: true,
            id: entry.id,
            name: entry.name,
            file: entry.file,
            path: entry.path,
            type: entry.type,
            size: entry.size * 1024,
            success: true,
            readonly: true
          });
        }
      }
      return attachments;
    },
    mapToSend: function mapToSend(o) {
      var _this8 = this;
      var output = [];
      Object.keys(o).forEach(function (k) {
        var customField = _this8.formFields.find(function (field) {
          return field.name === k;
        }) || {};
        output.push({
          name: k,
          multiple: customField.multiple,
          type: customField.type,
          values: o[k] ? o[k].map ? o[k].map(function (k) {
            return fileId(k);
          }) : [o[k].text || o[k]] : []
        });
      });
      return output;
      function fileId(file) {
        // upload endpoint returns application/json, so the upload component already
        // parsed file.response into an object; only JSON.parse when it's still a string
        var response = file.response;
        if (typeof response === 'string') {
          try {
            response = JSON.parse(response);
          } catch (e) {
            response = {};
          }
        }
        return response && response.id || file.id;
      }
    },
    onChange: function onChange() {
      this.$v.$reset();
      this.$v.$touch();
    },
    validate: function validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    getFields: function getFields(excludeStandardFields, justValues) {
      var _this9 = this;
      var result = [];
      var _loop = function _loop() {
        var _Object$entries$_i = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_Object$entries[_i], 2),
          name = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        var field = _this9.formFields.filter(function (i) {
          return i.name === name;
        });
        if (excludeStandardFields && field && field[0] && field[0].isStandard) return 1; // continue
        var valueToSend = value;
        if (justValues && valueToSend['text']) valueToSend = valueToSend['text'];
        result.push({
          key: field && field[0] ? field[0].key : name,
          formKey: _this9.formSettings.key,
          name: name,
          value: valueToSend
        });
      };
      for (var _i = 0, _Object$entries = Object.entries(this.FormModel); _i < _Object$entries.length; _i++) {
        if (_loop()) continue;
      }
      return result;
    },
    getFieldLabel: function getFieldLabel(name) {
      if (this.formFields) {
        var field = this.formFields.filter(function (f) {
          return f.name === name;
        });
        return field && field[0] ? field[0].label : '';
      }
      return '';
    },
    getFieldIsRequired: function getFieldIsRequired(name) {
      if (this.formFields) {
        var field = this.formFields.filter(function (f) {
          return f.name === name;
        });
        return field && field[0] ? field[0].required : '';
      }
      return false;
    },
    hideField: function hideField(name) {
      if (this.formFields) {
        var field = this.formFields.filter(function (f) {
          return f.name === name;
        });
        return field && field[0] ? field[0].hidden : false;
      }
      return false;
    }
  }
});

/***/ }),

/***/ "cXlN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2NQ_BViS47hZ6hHo186Y63","Dell":"gKCc9nNQEjCLWxhPVnvOE","Abbott":"iJV9tFXEb083DsWOgkXS_","Gap":"_1v8lgjUyuH-8sWhPAmewc","Allstate":"_2PF839VANMY2hh_p9fyANc","Asurion":"_1qPccrS3KvEAdpCInFr2t1","Invitae":"cX6tZrzUpm9wIdrdKYY2p","JWE":"_2jDzepD-rdcmgxJHNv-6QO"};

/***/ }),

/***/ "cfH+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{
      "form-success--": _vm.search,
      "update-button": _vm.updateButton,
      "symbol list": _vm.symbol,
      "readonly": _vm.disabled,
      "right-label": _vm.rightLabel
    },on:{"mousedown":_vm.emitMousedown}},[(_vm.type === "money")?_c('v-money',{ref:"money",staticClass:"hide",attrs:{"supplementalPrecision":_vm.supplementalPrecision}},[_vm._v(_vm._s(_vm.setValue))]):_vm._e(),(_vm.type === "money")?_c('v-money',{ref:"moneyPlaceholder",staticClass:"hide",attrs:{"supplementalPrecision":_vm.supplementalPrecision}},[_vm._v("0")]):_vm._e(),((_vm.helptipBody || _vm.$slots.message) && _vm.focused || (_vm.helptipBody || _vm.$slots.message) && _vm.error)?_c('ed-input-tooltip',{class:{ "error-message": _vm.error },attrs:{"helptipHeader":_vm.helptipHeader,"errorTip":_vm.error,"altTip":_vm.$attrs["info-only"],"helptipBody":_vm.$slots.message ? "" : _vm.helptipBody,"v-align":typeof _vm.$attrs["info-only"] === "undefined"}},[_vm._t("message",null,{"slot":"message"})],2):_vm._e(),(_vm.fieldLabel)?_c('label',[_vm._v(_vm._s(_vm.fieldLabel)),(!_vm.required && !_vm.hideOptional)?_c('em',{staticClass:"optional"},[_vm._v(" - optional")]):_vm._e()]):_vm._e(),(_vm.emptyFieldLabel)?_c('label',[_vm._v(" ")]):_vm._e(),_vm._t("additionalText"),_c('input',_vm._b({directives:[{name:"focus",rawName:"v-focus.lazy",value:(_vm.autofocus),expression:"autofocus",modifiers:{"lazy":true}}],ref:"input",staticClass:"form-control",class:{
      "form-control-money": _vm.type === 'money',
      "money-placeholder": !_vm.conditionalText && _vm.type === "money",
      "nil": _vm.nilMoney,
      "negative": _vm.negativeMoney,
      "text-right": _vm.symbol || _vm.amount && _vm.rightLabel,
    },style:(_vm.symbolWidth),attrs:{"autofocus":_vm.autofocus,"dir":_vm.setDir,"required":_vm.required,"type":_vm.type,"maxlength":_vm.maxlength,"placeholder":_vm.moneyPlaceholder},domProps:{"value":_vm.setValue},on:{"focus":_vm.emitFocus,"focusout":_vm.emitFocusOut,"blur":_vm.emitBlur,"input":function($event){return _vm.updateInput($event.target.value)},"keyup":function($event){return _vm.updateKeyUp($event.target.value)},"change":function($event){return _vm.changeValue($event.target.value)}}},'input',_vm.$props,false)),(_vm.showPassword)?_c('span',{staticClass:"toggle-password-icon",on:{"click":_vm.togglePassword}},[(_vm.fieldType === "password")?_c('i',{staticClass:"fal fa-eye"}):_vm._e(),(_vm.fieldType === "text")?_c('i',{staticClass:"fal fa-eye-slash"}):_vm._e()]):_vm._e(),(_vm.updateButton)?_c('ed-button',{staticClass:"btn btn-actionbar update-button",attrs:{"disabled":_vm.disabled},on:{"click":_vm.emitUpdate}},[_vm._v("Save")]):_vm._e(),(_vm.search)?_c('span',{staticClass:"search search-icon"},[_c('i',{staticClass:"fa fa-search"})]):_vm._e(),(_vm.searchBox)?_c('span',{staticClass:"search search-icon-right"},[_c('i',{staticClass:"fa fa-search"})]):_vm._e(),_c('span',{ref:"symbolWrapper",staticClass:"symbol-holder",attrs:{"id":"symbolWrapper"},on:{"click":_vm.focusInput}},[_vm._v(_vm._s(_vm.symbol))]),(_vm.helpText)?_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.helpText))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "coox":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateEnvelope_vue__ = __webpack_require__("jaZM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f267a1f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateEnvelope_vue__ = __webpack_require__("iOUh");
function injectStyle (ssrContext) {
  __webpack_require__("4DzP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f267a1f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateEnvelope_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f267a1f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateEnvelope_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "csE1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3mcaci6MDAVcpB-X-MeurB","Dell":"_1SqQkL3xSih8KHsaakIzhU","Abbott":"_3znivGlf9zpk4ThlhP83dM","Gap":"jwtPU0Vc-ZeVyNpqBPQxj","Allstate":"_29Pe4fI_Nc_zvEDjPvLUT-","Asurion":"_26G420y2yRz5gjJ2_G5CRy","Invitae":"RrGHNTZs59J6CrAeHQ4kL","JWE":"_3bIGnAO6H3i9bsoMEgNMqq"};

/***/ }),

/***/ "d+Go":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dialogs_LineItem_LineItemStore_js__ = __webpack_require__("PJql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__core_events_events__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object,
    sectionClass: String
  },
  data: function data() {
    return {
      invoiceCurrency: this.model.InitialInvoiceCurrencyCode
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__core_events_events___default.a.I2P.UPDATE_INVOICE_SCAN_SNAPSHOT);
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_2__core_events_events___default.a.I2P.UPDATE_INVOICE_SCAN_SNAPSHOT, this.updateSnapshot);
  },
  computed: {
    currency: function currency() {
      return this.invoiceCurrency;
    },
    balance: function balance() {
      return this.model.InitialInvoiceAmount - this.model.CurrentInvoicedAmount;
    },
    getTimeDue: function getTimeDue() {
      var now = new Date().getTime();
      var due = new Date(this.getDateFromAspNetFormat(this.model.DueTime)).getTime();
      var h = Math.floor((due - now) % 86400000 / 3600000);
      var m = Math.round((due - now) % 86400000 % 3600000 / 60000);
      return h > 0 ? h + ' hr ' + m + ' min' : 0 + ' hr';
    }
  },
  methods: {
    store: function store() {
      return new __WEBPACK_IMPORTED_MODULE_1__dialogs_LineItem_LineItemStore_js__["a" /* default */](this.api);
    },
    updateSnapshot: function updateSnapshot(e) {
      var sentCurrencyCode = e && e.data && e.data.invoiceCurrencyCode;
      if (sentCurrencyCode) {
        this.invoiceCurrency = sentCurrencyCode;
      }
      this.updateSnapshotItems(e.data.total);
    },
    updateSnapshotItems: function updateSnapshotItems(total) {
      this.model.CurrentInvoicedAmount = total;
      this.model.BudgetBalance = this.model.InitialInvoiceAmount - this.model.CurrentInvoicedAmount;
    },
    getDateFromAspNetFormat: function getDateFromAspNetFormat(date) {
      var re = /-?\d+/;
      var m = re.exec(date);
      return parseInt(m[0], 10);
    }
  }
});

/***/ }),

/***/ "d17Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('grid',{ref:"CostCentersGrid",attrs:{"name":"","label":"Cost Center","desc":"","views":false,"layout":"frame","search":"","endpoint":_vm.api.$.BUAndCC.getCostCenters,"actions":_vm.actions,"remove-many":"","fit-columns":"","editable":""},on:{"removeRow":_vm.removeCC,"removeRows":_vm.removeCCs,"changeRow":_vm.editCC}},[_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.addCC}},[_vm._v("Add CC")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d2cp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "d3mI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'Division': {
    label: 'Production',
    compose: divisionLink,
    width: 190
  },
  'OpenCards': {
    label: 'Open Cards',
    width: 180
  },
  'ClosedCards': {
    label: 'Closed Cards',
    width: 180
  },
  'Funded': {
    label: 'Funded',
    type: 'money',
    f: 'data.Funded',
    width: 180
  },
  'Allocated': {
    label: 'Allocated to cards',
    type: 'money',
    f: 'data.Allocated',
    width: 300
  },
  'Available': {
    label: 'Available',
    type: 'money',
    f: 'data.Available',
    width: 300
  },
  'Pending': {
    label: 'Pending Amount',
    type: 'money',
    f: 'data.Pending'
  }
});
function divisionLink(p) {
  if (!p.data) return '';
  var accountId = p.data.Id;
  var url = "#/d/Programs/>Card/list?AccountId=".concat(accountId);
  return "<a title=\"Open ".concat(p.value, "\" href=\"").concat(url, "\" data-action=\"goto\">").concat(p.value, "</a>");
}

/***/ }),

/***/ "d5+5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suppliers_details_vue__ = __webpack_require__("tNhx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43df46b5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suppliers_details_vue__ = __webpack_require__("jzUe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suppliers_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43df46b5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suppliers_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dCaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = singularize;
function singularize(value) {
  return value.endsWith('s') ? value.slice(0, -1) : value;
}

/***/ }),

/***/ "dECR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('span',{staticClass:"priority-tag"},[_c('i',{class:_vm.symbol},_vm._l((_vm.max),function(bullet){return _c('em',{class:{ on: _vm.colorize(bullet) }},[_vm._v("•")])}),0),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.tag))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dEO9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RejectCardRefill_vue__ = __webpack_require__("r4I0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffe10f8e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RejectCardRefill_vue__ = __webpack_require__("PSwI");
function injectStyle (ssrContext) {
  __webpack_require__("C9Nq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ffe10f8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RejectCardRefill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffe10f8e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RejectCardRefill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dK8e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"main col-md-6 col-md-offset-3 offset-md-3 col-sm-6 col-sm-offset-3 offset-sm-3"},[(!_vm.loading && !_vm.hasData)?_c('div',[_c('h3',{staticClass:"title"},[_vm._v("There is nothing to Approve")]),_vm._v(" "),_c('p',{staticClass:"message"},[_vm._v("Please go to dashboard for updated information.")]),_vm._v(" "),_c('ed-button',{staticClass:"pull-right",on:{"click":_vm.gotoDashboard}},[_vm._v("Go to Dashboard")])],1):_c('div',[_vm._v("\n        Loading approval queue ...\n      ")]),_vm._v(" "),_c('approveDialog',{attrs:{"showModal":_vm.showApproveDialog,"list":_vm.cards},on:{"close":_vm.gotoDashboard,"approve":_vm.doApprove}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dLa6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3UZy2bKodvDqhb8N90OePw","Dell":"_1tfXdktWQOufoSbAPmyMNI","Abbott":"_3PiXFkjSMs9d5_0kSaHGDe","Gap":"_3OS-HTzE8N_NFJoYngt1RL","Allstate":"_2Kxo4PIH0017F5PkBIVjsU","Asurion":"mBM1AL5zxZJsoLGXBiEiJ","Invitae":"_2LexLnpftNh4XOm_j9_KqV","JWE":"_3oGdYnuHA5RRPU7RsOPCb8"};

/***/ }),

/***/ "dPle":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_js__ = __webpack_require__("y+M7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_tabs__ = __webpack_require__("Q++R");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */]
  },
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__model_js__["a" /* default */],
      tabs: __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_tabs__["a" /* default */].tabs,
      rowClasses: {
        'negative-amount': function negativeAmount(params) {
          return (params.data || {}).Amount < 0;
        }
      }
    };
  }
});

/***/ }),

/***/ "dQfM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":function($event){return _vm.showModal(_vm.showAddCard)}}},[_vm._v("\n    Add Card\n  ")]),_vm._v(" "),_c('form',{ref:"formRef"},[_c('ed-modal',{attrs:{"title":"Add Card","show":_vm.showAddCard,"validation":"","primary-button":"Add","primary-button-disabled":_vm.savingCardInProgress},on:{"close":function($event){return _vm.showModal(_vm.showAddCard)},"validate":_vm.addCard,"confirm":_vm.addCard}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"add-card-overlay"},[(_vm.isPoolFunding)?_c('p',{staticClass:"small"},[_vm._v("Select the card holder below and the Daily Spend Limit for the card.")]):_c('p',{staticClass:"small"},[_vm._v("Select the card holder below and the amount you'd like to put on the card. You can request more funds to be added on the card later.")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.accountId === '')?_c('label',{attrs:{"for":"division"}},[_vm._v(_vm._s(_vm.divisionsName))]):_vm._e(),_vm._v(" "),(_vm.accountId === '')?_c('ed-select',{attrs:{"placeholder":'Select an Eved ' + _vm.divisionName.toLowerCase() + '...',"options":_vm.divisions,"label":"Name","track-by":"Id","name":"supplier_user"},on:{"input":function (o) {_vm.selectedAccountId = o.AccountId; _vm.selectedDivisionId = o.Id; _vm.selectUser = ''; _vm.selectUsers = []; _vm.fetchDailySpendLimitSettings()},"open":_vm.fetchUserDivisions},model:{value:(_vm.selectDivision),callback:function ($$v) {_vm.selectDivision=$$v},expression:"selectDivision"}}):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"cardHolder"}},[_vm._v("Card Holder")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('ed-select',{attrs:{"placeholder":"Select an Eved user...","options":_vm.card.users,"label":"Name","track-by":"Id","error":_vm.holderIncomplete,"disabled":_vm.accountId === '' && _vm.selectedAccountId === '',"name":"supplier_user"},on:{"open":_vm.onOpenCard,"scroll-bottom":function () { return _vm.loadUsers('card', false); },"search":function (term) { _vm.card.searchTerm = term; _vm.loadUsers('card', true) },"input":_vm.onSelectUser},model:{value:(_vm.selectUser),callback:function ($$v) {_vm.selectUser=$$v},expression:"selectUser"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nameOnCard"}},[_vm._v("Name on Card - "),_c('span',{staticClass:"optional-text"},[_vm._v("optional")])]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"nameOnCard","error":_vm.nameOnCardError,"disabled":!_vm.selectUser,"maxlength":"23","helptipHeader":"","help-text":"Max limit of 23 characters and only these punctuation symbols: . , - & '"},on:{"input":function (o) { _vm.nameOnCard = o; _vm.nameOnCardError = false; }},model:{value:(_vm.nameOnCard),callback:function ($$v) {_vm.nameOnCard=$$v},expression:"nameOnCard"}},[(_vm.nameOnCardError)?_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n                  "+_vm._s(_vm.errorMessageNameOnCard)+"\n                ")]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile Phone Number - "),_c('span',{staticClass:"optional-text"},[_vm._v("optional")])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"smaller","font-style":"italic"},attrs:{"slot":"additionalText"},slot:"additionalText"},[_vm._v("\n                The card holder can select to receive one-time passwords via text message\n              ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('vue-country-code',{ref:"countryCodeComponent",staticClass:"dropdown",attrs:{"disabledFetchingCountry":true,"enabledCountryCode":true,"preferredCountries":['us', 'gb', 'cn'],"disabled":!_vm.selectUser},on:{"onSelect":_vm.onCountrySelect}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('ed-input',{staticClass:"full-width",attrs:{"onlyNumbers":"","placeholder":"222 333 1234","error":_vm.cardHolderPhoneNumberError,"disabled":!_vm.selectUser},model:{value:(_vm.addObjectUser.Holder.Mobile.PhoneNumber),callback:function ($$v) {_vm.$set(_vm.addObjectUser.Holder.Mobile, "PhoneNumber", $$v)},expression:"addObjectUser.Holder.Mobile.PhoneNumber"}},[(_vm.cardHolderPhoneNumberError)?_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n                      "+_vm._s(_vm.errorPhoneMessage)+"\n                    ")]):_vm._e()])],1)])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date Of Birth - "),_c('span',{staticClass:"optional-text"},[_vm._v("optional")])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"smaller","font-style":"italic"},attrs:{"slot":"additionalText"},slot:"additionalText"},[_vm._v("\n                The card holder can select to receive one-time passwords via call center\n              ")]),_vm._v(" "),_c('ed-datepicker',{attrs:{"placeholder":"Select date","disabled":!_vm.selectUser,"format":_vm.dateFormat},model:{value:(_vm.addObjectUser.Holder.DateOfBirth),callback:function ($$v) {_vm.$set(_vm.addObjectUser.Holder, "DateOfBirth", $$v)},expression:"addObjectUser.Holder.DateOfBirth"}})],1),_vm._v(" "),(_vm.$root.getUser.$.userPermissions.includes('Administration') || _vm.$root.getUser.$.userPermissions.includes('EvedPayCardAdministrator'))?_c('div',[_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":function($event){return _vm.showModalUser(_vm.showAddUser)}}},[_vm._v("\n                Add User\n              ")]),_vm._v(" "),_c('AddUser',{attrs:{"show":_vm.showAddUser},on:{"close":_vm.closeAddUserModal}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"cardAdmin"}},[_vm._v("Admin - "),_c('span',{staticClass:"optional-text"},[_vm._v("optional")])]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select an Eved user...","options":_vm.admin.users.filter(_vm.filterAdminOptions),"checkboxes":false,"label":"Name","multiple":"","track-by":"Id","disabled":_vm.accountId === '' && _vm.selectedAccountId === '',"name":"supplier_user"},on:{"open":_vm.onOpenAdmin,"scroll-bottom":function () { return _vm.loadUsers('admin', false); },"search":function (term) { _vm.admin.searchTerm = term; _vm.loadUsers('admin', true) },"input":function (o) { return _vm.addObjectUser.AdditionalUsers = o; }},model:{value:(_vm.selectUsers),callback:function ($$v) {_vm.selectUsers=$$v},expression:"selectUsers"}})],1),_vm._v(" "),(!_vm.isPoolFunding)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.initialLoadDisabledReason),expression:"initialLoadDisabledReason"}],staticClass:"form-group",class:{ 'is-disabled-field': _vm.account.Available <= 0 }},[_c('label',{attrs:{"for":"initialLoad"}},[_vm._v("Initial Load")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"money","amount":"","error":_vm.initialLoadError,"id":"initialLoad","helptip-header":"","disabled":_vm.account.Available <= 0},on:{"input":function (o) { _vm.addObjectUser.initialLoad = +o; this$1.initialLoadError = false; }},model:{value:(_vm.initialLoad),callback:function ($$v) {_vm.initialLoad=$$v},expression:"initialLoad"}},[(_vm.initialLoadError)?_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n                "+_vm._s(_vm.errorMessage)+"\n                "),_c('strong',[_c('v-money',[_vm._v(_vm._s(_vm.account.Available))])],1)]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.isPoolFunding)?_c('div',{staticClass:"form-group",class:{ 'has-error': !!_vm.dailySpendLimitError }},[_c('label',{attrs:{"for":"dailySpendLimit"}},[_vm._v("Daily Spend Limit"),(!_vm.isDailySpendLimitRequired)?[_vm._v(" - "),_c('span',{staticClass:"optional-text"},[_vm._v("optional")])]:_vm._e()],2),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"money","amount":"","id":"dailySpendLimit","helptip-header":"","help-text":_vm.maxLimitHelpText},on:{"input":_vm.onDailySpendLimitInput},model:{value:(_vm.dailySpendLimit),callback:function ($$v) {_vm.dailySpendLimit=$$v},expression:"dailySpendLimit"}}),_vm._v(" "),(_vm.dailySpendLimitError)?_c('p',{staticClass:"dsl-validation-error"},[_vm._v(_vm._s(_vm.dailySpendLimitError))]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding)?_c('div',{staticClass:"form-group"},[_c('ed-input',{staticClass:"full-width",attrs:{"type":"money","field-label":"Refill Threshold","amount":"","id":"refillThreshold"},on:{"input":function (o) { return _vm.RefillSettings.RefillThreshold = +o; }},model:{value:(_vm.RefillSettings.RefillThreshold),callback:function ($$v) {_vm.$set(_vm.RefillSettings, "RefillThreshold", $$v)},expression:"RefillSettings.RefillThreshold"}})],1):_vm._e(),_vm._v(" "),(!_vm.isPoolFunding)?_c('div',{staticClass:"form-group"},[_c('ed-input',{staticClass:"full-width",attrs:{"type":"money","field-label":"Refill Amount","amount":"","id":"refillAmount"},on:{"input":function (o) { return _vm.RefillSettings.RefillAmount = +o; }},model:{value:(_vm.RefillSettings.RefillAmount),callback:function ($$v) {_vm.$set(_vm.RefillSettings, "RefillAmount", $$v)},expression:"RefillSettings.RefillAmount"}})],1):_vm._e(),_vm._v(" "),(this.accountSettings.ShowAccountOrGlCode)?_c('div',{staticClass:"form-group"},[_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","helptipHeader":"","field-label":"Account/Gl Code","required":_vm.addObjectUser.HasAccountingSystemSync,"validation":"","error":_vm.errorGLCode},on:{"input":function (o) { _vm.addObjectUser.AccountOrGlCode = o; },"validate":_vm.addCard},model:{value:(_vm.addObjectUser.AccountOrGlCode),callback:function ($$v) {_vm.$set(_vm.addObjectUser, "AccountOrGlCode", $$v)},expression:"addObjectUser.AccountOrGlCode"}})],1):_vm._e(),_vm._v(" "),(this.accountSettings.AccountingSystem.SyncEvedPayCards)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("PSL+ Vendor")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addObjectUser.HasAccountingSystemSync),expression:"addObjectUser.HasAccountingSystemSync"}],attrs:{"type":"checkbox","id":"push-to-accounting-system"},domProps:{"checked":Array.isArray(_vm.addObjectUser.HasAccountingSystemSync)?_vm._i(_vm.addObjectUser.HasAccountingSystemSync,null)>-1:(_vm.addObjectUser.HasAccountingSystemSync)},on:{"change":function($event){var $$a=_vm.addObjectUser.HasAccountingSystemSync,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.addObjectUser, "HasAccountingSystemSync", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.addObjectUser, "HasAccountingSystemSync", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.addObjectUser, "HasAccountingSystemSync", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"push-to-accounting-system"}},[_vm._v("Sync Card data with PSL+")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"checkbox-label-container"},[_c('label',{staticClass:"large-text",attrs:{"for":"physicalCard"}},[_vm._v("Single Physical Card - "),_c('span',{staticClass:"optional-text"},[_vm._v("optional")])])]),_vm._v(" "),_c('div',{staticClass:"checkbox-label-container"},[_c('small',{staticClass:"small-italic",staticStyle:{"font-size":"0.8em","display":"inline"}},[_vm._v("\n                When ordering multiple physical cards, please use the Request Physical Batch button\n              ")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.physicalCard),expression:"physicalCard"}],attrs:{"type":"checkbox","id":"physicalCard"},domProps:{"checked":Array.isArray(_vm.physicalCard)?_vm._i(_vm.physicalCard,null)>-1:(_vm.physicalCard)},on:{"change":function($event){var $$a=_vm.physicalCard,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.physicalCard=$$a.concat([$$v]))}else{$$i>-1&&(_vm.physicalCard=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.physicalCard=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"physicalCard"}},[_vm._v("Send the Cardholder a physical card - provide mailing address below:")])])]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.physicalCard }},[_c('label',{attrs:{"for":"country"}},[_vm._v("Country")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select a country...","options":_vm.countries,"label":"CountryName","track-by":"CountryID","openEndpoint":_vm.api.$.profile.getAllCountries,"disabled":_vm.disableControls,"name":"supplier_country"},on:{"input":function (o) { _vm.mailingAddress.country = o; this$1.countryIncomplete = false; },"select":function($event){return _vm.countrySelected($event)},"open":_vm.fetchCountriesOnOpen,"keyup":_vm.fetchCountries,"close":_vm.restoreCountries},model:{value:(_vm.formData.country),callback:function ($$v) {_vm.$set(_vm.formData, "country", $$v)},expression:"formData.country"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.physicalCard }},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"name","error":_vm.nameIncomplete,"placeholder":"Name","maxlength":"40"},on:{"input":function (o) { _vm.mailingAddress.name = o; this$1.nameIncomplete = false; }},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.physicalCard }},[_c('label',{attrs:{"for":"address"}},[_vm._v("Address")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"address","error":_vm.addressIncomplete,"placeholder":"Address","maxlength":"26"},on:{"input":function (o) { _vm.mailingAddress.line1 = o; this$1.addressIncomplete = false; }},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.physicalCard }},[_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","field-label":"Address Line 2","id":"addressLine2","placeholder":"Address Line 2"},on:{"input":function (o) { return _vm.mailingAddress.line2 = o; }},model:{value:(_vm.addressLine2),callback:function ($$v) {_vm.addressLine2=$$v},expression:"addressLine2"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.physicalCard }},[_c('label',{attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"city","error":_vm.cityIncomplete,"placeholder":"City","maxlength":"25"},on:{"input":function (o) { _vm.mailingAddress.city = o; this$1.cityIncomplete = false; }},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'disabled': !_vm.physicalCard }},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-item"},[_c('label',{attrs:{"for":"state"}},[_vm._v("State")]),_vm._v(" "),(_vm.isUS())?_c('ed-select',{attrs:{"options":_vm.USstates,"label":"StateName","error":_vm.stateIncomplete,"track-by":"StateID","name":"us_states"},on:{"input":function (o) { _vm.mailingAddress.state = o; this$1.stateIncomplete = false; },"open":_vm.fetchUSStatesOnOpen,"keyup":_vm.fetchUSStates,"close":_vm.restoreUSStates},model:{value:(_vm.formData.state),callback:function ($$v) {_vm.$set(_vm.formData, "state", $$v)},expression:"formData.state"}}):_vm._e(),_vm._v(" "),(_vm.isCanada())?_c('ed-select',{attrs:{"placeholder":"Select a region","options":_vm.canadaStates,"label":"StateName","disabled":_vm.disableControls,"name":"canada_states"},on:{"input":function (o) { _vm.mailingAddress.canadaState = o; this$1.stateIncomplete = false; },"open":_vm.fetchCanadaStatesOnOpen,"keyup":_vm.fetchCanadaStates,"close":_vm.restoreCanadaStates},model:{value:(_vm.formData.canadaState),callback:function ($$v) {_vm.$set(_vm.formData, "canadaState", $$v)},expression:"formData.canadaState"}}):_vm._e(),_vm._v(" "),(!_vm.formData.country || !_vm.isCanada() && !_vm.isUS())?_c('ed-input',{attrs:{"placeholder":"Select a region","disabled":_vm.disableControls,"name":"state_region"},on:{"input":function (o) { _vm.mailingAddress.region = o; this$1.stateIncomplete = false; }},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"input-group-item"},[_c('label',{attrs:{"for":"zipCode"}},[_vm._v("Zip Code")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"zipCode","error":_vm.zipCodeIncomplete,"placeholder":"Zip Code","maxlength":"5"},on:{"input":function (o) { _vm.mailingAddress.zip = o; this$1.zipCodeIncomplete = false; }},model:{value:(_vm.zipCode),callback:function ($$v) {_vm.zipCode=$$v},expression:"zipCode"}})],1)]),_vm._v(" "),(this.accountSettings.AllowRushPhysicalCards)?_c('hr'):_vm._e(),_vm._v(" "),(this.accountSettings.AllowRushPhysicalCards)?_c('div',{staticClass:"form-group",class:{ 'is-disabled-field': _vm.account.Available <= 0 }},[_c('label',{attrs:{"for":"rushOrder"}},[_vm._v("Rush Order - "),_c('span',{staticClass:"optional-text"},[_vm._v("optional")])]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n                For a fee, a physical card can be sent via expedited shipping.\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.rushDisabledReason),expression:"rushDisabledReason"}],staticClass:"form-group",staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rushOrder),expression:"rushOrder"}],attrs:{"type":"checkbox","id":"rushOrder","disabled":_vm.account.Available <= 0},domProps:{"checked":Array.isArray(_vm.rushOrder)?_vm._i(_vm.rushOrder,null)>-1:(_vm.rushOrder)},on:{"change":function($event){var $$a=_vm.rushOrder,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rushOrder=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rushOrder=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rushOrder=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"rushOrder"}},[_vm._v("Rush shipment of this card")])])]):_vm._e()])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "deRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],attrs:{"button-class":"btn btn-actionbar","ids":_vm.ids,"disabled":_vm.disabled},on:{"click":function($event){return _vm.showModal(_vm.showTransferFunds)}}},[_vm._v("\n    Transfer Funds\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Transfer EvedPay Card Account Funds","show":_vm.showTransferFunds,"validation":"","primary-button":"TRANSFER FUNDS"},on:{"close":function($event){return _vm.showModal(_vm.showTransferFunds)},"validate":_vm.transferFunds}},[_c('div',{staticClass:"transfer-funds-overlay",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Move funds between accounts.")]),_vm._v(" "),_c('label',[_vm._v("Transfer From")]),_vm._v(" "),_c('ed-select',{attrs:{"slot":"additionalInfo_1","options":_vm.divisions,"label":"Division","name":"divisions"},on:{"open":_vm.getUserDivisions,"input":function (option) {
                  this$1.selectOptionFrom.Division = option.Division
                  this$1.selectOptionFrom.Available = option.Available
                  this$1.selectOptionFrom.AccountId = option.Id
                }},slot:"additionalInfo_1",scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('div',{staticClass:"dropdown-option"},[_c('span',{staticClass:"division-name"},[_vm._v(_vm._s(props.option.Division))]),_vm._v(" "),_c('span',{staticClass:"available-amount-wrapper"},[_vm._v("\n              Available: "),_c('span',[_vm._v(_vm._s(props.option.Available.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))+" USD")])])])]}}])}),_vm._v(" "),_c('label',[_vm._v("Transfer To")]),_vm._v(" "),_c('ed-select',{attrs:{"slot":"additionalInfo_1","options":_vm.divisions.filter(_vm.filterOptions),"label":"Division","name":"divisions"},on:{"open":_vm.getUserDivisions,"input":_vm.setSelectOptionTo},slot:"additionalInfo_1",scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('div',{staticClass:"dropdown-option"},[_c('span',{staticClass:"division-name"},[_vm._v(_vm._s(props.option.Division))]),_vm._v(" "),_c('span',{staticClass:"available-amount-wrapper"},[_vm._v("\n              Available: "),_c('span',[_vm._v(_vm._s(props.option.Available.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))+" USD")])])])]}}])}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('ed-input',{staticClass:"full-width",attrs:{"field-label":"Amount","hide-optional":"","type":"money","amount":"","placeholder":"Amount","error":_vm.initialAmountError,"helptip-header":""},on:{"input":function (o) { _vm.initialAmount = +o; this$1.initialAmountError = false; }},model:{value:(_vm.initialAmount),callback:function ($$v) {_vm.initialAmount=$$v},expression:"initialAmount"}},[(_vm.initialAmountError)?_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n            "+_vm._s(_vm.errorMessage)+":\n            "),_c('strong',[_c('v-money',[_vm._v(_vm._s(_vm.selectOptionFrom.Available))])],1)]):_vm._e()])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "deUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("AD2D");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e68108a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("DF+k");
function injectStyle (ssrContext) {
  __webpack_require__("WcDs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e68108a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e68108a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dg/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoices_vue__ = __webpack_require__("yFC+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3937c58f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_invoices_vue__ = __webpack_require__("Lqvs");
function injectStyle (ssrContext) {
  __webpack_require__("vvv5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3937c58f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3937c58f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_invoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dgq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_user__ = __webpack_require__("uduW");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    isLoggedIn: !!localStorage.getItem('evedUser') && localStorage.getItem('evedUser') !== '{}',
    isSessionValid: false,
    csrf: !!localStorage.getItem('evedUserCsrf') && localStorage.getItem('evedUserCsrf')
  },
  actions: {
    ping: function ping(_ref) {
      var commit = _ref.commit;
      setTimeout(function () {
        return __WEBPACK_IMPORTED_MODULE_2__core_user__["a" /* default */].checkSession(commit);
      });
    },
    check: function check() {
      setTimeout(function () {
        return __WEBPACK_IMPORTED_MODULE_2__core_user__["a" /* default */].checkSession(true);
      });
    }
  },
  mutations: {
    updateSessionValidity: function updateSessionValidity(state, payload) {
      state.isSessionValid = payload;
    }
  }
});

/***/ }),

/***/ "dl2l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_user__ = __webpack_require__("uduW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__ = __webpack_require__("94Kh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__);
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */



function init() {
  var _settings = null;
  var _data = null;
  if (__WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].get() && __WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].get().data) {
    _settings = __WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].getCompanySettings();
    _data = __WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].get().data;
    _data.MarketTypeID = parseInt(_data.MarketTypeID);
    _data.MembershipPlanID = parseInt(_data.MembershipPlanID);
    _data.ApplyPartnerCommission = __WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].get().hasPC;
    _data.IsDell = __WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].get().isDell;
  }
  var User = __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default()(Object.assign({
    settings: _settings
  }, _data), toBool);
  var ROLE = {
    BASIC: User.type === 'basic',
    NO_ADMIN: true,
    REGIONAL_ADMIN: allow('RegionalAdministration'),
    COMPANY_ADMIN: allow('Administration'),
    FULL_ADMIN: User.type === 'admin'
  };
  var type = {
    BUYER: User.MarketTypeID === 1,
    BS: User.MarketTypeID === 2,
    SELLER: User.MarketTypeID === 3
  };
  var ENTITY = {
    ENTERPRISE: User.IsE360,
    CORPORATE: User.IsFusion,
    SUPPLIER: type.BS || type.SELLER,
    BASIC_BS: type.BS && !User.IsE360 && !User.IsFusion,
    ENTERPRISE_BS: type.BS && User.IsE360 && User.MembershipPlanID === 3,
    CORPORATE_B: type.BUYER && User.IsFusion,
    BASIC_B: type.BUYER && !User.IsFusion
  };
  return {
    ROLE: ROLE,
    type: type,
    ENTITY: ENTITY,
    User: User
  };
}
function allow(role) {
  return !~getPermissions().indexOf('deny' + role);
}
function toBool(v) {
  return v === '1' ? true : v === '0' ? false : v;
}
function getPermissions() {
  var authUser = JSON.parse(window.localStorage.getItem('evedUser'));
  var permissions = [];
  if (authUser && authUser.token && authUser.permissions) {
    permissions = authUser.permissions;
  }
  return permissions;
}
/* harmony default export */ __webpack_exports__["a"] = ({
  get role() {
    return init().ROLE;
  },
  get type() {
    return init().type;
  },
  get entity() {
    return init().ENTITY;
  },
  get user() {
    return init().User;
  }
});

/***/ }),

/***/ "dmNr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_user__ = __webpack_require__("uduW");
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */


/* harmony default export */ __webpack_exports__["a"] = ({
  setup: function setup() {
    var user = __WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].get();
    // Config
    global.intercomUpdateCalls = 1;
    global.intercomSettings = {
      app_id: "a4gh1g5t",
      name: user.name,
      email: user.username,
      user_hash: user.intercom_hash,
      created_at: new Date(user.created.replace(/ /, 'T').replace(/\.\d+/, '')).getTime() / 1000,
      is_fusion: user.flags.hasFusion,
      has_reporting: user.flags.hasReporting,
      hide_default_launcher: !user.flags.hasIntercomChat
    };
  },
  track: function track(event) {
    if (typeof global.Intercom === 'undefined') return;
    global.Intercom('trackEvent', event);
  },
  show: function show(visibility) {
    if (typeof global.Intercom === 'undefined') return;
    var user = __WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].get();
    setTimeout(function () {
      global.Intercom('update', {
        hide_default_launcher: visibility === false || user && !user.flags.hasIntercomChat
      });
    }, 100);
  },
  hide: function hide() {
    this.show(false);
  },
  logout: function logout() {
    if (typeof global.Intercom === 'undefined') return;
    global.Intercom('shutdown');
  },
  init: function init() {
    if (typeof global.Intercom !== 'undefined') return;

    // Init snippet
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', global.intercomSettings);
    } else {
      var d = document;
      var _i = function i() {
        _i.c(arguments);
      };
      _i.q = [];
      _i.c = function (args) {
        _i.q.push(args);
      };
      w.Intercom = _i;
      var l = function l() {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/' + "a4gh1g5t";
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      /* if (w.attachEvent) {
        w.attachEvent('onload', l)
      } else {
        w.addEventListener('load', l, false)
      } */
      l();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "dp0g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("U6b3");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0525f87a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("hMWa");
function injectStyle (ssrContext) {
  __webpack_require__("JBez")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0525f87a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0525f87a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dsuC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_user__ = __webpack_require__("uduW");

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    var model = {
      'Id': {
        label: '_'
      },
      '*BusinessUnitName': {
        label: 'Business Unit'
      },
      'CostCenterNo': {
        label: 'Cost Center ID'
      },
      'CostCenterName': {
        label: 'Cost Center Name'
      },
      'DivisionName': {
        label: getDivisionName()
      }
    };
    return model;
  }
});
function getDivisionName() {
  return __WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].get().settings['DivisionName'];
}

/***/ }),

/***/ "dvnc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},_vm._l((_vm.mapFields),function(field,index){return _c('div',{key:_vm.hash(field),staticClass:"form-group list",attrs:{"data-field":field.key}},[_c(field.type,_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.shouldBeVisible(field)),expression:"shouldBeVisible(field)"}],ref:"fields",refInFor:true,tag:"component",staticClass:"full-width list",attrs:{"field-label":field.label,"type":field.nativeType,"maxlength":field.maxLength,"placeholder":" ","required":field.required,"optional":field.optional,"error":_vm.$v.FormModel[field.key] && _vm.$v.FormModel[field.key].$error,"helptip-header":"","helptip-body":_vm.validationMessage(field),"options":_vm.fieldOptions(field),"track-by":"text","button-label":"Upload File","button-position":"bottom","post-action":_vm.api.env + field.dataSource.url,"headers":_vm.headers,"upload-auto":true,"multiple":_vm.multiple(field),"readonly":field.type === _vm.FIELD_TYPES.file ? true : false,"show-helptip-icon":false,"endpoint":field.type === _vm.FIELD_TYPES.file ? field.dataSource.url : null,"openEndpoint":field.dataSource.url,"label":"text","integer":field.integer},on:{"open":function($event){return _vm.fetchOptions(field)},"select":function () { _vm.counter++; _vm.clearDependencies(field) },"input":_vm.onChange,"hook:created":function($event){return _vm.update(field)},"hook:beforeCreate":function($event){return _vm.beforeCreateField(field)}},model:{value:(_vm.FormModel[field.key]),callback:function ($$v) {_vm.$set(_vm.FormModel, field.key, $$v)},expression:"FormModel[field.key]"}},'component',_vm.meta(field.key, index, field),false)),_vm._v(" "),(_vm.shouldShowInfo(field).label)?_c('div',{staticClass:"alternate"},[_c('label',[_vm._v("\n          "+_vm._s(field.label)+"\n          "),(!field.required)?_c('em',{staticClass:"optional-field-label"},[_vm._v(" - optional")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info-field"},[_c('em',[_vm._v("Select "),_c('strong',[_vm._v(_vm._s(_vm.shouldShowInfo(field).label))]),_vm._v(" "+_vm._s(_vm.shouldShowInfo(field).meta))])])]):_vm._e()],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dwv+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__("cS7h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__("BRZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sidebar__ = __webpack_require__("59tI");
//
//
//
//
//
//
//
//
//
//
//
//




function perfNow() {
  return window.performance && window.performance.now ? window.performance.now() : Date.now();
}
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation__["a" /* default */],
    MdFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_2__components_Sidebar__["a" /* default */]
  },
  props: ['reference'],
  data: function data() {
    return {
      name: 'layout-navigation',
      sidebarToggled: false,
      isInIframe: window.self !== window.top,
      // Observers
      resizeObserver: null,
      mutationObserver: null,
      // Target elements
      slotEl: null,
      modalEl: null,
      // Size state
      lastSent: {
        h: 0,
        w: 0
      },
      lastChangeTs: 0,
      initialBurstCount: 0,
      // Timers / flags
      pollInterval: null,
      reconnectInterval: null,
      destroyed: false,
      rafHandle: 0,
      // History hook backups
      origPushState: null,
      origReplaceState: null
    };
  },
  computed: {
    navOpened: function navOpened() {
      return this.sidebarToggled;
    },
    loading: function loading() {
      return this.$loading;
    }
  },
  mounted: function mounted() {
    this.bootstrap();
  },
  activated: function activated() {
    this.bootstrap();
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanup();
  },
  methods: {
    /* ---------- Initialization ---------- */bootstrap: function bootstrap() {
      var _this = this;
      if (!this.isInIframe) return;
      this.adjustShell();
      this.installMessageListener();
      this.setupContentObservers();
      this.installNavigationHooks();
      this.startReconnectWatcher();
      this.startPollingFallback();
      // Initial burst to ensure parent captures early size
      for (var i = 0; i < 3; i++) {
        setTimeout(function () {
          return _this.postSize();
        }, 60 * (i + 1));
      }
      // Post again after potential async layout settling
      setTimeout(function () {
        return _this.postSize();
      }, 500);
    },
    adjustShell: function adjustShell() {
      var _this2 = this;
      this.$nextTick(function () {
        var mainPanel = _this2.$el.querySelector('.main-panel');
        if (mainPanel) mainPanel.style.overflow = 'hidden';
      });
    },
    /* ---------- Navigation Hooks ---------- */installNavigationHooks: function installNavigationHooks() {
      if (!this.origPushState && window.history && window.history.pushState) {
        this.origPushState = window.history.pushState;
      }
      if (!this.origReplaceState && window.history && window.history.replaceState) {
        this.origReplaceState = window.history.replaceState;
      }
      var self = this;
      function afterNav() {
        // Reset burst so we aggressively re-measure after navigation
        self.initialBurstCount = 0;
        // Immediate measurement to capture shrink ASAP
        self.postSize();
        // Debounced follow-up
        self.postSizeDebounced();
        // Additional delayed re-measurements for late-rendering content
        self.scheduleBurst([100, 250, 500, 800, 1200]);
        // Notify parent
        try {
          window.parent.postMessage({
            type: 'navigated'
          }, '*');
        } catch (e) {}
      }

      // Patch pushState
      if (this.origPushState) {
        try {
          window.history.pushState = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            var r = self.origPushState.apply(this, args);
            afterNav();
            return r;
          };
        } catch (e) {}
      }

      // Patch replaceState
      if (this.origReplaceState) {
        try {
          window.history.replaceState = function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            var r = self.origReplaceState.apply(this, args);
            afterNav();
            return r;
          };
        } catch (e) {}
      }
      window.addEventListener('popstate', afterNav);
      window.addEventListener('hashchange', afterNav);

      // Vue router (best-effort)
      var vueGlobal = window.__VUE__ || window.__VUE_APP__ || window.app;
      var possibleRouter = vueGlobal && vueGlobal.$router || window.__VUE_ROUTER__ || this.$router;
      if (possibleRouter && !possibleRouter.__evedSizeHooked) {
        try {
          possibleRouter.afterEach(function () {
            return afterNav();
          });
          possibleRouter.__evedSizeHooked = true;
        } catch (e) {}
      }
    },
    /* ---------- PostMessage Listener ---------- */installMessageListener: function installMessageListener() {
      var _this3 = this;
      if (this.onMessage) window.removeEventListener('message', this.onMessage);
      this.onMessage = function (e) {
        if (e && e.data && e.data.type === 'request-size') {
          _this3.postSizeDebounced();
        }
      };
      window.addEventListener('message', this.onMessage);
    },
    /* ---------- Observers & Polling ---------- */setupContentObservers: function setupContentObservers() {
      var _this4 = this;
      if (this.destroyed) return;
      var el = this.$el.querySelector('.content.module');
      if (!el) {
        requestAnimationFrame(function () {
          return _this4.setupContentObservers();
        });
        return;
      }
      var modalEl = document.querySelector('.dawn-modal-container');
      if (this.slotEl === el && this.modalEl === modalEl) return;
      this.disconnectObservers();
      this.slotEl = el;
      this.modalEl = modalEl;
      if (window.ResizeObserver) {
        this.resizeObserver = new window.ResizeObserver(function () {
          _this4.postSizeDebounced();
        });
        this.resizeObserver.observe(el);

        // Also observe modal container if it exists
        if (modalEl) {
          this.resizeObserver.observe(modalEl);
        }
      }
      if (window.MutationObserver) {
        this.mutationObserver = new window.MutationObserver(function () {
          _this4.postSizeDebounced();
        });
        this.mutationObserver.observe(el, {
          childList: true,
          subtree: true,
          attributes: true
        });

        // Also observe modal container if it exists
        if (modalEl) {
          this.mutationObserver.observe(modalEl, {
            childList: true,
            subtree: true,
            attributes: true
          });
        }
      }
      el.querySelectorAll('img,iframe,video,object,embed,picture source').forEach(function (node) {
        node.addEventListener('load', _this4.postSizeDebounced, {
          passive: true
        });
      });

      // Also attach load listeners to modal elements if modal exists
      if (modalEl) {
        modalEl.querySelectorAll('img,iframe,video,object,embed,picture source').forEach(function (node) {
          node.addEventListener('load', _this4.postSizeDebounced, {
            passive: true
          });
        });
      }
      this.postSize();
    },
    startReconnectWatcher: function startReconnectWatcher() {
      var _this5 = this;
      if (this.reconnectInterval) clearInterval(this.reconnectInterval);
      this.reconnectInterval = setInterval(function () {
        if (_this5.destroyed) return;
        var current = _this5.$el.querySelector('.content.module');
        var currentModal = document.querySelector('.dawn-modal-container');
        if (current && current !== _this5.slotEl || currentModal !== _this5.modalEl) {
          _this5.setupContentObservers();
          _this5.postSizeDebounced();
        }
      }, 1000);
    },
    startPollingFallback: function startPollingFallback() {
      var _this6 = this;
      if (this.pollInterval) clearInterval(this.pollInterval);
      this.pollInterval = setInterval(function () {
        if (_this6.destroyed) return;
        if (perfNow() - _this6.lastChangeTs > 3000) {
          _this6.postSize();
        }
      }, 1500);
    },
    disconnectObservers: function disconnectObservers() {
      if (this.resizeObserver) {
        try {
          this.resizeObserver.disconnect();
        } catch (e) {}
        this.resizeObserver = null;
      }
      if (this.mutationObserver) {
        try {
          this.mutationObserver.disconnect();
        } catch (e) {}
        this.mutationObserver = null;
      }
    },
    /* ---------- Cleanup ---------- */cleanup: function cleanup() {
      this.destroyed = true;
      this.disconnectObservers();
      if (this.pollInterval) clearInterval(this.pollInterval);
      if (this.reconnectInterval) clearInterval(this.reconnectInterval);
      window.removeEventListener('message', this.onMessage);
      window.removeEventListener('popstate', this.postSizeDebounced);
      window.removeEventListener('hashchange', this.postSizeDebounced);
      cancelAnimationFrame(this.rafHandle);
      if (this.origPushState) {
        try {
          window.history.pushState = this.origPushState;
        } catch (e) {}
      }
      if (this.origReplaceState) {
        try {
          window.history.replaceState = this.origReplaceState;
        } catch (e) {}
      }
    },
    /* ---------- UI Interactions ---------- */toggleSideBar: function toggleSideBar() {
      this.sidebarToggled = !this.sidebarToggled;
      this.postSizeDebounced();
    },
    onCloseLayerClick: function onCloseLayerClick() {
      this.toggleSideBar();
    },
    /* ---------- Measurement & Posting ---------- */openDropdownBottom: function openDropdownBottom() {
      var bottom = 0;
      document.querySelectorAll('.dawnSelect__content-wrapper, .dawnSelect .toolbar').forEach(function (el) {
        if (!el.offsetParent) return; // closed (v-show)
        bottom = Math.max(bottom, el.getBoundingClientRect().bottom + window.pageYOffset);
      });
      return bottom ? Math.ceil(bottom + 20) : 0;
    },
    measureSize: function measureSize() {
      if (!this.slotEl) return {
        height: 0,
        width: 0
      };
      var rect = this.slotEl.getBoundingClientRect();
      var styles = window.getComputedStyle(this.slotEl);
      var marginTop = parseFloat(styles.marginTop) || 0;
      var marginBottom = parseFloat(styles.marginBottom) || 0;
      var height = Math.ceil(rect.height + marginTop + marginBottom);

      // Also measure modal if it exists
      if (this.modalEl) {
        var modalRect = this.modalEl.getBoundingClientRect();
        var modalStyles = window.getComputedStyle(this.modalEl);
        var modalMarginTop = parseFloat(modalStyles.marginTop) || 0;
        var modalMarginBottom = parseFloat(modalStyles.marginBottom) || 0;
        var modalPaddingTop = parseFloat(modalStyles.paddingTop) || 0;
        var modalPaddingBottom = parseFloat(modalStyles.paddingBottom) || 0;
        var modalHeight = Math.ceil(modalRect.height + modalMarginTop + modalMarginBottom + modalPaddingTop + modalPaddingBottom + 20);

        // Take the larger height
        height = Math.max(height, modalHeight);
      }

      // An open dropdown (e.g. the approval-rule user picker with its Apply button) overflows its
      // fixed-height field without growing any box, so without this the iframe is sized short and
      // the parent's footer covers the bottom of the dropdown (SPRT-19141).
      height = Math.max(height, this.openDropdownBottom());
      if (!height || height < 40) {
        height = Math.max(this.slotEl.scrollHeight, this.modalEl ? this.modalEl.scrollHeight : 0, document.documentElement ? document.documentElement.scrollHeight : 0, document.body ? document.body.scrollHeight : 0);
      }
      var width = Math.max(this.slotEl.scrollWidth, this.modalEl ? this.modalEl.scrollWidth : 0, document.documentElement ? document.documentElement.scrollWidth : 0);
      return {
        height: height,
        width: width
      };
    },
    postSize: function postSize() {
      if (!this.slotEl || !this.isInIframe) return;
      var _this$measureSize = this.measureSize(),
        height = _this$measureSize.height,
        width = _this$measureSize.width;
      var shrinking = height < this.lastSent.h;
      var changed = Math.abs(height - this.lastSent.h) > 2 || Math.abs(width - this.lastSent.w) > 2;
      if (shrinking || changed || this.initialBurstCount < 5) {
        window.parent.postMessage({
          type: 'resize',
          data: "if_height=".concat(height, "&if_width=").concat(width)
        }, '*');
        window.parent.postMessage({
          type: 'resize',
          data: {
            height: height,
            width: width
          }
        }, '*');
        this.lastSent = {
          h: height,
          w: width
        };
        this.lastChangeTs = perfNow();
        this.initialBurstCount++;
      }
    },
    postSizeDebounced: function postSizeDebounced() {
      var _this7 = this;
      cancelAnimationFrame(this.rafHandle);
      this.rafHandle = requestAnimationFrame(function () {
        _this7.$nextTick(function () {
          return _this7.postSize();
        });
      });
    },
    scheduleBurst: function scheduleBurst() {
      var _this8 = this;
      var delays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      delays.forEach(function (ms) {
        setTimeout(function () {
          if (!_this8.destroyed) _this8.postSize();
        }, ms);
      });
    }
  }
});

/***/ }),

/***/ "dxaE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e2uL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "e4wH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.closeDropdown),expression:"closeDropdown"}],staticClass:"more-actions",class:{ open : _vm.isDropdownOpen, dropup: _vm.showAbove, dropdown: !_vm.showAbove },staticStyle:{"display":"inline-block","width":"35px"}},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('Actions'),expression:"'Actions'",modifiers:{"bottom":true}}],staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"},on:{"click":function($event){$event.preventDefault();return _vm.openDropdown.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-ellipsis-v"})]),_vm._v(" "),_c('div',{ref:"dropdownMenu",staticClass:"dropdown-menu dropdown-menu-right"},[_c('div',{staticClass:"export selector grid-filter"},[_c('div',{staticClass:"container-"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.params)?_c('ul',{staticClass:"types"},_vm._l((_vm.params.actions),function(action,i){return _c('li',[_c(_vm.component(action),{tag:"component",staticClass:"action"})],1)}),0):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eAMW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eDUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dawn-select-list form-group",class:{ "invalid": _vm.error }},[(_vm.fieldLabel)?_c('label',[_vm._v(_vm._s(_vm.fieldLabel)),(!_vm.required && !_vm.hideOptional)?_c('em',{staticClass:"optional"},[_vm._v(" - optional")]):_vm._e()]):_vm._e(),(_vm.helptipBody && _vm.error)?_c('ed-input-tooltip',{class:{ "error-message": _vm.error },attrs:{"helptipHeader":_vm.helptipHeader,"helptipBody":_vm.helptipBody,"errorTip":_vm.error}}):_vm._e(),(_vm.$slots.description)?_c('div',{staticClass:"description"},[_c('em',[_vm._t("description")],2)]):_vm._e(),(_vm.emptyFieldLabel)?_c('label',[_vm._v(" ")]):_vm._e(),_c('div',{staticClass:"search"},[_c('ed-input',{ref:'input',staticClass:"pull-left inline",attrs:{"placeholder":_vm.t("Search"),"search":""},on:{"input":function($event){return _vm.debounceSearching(true)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c('div',{staticClass:"tabs pull-right"},[_c('a',{staticClass:"tab",class:{ active: _vm.isShowAll },on:{"click":function($event){$event.preventDefault();return _vm.showAll.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("Show All")))]),_c('a',{staticClass:"tab",class:{ active: _vm.isSelected },on:{"click":function($event){$event.preventDefault();return _vm.showSelected.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("Selected"))+" ("+_vm._s(_vm.selectedCount)+")")])]),_c('div',{staticClass:"body-wrapper"},[_c('div',{staticClass:"body ghost",attrs:{"endpoint":_vm.endpoint}},[(_vm.isShowAll)?_c('div',{staticClass:"list all",attrs:{"xendpoint":"endpoint"}},[(!_vm.filteredList.length && !_vm.pending)?_c('div',{staticClass:"info"},[_vm._v("No results")]):_vm._e(),_c('ed-checkbox',{attrs:{"value":_vm.filteredList},on:{"input":_vm.updateModel,"click":_vm.setModel}}),(_vm.pending)?_c('div',{staticClass:"info loading list"},[_vm._v("Loading...")]):_vm._e()],1):_vm._e(),(_vm.isSelected)?_c('div',{staticClass:"list selected"},[(!_vm.selectedFilteredList.length)?_c('div',{staticClass:"info"},[_vm._v("No results")]):_vm._e(),_c('ed-checkbox',{attrs:{"remove-only":"","value":_vm.selectedFilteredList},on:{"click":_vm.setModel}})],1):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eFeS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customFields_vue__ = __webpack_require__("cXFO");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e603fc7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customFields_vue__ = __webpack_require__("dvnc");
function injectStyle (ssrContext) {
  __webpack_require__("prgC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e603fc7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e603fc7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customFields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eFhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardDailySpendLimit_vue__ = __webpack_require__("U0Dc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6821fcf2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardDailySpendLimit_vue__ = __webpack_require__("+zUf");
function injectStyle (ssrContext) {
  __webpack_require__("8veb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6821fcf2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardDailySpendLimit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6821fcf2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardDailySpendLimit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eJx6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("6hc0");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1996a59a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("d17Q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1996a59a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eLfk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-modal',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: String,
    primaryButton: {
      type: String,
      default: 'Ok'
    },
    primaryButtonClass: {
      type: String,
      default: 'btn btn-primary'
    },
    additionalButtonClass: {
      type: String,
      default: 'btn btn-dark'
    },
    secondaryButton: {
      type: String,
      default: 'Cancel'
    },
    additionalButton: {
      type: String,
      default: ''
    },
    type: String,
    validation: {
      type: Boolean,
      default: false
    },
    primaryButtonDisabled: {
      type: Boolean,
      default: false
    },
    closeOnClickAway: Boolean,
    flat: Boolean
  },
  data: function data() {
    return {
      body: null,
      footer: null,
      savedBodyMinHeight: null
    };
  },
  computed: {
    hasSlotFooter: function hasSlotFooter() {
      return this.$slots.footer;
    },
    isIframedContext: function isIframedContext() {
      try {
        return window !== window.top && !!window.frameElement;
      } catch (e) {
        return false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    document.addEventListener('keydown', function (e) {
      if (_this.show && e.keyCode === 27) {
        _this.closeOnClickAway && _this.$emit('close');
      }
    });
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.$nextTick(this.applyOuterAdjustments);
      } else {
        this.revertOuterAdjustments();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.revertOuterAdjustments();
  },
  methods: {
    onbeforeshow: function onbeforeshow() {
      this.$emit('beforeshow');
    },
    // When ed-modal opens inside a same-origin iframe (legacy app embedded
    // in the dev-v3 shell), the modal scrolls with the outer page instead
    // of using its own internal scroll. Two adjustments make this work:
    //   1. Send the outer scroll container to the top, so the modal opens
    //      at the visible top of the page regardless of where the user was.
    //   2. Grow the iframe's body so the iframe element resizes (via the
    //      shell's height handshake) to be tall enough to contain the
    //      modal. The user then uses outer scroll to navigate the modal.
    applyOuterAdjustments: function applyOuterAdjustments() {
      var iframed = false;
      try {
        iframed = window !== window.top && !!window.frameElement;
      } catch (e) {
        iframed = false;
      }
      if (!iframed) {
        return;
      }
      var topDoc;
      try {
        topDoc = window.top.document;
      } catch (e) {
        return;
      }
      var layoutContent = topDoc.querySelector('.stepin-layout-content');
      if (layoutContent) {
        layoutContent.scrollTop = 0;
      }
      var mask = this.$refs.mask;
      var container = mask && mask.querySelector('.dawn-modal-container');
      if (container) {
        // 4rem container margin-top + a small buffer below the container
        var required = container.offsetHeight + 64 + 40;
        this.savedBodyMinHeight = document.body.style.minHeight;
        document.body.style.minHeight = required + 'px';
      }
    },
    revertOuterAdjustments: function revertOuterAdjustments() {
      if (this.savedBodyMinHeight !== null) {
        if (this.savedBodyMinHeight) {
          document.body.style.minHeight = this.savedBodyMinHeight;
        } else {
          document.body.style.removeProperty('min-height');
        }
        this.savedBodyMinHeight = null;
      }
    },
    onshow: function onshow() {
      this.$emit('show');
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit('modal-show');
    },
    close: function close(btnClick) {
      this.$emit('close', {
        btnClick: typeof btnClick === 'boolean' ? btnClick : false
      });
    },
    confirm: function confirm() {
      this.$emit('confirm');
      this.close();
    },
    additionalAction: function additionalAction() {
      this.$emit('additionalAction');
      this.close();
    },
    validate: function validate() {
      this.$emit('validate');
    },
    handleClose: function handleClose() {
      this.closeOnClickAway && this.$emit('close');
    }
  }
});

/***/ }),

/***/ "eN35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineItemsSection_vue__ = __webpack_require__("JaKc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a203e246_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineItemsSection_vue__ = __webpack_require__("G0m8");
function injectStyle (ssrContext) {
  __webpack_require__("1FKg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a203e246"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineItemsSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a203e246_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineItemsSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eOek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-flex active"},[_c('div',{staticClass:"invoice-email-form"},[_c('div',[_c('p',{staticClass:"email-label"},[_vm._v("Sender")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.emailData.FromEmail)+" "+_vm._s(_vm.emailData.NameSender))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"email-label"},[_vm._v("Subject")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.emailData.Subject))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"email-label"},[_vm._v("Date")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatDate(_vm.emailData.ReceivedDate)))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"email-label"},[_vm._v("Body")]),_vm._v(" "),_c('div',{staticClass:"email-body",domProps:{"innerHTML":_vm._s(_vm.emailData.OriginalBodyHtml)}})])]),_vm._v(" "),_c('div',{staticClass:"footer-section"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.closeWindow}},[_vm._v("\n      CLOSE\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ePHk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceDetails_vue__ = __webpack_require__("qPJb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_223e1d4f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceDetails_vue__ = __webpack_require__("wdvG");
function injectStyle (ssrContext) {
  __webpack_require__("zKv+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-223e1d4f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_223e1d4f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eTmq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticStyle:{"margin-bottom":"10px"},attrs:{"button-class":_vm.buttonClass,"ids":_vm.ids,"disabled":_vm.disabled},on:{"click":function($event){_vm.showReject = true}}},[_vm._v("\n    Decline\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Decline Daily Spend Limit Change","show":_vm.showReject,"validation":"","primary-button":"Decline","primaryButtonClass":"btn btn-danger","modalEndpoint":_vm.api.$.evedpaycard.approveOrRejectCardDailySpendLimit},on:{"close":function($event){_vm.showReject = false, _vm.rejectReason = ''},"confirm":function($event){return _vm.approveOrRejectCardDailySpendLimit()},"validate":_vm.approveOrRejectCardDailySpendLimit}},[_c('div',{staticClass:"reject-card-daily-spend-limit-overlay",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Provide a reason for declining the daily spend limit change.")]),_vm._v(" "),_c('label',[_vm._v("Reason")]),_vm._v(" "),_c('ed-input',{attrs:{"type":"text"},on:{"input":function (value) { return _vm.rejectReason = value; }},model:{value:(_vm.rejectReason),callback:function ($$v) {_vm.rejectReason=$$v},expression:"rejectReason"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eXUC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comments_vue__ = __webpack_require__("ZGyf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebc53a5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_comments_vue__ = __webpack_require__("TNwQ");
function injectStyle (ssrContext) {
  __webpack_require__("v88T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ebc53a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebc53a5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_comments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eiQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetOptions_vue__ = __webpack_require__("Pu0M");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf5f2156_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetOptions_vue__ = __webpack_require__("KHPA");
function injectStyle (ssrContext) {
  __webpack_require__("94BA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf5f2156"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf5f2156_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "el/S":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "enAH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PredictedCodingIcon_vue__ = __webpack_require__("ybBi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f762871_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PredictedCodingIcon_vue__ = __webpack_require__("rd3P");
function injectStyle (ssrContext) {
  __webpack_require__("o+j9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f762871"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PredictedCodingIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f762871_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PredictedCodingIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "etFT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceInformation_vue__ = __webpack_require__("Qy6d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5714ac34_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceInformation_vue__ = __webpack_require__("MWvc");
function injectStyle (ssrContext) {
  __webpack_require__("KgQl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5714ac34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5714ac34_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceInformation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "euHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");


// EventBus.$on(Eved.RFP.CREATED)

setTimeout(function () {
  //
  global.app.$pubnub && global.app.$pubnub.subscribe({
    channels: ['hello_world']
  });

  //
  global.app.$pubnub && global.app.$pubnub.addListener({
    status: function status(statusEvent) {
      if (statusEvent.category === 'PNConnectedCategory') {
        // handle status
      }
    },
    message: function message(_message) {
      console.log('New Message!', _message);
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].queue.push(_message);
      global.app.$notifications.notify({
        type: 'plain',
        icon: 'inbox',
        message: "<p>".concat(_message.message.data, "</p>"),
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    },
    presence: function presence(presenceEvent) {
      // handle presence
    }
  });
  //
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "evZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__("BRZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules__ = __webpack_require__("vZ0M");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var backToMap = {
  'EnvelopeApprovalDashboard': '/ApprovalDashboard'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MdFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer__["a" /* default */]
  },
  data: function data() {
    return {
      name: 'layout-navless',
      source: null,
      description: '',
      isBackTo: backToMap[this.$route.params.page]
    };
  },
  computed: {
    loading: function loading() {
      return this.$loading;
    },
    pageName: function pageName() {
      var layout = this;
      var page = '';
      if (this.$route.params.section && __WEBPACK_IMPORTED_MODULE_1__components_modules__["a" /* default */][this.$route.params.page + '/' + this.$route.params.section]) {
        page = __WEBPACK_IMPORTED_MODULE_1__components_modules__["a" /* default */][this.$route.params.page + '/' + this.$route.params.section];
      } else {
        page = __WEBPACK_IMPORTED_MODULE_1__components_modules__["a" /* default */][this.$route.params.page];
      }
      if (page) {
        // When module is async, set description after load
        if (page.module && typeof page.module === 'function' && this.$route.params.action && __WEBPACK_IMPORTED_MODULE_1__components_modules__["a" /* default */][this.$route.params.section + '/' + this.$route.params.action]) {
          __WEBPACK_IMPORTED_MODULE_1__components_modules__["a" /* default */][this.$route.params.section + '/' + this.$route.params.action]().then(function (v) {
            if (v) {
              layout.description = v.description;
            }
          });
        }
        return page.module && typeof page.module !== 'function' && ' ' || page.module && page.module.description || (page.module && typeof page.module === 'function' ? '' : '');
      } else {
        return '';
      }
    }
  },
  created: function created() {
    if (this.$route.params.page && this.$route.params.section && this.$route.params.action) {
      this.$routerHistory.save(['/' + this.$route.params.namespace + '/' + this.$route.params.page + '/' + this.$route.params.section + '/', '/' + this.$route.params.namespace + '/' + this.$route.params.page + '/' + this.$route.params.section + '/' + this.$route.params.action]);
    }
    this.source = this.$route.query['back-to'] || this.$routerHistory.previous().path;
  },
  methods: {
    cleanup: function cleanup() {
      // this.description = ''
      this.$destroy();
    },
    goBack: function goBack(e) {
      e.preventDefault();
      var page = this.$route.params.page;
      if (backToMap[page]) {
        window.location.href = "".concat(this.api.env).concat(backToMap[page]);
      }
      return false;
    }
  }
});

/***/ }),

/***/ "ew7J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1Ua2ICaDZP6-3nr7WfPloS","Dell":"BJrhSvvxZiYtCSusq1-M1","Abbott":"_2hsdpSWAPiNSdfFHBRKPIe","Gap":"_3A18w2PXH4QpSCxP_haLTv","Allstate":"_4OqNGE84LNRDVL_oa185Z","Asurion":"CUCWuG94p4aIq-MD7kZ0c","Invitae":"_1OzukO7JfQelSf5j6IzfgS","JWE":"_2NLeN9FggQTN3kZGipwHDi"};

/***/ }),

/***/ "ewFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:_vm.cardClass},[_c('div',{staticClass:"card-header",attrs:{"data-background-color":_vm.backgroundColor}},[(!_vm.hasHeaderSlot)?_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(!_vm.hasHeaderSlot)?_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.category))]):_vm._e(),_vm._t("header")],2),_c('div',{staticClass:"card-content",class:{ 'table-responsive' : _vm.hasTable }},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f/R8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object
  },
  computed: {
    divisionName: function divisionName() {
      return global.app.$user.$.settings.DivisionName || '';
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "f7Z3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f8kt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InvoiceScan_CellComp_TimeDueComp__ = __webpack_require__("CRvx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_Invoices_statuses_scss__ = __webpack_require__("BgeU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_Invoices_statuses_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modules_Invoices_statuses_scss__);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    var model = {
      'PaymentInvoiceId': '_',
      'InvoiceNumber': {
        label: 'Invoice',
        width: 150
      },
      Client: {
        label: 'Client',
        width: 150
      },
      Planner: {
        label: 'Submitted By',
        width: 160
      },
      Created: {
        label: 'Date Submitted',
        type: 'text',
        width: 150
      },
      Until: {
        label: 'Due',
        width: 150,
        type: 'tags',
        render: __WEBPACK_IMPORTED_MODULE_0__InvoiceScan_CellComp_TimeDueComp__["a" /* default */]
      },
      'InitialTotalAmount': {
        label: 'Amount',
        width: 140
      },
      Scanner: {
        label: 'Assigned To',
        width: 150
      },
      Reviewer: {
        label: 'Reviewer',
        type: 'text',
        width: 110
      },
      ProgramName: {
        label: 'Scanning Status',
        width: 150,
        getter: getScanningStatus
      },
      DivisionName: {
        label: 'Division',
        width: 150
      },
      BusinessUnit: {
        label: 'Business Unit',
        width: 150
      }
    };
    return model;
  }
});
function getScanningStatus(params) {
  var data = params.data || {};
  var isPending = data && (data.Scanner || '').trim() !== '' && data.InvoiceWasSaved;
  if (data.IsFromEmailForScanning) {
    return '<span class="badge incomplete">Incomplete</span>';
  }
  return isPending ? 'Pending' : 'Open';
}

/***/ }),

/***/ "fGtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__ = __webpack_require__("v/Ma");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c16ba1c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__ = __webpack_require__("WIwL");
function injectStyle (ssrContext) {
  __webpack_require__("Db+P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c16ba1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c16ba1c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fKL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.tooltipClass,style:(_vm.position)},[_c('p',{staticClass:"dawn-input-tooltip-header"},[_vm._v(_vm._s(_vm.helptipHeaderMsg))]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.helptipBody)+"\n    "),_vm._t("message")],2),_vm._v(" "),_c('div',{staticClass:"info-text"},[_vm._t("info")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fLOW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"ScanInvoiceGrid",attrs:{"model":_vm.getModel,"name":"Invoice Scanning","desc":"Line Item Entry","search-placeholder":"Invoices to be scanned","fit-columns":"","search":true,"resizing":false,"footer":"","endpoint":_vm.api.$.admin.getInvoicesToBeScanned,"alias":"InvoiceScanQueue","tabs":_vm.tabs}},[_c('back',{attrs:{"slot":"back-action"},slot:"back-action"}),_vm._v(" "),_c('span',{attrs:{"slot":"additionalButtons"},slot:"additionalButtons"},[_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.disableScanInvoiceButton,"name":"scan_invoice_button"},on:{"click":function($event){return _vm.scanInvoice(_vm.paymentInvoiceId)}}},[_vm._v("\n      Scan Invoice\n    ")]),_vm._v(" "),_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.disableReviewButton,"name":"review_invoice_button"},on:{"click":function($event){return _vm.reviewInvoice(_vm.paymentInvoiceId)}}},[_vm._v("\n      Review\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fOEW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3FsAD6rNzzeY3w6F9KAKSV","Dell":"_1ATy9lk-2vay89Zuq-TxVj","Abbott":"_2mj78Yl2ZDLywv3YlQW_HN","Gap":"_2o8_YDThYPtAaPJL8PB62H","Allstate":"_2z1jBvL7cY9SeklpCeVvwd","Asurion":"fVaLfsV7GzrSubQoKAAKM","Invitae":"_3CNJKZnGUS2r8xqZ2sSIFj","JWE":"_3dA2_11u3-EkZobjZjjFiY"};

/***/ }),

/***/ "fSiW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar"},on:{"click":function($event){return _vm.showModal(_vm.showAddTransaction)}}},[_vm._v("\n    ADD TRANSACTION\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Add Transaction","show":_vm.showAddTransaction,"primary-button":"ADD","primary-button-disabled":!_vm.selectedTransaction},on:{"close":function($event){_vm.showModal(_vm.showAddTransaction), _vm.closeObj = {}},"confirm":function($event){return _vm.$emit('transaction', _vm.fullTransactionObject)}}},[_c('div',{staticClass:"add-transaction-overlay",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Select a transaction to include in this "+_vm._s(_vm.envelopeTerm)+".")]),_vm._v(" "),_c('label',[_vm._v("Transaction")]),_vm._v(" "),_c('ed-select',{attrs:{"options":_vm.transactions,"label":"label","track-by":"value"},on:{"input":_vm.handleTransactionChange},model:{value:(_vm.selectedTransaction),callback:function ($$v) {_vm.selectedTransaction=$$v},expression:"selectedTransaction"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fk/s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transactions_vue__ = __webpack_require__("ft7C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ea223fe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transactions_vue__ = __webpack_require__("/ofR");
function injectStyle (ssrContext) {
  __webpack_require__("2LH4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ea223fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ea223fe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fn8K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__ = __webpack_require__("+Jq4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11eb1fac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__ = __webpack_require__("iMDH");
function injectStyle (ssrContext) {
  __webpack_require__("gFV1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11eb1fac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11eb1fac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fnVE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    paymentInvoiceId: {
      type: [String, Number],
      default: null
    },
    emailData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    formatDate: function formatDate(dateString) {
      if (!dateString) return '';
      var timestamp = parseInt(dateString.match(/\d+/)[0], 10);
      return new Date(timestamp).toLocaleString();
    }
  }
});

/***/ }),

/***/ "fnpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReceiptImageViewer',
  props: {
    imageUrl: {
      type: String,
      default: null
    },
    contentType: {
      type: String,
      default: null
    },
    errored: {
      type: Boolean,
      default: false
    },
    wrapHeight: {
      type: String,
      default: '332px'
    }
  },
  data: function data() {
    return {
      zoomLevel: 1,
      ZOOM_MIN: 0.5,
      ZOOM_MAX: 3,
      ZOOM_STEP: 0.25
    };
  },
  computed: {
    isPdf: function isPdf() {
      return this.contentType === 'application/pdf';
    }
  },
  watch: {
    imageUrl: function imageUrl() {
      this.zoomLevel = 1;
    }
  },
  methods: {
    zoomIn: function zoomIn() {
      var next = Math.round((this.zoomLevel + this.ZOOM_STEP) * 100) / 100;
      if (next > this.ZOOM_MAX) next = this.ZOOM_MAX;
      this.zoomLevel = next;
    },
    zoomOut: function zoomOut() {
      var next = Math.round((this.zoomLevel - this.ZOOM_STEP) * 100) / 100;
      if (next < this.ZOOM_MIN) next = this.ZOOM_MIN;
      this.zoomLevel = next;
    }
  }
});

/***/ }),

/***/ "fpte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpaychangepin',
  data: function data() {
    return {
      pin: ['', '', '', ''],
      confirmPin: ['', '', '', ''],
      cardId: this.$route.query.cardid,
      cardNumber: this.$route.query.cardNumber
    };
  },
  methods: {
    sanitizeInput: function sanitizeInput(index, pinArray) {
      pinArray[index] = pinArray[index].replace(/\D/g, '');
      this.focusNextInput(index, pinArray);
    },
    sanitizeInputConfirm: function sanitizeInputConfirm(index, pinArray) {
      pinArray[index] = pinArray[index].replace(/\D/g, '');
      this.focusNextInputConfirm(index, pinArray);
    },
    focusNextInput: function focusNextInput(index, pinArray) {
      if (index < pinArray.length - 1 && pinArray[index].trim() !== '') {
        var nextInput = this.$refs['pinInputField' + (index + 1)][0];
        if (nextInput) {
          nextInput.focus();
        }
      }
    },
    focusNextInputConfirm: function focusNextInputConfirm(index, pinArray) {
      if (index < pinArray.length - 1 && pinArray[index].trim() !== '') {
        var nextInput = this.$refs['confirmInputField' + (index + 1)][0];
        if (nextInput) {
          nextInput.focus();
        }
      }
    },
    handleBackspace: function handleBackspace(index, pinArray, event) {
      if (event.key === 'Backspace' && index > 0 && pinArray[index].trim() === '') {
        var previousInput = this.$refs['pinInputField' + (index - 1)][0];
        if (previousInput) {
          previousInput.focus();
        }
      }
    },
    handleBackspaceConfirm: function handleBackspaceConfirm(index, pinArray, event) {
      if (event.key === 'Backspace' && index > 0 && pinArray[index].trim() === '') {
        var previousInput = this.$refs['confirmInputField' + (index - 1)][0];
        if (previousInput) {
          previousInput.focus();
        }
      }
    },
    validatePin: function validatePin(pinValue, confirmPinValue) {
      if (!pinValue) {
        alert('Pin cannot be empty.');
        return true;
      }
      if (pinValue !== confirmPinValue) {
        alert("Pins don't match. Please re-enter.");
        this.pin = ['', '', '', ''];
        this.confirmPin = ['', '', '', ''];
        return true;
      }
      if (pinValue.length !== 4) {
        alert('Pin must be 4 digits long. Please re-enter.');
        this.pin = ['', '', '', ''];
        this.confirmPin = ['', '', '', ''];
        return true;
      }
      var numbers = '01234567890';
      var reverseNumbers = '09876543210';
      if (numbers.includes(pinValue) || reverseNumbers.includes(pinValue)) {
        alert('PIN cannot contain digits in sequence.');
        this.pin = ['', '', '', ''];
        this.confirmPin = ['', '', '', ''];
        return true;
      }
      if (pinValue === this.cardNumber) {
        alert('PIN cannot be similar to the last 4 digits of the card.');
        this.pin = ['', '', '', ''];
        this.confirmPin = ['', '', '', ''];
        return true;
      }
      if (/^(\d)\1+$/.test(pinValue)) {
        alert('PIN cannot be all the same digit.');
        this.pin = ['', '', '', ''];
        this.confirmPin = ['', '', '', ''];
        return true;
      }
      if (!/^\d+$/.test(pinValue)) {
        alert('PIN must contain only numbers.');
        this.pin = ['', '', '', ''];
        this.confirmPin = ['', '', '', ''];
        return true;
      }
      return false;
    },
    changePin: function changePin(event) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var pinValue, confirmPinValue, validationErrors, response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              pinValue = _this.pin.join('');
              confirmPinValue = _this.confirmPin.join('');
              validationErrors = _this.validatePin(pinValue, confirmPinValue);
              if (!validationErrors) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _context.prev = 6;
              if (!(_this.cardId && pinValue && confirmPinValue)) {
                _context.next = 12;
                break;
              }
              _context.next = 10;
              return _this.api.patch("evedpaycards/".concat(_this.cardId, "/set-pin"), {
                preventError: true,
                pin: pinValue
              });
            case 10:
              response = _context.sent;
              if (response.status === 200) {
                __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('pin-changed');
                _this.$router.push({
                  path: "/evedpay/details?cardid=".concat(_this.cardId),
                  query: _objectSpread(_objectSpread({}, _this.$route.query), _this.$route.query.cardNumber)
                });
              } else {
                _this.pin = ['', '', '', ''];
                _this.confirmPin = ['', '', '', ''];
                alert('Error while changing pin.');
              }
            case 12:
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](6);
              alert('Error while changing pin.');
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ "fsU0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dawn-modal"},on:{"beforeEnter":_vm.onbeforeshow,"afterEnter":_vm.onshow}},[(_vm.show)?_c('div',{ref:"mask",staticClass:"dawn-modal-mask",class:[_vm.flat ? 'flat' : '', _vm.isIframedContext ? 'iframed' : 'standalone']},[_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.handleClose),expression:"handleClose"}],class:["dawn-modal-container", _vm.type],attrs:{"endpoint":_vm.$attrs.modalEndpoint}},[_c('div',{staticClass:"dawn-modal-top"},[_c('span',{staticClass:"close-icon pull-right",attrs:{"title":"Close"},on:{"click":_vm.close}},[_c('i',{staticClass:"fal fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"dawn-modal-header"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_vm._t("body"),_vm._v(" "),_c('div',{staticClass:"dawn-modal-footer text-right"},[_vm._t("footer"),_vm._v(" "),(!_vm.hasSlotFooter)?_c('div',[(_vm.additionalButton != 'false' && _vm.additionalButton != '')?_c('ed-button',{staticClass:"additionalButtonClass",on:{"click":_vm.additionalAction}},[_vm._v(_vm._s(_vm.additionalButton))]):_vm._e(),_vm._v(" "),(_vm.secondaryButton != 'false')?_c('ed-button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.close(true)}}},[_vm._v(_vm._s(_vm.secondaryButton))]):_vm._e(),_vm._v(" "),(_vm.primaryButton != 'false' && !_vm.validation)?_c('ed-button',{class:_vm.primaryButtonClass,attrs:{"endpoint":_vm.$attrs.submitEndpoint,"disabled":_vm.primaryButtonDisabled},on:{"click":_vm.confirm}},[_vm._v("\n            "+_vm._s(_vm.primaryButton)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.primaryButton != 'false' && _vm.validation)?_c('ed-button',{class:_vm.primaryButtonClass,attrs:{"endpoint":_vm.$attrs.submitEndpoint,"disabled":_vm.primaryButtonDisabled},on:{"click":_vm.validate}},[_vm._v("\n            "+_vm._s(_vm.primaryButton)+"\n          ")]):_vm._e()],1):_vm._e()],2)],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ft7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__transactionDisplayMixin__ = __webpack_require__("51B0");



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpaytransactions',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__transactionDisplayMixin__["a" /* default */]],
  data: function data() {
    return {
      transactions: null,
      dateFormat: null
    };
  },
  computed: {
    moment: function moment() {
      return global.moment;
    }
  },
  created: function created() {
    var _this = this;
    this.getTransactions();
    __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$off('transaction-reconciled');
    __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$on('transaction-reconciled', function (transactionId) {
      var matchedTransaction = _this.transactions.find(function (transaction) {
        return transaction.Id === transactionId.data;
      });
      if (matchedTransaction) {
        var matchedId = matchedTransaction.Id;
        var token = _this.$route.query.token;
        _this.$notifications.notify({
          message: "Transaction was updated!<a href=\"#/evedpay/transactiondetails?token=".concat(token, "&transactionid=").concat(matchedId, "\"> Tap to revisit.</a>"),
          type: 'info',
          placement: {
            from: 'top',
            align: 'center'
          }
        });
      }
    });
  },
  methods: {
    getTransactions: function getTransactions() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this2.api.forms.post(_this2.api.$.evedpaycard.transactions, {
                sort: 'TransactionGroup',
                dir: 'DESC',
                start: 0,
                limit: 1000,
                isLiveGrid: true,
                filter: JSON.stringify({
                  searchTerm: ''
                })
              });
            case 3:
              response = _context.sent;
              _this2.transactions = response.data.Data.map(function (transaction) {
                return _objectSpread(_objectSpread({}, transaction), {}, {
                  merchant: transaction.Merchant,
                  amount: transaction.Amount,
                  date: transaction.TransactionDate,
                  status: transaction.TransactionStatus,
                  id: transaction.Id,
                  cardNumber: transaction.CardNumber,
                  reconcileStatus: transaction.ReconciliationStatus,
                  receipt: transaction.Receipt
                });
              });
              _this2.sortByDisplayGroup();
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error('Error fetching transactions:', _context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }))();
    },
    showDate: function showDate(transaction) {
      this.dateFormat = this.$user && this.$user.sessionSettings && this.$user.sessionSettings.DateAndTimeFormats && this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat ? this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat : 'MM-DD-YYYY';
      var date = this.moment(transaction.date).format(this.dateFormat);
      return date;
    },
    hasAccountPermission: function hasAccountPermission(permission) {
      if (this.$user && this.$user.$.userPermissions) {
        return this.$user.$.userPermissions.includes(permission);
      }
      return false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "fxZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_receiptScan_receiptScanPoller__ = __webpack_require__("N9pM");

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      receiptScan: {
        status: null,
        autoFill: null,
        matchCandidates: [],
        autoLinked: false,
        warnings: [],
        error: null
      },
      _receiptScanPoller: null
    };
  },
  methods: {
    startReceiptScan: function startReceiptScan(receiptScanId, contextHint) {
      if (this._receiptScanPoller) {
        this._receiptScanPoller.cancel();
      }
      var self = this;
      self.receiptScan = {
        status: __WEBPACK_IMPORTED_MODULE_0__core_receiptScan_receiptScanPoller__["a" /* default */].STATUS_UPLOADING,
        autoFill: null,
        matchCandidates: [],
        autoLinked: false,
        warnings: [],
        error: null
      };
      self._receiptScanPoller = Object(__WEBPACK_IMPORTED_MODULE_0__core_receiptScan_receiptScanPoller__["a" /* default */])({
        receiptScanId: receiptScanId,
        contextHint: contextHint || {},
        onStateChange: function onStateChange(status, data) {
          self.receiptScan.status = status;
          if (data && data.autoFill) {
            self.receiptScan.autoFill = data.autoFill;
          }
          if (data && data.matchCandidates) {
            self.receiptScan.matchCandidates = data.matchCandidates;
          }
          if (data && data.warnings) {
            self.receiptScan.warnings = data.warnings;
          }
        },
        onDone: function onDone(result) {
          self.receiptScan.status = __WEBPACK_IMPORTED_MODULE_0__core_receiptScan_receiptScanPoller__["a" /* default */].STATUS_COMPLETE;
          self.receiptScan.autoLinked = result.autoLinked;
          self.receiptScan.autoFill = result.autoFill;
          self.receiptScan.matchCandidates = result.matchCandidates;
          self.receiptScan.warnings = result.warnings;
        },
        onError: function onError(err) {
          self.receiptScan.error = err;
        }
      });
      self._receiptScanPoller.start();
    },
    cancelReceiptScan: function cancelReceiptScan() {
      if (this._receiptScanPoller) {
        this._receiptScanPoller.cancel();
        this._receiptScanPoller = null;
      }
    },
    applyAutoFill: function applyAutoFill() {
      if (!this.receiptScan.autoFill) {
        return;
      }
      this.$emit('receipt-scan-apply', this.receiptScan.autoFill);
    },
    dismissAutoFill: function dismissAutoFill() {
      this.receiptScan.autoFill = null;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._receiptScanPoller) {
      this._receiptScanPoller.cancel();
      this._receiptScanPoller = null;
    }
  }
});

/***/ }),

/***/ "g+w3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g0q4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g3X1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"envelope-rejection-reason-overlay"},[_c('p',{staticClass:"small"},[_c('strong',[_vm._v("Decline reason:")]),_vm._v(" "+_vm._s(_vm.rejectionReason)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g4pB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");



function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      modalText: '',
      isActive: false,
      cardStatusMessage: '',
      helpDeskTicketNumber: ''
    };
  },
  props: {
    status: String,
    cards: Array,
    division: Object,
    isEvedAdmin: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeModalText: function changeModalText(status) {
      switch (status) {
        case 'close':
          return this.cards.length === 1 ? 'You are about to close the following EvedPay card:' : 'You are about to close the following EvedPay cards:';
        default:
          return 'Are you sure you want to change this card status?';
      }
    },
    resetHelpDeskTicketNumber: function resetHelpDeskTicketNumber() {
      this.helpDeskTicketNumber = '';
      this.$emit('helpDeskTicketNumber', '');
    },
    onHelpDeskTicketInput: function onHelpDeskTicketInput(event) {
      var cleaned = (event.target.value || '').replace(/[^0-9]/g, '');
      if (cleaned !== this.helpDeskTicketNumber) {
        this.helpDeskTicketNumber = cleaned;
        event.target.value = cleaned;
      }
      this.$emit('helpDeskTicketNumber', this.helpDeskTicketNumber);
    },
    changeStatus: function changeStatus(status, showModal) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var statusToChange, isLockUnlock, body, _iterator, _step, card, response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              statusToChange = status;
              isLockUnlock = status === 'lock' || status === 'unlock';
              if (!(isLockUnlock && _this.isEvedAdmin && !_this.helpDeskTicketNumber.trim())) {
                _context.next = 5;
                break;
              }
              _this.cardStatusMessage = 'Help Desk Ticket Number is required.';
              return _context.abrupt("return");
            case 5:
              body = isLockUnlock ? {
                HelpDeskTicketNumber: _this.helpDeskTicketNumber.trim() || null
              } : undefined;
              _iterator = _createForOfIteratorHelper(_this.cards);
              _context.prev = 7;
              _iterator.s();
            case 9:
              if ((_step = _iterator.n()).done) {
                _context.next = 33;
                break;
              }
              card = _step.value;
              if (!isLockUnlock) {
                _context.next = 19;
                break;
              }
              statusToChange = _this.isActive ? 'lock' : 'unlock';
              if (!(_this.isActive && card.CardStatus === 'Locked' || !_this.isActive && card.CardStatus === 'Active')) {
                _context.next = 18;
                break;
              }
              _this.cardStatusMessage = "Card is already ".concat(_this.isActive ? 'locked' : 'active', ".");
              return _context.abrupt("return");
            case 18:
              _this.cardStatusMessage = '';
            case 19:
              _context.prev = 19;
              if (!card.Id) {
                _context.next = 25;
                break;
              }
              _context.next = 23;
              return _this.api.patch("evedpaycards/".concat(card.Id, "/").concat(statusToChange), body);
            case 23:
              response = _context.sent;
              if (response.status === 200) {
                showModal.showModal = false;
                _this.resetHelpDeskTicketNumber();
                _this.$emit('success');
              } else {
                _this.cardStatusMessage = 'Failed to change the status.';
              }
            case 25:
              _context.next = 30;
              break;
            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](19);
              _this.cardStatusMessage = 'Failed to change the status.';
            case 30:
              __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('status-changed', card.Id);
            case 31:
              _context.next = 9;
              break;
            case 33:
              _context.next = 38;
              break;
            case 35:
              _context.prev = 35;
              _context.t1 = _context["catch"](7);
              _iterator.e(_context.t1);
            case 38:
              _context.prev = 38;
              _iterator.f();
              return _context.finish(38);
            case 41:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[7, 35, 38, 41], [19, 27]]);
      }))();
    },
    singularize: function singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value;
    },
    // Surface the custom Name on Card next to the legal holder ("Jane Doe | John Smith") when it is set
    // and meaningfully differs (case-insensitive); otherwise show the legal name unchanged. Holder arrives
    // as a plain string from the cards grid rows, so normalise the object shape too. See PRODUCTDEV-5553.
    holderDisplay: function holderDisplay(card) {
      var legalName = card && card.Holder && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(card.Holder) === 'object' ? card.Holder.Name || '' : card && card.Holder || '';
      var nameOnCard = (card && card.NameOnCard || '').trim();
      if (!nameOnCard || nameOnCard.toLowerCase() === legalName.trim().toLowerCase()) {
        return legalName;
      }
      if (!legalName.trim()) {
        return nameOnCard;
      }
      return "".concat(nameOnCard, " | ").concat(legalName);
    }
  },
  created: function created() {
    this.divisionName = this.singularize(this.$root.getUser.settings.Labels.DivisionName);
    this.divisionsName = this.$root.getUser.settings.Labels.DivisionsName;
  }
});

/***/ }),

/***/ "g8Y0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFunding_vue__ = __webpack_require__("Uhb8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db01ebea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFunding_vue__ = __webpack_require__("BUe5");
function injectStyle (ssrContext) {
  __webpack_require__("tiZs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db01ebea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFunding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db01ebea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFunding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gE0V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util__ = __webpack_require__("OMJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */



// let instance = null

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
      noValue: false,
      invalidSum: false,
      validThreshold: true,
      validMinAmount: true,
      validMaxAmount: true
    };
  },
  computed: {
    //
    totalsRow: function totalsRow() {
      return this.params.node.rowPinned === 'bottom';
    },
    infoMessage: function infoMessage() {
      return this.params.colDef.infoMessage(this.params);
    },
    warningMessage: function warningMessage() {
      return !this.validMinAmount || !this.validMaxAmount;
    },
    moneyValue: function moneyValue() {
      if (this.params.value === null) {
        this.noValue = true;
        return null;
      }
      var p = this.params;
      var totals = [p.context.value || [], p.colDef.f, p.colDef.field];
      var isTotals = this.totalsRow && p.colDef.f;
      var VALUE = +p.value || (p.colDef.showDefaultEmpty ? '' : 0);
      var total = VALUE;
      var sum = this.sum.apply(this, totals);
      this.invalidSum = p.colDef.validSum && p.colDef.validSum.value !== sum;

      // TOTAL validations
      if (!Object(__WEBPACK_IMPORTED_MODULE_1_util__["isNullOrUndefined"])((p.colDef.minTotalThreshold || {}).value)) {
        this.validThreshold = p.colDef.minTotalThreshold.value <= sum;
      }
      if (!Object(__WEBPACK_IMPORTED_MODULE_1_util__["isNullOrUndefined"])((p.colDef.maxTotalThreshold || {}).value)) {
        this.validThreshold = sum < p.colDef.maxTotalThreshold.value;
      }

      // Line validations
      if (!Object(__WEBPACK_IMPORTED_MODULE_1_util__["isNullOrUndefined"])((p.colDef.minThreshold || {}).value) && !isTotals && p.value) {
        if (typeof this.minThreshold !== 'undefined') {
          if (this.minThreshold >= 0) {
            this.validMinAmount = +this.minThreshold < +VALUE;
            this.strictMin = true;
          } else {
            this.validMinAmount = +this.minThreshold <= +VALUE;
          }
          //
          !this.validMinAmount ? this.notify() : this.nextNotification();
        } else {
          this.validMinAmount = true;
        }
      }
      if (!Object(__WEBPACK_IMPORTED_MODULE_1_util__["isNullOrUndefined"])((p.colDef.maxThreshold || {}).value) && !isTotals && p.value) {
        if (typeof this.maxThreshold !== 'undefined') {
          if (this.maxThreshold > 0) {
            this.validMaxAmount = +VALUE <= +this.maxThreshold;
          } else {
            this.validMaxAmount = +VALUE < +this.maxThreshold;
            this.strictMax = true;
          }
          //
          !this.validMaxAmount && this.notify();
          !this.validMaxAmount && !this.validMinAmount && this.nextNotification();
        } else {
          this.validMaxAmount = true;
        }

        // when auto-correct needs to be implemented use next code:
        // if (!this.validMaxAmount) {
        //   // p.setValue(this.maxThreshold)
        //   // p.data._warning = true
        //   // return this.maxThreshold
        // } else {
        //   // p.data._warning = false
        // }
      }

      // set threshold flag
      if (isTotals) {
        p.context.totalsInvalid = !this.validThreshold;
        this.validMinAmount = true;
        this.validMaxAmount = true;
      }
      return isTotals ? sum : total;
    },
    invalidClass: function invalidClass() {
      return {
        'invalid': this.invalidSum,
        'invalid-threshold': !this.validThreshold,
        'invalid-amount': !this.validMinAmount || !this.validMaxAmount
      };
    },
    skipConversion: function skipConversion() {
      // return this.params.node.data._new && !this.params.node.data.draft
      // return this.params.node.data._new
    },
    currencyCode: function currencyCode() {
      return this.params.colDef.currency || this.params.data && this.params.data.CurrencyCode || this.params.context.currency;
    },
    validationMessage: function validationMessage() {
      var column = this.params.colDef.alias || this.params.colDef.headerName;
      var messageTemplateText = '';
      var strictMaxim = this.strictMax ? 'than' : 'than or equal to';
      var strictMinim = this.strictMin ? 'than' : 'than or equal to';
      if (!this.validMaxAmount) {
        messageTemplateText = "\n            <p>\n              ".concat(column, " must be less ").concat(strictMaxim, " <strong><v-money class=\"solid\" currency='").concat(this.currencyCode, "'> ").concat(this.maxThreshold, " </v-money></strong>\n            </p>\n          ");
      } else {
        if (!this.validMinAmount) {
          messageTemplateText = "\n              <p>\n                ".concat(column, " must be greater ").concat(strictMinim, " <strong><v-money class=\"solid\" currency='").concat(this.currencyCode, "'> ").concat(this.minThreshold, " </v-money></strong>\n              </p>\n            ");
        }
      }
      return messageTemplateText && this.currencyCode ? messageTemplateText : null;
    }
  },
  created: function created() {
    // instance = this
    this.setMinMaxAmountForValidation();
  },
  methods: {
    setMinMaxAmountForValidation: function setMinMaxAmountForValidation() {
      this.cell = this.params.eGridCell;
      this.gridRightMargin = this.params.api.gridPanel.ePinnedRightFloatingTop;
      this.setMaxAmountForValidation();
      this.setMinAmountForValidation();
      if (this.maxThreshold < 0 && typeof this.params.colDef.minThresholdRef[this.params.rowIndex] !== 'undefined' && typeof this.params.colDef.maxThresholdRef[this.params.rowIndex] !== 'undefined') {
        this.minThreshold = this.maxThreshold;
        this.maxThreshold = 0;
        this.params.colDef.minThresholdRef[this.params.rowIndex][this.params.colDef.field] = +this.minThreshold;
        this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field] = +this.maxThreshold;
      }
    },
    setMaxAmountForValidation: function setMaxAmountForValidation() {
      // set max threshold for each cell in column
      this.params.colDef.maxThresholdRef = this.params.colDef.maxThresholdRef || [];
      if (typeof this.params.data[this.params.colDef.field] !== 'undefined') {
        this.maxThreshold = typeof this.params.colDef.maxThresholdRef[this.params.rowIndex] !== 'undefined' && !isNaN(this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field]) ? this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field] : this.params.colDef.maxThreshold ? this.params.colDef.maxThreshold &&
        // compute max threshold based on formula / other column
        this.params.colDef.maxThreshold.f && this.params.data[this.params.colDef.maxThreshold.f] ||
        // compute max threshold based on own value
        this.params.data[this.params.colDef.field] ||
        // max threshold specified on column definition
        this.params.colDef.maxThreshold.value ||
        // fallback to 0 max threshold
        0 : null;
        if (typeof this.params.colDef.maxThresholdRef[this.params.rowIndex] === 'undefined') {
          this.params.colDef.maxThresholdRef[this.params.rowIndex] = {};
        }
        this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field] = +this.maxThreshold;
      }
    },
    setMinAmountForValidation: function setMinAmountForValidation() {
      // set min threshold for each cell in column
      this.params.colDef.minThresholdRef = this.params.colDef.minThresholdRef || [];
      if (typeof this.params.data[this.params.colDef.field] !== 'undefined') {
        this.minThreshold = typeof this.params.colDef.minThresholdRef[this.params.rowIndex] !== 'undefined' && !isNaN(this.params.colDef.minThresholdRef[this.params.rowIndex][this.params.colDef.field]) ? this.params.colDef.minThresholdRef[this.params.rowIndex][this.params.colDef.field] : this.params.colDef.minThreshold ? this.params.colDef.minThreshold &&
        // compute min threshold based on formula / other column
        this.params.colDef.minThreshold.f && this.params.data[this.params.colDef.minThreshold.f] ||
        // min threshold specified on column definition
        this.params.colDef.minThreshold.value ||
        // fallback to 0 min threshold
        0 : null;
        if (typeof this.params.colDef.minThresholdRef[this.params.rowIndex] === 'undefined') {
          this.params.colDef.minThresholdRef[this.params.rowIndex] = {};
        }
        this.params.colDef.minThresholdRef[this.params.rowIndex] = +this.minThreshold;
      }
    },
    notify: function notify(forceShow) {
      //
    },
    notifyComponent: function notifyComponent(messageTemplateText, forceShow) {
      var id = "".concat(this.params.colDef.field, "-").concat(this.params.rowIndex);
      if (forceShow) {
        this.$notifications.showById(id);
      } else {
        this.$notifications.notify({
          id: id,
          type: 'plain',
          timeout: 0,
          allowDismiss: false,
          position: {
            position: 'absolute',
            left: "".concat(this.gridRightMargin.getBoundingClientRect().left, "px"),
            top: "".concat(this.cell.getBoundingClientRect().top, "px"),
            offsetTop: "".concat(this.cell.parentNode.offsetTop + this.cell.clientHeight, "px")
          },
          component: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
            template: messageTemplateText
          }),
          message: "".concat(messageTemplateText, " ").concat(id),
          hide: this.$notifications.getLast().id !== id ? this.$notifications.errorState() : false
        });
      }
    },
    removeNotification: function removeNotification() {
      var remove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    } //
    ,
    nextNotification: function nextNotification() {
      //
    },
    getTaxes: function getTaxes(item, field) {
      var sumTaxes = 0;
      var taxes = item && item.taxes && item.taxes.length ? item.taxes : item && Object.keys(item).filter(function (k) {
        return ~k.indexOf('taxes_');
      }).map(function (k) {
        return item[k];
      }) || [];
      if (taxes.length && field === 'total') {
        sumTaxes = taxes.reduce(function (taxes, tax) {
          return taxes + (+tax.value || +tax || 0);
        }, 0);
      }
      return sumTaxes;
    },
    getFees: function getFees(item, field) {
      var sumFees = 0;
      var fees = item && item.fees && item.fees.length ? item.fees : item && Object.keys(item).filter(function (k) {
        return ~k.indexOf('fees_');
      }).map(function (k) {
        return item[k];
      }) || [];
      if (fees.length && field === 'total') {
        sumFees = fees.reduce(function (fees, fee) {
          return fees + (+fee.value || +fee || 0);
        }, 0);
      }
      return sumFees;
    },
    getDiscounts: function getDiscounts(item, field) {
      return item && item.discountAmount || 0;
    },
    sum: function sum(items, formula, field) {
      var _this = this;
      // let _formula = formula.replace(/_(\d+)/g, '[$1].value')
      var _formula = formula;
      if (this.params.context.total) {
        if (!isNaN(this.params.context.total)) {
          return parseFloat(parseFloat(this.params.context.total).toFixed(2));
        }
        return this.params.context.total;
      }
      return parseFloat(items.map(function (data) {
        return data._skip ? 0 : +eval(_formula) + _this.getTaxes(data, field) + _this.getFees(data, field) - _this.getDiscounts(data, field) || 0;
      }) // eslint-disable-line
      .reduce(function (a, b) {
        return a + b;
      }, 0).toFixed(2));
    },
    displayMoney: function displayMoney(p) {
      return !(p.node.rowPinned === 'bottom' && !p.value && !p.colDef.f) && !this.noValue;
    },
    showDetails: function showDetails() {
      this.shownDetails = !this.shownDetails;
    },
    edit: function edit(v) {
      this.params.setValue(v.label);
      this.params.value = v.label;
    },
    refresh: function refresh() {
      //
      this.shownDetails = false;
    }
  }
});

/***/ }),

/***/ "gEsY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"SF5VWUSfiKBuFdSJqPaoi","Dell":"_29vgcifzsq1ITVWrrkpEsm","Abbott":"_2Xy_SWh3TRIHWLAgyo331A","Gap":"_2eR7599mu5t7zZ8Fp8m5BO","Allstate":"EhgT0RvBWONxmKaUjkBWB","Asurion":"_3RUKhLshccquWiuV21OhoS","Invitae":"_3ExOskBlLUnrFEeX68OstE","JWE":"_2A7sMKcJ3SOnN6if4V7jR4"};

/***/ }),

/***/ "gFV1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gII9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1smnzUeGxwdkwt6R1_A_DO","Dell":"F9j4lBCoxOH05fE6xSMnL","Abbott":"_3QergqdgXeic8-tnxts05F","Gap":"_2Au0uAatFsNhZD9emKPrC4","Allstate":"_3K_5EEIvHrDhA0_IkeqMIm","Asurion":"_2u46KrQ12BbeE9F51mYfkj","Invitae":"_2Ni01kxuWeLgD0iHNV41kn","JWE":"_1_mSod1a2b54fIC1jGP1QL"};

/***/ }),

/***/ "gQZR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{attrs:{"title":_vm.$t("Company Settings")}}),_c('div',{staticClass:"container-fluid"},[_c('ed-section',{staticClass:"active",attrs:{"offset":"1"}},_vm._l((_vm.settings),function(setting,index){return _c('span',[(typeof setting.condition === "undefined" || setting.condition)?_c('ed-card',{key:setting.name,class:{ "new": setting.new, "editable": setting.editable },attrs:{"title":setting.name,"title-tooltip":setting.editable || null,"subtitle":_vm.subtitle(setting),"footer-button":setting.configurable,"icon":setting.icon,"endpoint":setting.saving && (setting.endpoint || _vm.api.$.settings.company.$)},on:{"edit":function($event){return _vm.edit(setting)}}},[(setting.help)?_c('span',{attrs:{"slot":"mask"},slot:"mask"},[_vm._v(_vm._s(setting.help))]):_vm._e(),(setting.status !== null)?_c('ed-switch',{attrs:{"slot":"top","value":_vm.$user.$.companySettings[setting.status],"disabled":setting.pending,"emit-on-mount":false},on:{"input":function($event){return _vm.change(setting)},"mousedown":function($event){return _vm.handleEndpoint(setting, $event)}},slot:"top",model:{value:(_vm.settings[index].value),callback:function ($$v) {_vm.$set(_vm.settings[index], "value", $$v)},expression:"settings[index].value"}}):_vm._e(),(setting.editable)?_c('span',{staticClass:"icon -pull-left",attrs:{"slot":"title-icon"},on:{"click":function($event){return _vm.edit(setting)}},slot:"title-icon"},[_vm._v("  "),_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(setting.editable || null),expression:"setting.editable || null",modifiers:{"bottom":true}}],staticClass:"edit-icon fas fa-pen"})]):_vm._e(),(setting.editable && setting.editing)?_c('ed-input',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(function () { return _vm.edit(setting, false); }),expression:"() => edit(setting, false)"}],staticClass:"edit-field small inline",attrs:{"slot":"title","update-button":"","disabled":_vm.isDisabled(setting),"autofocus":"","transition":"fade","maxlength":25},on:{"update":function($event){return _vm.change(setting, false)},"mousedown":function($event){return _vm.handleEndpoint(setting, $event)}},slot:"title",model:{value:(setting.name),callback:function ($$v) {_vm.$set(setting, "name", $$v)},expression:"setting.name"}}):_vm._e(),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[(setting.configurable != "false")?_c('ed-button',{staticClass:"btn btn-actionbar-",attrs:{"href":_vm.backUrl(setting.url, setting),"disabled":_vm.isDisabled(setting),"button-class":"btn btn-actionbar-"},on:{"click":_vm.edit}},[_vm._v(_vm._s(setting.configurable))]):_vm._e()],1)],1):_vm._e()],1)}),0)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gR0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('Open ' + _vm.params.value),expression:"'Open ' + params.value",modifiers:{"bottom":true}}],staticStyle:{"text-decoration":"underline","cursor":"pointer"},on:{"click":_vm.openEnvelope}},[_vm._v("\n    "+_vm._s(_vm.params.data.EnvelopeNumber)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gR1n":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./auth.vue": "UmH6",
	"./default.vue": "Pyxr",
	"./docs.vue": "jBGl",
	"./main.vue": "+qbq",
	"./mobile.vue": "wydl",
	"./navless.vue": "vGgY",
	"./other.vue": "XNcP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gR1n";

/***/ }),

/***/ "gk3X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ROW_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MIN_ROWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_ROWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WIDTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SETTING_PLACEHOLDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELECTOR_COMPONENTS; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getWidgetSize;
var ROW_HEIGHT = 45;
var MIN_ROWS = 4;
var MAX_ROWS = 6;
var WIDTHS = {
  width33Percent: 4,
  width50Percent: 6,
  width66Percent: 8,
  width100Percent: 12
};
var SETTING_PLACEHOLDERS = {
  toolbar: 'toolbar',
  settings: 'settings',
  footer: 'footer'
};
var SELECTOR_COMPONENTS = {
  radioSelector: 'ed-radio',
  checkBoxSelector: 'ed-checkbox',
  dropDownSelector: 'ed-select',
  currencySelector: 'ed-select'
};
function getWidgetSize(renderComponent) {
  var result = {
    MIN_ROWS: 8,
    MAX_ROWS: 8,
    NA_ROWS: 5,
    EX_MAX_ROWS: 20
  };
  switch (renderComponent) {
    case 'shortcuts-wdg-cmp':
      result.MIN_ROWS = 2;
      result.MAX_ROWS = 3;
      result.NA_ROWS = 2;
      break;
    case 'news-wdg-cmp':
      result.MIN_ROWS = 2;
      result.MAX_ROWS = 5;
      break;
    case 'approval-needed-wdg-cmp':
    case 'recent-updates-wdg-cmp':
      result.MIN_ROWS = 2;
      result.MAX_ROWS = 10;
      break;
    case 'paymentSupplierType-wdg-cmp':
      result.MIN_ROWS = 4;
      result.MAX_ROWS = 4;
      break;
    case 'hotelSpend-wdg-cmp':
      result.MIN_ROWS = 6;
      result.MAX_ROWS = 6;
      result.NA_ROWS = 5;
      break;
    case 'current-invoices-wdg-cmp':
    case 'current-programs-wdg-cmp':
      result.MIN_ROWS = 2;
      result.MAX_ROWS = 4;
      result.NA_ROWS = 2;
      break;
    case 'immediate-payment-escrows-wdg-cmp':
      result.MIN_ROWS = 2;
      result.MAX_ROWS = 10;
      result.NA_ROWS = 2;
      break;
  }
  return result;
}

/***/ }),

/***/ "glzZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[_c('p',[_vm._v(_vm._s(_vm.content))]),(!!_vm.author)?_c('small',[_vm._v(_vm._s(_vm.author))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gvZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addDivisionModal_vue__ = __webpack_require__("l9sY");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e21efcc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addDivisionModal_vue__ = __webpack_require__("B6Ul");
function injectStyle (ssrContext) {
  __webpack_require__("RFrs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e21efcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addDivisionModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e21efcc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addDivisionModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gyKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{},[_c('ed-radio',{attrs:{"fieldLabel":(_vm.allocationLabel + " Allocation"),"options":_vm.options,"track-by":"id","name":"allocation","error":_vm.error,"helptip-body":_vm.helptipBody,"helptipHeader":""},on:{"click":_vm.setAllocationType},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}},[_c('ed-select',{attrs:{"slot":"additionalInfo_1","placeholder":("Select " + _vm.allocationLabel),"options":_vm.allocations,"label":"value","track-by":"key","error":_vm.displayAllocationError,"helptip-body":_vm.displayAllocationError && ("Please select a " + _vm.allocationLabel + " Allocation") || "","helptipHeader":"","name":"cc_alocation"},on:{"select":function($event){return _vm.allocationSelected($event)}},slot:"additionalInfo_1",model:{value:(_vm.allocation),callback:function ($$v) {_vm.allocation=$$v},expression:"allocation"}}),_vm._v(" "),_c('p',{staticClass:"small",attrs:{"slot":"additionalInfo_2"},slot:"additionalInfo_2"},[_c('em',[_vm._v("After the invoice is scanned, you will be notified to add the "+_vm._s(_vm.allocationLabel)+"s before it can be approved.")])])],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h8Cl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h8o0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_he__ = __webpack_require__("t02m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("F3oP");





var SEARCH_DEBOUNCE = 300;
function isEmpty(opt) {
  if (opt === 0) return false;
  if (Array.isArray(opt) && opt.length === 0) return true;
  if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(opt) === 'object') {
    for (var prop in opt) {
      if (opt.hasOwnProperty(prop)) return false;
    }
    return true;
  }
  return !opt;
}
function includes(str, query) {
  /* istanbul ignore else */
  if (str === undefined) str = 'undefined';
  if (str === null) str = 'null';
  if (str === false) str = 'false';
  var text = str.toString().toLowerCase();
  return text.indexOf(query.trim()) !== -1;
}
function filterOptions(options, search, label, customLabel) {
  return options.filter(function (option) {
    return includes(customLabel(option, label), search);
  });
}
function stripGroups(options) {
  return options.filter(function (option) {
    return !option.$isLabel;
  });
}
function flattenOptions(values, label) {
  return function (options) {
    return options.reduce(function (prev, curr) {
      /* istanbul ignore else */
      if (curr[values] && curr[values].length) {
        prev.push({
          $groupLabel: curr[label],
          $isLabel: true
        });
        return prev.concat(curr[values]);
      }
      return prev;
    }, []);
  };
}
function filterGroups(search, label, values, groupLabel, customLabel, selectedGroup, multilist) {
  return function (groups) {
    return (multilist ? [selectedGroup] : groups).map(function (group) {
      /* istanbul ignore else */
      if (!group[values]) {
        console.warn("Options passed to vue-multiselect do not contain groups, despite the config.");
        return [];
      }
      var groupOptions = filterOptions(group[values], search, label, customLabel);
      return groupOptions.length ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, groupLabel, group[groupLabel]), values, groupOptions) : [];
    });
  };
}
var flow = function flow() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (x) {
    return fns.reduce(function (v, f) {
      return f(v);
    }, x);
  };
};
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: '',
      isOpen: false,
      prefferedOpenDirection: 'below',
      optimizedHeight: this.maxHeight,
      internalValue: this.value || this.value === 0 ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */])(Array.isArray(this.value) ? this.value : [this.value]) : []
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: true
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Array of all selected options from multiple select inputs.
     * @type {Array}
     */
    globalSelectedValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * Array of initial selected values (copy of initialValue).
     */
    selectedValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Presets the selected options value.
     * @type {Object||Array||String||Integer}
     */
    value: {
      type: null,
      default: function _default() {
        return [];
      }
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Clear the search input after select()
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: false
    },
    disableSelected: {
      type: Boolean,
      default: false
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: 'Select option'
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: true
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: false
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default: function _default(option, label) {
        if (isEmpty(option)) return '';
        return label ? option[label] : option;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: false
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: 'Press enter to create a tag'
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: 'top'
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: false
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1000
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    preserveSearch: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    /* istanbul ignore else */
    if (!this.multiple && !this.clearOnSelect) {
      console.warn('[Vue-Multiselect warn]: ClearOnSelect and Multiple props can’t be both set to false.');
    }
    if (!this.multiple && this.max) {
      console.warn('[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false.');
    }
  },
  computed: {
    filteredOptions: function filteredOptions() {
      var _this = this;
      if (this.serverSearch) {
        return this.options;
      }
      var search = this.search || '';
      var normalizedSearch = search.toLowerCase().trim();
      var options = this.options.concat();

      /* istanbul ignore else */
      if (this.internalSearch) {
        options = this.groupValues ? this.filterAndFlat(options, normalizedSearch, this.label) : filterOptions(options, normalizedSearch, this.label, this.customLabel);
      } else {
        options = this.groupValues ? flattenOptions(this.groupValues, this.groupLabel)(options) : options;
      }
      options = this.hideSelected ? options.filter(this.isNotSelected) : options;
      options = this.disableSelected ? options.map(function (option) {
        option.isDisabledOption = _this.globalSelectedValues.filter(function (o) {
          return o[_this.trackBy] === option[_this.trackBy];
        }).length > 0 && (_this.internalValue.length === 0 || _this.internalValue.filter(function (o) {
          return o[_this.trackBy] === option[_this.trackBy];
        }).length === 0) && _this.selectedValues.filter(function (op) {
          return op[_this.trackBy] === option[_this.trackBy];
        }).length === 0;
        return option;
      }) : options;

      /* istanbul ignore else */
      if (this.taggable && normalizedSearch.length && !this.isExistingOption(normalizedSearch)) {
        if (this.tagPosition === 'bottom') {
          options.push({
            isTag: true,
            label: normalizedSearch
          });
        } else {
          options.unshift({
            isTag: true,
            label: normalizedSearch
          });
        }
      }
      return options.slice(0, this.optionsLimit);
    },
    valueKeys: function valueKeys() {
      var _this2 = this;
      if (this.trackBy) {
        return this.internalValue.map(function (element) {
          return element[_this2.trackBy];
        });
      } else {
        return this.internalValue;
      }
    },
    optionKeys: function optionKeys() {
      var _this3 = this;
      var options = this.groupValues ? this.flatAndStrip(this.options) : this.options;
      return options.map(function (element) {
        return _this3.customLabel(element, _this3.label).toString().toLowerCase();
      });
    },
    currentOptionLabel: function currentOptionLabel() {
      return this.multiple ? this.searchable ? (this.multilist || this.checkboxes && this.multiple) && this.shownValue || '' : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? '' : this.placeholder;
    }
  },
  watch: {
    internalValue: function internalValue(newVal, oldVal) {
      /* istanbul ignore else */
      if (this.resetAfter && this.internalValue.length) {
        this.search = '';
        this.internalValue = [];
      }
    },
    search: function search() {
      this.$emit('search-change', this.search, this.id);
    },
    value: function value(_value) {
      this.internalValue = this.getInternalValue(_value);
    }
  },
  methods: {
    /**
     * Converts the internal value to the external value
     * @returns {Object||Array||String||Integer} returns the external value
     */
    getValue: function getValue() {
      return this.multiple ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */])(this.internalValue) : this.internalValue.length === 0 ? null : Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */])(this.internalValue[0]);
    },
    /**
     * Converts the external value to the internal value
     * @returns {Array} returns the internal value
     */
    getInternalValue: function getInternalValue(value) {
      return value === null || value === undefined ? [] : this.multiple ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */])(value) : Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */])([value]);
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @returns {Array} returns a filtered and flat options list
     */
    filterAndFlat: function filterAndFlat(options, search, label) {
      return flow(filterGroups(search, label, this.groupValues, this.groupLabel, this.customLabel, this.selectedGroupAfter || this.selectedGroup, this.multilist), flattenOptions(this.groupValues, this.groupLabel))(options);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @returns {Array} returns a flat options list without group labels
     */
    flatAndStrip: function flatAndStrip(options) {
      return flow(flattenOptions(this.groupValues, this.groupLabel), stripGroups)(options);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch: function updateSearch(query) {
      this.search = query;
    },
    debounceSearching: __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function () {
      this.$emit('search', this.search);
    }, SEARCH_DEBOUNCE),
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @returns {Boolean} returns true if element is available
     */
    isExistingOption: function isExistingOption(query) {
      return !this.options ? false : this.optionKeys.indexOf(query) > -1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected: function isSelected(option) {
      var opt = this.trackBy ? option[this.trackBy] : option;
      return this.valueKeys.indexOf(opt) > -1;
    },
    /**
     * Finds out if the given element is NOT already present
     * in the result value. Negated isSelected method.
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is not selected
     */
    isNotSelected: function isNotSelected(option) {
      return !this.isSelected(option);
    },
    isDisabled: function isDisabled(option) {
      return option.isDisabledOption === true;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel: function getOptionLabel(option) {
      /* istanbul ignore else */
      if (isEmpty(option)) return '';
      /* istanbul ignore else */
      if (option.isTag) return option.label;
      /* istanbul ignore else */
      if (option.$isLabel) return option.$groupLabel;
      var label = this.customLabel(option, this.label);
      /* istanbul ignore else */
      if (isEmpty(label)) return '';
      return this.decodeEntities ? __WEBPACK_IMPORTED_MODULE_3_he___default.a.decode(label) : label;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select: function select(option, key) {
      /* istanbul ignore else */
      if (this.blockKeys.indexOf(key) !== -1 || this.disabled || option.$isLabel || option.$isDisabled) return;
      /* istanbul ignore else */
      if (this.max && this.multiple && this.internalValue.length === this.max) return;
      /* istanbul ignore else */
      if (key === 'Tab' && !this.pointerDirty) return;
      if (option.isTag) {
        this.$emit('tag', option.label, this.id);
        this.search = '';
        if (this.closeOnSelect && !this.multiple) this.deactivate();
      } else {
        var isSelected = this.isSelected(option);
        if (isSelected) {
          // TODO:
          // commented out to allow selecting same option
          //
          if (this.checkboxes && this.multiple) {
            if (key !== 'Tab') this.removeElement(option);
            return;
          }
        } else if (this.multiple) {
          this.internalValue.push(option);
        } else {
          this.internalValue = [option];
        }
        this.$emit('select', Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */])(option), this.id);
        this.$emit('input', this.getValue(), this.id);
        this.selectedPointerSet(key, option);

        /* istanbul ignore else */
        if (this.clearOnSelect) this.search = '';
      }
      /* istanbul ignore else */
      if (this.closeOnSelect) this.deactivate();
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @returns {type}        description
     */
    removeElement: function removeElement(option) {
      var shouldClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      /* istanbul ignore else */
      if (this.disabled) return;
      /* istanbul ignore else */
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      var index = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(option) === 'object' ? this.valueKeys.indexOf(option[this.trackBy]) : this.valueKeys.indexOf(option);
      this.internalValue.splice(index, 1);
      this.$emit('input', this.getValue(), this.id);
      this.$emit('remove', Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */])(option), this.id);

      /* istanbul ignore else */
      if (this.closeOnSelect && shouldClose) this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement: function removeLastElement() {
      /* istanbul ignore else */
      if (this.blockKeys.indexOf('Delete') !== -1) return;
      /* istanbul ignore else */
      if (this.search.length === 0 && Array.isArray(this.internalValue)) {
        this.removeElement(this.internalValue[this.internalValue.length - 1], false);
      }
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate: function activate() {
      var _this4 = this;
      this.selectedGroupAfter = null;
      /* istanbul ignore else */
      if (this.isOpen || this.disabled) return;
      this.adjustPosition();
      /* istanbul ignore else  */
      if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
        this.pointer = 1;
      }
      this.isOpen = true;
      /* istanbul ignore else  */
      if (this.searchable) {
        if (!this.preserveSearch) this.search = '';
        this.$nextTick(function () {
          _this4.$refs.search.focus();
          if (_this4.getValue() === null || isEmpty(_this4.getValue())) {
            _this4.$refs.list.scrollTop = 0;
          } else {
            _this4.$refs.list.scrollTop = _this4.selectedPointerPosition;
          }
        });
      } else {
        this.$el.focus();
      }
      this.$emit('open', this.id);
      this.selectedPointerSet(undefined, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, this.trackBy, (this.getValue() || {})[this.trackBy]));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate: function deactivate(e) {
      /* istanbul ignore else */
      if (e && e.relatedTarget && (e.relatedTarget.type === 'radio' || e.relatedTarget.type === 'checkbox')) {
        this.preventDeactivate = e.relatedTarget;
        return;
      }
      if (e && e.target !== this.preventDeactivate) {
        this.preventDeactivate = false;
      }
      if (!this.isOpen || e && e.target === this.preventDeactivate) return;
      this.isOpen = false;
      /* istanbul ignore else  */
      if (this.searchable) {
        this.$refs.search.blur();
      } else {
        this.$el.blur();
      }
      if (!this.preserveSearch) this.search = '';
      this.$emit('close', this.getValue(), this.id);
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle: function toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition: function adjustPosition() {
      if (typeof window === 'undefined') return;
      var spaceAbove = this.$el.getBoundingClientRect().top;
      var spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      var hasEnoughSpaceBelow = spaceBelow > this.maxHeight;
      if (hasEnoughSpaceBelow || spaceBelow > spaceAbove || this.openDirection === 'below' || this.openDirection === 'bottom') {
        this.prefferedOpenDirection = 'below';
        this.optimizedHeight = Math.min(spaceBelow - 40, this.maxHeight);
      } else {
        this.prefferedOpenDirection = 'above';
        this.optimizedHeight = Math.min(spaceAbove - 40, this.maxHeight);
      }
    },
    /**
     * Handles the touchstart stop propagation.
     * Selects an option on mobile devices with one click
     * @param index
     * @param option
     */
    handleTouchStartStop: function handleTouchStartStop(index, option) {
      this.pointerSet(index);
      this.select(option);
    }
  }
});

/***/ }),

/***/ "h9OM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"LEanAiVihzhbQFxFNP5GU","Dell":"QvOXK-ZLXOJxHYQU4UM0a","Abbott":"_1O9CVfDV2oW_mqoX5e-INn","Gap":"_1vJCg5xk4q4M6JSfAGeaTo","Allstate":"_1ywLFXFS5KUFSh-mVKqSQJ","Asurion":"_2zT0-Vj_zEs7a8NSu2btd2","Invitae":"_2otwgz6TypScftYNUuCD2j","JWE":"_1liHHwq59g_mfjvyDfaLen"};

/***/ }),

/***/ "hDj0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hFsW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("body"),_vm._v(" "),(_vm.model)?_c('div',[_c('ul',{staticClass:"col-md-12"},_vm._l((_vm.attachments),function(attachment,index){return _c('li',{key:index},[_c('a',{attrs:{"target":"_blank","href":_vm.getAttachmentPath(attachment)}},[_vm._v(_vm._s(attachment.AttachmentName))])])}),0),_vm._v(" "),_c('br',{staticStyle:{"clear":"both"}})]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hG3n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hMCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewEmailModal_vue__ = __webpack_require__("fnVE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdb22c00_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewEmailModal_vue__ = __webpack_require__("DRsI");
function injectStyle (ssrContext) {
  __webpack_require__("eAMW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fdb22c00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewEmailModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdb22c00_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewEmailModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hMWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper",attrs:{"endpoint":_vm.widget.endPoint}},[(_vm.hasData && !_vm.loading)?_c('div',{staticClass:"row bottom-border header-row"},[_c('span',{staticClass:"header divisions"},[_vm._v(_vm._s(_vm.headerDivisionLabel))]),_vm._v(" "),_c('span',{staticClass:"header escrow"},[_vm._v("Escrow")]),_vm._v(" "),_c('span',{staticClass:"header transactionLimit text-right"},[_vm._v("Transaction Limit")]),_vm._v(" "),_c('span',{staticClass:"header amount text-right"},[_vm._v("Total Limit")]),_vm._v(" "),_c('span',{staticClass:"header balance text-right"},[_vm._v("Balance")])]):_vm._e(),_vm._v(" "),(_vm.hasData && !_vm.loading)?_c('div',{staticClass:"scroller"},[_c('div',_vm._l((_vm.groupedItems),function(group,divisionName){return _c('div',{key:divisionName},_vm._l((group),function(escrow,index){return _c('div',{key:index,staticClass:"row",class:index === 0 ? 'delimiter' : ''},[_c('span',{staticClass:"divisions"},[_vm._v(_vm._s(index === 0 ? divisionName : ''))]),_vm._v(" "),_c('span',{staticClass:"escrow"},[_vm._v("Escrow "+_vm._s(divisionName === 'Clientwide' ? 0 : index + 1))]),_vm._v(" "),_c('span',{staticClass:"transactionLimit text-right"},[_c('v-money',{attrs:{"code":"","currency":escrow.CurrencyCode}},[_vm._v(_vm._s(escrow.TransactionLimit))])],1),_vm._v(" "),_c('span',{staticClass:"amount text-right"},[_c('v-money',{attrs:{"code":"","currency":escrow.CurrencyCode}},[_vm._v(_vm._s(escrow.TotalLimit))])],1),_vm._v(" "),_c('span',{staticClass:"balance text-right"},[_c('v-money',{attrs:{"code":"","currency":escrow.CurrencyCode}},[_vm._v(_vm._s(escrow.Balance))])],1)])}),0)}),0)]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"empty-holder"},[_c('span')]):_vm._e(),_vm._v(" "),(!_vm.hasData && !_vm.loading)?_c('div',{staticClass:"empty-holder"},[_vm._m(0)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('i',{staticClass:"fal fa-credit-card icon"}),_vm._v(" "),_c('span',{staticClass:"text"},[_c('p',{staticClass:"bold"},[_vm._v("No Data Found")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("No items are currently available")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hPVU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loading__ = __webpack_require__("m4+0");

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.directive(__WEBPACK_IMPORTED_MODULE_0__loading__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__loading__["a" /* default */]);
  }
});

/***/ }),

/***/ "hPWI":
/***/ (function(module, exports) {

module.exports = {"CreatedAndSent":"Created And Sent","ChangeOrderSent":"Change Order Sent","Closed":"Closed","Cancelled":"Cancelled","OrderRequested":"Order Requested","ReloadRequested":"Reload Requested","Created":"Created","Revised":"Revised","EvedPayReady":"EvedPay Ready"}

/***/ }),

/***/ "hPWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapters__ = __webpack_require__("Nv6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_lang__ = __webpack_require__("pe4m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

var exportOptions = [{
  label: 'Selected',
  value: false
}, {
  label: 'All',
  value: true
}];
var Types = {
  'csv': {
    label: 'CSV',
    icon: 'fas fa-file fa-file-csv'
  },
  'xls': {
    label: 'XLS/XLSX',
    icon: 'fas fa-file-excel'
  },
  'pdf': {
    label: 'PDF',
    icon: 'fas fa-file-pdf'
  },
  'doc': {
    label: 'Word Document',
    icon: 'fas fa-file-word'
  }
};




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'export-selector',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__["mixin"]],
  props: {
    types: {
      type: Array,
      default: function _default() {
        return ['xls'];
      }
    },
    endpoint: String
  },
  data: function data() {
    return {
      //
      Types: Types,
      isExportSelectorOpened: false,
      exportOptions: exportOptions,
      exportOption: exportOptions[0],
      exportUri: 'about:blank'
    };
  },
  methods: {
    //
    t: function t(key) {
      return __WEBPACK_IMPORTED_MODULE_3__lang_lang__["a" /* i18n */].t(key);
    },
    openExportSelector: function openExportSelector() {
      this.isExportSelectorOpened = !this.isExportSelectorOpened;
    },
    closeExportSelector: function closeExportSelector() {
      if (this.isExportSelectorOpened) {
        this.isExportSelectorOpened = false;
      }
    },
    getExportUri: function getExportUri(type) {
      var _this = this;
      //
      var gridApi = this.$parent.gridOptions.api;
      var endpoint = this.$parent.endpoint.split('/')[1];
      var baseUri = this.endpoint ? "".concat(this.api.env, "/").concat(this.endpoint) : "".concat(this.api.env, "/").concat(endpoint, "/ExportList");
      var allColumns = gridApi.columnController.columnApi.getAllColumns() || [];
      var sortModel = gridApi.getSortModel();
      var filterModel = gridApi.getFilterModel();
      var limit = gridApi.rowModel.infiniteCache.virtualRowCount || 0;
      var searchTerm = this.$parent.searchTerm;
      var columns = [];
      var sortColumn = sortModel.length ? sortModel[0].colId : null;
      var sortDirection = sortModel.length ? sortModel[0].sort.toUpperCase() : null;
      var filter = __WEBPACK_IMPORTED_MODULE_1__adapters__["b" /* Filter */].mixin(filterModel, searchTerm, this.$parent.screen) || {};
      var filteredColumns = allColumns.filter(function (column) {
        return column.colDef.headerName !== '_';
      });
      filteredColumns.forEach(function (column) {
        column.colDef.action || (_this.exportOption.value ? false : !column.visible) || columns.push({
          Field: column.colDef.field,
          Name: column.colDef.headerName
        });
      });
      columns = global.encodeURI(JSON.stringify(columns));
      filter = global.encodeURI(JSON.stringify(filter));
      return "".concat(baseUri, "?") + "limit=".concat(limit, "&") + "start=0&" + "searchTerm=".concat(searchTerm, "&") + "Dir=".concat(sortDirection, "&") + "sort=".concat(sortColumn, "&") + "filter=".concat(filter, "&") + "columns=".concat(columns, "&") + "allColumns=".concat(this.exportOption.value, "&") + "getJustVisibleColumns=".concat(!this.exportOption.value, "&") + "columnsToLoad=".concat(columns);
    },
    doExport: function doExport(type) {
      var _this2 = this;
      var slug = "".concat(this.$parent.name || this.$parent.label, " > ").concat(type);
      this.exportUri = 'about:blank';
      this.$nextTick(function () {
        _this2.exportUri = _this2.getExportUri(type);
      });
      this.closeExportSelector();
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].GENERIC.EXPORT, slug);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "hRXq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2tS89XEpnP5AJvvr3XmR8z","Dell":"_13NtcZTZJlm3NUwS9KBmQ0","Abbott":"_2SHiDQv4CddKWpQxsadToG","Gap":"_355zy92kocEptlU0uV3bFH","Allstate":"_1evYppK9N8pFxPJAyXWMk3","Asurion":"WBAJXdt2GX6acgOTwYwgB","Invitae":"_2cA8U59D0Zg13vuq4B-x_9","JWE":"_2mGI6utF3UePE8ZlxyKU3G"};

/***/ }),

/***/ "hV+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("dPle");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_368e7eec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("YqwW");
function injectStyle (ssrContext) {
  __webpack_require__("/egI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-368e7eec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_368e7eec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hVxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEditSupplier_vue__ = __webpack_require__("66+x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2f4c8ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEditSupplier_vue__ = __webpack_require__("EyOm");
function injectStyle (ssrContext) {
  __webpack_require__("YnYi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2f4c8ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEditSupplier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2f4c8ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEditSupplier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hWew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InviteSupplierDialog_vue__ = __webpack_require__("mP7q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c38a3ba_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InviteSupplierDialog_vue__ = __webpack_require__("mL63");
function injectStyle (ssrContext) {
  __webpack_require__("bb1j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c38a3ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InviteSupplierDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c38a3ba_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InviteSupplierDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "haC8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation__ = __webpack_require__("qYFL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json__ = __webpack_require__("ZVSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json__);

var _this = this;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//



// Get avalable sitemap
// and asume all sections/components are allowed

var allowedComponents = __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a;

// NOTICE: deprecated
var resolveUser = function resolveUser(data) {
  /** Set payload as form-data */
  var formData = new FormData();
  formData.append('user', data.username);
  formData.append('pass', data.password);
  return new Promise(function (resolve, reject) {
    _this.api.post(_this.api.$.login, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(function (response) {
      response.data.login = _this.api.$.Login + response.data.sk;
      response.data.email = response.data.username;
      resolve(response.data);
    }).catch(function () {
      return reject;
    });
  });
};
var getModules = function getModules() {
  var authUser = JSON.parse(window.localStorage.getItem('evedUser'));
  var modules = [];
  if (authUser && authUser.token && authUser.modules) {
    modules = authUser.modules;
  }
  return modules;
};
var getPermissions = function getPermissions() {
  var authUser = JSON.parse(window.localStorage.getItem('evedUser'));
  var permissions = [];
  if (authUser && authUser.token && authUser.permissions) {
    permissions = authUser.permissions;
  }
  return permissions;
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'legacy-auth',
  created: function created() {
    var authUser = JSON.parse(window.localStorage.getItem('evedUser'));
    if (authUser && authUser.token) {
      this.$user.email = authUser.user.Email;
    }
  },
  resolveUser: resolveUser,
  allowedComponents: allowedComponents,
  allowedModules: function allowedModules() {
    // if (this.default.allowedModules.get) return

    var user = JSON.parse(window.localStorage.getItem('evedUser'));
    var modules = {};
    var menus = getModules();
    console.info('Allowed modules init');
    Object.keys(__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a).forEach(function (v, k) {
      // if (v === '_modules') return
      if (check(v)) {
        modules[v] = {
          label: __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[v].alias || __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a,
          alias: __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[v].label,
          autoHideSubtabs: __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[v].autoHideSubtabs,
          subtabs: {}
        };
        var subtabs = menus[__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[v].alias || __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[v]];

        // keep Programs menu label for Buyer/Seller
        if (modules[v].label === 'Commerce' && Number(user.domain) === 2) {
          modules[v].alias = 'Programs';
        }
        if (__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[v].subtabs) {
          subtabs = Object.assign({}, subtabs, __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[v].subtabs);
        }
        menus.length !== 0 && Object.keys(subtabs).forEach(function (vs, i) {
          if (typeof subtabs[vs].domain === 'undefined' || subtabs[vs].domain.indexOf(parseInt(user.domain)) > -1) {
            modules[v].subtabs[vs] = subtabs[vs].alias || subtabs[vs];
          }
        });

        // While filtering out navigation based on user permissions
        // also mark sections/components in the sitemap
        if (__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[v].pack) {
          var pack = __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[v].pack;
          var allowed = modules[v].subtabs;
          var allowedFlat = [];
          allowed && Object.keys(allowed).forEach(function (k) {
            return allowedFlat.push(allowed[k]);
          });
          Object.keys(pack).forEach(function (k) {
            if (typeof pack[k].name === 'string' || typeof pack[k] === 'string') {
              var name = pack[k].name || pack[k];
              allowedComponents[v].pack[k] = {
                name: name,
                notAllowed: !~allowedFlat.indexOf(k)
              };
            }
          });
        }
      }
    });
    function check(tab) {
      var user = JSON.parse(window.localStorage.getItem('evedUser'));
      var permissions = getPermissions();
      if (typeof __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].domain !== 'undefined' && !~__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].domain.indexOf(parseInt(user.domain))) {
        return false;
      }
      var result = true;
      var skip = false;
      if (typeof __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].allow !== 'undefined') {
        Object.keys(__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].allow).forEach(function (v, k) {
          if (!~permissions.indexOf('deny' + v)) {
            if (__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].allow[v] === 'any') {
              result = true;
              skip = true;
            }
            if (__WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].allow[v] === 'none') {
              result = false;
              skip = true;
            }
          } else if (!skip && __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].allow[v] === 'all') {
            result = false;
          }
        });
      }
      if (!skip) {
        if (typeof __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].subscription !== 'undefined' && __WEBPACK_IMPORTED_MODULE_2__core_site_map_map_json___default.a[tab].subscription !== user.subscription) {
          result = false;
        }
      }
      return result;
    }
    modules = Object(__WEBPACK_IMPORTED_MODULE_1__navigation__["a" /* navigation */])(_objectSpread({}, modules));
    console.info('You have access to', modules);
    var defaultKey = Object.keys(_this)[0];
    _this[defaultKey].allowedModules.get = modules;
    return modules;
  }
});

/***/ }),

/***/ "hbh0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dawn-attention-box-wrapper"},[_c('div',{staticClass:"title-area"},[_c('h1',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"page-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_c('div',{staticClass:"dawn-attention-box"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hbvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_20iivJeuW9sa2A-EPGb7Fl","Dell":"_162IHdTeRf_NRxekwRprNb","Abbott":"_22W7qDT8IgRY4aVPp8aGM_","Gap":"_1zn-Rj4Lrh4GjscT-nDlTJ","Allstate":"_3VQLnNc9uXopMs_dIYAqdH","Asurion":"_1PNjHVWVNEbPdlfECFbGSf","Invitae":"KlSym8bFU0XUIRVpsXBec","JWE":"_3rsp_cE6diFL4YpFxw478H"};

/***/ }),

/***/ "hcMa":
/***/ (function(module, exports) {

module.exports = {"_default":"local.","app":"local.","main":"web.eved.com","qainternaldemo":"qainternaldemoevedonline.","internaldemo":"internaldemoevedonline.","demo":"demoevedonline.","sandbox":"sandboxevedonline.","qaproduction":"qaproductionevedonline.","reporting-team":"reporting-team.","api-team":"api-team.","workflow-team":"workflow-team.","admin-team":"admin-team.","eved-fed":"www.","dev":"qainternaldemoevedonline."}

/***/ }),

/***/ "hcet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("SFkU");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1bf40d8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("JFv1");
function injectStyle (ssrContext) {
  __webpack_require__("g+w3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f1bf40d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1bf40d8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hfDE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-status-overlay"},[(_vm.status === 'lock' || _vm.status === 'unlock')?_c('div',[_c('p',[_vm._v("Locking a card prevents it from being used for new purchases. Unlock the card to resume usage.")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('ed-switch',{attrs:{"slot":"body","id":"lock-switch"},slot:"body",model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}}),_vm._v(" "),(_vm.cardStatusMessage)?_c('p',{staticClass:"card-status-message"},[_vm._v(_vm._s(_vm.cardStatusMessage))]):_vm._e()],1),_vm._v(" "),(_vm.isEvedAdmin)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"help-desk-ticket-number"}},[_vm._v("Help Desk Ticket Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.helpDeskTicketNumber),expression:"helpDeskTicketNumber"}],staticClass:"form-control",attrs:{"id":"help-desk-ticket-number","type":"text","inputmode":"numeric","maxlength":"250"},domProps:{"value":(_vm.helpDeskTicketNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.helpDeskTicketNumber=$event.target.value},_vm.onHelpDeskTicketInput]}})]):_vm._e()]):(_vm.status === 'report-lost-or-stolen')?_c('div',[_c('p',[_vm._v("This card will initially be locked while the process for reporting the card lost or stolen is facilitated.")])]):_c('div',[_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.changeModalText(_vm.status)))]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('tr',{staticClass:"row-with-border"},[_c('th',{staticClass:"small"},[_vm._v("Card Number")]),_vm._v(" "),_c('th',{staticClass:"small"},[_vm._v("Card Holder")]),_vm._v(" "),_c('th',{staticClass:"small"},[_vm._v(_vm._s(_vm.divisionName))]),_vm._v(" "),_c('th',{staticClass:"small"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"small"},[_vm._v("Balance")])]),_vm._v(" "),_vm._l((_vm.cards),function(card){return _c('tr',{key:card.Id},[_c('td',{staticClass:"small"},[_vm._v("**** **** **** "+_vm._s(card.CardNumber))]),_vm._v(" "),_c('td',{staticClass:"small"},[_vm._v(_vm._s(_vm.holderDisplay(card)))]),_vm._v(" "),_c('td',{staticClass:"small"},[_vm._v(_vm._s(card.Division ? card.Division : _vm.division.DivisionName))]),_vm._v(" "),_c('td',{staticClass:"small"},[_vm._v(_vm._s(card.CardStatus))]),_vm._v(" "),_c('td',{staticClass:"small"},[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(card.Balance))])],1)])})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Lock Card Activity")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hn0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-flex active"},[_c('ed-section',{staticClass:"no-flex active",attrs:{"title":_vm.getTitle,"wide":""}},[_c('span',{attrs:{"slot":"description"},slot:"description"},[_vm._v("\n      "+_vm._s(_vm.getDescription)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('ed-form',{staticClass:"col-md-12",attrs:{"submit-visible":false}},[(_vm.model.displayFundingCurrencies)?_c('ed-select',{attrs:{"field-label":"Funding Currency","placeholder":"Select a currency","options":_vm.model.currencies,"label":"Value","track-by":"Value","required":"","openEndpoint":_vm.api.$.invoice.i2p.currencies,"helptipHeader":"","error":_vm.errors.FundingCurrency,"helptip-body":_vm.errors.FundingCurrency && "Please select a Funding Currency" || "","name":"funding_currency"},on:{"select":function($event){return _vm.selectFundingCurrency($event)}},model:{value:(_vm.currency),callback:function ($$v) {_vm.currency=$$v},expression:"currency"}}):_vm._e(),_vm._v(" "),(
            !_vm.model.hideFundingEquivalentMessage &&
            (( _vm.model.displayFundingCurrencies &&
              _vm.currency &&
              _vm.currency.Key &&
              !_vm.isFundingCurrencySameOnPaymentRun
            ) || _vm.isFundingCurrencyDifferent))?_c('p',{staticClass:"funding-equivalent"},[_vm._v("\n          "+_vm._s(_vm.paymentNonUSDMessage)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.model.displayUSDEquivalent)?_c('ed-input',{attrs:{"field-label":"USD Equivalent","disabled":_vm.model.disableUSDEquivalent,"type":"money","amount":"","autoselect":"","helptipHeader":"","error":_vm.errors.USDEquivalentMissing,"helptip-body":_vm.errors.USDEquivalentMissing && "Please select USD Equivalent." || "","name":"usd_equivalent"},on:{"change":_vm.usdEquivalentChanged},model:{value:(_vm.model.usdEquivalent),callback:function ($$v) {_vm.$set(_vm.model, "usdEquivalent", $$v)},expression:"model.usdEquivalent"}}):_vm._e(),_vm._v(" "),_c('ed-datepicker',{attrs:{"field-label":"Scheduled Payment Date","placeholder":"Select date","required":"","disabled":_vm.model.disablePaymentDate,"shortcuts":_vm.datepickerShortcuts,"notBefore":_vm.model.notBeforePaymentDate,"error":_vm.errors.PaymentDateMissing,"helptip-body":_vm.errors.PaymentDateMissing && "Please select a Payment Date." || "","helptip-header":"","name":"scheduled_payment_date"},on:{"input":_vm.paymentDateChanged},model:{value:(_vm.paymentDate),callback:function ($$v) {_vm.paymentDate=$$v},expression:"paymentDate"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12 no-pad"},[_c('ed-checkbox',{attrs:{"options":_vm.approvalCheckboxOptions,"required":"","error":_vm.errors.ApprovalCheckboxError,"helptip-body":_vm.errors.ApprovalCheckboxError && "Please approve the submission of this payment" || "","helptip-header":"","name":"approve_payment_checkbox"},on:{"click":_vm.checkApprovalCheckbox}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clear"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hrZ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: Array,
    programLabel: String
  },
  computed: {
    hasProgramName: function hasProgramName() {
      return this.list.some(function (item) {
        return item.ProgramName;
      });
    },
    hasSupplier: function hasSupplier() {
      return this.list.some(function (item) {
        return item.SupplierName;
      });
    },
    hasDueDate: function hasDueDate() {
      return this.list.some(function (item) {
        return item.DueDate;
      });
    }
  }
});

/***/ }),

/***/ "hvKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  invoices: [],
  // array of objects with some details for each invoice
  selectedInvoices: [],
  addAnotherInvoice: false,
  submitAllInvoices: false
});

/***/ }),

/***/ "hwsh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dawn-slider-wrapper form-group"},[(_vm.fieldLabel)?_c('label',[_vm._v(_vm._s(_vm.fieldLabel)+" "),(_vm.required)?_c('span',[_vm._v("  *")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"helptip-wrapper"},[(_vm.helptipBody)?_c('span',{staticClass:"helptip-icon",on:{"click":function($event){return _vm.toggleHelp()}}},[_c('i',{class:[_vm.showHelp ? _vm.hideIcon : _vm.showIcon]})]):_vm._e(),_vm._v(" "),(_vm.helptipBody && _vm.showHelp || _vm.helptipBody && _vm.error)?_c('dawn-input-tooltip',{class:{'error-message' : _vm.error},attrs:{"helptipHeader":_vm.helptipHeader,"errorTip":_vm.error,"helptipBody":_vm.helptipBody}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"wrap",class:['vue-slider-component', _vm.flowDirection, _vm.disabledClass, { 'vue-slider-has-label': _vm.piecewiseLabel }],style:(_vm.wrapStyles),on:{"click":_vm.wrapClick}},[_c('div',{ref:"elem",staticClass:"vue-slider",style:([_vm.elemStyles, _vm.bgStyle]),attrs:{"aria-hidden":"true"}},[(_vm.isRange)?[_c('div',{ref:"dot0",class:[_vm.tooltipStatus, 'vue-slider-dot'],style:([_vm.dotStyles, _vm.sliderStyles[0]]),on:{"mousedown":function($event){return _vm.moveStart($event, 0)},"touchstart":function($event){return _vm.moveStart($event, 0)}}},[_c('span',{class:['vue-slider-tooltip-' + _vm.tooltipDirection[0], 'vue-slider-tooltip-wrap']},[_vm._t("tooltip",function(){return [_c('span',{staticClass:"vue-slider-tooltip",style:(_vm.tooltipStyles[0])},[_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[0]) : _vm.val[0]))])]},{"value":_vm.val[0],"index":0})],2)]),_vm._v(" "),_c('div',{ref:"dot1",class:[_vm.tooltipStatus, 'vue-slider-dot'],style:([_vm.dotStyles, _vm.sliderStyles[1]]),on:{"mousedown":function($event){return _vm.moveStart($event, 1)},"touchstart":function($event){return _vm.moveStart($event, 1)}}},[_c('span',{class:['vue-slider-tooltip-' + _vm.tooltipDirection[1], 'vue-slider-tooltip-wrap']},[_vm._t("tooltip",function(){return [_c('span',{staticClass:"vue-slider-tooltip",style:(_vm.tooltipStyles[1])},[_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[1]) : _vm.val[1]))])]},{"value":_vm.val[1],"index":1})],2)])]:[_c('div',{ref:"dot",class:[_vm.tooltipStatus, 'vue-slider-dot'],style:([_vm.dotStyles, _vm.sliderStyles]),on:{"mousedown":_vm.moveStart,"touchstart":_vm.moveStart}},[_c('span',{class:['vue-slider-tooltip-' + _vm.tooltipDirection, 'vue-slider-tooltip-wrap']},[_vm._t("tooltip",function(){return [_c('span',{staticClass:"vue-slider-tooltip",style:(_vm.tooltipStyles)},[_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val) : _vm.val))])]},{"value":_vm.val})],2)])],_vm._v(" "),_c('ul',{staticClass:"vue-slider-piecewise"},_vm._l((_vm.piecewiseDotWrap),function(piecewiseObj,index){return _c('li',{key:index,staticClass:"vue-slider-piecewise-item",style:([_vm.piecewiseDotStyle, piecewiseObj.style])},[_vm._t("piecewise",function(){return [(_vm.piecewise)?_c('span',{staticClass:"vue-slider-piecewise-dot",style:([ _vm.piecewiseStyle, piecewiseObj.inRange ? _vm.piecewiseActiveStyle : null ])}):_vm._e()]},{"label":piecewiseObj.label,"index":index,"first":index === 0,"last":index === _vm.piecewiseDotWrap.length - 1,"active":piecewiseObj.inRange}),_vm._v(" "),_vm._t("label",function(){return [(_vm.piecewiseLabel)?_c('span',{staticClass:"vue-slider-piecewise-label",style:([ _vm.labelStyle, piecewiseObj.inRange ? _vm.labelActiveStyle : null ])},[_vm._v("\n            "+_vm._s(piecewiseObj.label)+"\n          ")]):_vm._e()]},{"label":piecewiseObj.label,"index":index,"first":index === 0,"last":index === _vm.piecewiseDotWrap.length - 1,"active":piecewiseObj.inRange})],2)}),0),_vm._v(" "),_c('div',{ref:"process",staticClass:"vue-slider-process",style:(_vm.processStyle)})],2),_vm._v(" "),(!_vm.isRange && !_vm.data)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],staticClass:"vue-slider-sr-only",attrs:{"type":"range","min":_vm.min,"max":_vm.max},domProps:{"value":(_vm.val)},on:{"__r":function($event){_vm.val=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"slider-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],staticClass:"form-control",attrs:{"dir":"rtl","type":"number","min":_vm.min,"max":_vm.max},domProps:{"value":(_vm.val)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.val=$event.target.value},function($event){return _vm.onChg($event)}]}}),_c('span',[_vm._v(_vm._s(_vm.symbol))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hywn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3d4fW5H5W4u105-XvRRaV4","Dell":"_2_c3Ip2ZOlWBkRiVsbSTR9","Abbott":"PoBbF9MbnbyEWyhwQwE5g","Gap":"_13s6mLgnvM6YeB-HTv9az7","Allstate":"Pa5Eb6puyTOozB0aJn8EE","Asurion":"_1Nq-E2OOjFCYirE8-algGz","Invitae":"_30LJk3oVCehliM_5pyzGYm","JWE":"_3IBcZt4pjB1NT2wsLJny5A"};

/***/ }),

/***/ "i+5f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounts_vue__ = __webpack_require__("F6wb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a834f4a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accounts_vue__ = __webpack_require__("Qnfj");
function injectStyle (ssrContext) {
  __webpack_require__("nnjS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a834f4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a834f4a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i+Nj":
/***/ (function(module, exports) {

module.exports = {"VendorAddressId":"_","EntityLegalName":"Entity Legal Name","*Name":{"label":"Funding Entity Name","width":300},"Address":"Address","Address2":{"label":"Address 2","visible":false},"City":"City","StateAndRegion":{"label":"State/Region","visible":false},"Zip":"Postal/ZIP Code","Country":"Country","VatNo":"VAT ID","Email":{"label":"Email","visible":false},"EIN":"EIN"}

/***/ }),

/***/ "i/Pq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = envelopeTermFor;
// PRODUCTDEV-8800: what EvedPay Cards calls an envelope ("Envelope" or "Expense Report").
// A row from EvedPayCardEnvelopes/GetList carries its division's term; otherwise the client's, from GetUserSettings.

var text = function text(value) {
  return typeof value === 'string' && value ? value : null;
};
function envelopeTermFor(row) {
  var user = global.app && global.app.$user;
  var settings = user && user.sessionSettings && user.sessionSettings.CompanySettings || {};
  var labels = settings.Labels || {};
  var singular = text(row && row.EnvelopeTerm) || text(labels.EnvelopeTerm) || text(settings.EnvelopeTerm) || 'Envelope';
  var plural = text(row && row.EnvelopesTerm) || text(labels.EnvelopesTerm) || text(settings.EnvelopesTerm) || singular + 's';
  return {
    singular: singular,
    plural: plural,
    lower: singular.toLowerCase()
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "i2Zn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"endpoint":_vm.api.$.evedpaycard.cards}},[_vm._t("title"),_vm._v(" "),(_vm.cards && !_vm.cards.length)?_c('div',{staticClass:"no-data"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.cards),function(card,i){return _c('div',{key:card.id,on:{"click":function () { return _vm.redirectToCardTransactions(card); }}},[(_vm.showHeader(card, i))?_c('h6',[_vm._v("\n      "+_vm._s(_vm.headerText(card))+"\n    ")]):_vm._e(),_vm._v(" "),_c('ed-notice',{staticClass:"card"},[_c('div',{staticClass:"details"},[_c('i',{staticClass:"open icon fal fa-angle-right"}),_vm._v(" "),_c('div',{staticClass:"preview"},[_c('div',{staticClass:"image"},[_c('i',{staticClass:"icon fal fa-credit-card"}),_vm._v(" "),_c('div',{staticClass:"logo"},[_c('img',{staticStyle:{"display":"none"},attrs:{"src":"https://d1a4bxjw35af21.cloudfront.net/images_en/eved-pay-logo.svg","height":"16"}})])])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.showCardNameForDifferentStatus(card)))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatCardHolderLine(card)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(card.division))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(card.date))])]),_vm._v(" "),_c('table',{staticClass:"summary"},[_c('tr',[_c('td',[_vm._v("Initial load")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('v-money',[_vm._v(_vm._s(card.initialLoad))])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Refills")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('v-money',[_vm._v(_vm._s(card.refills))])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Pending requests")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('v-money',[_vm._v(_vm._s(card.pendingRequest))])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Spent")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('v-money',[_vm._v(_vm._s(card.spent))])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Returned")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('v-money',[_vm._v(_vm._s(card.returned))])],1)]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("Balance")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_c('v-money',[_vm._v(_vm._s(card.balance))])],1)])])])])],1)})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"icon fas fa-credit-card"}),_vm._v(" "),_c('h3',[_vm._v("No Cards")]),_vm._v(" "),_c('p',[_vm._v("Once you are assigned a card it will appear here")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i2x5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("okXg");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26941a47_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("NdDz");
function injectStyle (ssrContext) {
  __webpack_require__("H0PG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26941a47"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26941a47_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "i4M7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"well col-md-5 pull-right"},[(_vm.title)?_c('label',{staticClass:"title"},[_c('h5',{staticClass:"no-margin"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{staticClass:"item-label"},[_vm._v("Your Name")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm.$user.$.name))]),_vm._v(" "),_c('label',{staticClass:"item-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm.$user.email))]),_vm._v(" "),_c('label',{staticClass:"item-label"},[_vm._v("Date")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm.today))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i52k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/logo-light.14b7833.jpg";

/***/ }),

/***/ "i8rz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"title":_vm.claimMode ? 'Claim Receipt' : 'Submit Receipt',"show":_vm.show,"primary-button":_vm.claimMode ? 'CLAIM' : 'SUBMIT',"secondary-button":"CANCEL","primary-button-disabled":!_vm.selectedCandidate || _vm.actionInFlight,"type":"medium-large"},on:{"close":_vm.handleClose,"confirm":_vm.handleMatch}},[_c('div',{staticClass:"candidate-selector-body",attrs:{"slot":"body"},slot:"body"},[(!_vm.isMobile)?_c('p',{staticClass:"modal-subtitle"},[_vm._v("Upload an image of a receipt and it will be matched to a transaction and coded automatically.")]):_vm._e(),_vm._v(" "),(_vm.autoLinked && !_vm.dismissedAutoLink)?_c('div',{staticClass:"alert alert-info auto-linked-banner"},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v(" "),_c('span',[_vm._v("This receipt was automatically matched. Confirm or select a different transaction.")]),_vm._v(" "),_c('a',{staticClass:"dismiss-auto-link",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.dismissedAutoLink = true}}},[_vm._v("Dismiss")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"receipt-row"},[_c('div',{staticClass:"receipt-section"},[_c('h4',{staticClass:"section-label"},[_vm._v("Receipt")]),_vm._v(" "),_c('ReceiptImageViewer',{attrs:{"image-url":_vm.displayImageUrl,"content-type":_vm.localImageContentType,"errored":_vm.receiptImageError}})],1),_vm._v(" "),_c('div',{staticClass:"receipt-data-section"},[_c('h4',{staticClass:"section-label"},[_vm._v("Receipt Data")]),_vm._v(" "),_c('div',{staticClass:"receipt-data-stack"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"field-label"},[_vm._v("Merchant")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"field-value"},[_c('span',{staticClass:"skeleton skeleton-line skeleton-merchant"})]):_c('div',{staticClass:"field-value"},[_vm._v(_vm._s(_vm.ocrMerchant || '—'))])]),_vm._v(" "),_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"field-label"},[_vm._v("Date")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"field-value"},[_c('span',{staticClass:"skeleton skeleton-line skeleton-date"})]):_c('div',{staticClass:"field-value"},[_vm._v(_vm._s(_vm.ocrDate || '—'))])]),_vm._v(" "),_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"field-label"},[_vm._v("Amount")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"field-value"},[_c('span',{staticClass:"skeleton skeleton-line skeleton-amount"})]):_c('div',{staticClass:"field-value"},[_vm._v(_vm._s(_vm.ocrAmount || '—'))])])])])]),_vm._v(" "),(_vm.isMobile && !_vm.claimMode)?_c('div',{staticClass:"receipt-folder-prompt receipt-folder-prompt--top"},[_c('span',{staticClass:"prompt-text"},[_vm._v("Don’t see the transaction?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary add-to-folder-btn",attrs:{"type":"button","disabled":_vm.actionInFlight},on:{"click":_vm.handleSaveToFolder}},[_vm._v("\n        ADD TO RECEIPT FOLDER\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"transactions-section"},[_c('h4',{staticClass:"section-label"},[_vm._v("Open and Pending Transactions")]),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"candidates-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"select-col"}),_vm._v(" "),_c('th',{staticClass:"date-col"},[_vm._v("Date")]),_vm._v(" "),_c('th',{staticClass:"card-col"},[_vm._v("Card")]),_vm._v(" "),_c('th',{staticClass:"holder-col"},[_vm._v("Card Holder")]),_vm._v(" "),_c('th',{staticClass:"merchant-col"},[_vm._v("Merchant")]),_vm._v(" "),_c('th',{staticClass:"amount-col"},[_vm._v("Amount")]),_vm._v(" "),_c('th',{staticClass:"status-col"},[_vm._v("Transaction Status")])])]),_vm._v(" "),(_vm.loading)?_c('tbody',_vm._l((_vm.SKELETON_ROW_COUNT),function(n){return _c('tr',{key:'skeleton-row-' + n,staticClass:"skeleton-row"},[_c('td',{staticClass:"select-col"}),_vm._v(" "),_c('td',{staticClass:"date-col"},[_c('span',{staticClass:"skeleton skeleton-line"})]),_vm._v(" "),_c('td',{staticClass:"card-col"},[_c('span',{staticClass:"skeleton skeleton-line"})]),_vm._v(" "),_c('td',{staticClass:"holder-col"},[_c('span',{staticClass:"skeleton skeleton-line"})]),_vm._v(" "),_c('td',{staticClass:"merchant-col"},[_c('span',{staticClass:"skeleton skeleton-line"})]),_vm._v(" "),_c('td',{staticClass:"amount-col"},[_c('span',{staticClass:"skeleton skeleton-line"})]),_vm._v(" "),_c('td',{staticClass:"status-col"},[_c('span',{staticClass:"skeleton skeleton-line"})])])}),0):_c('tbody',_vm._l((_vm.candidates),function(candidate){return _c('tr',{key:candidate.legacyTransactionId,class:{ 'is-selected': _vm.selectedCandidate && _vm.selectedCandidate.legacyTransactionId === candidate.legacyTransactionId },on:{"click":function($event){_vm.selectedCandidate = candidate}}},[_c('td',{staticClass:"select-col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCandidate),expression:"selectedCandidate"}],staticClass:"candidate-radio",attrs:{"type":"radio","id":'candidate-' + candidate.legacyTransactionId},domProps:{"value":candidate,"checked":_vm._q(_vm.selectedCandidate,candidate)},on:{"change":function($event){_vm.selectedCandidate=candidate}}})]),_vm._v(" "),_c('td',{staticClass:"date-col"},[_vm._v(_vm._s(_vm.formatDate(candidate.transactionDate)))]),_vm._v(" "),_c('td',{staticClass:"card-col"},[(candidate.cardNumberLast4)?_c('span',[_vm._v("*"+_vm._s(candidate.cardNumberLast4))]):_c('span',[_vm._v("—")])]),_vm._v(" "),_c('td',{staticClass:"holder-col"},[_c('span',{staticClass:"holder-name"},[_vm._v(_vm._s(candidate.cardholderName || '—'))]),_vm._v(" "),(_vm.showNameOnCard(candidate))?_c('span',{staticClass:"holder-name-on-card"},[_vm._v(_vm._s(candidate.nameOnCard))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"merchant-col"},[_vm._v(_vm._s(candidate.merchantName || '—'))]),_vm._v(" "),_c('td',{staticClass:"amount-col"},[_vm._v(_vm._s(_vm.formatCurrency(candidate.amount, candidate.currencyCode)))]),_vm._v(" "),_c('td',{staticClass:"status-col"},[_vm._v(_vm._s(candidate.transactionStatus || 'Open'))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.isMobile && _vm.loading)?_c('div',{staticClass:"candidates-list"},_vm._l((_vm.SKELETON_ROW_COUNT),function(n){return _c('div',{key:'skeleton-mobile-' + n,staticClass:"candidate-item skeleton-row"},[_c('span',{staticClass:"skeleton skeleton-line skeleton-mobile-row"})])}),0):(_vm.isMobile)?_c('div',{staticClass:"candidates-list"},_vm._l((_vm.candidates),function(candidate){return _c('div',{key:candidate.legacyTransactionId,staticClass:"candidate-item",class:{ 'is-selected': _vm.selectedCandidate && _vm.selectedCandidate.legacyTransactionId === candidate.legacyTransactionId }},[_c('label',{staticClass:"candidate-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCandidate),expression:"selectedCandidate"}],staticClass:"candidate-radio",attrs:{"type":"radio","id":'candidate-mobile-' + candidate.legacyTransactionId},domProps:{"value":candidate,"checked":_vm._q(_vm.selectedCandidate,candidate)},on:{"change":function($event){_vm.selectedCandidate=candidate}}}),_vm._v(" "),_c('div',{staticClass:"candidate-details"},[_c('div',{staticClass:"merchant-name"},[_vm._v("\n                "+_vm._s(candidate.merchantName)+"\n                "),(candidate.cardNumberLast4)?_c('span',{staticClass:"card-last4"},[_vm._v("•••• "+_vm._s(candidate.cardNumberLast4))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"transaction-meta"},[_c('span',{staticClass:"amount"},[_vm._v(_vm._s(_vm.formatCurrency(candidate.amount, candidate.currencyCode)))]),_vm._v(" "),_c('span',{staticClass:"separator"},[_vm._v("•")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatDate(candidate.transactionDate)))])])])])])}),0):_vm._e(),_vm._v(" "),(!_vm.loading && (!_vm.candidates || _vm.candidates.length === 0))?_c('div',{staticClass:"empty-state"},[_c('p',[_vm._v("No matching transactions found. Add this receipt to your folder.")])]):_vm._e()]),_vm._v(" "),(!_vm.claimMode && !_vm.loading)?_c('div',{staticClass:"receipt-folder-prompt"},[_c('span',{staticClass:"prompt-text"},[_vm._v("Don’t see the transaction?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary add-to-folder-btn",attrs:{"type":"button","disabled":_vm.actionInFlight},on:{"click":_vm.handleSaveToFolder}},[_vm._v("\n        ADD TO RECEIPT FOLDER\n      ")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iHeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__ = __webpack_require__("7Mbz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d0aa4ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__ = __webpack_require__("4zVd");
function injectStyle (ssrContext) {
  __webpack_require__("SC5H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d0aa4ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iMDH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"formRef"},[_c('ed-modal',{attrs:{"title":"Add User","show":_vm.show,"validation":"","primary-button":"Add","type":"small-medium"},on:{"close":function($event){return _vm.$emit('close')},"validate":_vm.addUser,"confirm":_vm.addUser}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"add-user-overlay"},[_c('p',{staticClass:"bold"},[_vm._v("User Information")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.accountId === '')?_c('label',{attrs:{"for":"roles"}},[_vm._v(_vm._s(_vm.rolesName))]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"role"}},[_vm._v("User Role *")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select a Role","options":_vm.roles,"label":"Name","track-by":"Id","error":_vm.roleIncomplete,"name":"role_user"},on:{"input":function (o) { _vm.addObjectUser.Role = o; this$1.roleIncomplete = false; },"open":_vm.getUserRoles},model:{value:(_vm.selectRole),callback:function ($$v) {_vm.selectRole=$$v},expression:"selectRole"}})],1),_vm._v(" "),_c('div',{staticClass:"input-group row"},[_c('div',{staticClass:"form-group col-md-5"},[(_vm.accountId === '')?_c('label',{attrs:{"for":"division"}},[_vm._v(_vm._s(_vm.divisionsName))]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"divisionsDropdown"}},[_vm._v(_vm._s(this.$root.getUser.settings.Labels.DivisionsName)+" *")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":("Select a " + (_vm.singularize(this.$root.getUser.settings.Labels.DivisionName))),"options":_vm.divisionsDropdown,"label":"DivisionName","track-by":"DivisionId","error":_vm.divisionIncomplete,"name":"division_user"},on:{"input":function (o) { _vm.addObjectUser.Division = o; this$1.divisionIncomplete = false; },"open":_vm.getUserDivisions},model:{value:(_vm.selectDivision),callback:function ($$v) {_vm.selectDivision=$$v},expression:"selectDivision"}})],1),_vm._v(" "),_c('div',{staticClass:"input-group-item-button col-md-6"},[_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.addSelectedDivisionToGrid}},[_vm._v("\n              Add\n            ")]),_vm._v(" "),_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.addAllDivisions}},[_vm._v("\n              Add All\n            ")]),_vm._v(" "),_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.removeAllDivisions}},[_vm._v("\n              Remove All\n            ")])],1)]),_vm._v(" "),[_c('div',{staticClass:"grid-container"},[_c('Grid',{key:_vm.itemsHash(_vm.divisionsGrid),ref:"grid",staticClass:"divisions-list",attrs:{"layout":"frame","checkboxes":false,"allowExport":false,"model":_vm.DivisionModel.get(this.$root.getUser.settings),"search":true,"resizing":false,"actions":_vm.actions,"data":_vm.divisionsGrid,"views":false,"additional-filters":[],"all-row-selected":false,"selected-rows":[],"fit-columns":"","auto-height":"auto-height"},on:{"removeRow":function (payload, success, fail) { return _vm.handleRemoveDivision(payload, success, fail); }}})],1)],_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[(this.$user.sessionSettings.CompanySettings.HasCostCenter && !this.$user.sessionSettings.CompanySettings.UseBusinessUnitAndCostCenterMapping)?_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"costCenters"}},[_vm._v("Cost Centers")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select a Cost Center","options":_vm.costCenters,"label":"Value","track-by":"Key","multiple":"","name":"cost_center"},on:{"open":_vm.getCostCenters},model:{value:(_vm.selectCostCenter),callback:function ($$v) {_vm.selectCostCenter=$$v},expression:"selectCostCenter"}})],1):_vm._e(),_vm._v(" "),(this.$user.sessionSettings.CompanySettings.HasBusinessUnit && !this.$user.sessionSettings.CompanySettings.UseBusinessUnitAndCostCenterMapping)?_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"businessUnit"}},[_vm._v("Business Units")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select a Business Unit","options":_vm.businessUnit,"label":"Value","track-by":"Key","multiple":"","name":"business_unit"},on:{"open":_vm.getBusinessUnit},model:{value:(_vm.selectBusinessUnit),callback:function ($$v) {_vm.selectBusinessUnit=$$v},expression:"selectBusinessUnit"}})],1):_vm._e()]),_vm._v(" "),(this.$user.sessionSettings.CompanySettings.UseBusinessUnitAndCostCenterMapping)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"businessUnitAndCostCenter"}},[_vm._v("Business Units and Cost Centers")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select a Business Unit and Cost Center","options":_vm.businessUnitAndCostCenter,"label":"Value","track-by":"Key","multiple":"","name":"BU_CC"},on:{"open":_vm.getBusinessUnitAndCostCenter},model:{value:(_vm.selectBusinessUnitAndCostCenter),callback:function ($$v) {_vm.selectBusinessUnitAndCostCenter=$$v},expression:"selectBusinessUnitAndCostCenter"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("First Name*")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"firstName","error":_vm.firstNameIncomplete,"placeholder":"First Name"},on:{"input":function (o) { _vm.user.FirstName = o; this$1.firstNameIncomplete = false; }},model:{value:(_vm.user.FirstName),callback:function ($$v) {_vm.$set(_vm.user, "FirstName", $$v)},expression:"user.FirstName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Last Name*")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"lastName","error":_vm.lastNameIncomplete,"placeholder":"Last Name"},on:{"input":function (o) { _vm.user.LastName = o; this$1.lastNameIncomplete = false; }},model:{value:(_vm.user.LastName),callback:function ($$v) {_vm.$set(_vm.user, "LastName", $$v)},expression:"user.LastName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"name","error":_vm.positionIncomplete,"placeholder":"Title"},on:{"input":function (o) { _vm.user.Position = o; this$1.positionIncomplete = false; }},model:{value:(_vm.user.Position),callback:function ($$v) {_vm.$set(_vm.user, "Position", $$v)},expression:"user.Position"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email*")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"email","error":_vm.emailIncomplete,"placeholder":"Email"},on:{"input":function (o) { _vm.user.Email = o; this$1.emailIncomplete = false; }},model:{value:(_vm.user.Email),callback:function ($$v) {_vm.$set(_vm.user, "Email", $$v)},expression:"user.Email"}}),_vm._v(" "),(_vm.emailError)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.emailError))]):_vm._e()],1),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_vm._v("Mobile Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('vue-country-code',{ref:"countryCodeComponent",staticClass:"dropdown",attrs:{"disabledFetchingCountry":true,"enabledCountryCode":true,"preferredCountries":['us', 'gb', 'cn']},on:{"onSelect":_vm.onCountrySelect}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('ed-input',{staticClass:"full-width",attrs:{"onlyNumbers":"","placeholder":"222 333 1234","error":_vm.mobilePhoneIncomplete},model:{value:(_vm.user.MobilePhoneNumber),callback:function ($$v) {_vm.$set(_vm.user, "MobilePhoneNumber", $$v)},expression:"user.MobilePhoneNumber"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.accountId === '')?_c('label',{attrs:{"for":"countries"}},[_vm._v(_vm._s(_vm.countriesName))]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"role"}},[_vm._v("Country")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select a Country","options":_vm.countries,"openEndpoint":_vm.api.$.profile.getAllCountries,"label":"CountryName","track-by":"CountryID","error":_vm.countryIncomplete,"helptip-header":_vm.doDisplayCountryError && 'Error' || '',"helptip-body":_vm.doDisplayCountryError && 'Please select a country' || '',"name":"country_user"},on:{"input":function (o) { _vm.addObjectUser.country  = o; this$1.countryIncomplete = false; },"select":function($event){return _vm.countrySelected($event)},"open":_vm.fetchCountriesOnOpen,"keyup":_vm.fetchCountries},model:{value:(_vm.formData.country),callback:function ($$v) {_vm.$set(_vm.formData, "country", $$v)},expression:"formData.country"}})],1),_vm._v(" "),_c('p',{staticClass:"bold"},[_vm._v("Notification Preferences")]),_vm._v(" "),_c('div',{staticClass:"form-group-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.TurnOffEmail),expression:"user.TurnOffEmail"}],attrs:{"type":"checkbox","id":"turnOffEmailCheckbox"},domProps:{"checked":Array.isArray(_vm.user.TurnOffEmail)?_vm._i(_vm.user.TurnOffEmail,null)>-1:(_vm.user.TurnOffEmail)},on:{"change":function($event){var $$a=_vm.user.TurnOffEmail,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "TurnOffEmail", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "TurnOffEmail", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "TurnOffEmail", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"small-checkbox",attrs:{"for":"turnOffEmailCheckbox"}},[_vm._v("Turn off all email communication")])]),_vm._v(" "),_c('div',{staticClass:"form-group-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.ReceiveAllRatings),expression:"user.ReceiveAllRatings"}],attrs:{"type":"checkbox","id":"copyRatingsCheckbox","disabled":_vm.user.TurnOffEmail},domProps:{"checked":Array.isArray(_vm.user.ReceiveAllRatings)?_vm._i(_vm.user.ReceiveAllRatings,null)>-1:(_vm.user.ReceiveAllRatings)},on:{"change":function($event){var $$a=_vm.user.ReceiveAllRatings,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "ReceiveAllRatings", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "ReceiveAllRatings", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "ReceiveAllRatings", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"small-checkbox",attrs:{"for":"copyRatingsCheckbox"}},[_vm._v("Copy on all ratings received (receive all rating e-mails received from users)")])]),_vm._v(" "),_c('div',{staticClass:"form-group-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.ReceiveAllAdmin),expression:"user.ReceiveAllAdmin"}],attrs:{"type":"checkbox","id":"copyAdminEmailsCheckbox","disabled":_vm.user.TurnOffEmail},domProps:{"checked":Array.isArray(_vm.user.ReceiveAllAdmin)?_vm._i(_vm.user.ReceiveAllAdmin,null)>-1:(_vm.user.ReceiveAllAdmin)},on:{"change":function($event){var $$a=_vm.user.ReceiveAllAdmin,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "ReceiveAllAdmin", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "ReceiveAllAdmin", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "ReceiveAllAdmin", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"small-checkbox",attrs:{"for":"copyAdminEmailsCheckbox"}},[_vm._v("Copy on all administration e-mails received (receive all e-mails currently being sent to the owner/administrator of this account)")])])],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iOUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedRows && _vm.selectedRows[0] && _vm.selectedRows[0].data)?_c('div',{staticClass:"content"},[_c('ed-title-nav',{staticClass:"title-nav",attrs:{"title":_vm.title}},[(!this.$user.$.userPermissions.includes('ApprovalDashboard'))?_c('span',{attrs:{"slot":"action"},slot:"action"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.envelope.FromDashboard || _vm.$route.query.IsApproveEnvelopeFromEmail=='true' || _vm.$route.query.IsRejectEnvelopeFromEmail=='true' ? (_vm.$emit('backToTransactions'), _vm.goToDashboard()) : _vm.$emit('backToTransactions')}}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("   "+_vm._s(_vm.$t('BACK') + ' ' + _vm.$t('TO') + ' ' + (_vm.envelope.FromDashboard || _vm.$route.query.IsApproveEnvelopeFromEmail=='true' || _vm.$route.query.IsRejectEnvelopeFromEmail=='true' ? _vm.$t('DASHBOARD') : (_vm.editEnvelope ? _vm.$t('ENVELOPES') : _vm.$t('TRANSACTIONS'))) + ' ' + _vm.$t(_vm.$route.query['back-to'])))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row content",attrs:{"slot":"overview"},slot:"overview"},[_c('div',{staticClass:"summary well small col-md-offset-6 col-md-6"},[_c('table',{staticClass:"col-md-12"},[_c('thead',[_c('tr',[_c('td',[_vm._v("Transactions")]),_vm._v(" "),_c('td',[_vm._v("Amount")])])]),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',[_vm._v("Transactions")]),_vm._v(" "),_c('td',[_vm._v("Amount")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('strong',[_vm._v(_vm._s(_vm.selectedRows.length))])]),_vm._v(" "),_c('td',[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.calculatedTotalAmount.toFixed(2)))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"clear"})])]),_vm._v(" "),_c('TheToolbar',{attrs:{"slot":"toolbar"},slot:"toolbar"},[(!_vm.readonly)?_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.preventCreateEnvelope},on:{"click":function($event){return _vm.createEnvelope(false)}}},[_vm._v("\n        SAVE DRAFT\n      ")]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('ed-button',{staticClass:"alt",attrs:{"button-class":"btn btn-actionbar","disabled":_vm.preventCreateEnvelope},on:{"click":function($event){return _vm.createEnvelope(true)}}},[_vm._v("\n        SUBMIT\n      ")]):_vm._e(),_vm._v(" "),(_vm.isApprover && _vm.readonly)?_c('ed-button',{staticClass:"alt",attrs:{"button-class":"btn btn-actionbar","disabled":_vm.preventCreateEnvelope},on:{"success":_vm.refresh,"click":_vm.validateBeforeApprove}},[_vm._v("\n        Approve\n      ")]):_vm._e(),_vm._v(" "),(_vm.isApprover && _vm.readonly)?_c('RejectEnvelope',{attrs:{"envelope":_vm.envelope,"disabled":_vm.preventCreateEnvelope},on:{"success":function($event){_vm.envelope.FromDashboard ? (_vm.$emit('backToTransactions'), _vm.goToDashboard()) : _vm.$emit('backToTransactions')}}}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"container-fluid",attrs:{"title":""}},[_c('ed-section',{staticClass:"page-section active clear"},[_c('div',{staticClass:"notice-alert-container"},[(_vm.receiptIncomplete && !_vm.hasIncompleteField)?_c('ed-notice',{staticClass:"notice-alert",attrs:{"type":"danger","message":"Please attach a receipt for every transaction.","icon":"fas fa-exclamation-triangle"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"reject-reason-container col-md-12"},[(_vm.rejectedStatuses.includes(_vm.envelope.EnvelopeStatus))?_c('ed-notice',{staticClass:"reject-reason-alert",attrs:{"type":"danger","icon":"fas fa-exclamation-triangle"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.rejectionMessage)}})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"notice-alert-container"},[((_vm.hasIncompleteField && !_vm.receiptIncomplete) || (_vm.hasIncompleteField && _vm.receiptIncomplete))?_c('ed-notice',{staticClass:"notice-alert",attrs:{"type":"danger","message":"Please complete all required fields","icon":"fas fa-exclamation-triangle"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"notice-alert-container"},[(_vm.hasWrongSplitTotal)?_c('ed-notice',{staticClass:"notice-alert",attrs:{"type":"danger","message":"Coding amounts must equal the transaction amount.","icon":"fas fa-exclamation-triangle"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"notice-alert-container"},[(_vm.hasDuplicates)?_c('ed-notice',{staticClass:"notice-alert",attrs:{"type":"danger","icon":"fas fa-exclamation-triangle"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.duplicateMessage)}})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 no-pad"},[_c('div',{staticClass:"col-md-12 no-pad"},[_c('h4',[_vm._v(_vm._s(_vm.envelopeTerm.singular)+" Information")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('table',{staticClass:"full-width-table small"},[_c('thead',[_c('tr',[_c('th',{staticClass:"col-md-2"},[_vm._v("Card Holder:")]),_vm._v(" "),_c('th',{staticClass:"col-md-2"},[_vm._v("Card Number:")]),_vm._v(" "),_c('th',{staticClass:"col-md-2"},[_vm._v("Production:")]),_vm._v(" "),_c('th',{staticClass:"col-md-2"},[_vm._v(_vm._s(_vm.programName)+":")]),_vm._v(" "),_c('th',{staticClass:"col-md-2"},[_vm._v(_vm._s(_vm.envelopeTerm.singular)+" No:")]),_vm._v(" "),_c('th',{staticClass:"col-md-2"},[_vm._v("Date:")]),_vm._v(" "),_c('th',{staticClass:"col-md-2"},[_vm._v("Status:")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"col-md-2"},[_vm._v(_vm._s(_vm.formatHolderLine(_vm.selectedRows[0].data)))]),_vm._v(" "),_c('td',{staticClass:"col-md-2"},[_vm._v(" *"+_vm._s(_vm.selectedRows[0].data.CardNumber))]),_vm._v(" "),_c('td',{staticClass:"col-md-2"},[_vm._v(_vm._s(_vm.selectedRows[0].data.Division))]),_vm._v(" "),_c('td',{staticClass:"col-md-2"},[_c('ed-select',{staticClass:"custom-dropdown",attrs:{"placeholder":("Select a " + (_vm.programName.toLowerCase()) + "..."),"options":_vm.programLoader.items,"track-by":"Id","checkboxes":false,"customLabel":function (option) { return option && option.Name ? (option.InternalProgramID ? ((option.Name) + " (" + (option.InternalProgramID) + ")") : option.Name) : ''; },"server-search":"","name":"program","error":_vm.programIncomplete,"disabled":!_vm.isApprover && _vm.readonly},on:{"open":_vm.onSelectProgramOpen,"search":_vm.onProgramSearch,"scroll-bottom":function () { return _vm.loadPrograms(false); },"input":_vm.handleProgramInput},model:{value:(_vm.selectedProgram),callback:function ($$v) {_vm.selectedProgram=$$v},expression:"selectedProgram"}})],1),_vm._v(" "),_c('td',{staticClass:"col-md-2"},[_vm._v(_vm._s(_vm.envelope && _vm.envelope.EnvelopeNumber || ''))]),_vm._v(" "),_c('td',{staticClass:"col-md-2"},[_vm._v("\n                  "+_vm._s(_vm.getDateFromFormatedDate(_vm.envelope && _vm.envelope.FormattedLastModifiedDate))+"\n                  "),_c('br'),_vm._v(" "),(_vm.draftSaved)?_c('span',{staticStyle:{"font-style":"italic","font-size":"smaller"}},[_vm._v("Draft Saved "+_vm._s(_vm.getTimeFromFormatedDate(_vm.envelope && _vm.envelope.FormattedLastModifiedDate)))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"col-md-2"},[_vm._v(_vm._s(_vm.envelope && _vm.envelope.EnvelopeStatus || ''))])])])])]),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Transactions")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 -scroll"},[_c('div',{staticClass:"table-container small",attrs:{"xstyle":"{ width: `${1140 + formFields.length * 50}px` }"}},[_c('div',{staticClass:"table-row header col-md-12 no-pad"},[_c('div',{staticClass:"col-md-6 no-pad"},[_c('div',{staticClass:"col-md-1 id-row"},[_c('strong',[_vm._v("#")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('strong',[_vm._v("Date")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Merchant")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 supplier-column"},[_c('strong',[_vm._v("Supplier")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 amount-column"},[_c('strong',[_vm._v("Amount")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 no-pad",attrs:{"xstyle":"extraColumnsStyle"}},[_c('div',{staticClass:"col-md-2"},[_c('strong',[_vm._v("Description")])]),_vm._v(" "),(_vm.hasBu && !_vm.hasBuAndCcPair)?_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Business Unit")])]):_vm._e(),_vm._v(" "),(_vm.hasCc && !_vm.hasBuAndCcPair)?_c('div',{class:("col-md-" + (_vm.hasBu ? 2 : 3))},[_c('strong',[_vm._v("Cost Center")])]):_vm._e(),_vm._v(" "),(_vm.hasBuAndCcPair)?_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("BU/CC")])]):_vm._e(),_vm._v(" "),_c('div',{class:("col-md-" + (_vm.hasBu && _vm.hasCc ? 3 : 4))},[_c('strong',[_vm._v("Category")])]),_vm._v(" "),_c('div',{class:("col-md-" + (_vm.hasBu && _vm.hasCc ? 2 : 3))},[_c('strong',[_vm._v("Category Ref ID")])])])]),_vm._v(" "),_vm._l((_vm.selectedRows),function(selectedRow,index){return _c('div',{key:index,staticClass:"col-md-12 no-pad",class:{ 'red-border': _vm.duplicateIndexesMap[index] !== undefined }},[_c('div',{staticClass:"col-md-6 no-pad"},[_c('div',{staticClass:"col-md-1 id-row"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_vm._v(_vm._s(_vm.formatDate(selectedRow.data.TransactionDate)))]),_vm._v(" "),_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(selectedRow.data.Merchant),expression:"selectedRow.data.Merchant",modifiers:{"bottom":true}}],staticClass:"col-md-3 column-overflow"},[_vm._v(_vm._s(selectedRow.data.Merchant))]),_vm._v(" "),_c('div',{staticClass:"col-md-3 supplier-column"},[_c('ed-select',{staticClass:"custom-dropdown-supplier inline",attrs:{"placeholder":_vm.getSupplierPlaceholder(index),"options":_vm.supplierOptions,"value":_vm.selectedSuppliers[index],"checkboxes":false,"customLabel":_vm.getLabel,"required":"","server-search":"","name":"supplier","error":_vm.supplierIncomplete[index],"disabled":true},on:{"open":_vm.fetchSuppliersOnOpen,"search":_vm.fetchSuppliers,"select":_vm.getSelectedSupplier,"input":function (option) { return _vm.handleSupplierSelection(option, index); }},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('ed-select-options',{attrs:{"thumbnails":""}},[_c('div',{staticClass:"option-combo-img",attrs:{"slot":"row1"},slot:"row1"},[_c('img',{attrs:{"slot":"image","src":props.option.Value.Logo,"width":"48"},slot:"image"})]),_vm._v(" "),_c('div',{staticClass:"no-wrap",attrs:{"slot":"row2"},slot:"row2"},[_c('span',{staticClass:"option-strong"},[_c('strong',[_vm._v(_vm._s(_vm.he.decode(props.option.Value.CompanyName))+" ")])]),_vm._v(" "),_c('em',{staticClass:"option-em"},[_vm._v("("+_vm._s(props.option.Value.Vci)+")")]),_vm._v(" "),_c('br'),_vm._v(" "),(props.option.Value.SupplierName)?_c('span',{staticClass:"option-bold"},[_vm._v(" "+_vm._s(_vm.he.decode(props.option.Value.SupplierName)))]):_vm._e(),_vm._v(" "),(props.option.Value.SupplierRequestedName)?_c('span',[_c('br'),_vm._v(" "),_c('i',[_vm._v(_vm._s(props.option.Value.SupplierRequestedName))])]):_vm._e(),_vm._v(" "),(props.option.Value.CountryName)?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"fas fa-map-marker-alt contact-icon"}),_vm._v("  "+_vm._s(props.option.Value.City + (props.option.Value.State != '' && props.option.Value.State != null ? ' ' + props.option.Value.State : (props.option.Value.Region != '' && props.option.Value.Region != null ? ' ' + props.option.Value.Region : '')) + ' ' + props.option.Value.CountryName)+"\n                          ")]):_vm._e(),_vm._v(" "),(props.option.Value.BusinessType)?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"fas fa-briefcase contact-icon"}),_vm._v("  "+_vm._s(props.option.Value.BusinessType)+"\n                          ")]):_vm._e(),_vm._v(" "),(props.option.Value.SupplierEmail)?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"fas fa-envelope contact-icon"}),_vm._v("  "+_vm._s(props.option.Value.SupplierEmail)+"\n                          ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(props.option.Value.IsEvedPay)?_c('span',{staticClass:"label supplier-evedpay"},[_vm._v("EvedPay Ready")]):_vm._e(),_vm._v(" "),(props.option.Value.VendorType)?_c('span',{staticClass:"label",class:[("supplier-type-" + (props.option.Value.VendorType))]},[_vm._v(_vm._s(props.option.Value.VendorType)+" Supplier")]):_vm._e()])])]}}],null,true),model:{value:(_vm.selectedSuppliers[index]),callback:function ($$v) {_vm.$set(_vm.selectedSuppliers, index, $$v)},expression:"selectedSuppliers[index]"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 amount-column"},[_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(selectedRow.data.Amount.toFixed(2)))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 no-pad description-col",attrs:{"xstyle":"extraColumnsStyle"}},[_c('div',{staticClass:"col-md-2 description-field"},[_c('ed-input',{staticClass:"description-textbox small",attrs:{"type":"text","error":_vm.descriptionIncomplete[index],"maxlength":"250","disabled":!_vm.isApprover && _vm.readonly},on:{"input":function($event){_vm.descriptionIncomplete[index] = false}},model:{value:(_vm.descriptions[index]),callback:function ($$v) {_vm.$set(_vm.descriptions, index, $$v)},expression:"descriptions[index]"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 remove-line"},[(_vm.selectedRows.length > 1 && (_vm.isApprover || !_vm.readonly))?_c('button',{staticClass:"remove-button",on:{"click":function($event){return _vm.removeTransaction(index)}}},[_c('i',{staticClass:"fas fa-times-circle"})]):_vm._e()])]),_vm._v(" "),_vm._l((selectedRow.form),function(row,rowIndex){return (_vm.form)?_c('div',{key:("form-row-" + index + "-" + rowIndex + "-" + (_vm.splitCounters[index])),staticClass:"table-row"},[_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"col-md-6 no-pad"},[_c('div',{staticClass:"col-md-1 id-row"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[(rowIndex != 0)?_c('span',[_vm._v("     ")]):_vm._e(),_vm._v(" "),(rowIndex == 0)?_c('AddReceipt',{attrs:{"rowData":selectedRow.data,"incomplete":_vm.attachmentIncomplete[index],"attachments":_vm.attachments[index],"documents":_vm.additionalDocuments[index],"disabled":!_vm.isApprover && _vm.readonly,"isDraft":_vm.envelope && _vm.envelope.EnvelopeStatus && _vm.envelope.EnvelopeStatus === 'Draft'},on:{"attachmentsUpdated":function (files) { return _vm.updateAttachmentsFiles(files, index); },"additional-documents-updated":function (docs) { return _vm.updateAdditionalDocuments(docs, index); },"receiptScan":function (payload) { return _vm.applyRowReceiptScan(index, payload); },"scan-started":function () { return _vm.setRowScanning(index, true); },"scan-ended":function () { return _vm.setRowScanning(index, false); }}}):_vm._e(),_vm._v("\n                       \n                      "),(_vm.isApprover || !_vm.readonly)?_c('a',{staticClass:"row-action",attrs:{"href":"javascript:;"},on:{"click":function($event){(!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) ? _vm.showWarningMessage() : _vm.toggleSplit(index, rowIndex, selectedRow)}}},[_vm._v("\n                        +Split\n                      ")]):_vm._e(),_vm._v("\n                       \n                      "),(_vm.isApprover || !_vm.readonly)?_c('a',{staticClass:"row-action",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.copySplit(row)}}},[_vm._v("\n                        Copy\n                      ")]):_vm._e(),_vm._v("\n                       \n                      "),(_vm.isApprover || !_vm.readonly)?_c('a',{staticClass:"row-action",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.pasteSplit(index, row)}}},[_vm._v("\n                        Paste\n                      ")]):_vm._e(),_vm._v("\n                       \n                      "),((_vm.isApprover || !_vm.readonly) && _vm.splitCounters[index] > 1)?_c('a',{staticClass:"row-action",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeSplit(index, rowIndex, selectedRow)}}},[_vm._v("\n                        Remove\n                      ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 amount-column"},[(_vm.scanningRows[index])?_c('span',{staticClass:"skeleton skeleton-line skeleton-amount-cell"}):_c('ed-input',{key:("amount-input-" + index + "-" + rowIndex + "-" + (_vm.splitCounters[index])),staticClass:"amount-input",attrs:{"amount":"","type":"money","error":_vm.wrongSplitTotal[index],"disabled":!_vm.isApprover && _vm.readonly},on:{"input":function($event){return _vm.handleSplitAmounts(index)}},model:{value:(row.Amount),callback:function ($$v) {_vm.$set(row, "Amount", $$v)},expression:"row.Amount"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 no-pad",attrs:{"xstyle":"extraColumnsStyle"}},[_c('div',{staticClass:"extra-row"},[_c('div',{staticClass:"col-md-2 split-description-field"},[(_vm.scanningRows[index])?_c('span',{staticClass:"skeleton skeleton-line skeleton-description"}):_c('ed-input',{staticClass:"description-textbox small",attrs:{"type":"text","placeholder":"Description...","maxlength":"250","disabled":!_vm.isApprover && _vm.readonly},model:{value:(row.Description),callback:function ($$v) {_vm.$set(row, "Description", $$v)},expression:"row.Description"}})],1),_vm._v(" "),(_vm.hasBu && !_vm.hasBuAndCcPair)?_c('div',{staticClass:"col-md-3"},[_c('ed-select',{directives:[{name:"tooltip",rawName:"v-tooltip",value:((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0)
                        ? ("Please select a " + (_vm.programName.toLowerCase()) + " first")
                        : _vm.businessUnits.length === 0
                          ? ("Please add Business Units to the selected " + (_vm.programName.toLowerCase()) + " before proceeding")
                          : ''),expression:"(!selectedProgram || Object.keys(selectedProgram).length === 0)\n                        ? `Please select a ${ programName.toLowerCase() } first`\n                        : businessUnits.length === 0\n                          ? `Please add Business Units to the selected ${ programName.toLowerCase() } before proceeding`\n                          : ''"}],staticClass:"custom-dropdown-supplier no-margin inline",attrs:{"placeholder":"Select a BU...","options":_vm.businessUnits,"value":row.BusinessUnit,"checkboxes":false,"label":"name","track-by":"businessUnitId","name":"bu","error":row.BusinessUnit == null && _vm.buIncomplete[index],"disabled":((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) || _vm.businessUnits.length === 0) || (!_vm.isApprover && _vm.readonly)},on:{"input":function (value) { return _vm.handleInput(index, rowIndex, 'BusinessUnit', value); }},model:{value:(row.BusinessUnit),callback:function ($$v) {_vm.$set(row, "BusinessUnit", $$v)},expression:"row.BusinessUnit"}})],1):_vm._e(),_vm._v(" "),(_vm.hasCc && !_vm.hasBuAndCcPair)?_c('div',{class:("col-md-" + (_vm.hasBu ? 2 : 3))},[_c('ed-select',{directives:[{name:"tooltip",rawName:"v-tooltip",value:((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0)
                        ? ("Please select a " + (_vm.programName.toLowerCase()) + " first")
                        : _vm.costCenters.length === 0
                          ? ("Please add Cost Centers to the selected " + (_vm.programName.toLowerCase()) + " before proceeding")
                          : ''),expression:"(!selectedProgram || Object.keys(selectedProgram).length === 0)\n                        ? `Please select a ${ programName.toLowerCase() } first`\n                        : costCenters.length === 0\n                          ? `Please add Cost Centers to the selected ${ programName.toLowerCase() } before proceeding`\n                          : ''"}],staticClass:"custom-dropdown-supplier inline",attrs:{"placeholder":"Select a CC...","options":_vm.costCenters,"value":row.CostCenter,"checkboxes":false,"custom-label":function (o) { return ((o.code) + " (" + (o.name) + ")"); },"track-by":"costCenterId","name":"cc","error":row.CostCenter == null && _vm.ccIncomplete[index],"disabled":((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) || _vm.costCenters.length === 0) || (!_vm.isApprover && _vm.readonly)},on:{"input":function (value) { return _vm.handleInput(index, rowIndex, 'CostCenter', value); }},model:{value:(row.CostCenter),callback:function ($$v) {_vm.$set(row, "CostCenter", $$v)},expression:"row.CostCenter"}})],1):_vm._e(),_vm._v(" "),(_vm.hasBuAndCcPair)?_c('div',{staticClass:"col-md-3"},[_c('ed-select',{directives:[{name:"tooltip",rawName:"v-tooltip",value:((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0)
                        ? ("Please select a " + (_vm.programName.toLowerCase()) + " first")
                        : _vm.buAndCcPairs.length === 0
                          ? ("Please add BUs & CCs to the selected " + (_vm.programName.toLowerCase()) + " before proceeding")
                          : ''),expression:"(!selectedProgram || Object.keys(selectedProgram).length === 0)\n                        ? `Please select a ${ programName.toLowerCase() } first`\n                        : buAndCcPairs.length === 0\n                          ? `Please add BUs & CCs to the selected ${ programName.toLowerCase() } before proceeding`\n                          : ''"}],staticClass:"custom-dropdown-supplier inline",attrs:{"placeholder":"Select BU & CC...","options":_vm.buAndCcPairs,"value":row.BuAndCcPair,"checkboxes":false,"label":"name","track-by":"programBusinessUnitAndCostCenterId","name":"pair","error":row.BuAndCcPair == null && _vm.buAndCcPairIncomplete[index],"disabled":((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) || _vm.buAndCcPairs.length === 0) || (!_vm.isApprover && _vm.readonly)},on:{"input":function (value) { return _vm.handleInput(index, rowIndex, 'BuAndCcPair', value); }},model:{value:(row.BuAndCcPair),callback:function ($$v) {_vm.$set(row, "BuAndCcPair", $$v)},expression:"row.BuAndCcPair"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"predicted-category-field",class:[("col-md-" + (_vm.hasBu && _vm.hasCc ? 3 : 4)), { 'has-predicted-coding-icon': _vm.allowPredictiveCoding && row.isPredicted && row.Category }]},[_c('ed-select',{directives:[{name:"tooltip",rawName:"v-tooltip",value:((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0)
                        ? ("Please select a " + (_vm.programName.toLowerCase()) + " first")
                        : _vm.categories.length === 0
                          ? ("Please assign Categories to the " + (_vm.divisionName.toLowerCase()) + " of the selected " + (_vm.programName.toLowerCase()) + " before proceeding")
                          : ''),expression:"(!selectedProgram || Object.keys(selectedProgram).length === 0)\n                        ? `Please select a ${programName.toLowerCase()} first`\n                        : categories.length === 0\n                          ? `Please assign Categories to the ${divisionName.toLowerCase()} of the selected ${ programName.toLowerCase() } before proceeding`\n                          : ''"}],staticClass:"custom-dropdown-supplier inline",attrs:{"placeholder":"Select a Category...","options":_vm.categories,"value":row.Category,"checkboxes":false,"track-by":"key","label":"text","name":"category","error":row.Category == null && _vm.categoryIncomplete[index],"disabled":((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) || _vm.categories.length === 0) || (!_vm.isApprover && _vm.readonly)},on:{"input":function (value) {
                        _vm.handleInput(index, rowIndex, 'Category', value)
                        row.ReferenceId = value !== null ? value.referenceId : null
                        _vm.$forceUpdate()
                      }},model:{value:(row.Category),callback:function ($$v) {_vm.$set(row, "Category", $$v)},expression:"row.Category"}}),_vm._v(" "),(_vm.allowPredictiveCoding && row.isPredicted && row.Category)?_c('span',{staticClass:"predicted-coding-icon-container"},[_c('predicted-coding-icon')],1):_vm._e()],1),_vm._v(" "),_c('div',{class:("col-md-" + (_vm.hasBu && _vm.hasCc ? 2 : 3))},[_c('ed-input',{directives:[{name:"tooltip",rawName:"v-tooltip",value:((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0)
                        ? ("Please select a " + (_vm.programName.toLowerCase()) + " first")
                        : _vm.categories.length === 0
                          ? ("Please assign Categories to the " + (_vm.divisionName.toLowerCase()) + " of the selected " + (_vm.programName.toLowerCase()) + " before proceeding")
                          : !row.Category ? "Please select a category first" : ''),expression:"(!selectedProgram || Object.keys(selectedProgram).length === 0)\n                        ? `Please select a ${ programName.toLowerCase() } first`\n                        : categories.length === 0\n                          ? `Please assign Categories to the ${ divisionName.toLowerCase() } of the selected ${ programName.toLowerCase() } before proceeding`\n                          : !row.Category ? `Please select a category first` : ''"}],staticClass:"small-input",attrs:{"placeholder":"Category Ref ID...","value":row.ReferenceId,"disabled":((!_vm.selectedProgram || Object.keys(_vm.selectedProgram).length === 0) || _vm.categories.length === 0 || !row.Category) || (!_vm.isApprover && _vm.readonly),"maxlength":"50"},on:{"input":function (value) { return _vm.handleInput(index, rowIndex, 'ReferenceId', value); }},model:{value:(row.ReferenceId),callback:function ($$v) {_vm.$set(row, "ReferenceId", $$v)},expression:"row.ReferenceId"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"table-row"},[(_vm.formFields && _vm.formFields.length > 0)?_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"col-md-12"},_vm._l((_vm.formFields),function(field,index){return _c('div',{key:index,class:['no-pad', field.Type === 'select' ? 'col-md-2' : 'col-md-1']},[_c('span',[_vm._v(_vm._s(field.Label))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.formFields && _vm.formFields.length > 0)?_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"col-md-12"},_vm._l((row),function(field,fieldIndex){return _c('div',{class:['no-pad', field.Type === 'select' ? 'col-md-2' : 'col-md-1']},[(field.Type !== 'select')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(field.Values),expression:"field.Values"}],staticClass:"form-control",class:{ 'input-error': _vm.isCustomFieldInvalid(field, index) },attrs:{"type":"text","maxlength":"200","disabled":!_vm.isApprover && _vm.readonly},domProps:{"value":(field.Values)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(field, "Values", $event.target.value)}}}):_vm._e(),_vm._v(" "),(field.Type === 'select')?_c('ed-select',{class:['custom-field-dropdown', { 'input-error': _vm.isCustomFieldInvalid(field, index) }],attrs:{"placeholder":((field.Label) + "..."),"options":_vm.customOptions[field.Key],"track-by":"value","checkboxes":false,"label":"text","name":"program"},model:{value:(field.Values),callback:function ($$v) {_vm.$set(field, "Values", $$v)},expression:"field.Values"}}):_vm._e()],1)}),0)]):_vm._e()])]):_vm._e()})],2)})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 no-pad"},[_c('p',{staticClass:"total-amount"},[_vm._v("Total amount: "),_c('v-money',{attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.calculatedTotalAmount.toFixed(2)))])],1),_vm._v(" "),(_vm.isApprover || !_vm.readonly)?_c('AddTransaction',{attrs:{"selectedRows":_vm.selectedRows,"selectedProgram":_vm.selectedProgram,"envelopeId":_vm.envelope && _vm.envelope.Id,"envelopeTerm":_vm.envelopeTerm.lower},on:{"transaction":_vm.handleTransaction}}):_vm._e()],1),_vm._v(" "),_c('hr'),_vm._v(" "),((_vm.Approvers && _vm.Approvers.length > 0) || (_vm.ApprovalNeeded && _vm.ApprovalNeeded.length > 0) || _vm.canResubmit)?_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Approval")]),_vm._v(" "),((_vm.Approvers && _vm.Approvers.length > 0) || (_vm.ApprovalNeeded && _vm.ApprovalNeeded.length > 0))?_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',{staticClass:"col-md-2",staticStyle:{"width":"20%"}},[_vm._v("Approval:")]),_vm._v(" "),_c('th',{staticClass:"col-md-2",staticStyle:{"width":"20%"}},[_vm._v("When:")]),_vm._v(" "),_c('th',{staticClass:"col-md-5",staticStyle:{"width":"40%"}},[_vm._v("Approver:")]),_vm._v(" "),_c('th',{staticClass:"col-md-3",staticStyle:{"width":"20%"}},[_vm._v("Reason:")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.priorRoundApprovers),function(approver,hi){return _c('tr',{key:'hist-' + hi,staticClass:"approval-history-row"},[(!approver.Reason)?_c('td',{staticClass:"col-md-2"},[_c('i',{staticClass:"fas fa-check-circle approval-icon-approved"}),_vm._v("Approved")]):_vm._e(),_vm._v(" "),(approver.Reason)?_c('td',{staticClass:"col-md-2"},[_c('i',{staticClass:"fas fa-times-circle approval-icon-declined"}),_vm._v("Declined")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"col-md-2"},[_vm._v(_vm._s(_vm.formatDate(approver.CreatedDate)))]),_vm._v(" "),_c('td',{staticClass:"col-md-5"},[_vm._v(_vm._s(approver.User.Name))]),_vm._v(" "),(approver.Reason)?_c('td',{staticClass:"col-md-3"},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Click to see decline reason'),expression:"'Click to see decline reason'"}],staticStyle:{"margin-bottom":"10px"},attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fas fa-book",staticStyle:{"color":"red"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleReasonClick(approver)}}})])]):_vm._e()])}),_vm._v(" "),(_vm.hasResubmitHistory)?_c('tr',{staticClass:"resubmit-divider-row"},[_c('td',{attrs:{"colspan":"4"}},[_c('i',{staticClass:"fas fa-sync"}),_vm._v(" Approval process resubmitted"),(_vm.resubmitDividerDate)?[_vm._v(" · "+_vm._s(_vm.resubmitDividerDate))]:_vm._e()],2)]):_vm._e(),_vm._v(" "),_vm._l((_vm.currentRoundApprovers),function(approver,ci){return _c('tr',{key:'cur-' + ci},[(!approver.Reason)?_c('td',{staticClass:"col-md-2"},[_c('i',{staticClass:"fas fa-check-circle approval-icon-approved"}),_vm._v("Approved")]):_vm._e(),_vm._v(" "),(approver.Reason)?_c('td',{staticClass:"col-md-2",staticStyle:{"color":"red"}},[_c('i',{staticClass:"fas fa-times-circle approval-icon-declined"}),_vm._v("Declined")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"col-md-2"},[_vm._v(_vm._s(_vm.formatDate(approver.CreatedDate)))]),_vm._v(" "),_c('td',{staticClass:"col-md-5"},[_vm._v(_vm._s(approver.User.Name))]),_vm._v(" "),(approver.Reason)?_c('td',{staticClass:"col-md-3"},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Click to see decline reason'),expression:"'Click to see decline reason'"}],staticStyle:{"margin-bottom":"10px"},attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fas fa-book",staticStyle:{"color":"red"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleReasonClick(approver)}}})])]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.pendingApprovalRows),function(row,pi){return _c('tr',{key:'pend-' + pi},[_c('td',{staticClass:"col-md-2"},[(row.status === 'In Review')?[_c('i',{staticClass:"fas fa-clock approval-icon-inreview"}),_c('span',{staticClass:"approval-inreview-text"},[_vm._v("In Review")])]:[_c('i',{staticClass:"fas fa-clock approval-icon-pending"}),_c('span',{staticStyle:{"font-style":"italic"}},[_vm._v("Pending...")])]],2),_vm._v(" "),_c('td',{staticClass:"col-md-2"},[_vm._v(_vm._s(_vm.formatDate(row.createdDate)))]),_vm._v(" "),_c('td',{staticClass:"col-md-5"},[(row.isGroup)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.showApproversDialog = true}}},[_vm._v(_vm._s(row.name))]):[_vm._v(_vm._s(row.name))]],2),_vm._v(" "),_c('td',{staticClass:"col-md-3"})])})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{staticStyle:{"border-top":"1px solid #dee2e6"},attrs:{"colspan":"4"}})])])]):_vm._e(),_vm._v(" "),(_vm.envelope && _vm.waitingApprovalStatuses.includes(_vm.envelope.EnvelopeStatus))?_c('ed-button',{staticClass:"alt",attrs:{"button-class":"btn btn-actionbar","disabled":_vm.isResendButtonDisabled},on:{"click":_vm.handleResend}},[_vm._v("\n          RESEND\n        ")]):_vm._e(),_vm._v(" "),(_vm.resendMessage)?_c('span',{staticClass:"resend-message"},[_vm._v(_vm._s(_vm.resendMessage))]):_vm._e(),_vm._v(" "),(_vm.canResubmit)?_c('ed-button',{staticClass:"alt",attrs:{"button-class":"btn btn-actionbar","disabled":_vm.resubmitting},on:{"click":function($event){_vm.showResubmitDialog = true}}},[_c('i',{staticClass:"fas fa-sync"}),_vm._v(" RESUBMIT APPROVAL\n        ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"}),_vm._v(" "),(!_vm.readonly)?_c('ed-button',{staticClass:"alt",attrs:{"button-class":"btn centered-submit","disabled":_vm.preventCreateEnvelope},on:{"click":function($event){return _vm.createEnvelope(true)}}},[_vm._v("\n        SUBMIT\n      ")]):_vm._e(),_vm._v(" "),(_vm.isApprover && _vm.readonly)?_c('div',{staticClass:"centered-approval"},[_c('ed-button',{staticClass:"alt",attrs:{"button-class":"btn btn-actionbar bigger","disabled":_vm.preventCreateEnvelope},on:{"success":_vm.refresh,"click":_vm.validateBeforeApprove}},[_vm._v("\n          Approve\n        ")]),_vm._v(" "),_c('RejectEnvelope',{attrs:{"envelope":_vm.envelope,"disabled":_vm.preventCreateEnvelope},on:{"success":function($event){_vm.envelope.FromDashboard ? (_vm.$emit('backToTransactions'), _vm.goToDashboard()) : _vm.$emit('backToTransactions')}}})],1):_vm._e()],1)],1),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Caution","show":_vm.showAlertProgram,"primary-button":'YES',"secondary-button":'NO'},on:{"close":function($event){_vm.showAlertProgram = false, _vm.selectedProgram = _vm.programConfirmPressed ? _vm.programOption : _vm.previousSelectedProgram, _vm.programConfirmPressed = false},"confirm":function($event){_vm.handleProgramChange(_vm.programOption), _vm.programConfirmPressed = true}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Changing the "+_vm._s(_vm.programName)+" will delete all the split items. Are you sure you want to change the it?")])])]),_vm._v(" "),(_vm.envelope && _vm.waitingApprovalStatuses.includes(_vm.envelope.EnvelopeStatus))?_c('ApproveDialog',{attrs:{"showModal":_vm.showApproveDialog,"list":_vm.transformRows(_vm.envelope),"programLabel":_vm.programLabel,"loading":_vm.isApproving,"envelopeApproval":""},on:{"approve":_vm.doApprove,"close":function () { _vm.showApproveDialog = false }}}):_vm._e(),_vm._v(" "),_c('ed-modal',{attrs:{"title":((_vm.envelopeTerm.singular) + " Decline Reason"),"show":_vm.showEnvelopeRejectInfo,"primary-button":"Close","secondary-button":"false"},on:{"close":function($event){_vm.showEnvelopeRejectInfo = false}}},[_c('EnvelopeRejectInfo',{attrs:{"slot":"body","rejectionReason":_vm.rejectionReason},slot:"body"})],1),_vm._v(" "),_c('ed-modal',{attrs:{"title":" ","show":_vm.showResubmitDialog,"primary-button":"Resubmit Approval","secondary-button":"Cancel","type":"small-medium","primary-button-disabled":_vm.resubmitting},on:{"confirm":_vm.resubmitEnvelope,"close":function($event){_vm.showResubmitDialog = false}}},[_c('div',{staticClass:"resubmit-modal-body",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"resubmit-modal-title"},[_c('i',{staticClass:"fas fa-exclamation-circle resubmit-warn-icon"}),_vm._v("Resubmit this "+_vm._s(_vm.envelopeTerm.lower)+" for approval?\n      ")]),_vm._v(" "),_c('p',{staticClass:"resubmit-modal-intro"},[_vm._v("\n        This restarts the approval workflow from the "),_c('b',[_vm._v("first approver")]),_vm._v(" — it does not send the\n        "+_vm._s(_vm.envelopeTerm.lower)+" back to the submitter. Use this after an approval rule changed or if it was declined\n        by mistake.\n      ")]),_vm._v(" "),_c('div',{staticClass:"resubmit-points"},[_c('div',{staticClass:"resubmit-point"},[_c('i',{staticClass:"fas fa-sync rp-icon"}),_vm._v(" "),_c('span',[_vm._v("A fresh approval round starts at "),_c('b',[_vm._v("the first approver group")])])]),_vm._v(" "),_c('div',{staticClass:"resubmit-point"},[_c('i',{staticClass:"fas fa-clock rp-icon"}),_vm._v(" "),_c('span',[_vm._v("Previous decisions are kept in the approval history")])]),_vm._v(" "),_c('div',{staticClass:"resubmit-point"},[_c('i',{staticClass:"fas fa-check-circle rp-icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.envelopeTerm.singular)+" stays "),_c('b',[_vm._v("Submitted")]),_vm._v(" — no edits required")])]),_vm._v(" "),_c('div',{staticClass:"resubmit-point"},[_c('i',{staticClass:"fas fa-comment rp-icon"}),_vm._v(" "),_c('span',[_vm._v("All approvers are requested again")])])])])]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Approvers List","show":_vm.showApproversDialog,"primary-button":"Close","secondary-button":"false"},on:{"confirm":function($event){_vm.showApproversDialog = false},"close":function($event){_vm.showApproversDialog = false}}},[_c('div',{staticClass:"approvers-list-modal",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("The following is a list of all designated approvers.")]),_vm._v(" "),_c('h5',[_vm._v("Assigned Approvers")]),_vm._v(" "),_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Name:")]),_c('th',[_vm._v("Email:")]),_c('th',[_vm._v("Phone:")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.currentThresholdApprovers),function(u,i){return _c('tr',{key:'assigned-' + i},[_c('td',[_vm._v(_vm._s(u.Name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(u.Email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(u.Phone))])])}),0)]),_vm._v(" "),(_vm.nextThresholdApprovers.length)?[_c('h5',[_vm._v("Next Assigned Approvers")]),_vm._v(" "),_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Name:")]),_c('th',[_vm._v("Email:")]),_c('th',[_vm._v("Phone:")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.nextThresholdApprovers),function(u,i){return _c('tr',{key:'next-' + i},[_c('td',[_vm._v(_vm._s(u.Name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(u.Email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(u.Phone))])])}),0)])]:_vm._e()],2)]),_vm._v(" "),_c('RejectDialog',{attrs:{"showModal":_vm.showRejectDialog,"list":_vm.transformRows(_vm.envelope),"rejectText":'Decline',"programLabel":_vm.programLabel,"divisionLabel":_vm.divisionLabel,"submitEndpoint":_vm.submitEndpoint},on:{"reject":_vm.doReject,"close":function () { _vm.showRejectDialog = false }}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iXO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_details__ = __webpack_require__("weJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_Programs_Card_cards_CardStatus_vue__ = __webpack_require__("SLRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Programs_Card_cards_CardHolder_vue__ = __webpack_require__("rMOU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Grid_cells_actions__ = __webpack_require__("ayPo");




/* harmony default export */ __webpack_exports__["a"] = ({
  'CardNumber': {
    label: 'Card Number',
    compose: maskedCardNumber,
    width: 100
  },
  'Holder': {
    label: 'Card Holder',
    render: __WEBPACK_IMPORTED_MODULE_2__components_modules_Programs_Card_cards_CardHolder_vue__["a" /* default */],
    width: 120
  },
  NameOnCard: '_',
  'CardStatus': {
    label: 'Status',
    source: 'CardList',
    render: __WEBPACK_IMPORTED_MODULE_1__components_modules_Programs_Card_cards_CardStatus_vue__["a" /* default */],
    width: 120
  },
  'WaitingApproval': {
    label: 'Waiting Approval',
    details: 'local',
    detailsCondition: showAttachmentsExpandIcon,
    detailsParamsURL: getAttachmentsDetailsParams,
    detailsComp: __WEBPACK_IMPORTED_MODULE_0__attachments_details__["a" /* default */],
    width: 140
  },
  'Division': {
    label: 'Division',
    getter: getDivisionLink,
    width: 140
  },
  'Spent': {
    label: 'Spent',
    type: 'money',
    f: 'data.Spent',
    width: 120
  },
  'Balance': {
    label: 'Balance',
    type: 'money',
    f: 'data.Balance',
    width: 120
  },
  'InitialLoad': {
    label: 'Initial Load',
    type: 'money',
    f: 'data.InitialLoad',
    width: 120
  },
  'Refills': {
    label: 'Refills',
    type: 'money',
    f: 'data.Refills',
    width: 120
  },
  'Pending': {
    label: 'Pending Request',
    type: 'money',
    f: 'data.Pending',
    width: 120
  },
  'ReturnedAmount': {
    label: 'Return to Acct',
    type: 'money',
    f: 'data.ReturnedAmount',
    width: 130
  },
  AccountId: '_'
});
function maskedCardNumber(card) {
  if (card && card.data && card.data.CardNumber) {
    return '****' + card.data.CardNumber;
  } else {
    return '****';
  }
}
function showAttachmentsExpandIcon(params) {
  return parseInt(params.data.WaitingApproval) > 0;
}
function getAttachmentsDetailsParams(params) {
  return "?cardId=".concat(params.data.Id);
}
function getDivisionLink(params) {
  if (params && params.data && params.data.AccountId) {
    params.node.uri = params.colDef.uri = "#/d/Programs/>Card/list?AccountId=".concat(params.data.AccountId);
    params.value = params.data.Division;
    params.noTooltip = true;
    return __WEBPACK_IMPORTED_MODULE_3__components_Grid_cells_actions__["f" /* gotoCustom */].template(params);
  } else {
    return '';
  }
}

/***/ }),

/***/ "ilgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__ = __webpack_require__("X3jq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_Programs_Card_transactions_CandidateSelector_vue__ = __webpack_require__("jTz+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpayreceiptfolder',
  components: {
    CandidateSelector: __WEBPACK_IMPORTED_MODULE_4__components_modules_Programs_Card_transactions_CandidateSelector_vue__["a" /* default */]
  },
  data: function data() {
    return {
      featureFlags: __WEBPACK_IMPORTED_MODULE_2__core_feature_flags_feature_flags__["a" /* default */],
      receipts: null,
      imageUrlCache: {},
      isLoading: false,
      isRefreshing: false,
      isLoadingMore: false,
      currentPage: 1,
      pageSize: 25,
      totalPages: 1,
      hasMorePages: false,
      dateFormat: null,
      isMobile: false,
      lastRefreshTime: null,
      // Sort selection — 'UploadedAt' (CreatedAt desc) or 'TransactionDate' (OCR receipt date desc).
      // Maps to SearchReceiptsQuery.OrderBy on the server. Mobile-only control.
      sortBy: 'UploadedAt',
      // Candidate Selector state
      showCandidateSelector: false,
      selectedReceiptId: null,
      selectorCandidates: [],
      selectorRowVersion: null,
      selectorAutoLinked: false,
      // Delete confirmation state
      showDeleteConfirm: false,
      deleteTargetReceipt: null,
      // Pull-to-refresh state
      pullStartY: 0,
      pullDistance: 0,
      isPulling: false,
      // Swipe-to-delete state
      swipeStartX: 0,
      swipedRowId: null,
      swipeOffset: 0,
      // Highlight state
      highlightedReceiptId: null
    };
  },
  computed: {
    moment: function moment() {
      return global.moment;
    }
  },
  created: function created() {
    this.detectMobile();
    this.initializeData();
    window.addEventListener('resize', this.detectMobile);
    if (this.$route.query.highlight) {
      this.highlightedReceiptId = this.$route.query.highlight;
    }
  },
  mounted: function mounted() {
    if (this.isMobile) {
      this.$nextTick(this.setupInfiniteScroll);
    }
    if (this.highlightedReceiptId) {
      var self = this;
      this.$nextTick(function () {
        var el = document.querySelector('.receipt-row.is-highlighted');
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
        setTimeout(function () {
          self.highlightedReceiptId = null;
        }, 2500);
      });
    }
  },
  updated: function updated() {
    if (this.isMobile && this._infiniteObserver && this.$refs.infiniteScrollTrigger) {
      this._infiniteObserver.observe(this.$refs.infiniteScrollTrigger);
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.detectMobile);
    if (this._infiniteObserver) {
      this._infiniteObserver.disconnect();
    }
  },
  methods: {
    detectMobile: function detectMobile() {
      this.isMobile = global.config && global.config.layout === 'mobile';
    },
    initializeData: function initializeData() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchReceipts();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    _loadPage: function _loadPage(page) {
      var _arguments = arguments,
        _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, _ref$append, append, filters, result, items, totalCount;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref$append = _ref.append, append = _ref$append === void 0 ? false : _ref$append;
              // The folder lists only the current user's own receipts (PRODUCTDEV-5783) —
              // scoped server-side, no admin widening.
              filters = {
                status: 'FolderSaved'
              }; // orderBy/sortDirection map to SearchReceiptsQuery.OrderBy / SortDirection. Mobile-only:
              // desktop deliberately sends NO orderBy so its ordering stays exactly as Tudor's (the
              // server's omitted-orderBy default), independent of the mobile sort control.
              if (_this2.isMobile) {
                filters.orderBy = _this2.sortBy;
                filters.sortDirection = 'desc';
              }
              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].searchReceipts(filters, page, _this2.pageSize);
            case 5:
              result = _context2.sent;
              items = result.items || [];
              _this2.receipts = append ? _this2.receipts.concat(items) : items;
              _this2.currentPage = page;
              totalCount = result.totalCount || 0;
              _this2.totalPages = Math.ceil(totalCount / _this2.pageSize) || 1;
              _this2.hasMorePages = _this2.currentPage < _this2.totalPages;
              _this2._loadThumbnails(items);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    _loadThumbnails: function _loadThumbnails(items) {
      var self = this;
      items.forEach(function (receipt) {
        var id = receipt && receipt.receiptScanId;
        if (!id || self.imageUrlCache[id]) return;
        __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getImage(id).then(function (res) {
          if (res && res.presignedUrl) {
            self.$set(self.imageUrlCache, id, res.presignedUrl);
          }
        }).catch(function () {/* missing thumb falls back to icon */});
      });
    },
    // Presigned-URL expiry (~15 min) and CORS-blocked fetches both surface as <img> error.
    // Evict the cached URL so v-else falls through to the receipt icon instead of a broken image.
    onThumbnailError: function onThumbnailError(receipt) {
      var id = receipt && receipt.receiptScanId;
      if (!id) return;
      this.$set(this.imageUrlCache, id, null);
    },
    fetchReceipts: function fetchReceipts() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.isLoading = true;
              _context3.prev = 1;
              _context3.next = 4;
              return _this3._loadPage(_this3.currentPage);
            case 4:
              _this3.lastRefreshTime = new Date();
              _context3.next = 12;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);
              console.error('Error fetching receipts:', _context3.t0);
              _this3.receipts = _this3.receipts || [];
              _this3.$notifications.notify({
                type: 'danger',
                message: 'Failed to load receipts',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            case 12:
              _context3.prev = 12;
              _this3.isLoading = false;
              return _context3.finish(12);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 7, 12, 15]]);
      }))();
    },
    handleRefresh: function handleRefresh() {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this4.isRefreshing = true;
              _this4.currentPage = 1;
              _context4.prev = 2;
              _context4.next = 5;
              return _this4.fetchReceipts();
            case 5:
              _this4.$notifications.notify({
                type: 'success',
                message: 'Receipts refreshed',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            case 6:
              _context4.prev = 6;
              _this4.isRefreshing = false;
              return _context4.finish(6);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2,, 6, 9]]);
      }))();
    },
    setupInfiniteScroll: function setupInfiniteScroll() {
      var self = this;
      this._infiniteObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && self.hasMorePages && !self.isLoadingMore) {
            self.loadMoreReceipts();
          }
        });
      });
      if (this.$refs.infiniteScrollTrigger) {
        this._infiniteObserver.observe(this.$refs.infiniteScrollTrigger);
      }
    },
    loadMoreReceipts: function loadMoreReceipts() {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.isLoadingMore = true;
              _context5.prev = 1;
              _context5.next = 4;
              return _this5._loadPage(_this5.currentPage + 1, {
                append: true
              });
            case 4:
              _context5.next = 9;
              break;
            case 6:
              _context5.prev = 6;
              _context5.t0 = _context5["catch"](1);
              console.error('Error loading more receipts:', _context5.t0);
            case 9:
              _context5.prev = 9;
              _this5.isLoadingMore = false;
              return _context5.finish(9);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[1, 6, 9, 12]]);
      }))();
    },
    goToPage: function goToPage(page) {
      this.currentPage = page;
      this.fetchReceipts();
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return 'N/A';
      this.dateFormat = this.$user && this.$user.sessionSettings && this.$user.sessionSettings.DateAndTimeFormats && this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat ? this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat : 'MM-DD-YYYY';
      try {
        return this.moment(dateStr).format(this.dateFormat);
      } catch (e) {
        return dateStr;
      }
    },
    // The folder only lists the user's own receipts, so they can always claim/delete.
    canMutateReceipt: function canMutateReceipt(receipt) {
      return !!receipt;
    },
    readOnlyTooltip: function readOnlyTooltip() {
      return '';
    },
    handleClaim: function handleClaim(receipt) {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee6() {
        var statusData, candidates, refreshed, freshStatus, freshCandidates;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getStatus(receipt.receiptScanId);
            case 3:
              statusData = _context6.sent;
              candidates = statusData.matchCandidates || statusData.candidates || []; // Single auto-linked match — bypass selector and navigate directly
              if (!(statusData.autoLinked && candidates.length === 1)) {
                _context6.next = 8;
                break;
              }
              _this6.$router.push({
                path: '/evedpay/transactiondetails',
                query: {
                  transactionid: candidates[0].legacyTransactionId
                }
              });
              return _context6.abrupt("return");
            case 8:
              _this6.selectedReceiptId = receipt.receiptScanId;
              _this6.selectorCandidates = candidates;
              _this6.selectorRowVersion = statusData.rowVersion;
              _this6.selectorAutoLinked = statusData.autoLinked || false;
              _this6.showCandidateSelector = true;
              _context6.next = 48;
              break;
            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](0);
              if (!(_context6.t0.response && _context6.t0.response.status === 403)) {
                _context6.next = 22;
                break;
              }
              _this6.$notifications.notify({
                type: 'danger',
                message: 'You no longer have access to this receipt',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _this6.$router.push('/evedpay/receiptfolder');
              _context6.next = 48;
              break;
            case 22:
              if (!(_context6.t0.response && _context6.t0.response.status === 409)) {
                _context6.next = 47;
                break;
              }
              _this6.$notifications.notify({
                type: 'warning',
                message: 'Receipt state changed — pick again',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _context6.next = 26;
              return _this6.fetchReceipts();
            case 26:
              refreshed = _this6.receipts && _this6.receipts.find(function (r) {
                return r.receiptScanId === receipt.receiptScanId;
              });
              if (!refreshed) {
                _context6.next = 45;
                break;
              }
              _context6.prev = 28;
              _context6.next = 31;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].getStatus(receipt.receiptScanId);
            case 31:
              freshStatus = _context6.sent;
              freshCandidates = freshStatus.matchCandidates || freshStatus.candidates || []; // Single auto-linked match — bypass selector and navigate directly
              if (!(freshStatus.autoLinked && freshCandidates.length === 1)) {
                _context6.next = 36;
                break;
              }
              _this6.$router.push({
                path: '/evedpay/transactiondetails',
                query: {
                  transactionid: freshCandidates[0].legacyTransactionId
                }
              });
              return _context6.abrupt("return");
            case 36:
              _this6.selectedReceiptId = receipt.receiptScanId;
              _this6.selectorCandidates = freshCandidates;
              _this6.selectorRowVersion = freshStatus.rowVersion;
              _this6.selectorAutoLinked = freshStatus.autoLinked || false;
              _this6.showCandidateSelector = true;
              _context6.next = 45;
              break;
            case 43:
              _context6.prev = 43;
              _context6.t1 = _context6["catch"](28);
            case 45:
              _context6.next = 48;
              break;
            case 47:
              _this6.$notifications.notify({
                type: 'danger',
                message: 'Failed to load candidate transactions',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            case 48:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 15], [28, 43]]);
      }))();
    },
    handleClaimSelected: function handleClaimSelected(event) {
      this.closeCandidateSelector();
      this.$router.push({
        path: '/evedpay/transactiondetails',
        query: {
          transactionid: event.legacyTransactionId
        }
      });
    },
    handleClaimError: function handleClaimError(event) {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee7() {
        var receiptId;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(event.status === 403)) {
                _context7.next = 5;
                break;
              }
              _this7.closeCandidateSelector();
              _this7.$router.push('/evedpay/receiptfolder');
              _context7.next = 15;
              break;
            case 5:
              if (!(event.status === 409)) {
                _context7.next = 14;
                break;
              }
              receiptId = _this7.selectedReceiptId;
              _this7.closeCandidateSelector();
              _context7.next = 10;
              return _this7.fetchReceipts();
            case 10:
              _context7.next = 12;
              return _this7.handleClaim({
                receiptScanId: receiptId
              });
            case 12:
              _context7.next = 15;
              break;
            case 14:
              _this7.closeCandidateSelector();
            case 15:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    handleSaveToFolder: function handleSaveToFolder() {
      this.closeCandidateSelector();
      this.fetchReceipts();
    },
    closeCandidateSelector: function closeCandidateSelector() {
      this.showCandidateSelector = false;
      this.selectedReceiptId = null;
      this.selectorCandidates = [];
      this.selectorRowVersion = null;
      this.selectorAutoLinked = false;
    },
    handleDelete: function handleDelete(receipt) {
      this.deleteTargetReceipt = receipt;
      this.showDeleteConfirm = true;
    },
    confirmDelete: function confirmDelete() {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee8() {
        var receiptId;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (_this8.deleteTargetReceipt) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return");
            case 2:
              receiptId = _this8.deleteTargetReceipt.receiptScanId;
              _this8.closeDeleteConfirm();
              _context8.prev = 4;
              _context8.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__core_api_receiptScans__["b" /* default */].deleteReceipt(receiptId);
            case 7:
              // Remove row from list
              _this8.receipts = _this8.receipts.filter(function (r) {
                return r.receiptScanId !== receiptId;
              });
              _this8.$notifications.notify({
                type: 'success',
                message: 'Receipt deleted',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _context8.next = 20;
              break;
            case 11:
              _context8.prev = 11;
              _context8.t0 = _context8["catch"](4);
              if (!(_context8.t0.response && _context8.t0.response.status === 409)) {
                _context8.next = 19;
                break;
              }
              // Receipt is no longer in folder, refresh list
              _this8.$notifications.notify({
                type: 'warning',
                message: 'Receipt is no longer in your folder',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _context8.next = 17;
              return _this8.fetchReceipts();
            case 17:
              _context8.next = 20;
              break;
            case 19:
              if (_context8.t0.response && _context8.t0.response.status === 403) {
                _this8.$notifications.notify({
                  type: 'danger',
                  message: "You can't delete this receipt",
                  placement: {
                    from: 'top',
                    align: 'center'
                  }
                });
              } else {
                console.error('Error deleting receipt:', _context8.t0);
                _this8.$notifications.notify({
                  type: 'danger',
                  message: 'Failed to delete receipt',
                  placement: {
                    from: 'top',
                    align: 'center'
                  }
                });
              }
            case 20:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[4, 11]]);
      }))();
    },
    closeDeleteConfirm: function closeDeleteConfirm() {
      this.showDeleteConfirm = false;
      this.deleteTargetReceipt = null;
    },
    handleUploadClick: function handleUploadClick() {
      this.$router.push({
        path: '/evedpay/transactions'
      });
    },
    // Pull-to-refresh methods
    onPullStart: function onPullStart(e) {
      if (!this.isMobile || this.isRefreshing) return;
      var container = e.currentTarget;
      if (container.scrollTop > 0) return;
      this.pullStartY = e.touches[0].clientY;
      this.isPulling = true;
    },
    onPullMove: function onPullMove(e) {
      if (!this.isPulling) return;
      var deltaY = e.touches[0].clientY - this.pullStartY;
      var deltaX = Math.abs(e.touches[0].clientX - (this._pullStartX || e.touches[0].clientX));
      if (!this._pullStartX) this._pullStartX = e.touches[0].clientX;
      if (deltaX > deltaY) {
        this.isPulling = false;
        this.pullDistance = 0;
        return;
      }
      if (deltaY > 0) {
        this.pullDistance = Math.min(deltaY * 0.5, 100);
        e.preventDefault();
      }
    },
    onPullEnd: function onPullEnd() {
      if (!this.isPulling) return;
      this._pullStartX = null;
      if (this.pullDistance >= 60) {
        this.handleRefresh();
      }
      this.isPulling = false;
      this.pullDistance = 0;
    },
    // Swipe-to-delete methods
    onRowSwipeStart: function onRowSwipeStart(e, receipt) {
      this.swipeStartX = e.touches[0].clientX;
      this._swipeStartY = e.touches[0].clientY;
      this.swipedRowId = receipt.receiptScanId;
      this.swipeOffset = 0;
    },
    onRowSwipeMove: function onRowSwipeMove(e, receipt) {
      if (this.swipedRowId !== receipt.receiptScanId) return;
      var deltaX = e.touches[0].clientX - this.swipeStartX;
      var deltaY = Math.abs(e.touches[0].clientY - this._swipeStartY);
      if (deltaY > Math.abs(deltaX)) {
        this.swipedRowId = null;
        this.swipeOffset = 0;
        return;
      }
      if (deltaX < 0) {
        this.swipeOffset = Math.max(deltaX, -100);
        e.preventDefault();
      }
    },
    onRowSwipeEnd: function onRowSwipeEnd(e, receipt) {
      if (this.swipedRowId !== receipt.receiptScanId) return;
      if (this.swipeOffset < -60) {
        this.swipeOffset = -80;
      } else {
        this.swipeOffset = 0;
        this.swipedRowId = null;
      }
    },
    getSwipeStyle: function getSwipeStyle(receiptScanId) {
      if (this.swipedRowId === receiptScanId && this.swipeOffset !== 0) {
        return {
          transform: 'translateX(' + this.swipeOffset + 'px)',
          transition: 'transform 0.2s ease'
        };
      }
      return {
        transform: 'translateX(0)',
        transition: 'transform 0.2s ease'
      };
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "ispy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: [String, Number]
  },
  created: function created() {
    this.value = this.params && this.params.data && this.params.data.Until;
  },
  computed: {
    tag: function tag() {
      if (this.params.data.IsImmediatePayment) {
        return 'Immediate';
      } else {
        var diff = this.getTimeDifference(this.params.data.TimeDue);
        var res = '';
        if (diff < 0) {
          diff = Math.abs(diff);
          res = 'Overdue - ';
        }
        var hours = Math.floor(diff / 36e5);
        var minutes = Math.floor(diff % 36e5 / 60000);
        var hStr = hours === 0 ? '' : hours + ' hr';
        var mStr = minutes === 0 ? '' : minutes + ' min';
        res += hStr + (hStr !== '' ? ' ' : '') + mStr;
        return res;
      }
    },
    tagClass: function tagClass() {
      return 'text ' + this.getTimeDue(this.params);
    }
  },
  methods: {
    getTimeDifference: function getTimeDifference(timeDue) {
      var now = new Date().getTime();
      var due = new Date(this.getDateFromAspNetFormat(timeDue)).getTime();
      return due - now;
    },
    getTimeDue: function getTimeDue(params) {
      if (params.data.IsImmediatePayment) {
        return 'badge overdue';
      }
      if (this.getTimeDifference(params.data.TimeDue) < 0) {
        return 'text-danger';
      }
      return '';
    },
    getDateFromAspNetFormat: function getDateFromAspNetFormat(date) {
      var re = /-?\d+/;
      var m = re.exec(date);
      return parseInt(m[0], 10);
    }
  }
});

/***/ }),

/***/ "itzc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetInvoiceScanSnapshot_vue__ = __webpack_require__("d+Go");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c71ba2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetInvoiceScanSnapshot_vue__ = __webpack_require__("5cJS");
function injectStyle (ssrContext) {
  __webpack_require__("DRjV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36c71ba2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetInvoiceScanSnapshot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c71ba2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetInvoiceScanSnapshot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j0TN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3dgRT1_WAu0vYCFrZXdazU","Dell":"_2RRMsWVdqPAuROMV3BEqK9","Abbott":"_3OyGrZmP1U0qdyCvv-fU31","Gap":"_2fiArIg4ZBhEbNVimwmydf","Allstate":"_3YM-pKGTQVrlkqq3leDaK","Asurion":"_2ZeAwoccqhH8dBNJttzKdR","Invitae":"_1kODPHbtAxUMA0V0o3a29V","JWE":"kINd83KOHuk883cPdvNht"};

/***/ }),

/***/ "j3Ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"i2p-new-page"},[_c('ed-title-nav',{ref:"header",attrs:{"title":_vm.$t(_vm.pageTitle),"subtitle":_vm.$t(_vm.subtitle)}},[_c('snapshot',{attrs:{"slot":"overview","model":_vm.snapshotSettings},slot:"overview"}),_vm._v(" "),_c('span',{attrs:{"slot":"action"},slot:"action"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.cancel()}}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("  Back")])])]),_vm._v(" "),_c('toolbar',{attrs:{"slot":"toolbar"},slot:"toolbar"},[(!_vm.displaySendApFile)?_c('ed-button',{attrs:{"button-class":"btn btn-actionbar-primary pull-right","disabled":_vm.disablePaymentAction,"name":"submit-payment"},on:{"click":function($event){return _vm.validateAndSubmit()}}},[_vm._v(_vm._s(_vm.submitPaymentButton))]):_vm._e(),_vm._v(" "),(_vm.displaySendApFile)?_c('ed-button',{attrs:{"button-class":"btn btn-actionbar-primary pull-right","disabled":_vm.disablePaymentAction,"name":"submit-payment"},on:{"click":function($event){return _vm.sendApFiles()}}},[_vm._v(_vm._s('Send'))]):_vm._e(),_vm._v(" "),_c('ed-button',{attrs:{"button-class":"btn btn-actionbar pull-right","name":"cancel-payment"},on:{"click":function($event){return _vm.cancel()}}},[_vm._v(_vm._s('Cancel'))])],1)],1),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('br'),_vm._v(" "),(!_vm.displaySendApFile)?_c('span',{staticClass:"step1"},[_c('funding-information',{attrs:{"model":_vm.getFundingInformationModel(),"errors":_vm.validationErrors,"invoiceModelCurrencies":_vm.getInvoiceModelCurrencies,"isFundingCurrencyDifferent":_vm.isFundingCurrencyDifferent},on:{"fundingInfoChanged":_vm.fundingInfoChanged}}),_vm._v(" "),_vm._l((_vm.invoicesByDivisionOrBU),function(division,index){return _c('span',{key:division.DivisionOrBUName},[_c('invoices',{ref:"invoicesComp",refInFor:true,attrs:{"invoices":division.Invoices,"settings":_vm.getInvoicesSettings(division)},on:{"makePaymentCurrencyConversion":_vm.doCurrencyConversion,"amountOnInvoiceWasChanged":_vm.amountOnInvoiceWasChanged}}),_vm._v(" "),(_vm.isMakePayment)?_c('make-payment',{attrs:{"divisionKey":index,"model":division,"achInfo":_vm.settings.AchInfo},on:{"paymentChanges":_vm.makePaymentFieldsChanges,"changeAddress":function (d) { return _vm.changeAddress(d, index); }}}):_vm._e(),_vm._v(" "),(_vm.isPostPayment)?_c('post-payment',{attrs:{"divisionKey":index,"model":division,"paymentMethods":_vm.settings.paymentMethods,"userToken":_vm.user.token},on:{"paymentChanges":_vm.postPaymentFieldsChanged}}):_vm._e()],1)})],2):_vm._e(),_vm._v(" "),(_vm.displaySendApFile)?_c('span',{staticClass:"step2"},_vm._l((_vm.step2Models),function(item,i){return _c('span',{key:i},[_c('invoices',{attrs:{"invoices":_vm.filterInvoicesForStep2(item),"settings":_vm.getApFileInvoicesSettings(item)}}),_vm._v(" "),_c('send-ap-file',{attrs:{"emailSettings":item,"token":_vm.user.token},on:{"apFileChanges":_vm.apFileChanges,"changeAddress":function (d) { return _vm.changeAddress(d, i); }}})],1)}),0):_vm._e()]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.processingErrorModel.display,"title":"","primaryButton":"false","secondaryButton":"Ok","type":"large","name":"processing_error"},on:{"close":function($event){_vm.processingErrorModel.display = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v(_vm._s(_vm.processingErrorModel.headerLabel))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"full-width simple"},[_c('thead',_vm._l((_vm.processingErrorModel.columns),function(column){return _c('th',{key:column,staticClass:"col-md-2"},[_vm._v(_vm._s(column))])}),0),_vm._v(" "),_vm._l((_vm.processingErrorModel.errors),function(error){return _c('tbody',{key:error},[_c('tr',_vm._l((error),function(col){return _c('td',{key:col,staticClass:"col-md-2"},[(col.url !== '')?_c('a',{attrs:{"href":col.url}},[_vm._v(_vm._s(col.message))]):_vm._e(),_vm._v(" "),(col.url === '')?_c('span',[_vm._v(_vm._s(col.message))]):_vm._e()])}),0)])})],2)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j9Ga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(userSettings) {
    var model = {
      'DivisionsId': {
        label: '_'
      },
      '*DivisionName': {
        label: userSettings.Labels.DivisionName,
        width: 30,
        editable: false
      }
    };
    return model;
  }
});

/***/ }),

/***/ "jACo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CloseAccount_vue__ = __webpack_require__("Trxq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b88c498_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CloseAccount_vue__ = __webpack_require__("lEGT");
function injectStyle (ssrContext) {
  __webpack_require__("Hj+U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b88c498"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CloseAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b88c498_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CloseAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jAzx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("kss6");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f33699_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("CqA7");
function injectStyle (ssrContext) {
  __webpack_require__("3NN2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26f33699"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f33699_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jBGl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docs_vue__ = __webpack_require__("ojQe");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e06b10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_docs_vue__ = __webpack_require__("3nd9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e06b10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_docs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jHm1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoices_vue__ = __webpack_require__("zYxv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e2ea06_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoices_vue__ = __webpack_require__("5T3O");
function injectStyle (ssrContext) {
  __webpack_require__("aeML")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51e2ea06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e2ea06_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jIfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("owlQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5157c5fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("D/uH");
function injectStyle (ssrContext) {
  __webpack_require__("T6gH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5157c5fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jIjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{ref:"header",attrs:{"title":_vm.$t("Business Units and Cost Centers")}},[_c('span',{attrs:{"slot":"action"},slot:"action"},[(_vm.$routerHistory.hasHistory() && _vm.$route.query["back-to"])?_c('router-link',{attrs:{"to":{ path: _vm.$routerHistory.previous().path, hash: "" }}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_c('span',[_vm._v("  "+_vm._s(_vm.$t('Back') + ' ' + _vm.$t('to') + ' ' + _vm.$t(_vm.$route.query['back-to'])))])]):_vm._e()],1)]),_c('div',{staticClass:"container-fluid"},[_c('ed-section',{staticClass:"active clear"},[_c('div',{staticClass:"col-md-12 no-pad"},[_c('ed-checkbox',{staticClass:"text-left",attrs:{"options":[{
                    label: "Use Business Units",
                    status: _vm.settingsCopy.HasBusinessUnit
                  }]},on:{"click":_vm.changeBUSetting},model:{value:(_vm.settingsCopy.HasBusinessUnit),callback:function ($$v) {_vm.$set(_vm.settingsCopy, "HasBusinessUnit", $$v)},expression:"settingsCopy.HasBusinessUnit"}}),_c('ed-checkbox',{staticClass:"text-left",attrs:{"options":[{
                    label: "Use Cost Centers",
                    status: _vm.settingsCopy.HasCostCenter
                  }]},on:{"click":_vm.changeCCSetting},model:{value:(_vm.settingsCopy.HasCostCenter),callback:function ($$v) {_vm.$set(_vm.settingsCopy, "HasCostCenter", $$v)},expression:"settingsCopy.HasCostCenter"}}),_c('ed-checkbox',{staticClass:"text-left",attrs:{"options":[{
                    label: "Use paired Business Units and Cost Centers",
                    status: _vm.settingsCopy.UseBusinessUnitAndCostCenterMapping
                  }],"disabled":_vm.disablePairedBUCC},on:{"click":_vm.changePairedBUAndCCStatus},model:{value:(_vm.settingsCopy.UseBusinessUnitAndCostCenterMapping),callback:function ($$v) {_vm.$set(_vm.settingsCopy, "UseBusinessUnitAndCostCenterMapping", $$v)},expression:"settingsCopy.UseBusinessUnitAndCostCenterMapping"}}),(_vm.displayBUGrid)?_c('div',[_c('br'),_c('h4',[_vm._v("Business Units")]),_c('BUList'),_c('br')],1):_vm._e(),(_vm.displayCCGrid)?_c('div',[_c('br'),_c('h4',[_vm._v("Cost Centers")]),_c('CCList'),_c('br')],1):_vm._e(),(_vm.settingsCopy.UseBusinessUnitAndCostCenterMapping)?_c('div',[_c('br'),_c('h4',[_vm._v("Paired Business Units and Cost Centers")]),_c('BUAndCCList')],1):_vm._e()],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jTz+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateSelector_vue__ = __webpack_require__("86dO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c530944_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateSelector_vue__ = __webpack_require__("i8rz");
function injectStyle (ssrContext) {
  __webpack_require__("KMZP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c530944"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c530944_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jUNV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("9W4m");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a22d7b4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("WZNc");
function injectStyle (ssrContext) {
  __webpack_require__("0VFA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a22d7b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a22d7b4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jX68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cells_checkboxProxy__ = __webpack_require__("aLD8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var SORT_ASCENDING = 'fa-sort-up';
var SORT_DESCENDING = 'fa-sort-down';
var SORT_UNSORTED = 'fa-sort';


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  components: {
    checkboxProxy: __WEBPACK_IMPORTED_MODULE_1__cells_checkboxProxy__["a" /* default */]
  },
  created: function created() {
    var _this = this;
    var dragRows = this.params.context.dragRows;
    var headerCheckbox = dragRows ? 'action-drag' : 0;
    var cell;
    if (this.params.column.colDef.action === 'checkbox') {
      this.$nextTick(function () {
        cell = _this.params.api.headerRenderer.childContainers[1].headerRowComps[0].headerComps[headerCheckbox];
        _this.headerCheckbox = cell && cell.eHtmlElement;
      });
    }
  },
  data: function data() {
    return {
      //
      headerCheckbox: null
    };
  },
  computed: {
    sortState: function sortState() {
      return this.params.column.sort === 'asc' ? 'fa-sort-up' : this.params.column.sort === 'desc' ? 'fa-sort-down' : 'fa-sort';
    },
    isLast: function isLast() {
      return this.params.column.left === this.params.columnApi._columnController.bodyWidth - this.params.column.actualWidth;
    },
    disabled: function disabled() {
      return this.params.context.disableFilter;
    },
    appliedFilters: function appliedFilters() {
      var appliedFilters = this.params.api.getFilterModel()[this.params.column.colDef.field];
      appliedFilters = appliedFilters && appliedFilters.filter ? appliedFilters.filter.split('_').length : null;
      return this.params.column.filterActive ? appliedFilters : null;
    }
  },
  methods: {
    //
    showMenu: function showMenu(e) {
      this.disabled || this.params.showColumnMenu(e.target);
      this.params.context.shownPopover = true;
    },
    sortColumn: function sortColumn() {
      this.params.progressSort();
    },
    pinColumn: function pinColumn() {
      this.params.columnApi.setColumnPinned(this.params.column.colId, this.params.column.pinned ? null : 'left');
    },
    tooltip: function tooltip(sortState) {
      var tooltip = 'Sort';
      switch (sortState) {
        case SORT_ASCENDING:
          tooltip = 'Sort descending';
          break;
        case SORT_DESCENDING:
          tooltip = 'Sort ascending';
          break;
        case SORT_UNSORTED:
          tooltip = 'Sort ascending';
      }
      return tooltip;
    }
  }
}));

/***/ }),

/***/ "jaZM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__("NM/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_I2P_components_TheToolbar__ = __webpack_require__("u9q6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddTransactionInEnvelope_vue__ = __webpack_require__("ZXaR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_Programs_Card_envelopes_RejectEnvelope_vue__ = __webpack_require__("HePg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_Dashboard_widgets_ApprovalNeeded_approve_dialog__ = __webpack_require__("u8Yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AddReceipt_vue__ = __webpack_require__("VJRP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_api_receiptScans__ = __webpack_require__("X3jq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modules_Programs_Card_envelopes_EnvelopeRejectInfo_vue__ = __webpack_require__("T67L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modules_Dashboard_widgets_ApprovalNeeded_reject_dialog__ = __webpack_require__("2E/x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modules_Programs_Card_transactions_PredictedCodingIcon_vue__ = __webpack_require__("enAH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_he__ = __webpack_require__("t02m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modules_Programs_Card_envelopes_envelopeTerm__ = __webpack_require__("i/Pq");




function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














// import { backToMap } from '@/components/Layouts/navless'
var backToMap = {
  'EnvelopeApprovalDashboard': '/ApprovalDashboard'
};

// Predictive Coding prefill (EvedPay Card reconcile surface).
// surface = PredictionSurface.EpcReconcile, sent to the Platform predict API as the integer 1.
var EPC_RECONCILE_SURFACE = 1;
// Tight client-side cap so a slow predict endpoint can never hang the silent prefill.
var PREDICT_TIMEOUT_MS = 8000;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // Owned locally: Vue 2.7 props are shallow-reactive, so pushing into a prop array never
      // notifies the computed total — the page totals froze when adding a transaction.
      selectedRows: (this.initialRows || []).slice(),
      newEnvelope: {},
      selectedProgram: {},
      suppliers: [],
      selectedSupplier: '',
      supplierOptions: [],
      selectedSuppliers: [],
      descriptions: [],
      programOptions: [],
      supplierIds: [],
      supplierFromRow: {},
      form: null,
      formKey: '',
      splitCounters: [],
      splitAmounts: [],
      programIncomplete: false,
      wrongSplitTotal: [],
      supplierIncomplete: [],
      descriptionIncomplete: [],
      attachments: [],
      // PRODUCTDEV-5783 — per-transaction additional (non-receipt) documents, parallel to
      // `attachments`. Loaded from the reconcile/envelope response, sent on save.
      additionalDocuments: [],
      // PRODUCTDEV-5783 — per-transaction "receipt scanning" flag. While true, the row's
      // amount + description cells show a gray skeleton until the scan prefill lands.
      scanningRows: [],
      attachmentIncomplete: [],
      businessUnits: [],
      costCenters: [],
      buAndCcPairs: [],
      categories: [],
      hasBu: false,
      hasCc: false,
      hasBuAndCcPair: false,
      ccIncomplete: [],
      buIncomplete: [],
      buAndCcPairIncomplete: [],
      loadedCategoriesAndBuAndCc: -1,
      allowPredictiveCoding: false,
      categoryIncomplete: [],
      showAlertProgram: false,
      programOption: Object,
      previousSelectedProgram: Object,
      programConfirmPressed: false,
      requireReceiptDescription: false,
      draftSaved: false,
      showApproveDialog: false,
      showApproversDialog: false,
      isApproving: false,
      receiptIncomplete: false,
      approvalUsersData: {},
      readonly: true,
      preventCreateEnvelope: false,
      IsAppovalFromEditView: false,
      screen: '',
      Approvers: [],
      ApprovalNeeded: [],
      showEnvelopeRejectInfo: false,
      rejectionReason: '',
      copySplitObject: {},
      waitingApprovalStatuses: ['Open - Waiting Approval', 'Exported - Waiting Approval', 'Posted - Waiting Approval'],
      customFieldIncomplete: [],
      copiedForm: [],
      hasIncompleteField: false,
      // PRODUCTDEV-5809 — drives the dedicated "coding amounts must equal the transaction
      // amount" banner. A reactive data flag (not a computed) because wrongSplitTotal is
      // mutated by index, which Vue 2 can't track for a computed.
      hasWrongSplitTotal: false,
      customOptions: {},
      rejectedStatuses: ['Declined', 'Exported - Declined', 'Posted - Declined'],
      showRejectDialog: false,
      isResendButtonDisabled: false,
      resendMessage: '',
      // (productdev-5859) Resubmit Approval dialog state
      showResubmitDialog: false,
      resubmitting: false,
      resubmittedDate: null,
      baseCustomFields: null,
      receiptScanEnabled: __WEBPACK_IMPORTED_MODULE_16__core_feature_flags_feature_flags__["a" /* default */].receiptScanPrefill,
      isCategoryRequired: false,
      duplicateIndexesMap: {},
      hasDuplicates: false,
      duplicateMessage: '',
      programLoader: {
        items: [],
        pageIndex: 0,
        hasMore: true,
        isLoading: false,
        searchTerm: ''
      },
      pageSize: 50
    };
  },
  components: {
    TheToolbar: __WEBPACK_IMPORTED_MODULE_5__components_modules_I2P_components_TheToolbar__["a" /* default */],
    AddTransaction: __WEBPACK_IMPORTED_MODULE_6__AddTransactionInEnvelope_vue__["a" /* default */],
    AddReceipt: __WEBPACK_IMPORTED_MODULE_9__AddReceipt_vue__["a" /* default */],
    ApproveDialog: __WEBPACK_IMPORTED_MODULE_8__components_modules_Dashboard_widgets_ApprovalNeeded_approve_dialog__["default"],
    RejectEnvelope: __WEBPACK_IMPORTED_MODULE_7__components_modules_Programs_Card_envelopes_RejectEnvelope_vue__["a" /* default */],
    EnvelopeRejectInfo: __WEBPACK_IMPORTED_MODULE_11__components_modules_Programs_Card_envelopes_EnvelopeRejectInfo_vue__["a" /* default */],
    RejectDialog: __WEBPACK_IMPORTED_MODULE_12__components_modules_Dashboard_widgets_ApprovalNeeded_reject_dialog__["default"],
    PredictedCodingIcon: __WEBPACK_IMPORTED_MODULE_13__components_modules_Programs_Card_transactions_PredictedCodingIcon_vue__["a" /* default */]
  },
  props: {
    initialRows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    envelope: {
      type: Object,
      default: {}
    },
    editEnvelope: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;
    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iterator, _step, selectedRow, _row, i, row, supplierName, isStillWaitingApproval;
      return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$off('envelope-created');
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$on('envelope-created', function (envelopeNumber) {
              var envNumber = envelopeNumber.data;
              _this.$notifications.notify({
                message: "".concat(_this.envelopeTerm.singular, " ").concat(envNumber, " was created!"),
                type: 'info',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            });
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$off('envelope-draft');
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$on('envelope-draft', function (envelopeNumber) {
              var envNumber = envelopeNumber.data;
              _this.$notifications.notify({
                message: "".concat(_this.envelopeTerm.singular, " ").concat(envNumber, " was saved as draft!"),
                type: 'info',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            });
            _this.divisionName = _this.singularize(_this.$root.getUser.settings.Labels.DivisionName);
            _this.programName = _this.singularize(_this.$root.getUser.settings.Labels.ProgramLabel);
            _this.hasBu = _this.$root.getUser.settings.HasBusinessUnit;
            _this.hasCc = _this.$root.getUser.settings.HasCostCenter;
            _this.hasBuAndCcPair = _this.$root.getUser.settings.UseBusinessUnitAndCostCenterMapping;
            _this.hasBuOrCcOrPair = _this.hasBu || _this.hasCc || _this.hasBuAndCcPair;
            _context.prev = 10;
            if (_this.envelope && Object.keys(_this.envelope).length > 0) {
              if (_this.envelope.EnvelopeStatus === 'Draft' || _this.rejectedStatuses.includes(_this.envelope.EnvelopeStatus) && _this.envelope.CreatedByUserID === _this.$root.getUser.$.user.UserID) {
                _this.readonly = false;
              }
            } else {
              _this.readonly = false;
            }
            if (!(_this.envelope && _this.envelope.Id && _this.envelope.Id.length > 0)) {
              _context.next = 18;
              break;
            }
            if (!_this.waitingApprovalStatuses.includes(_this.envelope.EnvelopeStatus)) {
              _context.next = 16;
              break;
            }
            _context.next = 16;
            return _this.getApprovalUsers(_this.envelope.Id);
          case 16:
            _context.next = 18;
            return _this.getTransactions(_this.envelope.Id);
          case 18:
            _context.next = 20;
            return _this.initialize();
          case 20:
            _iterator = _createForOfIteratorHelper(_this.selectedRows);
            _context.prev = 21;
            _iterator.s();
          case 23:
            if ((_step = _iterator.n()).done) {
              _context.next = 32;
              break;
            }
            selectedRow = _step.value;
            _row = selectedRow.data;
            if (!_row.ProgramId) {
              _context.next = 30;
              break;
            }
            _this.selectedProgram = {
              Id: _row.ProgramId,
              Name: _row.ProgramName,
              InternalProgramID: _row.InternalProgramID
            };
            _this.getCategoriesAndBuAndCc(_row.ProgramId);
            return _context.abrupt("break", 32);
          case 30:
            _context.next = 23;
            break;
          case 32:
            _context.next = 37;
            break;
          case 34:
            _context.prev = 34;
            _context.t0 = _context["catch"](21);
            _iterator.e(_context.t0);
          case 37:
            _context.prev = 37;
            _iterator.f();
            return _context.finish(37);
          case 40:
            for (i = 0; i < _this.selectedRows.length; i++) {
              row = _this.selectedRows[i].data;
              if (row.Supplier || row.NonEvedSupplier) {
                supplierName = row.Supplier ? "".concat(row.Supplier, " (").concat(row.SupplierEoNumber, ")") : row.NonEvedSupplier;
                _this.selectedSupplier = {
                  Key: row.VendorId,
                  Value: {
                    CompanyName: supplierName,
                    VendorId: row.SupplierId || -row.SupplierNetworkId
                  }
                };
                _this.selectedSuppliers[i] = _this.selectedSupplier;
              }
            }
            _context.next = 43;
            return _this.fillEnvelopeData();
          case 43:
            // SPRT-17924/SPRT-18736: only auto-open the approve/decline dialogs from an email link when
            // the envelope is still waiting for approval. Stale email links (envelope declined and saved
            // back to Draft meanwhile) used to open the dialog anyway, and approving stamped the Draft
            // envelope with Open - Waiting Approval.
            isStillWaitingApproval = _this.envelope && _this.waitingApprovalStatuses.includes(_this.envelope.EnvelopeStatus);
            _this.showApproveDialog = _this.$route.query.IsApproveEnvelopeFromEmail === 'true' && isStillWaitingApproval;
            _this.showRejectDialog = _this.$route.query.IsRejectEnvelopeFromEmail === 'true' && isStillWaitingApproval;
            _context.next = 52;
            break;
          case 48:
            _context.prev = 48;
            _context.t1 = _context["catch"](10);
            console.error('Error during component initialization:', _context.t1);
            throw _context.t1;
          case 52:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[10, 48], [21, 34, 37, 40]]);
    }))();
  },
  beforeCreate: function beforeCreate() {
    this.he = __WEBPACK_IMPORTED_MODULE_14_he___default.a;
  },
  computed: {
    calculatedTotalAmount: function calculatedTotalAmount() {
      var total = this.selectedRows.reduce(function (total, row) {
        return total + row.data.Amount;
      }, 0);
      return total;
    },
    formFields: function formFields() {
      return this.form && this.form[0] ? this.form[0] : [];
    },
    extraColumnsStyle: function extraColumnsStyle() {
      return {
        width: "".concat(200 * 4 + this.formFields.length * 50, "px")
      };
    },
    // PRODUCTDEV-8800: the envelope's division term, else the client's.
    envelopeTerm: function envelopeTerm() {
      return Object(__WEBPACK_IMPORTED_MODULE_17__components_modules_Programs_Card_envelopes_envelopeTerm__["a" /* envelopeTermFor */])(this.envelope);
    },
    title: function title() {
      if (this.selectedRows.length > 0 && this.selectedRows[0].data) {
        if (this.envelope && this.waitingApprovalStatuses.includes(this.envelope.EnvelopeStatus)) {
          return "".concat(this.envelopeTerm.singular, " Approval");
        } else {
          return "Create ".concat(this.envelopeTerm.singular);
        }
      }
      return "Create ".concat(this.envelopeTerm.singular);
    },
    isApprover: function isApprover() {
      return this.isUserInApprovalList();
    },
    // (productdev-5859) Resubmit is available while the envelope can still be re-run through
    // approval: declined (re-run after a mistake) or still in approval (stuck after a rule
    // change) — i.e. before it's exported to an accounting system. Matches the grid's
    // declined-or-in-approval eligibility; the rejected test is intentionally broad so plain
    // "Rejected" and the "Exported/Posted - Rejected/Declined" variants all qualify.
    canResubmit: function canResubmit() {
      var status = this.envelope && this.envelope.EnvelopeStatus;
      if (!status) return false;
      return /reject|declin/i.test(status) || this.waitingApprovalStatuses.includes(status);
    },
    // (productdev-5859) Approval rounds: cancelled rows are prior (resubmitted) rounds shown as
    // muted history above a divider; the rest are the current round.
    priorRoundApprovers: function priorRoundApprovers() {
      return (this.Approvers || []).filter(function (a) {
        return a && a.IsCancelled;
      });
    },
    currentRoundApprovers: function currentRoundApprovers() {
      return (this.Approvers || []).filter(function (a) {
        return a && !a.IsCancelled;
      });
    },
    hasResubmitHistory: function hasResubmitHistory() {
      return this.priorRoundApprovers.length > 0;
    },
    // (productdev-5859) Real resubmit date from the backend (fresh round's creation time);
    // empty when unavailable so the divider shows no (wrong) date rather than today.
    resubmitDividerDate: function resubmitDividerDate() {
      return this.resubmittedDate ? this.formatDate(this.resubmittedDate) : '';
    },
    // (productdev-5859) Pending approvers for display. The current threshold (IsCurrentAction) is
    // shown as "In Review" and, when more than one person must approve now, collapsed into a single
    // "N Users" row (matches the design + invoice/PO). Later thresholds stay individual "Pending..."
    // rows — the envelope approval User has no order field, so only the current threshold groups here.
    // (productdev-5859) Current (in-review) threshold and the subsequent approvers, deduped by email
    // (GetApprovalUsersForEnvelope's .Distinct() is reference-equality on a DTO, so it can return the
    // same person twice). Also feed the "Approvers List" popup so its rows match the "N Users" count.
    currentThresholdApprovers: function currentThresholdApprovers() {
      return this.dedupeApproversByEmail((this.ApprovalNeeded || []).filter(function (u) {
        return u && u.IsCurrentAction;
      }));
    },
    nextThresholdApprovers: function nextThresholdApprovers() {
      return this.dedupeApproversByEmail((this.ApprovalNeeded || []).filter(function (u) {
        return u && !u.IsCurrentAction;
      }));
    },
    pendingApprovalRows: function pendingApprovalRows() {
      var current = this.currentThresholdApprovers;
      var later = this.nextThresholdApprovers;
      var rows = [];
      // Collapse to "N Users" only when more than one approver is in review now; the list is deduped
      // so the count matches the Approvers List popup. A single approver shows their name. The
      // collapsed row is flagged isGroup so the template renders a clickable popup link.
      if (current.length > 1) {
        rows.push({
          status: 'In Review',
          name: "".concat(current.length, " Users"),
          createdDate: current[0].CreatedDate,
          isGroup: true
        });
      } else if (current.length >= 1) {
        rows.push({
          status: 'In Review',
          name: current[0].Name,
          createdDate: current[0].CreatedDate,
          isGroup: false
        });
      }
      later.forEach(function (u) {
        return rows.push({
          status: 'Pending...',
          name: u.Name,
          createdDate: u.CreatedDate,
          isGroup: false
        });
      });
      return rows;
    },
    rejectionMessage: function rejectionMessage() {
      var message = "The ".concat(this.envelopeTerm.lower, " was declined for the following reason: ").concat(this.envelope.RejectionReason, "\n          <br> Only ").concat(this.envelope.CreatedByUser, " can edit this ").concat(this.envelopeTerm.lower, ".");
      return message;
    }
  },
  watch: {
    'envelope.FormattedLastModifiedDate': function envelopeFormattedLastModifiedDate(newValue) {
      this.getTimeFromFormatedDate(newValue);
      this.getDateFromFormatedDate(newValue);
    },
    selectedRows: function selectedRows(newVal, oldVal) {
      this.validateDuplicates();
    }
  },
  methods: {
    // Surface the custom Name on Card next to the holder ("Jane Doe | John Smith") when set and
    // meaningfully differs, mirroring the CardHolder.vue two-line layout the cards/envelopes grid renders.
    // See PRODUCTDEV-5553 for the underlying pattern.
    formatHolderLine: function formatHolderLine(rowData) {
      var holder = (rowData && rowData.Holder || '').trim();
      var nameOnCard = (rowData && rowData.NameOnCard || '').trim();
      if (!nameOnCard || nameOnCard.toLowerCase() === holder.toLowerCase()) {
        return rowData && rowData.Holder || '';
      }
      if (!holder) {
        return nameOnCard;
      }
      return "".concat(nameOnCard, " | ").concat(holder);
    },
    formatMoney: function formatMoney(amount) {
      if (typeof amount !== 'number') {
        return '$0.00';
      }
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount);
    },
    // Entry from AddReceipt's @receiptScan event. AddReceipt owns the upload +
    // Photon poll; we apply the prefill into the row's split form + description.
    // Both Upload and Folder paths land here, and the apply runs in the
    // background a few seconds after upload — so resolve the row by its
    // transaction Id when given, because the closure index can go stale if the
    // user added/removed rows while Photon was still running.
    applyRowReceiptScan: function applyRowReceiptScan(rowIndex, payload) {
      // PRODUCTDEV-5783 — defense-in-depth: never apply scan coding to a locked envelope
      // (not the active approver AND read-only), matching the coding-edit lock.
      if (!this.isApprover && this.readonly) return;
      var prefill = payload && payload.prefill;
      if (payload && payload.legacyTransactionId != null) {
        var resolved = this.selectedRows.findIndex(function (r) {
          return r && r.data && r.data.Id === payload.legacyTransactionId;
        });
        if (resolved !== -1) rowIndex = resolved;
      }
      if (rowIndex == null || rowIndex < 0 || !this.selectedRows[rowIndex]) return;
      if (!prefill) return;

      // The scan is ground truth: it OVERWRITES whatever split the row currently
      // has (matches reconcile + the original intent) and shows the breakdown for
      // the division's configured mode — subtotal + tax, or a single total line.
      var amount = prefill.amount || {};
      var hasBreakdown = amount.subtotal != null && amount.tax != null && !(amount.subtotal === 0 && amount.tax === 0);
      if (prefill.prefillMode === 'line_items_and_tax' && Array.isArray(prefill.lineItems) && prefill.lineItems.length > 0) {
        this.applyRowLineItemsPrefill(rowIndex, prefill.lineItems);
      } else if (prefill.prefillMode === 'subtotal_and_tax' && hasBreakdown) {
        this.applyRowAmountPrefill(rowIndex, {
          subtotalAmount: amount.subtotal,
          taxAmount: amount.tax
        });
      } else {
        // total_only, or a subtotal_and_tax receipt Photon couldn't break down:
        // collapse to a single card-total line.
        this.applyRowTotalPrefill(rowIndex, amount.total);
      }

      // PRODUCTDEV-5813: the transaction-level Description (descriptions[rowIndex]) is
      // user-owned — scan prefill writes only the split form above, never this field.
    },
    // Subtotal/Tax 2-row overwrite. The scan is ground truth, so it replaces any
    // existing split (no splitCounters guard) and normalizes the row to exactly
    // two coding lines — subtotal and tax. applyRowReceiptScan only routes here
    // when Photon returned a real, non-zero breakdown.
    applyRowAmountPrefill: function applyRowAmountPrefill(rowIndex, data) {
      var selectedRow = this.selectedRows[rowIndex];
      if (!data || !selectedRow || !Array.isArray(selectedRow.form)) return;
      this.normalizeRowFormForMode(rowIndex, 2);
      // PRODUCTDEV-5783 — label the two coded items 'Subtotal'/'Tax' (mirrors reconcile's
      // descriptions = ['Subtotal', 'Tax']). Persisted per split via form.Descriptions[i].
      if (selectedRow.form[0]) {
        this.$set(selectedRow.form[0], 'Amount', data.subtotalAmount);
        this.$set(selectedRow.form[0], 'Description', 'Subtotal');
      }
      if (selectedRow.form[1]) {
        this.$set(selectedRow.form[1], 'Amount', data.taxAmount);
        this.$set(selectedRow.form[1], 'Description', 'Tax');
      }
      this.handleSplitAmounts(rowIndex);
    },
    // Total-only overwrite: collapse the row back to a single coding line. A
    // single row's Amount is pinned to the card charge by handleSplitAmounts —
    // which is exactly the transaction total — so there's nothing else to set.
    applyRowTotalPrefill: function applyRowTotalPrefill(rowIndex, totalAmount) {
      var selectedRow = this.selectedRows[rowIndex];
      if (!selectedRow || !Array.isArray(selectedRow.form)) return;
      this.normalizeRowFormForMode(rowIndex, 1);
      if (selectedRow.form[0]) {
        // PRODUCTDEV-5805 — apply the SCANNED total to the single coded line. Previously the row
        // was left without an amount, so handleSplitAmounts fell back to the card charge
        // (data.Amount) — the scan total (e.g. 33) showed as the transaction amount (e.g. 4.19).
        // A null total (no OCR amount) still falls back to the card charge, which is the right default.
        this.$set(selectedRow.form[0], 'Amount', totalAmount);
        // PRODUCTDEV-5783 — single coded item labelled 'Total' (mirrors reconcile's descriptions = ['Total']).
        this.$set(selectedRow.form[0], 'Description', 'Total');
      }
      this.handleSplitAmounts(rowIndex);
    },
    // Line-items overwrite: one coding line per item (N-row split). Ground truth,
    // so no splitCounters guard. (Hidden in the V1 FE, but kept wired.)
    applyRowLineItemsPrefill: function applyRowLineItemsPrefill(rowIndex, lineItems) {
      var selectedRow = this.selectedRows[rowIndex];
      if (!Array.isArray(lineItems) || lineItems.length === 0 || !selectedRow || !Array.isArray(selectedRow.form)) return;
      this.normalizeRowFormForMode(rowIndex, lineItems.length);
      for (var j = 0; j < lineItems.length; j++) {
        if (selectedRow.form[j]) {
          this.$set(selectedRow.form[j], 'Amount', lineItems[j].amount);
          // PRODUCTDEV-5783 — label each coded item with the line-item description
          // (mirrors reconcile's descriptions = lineItems.map(li => li.description)).
          this.$set(selectedRow.form[j], 'Description', lineItems[j] && lineItems[j].description || '');
        }
      }
      this.handleSplitAmounts(rowIndex);
    },
    // Grow/shrink a row's split form to `target` rows using the envelope's
    // own split mechanics so the form model stays consistent.
    normalizeRowFormForMode: function normalizeRowFormForMode(rowIndex, target) {
      var selectedRow = this.selectedRows[rowIndex];
      if (!selectedRow || !Array.isArray(selectedRow.form) || target < 1) return;
      while (selectedRow.form.length < target) {
        this.toggleSplit(rowIndex, selectedRow.form.length - 1, selectedRow);
      }
      while (selectedRow.form.length > target) {
        this.removeSplit(rowIndex, selectedRow.form.length - 1, selectedRow);
      }
    },
    getCustomOptions: function getCustomOptions(url, key) {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this2.api.get(url);
            case 3:
              response = _context2.sent;
              if (response && response.data) {
                _this2.customOptions[key] = response.data;
              }
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    },
    initialize: function initialize() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.splitCounters = new Array(_this3.selectedRows.length).fill(1);
              _this3.splitAmounts = _this3.selectedRows.map(function (item) {
                return parseFloat(item.data.Amount);
              });
              _this3.descriptions = new Array(_this3.selectedRows.length).fill(null);
              _this3.selectedSuppliers = new Array(_this3.selectedRows.length).fill(null);
              _this3.attachments = new Array(_this3.selectedRows.length).fill(null);
              _this3.additionalDocuments = new Array(_this3.selectedRows.length).fill(null);
              _this3.scanningRows = new Array(_this3.selectedRows.length).fill(false);
              _this3.resetValidation();
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    handleReasonClick: function handleReasonClick(approver) {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              try {
                _this4.rejectionReason = approver.Reason;
                _this4.showEnvelopeRejectInfo = true;
              } catch (error) {
                console.error('There was a problem handling the button click:', error);
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    validateDuplicates: function validateDuplicates() {
      var _this5 = this;
      // Reset the duplicate indexes map
      this.duplicateIndexesMap = {};
      var seenIds = new Map(); // Track seen transaction IDs and their original index

      this.selectedRows.forEach(function (row, index) {
        var transactionId = row.data && row.data.Id;
        if (seenIds.has(transactionId)) {
          // If it's a duplicate, map the current index to the original index
          var originalIndex = seenIds.get(transactionId);
          _this5.duplicateIndexesMap[index] = originalIndex;
          _this5.duplicateIndexesMap[originalIndex] = originalIndex; // Mark the original as well
        } else {
          // Store the first occurrence of the transactionId
          seenIds.set(transactionId, index);
        }
      });

      // Check if there are any duplicates
      this.hasDuplicates = Object.keys(this.duplicateIndexesMap).length > 0;
      if (this.hasDuplicates) {
        this.preventCreateEnvelope = true;
        this.duplicateMessage = ['The following duplicate transactions were detected:',
        // Specific duplicate enumeration
        Object.entries(this.duplicateIndexesMap).filter(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            index = _ref2[0],
            originalIndex = _ref2[1];
          return parseInt(index) !== originalIndex;
        }) // Only message for duplicates
        .map(function (_ref3) {
          var _ref4 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            index = _ref4[0],
            originalIndex = _ref4[1];
          return "Transaction number ".concat(parseInt(index) + 1, " is a duplicate of transaction number ").concat(originalIndex + 1, ".");
        }).join(' '), 'Please consider removing the duplicates before submitting.'].join(' ');
      } else {
        this.preventCreateEnvelope = false;
        this.duplicateMessage = '';
      }
    },
    resetValidation: function resetValidation() {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.programIncomplete = false;
              _this6.wrongSplitTotal = new Array(_this6.selectedRows.length).fill(false);
              _this6.supplierIncomplete = new Array(_this6.selectedRows.length).fill(false);
              _this6.descriptionIncomplete = new Array(_this6.selectedRows.length).fill(false);
              _this6.attachmentIncomplete = new Array(_this6.selectedRows.length).fill(false);
              _this6.ccIncomplete = new Array(_this6.selectedRows.length).fill(false);
              _this6.buIncomplete = new Array(_this6.selectedRows.length).fill(false);
              _this6.buAndCcPairIncomplete = new Array(_this6.selectedRows.length).fill(false);
              _this6.categoryIncomplete = new Array(_this6.selectedRows.length).fill(false);
              _this6.customFieldIncomplete = new Array(_this6.selectedRows.length).fill(false);
              _this6.receiptIncomplete = false;
              _this6.hasIncompleteField = false;
              _this6.hasWrongSplitTotal = false;
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getSupplierPlaceholder: function getSupplierPlaceholder(index) {
      var row = this.selectedRows[index].data;
      return row.Merchant ? row.Merchant : 'Select a supplier...';
    },
    getTransactions: function getTransactions(envelopeId) {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.screen = _this7.envelope.FromDashboard ? 'Dashboard' : '';
              _context6.prev = 1;
              _context6.next = 4;
              return _this7.api.forms.post(_this7.api.$.evedpaycard.transactions, {
                sort: 'EnvelopeListOrder',
                dir: 'ASC',
                start: 0,
                limit: 100,
                isLiveGrid: true,
                filter: JSON.stringify({
                  'EnvelopeId': envelopeId,
                  'Screen': _this7.screen,
                  searchTerm: ''
                })
              });
            case 4:
              response = _context6.sent;
              if (response && response.data) {
                _this7.selectedRows = response.data.Data.map(function (item) {
                  return {
                    data: item
                  };
                });
              }
              _context6.next = 11;
              break;
            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);
              console.error('Error while retrieving transactions:', _context6.t0);
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[1, 8]]);
      }))();
    },
    approveOrReject: function approveOrReject(envelopes) {
      var _arguments = arguments,
        _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee7() {
        var reason, payload, response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              reason = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : '';
              _this8.isApproving = true;
              _context7.prev = 2;
              payload = {
                envelopesData: envelopes
              };
              if (reason.length > 0) {
                payload.envelopesData[0].RejectReason = reason;
              }
              // SPRT-17924: this save persists any coding edits the approver made in the approval view
              // (the coding fields are intentionally editable for approvers) — do not remove it. It used
              // to race the approval call and overwrite the approved EnvelopeStatusID (6) with Waiting
              // Approval (7); the backend now refuses that downgrade at the database level, so the save
              // is safe to keep.
              _this8.IsAppovalFromEditView = true;
              _context7.next = 8;
              return _this8.createEnvelope(true);
            case 8:
              payload.preventError = true;
              _context7.next = 11;
              return _this8.api.post(_this8.api.$.evedpaycard.approveOrRejectEnvelope, payload);
            case 11:
              response = _context7.sent;
              if (response.data) {
                _context7.next = 14;
                break;
              }
              throw new Error('Error during the request');
            case 14:
              _this8.showApproveDialog = false;
              // Redirect AFTER approval API call completes successfully
              if (_this8.envelope.FromDashboard || _this8.$route.query.IsApproveEnvelopeFromEmail === 'true' || _this8.$route.query.IsRejectEnvelopeFromEmail === 'true') {
                _this8.$emit('success');
                _this8.goToDashboard();
              } else {
                _this8.$emit('success');
              }
              _context7.next = 22;
              break;
            case 18:
              _context7.prev = 18;
              _context7.t0 = _context7["catch"](2);
              console.error(_context7.t0);
              _this8.$notifications.notify({
                type: 'plain',
                icon: 'exclamation-circle',
                placement: {
                  from: 'top',
                  align: 'center'
                },
                timeout: 0,
                message: 'An error occurred while saving. Please try again.',
                discard: 'Ok',
                goto: ''
              });
            case 22:
              _context7.prev = 22;
              _this8.isApproving = false;
              return _context7.finish(22);
            case 25:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[2, 18, 22, 25]]);
      }))();
    },
    doApprove: function doApprove() {
      this.approveOrReject([this.envelope]);
    },
    doReject: function doReject(reason) {
      this.approveOrReject([this.envelope], reason);
    },
    getApprovalUsers: function getApprovalUsers(envelopeId) {
      var _this9 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.api.get(_this9.api.$.evedpaycard.approvalUsersForEnvelope, {
                params: {
                  envelopeId: envelopeId
                }
              }).then(function (response) {
                _this9.approvalUsersData = response.data;
              }).catch(function (error) {
                console.error('There was a problem with the approval users request:', error);
              });
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    // (productdev-5859) Dedupe approver rows by email so the collapsed "N Users" count and the
    // Approvers List popup agree (GetApprovalUsersForEnvelope can return the same person twice).
    dedupeApproversByEmail: function dedupeApproversByEmail(list) {
      var seen = new Set();
      return (list || []).filter(function (u) {
        var email = (u && u.Email || '').trim().toLowerCase();
        if (!email) return true;
        if (seen.has(email)) return false;
        seen.add(email);
        return true;
      });
    },
    handleResend: function handleResend() {
      var _this10 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return _this10.resendEnvelopeApprovalEmail();
            case 3:
              _this10.resendMessage = 'The email was resent successfully.';
              _context9.next = 9;
              break;
            case 6:
              _context9.prev = 6;
              _context9.t0 = _context9["catch"](0);
              _this10.resendMessage = 'Failed to resend the email. Please try again.';
            case 9:
              setTimeout(function () {
                _this10.resendMessage = '';
              }, 5000);
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[0, 6]]);
      }))();
    },
    resendEnvelopeApprovalEmail: function resendEnvelopeApprovalEmail() {
      var _this11 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this11.isResendButtonDisabled = true;
              _context10.prev = 1;
              _context10.next = 4;
              return _this11.api.post(_this11.api.$.evedpaycard.resendEnvelopeApprovalEmail, {
                envelopeId: _this11.envelope.Id
              });
            case 4:
              _context10.next = 10;
              break;
            case 6:
              _context10.prev = 6;
              _context10.t0 = _context10["catch"](1);
              console.error('There was a problem with the approval email resend request:', _context10.t0);
              _this11.isResendButtonDisabled = false;
            case 10:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[1, 6]]);
      }))();
    },
    // (productdev-5859) Resubmit a declined/stuck envelope's approval — restart at the first
    // approver, recomputed from current rules. Calls the monolith endpoint (also reachable via
    // Eved.Platform). On success, return to the list like a decline does from this view.
    resubmitEnvelope: function resubmitEnvelope() {
      var _this12 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee11() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!_this12.resubmitting) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return");
            case 2:
              _this12.resubmitting = true;
              _context11.prev = 3;
              _context11.next = 6;
              return _this12.api.post("evedpaycards/envelope/".concat(_this12.envelope.Id, "/resubmit-approval"), {});
            case 6:
              response = _context11.sent;
              if (!(response && response.data && response.data.success)) {
                _context11.next = 13;
                break;
              }
              _this12.$notifications.notify({
                message: 'Approval has been resubmitted.',
                type: 'info',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _this12.showResubmitDialog = false;
              if (_this12.envelope && _this12.envelope.FromDashboard) {
                _this12.$emit('backToTransactions');
                _this12.goToDashboard();
              } else {
                _this12.$emit('backToTransactions');
              }
              _context11.next = 14;
              break;
            case 13:
              throw new Error(response && response.data && response.data.message || 'Error during the request');
            case 14:
              _context11.next = 20;
              break;
            case 16:
              _context11.prev = 16;
              _context11.t0 = _context11["catch"](3);
              console.error(_context11.t0);
              _this12.$notifications.notify({
                message: 'Unable to resubmit approval.',
                type: 'danger',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            case 20:
              _context11.prev = 20;
              _this12.resubmitting = false;
              return _context11.finish(20);
            case 23:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[3, 16, 20, 23]]);
      }))();
    },
    isUserInApprovalList: function isUserInApprovalList() {
      var currentUserID = this.$root.getUser.$.user.UserID;
      if (Array.isArray(this.approvalUsersData)) {
        return this.approvalUsersData.some(function (user) {
          return user.Id === currentUserID && user.IsCurrentAction;
        });
      }
      return false;
    },
    transformRows: function transformRows(envelope) {
      var amount = parseFloat(this.calculatedTotalAmount).toFixed(2);
      var row = {
        // PRODUCTDEV-8800: NeedsApproval stays the key reject-dialog matches; the label is what items-list shows.
        NeedsApproval: this.waitingApprovalStatuses.includes(envelope.EnvelopeStatus) ? 'EvedPay Envelope' : '',
        NeedsApprovalLabel: this.waitingApprovalStatuses.includes(envelope.EnvelopeStatus) ? 'EvedPay ' + this.envelopeTerm.singular : '',
        Amount: amount + ' USD'
      };
      return [row];
    },
    handleSplitAmounts: function handleSplitAmounts(index) {
      var _this13 = this;
      var data = this.selectedRows[index].data;
      var form = this.selectedRows[index].form;
      form.forEach(function (item, rowIndex) {
        // PRODUCTDEV-5783 — preserve a scanned/typed amount instead of always pinning a single
        // row to the transaction total. That pinning reset the amount whenever a split was
        // removed (2→1). A multi-row blank (null/undefined) stays blank (a scan can leave one
        // side empty for the user to fill); only a fresh single row with no amount of its own
        // falls back to the card total.
        if ((item.Amount === null || item.Amount === undefined) && form.length !== 1) {
          return;
        }
        var parsedAmount = item.Amount != null && item.Amount !== '' && !isNaN(parseFloat(item.Amount)) ? parseFloat(item.Amount) : form.length === 1 ? parseFloat(data.Amount) : 0;

        // Ensure the amount is set reactively
        if (!isNaN(parsedAmount)) {
          _this13.$set(form[rowIndex], 'Amount', parsedAmount);
        }
      });

      // Make sure the split amounts are updated and Vue re-renders
      this.splitAmounts[index] = form.map(function (item) {
        return item.Amount;
      });
      this.$forceUpdate(); // Force Vue to update the DOM
      this.$emit('split-amounts', this.splitAmounts);
    },
    handleInput: function handleInput(index, rowIndex, inputName, value) {
      this.$set(this.selectedRows[index].form[rowIndex], inputName, value);
      if (inputName === 'Category') {
        this.$set(this.selectedRows[index].form[rowIndex], 'isPredicted', false);
      }
      if (value) {
        this.$forceUpdate();
      }
    },
    formatDate: function formatDate(date) {
      var momentDateFormat = this.$root.getUser.sessionSettings.DateAndTimeFormats.MomentDateFormat;
      return global.moment(date).format(momentDateFormat);
    },
    getTimeFromFormatedDate: function getTimeFromFormatedDate(formatedDate) {
      if (formatedDate) {
        var parts = formatedDate.split(' ');
        if (parts.length >= 2) {
          var result = parts[1];
          if (parts.length > 2) {
            result += ' ' + parts[2];
          }
          return result;
        }
      }
      return '';
    },
    getDateFromFormatedDate: function getDateFromFormatedDate(formatedDate) {
      if (formatedDate) {
        return formatedDate.split(' ')[0];
      }
      return '';
    },
    parseJsonDate: function parseJsonDate(jsonDate) {
      return parseInt(jsonDate.match(/\d+/)[0], 10);
    },
    singularize: function singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value;
    },
    toggleSplit: function toggleSplit(index, rowIndex, selectedRow) {
      var _this14 = this;
      var existingRow = selectedRow.form[rowIndex];

      // PRODUCTDEV-5475 — initialize from the transaction amount, NOT 0 (keep-amount on split,
      // matching the reconcile modal): a $50 row splits to $50/$0 so the user keeps the total in
      // front of them to adjust. Null guard preserves an already-typed/prefilled amount; prefill
      // overwrites right after toggleSplit returns. handleSplitAmounts already keeps the value on remove.
      if (selectedRow.form.length < 2 && selectedRow.form[rowIndex].Amount == null) {
        this.$set(selectedRow.form[rowIndex], 'Amount', selectedRow.data.Amount || 0);
      }

      // Clone the existing row fields
      var newRow = existingRow.map(function (field) {
        return {
          Key: field.Key,
          Label: field.Label,
          Values: '',
          // Reset Values
          Required: field.Required,
          Type: field.Type
        };
      });
      this.baseCustomFields.forEach(function (baseObj, baseIndex) {
        if (newRow[baseIndex]) {
          Object.keys(baseObj).forEach(function (key) {
            newRow[baseIndex][key] = baseObj[key];
          });
        }
      });

      // Force reactivity
      this.$set(newRow, 'Amount', 0);

      // Add the new row in the form
      selectedRow.form.splice(rowIndex + 1, 0, newRow);
      this.$nextTick(function () {
        _this14.handleSplitAmounts(index);
      });
      this.splitCounters[index]++;
    },
    removeSplit: function removeSplit(index, rowIndex, selectedRow) {
      if (selectedRow.form.length > 1) {
        selectedRow.form.splice(rowIndex, 1);
        this.splitCounters[index]--;
        this.handleSplitAmounts(index);
        this.$forceUpdate();
      }
    },
    copySplit: function copySplit(row) {
      if (row) {
        this.copySplitObject.Amount = row.Amount;
        this.copySplitObject.Fields = Array.from(row);
        if (this.hasBuAndCcPair) {
          this.copySplitObject.BuAndCcPair = row.BuAndCcPair;
        }
        if (this.hasBu) {
          this.copySplitObject.BusinessUnit = row.BusinessUnit;
        }
        if (this.hasCc) {
          this.copySplitObject.CostCenter = row.CostCenter;
        }
        this.copySplitObject.Category = row.Category;
        this.copySplitObject.ReferenceId = row.ReferenceId;
        this.copySplitObject.Description = row.Description; // PRODUCTDEV-5783
      }
    },
    pasteSplit: function pasteSplit(index, row) {
      if (row) {
        this.copySplitObject.Fields.forEach(function (field) {
          var matchingField = row.find(function (f) {
            return f.Key === field.Key;
          });
          if (matchingField) {
            matchingField.Values = field.Values;
          }
        });
        row.Amount = this.copySplitObject.Amount;
        if (this.hasBuAndCcPair) {
          row.BuAndCcPair = this.copySplitObject.BuAndCcPair;
        }
        if (this.hasBu) {
          row.BusinessUnit = this.copySplitObject.BusinessUnit;
        }
        if (this.hasCc) {
          row.CostCenter = this.copySplitObject.CostCenter;
        }
        row.Category = this.copySplitObject.Category;
        this.$set(row, 'isPredicted', false);
        row.ReferenceId = this.copySplitObject.ReferenceId;
        this.$set(row, 'Description', this.copySplitObject.Description != null ? this.copySplitObject.Description : ''); // PRODUCTDEV-5783
        this.handleSplitAmounts(index);
        this.$forceUpdate();
      }
    },
    resetSplit: function resetSplit() {
      var _this15 = this;
      this.selectedRows.forEach(function (row, index) {
        row.form.forEach(function (item) {
          item.CostCenter = null;
          item.BusinessUnit = null;
          item.BuAndCcPair = null;
          item.Category = null;
          _this15.$set(item, 'isPredicted', false);
          item.ReferenceId = null;
        });
        row.form = [row.form[0]];
        _this15.splitCounters[index] = 1;
        _this15.handleSplitAmounts(index);
        _this15.$forceUpdate();
      });
    },
    formsTemplate: function formsTemplate() {
      var _this16 = this;
      this.selectedRows = this.selectedRows.map(function (row) {
        return _objectSpread(_objectSpread({}, row), {}, {
          form: JSON.parse(JSON.stringify(_this16.form))
        });
      });
    },
    getCategoriesAndBuAndCc: function getCategoriesAndBuAndCc(programId) {
      var _this17 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee12() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _this17.loadedCategoriesAndBuAndCc = 0;
              _context12.next = 4;
              return _this17.api.get(_this17.api.$.evedpaycard.categoriesAndBuAndCc, {
                params: {
                  programId: programId,
                  invoiceId: 0,
                  loadAllData: true
                }
              });
            case 4:
              response = _context12.sent;
              if (response && response.data) {
                if (response.data.costCentersAndBusinessUnit) {
                  _this17.hasBuAndCcPair = response.data.costCentersAndBusinessUnit.areCombined || _this17.$root.getUser.settings.UseBusinessUnitAndCostCenterMapping;
                  if (_this17.hasBuAndCcPair) {
                    if (response.data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits) {
                      _this17.buAndCcPairs = response.data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits;
                    }
                  } else {
                    _this17.hasBu = response.data.costCentersAndBusinessUnit.businessUnits.length > 0 || _this17.$root.getUser.settings.HasBusinessUnit;
                    _this17.hasCc = response.data.costCentersAndBusinessUnit.costCenters.length > 0 || _this17.$root.getUser.settings.HasCostCenter;
                    if (_this17.hasBu) {
                      _this17.businessUnits = response.data.costCentersAndBusinessUnit.businessUnits;
                    }
                    if (_this17.hasCc) {
                      _this17.costCenters = response.data.costCentersAndBusinessUnit.costCenters;
                    }
                  }
                }
                if (response.data.categories) {
                  _this17.categories = response.data.categories;
                }

                // Per-division Predictive Coding toggle, carried on the existing categories response.
                // Consumed by the batch predict prefill; when falsy, no predict XHR is ever fired.
                _this17.allowPredictiveCoding = !!response.data.allowPredictiveCoding;
                _this17.loadedCategoriesAndBuAndCc = 1;
              }
              _context12.next = 12;
              break;
            case 8:
              _context12.prev = 8;
              _context12.t0 = _context12["catch"](0);
              _this17.loadedCategoriesAndBuAndCc = -1;
              console.warn(_context12.t0);
            case 12:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[0, 8]]);
      }))();
    },
    // Predictive Coding: one silent, fail-silent batch predict on envelope open for the eligible rows.
    // Fire-and-forget; any failure leaves the fields empty and the user codes manually.
    prefillCategoriesFromPredictionBatch: function prefillCategoriesFromPredictionBatch() {
      var _this18 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee13() {
        var eligibleRows, divisionId, programId, items, response, results, predictionByKey;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (_this18.allowPredictiveCoding) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return");
            case 2:
              if (!(!_this18.categories || _this18.categories.length === 0)) {
                _context13.next = 4;
                break;
              }
              return _context13.abrupt("return");
            case 4:
              if (!(!_this18.selectedRows || _this18.selectedRows.length === 0)) {
                _context13.next = 6;
                break;
              }
              return _context13.abrupt("return");
            case 6:
              // Build the items from ONLY eligible rows: division on (checked above) and un-coded.
              eligibleRows = _this18.selectedRows.filter(function (row) {
                return _this18.isRowEligibleForPrediction(row);
              });
              if (!(eligibleRows.length === 0)) {
                _context13.next = 9;
                break;
              }
              return _context13.abrupt("return");
            case 9:
              divisionId = _this18.selectedRows[0].data.DivisionId;
              programId = _this18.selectedProgram && _this18.selectedProgram.Id ? _this18.selectedProgram.Id : _this18.selectedRows[0].data.ProgramId; // The batch endpoint accepts at most 100 items.
              items = eligibleRows.slice(0, 100).map(function (row) {
                return {
                  clientKey: String(row.data.Id),
                  surface: EPC_RECONCILE_SURFACE,
                  supplierId: null,
                  merchantName: row.data.Merchant,
                  itemName: null,
                  description: null,
                  amount: row.data.Amount != null ? row.data.Amount : null,
                  mcc: null
                };
              });
              _context13.prev = 12;
              _context13.next = 15;
              return _this18.api.platform.post(_this18.api.$.predictiveCoding.batch, {
                programId: programId,
                divisionId: divisionId,
                items: items
              }, {
                timeout: PREDICT_TIMEOUT_MS
              });
            case 15:
              response = _context13.sent;
              results = response && response.data && response.data.results;
              if (Array.isArray(results)) {
                _context13.next = 19;
                break;
              }
              return _context13.abrupt("return");
            case 19:
              // Index predictions by the ECHOED clientKey, never by array position.
              predictionByKey = {};
              results.forEach(function (result) {
                if (result && result.clientKey != null) {
                  predictionByKey[result.clientKey] = result.prediction;
                }
              });
              _this18.selectedRows.forEach(function (row) {
                var prediction = predictionByKey[String(row.data.Id)];
                // null categoryId means no prediction (miss/short-circuit): leave the field empty.
                if (!prediction || prediction.categoryId == null) return;
                // Re-check eligibility so a row the user coded while the batch was in flight is never clobbered.
                if (!_this18.isRowEligibleForPrediction(row)) return;
                var option = _this18.findPredictedCategoryOption(prediction.categoryId, prediction.subCategoryId);
                if (option) {
                  _this18.applyPredictedCategoryToRow(row, option);
                }
              });
              _context13.next = 26;
              break;
            case 24:
              _context13.prev = 24;
              _context13.t0 = _context13["catch"](12);
            case 26:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[12, 24]]);
      }))();
    },
    // A row is eligible for prediction when it is not already coded (its first split carries no Category).
    isRowEligibleForPrediction: function isRowEligibleForPrediction(row) {
      return !!(row && row.data && row.form && row.form[0] && !row.form[0].Category);
    },
    // Apply a matched dropdown option to the row's first split, filling Reference Id from the option
    // exactly as the manual category pick does in the template.
    applyPredictedCategoryToRow: function applyPredictedCategoryToRow(row, option) {
      this.$set(row.form[0], 'Category', option);
      this.$set(row.form[0], 'ReferenceId', option && option.referenceId ? option.referenceId : null);
      this.$set(row.form[0], 'isPredicted', !!(this.allowPredictiveCoding && option));
      this.$forceUpdate();
    },
    // Match a predicted categoryId/subCategoryId pair to a dropdown option by its composite key.
    // Options carry key = `${categoryId}_${subCategoryId}` when a subcategory is present, else `${categoryId}`.
    findPredictedCategoryOption: function findPredictedCategoryOption(categoryId, subCategoryId) {
      var key = subCategoryId != null ? "".concat(categoryId, "_").concat(subCategoryId) : "".concat(categoryId);
      return this.categories.find(function (option) {
        return option.key === key;
      });
    },
    handleSupplierSelection: function handleSupplierSelection(option, index) {
      if (option) {
        this.supplierIds[index] = option.Value.VendorId;
        this.supplierIncomplete[index] = false;
      }
    },
    fetchSuppliersOnOpen: function fetchSuppliersOnOpen() {
      var _this19 = this;
      this.suppliers.length || this.api.get(this.api.$.evedpaycard.suppliers, {
        params: {
          q: ''
        }
      }).then(function (r) {
        if (r && r.data) {
          _this19.supplierOptions = r.data;
          _this19.originalSuppliers = r.data;
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    getReconcile: function getReconcile(row, index) {
      var _this20 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee14() {
        var rowData, response, supplierName;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this20.programs = [];
              rowData = row.data;
              _context14.next = 4;
              return _this20.api.get('evedpaycards/transactions/get-reconcile', {
                params: {
                  transactionId: rowData.Id,
                  divisionId: rowData.DivisionId
                }
              });
            case 4:
              response = _context14.sent;
              if (rowData.Supplier || rowData.NonEvedSupplier) {
                supplierName = rowData.Supplier ? "".concat(rowData.Supplier, " (#").concat(rowData.SupplierEoNumber, ")") : rowData.NonEvedSupplier;
                _this20.selectedSuppliers[index] = {
                  Key: rowData.VendorId,
                  Value: {
                    CompanyName: supplierName,
                    VendorId: rowData.SupplierId || -rowData.SupplierNetworkId
                  }
                };
              }
              if (response && response.data) {
                _this20.descriptions[index] = response.data.ReconcileNote;
                if (response.data.TransactionFiles.length > 0) {
                  _this20.attachments[index] = response.data.TransactionFiles;
                }
                // PRODUCTDEV-5783 — hydrate additional documents from the same reconcile response.
                _this20.$set(_this20.additionalDocuments, index, response.data.AdditionalDocuments || []);
                _this20.$forceUpdate();
                _this20.setRowFieldsValues(response.data.TransactionFields, row, index);
              }
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    setAllRowsFields: function setAllRowsFields(reconciledMap) {
      var _this21 = this;
      if (this.loadedCategoriesAndBuAndCc === 0) {
        setTimeout(function () {
          _this21.setAllRowsFields(reconciledMap);
        }, 100);
        return;
      }
      this.loadedCategoriesAndBuAndCc = -1;
      this.selectedRows.forEach(function (row, i) {
        var id = row.data.Id;
        if (reconciledMap[id]) {
          _this21.setRowFieldsValues(reconciledMap[id].TransactionFields, row, i);
        }
        _this21.handleSplitAmounts(i);
      });

      // Existing reconcile values are now applied and the dropdown options are loaded,
      // so each row's coded/un-coded state is known. Attempt the silent batch prefill once on open.
      this.prefillCategoriesFromPredictionBatch();
    },
    setRowFieldsValues: function setRowFieldsValues(fieldsValues, row, rowIndex) {
      var _this22 = this;
      try {
        var existingRow = row.form[0];
        while (row.form.length < fieldsValues.length) {
          var newRow = existingRow.map(function (field) {
            return {
              Key: field.Key,
              Label: field.Label,
              Values: '',
              Required: field.Required,
              Type: field.Type
            };
          });
          row.form.splice(rowIndex + 1, 0, newRow);
          this.splitCounters[rowIndex]++;
        }
        fieldsValues.forEach(function (r, index) {
          row.form[index].Amount = r.Amount;
          row.form[index].ItemId = r.ItemId;
          // PRODUCTDEV-5783 — hydrate the per-split description. GetTransactionFieldsValues
          // already projects Description = split-item.Description, so reopen is FE-only.
          _this22.$set(row.form[index], 'Description', r.Description || '');
          if (_this22.hasBuAndCcPair) {
            if (r.ProgramBusinessUnitAndCostCenter && r.ProgramBusinessUnitAndCostCenter.Id) {
              row.form[index].BuAndCcPair = _this22.buAndCcPairs.find(function (pair) {
                return pair.programBusinessUnitAndCostCenterId === r.ProgramBusinessUnitAndCostCenter.Id.toString();
              });
            }
          } else {
            if (r.BusinessUnit && r.BusinessUnit.Id) {
              row.form[index].BusinessUnit = _this22.businessUnits.find(function (bu) {
                return bu.businessUnitId === r.BusinessUnit.Id.toString();
              });
            }
            if (r.CostCenter && r.CostCenter.Id) {
              row.form[index].CostCenter = _this22.costCenters.find(function (cc) {
                return cc.costCenterId === r.CostCenter.Id.toString();
              });
            }
          }
          if (r.CategoryId) {
            row.form[index].Category = _this22.categories.find(function (c) {
              return c.key === r.CategoryId.toString();
            });
            row.form[index].ReferenceId = r.ReferenceId;
          }
          r.CustomFields.forEach(function (field) {
            row.form[index].forEach(function (f) {
              if (f.Key === field.FieldId) {
                if (f.Type === 'select') {
                  var matchedOption = _this22.customOptions[f.Key].find(function (x) {
                    return x.text === field.Value;
                  });
                  if (matchedOption) {
                    _this22.$set(f, 'Values', matchedOption);
                  }
                } else {
                  f.Values = row && row.data && row.data.ReconcileId ? field.Value : f.Values;
                }
              }
            });
          });
          _this22.$forceUpdate();
        });
        this.handleSplitAmounts(rowIndex);
      } catch (error) {
        console.error("Error fetching field values for row ".concat(row.data.Id, ":"), error);
      }
    },
    fetchSuppliers: function fetchSuppliers(query) {
      var _this23 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee15() {
        var results;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return _this23.api.get(_this23.api.$.evedpaycard.suppliers, {
                params: {
                  q: query || ''
                }
              });
            case 2:
              results = _context15.sent;
              if (results && results.data) {
                _this23.supplierOptions = results.data;
              }
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    getSelectedSupplier: function getSelectedSupplier(e) {
      this.selectedSupplier = e.Value.VendorId;
    },
    handleTransaction: function handleTransaction(fullTransactionObject) {
      var _this24 = this;
      if (!this.selectedProgram || Object.keys(this.selectedProgram).length === 0) {
        if (fullTransactionObject && fullTransactionObject.data && fullTransactionObject.data.ProgramId) {
          this.$nextTick(function () {
            _this24.$notifications.notify({
              type: 'plain',
              icon: 'exclamation-circle',
              placement: {
                from: 'top',
                align: 'center'
              },
              timeout: 0,
              goto: '',
              message: "By selecting this transaction, you are about to select the following ".concat(_this24.programName.toLowerCase(), " '").concat(fullTransactionObject.data.ProgramName, "'. Do you want to proceed?"),
              dismiss: 'Yes',
              discard: 'No',
              onClose: function onClose(dismiss) {
                if (dismiss === 'Yes') {
                  _this24.addTransaction(fullTransactionObject);
                } else {
                  return;
                }
              }
            });
          });
        } else {
          this.addTransaction(fullTransactionObject);
        }
      } else {
        this.addTransaction(fullTransactionObject);
      }
    },
    addTransaction: function addTransaction(fullTransactionObject) {
      var _this25 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee16() {
        var formArray, firstElement, copiedFirstElement;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!(fullTransactionObject && fullTransactionObject.data)) {
                _context16.next = 27;
                break;
              }
              if (!fullTransactionObject.data.ProgramId) {
                _context16.next = 5;
                break;
              }
              _this25.selectedProgram = {
                Id: fullTransactionObject.data.ProgramId,
                Name: fullTransactionObject.data.ProgramName
              };
              _context16.next = 5;
              return _this25.getCategoriesAndBuAndCc(fullTransactionObject.data.ProgramId);
            case 5:
              formArray = _this25.selectedRows[0].form; // Create a deep copy of the first element and clear the Values property
              firstElement = formArray[0];
              copiedFirstElement = firstElement.map(function (field) {
                return _objectSpread(_objectSpread({}, field), {}, {
                  Values: ''
                });
              }); // Set default values
              _this25.baseCustomFields.forEach(function (baseObj, baseIndex) {
                if (copiedFirstElement[baseIndex]) {
                  Object.keys(baseObj).forEach(function (key) {
                    copiedFirstElement[baseIndex][key] = baseObj[key];
                  });
                }
              });

              // Set the copied form array back to the reactive data
              _this25.copiedForm = [copiedFirstElement];
              fullTransactionObject.form = _this25.copiedForm;
              fullTransactionObject.form.Amount = fullTransactionObject.data.Amount;
              _this25.selectedRows.push(fullTransactionObject);
              _this25.splitCounters.push(1);
              _this25.wrongSplitTotal.push(false);
              _this25.supplierIncomplete.push(false);
              _this25.descriptionIncomplete.push(false);
              _this25.attachmentIncomplete.push(false);
              _this25.ccIncomplete.push(false);
              _this25.buIncomplete.push(false);
              _this25.buAndCcPairIncomplete.push(false);
              _this25.categoryIncomplete.push(false);
              _this25.customFieldIncomplete.push(false);
              _this25.descriptions.push(null);
              _this25.selectedSuppliers.push(null);
              _this25.attachments.push(null);
              _this25.getReconcile(fullTransactionObject, _this25.selectedRows.length - 1);
            case 27:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    getLabel: function getLabel(option) {
      return option.Value.CompanyName + (option.Value.Vci ? ' (#' + option.Value.Vci + ')' : '');
    },
    prepareEnvelope: function prepareEnvelope(isSent) {
      var _this26 = this;
      if (this.selectedRows.length === 0) {
        console.error('No data');
        return;
      }
      var selectedData = this.selectedRows.map(function (row) {
        return row.data;
      });
      var minDate = this.parseJsonDate(selectedData[0].TransactionDate);
      var maxDate = this.parseJsonDate(selectedData[0].TransactionDate);
      selectedData.forEach(function (x) {
        var transactionDate = _this26.parseJsonDate(x.TransactionDate);
        if (transactionDate < minDate) minDate = transactionDate;
        if (transactionDate > maxDate) maxDate = transactionDate;
      });
      var forms = new Array(this.selectedRows.length).fill(null);
      this.selectedRows.forEach(function (row, rowIndex) {
        if (row.form && row.form[0] && Array.isArray(row.form[0])) {
          var itemIds = row.form.map(function (item) {
            return item.ItemId;
          });
          var formCopy = JSON.parse(JSON.stringify(row.form));
          var updatedFields = formCopy.map(function (i) {
            return i.map(function (x) {
              if (x.Type === 'select' && x.Values && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(x.Values) === 'object') {
                x.Values = x.Values.text;
              } else if (x.Type === 'text' && x.Values && Array.isArray(x.Values) && x.Values.length > 0) {
                x.Values = x.Values[0];
              }
              return x;
            });
          });
          var form = {
            Fields: updatedFields,
            CategoryIds: row.form.map(function (i) {
              return i && i.Category && i.Category.key;
            }),
            ReferenceIds: row.form.map(function (i) {
              return i && i.ReferenceId;
            }),
            BusinessUnitIds: row.form.map(function (i) {
              return i && i.BusinessUnit && i.BusinessUnit.businessUnitId;
            }).some(function (value) {
              return value !== null && value !== undefined;
            }) ? row.form.map(function (i) {
              return i && i.BusinessUnit && i.BusinessUnit.businessUnitId;
            }) : [],
            CostCenterIds: row.form.map(function (i) {
              return i && i.CostCenter && i.CostCenter.costCenterId;
            }).some(function (value) {
              return value !== null && value !== undefined;
            }) ? row.form.map(function (i) {
              return i && i.CostCenter && i.CostCenter.costCenterId;
            }) : [],
            ProgramBusinessUnitAndCostCenterIds: row.form.map(function (i) {
              return i && i.BuAndCcPair && i.BuAndCcPair.programBusinessUnitAndCostCenterId;
            }).some(function (value) {
              return value !== null && value !== undefined;
            }) ? row.form.map(function (i) {
              return i && i.BuAndCcPair && i.BuAndCcPair.programBusinessUnitAndCostCenterId;
            }) : [],
            Amounts: _this26.splitAmounts[rowIndex],
            // PRODUCTDEV-5783 — per-split descriptions, parallel to Amounts. SaveTransactionFields
            // maps form.Descriptions?[i] → split-item Description (the same column reconcile persists).
            // Length matches Amounts (same row.form), so the indexed read in Legacy is safe.
            Descriptions: row.form.map(function (i) {
              return i && i.Description;
            }),
            TransactionReconcileSplitItemIds: itemIds
          };
          forms[rowIndex] = form;
        }
      });
      this.newEnvelope = {
        Id: this.envelope ? this.envelope.Id : null,
        IsSent: isSent,
        IsAppovalFromEditView: this.IsAppovalFromEditView,
        CardId: this.selectedRows[0].data.CardId,
        ProgramId: this.selectedProgram ? this.selectedProgram.Id : null,
        StartDate: global.moment(minDate).format('YYYY-MM-DD'),
        EndDate: global.moment(maxDate).format('YYYY-MM-DD'),
        Amount: this.calculatedTotalAmount,
        TransactionIds: this.selectedRows.map(function (row) {
          return row.data.Id;
        }),
        SupplierIds: this.selectedSuppliers.map(function (supplier) {
          return supplier && supplier.Value && supplier.Value.VendorId ? supplier.Value.VendorId : null;
        }),
        Descriptions: this.descriptions,
        ReceiptFiles: this.attachments.map(function (att) {
          return att && att.length > 0 ? att : [{
            Empty: true
          }];
        }),
        // PRODUCTDEV-5783 — per-transaction additional documents (parallel to ReceiptFiles).
        // Send null (NOT []) for rows we never hydrated/managed so SyncReconcileDocuments no-ops
        // and PRESERVES existing docs; an explicit [] (user removed them) still soft-deletes.
        AdditionalDocuments: this.additionalDocuments.map(function (docs) {
          return Array.isArray(docs) ? docs : null;
        }),
        CategoryIds: this.selectedRows.map(function (row) {
          return row.form.map(function (i) {
            return i && i.Category && i.Category.key;
          });
        }),
        ReferenceIds: this.selectedRows.map(function (row) {
          return row.form.map(function (i) {
            return i && i.ReferenceId;
          });
        }),
        BusinessUnitIds: this.selectedRows.map(function (row) {
          return row.form.map(function (i) {
            return i && i.BusinessUnit && i.BusinessUnit.businessUnitId;
          });
        }),
        CostCenterIds: this.selectedRows.map(function (row) {
          return row.form.map(function (i) {
            return i && i.CostCenter && i.CostCenter.costCenterId;
          });
        }),
        BusinessUnitAndCostCenterIds: this.selectedRows.map(function (row) {
          return row.form.map(function (i) {
            return i && i.BuAndCcPair && i.BuAndCcPair.programBusinessUnitAndCostCenterId;
          });
        }),
        Forms: forms,
        FormKey: this.formKey,
        SplitAmounts: this.splitAmounts
      };
    },
    handleProgramChange: function handleProgramChange(option) {
      var _this27 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee17() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _this27.selectedProgram = option !== null ? option : Object;
              _this27.resetSplit();
              if (!(option && option.Id)) {
                _context17.next = 6;
                break;
              }
              _context17.next = 5;
              return _this27.getCategoriesAndBuAndCc(option.Id);
            case 5:
              // PRODUCTDEV-5699 — same interactive-program gap as the single reconcile screen:
              // the load-path batch (setAllRowsFields) only runs for rows that carried a program
              // at open, so an envelope whose program is picked here never predicted.
              // getCategoriesAndBuAndCc just refreshed allowPredictiveCoding for this program's
              // division and resetSplit cleared every row, so the batch's division / eligibility /
              // no-clobber gates all hold — re-fire it once.
              _this27.prefillCategoriesFromPredictionBatch();
            case 6:
              _this27.programIncomplete = false;
            case 7:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    handleProgramInput: function handleProgramInput(option) {
      if (this.previousSelectedProgram && option && this.previousSelectedProgram.Id === option.Id) {
        return;
      }
      this.programOption = option;
      if (this.previousSelectedProgram && this.previousSelectedProgram.Id && this.previousSelectedProgram.Name) {
        this.showAlertProgram = true;
      } else {
        this.handleProgramChange(option);
      }
    },
    onSelectProgramOpen: function onSelectProgramOpen() {
      this.programLoader.searchTerm = '';
      this.loadPrograms(true);
    },
    onProgramSearch: function onProgramSearch(term) {
      this.programLoader.searchTerm = term;
      this.loadPrograms(true);
    },
    loadPrograms: function loadPrograms() {
      var _arguments2 = arguments,
        _this28 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee18() {
        var reset, loader, _yield$_this28$api$ge, data, Items, HasMore, mapped;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              reset = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;
              loader = _this28.programLoader;
              if (!loader.isLoading) {
                _context18.next = 4;
                break;
              }
              return _context18.abrupt("return");
            case 4:
              if (reset) {
                loader.pageIndex = 0;
                loader.items = [];
                loader.hasMore = true;
              }
              if (loader.hasMore) {
                _context18.next = 7;
                break;
              }
              return _context18.abrupt("return");
            case 7:
              loader.isLoading = true;
              _context18.prev = 8;
              _context18.next = 11;
              return _this28.api.get(_this28.api.$.evedpaycard.programs, {
                params: {
                  divisionId: _this28.selectedRows[0].data.DivisionId,
                  pageIndex: loader.pageIndex,
                  pageSize: _this28.pageSize,
                  searchTerm: loader.searchTerm
                }
              });
            case 11:
              _yield$_this28$api$ge = _context18.sent;
              data = _yield$_this28$api$ge.data;
              Items = data.Items, HasMore = data.HasMore;
              mapped = Items.map(function (p) {
                return {
                  Id: p.ProgramId,
                  Name: p.ProgramName,
                  InternalProgramID: p.InternalProgramID
                };
              });
              loader.items = reset ? mapped : loader.items.concat(mapped);
              loader.hasMore = HasMore;
              loader.pageIndex += 1;
              _this28.programOptions = loader.items;
              _context18.next = 24;
              break;
            case 21:
              _context18.prev = 21;
              _context18.t0 = _context18["catch"](8);
              console.error('loadPrograms error', _context18.t0);
            case 24:
              _context18.prev = 24;
              loader.isLoading = false;
              return _context18.finish(24);
            case 27:
            case "end":
              return _context18.stop();
          }
        }, _callee18, null, [[8, 21, 24, 27]]);
      }))();
    },
    fillEnvelopeData: function fillEnvelopeData() {
      var _this29 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee19() {
        var divisionId, transactionIds, params, response, reconciledMap, _iterator2, _step2, x;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!(!_this29.selectedRows || _this29.selectedRows.length === 0)) {
                _context19.next = 2;
                break;
              }
              return _context19.abrupt("return");
            case 2:
              divisionId = _this29.selectedRows[0].data.DivisionId;
              transactionIds = _this29.selectedRows.map(function (row) {
                return row.data.Id;
              });
              params = {
                transactionIds: transactionIds.join('_'),
                divisionId: divisionId
              };
              if (_this29.envelope && _this29.envelope.Id) {
                params.envelopeId = _this29.envelope.Id;
              }
              _context19.next = 8;
              return _this29.api.get('evedpaycards/transactions/get-envelope', {
                params: params
              });
            case 8:
              response = _context19.sent;
              if (!(response && response.data)) {
                _context19.next = 42;
                break;
              }
              _this29.requireReceiptDescription = response.data.RequireReceiptDescription;
              _this29.isCategoryRequired = response.data.IsCategoryRequired;
              _this29.handleFormFieldsAndTemplate(response.data.Form);
              _this29.Approvers = response.data.ApproversData;
              _this29.ApprovalNeeded = response.data.WaitingApprovalUsers;
              _this29.resubmittedDate = response.data.ResubmittedDate || null;
              if (_this29.splitCounters.length === 0) {
                _this29.splitCounters = new Array(_this29.selectedRows.length).fill(1);
              } else if (_this29.splitCounters.length < _this29.selectedRows.length) {
                _this29.splitCounters.push(1);
              }
              if (_this29.additionalDocuments.length === 0) {
                _this29.additionalDocuments = new Array(_this29.selectedRows.length).fill(null);
              }
              if (_this29.scanningRows.length === 0) {
                _this29.scanningRows = new Array(_this29.selectedRows.length).fill(false);
              }
              reconciledMap = response.data.ReconciledTransactions;
              _this29.selectedRows.forEach(function (row, i) {
                var id = row.data.Id;
                if (reconciledMap[id]) {
                  _this29.descriptions[i] = reconciledMap[id].ReconcileNote;
                  _this29.attachments[i] = reconciledMap[id].TransactionFiles;
                  // PRODUCTDEV-5783 — hydrate additional documents for this transaction.
                  _this29.$set(_this29.additionalDocuments, i, reconciledMap[id].AdditionalDocuments || []);
                  _this29.$forceUpdate();
                }
              });
              _iterator2 = _createForOfIteratorHelper(_this29.form[0]);
              _context19.prev = 22;
              _iterator2.s();
            case 24:
              if ((_step2 = _iterator2.n()).done) {
                _context19.next = 33;
                break;
              }
              x = _step2.value;
              if (!(x.Type === 'select')) {
                _context19.next = 31;
                break;
              }
              _this29.$set(_this29.customOptions, x.Key, []);
              if (!(x.DataSource && x.DataSource.Url)) {
                _context19.next = 31;
                break;
              }
              _context19.next = 31;
              return _this29.getCustomOptions(x.DataSource.Url, x.Key);
            case 31:
              _context19.next = 24;
              break;
            case 33:
              _context19.next = 38;
              break;
            case 35:
              _context19.prev = 35;
              _context19.t0 = _context19["catch"](22);
              _iterator2.e(_context19.t0);
            case 38:
              _context19.prev = 38;
              _iterator2.f();
              return _context19.finish(38);
            case 41:
              _this29.setAllRowsFields(reconciledMap);
            case 42:
            case "end":
              return _context19.stop();
          }
        }, _callee19, null, [[22, 35, 38, 41]]);
      }))();
    },
    handleFormFieldsAndTemplate: function handleFormFieldsAndTemplate(form) {
      this.formKey = form.Key;
      if (form.Fieldsets && form.Fieldsets.length > 0) {
        this.form = [form.Fieldsets[0].Fields];
        this.baseCustomFields = JSON.parse(JSON.stringify(form.Fieldsets[0].Fields));
      } else {
        this.form = [[]];
        this.baseCustomFields = [[]];
      }
      this.formsTemplate();
    },
    removeTransaction: function removeTransaction(index) {
      var _this30 = this;
      if (this.selectedRows[index] && this.selectedRows[index].form) {
        this.selectedRows[index].form.forEach(function (row) {
          _this30.$set(row, 'isPredicted', false);
        });
      }
      this.selectedRows.splice(index, 1);
      this.selectedSuppliers.splice(index, 1);
      this.descriptions.splice(index, 1);
      this.splitCounters.splice(index, 1);
      this.splitAmounts.splice(index, 1);
      this.wrongSplitTotal.splice(index, 1);
      this.supplierIncomplete.splice(index, 1);
      this.ccIncomplete.splice(index, 1);
      this.buIncomplete.splice(index, 1);
      this.buAndCcPairIncomplete.splice(index, 1);
      this.categoryIncomplete.splice(index, 1);
      this.customFieldIncomplete.splice(index, 1);
      this.descriptionIncomplete.splice(index, 1);
      this.attachments.splice(index, 1);
      this.additionalDocuments.splice(index, 1);
      this.scanningRows.splice(index, 1);
      this.$forceUpdate();
    },
    stopCreateEnvelope: function stopCreateEnvelope() {
      this.preventCreateEnvelope = false;
    },
    validateBeforeApprove: function validateBeforeApprove() {
      var _this31 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee20() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return _this31.validateEnvelope(true);
            case 2:
              _this31.showApproveDialog = _context20.sent;
              _this31.preventCreateEnvelope = false;
            case 4:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    validateEnvelope: function validateEnvelope(isSent) {
      var _this32 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee21() {
        var validatedTransactionsAmounts, _loop, index;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee21$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (!_this32.preventCreateEnvelope) {
                _context22.next = 2;
                break;
              }
              return _context22.abrupt("return");
            case 2:
              _this32.preventCreateEnvelope = true;
              _this32.resetValidation();
              if (!isSent) {
                _context22.next = 17;
                break;
              }
              if (!_this32.selectedProgram || Object.keys(_this32.selectedProgram).length === 0) {
                _this32.programIncomplete = true;
                _this32.hasIncompleteField = true;
              } else {
                _this32.programIncomplete = false;
              }

              // PRODUCTDEV-5809 — restore the pre-V2 amount guard. Sync each row's splitAmounts from
              // its coding form first (so the payload reflects what's on screen), then ask the server
              // whether every row's splits sum to its transaction amount. Server check = exact decimal
              // equality, fail-closed: an imperfect/empty scan must be corrected, not submitted.
              _this32.selectedRows.forEach(function (_, i) {
                return _this32.handleSplitAmounts(i);
              });
              _context22.next = 9;
              return _this32.validateAmounts();
            case 9:
              validatedTransactionsAmounts = _context22.sent;
              _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _loop() {
                var row, validatedTransaction;
                return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _loop$(_context21) {
                  while (1) switch (_context21.prev = _context21.next) {
                    case 0:
                      row = _this32.selectedRows[index];
                      _this32.supplierIncomplete[index] = false;
                      if (!_this32.descriptions[index] && _this32.requireReceiptDescription) {
                        _this32.descriptionIncomplete[index] = true;
                        _this32.hasIncompleteField = true;
                      } else {
                        _this32.descriptionIncomplete[index] = false;
                      }
                      row.form.some(function (item) {
                        return !item || !item.BusinessUnit || item.BusinessUnit === null;
                      }) && _this32.hasBu && !_this32.hasBuAndCcPair ? _this32.buIncomplete[index] = _this32.hasIncompleteField = true : _this32.buIncomplete[index] = false;
                      row.form.some(function (item) {
                        return !item || !item.CostCenter || item.CostCenter === null;
                      }) && _this32.hasCc && !_this32.hasBuAndCcPair ? _this32.ccIncomplete[index] = _this32.hasIncompleteField = true : _this32.ccIncomplete[index] = false;
                      row.form.some(function (item) {
                        return !item || !item.BuAndCcPair || item.BuAndCcPair === null;
                      }) && _this32.hasBuAndCcPair ? _this32.buAndCcPairIncomplete[index] = _this32.hasIncompleteField = true : _this32.buAndCcPairIncomplete[index] = false;
                      if (_this32.isCategoryRequired) {
                        row.form.some(function (item) {
                          return !item || !item.Category || item.Category === null;
                        }) ? _this32.categoryIncomplete[index] = _this32.hasIncompleteField = true : _this32.categoryIncomplete[index] = false;
                      } else {
                        _this32.categoryIncomplete[index] = false;
                      }
                      row.form.some(function (item) {
                        return item.some(function (field) {
                          return field && field.Required && (!field.Values || field.Values.length === 0);
                        });
                      }) ? _this32.customFieldIncomplete[index] = _this32.hasIncompleteField = true : _this32.customFieldIncomplete[index] = false;

                      // PRODUCTDEV-5809 — block submit/approve when this row's coding amounts don't sum to
                      // the transaction amount (reverts PRODUCTDEV-5783's informational-only behavior). If the
                      // receipt truly belongs to the transaction the totals must match to the cent; otherwise
                      // it's a scan error the user must correct rather than leave on submit.
                      validatedTransaction = validatedTransactionsAmounts && validatedTransactionsAmounts.length ? validatedTransactionsAmounts.find(function (t) {
                        return t.TransactionId === row.data.Id;
                      }) : null;
                      if (validatedTransaction && validatedTransaction.IsValid) {
                        _this32.wrongSplitTotal[index] = false;
                      } else {
                        // Block via the dedicated amount flag, NOT hasIncompleteField — otherwise the generic
                        // "complete all required fields" banner also fires when the only problem is the total.
                        _this32.wrongSplitTotal[index] = true;
                        _this32.hasWrongSplitTotal = true;
                      }
                      _this32.$forceUpdate();
                      if (!_this32.attachments[index] || _this32.attachments[index].length === 0) {
                        _this32.attachmentIncomplete[index] = true;
                        _this32.receiptIncomplete = true;
                      } else {
                        _this32.attachmentIncomplete[index] = false;
                      }
                    case 12:
                    case "end":
                      return _context21.stop();
                  }
                }, _loop);
              });
              index = 0;
            case 12:
              if (!(index < _this32.selectedRows.length)) {
                _context22.next = 17;
                break;
              }
              return _context22.delegateYield(_loop(), "t0", 14);
            case 14:
              index++;
              _context22.next = 12;
              break;
            case 17:
              if (!(_this32.hasIncompleteField || _this32.receiptIncomplete || _this32.hasWrongSplitTotal)) {
                _context22.next = 19;
                break;
              }
              return _context22.abrupt("return", _this32.stopCreateEnvelope());
            case 19:
              return _context22.abrupt("return", true);
            case 20:
            case "end":
              return _context22.stop();
          }
        }, _callee21);
      }))();
    },
    // PRODUCTDEV-5809 — server-side amount validation (restored from before the V2 receipt-capture
    // work). Posts each row's transaction total + its split amounts; the server returns IsValid per
    // transaction (SplitAmounts.Sum() == TotalAmount, exact decimal equality). Fail-closed: an empty
    // result marks every row invalid so a backend hiccup blocks submit instead of letting a
    // mismatched envelope through.
    validateAmounts: function validateAmounts() {
      var _this33 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee22() {
        var transactionsToValidate, response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee22$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;
              transactionsToValidate = _this33.selectedRows.map(function (row, i) {
                var splits = Array.isArray(_this33.splitAmounts[i]) ? _this33.splitAmounts[i] : [_this33.splitAmounts[i]];
                return {
                  TransactionId: row.data.Id,
                  TotalAmount: row.data.Amount,
                  // Coerce blank/empty amounts to 0: the server model is List<decimal> (non-nullable), so a
                  // null would throw on deserialize. A blank coding line is effectively $0, so it still fails
                  // the sum and blocks (intended) — but cleanly, per-row, instead of fail-closing every row.
                  SplitAmounts: splits.map(function (v) {
                    var n = parseFloat(v);
                    return isNaN(n) ? 0 : n;
                  })
                };
              });
              _context23.next = 4;
              return _this33.api.post('evedpaycards/transactions/validate-amounts', {
                transactions: transactionsToValidate
              });
            case 4:
              response = _context23.sent;
              if (response.data) {
                _context23.next = 7;
                break;
              }
              throw new Error('Error during the request');
            case 7:
              return _context23.abrupt("return", response.data);
            case 10:
              _context23.prev = 10;
              _context23.t0 = _context23["catch"](0);
              console.error('Error verifying the amounts:', _context23.t0);
              return _context23.abrupt("return", []);
            case 14:
            case "end":
              return _context23.stop();
          }
        }, _callee22, null, [[0, 10]]);
      }))();
    },
    isCustomFieldInvalid: function isCustomFieldInvalid(field, index) {
      return (!field.Values || field.Values.length === 0) && field.Required && this.customFieldIncomplete[index];
    },
    createEnvelope: function createEnvelope() {
      var _arguments3 = arguments,
        _this34 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee23() {
        var isSent, response, payload, message;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee23$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              isSent = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : false;
              _context24.next = 3;
              return _this34.validateEnvelope(isSent);
            case 3:
              if (_context24.sent) {
                _context24.next = 5;
                break;
              }
              return _context24.abrupt("return");
            case 5:
              _this34.prepareEnvelope(isSent);
              _context24.prev = 6;
              _this34.newEnvelope.preventError = true;
              _context24.next = 10;
              return _this34.api.post(_this34.api.$.evedpaycard.envelope, _objectSpread({}, _this34.newEnvelope));
            case 10:
              response = _context24.sent;
              if (response.data) {
                _context24.next = 13;
                break;
              }
              throw new Error('Error during the request');
            case 13:
              _this34.programIncomplete = false;
              _this34.preventCreateEnvelope = false;
              _this34.selectedRows.forEach(function (row, rowIndex) {
                row.form.forEach(function (item, i) {
                  if (!item.ItemId) {
                    item.ItemId = response.data.TransationsItems[rowIndex].ItemIds[i];
                  }
                });
              });

              // PRODUCTDEV-5783 — now that the envelope is saved, run the deferred FolderSaved ->
              // Matched claim for any receipt picked from the folder this session (best-effort; a
              // failure just leaves the scan in the folder, never blocks the save). Mirrors reconcile.
              _this34.claimPendingFolderReceipts();
              if (isSent) {
                __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$emit('envelope-created', response.data.EnvelopeNumber);
                localStorage.setItem('row-highlight', response.data.Id);
                // Skip redirect when in approval flow - let approveOrReject handle it after the approval API call
                if (!_this34.IsAppovalFromEditView) {
                  _this34.envelope.FromDashboard || _this34.$route.query.IsApproveEnvelopeFromEmail === 'true' || _this34.$route.query.IsRejectEnvelopeFromEmail === 'true' ? (_this34.$emit('success'), _this34.goToDashboard()) : _this34.$emit('success');
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$emit('envelope-draft', response.data.EnvelopeNumber);
                _this34.envelope.FormattedLastModifiedDate = response.data.FormattedLastModifiedDate;
                _this34.envelope.Id = response.data.Id;
                _this34.envelope.EnvelopeNumber = response.data.EnvelopeNumber;
                _this34.envelope.EnvelopeStatus = response.data.EnvelopeStatus;
                _this34.draftSaved = true;
              }
              _context24.next = 26;
              break;
            case 20:
              _context24.prev = 20;
              _context24.t0 = _context24["catch"](6);
              console.error('Error during the request:', _context24.t0);
              // PRODUCTDEV-5574 — the envelope POST loops per-transaction CreateReconcileTransaction
              // calls, each in its own DB transaction, so a 403 EnvelopeEditBlocked can come from any
              // iteration. Surface the BE's blocked reason and the applied-count so the user knows
              // which transactions were persisted before the block instead of seeing a generic toast.
              payload = _context24.t0 && _context24.t0.response && _context24.t0.response.data || {};
              message = _this34.envelopeSaveBlockedMessage(payload);
              _this34.$notifications.notify({
                type: 'plain',
                icon: 'exclamation-circle',
                placement: {
                  from: 'top',
                  align: 'center'
                },
                timeout: 0,
                message: message,
                discard: 'Ok',
                goto: ''
              });
            case 26:
              _context24.prev = 26;
              _this34.preventCreateEnvelope = false;
              return _context24.finish(26);
            case 29:
            case "end":
              return _context24.stop();
          }
        }, _callee23, null, [[6, 20, 26, 29]]);
      }))();
    },
    envelopeSaveBlockedMessage: function envelopeSaveBlockedMessage(payload) {
      var reason = payload && payload.reason;
      var reasonMessage = this.reasonToMessage(reason);
      if (!reasonMessage) {
        return 'An error occurred while saving. Please try again.';
      }
      var appliedCount = payload && typeof payload.appliedCount === 'number' ? payload.appliedCount : 0;
      var totalCount = payload && typeof payload.totalCount === 'number' ? payload.totalCount : 0;
      // The CreateEnvelope endpoint is reached from two flows: brand-new envelope creation (no
      // envelope row exists yet when the 403 fires, so "refresh the envelope" would be wrong) and
      // submitter-resubmits-Declined-envelope. A neutral "refresh and verify" reads correctly in
      // both cases.
      if (appliedCount > 0 && totalCount > 0) {
        return "".concat(reasonMessage, " ").concat(appliedCount, " of ").concat(totalCount, " transaction").concat(totalCount === 1 ? '' : 's', " were saved before the request was blocked; please refresh and verify which transactions were saved.");
      }
      return reasonMessage;
    },
    reasonToMessage: function reasonToMessage(reason) {
      switch (reason) {
        case 'EnvelopePostedOrExported':
          return "This ".concat(this.envelopeTerm.lower, " has been posted or exported. Transactions in it can no longer be edited.");
        case 'NotAuthorized':
          return 'You do not have permission to edit one or more of these transactions.';
        case 'ProgramChangeNotAllowed':
          return "The ".concat((this.programName || 'department').toLowerCase(), " cannot be changed while the transaction is assigned to an ").concat(this.envelopeTerm.lower, ".");
        case 'EnvelopeNotFound':
        case 'TransactionNotFound':
          return 'We could not verify one of the selected transactions. Please refresh and try again.';
        default:
          return null;
      }
    },
    // PRODUCTDEV-5783 — deferred folder-receipt claim, called on envelope SAVE success.
    // For every saved receipt still in FolderSaved (i.e. picked from the folder and not yet
    // claimed), flip it FolderSaved -> Matched so it leaves the folder only once the envelope
    // is actually saved (cancel never strands it). Best-effort / fire-and-forget: a failed
    // claim just leaves the scan in the folder and never blocks the save. The getStatus gate
    // skips anything not FolderSaved, so an already-Matched (uploaded) receipt is a no-op —
    // no double-claim. Mirrors ReconcileTransaction.claimPendingFolderReceipts().
    claimPendingFolderReceipts: function claimPendingFolderReceipts() {
      var _this35 = this;
      if (!Array.isArray(this.selectedRows)) return;
      this.selectedRows.forEach(function (row, rowIndex) {
        var legacyTxId = row && row.data ? row.data.Id : null;
        var atts = _this35.attachments[rowIndex];
        if (!legacyTxId || !Array.isArray(atts)) return;
        atts.forEach(function (att) {
          var scanId = att && att.ReceiptScanId;
          if (!scanId) return;
          __WEBPACK_IMPORTED_MODULE_10__core_api_receiptScans__["b" /* default */].getStatus(scanId).then(function (statusData) {
            if (!statusData || statusData.status !== 'FolderSaved') return null;
            return __WEBPACK_IMPORTED_MODULE_10__core_api_receiptScans__["b" /* default */].claimReceipt(scanId, legacyTxId, statusData.rowVersion);
          }).catch(function (err) {
            console.warn('Deferred envelope folder-receipt claim failed (scan stays in folder):', err);
          });
        });
      });
    },
    updateAttachmentsFiles: function updateAttachmentsFiles(attachments, index) {
      this.attachments[index] = attachments;
      this.attachmentIncomplete[index] = false;
      var allFilesAttached = this.attachments.every(function (x) {
        return x && x.length > 0;
      });
      if (allFilesAttached) {
        this.receiptIncomplete = false;
      }
      this.$forceUpdate();
    },
    // PRODUCTDEV-5783 — receive the row's additional documents from AddReceipt and store
    // them per transaction (parent owns the canonical list, like `attachments`).
    updateAdditionalDocuments: function updateAdditionalDocuments(documents, index) {
      this.$set(this.additionalDocuments, index, documents);
    },
    // PRODUCTDEV-5783 — toggle the per-row "scanning" skeleton. Set true when AddReceipt's
    // Rescan starts Photon; cleared when the prefill lands (scan-ended) or the scan fails.
    setRowScanning: function setRowScanning(index, value) {
      this.$set(this.scanningRows, index, value);
    },
    showWarningMessage: function showWarningMessage() {
      var _this36 = this;
      this.$nextTick(function () {
        _this36.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: {
            from: 'top',
            align: 'center'
          },
          timeout: 0,
          message: "Please select a ".concat(_this36.programName.toLowerCase(), " before adding items"),
          discard: 'Ok',
          goto: ''
        });
      });
    },
    goToDashboard: function goToDashboard() {
      if (window.parent !== window) {
        window.parent.postMessage({
          type: 'LEGACY_GO_TO_DASHBOARD'
        }, '*');
        return;
      }
      var page = this.$route.params.page;
      if (backToMap[page]) {
        window.location.href = "".concat(this.api.env).concat(backToMap[page]);
      } else {
        this.$router.push('/d/Dashboard/MyDashboard');
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "jd/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"show":_vm.showModal,"validation":true,"type":"medium","title":"Edit AP File Template","primaryButton":"SAVE","secondary-button":"CANCEL","closeOnEsc":true},on:{"close":function($event){return _vm.$emit('close')},"validate":_vm.onSave}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('ed-form',{staticClass:"col-md-12",attrs:{"submit-visible":false}},[_c('section',{staticClass:"col-md-5 no-pad"}),_vm._v(" "),_c('section',{staticClass:"col-md-7 no-pad pull-right"},[_c('div',{staticClass:"row"},[_c('label',[_vm._v("AP File Template Name")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.model.Name))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ed-select-list',{attrs:{"field-label":"Divisions","endpoint":_vm.api.$.FundingInvoiceAndApSetting.getDivisionsForAPFileTemplates,"track-by":"DivisionId","label":"DivisionName","params":_vm.payload,"required":"","error":_vm.doDisplayDivisionsError,"helptip-header":_vm.doDisplayDivisionsError && 'Error' || '',"helptip-body":_vm.doDisplayDivisionsError && 'Please select a Division' || ''},on:{"select":_vm.selectDivision},model:{value:(_vm.divisions),callback:function ($$v) {_vm.divisions=$$v},expression:"divisions"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.doDisplayBUSelect)?_c('ed-select-list',{attrs:{"field-label":"Business Units","endpoint":_vm.api.$.FundingInvoiceAndApSetting.getBusinessUnitsForAPFileTemplates,"track-by":"Id","label":"Name","params":_vm.payload,"required":"","error":_vm.doDisplayBUError,"helptip-header":_vm.doDisplayBUError && 'Error' || '',"helptip-body":_vm.doDisplayBUError && 'Please select a Business Unit' || ''},on:{"select":_vm.selectBusinessUnit},model:{value:(_vm.businessUnits),callback:function ($$v) {_vm.businessUnits=$$v},expression:"businessUnits"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"clear"})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jfA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__core_events_events__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card',
  props: {
    useMeetingRequestor: Boolean,
    meetingRequesterName: String,
    rejectText: String,
    card: Object,
    programLabel: String,
    divisionLabel: String,
    lastEntry: Boolean
  },
  computed: {
    fullSupplierName: function fullSupplierName() {
      return this.card.SupplierEoNumber ? this.card.SupplierName + ' (' + this.card.SupplierEoNumber + ')' : this.card.SupplierName;
    },
    // Surface the custom Name on Card next to the holder ("Jane Doe | John Smith") when set and
    // meaningfully differs, mirroring the CardHolder.vue two-line layout the cards grid renders.
    // See PRODUCTDEV-5553 for the underlying pattern.
    holderDisplay: function holderDisplay() {
      var holder = (this.card.CardHolder || '').trim();
      var nameOnCard = (this.card.NameOnCard || '').trim();
      if (!nameOnCard || nameOnCard.toLowerCase() === holder.toLowerCase()) {
        return this.card.CardHolder;
      }
      if (!holder) {
        return nameOnCard;
      }
      return "".concat(nameOnCard, " | ").concat(holder);
    }
  },
  methods: {
    getEnvelope: function getEnvelope(envelopeId) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.api.forms.post(_this.api.$.evedpaycard.envelopes, {
                sort: 'CreatedDate',
                dir: 'ASC',
                start: 0,
                limit: 100,
                isLiveGrid: true,
                filter: JSON.stringify({
                  'EnvelopeId': envelopeId,
                  'Screen': 'Dashboard',
                  searchTerm: ''
                })
              });
            case 3:
              response = _context.sent;
              if (!(response && response.data)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", response.data.Data[0]);
            case 6:
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error('Error while retrieving envelopes:', _context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }))();
    },
    openEnvelope: function openEnvelope() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var envelopeIndex, envelopeId, envelope;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              envelopeIndex = _this2.card.Id.indexOf('ENVELOPE');
              envelopeId = '';
              if (envelopeIndex !== -1) {
                envelopeId = _this2.card.Id.substring(envelopeIndex + 'ENVELOPE'.length);
              }
              _context2.next = 5;
              return _this2.getEnvelope(envelopeId);
            case 5:
              envelope = _context2.sent;
              envelope.FromDashboard = true;
              if (!_this2.$user.$.userPermissions.includes('ApprovalDashboard')) {
                _context2.next = 12;
                break;
              }
              _context2.next = 10;
              return _this2.$router.push('/d/EnvelopeApprovalDashboard');
            case 10:
              _context2.next = 14;
              break;
            case 12:
              _context2.next = 14;
              return _this2.$router.push('/d/Programs/>Card/envelopes');
            case 14:
              _context2.next = 16;
              return __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.EVEDPAY_CARDS.OPEN_ENVELOPE, envelope);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
});

/***/ }),

/***/ "jjdZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"navbar-form navbar-right",attrs:{"role":"search"}},[_c('ed-input',{staticClass:"search-box",attrs:{"placeholder":_vm.$t("Search"),"search":""},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jkX1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("K6zE");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88ed79a6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("cfH+");
function injectStyle (ssrContext) {
  __webpack_require__("TAzg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88ed79a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88ed79a6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jly4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_Invoices_cells_statuses__ = __webpack_require__("MLM4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_Invoices_cells_attachments_details__ = __webpack_require__("3Tf6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_statuses__ = __webpack_require__("nBkH");



/* harmony default export */ __webpack_exports__["a"] = ({
  'InvoiceNumber': {
    label: 'Invoice',
    uid: 'Id',
    uri: '#/i/Invoices/sent/?goto=InvoiceDetail/{{id}}/0/send-invoices',
    onclick: 'setCookie("from_tab", "SentInvoices", "/")',
    width: 190
  },
  'ReferenceCode': {
    label: 'Supplier Invoice Number',
    width: 190,
    nowrap: false
  },
  'PONumber': {
    label: 'PO',
    width: 180
  },
  'EstimatedPaymentDateFormatted': {
    label: 'Estimated Payment Date',
    getter: __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_statuses__["j" /* customForCancelledOrRejected */],
    nowrap: false
  },
  'PaymentStatus': {
    label: 'Invoice Status',
    source: 'PaymentInvoiceList_ReceivedInvoices',
    render: __WEBPACK_IMPORTED_MODULE_0__components_modules_Invoices_cells_statuses__["a" /* default */],
    width: 300
  },
  'ClientName': {
    label: 'Client',
    uid: 'PoSenderVci',
    uri: '#/i/Invoices/Profile{{id}}-{{screen}}',
    tooltip: 'View profile of {{text}}'
  },
  'ProgramName': 'Project',
  'TotalAmount': {
    label: 'Amount',
    getter: __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_statuses__["l" /* hideForCancelledOrRejected */]
  },
  'DueDateWithinFormatted': {
    label: 'Due',
    getter: __WEBPACK_IMPORTED_MODULE_2__components_modules_Invoices_statuses__["l" /* hideForCancelledOrRejected */]
  },
  'DueDateWithin': '_',
  'MediaCount': {
    label: 'Attachments',
    detailsCondition: showAttachmentsExpandIcon,
    details: 'invoice.getAttachmentsDetails',
    detailsParamsURL: getAttachmentsDetailsParams,
    detailsComp: __WEBPACK_IMPORTED_MODULE_1__components_modules_Invoices_cells_attachments_details__["a" /* default */],
    visible: false
  },
  'CreatedBy': {
    label: 'Created By',
    visible: false
  },
  'CreatedByName': {
    label: 'Created By Name',
    visible: false
  },
  'EventName': {
    label: 'Event',
    visible: false
  },
  'FirstEventEndDateFormatted': {
    label: 'Event End Date',
    visible: false
  },
  'FirstEventStartDateFormatted': {
    label: 'Event Start Date',
    visible: false
  },
  'InvoiceDateFormatted': {
    label: 'Invoice Date',
    visible: false
  },
  'RemittanceInvoiceFormatted': {
    label: 'Payment Remittance Invoice',
    compose: remittanceInvoice,
    visible: false
  },
  'ProgramEndDateFormatted': {
    label: 'Project End Date',
    visible: false
  },
  'ProgramStartDateFormatted': {
    label: 'Project Start Date',
    visible: false
  },
  'ReqCode': {
    label: 'SAP PO',
    visible: false
  },
  'SupplierIDCode': {
    label: 'Supplier ID',
    visible: false
  }
});
function remittanceInvoice(p) {
  if (!p.data) return '';
  var url = "".concat(global.app.api.env, "/ProgramFusion/GenerateFundingInvoicePdf/").concat(p.value, "?fundingInvoiceID=").concat(p.data.RemittanceInvoiceID);
  var formattedValue = '';
  p.data.IsCreditInvoice ? p.data.RemittanceInvoiceCount === 1 ? formattedValue = "<a href=".concat(url, " target=\"_blank\" data-action=\"goto\">").concat(p.value, "</a>") : p.data.RemittanceInvoiceCount > 1 ? p.value : null : null;
  return formattedValue;
}
function showAttachmentsExpandIcon(params) {
  return params.data.MediaCount > 0;
}
function getAttachmentsDetailsParams(params) {
  return "/".concat(params.data.PaymentInvoiceID, "?") + "&poId=".concat(params.data.POID) + "&poVersionId=".concat(params.data.POVersionID) + "&poType=".concat(params.data.POType) + "&programid=".concat(params.data.ProgramID);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "jzUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{ref:"header",attrs:{"title":_vm.$t('Supplier Insurance Details'),"subtitle":_vm.subtitle}},[_c('Toolbar',{attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar-primary pull-right","disabled":!_vm.canVerify,"name":"save"},on:{"click":function($event){return _vm.save()}}},[_vm._v("Verify")])],1)],1),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"content no-flex- active"},[_c('ed-section',{staticClass:"no-flex active",attrs:{"title":"","wide-":""}},[_c('span',{attrs:{"slot":"description"},slot:"description"}),_vm._v(" "),_c('ed-form',{staticClass:"col-md-12 no-pad",attrs:{"submit-visible":false}},[_c('div',{staticClass:"col-md-12 no-pad"},[(_vm.supplier.DoesNotUseAuto !== null)?_c('div',{directives:[{name:"loading",rawName:"v-loading.2",value:(_vm.api.$.network.insuranceSupplierDetails),expression:"api.$.network.insuranceSupplierDetails",modifiers:{"2":true}}]},[_c('label',[_vm._v("Insurance Information")]),_vm._v(" "),_vm._l((_vm.insuranceDetails),function(detail,i){
var ref;
return (_vm.supplier.Name)?_c('ed-notice',_vm._b({key:i},'ed-notice',_vm.status(detail),false),[_c('div',{domProps:{"innerHTML":_vm._s((ref = detail.label).replace.apply(ref, _vm.certified(detail.status)))}})]):_vm._e()})],2):_vm._e(),_vm._v(" "),_c('ed-select',{staticClass:"col-md-4",attrs:{"name":"insurance-status-cmb","field-label":"Insurance Status","placeholder":"Select Insurance Status","options":_vm.insuranceStatuses,"required":"","helptip-body":"Please select a Insurance Status.","helptipHeader":""},model:{value:(_vm.supplier.InsuranceStatus),callback:function ($$v) {_vm.$set(_vm.supplier, "InsuranceStatus", $$v)},expression:"supplier.InsuranceStatus"}}),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),(_vm.showExpiration)?_c('ed-datepicker',{staticClass:"col-md-4 no-pad",attrs:{"name":"expiration-date","field-label":"Expiration Date","placeholder":"Select date","required":"","error":_vm.hasError,"helptip-body":_vm.error,"helptipHeader":""},model:{value:(_vm.supplier.ExpirationDate),callback:function ($$v) {_vm.$set(_vm.supplier, "ExpirationDate", $$v)},expression:"supplier.ExpirationDate"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),_c('grid',{ref:"InsuranceCertificatesGrid",attrs:{"model":_vm.SupplierCertificateModel,"endpoint":_vm.api.$.network.insuranceCertificates,"filter":{ Id: { filter: _vm.$route.query.Id } },"sort":{ CreatedDate: "desc" },"search":true,"resizing":false,"views":false,"checkboxes":false,"layout":"frame","fit-columns":"","footer":"","alias":"InsuranceCertificatesGrid","export-uri":"InsuranceSupplierCertificates/ExportList"}})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k0Nt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fileUploadComponent_vue__ = __webpack_require__("SiqJ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d59a9f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_fileUploadComponent_vue__ = __webpack_require__("Uqyy");
function injectStyle (ssrContext) {
  __webpack_require__("mRHZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fileUploadComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d59a9f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_fileUploadComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "k53z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_20yJWA3it2cZHXauMPI2Lo","Dell":"_3aCiQbZEkFARsYK0Xtbi-G","Abbott":"_2o9Lgxl_qtVMhPmiloXKnm","Gap":"_3mIeRtT-CwGNzo1w_jWYN5","Allstate":"_2yoxou53q8ouYrJ80netEk","Asurion":"_1Jg_YDlGbnfAOvkUf9W-ub","Invitae":"_1Whx1mEDjpwoUe2AXoIT9L","JWE":"_9SepzEfKStLDA_Czp8zZ1"};

/***/ }),

/***/ "k9gP":
/***/ (function(module, exports) {

module.exports = {"ApprovalHistoryId":"_","Action":{"label":"Action","width":200},"User":"User","Description":{"label":"Description","width":530},"CreatedDate":"Created"}

/***/ }),

/***/ "k9o7":
/***/ (function(module, exports) {

module.exports = {"MatchBusinessUnit":"Match Business Units","MatchCostCenter":"Match Cost Centers","OverridePreviousSteps":"May override previous steps","RequestEveryTime":"May request every time","UseHierarchyApproval":"Match Management Level"}

/***/ }),

/***/ "kFIn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"show":_vm.showModal,"validation":true,"type":"medium","title":_vm.title,"primaryButton":"SAVE","secondary-button":"CANCEL","closeOnEsc":true},on:{"close":function($event){return _vm.$emit('close')},"validate":_vm.onSave}},[_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('ed-form',{staticClass:"col-md-12 no-pad",attrs:{"submit-visible":false}},[_c('section',{staticClass:"col-md-5 no-pad"},[_c('p',[_vm._v("Address Information")])]),_vm._v(" "),_c('section',{staticClass:"col-md-7 pull-right"},[_c('div',{staticClass:"row"},[_c('ed-input',{attrs:{"field-label":"Entity Legal Name","placeholder":"Enter the Entity Legal Name","name":"legal_entity_name"},model:{value:(_vm.model.newAddress.EntityLegalName),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "EntityLegalName", $$v)},expression:"model.newAddress.EntityLegalName"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ed-input',{attrs:{"field-label":"Funding Entity Name","placeholder":"Enter the Funding Entity Name","required":"","error":_vm.doDisplayFundingEntityNameError,"helptip-header":_vm.doDisplayFundingEntityNameError && 'Error' || '',"helptip-body":_vm.doDisplayFundingEntityNameError && 'Please fill in Funding Entity Name' || '',"name":"funding_entity_name"},on:{"change":function($event){_vm.doDisplayFundingEntityNameError = false}},model:{value:(_vm.model.newAddress.FundingEntityName),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "FundingEntityName", $$v)},expression:"model.newAddress.FundingEntityName"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ed-input',{attrs:{"field-label":"Address","placeholder":"Enter Address","name":"address"},model:{value:(_vm.model.newAddress.Address),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "Address", $$v)},expression:"model.newAddress.Address"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ed-input',{attrs:{"field-label":"Address Line 2","placeholder":"Enter Address Line2","name":"address2"},model:{value:(_vm.model.newAddress.Address2),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "Address2", $$v)},expression:"model.newAddress.Address2"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ed-select',{attrs:{"field-label":"Country","placeholder":"Select a country...","options":_vm.countries,"label":"CountryName","track-by":"CountryID","openEndpoint":_vm.api.$.profile.getAllCountries,"name":"country"},on:{"select":function($event){return _vm.countrySelected($event)},"open":_vm.fetchCountriesOnOpen,"keyup":_vm.fetchCountries,"close":_vm.restoreCountries},model:{value:(_vm.model.newAddress.Country),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "Country", $$v)},expression:"model.newAddress.Country"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 no-pad"},[(_vm.isUS())?_c('ed-select',{attrs:{"field-label":"State","placeholder":"Select a state","options":_vm.USStates,"label":"StateName","track-by":"StateID","disabled":_vm.disableControls,"name":"us_states"},on:{"open":_vm.fetchUSStatesOnOpen,"keyup":_vm.fetchUSStates,"close":_vm.restoreUSStates},model:{value:(_vm.model.newAddress.State),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "State", $$v)},expression:"model.newAddress.State"}}):_vm._e(),_vm._v(" "),(_vm.isCanada())?_c('ed-select',{attrs:{"field-label":"State/Region","placeholder":"Select a region","options":_vm.canadaStates,"label":"StateName","track-by":"StateName","disabled":_vm.disableControls,"name":"canada_states"},on:{"open":_vm.fetchCanadaStatesOnOpen,"keyup":_vm.fetchCanadaStates,"close":_vm.restoreCanadaStates},model:{value:(_vm.model.newAddress.CanadaState),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "CanadaState", $$v)},expression:"model.newAddress.CanadaState"}}):_vm._e(),_vm._v(" "),(!_vm.model.newAddress.Country || !_vm.isCanada() && !_vm.isUS())?_c('ed-input',{attrs:{"field-label":"State/Region","placeholder":"Select a region","disabled":_vm.disableControls,"name":"state_region"},model:{value:(_vm.model.newAddress.Region),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "Region", $$v)},expression:"model.newAddress.Region"}}):_vm._e()],1),_vm._v(" "),_c('ed-input',{staticClass:"col-md-3",attrs:{"field-label":"City","placeholder":"Enter City","name":"city"},model:{value:(_vm.model.newAddress.City),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "City", $$v)},expression:"model.newAddress.City"}}),_vm._v(" "),_c('ed-input',{staticClass:"col-md-5 no-pad",attrs:{"field-label":"Postal/Zip Code","placeholder":"Enter Postal Code","name":"zip_code"},model:{value:(_vm.model.newAddress.ZipCode),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "ZipCode", $$v)},expression:"model.newAddress.ZipCode"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ed-input',{attrs:{"field-label":"VAT ID","placeholder":"Enter VAT ID","name":"vat_id"},model:{value:(_vm.model.newAddress.VatId),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "VatId", $$v)},expression:"model.newAddress.VatId"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ed-input',{attrs:{"field-label":"EIN","placeholder":"Enter EIN","name":"EIN","required":""},model:{value:(_vm.model.newAddress.EIN),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "EIN", $$v)},expression:"model.newAddress.EIN"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ed-input',{attrs:{"field-label":"Recipient Email Address","placeholder":"Enter Recipient Email Address","required":"","error":_vm.doDisplayEmailError,"helptip-header":_vm.doDisplayEmailError && 'Error' || '',"helptip-body":_vm.doDisplayEmailError && 'Please fill in Email Address' || '',"name":"email_address","helpText":"Use a semicolon to separate multiple email addresses"},on:{"change":function($event){_vm.doDisplayEmailError = false}},model:{value:(_vm.model.newAddress.Email),callback:function ($$v) {_vm.$set(_vm.model.newAddress, "Email", $$v)},expression:"model.newAddress.Email"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.hasAPSettingsByBU)?_c('ed-select-list',{attrs:{"field-label":"Divisions","endpoint":_vm.api.$.FundingInvoiceAndApSetting.getDivisionsForFundingAddresss,"track-by":"DivisionId","label":"DivisionName","params":_vm.payload,"required":"","error":_vm.doDisplayDivisionsError,"helptip-header":_vm.doDisplayDivisionsError && 'Error' || '',"helptip-body":_vm.doDisplayDivisionsError && 'Please select a Division' || ''},on:{"select":_vm.selectDivision},model:{value:(_vm.divisions),callback:function ($$v) {_vm.divisions=$$v},expression:"divisions"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.hasAPSettingsByBU)?_c('ed-select-list',{attrs:{"field-label":"Business Units","endpoint":_vm.api.$.FundingInvoiceAndApSetting.getBusinessUnitsForFundingAddresss,"track-by":"Id","label":"Name","params":_vm.payload,"required":"","error":_vm.doDisplayBUError,"helptip-header":_vm.doDisplayBUError && 'Error' || '',"helptip-body":_vm.doDisplayBUError && 'Please select a Business Unit' || ''},on:{"select":_vm.selectBusinessUnit},model:{value:(_vm.businessUnits),callback:function ($$v) {_vm.businessUnits=$$v},expression:"businessUnits"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"clear"})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kHcj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_Programs_Program_list__ = __webpack_require__("9cNB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Programs_Program_list_model__ = __webpack_require__("/0XY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Programs_Program_list_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modules_Programs_Program_list_model__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  description: 'Create a new Program',
  components: {
    ProgramList: __WEBPACK_IMPORTED_MODULE_1__components_modules_Programs_Program_list__["default"]
  },
  data: function data() {
    return {
      name: 'create-program',
      model: __WEBPACK_IMPORTED_MODULE_2__components_modules_Programs_Program_list_model___default.a,
      showModal1: false
    };
  },
  mounted: function mounted() {
    //
  },
  methods: {
    create: function create() {
      console.log(+new Date());
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].RFP.CREATED, 'created something', this);
    }
  }
});

/***/ }),

/***/ "kNBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_user__ = __webpack_require__("uduW");

var functionsMap = {
  '$action$': function $action$(card) {
    return card.Action;
  },
  '$what$': function $what$(card) {
    return {
      url: card.Url,
      text: card.What
    };
  },
  '$supplier$': function $supplier$(card) {
    return {
      url: card.SupplierProfileUrl,
      text: card.SupplierName + (card.SupplierVCI > 0 ? ' (' + card.SupplierVCI + ')' : '')
    };
  },
  '$programName$': function $programName$(card) {
    return {
      url: card.ProgramUrl,
      text: card.ProgramName + (card.InternalProgramId && card.InternalProgramId !== '' ? ', ' + card.InternalProgramId : '')
    };
  },
  '$programLabel$': function $programLabel$(card) {
    return getProgramLabel();
  }
};

// -----------------------------------------------------------------------------

var make = function make(icon, template) {
  return {
    icon: icon,
    template: template
  };
};
function getProgramLabel() {
  var settings = __WEBPACK_IMPORTED_MODULE_0__core_user__["a" /* default */].getCompanySettings();
  return settings.ProgramLabel ? settings.ProgramLabel : 'Program';
}

// -----------------------------------------------------------------------------

/* eslint key-spacing: 0 */

/* harmony default export */ __webpack_exports__["a"] = ({
  tokenize: function tokenize(template, card) {
    return template.split(' ').map(function (token) {
      return functionsMap[token] ? functionsMap[token](card) : ' ' + token + ' ';
    });
  },
  // -----------------------------------------------------------------------------

  default /**/: make('fa-envelope', /**/'$action$  $what$ for $supplier$ for $programName$'),
  // -----------------------------------------------------------------------------

  'EvedPayCard': {
    'EvedPay Card Activated' /**/: make('fa-credit-card', /**/'EvedPay Card $what$ was activated for $programName$'),
    'EvedPay Card Approved' /**/: make('fa-credit-card', /**/'EvedPay Card $what$ was approved for $programName$'),
    'EvedPay Card Closed' /**/: make('fa-credit-card', /**/'EvedPay Card $what$ was closed for $programName$'),
    'EvedPay Card Rejected' /**/: make('fa-credit-card', /**/'EvedPay Card $what$ was declined for $programName$'),
    'EvedPay Card Declined' /**/: make('fa-credit-card', /**/'EvedPay Card $what$ was declined for $programName$'),
    'EvedPay Card Requested' /**/: make('fa-credit-card', /**/'EvedPay Card $what$ was requested for $programName$')
  },
  'Invoice': {
    'Credit Invoice Issued' /**/: make('fa-file-plus', /**/'Credit invoice $what$ was submitted for $supplier$ for $programName$'),
    'Credit Received' /**/: make('fa-envelope', /**/'Credit was received for $what$ from $supplier$ for $programName$'),
    'Invoice Approved' /**/: make('fa-file-check', /**/'Invoice $what$ was approved for $supplier$ for $programName$'),
    'Invoice Cancelled' /**/: make('fa-file-times', /**/'Invoice $what$ was cancelled for $supplier$ for $programName$'),
    'Invoice Issued' /**/: make('fa-inbox-out', /**/'Invoice $what$ was submitted for $supplier$ for $programName$'),
    'Invoice Rejected' /**/: make('fa-file-times', /**/'Invoice $what$ was declined for $supplier$ for $programName$'),
    'Invoice Declined' /**/: make('fa-file-times', /**/'Invoice $what$ was declined for $supplier$ for $programName$')
  },
  'SupplierInvoice': {
    'Credit Invoice Issued' /**/: make('fa-file-plus', /**/'Credit invoice $what$ was submitted by $supplier$ for $programName$'),
    'Credit Received' /**/: make('fa-envelope', /**/'Credit was received for $what$ from $supplier$ for $programName$'),
    'Invoice Approved' /**/: make('fa-file-check', /**/'Invoice $what$ was approved for $supplier$ for $programName$'),
    'Invoice Cancelled' /**/: make('fa-file-times', /**/'Invoice $what$ was cancelled for $supplier$ for $programName$'),
    'Invoice Issued' /**/: make('fa-inbox-in', /**/'Invoice $what$ was submitted by $supplier$ for $programName$'),
    'Invoice Rejected' /**/: make('fa-file-times', /**/'Invoice $what$ was declined for $supplier$ for $programName$'),
    'Invoice Declined' /**/: make('fa-file-times', /**/'Invoice $what$ was declined for $supplier$ for $programName$')
  },
  'PO': {
    'Change Order Requested' /**/: make('fa-file-exclamation', /**/'$supplier$ requested a Change Order for $what$ in $programName$'),
    'File Added - PO' /**/: make('fa-file-plus', /**/'A file was added in $what$ for $programName$'),
    'PO Approved' /**/: make('fa-file-check', /**/'Purchase Order $what$ was approved for $supplier$ for $programName$'),
    'PO Cancelled' /**/: make('fa-file-times', /**/'Purchase Order $what$ was cancelled for $supplier$ for $programName$'),
    'PO Closed' /**/: make('fa-envelope', /**/'Purchase Order $what$ was closed for $supplier$ for $programName$'),
    'PO Created' /**/: make('fa-file-plus', /**/'Purchase Order $what$ was opened for $supplier$ for $programName$'),
    'PO Created from SOS' /**/: make('fa-file-plus', /**/'Purchase Order $what$ was opened for $supplier$ for $programName$'),
    'PO Rejected' /**/: make('fa-file-times', /**/'Purchase Order $what$ was declined for $supplier$ for $programName$'),
    'PO Declined' /**/: make('fa-file-times', /**/'Purchase Order $what$ was declined for $supplier$ for $programName$'),
    'Savings PO Cancelled' /**/: make('fa-file-times', /**/'Purchase Order $what$ was cancelled for $supplier$ for $programName$'),
    'Savings PO Closed' /**/: make('fa-envelope', /**/'Purchase Order $what$ was closed for $supplier$ for $programName$'),
    'Savings PO Created' /**/: make('fa-file-plus', /**/'Purchase Order $what$ was opened for $supplier$ for $programName$')
  },
  'Expense': {
    'Expense Approved' /**/: make('fa-file-check', /**/'Expense $what$ was approved for $supplier$ for $programName$'),
    'Expense Created' /**/: make('fa-file-plus', /**/'Expense $what$ was created for $programName$'),
    'Expense Rejected' /**/: make('fa-file-times', /**/'Expense $what$ was declined for $supplier$ for $programName$'),
    'Expense Declined' /**/: make('fa-file-times', /**/'Expense $what$ was declined for $supplier$ for $programName$')
  },
  'Program': {
    'File Added - Program' /**/: make('fa-file-plus', /**/'A file was added for $programName$'),
    'Program Cancelled' /**/: make('fa-file-times', /**/'$programLabel$  $programName$ was cancelled'),
    'Program Created' /**/: make('fa-file-plus', /**/'$programLabel$  $programName$ was created')
  },
  'Program Budget': {
    'Budget Approved' /**/: make('fa-file-check', /**/'Budget was approved for $programName$'),
    'Budget Rejected' /**/: make('fa-file-times', /**/'Budget was declined for $programName$'),
    'Budget Declined' /**/: make('fa-file-times', /**/'Budget was declined for $programName$'),
    'Budget Submitted' /**/: make('fa-envelope', /**/'Budget was submitted for $programName$')
  },
  'Payment': {
    'Credit Payment Remittance Invoice Generated'
    /**/: make('fa-repeat-alt', /**/'Credit request was initiated for $what$ from $supplier$ for $programName$'),
    'Payment Posted' /**/: make('fa-money-bill', /**/'Payment was posted to invoice $what$ to $supplier$ for $programName$'),
    'Payment Processed' /**/: make('fa-check-circle', /**/'Payment was processed for invoice $what$ to $supplier$ for $programName$'),
    'Payment Scheduled' /**/: make('fa-calendar-alt', /**/'Payment was scheduled for invoice $what$ to $supplier$ for $programName$')
  }
});

/***/ }),

/***/ "kPNv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-check dawn-radio",class:{ inline: _vm.$parent.$attrs["inline"] !== undefined, disabled: _vm.disabled }},[_c('label',{staticClass:"form-check-label"},[(!_vm.$attrs["track-by"])?_c('input',{ref:"radio",staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.name,"id":_vm.optionLabel,"disabled":_vm.disabled},domProps:{"value":_vm.optionValue,"checked":_vm.optionValue === _vm.value},on:{"input":function($event){return _vm.$emit("input", _vm.optionValue)},"click":_vm.chooseRadio}}):_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.name,"id":_vm.optionLabel,"disabled":_vm.disabled},domProps:{"value":_vm.optionValue,"checked":_vm.checked},on:{"click":_vm.chooseRadio}}),_c('span',{staticClass:"radio-mask",class:{ invalid: _vm.$attrs.error }}),_vm._t("icon"),(!_vm.$slots.default)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.optionLabel))]):_c('div',{staticClass:"dawn-radio-option-content"},[_vm._t("default")],2),(_vm.hasAdditionalInfo)?_c('div',{staticClass:"dawn-radio-option-content additional"},[_vm._t(_vm.slotName)],2):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kT8D":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Programs/create.vue": "a6om"
};
function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
};
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e/* lazy-once context */(0).then(function() {
		var id = map[req];
		if(!(id + 1)) // check for number or string
			throw new Error("Cannot find module '" + req + "'.");
		return id;
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "kT8D";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "kU6Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3SbKl0uisrnZeUKDDUzaqe","Dell":"_10AUc7z4jt1_t08r3dkheD","Abbott":"_16VTEYxYzKMdAdxh54KIJr","Gap":"_2Y_bWI9nrBHN037LKr-bLV","Allstate":"MCdUIvWzoI44Ve9_KKS_N","Asurion":"_2Q0miIyGJDVTCkzl42HFsZ","Invitae":"_1Hgh4jtgu7Ttc-HiQUiO1Q","JWE":"_2ymJJpWDDxhY0bSu8AzbXx"};

/***/ }),

/***/ "kVbx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      style: null,
      type: null,
      tooltipData: [],
      currency: 'USD',
      hasData: false
    };
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$on('showChartTooltip', function (r) {
      _this.style = r.data.style;
      _this.tooltipData = r.data.tooltipData;
      _this.currency = r.data.currency;
      _this.type = r.data.type;
      _this.hasData = r.data.hasData;
    });
  }
});

/***/ }),

/***/ "kXYG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__("Z60a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__("C9uT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__("lQbo");






function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var api = new __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */]();
var EventsSection = /*#__PURE__*/function () {
  function EventsSection(dependencies) {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, EventsSection);
    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(this, "dependencies", {});
    this.dependencies = dependencies;
  }
  return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(EventsSection, [{
    key: "recalculatePoAndReturnIt",
    value: function () {
      var _recalculatePoAndReturnIt = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default.a.mark(function _callee(PO, settings, isP2PInvoiceWithEditItem) {
        var _this = this;
        var poComputeTotalsUrl, response, poTotalTaxesAndFees, _iterator, _step, _loop;
        return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default.a.wrap(function _callee$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // set category name
              PO.events.map(function (ev) {
                ev.lineItems.map(function (item) {
                  if (item.category && !item.isFeeDiscountItem && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(item.category) === 'object') {
                    item.category = item.category.name || item.category.text || item.category.label || '';
                  }
                  return item;
                });
              });
              poComputeTotalsUrl = this.dependencies.useSavingsFields ? api.SavingsPurchaseOrderComputeTotals() : api.PurchaseOrderComputeTotals();
              _context3.next = 4;
              return this.dependencies.api.post(poComputeTotalsUrl, {
                Data: PO,
                UserId: this.dependencies.loggedInUserID
              });
            case 4:
              response = _context3.sent;
              if (!(response && response.data)) {
                _context3.next = 34;
                break;
              }
              PO.total = response.data.total;
              PO.subtotal = response.data.subtotal;
              PO.fees = response.data.fees;
              PO.taxes = response.data.taxes;
              PO.balance = response.data.balance;
              PO.discounts = response.data.discounts;
              PO.vat = response.data.vat;
              PO.gst = response.data.gst;
              poTotalTaxesAndFees = 0;
              _iterator = _createForOfIteratorHelper(response.data.events);
              _context3.prev = 16;
              _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default.a.mark(function _loop() {
                var responseEvent, poEvent, listOrdersToRemove, totalWithTaxesAndFees, _iterator2, _step2, _loop2;
                return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default.a.wrap(function _loop$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      responseEvent = _step.value;
                      poEvent = PO.events.filter(function (x) {
                        return x.uniqueId === responseEvent.uniqueId;
                      })[0];
                      if (!poEvent) {
                        _context2.next = 31;
                        break;
                      }
                      poEvent.total = responseEvent.total;
                      poEvent.fees = responseEvent.fees;
                      poEvent.taxes = responseEvent.taxes;
                      poEvent.vat = responseEvent.vat;
                      poEvent.gst = responseEvent.gst;
                      poEvent.discounts = responseEvent.discounts;
                      poEvent.subtotal = responseEvent.subtotal;
                      listOrdersToRemove = poEvent.lineItems.filter(function (itm) {
                        return itm.isAutoGenerated && responseEvent.lineItems.filter(function (n) {
                          return +n.listOrder === +itm.listOrder;
                        }).length === 0;
                      }).map(function (itm) {
                        return +itm.listOrder;
                      });
                      totalWithTaxesAndFees = 0;
                      _iterator2 = _createForOfIteratorHelper(responseEvent.lineItems);
                      _context2.prev = 13;
                      _loop2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default.a.mark(function _loop2() {
                        var responseItem, poLineItem, newItem;
                        return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default.a.wrap(function _loop2$(_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                              responseItem = _step2.value;
                              poLineItem = poEvent.lineItems.filter(function (x) {
                                return +x.listOrder === +responseItem.listOrder;
                              })[0];
                              if (poLineItem) {
                                poLineItem.total = responseItem.total;
                                poLineItem.subtotal = responseItem.subtotal;
                                poLineItem.discountAmount = responseItem.discountAmount;
                                poLineItem.discountPercent = responseItem.discountPercent;
                                poLineItem.totalTaxes = responseItem.totalTaxes;
                                poLineItem.totalFees = responseItem.totalFees;
                                poLineItem.totalTaxesForFees = responseItem.totalTaxesForFees;
                                poLineItem.totalWithTaxesAndFees = responseItem.totalWithTaxesAndFees;
                                poLineItem.fees = responseItem.fees;
                                poLineItem.taxes = responseItem.taxes;
                                poLineItem.hasCostCenter = settings.HasCostCenter;
                                poLineItem.hasBusinessUnit = settings.HasBusinessUnit;
                                delete poLineItem._pending;
                                delete poLineItem._loading;

                                // decoupling: taxes & fees are still displayed when total amount = 0
                                if (settings.AllowEditItem && !poLineItem.isAutoGenerated && Number(responseItem.quantity) === 0) {
                                  poLineItem.totalTaxes = 0;
                                  poLineItem.totalFees = 0;
                                  poLineItem.totalTaxesForFees = 0;
                                  poLineItem.total = 0;
                                  poLineItem.totalWithTaxesAndFees = 0;
                                }
                                if (settings.ExcludeTaxesFromPOThreshold) {
                                  poLineItem.totalToValidate = Number(poLineItem.total);
                                }
                                if (!poLineItem.subtotal) {
                                  totalWithTaxesAndFees += Number(poLineItem.total);
                                } else {
                                  totalWithTaxesAndFees += Number(poLineItem.subtotal) + Number(poLineItem.totalTaxes) + Number(poLineItem.totalFees);
                                }
                              } else {
                                newItem = utils.copy(responseItem);
                                newItem.hasCostCenter = settings.HasCostCenter;
                                newItem.hasBusinessUnit = settings.HasBusinessUnit;
                                delete newItem._pending;
                                delete newItem._loading;
                                if (settings.AllowEditItem && !newItem.isAutoGenerated && Number(newItem.quantity) === 0) {
                                  newItem.totalTaxes = 0;
                                  newItem.totalFees = 0;
                                  newItem.totalTaxesForFees = 0;
                                  newItem.total = 0;
                                  newItem.totalWithTaxesAndFees = 0;
                                }
                                if (settings.ExcludeTaxesFromPOThreshold) {
                                  newItem.totalToValidate = Number(newItem.total);
                                }
                                if (!newItem.subtotal) {
                                  totalWithTaxesAndFees += Number(newItem.total);
                                } else {
                                  totalWithTaxesAndFees += Number(newItem.subtotal) + Number(newItem.totalTaxes) + Number(newItem.totalFees);
                                }
                                newItem.entireRowInvalid = isP2PInvoiceWithEditItem && newItem.isAutoGenerated && newItem.feeTypeId > 0 && !newItem.itemExistsOnPO;
                                poEvent.lineItems.push(newItem);
                              }
                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }, _loop2);
                      });
                      _iterator2.s();
                    case 16:
                      if ((_step2 = _iterator2.n()).done) {
                        _context2.next = 20;
                        break;
                      }
                      return _context2.delegateYield(_loop2(), "t0", 18);
                    case 18:
                      _context2.next = 16;
                      break;
                    case 20:
                      _context2.next = 25;
                      break;
                    case 22:
                      _context2.prev = 22;
                      _context2.t1 = _context2["catch"](13);
                      _iterator2.e(_context2.t1);
                    case 25:
                      _context2.prev = 25;
                      _iterator2.f();
                      return _context2.finish(25);
                    case 28:
                      // decoupling: adjust total on event
                      if (settings.AllowEditItem) {
                        poTotalTaxesAndFees += totalWithTaxesAndFees;
                        poEvent.total = Math.round(totalWithTaxesAndFees * 100) / 100;
                      }

                      // remove auto generated taxes/fees
                      if (!responseEvent.lineItems || responseEvent.lineItems.length === 0) {
                        poEvent.lineItems = [];
                      } else if (listOrdersToRemove && listOrdersToRemove.length > 0) {
                        poEvent.lineItems = poEvent.lineItems.filter(function (itm) {
                          return !itm.isAutoGenerated || itm.isAutoGenerated && listOrdersToRemove.indexOf(+itm.listOrder) === -1;
                        });
                      }
                      poEvent.lineItems = _this.updateLineItemsOrder(poEvent.lineItems);
                    case 31:
                    case "end":
                      return _context2.stop();
                  }
                }, _loop, null, [[13, 22, 25, 28]]);
              });
              _iterator.s();
            case 19:
              if ((_step = _iterator.n()).done) {
                _context3.next = 23;
                break;
              }
              return _context3.delegateYield(_loop(), "t0", 21);
            case 21:
              _context3.next = 19;
              break;
            case 23:
              _context3.next = 28;
              break;
            case 25:
              _context3.prev = 25;
              _context3.t1 = _context3["catch"](16);
              _iterator.e(_context3.t1);
            case 28:
              _context3.prev = 28;
              _iterator.f();
              return _context3.finish(28);
            case 31:
              // decoupling: adjust total on PO
              if (settings.AllowEditItem) {
                PO.total = Math.round(poTotalTaxesAndFees * 100) / 100;
              }
              _context3.next = 35;
              break;
            case 34:
              this.deletePendingLoadingItems(PO);
            case 35:
              return _context3.abrupt("return", PO);
            case 36:
            case "end":
              return _context3.stop();
          }
        }, _callee, this, [[16, 25, 28, 31]]);
      }));
      function recalculatePoAndReturnIt(_x, _x2, _x3) {
        return _recalculatePoAndReturnIt.apply(this, arguments);
      }
      return recalculatePoAndReturnIt;
    }()
  }, {
    key: "updateLineItemsOrder",
    value: function updateLineItemsOrder(lineItems) {
      lineItems = lineItems.sort(function (a, b) {
        return +a.listOrder > +b.listOrder ? 1 : +b.listOrder > +a.listOrder ? -1 : 0;
      });
      var listOrder = 1;
      var _iterator3 = _createForOfIteratorHelper(lineItems),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var poItem = _step3.value;
          if (+poItem.listOrder !== listOrder) {
            poItem.listOrder = listOrder;
          }
          listOrder++;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return lineItems;
    }
  }, {
    key: "deletePendingLoadingItems",
    value: function deletePendingLoadingItems(PO) {
      PO.events.map(function (ev) {
        ev.lineItems.map(function (item) {
          delete item._pending;
          delete item._loading;
        });
      });
    }
  }, {
    key: "mapLineItemPropertiesFromSourceToTargetForCreate",
    value: function mapLineItemPropertiesFromSourceToTargetForCreate(targetLineItem, sourceLineItem) {
      targetLineItem.name = sourceLineItem.name;
      targetLineItem.description = sourceLineItem.description;
      targetLineItem.internalNote = sourceLineItem.internalNote;
      targetLineItem.taxCode = sourceLineItem.taxCode;
      targetLineItem.category = sourceLineItem.selectedCategory ? sourceLineItem.selectedCategory.text : '';
      targetLineItem.categoryRefId = sourceLineItem.categoryRefId;
      targetLineItem.pairedBusinessUnitAndCostCenter = sourceLineItem.pairedBusinessUnitAndCostCenter;
      targetLineItem.costCenterAndBusinessUnit = sourceLineItem.costCenterAndBusinessUnit;
      targetLineItem.useBusinessUnitAndCostCenterMapping = sourceLineItem.useBusinessUnitAndCostCenterMapping;
      targetLineItem.unit = sourceLineItem.unit;
      if (sourceLineItem.unitPriceSGR) {
        targetLineItem.unitPriceSGR = sourceLineItem.unitPriceSGR;
        targetLineItem.unitPricePreferredRate = sourceLineItem.unitPricePreferredRate;
        targetLineItem.unitPriceNegotiatedRate = sourceLineItem.unitPriceNegotiatedRate;
        targetLineItem.totalSGR = sourceLineItem.totalSGR;
        targetLineItem.totalPreferredRate = sourceLineItem.totalPreferredRate;
        targetLineItem.totalNegotiatedRate = sourceLineItem.totalNegotiatedRate;
      } else {
        // TODO
        targetLineItem.unitPriceSGR = 0;
        targetLineItem.unitPricePreferredRate = 0;
        targetLineItem.unitPriceNegotiatedRate = 0;
        targetLineItem.totalSGR = 0;
        targetLineItem.totalPreferredRate = 0;
        targetLineItem.totalNegotiatedRate = 0;
      }
      targetLineItem.unitPrice = sourceLineItem.unitPrice;
      targetLineItem.quantity = sourceLineItem.quantity;
      targetLineItem.units = sourceLineItem.units;
      targetLineItem.subtotal = sourceLineItem.subtotal;
      targetLineItem.total = sourceLineItem.total;
      targetLineItem.discountAmount = sourceLineItem.discountAmount;
      targetLineItem.discountPercent = sourceLineItem.discountPercent;
      targetLineItem.totalTaxes = sourceLineItem.totalTaxes;
      targetLineItem.totalFees = sourceLineItem.totalFees;
      targetLineItem.totalTaxesForFees = sourceLineItem.totalTaxesForFees;
      targetLineItem.totalWithTaxesAndFees = sourceLineItem.totalWithTaxesAndFees;
      targetLineItem.unitTypeModel = sourceLineItem.unitTypeModel;
      targetLineItem.unitType = sourceLineItem.unitType;
      targetLineItem.taxes = sourceLineItem.taxes;
      targetLineItem.fees = sourceLineItem.fees;
      targetLineItem.referenceId = sourceLineItem.referenceId;
      targetLineItem.isAutoGenerated = sourceLineItem.isAutoGenerated;
      targetLineItem.customFields = sourceLineItem.customFields;
      //
      targetLineItem._expanded = sourceLineItem._expanded;
      return targetLineItem;
    }
  }, {
    key: "mapLineItemPropertiesFromSourceToTargetForEdit",
    value: function mapLineItemPropertiesFromSourceToTargetForEdit(targetLineItem, sourceLineItem) {
      targetLineItem = this.mapLineItemPropertiesFromSourceToTargetForCreate(targetLineItem, sourceLineItem);
      var _loop3 = function _loop3(i) {
        var computedTax = sourceLineItem.taxes.find(function (tax) {
          return tax.name === targetLineItem.taxes[i].name;
        });
        if (computedTax) {
          targetLineItem.taxes[i].isChecked = computedTax.isChecked;
          targetLineItem.taxes[i].percentage = computedTax.percentage;
          targetLineItem.taxes[i].value = computedTax.value;
          targetLineItem.taxes[i].totalTaxes = computedTax.totalTaxes;
        }
      };
      for (var i = 0; i < targetLineItem.taxes.length; i++) {
        _loop3(i);
      }
      var _loop4 = function _loop4(_i) {
        var computedFee = sourceLineItem.fees.find(function (fee) {
          return fee.name === targetLineItem.fees[_i].name;
        });
        if (computedFee) {
          targetLineItem.fees[_i].value = computedFee.value;
          targetLineItem.fees[_i].totalTaxes = computedFee.totalTaxes;
        }
      };
      for (var _i = 0; _i < targetLineItem.fees.length; _i++) {
        _loop4(_i);
      }
      return targetLineItem;
    }
  }, {
    key: "getLineItemListElementFromFeeDiscount",
    value: function getLineItemListElementFromFeeDiscount(lineItem, sourceFeeDiscount) {
      lineItem.name = sourceFeeDiscount.category.text;
      lineItem.pairedBusinessUnitAndCostCenter = sourceFeeDiscount.pairedBusinessUnitAndCostCenter;
      lineItem.costCenterAndBusinessUnit = sourceFeeDiscount.costCenterAndBusinessUnit;
      lineItem.useBusinessUnitAndCostCenterMapping = sourceFeeDiscount.useBusinessUnitAndCostCenterMapping;
      lineItem.costCenter = sourceFeeDiscount.costCenter;
      lineItem.businessUnit = sourceFeeDiscount.businessUnit;
      lineItem.amountTypeValue = sourceFeeDiscount.amountTypeValue || 0;
      lineItem.unitPrice = sourceFeeDiscount.amountTypeValue || 0;
      lineItem.amountTypeId = sourceFeeDiscount.amountType.amountType || 0;
      lineItem.itemTypeId = sourceFeeDiscount.category.itemType;
      lineItem.units = '';
      lineItem.quantity = sourceFeeDiscount.amountTypeValue !== '' ? 1 : '';
      lineItem.isFeeDiscountItem = true;
      lineItem.description = sourceFeeDiscount.description;
      lineItem.total = sourceFeeDiscount.amountTypeValue || 0;
      lineItem.subtotal = sourceFeeDiscount.amountTypeValue || 0;
      lineItem.category = '';
      lineItem.feeTypeId = sourceFeeDiscount.feeTypeId;
      lineItem.taxTypeId = sourceFeeDiscount.taxTypeId;
      lineItem.customTypeId = sourceFeeDiscount.customTypeId;
      lineItem.customFields = sourceFeeDiscount.customFields;
      return lineItem;
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (EventsSection);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "kaxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardtransactions_vue__ = __webpack_require__("VK62");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20349a09_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardtransactions_vue__ = __webpack_require__("66e7");
function injectStyle (ssrContext) {
  __webpack_require__("QW1W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20349a09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardtransactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20349a09_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardtransactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kb2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("I6uD");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14eeb650_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("+/Gj");
function injectStyle (ssrContext) {
  __webpack_require__("rBem")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14eeb650"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14eeb650_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kcXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("EbYq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d3610e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4Zn2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d3610e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kf6H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2NAzpg4t6ztHN_39Ugteot","Dell":"_3VtSFLDy25I7RYxjR33w58","Abbott":"qwh6DEPYxm5PxP_99WzhV","Gap":"_1JG7FwwBbhmFJFfkxn164i","Allstate":"_7LiVRkaOQ9FNDgklXpWOI","Asurion":"_1gMDorAPppWxKwGqZ3gRV3","Invitae":"_3ucj1UvGv0XIo3rSZn7xHu","JWE":"_3xaiR6GqLKb5nD1-nRh0st"};

/***/ }),

/***/ "kl7m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "klGW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-flex active"},[_c('ed-section',{staticClass:"no-flex active no-margin no-border",attrs:{"title":" ","wide":"","full-width":""}},[_c('ed-form',{attrs:{"submit-visible":false}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-md-offset-7 no-pad"},[(_vm.model.DisplayPaidBy)?_c('ed-select',{attrs:{"field-label":"Paid By","placeholder":"Select Paid By","options":_vm.paidByOptions,"required":"","label":"Value","track-by":"Value","helptipHeader":"","error":_vm.errors.PaidByMissing,"helptip-body":_vm.errors.PaidByMissing && "Please enter Paid By." || "","name":"paid_by"},on:{"select":_vm.paidByChanged},model:{value:(_vm.paidBy),callback:function ($$v) {_vm.paidBy=$$v},expression:"paidBy"}}):_vm._e(),_vm._v(" "),_c('ed-select',{attrs:{"field-label":"Payment Method","placeholder":"Select Payment Method","options":_vm.paymentMethods,"required":"","label":"Value","track-by":"Value","helptipHeader":"","error":_vm.errors.PaymentMethodMissing,"helptip-body":_vm.errors.PaymentMethodMissing && "Please select a Payment Method." || "","name":"post_payment_method"},on:{"select":_vm.paymentMethodChanged},model:{value:(_vm.paymentMethod),callback:function ($$v) {_vm.paymentMethod=$$v},expression:"paymentMethod"}}),_vm._v(" "),(_vm.displayCostCenters)?_c('ed-select',{attrs:{"field-label":"Cost Center","placeholder":"Select Cost Center","options":_vm.model.CostCenters,"required":"","label":"Value","track-by":"Value","helptipHeader":"","error":_vm.errors.CostCenterMissing,"helptip-body":_vm.errors.CostCenterMissing && "Please select a Cost Center." || "","name":"post_payment_cost_center"},on:{"select":_vm.costCenterChanged},model:{value:(_vm.costCenter),callback:function ($$v) {_vm.costCenter=$$v},expression:"costCenter"}}):_vm._e(),_vm._v(" "),_c('ed-input',{attrs:{"field-label":"Reference Number","required":"","helptipHeader":"","error":_vm.errors.ReferenceNoMissing,"helptip-body":_vm.errors.ReferenceNoMissing && "Please enter a Reference Number." || "","name":"post_payment_reference_no"},on:{"input":_vm.emitChanges},model:{value:(_vm.referenceNo),callback:function ($$v) {_vm.referenceNo=$$v},expression:"referenceNo"}}),_vm._v(" "),_c('ed-upload',{class:{ loading: !_vm.uploadFinished },attrs:{"field-label":"Attachment","button-label":"Browse","data":_vm.uploadData,"readonly":"","multiple":false,"postAction":_vm.api.env + _vm.api.$.upload.uploadInvoice,"uploadAuto":true,"name":"post_payment_attachment_upload"},on:{"input":_vm.saveAttachment}}),_vm._v(" "),_c('ed-textarea',{attrs:{"field-label":"Payment Notes","max-length":150,"name":"post_payment_notes"},on:{"input":_vm.emitChanges},model:{value:(_vm.paymentNotes),callback:function ($$v) {_vm.paymentNotes=$$v},expression:"paymentNotes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"clear"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ks+p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kss6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fileUploadComponent_vue__ = __webpack_require__("k0Nt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-upload',
  components: {
    'upload-component': __WEBPACK_IMPORTED_MODULE_0__fileUploadComponent_vue__["default"]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__fileUploadComponent_vue__["default"]],
  props: {
    target: String,
    disabled: Boolean,
    readonly: Boolean,
    postAction: {
      type: String,
      default: function _default() {
        return this.$parent.endpoint || this.$parent.$attrs.endpoint;
      }
    },
    noButton: {
      type: Boolean,
      default: false
    },
    buttonPosition: {
      type: String,
      default: 'top'
    },
    uploadAuto: Boolean,
    fieldLabel: String,
    hideOptional: Boolean,
    buttonLabel: String,
    required: Boolean,
    multiple: Boolean,
    autofocus: Boolean,
    helptipHeader: String,
    helptipBody: String,
    showHelptipIcon: {
      type: Boolean,
      default: true
    },
    error: Boolean,
    data: Object,
    value: Array,
    canOpenFile: Boolean
  },
  data: function data() {
    return {
      files: [],
      showHelp: false,
      showIcon: 'fas fa-question-circle',
      hideIcon: 'far fa-times-circle'
    };
  },
  directives: {
    focus: {
      inserted: function inserted(el, binding) {
        if (binding.value) el.focus();else el.blur();
      },
      componentUpdated: function componentUpdated(el, binding) {
        if (binding.modifiers.lazy) {
          if (Boolean(binding.value) === Boolean(binding.oldValue)) {
            return;
          }
        }
        if (binding.value) el.focus();else el.blur();
      }
    }
  },
  created: function created() {
    if (this.value && this.value.length) {
      this.files = this.value;
    }
  },
  methods: {
    toggleHelp: function toggleHelp() {
      this.showHelp = !this.showHelp;
    },
    checkIndex: function checkIndex(item) {
      /* if (item === 0) {
        return true
      } */
    },
    formatBytes: function formatBytes(bytes, decimals) {
      if (bytes === 0) return '0 Bytes';
      var k = 1024;
      var dm = decimals || 2;
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    toggleEdit: function toggleEdit(item) {
      if (item.editing) {
        item.editing = false;
      } else {
        item.editing = true;
      }
    },
    isEditing: function isEditing(item) {
      return item.editing;
    },
    inputFile: function inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        // update

        if (newFile.active && !oldFile.active) {
          // beforeSend
          // min size
          if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
            this.$refs.upload.update(newFile, {
              error: 'size'
            });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
        }
        if (newFile.error && !oldFile.error) {
          // error
        }
        if (newFile.success && !oldFile.success) {
          // success
        }
      }
      if (!newFile && oldFile) {
        // remove
        if (oldFile.success && oldFile.response && oldFile.response.id) {
          // $.ajax({
          //   type: 'DELETE',
          //   url: '/upload/delete?id=' + oldFile.response.id,
          // })
        }
      }

      // Automatically activate upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }
      var filteredFiles = this.filterValidAndErrorFiles(this.files);
      this.$emit('input', this.files, filteredFiles.valid, filteredFiles.withError);
    },
    filterValidAndErrorFiles: function filterValidAndErrorFiles(files) {
      var validFiles = [];
      var invalidFiles = [];
      var itemResponse = '';
      var uploadError = '';
      files.map(function (item) {
        uploadError = '';
        if (!item.success) {
          invalidFiles.push(item);
        } else if (item.success && item.response) {
          if (utils.json.valid(item.response)) {
            itemResponse = JSON.parse(item.response);
            uploadError = itemResponse && itemResponse.uploadError ? itemResponse.uploadError : '';
          }
          if (uploadError === '') {
            validFiles.push(item);
          } else {
            invalidFiles.push(item);
          }
        }
      });
      return {
        valid: validFiles,
        withError: invalidFiles
      };
    },
    fileIcon: function fileIcon(type) {
      var icon;
      var color;
      switch (type) {
        case 'image/png':
        case 'image/jpeg':
        case 'image/svg':
        case 'image/svg+xml':
        case 'image/tiff':
        case 'image/webp':
        case 'image/gif':
        case 'image/x-icon':
          icon = 'file-image';
          color = '#4598d9';
          break;
        case 'application/pdf':
          icon = 'file-pdf';
          color = '#cb0404';
          break;
        case 'video/x-msvideo':
        case 'video/mpeg':
        case 'video/ogg':
        case 'video/webm':
        case 'video/3gpp':
        case 'video/3gpp2':
        case 'video/mp4':
        case 'video/x-ms-wmv':
          icon = 'file-video';
          color = '#dd4a4a';
          break;
        case 'audio/aac':
        case 'audio/midi':
        case 'audio/ogg':
        case 'audio/x-wav':
        case 'audio/webm':
        case 'audio/3gpp':
        case 'audio/3gpp2':
        case 'audio/mp3':
          icon = 'file-audio';
          color = '#ff8800';
          break;
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
        case 'application/json':
        case 'application/typescript':
        case 'application/xhtml+xml':
          icon = 'file-code';
          color = '#62c14c';
          break;
        case 'application/x-7z-compressed':
        case 'application/zip':
        case 'application/x-zip':
        case 'application/x-zip-compressed':
          icon = 'file-archive';
          color = '#acacac';
          break;
        default:
          icon = 'file-alt';
          color = '#2591e5';
      }
      return '<i style="color:' + color + '" class="fas fa-' + icon + '"></i>';
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "kxvb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("HnSJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_322c9b1c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ewFN");
function injectStyle (ssrContext) {
  __webpack_require__("P7S6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_322c9b1c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kzaK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils, global) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object,
    currency: String
  },
  methods: {
    showValue: function showValue(value) {
      if (Number(value) !== 0) {
        return true;
      }
      return false;
    },
    allTaxesComputed: function allTaxesComputed() {
      var _this = this;
      this.allTaxes = [];
      if (this.model.taxes) {
        this.model.taxes.map(function (tax) {
          if (tax.isChecked) {
            _this.allTaxes.push(utils.copy(tax));
          }
        });
      }
      if (this.model.fees) {
        this.model.fees.map(function (fee) {
          if (fee.taxes) {
            fee.taxes.map(function (feetax) {
              var exists = false;
              _this.allTaxes.map(function (alltax) {
                if (alltax.name.trim() === feetax.name.trim() && feetax.isChecked) {
                  alltax.value = Number(alltax.value) + Number(feetax.value);
                  exists = true;
                }
              });
              if (exists === false) {
                if (feetax.isChecked) {
                  _this.allTaxes.push(utils.copy(feetax));
                }
              }
            });
          }
        });
      }
      return this.allTaxes;
    },
    getHasCostCenterSetting: function getHasCostCenterSetting() {
      return global.app.getUser.settings.HasCostCenter && Number(global.app.getUser.settings.HasCostCenter) === 1 || this.model.hasCostCenter;
    },
    getHasBusinessUnitSetting: function getHasBusinessUnitSetting() {
      return global.app.getUser.settings.HasBusinessUnit && Number(global.app.getUser.settings.HasBusinessUnit) === 1 || this.model.hasBusinessUnit;
    },
    getUseBUAndCCSetting: function getUseBUAndCCSetting() {
      return global.app.getUser.settings.UseBusinessUnitAndCostCenterMapping && Number(global.app.getUser.settings.UseBusinessUnitAndCostCenterMapping) === 1 || this.model.useBusinessUnitAndCostCenterMapping;
    }
  },
  data: function data() {
    return {
      allTaxes: [],
      // TODO: replace
      hasCostCenterSetting: this.getHasCostCenterSetting(),
      hasBusinessUnitSetting: this.getHasBusinessUnitSetting(),
      useBUAndCCSetting: this.getUseBUAndCCSetting()
    };
  },
  computed: {
    BU: function BU() {
      return this.model.costCenterAndBusinessUnit && this.model.costCenterAndBusinessUnit.businessUnitName || 'None';
    },
    CC: function CC() {
      if (this.model.costCenterAndBusinessUnit) {
        var name = this.model.costCenterAndBusinessUnit.costCenterName;
        var code = this.model.costCenterAndBusinessUnit.costCenterNo;
        if (name || code) {
          return name && (name.indexOf(code) === -1 || name.trim() !== code.trim()) ? code + ' (' + name + ')' : code;
        }
      }
      return 'None';
    },
    BusinessUnitAndCostCenter: function BusinessUnitAndCostCenter() {
      return this.model.costCenterAndBusinessUnit && this.model.costCenterAndBusinessUnit.costCenterAndBusinessUnitName || 'None';
    },
    Description: function Description() {
      return this.model.description || 'None';
    },
    InternalNote: function InternalNote() {
      return this.model.internalNote || 'None';
    },
    CategoryRefId: function CategoryRefId() {
      return this.model.referenceId || 'None';
    },
    UnitType: function UnitType() {
      return this.model.unitType || 'None';
    },
    showMixBusinessUnitAndCostCenter: function showMixBusinessUnitAndCostCenter() {
      return this.model.costCenterAndBusinessUnit && this.model.costCenterAndBusinessUnit.costCenterAndBusinessUnitName;
    },
    existsAtLeastOneTax: function existsAtLeastOneTax() {
      this.allTaxesComputed();
      var exists = false;
      this.allTaxes && this.allTaxes.map(function (item) {
        if (Number(item.value) !== 0 && item.isChecked) {
          exists = true;
        }
      });
      return exists;
    },
    existsAtLeastOneFee: function existsAtLeastOneFee() {
      var exists = false;
      this.model.fees && this.model.fees.map(function (item) {
        if (Number(item.value) !== 0) {
          exists = true;
        }
      });
      return exists;
    },
    discountExists: function discountExists() {
      var number = Number(this.model.discountAmount);
      if (number && number !== 0) {
        return true;
      }
      return false;
    },
    showBUCCCategColumn: function showBUCCCategColumn() {
      return this.showMixBusinessUnitAndCostCenter || this.useBUAndCCSetting || this.hasBusinessUnitSetting || this.hasCostCenterSetting || this.model.isFeeDiscountItem === false;
    },
    showSavingsFields: function showSavingsFields() {
      return typeof this.model.poQuantity === 'undefined' && this.model.isFeeDiscountItem === false && (
      // when using savings fields, amounts are saved as strings &&
      this.model.unitPriceSGR || this.model.unitPricePreferredRate || this.model.unitPriceNegotiatedRate) && !(this.model.unitPriceSGR === 0 && this.model.unitPricePreferredRate === 0 && this.model.unitPriceNegotiatedRate === 0);
    },
    taxesAndFeesClass: function taxesAndFeesClass() {
      return 'column ' + (this.showSavingsFields ? 'col-md-2' : 'col-md-3');
    },
    supplementalPrecision: function supplementalPrecision() {
      try {
        var r = (this.model.unitPrice + '').split('.');
        var has8Digits = r && r.length > 1 && r[1].length > 2;
        return has8Digits ? 6 /* 8 digits */ : 0; /* 2 digits */
      } catch (e) {
        return 0; /* 2 digits */
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "l2QP":
/***/ (function(module, exports) {

module.exports = {"1":"Taxes","2":"Fees","3":"Other","default":"3"}

/***/ }),

/***/ "l77O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{attrs:{"title":_vm.$t("Import Data")}}),_c('div',{staticClass:"container-fluid"},[_c('ed-section',{staticClass:"active",attrs:{"offset":"1"}},_vm._l((_vm.settings),function(setting,index){return _c('span',[(typeof setting.condition === "undefined" || setting.condition)?_c('ed-card',{key:setting.name,class:{ "new": setting.new },attrs:{"title":setting.name,"subtitle":setting.description.replace("[placeholder]", setting.name || setting.placeholder),"footer-button":setting.configurable,"icon":setting.icon,"endpoint":setting.saving && (setting.endpoint || _vm.api.$.settings.company.$)}},[(setting.help)?_c('span',{attrs:{"slot":"mask"},slot:"mask"},[_vm._v(_vm._s(setting.help))]):_vm._e(),(setting.status !== null)?_c('ed-switch',{attrs:{"slot":"top","value":_vm.$user.$.companySettings[setting.status],"emit-on-mount":false},on:{"input":function($event){return _vm.change(setting)},"mousedown":function($event){return _vm.handleEndpoint(setting)}},slot:"top",model:{value:(_vm.settings[index].value),callback:function ($$v) {_vm.$set(_vm.settings[index], "value", $$v)},expression:"settings[index].value"}}):_vm._e(),(setting.editable)?_c('ed-input',{staticClass:"small inline",attrs:{"slot":"title","update-button":"","disabled":_vm.isDisabled(setting),"autofocus":"","helptipBody":"You can change your division name here"},on:{"update":function($event){return _vm.change(setting)},"mousedown":function($event){return _vm.handleEndpoint(setting)}},slot:"title",model:{value:(setting.name),callback:function ($$v) {_vm.$set(setting, "name", $$v)},expression:"setting.name"}}):_vm._e(),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[(setting.configurable != "false")?_c('ed-button',{staticClass:"btn btn-actionbar-",attrs:{"href":_vm.backUrl(setting.url, setting),"disabled":_vm.isDisabled(setting),"button-class":"btn btn-actionbar-"},on:{"click":function($event){return _vm.onImport(setting, $event)}}},[_vm._v(_vm._s(setting.configurable))]):_vm._e()],1)],1):_vm._e()],1)}),0)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l7FX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"slot":"body","endpoint":("evedpaycards/" + _vm.cardId + "/request-physical-card")},slot:"body"},[_c('div',{staticClass:"navless-layout-header"},[_vm._t("navbar",function(){return [_c('ed-button',{attrs:{"to":_vm.$routerHistory.previous().path}},[_c('i',{staticClass:"fal fa-chevron-left"}),_vm._v("\n           \n          Back\n        ")]),_vm._v(" "),_c('a',{staticClass:"pull-right list",on:{"click":function () { return _vm.requestPhysicalCard(); }}},[_c('strong',[_vm._v("Request")])])]})],2),_vm._v(" "),_c('div',{attrs:{"endpoint":"Settings/GetDivision"}},[_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"country"}},[_vm._v("Country")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select a country...","options":_vm.countries,"label":"CountryName","track-by":"CountryID","openEndpoint":_vm.api.$.profile.getAllCountries,"disabled":_vm.disableControls,"name":"supplier_country"},on:{"input":function (o) { return _vm.mailingAddress.country = o; },"select":function($event){return _vm.countrySelected($event)},"open":_vm.fetchCountriesOnOpen,"keyup":_vm.fetchCountries,"close":_vm.restoreCountries},model:{value:(_vm.formData.country),callback:function ($$v) {_vm.$set(_vm.formData, "country", $$v)},expression:"formData.country"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"name","placeholder":"Name","maxlength":"40"},on:{"input":function (o) { return _vm.mailingAddress.name = o; }},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),(_vm.errors.name)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.name))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"address"}},[_vm._v("Address")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"address","placeholder":"Address","maxlength":"26"},on:{"input":function (o) { return _vm.mailingAddress.line1 = o; }},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),(_vm.errors.line1)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.line1))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","field-label":"Address Line 2","id":"addressLine2","placeholder":"Address Line 2","maxlength":"26"},on:{"input":function (o) { return _vm.mailingAddress.line2 = o; }},model:{value:(_vm.addressLine2),callback:function ($$v) {_vm.addressLine2=$$v},expression:"addressLine2"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',[_c('label',{attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"city","placeholder":"City","maxlength":"25"},on:{"input":function (o) { return _vm.mailingAddress.city = o; }},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}}),_vm._v(" "),(_vm.errors.city)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.city))]):_vm._e()],1),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"state"}},[_vm._v("State")]),_vm._v(" "),(_vm.isUS())?_c('ed-select',{attrs:{"options":_vm.USstates,"openEndpoint":_vm.api.$.profile.getAllStates,"label":"StateName","track-by":"StateID","name":"us_states"},on:{"input":function (o) { return _vm.mailingAddress.state = o; },"open":_vm.fetchUSStatesOnOpen,"keyup":_vm.fetchUSStates,"close":_vm.restoreUSStates},model:{value:(_vm.formData.state),callback:function ($$v) {_vm.$set(_vm.formData, "state", $$v)},expression:"formData.state"}}):_vm._e(),_vm._v(" "),(_vm.isCanada())?_c('ed-select',{attrs:{"placeholder":"Select a region","options":_vm.canadaStates,"label":"StateName","disabled":_vm.disableControls,"name":"canada_states"},on:{"input":function (o) { return _vm.mailingAddress.state = o; },"open":_vm.fetchCanadaStatesOnOpen,"keyup":_vm.fetchCanadaStates,"close":_vm.restoreCanadaStates},model:{value:(_vm.formData.canadaState),callback:function ($$v) {_vm.$set(_vm.formData, "canadaState", $$v)},expression:"formData.canadaState"}}):_vm._e(),_vm._v(" "),(!_vm.formData.country || !_vm.isCanada() && !_vm.isUS())?_c('ed-input',{attrs:{"placeholder":"Select a region","disabled":_vm.disableControls,"name":"state_region"},on:{"input":function (o) { return _vm.mailingAddress.state = o; }},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}}):_vm._e(),_vm._v(" "),(_vm.errors.state)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.state))]):_vm._e()],1),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"zipCode"}},[_vm._v("Zip Code")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"zipCode","placeholder":"Zip Code","maxlength":"5"},on:{"input":function (o) { return _vm.mailingAddress.zip = o; }},model:{value:(_vm.zipCode),callback:function ($$v) {_vm.zipCode=$$v},expression:"zipCode"}}),_vm._v(" "),(_vm.errors.zip)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.zip))]):_vm._e()],1)]),_vm._v(" "),(this.allowRushPhysicalCards)?_c('hr'):_vm._e(),_vm._v(" "),(this.allowRushPhysicalCards)?_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n          For a fee, a physical card can be sent via expedited shipping.\n        ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rushOrder),expression:"rushOrder"}],attrs:{"type":"checkbox","id":"rushOrder"},domProps:{"checked":Array.isArray(_vm.rushOrder)?_vm._i(_vm.rushOrder,null)>-1:(_vm.rushOrder)},on:{"change":function($event){var $$a=_vm.rushOrder,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rushOrder=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rushOrder=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rushOrder=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"small",attrs:{"for":"rushOrder"}},[_vm._v("Rush shipment of this card")])])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"small"},[_vm._v("\n          Send the Cardholder a physical card - provide mailing address below:\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"rushOrder"}},[_vm._v("Rush Order - "),_c('span',{staticClass:"optional-text"},[_vm._v("optional")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l9sY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_string_js__ = __webpack_require__("dCaq");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      formData: {
        city: '',
        postalCode: '',
        originalCountryName: '',
        country: '',
        state: {
          StateID: 0,
          StateName: ''
        },
        canadaState: {
          StateID: 0,
          StateName: ''
        },
        region: ''
      },
      division: {
        Name: '',
        Description: '',
        AllowEvedAP: false,
        AllowEvedPayCards: false,
        DivisionID: '',
        EIN: ''
      },
      USstates: [],
      canadaStates: [],
      entities: [],
      selectEntity: '',
      countries: [],
      showAddDivision: false,
      mailingAddress: {},
      divisionNameIncomplete: false,
      einIncomplete: false,
      descriptionIncomplete: false,
      countryIncomplete: false,
      addressIncomplete: false,
      cityIncomplete: false,
      stateIncomplete: false,
      canadaStateIncomplete: false,
      zipCodeIncomplete: false,
      entityIncomplete: false,
      disableControls: false,
      isNewEntity: false,
      duplicateDivisionNameError: false,
      duplicateEINError: false
    };
  },
  methods: {
    singularize: function singularize(word) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_string_js__["a" /* singularize */])(word);
    },
    getEntity: function getEntity() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var vendorId, response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              vendorId = _this.$root.getUser.settings.VendorId;
              _context.next = 4;
              return _this.api.get(_this.api.$.settings.company.getEntity, {
                params: {
                  vendorId: vendorId
                }
              });
            case 4:
              response = _context.sent;
              if (response && response.data && response.data.EINs) {
                _this.entities = [{
                  Id: 'new',
                  Name: 'Add New Entity'
                }].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(response.data.EINs.map(function (ein) {
                  return {
                    Id: ein.VendorAddressId,
                    Name: ein.Name,
                    Address: ein.Address,
                    Address2: ein.Address2,
                    City: ein.City,
                    EIN: ein.EIN,
                    Zip: ein.Zip,
                    StateId: ein.StateId,
                    StateName: ein.StateName,
                    CountryId: ein.CountryId,
                    Country: ein.Country
                  };
                })));
              }
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error('Error fetching EINs:', _context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }))();
    },
    handleEntitySelection: function handleEntitySelection(value) {
      this.isNewEntity = value.Id === 'new';
      if (!this.isNewEntity) {
        this.duplicateEINError = false;
        this.countryIncomplete = false;
        this.cityIncomplete = false;
        this.zipCodeIncomplete = false;
        this.stateIncomplete = false;
        this.canadaStateIncomplete = false;
        this.nameIncomplete = false;
        this.entityIncomplete = false;
        var selectedEntity = this.entities.find(function (entity) {
          return entity.Id === value.Id;
        });
        if (selectedEntity) {
          this.division.EIN = selectedEntity.EIN;
          this.mailingAddress = {
            name: selectedEntity.Name,
            line1: selectedEntity.Address,
            line2: selectedEntity.Address2,
            city: selectedEntity.City,
            state: selectedEntity.StateName,
            zip: selectedEntity.Zip,
            country: selectedEntity.Country,
            region: selectedEntity.Region
          };
          this.formData = {
            country: this.countries.find(function (c) {
              return c.CountryID === selectedEntity.CountryId;
            }) || {
              CountryID: selectedEntity.CountryId,
              CountryName: selectedEntity.Country
            },
            state: this.USstates.find(function (s) {
              return s.StateID === selectedEntity.StateId;
            }) || {
              StateID: selectedEntity.StateId,
              StateName: selectedEntity.StateName
            },
            canadaState: this.canadaStates.find(function (s) {
              return s.StateID === selectedEntity.StateId;
            }) || {
              StateID: selectedEntity.StateId,
              StateName: selectedEntity.StateName
            }
          };
          this.disableControls = true;
        }
      } else {
        this.division.EIN = '';
        this.mailingAddress = {
          name: '',
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: ''
        };
        this.formData = {
          country: '',
          state: {
            StateID: 0,
            StateName: ''
          },
          canadaState: {
            StateID: 0,
            StateName: ''
          },
          region: ''
        };
        this.disableControls = false;
        this.duplicateEINError = false;
        this.einIncomplete = false;
      }
      if (value && value.Id) {
        this.entityIncomplete = false;
      }
    },
    addDivision: function addDivision() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var valid, isDuplicate, isEINDuplicate, payload, response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              valid = true;
              if (!_this2.division.Name) {
                _this2.divisionNameIncomplete = true;
                valid = false;
              } else {
                _this2.divisionNameIncomplete = false;
              }
              if (!_this2.division.Description) {
                _this2.descriptionIncomplete = true;
                valid = false;
              } else {
                _this2.descriptionIncomplete = false;
              }
              _context2.next = 5;
              return _this2.checkDivisionNameExists(_this2.division.Name);
            case 5:
              isDuplicate = _context2.sent;
              if (!isDuplicate) {
                _context2.next = 11;
                break;
              }
              _this2.duplicateDivisionNameError = true;
              return _context2.abrupt("return");
            case 11:
              _this2.duplicateDivisionNameError = false;
            case 12:
              if (!_this2.isNewEntity) {
                _context2.next = 22;
                break;
              }
              _context2.next = 15;
              return _this2.checkEINExists(_this2.division.EIN);
            case 15:
              isEINDuplicate = _context2.sent;
              if (!isEINDuplicate) {
                _context2.next = 21;
                break;
              }
              _this2.duplicateEINError = true;
              return _context2.abrupt("return");
            case 21:
              _this2.duplicateEINError = false;
            case 22:
              if (_this2.isNewEntity && !_this2.mailingAddress.name) {
                _this2.nameIncomplete = true;
                valid = false;
              } else {
                _this2.nameIncomplete = false;
              }
              if (_this2.isNewEntity && !_this2.division.EIN.trim()) {
                _this2.einIncomplete = true;
                valid = false;
              } else {
                _this2.einIncomplete = false;
              }
              if (_this2.isNewEntity && !_this2.mailingAddress.city) {
                _this2.cityIncomplete = true;
                valid = false;
              } else {
                _this2.cityIncomplete = false;
              }
              if (_this2.isNewEntity && !_this2.mailingAddress.zip) {
                _this2.zipCodeIncomplete = true;
                valid = false;
              } else {
                _this2.zipCodeIncomplete = false;
              }
              if (_this2.isNewEntity && !_this2.mailingAddress.line1) {
                _this2.addressIncomplete = true;
                valid = false;
              } else {
                _this2.addressIncomplete = false;
              }
              if (_this2.isNewEntity) {
                if (_this2.isUS() && !_this2.mailingAddress.state) {
                  _this2.stateIncomplete = true;
                  valid = false;
                } else {
                  _this2.stateIncomplete = false;
                }
              }
              if (_this2.isNewEntity) {
                if (_this2.isCanada() && !_this2.mailingAddress.canadaState) {
                  _this2.canadaStateIncomplete = true;
                  valid = false;
                } else {
                  _this2.canadaStateIncomplete = false;
                }
              }
              if (!_this2.isNewEntity && (!_this2.selectEntity || !_this2.selectEntity.Id)) {
                _this2.entityIncomplete = true;
                valid = false;
              } else {
                _this2.entityIncomplete = false;
              }
              if (valid) {
                _context2.next = 32;
                break;
              }
              return _context2.abrupt("return");
            case 32:
              _context2.prev = 32;
              payload = {
                DivisionName: _this2.division.Name,
                DivisionDescription: _this2.division.Description,
                DivisionID: _this2.division.DivisionID || 0,
                AllowEvedAP: _this2.division.AllowEvedAP || false,
                AllowEvedPayCards: _this2.division.AllowEvedPayCards || false,
                EIN: _this2.division.EIN,
                IsNewEntity: _this2.isNewEntity,
                Name: _this2.mailingAddress.name || '',
                VendorAddressId: _this2.isNewEntity ? null : _this2.selectEntity ? _this2.selectEntity.Id : null,
                Address: _this2.mailingAddress.line1 || '',
                Address2: _this2.mailingAddress.line2 || '',
                City: _this2.mailingAddress.city || '',
                CountryID: _this2.formData.country.CountryID || null,
                StateID: _this2.isUS() ? _this2.formData.state.StateID : _this2.isCanada() ? _this2.formData.canadaState.StateID || null : null,
                Region: _this2.isCanada() ? _this2.formData.canadaState.StateName : !_this2.isUS() ? _this2.formData.region : '',
                Zip: _this2.mailingAddress.zip || ''
              };
              _context2.next = 36;
              return _this2.api.post(_this2.api.$.settings.company.addDivision, payload);
            case 36:
              response = _context2.sent;
              if (response && response.data) {
                _this2.$emit('close');
              } else {
                console.error('Failed to add division');
              }
              _context2.next = 43;
              break;
            case 40:
              _context2.prev = 40;
              _context2.t0 = _context2["catch"](32);
              console.error('Error adding division:', _context2.t0);
            case 43:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[32, 40]]);
      }))();
    },
    checkDivisionNameExists: function checkDivisionNameExists(divisionName) {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this3.api.get(_this3.api.$.settings.company.checkDivisionNameUnique, {
                params: {
                  divisionName: divisionName
                }
              });
            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", response.data.SuccessMessage === 'NotUnique');
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.error('Error checking division name:', _context3.t0);
              return _context3.abrupt("return", false);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }))();
    },
    checkEINExists: function checkEINExists(ein) {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _this4.api.get(_this4.api.$.settings.company.checkEINUnique, {
                params: {
                  ein: ein
                }
              });
            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", response.data.SuccessMessage === 'NotUnique');
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              console.error('Error checking ein:', _context4.t0);
              return _context4.abrupt("return", false);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }))();
    },
    fetchCountriesOnOpen: function fetchCountriesOnOpen() {
      var _this5 = this;
      if (this.countries.length) {} else {
        this.api.forms.post(this.api.$.profile.getAllCountries, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this5.countries = r.data.Data;
            _this5.originalCountries = r.data.Data;
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    fetchCountries: function fetchCountries(value) {
      var _this6 = this;
      this.counter || this.api.forms.post(this.api.$.profile.getAllCountries, {
        q: value || ''
      }).then(function (r) {
        _this6.counter = 0;
        if (r && r.data && r.data.Data) {
          _this6.countries = r.data.Data;
        }
      }).catch(function (e) {
        console.warn(e);
        _this6.counter = 0;
      });
      this.counter = 1;
    },
    restoreCountries: function restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries);
      }
    },
    isUS: function isUS() {
      return this.formData.country && this.formData.country.CountryName === 'United States';
    },
    GetStatesUSURL: function GetStatesUSURL() {
      return this.api.$.profile.getAllStates;
    },
    isCanada: function isCanada() {
      return this.formData.country && this.formData.country.CountryName === 'Canada';
    },
    GetStatesCanadaURL: function GetStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates;
    },
    // Fetch States on OPEN
    fetchUSStatesOnOpen: function fetchUSStatesOnOpen() {
      var url = this.GetStatesUSURL();
      this.fetchStatesOnOpen(this.USstates, url);
    },
    fetchCanadaStatesOnOpen: function fetchCanadaStatesOnOpen() {
      var url = this.GetStatesCanadaURL();
      this.fetchStatesOnOpen(this.canadaStates, url);
    },
    fetchStatesOnOpen: function fetchStatesOnOpen(states, url) {
      var _this7 = this;
      if (states.length && (this.isCanada() || this.isUS())) {} else {
        this.api.forms.post(url, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this7.mapStatesDataOnOpen(r.data.Data);
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    mapStatesDataOnOpen: function mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USstates = this.USoriginalStates = data;
      } else {
        this.canadaStates = this.originalCanadaStates = data;
      }
    },
    // Fetch States on search text
    fetchUSStates: function fetchUSStates(value) {
      var url = this.GetStatesUSURL();
      this.fetchStates(value, url);
    },
    fetchCanadaStates: function fetchCanadaStates(value) {
      var url = this.GetStatesCanadaURL();
      this.fetchStates(value, url);
    },
    fetchStates: function fetchStates(value, url) {
      var _this8 = this;
      this.counter || this.api.forms.post(url, {
        q: value || ''
      }).then(function (r) {
        _this8.counter = 0;
        if (r && r.data && r.data.Data) {
          _this8.mapStatesDataOnFetch(r.data.Data);
        }
      }).catch(function (e) {
        console.warn(e);
        _this8.counter = 0;
      });
      this.counter = 1;
    },
    mapStatesDataOnFetch: function mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USstates = data;
      } else {
        this.canadaStates = data;
      }
    },
    // Restore States
    restoreUSStates: function restoreUSStates() {
      this.restoreStates(this.USstates, this.USoriginalStates);
    },
    restoreCanadaStates: function restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates);
    },
    restoreStates: function restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates);
      }
    },
    populateFormData: function populateFormData(data) {
      if (data.CompanyName !== null) {
        this.formData = {
          city: data.City,
          postalCode: data.Zip,
          originalCountryName: data.CountryName,
          country: {
            'CountryID': 186,
            'CountryName': 'United States'
          },
          state: {
            StateID: data.isCanada === 'False' && data.StateID || 0,
            StateName: data.isCanada === 'False' && data.State || ''
          },
          canadaState: {
            StateID: data.isCanada === 'True' && data.StateID || 0,
            StateName: data.isCanada === 'True' && data.State || ''
          },
          region: data.Region
        };
        this.disableControls = true;
      } else {
        this.disableControls = false;
      }
    },
    countrySelected: function countrySelected(e) {
      this.doDisplayCountryError = false;
      this.resetState(e.CountryName);
    },
    resetState: function resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.formData.state = {
          StateID: 0,
          StateName: ''
        };
        this.formData.canadaState = {
          StateID: 0,
          StateName: ''
        };
        this.formData.region = '';
      } else {
        this.originalCountryName = countryName;
      }
    },
    showModal: function showModal(showAddDivision) {
      this.showAddDivision = !showAddDivision;
      if (!this.showAddDivision) {
        this.resetModalFields();
      }
    },
    resetModalFields: function resetModalFields() {
      var _this9 = this;
      this.$nextTick(function () {
        _this9.division = {
          Name: '',
          Description: '',
          AllowEvedAP: false,
          AllowEvedPayCards: false,
          DivisionID: '',
          EIN: ''
        };
        _this9.formData = {
          city: '',
          postalCode: '',
          originalCountryName: '',
          country: '',
          state: {
            StateID: 0,
            StateName: ''
          },
          canadaState: {
            StateID: 0,
            StateName: ''
          },
          region: ''
        };
        _this9.mailingAddress = {
          name: '',
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: '',
          country: ''
        };
        _this9.isNewEntity = false;
        _this9.mailingAddress = {};
        _this9.selectEntity = '';
        _this9.countryIncomplete = false;
        _this9.divisionNameIncomplete = false;
        _this9.descriptionIncomplete = false;
        _this9.addressIncomplete = false;
        _this9.cityIncomplete = false;
        _this9.stateIncomplete = false;
        _this9.canadaStateIncomplete = false;
        _this9.zipCodeIncomplete = false;
        _this9.disableControls = false;
        _this9.nameIncomplete = false;
        _this9.selectEntity = false;
        _this9.entityIncomplete = false;
        _this9.einIncomplete = false;
        _this9.duplicateEINError = false;
      });
    }
  },
  watch: {
    show: function show(newVal) {
      if (!newVal) {
        this.resetModalFields();
      } else {
        this.populateFormData(this.formData);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "lEGT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],attrs:{"button-class":"btn btn-actionbar","ids":_vm.ids,"disabled":_vm.disabled},on:{"click":function($event){return _vm.showModal(_vm.showCloseAccount)}}},[_vm._v("\n    Close Account\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Close EvedPay Card Account","show":_vm.showCloseAccount,"primary-button":"Confirm"},on:{"close":function($event){_vm.showModal(_vm.showCloseAccount), _vm.closeObj = {}},"confirm":function($event){return _vm.closeAccount()}}},[_c('div',{staticClass:"close-account-overlay",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("You are about to close this EvedPay Card Account. Where would you like to move the remaining funds?")]),_vm._v(" "),_c('label',[_vm._v("Balance")]),_vm._v(" "),_c('v-money',{staticClass:"small",attrs:{"currency":"USD","locale":"en"}},[_vm._v(_vm._s(_vm.balance))]),_vm._v(" "),_c('ed-radio',{attrs:{"options":_vm.options,"track-by":"id","name":"add-funding","fieldLabel":"Add Funding:"},on:{"input":function (option) { return _vm.handleRadioInput(option); }}},[_c('ed-select',{attrs:{"slot":"additionalInfo_1","options":_vm.divisions,"label":"DivisionName","name":"divisions"},on:{"open":_vm.getUserDivisions,"input":function (option) {this$1.selectOption.DivisionId = option.DivisionId
                                        this$1.selectOption.DivisionName = option.DivisionName
                                        this$1.selectOption.AccountId = option.AccountId}},slot:"additionalInfo_1"}),_vm._v(" "),_c('p',{staticClass:"small",attrs:{"slot":"additionalInfo_2"},slot:"additionalInfo_2"},[_vm._v(_vm._s(_vm.division.DivisionName))])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lHmF":
/***/ (function(module, exports) {

module.exports = {"introduction":{"alias":"Intro","subtabs":{"get-started":"Getting Started"}},"colors":{"alias":"Colors","subtabs":{"guidlines":"Color Guidelines","palette":"Color Palette","combinations":"Color Combinations","usage":"Color Usage","accessibility":"Accessibility"}},"components":"Core Components","structure":"Structure","navigation":"Navigation"}

/***/ }),

/***/ "lOj7":
/***/ (function(module, exports) {

module.exports = {"ApprovalRuleId":"_","Name":"Name","CreatedBy":"Created By","CreatedDateFormatted":"Created","UpdatedBy":"Updated By","UpdatedDateFormatted":"Last Updated"}

/***/ }),

/***/ "lQ8Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lQbo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__("C9uT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__("Z60a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);



/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */
var Api = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function Api() {
  var _this = this;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Api);
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "baseURL", '//{ENV}purchaseordersapi.eved.com');
  // baseURL = '//localhost:58205'
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "ComputeLineItemTotals", function () {
    return "".concat(_this.baseURL, "/api/LineItem/ComputeTotals");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "SavingsComputeLineItemTotals", function () {
    return "".concat(_this.baseURL, "/api/SavingsLineItem/ComputeTotals");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "ComputeFeeTotals", function () {
    return "".concat(_this.baseURL, "/api/LineItem/ComputeFeeTotals");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "PurchaseOrderComputeTotals", function () {
    return "".concat(_this.baseURL, "/api/PurchaseOrderBuyer/ComputeTotals");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "SavingsPurchaseOrderComputeTotals", function () {
    return "".concat(_this.baseURL, "/api/SavingsPurchaseOrderBuyer/ComputeTotals");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "GetPurchaseOrderDetails", function () {
    return "".concat(_this.baseURL, "/api/PurchaseOrderBuyer/Get");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "GetSavingsDetails", function () {
    return "".concat(_this.baseURL, "/api/SavingsPurchaseOrderBuyer/Get");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "AddFeeOrDiscountItemGet", function () {
    return "".concat(_this.baseURL, "/api/AddFeeOrDiscountItem");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "SavePurchaseOrder", function () {
    return "".concat(_this.baseURL, "/api/PurchaseOrderBuyer/Save");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "SaveSavings", function () {
    return "".concat(_this.baseURL, "/api/SavingsPurchaseOrderBuyer/Save");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "SendPurchaseOrder", function () {
    return "".concat(_this.baseURL, "/api/PurchaseOrderBuyer/SendToSupplier");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "SendSavings", function () {
    return "".concat(_this.baseURL, "/api/SavingsPurchaseOrderBuyer/SendToSupplier");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "DropDownsListForItem", function () {
    return '/InvoiceToPay/GetItemsCategoriesAndBuAndCc';
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "GetCostCentersBusinessUnits", function () {
    return '/InvoiceToPay/GetCostCentersBusinessUnits';
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "GetSupplierTaxes", function () {
    return "".concat(_this.baseURL, "/api/Supplier/GetTaxes");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "GetSupplierFees", function () {
    return "".concat(_this.baseURL, "/api/Supplier/GetFees");
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "GetInvoiceTotalAmount", function () {
    return "/InvoiceToPay/GetInvoiceTotalAmount";
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "InitUploadInvoice", function () {
    return "/InvoiceToPay/InitUploadInvoice";
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "GetOverBudgetWarningData", function () {
    return "/InvoiceToPay/GetOverBudgetWarningData";
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "GetComments", function () {
    return "/Common/GetInvoiceCommentsJSON";
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "SaveComments", function () {
    return "/Common/SaveInvoiceComment";
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "GetPurchaseOrderItems", function () {
    return '/InvoiceToPay/GetPurchaseOrderItems';
  });
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "GetAllocations", function () {
    return '/InvoiceToPay/GetAllocations';
  });
});


/***/ }),

/***/ "lVLm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export log */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);

// logger
var log = function log(message, level) {
  if (message && level && console[level]) {
    var _console;
    if (message instanceof Array) (_console = console)[level].apply(_console, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(message));else console[level](message);
  } else {
    console.info(message);
  }
};

/***/ }),

/***/ "lW6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReplaceApFile' /* mandatory field */,

  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */]
  },
  props: {
    apFile: Object,
    token: String
  },
  activated: function activated() {
    this.show = false;
    this.attachmentFile = '';
    this.displayUploadError = false;
    this.uploadError = '';
  },
  data: function data() {
    return {
      show: false,
      paymentNotes: '',
      uploadFinished: true,
      attachmentFile: '',
      attachmentFiles: null,
      attachmentMissingError: false,
      displayUploadError: false,
      uploadError: ''
    };
  },
  computed: {
    auditFileExportUrl: function auditFileExportUrl() {
      return this.api.env + this.api.$.payment.generateApFile + '?auditFileId=' + this.apFile.ApFileId;
    },
    uploadSettings: function uploadSettings() {
      return {
        folder: 'Temp/',
        token: this.token,
        fileType: 'excel/csv',
        renameFile: this.apFile.AuditFileNumber
      };
    }
  },
  methods: {
    onClose: function onClose() {
      this.show = false;
      this.attachmentFiles = [];
    },
    isValid: function isValid() {
      var valid = this.attachmentFiles && this.attachmentFiles.length > 0;
      this.attachmentMissingError = !valid;
      return valid;
    },
    onSave: function onSave() {
      if (!this.isValid()) return;
      this.doReplace();
    },
    doReplace: function doReplace() {
      var _this = this;
      this.api.post(this.api.$.payment.replaceApFile, {
        auditFileID: this.apFile.ApFileId,
        uploadedFile: this.apFile.AuditFileNumber + '.' + this.getFileExtension(this.attachmentFiles[0].name),
        additionalNote: this.paymentNotes
      }).then(function (response) {
        // TODO: validate response
        _this.onClose();
      });
    },
    getFileExtension: function getFileExtension(fileName) {
      if (/[.]/.exec(fileName)) {
        var ext = /[^.]+$/.exec(fileName);
        if (ext && ext.length > 0) {
          return ext[0];
        }
      }
      return 'xls';
    },
    createAttachments: function createAttachments(e) {
      var _this2 = this;
      var completedFiles = e.filter(function (item) {
        return item.success ||
        // files uploaded with success
        !item.success && item.response && typeof item.response === 'string' && !_this2.isJson(item.response);
      } // files where requested failed
      );
      if (completedFiles.length >= 1) {
        this.attachmentMissingError = false;
      }
      if (completedFiles.length === e.length) {
        this.uploadFinished = true;
        e.map(function (item) {
          var itemResponse = null;
          if (item.success && item.response) {
            itemResponse = JSON.parse(item.response);
            _this2.uploadError = itemResponse && itemResponse.uploadError ? itemResponse.uploadError : '';
          }
          if (!item.success) {
            _this2.uploadError = 'Upload request failed';
          }
        });
        if (this.uploadError !== '') {
          this.displayUploadError = true;
        }
        this.attachmentFiles = e.filter(function (item) {
          return item.success && JSON.parse(item.response).success;
        });
      } else {
        this.uploadFinished = false;
      }
    },
    isJson: function isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
  }
});

/***/ }),

/***/ "lqPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_he__ = __webpack_require__("t02m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_receiptScanMixin__ = __webpack_require__("fxZG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__ = __webpack_require__("X3jq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_Programs_Card_transactions_ReceiptFolderPicker_vue__ = __webpack_require__("tGNh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_Programs_Card_transactions_ReceiptImageViewer_vue__ = __webpack_require__("38ON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modules_Programs_Card_transactions_PredictedCodingIcon_vue__ = __webpack_require__("enAH");


function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// Predictive Coding prefill (EvedPay Card reconcile surface).
// surface = PredictionSurface.EpcReconcile, sent to the Platform predict API as the integer 1.
var EPC_RECONCILE_SURFACE = 1;
// Tight client-side cap so a slow predict endpoint can never hang the silent prefill.
var PREDICT_TIMEOUT_MS = 8000;
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ReceiptFolderPicker: __WEBPACK_IMPORTED_MODULE_8__components_modules_Programs_Card_transactions_ReceiptFolderPicker_vue__["a" /* default */],
    ReceiptImageViewer: __WEBPACK_IMPORTED_MODULE_9__components_modules_Programs_Card_transactions_ReceiptImageViewer_vue__["a" /* default */],
    PredictedCodingIcon: __WEBPACK_IMPORTED_MODULE_10__components_modules_Programs_Card_transactions_PredictedCodingIcon_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_receiptScanMixin__["a" /* default */]],
  data: function data() {
    return {
      receiptScanEnabled: __WEBPACK_IMPORTED_MODULE_6__core_feature_flags_feature_flags__["a" /* default */].receiptScanPrefill,
      // PRODUCTDEV-5788 — per-division "No Receipt Capture" gate. Default false so a
      // fetch failure never hides the scan affordances on an enabled division. Set in
      // created() from the division's receipt-scan mode (scanning_disabled). When true:
      // hide the folder + replace-coding controls and attach uploads WITHOUT Photon.
      // The GLOBAL receiptScanEnabled flag (above) is untouched, so coding + the
      // Description column + Additional Documents keep rendering (forward-only, per §5).
      receiptCaptureDisabled: false,
      // PRODUCTDEV-5788 — false until the division's scan mode resolves; the scan-actions
      // block waits on this so "Add from receipt folder" doesn't flash in for a frame before
      // "No Receipt Capture" is known. Set true after the getScanMode fetch (or when skipped).
      receiptScanModeLoaded: false,
      // PRODUCTDEV-5805 — DivisionId of the transaction being reconciled; sent to /prefill so a
      // folder-picked (unmatched) receipt's prefill matches this division's selected scan mode
      // instead of the BE default (subtotal_and_tax).
      receiptScanDivisionId: null,
      receiptScanPrefillApplied: false,
      receiptScanConfidence: null,
      receiptScanPrefillMode: null,
      // amount_mismatch from prefill — surfaced via the warning banner above
      // the Coding section. The BE no longer falls back to total_only on
      // mismatch; instead it preserves Photon's breakdown and asks us to warn.
      amountMismatch: false,
      receiptScanPhotonTotal: null,
      uploadingReceipt: false,
      uploadProgressPct: 0,
      // PRODUCTDEV-5802 — old-UI loading spinner (global `.loading` class, same
      // affordance the legacy ed-upload showed via `{loading: !uploadFinished}`)
      // over the Receipt section during plain byte-upload windows that have no
      // 4s bar: replaceReceiptFile (re-upload once coding/receipt exists) and
      // attachReceiptWithoutScan (No Receipt Capture mode). The 4s bar stays
      // reserved for windows where Photon actually scans (fresh first upload,
      // Rescan Receipt).
      receiptUploadInProgress: false,
      // PRODUCTDEV-5802 (reopen, Case 3) — same old-UI spinner over the
      // Additional Documents section while an Upload-file byte-upload is in
      // flight, with Save gated for the window.
      documentUploadInProgress: false,
      scanningReceipt: false,
      scanCompleted: false,
      // Full-screen "Uploading receipt…" overlay during UPLOAD NEW RECEIPT's
      // upload+Photon round-trip. Mobile-only (isMobile) — desktop keeps its
      // inline receipt-upload-progress bar. Set true once the fresh-scan flow
      // starts (past validation) and cleared by the scanCompleted watcher, which
      // every terminal branch of the upload flow flips to true.
      uploadingScanOverlay: false,
      // PRODUCTDEV-5772 — receipt replacement. When a receipt already exists and the
      // user uploads/picks a new one, the file is swapped WITHOUT scanning and this
      // flag raises the "Replace coding?" alert. pendingRescanFile holds the new File
      // so "Rescan Receipt" can run Photon on it on demand. Both cleared after rescan,
      // chip-remove, or a fresh first-run upload.
      receiptReplacedPendingRescan: false,
      pendingRescanFile: null,
      // PRODUCTDEV-5783 — when a REPLACE came from the receipt folder (which already has scan
      // data), this holds that folder scan's id so "Replace coding" applies its EXISTING prefill
      // (no re-scan). Null for an upload-replace, which re-scans via pendingRescanFile.
      pendingFolderPrefillScanId: null,
      // PRODUCTDEV-5772 — true when the reconcile was opened with saved coding rows
      // (backend returned TransactionFields). The most reliable "coding already exists"
      // signal — covers single-row / category-only / amount-only coding that has no
      // split count or description to detect. Drives hasCodingOrReceipt.
      loadedWithCoding: false,
      descriptions: [],
      showFolderPicker: false,
      folderPickerIsProcessing: false,
      // PRODUCTDEV-5772 — supporting documents, kept entirely separate from receipts
      // (attachedFiles). Never Photon-scanned, never affect status / IsComplete.
      additionalDocuments: [],
      programs: [],
      noteText: '',
      suppliers: [],
      newReconcile: {},
      selectedSupplier: Object,
      selectedProgram: null,
      supplierOptions: [],
      programOptions: [],
      splitCounter: 1,
      mediaFilesPath: '',
      form: null,
      requireReceiptDescription: false,
      attachedPath: [],
      uploadData: {
        token: this.$user.sessionSettings.Token
      },
      splitAmounts: this.transaction.data.Amount,
      attachedFiles: [],
      transactionFiles: [],
      businessUnits: [],
      costCenters: [],
      buAndCcPairs: [],
      categories: [],
      selectedBu: [],
      selectedCc: [],
      selectedBuAndCcPair: [],
      selectedCategory: [],
      predictedCategory: [],
      referenceId: [],
      programName: '',
      divisionName: '',
      loadedCategoriesAndBuAndCc: -1,
      allowPredictiveCoding: false,
      // True from mount until setRowFieldsValues actually writes per-row
      // values into the form. Hides the empty-cells flash that otherwise
      // shows while getCategoriesAndBuAndCc + the sequential per-select
      // getCustomOptions network calls finish.
      codingRowsLoading: true,
      hasBu: false,
      hasCc: false,
      hasBuAndCcPair: false,
      showAlert: false,
      programOption: Object,
      previousSelectedProgram: Object,
      programConfirmPressed: false,
      copySplitObject: {},
      customOptions: {},
      baseCustomFields: null,
      uploadFinished: true,
      programLoader: {
        items: [],
        pageIndex: 0,
        hasMore: true,
        isLoading: false,
        searchTerm: ''
      }
    };
  },
  props: {
    transaction: Object,
    fieldsIncomplete: Object,
    reconcileAction: 'create',
    // PRODUCTDEV-5574 — receipt upload follows its own pre-existing rules (only the current approver or
    // global admin in an in-envelope state); parent computes this so we don't transitively widen receipt
    // access when reconcileAction is granted to card holders / division admins / non-current approvers.
    receiptEditAllowed: {
      type: Boolean,
      default: false
    },
    // True only when mounted by the mobile EvedPay surface
    // (EvedPay/transactiondetails.vue). Gates mobile-only UI (the full-screen
    // upload overlay, the mobile Additional Documents layout) so the shared
    // desktop Reconcile modal stays unchanged. Same pattern as CandidateSelector's is-mobile.
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  beforeCreate: function beforeCreate() {
    this.he = __WEBPACK_IMPORTED_MODULE_3_he___default.a;
  },
  created: function created() {
    var _this = this;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var row, supplierName, scanSetting, receiptScanId;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            row = _this.transaction.data;
            if (row.ProgramId) {
              _this.selectedProgram = {
                Id: row.ProgramId,
                Name: row.ProgramName,
                InternalProgramID: row.InternalProgramID
              };
              _this.getCategoriesAndBuAndCc(row.ProgramId);
            }
            if (row.Supplier || row.NonEvedSupplier) {
              supplierName = row.Supplier ? "".concat(row.Supplier, " (#").concat(row.SupplierEoNumber, ")") : row.NonEvedSupplier;
              _this.selectedSupplier = {
                Key: row.VendorId,
                Value: {
                  CompanyName: supplierName,
                  VendorId: row.SupplierId || -row.SupplierNetworkId
                }
              };
            }
            _context.next = 6;
            return _this.getReconcile(row);
          case 6:
            if (!(_this.receiptScanEnabled && row.DivisionId != null)) {
              _context.next = 19;
              break;
            }
            // PRODUCTDEV-5805 — remember the division so tryApplyReceiptScanPrefill can tell the BE
            // which division's mode to apply when prefilling an unmatched folder receipt.
            _this.receiptScanDivisionId = row.DivisionId;
            _context.prev = 8;
            _context.next = 11;
            return __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].getScanMode(row.DivisionId);
          case 11:
            scanSetting = _context.sent;
            _this.receiptCaptureDisabled = !!(scanSetting && scanSetting.prefillMode === 'scanning_disabled');
            _context.next = 19;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](8);
            console.warn('Could not fetch receipt-scan mode (defaulting to enabled):', _context.t0);
            _this.receiptCaptureDisabled = false;
          case 19:
            // PRODUCTDEV-5788 — mode resolved (or not applicable); reveal the scan actions now so
            // the folder button never renders before the No-Capture state is known.
            _this.receiptScanModeLoaded = true;

            // One-shot receipt-scan prefill from query param
            _context.next = 22;
            return _this.tryApplyReceiptScanPrefill();
          case 22:
            // Start poller if receiptScanId is present and scan is still processing
            receiptScanId = _this.$route.query.receiptScanId;
            if (!(receiptScanId && _this.receiptScanEnabled)) {
              _context.next = 29;
              break;
            }
            _this.startReceiptScan(receiptScanId, {
              transactionId: _this.transaction.data.Id
            });
            // Consume any Legacy-upload metadata stashed by Card-list's Dashboard
            // SUBMIT flow. Without this the matched-via-Dashboard reconcile has no
            // TransactionFiles row, and reopen-view crashes (Substring(0,-1)).
            // One-shot: delete the key after consuming so a refresh or different
            // tab doesn't double-attach.
            _this.consumeStashedLegacyReceipt(receiptScanId);
            // Mobile FAB flow: upload happened in mobile.vue against Platform only and
            // matchToTransaction (SubmitReceipt → Done) is Platform-only too, so Legacy
            // /get-reconcile returned TransactionFiles=[] and populateFiles did nothing.
            // Bridge by fetching Platform's FileInfo + presigned URL and pushing a
            // synthetic attachment so hasAttachment flips true and the image renders.
            // Save-time createReconcile reads filteredAttachments (incl. ReceiptScanId),
            // Legacy EvedPayCardsRepository writes a TransactionFile row, and
            // ConfirmLegacySubmit advances the scan from Matched → Submitted.
            if (!(_this.isMobile && _this.attachedFiles.length === 0)) {
              _context.next = 29;
              break;
            }
            _context.next = 29;
            return _this.attachReceiptScanIfMissing(receiptScanId);
          case 29:
            _this.programName = _this.singularize(_this.$root.getUser.settings.Labels.ProgramLabel);
            _this.divisionName = _this.singularize(_this.$root.getUser.settings.Labels.DivisionName);
            _this.hasBu = _this.$root.getUser.settings.HasBusinessUnit;
            _this.hasCc = _this.$root.getUser.settings.HasCostCenter;
            _this.hasBuAndCcPair = _this.$root.getUser.settings.UseBusinessUnitAndCostCenterMapping;
            _this.hasBuOrCcOrPair = _this.hasBu || _this.hasCc || _this.hasBuAndCcPair;
            _this.$emit('split-amounts', _this.splitAmounts);
            _context.next = 42;
            break;
          case 38:
            _context.prev = 38;
            _context.t1 = _context["catch"](0);
            console.error('Error during component initialization:', _context.t1);
            throw _context.t1;
          case 42:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 38], [8, 15]]);
    }))();
  },
  computed: {
    supplierPlaceholder: function supplierPlaceholder() {
      var row = this.transaction.data;
      return row.Merchant ? row.Merchant : 'Select a supplier...';
    },
    isUserAdmin: function isUserAdmin() {
      if (this.$user.$.userPermissions.includes('EvedPayCardAdministrator')) {
        return true;
      }
      return false;
    },
    permissionTooltip: function permissionTooltip() {
      return 'You do not have permission to change receipt attachments on this transaction.';
    },
    isInEnvelope: function isInEnvelope() {
      var id = this.transaction && this.transaction.data && this.transaction.data.EnvelopeId;
      return !!id && id !== '00000000-0000-0000-0000-000000000000';
    },
    envelopePostedOrExported: function envelopePostedOrExported() {
      var status = this.transaction && this.transaction.data && this.transaction.data.EnvelopeStatus || '';
      return status.startsWith('Posted') || status.startsWith('Exported');
    },
    envelopeBlockedStateLabel: function envelopeBlockedStateLabel() {
      var status = this.transaction && this.transaction.data && this.transaction.data.EnvelopeStatus || '';
      if (status.startsWith('Posted')) return 'posted';
      if (status.startsWith('Exported')) return 'exported';
      return '';
    },
    // PRODUCTDEV-5790 — receipt + additional-document editing is allowed whenever the
    // reconcile is editable (create/edit), OR for a card admin even on a view-locked
    // (submitted-envelope) transaction. This restores the PRODUCTDEV-4071 admin exception
    // that the V2 receipt-capture rework dropped. Coding stays read-only in view mode
    // regardless (gated separately on reconcileAction === 'view'); admins persist a
    // receipt/document-only change through the narrow update-receipt endpoint in the host.
    // Current approvers don't need a clause here — they already resolve to 'edit'.
    canManageReceipts: function canManageReceipts() {
      return this.reconcileAction !== 'view' || this.isUserAdmin;
    },
    hasAttachment: function hasAttachment() {
      return Array.isArray(this.attachedFiles) && this.attachedFiles.some(function (f) {
        return f && f.success !== false;
      });
    },
    // PRODUCTDEV-5772 — a brand-new receipt upload auto-scans Photon ONLY on a
    // fresh/default reconcile: no coding entered yet AND no receipt attached. The
    // moment coding exists (a scan ran, or saved coding was loaded, or the user
    // split/described rows) OR a receipt is attached, an upload instead swaps the
    // receipt and offers "Rescan Receipt" — so existing coding is never silently
    // overwritten. Additional Documents are deliberately NOT considered here.
    hasCodingOrReceipt: function hasCodingOrReceipt() {
      if (this.hasAttachment) return true;
      // Opened with saved coding (any shape — single row, category-only, etc.).
      if (this.loadedWithCoding) return true;
      // Coding entered/scanned this session: extra split rows, descriptions, or any
      // category / BU / CC / pair / reference-id selected on a row.
      if (Array.isArray(this.form) && this.form.length > 1) return true;
      if (Array.isArray(this.descriptions) && this.descriptions.some(function (d) {
        return d && String(d).trim() !== '';
      })) return true;
      var selections = [this.selectedCategory, this.selectedBu, this.selectedCc, this.selectedBuAndCcPair];
      if (selections.some(function (arr) {
        return Array.isArray(arr) && arr.some(function (v) {
          return v != null;
        });
      })) return true;
      if (Array.isArray(this.referenceId) && this.referenceId.some(function (v) {
        return v != null && v !== '';
      })) return true;
      return false;
    },
    // PRODUCTDEV-5783 — the "Replace coding?" alert text + action differ by source: a folder
    // replace applies the folder receipt's existing prefill; an upload replace re-scans via Photon.
    replaceCodingMessage: function replaceCodingMessage() {
      return this.pendingFolderPrefillScanId ? 'Receipt added from the folder. Replace the current coding with the folder receipt\'s?' : 'A new receipt was uploaded. Replace coding?';
    },
    replaceCodingActionLabel: function replaceCodingActionLabel() {
      return this.pendingFolderPrefillScanId ? 'Replace coding' : 'Scan Receipt';
    },
    primaryAttachment: function primaryAttachment() {
      if (!this.hasAttachment) return null;
      return this.attachedFiles.find(function (f) {
        return f && f.success !== false;
      }) || null;
    },
    previewFileName: function previewFileName() {
      var f = this.primaryAttachment;
      return f && (f.name || f.file) || '';
    },
    previewUrl: function previewUrl() {
      var f = this.primaryAttachment;
      if (!f) return '';
      return f.path || '';
    },
    primaryAttachmentIconClass: function primaryAttachmentIconClass() {
      var name = (this.previewFileName || '').toLowerCase();
      if (/\.pdf$/.test(name)) return 'fa-file-pdf';
      if (/\.(png|jpe?g|gif|webp)$/.test(name)) return 'fa-file-image';
      return 'fa-file';
    }
  },
  watch: {
    // Clear the mobile upload overlay the moment the upload+scan reaches a terminal
    // state. uploadNewReceipt's fresh-scan flow sets scanCompleted=true at every
    // success/failure branch (the rollback blocks + tryApplyReceiptScanPrefill's
    // finally + the receiptScan.status watcher below), so this single watcher covers
    // them all. Inert outside the upload flow: the flag is already false there.
    scanCompleted: function scanCompleted(newVal) {
      if (newVal === true) {
        this.uploadingScanOverlay = false;
      }
    },
    'receiptScan.status': function receiptScanStatus(newStatus) {
      var self = this;
      var terminalFailure = newStatus === 'Failed' || newStatus === 'PlatformUnreachable' || newStatus === 'PollingTimeout';
      if (newStatus === 'Complete') {
        // Guard: tryApplyReceiptScanPrefill (the inline /api/v4 sync path) already
        // applies amounts immediately after submit. The poller-driven Complete event
        // arrives later. With reconcile uploads always auto-linked (BE change), the
        // poller's autoFill data would re-run applyAmountPrefill and overwrite the
        // form — including writing nulls when photonSubtotal/photonTax both ==0 —
        // making the amount cells appear empty. Skip the redundant pass when prefill
        // already landed.
        if (!self.receiptScanPrefillApplied && self.receiptScan.autoLinked && self.receiptScan.autoFill) {
          // ReceiptScanAutoFillDataDto: photonTotal/photonSubtotal/photonTax (no confidence here)
          var auto = self.receiptScan.autoFill;
          self.applyAmountPrefill({
            totalAmount: auto.photonTotal,
            subtotalAmount: auto.photonSubtotal,
            taxAmount: auto.photonTax
          });
          self.receiptScanPrefillApplied = true;
          self.receiptScanConfidence = null;
        }
        // Photon is done — drop the skeleton. The inline-prefill path's finally
        // intentionally leaves these flags untouched on 409/404/sentinel so the
        // upload-bar's post-100% tick can engage the skeleton during the gap;
        // the watcher is responsible for clearing it once Photon lands.
        self.scanCompleted = true;
        self.scanningReceipt = false;
      } else if (terminalFailure) {
        // Photon never completed (failed / unreachable / poll timeout). Clear
        // the skeleton so the user can manually fill the form — the poller's
        // onError surfaces the user-facing message; no warning duplicated here.
        self.scanCompleted = true;
        self.scanningReceipt = false;
      }
    }
  },
  methods: {
    // Surface the custom Name on Card next to the holder ("Jane Doe | John Smith") when set and
    // meaningfully differs, mirroring the CardHolder.vue two-line layout the cards/envelopes grid renders.
    // See PRODUCTDEV-5553 for the underlying pattern.
    formatHolderLine: function formatHolderLine(rowData) {
      var holder = (rowData && rowData.Holder || '').trim();
      var nameOnCard = (rowData && rowData.NameOnCard || '').trim();
      if (!nameOnCard || nameOnCard.toLowerCase() === holder.toLowerCase()) {
        return rowData && rowData.Holder || '';
      }
      if (!holder) {
        return nameOnCard;
      }
      return "".concat(nameOnCard, " | ").concat(holder);
    },
    getCustomOptions: function getCustomOptions(url, key) {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this2.api.get(url);
            case 3:
              response = _context2.sent;
              if (response && response.data) {
                _this2.customOptions[key] = response.data;
              }
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    },
    openAttachment: function openAttachment(data) {
      data.e.preventDefault();

      // PRODUCTDEV-5783 — PDFs open in a new browser tab, matching how the rest of the app
      // opens files (window.open '_blank', e.g. envelope export). The in-app iframe can't
      // render cross-origin PDFs that send X-Frame-Options (Legacy/S3), so framing them left
      // the pane blank — that's why some receipt/document links "didn't work" for PDFs.
      if (data.file.type === 'application/pdf') {
        if (data.path) window.open(data.path, '_blank');
        return;
      }

      // Images keep the in-app overlay viewer — renders fine via <embed>.
      var frame = window.document.getElementById('transactionAttachment');
      frame.srcdoc = "<style>embed {width: 99%}</style><embed src=\"".concat(data.path, "\" type=").concat(data.file.type, " />");
      frame.classList.add('open');
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('openAttachment');
    },
    closeAttachment: function closeAttachment() {
      window.document.getElementById('transactionAttachment').classList.remove('open');
      window.document.getElementById('transactionAttachment').removeAttribute('srcdoc');
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('closeAttachment');
    },
    createAttachments: function createAttachments(e) {
      var _this3 = this;
      e.forEach(function (x) {
        var parts = x.name.split('.');
        var extension = '';
        if (parts.length > 1) {
          extension = parts[parts.length - 1];
        }
        if (!['pdf', 'png', 'jpg', 'jpeg'].includes(extension.toLowerCase())) {
          _this3.attachedFiles = _this3.attachedFiles.filter(function (x) {
            return x.success;
          });
          _this3.showWarningMessage("The file \"".concat(x.name, "\" is not compatible. Please upload files with one of the following extensions: .pdf, .png, .jpg, .jpeg"));
          return;
        }
        var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
        if (x.size >= MAX_FILE_SIZE) {
          _this3.attachedFiles = _this3.attachedFiles.filter(function (x) {
            return x.size <= MAX_FILE_SIZE;
          });
          _this3.showWarningMessage("The file \"".concat(x.name, "\" is too large. Please upload files smaller than 10 MB."));
          return;
        }
      });
      var completedFiles = e.filter(function (item) {
        return item.success ||
        // files uploaded with success
        !item.success && item.response && typeof item.response === 'string' && !_this3.isJson(item.response);
      } // files where requested failed
      );
      if (completedFiles.length === e.length) {
        this.uploadFinished = true;
        this.$emit('uploadFinished', this.uploadFinished);
        var attachments = e.map(function (item) {
          var uploadError = '';
          var itemResponse = null;
          var clientDataPath = '';
          var mediaFile = '';
          if (item.success && item.response) {
            itemResponse = JSON.parse(item.response);
            if (itemResponse.success) {
              var regex = /(ClientData\/.*)/;
              var match = itemResponse.path.match(regex);
              if (match && match.length > 1) {
                var filePath = match[1];
                clientDataPath = filePath.substring(filePath.indexOf('ClientData'));
                _this3.attachedPath.push(clientDataPath);
                var splits = clientDataPath.split('/');
                mediaFile = splits[splits.length - 1];
              } else {
                console.log('No matching files.');
              }
            }
            uploadError = itemResponse && itemResponse.uploadError ? itemResponse.uploadError : '';
          }
          if (!item.success) {
            uploadError = 'Upload request failed';
          }
          if (_this3.reconcileAction !== 'create' && !item.response) {
            var _splits = item.path.split('/');
            mediaFile = _splits[_splits.length - 1];
          }
          var vendorId = _this3.$root.getUser.$.data.VendorID;
          var VCI = _this3.$root.getUser.$.data.VCI;
          if (uploadError) {
            _this3.showWarningMessage('File "' + item.name + '": ' + uploadError);
          } else {
            return {
              OriginalName: item.name,
              SizeBytes: item.size,
              MediaFile: item.mediaFile ? item.mediaFile : mediaFile || '',
              AttachmentFile: itemResponse ? itemResponse.file : item.file || '',
              Id: item.id ? item.id : '',
              PathWithName: item.pathWithName ? item.pathWithName : itemResponse ? clientDataPath : '',
              FullPath: item.path ? item.path : itemResponse.path ? itemResponse.path : '',
              ReadOnly: item.readonly || false,
              VendorId: vendorId,
              VCI: VCI
            };
          }
        });
        this.mediaFilesPath = this.attachedPath.join(', ');
        this.$emit('mediaFilesPathUpdated', this.mediaFilesPath);
        this.attachedPath = [];
        try {
          this.attachedFiles = this.attachedFiles.filter(function (item) {
            return item.success && (!item.response && item.name ||
            // take existing items from edit
            JSON.parse(item.response).success // take new added items
            );
          }).map(function (item) {
            if (item.response) {
              var response = JSON.parse(item.response);
              if (response.path) {
                item.path = response.path; // assign the 'path' property from the response to the item
              }
            }
            return item;
          });
        } catch (ee) {
          console.error(ee);
        }
        var filteredAttachments = attachments.filter(function (item) {
          return item;
        });
        this.$emit('attachmentsUpdated', filteredAttachments);
        this.$emit('uploadFinished', this.uploadFinished);
        return filteredAttachments;
      } else {
        this.uploadFinished = false;
        this.$emit('uploadFinished', this.uploadFinished);
      }
    },
    isJson: function isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    singularize: function singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value;
    },
    populateFiles: function populateFiles() {
      var _this4 = this;
      if (this.transactionFiles.length > 0) {
        this.transactionFiles.forEach(function (file) {
          var parts = file.OriginalName.split('.');
          var extension = '';
          var fileType = '';
          if (parts.length > 1) {
            extension = parts[parts.length - 1].toLowerCase();
          }
          switch (extension) {
            case 'png':
              fileType = 'image/png';
              break;
            case 'pdf':
              fileType = 'application/pdf';
              break;
            case 'jpg':
              fileType = 'image/jpg';
              break;
            case 'jpeg':
              fileType = 'image/jpeg';
              break;
            default:
              fileType = '';
          }
          _this4.attachedFiles.push({
            name: file.OriginalName,
            type: fileType,
            size: file.SizeBytes,
            file: file.MediaFile,
            mediaFile: file.MediaFile,
            path: file.FullPath,
            pathWithName: file.PathWithName,
            id: file.Id,
            success: true,
            readonly: _this4.reconcileAction === 'view'
          });
        });
        var attachments = this.attachedFiles.map(function (item) {
          return {
            OriginalName: item.name,
            SizeBytes: item.size,
            MediaFile: item.mediaFile,
            AttachmentFile: item.file,
            PathWithName: item.pathWithName,
            FullPath: item.path,
            ReadOnly: item.readonly || false,
            Id: item.id
          };
        });
        var filteredAttachments = attachments.filter(function (item) {
          return item;
        });
        this.$emit('attachmentsUpdated', filteredAttachments);
      }
    },
    setRowFieldsValues: function setRowFieldsValues(fieldsValues) {
      var _this5 = this;
      if (this.loadedCategoriesAndBuAndCc === 0) {
        setTimeout(function () {
          _this5.setRowFieldsValues(fieldsValues);
        }, 100);
        return;
      }
      this.loadedCategoriesAndBuAndCc = -1;

      // No server-side coding rows to apply. Don't reset the per-row arrays
      // (descriptions/selectedCategory/selectedBu/selectedCc/referenceId/...) —
      // for a SUBMIT-match open, tryApplyReceiptScanPrefill already populated
      // them via applyAmountPrefill / applyLineItemsPrefill before this
      // deferred call lands, and the `= new Array(0).fill(...)` lines below
      // would clobber the prefill ('Subtotal' / 'Tax' descriptions disappear
      // about 100ms after the modal opens). For brand-new reconciles with no
      // prefill, the arrays start empty in data() so no-op is correct too.
      if (!Array.isArray(fieldsValues) || fieldsValues.length === 0) {
        this.codingRowsLoading = false;
        return;
      }
      var existingRow = this.form[0];
      while (this.form.length < fieldsValues.length) {
        var newRow = existingRow.map(function (field) {
          return {
            Key: field.Key,
            Label: field.Label,
            Values: field.Values,
            Required: field.Required,
            Type: field.Type
          };
        });
        this.form.push(newRow);
        this.splitCounter++;
      }
      if (this.hasBuAndCcPair) {
        this.selectedBuAndCcPair = new Array(fieldsValues.length).fill(null);
      }
      if (this.hasBu) {
        this.selectedBu = new Array(fieldsValues.length).fill(null);
      }
      if (this.hasCc) {
        this.selectedCc = new Array(fieldsValues.length).fill(null);
      }
      this.selectedCategory = new Array(fieldsValues.length).fill(null);
      this.predictedCategory = new Array(fieldsValues.length).fill(false);
      this.referenceId = new Array(fieldsValues.length).fill(null);
      this.descriptions = new Array(fieldsValues.length).fill('');
      fieldsValues.forEach(function (r, index) {
        _this5.$set(_this5.form[index], 'Amount', r.Amount);
        _this5.form[index].ItemId = r.ItemId;
        r.CustomFields.forEach(function (field) {
          _this5.form[index].forEach(function (f) {
            if (f.Key === field.FieldId) {
              if (f.Type === 'select') {
                var matchedOption = _this5.customOptions[f.Key].find(function (x) {
                  return x.text === field.Value;
                });
                if (matchedOption) {
                  _this5.$set(f, 'Values', matchedOption);
                }
              } else {
                f.Values = _this5.transaction && _this5.transaction.data && _this5.transaction.data.ReconcileId ? field.Value : f.Values;
              }
            }
          });
        });
        if (_this5.hasBuAndCcPair) {
          if (r.ProgramBusinessUnitAndCostCenter && r.ProgramBusinessUnitAndCostCenter.Id) {
            _this5.selectedBuAndCcPair[index] = _this5.buAndCcPairs.find(function (pair) {
              return pair.programBusinessUnitAndCostCenterId === r.ProgramBusinessUnitAndCostCenter.Id.toString();
            });
          }
        } else {
          if (r.BusinessUnit && r.BusinessUnit.Id) {
            _this5.selectedBu[index] = _this5.businessUnits.find(function (bu) {
              return bu.businessUnitId === r.BusinessUnit.Id.toString();
            });
          }
          if (r.CostCenter && r.CostCenter.Id) {
            _this5.selectedCc[index] = _this5.costCenters.find(function (cc) {
              return cc.costCenterId === r.CostCenter.Id.toString();
            });
          }
        }
        if (r.CategoryId) {
          _this5.selectedCategory[index] = _this5.categories.find(function (c) {
            return c.key === r.CategoryId.toString();
          });
          _this5.referenceId[index] = r.ReferenceId;
        }
        if (r.Description) {
          _this5.descriptions[index] = r.Description;
        }
      });
      this.handleSplitAmounts();
      this.emitReconcileData();
      // Values are now in form/per-row arrays — drop the skeleton.
      this.codingRowsLoading = false;

      // Existing reconcile values are now applied and the dropdown options are loaded,
      // so selectedCategory reflects the real coded/un-coded state. Attempt the silent prefill.
      this.prefillCategoryFromPrediction();
    },
    toggleSplit: function toggleSplit(index) {
      var _this6 = this;
      var existingRow = this.form[index];

      // PRODUCTDEV-5475 — initialize from the transaction amount, NOT 0. Splitting a $50 tx
      // should land on $50/$0, not $0/$0, so the user keeps the total in front of them to adjust;
      // it also stops a later "remove split" from snapping the single row back to the tx total
      // (handleSplitAmounts only resets to tx.Amount when the amount is missing/0). The null guard
      // preserves an already-typed amount, and prefill paths overwrite right after toggleSplit
      // returns, so subtotal+tax prefill is unaffected.
      if (this.form.length < 2 && this.form[index].Amount == null) {
        this.$set(this.form[index], 'Amount', this.transaction.data.Amount || 0);
      }

      // Clone the existing row fields
      var newRow = existingRow.map(function (field) {
        return {
          Key: field.Key,
          Label: field.Label,
          Values: '',
          // Reset Values
          Required: field.Required,
          Type: field.Type
        };
      });
      this.baseCustomFields.forEach(function (baseObj, baseIndex) {
        if (newRow[baseIndex]) {
          Object.keys(baseObj).forEach(function (key) {
            newRow[baseIndex][key] = baseObj[key];
          });
        }
      });

      // Force reactivity
      this.$set(newRow, 'Amount', 0);

      // Add the new row in the form
      this.form.splice(index + 1, 0, newRow);
      if (this.hasBuAndCcPair) {
        this.selectedBuAndCcPair.splice(index + 1, 0, null);
      }
      if (this.hasBu) {
        this.selectedBu.splice(index + 1, 0, null);
      }
      if (this.hasCc) {
        this.selectedCc.splice(index + 1, 0, null);
      }
      this.selectedCategory.splice(index + 1, 0, null);
      if (!Array.isArray(this.predictedCategory)) {
        this.predictedCategory = new Array(this.form.length - 1).fill(false);
      }
      this.predictedCategory.splice(index + 1, 0, false);
      this.referenceId.splice(index + 1, 0, null);
      this.descriptions.splice(index + 1, 0, '');
      this.$nextTick(function () {
        _this6.handleSplitAmounts();
      });
      this.splitCounter++;
      this.emitReconcileData();
    },
    removeSplit: function removeSplit(index) {
      if (this.form.length > 1) {
        this.form.splice(index, 1);
        if (this.hasBuAndCcPair) {
          this.selectedBuAndCcPair.splice(index, 1);
        }
        if (this.hasBu) {
          this.selectedBu.splice(index, 1);
        }
        if (this.hasCc) {
          this.selectedCc.splice(index, 1);
        }
        this.selectedCategory.splice(index, 1);
        if (Array.isArray(this.predictedCategory)) {
          this.predictedCategory.splice(index, 1);
        }
        this.referenceId.splice(index, 1);
        this.descriptions.splice(index, 1);
        this.splitCounter--;
        this.handleSplitAmounts();
        this.emitReconcileData();
        this.$forceUpdate();
      }
    },
    // Grow or shrink the form to exactly `target` rows so receipt-driven prefill
    // can apply cleanly regardless of the form's prior state. Used by the three
    // applyXxxPrefill paths when transitioning between prefill modes (e.g.
    // subtotal_and_tax → X → total_only would otherwise leave splitCounter=2
    // and the new total_only prefill would silently no-op).
    //
    // Tail rows are removed when shrinking — their per-row category/BU/CC/refId
    // metadata is intentionally discarded. This is fine because receipt-driven
    // prefill represents ground truth from the new receipt; the user hasn't
    // coded the new receipt's rows yet.
    normalizeFormForMode: function normalizeFormForMode(target) {
      if (!this.form || target < 1) {
        return;
      }
      while (this.form.length < target) {
        this.toggleSplit(this.form.length - 1);
      }
      while (this.form.length > target) {
        this.removeSplit(this.form.length - 1);
      }
    },
    copySplit: function copySplit(index) {
      if (this.form.length > 0) {
        this.copySplitObject.Amount = this.form[index].Amount;
        this.copySplitObject.Fields = Array.from(this.form[index]);
        if (this.hasBuAndCcPair) {
          this.copySplitObject.SelectedBuAndCcPair = this.selectedBuAndCcPair[index];
        }
        if (this.hasBu) {
          this.copySplitObject.SelectedBu = this.selectedBu[index];
        }
        if (this.hasCc) {
          this.copySplitObject.SelectedCc = this.selectedCc[index];
        }
        this.copySplitObject.SelectedCategory = this.selectedCategory[index];
        this.copySplitObject.ReferenceId = this.referenceId[index];
        this.copySplitObject.Description = this.descriptions[index];
      }
    },
    pasteSplit: function pasteSplit(index) {
      var _this7 = this;
      if (this.form.length > 0) {
        this.form[index].Amount = this.copySplitObject.Amount;
        this.copySplitObject.Fields.forEach(function (field) {
          var matchingField = _this7.form[index].find(function (f) {
            return f.Key === field.Key;
          });
          if (matchingField) {
            matchingField.Values = field.Values;
          }
        });
        if (this.hasBuAndCcPair) {
          this.selectedBuAndCcPair[index] = this.copySplitObject.SelectedBuAndCcPair;
        }
        if (this.hasBu) {
          this.selectedBu[index] = this.copySplitObject.SelectedBu;
        }
        if (this.hasCc) {
          this.selectedCc[index] = this.copySplitObject.SelectedCc;
        }
        this.selectedCategory[index] = this.copySplitObject.SelectedCategory;
        this.$set(this.predictedCategory, index, false);
        this.referenceId[index] = this.copySplitObject.ReferenceId;
        this.$set(this.descriptions, index, this.copySplitObject.Description != null ? this.copySplitObject.Description : '');
        this.handleSplitAmounts();
        this.emitReconcileData();
        this.$forceUpdate();
      }
    },
    resetSplit: function resetSplit() {
      // Program change clears only program-scoped per-row state (BU / CC / BU+CC pair /
      // Category / ReferenceId) because those options come from the program's chart of
      // accounts and don't carry over. Split rows themselves stay — together with their
      // amounts and descriptions — because those are either receipt-OCR-derived
      // (Subtotal/Tax or line items from Photon) or user-typed, neither of which is
      // tied to the program.
      var rowCount = this.form && this.form.length ? this.form.length : 1;
      this.selectedBu = new Array(rowCount).fill(null);
      this.selectedCc = new Array(rowCount).fill(null);
      this.selectedBuAndCcPair = new Array(rowCount).fill(null);
      this.selectedCategory = new Array(rowCount).fill(null);
      this.predictedCategory = new Array(rowCount).fill(false);
      this.referenceId = new Array(rowCount).fill(null);
      this.handleSplitAmounts();
      this.emitReconcileData();
      this.$forceUpdate();
    },
    formsTemplate: function formsTemplate() {
      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(this.transaction) === 'object' && this.transaction !== null) {
        if (!this.transaction.hasOwnProperty('form')) {
          this.transaction.form = JSON.parse(JSON.stringify(this.form));
        }
      }
    },
    getCategoriesAndBuAndCc: function getCategoriesAndBuAndCc(programId) {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this8.loadedCategoriesAndBuAndCc = 0;
              _context3.next = 3;
              return _this8.api.get(_this8.api.$.evedpaycard.categoriesAndBuAndCc, {
                params: {
                  programId: programId,
                  invoiceId: 0,
                  loadAllData: true
                }
              });
            case 3:
              response = _context3.sent;
              if (response && response.data) {
                if (response.data.costCentersAndBusinessUnit) {
                  _this8.hasBuAndCcPair = response.data.costCentersAndBusinessUnit.areCombined || _this8.$root.getUser.settings.UseBusinessUnitAndCostCenterMapping;
                  if (_this8.hasBuAndCcPair) {
                    if (response.data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits) {
                      _this8.buAndCcPairs = response.data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits;
                    }
                  } else {
                    _this8.hasBu = response.data.costCentersAndBusinessUnit.businessUnits.length > 0 || _this8.$root.getUser.settings.HasBusinessUnit;
                    _this8.hasCc = response.data.costCentersAndBusinessUnit.costCenters.length > 0 || _this8.$root.getUser.settings.HasCostCenter;
                    if (_this8.hasBu) {
                      _this8.businessUnits = response.data.costCentersAndBusinessUnit.businessUnits;
                    }
                    if (_this8.hasCc) {
                      _this8.costCenters = response.data.costCentersAndBusinessUnit.costCenters;
                    }
                  }
                }
                if (response.data.categories) {
                  _this8.categories = response.data.categories;
                }

                // Per-division Predictive Coding toggle, carried on the existing categories response.
                // Consumed by the predict prefill; when falsy, no predict XHR is ever fired.
                _this8.allowPredictiveCoding = !!response.data.allowPredictiveCoding;
                _this8.loadedCategoriesAndBuAndCc = 1;
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    onSelectProgramOpen: function onSelectProgramOpen() {
      this.programLoader.searchTerm = '';
      this.loadPrograms(true);
    },
    loadPrograms: function loadPrograms() {
      var _arguments = arguments,
        _this9 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var reset, loader, _yield$_this9$api$get, data, Items, HasMore, mapped;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              reset = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              loader = _this9.programLoader;
              if (!loader.isLoading) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              if (reset) {
                loader.pageIndex = 0;
                loader.items = [];
                loader.hasMore = true;
              }
              if (loader.hasMore) {
                _context4.next = 7;
                break;
              }
              return _context4.abrupt("return");
            case 7:
              loader.isLoading = true;
              _context4.prev = 8;
              _context4.next = 11;
              return _this9.api.get(_this9.api.$.evedpaycard.programs, {
                params: {
                  divisionId: _this9.transaction.data.DivisionId,
                  pageIndex: loader.pageIndex,
                  pageSize: _this9.pageSize,
                  searchTerm: loader.searchTerm
                }
              });
            case 11:
              _yield$_this9$api$get = _context4.sent;
              data = _yield$_this9$api$get.data;
              Items = data.Items, HasMore = data.HasMore;
              mapped = Items.map(function (p) {
                return {
                  Id: p.ProgramId,
                  Name: p.ProgramName,
                  InternalProgramID: p.InternalProgramID
                };
              });
              loader.items = reset ? mapped : loader.items.concat(mapped);
              loader.hasMore = HasMore;
              loader.pageIndex += 1;
              _this9.programOptions = loader.items;
              _context4.next = 24;
              break;
            case 21:
              _context4.prev = 21;
              _context4.t0 = _context4["catch"](8);
              console.error('loadPrograms error', _context4.t0);
            case 24:
              _context4.prev = 24;
              loader.isLoading = false;
              return _context4.finish(24);
            case 27:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[8, 21, 24, 27]]);
      }))();
    },
    onProgramSearch: function onProgramSearch(term) {
      this.programLoader.searchTerm = term;
      this.loadPrograms(true);
    },
    getReconcile: function getReconcile(row) {
      var _this10 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
        var reachedSetRowFieldsValues, response, form, _iterator, _step, x, transactionFields;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this10.programs = [];
              // Guarantee codingRowsLoading flips false on EVERY exit — without this,
              // any failure between here and setRowFieldsValues (network blip, 500,
              // transient perm error, getCustomOptions rejection) leaves the coding
              // <tbody> stuck behind the shimmer with no recovery short of closing
              // the modal.
              reachedSetRowFieldsValues = false;
              _context5.prev = 2;
              _context5.next = 5;
              return _this10.api.get('evedpaycards/transactions/get-reconcile', {
                params: {
                  transactionId: row.Id,
                  divisionId: row.DivisionId
                }
              });
            case 5:
              response = _context5.sent;
              if (!(response && response.data)) {
                _context5.next = 43;
                break;
              }
              _this10.noteText = response.data.ReconcileNote;
              _this10.requireReceiptDescription = response.data.RequireReceiptDescription;
              _this10.handleTextDescription();
              _this10.transactionFiles = response.data.TransactionFiles;
              _this10.populateFiles();
              // PRODUCTDEV-5772 — hydrate supporting documents (separate from receipts).
              _this10.populateAdditionalDocuments(response.data.AdditionalDocuments);
              form = response.data.Form;
              _this10.formKey = form.Key;
              if (form.Fieldsets && form.Fieldsets.length > 0) {
                _this10.form = [form.Fieldsets[0].Fields];
                _this10.baseCustomFields = JSON.parse(JSON.stringify(form.Fieldsets[0].Fields));
              } else {
                _this10.form = [[]];
                _this10.baseCustomFields = [[]];
              }
              _this10.$emit('fields-updated', {
                fields: _this10.form,
                formKey: _this10.formKey
              });
              _this10.formsTemplate();
              _iterator = _createForOfIteratorHelper(_this10.form[0]);
              _context5.prev = 19;
              _iterator.s();
            case 21:
              if ((_step = _iterator.n()).done) {
                _context5.next = 30;
                break;
              }
              x = _step.value;
              if (!(x.Type === 'select')) {
                _context5.next = 28;
                break;
              }
              _this10.$set(_this10.customOptions, x.Key, []);
              if (!(x.DataSource && x.DataSource.Url)) {
                _context5.next = 28;
                break;
              }
              _context5.next = 28;
              return _this10.getCustomOptions(x.DataSource.Url, x.Key);
            case 28:
              _context5.next = 21;
              break;
            case 30:
              _context5.next = 35;
              break;
            case 32:
              _context5.prev = 32;
              _context5.t0 = _context5["catch"](19);
              _iterator.e(_context5.t0);
            case 35:
              _context5.prev = 35;
              _iterator.f();
              return _context5.finish(35);
            case 38:
              // PRODUCTDEV-5772 — always load whatever coding was saved (the most recent
              // save) and show it on reopen. A previous "orphan-rescue" guard discarded
              // saved coding here for Open txns that once had a receipt but no longer do —
              // that was a band-aid for the old remove-receipt-clears-coding behavior, which
              // no longer exists. Coding now persists by design (✕ / replace never wipe it),
              // so the form must reflect exactly what was saved last.
              transactionFields = response.data.TransactionFields; // Snapshot "opened with coding" synchronously (before setRowFieldsValues'
              // deferred per-row population) so hasCodingOrReceipt is correct immediately.
              _this10.loadedWithCoding = Array.isArray(transactionFields) && transactionFields.length > 0;
              reachedSetRowFieldsValues = true;
              _this10.setRowFieldsValues(transactionFields);
              if (Array.isArray(response.data.Descriptions)) {
                _this10.descriptions = response.data.Descriptions;
              }
            case 43:
              _context5.prev = 43;
              // setRowFieldsValues already flips this flag on its own success
              // path; the finally only matters on the error path where we never
              // reached it. Without the guard the loading shimmer would mask
              // the coding rows for the rest of the modal's lifetime.
              if (!reachedSetRowFieldsValues) {
                _this10.codingRowsLoading = false;
              }
              return _context5.finish(43);
            case 46:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[2,, 43, 46], [19, 32, 35, 38]]);
      }))();
    },
    fetchSuppliersOnOpen: function fetchSuppliersOnOpen() {
      var _this11 = this;
      this.suppliers.length || this.api.get(this.api.$.evedpaycard.suppliers, {
        params: {
          q: ''
        }
      }).then(function (r) {
        if (r && r.data) {
          _this11.supplierOptions = r.data;
          _this11.originalSuppliers = r.data;
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    fetchSuppliers: function fetchSuppliers(query) {
      var _this12 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
        var results;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this12.api.get(_this12.api.$.evedpaycard.suppliers, {
                params: {
                  q: query || ''
                }
              });
            case 2:
              results = _context6.sent;
              if (results && results.data) {
                _this12.supplierOptions = results.data;
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getSelectedSupplier: function getSelectedSupplier(e) {
      this.selectedSupplier = e.Value.VendorId;
    },
    getLabel: function getLabel(option) {
      if (Object.keys(option).length > 0) {
        return option.Value.CompanyName + (option.Value.Vci ? ' (#' + option.Value.Vci + ')' : '');
      }
    },
    handleSplitAmounts: function handleSplitAmounts() {
      var _this13 = this;
      this.form.forEach(function (item, index) {
        // Preserve an explicitly-blank Amount (null / undefined). Receipt prefill in
        // subtotal_and_tax mode uses null to mean "Photon couldn't extract this side —
        // let the user type it in" — coercing it back to 0 would render $0.00 in the
        // input and mask the intent.
        if (item.Amount === null || item.Amount === undefined) {
          return;
        }

        // PRODUCTDEV-5475 — keep a row's amount whenever it's a real value. A 0 only
        // counts as "real" when the row carries a description (a prefilled "Subtotal"/
        // "Tax" line, or one the user labelled), so a no-tax receipt's $0 row survives a
        // split removal. A 0/blank on an UNdescribed row is just a placeholder: a single
        // row falls back to the transaction total, a multi-row stays 0. Non-zero amounts
        // are always kept regardless of description.
        var hasDescription = !!(_this13.descriptions && String(_this13.descriptions[index] || '').trim());
        var amountNum = parseFloat(item.Amount);
        var keepAmount = item.Amount !== '' && !isNaN(amountNum) && (amountNum !== 0 || hasDescription);
        var parsedAmount = keepAmount ? amountNum : _this13.form.length === 1 ? parseFloat(_this13.transaction.data.Amount) : 0;

        // Ensure the amount is set reactively
        if (!isNaN(parsedAmount)) {
          _this13.$set(item, 'Amount', parsedAmount);
        }
      });

      // Make sure the split amounts are updated and Vue re-renders
      this.splitAmounts = this.form.map(function (item) {
        return item.Amount;
      });
      this.$forceUpdate(); // Force Vue to update the DOM
      this.$emit('split-amounts', this.splitAmounts);
    },
    handleTextDescription: function handleTextDescription() {
      var data = {
        noteText: this.noteText,
        requireReceiptDescription: this.requireReceiptDescription
      };
      this.$emit('description-text', data);
      this.fieldsIncomplete.descriptionIncomplete = false;
    },
    handleSupplierSelection: function handleSupplierSelection(option) {
      this.selectedSupplier = option;
      this.emitReconcileData();
    },
    handleProgramChange: function handleProgramChange(option) {
      var _this14 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this14.selectedProgram = option !== null ? option : Object;
              _this14.resetSplit();
              if (!(option && option.Id)) {
                _context7.next = 6;
                break;
              }
              _context7.next = 5;
              return _this14.getCategoriesAndBuAndCc(option.Id);
            case 5:
              // PRODUCTDEV-5699 — the dominant flow opens the transaction with no program and
              // picks it here. The load-path prefill (setRowFieldsValues) only runs for a
              // transaction that already carried a program at open, so without this re-fire no
              // prediction ever runs for an interactively chosen program. getCategoriesAndBuAndCc
              // has just refreshed allowPredictiveCoding for THIS program's division and resetSplit
              // cleared the row, so the reactive precondition holds (division on, categories loaded,
              // merchant known, un-coded row). The division / categories-loaded / no-clobber gates
              // all live inside prefillCategoryFromPrediction, so re-calling it stays gated.
              _this14.prefillCategoryFromPrediction();
            case 6:
              _this14.emitReconcileData();
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    handleProgramInput: function handleProgramInput(option) {
      if (this.previousSelectedProgram && option && this.previousSelectedProgram.Id === option.Id) {
        this.handleProgramChange(option);
        return;
      }
      this.programOption = option;
      if (Object.keys(this.previousSelectedProgram).length !== 0 && this.previousSelectedProgram && this.previousSelectedProgram.Id && this.previousSelectedProgram.Name) {
        this.showAlert = true;
      } else {
        this.handleProgramChange(option);
      }
    },
    handleBUSelection: function handleBUSelection(option, rowIndex) {
      this.selectedBu[rowIndex] = option;
      this.emitReconcileData();
    },
    handleCCSelection: function handleCCSelection(option, rowIndex) {
      this.selectedCc[rowIndex] = option;
      this.emitReconcileData();
    },
    handleBuAndCcPairSelection: function handleBuAndCcPairSelection(option, rowIndex) {
      this.selectedBuAndCcPair[rowIndex] = option;
      this.emitReconcileData();
    },
    handleCategorySelection: function handleCategorySelection(option, rowIndex, opts) {
      // PRODUCTDEV-5699 — use $set, not direct array-index assignment. Vue 2 does not track
      // `this.arr[i] = v`, so a programmatic prefill (predictive coding) set the data but the
      // bound <ed-select> never re-rendered — the predicted Category looked unselected. Manual
      // picks worked because they flow through the component's own v-model. $set makes the
      // programmatic set reactive for both paths.
      this.$set(this.selectedCategory, rowIndex, option);
      this.$set(this.referenceId, rowIndex, option && option.referenceId ? option.referenceId : null);
      this.$set(this.predictedCategory, rowIndex, !!(this.allowPredictiveCoding && opts && opts.predicted && option));
      this.emitReconcileData();
    },
    // Predictive Coding: silent, fail-silent Category prefill for an un-coded EPC reconcile row.
    // Fire-and-forget; any failure leaves the field empty and the user codes manually.
    prefillCategoryFromPrediction: function prefillCategoryFromPrediction() {
      var _arguments2 = arguments,
        _this15 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee8() {
        var rowIndex, row, programId, response, prediction, option;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              rowIndex = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : 0;
              if (_this15.allowPredictiveCoding) {
                _context8.next = 3;
                break;
              }
              return _context8.abrupt("return");
            case 3:
              if (!(!_this15.categories || _this15.categories.length === 0)) {
                _context8.next = 5;
                break;
              }
              return _context8.abrupt("return");
            case 5:
              if (!_this15.selectedCategory[rowIndex]) {
                _context8.next = 7;
                break;
              }
              return _context8.abrupt("return");
            case 7:
              row = _this15.transaction && _this15.transaction.data;
              if (row) {
                _context8.next = 10;
                break;
              }
              return _context8.abrupt("return");
            case 10:
              // PRODUCTDEV-5699 — use the program the user actually has selected. In the dominant flow
              // the program is picked after the transaction opens, so transaction.data.ProgramId is still
              // null/stale here; fall back to it for the load path where the two are equal.
              programId = _this15.selectedProgram && _this15.selectedProgram.Id || row.ProgramId;
              if (programId) {
                _context8.next = 13;
                break;
              }
              return _context8.abrupt("return");
            case 13:
              _context8.prev = 13;
              _context8.next = 16;
              return _this15.api.platform.post(_this15.api.$.predictiveCoding.predict, {
                programId: programId,
                divisionId: row.DivisionId,
                surface: EPC_RECONCILE_SURFACE,
                supplierId: null,
                merchantName: row.Merchant,
                itemName: null,
                description: null,
                amount: row.Amount != null ? row.Amount : null,
                mcc: null
              }, {
                timeout: PREDICT_TIMEOUT_MS
              });
            case 16:
              response = _context8.sent;
              prediction = response && response.data; // null categoryId means no prediction (miss/short-circuit): leave the field empty.
              if (!(!prediction || prediction.categoryId == null)) {
                _context8.next = 20;
                break;
              }
              return _context8.abrupt("return");
            case 20:
              if (!_this15.selectedCategory[rowIndex]) {
                _context8.next = 22;
                break;
              }
              return _context8.abrupt("return");
            case 22:
              option = _this15.findPredictedCategoryOption(prediction.categoryId, prediction.subCategoryId);
              if (option) {
                // Reuse the manual-pick handler so Reference Id fills from option.referenceId exactly as on a manual pick.
                _this15.handleCategorySelection(option, rowIndex, {
                  predicted: true
                });
              }
              _context8.next = 28;
              break;
            case 26:
              _context8.prev = 26;
              _context8.t0 = _context8["catch"](13);
            case 28:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[13, 26]]);
      }))();
    },
    // Match a predicted categoryId/subCategoryId pair to a dropdown option by its composite key.
    // Options carry key = `${categoryId}_${subCategoryId}` when a subcategory is present, else `${categoryId}`.
    findPredictedCategoryOption: function findPredictedCategoryOption(categoryId, subCategoryId) {
      var key = subCategoryId != null ? "".concat(categoryId, "_").concat(subCategoryId) : "".concat(categoryId);
      return this.categories.find(function (option) {
        return option.key === key;
      });
    },
    handleReferenceID: function handleReferenceID(value, rowIndex) {
      this.referenceId[rowIndex] = value;
      this.emitReconcileData();
    },
    handleDescription: function handleDescription(value, rowIndex) {
      // Mirrors handleReferenceID — prefill seeds the description ('Total' /
      // 'Subtotal' / 'Tax' / line-item name), the user can correct it inline,
      // and emitReconcileData carries the edits to the save payload via
      // form.Descriptions[i].
      this.descriptions[rowIndex] = value;
      this.emitReconcileData();
    },
    emitReconcileData: function emitReconcileData() {
      var data = {
        itemIds: this.form.map(function (item) {
          return item.ItemId;
        }),
        splitCounter: this.splitCounter,
        selectedSupplier: this.selectedSupplier !== null ? this.selectedSupplier : Object,
        selectedProgram: this.selectedProgram !== null ? this.selectedProgram : Object,
        selectedCategory: this.selectedCategory.map(function (x) {
          return x && x.key;
        }),
        referenceId: this.referenceId !== null ? this.referenceId : '',
        descriptions: this.descriptions,
        fields: this.form
      };
      if (this.hasBuAndCcPair) {
        data.selectedBu = this.selectedBuAndCcPair.map(function (x) {
          return x && parseInt(x.businessUnitId, 10);
        });
        data.selectedCc = this.selectedBuAndCcPair.map(function (x) {
          return x && parseInt(x.costCenterId, 10);
        });
        data.selectedBuAndCcPair = this.selectedBuAndCcPair.map(function (x) {
          return x && parseInt(x.programBusinessUnitAndCostCenterId, 10);
        });
      } else {
        if (this.hasBu) {
          data.selectedBu = this.selectedBu.map(function (x) {
            return x && parseInt(x.businessUnitId, 10);
          });
        }
        if (this.hasCc) {
          data.selectedCc = this.selectedCc.map(function (x) {
            return x && parseInt(x.costCenterId, 10);
          });
        }
      }
      this.$emit('reconcile-created', data);
    },
    formatDate: function formatDate(date) {
      var momentDateFormat = this.$root.getUser.sessionSettings.DateAndTimeFormats.MomentDateFormat;
      return global.moment(date).format(momentDateFormat);
    },
    showWarningMessage: function showWarningMessage(message) {
      var _this16 = this;
      this.$nextTick(function () {
        _this16.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: {
            from: 'top',
            align: 'center'
          },
          timeout: 0,
          message: message,
          discard: 'Ok',
          goto: ''
        });
      });
    },
    // Pick up the Legacy /UploadReceiptReconcile metadata that Card-list's
    // Dashboard SUBMIT flow stored before navigation, push it to attachedFiles
    // so the save payload has a TransactionFile row, then delete the key.
    // No-op when called without a stash entry (e.g. plain reconcile reopen).
    consumeStashedLegacyReceipt: function consumeStashedLegacyReceipt(receiptScanId) {
      if (!receiptScanId) return;
      var key = 'receiptScanLegacyPath_' + receiptScanId;
      var raw;
      try {
        raw = global.sessionStorage.getItem(key);
      } catch (err) {
        return;
      }
      if (!raw) return;
      var meta;
      try {
        meta = JSON.parse(raw);
      } catch (err) {
        try {
          global.sessionStorage.removeItem(key);
        } catch (e) {}
        return;
      }
      try {
        global.sessionStorage.removeItem(key);
      } catch (e) {}
      if (!meta || !meta.pathWithName) return;
      // Don't double-attach if populateFiles already pulled an existing
      // TransactionFile for the same path (e.g. on a refresh after save).
      var alreadyAttached = this.attachedFiles.some(function (f) {
        return f && f.pathWithName === meta.pathWithName;
      });
      if (alreadyAttached) return;
      this.attachedFiles.push({
        name: meta.name || 'Receipt',
        type: meta.type || '',
        size: meta.size || 0,
        file: meta.file || meta.mediaFile || '',
        mediaFile: meta.mediaFile || meta.file || '',
        path: meta.path || '',
        pathWithName: meta.pathWithName,
        id: '',
        success: true,
        readonly: false,
        receiptScanId: receiptScanId,
        // Flag: this attachment came from a pre-existing matched scan (uploaded
        // before the modal opened, via Dashboard SUBMIT or the folder picker).
        // cleanupUnsavedReceipts must skip it on cancel — the scan is already in
        // Matched state, and DELETE on it would orphan the match + (per Tudor's
        // repro) the BE request hangs since the scan isn't a fresh upload.
        preExistingMatch: true
      });
      this.emitAttachmentsUpdated();
    },
    // Mobile FAB flow bridge (PRODUCTDEV-5475): a scan matched on the SubmitReceipt
    // page is Platform-only — Legacy has no TransactionFiles row yet, so populateFiles
    // leaves the Receipt slot empty. Fetch the scan's FileInfo + presigned URL and push
    // a synthetic attachment so hasAttachment flips true and the receipt renders.
    // Called only when isMobile && attachedFiles is empty (see init) — desktop never
    // arrives in this state.
    attachReceiptScanIfMissing: function attachReceiptScanIfMissing(receiptScanId) {
      var _this17 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee9() {
        var results, scan, imageRes, fi, presignedUrl, name, parts, ext, fileType, stagedKey;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (receiptScanId) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              _context9.prev = 2;
              _context9.next = 5;
              return Promise.all([__WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].getStatus(receiptScanId), __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].getImage(receiptScanId).catch(function () {
                return null;
              })]);
            case 5:
              results = _context9.sent;
              scan = results[0];
              imageRes = results[1];
              fi = scan && scan.fileInfo;
              if (!(!fi || !fi.providerKey)) {
                _context9.next = 11;
                break;
              }
              return _context9.abrupt("return");
            case 11:
              presignedUrl = '';
              if (imageRes && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(imageRes) === 'object') {
                presignedUrl = imageRes.presignedUrl || imageRes.url || imageRes.data && (imageRes.data.presignedUrl || imageRes.data.url) || '';
              } else if (typeof imageRes === 'string') {
                presignedUrl = imageRes;
              }
              name = fi.originalFileName || 'receipt';
              parts = name.split('.');
              ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
              fileType = '';
              _context9.t0 = ext;
              _context9.next = _context9.t0 === 'png' ? 20 : _context9.t0 === 'pdf' ? 22 : _context9.t0 === 'jpg' ? 24 : _context9.t0 === 'jpeg' ? 26 : 28;
              break;
            case 20:
              fileType = 'image/png';
              return _context9.abrupt("break", 29);
            case 22:
              fileType = 'application/pdf';
              return _context9.abrupt("break", 29);
            case 24:
              fileType = 'image/jpg';
              return _context9.abrupt("break", 29);
            case 26:
              fileType = 'image/jpeg';
              return _context9.abrupt("break", 29);
            case 28:
              fileType = fi.contentType || '';
            case 29:
              // path = presigned URL drives <img src> via the computed previewUrl.
              // pathWithName = the scan image's durable STAGED S3 key (PRODUCTDEV-5783
              // pattern), derived from the presigned URL exactly like the folder
              // claim/replace flows — Legacy persists it and reopen re-serves it as
              // AWS_ASSETS_PRIVATE_PATH + PathWithName through the session-authed
              // Storage/private proxy. Do NOT store fi.providerKey here: that is
              // Photon's RESULT ARTIFACT key (data/…/*.json), which the proxy refuses
              // (no auth case for 'data/…') — every FAB-matched reconcile reopened
              // with a broken receipt image until 2026-06-06. providerKey survives
              // only as a non-empty fallback so the save payload never carries an
              // empty PathWithName (empty crashes Legacy's reopen path).
              stagedKey = _this17.stagedKeyFromPresignedUrl(presignedUrl);
              _this17.attachedFiles.push({
                name: name,
                type: fileType,
                size: fi.sizeBytes,
                file: name,
                mediaFile: name,
                path: presignedUrl || fi.providerKey,
                pathWithName: stagedKey || fi.providerKey,
                id: '',
                success: true,
                readonly: false,
                receiptScanId: receiptScanId,
                // Scan is already in Matched state from SubmitReceipt's matchToTransaction.
                // cleanupUnsavedReceipts must skip it on cancel — DELETE on a Matched
                // scan orphans the link (same constraint as the folder-pick
                // preExistingMatch flag).
                preExistingMatch: true
              });
              _this17.emitAttachmentsUpdated();
              _context9.next = 37;
              break;
            case 34:
              _context9.prev = 34;
              _context9.t1 = _context9["catch"](2);
              // Non-critical — user can still manually attach via the camera/upload buttons.
              console.warn('attachReceiptScanIfMissing failed:', _context9.t1);
            case 37:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[2, 34]]);
      }))();
    },
    tryApplyReceiptScanPrefill: function tryApplyReceiptScanPrefill(receiptScanIdArg) {
      var _this18 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee10() {
        var receiptScanId, prefillData, prefillDeferred, stashKey, stashed, amount, status, notReady;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              receiptScanId = receiptScanIdArg || _this18.$route.query.receiptScanId; // PRODUCTDEV-5788 — never scan/prefill when the division is "No Receipt Capture".
              if (!(!receiptScanId || !_this18.receiptScanEnabled || _this18.receiptCaptureDisabled)) {
                _context10.next = 3;
                break;
              }
              return _context10.abrupt("return");
            case 3:
              // Check for pre-fetched prefill (Card-list.openMatchedReconcile pre-calls
              // /prefill before opening the modal so the form arrives populated). One-shot:
              // remove the key after consuming so a refresh doesn't reuse stale data.
              prefillData = null;
              prefillDeferred = false;
              try {
                stashKey = 'receiptScanPrefill_' + receiptScanId;
                stashed = global.sessionStorage.getItem(stashKey);
                if (stashed) {
                  try {
                    prefillData = JSON.parse(stashed);
                  } catch (e) {
                    prefillData = null;
                  }
                  try {
                    global.sessionStorage.removeItem(stashKey);
                  } catch (e) {}
                }
              } catch (e) {
                // sessionStorage disabled / SSR — fall through to API
              }
              _context10.prev = 6;
              if (prefillData) {
                _context10.next = 11;
                break;
              }
              _context10.next = 10;
              return __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].getPrefill(receiptScanId, _this18.receiptScanDivisionId);
            case 10:
              prefillData = _context10.sent;
            case 11:
              if (prefillData) {
                // ReceiptPrefillDto shape: { amount: { total, subtotal, tax, currencyCode }, lineItems,
                //   overallConfidence, prefillMode, fallbackReason, warnings, merchantName, transactionDate, description }
                amount = prefillData.amount || {};
                if (prefillData.prefillMode === 'line_items_and_tax' && Array.isArray(prefillData.lineItems) && prefillData.lineItems.length > 0) {
                  _this18.applyLineItemsPrefill(prefillData.lineItems);
                } else {
                  _this18.applyAmountPrefill({
                    totalAmount: amount.total,
                    subtotalAmount: amount.subtotal,
                    taxAmount: amount.tax
                  });
                }
                _this18.receiptScanPrefillApplied = true;
                _this18.receiptScanPrefillMode = prefillData.prefillMode || null;
                _this18.receiptScanConfidence = prefillData.overallConfidence != null ? prefillData.overallConfidence < 0.7 ? 'low' : prefillData.overallConfidence < 0.9 ? 'medium' : 'high' : null;
                // Capture the mismatch signal + Photon's total so the banner can show
                // both amounts. `amountMatch` is the BE-side comparison code; the
                // warnings array is the canonical user-facing trigger.
                _this18.amountMismatch = Array.isArray(prefillData.warnings) && prefillData.warnings.indexOf('warning.amount_mismatch') >= 0;
                _this18.receiptScanPhotonTotal = amount && amount.total != null ? amount.total : null;
              }
              _context10.next = 19;
              break;
            case 14:
              _context10.prev = 14;
              _context10.t0 = _context10["catch"](6);
              // Suppress the toast when the scan simply isn't ready yet. The inline
              // call from uploadNewReceipt fires in parallel with the poller, so it
              // commonly hits /prefill before Photon has finished — Platform returns
              // 409 (not_ready); 404 covers the rare race where the scan was disposed
              // before this call landed; sentinel errors (timeout / 5xx) include the
              // 15s pollInstance timeout that fires when Photon takes longer than
              // expected. In all three the watcher-driven prefill on
              // `receiptScan.status` still runs once it flips to Complete, so the user isn't
              // left without prefill — surfacing a warning is just noise.
              status = _context10.t0 && _context10.t0.response && _context10.t0.response.status;
              notReady = status === 409 || status === 404 || _context10.t0.isPlatformSentinelError;
              if (notReady) {
                prefillDeferred = true;
                console.warn('Receipt prefill deferred to poller path:', status || _context10.t0 && _context10.t0.message);
              } else {
                console.error('Receipt scan prefill error:', _context10.t0);
                _this18.showWarningMessage('Could not load receipt prefill data. Proceeding without prefill.');
              }
            case 19:
              _context10.prev = 19;
              // Photon round-trip is over (success OR non-retry error) — clear the
              // skeleton and lower the gate so the bar's post-100% tick in
              // startUploadProgressBar doesn't re-engage it. EXCEPTION: when the
              // inline /prefill returned 409/404/sentinel "not_ready", the
              // poller-driven `receiptScan.status` watcher is still going to apply
              // prefill on Complete. Leaving scanCompleted
              // false here keeps the bar-post-100% tick eligible to flip the
              // skeleton ON, covering the bar-end → Photon-complete gap (~10s for
              // typical Photon timing). The watcher clears both flags when it lands.
              if (!prefillDeferred) {
                _this18.scanCompleted = true;
                _this18.scanningReceipt = false;
              }
              return _context10.finish(19);
            case 22:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[6, 14, 19, 22]]);
      }))();
    },
    applyAmountPrefill: function applyAmountPrefill(prefillData) {
      if (!prefillData || this.reconcileAction === 'view') {
        return;
      }
      var hasSubtotalAndTax = prefillData.subtotalAmount != null && prefillData.taxAmount != null;
      if (hasSubtotalAndTax && this.form) {
        // Normalize to exactly 2 rows — handles fresh state (split from 1→2) AND
        // the receipt-replacement case where the user just X'd a prior receipt
        // that left the form at splitCounter=N (e.g. line_items_and_tax).
        this.normalizeFormForMode(2);
        if (!this.form[0]) {
          return;
        }

        // Photon /api/v4 emits 0 (not null) for Subtotal/Tax when it failed to extract them
        // — confidence==0 in the raw JSON. Both-zero against any total is the unambiguous
        // "no breakdown" signal. In that case leave the Amount fields BLANK so the user
        // can type the split themselves rather than overwriting the form with $0.00s.
        // When at least one side is non-zero we trust Photon's numbers (legit no-tax
        // receipts have subtotal>0, tax=0 with high confidence and stay correct).
        var bothZero = prefillData.subtotalAmount === 0 && prefillData.taxAmount === 0;
        this.$set(this.form[0], 'Amount', bothZero ? null : prefillData.subtotalAmount);
        if (this.form[1]) {
          this.$set(this.form[1], 'Amount', bothZero ? null : prefillData.taxAmount);
        }

        // Hardcoded row labels — the OCR doesn't tag subtotal/tax as line items,
        // so we synthesize the two labels that match what the user sees in the Receipt
        // Data panel. Saved to Legacy via form.Descriptions[i] on submit.
        this.descriptions = ['Subtotal', 'Tax'];
        this.handleSplitAmounts();
        // handleSplitAmounts only emits 'split-amounts'; descriptions ride on
        // reconcile-created, so emit that too or the labels never reach the save payload.
        this.emitReconcileData();
      } else if (prefillData.totalAmount != null && this.form) {
        // Normalize to exactly 1 row — handles fresh state AND the
        // receipt-replacement case where the prior receipt left the form at
        // splitCounter > 1 (the bug Tudor reported: sub+tax → X → total_only
        // used to silently no-op because of a `splitCounter === 1` guard here).
        this.normalizeFormForMode(1);
        var row = this.form[0];
        if (row) {
          this.$set(row, 'Amount', prefillData.totalAmount);
          // Symmetric with the subtotal_and_tax branch above — give the single
          // row a label so the user has a visible "prefill happened" signal in
          // the Description column.
          this.descriptions = ['Total'];
          this.handleSplitAmounts();
          this.emitReconcileData();
        }
      }
    },
    applyLineItemsPrefill: function applyLineItemsPrefill(lineItems) {
      if (!Array.isArray(lineItems) || lineItems.length === 0 || this.reconcileAction === 'view' || !this.form) {
        return;
      }

      // Normalize to exactly N rows. Used to require splitCounter===1 and grew
      // the form with a loop of toggleSplit; that broke the receipt-replacement
      // case (prior receipt left the form with the wrong row count and the
      // function silently no-op'd). normalizeFormForMode handles both grow and
      // shrink uniformly.
      this.normalizeFormForMode(lineItems.length);
      for (var j = 0; j < lineItems.length; j++) {
        if (this.form[j]) {
          this.$set(this.form[j], 'Amount', lineItems[j].amount);
        }
      }

      // `descriptions` — per-row split-item labels. Read back from Legacy split-item
      // Description column (EvedPayCardsRepository:2984) and sent on save via indexed
      // parallel array (form.Descriptions[i]). Falsy entries render no span — see Coding row template.
      this.descriptions = lineItems.map(function (li) {
        return li && li.description || '';
      });
      this.handleSplitAmounts();
      // Push descriptions up to the parent so they ride the save payload —
      // handleSplitAmounts only emits 'split-amounts'.
      this.emitReconcileData();
    },
    openFolderPicker: function openFolderPicker() {
      this.showFolderPicker = true;
    },
    closeFolderPicker: function closeFolderPicker() {
      this.showFolderPicker = false;
      this.folderPickerIsProcessing = false;
    },
    handleFolderPickerSelect: function handleFolderPickerSelect(event) {
      var _this19 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee11() {
        var receiptScanId, self, optimisticAttachment, statusData, imgRes, presignedUrl, stagedKey, fileName, contentType, blob, blobUrl, imgFetch, fileSize, legacyUrl, blobType, legacyFile, legacyFormData, legacyToken, legacyResp, legacyBody, pwnMatch, clientDataPath, mediaFile;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!_this19.hasCodingOrReceipt) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return", _this19.replaceReceiptFromFolder(event));
            case 2:
              receiptScanId = event && event.receiptScanId;
              if (!(!receiptScanId || _this19.folderPickerIsProcessing)) {
                _context11.next = 5;
                break;
              }
              return _context11.abrupt("return");
            case 5:
              _this19.folderPickerIsProcessing = true;
              // Cover the form's stale Amount + description cells with the skeleton
              // for the whole claim + prefill window — folder-pick has no progress
              // bar, so without this the user sees the prior receipt's values until
              // the new prefill arrives ~1-3s later. Cleared by tryApplyReceiptScanPrefill's
              // finally (success / non-retry error) or by the receiptScan.status
              // watcher on a terminal status.
              _this19.scanCompleted = false;
              _this19.scanningReceipt = true;
              // PRODUCTDEV-5802 (reopen) — close the picker right away and run the whole
              // fetch/upload window in the reconcile modal itself: file chip visible
              // immediately, old-UI spinner over the Receipt section, Save gated. This is
              // the same affordance Case 1 (Upload new receipt) shows, per the ticket.
              _this19.closeFolderPicker();
              _this19.receiptUploadInProgress = true;
              _this19.acquireSaveGate();
              self = _this19; // Optimistic chip from the folder row's own metadata so the FILE is visible
              // under the spinner from the first frame. Enriched below (preview path,
              // staged key, Legacy path) as each piece resolves; rolled back on failure.
              optimisticAttachment = {
                name: event && event.originalFileName || 'Receipt',
                type: event && event.contentType || '',
                size: event && event.sizeBytes != null ? event.sizeBytes : 0,
                file: '',
                mediaFile: '',
                path: '',
                pathWithName: '',
                id: '',
                success: true,
                readonly: false,
                receiptScanId: receiptScanId,
                _blobUrl: '',
                // PRODUCTDEV-5783 — the folder receipt is NOT claimed at pick time. It stays
                // FolderSaved (in the folder) until the reconcile is SAVED; claimPendingFolderReceipts()
                // performs the FolderSaved → Matched transition on save success. On cancel the scan is
                // left untouched (cleanupUnsavedReceipts skips it) so it remains in the folder, and an
                // explicit ✕ removal also leaves it in the folder (removePrimaryAttachment skips it).
                pendingFolderClaim: true
              };
              self.attachedFiles.push(optimisticAttachment);
              self.emitAttachmentsUpdated();
              _context11.prev = 15;
              _context11.next = 18;
              return __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].getStatus(receiptScanId);
            case 18:
              statusData = _context11.sent;
              if (!(!statusData || statusData.status !== 'FolderSaved')) {
                _context11.next = 23;
                break;
              }
              self.$notifications.notify({
                type: 'warning',
                message: 'Receipt is no longer in the folder — pick another',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              self.rollbackFolderPickAttachment(optimisticAttachment);
              return _context11.abrupt("return");
            case 23:
              _context11.prev = 23;
              _context11.next = 26;
              return __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].getImage(receiptScanId);
            case 26:
              imgRes = _context11.sent;
              _context11.next = 32;
              break;
            case 29:
              _context11.prev = 29;
              _context11.t0 = _context11["catch"](23);
              console.warn('Could not fetch folder receipt image:', _context11.t0);
            case 32:
              presignedUrl = imgRes && imgRes.presignedUrl; // PRODUCTDEV-5783 — durable reopen key (see stagedKeyFromPresignedUrl): stored as PathWithName
              // so Legacy's Storage/private proxy re-serves the receipt on reopen even when the S3 byte-fetch
              // below is CORS-blocked and no permanent Legacy copy gets made.
              stagedKey = self.stagedKeyFromPresignedUrl(presignedUrl); // Prefer the folder row's own metadata (passed from the picker) for name/type/size —
              // it's authoritative and present even when the S3 byte-fetch below is blocked, which is
              // what left the chip showing 0 bytes (PRODUCTDEV-5783). getImage (GetReceiptImageResult)
              // only returns fileName/contentType, never size, so size in particular must come from the row.
              fileName = event && event.originalFileName || imgRes && imgRes.fileName || 'Receipt';
              contentType = event && event.contentType || imgRes && imgRes.contentType || ''; // Fetch the bytes ONCE — used for both the optimistic preview (via
              // local blob URL, same render path as uploadNewReceipt at :1755) and
              // the Legacy upload below. Without the blob URL preview the receipt
              // panel renders empty: ReceiptImageViewer reads attachment.path, and
              // an S3 presigned URL stuck directly in there isn't reliably
              // loadable inside the modal's render context.
              blob = null;
              blobUrl = '';
              if (!presignedUrl) {
                _context11.next = 54;
                break;
              }
              _context11.prev = 39;
              _context11.next = 42;
              return fetch(presignedUrl);
            case 42:
              imgFetch = _context11.sent;
              if (!(imgFetch && imgFetch.ok)) {
                _context11.next = 49;
                break;
              }
              _context11.next = 46;
              return imgFetch.blob();
            case 46:
              blob = _context11.sent;
              blobUrl = URL.createObjectURL(blob);
              contentType = blob.type || contentType;
            case 49:
              _context11.next = 54;
              break;
            case 51:
              _context11.prev = 51;
              _context11.t1 = _context11["catch"](39);
              console.warn('Could not fetch folder receipt bytes:', _context11.t1);
            case 54:
              // Real size from the folder row; fall back to the fetched blob only if the row didn't
              // carry one. (Previously this was blob.size-or-0, so a blocked fetch showed 0 bytes.)
              fileSize = event && event.sizeBytes != null ? event.sizeBytes : blob ? blob.size : 0; // Enrich the early chip with what's now resolved: authoritative
              // name/type (getImage fallback), the preview path — local blob URL when
              // the fetch succeeded (fastest render), else the presigned S3 URL
              // (<img src> loads cross-origin without CORS) — and the durable staged
              // key (PRODUCTDEV-5783) so reopen works via the Storage/private proxy;
              // the Legacy dual-upload below overwrites it with the permanent
              // (non-staged) ClientData path when the byte-fetch succeeded.
              optimisticAttachment.name = fileName;
              optimisticAttachment.type = contentType;
              optimisticAttachment.size = fileSize;
              optimisticAttachment.path = blobUrl || presignedUrl || '';
              optimisticAttachment.pathWithName = stagedKey;
              // Track the blob URL separately so removePrimaryAttachment / beforeDestroy
              // can revoke it. `path` may be swapped to a non-blob URL later, so the
              // raw blob handle has to live in its own field.
              optimisticAttachment._blobUrl = blobUrl || '';
              self.emitAttachmentsUpdated();

              // Legacy dual-upload — reuse the blob we already fetched. Without
              // this the Legacy TransactionFiles row has PathWithName='' and
              // reopen-view crashes (Substring(0,-1)).
              if (!blob) {
                _context11.next = 82;
                break;
              }
              legacyUrl = self.api && self.api.env ? self.api.env + self.api.$.evedpaycard.receipt : null;
              if (!legacyUrl) {
                _context11.next = 82;
                break;
              }
              _context11.prev = 65;
              blobType = blob.type || contentType || 'application/octet-stream';
              legacyFile = new File([blob], fileName, {
                type: blobType
              });
              legacyFormData = new FormData();
              legacyFormData.append('attachment_upload', legacyFile);
              legacyToken = self.$user && self.$user.sessionSettings ? self.$user.sessionSettings.Token : '';
              _context11.next = 73;
              return self.api.post(legacyUrl, legacyFormData, {
                headers: {
                  'Authorization': 'Bearer ' + legacyToken,
                  'Content-Type': 'multipart/form-data'
                }
              });
            case 73:
              legacyResp = _context11.sent;
              legacyBody = legacyResp && legacyResp.data;
              if (typeof legacyBody === 'string') {
                try {
                  legacyBody = JSON.parse(legacyBody);
                } catch (e) {
                  legacyBody = null;
                }
              }
              if (legacyBody && legacyBody.success && legacyBody.path) {
                pwnMatch = legacyBody.path.match(/(ClientData\/.*)/);
                clientDataPath = pwnMatch && pwnMatch[1] ? pwnMatch[1] : legacyBody.path;
                mediaFile = legacyBody.file || clientDataPath.split('/').pop(); // PRODUCTDEV-5783 — overwrite path with Legacy's durable URL (mirrors
                // uploadNewReceipt). The saved FullPath comes from item.path; the blob URL used
                // for the optimistic preview is session-local and dies on reload, so a reopened
                // reconcile couldn't display the receipt. Legacy's URL renders through the
                // <embed>/<iframe> preview (display needs no CORS) and survives reopen; the blob
                // handle stays in _blobUrl for later revocation.
                optimisticAttachment.path = legacyBody.path;
                optimisticAttachment.pathWithName = clientDataPath;
                optimisticAttachment.mediaFile = mediaFile;
                optimisticAttachment.file = mediaFile;
                self.emitAttachmentsUpdated();
              }
              _context11.next = 82;
              break;
            case 79:
              _context11.prev = 79;
              _context11.t2 = _context11["catch"](65);
              // Surface but don't abort — Platform-side claim still goes through;
              // user will see the receipt in the modal but reopen will hit the
              // empty-path crash. Better to let them save and warn than block.
              console.warn('Legacy upload of folder receipt failed:', _context11.t2);
            case 82:
              // PRODUCTDEV-5802 (reopen) — the file transfer is done: lift the spinner
              // and unlock Save BEFORE the prefill round-trip; the coding-row skeleton
              // (scanningReceipt) covers the prefill window, matching the fresh-upload
              // flow's gating (Save unlocks once the upload itself has resolved).
              self.receiptUploadInProgress = false;
              self.releaseSaveGate();

              // PRODUCTDEV-5783 — do NOT claim here. The receipt must stay in the folder until
              // the reconcile is actually saved (claimPendingFolderReceipts() runs the deferred
              // FolderSaved → Matched on save success). Prefill still runs against the FolderSaved
              // scan to auto-fill the coding (BuildReceiptPrefill allows FolderSaved).
              _context11.next = 86;
              return self.tryApplyReceiptScanPrefill(receiptScanId);
            case 86:
              self.$notifications.notify({
                type: 'success',
                message: 'Receipt added from folder',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _context11.next = 93;
              break;
            case 89:
              _context11.prev = 89;
              _context11.t3 = _context11["catch"](15);
              // Roll back the chip + drop the skeleton/spinner and unlock Save —
              // tryApplyReceiptScanPrefill (which clears the skeleton on the happy
              // path) was never reached on this error branch.
              self.rollbackFolderPickAttachment(optimisticAttachment);
              if (_context11.t3.response && _context11.t3.response.status === 409) {
                self.$notifications.notify({
                  type: 'warning',
                  message: 'Receipt state changed — pick another',
                  placement: {
                    from: 'top',
                    align: 'center'
                  }
                });
              } else if (_context11.t3.response && _context11.t3.response.status === 403) {
                self.$notifications.notify({
                  type: 'danger',
                  message: 'You no longer have access to this receipt',
                  placement: {
                    from: 'top',
                    align: 'center'
                  }
                });
              } else {
                console.error('Failed to add receipt from folder:', _context11.t3);
                self.$notifications.notify({
                  type: 'danger',
                  message: 'Failed to add receipt. Please try again.',
                  placement: {
                    from: 'top',
                    align: 'center'
                  }
                });
              }
            case 93:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[15, 89], [23, 29], [39, 51], [65, 79]]);
      }))();
    },
    // PRODUCTDEV-5802 (reopen) — shared rollback for a failed folder pick: remove
    // the optimistic chip, revoke its blob URL, clear the skeleton + spinner, and
    // unlock Save. The picker is already closed at this point (closed on ADD).
    rollbackFolderPickAttachment: function rollbackFolderPickAttachment(attachment) {
      if (attachment) {
        var idx = this.attachedFiles.indexOf(attachment);
        if (idx !== -1) {
          this.attachedFiles.splice(idx, 1);
          this.emitAttachmentsUpdated();
        }
        this.revokeAttachmentBlobUrl(attachment);
      }
      this.scanCompleted = true;
      this.scanningReceipt = false;
      this.receiptUploadInProgress = false;
      this.releaseSaveGate();
    },
    // PRODUCTDEV-5802 (reopen) — counted Save gate. Several uploads can be in
    // flight at once (receipt upload/scan + an Additional Documents upload), and
    // a plain boolean emit lets whichever finishes FIRST unlock Save while the
    // other is still uploading. Acquire emits uploadFinished(false) on first
    // hold; release emits uploadFinished(true) only when every hold is gone.
    acquireSaveGate: function acquireSaveGate() {
      this._saveGateCount = (this._saveGateCount || 0) + 1;
      this.$emit('uploadFinished', false);
    },
    releaseSaveGate: function releaseSaveGate() {
      this._saveGateCount = Math.max(0, (this._saveGateCount || 0) - 1);
      if (this._saveGateCount === 0) {
        this.$emit('uploadFinished', true);
      }
    },
    // ===== PRODUCTDEV-5772 — Additional Documents =====
    // Supporting files attached to the reconcile. Deliberately NOT receipts: never
    // Photon-scanned, never enter attachedFiles/ReceiptFiles, never affect IsComplete
    // or Reconciliation Status. Persisted in their own Legacy table. No progress bar.

    // Plain Legacy byte-upload — no Platform/Photon, no progress bar. The file shows
    // as a chip immediately; it joins the save payload once Legacy returns its path.
    uploadNewDocument: function uploadNewDocument() {
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'application/pdf, image/png, image/jpeg';
      var self = this;
      input.onchange = /*#__PURE__*/function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee12(e) {
          var file, parts, ext, ALLOWED, legacyUrl, fileType, localObjectUrl, doc, legacyFormData, legacyToken, resp, body, match, clientDataPath, idx;
          return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                file = e.target.files && e.target.files[0];
                if (file) {
                  _context12.next = 3;
                  break;
                }
                return _context12.abrupt("return");
              case 3:
                // Same allowlist + 10MB cap as the receipt path (ticket: additional docs
                // allow the same file types as the receipt).
                parts = file.name ? file.name.split('.') : [];
                ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
                ALLOWED = ['pdf', 'png', 'jpg', 'jpeg'];
                if (!(ALLOWED.indexOf(ext) === -1)) {
                  _context12.next = 9;
                  break;
                }
                self.$notifications.notify({
                  type: 'info-warn',
                  message: 'Please upload a file with one of these extensions: .pdf, .png, .jpg, .jpeg',
                  placement: {
                    from: 'top',
                    align: 'center'
                  }
                });
                return _context12.abrupt("return");
              case 9:
                if (!(file.size >= 10 * 1024 * 1024)) {
                  _context12.next = 12;
                  break;
                }
                self.$notifications.notify({
                  type: 'info-warn',
                  message: 'File is too large. Please upload a document smaller than 10 MB.',
                  placement: {
                    from: 'top',
                    align: 'center'
                  }
                });
                return _context12.abrupt("return");
              case 12:
                legacyUrl = self.api && self.api.env ? self.api.env + self.api.$.evedpaycard.receipt : null;
                if (legacyUrl) {
                  _context12.next = 16;
                  break;
                }
                self.showWarningMessage('Failed to upload document. Please try again.');
                return _context12.abrupt("return");
              case 16:
                fileType = ext === 'png' ? 'image/png' : ext === 'pdf' ? 'application/pdf' : ext === 'jpg' ? 'image/jpg' : ext === 'jpeg' ? 'image/jpeg' : file.type || '';
                localObjectUrl = URL.createObjectURL(file); // Optimistic chip so the document shows right away. It is NOT part of the
                // save payload until pathWithName lands (emit happens after the upload).
                doc = {
                  name: file.name,
                  type: fileType,
                  size: file.size,
                  file: '',
                  mediaFile: '',
                  path: localObjectUrl,
                  pathWithName: '',
                  id: '',
                  success: true,
                  readonly: false,
                  _blobUrl: localObjectUrl
                };
                self.additionalDocuments.push(doc);

                // PRODUCTDEV-5802 (reopen, Case 3) — old-UI spinner over the section and
                // Save gated while the byte-upload is in flight, so a Save click can't
                // race a document that isn't in the payload yet.
                self.documentUploadInProgress = true;
                self.acquireSaveGate();
                _context12.prev = 22;
                legacyFormData = new FormData();
                legacyFormData.append('attachment_upload', file);
                legacyToken = self.$user && self.$user.sessionSettings ? self.$user.sessionSettings.Token : '';
                _context12.next = 28;
                return self.api.post(legacyUrl, legacyFormData, {
                  headers: {
                    'Authorization': 'Bearer ' + legacyToken,
                    'Content-Type': 'multipart/form-data'
                  }
                });
              case 28:
                resp = _context12.sent;
                body = resp && resp.data;
                if (typeof body === 'string') {
                  try {
                    body = JSON.parse(body);
                  } catch (parseErr) {
                    body = null;
                  }
                }
                if (!(!body || !body.success || !body.path)) {
                  _context12.next = 33;
                  break;
                }
                throw new Error(body && body.uploadError ? body.uploadError : 'Upload failed');
              case 33:
                match = body.path.match(/(ClientData\/.*)/);
                clientDataPath = match && match[1] ? match[1] : body.path;
                doc.pathWithName = clientDataPath;
                doc.mediaFile = body.file || clientDataPath.split('/').pop();
                doc.file = doc.mediaFile;
                // PRODUCTDEV-5783 — persist Legacy's durable URL as the path (mirrors uploadNewReceipt).
                // FullPath is saved from doc.path; the blob URL used for the optimistic chip dies on
                // reload, so without this the document can't be opened from a reopened reconcile.
                doc.path = body.path;
                self.emitAdditionalDocumentsUpdated();
                _context12.next = 49;
                break;
              case 42:
                _context12.prev = 42;
                _context12.t0 = _context12["catch"](22);
                console.warn('Document upload failed:', _context12.t0);
                idx = self.additionalDocuments.indexOf(doc);
                if (idx !== -1) {
                  self.additionalDocuments.splice(idx, 1);
                }
                self.revokeAttachmentBlobUrl(doc);
                self.showWarningMessage('File "' + file.name + '" could not be uploaded. Please try again.');
              case 49:
                _context12.prev = 49;
                self.documentUploadInProgress = false;
                self.releaseSaveGate();
                return _context12.finish(49);
              case 53:
              case "end":
                return _context12.stop();
            }
          }, _callee12, null, [[22, 42, 49, 53]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
      input.click();
    },
    removeDocument: function removeDocument(index) {
      var doc = this.additionalDocuments[index];
      if (!doc) return;
      this.revokeAttachmentBlobUrl(doc);
      this.additionalDocuments.splice(index, 1);
      this.emitAdditionalDocumentsUpdated();
    },
    openDocument: function openDocument(doc, e) {
      this.openAttachment({
        e: e,
        file: {
          type: doc.type
        },
        path: doc.path
      });
    },
    documentIconClass: function documentIconClass(doc) {
      var name = (doc && doc.name || '').toLowerCase();
      if (/\.pdf$/.test(name)) return 'fa-file-pdf';
      if (/\.(png|jpe?g|gif|webp)$/.test(name)) return 'fa-file-image';
      return 'fa-file';
    },
    // Build the Legacy TransactionFile-shaped array and emit ONLY finalized docs
    // (those with a pathWithName). Mirrors emitAttachmentsUpdated; VendorId is
    // required by the FK on EvedPayCardTransactionDocuments.
    emitAdditionalDocumentsUpdated: function emitAdditionalDocumentsUpdated() {
      var vendorId = this.$root.getUser.$.data.VendorID;
      var vci = this.$root.getUser.$.data.VCI;
      var emitted = this.additionalDocuments.filter(function (item) {
        return item && item.pathWithName;
      }).map(function (item) {
        return {
          OriginalName: item.name,
          SizeBytes: item.size,
          MediaFile: item.mediaFile,
          AttachmentFile: item.file,
          PathWithName: item.pathWithName,
          FullPath: item.path,
          ReadOnly: item.readonly || false,
          Id: item.id,
          VendorId: vendorId,
          VCI: vci
        };
      });
      this.$emit('additional-documents-updated', emitted);
    },
    // Hydrate the document chips from a saved reconcile (ReconcileData.AdditionalDocuments).
    // Emits afterwards so a save that doesn't touch docs re-sends the existing rows
    // (by Id) and SyncReconcileDocuments keeps them instead of soft-deleting.
    populateAdditionalDocuments: function populateAdditionalDocuments(documents) {
      if (!Array.isArray(documents)) return;
      var self = this;
      documents.forEach(function (file) {
        var parts = (file.OriginalName || '').split('.');
        var ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
        var fileType = ext === 'png' ? 'image/png' : ext === 'pdf' ? 'application/pdf' : ext === 'jpg' ? 'image/jpg' : ext === 'jpeg' ? 'image/jpeg' : '';
        self.additionalDocuments.push({
          name: file.OriginalName,
          type: fileType,
          size: file.SizeBytes,
          file: file.MediaFile,
          mediaFile: file.MediaFile,
          path: file.FullPath,
          pathWithName: file.PathWithName,
          id: file.Id,
          success: true,
          readonly: self.reconcileAction === 'view'
        });
      });
      this.emitAdditionalDocumentsUpdated();
    },
    uploadNewReceipt: function uploadNewReceipt() {
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*,application/pdf';
      var self = this;
      input.onchange = function (e) {
        var file = e.target.files && e.target.files[0];
        if (!file) {
          return;
        }

        // <input accept> is a hint only — the OS picker / mobile flows can
        // bypass it. Enforce the same allowlist + 10MB cap as
        // AddReceipt.vue:166-181 and Card-list handleReceiptFileSelected so
        // the BE doesn't have to reject and the user gets useful copy.
        var parts = file.name ? file.name.split('.') : [];
        var ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
        var ALLOWED = ['pdf', 'png', 'jpg', 'jpeg'];
        if (ALLOWED.indexOf(ext) === -1) {
          self.$notifications.notify({
            type: 'info-warn',
            message: 'Please upload a file with one of these extensions: .pdf, .png, .jpg, .jpeg',
            placement: {
              from: 'top',
              align: 'center'
            }
          });
          return;
        }
        var MAX_FILE_SIZE = 10 * 1024 * 1024;
        if (file.size >= MAX_FILE_SIZE) {
          self.$notifications.notify({
            type: 'info-warn',
            message: 'File is too large. Please upload a receipt smaller than 10 MB.',
            placement: {
              from: 'top',
              align: 'center'
            }
          });
          return;
        }

        // PRODUCTDEV-5475/5788 — "No Receipt Capture" (the division's scanning_disabled mode):
        // attach ANY uploaded receipt as-is via the SAME Legacy upload the scan flow uses, but
        // NEVER call Photon — no scan/prefill/rescan, no overlay/progress. Applies on every
        // surface (receiptCaptureDisabled is self-fetched in created()). The Upload button is
        // already disabled once a receipt is attached (hasAttachment), so this is a first attach.
        if (self.receiptCaptureDisabled) {
          self.attachReceiptWithoutScan(file);
          return;
        }

        // PRODUCTDEV-5772 — coding already exists or a receipt is attached: this is a
        // REPLACE, not a first scan. Swap the file without touching Photon or the
        // coding, and surface the "Replace coding?" alert (rescan is opt-in from there).
        if (self.hasCodingOrReceipt) {
          self.replaceReceiptFile(file);
          return;
        }

        // Fresh/default reconcile (no coding, no receipt) — the original auto-scan flow.
        self.receiptReplacedPendingRescan = false;
        self.pendingRescanFile = null;
        self.pendingFolderPrefillScanId = null;

        // Gate the parent modal's Save button for the entire upload lifecycle —
        // unlocks only after Platform's scan resolves (or fails), so the user
        // can't save before Photon has had a chance to prefill the form.
        self.acquireSaveGate();

        // Fake 4s progress bar — always runs the full 4 seconds regardless of
        // upload outcome (per Tudor's request). Skeleton AND bar run together:
        // - Bar = progress indicator at the bottom of the upload row.
        // - Skeleton = covers the form's stale Amount + description cells so
        //   the user doesn't see the prior receipt's values bleed through
        //   while the new prefill is still in flight.
        // Cleared by tryApplyReceiptScanPrefill's finally (success or
        // non-retry error) or by the receiptScan.status watcher on Complete
        // / Failed / PlatformUnreachable / PollingTimeout.
        self.scanCompleted = false;
        self.scanningReceipt = true;
        // Mobile-only full-screen overlay for the whole upload+scan window. Set
        // here (past validation + the replace branch) so the early returns above
        // can't strand it; the scanCompleted watcher clears it on every terminal
        // branch. The template gates the render behind isMobile, so this is inert
        // on desktop. Mirrors BACKUP's placement inside the fresh-scan flow.
        self.uploadingScanOverlay = true;
        self.startUploadProgressBar();

        // Optimistic preview — push the file with a local objectURL so the
        // preview pane renders instantly while the uploads run in background.
        var fileType = ext === 'png' ? 'image/png' : ext === 'pdf' ? 'application/pdf' : ext === 'jpg' ? 'image/jpg' : ext === 'jpeg' ? 'image/jpeg' : file.type || '';
        var localObjectUrl = URL.createObjectURL(file);
        var optimisticAttachment = {
          name: file.name,
          type: fileType,
          size: file.size,
          file: '',
          mediaFile: '',
          path: localObjectUrl,
          pathWithName: '',
          id: '',
          success: true,
          readonly: false,
          receiptScanId: null,
          // Track the blob URL separately so removePrimaryAttachment / beforeDestroy
          // can revoke it. `path` is overwritten with Legacy's URL once the upload
          // resolves, so the raw blob handle has to live in its own field.
          _blobUrl: localObjectUrl
        };
        self.attachedFiles.push(optimisticAttachment);
        self.emitAttachmentsUpdated();

        // Dual-upload, Legacy-first (mirrors AddReceipt.vue): Legacy returns the
        // ClientData/... path TransactionFiles.PathWithName needs for reopen-view.
        // Doing it first means pathWithName lands long before Photon finishes, so
        // there's no race with the Save click; sequential reads also avoid the
        // parallel-FormData-read corruption of Photon's PDF multipart body.
        self.uploadReceiptToLegacy(file).then(function (legacy) {
          optimisticAttachment.path = legacy.path;
          optimisticAttachment.pathWithName = legacy.pathWithName;
          optimisticAttachment.mediaFile = legacy.mediaFile;
          optimisticAttachment.file = legacy.file;
          self.emitAttachmentsUpdated();
          // Platform — sync Photon /api/v4 extraction for prefill. If this fails the
          // receipt is still saveable (Legacy already has it); the user just doesn't
          // get auto-prefill.
          self.scanReceiptAndPrefill(file, optimisticAttachment);
        }).catch(function (err) {
          // Without the Legacy path the receipt can't be persisted on the
          // transaction's TransactionFiles row, so there's no point continuing.
          console.warn('Legacy receipt upload failed:', err);
          var idxLegacyErr = self.attachedFiles.indexOf(optimisticAttachment);
          if (idxLegacyErr >= 0) {
            self.attachedFiles.splice(idxLegacyErr, 1);
            self.emitAttachmentsUpdated();
          }
          self.revokeAttachmentBlobUrl(optimisticAttachment);
          self.scanCompleted = true;
          self.releaseSaveGate();
          self.showWarningMessage('Failed to upload receipt. Please try again.');
        });
      };
      input.click();
    },
    // PRODUCTDEV-5475/5788 — No Receipt Capture (the division's scanning_disabled mode):
    // attach an uploaded receipt to the transaction WITHOUT sending it to Photon. Gated by
    // receiptCaptureDisabled, so it applies on every surface. Mirrors the fresh-upload flow's
    // optimistic attach + Legacy-first upload, but runs no scan, no prefill, no overlay/progress
    // and no rescan prompt; the attachment keeps receiptScanId: null and saves like any
    // non-scanned attachment. Locks Save during the brief Legacy upload (unlocks on
    // resolve/fail). Returns the upload promise (for tests).
    attachReceiptWithoutScan: function attachReceiptWithoutScan(file) {
      var self = this;
      // Clear any stale replace/rescan state — scanning never runs in this mode.
      self.receiptReplacedPendingRescan = false;
      self.pendingRescanFile = null;
      self.pendingFolderPrefillScanId = null;

      // Lock Save for the brief Legacy upload window; unlock once the receipt is attached.
      self.acquireSaveGate();
      var parts = file.name ? file.name.split('.') : [];
      var ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
      var fileType = ext === 'png' ? 'image/png' : ext === 'pdf' ? 'application/pdf' : ext === 'jpg' ? 'image/jpg' : ext === 'jpeg' ? 'image/jpeg' : file.type || '';
      var localObjectUrl = URL.createObjectURL(file);
      var optimisticAttachment = {
        name: file.name,
        type: fileType,
        size: file.size,
        file: '',
        mediaFile: '',
        path: localObjectUrl,
        pathWithName: '',
        id: '',
        success: true,
        readonly: false,
        receiptScanId: null,
        _blobUrl: localObjectUrl
      };
      self.attachedFiles.push(optimisticAttachment);
      self.emitAttachmentsUpdated();

      // PRODUCTDEV-5802 — old-UI spinner for the upload window; No-Capture mode
      // never shows the 4s bar (no scan), so it previously showed nothing.
      self.receiptUploadInProgress = true;
      return self.uploadReceiptToLegacy(file).then(function (legacy) {
        optimisticAttachment.path = legacy.path;
        optimisticAttachment.pathWithName = legacy.pathWithName;
        optimisticAttachment.mediaFile = legacy.mediaFile;
        optimisticAttachment.file = legacy.file;
        self.emitAttachmentsUpdated();
        self.receiptUploadInProgress = false;
        // No Photon scan to wait on — unlock Save now (receiptScanId stays null).
        self.releaseSaveGate();
      }).catch(function (err) {
        console.warn('Legacy receipt upload failed:', err);
        var idx = self.attachedFiles.indexOf(optimisticAttachment);
        if (idx >= 0) {
          self.attachedFiles.splice(idx, 1);
          self.emitAttachmentsUpdated();
        }
        self.revokeAttachmentBlobUrl(optimisticAttachment);
        self.receiptUploadInProgress = false;
        self.releaseSaveGate();
        self.showWarningMessage('Failed to upload receipt. Please try again.');
      });
    },
    // Posts the raw receipt file to the Legacy evednetwork upload endpoint and
    // resolves with the canonical ClientData/... path fields (the values the save
    // flow + reopen-view consume). Shared by first-run upload, Upload-New-Receipt
    // replacement, and folder replacement. Rejects on any non-success response.
    uploadReceiptToLegacy: function uploadReceiptToLegacy(file) {
      var _this20 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee13() {
        var legacyUrl, legacyFormData, legacyToken, legacyResp, legacyBody, match, clientDataPath, mediaFile;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              legacyUrl = _this20.api && _this20.api.env ? _this20.api.env + _this20.api.$.evedpaycard.receipt : null;
              if (legacyUrl) {
                _context13.next = 3;
                break;
              }
              throw new Error('No Legacy upload URL configured');
            case 3:
              legacyFormData = new FormData();
              legacyFormData.append('attachment_upload', file);
              legacyToken = _this20.$user && _this20.$user.sessionSettings ? _this20.$user.sessionSettings.Token : '';
              _context13.next = 8;
              return _this20.api.post(legacyUrl, legacyFormData, {
                headers: {
                  'Authorization': 'Bearer ' + legacyToken,
                  'Content-Type': 'multipart/form-data'
                }
              });
            case 8:
              legacyResp = _context13.sent;
              legacyBody = legacyResp && legacyResp.data;
              if (typeof legacyBody === 'string') {
                try {
                  legacyBody = JSON.parse(legacyBody);
                } catch (e) {
                  legacyBody = null;
                }
              }
              if (!(!legacyBody || !legacyBody.success || !legacyBody.path)) {
                _context13.next = 13;
                break;
              }
              throw new Error('Legacy upload rejected the file');
            case 13:
              match = legacyBody.path.match(/(ClientData\/.*)/);
              clientDataPath = match && match[1] ? match[1] : legacyBody.path;
              mediaFile = legacyBody.file || clientDataPath.split('/').pop();
              return _context13.abrupt("return", {
                path: legacyBody.path,
                pathWithName: clientDataPath,
                mediaFile: mediaFile,
                file: mediaFile
              });
            case 17:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    // Platform half of the receipt flow, shared by the first-run upload and the
    // Rescan Receipt action. Submits the file to Photon (/api/v4), then starts the
    // scan-status watcher + applies OCR prefill. The receipt is already persisted to
    // Legacy by the caller, so any Platform failure here is non-fatal — the user can
    // still save and fill the coding manually.
    scanReceiptAndPrefill: function scanReceiptAndPrefill(file, attachment) {
      var _this21 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee14() {
        var self, formData, idempotencyKey, extra, data, imageRejected;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              self = _this21;
              formData = new FormData();
              formData.append('file', file);
              idempotencyKey = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0;
                var v = c === 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
              });
              extra = {
                uploadContextLegacyTransactionId: self.transaction.data.Id,
                uploadSurface: 'reconcile'
              };
              self.$notifications.notify({
                type: 'info',
                message: 'Scanning receipt...',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _context14.prev = 6;
              _context14.next = 9;
              return __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].submitReceipt(formData, idempotencyKey, extra);
            case 9:
              data = _context14.sent;
              if (!(!data || !data.receiptScanId)) {
                _context14.next = 15;
                break;
              }
              self.scanCompleted = true;
              self.releaseSaveGate();
              self.showWarningMessage('Receipt uploaded but scanning is unavailable. You can fill the form manually.');
              return _context14.abrupt("return");
            case 15:
              if (attachment) {
                attachment.receiptScanId = data.receiptScanId;
              }
              self.releaseSaveGate();
              // Keep the autoLink watcher (584-600) live for the auto-redirect case AND
              // apply OCR prefill unconditionally so the form fills regardless of autoLink.
              // tryApplyReceiptScanPrefill handles all modes (total_only / subtotal_and_tax
              // / line_items_and_tax).
              self.startReceiptScan(data.receiptScanId, {
                transactionId: self.transaction.data.Id
              });
              self.tryApplyReceiptScanPrefill(data.receiptScanId);
              _context14.next = 27;
              break;
            case 21:
              _context14.prev = 21;
              _context14.t0 = _context14["catch"](6);
              // Legacy already succeeded → receipt is saveable + viewable. Unlock save and
              // let the user fill the form manually. Sentinel errors are Platform's
              // deliberate deflection (e.g. flag off), so they're not surfaced as a warning.
              self.scanCompleted = true;
              self.releaseSaveGate();
              // PRODUCTDEV-5851 — a 422 means the image couldn't be scanned (e.g. dimensions out of
              // range), but the receipt is still persisted + attached via Legacy. Drop the scanning
              // skeleton (the upload bar engaged it expecting Photon to land, which never happens here)
              // and proceed silently to manual entry — empty fields, no prefill, no warning. This is an
              // expected case, not a failure. Isolated to this status; every other error keeps its handling.
              imageRejected = _context14.t0.response && _context14.t0.response.status === 422;
              if (imageRejected) {
                self.scanningReceipt = false;
              } else if (!_context14.t0.isPlatformSentinelError) {
                self.showWarningMessage('Receipt scanning failed. You can fill the form manually.');
              }
            case 27:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[6, 21]]);
      }))();
    },
    // PRODUCTDEV-5772 — replace an existing receipt via UPLOAD NEW RECEIPT WITHOUT
    // scanning. Uploads the new file to Legacy (so it persists + reopens), swaps the
    // chip, stashes the File for an optional Rescan, and raises the "Replace coding?"
    // alert. The coding is left untouched until the user explicitly clicks Rescan.
    replaceReceiptFile: function replaceReceiptFile(file) {
      var _this22 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee15() {
        var self, old, oldIdx, parts, ext, fileType, blobUrl, optimisticAttachment, legacy, failIdx;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              self = _this22; // PRODUCTDEV-5802 (reopen) — mirror the old ed-upload UX: the FILE shows
              // immediately (optimistic chip) with the old-UI spinner over the section,
              // and Save is gated for the whole upload window so a click can't race the
              // in-flight swap. The chip rolls back if Legacy rejects the upload.
              // Drop the receipt being replaced (and its Platform scan, if any) up front
              // so the new chip is what's visible under the spinner.
              old = self.primaryAttachment;
              if (old) {
                // PRODUCTDEV-5783 — only soft-delete a CLAIMED scan. An unclaimed folder pick
                // (pendingFolderClaim) must stay in the folder, exactly like the ✕ removal does.
                if (old.receiptScanId && !old.pendingFolderClaim) {
                  __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].deleteReceipt(old.receiptScanId).catch(function (e) {
                    console.warn('Soft-delete of replaced ReceiptScan failed (UI continues):', e);
                  });
                }
                self.revokeAttachmentBlobUrl(old);
                oldIdx = self.attachedFiles.indexOf(old);
                if (oldIdx >= 0) self.attachedFiles.splice(oldIdx, 1);
              }
              parts = file.name ? file.name.split('.') : [];
              ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
              fileType = ext === 'png' ? 'image/png' : ext === 'pdf' ? 'application/pdf' : ext === 'jpg' ? 'image/jpg' : ext === 'jpeg' ? 'image/jpeg' : file.type || '';
              blobUrl = URL.createObjectURL(file);
              optimisticAttachment = {
                name: file.name,
                type: fileType,
                size: file.size,
                file: '',
                mediaFile: '',
                path: blobUrl,
                pathWithName: '',
                id: '',
                success: true,
                readonly: false,
                // No scan yet — replacement is scan-on-demand via Rescan Receipt.
                receiptScanId: null,
                _blobUrl: blobUrl
              };
              self.attachedFiles.push(optimisticAttachment);
              self.emitAttachmentsUpdated();
              self.receiptUploadInProgress = true;
              self.acquireSaveGate();
              _context15.prev = 12;
              _context15.next = 15;
              return self.uploadReceiptToLegacy(file);
            case 15:
              legacy = _context15.sent;
              _context15.next = 29;
              break;
            case 18:
              _context15.prev = 18;
              _context15.t0 = _context15["catch"](12);
              console.warn('Legacy upload of replacement receipt failed:', _context15.t0);
              // Roll back the optimistic chip — the file never landed anywhere.
              failIdx = self.attachedFiles.indexOf(optimisticAttachment);
              if (failIdx >= 0) self.attachedFiles.splice(failIdx, 1);
              self.revokeAttachmentBlobUrl(optimisticAttachment);
              self.emitAttachmentsUpdated();
              self.receiptUploadInProgress = false;
              self.releaseSaveGate();
              self.showWarningMessage('Failed to upload receipt. Please try again.');
              return _context15.abrupt("return");
            case 29:
              optimisticAttachment.file = legacy.file;
              optimisticAttachment.mediaFile = legacy.mediaFile;
              optimisticAttachment.pathWithName = legacy.pathWithName;
              self.emitAttachmentsUpdated();
              self.receiptUploadInProgress = false;
              self.releaseSaveGate();
              self.pendingRescanFile = file;
              self.pendingFolderPrefillScanId = null;
              // PRODUCTDEV-5843 — no success toast on replace: the inline "Replace coding?"
              // alert below the receipt (driven by receiptReplacedPendingRescan) already
              // conveys this, and the toast was misleading when coding is locked.
              self.receiptReplacedPendingRescan = true;
            case 38:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[12, 18]]);
      }))();
    },
    // PRODUCTDEV-5772 — the user replaced the receipt and chose to update the coding
    // from it. Runs the same Photon scan + prefill the first upload does, using the
    // stashed replacement File, then clears the "Replace coding?" alert.
    rescanReceipt: function rescanReceipt() {
      var self = this;
      // PRODUCTDEV-5783 — folder replace: the picked receipt already has scan data, so apply its
      // EXISTING prefill (replace the coding) instead of re-running Photon. tryApplyReceiptScanPrefill
      // fills the coding from the FolderSaved scan and clears the skeleton.
      if (self.pendingFolderPrefillScanId) {
        var folderScanId = self.pendingFolderPrefillScanId;
        self.pendingFolderPrefillScanId = null;
        self.receiptReplacedPendingRescan = false;
        self.scanCompleted = false;
        self.scanningReceipt = true;
        self.tryApplyReceiptScanPrefill(folderScanId);
        return;
      }
      if (!self.pendingRescanFile) {
        self.receiptReplacedPendingRescan = false;
        return;
      }
      var file = self.pendingRescanFile;
      self.receiptReplacedPendingRescan = false;
      self.pendingRescanFile = null;
      // PRODUCTDEV-5783 — gate Save for the scan window so the user can't save mid-scan (matches
      // the first-scan path). Photon re-enables it via uploadFinished(true) when the scan resolves
      // in scanReceiptAndPrefill. Show the progress bar/skeleton for the scan window.
      self.acquireSaveGate();
      self.scanCompleted = false;
      self.scanningReceipt = true;
      self.startUploadProgressBar();
      self.scanReceiptAndPrefill(file, self.primaryAttachment);
    },
    // PRODUCTDEV-5772 — replace the current receipt with one picked from the folder,
    // WITHOUT scanning. Fetches the folder receipt's bytes, re-uploads to Legacy for a
    // persisted/reopenable path, swaps the chip, stashes the File for an optional
    // Rescan, and raises the "Replace coding?" alert. No claim, no prefill.
    // PRODUCTDEV-5783 — pull the durable ClientData/... S3 key out of a folder receipt's presigned
    // URL. On reopen Legacy rebuilds the image URL as AWS_ASSETS_PRIVATE_PATH + PathWithName via its
    // session-authed Storage/private proxy, so this key (the bytes already sit in the private bucket
    // under .../EvedpayCardTransactionFiles/staged/<guid>/) makes a folder receipt reopen like a
    // normal upload — no browser→S3 byte transfer, no CORS dependency. Decode so the stored key
    // matches the raw key Legacy expects (the URL path is percent-encoded).
    stagedKeyFromPresignedUrl: function stagedKeyFromPresignedUrl(presignedUrl) {
      if (!presignedUrl || typeof presignedUrl !== 'string') return '';
      var m = presignedUrl.match(/(ClientData\/[^?]+)/);
      if (!m || !m[1]) return '';
      try {
        return decodeURIComponent(m[1]);
      } catch (e) {
        return m[1];
      }
    },
    replaceReceiptFromFolder: function replaceReceiptFromFolder(event) {
      var _this23 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee16() {
        var receiptScanId, self, old, oldIdx, newAttachment, imgRes, presignedUrl, fileName, contentType, stagedKey, blob, blobUrl, imgFetch, fileSize, blobType, legacyFile, legacy;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              receiptScanId = event && event.receiptScanId;
              if (!(!receiptScanId || _this23.folderPickerIsProcessing)) {
                _context16.next = 3;
                break;
              }
              return _context16.abrupt("return");
            case 3:
              _this23.folderPickerIsProcessing = true;
              self = _this23; // PRODUCTDEV-5802 (reopen) — same affordance as Case 1: close the picker on
              // ADD, swap the chip in immediately (file visible from the first frame),
              // old-UI spinner over the Receipt section, Save gated for the whole window.
              _this23.closeFolderPicker();
              _this23.receiptUploadInProgress = true;
              _this23.acquireSaveGate();
              // Drop the receipt being replaced (and its Platform scan, if any) up front
              // so the incoming chip is what's visible under the spinner.
              old = self.primaryAttachment;
              if (old) {
                // PRODUCTDEV-5783 — only soft-delete a CLAIMED scan. An unclaimed folder pick
                // (pendingFolderClaim) must stay in the folder, exactly like the ✕ removal does.
                if (old.receiptScanId && !old.pendingFolderClaim) {
                  __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].deleteReceipt(old.receiptScanId).catch(function (e) {
                    console.warn('Soft-delete of replaced ReceiptScan failed (UI continues):', e);
                  });
                }
                self.revokeAttachmentBlobUrl(old);
                oldIdx = self.attachedFiles.indexOf(old);
                if (oldIdx >= 0) self.attachedFiles.splice(oldIdx, 1);
              }
              // Optimistic chip from the folder row's own metadata (authoritative and
              // present even when the S3 byte-fetch below is CORS-blocked; getImage
              // never returns size). Enriched below as each piece resolves.
              newAttachment = {
                name: event && event.originalFileName || 'Receipt',
                type: event && event.contentType || '',
                size: event && event.sizeBytes != null ? event.sizeBytes : 0,
                file: '',
                mediaFile: '',
                path: '',
                pathWithName: '',
                id: '',
                success: true,
                readonly: false,
                // PRODUCTDEV-5783 — keep the folder scan's association so "Replace coding" can apply its
                // EXISTING prefill, and so it's claimed out of the folder on save (deferred, like a fresh pick).
                receiptScanId: receiptScanId,
                pendingFolderClaim: true,
                _blobUrl: ''
              };
              self.attachedFiles.push(newAttachment);
              self.emitAttachmentsUpdated();
              _context16.prev = 13;
              _context16.prev = 14;
              _context16.next = 17;
              return __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].getImage(receiptScanId);
            case 17:
              imgRes = _context16.sent;
              _context16.next = 23;
              break;
            case 20:
              _context16.prev = 20;
              _context16.t0 = _context16["catch"](14);
              console.warn('Could not fetch folder receipt image:', _context16.t0);
            case 23:
              presignedUrl = imgRes && imgRes.presignedUrl;
              fileName = event && event.originalFileName || imgRes && imgRes.fileName || 'Receipt';
              contentType = event && event.contentType || imgRes && imgRes.contentType || '';
              if (presignedUrl) {
                _context16.next = 30;
                break;
              }
              self.rollbackFolderPickAttachment(newAttachment);
              self.$notifications.notify({
                type: 'warning',
                message: 'Receipt is no longer in the folder — pick another',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              return _context16.abrupt("return");
            case 30:
              // PRODUCTDEV-5783 — durable reopen WITHOUT any S3 byte transfer. Legacy serves receipts on
              // reopen as AWS_ASSETS_PRIVATE_PATH + PathWithName (a session-authed Storage/private proxy
              // over the private bucket). The folder receipt's bytes already live in that bucket under
              // .../EvedpayCardTransactionFiles/staged/<guid>/, so storing that key as PathWithName makes
              // the receipt reopen exactly like a normal upload — no fetch, no CORS, no re-upload.
              stagedKey = self.stagedKeyFromPresignedUrl(presignedUrl); // Still fetch the bytes BEST-EFFORT: when it succeeds we ALSO push a permanent (non-staged)
              // copy to Legacy and prefer that PathWithName. When CORS blocks it (e.g. localhost) `blob`
              // stays null, we skip the upload, and the staged key above keeps reopen working.
              blob = null;
              blobUrl = '';
              _context16.prev = 33;
              _context16.next = 36;
              return fetch(presignedUrl);
            case 36:
              imgFetch = _context16.sent;
              if (!(imgFetch && imgFetch.ok)) {
                _context16.next = 43;
                break;
              }
              _context16.next = 40;
              return imgFetch.blob();
            case 40:
              blob = _context16.sent;
              blobUrl = URL.createObjectURL(blob);
              contentType = blob.type || contentType;
            case 43:
              _context16.next = 48;
              break;
            case 45:
              _context16.prev = 45;
              _context16.t1 = _context16["catch"](33);
              console.warn('Could not fetch folder receipt bytes (CORS?) — continuing without Legacy upload:', _context16.t1);
            case 48:
              // Real size from the folder row; fall back to the fetched blob only if the row didn't carry one.
              fileSize = event && event.sizeBytes != null ? event.sizeBytes : blob ? blob.size : 0; // Enrich the early chip — preview via the local blob URL when the fetch
              // succeeded, else the presigned S3 URL (cross-origin <img> needs no CORS).
              // pathWithName defaults to the staged key so reopen works; a successful
              // Legacy upload below overwrites it with the permanent path.
              newAttachment.name = fileName;
              newAttachment.type = contentType;
              newAttachment.size = fileSize;
              newAttachment.path = blobUrl || presignedUrl || '';
              newAttachment.pathWithName = stagedKey;
              newAttachment._blobUrl = blobUrl || '';
              self.emitAttachmentsUpdated();

              // Legacy dual-upload — ONLY when we actually have the bytes. Overwrites path/pathWithName
              // with Legacy's durable URL so the receipt survives reopen (mirrors uploadNewReceipt /
              // the fresh folder-pick at :1900). Non-fatal on failure: the receipt is still attached and
              // saveable, the Platform claim still goes through; reopen just falls back to the scan image.
              if (!blob) {
                _context16.next = 73;
                break;
              }
              _context16.prev = 57;
              blobType = blob.type || contentType || 'application/octet-stream';
              legacyFile = new File([blob], fileName, {
                type: blobType
              });
              _context16.next = 62;
              return self.uploadReceiptToLegacy(legacyFile);
            case 62:
              legacy = _context16.sent;
              newAttachment.path = legacy.path;
              newAttachment.pathWithName = legacy.pathWithName;
              newAttachment.mediaFile = legacy.mediaFile;
              newAttachment.file = legacy.file;
              self.emitAttachmentsUpdated();
              _context16.next = 73;
              break;
            case 70:
              _context16.prev = 70;
              _context16.t2 = _context16["catch"](57);
              console.warn('Legacy upload of replacement folder receipt failed (UI continues):', _context16.t2);
            case 73:
              // PRODUCTDEV-5802 (reopen) — transfer done: lift the spinner, unlock Save.
              self.receiptUploadInProgress = false;
              self.releaseSaveGate();

              // The folder receipt already has scan data: offer to replace the coding WITH it (no re-scan).
              // pendingRescanFile stays null so rescanReceipt applies the folder prefill instead of Photon.
              self.pendingRescanFile = null;
              self.pendingFolderPrefillScanId = receiptScanId;
              // PRODUCTDEV-5843 — no success toast on replace: the inline "Replace coding?"
              // alert below the receipt already conveys this (see replaceReceiptFile).
              self.receiptReplacedPendingRescan = true;
              self.closeFolderPicker();
              _context16.next = 86;
              break;
            case 81:
              _context16.prev = 81;
              _context16.t3 = _context16["catch"](13);
              console.error('Failed to replace receipt from folder:', _context16.t3);
              self.rollbackFolderPickAttachment(newAttachment);
              self.$notifications.notify({
                type: 'danger',
                message: 'Failed to add receipt. Please try again.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            case 86:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[13, 81], [14, 20], [33, 45], [57, 70]]);
      }))();
    },
    startUploadProgressBar: function startUploadProgressBar() {
      this.cancelUploadProgressBar();
      this.uploadingReceipt = true;
      this.uploadProgressPct = 0;
      var self = this;
      var start = performance.now();
      var duration = 4000;
      var _tick = function tick(now) {
        var pct = Math.min(100, Math.round((now - start) / duration * 100));
        self.uploadProgressPct = pct;
        if (pct < 100) {
          self._uploadProgressRaf = requestAnimationFrame(_tick);
        } else {
          self._uploadProgressRaf = null;
          self.uploadingReceipt = false;
          // Bar finished. If Photon hasn't responded yet, flip to skeleton state;
          // otherwise the prefill is already on the form so we render nothing.
          if (!self.scanCompleted) {
            self.scanningReceipt = true;
          }
        }
      };
      this._uploadProgressRaf = requestAnimationFrame(_tick);
    },
    cancelUploadProgressBar: function cancelUploadProgressBar() {
      if (this._uploadProgressRaf) {
        cancelAnimationFrame(this._uploadProgressRaf);
        this._uploadProgressRaf = null;
      }
      this.uploadingReceipt = false;
      this.uploadProgressPct = 0;
    },
    formatBytes: function formatBytes(bytes, decimals) {
      if (bytes == null || bytes === 0) return '0 Bytes';
      var k = 1024;
      var dm = decimals != null ? decimals : 2;
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    openPrimaryAttachment: function openPrimaryAttachment(e) {
      var f = this.primaryAttachment;
      if (!f) return;
      var name = (f.name || f.file || '').toLowerCase();
      var type = f.type || (/\.pdf$/.test(name) ? 'application/pdf' : /\.png$/.test(name) ? 'image/png' : /\.jpe?g$/.test(name) ? 'image/jpeg' : '');
      this.openAttachment({
        e: e || {
          preventDefault: function preventDefault() {}
        },
        file: {
          type: type
        },
        path: f.path
      });
    },
    removePrimaryAttachment: function removePrimaryAttachment() {
      var f = this.primaryAttachment;
      if (!f) return;
      // Soft-delete on Platform if this is a Platform-uploaded scan. Fire-and-forget so
      // UI removal always succeeds; the DELETE handler is idempotent on already-deleted
      // rows and tolerates any non-Submitted status (DeleteFolderReceiptCommandHandler).
      // PRODUCTDEV-5783 — a folder receipt picked this session but not yet claimed
      // (pendingFolderClaim) must NOT be deleted on removal: it still lives in the folder,
      // so removing it from this reconcile should simply leave it there for later use.
      if (f.receiptScanId && !f.pendingFolderClaim) {
        __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].deleteReceipt(f.receiptScanId).catch(function (err) {
          console.warn('Soft-delete of ReceiptScan failed (UI continues):', err);
        });
      }
      this.revokeAttachmentBlobUrl(f);
      var idx = this.attachedFiles.indexOf(f);
      if (idx >= 0) {
        this.attachedFiles.splice(idx, 1);
      }
      // Reset scan METADATA only so a later Rescan's prefill can apply cleanly.
      // This intentionally does NOT touch the coding values themselves.
      this.receiptScanPrefillApplied = false;
      this.receiptScanPrefillMode = null;
      this.receiptScanConfidence = null;
      this.amountMismatch = false;
      this.receiptScanPhotonTotal = null;
      // PRODUCTDEV-5772 — removing the receipt clears any pending "Replace coding?" alert.
      this.receiptReplacedPendingRescan = false;
      this.pendingRescanFile = null;
      this.pendingFolderPrefillScanId = null;

      // PRODUCTDEV-5772 — removing the receipt must NOT wipe the coding. Previously
      // this collapsed the form to one row and cleared Amount/descriptions; now the
      // already-entered/scanned coded items persist (the user can still edit them).
      // Because coding remains, the next new-receipt upload sees it via
      // hasCodingOrReceipt and offers Rescan instead of auto-scanning.
      this.emitAttachmentsUpdated();
    },
    // Build the Card-list-shaped attachment array from this.attachedFiles and emit it.
    // Card-list listens on @attachmentsUpdated → updateAttachmentsFiles → this.filteredAttachments,
    // which feeds createReconcile's IsComplete validation + the ReceiptFiles payload.
    // Without this emit, uploads + folder picks never reach Card-list's state, so
    // filteredAttachments stays empty and saves come back with ReceiptFiles: [] and
    // IsComplete: false (status stays Open instead of moving to Coded).
    //
    // VendorId + VCI MUST be included — Legacy's EvedPayCardTransactionFiles table
    // has FK_EvedPayCardTransactionFiles_Vendors on VendorID. Without these the
    // INSERT violates the constraint and the reconcile POST returns 500.
    emitAttachmentsUpdated: function emitAttachmentsUpdated() {
      var vendorId = this.$root.getUser.$.data.VendorID;
      var vci = this.$root.getUser.$.data.VCI;
      var emitted = this.attachedFiles.map(function (item) {
        return {
          OriginalName: item.name,
          SizeBytes: item.size,
          MediaFile: item.mediaFile,
          AttachmentFile: item.file,
          PathWithName: item.pathWithName,
          FullPath: item.path,
          ReadOnly: item.readonly || false,
          Id: item.id,
          VendorId: vendorId,
          VCI: vci
        };
      });
      this.$emit('attachmentsUpdated', emitted);
    },
    // Called by the parent's closeReconcile() (Card-transactions/index.vue) when the user
    // dismisses the modal without saving. Soft-deletes every Platform receipt-scan that
    // was uploaded in this session so it doesn't linger as an orphan with OCR data.
    cleanupUnsavedReceipts: function cleanupUnsavedReceipts() {
      if (!Array.isArray(this.attachedFiles) || this.attachedFiles.length === 0) return;
      this.attachedFiles.forEach(function (f) {
        // Only dispose scans uploaded INSIDE this reconcile session (UPLOAD NEW
        // RECEIPT button). Two flags are deliberately left alone on cancel:
        //  - preExistingMatch: scans from a prior Dashboard-SUBMIT match — already Matched,
        //    the scan stays linked at the Platform level for a later visit.
        //  - pendingFolderClaim: folder receipts picked this session but NOT yet claimed
        //    (PRODUCTDEV-5783) — they must stay FolderSaved so they remain in the folder
        //    when the user cancels instead of saving.
        if (f && f.receiptScanId && !f.preExistingMatch && !f.pendingFolderClaim) {
          __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].deleteReceipt(f.receiptScanId).catch(function (err) {
            console.warn('Soft-delete of unsaved ReceiptScan failed:', err);
          });
        }
      });
    },
    // PRODUCTDEV-5783 — called by the host on reconcile SAVE success. Performs the deferred
    // FolderSaved → Matched claim for any receipt picked from the folder this session, so a
    // folder receipt only leaves the folder once the reconcile is actually saved (never on
    // cancel). Re-fetches the rowVersion first (prefill bumped it after the pick) and skips
    // anything no longer FolderSaved. Best-effort + fire-and-forget — a failed claim just
    // leaves the scan in the folder rather than blocking the save that already succeeded.
    claimPendingFolderReceipts: function claimPendingFolderReceipts() {
      if (!Array.isArray(this.attachedFiles) || this.attachedFiles.length === 0) return;
      var legacyTxId = this.transaction && this.transaction.data ? this.transaction.data.Id : null;
      if (!legacyTxId) return;
      this.attachedFiles.forEach(function (f) {
        if (!f || !f.receiptScanId || !f.pendingFolderClaim) return;
        // Clear the flag up front so a re-entrant save can't double-claim the same scan.
        f.pendingFolderClaim = false;
        var scanId = f.receiptScanId;
        __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].getStatus(scanId).then(function (statusData) {
          if (!statusData || statusData.status !== 'FolderSaved') return null;
          return __WEBPACK_IMPORTED_MODULE_7__core_api_receiptScans__["b" /* default */].claimReceipt(scanId, legacyTxId, statusData.rowVersion);
        }).catch(function (err) {
          console.warn('Deferred folder-receipt claim failed (receipt stays in folder):', err);
        });
      });
    },
    revokeAttachmentBlobUrl: function revokeAttachmentBlobUrl(attachment) {
      if (!attachment || !attachment._blobUrl) return;
      // Guard the scheme — `path` can be swapped to Legacy's https URL after
      // upload, but `_blobUrl` holds the original handle. Only call revoke on
      // blob: URLs (no-op otherwise, but cheap to check defensively).
      if (typeof attachment._blobUrl === 'string' && attachment._blobUrl.indexOf('blob:') === 0) {
        URL.revokeObjectURL(attachment._blobUrl);
      }
      attachment._blobUrl = '';
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Revoke any blob URLs still pinned on attachments. Splice paths
    // (removePrimaryAttachment, upload-failure branches) already revoke
    // individually; this catches the happy-path teardown where the user
    // saves and the modal closes with attachments still in the array.
    var self = this;
    if (Array.isArray(this.attachedFiles)) {
      this.attachedFiles.forEach(function (f) {
        self.revokeAttachmentBlobUrl(f);
      });
    }
    // PRODUCTDEV-5772 — also revoke any object URLs held by additional documents.
    if (Array.isArray(this.additionalDocuments)) {
      this.additionalDocuments.forEach(function (d) {
        self.revokeAttachmentBlobUrl(d);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "lwZO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1vYVFoFk4KGP5A_Hkd9Q9Q","Dell":"_2oGhhvFlMNra4JGbzniTTw","Abbott":"_2MfA7KrNOXAdgHppnnZbzC","Gap":"_1U2JuMExJYDaHG0_CAHhb9","Allstate":"_1U3Yv-3GW-K23b-bu8CTpd","Asurion":"_1h2YMzUxR8KAtgTDe-exre","Invitae":"_9cLeNLS_DMGJNN-0dzO31","JWE":"_3F4BjBrG13kUgBHiA3-704"};

/***/ }),

/***/ "lxXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Grid_cells_actions__ = __webpack_require__("ayPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BUModel_js__ = __webpack_require__("yi8+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__core_events_events__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */]
  },
  data: function data() {
    return {
      BUModel: __WEBPACK_IMPORTED_MODULE_2__BUModel_js__["a" /* default */],
      actions: [__WEBPACK_IMPORTED_MODULE_1__components_Grid_cells_actions__["g" /* remove */]]
    };
  },
  computed: {
    getModel: function getModel() {
      return __WEBPACK_IMPORTED_MODULE_2__BUModel_js__["a" /* default */].get();
    }
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__core_events_events___default.a.BU_CC.REFRESH, function (r) {
      _this.refresh();
    });
  },
  methods: {
    editBU: function editBU(payload, success, fail) {
      //
      if (!this.validBU(payload.data)) {
        fail('Invalid Business Unit');
      } else {
        this.api.post(this.api.$.BUAndCC.saveBusinessUnit, payload.data).then(function (r) {
          return success(r);
        }).catch(function (e) {
          return fail();
        });
      }
    },
    removeBU: function removeBU(payload, success, fail) {
      //
      var id = +payload.data.BusinessUnitId;
      this.api.delete(this.api.$.BUAndCC.deleteBusinessUnit + '/' + id, id).then(function (r) {
        return success();
      }).catch(function (e) {
        return fail('Something went wrong. Cannot delete the Business Unit');
      });
    },
    removeBUs: function removeBUs(payload) {
      //
      var businessUnitIds = [];
      payload.rows.forEach(function (element) {
        businessUnitIds.push(element.data.BusinessUnitId);
      });
      var p = {
        IDs: businessUnitIds
      };
      this.api.post(this.api.$.BUAndCC.deleteBusinessUnits, p).then(this.validateDeleteBUs);
    },
    validBU: function validBU(data) {
      //
      var isValid = true;
      if (data.BusinessUnitName.trim() === '') {
        isValid = false;
      }
      return isValid;
    },
    addBU: function addBU() {
      this.$refs.BusinessUnitsGrid.addRow({});
    },
    refresh: function refresh() {
      this.$refs.BusinessUnitsGrid.quickSearch();
      this.$refs.BusinessUnitsGrid.onSelectAll(false);
    },
    validateDeleteBUs: function validateDeleteBUs(r) {
      if (r.data.Errors.length !== 0) {
        alert('Something went wrong. Cannot delete the Business Units.');
      }
      __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__core_events_events___default.a.BU_CC.REFRESH);
    }
  }
});

/***/ }),

/***/ "m/F2":
/***/ (function(module, exports) {

module.exports = {"dashboard":{"create":"https://widgetsapi.eved.com/api/widgets/Create","templates":"https://widgetsapi.eved.com/api/widgets/Available/0","container":"https://widgetsapi.eved.com/api/widgets/Sections/0","widgets":"https://widgetsapi.eved.com/api/widgets","widget":"https://widgetsapi.eved.com/api/widgets/Widget","widgetInfo":"https://widgetsapi.eved.com/api/widgets/WidgetInfo"},"program":{"list":"/Program/GetProgramList","received":"/QqManageContract/LoadReceivedPrograms","sent":"/QqManageContract/GetList","new":"/ProgramFusion/SaveProgram","upload":"/Upload/ImportedFile","import":"/ProgramsUploaderProxy/GetFieldsAndHeaders","create":"/ProgramsUploaderProxy/BulkImport","permissions":"/ProgramsUploaderProxy/GetCollaboratorsPermissions","titles":"/ProgramsUploaderProxy/GetCollaboratorsTitles","details":"/Program/GetProgramDetails"},"rfp":{"received":"/RfpList/GetList","sent":"/RfpSentList/GetSentList"},"sos":{"list":{"$":"/Scope/GetList","scope":"Scope"}},"po":{"received":"/QqManagePurchaseOrder/LoadPurchaseOrder","sent":"/QqSentPurchaseOrder/LoadPurchaseOrder","wo":"/QqSentPurchaseOrder/LoadPurchaseOrder","approval":"/PurchaseOrderApproval/GetList","list":{"$":"/QqManagePurchaseOrder/LoadPurchaseOrder","cta":"ActionRequired"}},"wo":{"list":"/QqSentPurchaseOrder/LoadPurchaseOrder"},"commission":{"list":"/PartnerCommission/LoadCommissions"},"expense":{"list":{"$":"/Expense/GetList","expense":"Expenses","approval":"ExpensesApprovalQueue","programs":"/Program/GetProgramsForCombo","owners":"/Program/PrepareRpfOwner"},"add":"/ScopeOfService/Save","upload":"/Upload/ImportedFile","import":"https://dataimportapi.eved.com/api/Excel/GetObjectProperties","create":"https://dataimportapi.eved.com/api/Excel/Import","permissions":"/ExpensesUploaderProxy/GetCollaboratorsPermissions","titles":"/ExpensesUploaderProxy/GetCollaboratorsTitles"},"invoice":{"list":{"$":"/PaymentInvoice/GetList","received":"ReceivedInvoices","sent":"SentInvoices","paymentsSent":"PaymentsMade","paymentsReceived":"PaymentsReceive","funding":"FundingInvoices","ap":"AccountPayableFiles","receivedCta":"ReceivedActionPayment","sentCta":"SentActionPayment","uploadInvoicePrograms":"/InvoiceToPay/GetPrograms","canCancelInvoice":"/PaymentInvoice/CanCancelInvoice","validateRemitPayment":"/PaymentInvoice/ValidateInvoices","validateEditInvoice":"/PaymentInvoice/ValidateInvoiceEdit"},"upload":"/Upload/ImportedFile","import":"/InvoicesUploader/GetFieldsAndHeaders","validate":"/InvoicesUploader/Validate","additional":"/InvoicesUploader/GetInvoices","validateChangeSupplierAtImport":"/InvoicesUploader/ValidateChangeSupplier","getProcessingFeeByProgram":"/InvoicesUploader/GetProcessingFeeByProgram","create":"/InvoicesUploader/BulkImport","categories":"/InvoicesUploader/GetCategories","skybox":"/SupplierDashboard/GetInvoicePageHeaderData","payments":"/PaymentList/GetList","rejectReason":"/PaymentInvoice/GetRejectionReason","suppliers":"/InvoiceToPay/GetSuppliersForITPWithLineItems","suppliersBankAccount":"/InvoiceToPay/GetMaskedBankAccount","similarSuppliers":"/SourceCommon/GetSuppliersWithSimilarName","checkSupplierZipCode":"/InvoiceToPay/CheckSupplierZipCode","i2p":{"currencies":"/InvoiceToPay/GetGlobalCurrenciesByProgram","paymentTypes":"/InvoiceToPay/GetInvoicePaymentTypesCombo","programDetails":"/InvoiceToPay/GetProgramDetails","purchaseOrders":"/InvoiceToPay/GetPOs","getPOSnapshotDetails":"/InvoiceToPay/GetPOSnapshotDetails","getRemainingQtyAndAmountOnPOItems":"/InvoiceToPay/GetRemainingQtyOnPOItems","getSupplierFromAddSupplierButton":"InvoiceToPay/GetSupplierFromAddSupplierButton","getInvoiceDueDate":"/InvoiceToPay/GetInvoiceDueDate","supplierEvedPayStatus":"/InvoiceToPay/GetSupplierEvedPayStatus","getImmediatePaymentSettings":"/InvoiceToPay/GetImmediatePaymentSettings","discounts":"/InvoiceToPay/GetDiscountsCombo","remainingBudget":"/InvoiceToPay/GetProgramRemainingBudgetDetails","customFields":"/open-api/invoices/fields","itemCustomFields":"/open-api/invoices/item-fields","saveInvoice":"/InvoiceToPay/SaveInvoice","cancelInvoice":"/InvoiceToPay/CancelInvoice","checkOverBudgetBeforeSendingToScan":"/InvoiceToPay/CheckOverBudgetBeforeSendingToScan","submitBatch":"/InvoiceToPay/SubmitBatch","getSupplierCountryName":"/InvoiceToPay/GetSupplierCountryName"},"getAttachmentsDetails":"/PaymentInvoice/GetJsonAttachmentsDetails","sendZipMismatchEmail":"/PaymentInvoice/SendZipMismatchEmail","reviewEmail":"/eo-admin/payment-invoice-details"},"clientInvoice":{"list":"/ClientInvoice/GetProgramsForWidget","payment":"/ClientInvoicePayments/GetClientInvoicePaymentsForWidget","cta":"/ActionRequired/GetProgramsForWidget"},"card":{"list":"/EvedPayCards/GetList","transaction":"/EvedPayTransactions/GetList","approval":"/EvedPayApproval/GetList"},"evedpaycard":{"list":"/evedpaycards","accounts":"/EvedPayCardAccounts/GetList","account":"/evedpaycards/accounts/","division":"/evedpaycards/divisions-with-accounts/","cards":"/EvedPayCardList/GetList","transactions":"/EvedPayCardTransactions/GetList","envelopes":"/EvedPayCardEnvelopes/GetList","envelope":"evedpaycards/envelope","reconcile":"evedpaycards/reconcile","programs":"evedpaycards/programs","approvalUsers":"evedpaycards/approval-users","refillApprovalUsers":"evedpaycards/refill-approval-users","approvalUsersForEnvelope":"evedpaycards/approval-users-for-envelope","canEditInEnvelopeTransaction":"evedpaycards/transactions/can-edit","receipt":"/UploadReceiptReconcile","approveOrReject":"/approval","approveOrRejectEnvelope":"evedpaycards/envelope/approval","approveOrRejectCardFunding":"evedpaycards/funding/approval","approveOrRejectCardRefill":"evedpaycards/refill/approval","approveOrRejectCardDailySpendLimit":"evedpaycards/daily-spend-limit/approval","history":"/EvedPayCardHistory/GetList","suppliers":"evedpaycards/reconcile-suppliers","categoriesAndBuAndCc":"InvoiceToPay/GetItemsCategoriesAndBuAndCc","saveUser":"Users/SaveUser","costCenters":"/UserProfile/GetCostCenters","businessUnits":"/UserProfile/GetBusinessUnits","BU_CC_pair":"BusinessUnitsAndCostCenters/GetBuAndCcPairsForCombo","cardWithDetails":"evedpaycards/card-with-details","addTransactionNumberToEnvelope":"evedpaycards/envelopes/save-transaction-number","createAPFile":"evedpaycards/envelope/create-ap-file","resendEnvelopeApprovalEmail":"evedpaycards/resend-envelope-approval-email","resendCardApprovalEmail":"evedpaycards/resend-card-approval-email","resendCardFundingApprovalEmail":"evedpaycards/resend-card-funding-approval-email","resendCardRefillApprovalEmail":"evedpaycards/resend-card-refill-approval-email","resendCardDailySpendLimitApprovalEmail":"evedpaycards/resend-card-daily-spend-limit-approval-email","statements":"/EvedPayCardAccountStatements/GetList","updateReceipt":"evedpaycards/transaction/update-receipt","requestCardOtp":"evedpaycards/request-card-otp","verifyCardOtp":"evedpaycards/verify-card-otp"},"settings":{"company":{"$":"/Settings/SaveSettings","addDivision":"/Settings/AddDivision","getEntity":"/Settings/GetEntity","checkDivisionNameUnique":"/Settings/CheckDivisionNameUnique","checkEINUnique":"/Settings/CheckEINUnique","approval":"/Settings/UpdateAllowApprovalSettings","approvalDelegate":"/ApprovalDelegate","timeDate":"/Settings/TimeAndDate","budget":"/SettingsBudget","payment":"/PaymentInfoFromSettings","programTemplate":"/Settings/ProgramTemplate","email":"/EmailVerification","report":"/Reports","scope":"/Scopes","program":"/Program","costCenter":"/CostCenter","currency":"/Settings/CurrencySetting","erp":"/Settings/ERP","division":"/Divisions","meetingType":"/MeetingType","expense":"/Expenses","invoice":"/Invoices","partner":"/PartnerFunding","partnerCommission":"/PartnerCommissionSettings","po":"/PurchaseOrders","invitation":"/Invitations","companyNotification":"/Settings/CompanySettingsNotifications","notification":"/Notifications","template":"/QqTemplate","category":"/ProductSubcategory","vat":"/SettingsVAT","taxAuthority":"/TaxAuthority/TaxAuthorities","landmark":"/Landmarks/Landmarks","fundingInvAndAPSettings":"/Settings/UpdateHasFundingInvAndAPSettings","countries":"/UserProfile/GetCountries"},"my":{"resetPassword":"/../api/v2/forgotPassword","settings":"/api/GetUserSettings","renew":"/api/Renew","switch":"/Account/SwitchToCompany","switchToEoAdmin":"/Users/GetSwitchToEoAdminUrl"},"currencies":"/Settings/GetGlobalCurrenciesByProgram","currenciesFilter":"/Program/GetCurrencyForGridCombo","countries":"/Profile/GetAllCountries"},"common":{"notifications":"/UserNotification/GetPopUpNotifications","readNotifications":"/UserNotification/SetViewedNotification","filterViews":"/Common/FilterView","optionsFilter":"/Common/DynamicFilter"},"approval":{"getApprovalRules":"/ApprovalRule/GetRules","getApprovalRulesHistory":"/ApprovalRule/GetApprovalRulesHistory","getRule":"/ApprovalRule/GetRule","deleteRule":"/ApprovalRule/DeleteRule","getContext":"/ApprovalRule/GetContext","getRuleContextOptions":"/ApprovalRule/GetRuleContextOptions","getConditionOptions":"/ApprovalRule/GetConditionOptions","saveRule":"/ApprovalRule/SaveRule","getNewRuleId":"/ApprovalRule/GetNewRuleId","getDivisions":"/Settings/GetDivisions","getCategories":"/Settings/GetCategories","getRoles":"/Settings/GetRoles","getUsers":"/Settings/GetUsers","getTeamTabRoles":"/Settings/GetTeamTabRoles","getMeetingTypes":"/Settings/GetMeetingTypes","getCostCenters":"/Settings/GetCostCenters","getBusinessUnits":"/Settings/GetBusinessUnits","getItemOwnerValues":"/Settings/GetItemOwnerValues","saveSettings":"/Settings/SaveAdminSettings","initApprovalNote":"/Settings/GetApprovalNoteSettings","saveApprovalNote":"/Settings/SaveApprovalNoteSettings"},"BUAndCC":{"getBusinessUnits":"/BusinessUnits/GetListForDatatable","getCostCenters":"/CostCenters/GetListForDatatable","getBusinessUnitsAndCostCenters":"/BusinessUnitsAndCostCenters/GetListForDatatable","saveSettings":"/BusinessUnitsAndCostCenters/SaveAdminSettings","saveBusinessUnit":"/BusinessUnits/BusinessUnit","saveCostCenter":"/CostCenters/CostCenter","deleteBusinessUnit":"/BusinessUnits/BusinessUnit","deleteBusinessUnits":"/BusinessUnits/BusinessUnits","deleteCostCenter":"/CostCenters/CostCenter","deleteCostCenters":"/CostCenters/CostCenters","saveBuAndCcPair":"/BusinessUnitsAndCostCenters/Pair","deleteBuAndCcPair":"/BusinessUnitsAndCostCenters/Pair","deleteBuAndCcPairs":"/BusinessUnitsAndCostCenters/Pairs","exportGridData":"/BusinessUnitsAndCostCenters/ExportList"},"FundingInvoiceAndApSetting":{"getFundingAddresses":"/FundingInvoiceSettings/GetListForDatatable","getAPFileTemplates":"/ApFileSettings/GetListForDatatable","deleteFundingAddress":"/FundingInvoiceSettings/DeleteFundingAddress","deleteFundingAddresses":"/FundingInvoiceSettings/DeleteFundingAddresses","saveFundingAddress":"/FundingInvoiceSettings/SaveFundingAddress","updateFundingAddress":"/FundingInvoiceSettings/UpdateFundingAddress","updateAPFileTemplate":"/ApFileSettings/UpdateAPFileTemplate","getDivisionsForFundingAddresss":"/FundingInvoiceSettings/GetDivisionsForFundingAddress","getBusinessUnitsForFundingAddresss":"/FundingInvoiceSettings/GetBusinessUnitsForFundingAddress","getDivisionsForAPFileTemplates":"APFileSettings/GetDivisionsForAPFileTemplates","getBusinessUnitsForAPFileTemplates":"APFileSettings/GetBusinessUnitsForAPFileTemplates","getSelectedDivisions":"/FundingInvoiceSettings/GetSelectedDivisions","getSelectedBusinessUnits":"/FundingInvoiceSettings/GetSelectedBusinessUnits","getSelectedAPTemplateDivisions":"/APFileSettings/GetSelectedDivisions","getSelectedAPTemplateBusinessUnits":"/APFileSettings/GetSelectedBusinessUnits","hasAPSettingsByBU":"/APFileSettings/HasAPSettingsByBU"},"profile":{"getAllCountries":"/Profile/GetAllCountries","getAllStates":"/Profile/GetAllStates","getCanadaStates":"/Profile/GetAllCanadaProvinces"},"upload":{"uploadInvoice":"/Upload/UploadInvoice","uploadCommnetFile":"/Upload/ManageMediaFile?fromPage=Comments&programID=0","uploadFile":"/Upload/UploadFile"},"payment":{"init":"/Payment/InitPayment","validate":"/Payment/ValidatePayment","submit":"/Payment/SubmitPayment","initApFiles":"/Payment/PreparePaymentStep2","sendApFiles":"/Payment/SubmitPaymentStep2","replaceApFile":"/Payment/ReplaceAuditFile","generateApFile":"/Payment/GenerateAuditFile","changeFundingCurrency":"/Payment/ChangeFundingCurrency","checkPaymentProcessingFinished":"/Payment/IsPaymentProcessingFinished","getReversalOrCorrectApFileInfo":"/Payment/GetReversalOrCorrectAPFileInfo","sendReversalOrCorrectedApFile":"/Payment/SendReversalOrCorrectedAPFile","replaceFundingStatement":"/Payment/CorrectFundingStatement","correctApFile":"/Payment/CorrectAuditFile"},"admin":{"getInvoicesToBeScanned":"/InvoiceScan/GetListForDatatable","getInvoicesToBeScannedHistory":"/InvoiceScanHistory/GetListForDatatable","scannerIsAssignedToInvoice":"/InvoiceScanning/ScannerIsAssignedToInvoice","validateReviewInvoiceAction":"/InvoiceScanning/CanReviewInvoice","getInvoiceScannedHistory":"","getInvoiceScanners":""},"network":{"insuranceSuppliers":"/network/insurance-suppliers","insuranceCertificates":"/network/supplier-cetificates","insuranceSupplierDetails":"/network/supplier-insurance-details"},"supplier":{"customFields":"/suppliers/add-form"},"mfa":{"validateCode":"/Account/ValidateMfaCode","getToken":"/Account/GetMfaSoftwareToken","checkToken":"/Account/VerifyMfaSoftwareToken","setPhone":"/Account/SetMfaPhoneNumber","checkPhone":"/Account/VerifyPhoneNumber","getConfig":"/UserProfile/GetMFAConfiguration","setConfig":"/UserProfile/SetMfaPreferrence"},"divisionUsers":"Users/GetDivisionUsers","predictiveCoding":{"predict":"api/v1/predictive-coding/predict","batch":"api/v1/predictive-coding/predictions:batch"}}

/***/ }),

/***/ "m4+0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var skeleton = function skeleton(count, fieldWidth) {
  var element = function element(template) {
    var str = '';
    for (var i = 0; i < count; i++) {
      var random = Math.floor(Math.random() * 60 + 20);
      str += template.replace('[[RANDOM]]', random).replace('[[WIDTH]]', fieldWidth).replace('[[MWIDTH]]', fieldWidth);
    }
    return str;
  };
  return "<div class='skeleton-container'>\n            ".concat(element("\n            <div class='skeleton-box form-label' style='width: [[RANDOM]]%; max-width: [[MWIDTH]]'></div>\n            <div class='skeleton-box form-field' style='width: [[WIDTH]]'></div>\n            "), "\n          </div>");
};
var css = "\n.skeleton-box {\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n  vertical-align: middle;\n  background-color: #ececec;\n}\n.skeleton-box::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  -webkit-transform: translateX(-100%);\n  transform: translateX(-100%);\n  background-image: -webkit-gradient(linear,left top,right top,color-stop(0,hsla(0,0%,100%,0)),color-stop(20%,hsla(0,0%,100%,.2)),color-stop(60%,hsla(0,0%,100%,.5)),to(hsla(0,0%,100%,0)));\n  background-image: linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.2) 20%,hsla(0,0%,100%,.5) 60%,hsla(0,0%,100%,0));\n  -webkit-animation: shimmer 3s infinite;\n  animation: shimmer 3s infinite;\n  content: '';\n}\n\n@keyframes shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n.skeleton-box.form-label {\n  height: 1.25em;\n  width: 50%;\n\n  margin: 2px 0 4px;\n  display: block;\n}\n.skeleton-box.form-field.form-field {\n  height: 2.75em;\n  width: 101%;\n\n  background-image: none;\n  background-color: #ececec;\n  border: none;\n\n  margin-bottom: 14.25px;\n}\n\n.loading.skeleton > * {\n  visibility: hidden;\n}\n.loading.skeleton > .skeleton-loader {\n  visibility: visible;\n}\n\n.loading .skeleton-container {\n  display: block;\n  opacity: 1;\n  z-index: 1;\n}\n.loading.skeleton.bare .skeleton-container,\n.loading.skeleton.list .skeleton-container {\n  /*position: static;*/\n}\n.skeleton-container {\n  /*display: none;*/\n  opacity: 0;\n  transition: opacity 0.5s;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: -1;\n}\n";
var DEFAULT_COUNT = 5;
var LOADING = {
  name: 'loading',
  bind: function bind(el, binding, vnode) {
    var endpoint = binding.value;
    if (!endpoint) return;
    var count = Object.keys(binding.modifiers)[0];
    count = !isNaN(count) && +count || DEFAULT_COUNT;
    var field = el.querySelector('*:first-child:not(label)');
    var skeletonNode = document.createElement('div');
    skeletonNode.className = 'skeleton-loader';
    // skeletonNode.innerHTML = skeleton(count, fieldWidth)

    setTimeout(function () {
      var fieldWidth = field && field.getBoundingClientRect().width ? "".concat(field.getBoundingClientRect().width + 2, "px") : 'calc(100% + 2px)';
      skeletonNode.innerHTML = skeleton(count, fieldWidth);
    }, 0);
    el.setAttribute('endpoint', endpoint);
    el.style.position = 'relative';
    el.classList.add('ghost', 'skeleton');
    !field && el.classList.add('bare');
    el.appendChild(skeletonNode);
    setTimeout(function () {
      el.style.minHeight = el.querySelector('.skeleton-container').getBoundingClientRect().height + 'px';
    }, 0);
  }
};
skeletonStyles();
/* harmony default export */ __webpack_exports__["a"] = (LOADING);
function skeletonStyles() {
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  head.appendChild(style);
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

/***/ }),

/***/ "m50H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_39LZANNjVYASDqj5YxDNjP","Dell":"_3JVuefomT0ihknsKK6Ot5r","Abbott":"_17q6BHn01bMf3MTEQZSCUd","Gap":"_361zvFy-TC22ugrt75SWr","Allstate":"_2P-Vgi8_X1-b5rqO-IUCLz","Asurion":"s7ajZa0H5KQcybA3yh2f5","Invitae":"_1jd1hnjoH0T-g-z-QRXA3C","JWE":"_2gekaP8r1GvupVF1-zo0XM"};

/***/ }),

/***/ "m5D7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mEnS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-item"},[_c('router-link',{attrs:{"tag":"li","to":_vm.href,"active-class":"active","exact":""}},[_c('a',{attrs:{"href":_vm.href}},[_c('p',{on:{"click":function($event){return _vm.$emit("click")}}},[_c('span',{class:_vm.icon}),_vm._v(" \n"+_vm._s(_vm.title))])])]),_c('div',{staticClass:"subnav"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mITd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllocateToCC_vue__ = __webpack_require__("KSS+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e7ca77_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllocateToCC_vue__ = __webpack_require__("TEN6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllocateToCC_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e7ca77_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllocateToCC_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mJEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return numeric; });
var numeric = {
  getNumberFromString: function getNumberFromString(value) {
    // replace all non-numeric characters without , and . and - (without thousand, decimal separator and negative minus(substract) sign)
    var regex1 = new RegExp('[^\\d.,-]', 'g');
    value = value.replace(regex1, '');

    // replace thousand separator with empty space
    var thousandSeparator = "\\".concat(utils.locale.getLocaleThousandSeparator());
    regex1 = new RegExp(thousandSeparator, 'g');
    value = value.replace(regex1, '');

    // keep last decimal separator if there are more
    var decimalSeparator = "\\".concat(utils.locale.getDecimalSeparator());
    regex1 = new RegExp('[' + decimalSeparator + '](?=.*[' + decimalSeparator + '])', 'g');
    value = value.replace(regex1, '');

    // get the string entered until numeric chars (to verify if there is any substractor in it)
    // this is for negative numbers entered
    regex1 = new RegExp('^\\D+', 'g');
    var prefixString = value.match(regex1);

    // replace all 'minus'(substract) signs from value
    regex1 = new RegExp('-', 'g');
    value = value.replace(regex1, '');

    // verify if there is any substractor char in the string entered until numeric chars
    // this is for negative numbers entered
    if (prefixString && prefixString.indexOf('-') > -1) {
      var substractorString = '-';
      substractorString += value;
      value = substractorString;
    }
    return value;
  },
  setMaxNumberOfDigits: function setMaxNumberOfDigits(value, numberOfDigits) {
    var indexOfDecimalSeparator = value.indexOf(utils.locale.getDecimalSeparator());
    var decimalSepIsInValue = indexOfDecimalSeparator > -1;
    if (decimalSepIsInValue) {
      var maximNrOfDigits = value.length - indexOfDecimalSeparator;
      if (maximNrOfDigits > numberOfDigits) {
        value = value.substring(0, indexOfDecimalSeparator + numberOfDigits + 1);
        value = value.toString();
      }
    }
    return value;
  },
  getNumberWithDecimals: function getNumberWithDecimals(value, digits) {
    if (!digits) digits = 2;
    value = this.getNumberFromString(value);
    value = value ? parseFloat(value).toFixed(digits) : parseFloat(0).toFixed(digits);
    value = value.toString();
    return value;
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "mL63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-modal',{attrs:{"show":_vm.show,"title":_vm.title,"primary-button":"false","secondary-button":"false","type":"medium","closeOnEsc":true},on:{"close":_vm.onClose,"validate":_vm.send}},[_c('div',{staticClass:"content",attrs:{"slot":"body"},slot:"body"},[_c('span',{staticClass:"description-section-modal"},[_vm._v("\n      The supplier will receive an email letting them know that your company uses EvedPay!\n      Eved's merchant services team will assist them with the sign-up process if they\n      don't already have an account.\n    ")]),_vm._v(" "),_c('form',{staticClass:"col-md-offset-1 col-md-11 mb-offset-64",on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},_vm._l((_vm.invite),function(supplier,i){return _c('ed-section',{key:i,staticClass:"no-border",attrs:{"wide":""}},[(i === 0)?_c('span',{attrs:{"slot":"description"},slot:"description"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-11"},[(_vm.$v.$invalid && _vm.$v.$dirty)?_c('div',{staticClass:"error-summary panel panel-danger panel-side no-icon"},[_c('div',{staticClass:"panel-heading"}),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',[_vm._v("\n                All fields are required unless labeled 'optional'\n              ")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading.8",value:(_vm.api.$.supplier.customFields),expression:"api.$.supplier.customFields",modifiers:{"8":true}}],staticClass:"form-group list"},[_c('transition-group',{attrs:{"name":"field"}},_vm._l((_vm.mapFields),function(field,index){return _c('div',{key:_vm.hash(field),staticClass:"form-group list",attrs:{"data-field":field.key}},[_c(field.type,_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.shouldBeVisible(field)),expression:"shouldBeVisible(field)"}],ref:"fields",refInFor:true,tag:"component",staticClass:"full-width list",attrs:{"field-label":field.label,"type":field.nativeType,"maxlength":field.maxLength,"placeholder":" ","required":field.required,"optional":field.optional,"error":_vm.$v.Supplier[field.key] && _vm.$v.Supplier[field.key].$error,"helptip-header":"","helptip-body":_vm.validationMessage(field),"options":_vm.fieldOptions(field),"track-by":"text","button-label":"Upload File","button-position":"bottom","post-action":_vm.api.env + field.dataSource.url,"headers":_vm.headers,"upload-auto":true,"multiple":_vm.multiple(field),"readonly":field.type === _vm.FIELD_TYPES.file ? true : false,"show-helptip-icon":false,"endpoint":field.type === _vm.FIELD_TYPES.file ? field.dataSource.url : null,"openEndpoint":field.dataSource.url,"label":"text","integer":field.integer,"xserver-search":"field.serverSearch","xsearch":"query => fetchOptions(field, query)"},on:{"open":function($event){return _vm.fetchOptions(field)},"select":function () { _vm.selectOption(field) },"hook:created":function($event){return _vm.update(field)},"hook:beforeCreate":function($event){return _vm.beforeCreateField(field)}},model:{value:(supplier[field.key]),callback:function ($$v) {_vm.$set(supplier, field.key, $$v)},expression:"supplier[field.key]"}},'component',_vm.meta(field.key, index, field),false)),_vm._v(" "),(_vm.shouldShowInfo(field).label)?_c('div',{staticClass:"alternate"},[_c('label',[_vm._v("\n                    "+_vm._s(field.label)+"\n                    "),(!field.required)?_c('em',{staticClass:"optional-field-label"},[_vm._v(" - optional")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info-field"},[_c('em',[_vm._v("Select "),_c('strong',[_vm._v(_vm._s(_vm.shouldShowInfo(field).label))]),_vm._v(" "+_vm._s(_vm.shouldShowInfo(field).meta))])])]):_vm._e()],1)}),0),_vm._v(" "),_c('transition-group',{attrs:{"name":"field","duration":1000}},[(_vm.customFields.length && !_vm.loading)?_c('div',{key:"submit"},[_c('br')]):_c('small',{key:"wait"},[_vm._v(" "+_vm._s(null && _vm.$t("Wait a second..."))+" ")])])],1)])])}),1)]),_vm._v(" "),_c('div',{staticClass:"buttons clear",attrs:{"slot":"footer"},slot:"footer"},[_c('ed-button',{attrs:{"button-class":"btn btn-default"},on:{"click":_vm.onClose}},[_vm._v("Cancel")]),_vm._v(" "),_c('ed-button',{class:{ invalid: _vm.$v.$invalid && _vm.$v.$dirty, disabled: !_vm.canSubmit },attrs:{"disabled":!_vm.canSubmit,"endpoint":_vm.submitAction},on:{"click":_vm.send}},[_vm._v("Send Invite")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mMkD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "mP7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_readOnlyError__ = __webpack_require__("KyYW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_readOnlyError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_readOnlyError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);





function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { Eved, EventBus } from '@/event-bus'


var Supplier = {
  //
};
var FIELD_TYPES = {
  number: 'ed-input',
  textarea: 'ed-textarea',
  text: 'ed-input',
  email: 'ed-input',
  select: 'ed-select',
  date: 'ed-datepicker',
  file: 'ed-upload'
};
var opIn = function opIn(value, collection) {
  return !!~collection.indexOf(value);
};
var opNotIn = function opNotIn() {
  return !opIn.apply(void 0, arguments);
};
var operators = {
  'IN': opIn,
  'NOT IN': opNotIn
};
var fieldMapper = function fieldMapper(field) {
  return _objectSpread(_objectSpread({}, field.constructor.name === 'Object' ? field : {}), {}, {
    type: FIELD_TYPES[field.type] || field.type || FIELD_TYPES['text'],
    nativeType: field.type === 'number' ? 'text' : field.type || 'text',
    key: field.name || field.key || (field.label || field).replace && (field.label || field).replace(/ /g, ''),
    label: getLabel(field.label || field),
    required: field.required || (field.validation || {}).required,
    dependency: (field.validation || {}).dependencies[0],
    integer: field.type === 'number',
    multiple: field.multiple,
    // serverSearch: field.serverSearch,
    serverOptions: field.multiple && field.type === 'select' && (field.dataSource || {}).url
  });
};
var getLabel = function getLabel(label) {
  var labels = global.app.$user.sessionSettings.CompanySettings.Labels;
  var tokens = label.match(/\{\{\w+\}\}/g);
  var r = label;
  tokens && tokens.forEach(function (token) {
    var label = token.replace('{{', '').replace('}}', '');
    r = r.replace(token, labels[label]);
  });
  return r;
};
var additionalFields = [
  //
];
var TEMPLATE_FIELD = 'templateName';
var validEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddSupplier',
  props: {
    model: Object,
    invoiceId: Number,
    eventHub: Object,
    operation: String
  },
  created: function created() {
    this.getCustomFields();
    this.Supplier = this.invite[0];
  },
  mounted: function mounted() {
    //
  },
  beforeLeave: function beforeLeave() {
    return this.check();
  },
  data: function data() {
    var _this = this;
    return {
      FIELD_TYPES: FIELD_TYPES,
      //
      headers: {
        'Authorization': "Bearer ".concat(this.$user.sessionSettings.Token)
      },
      submitAction: '',
      canSubmit: true,
      invite: [utils.copy(Supplier)],
      options: {},
      Supplier: null,
      sentInvite: false,
      showCancelBtn: false,
      customFields: [],
      counter: 0,
      loading: false,
      lastUpdatedKey: '',
      show: true,
      title: 'Invite Supplier',
      hash: function hash(field) {
        var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.invite[0];
        var hash = field.key + /* this.options.length + */field.validation.dependencies.map(function (d) {
          return (form[d.name] || {}).text;
        }).join('-') + _this.counter;
        // field.hash = field.hash || hash
        return hash;
      },
      shouldBeVisible: function shouldBeVisible(field) {
        var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.invite[0];
        if (_this.loading) return false;
        var dependencies = !!field.validation.dependencies.length;
        field.validation.unresolvedDependencies = [];
        return !dependencies || field.validation.dependencies.some(function (dependency) {
          var dependsOn = form[dependency.name];
          var dependsOnValue = (dependsOn || {}).text;
          var collection = dependency.values;
          var resolved = operators[dependency.operator](dependsOnValue, collection) || !collection.length;
          if (resolved) {
            field.validation.unresolvedDependencies.push(dependency.name);
          }
          return dependsOnValue && resolved;
        });
      },
      shouldShowInfo: function shouldShowInfo(field) {
        var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.invite[0];
        if (_this.loading) return false;
        var info = '';
        if (field.type === FIELD_TYPES.file) {
          var dependsOn = field.validation.unresolvedDependencies[0];
          var dependsOnLabel = (_this.mapFields.find(function (customField) {
            return customField.name === dependsOn;
          }) || {}).label;
          var dependsOnValue = dependsOn && (form[dependsOn] || {}).text;
          info = !dependsOnValue && {
            label: dependsOnLabel,
            meta: dependsOn === (field.validation.dependencies[0] || {}).name ? 'first' : ''
          };
        }
        return info;
      },
      validationMessage: function validationMessage(field) {
        return _this.$v.Supplier[field.key] && _this.$v.Supplier[field.key].$error ? field.description || "Please fill in ".concat(_this.$v.Supplier[field.key].validationRule === false && _this.$v.Supplier[field.key].$model ? 'a valid' : 'the', " ").concat(field.label) : field.description;
      }
    };
  },
  validations: function validations() {
    return {
      Supplier: _objectSpread({}, this.validationRules)
    };
  },
  computed: {
    mapFields: function mapFields() {
      return this.customFields.map(fieldMapper);
    },
    validationRules: function validationRules() {
      var _this2 = this;
      var validations = {};
      this.mapFields.forEach(function (field) {
        validations[field.key] = field.required ? {
          isValid: function isValid(v) {
            return !_this2.shouldBeVisible(field) ? true : field.nativeType === 'email' ? Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"])(v) && validEmail.test(String(v)) : Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"])(v);
          }
        } : {
          isValid: function isValid(v) {
            return !_this2.shouldBeVisible(field) ? true : field.nativeType === 'email' ? typeof v !== 'undefined' && validEmail.test(String(v)) : true;
          }
        };
      });
      return validations;
    }
  },
  methods: {
    send: function send() {
      var _this3 = this;
      if (this.canSubmit) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          console.log(this.mapToSend(this.invite[0]));
          return;
        }
        this.api.post(this.submitAction, this.mapToSend(this.invite[0])).then(function (r) {
          _this3.counter++;
          _this3.showConfirmation();
          _this3.cancel();
          _this3.prefillCustomFields(_this3.formFields);
          _this3.show = false;
        }).catch(function (e) {
          _this3.showError(e.response);
        });
      }
    },
    onClose: function onClose() {
      this.eventHub.$emit('onCloseAddSupplier', {});
      this.show = false;
    },
    preSend: function preSend(field) {
      var _this4 = this;
      var fieldEl = document.querySelector("[data-field=".concat(field));

      // if (!~prevalidateFields.indexOf(field)) {
      //   return
      // }

      fieldEl.classList.add('loading');
      this.api.post(this.submitAction, this.mapToSend(this.invite[0])).then(function (r) {
        fieldEl.classList.remove('loading');
      }).catch(function (e) {
        fieldEl.classList.remove('loading');
        _this4.showError(e.response);
      });
    },
    meta: function meta(field, index) {
      var hasTemplateField = this.customFields.find(function (f) {
        return f.name === TEMPLATE_FIELD;
      });
      if (field !== TEMPLATE_FIELD && hasTemplateField && !this.Supplier[TEMPLATE_FIELD]) {
        this.canSubmit = false;
        return {
          disabled: true,
          class: 'dim disabled'
        };
      } else {
        if (this.Supplier[TEMPLATE_FIELD]) {
          this.canSubmit = true;
        }
      }
    },
    showConfirmation: function showConfirmation() {
      this.invite[0].Email && this.$notifications.notify({
        message: "An invitation has been sent to ".concat(this.invite[0].SupplierName || '', " (").concat(this.invite[0].Email, ")"),
        type: 'info',
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    },
    showError: function showError(r) {
      this.invite[0].Email && r.data.error && r.data.error.name === 'ValidationError' && this.$notifications.notify({
        timeout: 10000,
        message: r.data.error.message,
        type: 'info-warn',
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    },
    addMore: function addMore() {
      this.showCancelBtn = this.emptyInvite();
      this.invite.push(Supplier);
    },
    cancel: function cancel() {
      // this.invite = [ utils.copy(Supplier) ]
      this.emptySupplier(this.invite[0]);
      document.querySelector('.main-panel').scrollTo(0, 0);
      this.$v.$reset();
    },
    emptySupplier: function emptySupplier(obj) {
      var fields = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(this.mapFields), additionalFields);
      fields.forEach(function (field) {
        if (field.key) {
          obj[field.key] = null;
        }
      });
      obj.MeetingDate = null;
    },
    validate: function validate() {
      //
    },
    check: function check() {
      return this.invite.filter(this.validateSupplier).length || this.emptyInvite() || this.sentInvite;
    },
    emptyInvite: function emptyInvite() {
      return this.invite.length === 1 && !this.invite[0].supplier && !this.invite[0].fullName && !this.invite[0].email;
    },
    validateSupplier: function validateSupplier(supplier) {
      return supplier.supplier && supplier.fullName && supplier.email;
    },
    getCustomFields: function getCustomFields() {
      var _this5 = this;
      this.api.get(this.api.$.supplier.customFields, {}).then(function (r) {
        if (r.data && r.data.form) {
          var _this5$customFields;
          _this5.submitAction = r.data.form.action;
          (_this5$customFields = _this5.customFields).push.apply(_this5$customFields, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(r.data.form.fieldsets[0].fields).concat(additionalFields));

          //
          _this5.formFields = r.data.form.fieldsets[0].fields;
          _this5.prefillCustomFields(_this5.formFields);
        }
      });
    },
    prefillCustomFields: function prefillCustomFields(fields) {
      var _this6 = this;
      fields.map(function (field) {
        if (field.values.length) {
          if (field.type === 'select') {
            if (field.name !== TEMPLATE_FIELD) {
              _this6.invite[0][field.name] = {
                value: 0,
                text: field.values[0]
              };
            }
          } else {
            _this6.invite[0][field.name] = field.values[0];
          }
        }
      });
    },
    fetchOptions: function fetchOptions(field, i) {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee() {
        var options;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this7.options[field.key] && _this7.options[field.key].length && !field.dataSource.queryParameters.length // &&
              // !field.serverSearch
              )) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return _this7.api.get(field.dataSource.url + '?' + _this7.query(field, _this7.invite[0], i));
            case 4:
              options = _context.sent;
              options && options.data ? _this7.options[field.key] = options.data : void 0;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    update: function update(field) {
      if (this.options[field.key]) {
        // console.log('creating', field.key)
      }
    },
    selectOption: function selectOption(field) {
      var isServerOptions = field.serverOptions;
      var shouldRefreshFields = !isServerOptions;
      if (shouldRefreshFields) {
        this.counter++;
      }
      this.clearDependencies(field);
    },
    clearDependencies: function clearDependencies(field) {
      var _this8 = this;
      var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.invite[0];
      this.lastUpdatedKey = field.name;
      if (this.lastUpdatedKey === TEMPLATE_FIELD) {
        // reset files
        var customField = this.customFields.find(function (f) {
          return f.type === 'file';
        });
        if (customField && this.shouldBeVisible(customField)) {
          form[customField.name] = null;
          delete form[customField.name];
          this.options[field.key] = null;
          delete this.options[field.key];
          this.$nextTick(function () {
            _this8.beforeCreateField(customField, true);
          });
        }
      }
      if (field.type === FIELD_TYPES.select) {
        Object.keys(form).forEach(function (f) {
          var customField = _this8.customFields.find(function (f) {
            return ~f.dataSource.queryParameters.indexOf(field.name);
          });
          if (customField) {
            form[customField.name] = null;
            delete form[customField.name];
          }
        });
      }
    },
    beforeCreateField: function beforeCreateField(field, force) {
      var _this9 = this;
      if (!field.serverSearch && force === undefined && (!this.shouldBeVisible(field) || field.dataSource.url === '')) return;

      // File fields
      if (field.type === FIELD_TYPES.file || field.type === 'file') {
        this.api.get(field.dataSource.url + '?' + this.query(field, this.invite[0])).then(function (options) {
          if (options && options.data) {
            _this9.invite[0][field.name] = _this9.mapAttachments(options.data);
            _this9.options[field.key] = options.data;
          }
          if (force) {
            _this9.$forceUpdate();
          }
        });
      }
      if (field.integer) {
        if (this.lastUpdatedKey === TEMPLATE_FIELD || !this.Supplier[TEMPLATE_FIELD]) {
          this.loading = true;
          this.api.get(field.dataSource.url + '?' + this.query(field, this.invite[0])).then(function (options) {
            if (options && typeof options.data !== 'undefined') {
              _this9.$set(_this9.Supplier, field.key, options.data);
            }
            _this9.loading = false;
          });
        }
      }
      if (field.serverOptions) {
        if (this.lastUpdatedKey === TEMPLATE_FIELD || !this.Supplier[TEMPLATE_FIELD]) {
          this.loading = true;
          this.$loading = true;
          this.api.get(field.dataSource.url + '?' + this.query(field, this.invite[0])).then(function (options) {
            if (options && typeof options.data !== 'undefined') {
              _this9.$set(_this9.Supplier, field.key, options.data);
              _this9.options[field.key] = options.data;
            }
            _this9.loading = false;
            _this9.$loading = false;
          });
        }
      }
    },
    query: function query(field, form) {
      var q = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var query = '';
      if (field.serverSearch) {
        query += "q=".concat(q);
      }
      field.dataSource.queryParameters.map(function (param) {
        var value = (form[param] || {}).text || form[param];
        query += value ? "&".concat(param, "=").concat(encodeURIComponent(value)) : '';
      });
      return query;
    },
    fieldOptions: function fieldOptions(field) {
      // console.log('rendering options for', field.key)
      if (!this.shouldBeVisible(field)) return [];
      if (this.options[field.key]) return field.options || this.options[field.key] || [];

      // this.options[field.key] ||
      this.$set(this.options, field.key, []);

      // File fields
      if (field.type === FIELD_TYPES.file) {
        this.$set(this.Supplier, field.key, []);
      }
    },
    multiple: function multiple(field) {
      return field.multiple;
    },
    mapAttachments: function mapAttachments(files) {
      var attachments = [];
      for (var f in files) {
        if (files.hasOwnProperty(f)) {
          var entry = files[f];
          attachments.push({
            fileObject: true,
            id: entry.id,
            name: entry.name,
            file: entry.file,
            path: entry.path,
            type: entry.type,
            size: entry.size * 1024,
            success: true,
            readonly: true
          });
        }
      }
      return attachments;
    },
    mapToSend: function mapToSend(o) {
      var _this10 = this;
      var output = [];
      Object.keys(o).forEach(function (k) {
        var customField = _this10.customFields.find(function (field) {
          return field.name === k;
        }) || {};
        output.push({
          name: k,
          multiple: customField.multiple,
          type: customField.type,
          values: o[k] && o[k] !== 'undefined' ? o[k].map ? o[k].map(function (k) {
            return multiselectOrFiles(k, customField);
          }) : [o[k].text || o[k]] : []
        });
      });
      return output;
      function fileId(file) {
        // upload endpoint returns application/json, so the upload component already
        // parsed file.response into an object; only JSON.parse when it's still a string
        var response = file.response;
        if (typeof response === 'string') {
          try {
            response = JSON.parse(response);
          } catch (e) {
            response = {};
          }
        }
        return response && response.id || file.id;
      }
      function multiselectOrFiles(k, field) {
        var isFilesField = field.type === 'file';
        if (isFilesField) {
          return fileId(k);
        } else {
          return k.value;
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("RMJP")))

/***/ }),

/***/ "mRHZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1skbtz0DB8eC62o1G0uhvU","Dell":"VYEXCRbvqrCYu_M6BALLL","Abbott":"_1fnyuQPwGTVCKpc5pbQq92","Gap":"_2rC4x8bHGPGM_lK2y5gUJI","Allstate":"_2ErDOxyM8D2r0VgfFaRu1V","Asurion":"_2kiW-b_TH8X9bB6vFteZVK","Invitae":"_3ISZK6ix6hetfnv27QMLqb","JWE":"_20c5p4HyLIewhJHtwrCI0a"};

/***/ }),

/***/ "mWEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Program_sent_model__ = __webpack_require__("u2bT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Program_sent_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Program_sent_model__);
//
//
//
//
//
//
//
//
//
//
//
//


// import model from './model'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */]
  },
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__Program_sent_model___default.a,
      defaultFilter: {
        ProgramOwner: {
          filter: this.$user.$.name
        }
      }
    };
  }
});

/***/ }),

/***/ "mX93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ProgramBudget: 0,
  ProgramCurrencyCode: null,
  InvoiceCurrencyCode: null,
  OriginalInvoiceCurrencyCode: null,
  TotalInvoicedAmount: 0,
  TotalVatGstAmount: 0,
  CurrentInvoicedAmount: 0,
  CurrentVatGstAmount: 0,
  ExpenseAmount: 0,
  TotalVatGstOnExpense: 0,
  BudgetBalance: 0,
  InvoiceWasSubmitted: null,
  ExcludeVATFromBudget: null,
  ShowVatAllocation: null,
  ShowExpenses: null,
  IncludeExpenseInBudget: null,
  initDataForEdit: true,
  useHighLevelAllocation: null,
  InvoiceWorkflow: '',
  POCurrencyCode: null,
  TotalAmount: 0,
  TotalInvoiceAmount: 0,
  ReceivedAmount: 0,
  TotalUnprocessed: 0,
  POBalance: 0,
  ProgramIsSelected: false
});

/***/ }),

/***/ "mYwu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.name, _vm.isInIframe ? "embedded" : ""],attrs:{"id":"layout"}},[_c('div',{staticClass:"wrapper centered",class:{ 'nav-open' : _vm.navOpened }},[_c('sidebar',{attrs:{"open":_vm.navOpened},on:{"linkClicked":_vm.toggleSideBar}}),_c('div',{staticClass:"main-panel",class:{ 'loading' : _vm.loading }},[(!_vm.isInIframe)?_c('ed-meta-nav'):_vm._e(),(!_vm.isInIframe)?_c('navigation',{attrs:{"reference":_vm.reference},on:{"toggleSideBar":_vm.toggleSideBar}}):_vm._e(),_vm._t("default"),(!_vm.isInIframe)?_c('md-footer'):_vm._e(),(_vm.navOpened)?_c('div',{staticClass:"close-layer",on:{"click":_vm.onCloseLayerClick}}):_vm._e()],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mZDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__override__ = __webpack_require__("1m0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__core_events_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LegacyContainer__ = __webpack_require__("jIfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TheToolbar__ = __webpack_require__("u9q6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InvoiceInformation__ = __webpack_require__("etFT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_invoice_information_model__ = __webpack_require__("taVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_program_constants__ = __webpack_require__("mo7C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BudgetSnapshot__ = __webpack_require__("wpDf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_budget_snapshot_model__ = __webpack_require__("mX93");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BudgetInvoiceScanSnapshot__ = __webpack_require__("itzc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_budget_scan_snapshot_model__ = __webpack_require__("494k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__models_purchaseOrder__ = __webpack_require__("F/un");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__models_settings_model__ = __webpack_require__("9mTN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LineItemsSection__ = __webpack_require__("eN35");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__dialogs_LineItem_LineItemStore__ = __webpack_require__("PJql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HighAllocationSection_vue__ = __webpack_require__("G2an");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_comments__ = __webpack_require__("eXUC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__models_cc_allocation_model_js__ = __webpack_require__("u8vE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__models_bu_and_cc_allocation_model_js__ = __webpack_require__("azIS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__models_category_allocation_model_js__ = __webpack_require__("t2nd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AllocationsSection_AllocationsStore_js__ = __webpack_require__("IowB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__models_batch_settings_js__ = __webpack_require__("hvKh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__models_modals_settings_js__ = __webpack_require__("TBEP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__models_batch_invoice_js__ = __webpack_require__("woxS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__api__ = __webpack_require__("lQbo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__EventsSection_EventsSection_js__ = __webpack_require__("kXYG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__core_charts_helper_formatter_js__ = __webpack_require__("7VNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__core_charts_helper_formatter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__core_charts_helper_formatter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__models_line_item_constants__ = __webpack_require__("xmRq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ReviewEmailModal_vue__ = __webpack_require__("hMCI");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
































var api = new __WEBPACK_IMPORTED_MODULE_29__api__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InvToPay',
  components: {
    legacySteps: __WEBPACK_IMPORTED_MODULE_6__components_LegacyContainer__["a" /* default */],
    TheToolbar: __WEBPACK_IMPORTED_MODULE_7__components_TheToolbar__["a" /* default */],
    invoiceInformation: __WEBPACK_IMPORTED_MODULE_8__InvoiceInformation__["a" /* default */],
    budgetSnapshot: __WEBPACK_IMPORTED_MODULE_11__BudgetSnapshot__["a" /* default */],
    lineItemsSection: __WEBPACK_IMPORTED_MODULE_17__LineItemsSection__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_20__components_comments__["a" /* default */],
    highAllocationSection: __WEBPACK_IMPORTED_MODULE_19__HighAllocationSection_vue__["a" /* default */],
    budgetScanSnapshot: __WEBPACK_IMPORTED_MODULE_13__BudgetInvoiceScanSnapshot__["a" /* default */],
    Grid: __WEBPACK_IMPORTED_MODULE_28__components_Grid__["a" /* default */],
    ReviewEmailModal: __WEBPACK_IMPORTED_MODULE_33__ReviewEmailModal_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off('checkEoNumber');
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on('checkEoNumber', this.handleSupplierStatus);
    this.batch = utils.copy(__WEBPACK_IMPORTED_MODULE_25__models_batch_settings_js__["a" /* default */]);
    this.onCreated();
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off('zipEmailSent');
    __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on('zipEmailSent', function () {
      _this.$notifications.notify({
        message: "Email has been sent to the supplier!",
        type: 'info',
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    });
  },
  activated: function activated() {
    this.submitDisabled = false;
    if (this.createdWasCalled === false) {
      this.initInvoice();
    }
  },
  deactivated: function deactivated() {
    this.onDeactivated();
  },
  beforeLeave: function beforeLeave() {
    if (!this.purchaseOrderInitialModel && !this.purchaseOrder) return true;
    var poValid = this.validatePurchaseOrderBeforeLeave();
    var invoiceValid = this.validateInvoiceBeforeLeave();
    var valid = poValid && invoiceValid;
    if (this.batch.invoices.length > 0 && !this.batch.submitAllInvoices) {
      // TODO: maybe use another message !?
      valid = false;
    }
    return valid;
  },
  data: function data() {
    return {
      showReviewEmailModal: false,
      reviewEmailContent: '',
      cancelClicked: false,
      paymentInvoiceId: 0,
      programId: 0,
      duplicateInvoices: [],
      showDuplicateInvoiceStep1: false,
      showDuplicateInvoiceStep2: false,
      allowDuplicateInvoices: false,
      showOverBudgetWarning: false,
      showOverBudgetWarningBeforeSendingToScan: false,
      showSupplierZipCodeWarning: false,
      overBudgetWarningBeforeSendingToScanWasAccepted: false,
      supplierZipCodeWarningWasAccepted: false,
      showPendingScanningWarning: false,
      showDifferentAmountWarning: false,
      showUnitPriceAtZeroWarning: false,
      showBudgetAlmostUsedNotification: false,
      overBudgetModel: {
        Context: ''
      },
      invoiceInformationInitialModel: {},
      purchaseOrderInitialModel: {},
      invoiceInformationModel: __WEBPACK_IMPORTED_MODULE_9__models_invoice_information_model__["a" /* default */],
      purchaseOrder: __WEBPACK_IMPORTED_MODULE_15__models_purchaseOrder__["a" /* default */],
      settingsModel: __WEBPACK_IMPORTED_MODULE_16__models_settings_model__["a" /* default */],
      budgetSnapshotModel: __WEBPACK_IMPORTED_MODULE_12__models_budget_snapshot_model__["a" /* default */],
      budgetScanSnapshotModel: __WEBPACK_IMPORTED_MODULE_14__models_budget_scan_snapshot_model__["a" /* default */],
      ccAllocations: null,
      pairsAllocations: null,
      categoriesAllocations: null,
      costCentersForScan: null,
      pairsForScan: null,
      activeStep: {},
      tabs: [],
      loading: true,
      dependencies: {
        api: this.api,
        loggedInUserID: 0,
        useSavingsFields: false
      },
      showValidationError: false,
      validationErrorTitle: '',
      validationTitle: '',
      useHighLevelAllocation: null,
      currencyCode: 'USD',
      approvalCheckboxOptions: [{
        label: 'I approve the submission of this invoice',
        status: false
      }],
      additionalInvoiceConfirmationOptions: [{
        status: false
      }],
      approvalCheckboxError: false,
      approvalNoteError: false,
      additionalInvoiceConfirmationError: false,
      InvoiceAmount: 0,
      VATAmount: 0,
      eventsSectionData: null,
      notInvoicedAmount: null,
      createdWasCalled: false,
      submitDisabled: false,
      decouplingSettings: [],
      initData: {},
      user: {},
      poWasLoaded: false,
      batch: __WEBPACK_IMPORTED_MODULE_25__models_batch_settings_js__["a" /* default */],
      batchGridModel: __WEBPACK_IMPORTED_MODULE_27__models_batch_invoice_js__["a" /* default */],
      modals: __WEBPACK_IMPORTED_MODULE_26__models_modals_settings_js__["a" /* default */],
      submitAfterConfirmation: false,
      countries: [],
      supplierCountry: {},
      showCountryMissing: false,
      checkZipMatches: false,
      isEvedSupplier: false
    };
  },
  computed: {
    getBatchGridModel: function getBatchGridModel() {
      return __WEBPACK_IMPORTED_MODULE_27__models_batch_invoice_js__["a" /* default */].get(this.$user.$.settings);
    },
    divisionLabel: function divisionLabel() {
      if (this.settingsModel.CompanySettings.EditingInvoiceScan) {
        return this.initData.sender.company.DivisionLabel;
      }
    },
    getBatchPopupMessage: function getBatchPopupMessage() {
      var msg = 'All selected invoices will be submitted';
      if (this.settingsModel.CompanySettings.AllowInvoiceScanning) {
        msg += ' and will be scanned in 1 business day.';
      }
      msg += '. Any unchecked invoices will be saved as drafts.';
      return msg;
    },
    noOfDraftInvoicesInBatch: function noOfDraftInvoicesInBatch() {
      return this.batch.invoices.length - (this.batch.selectedInvoices || []).length;
    },
    noOfInvoicesToSubmit: function noOfInvoicesToSubmit() {
      return this.batch.invoices.length - this.noOfDraftInvoicesInBatch;
    },
    getSubtitle: function getSubtitle() {
      return this.settingsModel && this.settingsModel.CompanySettings && this.settingsModel.CompanySettings.EditingInvoiceScan ? this.invoiceInformationModel.InvoiceNumber : ' ';
    },
    programLabel: function programLabel() {
      return global.app.$user.sessionSettings.CompanySettings.ProgramLabel.toLowerCase();
    },
    showCommentsBtn: function showCommentsBtn() {
      return this.settingsModel && this.settingsModel.CompanySettings && this.settingsModel.CompanySettings.EditingInvoiceScan === false;
    },
    eventsSectionObj: function eventsSectionObj() {
      if (this.eventsSectionData === null) {
        this.eventsSectionData = new __WEBPACK_IMPORTED_MODULE_30__EventsSection_EventsSection_js__["a" /* default */](this.dependencies);
      }
      return this.eventsSectionData;
    },
    showSaveBtn: function showSaveBtn() {
      return (this.isCreateInvoice() || this.settingsModel.CompanySettings.EditingInvoiceScan === true || this.invoiceInformationModel.IsDraft) && this.settingsModel.CompanySettings.AllowInvoiceScanning === false && !this.isP2PInvoice && this.batch.invoices.length === 0;
    },
    showAddAnotherBtn: function showAddAnotherBtn() {
      return this.paymentInvoiceId <= 0;
    },
    showSubmitBatchBtn: function showSubmitBatchBtn() {
      return this.batch.invoices.length > 0 && this.paymentInvoiceId <= 0;
    },
    showLineItems: function showLineItems() {
      return this.isP2PInvoiceWithAddEditItems || !this.isP2PInvoice && this.purchaseOrder.PO.programDetails.uniqueId && this.purchaseOrder.PO.programDetails.uniqueId !== __WEBPACK_IMPORTED_MODULE_32__models_line_item_constants__["a" /* default */].defaultUniqueId;
    },
    isBeforeSendingToScan: function isBeforeSendingToScan() {
      return !this.isP2PInvoice && this.settingsModel.CompanySettings.AllowInvoiceScanning === true;
    },
    canAddLineItems: function canAddLineItems() {
      return this.useHighLevelAllocation === false && this.settingsModel.CompanySettings.AllowInvoiceScanning === false || this.isP2PInvoiceWithAddEditItems;
    },
    showCCAllocations: function showCCAllocations() {
      var showCCs = false;
      if (!this.isCreateInvoice()) {
        showCCs = this.ccAllocations && this.ccAllocations.AllocationList.length !== 0 || this.ccAllocations.WasReset || this.ccAllocations.AllocationList.length === 0 && this.ccAllocations.GridModel['*Name'].options.length !== 0;
      } else {
        showCCs = this.settingsModel.CompanySettings.HasCostCenter && !this.settingsModel.CompanySettings.UseBusinessUnitAndCostCenterMapping && this.ccAllocations && this.ccAllocations.AllocationList.length !== 0 || this.ccAllocations.WasReset;
      }
      return showCCs;
    },
    showPairsAllocations: function showPairsAllocations() {
      var showPairs = false;
      if (!this.isCreateInvoice()) {
        showPairs = this.pairsAllocations && this.pairsAllocations.AllocationList.length !== 0 || this.pairsAllocations.WasReset || this.pairsAllocations.AllocationList.length === 0 && this.pairsAllocations.GridModel['*Name'].options.length !== 0;
      } else {
        showPairs = this.settingsModel.CompanySettings.UseBusinessUnitAndCostCenterMapping && this.pairsAllocations && this.pairsAllocations.AllocationList.length !== 0 || this.pairsAllocations.WasReset;
      }
      return showPairs;
    },
    showCategoryAllocations: function showCategoryAllocations() {
      return this.settingsModel.CompanySettings.AllocateCategories;
    },
    isP2PInvoice: function isP2PInvoice() {
      return this.invoiceInformationModel.InvoiceWorkflow && this.invoiceInformationModel.InvoiceWorkflow.indexOf('P2PInvoice') !== -1;
    },
    isP2PInvoiceWithAddEditItems: function isP2PInvoiceWithAddEditItems() {
      // allowed actions: edit items, add/edit taxes
      return this.isP2PInvoice && this.settingsModel.CompanySettings.AllowEditItem;
    },
    showAdditionalInvoiceConfirmation: function showAdditionalInvoiceConfirmation() {
      return this.settingsModel.CompanySettings.RequireAdditionalInvoiceConfirmation && this.settingsModel.CompanySettings.EditingInvoiceScan === false;
    },
    maxInvoiceAmount: function maxInvoiceAmount() {
      return this.isCreateInvoice() ? this.notInvoicedAmount : this.invoiceInformationInitialModel.InvoiceAmount + this.notInvoicedAmount;
    },
    categRefIdRequired: function categRefIdRequired() {
      return this.settingsModel.CompanySettings.IsRequiredCategRefID;
    },
    getDecouplingSettings: function getDecouplingSettings() {
      return this.decouplingSettings;
    }
  },
  watch: {
    'invoiceInformationModel.SupplierZipCode': 'checkIfZipMatches',
    'invoiceInformationModel.Supplier.SupplierZIP': 'checkIfZipMatches'
  },
  methods: {
    onCreated: function onCreated() {
      var _this2 = this;
      this.createdWasCalled = true;
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.CHANGE_ALLOCATION);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.CHANGE_ALLOCATION, function (e) {
        if (e.data && e.data.Type && e.data.Allocation) {
          _this2.updateAllocationModel(e.data.Type, e.data.Allocation, e.data.ValidAllocations);
        }
        _this2.updatePOItemsAfterAllocationChange();
      });
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.ADD_CC_FOR_SCAN);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.ADD_CC_FOR_SCAN, this.updateAllocationForScan);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.PROGRAM_SELECTED);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.PROGRAM_SELECTED, function (e) {
        // update program
        var programDetails = JSON.parse(e.data.ProgramDetails);
        if (programDetails.CurrencyCode) {
          _this2.currencyCode = programDetails.CurrencyCode;
        }
        var programUniqueId = programDetails.UniqueId;
        _this2.programId = programDetails.ProgramID;
        if (_this2.purchaseOrder && _this2.purchaseOrder.PO) {
          if (_this2.purchaseOrder.PO.programDetails) {
            _this2.purchaseOrder.PO.programDetails.uniqueId = programUniqueId;
            if (programDetails.CurrencyCode) {
              _this2.purchaseOrder.PO.programDetails.currencyCode = programDetails.CurrencyCode;
            }
            // i2p and bu/cc allocation
            _this2.purchaseOrder.PO.events[0].uniqueId = e.data.EventKey;
          }
          _this2.purchaseOrder.PO.allocateProcessingFeeToEveryCostCenter = e.data.AllocateProcessingFeeToEveryCostCenter;
        }

        // update budgetSnapshot
        var budgetSnapshotInfo = JSON.parse(e.data.BudgetSnapshotInfo);
        budgetSnapshotInfo.initDataForEdit = true;
        budgetSnapshotInfo.ProgramIsSelected = true;
        budgetSnapshotInfo.useHighLevelAllocation = _this2.useHighLevelAllocation;
        if (_this2.invoiceInformationModel && _this2.invoiceInformationModel.CurrencyCode) {
          budgetSnapshotInfo.InvoiceCurrencyCode = _this2.invoiceInformationModel.CurrencyCode;
        }
        if (e.data.InvoiceWorkflowStr) {
          _this2.invoiceInformationModel.InvoiceWorkflow = e.data.InvoiceWorkflowStr;
          budgetSnapshotInfo.InvoiceWorkflow = e.data.InvoiceWorkflowStr;
          if (_this2.isP2PInvoice) {
            _this2.useHighLevelAllocation = false;
            budgetSnapshotInfo.useHighLevelAllocation = false;
            _this2.invoiceInformationModel.UseHighLevelAllocation = false;
          }
        }
        _this2.budgetSnapshotModel = budgetSnapshotInfo;

        // when the program is changed all the items will be deleted
        if (_this2.purchaseOrder && _this2.purchaseOrder.PO && _this2.purchaseOrder.PO.events && _this2.purchaseOrder.PO.events[0]) {
          _this2.purchaseOrder.PO.events[0].lineItems = [];
          if (!_this2.invoiceInformationModel.isEditInit) {
            _this2.recalculatePO();
          }
        }
        if (e.data.BillTo && e.data.BillTo.company) {
          _this2.setBillToData(e.data.BillTo.company);
        }
        if (e.data.POTerms) {
          _this2.setPOTerms(e.data.POTerms);
        }
        _this2.invoiceInformationModel.UseSavingsFields = e.data.UseSavingsFields;
        _this2.additionalInvoiceConfirmationOptions = [{
          status: false,
          label: e.data.AdditionalInvoiceConfirmationText
        }];
        if (e.data.ApprovalNotePlaceholder) {
          _this2.invoiceInformationModel.ApproveNote = e.data.ApprovalNotePlaceholder;
          _this2.settingsModel.CompanySettings.ApprovalNotePlaceholder = e.data.ApprovalNotePlaceholder;
        }
        if (_this2.useHighLevelAllocation) {
          _this2.setHighLevelComboAndGridItems(e.data.InvoiceCostCenters, e.data.InvoiceCategories, e.data.InvoiceBuAndCcPairs, e.data.ProgramCostCenters, e.data.ProgramCategories, e.data.ProgramBuAndCcPairs);
        }
      });
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.VALIDATION_COMPLETED);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.VALIDATION_COMPLETED, function (e) {
        if (e.data.validInvoice && (_this2.cancelClicked || e.data.gotoNextTab)) {
          _this2.cancelInvoice();
        }
      });
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.DUE_DATE_COMPUTED_ON_INIT);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.DUE_DATE_COMPUTED_ON_INIT, function (e) {
        if (e.data.dueDate) {
          _this2.invoiceInformationInitialModel.DueDate = e.data.dueDate;
        }
      });
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.INVOICE_AMOUNT_CHANGED);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.INVOICE_AMOUNT_CHANGED, function (e) {
        if (e.data && !isNaN(e.data.amount)) {
          _this2.InvoiceAmount = Number(e.data.amount);
          _this2.supplierZipCodeWarningWasAccepted = false;
        }
        if (_this2.isP2PInvoice) {
          _this2.invoiceInformationModel.InvoiceAmount = Number(e.data.amount);
          _this2.notInvoicedAmount = e.data.notInvoicedAmount;
          _this2.invoiceInformationModel.NotInvoicedAmount = e.data.notInvoicedAmount;
          _this2.updateSnaphot();
        }
      });
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.INVOICE_INITIAL_TOTAL_AMOUNT_CHANGED);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.INVOICE_INITIAL_TOTAL_AMOUNT_CHANGED, function (e) {
        if (e.data.amount) {
          _this2.invoiceInformationModel.InitialTotalAmount = Number(e.data.amount);
          _this2.overBudgetWarningBeforeSendingToScanWasAccepted = false;
          _this2.supplierZipCodeWarningWasAccepted = false;
        }
      });
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.VAT_AMOUNT_CHANGED);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.VAT_AMOUNT_CHANGED, function (e) {
        if (e.data && !isNaN(e.data.vatgstAmount)) {
          _this2.VATAmount = Number(e.data.vatgstAmount);
          _this2.overBudgetWarningBeforeSendingToScanWasAccepted = false;
          _this2.supplierZipCodeWarningWasAccepted = false;
        }
      });
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.REMOVE_P2P_PO);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.REMOVE_P2P_PO, function (e) {
        if (_this2.purchaseOrder.PO) {
          _this2.purchaseOrder.PO.uniqueId = '';
        }
      });
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.SUPPLIER_COUNTRY_CONFIRMED);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.SUPPLIER_COUNTRY_CONFIRMED, this.onSupplierCountryConfirmed);
      this.initInvoice();
    },
    onDeactivated: function onDeactivated() {
      this.submitDisabled = false;
      this.cancelClicked = false;
      this.useHighLevelAllocation = null;
      this.createdWasCalled = false;
      this.batch.addAnotherInvoice = false;
      this.batch.submitAllInvoices = false;
      this.senderOnInit = null;
      this.itemsOnInit = null;
      this.initData = {};
      this.poWasLoaded = false;
      this.countries = [];
      this.supplierCountry = {};
      this.showCountryMissing = false;
      this.clearTabs();
      this.resetJSONmodel();
      this.resetDuplicateInvoice();
    },
    initInvoice: function initInvoice() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this3.$nextTick(function () {
                _this3.resetJSONmodel();
                _this3.useHighLevelAllocation = null;
                _this3.programId = 0;
                _this3.highlightTabs();
                _this3.loading = true;

                // should not be included in resetJSONmodel()
                if (_this3.$route.query.from !== 'batch') {
                  _this3.batch.invoices = [];
                  _this3.batch.selectedInvoices = null;
                }
                _this3.initUploadInvoice().then(function (r) {
                  _this3.initData = r.data;
                  _this3.useHighLevelAllocation = _this3.initData.useHighLevelAllocation;
                  _this3.paymentInvoiceId = _this3.initData.paymentInvoiceId;

                  // settings
                  if (_this3.initData.settings) {
                    _this3.settingsModel.CompanySettings = _this3.initData.settings;
                    _this3.additionalInvoiceConfirmationOptions[0].label = _this3.settingsModel.CompanySettings.AdditionalInvoiceConfirmationText;
                  }

                  // current user data
                  if (_this3.initData.user && _this3.initData.user !== '') {
                    _this3.user = _this3.initData.user;
                    _this3.dependencies.loggedInUserID = _this3.user.buyerUserID;
                    _this3.dependencies.canEditCategRefId = _this3.user.canEditCategRefId;
                  }

                  // workflow
                  if (_this3.initData.invoice) {
                    _this3.invoiceInformationModel.InvoiceWorkflow = _this3.initData.invoice.InvoiceWorkflow;
                  }
                  _this3.loadInitialData();
                });
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    loadPurchaseOrder: function loadPurchaseOrder(PO, items) {
      if (this.isP2PInvoiceWithAddEditItems) {
        // p2p decoupling
        if (this.paymentInvoiceId > 0) {
          // edit
          PO.events = this.updateQtyAndUnitsFromInvoiceOnEdit(PO.events, items);
        } else {
          // create
          PO.events = this.updateQtyAndUnitsFromPOonCreate(PO.events, items);
        }
        PO.events = this.store().getEventsWithOrderedLineItems(PO.events);
      } else if (this.paymentInvoiceId > 0 && Array.isArray(items)) {
        // i2p: update InvoiceItemKey on PO items
        PO.events = this.store().updateItemsForI2PInvoiceOnEdit(PO.events, items);
      }
      this.purchaseOrder.PO = PO;
      this.poWasLoaded = true;
    },
    loadInitialData: function loadInitialData() {
      var data = this.initData;
      if (data.invoice) {
        for (var key in data.invoice) {
          if (data.invoice.hasOwnProperty(key)) {
            this.invoiceInformationModel[key] = data.invoice[key];
          }
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(data.program) === 'object') {
        this.programId = data.program.ProgramID;
        this.invoiceInformationModel.ProgramID = data.program.ProgramID;
        this.invoiceInformationModel.ProgramName = data.program.ProgramName;
        this.invoiceInformationModel.DivisionID = data.program.DivisionID;
        this.invoiceInformationModel.BusinessUnitID = data.program.BusinessUnitID;
        this.invoiceInformationModel.DivisionName = data.program.DivisionName;
        this.invoiceInformationModel.ProgramCurrencyCode = data.program.ProgramCurrencyCode;

        // SPRT-18874: the screen can be opened straight onto a program without ever using the picker
        // (shortcut link, bookmark, back navigation), so flag a cancelled program on load too. The backend
        // sends this only for a program the invoice is not already on, so opening an existing invoice whose
        // program was cancelled afterwards is never flagged — that invoice stays editable.
        if (data.program.IsProgramCancelled === true) {
          this.invoiceInformationModel.Errors.ProgramCancelled = true;
          this.showCancelledProgramError();
        }
      }
      if (this.$route.query.fusionPoId) {
        this.invoiceInformationModel.POid = this.$route.query.fusionPoId;
      }
      if (data.poTerms) {
        this.setPOTerms(data.poTerms);
      }
      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(data.supplier) === 'object') {
        this.invoiceInformationModel.Supplier.VendorID = data.supplier.SupplierID;
        this.invoiceInformationModel.Supplier.VendorUserID = data.supplier.SupplierUserID;
        this.invoiceInformationModel.Supplier.SupplierVCI = data.supplier.SupplierVCI;
        this.invoiceInformationModel.Supplier.CountryName = data.supplier.SupplierCountryName;
        this.invoiceInformationModel.SupplierId = data.supplier.SupplierID;
        this.invoiceInformationModel.SupplierUserId = data.supplier.SupplierUserID;
        this.invoiceInformationModel.MyVendorTempEONumber = data.supplier.MyVendorTempEONumber;
        this.invoiceInformationModel.SupplierName = data.supplier.SupplierName;
        this.invoiceInformationModel.isEditInit = true;
        if (data.supplier.SupplierName) {
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.ADDED_NEW_SUPPLIER, {
              SupplierInfoVM: {
                SupplierName: data.supplier.SupplierName,
                SupplierContactName: data.supplier.SupplierContactName,
                VatGstId: data.supplier.VatGstId,
                EmailAddress: data.supplier.SupplierEmail,
                SupplierPhone: data.supplier.SupplierPhone,
                VendorID: data.supplier.SupplierID,
                VendorUserID: data.supplier.SupplierUserID,
                DiscountPaymentTermID: data.invoice && data.invoice.DiscountPaymentTermID,
                DiscountName: data.invoice && data.invoice.DiscountName,
                DiscountDisplayName: data.invoice && data.invoice.DiscountDisplayName,
                DiscountDaysNo: data.invoice && data.invoice.DiscountDaysNo,
                SupplierAddress1: data.supplier.SupplierAddress1,
                SupplierAddress2: data.supplier.SupplierAddress2,
                SupplierCity: data.supplier.SupplierCity,
                SupplierState: data.supplier.SupplierState,
                SupplierRegion: data.supplier.SupplierRegion,
                SupplierZIP: data.supplier.SupplierZIP,
                CountryName: data.supplier.SupplierCountryName,
                VendorType: data.supplier.VendorType,
                HasDefaultImmediatePayment: data.supplier.HasDefaultImmediatePayment,
                WithholdingTaxPercent: data.supplier.WithholdingTaxPercent,
                Currencies: data.supplier.Currencies
              },
              CardInfo: {
                logoPath: ' ',
                Logo: data.supplier.SupplierLogo
              },
              VendorId: data.supplier.SupplierID,
              VendorVCI: data.supplier.SupplierVCI > 0 ? data.supplier.SupplierVCI : data.supplier.MyVendorTempEONumber,
              VendorUserID: data.supplier.SupplierUserID,
              IsInitSupplier: true,
              InvoiceCurrencyCode: data.invoice.CurrencyCode
            });
          }, 200);
        }
      }
      if (data.invoice) {
        this.invoiceInformationModel.PaymentInvoiceId = this.paymentInvoiceId;
        this.invoiceInformationModel.InvoiceDate = data.invoice.InvoiceDate === '' ? null : data.invoice.InvoiceDate;
        this.invoiceInformationModel.DueDate = data.invoice.DueDate === '' ? null : data.invoice.DueDate;
        this.invoiceInformationModel.InvoiceAmount = data.invoice.InvoiceAmount || this.invoiceInformationModel.InvoiceAmount;
        this.invoiceInformationModel.VATGSTAmount = data.invoice.InvoiceVATGSTAmount || this.invoiceInformationModel.VATGSTAmount;
        this.invoiceInformationModel.POid = data.invoice.POId || this.$route.query.fusionPoId;
        this.currencyCode = data.invoice.CurrencyCode;
        this.dependencies.useSavingsFields = data.invoice.UseSavingsFields;
        this.notInvoicedAmount = data.invoice.NotInvoicedAmount;
        this.invoiceInformationModel.IsFromEmailForScanning = data.invoice.IsFromEmailForScanning || false;
        this.InvoiceAmount = data.invoice.InvoiceAmount || this.invoiceInformationModel.InvoiceAmount;
        this.VATAmount = data.invoice.InvoiceVATGSTAmount || this.invoiceInformationModel.VATGSTAmount;
        if (data.invoice.Attachments && data.invoice.Attachments.length > 0) {
          this.invoiceInformationModel.Attachments = data.invoice.Attachments;
        } else {
          this.invoiceInformationModel.Attachments = [];
        }
        if (this.settingsModel && this.settingsModel.CompanySettings) {
          this.invoiceInformationModel.ApproveNote = this.settingsModel.CompanySettings.ApprovalNotePlaceholder || '';
        }

        // used timeout to make sure invoiceInformation.created is initiated and mapExistingItems.can be called
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.MAP_INVOICE_INFORMATION_FIELDS);
        }, 50);
      }

      // IMPORTANT: remove after removing from backend the save/submit/get of the PO
      if (data.purchaseOrder && data.purchaseOrder !== '') {
        this.loadPurchaseOrder(JSON.parse(data.purchaseOrder), data.invoice.Items);
      } else if (/* !this.poWasLoaded && */__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(data.program) === 'object') {
        this.purchaseOrder.PO.programDetails.uniqueId = data.program.UniqueId;
        this.purchaseOrder.PO.programDetails.internalProgramId = data.program.InternalProgramId;
        this.purchaseOrder.PO.programDetails.name = data.program.ProgramName;
        this.purchaseOrder.PO.programDetails.isNewProgram = false;
        this.purchaseOrder.PO.programDetails.currencyCode = data.program.ProgramCurrencyCode;
        if (data.program.EventUniqueId && this.purchaseOrder.PO.events && this.purchaseOrder.PO.events[0]) {
          // i2p and bu/cc allocation
          this.purchaseOrder.PO.events[0].uniqueId = data.program.EventUniqueId;
        }
      }
      if (this.purchaseOrder && this.purchaseOrder.PO && this.isCreateInvoice()) {
        this.purchaseOrder.PO.allocateProcessingFeeToEveryCostCenter = this.settingsModel.CompanySettings.AllocateProcessingFeeToEveryCostCenter;
      }
      if (data.sender) {
        this.invoiceInformationModel.CreatedByInfo = {
          Name: data.sender.user.FirstName + ' ' + data.sender.user.LastName,
          Email: data.sender.user.Email,
          Phone: data.sender.user.PhoneNumber
        };
        this.setBillToData(data.sender.company);
        this.purchaseOrder.PO.preparedBy = {
          email: data.sender.user.Email,
          firstName: data.sender.user.FirstName,
          lastName: data.sender.user.LastName,
          office: data.sender.user.PhoneNumber,
          mobile: data.sender.user.Mobile
        };
        this.purchaseOrder.PO.companyInfo = {
          vendorId: data.sender.company.VendorID,
          name: data.sender.company.Name,
          logo: data.sender.company.Logo,
          address: {
            address1: data.sender.company.Address,
            address2: data.sender.company.Address2,
            city: data.sender.company.City,
            state: data.sender.company.State,
            region: data.sender.company.Region,
            zipCode: data.sender.company.ZipCode,
            country: data.sender.company.Country
          }
        };
      }
      if (data.budgetSnapshotInfo) {
        var snapshot = data.budgetSnapshotInfo;
        snapshot.initDataForEdit = true;
        snapshot.useHighLevelAllocation = this.useHighLevelAllocation;
        snapshot.InvoiceWorkflow = data.invoice.InvoiceWorkflow;
        if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(data.program) === 'object') {
          snapshot.ProgramIsSelected = true;
        }
        this.budgetSnapshotModel = snapshot;
      }
      if (data.budgetInvoiceScanSnapshot) {
        this.budgetScanSnapshotModel = data.budgetInvoiceScanSnapshot;
      }

      // TODO: update program and supplier
      if (this.useHighLevelAllocation) {
        this.initHighLevelAllocation();
        if (data.invoiceCostCenters || data.invoiceCategories || data.invoiceBuAndCcPairs) {
          this.setHighLevelComboAndGridItems(data.invoiceCostCenters, data.invoiceCategories, data.invoiceBuAndCcPairs, data.programCostCenters, data.programCategories, data.programBuAndCcPairs);
        }
        this.recalculatePO();
      }
      if (data.scanAllocationOption || data.hasMultipleAllocation) {
        this.invoiceInformationModel.allocationType = data.allocationType;
        this.invoiceInformationModel.scanAllocationOption = data.scanAllocationOption;
        this.invoiceInformationModel.hasMultipleAllocation = data.hasMultipleAllocation;
      }
      this.invoiceInformationModel.PaymentTypeID = this.invoiceInformationModel.PaymentTypeID || data.defaultPaymentType.Id;
      this.invoiceInformationModel.PaymentType = this.invoiceInformationModel.PaymentType || data.defaultPaymentType.Value;
      this.invoiceInformationModel.DiscountPaymentTermID = data.defaultDiscount.Key;
      this.invoiceInformationModel.DiscountDisplayName = data.defaultDiscount.Value;
      this.invoiceInformationModel.DiscountName = data.defaultDiscount.Name;
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.MAP_DEFAULT_PAYMENT_TYPE_DISCOUNT);
      this.cacheInitialData();
    },
    getDecouplingCompanySettings: function getDecouplingCompanySettings() {
      return {
        AllowExceedPOQty: this.isP2PInvoice && this.settingsModel.CompanySettings.AllowEditItem && this.settingsModel.CompanySettings.AllowInvoiceToExceedPOQty,
        ExcludeTaxes: this.isP2PInvoice && this.settingsModel.CompanySettings.AllowEditItem && this.settingsModel.CompanySettings.ExcludeTaxesFromPOThreshold
      };
    },
    updateQtyAndUnitsFromPOonCreate: function updateQtyAndUnitsFromPOonCreate(poEvents, invoicedItems) {
      var settings = this.getDecouplingCompanySettings();
      this.decouplingSettings = this.store().getDecouplingSettingsPerItem(poEvents, invoicedItems, settings);
      return this.store().updateEventsOnCreate(poEvents, invoicedItems, this.decouplingSettings);
    },
    updateQtyAndUnitsFromInvoiceOnEdit: function updateQtyAndUnitsFromInvoiceOnEdit(poEvents, invoiceItems) {
      var settings = this.getDecouplingCompanySettings();
      this.decouplingSettings = this.store().getDecouplingSettingsPerItem(poEvents, invoiceItems, settings);
      return this.store().getEventsWithChangesFromInvoice(poEvents, invoiceItems, this.decouplingSettings);
    },
    store: function store() {
      return new __WEBPACK_IMPORTED_MODULE_18__dialogs_LineItem_LineItemStore__["a" /* default */](this.api);
    },
    allocationsStore: function allocationsStore() {
      return new __WEBPACK_IMPORTED_MODULE_24__AllocationsSection_AllocationsStore_js__["a" /* default */](this.api);
    },
    back: function back() {
      if (this.mustSave) {
        this.save();
      }
    },
    isCreateInvoice: function isCreateInvoice() {
      return parseInt(this.$route.query.invoiceId) <= 0 || isNaN(parseInt(this.$route.query.invoiceId));
    },
    initHighLevelAllocation: function initHighLevelAllocation() {
      this.ccAllocations = {
        Type: 'CostCenters',
        AllocationList: [],
        SelectionList: [],
        GridTitle: 'Cost Center',
        GridModel: __WEBPACK_IMPORTED_MODULE_21__models_cc_allocation_model_js__["a" /* default */].get([], []),
        InvoiceInformation: {
          programId: this.invoiceInformationModel.ProgramID
        },
        Label: 'Cost Center',
        WasReset: false,
        TotalPercent: 0,
        ValidAllocations: true
      };
      this.pairsAllocations = {
        Type: 'Pairs',
        AllocationList: [],
        SelectionList: [],
        GridTitle: 'Business Unit & Cost Center',
        GridModel: __WEBPACK_IMPORTED_MODULE_22__models_bu_and_cc_allocation_model_js__["a" /* default */].get([], []),
        InvoiceInformation: {
          programId: this.invoiceInformationModel.ProgramID
        },
        Label: 'Pair',
        WasReset: false,
        TotalPercent: 0,
        ValidAllocations: true
      };
      this.categoriesAllocations = {
        Type: 'Categories',
        AllocationList: [],
        SelectionList: [],
        GridTitle: 'Category',
        GridModel: __WEBPACK_IMPORTED_MODULE_23__models_category_allocation_model_js__["a" /* default */].get([], [], this.user.canEditCategRefId),
        InvoiceInformation: {
          programId: this.invoiceInformationModel.ProgramID
        },
        Label: 'Category',
        WasReset: this.settingsModel.CompanySettings.AllocateCategories,
        TotalPercent: 0,
        ValidAllocations: true
      };
    },
    setHighLevelComboAndGridItems: function setHighLevelComboAndGridItems(invCC, invCategories, invPairs, pgCC, pgCategories, pgPairs) {
      this.ccAllocations.AllocationList = invCC;
      if (invCC.length === 1) {
        this.ccAllocations.AllocationList.map(function (item) {
          item.Percent = 100;
          return item;
        });
      }
      this.ccAllocations.GridModel['*Name'].options = pgCC;
      this.ccAllocations.SelectionList = pgCC;
      this.ccAllocations.GridModel['*Name'].selectedOptions = invCC;
      this.ccAllocations.InvoiceInformation.programId = this.invoiceInformationModel.ProgramID;
      this.ccAllocations.WasReset = invCC.length > 0;
      this.pairsAllocations.AllocationList = invPairs;
      if (invPairs.length === 1) {
        this.pairsAllocations.AllocationList.map(function (item) {
          item.Percent = 100;
          return item;
        });
      }
      this.pairsAllocations.GridModel['*Name'].options = pgPairs;
      this.pairsAllocations.SelectionList = pgPairs;
      this.pairsAllocations.GridModel['*Name'].selectedOptions = invPairs;
      this.pairsAllocations.InvoiceInformation.programId = this.invoiceInformationModel.ProgramID;
      this.pairsAllocations.WasReset = invPairs.length > 0;
      this.categoriesAllocations.AllocationList = invCategories;
      this.categoriesAllocations.GridModel['*Name'].options = pgCategories;
      this.categoriesAllocations.SelectionList = pgCategories;
      this.categoriesAllocations.GridModel['*Name'].selectedOptions = invCategories;
      this.categoriesAllocations.InvoiceInformation.programId = this.invoiceInformationModel.ProgramID;
    },
    validateAllocationsTotal: function validateAllocationsTotal() {
      if (this.ccAllocations.WasReset && this.ccAllocations.TotalPercent !== 100 || this.pairsAllocations.WasReset && this.pairsAllocations.TotalPercent !== 100 || this.categoriesAllocations.WasReset && this.categoriesAllocations.TotalPercent !== 100) {
        return false;
      }
      return true;
    },
    validateAllocations: function validateAllocations() {
      var isValid = true;
      if (!this.ccAllocations.ValidAllocations || !this.pairsAllocations.ValidAllocations || !this.categoriesAllocations.ValidAllocations) {
        isValid = false;
      }
      return isValid;
    },
    validatePurchaseOrderBeforeLeave: function validatePurchaseOrderBeforeLeave() {
      var _this4 = this;
      var oldPO = this.purchaseOrderInitialModel;
      var newPO = this.purchaseOrder.PO;

      // line items
      var oldItemKeys = [];
      oldPO && oldPO.events && oldPO.events.length > 0 && oldPO.events.map(function (ev, evindex) {
        ev.lineItems.map(function (item, index) {
          if (item.itemKey) {
            oldItemKeys.push(item.itemKey);
          }
        });
      });
      var lineItemsValid = newPO && newPO.events && newPO.events.length > 0;
      if (lineItemsValid) {
        newPO.events.map(function (newEvent, evindex) {
          var oldEvent = oldPO.events && oldPO.events.filter(function (e) {
            return e.uniqueId === newEvent.uniqueId;
          })[0];
          if (!oldEvent || newEvent.lineItems.filter(function (item) {
            return oldItemKeys.indexOf(item.itemKey) === -1 && item.itemKey;
          }).length !== 0 || newEvent.lineItems.length !== oldEvent.lineItems.length) {
            lineItemsValid = false;
          } else {
            if (newEvent.lineItems.length === oldEvent.lineItems.length) {
              var skipNameValidation = _this4.invoiceInformationModel.UseHighLevelAllocation;
              newEvent.lineItems.forEach(function (nItem, index) {
                var oItem = oldEvent.lineItems[index];
                if (parseInt(nItem.listOrder) !== parseInt(oItem.listOrder) || parseFloat(nItem.total || 0) !== parseFloat(oItem.total || 0) || nItem.isFeeDiscountItem !== oItem.isFeeDiscountItem || (nItem.name || '') !== (oItem.name || '') && !skipNameValidation || (nItem.description || '') !== (oItem.description || '') || (nItem.internalNote || '') !== (oItem.internalNote || '') || parseFloat(nItem.quantity || 0) !== parseFloat(oItem.quantity || 0) || !nItem.isFeeDiscountItem && (parseFloat(nItem.unitPrice || 0) !== parseFloat(oItem.unitPrice || 0) || parseFloat(nItem.units || 0) !== parseFloat(oItem.units || 0) || (nItem.unitType || '') !== (oItem.unitType || '') || (nItem.referenceId || '') !== (oItem.referenceId || '') || (nItem.category || '') !== (oItem.category || '') || parseFloat(nItem.discount || 0) !== parseFloat(oItem.discount || 0) || parseFloat(nItem.discountAmount || 0) !== parseFloat(oItem.discountAmount || 0) || parseFloat(nItem.discountPercent || 0) !== parseFloat(oItem.discountPercent || 0)) || nItem.isFeeDiscountItem && (parseInt(nItem.amountTypeId || 0) !== parseInt(oItem.amountTypeId || 0) || parseFloat(nItem.amountTypeValue || 0) !== parseFloat(oItem.amountTypeValue || 0)) || parseFloat(nItem.totalTaxes || 0) !== parseFloat(oItem.totalTaxes || 0) || parseFloat(nItem.totalFees || 0) !== parseFloat(oItem.totalFees || 0) || parseFloat(nItem.totalTaxesForFees || 0) !== parseFloat(oItem.totalTaxesForFees || 0) || parseFloat(nItem.subtotal || 0) !== parseFloat(oItem.subtotal || 0) || !nItem.costCenterAndBusinessUnit && oItem.costCenterAndBusinessUnit || nItem.costCenterAndBusinessUnit && !oItem.costCenterAndBusinessUnit || (nItem.costCenterAndBusinessUnit.costCenterNo || '') !== (oItem.costCenterAndBusinessUnit.costCenterNo || '') || (nItem.costCenterAndBusinessUnit.costCenterName || '') !== (oItem.costCenterAndBusinessUnit.costCenterName || '') || (nItem.costCenterAndBusinessUnit.businessUnitName || '') !== (oItem.costCenterAndBusinessUnit.businessUnitName || '') || (nItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName || '') !== (oItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName || '') || (nItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey || '') !== (oItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey || '')) {
                  lineItemsValid = false;
                }
              });
            }
          }
        });
      }
      var poValid = oldPO && newPO && oldPO.uniqueId === newPO.uniqueId && oldPO.programDetails.uniqueId === newPO.programDetails.uniqueId && oldPO.supplier && newPO.supplier && oldPO.supplier.email === newPO.supplier.email && lineItemsValid;
      return poValid;
    },
    validateInvoiceBeforeLeave: function validateInvoiceBeforeLeave() {
      var oldInv = this.invoiceInformationInitialModel;
      var newInv = this.invoiceInformationModel;

      // invoice attachments
      var oldAttachments = [];
      oldInv && oldInv.Attachments && oldInv.Attachments.map(function (f, i) {
        oldAttachments.push(f.AttachmentFile);
      });
      var attachmentsValid = newInv && newInv.Attachments && newInv.Attachments.filter(function (f) {
        return oldAttachments.indexOf(f.AttachmentFile) === -1;
      }).length === 0;
      var invoiceValid = oldInv && newInv && oldInv.PaymentTypeID === newInv.PaymentTypeID && new Date(oldInv.InvoiceDate).toDateString() === new Date(newInv.InvoiceDate).toDateString() && new Date(oldInv.DueDate).toDateString() === new Date(newInv.DueDate).toDateString() && attachmentsValid && oldInv.CurrencyCode === newInv.CurrencyCode && (!this.invoiceInformationModel.UseHighLevelAllocation || (+oldInv.InvoiceAmount || 0) === (+newInv.InvoiceAmount || 0) && (+oldInv.VATGSTAmount || 0) === (+newInv.VATGSTAmount || 0));
      return invoiceValid;
    },
    setBillToData: function setBillToData(company) {
      this.purchaseOrder.PO.billTo = {
        companyName: company.Name,
        address: {
          address1: company.Address1,
          address2: company.Address2,
          city: company.City,
          state: company.State,
          region: company.Region,
          zipCode: company.ZipCode,
          country: company.Country,
          vatNo: company.VatNo
        }
      };
    },
    setPOTerms: function setPOTerms(terms) {
      this.purchaseOrder.PO.terms = terms;
    },
    cacheInitialData: function cacheInitialData() {
      this.purchaseOrderInitialModel = utils.copy(this.purchaseOrder.PO);
      this.invoiceInformationInitialModel = utils.copy(this.invoiceInformationModel);
    },
    getInvoiceAmountToValidateAgainstUninvoiced: function getInvoiceAmountToValidateAgainstUninvoiced() {
      var finalInvoiceAmount = this.invoiceInformationModel && Number(this.invoiceInformationModel.InvoiceAmount);
      if (!this.isCreateInvoice()) {
        if (finalInvoiceAmount > 0) {
          // positive amount
          if (finalInvoiceAmount > this.invoiceInformationInitialModel.InvoiceAmount || 0) {
            finalInvoiceAmount -= this.invoiceInformationInitialModel.InvoiceAmount || 0;
          } else {
            finalInvoiceAmount = 0;
          }
        } else if (finalInvoiceAmount < 0) {
          // negative amount
          if (finalInvoiceAmount < this.invoiceInformationInitialModel.InvoiceAmount) {
            finalInvoiceAmount -= this.invoiceInformationInitialModel.InvoiceAmount || 0;
          } else {
            finalInvoiceAmount = 0;
          }
        }
      }
      return finalInvoiceAmount;
    },
    hasAnyPDFAttachment: function hasAnyPDFAttachment() {
      // exclude readonly files
      if (!this.invoiceInformationModel.Attachments || JSON.stringify(this.invoiceInformationModel.Attachments) === JSON.stringify({}) || this.invoiceInformationModel.Attachments.length <= 0) return false;
      var any = false;
      this.invoiceInformationModel.Attachments.map(function (f) {
        if (!f.ReadOnly && f.AttachmentFile.toLowerCase().endsWith('.pdf')) {
          any = true;
        }
      });
      return any;
    },
    isOverBudgetBeforeSendingToScan: function isOverBudgetBeforeSendingToScan() {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var param, r;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this5.invoiceInformationModel.ProgramID === 0 || _this5.invoiceInformationModel.InitialTotalAmount <= 0)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", false);
            case 2:
              param = {
                programId: _this5.invoiceInformationModel.ProgramID,
                invoiceAmount: _this5.invoiceInformationModel.InitialTotalAmount,
                invoiceVatGst: +_this5.invoiceInformationModel.VATGSTAmount,
                currencyCode: _this5.invoiceInformationModel.CurrencyCode
              };
              _context2.next = 5;
              return _this5.api.post(_this5.api.$.invoice.i2p.checkOverBudgetBeforeSendingToScan, param);
            case 5:
              r = _context2.sent;
              if (!(r.data && r.data.IsOverBudget)) {
                _context2.next = 9;
                break;
              }
              _this5.overBudgetAmountBeforeSendingToScan = r.data.OverBudgetAmount;
              return _context2.abrupt("return", true);
            case 9:
              return _context2.abrupt("return", false);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    checkSupplierZipCode: function checkSupplierZipCode() {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var param, r;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!_this6.invoiceInformationModel.SupplierZipCode || !_this6.invoiceInformationModel.Supplier.VendorID || _this6.invoiceInformationModel.Supplier.VendorID <= 0)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", false);
            case 2:
              param = {
                supplierId: _this6.invoiceInformationModel.Supplier.VendorID,
                zipCode: _this6.invoiceInformationModel.SupplierZipCode
              };
              _context3.next = 5;
              return _this6.api.post(_this6.api.$.invoice.checkSupplierZipCode, param);
            case 5:
              r = _context3.sent;
              if (!(r.data && r.data.ZipCodeIsDifferent)) {
                _context3.next = 8;
                break;
              }
              return _context3.abrupt("return", true);
            case 8:
              return _context3.abrupt("return", false);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    checkIfZipMatches: function checkIfZipMatches() {
      if (this.invoiceInformationModel.SupplierZipCode && this.invoiceInformationModel.Supplier.SupplierZIP) {
        this.checkZipMatches = this.invoiceInformationModel.SupplierZipCode.toLowerCase().trim() === this.invoiceInformationModel.Supplier.SupplierZIP.toLowerCase().trim();
      } else if (typeof this.invoiceInformationModel.SupplierZipCode !== 'undefined' && typeof this.invoiceInformationModel.Supplier.SupplierZIP !== 'undefined') {
        this.checkZipMatches = false;
      }
      return this.checkZipMatches;
    },
    reviewEmail: function reviewEmail() {
      try {
        var invoiceId = this.invoiceInformationModel.PaymentInvoiceId;
        this.api.get(this.api.$.invoice.reviewEmail, {
          invoiceId: invoiceId
        });
      } catch (ex) {
        console.error('Error sending email:', ex);
      }
    },
    closeReviewEmailModal: function closeReviewEmailModal() {
      this.showReviewEmailModal = false;
    },
    openReviewEmailModal: function openReviewEmailModal() {
      var _this7 = this;
      try {
        var paymentInvoiceId = this.invoiceInformationModel.PaymentInvoiceId;
        if (!paymentInvoiceId) {
          console.warn('Invoice ID not available');
          return;
        }
        this.api.get("".concat(this.api.$.invoice.reviewEmail, "/").concat(paymentInvoiceId)).then(function (response) {
          _this7.reviewEmailContent = response.data;
          _this7.showReviewEmailModal = true;
        }).catch(function (ex) {
          return console.error('Error getting review email:', ex);
        });
      } catch (ex) {
        console.error('Error getting review email:', ex);
      }
    },
    sendZipMismatchEmail: function sendZipMismatchEmail() {
      try {
        var invoiceId = this.invoiceInformationModel.PaymentInvoiceId;
        this.api.post(this.api.$.invoice.sendZipMismatchEmail, {
          invoiceId: invoiceId
        }).then(function (response) {
          if (response.status === 200) {
            __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('zipEmailSent');
          } else {
            alert('Failed to send email.');
          }
        }).catch(function (error) {
          console.error('Error sending email: ', error);
        });
      } catch (ex) {
        console.error('Error sending email:', ex);
      }
    },
    handleSupplierStatus: function handleSupplierStatus(eo) {
      this.checkIfZipMatches();
      var eoNumber = eo.data;
      if (!eoNumber) {
        this.isEvedSupplier = false;
      } else {
        this.isEvedSupplier = true;
      }
    },
    validate: function validate(submit) {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var validInvoice, finalInvoiceAmount, isPositiveAmount, actionLabel, validationMessageModel, invoiceAmount, _validationMessageModel;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              validInvoice = true; // Program Validation
              if (!_this8.invoiceInformationModel.ProgramID || _this8.invoiceInformationModel.ProgramID <= 0) {
                _this8.invoiceInformationModel.Errors.ProgramMissing = true;
                validInvoice = false;
              }

              // PO Validation
              if (_this8.isP2PInvoice && (!_this8.settingsModel.CompanySettings.AllowInvoiceToExceedPOQty || !_this8.settingsModel.CompanySettings.ExcludeTaxesFromPOThreshold)) {
                if (!_this8.invoiceInformationModel.POid || _this8.invoiceInformationModel.POid <= 0) {
                  _this8.invoiceInformationModel.Errors.POMissing = true;
                  validInvoice = false;
                }

                // Invoice Amount Validation (it must be lower that PO notInvoicedAmount)
                finalInvoiceAmount = _this8.getInvoiceAmountToValidateAgainstUninvoiced();
                isPositiveAmount = _this8.invoiceInformationModel && Number(_this8.invoiceInformationModel.InvoiceAmount) >= 0;
                if (finalInvoiceAmount && !isNaN(_this8.notInvoicedAmount) && (_this8.isCreateInvoice() || finalInvoiceAmount !== 0) && (isPositiveAmount && (finalInvoiceAmount > _this8.notInvoicedAmount || finalInvoiceAmount < 0) || !isPositiveAmount && (finalInvoiceAmount < _this8.notInvoicedAmount || finalInvoiceAmount > 0))) {
                  if (_this8.isP2PInvoiceWithAddEditItems) {
                    if (!_this8.settingsModel.CompanySettings.ExcludeTaxesFromPOThreshold) {
                      _this8.invoiceInformationModel.Errors.InvoiceAmountExceededPOThreshold = true;
                      validInvoice = false;
                    }
                  } else {
                    _this8.invoiceInformationModel.Errors.InvoiceAmountOutOfRange = true;
                    validInvoice = false;
                  }
                }

                // validate qty, units and unit price min/max thresholds
                if (_this8.$refs.lineItemsComp && _this8.$refs.lineItemsComp.$refs.lineItems && _this8.$refs.lineItemsComp.$refs.lineItems[0].validateCells()) {
                  validInvoice = false;
                }
              }

              // Supplier Validation
              if (!_this8.invoiceInformationModel.Supplier.SupplierName) {
                _this8.invoiceInformationModel.Errors.SupplierMissing = true;
                validInvoice = false;
              }

              // Payment Type Validation
              if ((_this8.invoiceInformationModel.PaymentTypeID <= 0 || !_this8.invoiceInformationModel.PaymentType) && submit) {
                _this8.invoiceInformationModel.Errors.PaymentTypeMissing = true;
                validInvoice = false;
              }

              // Invoice Date Validation
              if (!_this8.invoiceInformationModel.InvoiceDate && submit) {
                _this8.invoiceInformationModel.Errors.InvoiceDateMissing = true;
                validInvoice = false;
              }

              // Due Date Validation
              if (!_this8.invoiceInformationModel.DueDate && submit) {
                _this8.invoiceInformationModel.Errors.DueDateMissing = true;
                validInvoice = false;
              }

              // Attachments Validation
              if (_this8.settingsModel.CompanySettings.RequireAttachment && submit && !_this8.hasAnyPDFAttachment()) {
                _this8.invoiceInformationModel.Errors.AttachmentsMissing = true;
                validInvoice = false;
              }

              // Supplier Zip
              if (_this8.invoiceInformationModel.IsRequiredSupplierZipCode && submit && (!_this8.invoiceInformationModel.SupplierZipCode || (_this8.invoiceInformationModel.SupplierZipCode || '').trim() === '')) {
                _this8.invoiceInformationModel.Errors.SupplierZipCodeMissing = true;
                validInvoice = false;
              }

              // Reference No
              if (_this8.$route.query.invoiceId !== '0' || !_this8.settingsModel.CompanySettings.AllowInvoiceScanning || _this8.isP2PInvoice) {
                if (_this8.invoiceInformationModel.ReferenceNoIsRequired && submit && (!_this8.invoiceInformationModel.ReferenceNo || (_this8.invoiceInformationModel.ReferenceNo || '').trim() === '')) {
                  _this8.invoiceInformationModel.Errors.ReferenceNoMissing = true;
                  validInvoice = false;
                }
              }

              // Currency Validation
              if (_this8.invoiceInformationModel.CurrencyID <= 0 || !_this8.invoiceInformationModel.CurrencyCode) {
                _this8.invoiceInformationModel.Errors.InvoiceCurrencyMissing = true;
                validInvoice = false;
              }
              if (_this8.useHighLevelAllocation || _this8.isP2PInvoice) {
                // Invoice Amount Validation
                if (!_this8.invoiceInformationModel.InvoiceAmount || Number(_this8.invoiceInformationModel.InvoiceAmount) === 0) {
                  _this8.invoiceInformationModel.Errors.InvoiceAmountMissing = true;
                  validInvoice = false;
                }
              }

              // Invoice scan - amount validation
              if (!_this8.useHighLevelAllocation && !_this8.isP2PInvoice && _this8.settingsModel.CompanySettings.AllowInvoiceScanning) {
                if (!_this8.settingsModel.CompanySettings.EditingInvoiceScan && !_this8.invoiceInformationModel.InitialTotalAmount || Number(_this8.invoiceInformationModel.InitialTotalAmount) === 0) {
                  _this8.invoiceInformationModel.Errors.InitialTotalAmountMissing = true;
                  validInvoice = false;
                }
              }

              // Approval Checkbox Validation
              if (!_this8.approvalCheckboxOptions[0].status && submit && _this8.settingsModel.CompanySettings.EditingInvoiceScan === false) {
                _this8.approvalCheckboxError = true;
                validInvoice = false;
              } else {
                _this8.approvalCheckboxError = false;
              }

              // Approval Note
              if (_this8.isCreateInvoice() && _this8.settingsModel.CompanySettings.EditingInvoiceScan === false && !_this8.isApprovalNoteValid()) {
                _this8.approvalNoteError = true;
                validInvoice = false;
              } else {
                _this8.approvalNoteError = false;
              }

              // Invoice matches PO Validation
              if (_this8.settingsModel.CompanySettings.RequireAdditionalInvoiceConfirmation && !_this8.additionalInvoiceConfirmationOptions[0].status && submit && _this8.settingsModel.CompanySettings.EditingInvoiceScan === false) {
                _this8.additionalInvoiceConfirmationError = true;
                validInvoice = false;
              } else {
                _this8.additionalInvoiceConfirmationError = false;
              }

              // Line Items Validation
              if (!_this8.useHighLevelAllocation && !_this8.isP2PInvoice) {
                // i2p
                if (!_this8.settingsModel.CompanySettings.AllowInvoiceScanning && _this8.purchaseOrder.PO.events && _this8.purchaseOrder.PO.events[0].lineItems.length === 0 && validInvoice === true) {
                  actionLabel = submit ? 'submit' : 'save';
                  _this8.validationErrorTitle = 'Please add at least one line item to ' + actionLabel + ' your invoice.';
                  validInvoice = false;
                }

                // Line items names
                if (_this8.purchaseOrder.PO.events && _this8.purchaseOrder.PO.events[0].lineItems.filter(function (item) {
                  return item._invalid === 'true';
                }).length > 0 && validInvoice === true) {
                  _this8.validationErrorTitle = 'Please complete the empty fields for the highlighted items in the Line Items grid of the screen in order to submit your invoice.';
                  validInvoice = false;
                }
              }
              if (!_this8.useHighLevelAllocation && _this8.isP2PInvoice) {
                if (_this8.purchaseOrder.PO.events[0].lineItems.some(function (i) {
                  return i.entireRowInvalid;
                })) {
                  _this8.validationErrorTitle = 'The PO does not have the Processing Fee Item, please edit and resubmit the PO before submitting the invoice.';
                  validInvoice = false;
                }
              }

              // High Level Validation
              if (_this8.programId > 0 && _this8.useHighLevelAllocation && !_this8.isP2PInvoice) {
                validationMessageModel = _this8.validateHighLevelAllocations();
                if (validationMessageModel && validationMessageModel.ErrorMessage !== '') {
                  _this8.validationErrorTitle = validationMessageModel.ErrorMessage;
                  _this8.validationTitle = validationMessageModel.ErrorTitle;
                  validInvoice = false;
                }
              }

              // Same day invoice
              if (!(_this8.invoiceInformationModel && _this8.invoiceInformationModel.IsSameDayDeposit && submit)) {
                _context4.next = 26;
                break;
              }
              // negative amount validation
              invoiceAmount = !_this8.isP2PInvoice ? Number(_this8.purchaseOrder.PO.events[0].total) // i2p
              : Number(_this8.invoiceInformationModel.InvoiceAmount);
              if (invoiceAmount < 0) {
                _this8.invoiceInformationModel.Errors.InvoiceAmountNegative = true;
                validInvoice = false;
              }

              // Same day deposit - thresholds validation
              _context4.next = 24;
              return _this8.validateSameDayThresholds();
            case 24:
              _validationMessageModel = _context4.sent;
              if (_validationMessageModel && _validationMessageModel.ErrorMessage !== '') {
                _this8.validationErrorTitle = _validationMessageModel.ErrorMessage;
                _this8.validationTitle = _validationMessageModel.ErrorTitle;
                validInvoice = false;
              }
            case 26:
              // SPRT-18874: the selected program is cancelled — refuse both save and submit. The flag is set by
              // InvoiceInformation.processProgramDetails when the program is picked; the backend refuses the same
              // request independently (InvoiceToPay.GuardProgramNotCancelled), so a bypassed UI does not get through.
              //
              // Runs LAST on purpose. Several checks above (Processing Fee Item, high-level allocations, same-day
              // thresholds) assign validationErrorTitle without testing validInvoice first, so from anywhere earlier
              // this message would be overwritten and the modal would send the user off to fix an allocation or a PO
              // on an invoice that can never be accepted. A cancelled program outranks every other reason.
              if (_this8.invoiceInformationModel.Errors.ProgramCancelled) {
                _this8.validationErrorTitle = __WEBPACK_IMPORTED_MODULE_10__models_program_constants__["a" /* default */].cancelledProgramMessage;
                _this8.validationTitle = '';
                validInvoice = false;
              }
              if (validInvoice && submit && _this8.settingsModel.CompanySettings.EditingInvoiceScan && !_this8.validateInvoiceAmount()) {
                validInvoice = false;
              }

              // Allocation type for scan validation
              if (_this8.invoiceInformationModel && _this8.invoiceInformationModel.HasAllocationSection && !_this8.invoiceInformationModel.IsAllocationSelected) {
                _this8.invoiceInformationModel.Errors.AllocationTypeMissing = true;
                validInvoice = false;
              }

              // Allocation for scan validation
              if (_this8.invalidAllocationForScan()) {
                _this8.invoiceInformationModel.Errors.AllocationMissing = true;
                validInvoice = false;
              }

              // P2P with line items validations
              if (validInvoice && submit && _this8.isP2PInvoiceWithAddEditItems) {
                if (!_this8.hasAtleastOneItemAdded()) {
                  _this8.validationErrorTitle = 'This PO was already invoiced in full.';
                  _this8.validationTitle = '';
                  validInvoice = false;
                }
                if (validInvoice && _this8.settingsModel.CompanySettings.AllowInvoiceToExceedPOQty && !_this8.isValidItemTotalAmount()) {
                  // validate invoiced amount
                  validInvoice = false;
                }

                // IMPORTANT: this must be the last validation
                if (validInvoice && _this8.hasItemsWithUnitPriceAtZero()) {
                  if (_this8.modals.allowItemsWithZeroUnitPrice) {
                    _this8.showUnitPriceAtZeroWarning = true;
                    validInvoice = false;
                  }
                }
              }

              // Custom Fields
              if (!(_this8.$refs.invoiceInformationRef.$refs.customFieldsRef && _this8.$refs.invoiceInformationRef.$refs.customFieldsRef.validate())) {
                validInvoice = false;
              }

              // display error
              if (_this8.validationErrorTitle) {
                _this8.showValidationError = true;
              }
              return _context4.abrupt("return", validInvoice);
            case 34:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    isValidItemTotalAmount: function isValidItemTotalAmount() {
      var result = true;
      if (this.isP2PInvoiceWithAddEditItems) {
        var excludeTaxes = this.settingsModel.CompanySettings.ExcludeTaxesFromPOThreshold;
        this.purchaseOrder.PO.events[0].lineItems.forEach(function (item) {
          if (!item.isAutoGenerated && Number(item.quantity) !== 0) {
            var amountToValidate = excludeTaxes ? item.total // allow any amount for taxes
            : item.totalWithTaxesAndFees;

            // total amount validation
            if (Number(amountToValidate) < Number(item.minTotalAmount) || Number(amountToValidate) > Number(item.maxTotalAmount)) {
              item._invalid = true;
              result = false;
            }

            // unit price validation
            if ((!item.isFeeDiscountItem || Number(item.amountTypeId) === 1) && Number(item.unitPrice) > Number(item.maxUnitPrice)) {
              item._invalid = true;
              result = false;
            }
          }
        });
      }
      return result;
    },
    hasItemsWithUnitPriceAtZero: function hasItemsWithUnitPriceAtZero() {
      var result = false;
      if (this.isP2PInvoiceWithAddEditItems) {
        this.purchaseOrder.PO.events[0].lineItems.forEach(function (item) {
          if (!item.isQuantityReadonly && (item.isFeeDiscountItem && Number(item.amountTypeValue) === 0 || !item.isFeeDiscountItem && Number(item.unitPrice) === 0)) {
            result = true;
          }
        });
      }
      return result;
    },
    hasAtleastOneItemAdded: function hasAtleastOneItemAdded() {
      // avoid submitting the invoice with items without quantity
      var result = false;
      if (this.isP2PInvoiceWithAddEditItems) {
        this.purchaseOrder.PO.events[0].lineItems.forEach(function (item) {
          if (Number(item.quantity) !== 0) {
            result = true;
          }
        });
      }
      return result;
    },
    validateHighLevelAllocations: function validateHighLevelAllocations() {
      var validationMessageModel = {
        ErrorMessage: '',
        ErrorTitle: ''
      };
      // Allocations 100%
      if (!this.validateAllocationsTotal()) {
        validationMessageModel.ErrorMessage = 'Please allocate your invoice to 100% in the Allocation sections of the screen to submit your invoice.';
      }
      if (!this.validateAllocations()) {
        validationMessageModel.ErrorMessage = 'Please select a value from the drop-down or complete the missing fields ' + 'for the highlighted items in the Allocation sections of the screen in order to submit your invoice.';
      }
      return validationMessageModel;
    },
    validateSameDayThresholds: function validateSameDayThresholds() {
      var _this9 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
        var invoiceAmount, validationMessageModel;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              invoiceAmount = !_this9.isP2PInvoice ? Number(_this9.purchaseOrder.PO.events[0].total) // i2p
              : Number(_this9.invoiceInformationModel.InvoiceAmount);
              if (invoiceAmount === 0) {
                invoiceAmount = _this9.invoiceInformationModel.InitialTotalAmount;
              }
              validationMessageModel = {
                ErrorMessage: '',
                ErrorTitle: 'Amount Exceeds Threshold'
              };
              _context5.next = 5;
              return _this9.api.get(_this9.api.$.invoice.i2p.getImmediatePaymentSettings, {
                params: {
                  divisionId: _this9.invoiceInformationModel.DivisionID,
                  currencyCode: _this9.invoiceInformationModel.CurrencyCode,
                  invoiceIdEdited: _this9.invoiceInformationModel.PaymentInvoiceId,
                  invoiceAmount: invoiceAmount
                }
              }).then(function (response) {
                if (response.data.NoCurrency) {
                  validationMessageModel.ErrorMessage = 'There are no escrow funds for currency ' + _this9.invoiceInformationModel.CurrencyCode + '.';
                  return validationMessageModel;
                }
                if (response.data.InvoiceAmountInDefaultCurrency) {
                  invoiceAmount = response.data.InvoiceAmountInDefaultCurrency;
                }
                if (response.data.TransactionLimit !== 0 && response.data.TransactionLimit < invoiceAmount) {
                  var formattedLimit = __WEBPACK_IMPORTED_MODULE_31__core_charts_helper_formatter_js___default.a.getMoneyFormatedValue(response.data.TransactionLimit, response.data.EscrowCurrencyCode);
                  validationMessageModel.ErrorMessage = 'This invoice amount exceeds the allowed amount per transaction of ' + formattedLimit + '. Please adjust your invoice amount to be below the threshold amount.';
                  return validationMessageModel;
                }
                if (response.data.TotalLimit !== 0 && response.data.Balance < invoiceAmount) {
                  var formattedAmount = __WEBPACK_IMPORTED_MODULE_31__core_charts_helper_formatter_js___default.a.getMoneyFormatedValue(invoiceAmount - response.data.Balance, response.data.EscrowCurrencyCode);
                  var formattedTotalLimit = __WEBPACK_IMPORTED_MODULE_31__core_charts_helper_formatter_js___default.a.getMoneyFormatedValue(response.data.TotalLimit, response.data.EscrowCurrencyCode);
                  validationMessageModel.ErrorMessage = 'This invoice will push the total balance allowed for your company (' + formattedTotalLimit + '). ' + 'In order to push this as a ' + utils.constants.invoice.SameDayLabel + ' payment invoice, please reduce your total amount by ' + formattedAmount + '.';
                  return validationMessageModel;
                }
              });
            case 5:
              return _context5.abrupt("return", validationMessageModel);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    validateInvoiceAmount: function validateInvoiceAmount() {
      // validate total amount excluding auto-generated merchant fee and discounted payment term (i2p)
      var autogeneratedAmounts = this.getAutogeneratedAmount();
      var _initialAmount = (this.invoiceInformationModel.InitialTotalAmount + autogeneratedAmounts).toFixed(2);
      if (+this.purchaseOrder.PO.events[0].total !== +_initialAmount) {
        if (!this.modals.allowDifferentAmount) {
          this.showDifferentAmountWarning = true;
          return false;
        }
      }
      return true;
    },
    getAutogeneratedAmount: function getAutogeneratedAmount() {
      // i2p
      var sum = 0;
      this.purchaseOrder.PO.events && this.purchaseOrder.PO.events[0] && this.purchaseOrder.PO.events[0].lineItems && this.purchaseOrder.PO.events[0].lineItems.forEach(function (item) {
        if (item.isAutoGenerated) {
          sum += Number(item.total);
        }
      });
      return sum;
    },
    invalidAllocationForScan: function invalidAllocationForScan() {
      if (!this.invoiceInformationModel.HasAllocationForScan) {
        this.costCentersForScan = [];
        this.pairsForScan = [];
      }
      return this.invoiceInformationModel && this.invoiceInformationModel.HasAllocationSection && this.invoiceInformationModel.IsAllocationSelected && this.invoiceInformationModel.HasAllocationForScan && (this.costCentersForScan === null || this.costCentersForScan && this.costCentersForScan.length === 0) && (this.pairsForScan === null || this.pairsForScan && this.pairsForScan.length === 0);
    },
    loadedStep: function loadedStep() {
      this.loading = false;
    },
    highlightTabs: function highlightTabs() {
      this.$root.legacyTab = 'Commerce';
      this.$root.legacySubtab = 'Invoices';
    },
    clearTabs: function clearTabs() {
      var _this10 = this;
      this.$nextTick(function () {
        _this10.$root.legacyTab = _this10.$root.legacySubtab = '';
        _this10.programId = 0;
      });
    },
    resetJSONmodel: function resetJSONmodel() {
      this.invoiceInformationModel = utils.copy(__WEBPACK_IMPORTED_MODULE_9__models_invoice_information_model__["a" /* default */]);
      this.purchaseOrder = utils.copy(__WEBPACK_IMPORTED_MODULE_15__models_purchaseOrder__["a" /* default */]);
      this.settingsModel = utils.copy(__WEBPACK_IMPORTED_MODULE_16__models_settings_model__["a" /* default */]);
      this.budgetSnapshotModel = utils.copy(__WEBPACK_IMPORTED_MODULE_12__models_budget_snapshot_model__["a" /* default */]);
      this.budgetScanSnapshotModel = utils.copy(__WEBPACK_IMPORTED_MODULE_14__models_budget_scan_snapshot_model__["a" /* default */]);
      this.modals = utils.copy(__WEBPACK_IMPORTED_MODULE_26__models_modals_settings_js__["a" /* default */]);

      // reset submission approval
      this.approvalCheckboxError = false;
      this.approvalNoteError = false;
      this.approvalCheckboxOptions[0].status = false;
      this.additionalInvoiceConfirmationError = false;
      this.additionalInvoiceConfirmationOptions[0].status = false;
    },
    cancelInvoice: function cancelInvoice() {
      if (this.batch.addAnotherInvoice) {
        this.createAnotherInvoice();
      } else {
        var tab = '';
        var subtab = '';
        var url = '/i/Programs/Invoice-received/';
        if (this.$route.query.from) {
          if (this.$route.query.from.toLowerCase().trim() === 'eoadmin') {
            url = '/d/InvoiceScan/queue/';
            // global.top.document.getElementById('VuePageFrame').className = 'VuePage'
            // global.top.document.body.style.overflow = 'auto'
            // return
          } else if (this.$route.query.from.toLowerCase().trim() === 'mydashboard') {
            url = '/d/Dashboard/MyDashboard/';
            tab = 'HomeEO';
            subtab = 'Dashboard';
          } else if (this.$route.query.from.toLowerCase().trim() === 'programinvoices' || this.$route.query.from.toLowerCase().trim() === 'program-invoice-list') {
            url = '/i/Programs/Program-list/?goto=PaymentInvoice/ProgramInvoiceList/' + this.$route.query.programId;
            tab = 'Commerce';
            subtab = 'Invoices';
          } else if (this.$route.query.from.toLowerCase().trim() === 'programdashboard') {
            url = '/i/Programs/Program-list/?goto=ProgramDashboard/ProgramDashboard/' + (typeof this.$route.query.programId !== 'undefined' ? this.$route.query.programId : 0);
            tab = 'Commerce';
            subtab = 'ProgramList';
          } else if (this.$route.query.from.toLowerCase().trim() === 'programsentpos') {
            // Program Dashboard > POs tab
            url = '/i/Programs/Program-list/?goto=QqSentPurchaseOrder/QqSentPurchaseOrder/' + (typeof this.$route.query.programId !== 'undefined' ? this.$route.query.programId : 0);
            tab = 'Commerce';
            subtab = 'ProgramList';
          } else if (this.$route.query.from.toLowerCase().trim().indexOf('poinvoices') === 0) {
            // PO Details > Invoices tab
            url = '/i/Programs/Program-list/?goto=PaymentInvoiceFusion' + (typeof this.$route.query.fusionPoId !== 'undefined' ? this.$route.query.fusionPoId : this.invoiceInformationModel.POid);
            tab = 'Commerce';
            subtab = 'ProgramList';
          } else if (this.$route.query.from.toLowerCase().trim() === 'sentpos') {
            // PO's grid
            url = '/i/Programs/PO-sent/?goto=QqSentPurchaseOrder';
            tab = 'Commerce';
            subtab = 'QqSentPurchaseOrder';
          } else if (this.$route.query.from.toLowerCase().trim().indexOf('podetails') === 0) {
            // PO Details
            url = '/i/Programs/PO-sent/?goto=/ScopeOfService/View/' + this.invoiceInformationModel.POMasterId + '/1';
            if (this.$route.query.from.toLowerCase().trim() === 'podetailsfromprogram') {
              url += '/' + this.$route.query.programId;
            }
            tab = 'Commerce';
            subtab = 'QqSentPurchaseOrder';
          }
        } else if (this.$route.query.supplierId) {
          url = '/i/Network/SupplierNetwork/';
          tab = 'Network';
          subtab = 'Network';
        }
        if (tab !== '' && subtab !== '') {
          this.$root.legacyTab = tab;
          this.$root.legacySubtab = subtab;
        }
        this.$router.push(url);
      }
    },
    beforeCancelInvoice: function beforeCancelInvoice() {
      this.cancelClicked = true;
      if (this.invoiceInformationModel.InvoiceIsSaved) {
        if (this.validate(false)) {
          this.cancelInvoice();
        }
      } else {
        this.cancelInvoice();
      }
    },
    createAnotherInvoice: function createAnotherInvoice() {
      this.$router.push('/d/InvoiceToPay/upload?invoiceId=0&from=batch&programId=' + this.invoiceInformationModel.ProgramID);

      // reset data()
      var batchInvoices = this.batch.invoices;
      Object.assign(this.$data, this.$options.data.call(this));
      this.batch.invoices = batchInvoices;

      // call deactivated()
      this.onDeactivated();

      // call created()
      this.onCreated();
    },
    submitAndAddAnother: function submitAndAddAnother() {
      var _this11 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this11.submitAfterConfirmation = true;
              _this11.batch.addAnotherInvoice = true;
              _this11.batch.submitAllInvoices = false;
              _this11.doConfirmationsBeforeSave();
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    initSubmitBatch: function initSubmitBatch() {
      this.submitAfterConfirmation = true;
      this.batch.addAnotherInvoice = false;
      this.batch.submitAllInvoices = true;
      this.doConfirmationsBeforeSave();
    },
    saveOneInvoice: function saveOneInvoice(withSubmit) {
      var _this12 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this12.submitAfterConfirmation = withSubmit;
              _this12.batch.addAnotherInvoice = false;
              _this12.batch.submitAllInvoices = false;
              _this12.doConfirmationsBeforeSave();
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    doConfirmationsBeforeSave: function doConfirmationsBeforeSave() {
      var _this13 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee8() {
        var items, isValidBuAndCC;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              items = _this13.getInvoiceItems();
              isValidBuAndCC = true;
              isValidBuAndCC = !_this13.settingsModel.CompanySettings.UseBusinessUnitAndCostCenterMapping || items.every(function (item) {
                return item.businessUnitId && item.costCenterId && item.programBusinessUnitAndCostCenterId;
              });
              if (isValidBuAndCC) {
                _context8.next = 12;
                break;
              }
              if (!_this13.isP2PInvoice) {
                _context8.next = 9;
                break;
              }
              alert('You cannot submit this invoice because line items are not allocated to BU&CCs. Please edit the PO, allocate all line items to BU&CCs, send the PO and then submit the invoice.');
              return _context8.abrupt("return", false);
            case 9:
              if (!(!_this13.useHighLevelAllocation && (items[0].costCenterAndBusinessUnit.costCenterAndBusinessUnitKey === null || items[0].costCenterAndBusinessUnit.costCenterAndBusinessUnitKey === ''))) {
                _context8.next = 12;
                break;
              }
              alert('You cannot submit this invoice because line items are not allocated to BU&CCs.');
              return _context8.abrupt("return", false);
            case 12:
              _this13.verifySupplierCountry();
              return _context8.abrupt("return", true);
            case 14:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    fetchCountries: function fetchCountries() {
      var _this14 = this;
      this.api.forms.post(this.api.$.settings.company.countries, {
        q: ''
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          _this14.countries = r.data.Data;
        }
      }).catch(function (e) {
        return console.warn(e);
      });
    },
    selectCountry: function selectCountry() {
      this.showCountryMissing = false;
    },
    onSupplierCountrySelected: function onSupplierCountrySelected() {
      if (this.supplierCountry && this.supplierCountry.Value) {
        this.purchaseOrder.PO.supplier.address.country = this.supplierCountry.Value;
        this.modals.selectSupplierCountry = false;
        this.verifySupplierCountry();
      } else {
        this.showCountryMissing = true;
      }
    },
    closeSupplierCountrySelection: function closeSupplierCountrySelection() {
      this.modals.selectSupplierCountry = false;
      this.submitAfterConfirmation = false;
    },
    supplierWasChanged: function supplierWasChanged() {
      return +this.purchaseOrderInitialModel.supplier.vci !== +this.purchaseOrder.PO.supplier.vci || this.purchaseOrderInitialModel.supplier.email !== this.purchaseOrder.PO.supplier.email;
    },
    verifyBudgetAlmostUsed: function verifyBudgetAlmostUsed() {
      var canSave = true;
      if (!this.settingsModel.CompanySettings.EditingInvoiceScan) {
        if (this.budgetSnapshotModel.BudgetBalance * 100 / this.budgetSnapshotModel.ProgramBudget < 20 && this.budgetSnapshotModel.BudgetBalance * 100 / this.budgetSnapshotModel.ProgramBudget >= 0) {
          this.showBudgetAlmostUsedNotification = true;
          canSave = false;
        }
      }
      if (canSave) {
        this.save(this.submitAfterConfirmation);
      }
    },
    verifySupplierCountry: function verifySupplierCountry() {
      var _this15 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee9() {
        var verifySupplier;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              // verify supplier provide services in the Bill To country
              verifySupplier = _this15.submitAfterConfirmation && typeof _this15.purchaseOrder.PO.supplier.address !== 'undefined' &&
              // supplier selected
              typeof _this15.purchaseOrder.PO.billTo.address !== 'undefined' && (_this15.isCreateInvoice() || _this15.supplierWasChanged() || _this15.invoiceInformationModel.IsDraft && !_this15.settingsModel.CompanySettings.EditingInvoiceScan);
              if (verifySupplier) {
                if ((_this15.purchaseOrder.PO.supplier.address.country || '').trim() === '') {
                  if (_this15.purchaseOrder.PO.supplier.vci > 0) {
                    _this15.api.get(_this15.api.$.invoice.i2p.getSupplierCountryName, {
                      params: {
                        supplierEONumber: _this15.purchaseOrder.PO.supplier.vci
                      }
                    }).then(function (r) {
                      if (r && r.data) {
                        _this15.purchaseOrder.PO.supplier.address.country = r.data;
                        _this15.compareSupplierAndBillToCountries();
                      } else {
                        _this15.showModalToChooseSupplierCountry();
                      }
                    });
                  } else {
                    _this15.showModalToChooseSupplierCountry();
                  }
                } else {
                  _this15.compareSupplierAndBillToCountries();
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.SUPPLIER_COUNTRY_CONFIRMED);
              }
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    showModalToChooseSupplierCountry: function showModalToChooseSupplierCountry() {
      this.supplierCountry = {};
      this.showCountryMissing = false;
      this.modals.selectSupplierCountry = true;
    },
    compareSupplierAndBillToCountries: function compareSupplierAndBillToCountries() {
      if (this.purchaseOrder.PO.billTo.address.country !== this.purchaseOrder.PO.supplier.address.country && this.purchaseOrder.PO.billTo.address.country === 'United States' && this.purchaseOrder.PO.supplier.withholdingTaxPercent !== 0) {
        this.modals.showSupplierProvideServicesConfirmation = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.SUPPLIER_COUNTRY_CONFIRMED);
      }
    },
    onSupplierCountryConfirmed: function onSupplierCountryConfirmed() {
      this.verifyBudgetAlmostUsed();
    },
    closeBudgetAlmostUsedNotification: function closeBudgetAlmostUsedNotification() {
      this.showBudgetAlmostUsedNotification = false;
      this.save(this.submitAfterConfirmation);
    },
    onSupplierProvideServicesConfirmation: function onSupplierProvideServicesConfirmation() {
      this.invoiceInformationModel.IsWithholdingTaxEligible = this.purchaseOrder.PO.supplier.address.country !== this.purchaseOrder.PO.billTo.address.country && this.purchaseOrder.PO.billTo.address.country === 'United States';
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.SUPPLIER_COUNTRY_CONFIRMED);
    },
    closeSupplierProvideServicesConfirmation: function closeSupplierProvideServicesConfirmation(data) {
      this.modals.showSupplierProvideServicesConfirmation = false;
      if (data && data.btnClick === true) {
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.SUPPLIER_COUNTRY_CONFIRMED);
      }
    },
    save: function save(withSubmit) {
      var _this16 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee10() {
        var valid, supplierZipCodeIsDifferent, isOverBudgetCase;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(_this16.batch.submitAllInvoices && (_this16.invoiceInformationModel.ProgramID || 0) <= 0)) {
                _context10.next = 4;
                break;
              }
              _this16.modals.showSubmitBatchConfirmation = true;
              _context10.next = 26;
              break;
            case 4:
              _context10.next = 6;
              return _this16.validate(withSubmit);
            case 6:
              valid = _context10.sent;
              if (!valid) {
                _context10.next = 26;
                break;
              }
              supplierZipCodeIsDifferent = false;
              if (!(!_this16.supplierZipCodeWarningWasAccepted && withSubmit)) {
                _context10.next = 13;
                break;
              }
              _context10.next = 12;
              return _this16.checkSupplierZipCode();
            case 12:
              supplierZipCodeIsDifferent = _context10.sent;
            case 13:
              if (supplierZipCodeIsDifferent) {
                _context10.next = 25;
                break;
              }
              if (!(_this16.isBeforeSendingToScan && !_this16.overBudgetWarningBeforeSendingToScanWasAccepted)) {
                _context10.next = 20;
                break;
              }
              _context10.next = 17;
              return _this16.isOverBudgetBeforeSendingToScan();
            case 17:
              _context10.t0 = _context10.sent;
              _context10.next = 21;
              break;
            case 20:
              _context10.t0 = false;
            case 21:
              isOverBudgetCase = _context10.t0;
              if (!isOverBudgetCase) {
                _this16.savePurchaseOrder(_this16.submitAfterConfirmation);
                // after saving the PO, if required, then this.saveInvoice(withSubmit) will be called
              } else {
                _this16.showOverBudgetWarningBeforeSendingToScan = true;
              }
              _context10.next = 26;
              break;
            case 25:
              _this16.showSupplierZipCodeWarning = true;
            case 26:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    onSubmitBatchClose: function onSubmitBatchClose() {
      this.modals.showSubmitBatchConfirmation = false;
      this.batch.submitAllInvoices = false;
      this.batch.selectedInvoices = null;
    },
    onSubmitBatchConfirmation: function onSubmitBatchConfirmation() {
      // TODO: confirmation to skip validation on current invoice
      this.submitBatch();
    },
    getInvoiceIdsFromBatch: function getInvoiceIdsFromBatch() {
      var _this17 = this;
      if (this.batch.selectedInvoices === null || this.batch.selectedInvoices.length === 0) return [];
      var invoiceIds = [];
      this.batch.invoices.map(function (inv) {
        if (_this17.batch.selectedInvoices.indexOf(inv.id) !== -1) {
          invoiceIds.push(inv.id);
        }
      });
      return invoiceIds;
    },
    submitBatch: function submitBatch() {
      var _this18 = this;
      var invoiceIds = this.getInvoiceIdsFromBatch();
      if (invoiceIds && invoiceIds.length > 0) {
        this.api.post(this.api.$.invoice.i2p.submitBatch, {
          invoiceIds: invoiceIds
        }).then(function (response) {
          _this18.batch = utils.copy(__WEBPACK_IMPORTED_MODULE_25__models_batch_settings_js__["a" /* default */]);
          _this18.onSubmitBatchClose();
          if (response.data.Success) {
            _this18.batch.invoices = [];
            __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.VALIDATION_COMPLETED, {
              validInvoice: true,
              gotoNextTab: true
            });
          } else {
            // TODO: show error
          }
        });
      } else {
        this.batch.invoices = [];
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.VALIDATION_COMPLETED, {
          validInvoice: true,
          gotoNextTab: true
        });
      }
    },
    onBatchInvoiceSelected: function onBatchInvoiceSelected(e) {
      var _this19 = this;
      if (e && Array.isArray(e)) {
        this.batch.selectedInvoices = [];
        e.map(function (i) {
          if (i.data.id) {
            _this19.batch.selectedInvoices.push(i.data.id);
          }
        });
      } else {
        this.batch.selectedInvoices = [];
      }
    },
    closeValidationError: function closeValidationError() {
      this.showValidationError = false;
      this.validationErrorTitle = '';
      this.validationTitle = '';
    },
    savePurchaseOrder: function savePurchaseOrder(submit) {
      this.saveInvoice(submit);

      // IMPORTANT: uncomment after removing from backend the save/submit/get of the PO
      /* if (!this.isP2PInvoice) {
        let url = this.invoiceInformationModel.UseSavingsFields
          ? api.SaveSavings()
          : api.SavePurchaseOrder()
         // save PO
        this.api.post(
            url, { params: {
              userId: this.user.buyerUserID,
              data: this.purchaseOrder.PO
            }}
          ).then(r => {
            if (r && r.data) {
              this.invoiceInformationModel.PONumber = r.data
               // send PO to supplier
              if (submit) {
                url = this.invoiceInformationModel.UseSavingsFields
                  ? api.SendSavings()
                  : api.SendPurchaseOrder()
                 this.api.post(
                  url, { params: {
                    userId: this.user.buyerUserID,
                    data: this.purchaseOrder.PO
                  }}
                ).then(r => {
                  if (r && r.data) {
                    // save/submit invoice
                    this.invoiceInformationModel.PONumber = r.data
                    this.saveInvoice(submit)
                  }
                })
                .catch(e => this.onSaveError())
              } else {
                // save/submit invoice
                this.saveInvoice(submit)
              }
            }
          })
          .catch(e => this.onSaveError())
      } else {
        // p2p: save/submit invoice
        this.saveInvoice(submit)
      } */
    },
    setInvoiceAmount: function setInvoiceAmount() {
      if (!this.isP2PInvoice) {
        this.invoiceInformationModel.InvoiceAmount = this.purchaseOrder.PO.events[0].total; // i2p
        if (!this.isBeforeSendingToScan) {
          this.invoiceInformationModel.VATGSTAmount = +this.purchaseOrder.PO.vat + +this.purchaseOrder.PO.gst;
        }
      }
    },
    setInvoiceDates: function setInvoiceDates() {
      if (this.invoiceInformationModel.InvoiceDate) {
        this.invoiceInformationModel.InvoiceDate = global.moment(this.invoiceInformationModel.InvoiceDate).format('MM/DD/YYYY');
      }
      if (this.invoiceInformationModel.DueDate) {
        this.invoiceInformationModel.DueDate = global.moment(this.invoiceInformationModel.DueDate).format('MM/DD/YYYY');
      }
    },
    getInvoiceItems: function getInvoiceItems() {
      var allItems = [];
      this.purchaseOrder.PO.events.forEach(function (ev) {
        ev.lineItems.forEach(function (itm) {
          var newItem = itm;
          newItem.id = itm.itemKey;
          newItem.invoiceItemKey = itm.invoiceItemKey;
          newItem.eventKey = ev.uniqueId;
          newItem.categoryName = itm.category;
          newItem.categoryRefNo = itm.referenceId;
          newItem.costCenterNo = itm.costCenterAndBusinessUnit && itm.costCenterAndBusinessUnit.costCenterNo || '';
          newItem.costCenterName = itm.costCenterAndBusinessUnit && itm.costCenterAndBusinessUnit.costCenterName || '';
          newItem.businessUnitName = itm.costCenterAndBusinessUnit && itm.costCenterAndBusinessUnit.businessUnitName || '';
          newItem.programBusinessUnitAndCostCenterId = itm.costCenterAndBusinessUnit && itm.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId || null;
          newItem.businessUnitId = itm.costCenterAndBusinessUnit && itm.costCenterAndBusinessUnit.businessUnitId || null;
          newItem.costCenterId = itm.costCenterAndBusinessUnit && itm.costCenterAndBusinessUnit.costCenterId || null;
          allItems.push(newItem);
        });
      });
      return allItems;
    },
    // IMPORTANT: should be called only from savePurchaseOrder method
    saveInvoice: function saveInvoice(submit) {
      var _this20 = this;
      this.setInvoiceAmount();
      this.setInvoiceDates();
      submit = submit || false;
      this.submitDisabled = true;
      var items = this.getInvoiceItems();
      this.invoiceInformationModel.CustomFields = this.$refs.invoiceInformationRef.$refs.customFieldsRef.getFields(true, true);

      // call SaveBudget to save purchase order details
      var model = {
        purchaseOrder: JSON.stringify(this.purchaseOrder.PO),
        items: items,
        invoice: this.invoiceInformationModel,
        supplier: this.invoiceInformationModel.Supplier,
        submit: submit,
        allowDuplicateInvoices: this.allowDuplicateInvoices,
        costCenters: this.ccAllocations && this.ccAllocations.AllocationList,
        buAndCcPairs: this.pairsAllocations && this.pairsAllocations.AllocationList,
        categories: this.categoriesAllocations && this.categoriesAllocations.AllocationList,
        costCentersForScan: this.costCentersForScan,
        buAndCcPairsForScan: this.pairsForScan,
        submitBatch: this.batch.addAnotherInvoice || this.batch.submitAllInvoices
      };
      this.api.post(this.api.$.invoice.i2p.saveInvoice, model).then(function (response) {
        if (_this20.allowDuplicateInvoices) _this20.resetDuplicateInvoice();
        _this20.submitDisabled = false;
        if (response.data && response.data.SuccessMessage === 'Error') {
          // SPRT-18874: when the backend refused for a known reason it sends ErrorMessage (cancelled
          // program, escrow block, concurrent edit); show that instead of the generic "something went
          // wrong", which told the user to resubmit an invoice that can never be accepted.
          _this20.showSaveInvoiceError(response.data.ErrorMessage);
          _this20.submitDisabled = true;
        } else if (response.data && response.data.DuplicateInvoices && response.data.DuplicateInvoices.length > 0) {
          // Duplicate Invoice
          _this20.showDuplicateInvoice(response.data.DuplicateInvoices, submit);
        } else {
          var data = response.data;
          var isOverBudget = data && data.IsOverBudget;
          var isPendingScanning = data && data.IsPendingScanning;

          // reload purchase order model
          // IMPORTANT: uncomment after removing from backend the save/submit/get of the PO
          /* if (!this.isP2PInvoice && (!submit || isOverBudget || isPendingScanning ||
            this.batch.submitAllInvoices)) {
            this.getPurchaseOrder().then(r => {
              if (r && r.data) { */
          if (data && data.PurchaseOrder && (/* if the page will change, no need to reload the PO */
          isOverBudget || !(submit || _this20.batch.submitAllInvoices || _this20.batch.addAnotherInvoice))) {
            var responsePO = JSON.parse(data.PurchaseOrder); // r.data
            responsePO.events = _this20.store().keepItemCustomFields(responsePO.events, _this20.purchaseOrder.PO.events);
            _this20.purchaseOrder.PO = responsePO;
            _this20.purchaseOrder.PO.events = _this20.store().getEventsWithOrderedLineItems(_this20.purchaseOrder.PO.events);
            if (_this20.purchaseOrder.PO.currency && _this20.purchaseOrder.PO.currency.code) {
              _this20.purchaseOrder.PO.currencySelected = true;
              _this20.currencyCode = _this20.purchaseOrder.PO.currency.code;
            }
            // update the grid component with the changed model
            _this20.$nextTick(function () {
              _this20.recalculatePO();
            });
          }
          /* })
          } */

          _this20.$nextTick(function () {
            var oldInvoiceId = _this20.invoiceInformationModel.PaymentInvoiceId;
            if (data.PaymentInvoiceId) {
              _this20.invoiceInformationModel.PaymentInvoiceId = data.PaymentInvoiceId;
              _this20.invoiceInformationModel.InvoiceIsSaved = true;
            } else {
              _this20.showSaveInvoiceError();
            }
            var isBatchAction = _this20.batch.addAnotherInvoice || _this20.batch.submitAllInvoices;
            if (!isOverBudget && isBatchAction) {
              _this20.addOrUpdateInvoiceToBatch(oldInvoiceId);
            }
            _this20.cacheInitialData();
            if (isOverBudget) {
              _this20.submitWasPressed = submit;
              _this20.showOverBudget(data.FusionVersionId);
            } else if (isPendingScanning && !isBatchAction) {
              _this20.submitWasPressed = submit;
              _this20.showPendingScanningWarning = true;
            } else {
              if (_this20.batch.submitAllInvoices) {
                // show Submit Batch popup after Submit
                _this20.modals.showSubmitBatchConfirmation = true;
              } else {
                __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.VALIDATION_COMPLETED, {
                  validInvoice: true,
                  gotoNextTab: submit
                });
              }
            }
          });
        }
      });
    },
    getPurchaseOrder: function getPurchaseOrder(poNumber, userId) {
      var _this21 = this;
      if (!poNumber) poNumber = this.invoiceInformationModel.PONumber;
      if (!userId) userId = this.user.buyerUserID;
      var url = this.invoiceInformationModel.UseSavingsFields ? api.GetSavingsDetails() : api.GetPurchaseOrderDetails();
      return this.api.get(url + '?uniqueId=' + poNumber + '&userId=' + userId).catch(function (e) {
        return _this21.onSaveError();
      });
    },
    // SPRT-18874: mdNotification renders `message` with v-html (core/components/mdNotification/index.vue),
    // and this method now carries a backend-supplied string instead of a hardcoded literal. Every
    // ErrorMessage the save path can produce today is server-built with numeric/currency interpolation
    // only, so nothing is injectable right now — but the first one that echoes a supplier, program, invoice
    // or user name would be, and nothing here would signal that constraint back to the backend. Escaped at
    // this call site rather than in mdNotification, whose v-html other callers rely on for links.
    escapeNotificationHtml: function escapeNotificationHtml(value) {
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },
    // SPRT-18874: `heading` is what the notification store dedupes `alert: true` entries by
    // (core/components/mdNotifications/install.js). Every alert on this screen used to pass none, so they
    // all collided on `heading === undefined` and — with `timeout: 0` here — the first banner up swallowed
    // every other one until the user dismissed it by hand. A distinct heading per kind of refusal is what
    // lets the cancelled-program banner and a save failure coexist.
    showSaveInvoiceError: function showSaveInvoiceError(message) {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        heading: 'Invoice not saved',
        timeout: 0,
        message: this.escapeNotificationHtml(message || 'Something went wrong. Please resubmit the invoice.')
      });
    },
    // SPRT-18874: mirrors InvoiceInformation.showCancelledProgramError for the load path, which reaches a
    // cancelled program without going through the picker. Finite timeout, unlike the save-error alert
    // above: this one goes STALE — switching to a valid program clears the field error, and a
    // never-closing banner would keep saying the program is cancelled. Same heading as the picker's, so
    // the two dedupe against each other instead of stacking the identical message twice.
    showCancelledProgramError: function showCancelledProgramError() {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        heading: 'Cancelled program',
        timeout: 10000,
        message: __WEBPACK_IMPORTED_MODULE_10__models_program_constants__["a" /* default */].cancelledProgramMessage
      });
    },
    showOverBudgetWarningBeforeSendingToScan: function showOverBudgetWarningBeforeSendingToScan() {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        timeout: 0,
        message: 'showOverBudgetWarningBeforeSendingToScan.'
      });
    },
    onAcceptOverBudgetWarningBeforeSendingToScan: function onAcceptOverBudgetWarningBeforeSendingToScan() {
      this.showOverBudgetWarningBeforeSendingToScan = false;
      this.overBudgetWarningBeforeSendingToScanWasAccepted = true;
      this.save(this.submitAfterConfirmation);
    },
    onAcceptSupplierZipCodeWarning: function onAcceptSupplierZipCodeWarning() {
      this.showSupplierZipCodeWarning = false;
      this.supplierZipCodeWarningWasAccepted = true;
      this.save(this.submitAfterConfirmation);
    },
    addOrUpdateInvoiceToBatch: function addOrUpdateInvoiceToBatch(oldInvoiceId) {
      var _this22 = this;
      if (!this.batch.invoices) this.batch.invoices = [];
      var invmodel = {
        id: this.invoiceInformationModel.PaymentInvoiceId,
        programName: this.invoiceInformationModel.ProgramName,
        divisionName: this.invoiceInformationModel.DivisionName,
        supplierCompanyName: this.purchaseOrder && this.purchaseOrder.PO && this.purchaseOrder.PO.supplier ? this.purchaseOrder.PO.supplier.companyName : this.invoiceInformationModel.SupplierName,
        supplierInvoiceNumber: this.invoiceInformationModel.ReferenceNo,
        totalAmount: this.settingsModel.CompanySettings.AllowInvoiceScanning && !this.isP2PInvoice ? this.invoiceInformationModel.InitialTotalAmount : this.invoiceInformationModel.InvoiceAmount,
        currencyCode: this.invoiceInformationModel.CurrencyCode
      };
      var canAdd = true;
      this.batch.invoices.map(function (inv) {
        if (_this22.invoiceInformationModel.PaymentInvoiceId === inv.id || oldInvoiceId === inv.id) {
          inv.id = invmodel.id;
          inv.programName = invmodel.programName;
          inv.divisionName = invmodel.divisionName;
          inv.supplierCompanyName = invmodel.supplierCompanyName;
          inv.supplierInvoiceNumber = invmodel.supplierInvoiceNumber;
          inv.totalAmount = invmodel.totalAmount;
          inv.currencyCode = invmodel.currencyCode;
          canAdd = false;
        }
      });
      if (canAdd) {
        this.batch.invoices.push(invmodel);
      }
    },
    showOverBudget: function showOverBudget(fusionVersionId) {
      var _this23 = this;
      this.api.get(api.GetOverBudgetWarningData(), {
        params: {
          fusionVersionID: fusionVersionId,
          context: 'Invoice',
          invoiceId: this.$route.query.invoiceId
        }
      }).then(function (response) {
        _this23.overBudgetModel = response.data;
        _this23.showOverBudgetWarning = true;
      });
    },
    confirmOverBudget: function confirmOverBudget() {
      this.showOverBudgetWarning = false;
      if (this.batch.submitAllInvoices) {
        this.onSubmitBatchConfirmation();
      } else {
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.VALIDATION_COMPLETED, {
          validInvoice: true,
          gotoNextTab: this.submitWasPressed
        });
      }
    },
    doCancelInvoiceAction: function doCancelInvoiceAction() {
      var _this24 = this;
      this.showOverBudgetWarning = false;
      var paymentInvoiceId = this.invoiceInformationModel.PaymentInvoiceId;
      this.api.post(this.api.$.invoice.i2p.cancelInvoice, {
        paymentInvoiceId: paymentInvoiceId
      }).then(function (r) {
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.VALIDATION_COMPLETED, {
          validInvoice: true,
          gotoNextTab: _this24.submitWasPressed
        });
      });
    },
    closePendingScanningModal: function closePendingScanningModal() {
      this.showPendingScanningWarning = false;
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.VALIDATION_COMPLETED, {
        validInvoice: true,
        gotoNextTab: this.submitWasPressed
      });
    },
    showDuplicateInvoice: function showDuplicateInvoice(duplicateInvoices, submit) {
      this.resetDuplicateInvoice();
      this.duplicateInvoices = duplicateInvoices;
      this.allowDuplicateInvoices = false;
      this.submitWasPressed = submit;
      this.showDuplicateInvoiceStep1 = true;
    },
    duplicateInvoiceAction: function duplicateInvoiceAction() {
      this.showDuplicateInvoiceStep2 = false;
      this.allowDuplicateInvoices = true;
      if (this.batch.submitAllInvoices) {
        this.initSubmitBatch();
      } else {
        this.save(this.submitWasPressed);
      }
    },
    resetDuplicateInvoice: function resetDuplicateInvoice() {
      this.duplicateInvoices = [];
      this.showDuplicateInvoiceStep1 = false;
      this.showDuplicateInvoiceStep2 = false;
      this.allowDuplicateInvoices = false;
    },
    duplicateInvoicePdfUrl: function duplicateInvoicePdfUrl(invoiceId) {
      return this.api.env + '/PaymentInvoice/ExportInvoice/?ids=[' + invoiceId + ']&isAllSelected=false';
    },
    initUploadInvoice: function initUploadInvoice() {
      return this.api.get(api.InitUploadInvoice(), {
        params: {
          paymentInvoiceId: this.$route.query.invoiceId,
          programId: this.$route.query.programId,
          supplierId: this.$route.query.supplierId,
          supplierVCI: this.$route.query.eoNumber,
          fusionPoId: Math.abs(this.$route.query.fusionPoId)
        }
      });
    },
    addSupplierData: function addSupplierData(e) {
      var _this25 = this;
      var supplierInfo = e.SupplierInfoVM.Supplier;
      var supplierCountry = '';
      try {
        supplierCountry = this.purchaseOrder.PO.supplier.address.country;
      } catch (e) {
        //
      }
      this.purchaseOrder.PO.supplier = {
        companyName: supplierInfo.SupplierName || '',
        network: null,
        phone: supplierInfo.SupplierPhone || '',
        address: {
          address1: supplierInfo.SupplierAddress1 || '',
          address2: supplierInfo.SupplierAddress2 || '',
          city: supplierInfo.SupplierCity || '',
          state: supplierInfo.SupplierState || '',
          region: supplierInfo.SupplierRegion || '',
          zipCode: supplierInfo.SupplierZIP || '',
          country: supplierInfo.CountryName || supplierCountry || ''
        },
        vci: e.Vci,
        id: supplierInfo.SupplierID || '',
        vatGstCode: supplierInfo.SupplierVatGstID || '',
        contactName: supplierInfo.SupplierContactName || '',
        email: supplierInfo.EmailAddress,
        useDifferentBillingAddress: 'False',
        withholdingTaxPercent: supplierInfo.WithholdingTaxPercent
      };
      if (e.SupplierInfoVM.SupplierId) {
        this.invoiceInformationModel.Supplier.VendorID = e.SupplierInfoVM.SupplierId;
      }
      if (!this.isP2PInvoice) {
        // only for i2p invoices the supplier can be selected and contacts must be removed
        this.purchaseOrder.PO.supplierContacts = [];
      }

      // run ComputeTotals to add or update auto generated taxes
      this.$nextTick(function () {
        if (!_this25.invoiceInformationModel.isEditInit) {
          _this25.recalculatePO();
        }
      });
      if (!e.IsInitSupplier) {
        this.api.forms.post(this.api.$.invoice.similarSuppliers, {
          supplierName: supplierInfo.SupplierName
        }).then(function (r) {
          if (r && r.data && r.data.SuccessMessage === 'Suppliers') {
            var suppliers = JSON.parse(r.data.Data);
            var alertMessage = 'There are multiple suppliers with a similar name to <b>' + supplierInfo.SupplierName + '</b> in the Eved Network:<br />';
            alertMessage += '<ul>';
            for (var i = 0; i < suppliers.length; i++) {
              var supplierInformation = suppliers[i].split('|');
              alertMessage += '<li>' + supplierInformation[0] + '<ul>';
              alertMessage += '<li> Business Type: ' + supplierInformation[1] + '</li>';
              alertMessage += '<li> Location: ' + supplierInformation[2] + '</li>';
              alertMessage += '</ul></li>';
            }
            alertMessage += '</ul>';
            alertMessage += 'If you have not selected the correct supplier, please close this window and select the correct one.';
            global.app.$notifications.notify({
              message: alertMessage,
              width: 600,
              timeout: 0,
              placement: {
                from: 'top',
                align: 'center'
              },
              type: 'warning',
              icon: 'exclamation-circle',
              dismiss: 'OK'
            });
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    onDiscountSelected: function onDiscountSelected(e) {
      var _this26 = this;
      this.purchaseOrder.PO.discountTerm = e.DiscountName;
      this.invoiceInformationModel.DiscountName = e.DiscountName;
      this.invoiceInformationModel.DiscountPaymentTermID = e.DiscountPaymentTermID;

      // no need to recalculate PO when this action is called from supplier selection or PO selection
      // it will be triggered in another method
      if (!e.SkipRecalculatePO) {
        this.$nextTick(function () {
          if (!_this26.invoiceInformationModel.isEditInit) {
            _this26.recalculatePO();
          }
        });
      }
    },
    // PO selected in combo
    onUpdatePOModel: function onUpdatePOModel(e) {
      var _this27 = this;
      this.purchaseOrder.PO = e.PO;
      this.invoiceInformationModel.POMasterId = e.POMasterId;
      if (this.purchaseOrder.PO.additionalInvoiceConfirmationText) {
        this.additionalInvoiceConfirmationOptions = [{
          status: false,
          label: this.purchaseOrder.PO.additionalInvoiceConfirmationText
        }];
      }
      if (this.isP2PInvoiceWithAddEditItems) {
        this.getRemainingQtyAndAmountOnPOItems(e.POMasterID);
      } else {
        this.$nextTick(function () {
          __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_5__core_events_events___default.a.I2P.UPDATE_PO_MODEL_COMPLETED);
          if (!_this27.invoiceInformationModel.isEditInit) {
            _this27.recalculatePO();
          }
        });
      }
    },
    getRemainingQtyAndAmountOnPOItems: function getRemainingQtyAndAmountOnPOItems(poMasterId) {
      var _this28 = this;
      if (this.isP2PInvoiceWithAddEditItems) {
        this.api.forms.post(this.api.$.invoice.i2p.getRemainingQtyAndAmountOnPOItems, {
          poMasterId: poMasterId
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            var items = JSON.parse(r.data.Data);
            if (_this28.isP2PInvoiceWithAddEditItems) {
              _this28.purchaseOrder.PO.events = _this28.updateQtyAndUnitsFromPOonCreate(_this28.purchaseOrder.PO.events, items);
            } else {
              _this28.purchaseOrder.PO.events = items;
            }
            __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_5__core_events_events___default.a.I2P.UPDATE_PO_MODEL_COMPLETED);
            _this28.recalculatePO();
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    onCurrencySelected: function onCurrencySelected(e) {
      this.currencyCode = e.code;
      this.purchaseOrder.PO.currency.code = e.code;
      this.purchaseOrder.PO.currency.symbol = e.symbol;
      this.purchaseOrder.PO.currency.decimalPlaces = e.decimalPlaces;
      this.purchaseOrder.PO.currencySelected = e.code && e.code !== '';
      this.budgetSnapshotModel.OriginalInvoiceCurrencyCode = this.budgetSnapshotModel.InvoiceCurrencyCode;
      this.budgetSnapshotModel.InvoiceCurrencyCode = e.code;
      if (!this.isP2PInvoice) {
        if (this.useHighLevelAllocation || !this.settingsModel.CompanySettings.EditingInvoiceScan && this.settingsModel.CompanySettings.AllowInvoiceScanning) {
          this.updateSnaphot();
        } else {
          this.updateLineItemSnaphot();
        }
      }
      if (this.settingsModel.CompanySettings.EditingInvoiceScan) {
        this.updateInvoiceScanSnapshot();
      }
    },
    onChangeSameDaySetting: function onChangeSameDaySetting(e) {
      this.invoiceInformationModel.IsSameDayDeposit = e.status;
    },
    onChangeReimbursementSetting: function onChangeReimbursementSetting(e) {
      this.invoiceInformationModel.IsReimbursement = e.status;
    },
    updateLineItemSnaphot: function updateLineItemSnaphot() {
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_5__core_events_events___default.a.I2P.UPDATE_SNAPSHOT, {
        total: +this.purchaseOrder.PO.total,
        totalVATGST: +this.purchaseOrder.PO.vat + +this.purchaseOrder.PO.gst,
        programCurrencyCode: this.purchaseOrder.PO.programDetails.currencyCode
      });
    },
    updateInvoiceScanSnapshot: function updateInvoiceScanSnapshot() {
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_5__core_events_events___default.a.I2P.UPDATE_INVOICE_SCAN_SNAPSHOT, {
        total: +this.purchaseOrder.PO.total,
        invoiceCurrencyCode: this.invoiceInformationModel.CurrencyCode
      });
    },
    removeSupplierData: function removeSupplierData(e) {
      this.purchaseOrder.PO.supplier = {};
      this.purchaseOrder.PO.supplierContacts = [];
      this.invoiceInformationModel.SupplierId = 0;
      this.invoiceInformationModel.SupplierName = '';
      this.invoiceInformationModel.SupplierUserId = 0;
      this.invoiceInformationModel.Supplier = {
        VendorID: 0,
        VendorUserID: 0
      };
    },
    validateProgramSelected: function validateProgramSelected(e) {
      var valid = this.purchaseOrder.PO.events && this.purchaseOrder.PO.events[0].lineItems.length === 0; // i2p

      if (valid) {
        this.resetScanningAllocation();
      }
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.CONFIRM_PROGRAM_SELECTED, {
        canSelectProgram: valid,
        program: e
      });
    },
    resetScanningAllocation: function resetScanningAllocation() {
      if (this.settingsModel.CompanySettings.AllowInvoiceScanning && this.paymentInvoiceId <= 0) {
        this.costCentersForScan = null;
        this.invoiceInformationModel.HasAllocationForScan = false;
      }
    },
    updateAllocationModel: function updateAllocationModel(type, updatedModel, validAllocations) {
      switch (type) {
        case 'CostCenters':
          this.ccAllocations.AllocationList = updatedModel;
          this.ccAllocations.WasReset = true;
          this.pairsAllocations.WasReset = false;
          this.ccAllocations.ValidAllocations = validAllocations;
          break;
        case 'Pairs':
          this.pairsAllocations.AllocationList = updatedModel;
          this.pairsAllocations.WasReset = true;
          this.ccAllocations.WasReset = false;
          this.pairsAllocations.ValidAllocations = validAllocations;
          break;
        case 'Categories':
          this.categoriesAllocations.AllocationList = updatedModel;
          this.categoriesAllocations.ValidAllocations = validAllocations;
          break;
      }
    },
    updateAllocationForScan: function updateAllocationForScan(e) {
      this.costCentersForScan = e.data && e.data.costCenters.map(function (i) {
        var cc = {
          Id: i.key,
          Name: i.value
        };
        return cc;
      });
      this.pairsForScan = e.data && e.data.pairs.map(function (i) {
        var pair = {
          Id: i.key,
          Name: i.value
        };
        return pair;
      });
      this.invoiceInformationModel.Errors.AllocationMissing = false;
    },
    mapAllocation: function mapAllocation() {
      var allocationParameter = {};
      allocationParameter.CostCenters = this.ccAllocations.AllocationList;
      allocationParameter.BuAndCcPairs = this.pairsAllocations.AllocationList;
      allocationParameter.Categories = this.categoriesAllocations.AllocationList;
      allocationParameter.InvoiceAmount = this.invoiceInformationModel.InvoiceAmount;
      allocationParameter.VATAmount = this.invoiceInformationModel.VATGSTAmount;
      allocationParameter.ProgramId = this.invoiceInformationModel.ProgramID;
      return allocationParameter;
    },
    checkApprovalCheckBox: function checkApprovalCheckBox(e) {
      if (this.approvalCheckboxOptions.status && this.approvalCheckboxOptions.status === true) {
        this.approvalCheckboxError = false;
      }
    },
    checkAdditionalInvoiceConfirmationBox: function checkAdditionalInvoiceConfirmationBox(e) {
      if (this.additionalInvoiceConfirmationOptions.status && this.additionalInvoiceConfirmationOptions.status === true) {
        this.additionalInvoiceConfirmationError = false;
      }
    },
    updatePOItemsAfterAllocationChange: function updatePOItemsAfterAllocationChange() {
      var _this29 = this;
      var allocationParameter = this.mapAllocation();
      this.allocationsStore().getPurchaseOrderItems(allocationParameter).then(function (response) {
        if (response.Data) {
          _this29.purchaseOrder.PO.events[0].lineItems = JSON.parse(response.Data); // bu/cc allocation
          _this29.purchaseOrder.PO.events[0].total = _this29.invoiceInformationModel.InvoiceAmount;
          _this29.purchaseOrder.PO.vat = 0;
          _this29.purchaseOrder.PO.events[0].lineItems.map(function (item, index) {
            if (item.amountTypeId === 1) {
              _this29.purchaseOrder.PO.vat += item.amountTypeValue;
            }
          });
          _this29.$nextTick(function () {
            _this29.recalculatePO();
          });
        }
      });
    },
    recalculatePO: function recalculatePO() {
      var _this30 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee11() {
        var eventsSectionData;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!(_this30.useHighLevelAllocation === false)) {
                _context11.next = 4;
                break;
              }
              __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].I2P.RECALCULATE_PO, {});
              _context11.next = 10;
              break;
            case 4:
              // High Level Allocation
              eventsSectionData = new __WEBPACK_IMPORTED_MODULE_30__EventsSection_EventsSection_js__["a" /* default */](_this30.dependencies);
              _context11.next = 7;
              return eventsSectionData.recalculatePoAndReturnIt(_this30.purchaseOrder.PO, _this30.settingsModel.CompanySettings, _this30.isP2PInvoiceWithAddEditItems);
            case 7:
              _this30.purchaseOrder.PO = _context11.sent;
              _this30.purchaseOrder.PO.events = _this30.store().getEventsWithOrderedLineItems(_this30.purchaseOrder.PO.events);
              _this30.updateSnaphot();
            case 10:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    updateSnaphot: function updateSnaphot() {
      if (!this.settingsModel.CompanySettings.EditingInvoiceScan && this.settingsModel.CompanySettings.AllowInvoiceScanning) {
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_5__core_events_events___default.a.I2P.UPDATE_SNAPSHOT, {
          total: +this.invoiceInformationModel.InitialTotalAmount,
          totalVATGST: +this.VATAmount,
          programCurrencyCode: this.purchaseOrder.PO.programDetails.currencyCode,
          isP2PWorkflow: false
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_5__core_events_events___default.a.I2P.UPDATE_SNAPSHOT, {
          total: +this.invoiceInformationModel.InvoiceAmount,
          totalVATGST: +this.invoiceInformationModel.VATGSTAmount,
          programCurrencyCode: this.purchaseOrder.PO.programDetails.currencyCode,
          isP2PWorkflow: this.isP2PInvoice
        });
      }
    },
    onCloseDifferentAmountModal: function onCloseDifferentAmountModal() {
      this.showDifferentAmountWarning = false;
    },
    onConfirmDifferentAmountModal: function onConfirmDifferentAmountModal() {
      this.showDifferentAmountWarning = false;
      this.modals.allowDifferentAmount = true;
      this.save(true);
    },
    onConfirmUnitPriceAtZero: function onConfirmUnitPriceAtZero() {
      this.showUnitPriceAtZeroWarning = false;
      this.modals.allowItemsWithZeroUnitPrice = true;
      this.save(true);
    },
    onPOAmountChanged: function onPOAmountChanged(e) {
      // this.notInvoicedAmount += e.total - e.previousTotal
    },
    isApprovalNoteValid: function isApprovalNoteValid() {
      return !this.settingsModel.CompanySettings.IsApprovalNoteRequired || (this.invoiceInformationModel.ApproveNote || '') !== '' && this.invoiceInformationModel.ApproveNote !== this.settingsModel.CompanySettings.ApprovalNotePlaceholder;
    },
    onApprovalNoteChange: function onApprovalNoteChange() {
      if (this.approvalNoteError && this.isApprovalNoteValid()) {
        this.approvalNoteError = false;
      }
    }
  }
});
Object(__WEBPACK_IMPORTED_MODULE_3__override__["a" /* attach */])();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "mhc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    rows: Array,
    fromPage: String
  },
  data: function data() {
    return {
      showModal: false,
      modalContent: ''
    };
  },
  methods: {
    validateInvoices: function validateInvoices() {
      var _this = this;
      if (!this.rows || this.rows.length > 1) {
        this.modalContent = 'You can only edit one invoice at a time. Please deselect all invoices except for one and try again.';
        this.showModal = true;
      } else {
        this.api.forms.post(this.api.$.invoice.list.validateEditInvoice, {
          isAll: false,
          paymentInvoiceIDs: JSON.stringify([this.rows[0].data.PaymentInvoiceID])
        }).then(function (result) {
          if (result && result.data) {
            var errors = JSON.parse(result.data.Data);
            if (result.data.SuccessMessage !== 'Success') {
              _this.modalContent = errors.BaseValidationResult.Data;
              _this.showModal = true;
            } else {
              _this.redirectToEditInvoice();
            }
          }
        });
      }
    },
    redirectToEditInvoice: function redirectToEditInvoice() {
      if (this.rows && this.rows.length === 1) {
        this.$router.push('/d/Invoices/edit?id=' + this.rows[0].data.PaymentInvoiceID + '&fromPage=' + this.fromPage);
      }
    }
  }
});

/***/ }),

/***/ "mil4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mmgJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-rejection-reason-overlay"},[_c('p',{staticClass:"small"},[_c('strong',[_vm._v("Card was declined by:")]),_vm._v(" "+_vm._s(_vm.card.RejectedBy)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"small"},[_c('strong',[_vm._v("Decline reason:")]),_vm._v(" "+_vm._s(_vm.card.RejectReason)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mnjY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("haC8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d7921ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("g0q4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d7921ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mo7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// SPRT-18874 — a cancelled program takes no new invoices. Shared by the program field (flagged the moment
// a cancelled program is selected) and by validate() (refuses the save/submit) so both read identically.
/* harmony default export */ __webpack_exports__["a"] = ({
  cancelledProgramMessage: 'This program has been cancelled. Invoices cannot be submitted against a cancelled program.'
});

/***/ }),

/***/ "n/VL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-field-group',
  props: {
    fieldLabel: String,
    required: Boolean,
    helpText: String,
    helptipHeader: String,
    helptipBody: String,
    error: Boolean
  },
  data: function data() {
    return {
      showHelp: false,
      showIcon: 'fas fa-question-circle',
      hideIcon: 'far fa-times-circle'
    };
  },
  methods: {
    toggleHelp: function toggleHelp() {
      this.showHelp = !this.showHelp;
    }
  }
});

/***/ }),

/***/ "nBkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INVOICE_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SUBMITTED; });
/* unused harmony export SUBMITTED_PENDING */
/* unused harmony export SUBMITTED_APPROVED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DECLINED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REJECTED; });
/* unused harmony export PAYMENT_REJECTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPROVED; });
/* unused harmony export SCHEDULED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAID; });
/* unused harmony export PARTIAL */
/* unused harmony export OVERDUE_APPROVED */
/* unused harmony export OVERDUE_PENDING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OVERDUE; });
/* unused harmony export PARTIALLY_SCHEDULED */
/* unused harmony export PARTIALLY_SCHEDULED_OVERDUE */
/* unused harmony export SCHEDULED_OVERDUE */
/* unused harmony export PARTIALLY_PAID */
/* unused harmony export PARTIALLY_PAID_OVERDUE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PARTIALLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return metaStatuses; });
/* unused harmony export metaStatusFilterOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cannotCancelReasons; });
/* unused harmony export isCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hideForCancelledOrRejected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return customForCancelledOrRejected; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

var INVOICE_STATUS = 'PaymentStatus';
var SUBMITTED = 'Submitted';
var SUBMITTED_PENDING = 'Submitted - Pending Approval';
var SUBMITTED_APPROVED = 'Submitted - Approved';
var DECLINED = 'Declined';
var REJECTED = 'Rejected';
var PAYMENT_REJECTED = 'Payment Rejected';
var PENDING = 'Pending';
var APPROVED = 'Approved';
var SCHEDULED = 'Scheduled';
var PAID = 'Paid';
var PARTIAL = 'Partial';
var OVERDUE_APPROVED = 'Overdue - Approved';
var OVERDUE_PENDING = 'Overdue - Pending Approval';
var OVERDUE = 'Overdue';
var PARTIALLY_SCHEDULED = 'Partially Scheduled';
var PARTIALLY_SCHEDULED_OVERDUE = 'Partially Scheduled - Overdue';
var SCHEDULED_OVERDUE = 'Scheduled - Overdue';
var PARTIALLY_PAID = 'Partially Paid';
var PARTIALLY_PAID_OVERDUE = 'Partially Paid - Overdue';
var PARTIALLY = 'Partially';
var NONE = 'none';
var metaStatuses = [PENDING, SUBMITTED, APPROVED, SCHEDULED, PAID, PARTIAL, OVERDUE_APPROVED, OVERDUE_PENDING];
var metaStatusFilterOptions = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, NONE, {}), PENDING, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, INVOICE_STATUS, [SUBMITTED_PENDING, SUBMITTED_APPROVED, SCHEDULED, SCHEDULED_OVERDUE, PARTIALLY_SCHEDULED, PARTIALLY_SCHEDULED_OVERDUE, OVERDUE_APPROVED, OVERDUE_PENDING, DECLINED, PAYMENT_REJECTED])), SUBMITTED, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, INVOICE_STATUS, [SUBMITTED_PENDING, SUBMITTED_APPROVED])), APPROVED, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, INVOICE_STATUS, [SUBMITTED_APPROVED])), SCHEDULED, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, INVOICE_STATUS, [SCHEDULED, SCHEDULED_OVERDUE, PARTIALLY_SCHEDULED, PARTIALLY_SCHEDULED_OVERDUE])), PAID, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, INVOICE_STATUS, [PAID, PARTIALLY_PAID, PARTIALLY_PAID_OVERDUE])), PARTIAL, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, INVOICE_STATUS, [PARTIALLY_SCHEDULED, PARTIALLY_SCHEDULED_OVERDUE, PARTIALLY_PAID, PARTIALLY_PAID_OVERDUE])), OVERDUE, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, INVOICE_STATUS, [OVERDUE_APPROVED, OVERDUE_PENDING, PARTIALLY_SCHEDULED_OVERDUE, SCHEDULED_OVERDUE, PARTIALLY_PAID_OVERDUE]));
var state = [];
metaStatuses.map(function (status) {
  return state.push({
    name: status,
    active: false
  });
});
function existingValues(filter, f, metaStatus) {
  var existingNotMeta = (filter[f] && filter[f].filter && filter[f].filter.split('_') || []).filter(function (k) {
    return !~metaStatusFilterOptions[metaStatus][f].indexOf(k);
  });
  var existingMeta = [];
  metaStatusFilterOptions[metaStatus][f].length === 1 && state.filter(function (status) {
    return status.active;
  }).map(function (status) {
    return existingMeta.push.apply(existingMeta, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(metaStatusFilterOptions[status.name][f]));
  });
  return [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(existingNotMeta), existingMeta);
}
var StatusesConfig = {
  get additionalFilters() {
    var filters = [];
    Object.keys(metaStatusFilterOptions).forEach(function (k) {
      return filters.push.apply(filters, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(Object.keys(metaStatusFilterOptions[k])));
    });
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(new Set(filters));
  },
  filters: function filters(metaStatuses) {
    var existingFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var query = arguments.length > 2 ? arguments[2] : undefined;
    var filter = _objectSpread({}, existingFilter);
    metaStatuses.forEach(function (metaStatus) {
      var isActive = StatusesConfig.isActiveFilter(metaStatus, existingFilter).active;
      var foundStatus = state.find(function (status) {
        return status.name === metaStatus;
      }) || {};
      isActive ? foundStatus.active = false : foundStatus.active = true;
      Object.keys(metaStatusFilterOptions[metaStatus]).forEach(function (f) {
        var existing = query ? [] : existingValues(filter, f, metaStatus);
        filter[f] = {
          filter: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(new Set([].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(existing), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(!isActive && metaStatusFilterOptions[metaStatus][f] || [])))).join('_')
        };
        filter[f] = filter[f].filter ? filter[f] : null;
      });
    });
    return filter;
  },
  isActiveFilter: function isActiveFilter(metaStatus) {
    var existingFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var query = arguments.length > 2 ? arguments[2] : undefined;
    if (query) {
      return {
        active: ~query.indexOf(metaStatus),
        partial: false
      };
    }
    var isActive = true;
    var isPartiallyActive = true;
    Object.keys(metaStatusFilterOptions[metaStatus]).forEach(function (f) {
      isActive = existingFilter[f] ? isActive && metaStatusFilterOptions[metaStatus][f].every(function (s) {
        return ~existingFilter[f].filter.split('_').indexOf(s);
      }) : false;
      isPartiallyActive = existingFilter[f] ? !isActive && metaStatusFilterOptions[metaStatus][f].some(function (s) {
        return ~existingFilter[f].filter.split('_').indexOf(s);
      }) && metaStatusFilterOptions[metaStatus][f].length > 1 : false;
    });
    return {
      active: isActive,
      partial: isPartiallyActive
    };
  }
};
/* harmony default export */ __webpack_exports__["k"] = (StatusesConfig);
var cannotCancelReasons = {
  'Cancelled': 'This invoice is already cancelled.',
  'NoPermission': 'You do not have permission to cancel invoices.',
  'NotCreatedByLogged': 'This invoice cannot be cancelled. It can only be cancelled by the client.',
  'HasPayments': 'This invoice cannot be cancelled. A payment has already been made against it.',
  'ProgramClosed': 'You cannot cancel an invoice for a Closed program, please reopen the program and try again.'
};
var isCancelled = function isCancelled(invoice) {
  return invoice[0] && invoice[0].data.PaymentStatus === 'Cancelled';
};
var hideForCancelledOrRejected = function hideForCancelledOrRejected(params) {
  return !params.data ? null : params.data.PaymentStatus === 'Declined' || params.data.PaymentStatus === 'Cancelled' ? null : params.data[params.colDef.field];
};
var customForCancelledOrRejected = function customForCancelledOrRejected(params) {
  return !params.data ? null : params.data.PaymentStatus === 'Declined' || params.data.PaymentStatus === 'Cancelled' || params.data.PaymentStatus === 'Payment Rejected' ? params.data.PaymentStatus : params.data.PaymentStatus === 'Review Needed' || params.data.PaymentStatus === 'Pending Scan' || params.data.PaymentStatus < 0 ? '' : params.data[params.colDef.field];
};

/***/ }),

/***/ "nIm4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("eLfk");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e983937a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("fsU0");
function injectStyle (ssrContext) {
  __webpack_require__("F1G1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e983937a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e983937a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nPXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__("NM/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__core_events_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Card_transactions_model_js__ = __webpack_require__("Hn6R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Card_envelopes_model__ = __webpack_require__("JKEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modules_Programs_Card_history_model_js__ = __webpack_require__("2fKY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modules_Programs_Card_cards_model_js__ = __webpack_require__("iXO6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modules_Programs_Card_account_statements_model_js__ = __webpack_require__("4xzk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddCard_vue__ = __webpack_require__("11RA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AccountRefillSettings_vue__ = __webpack_require__("Rbff");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AddFunding_vue__ = __webpack_require__("g8Y0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RejectCard_vue__ = __webpack_require__("QAUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ApprovalNeededUsers_vue__ = __webpack_require__("ygWI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modules_Dashboard_widgets_ApprovalNeeded_approve_dialog__ = __webpack_require__("u8Yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_modules_Programs_Card_envelopes_RejectEnvelope_vue__ = __webpack_require__("HePg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__RejectCardFunding_vue__ = __webpack_require__("sXLw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__RejectCardRefill_vue__ = __webpack_require__("dEO9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__RejectCardDailySpendLimit_vue__ = __webpack_require__("Fke0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CardSettings_vue__ = __webpack_require__("/6HA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__CloseAccount_vue__ = __webpack_require__("jACo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_modules_Programs_Card_transactions_CreateEnvelope_vue__ = __webpack_require__("coox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_modules_Programs_Card_transactions_ReconcileTransaction_vue__ = __webpack_require__("Yqmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_modules_Programs_Card_transactions_CandidateSelector__ = __webpack_require__("jTz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__core_api_receiptScans__ = __webpack_require__("X3jq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__core_receiptScan_receiptScanPoller__ = __webpack_require__("N9pM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__core_receiptScan_imageCompression__ = __webpack_require__("D1Zk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__CardRejectInfo_vue__ = __webpack_require__("RoRd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__CardStatus_vue__ = __webpack_require__("1t90");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__RequestPhysicalCard_vue__ = __webpack_require__("v86b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_modules_Programs_Card_envelopes_AddTransactionNumber__ = __webpack_require__("0cyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__CardAddFunds_vue__ = __webpack_require__("/roU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ReturnFundsToAccount_vue__ = __webpack_require__("+i84");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__CardRefill_vue__ = __webpack_require__("5mev");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__CardDailySpendLimit_vue__ = __webpack_require__("eFhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_modules_Programs_Card_list_AccountingSystemSettings_vue__ = __webpack_require__("P2/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__CardAdditionalUsers_vue__ = __webpack_require__("EK88");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__ShowCardNumber_vue__ = __webpack_require__("R8ny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__RequestPhysicalBatch_vue__ = __webpack_require__("oDR5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_modules_Programs_Card_cards__ = __webpack_require__("z3J+");




function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









































var cardMethods = __WEBPACK_IMPORTED_MODULE_44__components_modules_Programs_Card_cards__["default"].methods;

// reload page after browser back pressed
function handlePopState(event) {
  if (document.location.href.includes('list')) {
    window.location.reload();
  }
}
window.addEventListener('popstate', handlePopState);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_5__components_Grid__["a" /* default */],
    CreateEnvelope: __WEBPACK_IMPORTED_MODULE_25__components_modules_Programs_Card_transactions_CreateEnvelope_vue__["a" /* default */],
    Reconcile: __WEBPACK_IMPORTED_MODULE_26__components_modules_Programs_Card_transactions_ReconcileTransaction_vue__["a" /* default */],
    CandidateSelector: __WEBPACK_IMPORTED_MODULE_27__components_modules_Programs_Card_transactions_CandidateSelector__["a" /* default */],
    AddCard: __WEBPACK_IMPORTED_MODULE_13__AddCard_vue__["a" /* default */],
    AccountRefillSettings: __WEBPACK_IMPORTED_MODULE_14__AccountRefillSettings_vue__["a" /* default */],
    AddFunding: __WEBPACK_IMPORTED_MODULE_15__AddFunding_vue__["a" /* default */],
    RejectCard: __WEBPACK_IMPORTED_MODULE_16__RejectCard_vue__["a" /* default */],
    RejectCardFunding: __WEBPACK_IMPORTED_MODULE_20__RejectCardFunding_vue__["a" /* default */],
    RejectCardRefill: __WEBPACK_IMPORTED_MODULE_21__RejectCardRefill_vue__["a" /* default */],
    RejectCardDailySpendLimit: __WEBPACK_IMPORTED_MODULE_22__RejectCardDailySpendLimit_vue__["a" /* default */],
    ApprovalNeededUsers: __WEBPACK_IMPORTED_MODULE_17__ApprovalNeededUsers_vue__["a" /* default */],
    ApproveDialog: __WEBPACK_IMPORTED_MODULE_18__components_modules_Dashboard_widgets_ApprovalNeeded_approve_dialog__["default"],
    RejectEnvelope: __WEBPACK_IMPORTED_MODULE_19__components_modules_Programs_Card_envelopes_RejectEnvelope_vue__["a" /* default */],
    CardSettings: __WEBPACK_IMPORTED_MODULE_23__CardSettings_vue__["a" /* default */],
    CloseAccount: __WEBPACK_IMPORTED_MODULE_24__CloseAccount_vue__["a" /* default */],
    CardRejectInfo: __WEBPACK_IMPORTED_MODULE_32__CardRejectInfo_vue__["a" /* default */],
    CardStatus: __WEBPACK_IMPORTED_MODULE_33__CardStatus_vue__["a" /* default */],
    RequestPhysicalCard: __WEBPACK_IMPORTED_MODULE_34__RequestPhysicalCard_vue__["a" /* default */],
    AddTransactionNumber: __WEBPACK_IMPORTED_MODULE_35__components_modules_Programs_Card_envelopes_AddTransactionNumber__["a" /* default */],
    CardAddFunds: __WEBPACK_IMPORTED_MODULE_36__CardAddFunds_vue__["a" /* default */],
    ReturnFunds: __WEBPACK_IMPORTED_MODULE_37__ReturnFundsToAccount_vue__["a" /* default */],
    RefillSettings: __WEBPACK_IMPORTED_MODULE_38__CardRefill_vue__["a" /* default */],
    CardDailySpendLimit: __WEBPACK_IMPORTED_MODULE_39__CardDailySpendLimit_vue__["a" /* default */],
    AccountingSystemSettings: __WEBPACK_IMPORTED_MODULE_40__components_modules_Programs_Card_list_AccountingSystemSettings_vue__["a" /* default */],
    RequestPhysicalBatch: __WEBPACK_IMPORTED_MODULE_43__RequestPhysicalBatch_vue__["a" /* default */],
    CardAdditionalUsers: __WEBPACK_IMPORTED_MODULE_41__CardAdditionalUsers_vue__["a" /* default */],
    ShowCardNumber: __WEBPACK_IMPORTED_MODULE_42__ShowCardNumber_vue__["a" /* default */]
  },
  data: function data() {
    var _this = this;
    return {
      divName: '',
      showTransactionsTab: true,
      showEnvelopesTab: false,
      showCardHistoryTab: false,
      showCardsTab: false,
      showAccountStatementsTab: false,
      divisions: [],
      selectedAccountId: null,
      selectedProgram: 0,
      selectedSupplier: 0,
      fields: [],
      formKey: '',
      splitAmounts: [],
      noteText: '',
      mediaFilesPath: '',
      filteredAttachments: [],
      // PRODUCTDEV-5772 — supporting documents, kept separate from receipts.
      additionalDocumentsFiles: [],
      receiptIncomplete: false,
      requireReceiptDescription: Boolean,
      descriptionIncomplete: false,
      savePressed: false,
      selectedDivisionName: '...',
      modelTransactions: __WEBPACK_IMPORTED_MODULE_8__Card_transactions_model_js__["a" /* default */],
      modelTransactionsAccount: _objectSpread({}, __WEBPACK_IMPORTED_MODULE_8__Card_transactions_model_js__["a" /* default */]),
      modelEnvelopes: __WEBPACK_IMPORTED_MODULE_9__Card_envelopes_model__["a" /* default */],
      modelCardHistory: __WEBPACK_IMPORTED_MODULE_10__components_modules_Programs_Card_history_model_js__["a" /* default */],
      modelCards: __WEBPACK_IMPORTED_MODULE_11__components_modules_Programs_Card_cards_model_js__["a" /* default */],
      modelCardsAccount: _objectSpread({}, __WEBPACK_IMPORTED_MODULE_11__components_modules_Programs_Card_cards_model_js__["a" /* default */]),
      modelAccountStatements: __WEBPACK_IMPORTED_MODULE_12__components_modules_Programs_Card_account_statements_model_js__["a" /* default */],
      sort: {
        TransactionDateFormatted: 'desc'
      },
      sortHistory: {
        Date: 'desc'
      },
      sortEnvelopes: {
        CreatedDate: 'desc'
      },
      sortCards: {
        CardNumber: 'desc'
      },
      sortStatements: {
        CreatedDate: 'desc'
      },
      hasData: false,
      headerData: {
        Funded: '',
        Allocated: '',
        Available: '',
        Pending: ''
      },
      cardsList: [{}],
      account: {},
      accountSettings: {
        AccountingSystem: {}
      },
      division: {},
      accountRefillSettings: {
        Visible: false,
        ActionDisabled: true
      },
      closeObj: {},
      selectedRows: [],
      selectedAll: null,
      programName: '',
      showCreateEnvelope: false,
      showReconcile: false,
      receiptScanEnabled: __WEBPACK_IMPORTED_MODULE_31__core_feature_flags_feature_flags__["a" /* default */].receiptScanPrefill,
      // PRODUCTDEV-5788 — account-scoped table: a single division is in context, so gate the
      // Submit Receipt button on THAT division's receipt-scan mode. Default false; set true in
      // getAccountData() once the mode resolves and is not "No Receipt Capture".
      accountScanEnabled: false,
      uploadingReceipt: false,
      uploadProgressPct: 0,
      showSubmitReceiptModal: false,
      pendingReceiptFile: null,
      // PRODUCTDEV-5804 — object URL for the pending file so the chip link carries a real href
      // (right-click "Open in new tab"). Lifecycle owned by the pendingReceiptFile watcher.
      pendingReceiptObjectUrl: '',
      showCandidateSelector: false,
      candidateSelectorReceiptId: null,
      candidateSelectorCandidates: [],
      candidateSelectorRowVersion: null,
      candidateSelectorAutoLinked: false,
      candidateSelectorAutoFill: null,
      candidateSelectorLoading: false,
      // True while a SUBMIT-click match POST is in flight. Used to suppress the
      // dispose-on-cancel path in handleCandidateSelectorClose since ed-modal
      // auto-emits @close immediately after @confirm (edModal/index.vue:161-163).
      candidateSelectorMatching: false,
      candidateSelectorLocalImageUrl: null,
      candidateSelectorLocalImageType: null,
      // Legacy /UploadReceiptReconcile response captured at SUBMIT time so
      // we can hand the canonical TransactionFiles metadata (PathWithName,
      // MediaFile, FullPath) to ReconcileTransaction once the user picks a
      // match. Without this the saved reconcile has no TransactionFiles row,
      // and reopen-view crashes on Substring(0,-1) of an empty path.
      pendingLegacyReceipt: null,
      activePoller: null,
      pollInterval: null,
      isActive: false,
      showApprovalUsers: false,
      approvalUsersData: [],
      showApproveDialog: false,
      reconcileAction: 'create',
      editAuth: null,
      selectedBu: [],
      selectedCc: [],
      selectedBuAndCcPair: [],
      selectedCategory: [],
      referenceId: [],
      descriptions: [],
      splitCounter: 1,
      buAndCcPairIncomplete: [],
      buIncomplete: [],
      ccIncomplete: [],
      categoryIncomplete: [],
      itemIds: [],
      refreshScheduled: false,
      envelope: {},
      transaction: {},
      highlightedObjectId: '',
      rowClasses: {
        'row-highlight': function rowHighlight(params) {
          return params.data && (params.data.Id === _this.highlightedObjectId || params.data.EnvelopeId === _this.highlightedObjectId);
        }
      },
      showCardRejectInfo: false,
      card: [],
      noTooltipFields: ['TransactionStatus', 'ReconciliationStatus', 'TransactionNumber', 'EnvelopeNumber', 'EnvelopeStatus'],
      showShowCardNumber: false,
      showCardStatus: {
        showModal: false
      },
      helpDeskTicketNumber: '',
      showAddCard: false,
      showRequestPhysicalCardOpen: {
        showModal: false
      },
      showRequestPhysicalBatchOpen: {
        showModal: false,
        dataFlag: '',
        data: null
      },
      mailingAddress: {},
      cardStatus: '',
      divisionName: '',
      divisionsName: '',
      cardDivisionId: null,
      modalTitle: '',
      selectedObj: [],
      waitingApprovalStatuses: ['Open - Waiting Approval', 'Exported - Waiting Approval', 'Posted - Waiting Approval'],
      rejectedStatuses: ['Rejected', 'Declined', 'Exported - Rejected', 'Posted - Rejected', 'Exported - Declined', 'Posted - Declined'],
      addFundsErrors: false,
      showAddFunds: false,
      fundingAmount: 0,
      showReturnFundsToAccount: false,
      returnFunds: '',
      isRefillOpen: {
        showModal: false
      },
      isDailySpendLimitOpen: {
        showModal: false
      },
      showAccountingSystemSettings: false,
      showCardAdditionalUsers: false,
      additionalUsers: [],
      disabledResendButtons: {},
      pushingToAccountingSystem: false,
      hasPhysicalCards: false,
      uploadFinished: true
    };
  },
  created: function created() {
    var _this2 = this;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.selectedAccountId = _this2.$route.query.AccountId;
            _this2.divisionName = _this2.singularize(_this2.$root.getUser.settings.Labels.DivisionName);
            _this2.divisionsName = _this2.$root.getUser.settings.Labels.DivisionsName;
            _this2.programName = _this2.singularize(_this2.$root.getUser.settings.Labels.ProgramLabel);
            _this2.modelTransactionsAccount.ProgramName.label = _this2.programName;
            _this2.modelTransactionsAccount.Division = '_';
            _this2.modelEnvelopes.ProgramName.label = _this2.programName;
            if (!_this2.$root.getUser.settings.HasBusinessUnit) {
              delete _this2.modelEnvelopes.BusinessUnit;
            }
            _this2.modelCardsAccount.Division = '_';
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off('status-changed');
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on('status-changed', function (cardId) {
              _this2.refreshCardWithDetails(cardId.data);
            });
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off('refill');
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on('refill', function (cardId) {
              _this2.refreshCardWithDetails(cardId.data);
            });
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off('dailySpendLimit');
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on('dailySpendLimit', function (cardId) {
              _this2.refreshCardWithDetails(cardId.data);
            });
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off('funds-changed');
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on('funds-changed', function (cardId) {
              _this2.refreshCardWithDetails(cardId.data);
              _this2.getAccountData();
            });
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_7__core_events_events___default.a.EVEDPAY_CARDS.OPEN_ENVELOPE);
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_7__core_events_events___default.a.EVEDPAY_CARDS.OPEN_ENVELOPE, function (envelope) {
              _this2.envelope = envelope.data;
              _this2.showCreateEnvelope = true;
            });
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off('receipt-scan-started');
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on('receipt-scan-started', function (payload) {
              _this2.handleReceiptScanStarted(payload.data);
            });
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_7__core_events_events___default.a.EVEDPAY_CARDS.OPEN_RECONCILE);
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_7__core_events_events___default.a.EVEDPAY_CARDS.OPEN_RECONCILE, _this2.handleTransaction);
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off('transaction-reconciled');
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$on('transaction-reconciled', function (transactionId) {
              if (_this2.transaction && _this2.transaction.data) {
                var matchedTransaction = _this2.transaction.data.Id === transactionId.data;
                if (matchedTransaction) {
                  var transactionNumber = _this2.transaction.data.TransactionNumber;
                  _this2.$notifications.notify({
                    message: "Transaction ".concat(transactionNumber, " was updated!"),
                    type: 'info',
                    placement: {
                      from: 'top',
                      align: 'center'
                    }
                  });
                }
              }
            });
            _this2.highlightedObjectId = localStorage.getItem('row-highlight');
            __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$off('physicalCardRequested');
            _this2.initializeData();
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  activated: function activated() {
    this.showCreateEnvelope = false;
    this.envelope = {};
    this.showTransactions();
    if (this.$route.query.StatementsTab) {
      this.showAccountStatements();
      var newQuery = _objectSpread({}, this.$route.query);
      delete newQuery.StatementsTab;
      this.$router.replace({
        query: newQuery
      });
    }
  },
  computed: {
    // PRODUCTDEV-5804 — icon glyph + color for the pending receipt chip (ed-upload palette).
    pendingReceiptIcon: function pendingReceiptIcon() {
      var name = (this.pendingReceiptFile && this.pendingReceiptFile.name || '').toLowerCase();
      if (/\.pdf$/.test(name)) return {
        iconClass: 'fa-file-pdf',
        color: '#cb0404'
      };
      if (/\.(png|jpe?g|gif|webp)$/.test(name)) return {
        iconClass: 'fa-file-image',
        color: '#4598d9'
      };
      return {
        iconClass: 'fa-file',
        color: '#acacac'
      };
    },
    selectedId: function selectedId() {
      return this.transaction && this.transaction.data && this.transaction.data.PaymentInvoiceID;
    },
    isUserAdmin: function isUserAdmin() {
      // OR EvedPayCardViewReconcileClose so the reconcile/view admin-equivalent gets
      // the same affordances as EvedPayCardAdministrator — matches the legacy EPC pattern
      // already used by hasAccountPermission gates throughout this template.
      var perms = this.$user.$.userPermissions;
      if (perms.includes('EvedPayCardAdministrator') || perms.includes('EvedPayCardViewReconcileClose')) {
        return true;
      }
      return false;
    },
    // PRODUCTDEV-5574 — preserves the pre-existing receipt-upload rules for this view too. See
    // Card-transactions/index.vue for the rationale.
    receiptEditAllowed: function receiptEditAllowed() {
      if (this.isUserAdmin) return true;
      var t = this.transaction && this.transaction.data;
      if (!t || !t.TransactionStatus) return false;
      var inEnvelopeReadonly = ['In Envelope', 'Exported', 'Posted'].includes(t.TransactionStatus);
      if (!inEnvelopeReadonly) return t.ReconciliationStatus !== 'Approved';
      if (t.EnvelopeStatus === 'Draft') return true;
      if (t.ReconciliationStatus === 'Approved') return false;
      return this.isUserInApprovalList();
    },
    isEvedAdmin: function isEvedAdmin() {
      return !!(this.$user && this.$user.$ && this.$user.$.user && this.$user.$.user.IsEvedAdmin);
    },
    isCardStatusSubmitDisabled: function isCardStatusSubmitDisabled() {
      var isLockUnlock = this.cardStatus === 'lock' || this.cardStatus === 'unlock';
      return isLockUnlock && this.isEvedAdmin && !this.helpDeskTicketNumber.trim();
    },
    filter: function filter() {
      if (this.hasAccountPermission('EvedPayCardAdministrator') || this.hasAccountPermission('EvedPayCardViewReconcileClose')) {
        return {
          AccountId: {
            filter: this.$route.query.AccountId
          }
        };
      } else {
        return {
          HolderUserId: {
            filter: this.$user.$.user.UserID
          },
          AccountId: {
            filter: this.$route.query.AccountId
          }
        };
      }
    },
    showApproveButton: function showApproveButton() {
      return this.isUserInApprovalList();
    },
    showRejectButton: function showRejectButton() {
      return this.isUserInApprovalList();
    },
    filterHistory: function filterHistory() {
      return {
        AccountID: {
          filter: this.$route.query.AccountId
        }
      };
    },
    filterCards: function filterCards() {
      return {
        AccountId: {
          filter: this.$route.query.AccountId
        }
      };
    },
    filterStatements: function filterStatements() {
      return {
        AccountId: {
          filter: this.$route.query.AccountId
        }
      };
    },
    gridTabKey: function gridTabKey() {
      return "".concat(this.showTransactionsTab, " ").concat(this.showEnvelopesTab, " ").concat(this.showCardHistoryTab, " ").concat(this.showCardsTab, " ").concat(this.showAccountStatementsTab, " ").concat(this.$route.query.AccountId);
    },
    processedSelectedObj: function processedSelectedObj() {
      return this.selectedObj[0] || {};
    },
    cardForShowNumber: function cardForShowNumber() {
      var obj = this.processedSelectedObj;
      var fullCard = obj.Id ? this.cardsList.find(function (c) {
        return c.Id === obj.Id;
      }) : null;
      return {
        Id: obj.Id,
        AccountId: obj.AccountId,
        CardNumber: obj.CardNumber,
        Holder: obj.Holder || '',
        NameOnCard: obj.NameOnCard || fullCard && fullCard.NameOnCard || '',
        ExpirationDate: fullCard && fullCard.ExpirationDate || obj.ExpirationDate || ''
      };
    },
    lockUnlockButtonText: function lockUnlockButtonText() {
      if (this.selectedObj.length > 0) {
        var cardStatus = this.selectedObj[0].CardStatus;
        switch (cardStatus) {
          case 'Active':
            return 'Lock Card';
          case 'Locked':
            return 'Unlock Card';
          case 'Locked - Lost/Stolen':
            return 'Unlock Card';
          case 'Closed':
            return 'Lock Card';
          default:
            return 'Lock Card';
        }
      }
      return 'Lock Card';
    }
  },
  mounted: function mounted() {
    this.isActive = true;
    this.$nextTick(function () {
      var summaryCardFooter = document.querySelectorAll('.dawn-card-footer');
      summaryCardFooter.forEach(function (el) {
        el.style.pointerEvents = 'none';
        el.style.zIndex = '-1';
        el.style.opacity = '0';
      });
    });
  },
  watch: {
    // PRODUCTDEV-5804 — own the pending file's object URL lifecycle (revoke old, create new) so the
    // chip link has a stable href. Covers every assignment site to pendingReceiptFile.
    pendingReceiptFile: function pendingReceiptFile(file) {
      if (this.pendingReceiptObjectUrl) {
        URL.revokeObjectURL(this.pendingReceiptObjectUrl);
        this.pendingReceiptObjectUrl = '';
      }
      if (file) this.pendingReceiptObjectUrl = URL.createObjectURL(file);
    },
    showCreateEnvelope: function showCreateEnvelope(newValue) {
      if (newValue) {
        this.highlightedObjectId = this.envelope.Id;
      }
    },
    selectedAccountId: function selectedAccountId(newValue) {
      this.rememberLastAccount(newValue);
    },
    'showRequestPhysicalBatchOpen.showModal': function () {
      var _showRequestPhysicalBatchOpenShowModal = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee2(newVal) {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!newVal) {
                _context2.next = 4;
                break;
              }
              _context2.next = 3;
              return this.getCards(this.$route.query.AccountId);
            case 3:
              this.showRequestPhysicalBatchOpen.data = this.showRequestPhysicalBatchOpen.dataFlag === 'filtered' ? this.filteredPhysicalCards : this.selectedRows;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function showRequestPhysicalBatchOpenShowModal(_x) {
        return _showRequestPhysicalBatchOpenShowModal.apply(this, arguments);
      }
      return showRequestPhysicalBatchOpenShowModal;
    }(),
    // Revoke the receipt's local objectURL when the Select Transaction modal closes,
    // regardless of which path closed it (X button, auto-link redirect, no-candidates,
    // error). Keeps memory tidy — objectURLs leak until the document is destroyed.
    showCandidateSelector: function showCandidateSelector(newVal) {
      if (!newVal && this.candidateSelectorLocalImageUrl) {
        URL.revokeObjectURL(this.candidateSelectorLocalImageUrl);
        this.candidateSelectorLocalImageUrl = null;
        this.candidateSelectorLocalImageType = null;
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, cardMethods), {}, {
    formatCardHolderLine: function formatCardHolderLine(card) {
      var holderName = card && card.Holder && card.Holder.Name || '';
      var nameOnCard = (card && card.NameOnCard || '').trim();
      if (nameOnCard && nameOnCard !== holderName.trim()) {
        return "".concat(nameOnCard, " | ").concat(holderName);
      }
      return holderName;
    },
    initializeData: function initializeData() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getDivision();
            case 2:
              _context3.next = 4;
              return _this3.getUserDivisions();
            case 4:
              _context3.next = 6;
              return _this3.getCardsAndAccountData();
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    addFunds: function addFunds() {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", cardMethods.addFunds.call(_this4));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    doReturnFunds: function doReturnFunds() {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", cardMethods.doReturnFunds.call(_this5));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    handlePslSettingsSave: function handlePslSettingsSave() {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee6() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this6.$refs.accountingSystemSettingsCmp.save();
            case 2:
              res = _context6.sent;
              _this6.showAccountingSystemSettings = !res;
              return _context6.abrupt("return", res);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    updateAdditionalUsers: function updateAdditionalUsers() {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", cardMethods.updateAdditionalUsers.call(_this7));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    lostStolen: function lostStolen() {
      return cardMethods.lostStolen.call(this);
    },
    getCardsAndAccountData: function getCardsAndAccountData() {
      this.getAccountData();
      this.getCards(this.selectedAccountId);
    },
    isPoolFunding: function isPoolFunding(card) {
      // PRODUCTDEV-5881: a card follows pool funding rules when its account is Pool - Shared Funds
      // (card.IsPoolFunding) OR it carries the legacy per-card UseAutoCardFunding flag.
      return !!(card && (card.IsPoolFunding || card.UseAutoCardFunding));
    },
    // PRODUCTDEV-5908: count the active pending-approval sections on a card (Funding, Refill Settings,
    // Daily Spend Limit). The card-info column plus these sections all share one row, so both the card's
    // grid-cell width (cardClass) and each inner column width (cardApprovalColClass) key off this count.
    activeApprovalSections: function activeApprovalSections(card) {
      return (card.PendingRequest > 0 ? 1 : 0) + ((card.RefillSettings || {}).HasRefillRequest ? 1 : 0) + (card.HasDailySpendLimitRequest ? 1 : 0);
    },
    // PRODUCTDEV-5908: widen the card's cell in the .card-container grid (24% columns) so the info column
    // and every pending-approval section sit on one row, exactly like Funding / Refill. The card spans
    // (sections + 1) columns; with no pending approval it keeps the default single-column width.
    // Previously only Funding / Refill widened the card, so a Daily Spend Limit card stayed one column wide
    // and its to-the-right section was crammed into ~24%, wrapping the text (see PRODUCTDEV-5908 screenshot).
    cardClass: function cardClass(card) {
      var sections = this.activeApprovalSections(card);
      return sections > 0 ? 'cardApprovalSpan-' + (sections + 1) : '';
    },
    // PRODUCTDEV-5908: size the card-info column and each pending-approval section (Funding, Refill Settings,
    // Daily Spend Limit) so they always share a single Bootstrap row. The info column plus N active approval
    // sections split the 12-column grid evenly: 0 -> col-md-12, 1 -> col-md-6, 2 -> col-md-4, 3 -> col-md-3.
    // This replaces the per-section col-md-4/col-md-6 ternaries, which only accounted for Funding + Refill and
    // left a Daily Spend Limit section (or any third section) overflowing onto the next row instead of sitting
    // to the right. All counts yield a whole Bootstrap width, so no fractional col-md-* class is produced.
    cardApprovalColClass: function cardApprovalColClass(card) {
      return 'col-md-' + 12 / (this.activeApprovalSections(card) + 1);
    },
    getCardWithDetails: function getCardWithDetails(cardId) {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee8() {
        var id, params, response, matchedCard;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              // PRODUCTDEV-5884: QA hit a 500 ("Something went wrong") on the post-save refresh after a Daily
              // Spend Limit change - DevTools showed card-with-details called with a malformed wrapped id
              // (id={data:<guid>}) while the DSL PATCH itself returned 200 (the change saved). Callers reach
              // this through several EventBus/@success paths with inconsistent payload shapes (most pass the
              // bare id; some wrap it as { data: <id> }), so defensively normalize any wrapped value to the
              // bare id and bail if none resolves. NOTE: if a 500 recurs here with a *bare* id, the cause is
              // server-side in card-with-details (e.g. a pool card with a pending DSL approval), not this URL.
              id = cardId;
              while (id && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(id) === 'object') {
                id = id.data;
              }
              if (id) {
                _context8.next = 6;
                break;
              }
              console.warn('getCardWithDetails: no card id resolved from', cardId);
              return _context8.abrupt("return");
            case 6:
              params = {
                id: id
              };
              _context8.next = 9;
              return _this8.api.get(_this8.api.$.evedpaycard.cardWithDetails, {
                params: params
              });
            case 9:
              response = _context8.sent;
              if (response.data) {
                matchedCard = _this8.cardsList.findIndex(function (card) {
                  return card.Id === id;
                });
                if (matchedCard !== -1) {
                  _this8.$set(_this8.cardsList, matchedCard, response.data);
                  _this8.sortCardsList();
                }
              }
              _context8.next = 16;
              break;
            case 13:
              _context8.prev = 13;
              _context8.t0 = _context8["catch"](0);
              console.log(_context8.t0);
            case 16:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[0, 13]]);
      }))();
    },
    approveOrReject: function approveOrReject(cardId) {
      var _this9 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee9() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              payload = {
                cardsData: JSON.stringify([{
                  Id: cardId
                }])
              };
              _context9.next = 4;
              return _this9.api.post(_this9.api.$.evedpaycard.approveOrReject, payload);
            case 4:
              response = _context9.sent;
              if (!(response.data === 'Success')) {
                _context9.next = 9;
                break;
              }
              setTimeout(function () {
                _this9.refreshCardWithDetails(cardId);
              }, 1000);
              _context9.next = 10;
              break;
            case 9:
              throw new Error('Error during the request');
            case 10:
              _context9.next = 15;
              break;
            case 12:
              _context9.prev = 12;
              _context9.t0 = _context9["catch"](0);
              console.error(_context9.t0);
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[0, 12]]);
      }))();
    },
    approveOrRejectEvedPayCardFunding: function approveOrRejectEvedPayCardFunding(cardId) {
      var _this10 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee10() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              payload = {
                cardsData: JSON.stringify([{
                  Id: cardId
                }])
              };
              _context10.next = 4;
              return _this10.api.post(_this10.api.$.evedpaycard.approveOrRejectCardFunding, payload);
            case 4:
              response = _context10.sent;
              if (response.data) {
                _context10.next = 7;
                break;
              }
              throw new Error('Error during the request');
            case 7:
              _this10.refreshCardWithDetails(cardId);
              _context10.next = 13;
              break;
            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10["catch"](0);
              console.error(_context10.t0);
            case 13:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[0, 10]]);
      }))();
    },
    approveOrRejectEvedPayCardRefill: function approveOrRejectEvedPayCardRefill(cardId) {
      var _this11 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee11() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              payload = {
                cardsData: JSON.stringify([{
                  Id: cardId
                }])
              };
              _context11.next = 4;
              return _this11.api.post(_this11.api.$.evedpaycard.approveOrRejectCardRefill, payload);
            case 4:
              response = _context11.sent;
              if (response.data) {
                _context11.next = 7;
                break;
              }
              throw new Error('Error during the request');
            case 7:
              _this11.refreshCardWithDetails(cardId);
              _context11.next = 13;
              break;
            case 10:
              _context11.prev = 10;
              _context11.t0 = _context11["catch"](0);
              console.error(_context11.t0);
            case 13:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[0, 10]]);
      }))();
    },
    resendCardApprovalEmail: function resendCardApprovalEmail(cardId) {
      var _this12 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this12.$set(_this12.disabledResendButtons, cardId, true);
              _context12.prev = 1;
              _context12.next = 4;
              return _this12.api.post(_this12.api.$.evedpaycard.resendCardApprovalEmail, {
                cardId: cardId
              });
            case 4:
              _context12.next = 10;
              break;
            case 6:
              _context12.prev = 6;
              _context12.t0 = _context12["catch"](1);
              console.error('There was a problem with the approval email resend request:', _context12.t0);
              _this12.$set(_this12.disabledResendButtons, cardId, false);
            case 10:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[1, 6]]);
      }))();
    },
    resendCardFundingApprovalEmail: function resendCardFundingApprovalEmail(cardId) {
      var _this13 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee13() {
        var key;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              key = "".concat(cardId, "-funding");
              _this13.$set(_this13.disabledResendButtons, key, true);
              _context13.prev = 2;
              _context13.next = 5;
              return _this13.api.post(_this13.api.$.evedpaycard.resendCardFundingApprovalEmail, {
                cardId: cardId
              });
            case 5:
              _context13.next = 11;
              break;
            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13["catch"](2);
              console.error('There was a problem with the approval email resend request:', _context13.t0);
              _this13.$set(_this13.disabledResendButtons, key, false);
            case 11:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[2, 7]]);
      }))();
    },
    resendCardRefillApprovalEmail: function resendCardRefillApprovalEmail(cardId) {
      var _this14 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee14() {
        var key;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              key = "".concat(cardId, "-refill");
              _this14.$set(_this14.disabledResendButtons, key, true);
              _context14.prev = 2;
              _context14.next = 5;
              return _this14.api.post(_this14.api.$.evedpaycard.resendCardRefillApprovalEmail, {
                cardId: cardId
              });
            case 5:
              _context14.next = 11;
              break;
            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14["catch"](2);
              console.error('There was a problem with the approval email resend request:', _context14.t0);
              _this14.$set(_this14.disabledResendButtons, key, false);
            case 11:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[2, 7]]);
      }))();
    },
    // PRODUCTDEV-5884 (pool funding): approve a pending Daily Spend Limit change from the tile (mirror of
    // approveOrRejectEvedPayCardRefill). Decline goes through the RejectCardDailySpendLimit component.
    approveOrRejectEvedPayCardDailySpendLimit: function approveOrRejectEvedPayCardDailySpendLimit(cardId) {
      var _this15 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee15() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              payload = {
                cardsData: JSON.stringify([{
                  Id: cardId
                }])
              };
              _context15.next = 4;
              return _this15.api.post(_this15.api.$.evedpaycard.approveOrRejectCardDailySpendLimit, payload);
            case 4:
              response = _context15.sent;
              if (response.data) {
                _context15.next = 7;
                break;
              }
              throw new Error('Error during the request');
            case 7:
              _this15.refreshCardWithDetails(cardId);
              _context15.next = 13;
              break;
            case 10:
              _context15.prev = 10;
              _context15.t0 = _context15["catch"](0);
              console.error(_context15.t0);
            case 13:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[0, 10]]);
      }))();
    },
    resendCardDailySpendLimitApprovalEmail: function resendCardDailySpendLimitApprovalEmail(cardId) {
      var _this16 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee16() {
        var key;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              key = "".concat(cardId, "-dsl");
              _this16.$set(_this16.disabledResendButtons, key, true);
              _context16.prev = 2;
              _context16.next = 5;
              return _this16.api.post(_this16.api.$.evedpaycard.resendCardDailySpendLimitApprovalEmail, {
                cardId: cardId
              });
            case 5:
              _context16.next = 11;
              break;
            case 7:
              _context16.prev = 7;
              _context16.t0 = _context16["catch"](2);
              console.error('There was a problem with the approval email resend request:', _context16.t0);
              _this16.$set(_this16.disabledResendButtons, key, false);
            case 11:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[2, 7]]);
      }))();
    },
    getApprovalUsers: function getApprovalUsers(cardId) {
      var _this17 = this;
      this.api.get(this.api.$.evedpaycard.approvalUsers, {
        params: {
          cardId: cardId
        }
      }).then(function (response) {
        _this17.approvalUsersData = response.data;
      }).catch(function (error) {
        console.error('There was a problem with the approval users request:', error);
      });
    },
    getRefillApprovalUsers: function getRefillApprovalUsers(cardId) {
      var _this18 = this;
      this.api.get(this.api.$.evedpaycard.refillApprovalUsers, {
        params: {
          cardId: cardId
        }
      }).then(function (response) {
        _this18.approvalUsersData = response.data;
      }).catch(function (error) {
        console.error('There was a problem with the approval users request:', error);
      });
    },
    handleButtonClick: function handleButtonClick(cardId, refill) {
      var _this19 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee17() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              if (!refill) {
                _context17.next = 6;
                break;
              }
              _context17.next = 4;
              return _this19.getRefillApprovalUsers(cardId);
            case 4:
              _context17.next = 8;
              break;
            case 6:
              _context17.next = 8;
              return _this19.getApprovalUsers(cardId);
            case 8:
              _this19.showApprovalUsers = true;
              _context17.next = 14;
              break;
            case 11:
              _context17.prev = 11;
              _context17.t0 = _context17["catch"](0);
              console.error('There was a problem handling the button click:', _context17.t0);
            case 14:
            case "end":
              return _context17.stop();
          }
        }, _callee17, null, [[0, 11]]);
      }))();
    },
    handleButtonClickReject: function handleButtonClickReject(cardId) {
      var _this20 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee18() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              try {
                _this20.card = _this20.cardsList.find(function (card) {
                  return card.Id === cardId;
                });
                _this20.$emit('card', _this20.card);
                _this20.showCardRejectInfo = true;
              } catch (error) {
                console.error('There was a problem handling the button click:', error);
              }
            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    handleSuccess: function handleSuccess() {
      var _this21 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee19() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return _this21.getCardsAndAccountData();
            case 2:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    sortCardsList: function sortCardsList() {
      var statusOrder = {
        'Pending Approval': 0,
        'Active': 1,
        'Processing': 2,
        'Inactive': 3,
        'Locked': 4,
        'Locked - Lost/Stolen': 5,
        'Expired': 6,
        'Closed': 7,
        'Rejected': 8,
        'Declined': 8
      };
      this.cardsList.sort(function (a, b) {
        var statusA = a.CardStatus || 'N/A';
        var statusB = b.CardStatus || 'N/A';
        return statusOrder[statusA] - statusOrder[statusB];
      });
    },
    getCards: function getCards(accountId) {
      var _this22 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee20() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              _context20.next = 3;
              return _this22.api.get(_this22.api.$.evedpaycard.list, {
                params: {
                  accountId: accountId
                }
              });
            case 3:
              result = _context20.sent;
              _this22.cardsList = result.data.length ? result.data : [{}];
              _this22.sortCardsList();
              _this22.hasData = true;
              _this22.refreshProcessingCards();
              _this22.filteredPhysicalCards = _this22.filterPhysicalCards(_this22.cardsList);
              _context20.next = 15;
              break;
            case 11:
              _context20.prev = 11;
              _context20.t0 = _context20["catch"](0);
              _this22.hasData = false;
              console.log('error', _context20.t0);
            case 15:
            case "end":
              return _context20.stop();
          }
        }, _callee20, null, [[0, 11]]);
      }))();
    },
    filterPhysicalCards: function filterPhysicalCards(cards) {
      var physicalCards = cards.filter(function (card) {
        return !card.IsPhysicalCard && card.CardStatus === 'Active';
      }).sort(function (a, b) {
        return new Date(b.CreatedDate) - new Date(a.CreatedDate);
      });
      this.hasPhysicalCards = physicalCards.length > 0;
      return physicalCards;
    },
    handleRequestPhysicalSuccess: function handleRequestPhysicalSuccess() {
      this.getCards(this.$route.query.AccountId);
      this.refresh();
    },
    handleCardAdditionSuccess: function handleCardAdditionSuccess() {
      this.refreshScheduled = false;
      this.refreshCards();
      this.getAccountData();
      this.getCards(this.$route.query.AccountId);
    },
    refreshProcessingCards: function refreshProcessingCards() {
      var _this23 = this;
      this.clearPollInterval();
      var needsRefresh = this.cardsList.some(function (card) {
        return card.CardStatus === 'Processing' || card.CardStatus === 'Pending Approval' || card.CardStatus === 'Rejected' || card.CardStatus === 'Declined';
      });
      if (needsRefresh && !this.refreshScheduled) {
        var delay = 1 * 60 * 1000;
        this.pollInterval = setTimeout(function () {
          if (_this23.isActive) {
            _this23.refreshCards();
            _this23.refreshScheduled = true;
          }
        }, delay);
      }
    },
    getUserDivisions: function getUserDivisions() {
      var _this24 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee21() {
        var result, last, target, matchedAccount;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _this24.users = [];
              _context21.prev = 1;
              _context21.next = 4;
              return _this24.api.get(_this24.api.$.evedpaycard.division);
            case 4:
              result = _context21.sent;
              if (result && result.data) {
                _this24.divisions = result.data;
                if (!_this24.$route.query.AccountId && _this24.divisions.length > 0) {
                  last = _this24.readLastAccount();
                  target = _this24.divisions.some(function (d) {
                    return d.AccountId === last;
                  }) ? last : _this24.divisions[0].AccountId;
                  _this24.redirectCardholder(target);
                }
                matchedAccount = _this24.divisions.find(function (div) {
                  return div.AccountId === _this24.selectedAccountId;
                });
                _this24.divName = matchedAccount ? matchedAccount.DivisionName : '...';
                _this24.hasData = true;
              }
              _context21.next = 12;
              break;
            case 8:
              _context21.prev = 8;
              _context21.t0 = _context21["catch"](1);
              _this24.hasData = false;
              console.log('error', _context21.t0);
            case 12:
            case "end":
              return _context21.stop();
          }
        }, _callee21, null, [[1, 8]]);
      }))();
    },
    getAccountData: function getAccountData() {
      var _this25 = this;
      return this.api.get(this.api.$.evedpaycard.account + this.$route.query.AccountId).then(function (result) {
        if (result && result.data) {
          _this25.account = result.data;
          _this25.getAccountSettings(_this25.account.DivisionId);
          // PRODUCTDEV-5788 — gate this account's Submit Receipt button on its division's
          // receipt-scan mode. Default false on any failure (button stays hidden).
          if (_this25.receiptScanEnabled && _this25.account.DivisionId != null) {
            __WEBPACK_IMPORTED_MODULE_28__core_api_receiptScans__["b" /* default */].getScanMode(_this25.account.DivisionId).then(function (scanSetting) {
              _this25.accountScanEnabled = !!(scanSetting && scanSetting.prefillMode !== 'scanning_disabled');
            }).catch(function (modeErr) {
              console.warn('Could not fetch receipt-scan mode (Submit Receipt hidden):', modeErr);
              _this25.accountScanEnabled = false;
            });
          } else {
            _this25.accountScanEnabled = false;
          }
        } else {
          _this25.account = {};
          _this25.accountScanEnabled = false;
        }
        _this25.hasData = true;
      }).catch(function (error) {
        _this25.hasData = false;
        console.log('error', error);
      });
    },
    getAccountSettings: function getAccountSettings(divisionId) {
      var _this26 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee22() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (!(_this26.accountSettings && _this26.accountSettings.DivisionId === divisionId)) {
                _context22.next = 2;
                break;
              }
              return _context22.abrupt("return");
            case 2:
              _context22.prev = 2;
              _context22.next = 5;
              return _this26.api.get("evedpaycards/accounts/".concat(divisionId, "/settings-by-division"));
            case 5:
              response = _context22.sent;
              if (response.status === 200) {
                _this26.accountSettings = response.data;
              }
              _context22.next = 12;
              break;
            case 9:
              _context22.prev = 9;
              _context22.t0 = _context22["catch"](2);
              console.log(_context22.t0);
            case 12:
            case "end":
              return _context22.stop();
          }
        }, _callee22, null, [[2, 9]]);
      }))();
    },
    getDivision: function getDivision() {
      var _this27 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee23() {
        var result, _iterator, _step, divAcc;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;
              _context23.next = 3;
              return _this27.api.get(_this27.api.$.evedpaycard.division);
            case 3:
              result = _context23.sent;
              if (result && result.data) {
                _iterator = _createForOfIteratorHelper(result.data);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    divAcc = _step.value;
                    if (divAcc.AccountId === _this27.$route.query.AccountId) {
                      _this27.division = divAcc;
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
              _this27.hasData = true;
              _context23.next = 12;
              break;
            case 8:
              _context23.prev = 8;
              _context23.t0 = _context23["catch"](0);
              _this27.hasData = false;
              console.log('error', _context23.t0);
            case 12:
            case "end":
              return _context23.stop();
          }
        }, _callee23, null, [[0, 8]]);
      }))();
    },
    approveOrRejectEnvelope: function approveOrRejectEnvelope(envelopes) {
      var _this28 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee24() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;
              payload = {
                envelopesData: envelopes
              };
              _context24.next = 4;
              return _this28.api.post(_this28.api.$.evedpaycard.approveOrRejectEnvelope, payload);
            case 4:
              response = _context24.sent;
              if (response.data) {
                _context24.next = 7;
                break;
              }
              throw new Error('Error during the request');
            case 7:
              _this28.refresh();
              _context24.next = 13;
              break;
            case 10:
              _context24.prev = 10;
              _context24.t0 = _context24["catch"](0);
              console.error(_context24.t0);
            case 13:
            case "end":
              return _context24.stop();
          }
        }, _callee24, null, [[0, 10]]);
      }))();
    },
    doApprove: function doApprove() {
      if (this.showEnvelopesTab) {
        var envelopes = this.selectedRows.map(function (r) {
          return r.data;
        });
        this.approveOrRejectEnvelope(envelopes);
      } else if (this.showCardsTab) {
        this.approveOrReject(this.selectedObj[0].Id);
      }
    },
    transformRows: function transformRows(rows) {
      var _this29 = this;
      if (this.showEnvelopesTab) {
        return rows.map(function (r) {
          var amount = parseFloat(r.data.Amount).toFixed(2);
          var row = {
            NeedsApproval: _this29.waitingApprovalStatuses.includes(r.data.EnvelopeStatus) ? 'EvedPay Envelope' : '',
            Amount: amount + ' USD'
          };
          return row;
        });
      } else if (this.showCardsTab) {
        return rows.map(function (r) {
          var amount = parseFloat(r.data.InitialLoad).toFixed(2);
          var row = {
            NeedsApproval: r.data.CardStatus === 'Pending Approval' ? 'EvedPay Card' : '',
            Amount: amount + ' USD'
          };
          return row;
        });
      }
    },
    getApprovalUsersEnvelope: function getApprovalUsersEnvelope(envelopeId) {
      var _this30 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee25() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return _this30.api.get(_this30.api.$.evedpaycard.approvalUsersForEnvelope, {
                params: {
                  envelopeId: envelopeId
                }
              }).then(function (response) {
                _this30.approvalUsersData = response.data;
              }).catch(function (error) {
                console.error('There was a problem with the approval users request:', error);
              });
            case 2:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    isUserInApprovalList: function isUserInApprovalList() {
      var currentUserID = this.$root.getUser.$.user.UserID;
      if (Array.isArray(this.approvalUsersData)) {
        return this.approvalUsersData.some(function (user) {
          return user.Id === currentUserID && user.IsCurrentAction;
        });
      }
      return false;
    },
    handleButtonClickEnvelope: function handleButtonClickEnvelope(envelopeId) {
      var _this31 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee26() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;
              _context26.next = 3;
              return _this31.getApprovalUsersEnvelope(envelopeId);
            case 3:
              _this31.showApprovalUsers = true;
              _context26.next = 9;
              break;
            case 6:
              _context26.prev = 6;
              _context26.t0 = _context26["catch"](0);
              console.error('There was a problem handling the button click:', _context26.t0);
            case 9:
            case "end":
              return _context26.stop();
          }
        }, _callee26, null, [[0, 6]]);
      }))();
    },
    stopSave: function stopSave() {
      this.savePressed = false;
    },
    resetValidation: function resetValidation() {
      this.receiptIncomplete = false;
      this.descriptionIncomplete = false;
      this.buAndCcPairIncomplete = new Array(this.splitCounter).fill(false);
      this.buIncomplete = new Array(this.splitCounter).fill(false);
      this.ccIncomplete = new Array(this.splitCounter).fill(false);
      this.categoryIncomplete = new Array(this.splitCounter).fill(false);
    },
    createReconcile: function createReconcile() {
      var _this32 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee27() {
        var hasIncompleteField, i, formCopy, updatedFields, form, padArray, rowCount, paddedSelectedBu, paddedSelectedCc, paddedSelectedBuAndCcPair, paddedSelectedCategory, paddedReferenceId, paddedDescriptions, paddedSplitAmounts, EMPTY_GUID, paddedItemIds, response, blockedReason, message;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              hasIncompleteField = false;
              if (!(_this32.selectedProgram && Object.keys(_this32.selectedProgram).length !== 0 && _this32.selectedProgram.Id)) {
                hasIncompleteField = true;
              }
              if ((!_this32.noteText || _this32.noteText && _this32.noteText.length === 0) && _this32.requireReceiptDescription && _this32.filteredAttachments.length !== 0) {
                _this32.descriptionIncomplete = true;
                hasIncompleteField = true;
              } else {
                _this32.descriptionIncomplete = false;
              }
              if (_this32.filteredAttachments.length === 0) {
                hasIncompleteField = true;
              }
              if (!(_this32.transaction.data.EnvelopeId && _this32.transaction.data.EnvelopeId !== '00000000-0000-0000-0000-000000000000' && _this32.filteredAttachments.length === 0 && _this32.transaction.data.EnvelopeStatus !== 'Draft')) {
                _context27.next = 7;
                break;
              }
              _this32.$notifications.notify({
                type: 'info-warn',
                message: 'Receipt is required. Please upload at least one file.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              return _context27.abrupt("return", _this32.stopSave());
            case 7:
              _this32.buAndCcPairIncomplete = new Array(_this32.splitCounter).fill(false);
              _this32.buIncomplete = new Array(_this32.splitCounter).fill(false);
              _this32.ccIncomplete = new Array(_this32.splitCounter).fill(false);
              _this32.categoryIncomplete = new Array(_this32.splitCounter).fill(false);
              for (i = 0; i < _this32.splitCounter; i++) {
                if (_this32.selectedBuAndCcPair) {
                  _this32.buAndCcPairIncomplete[i] = !_this32.selectedBuAndCcPair[i];
                } else if (_this32.selectedBu && _this32.selectedCc) {
                  _this32.buIncomplete[i] = !_this32.selectedBu[i];
                  _this32.ccIncomplete[i] = !_this32.selectedCc[i];
                } else if (_this32.selectedBu && !_this32.selectedCc) {
                  _this32.buIncomplete[i] = !_this32.selectedBu[i];
                } else if (!_this32.selectedBu && _this32.selectedCc) {
                  _this32.ccIncomplete[i] = !_this32.selectedCc[i];
                }
                if (_this32.buAndCcPairIncomplete[i] || _this32.buIncomplete[i] || _this32.ccIncomplete[i]) {
                  hasIncompleteField = true;
                }
                if (!(_this32.selectedCategory && _this32.selectedCategory[i])) {
                  hasIncompleteField = true;
                }

                // check incomplete custom fields
                if (_this32.fields.some(function (item) {
                  return item.some(function (field) {
                    return field && field.Required && (!field.Values || field.Values.length === 0);
                  });
                })) {
                  hasIncompleteField = true;
                }
              }
              if (!_this32.descriptionIncomplete) {
                _context27.next = 14;
                break;
              }
              return _context27.abrupt("return", _this32.stopSave());
            case 14:
              _context27.prev = 14;
              formCopy = JSON.parse(JSON.stringify(_this32.fields));
              updatedFields = formCopy.map(function (i) {
                return i.map(function (x) {
                  if (x.Type === 'select' && x.Values && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(x.Values) === 'object') {
                    x.Values = x.Values.text;
                  } else if (x.Type === 'text' && x.Values && Array.isArray(x.Values) && x.Values.length > 0) {
                    x.Values = x.Values[0];
                  }
                  return x;
                });
              });
              form = {
                Fields: updatedFields,
                CategoryIds: _this32.selectedCategory,
                ReferenceIds: _this32.referenceId,
                Descriptions: _this32.descriptions,
                BusinessUnitIds: _this32.selectedBu,
                CostCenterIds: _this32.selectedCc,
                ProgramBusinessUnitAndCostCenterIds: _this32.selectedBuAndCcPair,
                Amounts: _this32.splitAmounts,
                TransactionReconcileSplitItemIds: _this32.itemIds
              };
              if (!_this32.selectedCardId) {
                _context27.next = 49;
                break;
              }
              // Defensive padding — every per-row array must have splitCounter entries or
              // Legacy's SaveTransactionFields (EvedPayCardsRepository.cs:3848) throws
              // IndexOutOfRange when it iterates Amounts.Count and accesses parallel arrays.
              // Photon-driven splits can outpace the emit chain that syncs these arrays back
              // up to Card-list, leaving shorter-than-expected lengths at save time.
              padArray = function padArray(arr, len, fill) {
                var out = Array.isArray(arr) ? arr.slice() : [];
                while (out.length < len) {
                  out.push(fill === undefined ? null : fill);
                }
                return out;
              };
              rowCount = _this32.splitCounter || 1;
              paddedSelectedBu = padArray(_this32.selectedBu, rowCount);
              paddedSelectedCc = padArray(_this32.selectedCc, rowCount);
              paddedSelectedBuAndCcPair = padArray(_this32.selectedBuAndCcPair, rowCount);
              paddedSelectedCategory = padArray(_this32.selectedCategory, rowCount);
              paddedReferenceId = padArray(_this32.referenceId, rowCount);
              paddedDescriptions = padArray(_this32.descriptions, rowCount, '');
              paddedSplitAmounts = padArray(_this32.splitAmounts, rowCount, 0); // Pad itemIds with the Empty Guid so SaveTransactionFields sees a
              // valid List<Guid> even when this.itemIds is shorter than rowCount
              // (or empty — e.g. a fresh SUBMIT-match reconcile where the rows
              // come from prefill and never had server-side ItemIds assigned).
              // Empty Guid hits the Guid.Empty branch in the BE loop and is
              // treated as a new split-item insert.
              // Without this pad, undefined entries serialize to JSON null and
              // either deserialize the whole property to null on the BE (NRE on
              // [i]) or raise an IndexOutOfRange when itemIds is shorter than
              // Amounts.Count.
              EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
              paddedItemIds = padArray(_this32.itemIds, rowCount, EMPTY_GUID).map(function (id) {
                return id == null || id === '' ? EMPTY_GUID : id;
              }); // Sync the padded arrays into the Form payload too — the inner Form{...} object
              // is consumed by SaveTransactionFields which has the same parallel-indexing assumption.
              form.BusinessUnitIds = paddedSelectedBu;
              form.CostCenterIds = paddedSelectedCc;
              form.ProgramBusinessUnitAndCostCenterIds = paddedSelectedBuAndCcPair;
              form.CategoryIds = paddedSelectedCategory;
              form.ReferenceIds = paddedReferenceId;
              form.Descriptions = paddedDescriptions;
              form.Amounts = paddedSplitAmounts;
              form.TransactionReconcileSplitItemIds = paddedItemIds;
              _context27.next = 40;
              return _this32.api.post(_this32.api.$.evedpaycard.reconcile, _objectSpread(_objectSpread({
                preventError: true
              }, _this32.newReconcile), {}, {
                CardId: _this32.selectedCardId,
                TransactionId: _this32.selectedTransactionId,
                SupplierId: _this32.selectedSupplier && _this32.selectedSupplier.Value ? _this32.selectedSupplier.Value.VendorId : null,
                ProgramId: _this32.selectedProgram && _this32.selectedProgram.Id ? _this32.selectedProgram.Id : null,
                ReceiptFiles: _this32.filteredAttachments,
                AdditionalDocuments: _this32.additionalDocumentsFiles,
                Note: _this32.noteText,
                SplitAmounts: paddedSplitAmounts,
                BusinessUnitIds: paddedSelectedBu,
                CostCenterIds: paddedSelectedCc,
                BusinessUnitAndCostCenterIds: paddedSelectedBuAndCcPair,
                CategoryIds: paddedSelectedCategory,
                ReferenceIds: paddedReferenceId,
                Descriptions: paddedDescriptions,
                IsComplete: !hasIncompleteField,
                Form: form,
                FormKey: _this32.formKey
              }));
            case 40:
              response = _context27.sent;
              if (!response.data) {
                _context27.next = 45;
                break;
              }
              return _context27.abrupt("return", true);
            case 45:
              console.error('Error during the request. Response data is null.');
              _this32.$notifications.notify({
                type: 'plain',
                icon: 'exclamation-circle',
                placement: {
                  from: 'top',
                  align: 'center'
                },
                timeout: 0,
                message: 'An error occurred while saving. Please try again.',
                discard: 'Ok',
                goto: ''
              });
            case 47:
              _context27.next = 51;
              break;
            case 49:
              console.error('Selected CardId is null or undefined.');
              _this32.$notifications.notify({
                type: 'plain',
                icon: 'exclamation-circle',
                placement: {
                  from: 'top',
                  align: 'center'
                },
                timeout: 0,
                message: 'An error occurred while saving. Please try again.',
                discard: 'Ok',
                goto: ''
              });
            case 51:
              _context27.next = 60;
              break;
            case 53:
              _context27.prev = 53;
              _context27.t0 = _context27["catch"](14);
              console.error('Error during the request:', _context27.t0);
              // PRODUCTDEV-5574 — surface the backend's blocked-reason payload (race where envelope
              // flipped to Posted/Exported while modal was open, or a ProgramId tamper).
              blockedReason = _context27.t0 && _context27.t0.response && _context27.t0.response.data && _context27.t0.response.data.reason;
              message = _this32.envelopeEditBlockedMessage(blockedReason) || 'An error occurred while saving. Please try again.';
              _this32.$notifications.notify({
                type: 'plain',
                icon: 'exclamation-circle',
                placement: {
                  from: 'top',
                  align: 'center'
                },
                timeout: 0,
                message: message,
                discard: 'Ok',
                goto: ''
              });
              _this32.stopSave();
            case 60:
            case "end":
              return _context27.stop();
          }
        }, _callee27, null, [[14, 53]]);
      }))();
    },
    createEnvelope: function createEnvelope() {
      this.showCreateEnvelope = true;
      window.history.pushState({}, '', '#/d/Programs/>Card/envelopes');
    },
    clearPollInterval: function clearPollInterval() {
      if (this.pollInterval) {
        clearTimeout(this.pollInterval);
        this.pollInterval = null;
      }
    },
    hasAccountPermission: function hasAccountPermission(permission) {
      if (this.$user && this.$user.$.userPermissions && this.$user.$.userPermissions.length !== 0) {
        return this.$user.$.userPermissions.includes(permission);
      }
      return false;
    },
    closeAccount: function closeAccount() {
      if (Object.keys(this.closeObj).length !== 0) {
        this.closeObj.divisionId = parseInt(this.account.Id);
        this.closeObj.funds = this.headerData.Available;
        this.closeObj = {};
      }
    },
    cardActionDisabled: function cardActionDisabled(actionName, card) {
      return !!this.actionDisabledReason(actionName, card);
    },
    actionDisabledReason: function actionDisabledReason(actionName, card) {
      if (this.selectedRows.length > 1 && actionName === 'reconcile') {
        return 'You can only reconcile one transaction at a time.';
      }
      if (card && actionName === 'approveValidation' && card.PendingRequest > this.account.Available) {
        return 'There are insufficient funds in the account to complete this request.';
      }
      if (this.selectedRows.length > 0) {
        var firstCardId = this.selectedRows[0].data.CardId;
        var programIds = Array.from(new Set(this.selectedRows.map(function (row) {
          return row && row.data.ProgramId !== null ? row.data.ProgramId : null;
        }).filter(function (id) {
          return id !== null;
        })));
        if (programIds.length > 1 && actionName === 'createEnvelope') {
          return "Only transactions from the same ".concat(this.programName.toLowerCase(), " that are not already part of an envelope can be selected.");
        }
        var _iterator2 = _createForOfIteratorHelper(this.selectedRows),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var row = _step2.value;
            if (row.data.TransactionStatus === 'Rejected' || row.data.TransactionStatus === 'Declined') {
              return 'Only transactions that are not Rejected or Declined can be selected.';
            }
            if (row.data.TransactionStatus === 'Pending' && actionName !== 'reconcile') {
              return 'Only transactions that are not Pending or Declined can be selected.';
            }
            if (row.data.EnvelopeNumber !== null && actionName === 'createEnvelope') {
              return 'Only transactions that are not already part of an envelope can be selected.';
            }
            if (row.data.CardId !== firstCardId) {
              return 'Only transactions from the same card that are not already part of an envelope can be selected.';
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      if (this.showEnvelopesTab) {
        if (this.selectedRows.length > 1 && actionName === 'envelope') {
          return 'You can only open one envelope at a time.';
        }
      }
      if (this.showCardsTab) {
        return cardMethods.actionDisabledReason.call(this, actionName);
      }
      if (this.selectedRows.length === 0 && !card) {
        return 'Please select a transaction.';
      }
    },
    singularize: function singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value;
    },
    exportEnvelope: function exportEnvelope() {
      window.open("".concat(this.api.env, "/evedpaycards/envelope/export/").concat(this.selectedRows[0].data.Id), '_blank');
    },
    createAPFile: function createAPFile() {
      var _this33 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee28() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              payload = {
                envelopeIds: _this33.selectedRows.map(function (r) {
                  return r.data.Id;
                })
              };
              _context28.next = 3;
              return _this33.api.post(_this33.api.$.evedpaycard.createAPFile, payload);
            case 3:
              response = _context28.sent;
              if (response.data) {
                _context28.next = 8;
                break;
              }
              throw new Error('Error during the request');
            case 8:
              _this33.refresh();
            case 9:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }))();
    },
    pushToAccountingSystem: function pushToAccountingSystem() {
      var _this34 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee29() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _this34.pushingToAccountingSystem = true;
              _context29.next = 3;
              return _this34.api.put("evedpaycards/envelope/push-to-accounting-system", {
                envelopeIds: _this34.selectedRows.map(function (r) {
                  return r.data.Id;
                })
              });
            case 3:
              response = _context29.sent;
              if (!(response.status !== 200)) {
                _context29.next = 9;
                break;
              }
              _this34.pushingToAccountingSystem = false;
              throw new Error('Error during the request');
            case 9:
              _this34.pushingToAccountingSystem = false;
              _this34.$notifications.notify({
                message: "The envelope(s) data has been sent to PSL+.",
                type: 'info',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _this34.refresh();
            case 12:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }))();
    },
    envelopeActionDisabled: function envelopeActionDisabled(actionName) {
      return !!this.envelopeActionDisabledReason(actionName);
    },
    envelopeActionDisabledReason: function envelopeActionDisabledReason(actionName) {
      if (this.selectedRows.length === 0) {
        return 'Please select an envelope.';
      }
      if (actionName === 'exportEnvelope') {
        if (this.selectedRows.length !== 1) {
          return 'You can only export one envelope at a time.';
        } else if (this.selectedRows.length === 1) {
          if (this.selectedRows[0].data.EnvelopeStatus === 'Draft') {
            return 'You cannot export draft envelopes.';
          }
          if (this.rejectedStatuses.includes(this.selectedRows[0].data.EnvelopeStatus)) {
            return 'You cannot export declined envelopes.';
          }
        }
      }
      if (actionName === 'addTransactionNumber') {
        if (this.selectedRows.length === 0) {
          return 'Select an envelope.';
        }
        if (this.selectedRows.length === 1 && this.selectedRows[0].data.TransactionNo !== null) {
          return 'Envelope already has a transaction number.';
        }
        var hasTransactionNo = this.selectedRows.some(function (row) {
          return row.data.TransactionNo !== null;
        });
        var hasOtherStatus = this.selectedRows.some(function (row) {
          return row.data.EnvelopeStatus !== 'Exported - Approved' && row.data.EnvelopeStatus !== 'Exported - Waiting Approval';
        });
        var firstApFileId = this.selectedRows[0].data.ApFileId;
        var sameApFileId = this.selectedRows.every(function (row) {
          return row.data.ApFileId === firstApFileId;
        });
        if (hasTransactionNo || hasOtherStatus || !sameApFileId) {
          return 'All selected envelopes must be in the same AP File and without a Transaction Number.';
        }
      }
      if (actionName === 'createAPFile') {
        if (this.selectedRows.length > 0) {
          var _iterator3 = _createForOfIteratorHelper(this.selectedRows),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var row = _step3.value;
              if (row.data.APFile !== '' || row.data.EnvelopeStatus === 'Draft' || this.rejectedStatuses.includes(row.data.EnvelopeStatus)) {
                return 'You can only select envelopes that are not drafts, not declined, and do not have an AP file.';
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          var _iterator4 = _createForOfIteratorHelper(this.selectedRows),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _row = _step4.value;
              if (!_row.data.CanGenerateAPFileWithoutApproval && _row.data.EnvelopeStatus !== 'Open - Approved') {
                return 'One or more envelopes need to be approved first.';
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }
      if (actionName === 'pushToAccountingSystemAction') {
        if (this.pushingToAccountingSystem) {
          return 'Pushing to PSL+...';
        }
        if (this.selectedRows.length > 0) {
          var accountSettings = this.accountSettings;
          if (!accountSettings || !accountSettings.AccountingSystem || accountSettings.AccountingSystem.SyncEvedPayCardEnvelopes !== true) {
            return '"PSL+ Integration - Sync Envelope data" is unchecked.';
          }
        }
        var _iterator5 = _createForOfIteratorHelper(this.selectedRows),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _row2 = _step5.value;
            if (!_row2.data.CardNumberKeyForAccountingSystem) {
              return 'Please first push card to PSL+ or assign the corresponding card number in PSL+ to the existing EVED card.';
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        var _iterator6 = _createForOfIteratorHelper(this.selectedRows),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _row3 = _step6.value;
            if (_row3.data.EnvelopeStatus === 'Draft' || this.rejectedStatuses.includes(_row3.data.EnvelopeStatus)) {
              return 'You can only select envelopes that are not drafts or declined.';
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    },
    requestPhysicalBatchActionDisabled: function requestPhysicalBatchActionDisabled(actionName) {
      return !!this.requestPhysicalBatchActionDisabledReason(actionName);
    },
    requestPhysicalBatchActionDisabledReason: function requestPhysicalBatchActionDisabledReason(actionName) {
      if (actionName === 'requestPhysicalBatch' && !this.hasPhysicalCards) {
        return 'No cards available for batch ordering.';
      }
    },
    rowSelected: function rowSelected(event) {
      var _this35 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee30() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              if (!(typeof event === 'boolean')) {
                _context30.next = 4;
                break;
              }
              _this35.selectedAll = event;
              _context30.next = 29;
              break;
            case 4:
              _this35.selectedRows = event;
              if (!_this35.showTransactionsTab) {
                _context30.next = 11;
                break;
              }
              if (_this35.highlightedObjectId && _this35.highlightedObjectId.length > 0 && !_this35.showReconcile && _this35.selectedRows.length > 0) {
                _this35.highlightedObjectId = '';
                _this35.redrawRows();
              }
              _context30.next = 9;
              return _this35.applyTransactionContext(_this35.selectedRows[0]);
            case 9:
              _context30.next = 29;
              break;
            case 11:
              if (!_this35.showEnvelopesTab) {
                _context30.next = 16;
                break;
              }
              if (_this35.highlightedObjectId && _this35.highlightedObjectId.length > 0 && !_this35.showCreateEnvelope && _this35.selectedRows.length > 0) {
                _this35.highlightedObjectId = '';
                localStorage.setItem('row-highlight', '');
                _this35.$refs.grid.gridOptions.api.redrawRows();
              }
              if (_this35.selectedRows.length === 1) {
                _this35.envelope = _this35.selectedRows[0].data;
                _this35.getApprovalUsersEnvelope(_this35.envelope.Id);
              }
              _context30.next = 29;
              break;
            case 16:
              if (!_this35.showCardsTab) {
                _context30.next = 29;
                break;
              }
              if (!(_this35.selectedRows.length > 0)) {
                _context30.next = 28;
                break;
              }
              _this35.selectedObj = _this35.selectedRows.map(function (card) {
                return card.data;
              });
              _this35.cardDivisionId = _this35.selectedObj[0].DivisionId;
              if (!_this35.selectedObj.every(function (card) {
                return card.CardStatus === 'Pending Approval';
              })) {
                _context30.next = 25;
                break;
              }
              _context30.next = 23;
              return _this35.getApprovalUsers(_this35.selectedObj[0].Id);
            case 23:
              _context30.next = 26;
              break;
            case 25:
              _this35.approvalUsersData = [];
            case 26:
              _context30.next = 29;
              break;
            case 28:
              _this35.selectedObj = [];
            case 29:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      }))();
    },
    showModal: function showModal(showReconcile) {
      if (!this.savePressed) {
        this.showReconcile = !showReconcile;
        if (this.showReconcile) {
          this.highlightedObjectId = this.transaction.data.Id;
        } else {
          this.redrawRows();
        }
        this.resetModalFields();
      }
    },
    resetFields: function resetFields() {
      this.savePressed = false;
      this.selectedProgram = '';
      this.selectedSupplier = '';
      this.noteText = '';
      this.mediaFilesPath = '';
      this.filteredAttachments = [];
      this.additionalDocumentsFiles = [];
      this.fields = [];
      this.formKey = '';
    },
    resetModalFields: function resetModalFields() {
      if (this.showReconcile) {
        if (this.$refs.reconcileComp) {
          this.$refs.reconcileComp.$refs.formRef.reset();
          this.resetValidation();
          this.resetFields();
        }
      } else {
        this.$refs.grid.onSelectAll(false);
        this.selectedRows = [];
        this.transaction = {};
        this.approvalUsersData = [];
        this.$refs.reconcileComp.$refs.formRef.reset();
        this.resetValidation();
        this.resetFields();
      }
    },
    updateMediaFilesPath: function updateMediaFilesPath(mediaFilesPath) {
      this.mediaFilesPath = mediaFilesPath;
    },
    updateAttachmentsFiles: function updateAttachmentsFiles(filteredAttachments) {
      this.filteredAttachments = filteredAttachments;
    },
    // PRODUCTDEV-5772 — supporting documents from the reconcile modal (Card-list host).
    updateAdditionalDocuments: function updateAdditionalDocuments(additionalDocuments) {
      this.additionalDocumentsFiles = additionalDocuments;
    },
    handleFieldsUpdated: function handleFieldsUpdated(form) {
      this.fields = form.fields;
      this.formKey = form.formKey;
    },
    handleSplitAmounts: function handleSplitAmounts(data) {
      this.splitAmounts = data;
    },
    handleDescriptionText: function handleDescriptionText(data) {
      this.noteText = data.noteText;
      this.requireReceiptDescription = data.requireReceiptDescription;
    },
    handleUploadFinished: function handleUploadFinished(finished) {
      this.uploadFinished = finished;
    },
    saveAndReconcile: function saveAndReconcile() {
      var _this36 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee31() {
        var mapFile, payload, r;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              if (_this36.savePressed) {
                _context31.next = 26;
                break;
              }
              _this36.savePressed = true;
              if (!(_this36.reconcileAction === 'view' && _this36.isUserAdmin)) {
                _context31.next = 22;
                break;
              }
              if (!(_this36.filteredAttachments.length === 0)) {
                _context31.next = 6;
                break;
              }
              _this36.$notifications.notify({
                type: 'info-warn',
                message: 'Receipt is required. Please upload at least one file.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              return _context31.abrupt("return", _this36.stopSave());
            case 6:
              // PRODUCTDEV-5790 — also carry additional documents so a card admin can add/remove
              // them (not just the receipt) on a view-locked transaction. Backend keeps docs by Id
              // and soft-deletes any not in the list; additionalDocumentsFiles is populated from the
              // modal on open, so an untouched doc set round-trips unchanged.
              mapFile = function mapFile(f) {
                return {
                  id: f.Id || '00000000-0000-0000-0000-000000000000',
                  pathWithName: f.PathWithName,
                  originalName: f.OriginalName,
                  mediaFile: f.MediaFile,
                  sizeBytes: f.SizeBytes,
                  vendorId: f.VendorId
                };
              };
              payload = {
                transactionId: _this36.selectedTransactionId,
                receiptFiles: _this36.filteredAttachments.map(mapFile),
                additionalDocuments: _this36.additionalDocumentsFiles.map(mapFile)
              };
              _context31.prev = 8;
              _context31.next = 11;
              return _this36.api.post(_this36.api.$.evedpaycard.updateReceipt, payload);
            case 11:
              _this36.$notifications.notify({
                type: 'info',
                message: 'Receipt updated successfully',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _this36.savePressed = false;
              _this36.closeReconcile({
                userCancelled: false
              });
              _this36.resetModalFields();
              _context31.next = 20;
              break;
            case 17:
              _context31.prev = 17;
              _context31.t0 = _context31["catch"](8);
              console.error('Error while updating the receipt:', _context31.t0);
            case 20:
              _context31.next = 26;
              break;
            case 22:
              _context31.next = 24;
              return _this36.createReconcile();
            case 24:
              r = _context31.sent;
              if (r) {
                __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$emit('transaction-reconciled', _this36.transaction.data.Id);
                _this36.savePressed = false;
                _this36.closeReconcile({
                  userCancelled: false
                });
                _this36.resetModalFields();
              }
            case 26:
            case "end":
              return _context31.stop();
          }
        }, _callee31, null, [[8, 17]]);
      }))();
    },
    handleReconcileCreated: function handleReconcileCreated(data) {
      this.fields = data.fields ? data.fields : this.fields;
      this.itemIds = data.itemIds;
      this.splitCounter = data.splitCounter;
      this.selectedSupplier = data.selectedSupplier;
      this.selectedProgram = data.selectedProgram;
      this.selectedBu = data.selectedBu;
      this.selectedCc = data.selectedCc;
      this.selectedBuAndCcPair = data.selectedBuAndCcPair;
      this.selectedCategory = data.selectedCategory;
      this.referenceId = data.referenceId;
      this.descriptions = data.descriptions;
    },
    createReconciliationEnvelope: function createReconciliationEnvelope() {
      if (this.selectedRows.length === 0) {
        console.error('No data');
        return;
      }
    },
    formatDate: function formatDate(date) {
      if (!date) {
        return 'N/A';
      }
      var momentDate = global.moment(date);
      var month = momentDate.format('MM');
      var year = momentDate.format('YY');
      return month + '/' + year;
    },
    formatDateMMDDYYYY: function formatDateMMDDYYYY(date) {
      var momentDate = global.moment(date);
      var day = momentDate.format('DD');
      var month = momentDate.format('MM');
      var year = momentDate.format('YYYY');
      return month + '/' + day + '/' + year;
    },
    showTransactions: function showTransactions() {
      this.showTransactionsTab = true;
      this.showEnvelopesTab = false;
      this.showCardHistoryTab = false;
      this.showCardsTab = false;
      this.showAccountStatementsTab = false;
      this.highlightedObjectId = '';
      this.selectedRows = [];
      localStorage.setItem('row-highlight', '');
      this.envelope = {};
    },
    showEnvelopes: function showEnvelopes() {
      this.selectedRows = [];
      this.showTransactionsTab = false;
      this.showEnvelopesTab = true;
      this.showCardHistoryTab = false;
      this.showCardsTab = false;
      this.showAccountStatementsTab = false;
      this.highlightedObjectId = '';
      this.highlightedObjectId = localStorage.getItem('row-highlight');
      this.cardApproval = false;
      this.envelopeApproval = true;
      this.envelope = {};
    },
    showCardHistory: function showCardHistory() {
      this.selectedRows = [];
      this.showTransactionsTab = false;
      this.showEnvelopesTab = false;
      this.showCardHistoryTab = true;
      this.showCardsTab = false;
      this.showAccountStatementsTab = false;
      this.highlightedObjectId = '';
      localStorage.setItem('row-highlight', '');
    },
    showCards: function showCards() {
      this.selectedRows = [];
      this.showTransactionsTab = false;
      this.showEnvelopesTab = false;
      this.showCardHistoryTab = false;
      this.showCardsTab = true;
      this.showAccountStatementsTab = false;
      this.highlightedObjectId = '';
      localStorage.setItem('row-highlight', '');
      this.cardApproval = true;
      this.envelopeApproval = false;
    },
    showAccountStatements: function showAccountStatements() {
      this.selectedRows = [];
      this.showTransactionsTab = false;
      this.showEnvelopesTab = false;
      this.showCardHistoryTab = false;
      this.showCardsTab = false;
      this.showAccountStatementsTab = true;
      this.highlightedObjectId = '';
      localStorage.setItem('row-highlight', '');
    },
    closeReconcile: function closeReconcile(opts) {
      // userCancelled defaults to true so existing X/cancel callers behave unchanged;
      // saveAndReconcile passes userCancelled:false so cleanupUnsavedReceipts doesn't
      // delete the ReceiptScan that was just linked. Everything else still runs —
      // the modal closes / state resets either way.
      var userCancelled = !opts || opts.userCancelled !== false;
      if (userCancelled) {
        if (this.$refs.reconcileComp && typeof this.$refs.reconcileComp.cleanupUnsavedReceipts === 'function') {
          // Soft-delete any Platform receipt-scans uploaded in this session before tearing
          // down the modal — fire-and-forget so close stays responsive.
          this.$refs.reconcileComp.cleanupUnsavedReceipts();
        }
      } else if (this.$refs.reconcileComp && typeof this.$refs.reconcileComp.claimPendingFolderReceipts === 'function') {
        // PRODUCTDEV-5783 — reconcile saved: claim any receipt picked from the folder this
        // session (deferred FolderSaved → Matched) so it leaves the folder only on save.
        this.$refs.reconcileComp.claimPendingFolderReceipts();
      }
      this.showReconcile = false;
      this.refresh();
      this.selectedRows = [];
      this.transaction = {};
      this.approvalUsersData = [];
      this.resetValidation();
      this.resetFields();
      // Strip receiptScanId from URL so a later reconcile opened from the
      // grid doesn't accidentally re-apply the just-matched scan's prefill.
      if (this.$route.query.receiptScanId) {
        var cleaned = _objectSpread({}, this.$route.query);
        delete cleaned.receiptScanId;
        this.$router.replace({
          query: cleaned
        }).catch(function () {});
      }
    },
    refreshCards: function refreshCards() {
      var _this37 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee32() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return _this37.getCards(_this37.selectedAccountId);
            case 2:
              if (_this37.showCardsTab) {
                _this37.refresh();
              }
            case 3:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }))();
    },
    refreshCardWithDetails: function refreshCardWithDetails(cardId) {
      var _this38 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee33() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return _this38.getCardWithDetails(cardId);
            case 2:
              if (_this38.showCardsTab) {
                _this38.refresh();
              }
            case 3:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }))();
    },
    refresh: function refresh() {
      this.$refs.grid.refreshGrid();
    },
    redrawRows: function redrawRows() {
      this.$refs.grid.gridOptions.api.redrawRows();
    },
    redirectCardholder: function redirectCardholder(accountId) {
      this.$router.push('/d/Programs/>Card/list?AccountId=' + accountId);
      this.selectedAccountId = this.$route.query.AccountId;
      this.rememberLastAccount(accountId);
      this.getAccountData();
      this.getUserDivisions();
      this.getCards(this.selectedAccountId);
    },
    lastAccountStorageKey: function lastAccountStorageKey() {
      var userId = this.$user && this.$user.$ && this.$user.$.user && this.$user.$.user.UserID;
      return userId ? 'evedpay:lastAccountId:' + userId : null;
    },
    rememberLastAccount: function rememberLastAccount(accountId) {
      if (!accountId || !global.localStorage) return;
      var key = this.lastAccountStorageKey();
      if (!key) return;
      try {
        global.localStorage.setItem(key, accountId);
      } catch (e) {
        // localStorage may be unavailable (private mode); silently ignore.
      }
    },
    readLastAccount: function readLastAccount() {
      if (!global.localStorage) return null;
      var key = this.lastAccountStorageKey();
      if (!key) return null;
      try {
        return global.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    },
    updateUrlBackToAccountPage: function updateUrlBackToAccountPage() {
      window.history.pushState({}, '', '#/d/Programs/>Card/list?AccountId=' + this.selectedAccountId);
    },
    handleTransaction: function handleTransaction(transaction) {
      var _this39 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee34() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return _this39.applyTransactionContext(transaction);
            case 2:
              _this39.showReconcile = true;
              _this39.highlightedObjectId = _this39.transaction.data.Id;
            case 4:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }))();
    },
    // PRODUCTDEV-5574 — shared transaction-context setup for every entry point that switches the
    // active transaction (row checkbox + toolbar Reconcile, transaction-number link, etc.). Resets
    // editAuth before fetching so the previous transaction's permissions can't leak into the new
    // row, and re-fetches editAuth whenever the new transaction is in an envelope so the toolbar
    // path also reaches the in-envelope edit gate instead of falling back to view-only.
    applyTransactionContext: function applyTransactionContext(transaction) {
      var _this40 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee35() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _this40.transaction = transaction;
              _this40.editAuth = null;
              if (!(_this40.transaction && _this40.transaction.data)) {
                _context35.next = 16;
                break;
              }
              _this40.selectedCardId = _this40.transaction.data.CardId;
              _this40.selectedTransactionId = _this40.transaction.data.Id;
              if (!(_this40.transaction.data.EnvelopeId && _this40.transaction.data.EnvelopeId !== '00000000-0000-0000-0000-000000000000')) {
                _context35.next = 8;
                break;
              }
              _context35.next = 8;
              return _this40.fetchEditAuth(_this40.transaction.data.Id);
            case 8:
              // PRODUCTDEV-5783 — reset before the conditional reload so isUserInApprovalList()
              // reflects THIS transaction's envelope. getApprovalUsersEnvelope only runs for
              // waiting-approval envelopes, so without this a previously-opened approver envelope's
              // data could leak through and wrongly grant edit/receipt access. Mirrors Card-transactions.
              _this40.approvalUsersData = [];
              if (!_this40.waitingApprovalStatuses.includes(_this40.transaction.data.EnvelopeStatus)) {
                _context35.next = 12;
                break;
              }
              _context35.next = 12;
              return _this40.getApprovalUsersEnvelope(_this40.transaction.data.EnvelopeId);
            case 12:
              _context35.next = 14;
              return _this40.handleReconcileAction(_this40.transaction);
            case 14:
              _context35.next = 17;
              break;
            case 16:
              _this40.reconcileAction = 'create';
            case 17:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }))();
    },
    handleReconcileAction: function handleReconcileAction(transaction) {
      var _this41 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee36() {
        var readonlyStatuses, isInEnvelopeByTxStatus;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              readonlyStatuses = ['In Envelope', 'Exported', 'Posted'];
              isInEnvelopeByTxStatus = readonlyStatuses.includes(transaction.data.TransactionStatus);
              if (transaction.data.ReconciliationStatus !== 'Open') {
                if (transaction.data.ReconciliationStatus === 'Coded') {
                  if (transaction.data.EnvelopeStatus === 'Draft') {
                    _this41.reconcileAction = 'edit';
                  } else if (!isInEnvelopeByTxStatus || _this41.canEditInEnvelopeFromReconcileModal()) {
                    _this41.reconcileAction = 'edit';
                  } else {
                    _this41.reconcileAction = 'view';
                  }
                } else if (isInEnvelopeByTxStatus && _this41.canEditInEnvelopeFromReconcileModal()) {
                  // PRODUCTDEV-5574 — Approved envelopes (e.g. Open - Approved) remain editable from the
                  // Reconcile modal for authorized roles; per spec they are not editable from the envelope page.
                  _this41.reconcileAction = 'edit';
                } else {
                  _this41.reconcileAction = 'view';
                }
              } else if (isInEnvelopeByTxStatus) {
                if (transaction.data.EnvelopeStatus === 'Draft') {
                  _this41.reconcileAction = 'edit';
                } else if (_this41.canEditInEnvelopeFromReconcileModal()) {
                  _this41.reconcileAction = 'edit';
                } else {
                  _this41.reconcileAction = 'view';
                }
              } else {
                _this41.reconcileAction = 'create';
              }
            case 3:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }))();
    },
    // PRODUCTDEV-5574 — fetch the backend's edit-authorization profile for an in-envelope
    // transaction. Mirrors Card-transactions/index.vue.
    fetchEditAuth: function fetchEditAuth(transactionId) {
      var _this42 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee37() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.prev = 0;
              _context37.next = 3;
              return _this42.api.get(_this42.api.$.evedpaycard.canEditInEnvelopeTransaction, {
                params: {
                  transactionId: transactionId
                }
              });
            case 3:
              response = _context37.sent;
              _this42.editAuth = response.data || null;
              _context37.next = 12;
              break;
            case 7:
              _context37.prev = 7;
              _context37.t0 = _context37["catch"](0);
              console.error('There was a problem fetching transaction edit authorization:', _context37.t0);
              // Fail closed to view-only, but tell the user why so a transient can-edit
              // failure doesn't read as a silent permission downgrade.
              _this42.editAuth = null;
              _this42.$notifications.notify({
                type: 'plain',
                icon: 'exclamation-circle',
                placement: {
                  from: 'top',
                  align: 'center'
                },
                timeout: 0,
                message: 'We could not verify your edit permissions for this transaction. Please refresh and try again.',
                discard: 'Ok',
                goto: ''
              });
            case 12:
            case "end":
              return _context37.stop();
          }
        }, _callee37, null, [[0, 7]]);
      }))();
    },
    // PRODUCTDEV-5574 — the Reconcile modal does not grant edit access to a Declined-envelope
    // submitter who isn't also a card holder/admin/approver/global admin. That submitter-only
    // path is the envelope page's responsibility (CreateEnvelope.vue editEnvelope flow).
    canEditInEnvelopeFromReconcileModal: function canEditInEnvelopeFromReconcileModal() {
      // ASP.NET MVC's default JsonResult serializes property names as-is (PascalCase),
      // matching the convention used by other endpoints in this controller.
      if (!this.editAuth || !this.editAuth.CanEdit) return false;
      return this.editAuth.IsCardHolder || this.editAuth.IsCardAdmin || this.editAuth.IsApprover || this.editAuth.IsGlobalAdmin;
    },
    envelopeEditBlockedMessage: function envelopeEditBlockedMessage(reason) {
      switch (reason) {
        case 'EnvelopePostedOrExported':
          return 'This envelope has been posted or exported. Transactions in it can no longer be edited.';
        case 'NotAuthorized':
          return 'You do not have permission to edit this transaction.';
        case 'ProgramChangeNotAllowed':
          return "The ".concat((this.programName || 'department').toLowerCase(), " cannot be changed while the transaction is assigned to an envelope.");
        case 'EnvelopeNotFound':
        case 'TransactionNotFound':
          return 'We could not verify this transaction\'s envelope. Please refresh and try again.';
        default:
          return null;
      }
    },
    openReceiptUpload: function openReceiptUpload() {
      this.pendingReceiptFile = null;
      this.showSubmitReceiptModal = true;
    },
    triggerReceiptFileInput: function triggerReceiptFileInput() {
      this.$refs.receiptUploadInput.click();
    },
    handleReceiptFileSelected: function handleReceiptFileSelected(event) {
      var files = event.target.files;
      if (!files || files.length === 0) {
        return;
      }
      var file = files[0];

      // Mirror AddReceipt.vue:166-181 — the <input accept> attribute is a hint
      // only; users can bypass it via drag/drop or via mobile pickers. Enforce
      // here so the BE doesn't have to reject and the user gets useful copy.
      var ALLOWED = ['pdf', 'png', 'jpg', 'jpeg'];
      var parts = file.name ? file.name.split('.') : [];
      var extension = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
      if (!ALLOWED.includes(extension)) {
        this.$notifications.notify({
          type: 'info-warn',
          message: 'Please upload a file with one of these extensions: .pdf, .png, .jpg, .jpeg',
          placement: {
            from: 'top',
            align: 'center'
          }
        });
        if (this.$refs.receiptUploadInput) {
          this.$refs.receiptUploadInput.value = '';
        }
        return;
      }
      var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB — matches AddReceipt.vue
      if (file.size >= MAX_FILE_SIZE) {
        this.$notifications.notify({
          type: 'info-warn',
          message: 'File is too large. Please upload a receipt smaller than 10 MB.',
          placement: {
            from: 'top',
            align: 'center'
          }
        });
        if (this.$refs.receiptUploadInput) {
          this.$refs.receiptUploadInput.value = '';
        }
        return;
      }
      this.pendingReceiptFile = file;
    },
    clearPendingReceiptFile: function clearPendingReceiptFile() {
      this.pendingReceiptFile = null;
      if (this.$refs.receiptUploadInput) {
        this.$refs.receiptUploadInput.value = '';
      }
    },
    formatFileSize: function formatFileSize(bytes) {
      if (!bytes) return '';
      if (bytes < 1024) return bytes + 'b';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + 'Kb';
      return (bytes / (1024 * 1024)).toFixed(1) + 'Mb';
    },
    closeSubmitReceiptModal: function closeSubmitReceiptModal() {
      if (this.uploadingReceipt) return;
      this.showSubmitReceiptModal = false;
      this.pendingReceiptFile = null;
      if (this.$refs.receiptUploadInput) {
        this.$refs.receiptUploadInput.value = '';
      }
    },
    confirmSubmitReceipt: function confirmSubmitReceipt() {
      var _this43 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee38() {
        var file, barDuration, start, barComplete, legacyUrl, legacyToken, legacyPromise, formData, idempotencyKey, channelDivisionId, submitExtra, uploadPromise, _yield$Promise$all, _yield$Promise$all2, data, legacyMeta;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              if (_this43.pendingReceiptFile) {
                _context38.next = 2;
                break;
              }
              return _context38.abrupt("return");
            case 2:
              _context38.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_30__core_receiptScan_imageCompression__["a" /* default */])(_this43.pendingReceiptFile);
            case 4:
              file = _context38.sent;
              _this43.uploadingReceipt = true;
              _this43.uploadProgressPct = 0;
              _this43.pendingLegacyReceipt = null;

              // Drive bar width AND % label off the same rAF loop so they tick together over 4s.
              // The promise it returns IS the gate — we only swap modals once the bar truly hits 100%.
              barDuration = 4000;
              start = performance.now();
              barComplete = new Promise(function (resolve) {
                var _tick = function tick(now) {
                  var pct = Math.min(100, Math.round((now - start) / barDuration * 100));
                  _this43.uploadProgressPct = pct;
                  if (pct < 100) {
                    _this43._uploadProgressRaf = requestAnimationFrame(_tick);
                  } else {
                    _this43._uploadProgressRaf = null;
                    resolve();
                  }
                };
                _this43._uploadProgressRaf = requestAnimationFrame(_tick);
              }); // Option D — Legacy upload first (sequential), Platform second. Without
              // this the matched reconcile saves with no TransactionFiles row, and
              // reopen-view crashes on Substring(0,-1) of an empty PathWithName.
              // Mirrors ReconcileTransaction.uploadNewReceipt's pattern. Runs in
              // parallel with the 4s bar — Legacy is fast (~1-2s) so it normally
              // completes long before the bar; if it doesn't, we still wait for the
              // bar to swap modals (Platform may also still be in flight).
              legacyUrl = _this43.api && _this43.api.env ? _this43.api.env + _this43.api.$.evedpaycard.receipt : null;
              legacyToken = _this43.$user && _this43.$user.sessionSettings ? _this43.$user.sessionSettings.Token : '';
              legacyPromise = legacyUrl ? function (self) {
                var lf = new FormData();
                lf.append('attachment_upload', file);
                return self.api.post(legacyUrl, lf, {
                  headers: {
                    'Authorization': 'Bearer ' + legacyToken,
                    'Content-Type': 'multipart/form-data'
                  }
                }).then(function (resp) {
                  var body = resp && resp.data;
                  if (typeof body === 'string') {
                    try {
                      body = JSON.parse(body);
                    } catch (e) {
                      body = null;
                    }
                  }
                  if (!body || !body.success || !body.path) return null;
                  var m = body.path.match(/(ClientData\/.*)/);
                  var pathWithName = m && m[1] ? m[1] : body.path;
                  var mediaFile = body.file || pathWithName.split('/').pop();
                  return {
                    path: body.path,
                    pathWithName: pathWithName,
                    mediaFile: mediaFile,
                    file: mediaFile,
                    name: file.name,
                    type: file.type || '',
                    size: file.size || 0
                  };
                }).catch(function (err) {
                  console.warn('Legacy receipt upload failed at Dashboard SUBMIT:', err);
                  return null;
                });
              }(_this43) : Promise.resolve(null);
              formData = new FormData();
              formData.append('file', file);
              idempotencyKey = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0;
                var v = c === 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
              }); // Channel narrowing — the Open and Pending Transactions page binds to an
              // "account" which is a Division (legacy naming). Send its DivisionId so the
              // BE ranker scopes candidates to Programs in this Division. Omit when no
              // account is loaded (BE treats null as "no narrowing", current behavior).
              channelDivisionId = _this43.account && _this43.account.DivisionId ? _this43.account.DivisionId : null;
              submitExtra = channelDivisionId != null ? {
                uploadContextLegacyDivisionId: channelDivisionId
              } : null; // Kick off the upload now, but DON'T await it here. We always swap modals
              // when the bar finishes (4s) — the upload may complete before, during, or after.
              _this43.$notifications.notify({
                type: 'info',
                message: 'Scanning receipt...',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              uploadPromise = __WEBPACK_IMPORTED_MODULE_28__core_api_receiptScans__["b" /* default */].submitReceipt(formData, idempotencyKey, submitExtra);
              _context38.prev = 21;
              _context38.next = 24;
              return barComplete;
            case 24:
              _this43.uploadingReceipt = false;

              // Build a client-side objectURL from the file the user just picked so the
              // receipt is visible the instant the skeleton modal opens — no waiting on
              // the BE image fetch. URL is revoked on modal close (see watcher below).
              // We pass the MIME alongside so the modal renders <embed> for PDFs (an
              // <img> tag silently shows nothing for application/pdf bytes).
              if (_this43.candidateSelectorLocalImageUrl) {
                URL.revokeObjectURL(_this43.candidateSelectorLocalImageUrl);
              }
              _this43.candidateSelectorLocalImageUrl = URL.createObjectURL(file);
              _this43.candidateSelectorLocalImageType = file.type || null;
              _this43.closeSubmitReceiptModal();

              // Open the Select Transaction modal in skeleton state. receiptScanId is
              // still null — handleReceiptScanStarted will set it + start the poller
              // once `uploadPromise` resolves. The image is already visible from the
              // local objectURL above.
              _this43.candidateSelectorReceiptId = null;
              _this43.candidateSelectorCandidates = [];
              _this43.candidateSelectorRowVersion = null;
              _this43.candidateSelectorAutoLinked = false;
              _this43.candidateSelectorAutoFill = null;
              _this43.candidateSelectorLoading = true;
              _this43.showCandidateSelector = true;

              // Now wait for the upload itself. Stash Legacy metadata alongside so
              // handleMatchSelected can hand it to ReconcileTransaction via sessionStorage.
              _context38.next = 38;
              return Promise.all([uploadPromise, legacyPromise]);
            case 38:
              _yield$Promise$all = _context38.sent;
              _yield$Promise$all2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_yield$Promise$all, 2);
              data = _yield$Promise$all2[0];
              legacyMeta = _yield$Promise$all2[1];
              _this43.pendingLegacyReceipt = legacyMeta || null;

              // User may have dismissed the skeleton modal mid-flight. handleReceiptScanStarted
              // hasn't fired yet so candidateSelectorReceiptId is still null and the close
              // handler couldn't dispose. Fire delete here with the freshly-returned id.
              if (_this43.showCandidateSelector) {
                _context38.next = 46;
                break;
              }
              if (data && data.receiptScanId) {
                __WEBPACK_IMPORTED_MODULE_28__core_api_receiptScans__["b" /* default */].deleteReceipt(data.receiptScanId).catch(function (err) {
                  console.warn('Receipt dispose on mid-upload dismiss failed (ignored):', err);
                });
              }
              return _context38.abrupt("return");
            case 46:
              if (data && data.receiptScanId) {
                // extended-bus.js auto-wraps payload as { target, data }; emit raw shape so listener's payload.data resolves to { receiptScanId, source }
                __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$emit('receipt-scan-started', {
                  receiptScanId: data.receiptScanId,
                  source: 'webDashboard'
                });
                if (legacyUrl && !legacyMeta) {
                  // Photon succeeded but the parallel Legacy attachment upload failed (see Option D
                  // comment above). The reconcile match will still work on the Platform side, but the
                  // legacy reopen-view will show no receipt image. Surface this clearly so the user can
                  // cancel + retry instead of discovering the gap later.
                  _this43.$notifications.notify({
                    type: 'info-warn',
                    message: "Receipt scanned, but it couldn't be attached to the transaction record. Match will still work, but the receipt won't appear on reopen. Cancel and retry if you need the attachment preserved.",
                    placement: {
                      from: 'top',
                      align: 'center'
                    }
                  });
                }
                // Success case: no post-scan toast — the immediate "Scanning receipt..."
                // toast above signaled progress, and the candidate selector modal opening
                // is sufficient completion confirmation.
              }
              _context38.next = 62;
              break;
            case 49:
              _context38.prev = 49;
              _context38.t0 = _context38["catch"](21);
              // Upload failed — close whichever modal is still up.
              _this43.uploadingReceipt = false;
              _this43.closeSubmitReceiptModal();

              // PRODUCTDEV-5851 — the image couldn't be scanned (e.g. dimensions out of range), but the
              // backend still persisted the receipt (ReadyForMatch, zero candidates) and returns 422 with
              // its receiptScanId. Silently drive the SAME post-scan flow (no error toast) so the user can
              // match manually or save it to their folder. Isolated to this one status — every other error
              // keeps its handling below.
              if (!(_context38.t0.response && _context38.t0.response.status === 422 && _context38.t0.response.data && _context38.t0.response.data.receiptScanId)) {
                _context38.next = 56;
                break;
              }
              __WEBPACK_IMPORTED_MODULE_6__event_bus__["b" /* EventBus */].$emit('receipt-scan-started', {
                receiptScanId: _context38.t0.response.data.receiptScanId,
                source: 'webDashboard'
              });
              return _context38.abrupt("return");
            case 56:
              if (_this43.showCandidateSelector && _this43.candidateSelectorLoading && !_this43.candidateSelectorReceiptId) {
                _this43.showCandidateSelector = false;
                _this43.candidateSelectorLoading = false;
              }
              if (!_context38.t0.isPlatformSentinelError) {
                _context38.next = 60;
                break;
              }
              _this43.$notifications.notify({
                type: 'info-warn',
                message: 'Receipt capture is temporarily unavailable. Please try again later.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              return _context38.abrupt("return");
            case 60:
              _this43.$notifications.notify({
                type: 'info-warn',
                message: 'Failed to upload receipt. Please try again.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              console.error('Error uploading receipt:', _context38.t0);
            case 62:
              _context38.prev = 62;
              if (_this43._uploadProgressRaf) {
                cancelAnimationFrame(_this43._uploadProgressRaf);
                _this43._uploadProgressRaf = null;
              }
              _this43.uploadingReceipt = false;
              _this43.uploadProgressPct = 0;
              return _context38.finish(62);
            case 67:
            case "end":
              return _context38.stop();
          }
        }, _callee38, null, [[21, 49, 62, 67]]);
      }))();
    },
    handleReceiptScanStarted: function handleReceiptScanStarted(data) {
      var self = this;
      var receiptScanId = data.receiptScanId;
      if (this.activePoller) {
        this.activePoller.cancel();
      }

      // Open the Select Transaction modal IMMEDIATELY in skeleton-loading state
      // so the user sees the receipt image + shimmer placeholders while the
      // Photon scan polls in the background. The poller's onDone clears
      // `candidateSelectorLoading` and populates real candidates/autoFill.
      this.candidateSelectorReceiptId = receiptScanId;
      this.candidateSelectorCandidates = [];
      this.candidateSelectorRowVersion = null;
      this.candidateSelectorAutoLinked = false;
      this.candidateSelectorAutoFill = null;
      this.candidateSelectorLoading = true;
      this.showCandidateSelector = true;
      var poller = Object(__WEBPACK_IMPORTED_MODULE_29__core_receiptScan_receiptScanPoller__["a" /* default */])({
        receiptScanId: receiptScanId,
        contextHint: {
          source: data.source
        },
        onStateChange: function onStateChange() {},
        onDone: function onDone() {
          self.activePoller = null;
          __WEBPACK_IMPORTED_MODULE_28__core_api_receiptScans__["b" /* default */].getStatus(receiptScanId).then(function (statusData) {
            var candidates = statusData && statusData.matchCandidates || [];

            // Auto-link only when exactly one candidate AND BE flagged it as a confident
            // match. Route straight to the transaction detail page with the receiptScanId
            // so ReconcileTransaction.tryApplyReceiptScanPrefill picks it up and applies
            // prefill per the Division's configured mode.
            if (candidates.length === 1 && statusData.autoLinked) {
              self.showCandidateSelector = false;
              self.candidateSelectorLoading = false;
              self.candidateSelectorReceiptId = null;
              self.openMatchedReconcile(candidates[0].legacyTransactionId, receiptScanId);
              return;
            }

            // Either real candidates OR zero candidates — keep the modal open so the user
            // can pick a match, ADD TO RECEIPT FOLDER deliberately, or CANCEL (which
            // soft-deletes via handleCandidateSelectorClose). Don't silently auto-park —
            // the user needs to see the receipt and decide.
            self.candidateSelectorReceiptId = receiptScanId;
            self.candidateSelectorCandidates = candidates;
            self.candidateSelectorRowVersion = statusData.rowVersion;
            self.candidateSelectorAutoLinked = statusData.autoLinked || false;
            self.candidateSelectorAutoFill = statusData.autoFill || null;
            self.candidateSelectorLoading = false;
            self.showCandidateSelector = true;
          }).catch(function (err) {
            console.error('Error fetching receipt status:', err);
            self.showCandidateSelector = false;
            self.candidateSelectorLoading = false;
            self.$notifications.notify({
              type: 'danger',
              message: 'Failed to retrieve receipt details. Please try again.',
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          });
        },
        onError: function onError(error) {
          self.activePoller = null;
          // Scan failed/timed out — drop the skeleton modal so the user isn't stuck staring at it.
          self.showCandidateSelector = false;
          self.candidateSelectorLoading = false;
          if (error.type === 'unreachable' || error.type === 'timeout') {
            // Scan still in progress server-side; BE retry sweep continues
            // up to its wall-clock ceiling. The receipt isn't in the folder
            // yet, so don't navigate there — it would be empty.
            self.$notifications.notify({
              type: 'info',
              message: 'Scan is taking longer than expected. We\'ll keep working on it — check the Receipt Folder later.',
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          } else if (error.type === 'scan_failed') {
            self.$notifications.notify({
              type: 'danger',
              message: 'Scan failed. Please try uploading the receipt again.',
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          } else {
            self.$notifications.notify({
              type: 'danger',
              message: 'Error scanning receipt. Please try again.',
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          }
        }
      });
      this.activePoller = poller;
      poller.start();
    },
    // TODO(productdev-5606): mobile + folder callers may need same loading prop wiring
    handleMatchSelected: function handleMatchSelected(data) {
      // Clear receiptId BEFORE the modal's @close fires, otherwise
      // handleCandidateSelectorClose will fall through to dispose-on-cancel and
      // soft-delete the already-Matched receipt (BE returns 400 wrong_state).
      // (handleSaveToFolder below has the same pattern for the same reason.)
      this.candidateSelectorReceiptId = null;
      this.showCandidateSelector = false;
      // Open the desktop reconcile modal in-place with the matched tx data —
      // ReconcileTransaction will apply prefill from receiptScanId in the URL
      // and consume the stashed Legacy upload metadata for the file chip.
      this.openMatchedReconcile(data.legacyTransactionId, data.receiptScanId);
    },
    // Open the desktop reconcile modal for a transaction that was just matched
    // via the CandidateSelector. Used by both manual-pick (handleMatchSelected)
    // and auto-link (in handleReceiptScanStarted's onDone). Stashes the Legacy
    // upload metadata, pre-fetches the prefill (so the modal opens populated
    // instead of empty-then-populating), drops receiptScanId into the URL query
    // so ReconcileTransaction.tryApplyReceiptScanPrefill + consumeStashedLegacyReceipt
    // pick it up on mount, then fetches the tx data via the grid's existing
    // endpoint so handleTransaction can open the modal exactly like a row click.
    openMatchedReconcile: function openMatchedReconcile(legacyTransactionId, receiptScanId) {
      var _this44 = this;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee39() {
        var prefillP, txP, _yield$Promise$all3, _yield$Promise$all4, resp, rows, tx;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _this44.stashLegacyReceiptForReconcile(receiptScanId);
              _context39.prev = 1;
              _context39.next = 4;
              return _this44.$router.replace({
                query: _objectSpread(_objectSpread({}, _this44.$route.query), {}, {
                  receiptScanId: receiptScanId
                })
              });
            case 4:
              _context39.next = 8;
              break;
            case 6:
              _context39.prev = 6;
              _context39.t0 = _context39["catch"](1);
            case 8:
              // Pre-fetch prefill in parallel with the tx fetch. Stash result so
              // ReconcileTransaction.tryApplyReceiptScanPrefill consumes it synchronously
              // on mount instead of doing its own network call (which would render the
              // modal empty for ~200-500ms then flash in the values). Promise.all gates
              // the modal open behind whichever fetch finishes last.
              prefillP = __WEBPACK_IMPORTED_MODULE_28__core_api_receiptScans__["b" /* default */].getPrefill(receiptScanId).then(function (data) {
                if (data) {
                  try {
                    global.sessionStorage.setItem('receiptScanPrefill_' + receiptScanId, JSON.stringify(data));
                  } catch (e) {
                    // sessionStorage disabled — Reconcile falls back to its own API call
                  }
                }
              }).catch(function () {
                // Prefill fetch failed — Reconcile's tryApplyReceiptScanPrefill will retry
                // via the API path. Not fatal here.
              });
              txP = _this44.api.forms.post(_this44.api.$.evedpaycard.transactions, {
                sort: 'TransactionStatus',
                dir: 'ASC',
                start: 0,
                limit: 1,
                isLiveGrid: true,
                filter: JSON.stringify({
                  Id: legacyTransactionId,
                  searchTerm: ''
                })
              });
              _context39.prev = 10;
              _context39.next = 13;
              return Promise.all([prefillP, txP]);
            case 13:
              _yield$Promise$all3 = _context39.sent;
              _yield$Promise$all4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_yield$Promise$all3, 2);
              resp = _yield$Promise$all4[1];
              rows = resp && resp.data && resp.data.Data;
              if (!(rows && rows.length > 0)) {
                _context39.next = 23;
                break;
              }
              tx = rows[0];
              _context39.next = 21;
              return _this44.handleTransaction({
                data: _objectSpread(_objectSpread({}, tx), {}, {
                  merchant: tx.Merchant,
                  amount: tx.Amount,
                  date: tx.TransactionDate,
                  status: tx.TransactionStatus,
                  reconcileStatus: tx.ReconciliationStatus,
                  id: tx.Id
                })
              });
            case 21:
              _context39.next = 24;
              break;
            case 23:
              _this44.$notifications.notify({
                type: 'warning',
                message: 'Could not open the matched transaction. Click it in the list to view.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            case 24:
              _context39.next = 30;
              break;
            case 26:
              _context39.prev = 26;
              _context39.t1 = _context39["catch"](10);
              console.error('Failed to load matched transaction for reconcile:', _context39.t1);
              _this44.$notifications.notify({
                type: 'warning',
                message: 'Could not open the matched transaction. Click it in the list to view.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            case 30:
            case "end":
              return _context39.stop();
          }
        }, _callee39, null, [[1, 6], [10, 26]]);
      }))();
    },
    // Persist the Legacy upload metadata under a sessionStorage key that the
    // navigated-to ReconcileTransaction will read once on `created`. We use
    // sessionStorage rather than a Vuex store because the receipt-capture flow
    // doesn't have one and a query-string blob would be ugly + URL-length-bounded.
    // The receiving side deletes the entry after consuming it (one-shot).
    stashLegacyReceiptForReconcile: function stashLegacyReceiptForReconcile(receiptScanId) {
      if (!receiptScanId || !this.pendingLegacyReceipt) return;
      try {
        var key = 'receiptScanLegacyPath_' + receiptScanId;
        global.sessionStorage.setItem(key, JSON.stringify(this.pendingLegacyReceipt));
      } catch (err) {
        // Storage quota / disabled / SSR — non-fatal, the reconcile just won't
        // populate the file. User can still save (banner / matched scan stays),
        // they just lose the reopen-view convenience.
        console.warn('Could not stash legacy receipt metadata:', err);
      }
    },
    handleSaveToFolder: function handleSaveToFolder() {
      this.showCandidateSelector = false;
      this.candidateSelectorReceiptId = null;
      // CandidateSelector emits this event AND already shows the success toast itself —
      // don't double up here.
    },
    handleMatchAttempt: function handleMatchAttempt() {
      // ed-modal.confirm() synchronously fires @close right after @confirm
      // (edModal/index.vue:161-163). Without this flag, handleCandidateSelectorClose
      // would treat the SUBMIT click as a cancel and DELETE the scan while the
      // match POST is still in flight — DELETE wins the race ~half the time, and
      // the match handler 404s because the scan is soft-deleted before
      // AuthorizeMutateAsync runs. The match success/error paths handle disposal.
      this.candidateSelectorMatching = true;
    },
    handleMatchError: function handleMatchError() {
      // Match POST failed; ed-modal already auto-closed. The scan is alive in
      // ReadyForMatch but no longer reachable from any UI surface (folder hides
      // non-FolderSaved). Dispose it explicitly so it doesn't orphan.
      var idToDispose = this.candidateSelectorReceiptId;
      this.candidateSelectorReceiptId = null;
      this.candidateSelectorMatching = false;
      if (idToDispose) {
        __WEBPACK_IMPORTED_MODULE_28__core_api_receiptScans__["b" /* default */].deleteReceipt(idToDispose).catch(function (err) {
          console.warn('Match-error scan dispose failed (ignored):', err);
        });
      }
    },
    handleCandidateSelectorClose: function handleCandidateSelectorClose() {
      var self = this;
      // X / CANCEL dismiss = dispose. handleMatchSelected and handleSaveToFolder
      // both null candidateSelectorReceiptId BEFORE close fires, so the snapshot
      // below is non-null only on the true "user walked away" path. DELETE
      // /receipts/{id} soft-deletes from any status except Submitted (per the
      // ReceiptScan.SoftDelete invariant) and is idempotent, so it's safe whether
      // OCR finished or is still in flight.
      if (self.activePoller) {
        self.activePoller.cancel();
        self.activePoller = null;
      }
      // SUBMIT click triggers ed-modal's auto-close synchronously; the match POST
      // is still in flight. Skip dispose — handleMatchSelected/handleMatchError
      // will own cleanup.
      if (self.candidateSelectorMatching) {
        self.candidateSelectorMatching = false;
        self.showCandidateSelector = false;
        self.candidateSelectorLoading = false;
        return;
      }
      var idToDispose = self.candidateSelectorReceiptId;
      self.showCandidateSelector = false;
      self.candidateSelectorLoading = false;
      self.candidateSelectorReceiptId = null;
      if (idToDispose) {
        __WEBPACK_IMPORTED_MODULE_28__core_api_receiptScans__["b" /* default */].deleteReceipt(idToDispose).catch(function (err) {
          // 404 / wrong_state means a late match or save-to-folder won the race —
          // the scan moved on, nothing to dispose. Swallow.
          console.warn('Receipt dispose on cancel failed (ignored):', err);
        });
      }
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.isActive = false;
    this.clearPollInterval();
    this.refreshScheduled = false;
    if (this.activePoller) {
      this.activePoller.cancel();
      this.activePoller = null;
    }
    if (this.pendingReceiptObjectUrl) URL.revokeObjectURL(this.pendingReceiptObjectUrl);
  },
  deactivated: function deactivated() {
    this.isActive = false;
    this.clearPollInterval();
    this.refreshScheduled = false;
    if (this.activePoller) {
      this.activePoller.cancel();
      this.activePoller = null;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "nY8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.params.data.TransactionStatus != 'Declined')?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('Open ' + _vm.params.value),expression:"'Open ' + params.value",modifiers:{"bottom":true}}],staticStyle:{"text-decoration":"underline","cursor":"pointer"},on:{"click":_vm.OpenReconcile}},[_vm._v("\n    "+_vm._s(_vm.params.data.TransactionNumber)+"\n  ")]):_c('span',[_vm._v(_vm._s(_vm.params.data.TransactionNumber))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "naW0":
/***/ (function(module, exports) {

module.exports = {"rule":"RuleDTO","condition":"ConditionDTO","action":"ActionDTO","role":"RoleDTO","conditionValue":"ConditionValueDTO","user":"UserDTO","po":"POConditionDTO","invoice":"InvoiceConditionDTO","expense":"ExpenseConditionDTO","scope":"ScopeConditionDTO","evedPay":"EvedPayCardConditionDTO","programBudget":"ProgramBudgetConditionDTO","division":"DivisionConditionDTO","businessUnit":"BusinessUnitConditionDTO","costCenter":"CostCenterConditionDTO","meetingType":"MeetingTypeConditionDTO","category":"CategoryConditionDTO","itemOwner":"ItemOwnerConditionDTO","programTeamMember":"ProgramTeamMemberConditionDTO","amount":"TotalAmountConditionDTO","adjustmentAmount":"AdjustmentAmountConditionDTO","notify":"NotifyApprovalActionDTO","requestApprovalAction":"RequestApprovalActionDTO","evedPayStatus":"SupplierEvedPayStatusConditionDTO","discountPaymentTerms":"DiscountPaymentTermsConditionDTO","preCommit":"PreCommitConditionDTO","supplierLocation":"SupplierLocationConditionDTO","supplierOrganizationType":"SupplierOrganizationTypeConditionDTO"}

/***/ }),

/***/ "nds2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de": [
		"wBVm",
		6
	],
	"./de.json": [
		"wBVm",
		6
	],
	"./en-GB": [
		"XG68",
		5
	],
	"./en-GB.json": [
		"XG68",
		5
	],
	"./en-US": [
		"0TFE"
	],
	"./en-US.json": [
		"0TFE"
	],
	"./es": [
		"IM7x",
		4
	],
	"./es.json": [
		"IM7x",
		4
	],
	"./ro": [
		"cQwO",
		3
	],
	"./ro.json": [
		"cQwO",
		3
	],
	"./zh-HK": [
		"lpNb",
		2
	],
	"./zh-HK.json": [
		"lpNb",
		2
	],
	"./zh-SG": [
		"pKha",
		1
	],
	"./zh-SG.json": [
		"pKha",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "nds2";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "neG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("1IA/");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd066782_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("j3Ff");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd066782_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nePQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-switch',
  props: {
    fieldLabel: String,
    required: Boolean,
    value: {
      default: false
    },
    disabled: {
      default: false
    },
    label: {
      default: ''
    },
    textEnabled: {
      default: 'On'
    },
    textDisabled: {
      default: 'Off'
    },
    color: {
      default: 'default'
    },
    emitOnMount: {
      default: true
    },
    helptipHeader: String,
    helptipBody: String,
    error: Boolean
  },
  mounted: function mounted() {
    if (this.emitOnMount) {
      this.$emit('input', this.value);
    }
  },
  data: function data() {
    return {
      showHelp: false,
      showIcon: 'fas fa-question-circle',
      hideIcon: 'far fa-times-circle'
    };
  },
  methods: {
    trigger: function trigger(e) {
      this.$emit('input', e.target.checked);
    },
    mousedown: function mousedown(e) {
      this.$emit('mousedown', e);
    },
    toggleHelp: function toggleHelp() {
      this.showHelp = !this.showHelp;
    }
  },
  computed: {
    classObject: function classObject() {
      var color = this.color,
        value = this.value,
        disabled = this.disabled; // eslint-disable-line
      return {
        'vue-switcher': true,
        'vue-switcher--unchecked': !value,
        'vue-switcher--disabled': disabled
      };
    },
    shouldShowLabel: function shouldShowLabel() {
      return this.label !== '' || this.textEnabled !== '' || this.textDisabled !== '';
    }
  }
});

/***/ }),

/***/ "neRZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nf0W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"endpoint":_vm.submitEndpoint}},[(!_vm.loading && _vm.cards && (_vm.cards.length > 1))?_c('div',{staticClass:"top-buttons"},[_c('ed-button',{staticClass:"btn btn-actionbar primary",on:{"click":_vm.showApproveAll}},[_vm._v("\n      Approve All\n    ")]),_vm._v(" "),_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.showRejectAll}},[_vm._v("\n      "+_vm._s(_vm.rejectText)+" All\n    ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wrapper"},[(_vm.hasData)?_c('div',{staticClass:"scroller"},[_c('div',_vm._l((_vm.cards),function(card,i){return _c('card',{key:i,attrs:{"id":("card-" + i),"useMeetingRequestor":_vm.useMeetingRequestor,"meetingRequesterName":_vm.meetingRequesterName,"rejectText":_vm.rejectText,"card":card,"programLabel":_vm.programLabel,"divisionLabel":_vm.divisionLabel,"lastEntry":i === _vm.cards.length - 1},on:{"onApprove":function($event){return _vm.showApprove(card)},"onReject":function($event){return _vm.showReject(card)}}})}),1)]):_vm._e(),_vm._v(" "),(this.loading)?_c('div',{staticClass:"empty-holder"},[_c('span',{staticClass:"approval-loading"}),_vm._v(" Loading approval queue ...\n    ")]):_vm._e(),_vm._v(" "),(!this.loading && !_vm.hasData)?_c('div',{staticClass:"empty-holder"},[_c('i',{staticClass:"fal fa-check-circle"}),_vm._v(" "),_vm._m(0)]):_vm._e()]),_vm._v(" "),_c('approveDialog',{attrs:{"showModal":_vm.showApproveDialog,"list":_vm.dialogList,"programLabel":_vm.programLabel,"divisionLabel":_vm.divisionLabel,"submitEndpoint":_vm.submitEndpoint},on:{"approve":_vm.doApprove,"close":function () { _vm.showApproveDialog = false }}}),_vm._v(" "),_c('rejectDialog',{attrs:{"showModal":_vm.showRejectDialog,"list":_vm.dialogList,"rejectText":_vm.rejectText,"programLabel":_vm.programLabel,"divisionLabel":_vm.divisionLabel,"submitEndpoint":_vm.submitEndpoint},on:{"reject":_vm.doReject,"close":function () { _vm.showRejectDialog = false }}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('p',{staticClass:"bold"},[_vm._v("No Items in Queue")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("No items are ready for review")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nleJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__ = __webpack_require__("HMpe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_lang__ = __webpack_require__("pe4m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var hiddenCols = ['_', '+'];

// import { EventBus } from '@/event-bus'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'column-selector',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  props: {
    columns: Array,
    api: Object
  },
  data: function data() {
    return {
      invalid: false,
      isColumnSelectorOpened: false,
      search: '',
      columnsList: this.columns
    };
  },
  computed: {
    filteredColumns: function filteredColumns() {
      var _this = this;
      return this.columnsList.filter(function (column) {
        return column.headerName.toLowerCase().includes(_this.search.toLowerCase());
      });
    }
  },
  created: function created() {
    this.oColumns = utils.copy(this.columns);
    this.defaultColumns = utils.copy(this.columns);
  },
  mounted: function mounted() {
    //
    var sourceViewport = this.$el.querySelector('.scroller.source');
    var destViewport = this.$el.querySelector('.scroller.destination');
    this.psSource = new __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__["a" /* default */](sourceViewport, {
      minScrollbarLength: 20
    });
    this.psDest = new __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__["a" /* default */](destViewport, {
      minScrollbarLength: 20
    });
  },
  methods: {
    t: function t(key) {
      return __WEBPACK_IMPORTED_MODULE_2__lang_lang__["a" /* i18n */].t(key);
    },
    openColumnSelector: function openColumnSelector() {
      var _this2 = this;
      // update columns
      this.columnsList = this.$parent.gridOptions.columnApi.getAllColumns().map(function (column) {
        return {
          field: column.colId,
          headerName: column.colDef.headerName,
          hide: !column.visible
        };
      });
      this.isColumnSelectorOpened = !this.isColumnSelectorOpened;
      setTimeout(function () {
        _this2.$refs.input.$refs.input.focus();
        _this2.updateScroll();
      }, 50);
    },
    closeColumnSelector: function closeColumnSelector() {
      if (this.isColumnSelectorOpened) {
        this.isColumnSelectorOpened = false;
        this.revert();
      }
    },
    updateScroll: function updateScroll() {
      this.psSource.update();
      this.psDest.update();
    },
    hiddenColumn: function hiddenColumn(column) {
      return hiddenCols.indexOf(column.headerName) === -1;
    },
    hideColumn: function hideColumn(column) {
      column.hide = true;
    },
    showColumn: function showColumn(column) {
      column.hide = false;
    },
    valid: function valid() {
      var _this3 = this;
      var valid = this.columnsList.filter(function (column) {
        return !column.hide && _this3.hiddenColumn(column);
      }).length >= 1;
      this.invalid = !valid;
      return valid;
    },
    apply: function apply() {
      if (!this.valid()) return;
      var grid = this;
      this.columnsList.forEach(function (column) {
        grid.$parent.gridOptions.columnApi.setColumnVisible(column.field, !column.hide);
      });
      this.oColumns = this.columnsList;
      this.closeColumnSelector();
    },
    revert: function revert() {
      this.columnsList = utils.copy(this.oColumns);
    },
    revertDefault: function revertDefault() {
      this.oColumns = this.columnsList;
      this.columnsList = utils.copy(this.defaultColumns);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "nnjS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1dORgr0FdVZNG5AhCqBG8G","Dell":"_3pIwAgqelIP6u7Jj6_LgOf","Abbott":"_2x0yL5EOFe5-_FM9JC14J","Gap":"_30NJlyCEiaki98PfBMM8Xv","Allstate":"_1Z7VIod3zJvL04ZPm21iJt","Asurion":"rt7iIdp1vErCMwDR0nGPw","Invitae":"_1hZcgg-Xsa3wKmmHloQDDZ","JWE":"_34rqLNCIVKF4LCeBcoKlsl"};

/***/ }),

/***/ "nxvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_charts_components_money__ = __webpack_require__("TQ2p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_charts_components_tooltip_standard__ = __webpack_require__("Ik2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter__ = __webpack_require__("7VNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__ = __webpack_require__("CRMk");




/* harmony default export */ __webpack_exports__["a"] = ({
  showLegend: false,
  showSmallLegend: true,
  chartOpts: getOptions(),
  chartData: function chartData(widget, data) {
    return getChartData(widget, data);
  },
  chartInfo: function chartInfo(widget, data) {
    return getChartInfo(data, getVariableIndex(widget));
  },
  drillDown: function drillDown(ctx, value, index) {
    return executeDrillDown(ctx, value, index);
  },
  drillDownReturn: function drillDownReturn(ctx) {
    return reverseDrillDown(ctx);
  },
  components: {
    labelValue: __WEBPACK_IMPORTED_MODULE_0__core_charts_components_money__["a" /* default */],
    tooltip: __WEBPACK_IMPORTED_MODULE_1__core_charts_components_tooltip_standard__["a" /* default */]
  }
});
function getOptions() {
  var baseCustSet = {
    chartGroupValue: 'FromFilter:PaymentStatusMainFilter',
    containterStyle: '',
    hasDrillDown: true,
    recalculateGridMax: true,
    showTotal: true,
    multipleSeries: true,
    dynamicHeight: true,
    tooltip: {
      tooltipType: 'standard',
      width: '330px'
    }
  };
  var baseOpts = {
    customSettings: baseCustSet,
    stackBars: true,
    seriesBarDistance: 18,
    horizontalBars: true,
    targetLine: {
      value: 0,
      class: 'ct-target-line'
    },
    labelInterpolationFnc: function labelInterpolationFnc(value) {
      return value[0];
    },
    fullWidth: false,
    axisY: {
      position: 'start',
      labelOffset: {
        x: 2,
        y: 1
      },
      scaleMinSpace: 15,
      showGrid: true,
      showLabel: true,
      offset: 140,
      labelInterpolationFnc: function labelInterpolationFnc(value) {
        return value;
      } // return formatter.thousandsFormatter(value) }
    },
    chartPadding: {
      top: 2,
      right: 25,
      bottom: 5,
      left: 5
    }
  };
  return baseOpts;
}
function getChartInfo(dataIn, pos) {
  var result = [];
  dataIn.forEach(function (elem) {
    var gdPos = result.findIndex(function (k) {
      return k[0] === elem[pos];
    });
    if (gdPos === -1) result.push(elem[pos]);
  });
  return result.map(function (k) {
    return k[0];
  });
}
function getChartData(widget, data) {
  var labelsGrouped = [];
  var totalSpend = 0;
  var grInx = getVariableIndex(widget);
  data.forEach(function (elem) {
    var label = grInx === 5 ? elem[5] + (elem[6] ? ' (' + elem[6] + ')' : '') : elem[grInx];
    if (label !== '') {
      var gdPos = labelsGrouped.findIndex(function (k) {
        return k[0] === label;
      });
      if (gdPos === -1) {
        labelsGrouped.push([label, 0, [0, 0, 0, 0]]);
      }
      var labelPos = labelsGrouped.findIndex(function (k) {
        return k[0] === label;
      });
      labelsGrouped[labelPos][1] += elem[7] + elem[8] + elem[9] + elem[10];
      labelsGrouped[labelPos][2][0] += elem[7] || 0;
      labelsGrouped[labelPos][2][1] += elem[8] || 0;
      labelsGrouped[labelPos][2][2] += elem[9] || 0;
      labelsGrouped[labelPos][2][3] += elem[10] || 0;
    }
  });
  var sortedData = labelsGrouped.slice(0);
  sortedData.sort(function (a, b) {
    return a[1] - b[1];
  });
  var totals = sortedData.map(function (k) {
    return k[1];
  });
  var maxValue = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayMaxValue(totals);
  var minValue = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayMinValue(totals);
  var seriesGrouped = sortedData.map(function (k) {
    return k[2];
  });
  totals = sortedData.map(function (k) {
    return __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.thousandsFormatter(k[1]);
  });
  return {
    total: totalSpend.toFixed(2),
    labels: sortedData.map(function (k) {
      return k[0];
    }),
    series: [{
      type: 'Bar',
      stackBars: true,
      maxValue: maxValue,
      minValue: minValue,
      ignoreForCharts: false,
      barSpace: 40,
      minHeight: 90,
      data: [{
        name: 'Balance',
        value: seriesGrouped.map(function (k) {
          return k[0].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].blueLight,
        width: '25px',
        ignoreLabel: true
      }, {
        name: 'Scheduled Payments - Funds Not Received',
        value: seriesGrouped.map(function (k) {
          return k[2].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].green,
        width: '25px',
        ignoreLabel: true
      }, {
        name: 'Scheduled Payments - Funds Received',
        value: seriesGrouped.map(function (k) {
          return k[1].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].purple,
        width: '25px',
        ignoreLabel: true
      }, {
        name: 'Received Payments',
        value: seriesGrouped.map(function (k) {
          return k[3].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].yellowish,
        width: '25px',
        ignoreLabel: false,
        metadata: {
          barLabels: totals
        }
      }]
    }],
    tooltipData: {
      helpText: 'Click on the bar to show Invoice spend details.',
      metadata: tooltipMetadata,
      data: [sortedData.map(function (t) {
        return t[0];
      }), seriesGrouped.map(function (k) {
        return k[0].toFixed(2);
      }), seriesGrouped.map(function (k) {
        return k[2].toFixed(2);
      }), seriesGrouped.map(function (k) {
        return k[1].toFixed(2);
      }), seriesGrouped.map(function (k) {
        return k[3].toFixed(2);
      }), sortedData.map(function (k) {
        return k[1];
      })]
    }
  };
}
function getChartDataDrilled(dataIn, pos) {
  if (dataIn.length === 0) return {
    labels: null,
    series: []
  };
  var display = pos === 5 ? 0 : 5;
  var labelsGrouped = [];
  dataIn.forEach(function (inv) {
    var label = inv[display];
    var pos = labelsGrouped.findIndex(function (k) {
      return k[0] === label;
    });
    if (pos === -1) {
      labelsGrouped.push([label, 0, [0, 0, 0, 0], '', '']);
    }
    var labelPos = labelsGrouped.findIndex(function (k) {
      return k[0] === label;
    });
    labelsGrouped[labelPos][1] += inv[7] + inv[8] + inv[9] + inv[10];
    labelsGrouped[labelPos][2][0] += inv[7] || 0;
    labelsGrouped[labelPos][2][1] += inv[8] || 0;
    labelsGrouped[labelPos][2][2] += inv[9] || 0;
    labelsGrouped[labelPos][2][3] += inv[10] || 0;
    labelsGrouped[labelPos][3] = inv[1] + (inv[3] ? ' (' + inv[3] + ')' : '');
    labelsGrouped[labelPos][4] = display === 5 ? inv[0] : inv[5];
    labelsGrouped[labelPos][5] = 'Invoice Due Date: ' + inv[11];
  });
  var sortedData = labelsGrouped.slice(0);
  sortedData.sort(function (a, b) {
    return a[1] - b[1];
  });
  var totals = sortedData.map(function (k) {
    return k[1];
  });
  var maxValue = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayMaxValue(totals);
  var minValue = __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.getArrayMinValue(totals);
  var seriesGrouped = sortedData.map(function (k) {
    return k[2];
  });
  totals = sortedData.map(function (k) {
    return __WEBPACK_IMPORTED_MODULE_2__core_charts_helper_formatter___default.a.thousandsFormatter(k[1]);
  });
  return {
    total: 0,
    labels: sortedData.map(function (k) {
      return k[0];
    }),
    series: [{
      type: 'Bar',
      stackBars: true,
      maxValue: maxValue,
      minValue: minValue,
      ignoreForCharts: false,
      barSpace: 36,
      minHeight: 90,
      data: [{
        name: 'Balance',
        value: seriesGrouped.map(function (k) {
          return k[0].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].blueLight,
        width: '25px',
        ignoreLabel: true
      }, {
        name: 'Scheduled Payments - Funds Not Received',
        value: seriesGrouped.map(function (k) {
          return k[2].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].green,
        width: '25px',
        ignoreLabel: true
      }, {
        name: 'Scheduled Payments - Funds Received',
        value: seriesGrouped.map(function (k) {
          return k[1].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].purple,
        width: '25px',
        ignoreLabel: true
      }, {
        name: 'Received Payments',
        value: seriesGrouped.map(function (k) {
          return k[3].toFixed(2);
        }),
        color: __WEBPACK_IMPORTED_MODULE_3__core_charts_helper_chartColors__["a" /* default */].yellowish,
        width: '25px',
        ignoreLabel: false,
        metadata: {
          barLabels: totals
        }
      }]
    }],
    tooltipData: {
      metadata: tooltipMedatadaDrilled,
      data: [sortedData.map(function (t) {
        return t[0];
      }), sortedData.map(function (t) {
        return t[3];
      }), sortedData.map(function (t) {
        return t[4];
      }), sortedData.map(function (t) {
        return t[5];
      }), seriesGrouped.map(function (k) {
        return k[0].toFixed(2);
      }), seriesGrouped.map(function (k) {
        return k[2].toFixed(2);
      }), seriesGrouped.map(function (k) {
        return k[1].toFixed(2);
      }), seriesGrouped.map(function (k) {
        return k[3].toFixed(2);
      }), sortedData.map(function (k) {
        return k[1];
      })]
    }
  };
}
function executeDrillDown(ctx, value) {
  var selected = value;
  var data = [];
  ctx.rawData.forEach(function (el) {
    el[5] = el[5] + (el[6] ? ' (' + el[6] + ')' : '');
    el[6] = null;
    data.push(el);
  });
  var filterIndex = getVariableIndex(ctx.widget);
  var fullData = data.filter(function (row) {
    return ~row.indexOf(selected);
  });
  ctx.chartData = getChartDataDrilled(fullData, filterIndex);
  ctx.chartInfo = getChartInfo(fullData, 1);
  ctx.chartComponent.chartOpts.stackBars = true;
  ctx.chartComponent.chartOpts.customSettings.hasDrillDown = false;
  ctx.chartComponent.chartOpts.customSettings.tooltip = {
    width: '330px',
    topOffset: -10,
    leftOffset: 50
  };
  ctx.$emit('childRedraw');
}
function reverseDrillDown(ctx) {
  ctx.chartComponent.chartOpts = getOptions();
  ctx.$emit('childRedraw');
}
function getVariableValue(widget) {
  var variable = widget.variables.filter(function (s) {
    if (s.name === 'PaymentStatusMainFilter') return s.value[0];else return null;
  });
  return variable[0].value[0];
}
function getVariableIndex(widget) {
  var variableVal = getVariableValue(widget);
  if (variableVal === 'Programs') return 1;else if (variableVal === 'Supplier') return 5;
  return 4; // for divisions
}
var tooltipMetadata = [{
  label: '',
  type: 'title',
  format: ''
}, {
  label: 'Balance',
  type: 'main',
  format: 'currency'
}, {
  label: 'Scheduled Payments - Funds Not Received',
  type: 'main',
  format: 'currency'
}, {
  label: 'Scheduled Payments - Funds Received',
  type: 'main',
  format: 'currency'
}, {
  label: 'Received Payments',
  type: 'main',
  format: 'currency'
}, {
  label: 'Total',
  type: 'secondary',
  format: 'currency'
}];
var tooltipMedatadaDrilled = [{
  label: '',
  type: 'title',
  format: ''
}, {
  label: 'Program',
  type: 'subtitle',
  format: ''
}, {
  label: '',
  type: 'subtitle',
  format: ''
}, {
  label: '',
  type: 'subtitle',
  format: ''
}, {
  label: 'Balance',
  type: 'main',
  format: 'currency'
}, {
  label: 'Scheduled Payments - Funds Not Received',
  type: 'main',
  format: 'currency'
}, {
  label: 'Scheduled Payments - Funds Received',
  type: 'main',
  format: 'currency'
}, {
  label: 'Received Payments',
  type: 'main',
  format: 'currency'
}, {
  label: 'Total',
  type: 'secondary',
  format: 'currency'
}];

/***/ }),

/***/ "o+j9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o/EM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oCQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-drag"},[_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.closeMenu),expression:"closeMenu"}],class:{ "open": _vm.isMenuOpen, "dropdown": true }},[_c('i',{staticClass:"far fa-ellipsis-v dropdown-toggle dots-icon",staticStyle:{"font-size":"20px"},attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":function($event){_vm.isMenuOpen = !_vm.isMenuOpen}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMenuOpen),expression:"isMenuOpen"}],staticClass:"dropdown-menu dropdown-menu-right",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_vm._l((_vm.buttons),function(button,i){return _c('li',{key:i},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":button.ref},nativeOn:{"click":function($event){return _vm.buttonAction(button)}}},[_vm._v(_vm._s(button.label))])],1)}),_vm._v(" "),_c('li',[(_vm.hasOptions)?_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":_vm.showSettingsDialog}},[_vm._v("Widget Settings")]):_vm._e()]),_vm._v(" "),_c('li',[(!_vm.minimized)?_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":_vm.toggleCollapse}},[_vm._v("Minimize")]):_vm._e()]),_vm._v(" "),_c('li',[(_vm.minimized)?_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":_vm.toggleCollapse}},[_vm._v("Restore")]):_vm._e()])],2)]),_vm._v(" "),(_vm.showSettings)?_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.hideSettingsDialog),expression:"hideSettingsDialog"}],staticClass:"dropdown open"},[_c('ul',{staticClass:"dropdown-menu dropdown-menu-right width2x"},[_c('li',[_c('widget-options',{attrs:{"options":_vm.options,"value":_vm.widget},on:{"set":_vm.set}})],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oDR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestPhysicalBatch_vue__ = __webpack_require__("K40X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203790b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestPhysicalBatch_vue__ = __webpack_require__("Kn9K");
function injectStyle (ssrContext) {
  __webpack_require__("Tnpt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-203790b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestPhysicalBatch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203790b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestPhysicalBatch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oFCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__("Usg1");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpaycarddetails',
  data: function data() {
    return {
      cardId: this.$route.query.cardid,
      cards: null
    };
  },
  created: function created() {
    var _this = this;
    var CardId = this.$route.query.cardid;
    this.api.forms.post(this.api.$.evedpaycard.cards, {
      sort: 'CardNumber',
      dir: 'DESC',
      start: 0,
      limit: 100,
      isLiveGrid: true,
      filter: {
        CardStatus: 'active',
        searchTerm: ''
      }
    }).then(function (r) {
      var matchedCard = r.data.Data.find(function (card) {
        return card.Id === CardId;
      });
      if (matchedCard) {
        _this.cards = {
          name: matchedCard.Name || "EvedPay Card ...".concat(matchedCard.CardNumber),
          holder: matchedCard.Holder,
          holderUserId: matchedCard.HolderUserId,
          id: matchedCard.Id,
          cardNumber: matchedCard.CardNumber,
          divisionId: matchedCard.DivisionId,
          isPhysicalCard: matchedCard.IsPhysicalCard,
          cardStatus: matchedCard.CardStatus,
          accountBalance: matchedCard.AccountBalance,
          pending: matchedCard.Pending
        };
      }
    });
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$off('pin-changed');
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$on('pin-changed', function () {
      _this.$notifications.notify({
        message: "Pin has been changed successfully!",
        type: 'info',
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    });
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$off('fundsAdded');
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["b" /* EventBus */].$on('fundsAdded', function () {
      _this.$notifications.notify({
        message: "Request sent successfully!",
        type: 'info',
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    });
  },
  computed: {
    isCardHolder: function isCardHolder() {
      return this.cards && this.$user.$.user.UserID === this.cards.holderUserId;
    },
    isUserAdmin: function isUserAdmin() {
      if (this.$user.$.userPermissions.includes('EvedPayCardAdministrator')) {
        return true;
      }
      return false;
    }
  },
  methods: {
    redirectToRequestCard: function redirectToRequestCard(card) {
      this.$router.push({
        path: "/evedpay/requestcard?cardid=".concat(card.id),
        query: _objectSpread({
          divisionId: card.divisionId
        }, this.$route.query)
      });
    },
    redirectToChangePin: function redirectToChangePin(card) {
      this.$router.push({
        path: "/evedpay/changepin?cardid=".concat(card.id),
        query: _objectSpread({}, this.$route.query)
      });
    },
    redirectToShowNumber: function redirectToShowNumber(card) {
      this.$router.push({
        path: "/evedpay/shownumber?cardid=".concat(card.id),
        query: _objectSpread({}, this.$route.query)
      });
    },
    redirectToAddFunds: function redirectToAddFunds(card) {
      this.$router.push({
        path: "/evedpay/loadfunds?cardid=".concat(card.id),
        query: _objectSpread({
          accBalance: card.accountBalance
        }, this.$route.query)
      });
    }
  }
});

/***/ }),

/***/ "oML2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oNa7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

var interactionHandler = null;
var defaultClass = 'dawn-input-tooltip';
var errorClass = 'error-message';
var NAVBAR_HEIGHT = 160;
var DEFAULT_TITLE = 'What is this?';
var DEFAULT_MESSAGE = 'Please fill in this field';
var ERROR_MESSAGE = 'Invalid Entry';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-input-tooltip',
  props: {
    helptipHeader: {
      type: String,
      default: DEFAULT_TITLE
    },
    helptipBody: {
      type: String,
      default: DEFAULT_MESSAGE
    },
    errorTip: {
      type: Boolean,
      default: false
    },
    altTip: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    helptipHeaderMsg: function helptipHeaderMsg() {
      return this.errorTip && this.helptipHeader === DEFAULT_TITLE ? ERROR_MESSAGE : this.helptipHeader;
    },
    tooltipClass: function tooltipClass() {
      return "".concat(defaultClass, " ").concat(this.$slots.default ? 'info' : this.altTip ? 'alt-message' : '');
    }
  },
  data: function data() {
    return {
      position: {}
    };
  },
  created: function created() {
    var _this = this;
    this.setContext();
    if (!interactionHandler) {
      setTimeout(function () {
        return document.addEventListener('click', _this.interactionHandler);
      }, 0);
      interactionHandler = true;
    }
    this.$parent.$on('hook:destroyed', function () {
      document.removeEventListener('click', _this.interactionHandler);
      interactionHandler = null;
    });
    this.unwatchError = this.$parent.$watch('error', this.errorHandler);
    this.unwatchFocused = this.$parent.$watch('focused', this.visibilityHandler);
    this.unwatchIsOpen = this.$parent.$watch('isOpen', this.visibilityHandler);
    this.unwatchShowPopup = this.$parent.$watch('showPopup', this.visibilityHandler);
  },
  mounted: function mounted() {
    this.scrollToError();

    //
    if (typeof this.$attrs['v-align'] !== 'undefined') {
      this.position = {
        top: "".concat(-this.$el.clientHeight / 2 + 45, "px")
      };
    }
  },
  destroyed: function destroyed() {
    var _this2 = this;
    // document.removeEventListener('click', this.interactionHandler)
    setTimeout(function () {
      _this2.unwatchError();
      _this2.unwatchFocused();
      _this2.unwatchIsOpen();
      _this2.unwatchShowPopup();
    }, 500);
  },
  methods: {
    setContext: function setContext() {
      this.context = document.querySelector('.dawn-modal-container') || document;
      this.viewport = document.querySelector('.dawn-modal-container') ? document.querySelector('.dawn-modal-mask') : document.querySelector('.main-panel');
    },
    interactionHandler: function interactionHandler(e) {
      if (e.target.type === 'button') {
        this.scrollToError();
      }
    },
    errorHandler: function errorHandler(oldV, newV) {
      var _this3 = this;
      if (newV) {
        setTimeout(function () {
          return document.addEventListener('click', _this3.interactionHandler);
        }, 0);
        this.scrollToError();
      }
    },
    scrollToError: function scrollToError(error) {
      var _this4 = this;
      if (this.errorTip || this.shouldScrollToNextError) {
        this.$nextTick(function () {
          _this4.scrollFirstIntoView();
          _this4.hideOtherErrors();
        });
      } else {
        if (!error) {
          this.$nextTick(function () {
            setTimeout(function () {
              _this4.shouldScrollToNextError = true;
              _this4.unwatchError();
            }, 100);
          });
        } else {
          this.shouldScrollToNextError = false;
        }
      }
    },
    visibilityHandler: function visibilityHandler(v) {
      v ? this.$el.classList.remove('invisible') : this.$el.classList.add('invisible');
    },
    scrollFirstIntoView: function scrollFirstIntoView() {
      var firstError = this.context.querySelectorAll(".".concat(defaultClass, ".").concat(errorClass))[0];
      if (firstError) {
        firstError.scrollIntoView();
        firstError.classList.remove('invisible');
        this.viewport.scrollTop += firstError.getBoundingClientRect().top - NAVBAR_HEIGHT;

        //
        if (window !== window.parent) {
          setTimeout(function () {
            window.parent.scrollTo(0, 0);
          }, 0);
        }
      }
    },
    hideOtherErrors: function hideOtherErrors() {
      this.context.querySelectorAll(".".concat(defaultClass, ".").concat(errorClass)).forEach(function (error, i) {
        if (i === 0) {
          //
        } else {
          error.getAttribute('upload-message') || error.classList.add('invisible');
        }
      });
    }
  }
});

/***/ }),

/***/ "oXkD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications"},[_c('transition-group',{attrs:{"name":"list"}},_vm._l((_vm.notifications),function(n,index){return _c('md-notification',{key:n,attrs:{"heading":n.heading,"message":n.message,"icon":n.icon,"type":n.type,"width":n.width,"position":n.position,"placement":n.placement,"timeout":n.timeout,"allowDismiss":n.allowDismiss,"dismiss":n.dismiss,"discard":n.discard,"goto":n.goto,"hide":n.component ? true : n.hide},on:{"onClose":function($event){return _vm.onClose($event, n, index)}}},[(n.component)?_c('div',{attrs:{"slot":"message"},slot:"message"},[_c(n.component,{tag:"component"})],1):_vm._e()])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oYUa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");

__WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].GENERIC.EXPORT, function (e) {
  //
  console.log('Exporting', e.data);
});

/***/ }),

/***/ "oZvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('chart-tooltip'),_vm._v(" "),_c('program-spend',{ref:"programSpend",staticClass:"program-spend-widget",class:{ 'card--notice': _vm.displayNotice },attrs:{"widget":_vm.widget,"id":"program-spend-widget"}}),_vm._v(" "),(_vm.displayNotice)?_c('ed-notice',{staticClass:"program-spend-widget__notice",attrs:{"type":_vm.noticeType,"icon":"fas fa-exclamation-triangle"}},[_vm._v("\n    "+_vm._s(_vm.noticeMsg)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "obo4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{attrs:{"title":_vm.$t('Products'),"subtitle":_vm.$t('Manage Products'),"tabs":_vm.tabs}}),_vm._v(" "),_c('legacy-container',{attrs:{"url":_vm.url}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oePj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("30EY");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4c230ce_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("yvmx");
function injectStyle (ssrContext) {
  __webpack_require__("U0nG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b4c230ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4c230ce_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ohQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suppliers_vue__ = __webpack_require__("BwHz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09603488_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suppliers_vue__ = __webpack_require__("tF4L");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suppliers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09603488_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suppliers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ojCN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseChartWidget__ = __webpack_require__("wrv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__("87ps");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__baseChartWidget__["a" /* default */])('program-spend-wdg-cmp', __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]));

/***/ }),

/***/ "ojQe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("+qbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Themes_docs_theme_scss__ = __webpack_require__("1wCz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Themes_docs_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Themes_docs_theme_scss__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__main__["default"],
  computed: {
    className: function className() {
      return 'layout-docs';
    }
  }
});

/***/ }),

/***/ "okXg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__("yYTH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_scrollbarHelper_js__ = __webpack_require__("7yCl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'recent-updates-wdg-cmp',
  props: {
    widget: Object
  },
  data: function data() {
    return {
      cards: [],
      loading: false
    };
  },
  computed: {
    groups: function groups() {
      var result = [];
      var now = new Date();
      var today1 = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var today2 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
      var yesterday1 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
      var yesterday2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59, 999);
      var twoDaysAgo1 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2);
      var twoDaysAgo2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2, 23, 59, 59, 999);
      var threeDaysAgo1 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 3);
      var threeDaysAgo2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 3, 23, 59, 59, 999);
      var earlier1 = new Date(1, 1, 1);
      var earlier2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 4, 23, 59, 59, 999);
      this.pushIfPresent(result, this.getInRange('Today', today1, today2));
      this.pushIfPresent(result, this.getInRange('Yesterday', yesterday1, yesterday2));
      this.pushIfPresent(result, this.getInRange('2 days ago', twoDaysAgo1, twoDaysAgo2));
      this.pushIfPresent(result, this.getInRange('3 days ago', threeDaysAgo1, threeDaysAgo2));
      this.pushIfPresent(result, this.getInRange('Older', earlier1, earlier2));
      return result;
    },
    hasData: function hasData() {
      if (this.cards !== null && this.cards.length > 0) return true;else return false;
    }
  },
  created: function created() {
    var _this = this;
    this.loading = true;
    this.api.get(this.widget.endPoint, {}).then(function (r) {
      _this.cards = r.data;
    }).finally(function () {
      _this.loading = false;
      if (_this.hasData) {
        _this.$nextTick(function () {
          __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit('updateWidgetHeightSimple', {
            wId: _this.widget.id,
            height: _this.$el.clientHeight + 6,
            explicitS: _this.cards.length === 1 ? 2 : null
          });
          if (_this.cards.length > 7) {
            _this.$el.querySelector('.scroller').style.height = '640px';
            Object(__WEBPACK_IMPORTED_MODULE_1__helpers_scrollbarHelper_js__["a" /* initScrollbar */])(_this, '.scroller');
          }
        });
      }
    });
  },
  methods: {
    pushIfPresent: function pushIfPresent(result, group) {
      if (group.cards.length > 0) {
        result.push(group);
      }
    },
    getInRange: function getInRange(header, startDate, endDate) {
      var result = [];
      for (var i = 0, n = this.cards.length; i < n; i++) {
        if (global.moment(this.cards[i].Date).isBetween(startDate, endDate)) {
          result.push(this.cards[i]);
        }
      }
      return {
        header: header,
        cards: result
      };
    }
  },
  components: {
    card: __WEBPACK_IMPORTED_MODULE_0__card__["default"]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "opm4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.validateCancelInvoice()}}},[_vm._v("Cancel\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showModal,"title":"","xsubtitle":"","primaryButton":"Yes","secondaryButton":"No"},on:{"close":function($event){_vm.showModal = false},"confirm":function($event){return _vm.cancelInvoice()}}},[_c('span',{attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"col-md-8 lh15"},[_vm._v("\n        Are you sure you want to cancel invoice "+_vm._s(_vm.name)+"?\n      ")]),_vm._v(" "),_c('div',{staticClass:"clear"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "opr4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("nePQ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd5b8a7a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("rNIe");
function injectStyle (ssrContext) {
  __webpack_require__("y/ak")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd5b8a7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd5b8a7a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ovkd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_Dashboard_widgets_SharedComponents_WidgetSettingsMenu__ = __webpack_require__("XEt1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-widget',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  components: {
    WidgetSettingsMenu: __WEBPACK_IMPORTED_MODULE_2__components_modules_Dashboard_widgets_SharedComponents_WidgetSettingsMenu__["default"]
  },
  props: {
    value: null,
    title: String,
    toolbar: {
      type: Boolean,
      default: true
    },
    details: {
      type: Object,
      default: function _default() {
        return {
          label: '',
          action: ''
        };
      }
    },
    settings: {
      type: Object,
      default: function _default() {
        return {
          title: this.title,
          details: this.details
        };
      }
    },
    position: Object,
    draggable: {
      type: String,
      default: 'false'
    }
  },
  computed: {
    settingsFlyoutOffset: function settingsFlyoutOffset() {
      return {
        right: this.position ? 1 * (this.position.w * 10 - 100 + this.position.x * 10) + '%' : 0
      };
    },
    innerHeight: function innerHeight() {
      return this.$root.innerHeight;
    },
    currency: function currency() {
      return this.value.variables[1].value[0];
    },
    hasOptions: function hasOptions() {
      var varCnt = this.value.variables.length;
      if (varCnt !== 1) return true;
      return false;
    },
    isCollapsed: function isCollapsed() {
      return this.value.isCollapsed;
    },
    reqDraw: function reqDraw() {
      if (this.value.reqDraw && !this.value.isCollapsed || this.value.isDrawn) return true;else if (!this.value.isDrawn && !this.value.isCollapsed) return true;else return false;
    },
    hasFooter: function hasFooter() {
      var hasActions = this.value.actions.length > 0;
      if (!hasActions) {
        for (var n = this.value.variableDefinitions.length, i = 0; i < n; i++) {
          if (this.value.variableDefinitions[i].placement === 'footer') {
            hasActions = true;
            break;
          }
        }
      }
      return hasActions;
    }
  },
  data: function data() {
    return {
      onScrollIntoView: function onScrollIntoView() {
        var _this = this;
        this.$nextTick(function () {
          setTimeout(function () {
            if (!_this.loaded && _this.childComp && _this.$el && _this.$el.getBoundingClientRect().top < _this.innerHeight - 50) {
              _this.loaded = true;
              _this.childComp.$emit('scrollIntoView');
            }
          }, 500);
        });
        return this.position.offset;
      },
      bottomOptionsExpanded: true,
      isDisabled: false
    };
  },
  created: function created() {
    this.$on('clone', this.clone);
    this.$on('remove', this.remove);
    this.$on('resize', this.onResize);
    this.loaded = false;
    this.childComp = null;
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.childComp = _this2.$refs.widgetContent ? _this2.$refs.widgetContent.children[0].__vue__ : null;
    });
  },
  methods: {
    onResize: function onResize() {
      // this.api.put(`${this.api.$.dashboard.widget}/${this.value.id}`, {
      //  variables: [{
      //    name: 'Width',
      //    value: settings.methods.getWidthKey(this.value.w)
      //  }]
      // })
    },
    toggleCollapse: function toggleCollapse() {
      var _this3 = this;
      this.position.isCollapsed = !this.position.isCollapsed;
      var position = [{
        widgetId: this.value.id,
        dockInfo: {
          dockRow: this.position.y,
          dockOrder: this.position.x,
          isCollapsed: this.position.isCollapsed
        }
      }];
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('widgetCollapseStateChanged', {
          wId: _this3.value.id,
          pos: position
        });
        _this3.api.put("".concat(_this3.api.$.dashboard.widgets), position).catch(function (e) {
          self.value.isCollapsed = true;
          // global.alert('Something went wrong. Could not save the Dashboard.')
        });
        if (!_this3.position.isCollapsed && !_this3.value.isDrawn && _this3.value.reqDraw) {
          _this3.value.reqDraw = true;
          _this3.$nextTick(function () {
            _this3.$emit('saved');
          });
        }
      });
    },
    bringWidgetToFront: function bringWidgetToFront() {
      this.removeTopClass();
      this.$parent.$el.classList.add('alternateTop');
    },
    toggleDateFilter: function toggleDateFilter(widget) {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.datepick.$el.classList.toggle('picker-top');
      });
    },
    closeDateFilter: function closeDateFilter(widget) {
      var _this5 = this;
      this.$nextTick(function () {
        _this5.$refs.datepick.$el.classList.remove('picker-top');
      });
    },
    updateDateFilter: function updateDateFilter(widget, date) {
      if (date.start) {
        widget.dateRangeFilter.startDate = global.moment(date.start).format('YYYY-MM-DD');
        widget.dateRangeFilter.endDate = global.moment(date.end).format('YYYY-MM-DD');
        widget.dateRangeFilter.dateRange = date.preset || 'None';
        if (widget.dateRangeFilter.dateRange !== 'None' && widget.dateRangeFilter.dateRange !== 'none') {
          this.$refs.datepick.closePopup();
          this.applyDateRangeFilter(widget);
        }
      } else {
        widget.dateRangeFilter.startDate = date[0];
        widget.dateRangeFilter.endDate = date[1];
        widget.dateRangeFilter.dateRange = 'None';
      }
    },
    applyDateRangeFilter: function applyDateRangeFilter(widget) {
      var _this6 = this;
      this.api.post("".concat(this.api.$.dashboard.widget, "/").concat(widget.id), widget.dateRangeFilter).then(function (r) {
        _this6.$emit('saved');
      });
    },
    removeTopClass: function removeTopClass() {
      var element = document.querySelector('.alternateTop');
      if (element) element.classList.remove('alternateTop');
    },
    hideSettings: function hideSettings() {
      __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit('widgetSettingsClose');
    },
    toggleBottomOptions: function toggleBottomOptions() {
      // this.bringWidgetToFront()
    },
    getOptionValue: function getOptionValue(i) {
      var _this7 = this;
      var option = this.value.variableDefinitions[i].items.filter(function (k) {
        return k.key === _this7.value.variables[i].value[0];
      });
      return option && option[0] && option[0].label;
    },
    update: function update(v, variable, i) {
      if (v) {
        this.value.label = v.value.label;
        if (v.moduleWidth && this.value.w !== v.moduleWidth.value) {
          this.value.w = v.moduleWidth.value;
          this.startW = this.value.w;
          this.$parent.$parent.layoutUpdate();
          this.$parent.$emit('resized', v.moduleWidth.value);
        }
        if (v.value.actions) {
          this.value.actions = utils.copy(v.value.actions);
        }
        // update variables
        this.value.variables = v.value.variables;
      }
    },
    set: function set(v, variable, i) {
      var _this8 = this;
      var self = this;
      var o = this.value.variables && utils.copy(this.value.variables);
      if (!v && variable) {
        //
        this.$nextTick(function () {
          _this8.value.variables[i].value = [variable.key];
        });
      }
      this.$nextTick(function () {
        var _v = v && utils.copy(v);
        var payload = {
          label: (_v || _this8).value.label,
          variables: (_v || _this8).value.variables
        };
        _this8.api.put("".concat(_this8.api.$.dashboard.widget, "/").concat(_this8.value.id), payload).then(function (r) {
          _this8.update(_v, variable, i);
          _this8.$emit('saved');
          if (_this8.$refs.widgetSettings) {
            _this8.$refs.widgetSettings.operations.savePending = false;
          }
          _this8.hideSettings();
        }).catch(function (e) {
          self.value.variables = o;
          // global.alert('Something went wrong. Could not save the Dashboard.')
        });
      });
    },
    clone: function clone() {
      var _this9 = this;
      var widgets = this.$parent.$parent.$parent.widgets;
      var layoutRows = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(widgets.map(function (w) {
        return w.y;
      })));
      var dockInfo = {
        dockOrder: 0,
        dockRow: layoutRows + 1
      };
      var payload = {
        label: "".concat(this.value.label, " [copy]"),
        variables: this.value.variables,
        // buttons: this.value.buttons,
        saveAsNew: true,
        dockInfo: dockInfo
      };
      this.api.put("".concat(this.api.$.dashboard.widget, "/").concat(this.value.id), payload).then(function (r) {
        _this9.$emit('cloned', {
          id: r.data.id
        });
        if (_this9.$refs.widgetSettings) {
          _this9.$refs.widgetSettings.operations.clonePending = false;
        }
        _this9.hideSettings();
      }).catch(function (e) {
        // global.alert('Something went wrong. Could not save the Dashboard.')
      });
    },
    remove: function remove() {
      var _this10 = this;
      this.api.delete("".concat(this.api.$.dashboard.widget, "/").concat(this.value.id)).then(function (r) {
        _this10.$emit('removed');
        if (_this10.$refs.widgetSettings) {
          _this10.$refs.widgetSettings.operations.deletePending = false;
        }
        _this10.hideSettings();
      }).catch(function (e) {
        // global.alert('Something went wrong. Could not save the Dashboard.')
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("RMJP")))

/***/ }),

/***/ "owlQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_legacy_auth__ = __webpack_require__("mnjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LegacyContainer_legacyRouter__ = __webpack_require__("IYIA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_api_env_json__ = __webpack_require__("hcMa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_api_env_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__core_api_env_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_I2P_dialogs_InviteSupplierDialog__ = __webpack_require__("hWew");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { routeOldLinks } from './routeOldLinks'







var eventHub = new __WEBPACK_IMPORTED_MODULE_7_vue__["default"]();
var allowedComponents = __WEBPACK_IMPORTED_MODULE_2__core_legacy_auth__["a" /* default */].allowedComponents,
  allowedModules = __WEBPACK_IMPORTED_MODULE_2__core_legacy_auth__["a" /* default */].allowedModules;

/** Allow for iframe interoperation */
if (document.domain) {
  var host = document.createElement('a');
  // host.href = global.location.protocol === 'https:' ? process.env.BASE || process.env.NET_GATEWAY : window.location.href
  host.href = "https://eved.com";
  try {
    document.domain = host.hostname;
  } catch (e) {}

  // resize iframe with content size
  global.addEventListener('message', function (event) {
    var d = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.parse(event.data);
    var frame = global.document.getElementById('MainPageFrame');
    if (frame) {
      frame.style.height = parseInt(d.if_height) + 0 + 'px';
      // frame.style.width = d.if_width + 'px'
    }
    if (d.showOverlay === 'true') {
      document.body.setAttribute('legacy-modal', true);
      document.querySelector('.dawn-title-nav.sticky') && document.querySelector('.dawn-title-nav.sticky').classList.remove('sticky');
    }
    if (d.showOverlay === 'false') {
      document.body.setAttribute('legacy-modal', false);
      // global.document.getElementById('MainPageFrame').className = 'fade in'
    }
    if (d.showAddSupplierDialog === 'true') {
      document.getElementById('opendialog_hidden').click();
    }

    // hook into navigating inside legacy component
    if (d.showWelcome) {
      // global.document.getElementById('MainPageFrame').className = 'fade out'
    }
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_3__components_LegacyContainer_legacyRouter__["a" /* default */].methods.polyfillParent.call(this);
  },
  created: function created() {
    // show loading indicator
    this.iframeLoading = 'loading-back';

    // if (featureFlags.legacyViewDisabled) routeOldLinks.call(this, this.$route, this.getModule())
  },
  updated: function updated() {
    // show loading indicator
    this.iframeLoading = 'loading-back';

    // force show loading indicator on navigating between different modules
    if (global.document.getElementById('iframe')) global.document.getElementById('iframe').className = 'content loading-back';

    // TODO:
    // fade out when loading another legacy module
    // if (global.document.getElementById('MainPageFrame')) global.document.getElementById('MainPageFrame').className = 'fade out'

    // TODO:
    // wider legacy pages
    // if (global.document.getElementById('MainPageFrame')) global.document.getElementById('MainPageFrame').style.width = '1240px'
  },
  props: {
    url: String,
    absUrl: String
  },
  computed: {
    legacyNav: function legacyNav() {
      var nav = {};
      var module = allowedModules()[this.$route.params.page];
      if (module) {
        nav.title = module.title;
        nav.subtitle = module.subtitle;
      }
      return nav;
    }
  },
  data: function data() {
    return {
      featureFlags: __WEBPACK_IMPORTED_MODULE_0__core_feature_flags_feature_flags__["a" /* default */],
      iframeLoading: 'loading-back',
      uri: global.location.protocol === 'https:' ? Object({"NODE_ENV":"production","PORTAL_ENV":false,"BASE":"https://eved.com","LEGACY_SUBDOMAIN":"evedonline.","PHP_GATEWAY":"https://local.eved.com/api/v2","NET_GATEWAY":"https://local.eved.com/evednetwork","PLATFORM_GATEWAY":"https://platform.eved.com/api","PHP_GATEWAY_FEATURE":"https://local.eved.com/api/v2","NET_GATEWAY_FEATURE":"https://local.eved.com/evednetwork","PUBLIC_PATH":"eved-dawn/dist","INTERCOM_APP":"a4gh1g5t","GA":"UA-6992574-5","PLATFORM_URL":"https://platform.eved.com","FEATURE_RECEIPT_SCAN_PREFILL":"true"}).NET_PROXY && Object({"NODE_ENV":"production","PORTAL_ENV":false,"BASE":"https://eved.com","LEGACY_SUBDOMAIN":"evedonline.","PHP_GATEWAY":"https://local.eved.com/api/v2","NET_GATEWAY":"https://local.eved.com/evednetwork","PLATFORM_GATEWAY":"https://platform.eved.com/api","PHP_GATEWAY_FEATURE":"https://local.eved.com/api/v2","NET_GATEWAY_FEATURE":"https://local.eved.com/evednetwork","PUBLIC_PATH":"eved-dawn/dist","INTERCOM_APP":"a4gh1g5t","GA":"UA-6992574-5","PLATFORM_URL":"https://platform.eved.com","FEATURE_RECEIPT_SCAN_PREFILL":"true"}).NET_PROXY.replace(/:[0-9]+\//, '/') + '/' || this.api.env + '/' : "https://local.eved.com/evednetwork".replace(__WEBPACK_IMPORTED_MODULE_5__core_api_env_json___default.a._default, "".concat(__WEBPACK_IMPORTED_MODULE_5__core_api_env_json___default.a._default).concat("evedonline.")).replace(/:[0-9]+\//, '/') + '/',
      module: this.$route.params.page,
      backTo: {
        name: '_allModules',
        params: {
          namespace: 'd',
          page: this.$route.params.page,
          section: this.$route.hash.substr(1)
        }
      },
      isEmbedded: global.self !== global.top
    };
  },
  methods: {
    updateHash: function updateHash() {
      // const vm = this
      // TODO:
      // get url when navigating inside legacy module
      //
      // var currentModule = window.frames['NetFrame'].location.href.replace(this.uri, '')

      // if (currentModule !== this.$route.params.page) {
      // window.location.hash = '/' + this.$route.params.namespace + '/' + currentModule
      // }

      // hook
      try {
        __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit('navigated', global.frames['NetFrame'].location.href);
      } catch (e) {}
      setTimeout(function () {
        if (global.frames['NetFrame']) {
          // flag legacy pages
          global.frames['NetFrame'].document.body.className.replace(' vue', '');
          global.frames['NetFrame'].document.body.className += ' vue';
          global.frames['NetFrame'].document.documentElement.className = ' vue';

          // TODO:
          // wider legacy pages
          // global.document.getElementById('MainPageFrame').style.width = '100%'
          // global.frames['NetFrame'].document.body.style.width = '100%'

          global.app.$loading = false;
        }
      }, 5);

      // Detect if any error is thrown by backend and go to 404
      // or issue another request to find out if the session expired
      try {
        global.document.getElementById('MainPageFrame').contentDocument.body.nodeName && null;
      } catch (e) {
        global.document.getElementById('iframe').className = 'broken';

        // find out if session expired
        // this.api.get(global.document.getElementById('MainPageFrame').src)

        setTimeout(function () {
          // this.$router.push('/404')
          global.app.$notifications.removeAll();
          if (global.app.$user.sessionSettings) {
            global.app.$notifications.notify({
              type: 'plain',
              icon: 'exclamation-circle',
              message: 'Something went wrong' + "<br><a class=\"btn btn-xs btn-actionbar\" target=\"_blank\" href=\"https://www.eved.com/contact-us/\">Report this</a>" + "<a class=\"btn btn-xs btn-actionbar\" href=\".\">Go to Dashboard</a>",
              timeout: 0,
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          } else {
            global.app.$notifications.notify({
              type: 'plain',
              icon: 'exclamation-circle',
              message: 'Invalid session',
              timeout: 2000,
              placement: {
                from: 'top',
                align: 'center'
              },
              onClose: function onClose() {
                global.app.$user.logout();
              }
            });
          }
        }, 1000);
      }
    },
    getModule: function getModule(force) {
      var _this = this;
      if (this.absUrl) return "".concat(this.absUrl);
      if (this.url) return "".concat(this.api.env, "/").concat(this.url);
      if (this.$route.params.namespace === 'd') return;
      if (!allowedModules.get[this.$route.params.page] && this.$route.params.page !== 'Admin') {
        this.$router.push('/404');
      }
      var components = allowedComponents[this.$route.params.page] ? allowedComponents[this.$route.params.page].pack : null;
      var uglyUrl = this.$route.params.section ? this.$route.params.section.replace(/--/g, '/') : '';

      //
      if (this.refreshBack) {
        // global.frames['NetFrame'].location.href = this.uri + '/' + (this.$route.params.section || 'Dashboard')
        // this.refreshKey = +new Date()
        this.refreshBack = null;
      }
      if (this.$route.params.action === '--') this.refreshBack = true;
      var url = components ? Object.keys(components).filter(function (k) {
        return components[k].name === _this.$route.params.section;
      })[0] ? Object.keys(components).filter(function (k) {
        return components[k].name === _this.$route.params.section;
      })[0] : uglyUrl : this.$route.params.section ? uglyUrl + (this.$route.params.action && this.$route.params.action !== '--' ? '/' + this.$route.params.action : '') : this.$route.params.page;

      // php pages
      url = url.replace('common.', '../?page=common.');
      url = url.replace('vendors.', '../?page=vendors.');
      var gotoUrl = this.$route.query.goto;
      var decodedUrl = decodeURIComponent(url);
      return "".concat(this.uri).concat(gotoUrl || decodedUrl);
    },
    openNewFormatDialog: function openNewFormatDialog() {
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_6__modules_I2P_dialogs_InviteSupplierDialog__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: null,
          invoiceId: this.getInvoiceId,
          eventHub: eventHub,
          operation: 'add'
        }
      });
      instance.$slots.default = [];
      instance.$mount();
      this.$refs.dialogContainer.appendChild(instance.$el);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "p0jD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_formatter__ = __webpack_require__("7VNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__helper_formatter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contents: Object,
    currency: String
  },
  computed: {
    hasSecondarySection: function hasSecondarySection() {
      if (this.getMultipleEntriesByType('secondary').length > 0) return true;else return false;
    },
    label: function label() {
      var title = this.getSingleEntryByType('title');
      return title;
    },
    getSubtitleEntries: function getSubtitleEntries() {
      return this.getMultipleEntriesByType('subtitle');
    },
    getMainEntries: function getMainEntries() {
      return this.getMultipleEntriesByType('main');
    },
    getSecondaryEntries: function getSecondaryEntries() {
      return this.getMultipleEntriesByType('secondary');
    },
    helpText: function helpText() {
      return this.contents.helpText;
    }
  },
  methods: {
    getSingleEntryByType: function getSingleEntryByType(type) {
      var index = this.contents.data.findIndex(function (e) {
        return e.type === type;
      });
      var result = index !== -1 ? this.contents.data[index].content : '';
      return result;
    },
    getMultipleEntriesByType: function getMultipleEntriesByType(type) {
      var _this = this;
      var filteredData = this.contents.data.filter(function (entry) {
        return entry.type === type;
      });
      var result = [];
      filteredData.forEach(function (element) {
        result.push({
          label: element.label,
          value: _this.formatValue(element.content, element.format)
        });
      });
      return result;
    },
    formatValue: function formatValue(value, type) {
      if (value === null || value === undefined) return 'N/A';
      if (type === 'currency') return __WEBPACK_IMPORTED_MODULE_0__helper_formatter___default.a.getMoneyFormatedValue(value, this.currency);
      if (type === 'percentage') return value + '%';
      return value;
    }
  }
});

/***/ }),

/***/ "p19q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rule_vue__ = __webpack_require__("cMpp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9705c1a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_rule_vue__ = __webpack_require__("ZPua");
function injectStyle (ssrContext) {
  __webpack_require__("8LDB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9705c1a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_rule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p4xt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotImplemented_vue__ = __webpack_require__("9fMx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0968c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotImplemented_vue__ = __webpack_require__("+0ya");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotImplemented_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0968c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotImplemented_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p5HV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_user__ = __webpack_require__("uduW");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    division: {},
    ids: null,
    disabled: false,
    tooltip: ''
  },
  data: function data() {
    return {
      divisions: [],
      divisionName: '',
      selectOption: {},
      selectedValue: {},
      closeObj: {},
      showTransferFunds: false,
      initialAmount: '',
      initialAmountError: false,
      errorMessage: 'The amount cannot be greater than the current balance'
    };
  },
  created: function created() {
    this.getDivisionNameToSingularWithLowerCase();
    this.selectOptionFrom = {};
    this.selectOptionTo = {};
  },
  methods: {
    getUserDivisions: function getUserDivisions() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.divisions = [];
              _context.prev = 1;
              _context.next = 4;
              return _this.api.post(_this.api.$.evedpaycard.accounts);
            case 4:
              response = _context.sent;
              if (response && response.data && response.data.Data) {
                _this.divisions = response.data.Data;
              }
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.warn(_context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    filterOptions: function filterOptions(option) {
      return this.selectOptionFrom.AccountId !== option.Id;
    },
    setSelectOptionTo: function setSelectOptionTo(option) {
      this.selectOptionTo.Division = option.Division;
      this.selectOptionTo.Available = option.Available;
      this.selectOptionTo.AccountId = option.Id;
    },
    getDivisionNameToSingularWithLowerCase: function getDivisionNameToSingularWithLowerCase() {
      var divisionName = __WEBPACK_IMPORTED_MODULE_2__core_user__["a" /* default */].get().settings['DivisionName'];
      this.divisionName = divisionName[divisionName.length - 1] === 's' ? divisionName.toLowerCase().slice(0, -1) : divisionName;
    },
    transferFunds: function transferFunds() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var command, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              command = {
                SourceAccountId: _this2.selectOptionFrom.AccountId,
                DestinationAccountId: _this2.selectOptionTo.AccountId,
                Amount: _this2.initialAmount
              };
              if (!(_this2.initialAmount <= 0 || _this2.initialAmount > _this2.selectOptionFrom.Available)) {
                _context2.next = 4;
                break;
              }
              _this2.initialAmountError = true;
              return _context2.abrupt("return");
            case 4:
              _context2.prev = 4;
              _context2.next = 7;
              return _this2.api.post('/evedpaycards/accounts/transfer-funds', command);
            case 7:
              response = _context2.sent;
              if (response.status === 200) {
                _this2.$emit('success');
                _this2.showTransferFunds = false;
                _this2.initialAmountError = false;
              }
              _context2.next = 13;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[4, 11]]);
      }))();
    },
    showModal: function showModal(showTransferFunds) {
      this.showTransferFunds = !showTransferFunds;
      if (!showTransferFunds) {
        this.resetModal();
      }
    },
    resetModal: function resetModal() {
      this.selectOptionFrom = {};
      this.selectOptionTo = {};
      this.initialAmount = '';
      this.initialAmountError = false;
    }
  }
});

/***/ }),

/***/ "p81o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('ed-select',{attrs:{"field-label":"Supplier","placeholder":_vm.supplierComboPlaceholder,"options":_vm.suppliers,"required":"","customLabel":_vm.getLabel,"server-search":"","openEndpoint":_vm.api.$.invoice.suppliers,"helptipHeader":"","track-by":"Key","disabled":_vm.disableSupplier(_vm.supplier) || _vm.isP2PInvoice,"error":_vm.model.Errors.SupplierMissing,"helptip-body":_vm.model.Errors.SupplierMissing && "Please select a Supplier." || "","name":"suppliers"},on:{"open":_vm.fetchSuppliersOnOpen,"search":_vm.fetchSuppliers,"close":_vm.restoreSuppliers,"select":function($event){return _vm.selectedSupplier($event)}},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('ed-select-options',{attrs:{"thumbnails":""}},[_c('div',{staticClass:"option-combo-img",attrs:{"slot":"row1"},slot:"row1"},[_c('img',{attrs:{"slot":"image","src":props.option.Value.Logo,"width":"48"},slot:"image"})]),_vm._v(" "),_c('div',{staticClass:"no-wrap",attrs:{"slot":"row2"},slot:"row2"},[_c('span',{staticClass:"option-strong"},[_c('strong',[_vm._v(_vm._s(_vm.he.decode(props.option.Value.CompanyName))+" ")])]),_vm._v(" "),_c('em',{staticClass:"option-em"},[_vm._v("("+_vm._s(props.option.Value.Vci)+")")]),_vm._v(" "),_c('br'),_vm._v(" "),(props.option.Value.SupplierName)?_c('span',{staticClass:"option-bold"},[_vm._v(" "+_vm._s(_vm.he.decode(props.option.Value.SupplierName)))]):_vm._e(),_vm._v(" "),(props.option.Value.SupplierRequestedName)?_c('span',[_c('br'),_vm._v(" "),_c('i',[_vm._v(_vm._s(props.option.Value.SupplierRequestedName))])]):_vm._e(),_vm._v(" "),(props.option.Value.CountryName)?_c('span',{staticClass:"address-wrap"},[_c('br'),_vm._v(" "),_c('span',{staticClass:"fas fa-map-marker-alt contact-icon"}),_vm._v("  "+_vm._s(props.option.Value.City + (props.option.Value.State != '' && props.option.Value.State != null ? ' ' + props.option.Value.State : (props.option.Value.Region != '' && props.option.Value.Region != null ? ' ' + props.option.Value.Region : '')) + ' ' + props.option.Value.CountryName)+"\n                "),(_vm.isEoadmin)?_c('span',[_vm._v(" "+_vm._s(props.option.Value.SupplierZIP)+" ")]):_vm._e()]):_vm._e(),_vm._v(" "),(props.option.Value.BusinessType)?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"fas fa-briefcase contact-icon"}),_vm._v("  "+_vm._s(props.option.Value.BusinessType)+"\n            ")]):_vm._e(),_vm._v(" "),(props.option.Value.SupplierEmail)?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"fas fa-envelope contact-icon"}),_vm._v("  "+_vm._s(props.option.Value.SupplierEmail)+"\n            ")]):_vm._e(),_vm._v(" "),(props.option.Value.VatGstId && _vm.isEoadmin)?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"fas fa-file-alt contact-icon"}),_vm._v("  "+_vm._s(props.option.Value.VatGstId)+"\n              "),_c('br')]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(props.option.Value.IsEvedPay)?_c('span',{staticClass:"label supplier-evedpay"},[_vm._v("EvedPay Ready")]):_vm._e(),_vm._v(" "),(props.option.Value.VendorType)?_c('span',{staticClass:"label",class:[("supplier-type-" + (props.option.Value.VendorType))]},[_vm._v(_vm._s(props.option.Value.VendorType)+" Supplier")]):_vm._e(),_vm._v(" "),(props.option.Value.Currencies)?_c('span',[_c('br'),_vm._v("\n              Currencies accepted: "+_vm._s(props.option.Value.Currencies)+"\n            ")]):_vm._e()])])]}}]),model:{value:(_vm.supplier),callback:function ($$v) {_vm.supplier=$$v},expression:"supplier"}}),_vm._v(" "),(_vm.supplier)?_c('div',[_c('br'),_vm._v(" "),_c('ed-card',{staticClass:"supplier-details",attrs:{"removable":!_vm.isP2PInvoice,"name":"supplier_card"},on:{"removecard":_vm.removeSupplier}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"supplier-img"},[_c('img',{attrs:{"slot":"image","src":_vm.supplier.Value.Logo,"width":"95"},slot:"image"})]),_vm._v(" "),_c('div',{staticClass:"no-wrap supplier-txt"},[(_vm.supplier)?_c('span',[_c('strong',{staticClass:"supplier-strong"},[_vm._v(_vm._s(_vm.supplier.Value.CompanyName)+" ")]),_vm._v(" "),_c('em',{staticClass:"supplier-em"},[_vm._v(_vm._s(_vm.supplier.Value.Vci ? '(' + _vm.supplier.Value.Vci + ')' : ''))]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('b',[(_vm.supplier && _vm.supplier.Value.SupplierName)?_c('span',{staticClass:"supplier-strong"},[_vm._v(" "+_vm._s(_vm.supplier.Value.SupplierName)+"\n                "),_c('br')]):_vm._e()]),_vm._v(" "),(_vm.supplier && _vm.supplier.Value.CountryName)?_c('span',{staticClass:"address-wrap"},[_c('span',{staticClass:"fas fa-map-marker-alt contact-icon"}),_vm._v("  "+_vm._s(_vm.supplier.Value.City + (_vm.supplier.Value.State != '' && _vm.supplier.Value.State != null ? ' ' + _vm.supplier.Value.State : (_vm.supplier.Value.Region != '' && _vm.supplier.Value.Region != null ? ' ' + _vm.supplier.Value.Region : '')) + ' ' + _vm.supplier.Value.CountryName)+"\n              "),(_vm.isEoadmin)?_c('span',[_vm._v(" "+_vm._s(_vm.supplier.Value.SupplierZIP)+" ")]):_vm._e(),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.supplier && _vm.supplier.Value.BusinessType)?_c('span',[_c('span',{staticClass:"fas fa-briefcase contact-icon"}),_vm._v("  "+_vm._s(_vm.supplier.Value.BusinessType)+"\n              "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.supplier && _vm.supplier.Value.SupplierEmail)?_c('span',[_c('span',{staticClass:"fas fa-envelope contact-icon"}),_vm._v("  "+_vm._s(_vm.supplier.Value.SupplierEmail)+"\n              "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.supplier && _vm.bankAccount && _vm.isEoadmin)?_c('span',[_c('span',{staticClass:"fas fa-university contact-icon"}),_vm._v("  "+_vm._s(_vm.bankAccount)+"\n              "),_c('span',{staticClass:"bank-account"},[_vm._v(" "+_vm._s(_vm.currencyCode)+" ")]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.supplier && _vm.supplier.Value.VatGstId && _vm.isEoadmin)?_c('span',[_c('span',{staticClass:"fas fa-file-alt contact-icon"}),_vm._v("  "+_vm._s(_vm.supplier.Value.VatGstId)+"\n              "),_c('br')]):_vm._e(),_vm._v(" "),_c('div',[(_vm.displayEvedPayStatus)?_c('span',{staticClass:"label",class:[("supplier-" + (_vm.label(_vm.evedPayStatus)))]},[_vm._v(_vm._s(_vm.evedPayStatus))]):_vm._e(),_vm._v(" "),(_vm.supplier && _vm.supplier.Value.VendorType)?_c('span',{staticClass:"label",class:[("supplier-type-" + (_vm.supplier.Value.VendorType))]},[_vm._v(_vm._s(_vm.supplier.Value.VendorType)+" Supplier")]):_vm._e()]),_vm._v(" "),(_vm.supplier && _vm.supplier.Value.Currencies)?_c('span',[_vm._v("\n              Currencies accepted: "+_vm._s(_vm.supplier.Value.Currencies)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"})])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),(_vm.supplierDifferentCurrency)?_c('ed-notice',{staticClass:"v-align-center",attrs:{"type":"warn","icon":"fas fa-exclamation-triangle"}},[_vm._v("\n\t  This supplier is not set up to accept payments in this currency.\n\t")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pB8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ct-tooltip shadowBox"},[_c('span',[_c('p',{staticClass:"tooltip-title"},[_vm._v(_vm._s(_vm.label))]),_vm._l((_vm.getSubtitleEntries && _vm.getSubtitleEntries),function(entry,i){return _c('p',[_c('span'),_c('a',{staticClass:"key black"},[_vm._v(_vm._s(entry.value))])])}),_c('hr'),_vm._l((_vm.getMainEntries && _vm.getMainEntries),function(entry,i){return _c('p',[_c('span'),_c('a',{staticClass:"key black"},[_vm._v(_vm._s(entry.label))]),_c('a',{staticClass:"value black"},[_vm._v(_vm._s(entry.value))])])}),(_vm.hasSecondarySection)?_c('hr'):_vm._e(),_vm._l((_vm.getMainEntries && _vm.getSecondaryEntries),function(entry,i){return _c('p',[_c('span'),_c('a',{staticClass:"key black"},[_vm._v(_vm._s(entry.label))]),_c('a',{staticClass:"value black"},[_vm._v(_vm._s(entry.value))])])}),(_vm.helpText)?_c('p',{staticClass:"helpText"},[_vm._v(_vm._s(_vm.helpText))]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pCVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"addFeeTaxesDialogContainer"},[_c('ed-modal',{attrs:{"show":_vm.show,"title":_vm.title,"primary-button":"Save","secondary-button":"Cancel","type":"medium","validation":_vm.validation,"closeOnEsc":true,"submitEndpoint":_vm.computePoTotalEndpoint,"name":"add_line_item"},on:{"close":_vm.onClose,"validate":_vm.onSave}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"col-md-10 no-pad"},[_c('h5',{staticClass:"section-title"},[_vm._v("Item Details")]),_vm._v(" "),_c('ed-input',{ref:"productNameField",attrs:{"field-label":"Product Name","required":"required","disabled":_vm.model.canEditOnlyPrice,"error":_vm.doDisplayNameError,"helptip-header":"","helptip-body":_vm.doDisplayNameError && 'Please fill in a name' || '',"name":"product_name"},on:{"change":_vm.itemNameChanged},model:{value:(_vm.formData.draftItem.name),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "name", $$v)},expression:"formData.draftItem.name"}}),_vm._v(" "),_c('ed-textarea',{attrs:{"disabled":_vm.model.canEditOnlyPrice,"field-label":"Description","name":"description"},model:{value:(_vm.formData.draftItem.description),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "description", $$v)},expression:"formData.draftItem.description"}}),_vm._v(" "),_c('ed-textarea',{attrs:{"disabled":_vm.model.canEditOnlyPrice,"field-label":"Internal Note (not visible to supplier)","name":"internalNote"},model:{value:(_vm.formData.draftItem.internalNote),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "internalNote", $$v)},expression:"formData.draftItem.internalNote"}}),_vm._v(" "),(_vm.categories)?_c('ed-select',{attrs:{"field-label":"Category","placeholder":"Select a Category","options":_vm.categories,"required":"required","disabled":_vm.model.canEditOnlyPrice,"label":"text","track-by":"key","error":_vm.doDisplayCategoryError,"helptip-header":"","helptip-body":_vm.doDisplayCategoryError && 'Please select a category' || '',"name":"category"},on:{"select":_vm.categoryChanged},model:{value:(_vm.formData.draftItem.selectedCategory),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "selectedCategory", $$v)},expression:"formData.draftItem.selectedCategory"}}):_vm._e(),_vm._v(" "),_c('ed-input',{attrs:{"field-label":"Category Ref ID","disabled":_vm.disableCategoryRefInput,"required":_vm.isRequiredCategRefID,"maxlength":"50","error":_vm.isRequiredCategRefID && _vm.doDisplayCategRefIdErrorComputed,"helptip-header":"","helptip-body":_vm.isRequiredCategRefID && _vm.doDisplayCategRefIdErrorComputed && 'Please fill in a Category Ref ID' || '',"name":"category_ref_id"},on:{"change":_vm.categoryRefIdChanged},model:{value:(_vm.formData.draftItem.referenceId),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "referenceId", $$v)},expression:"formData.draftItem.referenceId"}}),_vm._v(" "),(_vm.showOneBusinessUnit)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-md-4 no-pad"},[_vm._v("Business Unit")]),_vm._v(" "),_c('span',{staticClass:"col-md-8 small",attrs:{"name":"one_bu_name"}},[_vm._v(_vm._s(_vm.businessUnit.name))])]):_vm._e(),_vm._v(" "),(_vm.showBusinessUnits)?_c('div',{staticClass:"row"},[_c('ed-select',{attrs:{"field-label":"Business Unit","placeholder":"Select business unit","options":_vm.businessUnits,"required":"required","disabled":_vm.model.canEditOnlyPrice,"label":"name","track-by":"key","error":_vm.doDisplayBusinessUnitError,"helptip-header":"","helptip-body":_vm.doDisplayBusinessUnitError && 'Please select a Business Unit' || '',"name":"business_units"},on:{"select":function($event){return _vm.businessUnitSelected($event)}},model:{value:(_vm.formData.draftItem.businessUnit),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "businessUnit", $$v)},expression:"formData.draftItem.businessUnit"}})],1):_vm._e(),_vm._v(" "),(_vm.showOneCostCenter)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-md-4 no-pad"},[_vm._v("Cost Center")]),_vm._v(" "),_c('span',{staticClass:"col-md-8 small",attrs:{"name":"one_cc_name"}},[_vm._v(" "+_vm._s(this.getCostCenterName(_vm.costCenter))+" ")])]):_vm._e(),_vm._v(" "),(_vm.showCostCenters)?_c('div',{staticClass:"row"},[_c('ed-select',{attrs:{"field-label":"Cost Center","placeholder":"Select a Cost Center","options":_vm.costCenters,"required":"required","disabled":_vm.model.canEditOnlyPrice,"label":"name","track-by":"key","customLabel":_vm.getCostCenterName,"error":_vm.doDisplayCostCenterError,"helptip-header":"","helptip-body":_vm.doDisplayCostCenterError && 'Please select a Cost Center' || '',"name":"cost_centers"},on:{"select":function($event){return _vm.costCenterSelected($event)}},model:{value:(_vm.formData.draftItem.costCenter),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "costCenter", $$v)},expression:"formData.draftItem.costCenter"}})],1):_vm._e(),_vm._v(" "),(_vm.showOneCostCenterWithBusinessUnit)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-md-4 no-pad"},[_vm._v("Business Unit and Cost Center")]),_vm._v(" "),_c('span',{staticClass:"col-md-8 small",attrs:{"name":"one_bu_cc_pair_name"}},[_vm._v(_vm._s(_vm.businessUnitsWithCostCenter.name))])]):_vm._e(),_vm._v(" "),(_vm.showMixCostCentersWithBusinessUnits)?_c('div',{staticClass:"row"},[_c('ed-select',{attrs:{"field-label":"Business Unit and Cost Center","placeholder":"Select business unit and cost center pair","options":_vm.businessUnitsWithCostCenters,"required":"required","disabled":_vm.model.canEditOnlyPrice,"label":"name","track-by":"key","error":_vm.doDisplayMixCostCenterWithBusinessUnitError,"helptip-header":"","helptip-body":_vm.doDisplayMixCostCenterWithBusinessUnitError && 'Please select a Business Unit with Cost Center' || '',"name":"bu_cc_pairs"},on:{"select":function($event){return _vm.businessUnitWithCostCenterSelected($event)}},model:{value:(_vm.formData.draftItem.pairedBusinessUnitAndCostCenter),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "pairedBusinessUnitAndCostCenter", $$v)},expression:"formData.draftItem.pairedBusinessUnitAndCostCenter"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),(_vm.model.units)?_c('ed-select',{attrs:{"field-label":"Unit","placeholder":"Select an Unit","options":_vm.model.units,"required":"required","disabled":_vm.model.canEditOnlyPrice,"label":"text","track-by":"key","error":_vm.doDisplayUnitsError,"helptip-header":"","helptip-body":_vm.doDisplayUnitsError && 'Please select a unit' || '',"name":"select_unit"},on:{"select":_vm.unitsChanged},model:{value:(_vm.formData.draftItem.unitTypeModel),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "unitTypeModel", $$v)},expression:"formData.draftItem.unitTypeModel"}}):_vm._e(),_vm._v(" "),(_vm.hasSyncSuppliersToAccountingSystem)?_c('ed-input',{attrs:{"field-label":"Tax Code","disabled":_vm.model.canEditOnlyPrice,"name":"taxCode"},model:{value:(_vm.formData.draftItem.taxCode),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "taxCode", $$v)},expression:"formData.draftItem.taxCode"}}):_vm._e(),_vm._v(" "),_c('custom-fields',{ref:"itemCustomFieldsRef",attrs:{"endpoint":_vm.api.$.invoice.i2p.itemCustomFields,"queryParameters":{invoiceId: _vm.model.PaymentInvoiceId, divisionId: _vm.model.DivisionID},"values":_vm.formData.draftItem.customFields}})],1),_vm._v(" "),_c('section',{staticClass:"col-md-12 no-pad"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h5',{staticClass:"section-title"},[_vm._v("Pricing")]),_vm._v(" "),_c('em',{staticClass:"small"},[_vm._v("Use the fields below to edit the unit and pricing details for this item(s).")])])]),_vm._v(" "),_c('p'),_vm._v(" "),(_vm.model.useSavingsFields === false)?_c('div',{staticClass:"row ghost",attrs:{"endpoint":_vm.computeItemTotalEndpoint}},[_c('div',{staticClass:"col-xs-11 col-md-2"},[_c('ed-input',{attrs:{"field-label":"Unit Price","right-label":"","amount":"","autoselect":"","type":"money","currency":_vm.currency,"supplementalPrecision":_vm.supplementalPrecision,"name":"unit_price","hide-optional":"","error":_vm.doDisplayUnitPriceError,"helptip-header":''},on:{"change":_vm.computeItemTotal,"input":_vm.unitPriceInputChanged},model:{value:(_vm.formData.draftItem.unitPrice),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "unitPrice", $$v)},expression:"formData.draftItem.unitPrice"}},[(_vm.doDisplayUnitPriceError && _vm.unitPriceErrorMsg || '')?_c('span',{attrs:{"slot":"message"},slot:"message"},[_c('p',[_vm._v("Unit price must be less than or equal to\n                      "),_c('v-money',{staticClass:"bold-text",attrs:{"currency":_vm.currency}},[_vm._v("\n                        "+_vm._s(Number(this.model.maxThreshold.unitPrice))+"\n                      ")])],1)]):_vm._e(),_vm._v(" "),(_vm.doDisplayUnitPriceError && _vm.unitPriceNonZeroMsg || '')?_c('span',{attrs:{"slot":"message"},slot:"message"},[_c('p',[_vm._v(_vm._s(_vm.unitPriceNonZeroMsg))])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"col-xs-11 col-md-2"},[_c('ed-input',{attrs:{"field-label":"Quantity","right-label":"","required":"required","error":_vm.doDisplayQuantityError,"helptip-header":_vm.doDisplayQuantityError &&  'Error' || '',"helptip-body":_vm.doDisplayQuantityError && _vm.quantityErrorMsg || '',"amount":"","autoselect":"","name":"quantity","hide-optional":""},on:{"change":_vm.computeItemTotal,"input":_vm.quantityChanged},model:{value:(_vm.formData.draftItem.quantity),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "quantity", $$v)},expression:"formData.draftItem.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center align-bottom"},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"col-xs-11 col-md-2"},[_c('ed-input',{attrs:{"field-label":"Units","right-label":"","amount":"","autoselect":"","name":"units","hide-optional":"","error":_vm.doDisplayUnitsInputError,"helptip-header":_vm.doDisplayUnitsInputError &&  'Error' || '',"helptip-body":_vm.doDisplayUnitsInputError && _vm.unitsErrorMsg || ''},on:{"change":_vm.computeItemTotal,"input":_vm.unitsInputChanged},model:{value:(_vm.formData.draftItem.units),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "units", $$v)},expression:"formData.draftItem.units"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"col-xs-11 col-md-2"},[_c('ed-input',{attrs:{"field-label":"Total","right-label":"","amount":"","type":"money","currency":_vm.currency,"disabled":true,"name":"totals","hide-optional":""},model:{value:(_vm.formData.draftItem.total),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "total", _vm._n($$v))},expression:"formData.draftItem.total"}})],1)]):_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('label',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-xs-12 col-md-2"},[_c('label',[_vm._v("Unit Price")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-xs-12 col-md-2"},[_c('label',[_vm._v("Quantity")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-xs-12 col-md-2"},[_c('label',[_vm._v("Units")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-xs-12 col-md-3"},[_c('label',[_vm._v("Total")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('label',[_vm._v("SGR")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"amount":"","autoselect":"","type":"money","supplementalPrecision":_vm.supplementalPrecision,"currency":_vm.currency,"placeholder":_vm.formData.draftItem.unitPricePlaceHolder},on:{"change":_vm.sgrChanged},model:{value:(_vm.formData.draftItem.unitPriceSGR),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "unitPriceSGR", $$v)},expression:"formData.draftItem.unitPriceSGR"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"right-label":"","amount":"","autoselect":""},on:{"change":_vm.computeItemTotal},model:{value:(_vm.formData.draftItem.quantity),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "quantity", $$v)},expression:"formData.draftItem.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"right-label":"","amount":"","autoselect":""},on:{"change":_vm.computeItemTotal},model:{value:(_vm.formData.draftItem.units),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "units", $$v)},expression:"formData.draftItem.units"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-3"},[_c('ed-input',{attrs:{"amount":"","type":"money","currency":_vm.currency,"disabled":true,"name":"sgr_total"},model:{value:(_vm.formData.draftItem.totalSGR),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "totalSGR", _vm._n($$v))},expression:"formData.draftItem.totalSGR"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('label',[_vm._v("Preferred Rate")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"amount":"","autoselect":"","type":"money","supplementalPrecision":_vm.supplementalPrecision,"currency":_vm.currency,"placeholder":_vm.formData.draftItem.unitPricePlaceHolder},on:{"change":_vm.prefferedRateChanged},model:{value:(_vm.formData.draftItem.unitPricePreferredRate),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "unitPricePreferredRate", $$v)},expression:"formData.draftItem.unitPricePreferredRate"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"amount":"","right-label":"","disabled":true},model:{value:(_vm.formData.draftItem.quantity),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "quantity", $$v)},expression:"formData.draftItem.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"amount":"","right-label":"","disabled":true},model:{value:(_vm.formData.draftItem.units),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "units", $$v)},expression:"formData.draftItem.units"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-3"},[_c('ed-input',{attrs:{"amount":"","type":"money","currency":_vm.currency,"disabled":true,"name":"preffered_rate_total"},model:{value:(_vm.formData.draftItem.totalPreferredRate),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "totalPreferredRate", _vm._n($$v))},expression:"formData.draftItem.totalPreferredRate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('label',[_vm._v("Negotiated Rate")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"amount":"","autoselect":"","type":"money","currency":_vm.currency,"supplementalPrecision":_vm.supplementalPrecision,"placeholder":_vm.formData.draftItem.unitPricePlaceHolder},on:{"change":_vm.negotiatedRateChanged},model:{value:(_vm.formData.draftItem.unitPriceNegotiatedRate),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "unitPriceNegotiatedRate", $$v)},expression:"formData.draftItem.unitPriceNegotiatedRate"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"amount":"","right-label":"","disabled":true},model:{value:(_vm.formData.draftItem.quantity),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "quantity", $$v)},expression:"formData.draftItem.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"amount":"","right-label":"","disabled":true},model:{value:(_vm.formData.draftItem.units),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "units", $$v)},expression:"formData.draftItem.units"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-3"},[_c('ed-input',{attrs:{"amount":"","type":"money","currency":_vm.currency,"disabled":true,"name":"negotiated_rate_total"},model:{value:(_vm.formData.draftItem.totalNegotiatedRate),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "totalNegotiatedRate", _vm._n($$v))},expression:"formData.draftItem.totalNegotiatedRate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('label',[_vm._v("Price")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"amount":"","autoselect":"","type":"money","supplementalPrecision":_vm.supplementalPrecision,"currency":_vm.currency,"error":_vm.doDisplayUnitPriceError,"placeholder":_vm.formData.draftItem.unitPricePlaceHolder,"helptip-header":''},on:{"change":_vm.unitPriceChanged},model:{value:(_vm.formData.draftItem.unitPrice),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "unitPrice", $$v)},expression:"formData.draftItem.unitPrice"}},[(_vm.doDisplayUnitPriceError && _vm.unitPriceNonZeroMsg || '')?_c('span',{attrs:{"slot":"message"},slot:"message"},[_c('p',[_vm._v(_vm._s(_vm.unitPriceNonZeroMsg))])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"amount":"","right-label":"","disabled":true},model:{value:(_vm.formData.draftItem.quantity),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "quantity", $$v)},expression:"formData.draftItem.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-2"},[_c('ed-input',{attrs:{"amount":"","right-label":"","disabled":true},model:{value:(_vm.formData.draftItem.units),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "units", $$v)},expression:"formData.draftItem.units"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-3"},[_c('ed-input',{attrs:{"amount":"","type":"money","currency":_vm.currency,"disabled":true,"name":"price_total"},model:{value:(_vm.formData.draftItem.total),callback:function ($$v) {_vm.$set(_vm.formData.draftItem, "total", _vm._n($$v))},expression:"formData.draftItem.total"}})],1)])])])]),_vm._v(" "),_c('section',{staticClass:"col-md-12 no-pad"},[_c('a',{staticClass:"section-title",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showDiscountsFeesTaxes = !_vm.showDiscountsFeesTaxes}}},[_c('i',{class:("icon fas fa-chevron-" + (_vm.showDiscountsFeesTaxes ? 'up' : 'down'))}),_vm._v("\n             \n            "),_c('span',[_vm._v("Discounts, Fees and Taxes")])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),(_vm.showDiscountsFeesTaxes)?_c('div',{staticClass:"form-group"},[_c('section',{staticClass:"pad"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"heading col-md-4 no-pad"},[_c('label',[_vm._v(" Other")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-md-2"},[_c('label',[_vm._v(" Percent")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("    ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-md-2"},[_c('label',[_vm._v(" Amount")])])]),_vm._v(" "),_c('tax-line',{staticClass:"row",attrs:{"discount":"","model":_vm.formData.draftItem,"compute":_vm.computeItemTotal,"context":_vm.vm}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8 text-right",attrs:{"name":"discount_subtotal"}},[_c('strong',[_c('small',[_vm._v("\n                      Subtotal:  \n                      "),_c('v-money',{attrs:{"currency":_vm.currency}},[_vm._v(_vm._s(_vm.formData.draftItem.subtotal))])],1)])])])],1),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('section',{staticClass:"pad"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"heading col-md-4 no-pad",attrs:{"name":"taxesLabel"}},[_c('label',[_vm._v(" Taxes")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-md-2"},[_c('label',[_vm._v(" Percent")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("    ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-md-2"},[_c('label',[_vm._v(" Amount")])])]),_vm._v(" "),_vm._l((_vm.formData.draftItem.taxes),function(tax){return _c('tax-line',{key:tax.name,staticClass:"row",attrs:{"model":tax,"compute":_vm.computeItemTotal,"context":_vm.vm}})}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8 text-right",attrs:{"name":"taxes_subtotal"}},[_c('strong',[_c('small',[_vm._v("\n                      Subtotal:  \n                      "),_c('v-money',{attrs:{"currency":_vm.currency,"supplementalPrecision":6}},[_vm._v(_vm._s(_vm.formData.draftItem.totalTaxes - _vm.formData.draftItem.totalTaxesForFees || 0))])],1)])])])],2),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('section',{staticClass:"pad"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"heading col-md-4 no-pad",attrs:{"name":"feesLabel"}},[_c('label',[_vm._v(" Fees")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-md-2"},[_c('label',[_vm._v(" Percent")])]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("    ")]),_vm._v(" "),_c('div',{staticClass:"heading right-label col-md-2"},[_c('label',[_vm._v(" Amount")])]),_vm._v(" "),_c('div',{staticClass:"heading col-md-2 text-right"},[_c('label',[_vm._v(" Taxes")])])]),_vm._v(" "),_vm._l((_vm.formData.draftItem.fees),function(fee){return _c('tax-line',{key:fee.name,staticClass:"row",attrs:{"model":fee,"compute":_vm.computeItemTotal,"details":_vm.openAddFeeTaxesDialog,"context":_vm.vm}})}),_vm._v(" "),_c('div',{staticClass:"row bold-text small"},[_c('div',{staticClass:"col-xs-6 col-md-6 text-right"},[_vm._v("Subtotal:")]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 col-md-2 text-right",attrs:{"name":"fees_subtotal"}},[_c('v-money',{attrs:{"currency":_vm.currency,"supplementalPrecision":6}},[_vm._v(_vm._s(_vm.formData.draftItem.totalFees || 0))])],1),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("    ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 col-md-2 text-right",attrs:{"name":"fee_taxes_subtotal"}},[_c('v-money',{attrs:{"currency":_vm.currency,"supplementalPrecision":6}},[_vm._v(_vm._s(_vm.formData.draftItem.totalTaxesForFees || 0))])],1)])],2)]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"col-md-12 no-pad"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("  ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8 col-md-8 text-right bold-text"},[_vm._v("Subtotal with taxes and fees:")]),_vm._v(" "),_c('div',{staticClass:"pull-left text-center"},[_vm._v("    ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 text-right",attrs:{"name":"subtotal_with_fees_and_taxes"}},[_c('v-money',{staticClass:"bold-text",attrs:{"currency":_vm.currency}},[_vm._v(_vm._s(_vm.formData.draftItem.totalWithTaxesAndFees || 0))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"clear"})])]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showVatGstPercentConfirmation,"title":"VAT/GST Percent Confirmation","primaryButton":"SAVE ITEM","secondaryButton":"BACK","closeOnEsc":true},on:{"confirm":_vm.onAcceptVatGstPercentConfirmation,"close":function($event){_vm.showVatGstPercentConfirmation = false}}},[(_vm.model.vatGstPercentagesPerCountry !== null)?_c('div',{staticClass:"content form-group",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("The VAT/GST percent is not valid in the country of the supplier. "),_c('br'),_vm._v(" The valid percentages for "+_vm._s(_vm.model.supplierCountry)+" are:")]),_c('br'),_vm._v(" "),_c('ul',_vm._l((_vm.model.vatGstPercentagesPerCountry[this.model.supplierCountry]),function(percent){return _c('li',[_vm._v("\n            "+_vm._s(percent)+"%\n          ")])}),0),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Please make sure the VAT/GST percent is correct before continuing as this will affect payments.")])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pUcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  props: {}
});

/***/ }),

/***/ "pV7Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancel_vue__ = __webpack_require__("QtZ6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66068550_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cancel_vue__ = __webpack_require__("opm4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66068550_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cancel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pb7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ReplaceApFile_vue__ = __webpack_require__("LZPs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FundingAddress_vue__ = __webpack_require__("OA49");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SendApFile',
  components: {
    ReplaceApFile: __WEBPACK_IMPORTED_MODULE_1__components_ReplaceApFile_vue__["a" /* default */],
    FundingAddress: __WEBPACK_IMPORTED_MODULE_2__components_FundingAddress_vue__["a" /* default */]
  },
  props: {
    emailSettings: Object,
    token: String
  },
  activated: function activated() {
    this.uploadFinished = true;
  },
  data: function data() {
    return {
      attachments: [],
      uploadFinished: true,
      attachmentsMissing: false,
      uploadData: {
        folder: 'Temp/',
        token: this.token
      }
    };
  },
  methods: {
    createAttachments: function createAttachments(e) {
      var completedFiles = e.filter(function (item) {
        return item.success ||
        // files uploaded with success
        !item.success && item.response && typeof item.response === 'string' && !utils.json.valid(item.response);
      } // files where requested failed
      );
      if (completedFiles.length >= 1) {
        this.attachmentsMissing = false;
      }
      if (completedFiles.length === e.length) {
        this.uploadFinished = true;
        var uploadedfiles = e.map(function (item) {
          var uploadError = '';
          var itemResponse = null;
          if (item.success && item.response) {
            itemResponse = JSON.parse(item.response);
            uploadError = itemResponse && itemResponse.uploadError ? itemResponse.uploadError : '';
          }
          if (!item.success) {
            uploadError = 'Upload request failed';
          }
          if (!uploadError) {
            return {
              AttachmentName: item.name,
              AttachmentSize: item.size,
              AttachmentFile: itemResponse ? itemResponse.file : item.file || '',
              AttachmentId: item.id || 0,
              AttachmentPath: itemResponse ? itemResponse.path : ''
            };
          }
        });
        this.attachments = uploadedfiles.map(function (item) {
          if (isNaN(item.AttachmentId)) {
            item.AttachmentId = 0;
          }
          return item;
        });
      } else {
        this.uploadFinished = false;
      }
      this.emitChanges();
    },
    emitChanges: function emitChanges() {
      var data = {
        divisionName: this.emailSettings.DivisionName,
        cc: this.emailSettings.Cc,
        bcc: this.emailSettings.Bcc,
        message: this.emailSettings.Message,
        attachments: this.attachments
      };
      this.$emit(__WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* Eved */].PAYMENT.APFILE_FIELDS_CHANGES, data);
    },
    getReplaceAuditFileModel: function getReplaceAuditFileModel() {
      return {
        ApFileId: this.emailSettings.ApFileId,
        AuditFileNumber: this.emailSettings.AuditFileNumber
      };
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "pcPi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"update-card"},[_c('i',{class:['fal', 'fa-2x', 'fa-fw', _vm.icon]}),_vm._v(" "),_c('div',{staticClass:"card-text"},[_vm._l((_vm.fragments),function(fragment){return [(fragment.url && (fragment.url !== ''))?_c('a',{attrs:{"href":fragment.url}},[_vm._v(_vm._s(fragment.text))]):[_vm._v(_vm._s(fragment.text || fragment))]]}),_vm._v(" "),_c('div',{staticClass:"when"},[_vm._v(_vm._s(_vm.when))])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pd+q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-custom-cell ag-cell-money",class:[_vm.invalidClass, _vm.infoMessage || _vm.warningMessage ? "info-message" : ""]},[_c('div',{staticClass:"ag-custom-cell-value"},[(_vm.displayMoney(_vm.params))?_c('v-money',{ref:"moneys",attrs:{"skip-conversion":_vm.skipConversion,"supplementalPrecision":_vm.supplementalPrecision,"currency":_vm.currencyCode}},[_vm._v(_vm._s(_vm.moneyValue))]):_vm._e()],1),_vm._v("  "),(_vm.infoMessage && !_vm.totalsRow)?_c('i',{class:_vm.infoMessageIcon || "far fa-info-circle info-icon",attrs:{"title":_vm.infoMessage}}):_vm._e(),(_vm.warningMessage)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.validationMessage),expression:"validationMessage"}],staticClass:"fas fa-exclamation-circle info-icon error-icon"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pd28":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pdqT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_charts_components_tooltip_standard__ = __webpack_require__("Ik2T");

/* harmony default export */ __webpack_exports__["a"] = ({
  chartType: 'Pie',
  showInChartLegend: true,
  chartOpts: getOptions(),
  chartData: function chartData(widget, data) {
    return getChartData(widget, data);
  },
  chartInfo: function chartInfo(widget, data) {
    return getChartInfo(data, 1);
  },
  drillDown: function drillDown(ctx, value, index) {
    return executeDrillDown(ctx, value, index);
  },
  drillDownReturn: function drillDownReturn(ctx) {
    return reverseDrillDown(ctx);
  },
  components: {
    tooltip: __WEBPACK_IMPORTED_MODULE_0__core_charts_components_tooltip_standard__["a" /* default */]
  }
});
function getOptions() {
  var baseCustSet = {
    chartGroupValue: 'Hotel Chain',
    showTotal: true,
    recalculateGridMax: false,
    hasDrillDown: true,
    chartInfoTooltip: true,
    containterStyle: 'height: 270px; margin-top: 3px; margin-left: 0px;',
    tooltip: {
      width: '200px'
    }
  };
  var baseOpts = {
    customSettings: baseCustSet,
    donut: true,
    donutWidth: 90,
    height: '260px',
    width: '260px'
  };
  return baseOpts;
}
function getChartInfo(dataIn, pos) {
  var result = [];
  dataIn.forEach(function (elem) {
    var gdPos = result.findIndex(function (k) {
      return k[0] === elem[pos];
    });
    if (gdPos === -1) result.push(elem[pos]);
  });
  return result.map(function (k) {
    return k[0];
  });
}
function getChartData(widget, data) {
  var sortedData = prepareData(widget, data, 1);
  sortedData = getTopDataGroup(sortedData, 'Other Hotel Chains');
  var seriesGrouped = sortedData.map(function (k) {
    return k[1];
  });
  return {
    labels: sortedData.map(function (k) {
      return k[0];
    }),
    series: seriesGrouped.map(function (q) {
      return Math.abs(q);
    }),
    labelData: seriesGrouped,
    tooltipData: {
      helpText: 'Click on the slice to see Brand level spend details.',
      metadata: tooltipMetadata,
      data: [sortedData.map(function (t) {
        return t[0];
      }), seriesGrouped]
    }
  };
}
function getTopDataGroup(data, otherText) {
  var maxItems = 8;
  if (data.length > maxItems && data.length !== maxItems + 1) {
    var otherIt = [otherText, 0];
    for (var i = maxItems; i < data.length; i++) {
      otherIt[1] += data[i][1];
    }
    data.splice(maxItems, data.length - maxItems);
    data.push(otherIt);
  }
  return data;
}
function getChartDataDrilled(data, widget) {
  var sortedData = prepareData(widget, data, 0);
  sortedData = getTopDataGroup(sortedData, 'Other Hotel Brands');
  var seriesGrouped = sortedData.map(function (k) {
    return k[1];
  });
  return {
    labels: sortedData.map(function (k) {
      return k[0];
    }),
    series: seriesGrouped.map(function (q) {
      return Math.abs(q);
    }),
    labelData: seriesGrouped,
    tooltipData: {
      metadata: tooltipMedatadaDrilled,
      data: [sortedData.map(function (t) {
        return t[0];
      }), seriesGrouped]
    }
  };
}
function executeDrillDown(ctx, value) {
  var chain = value;
  var fullData = ctx.rawData.filter(function (row) {
    return ~row.indexOf(chain);
  });
  var newChartData = getChartDataDrilled(fullData, ctx);
  ctx.chartData = newChartData;
  ctx.chartInfo = newChartData.labels;
  ctx.chartComponent.chartOpts.customSettings.hasDrillDown = false;
  ctx.chartComponent.chartOpts.customSettings.tooltip = {
    width: '235px',
    topOffset: -10,
    leftOffset: 50
  };
  ctx.$emit('childRedraw');
}
function reverseDrillDown(ctx) {
  ctx.chartComponent.chartOpts = getOptions();
  ctx.chartComponent.chartOpts.customSettings.hasDrillDown = true;
  ctx.$emit('childRedraw');
}
function prepareData(widget, data, ind) {
  var scenarioIndex = getVariableIndex(widget);
  if (data.length === 0) return {
    labels: null,
    series: []
  };
  var labelsGrouped = [];
  data.forEach(function (chain) {
    var label = chain[ind];
    if (label === null || label === '') label = 'No Brand';
    var pos = labelsGrouped.findIndex(function (k) {
      return k[0] === label;
    });
    var value = getSumBasedOnScenario(chain, scenarioIndex);
    if (pos === -1) {
      labelsGrouped.push([label, value]);
    } else {
      labelsGrouped[pos][1] += value;
    }
  });
  var sortedData = labelsGrouped.slice(0);
  sortedData.sort(function (a, b) {
    return b[1] - a[1];
  });
  return sortedData;
}
function getVariableValue(widget) {
  var wgt = widget.variables ? widget.variables : widget.widget.variables;
  var variable = wgt.filter(function (s) {
    if (s.name === 'PaymentStatusFilter') return s.value[0];else return null;
  });
  return variable[0].value[0];
}
function getSumBasedOnScenario(chain, scenarioIndex) {
  var sum = 0;
  if (scenarioIndex === 1) {
    sum = chain[3];
  } else if (scenarioIndex === 2) {
    sum = chain[5] + chain[6] + (chain[2] === true ? chain[3] : 0);
  } else if (scenarioIndex === 3) {
    sum = chain[4] + chain[7];
  }
  return sum;
}
function getVariableIndex(widget) {
  var variableVal = getVariableValue(widget);
  if (variableVal === 'TotalSpend') return 1;else if (variableVal === 'PaidSpend') return 2;
  return 3; // open spend
}
var ttLabel = 'Total Spend';
var tooltipMetadata = [{
  label: '',
  type: 'title',
  format: ''
}, {
  label: ttLabel,
  type: 'main',
  format: 'currency'
}];
var tooltipMedatadaDrilled = [{
  label: '',
  type: 'title',
  format: ''
}, {
  label: ttLabel,
  type: 'main',
  format: 'currency'
}];

/***/ }),

/***/ "pe4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return languages; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isLang;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadLanguageAsync;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_locales_en_US__ = __webpack_require__("0TFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_locales_en_US___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lang_locales_en_US__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__("Usg1");





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages: {
    'en-US': __WEBPACK_IMPORTED_MODULE_2__lang_locales_en_US___default.a
  },
  silentTranslationWarn: true
});
var loadedLanguages = ['en-US'];
var languages = {
  'en-US': 'English',
  'de': 'Deutch',
  'es': 'Español',
  'ro': 'Română',
  'zh-HK': '香港'
};
function setI18nLanguage(lang) {
  i18n.locale = lang;
  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  __WEBPACK_IMPORTED_MODULE_4__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* Eved */].GENERIC.LANGUAGE_CHANGED, lang);
  return lang;
}
function isLang(lang) {
  return i18n.locale === lang;
}
function loadLanguageAsync(lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return __webpack_require__("nds2")("./".concat(lang)).then(function (msgs) {
        i18n.setLocaleMessage(lang, msgs);
        loadedLanguages.push(lang);
        return setI18nLanguage(lang);
      }).catch(function (e) {
        return console.warn('Language not supported');
      });
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}

/***/ }),

/***/ "pfsV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-flex active"},[_c('ed-section',{staticClass:"no-flex active no-margin no-border",attrs:{"title":" ","wide":"","full-width":""}},[_c('div',[_c('br'),_vm._v(" "),_c('ed-form',{staticClass:"col-md-5 col-md-offset-7 no-pad",attrs:{"submit-visible":false}},[_c('ed-select',{attrs:{"field-label":"Payment Method","placeholder":"Select Payment Method","options":_vm.paymentMethods,"required":"","disabled":"","label":"Value","track-by":"Value","name":"payment_method"},model:{value:(_vm.paymentMethod),callback:function ($$v) {_vm.paymentMethod=$$v},expression:"paymentMethod"}}),_vm._v(" "),(_vm.model.AuditFileTemplates && _vm.model.AuditFileTemplates.length === 1)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("AP Template")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v(_vm._s(_vm.model.AuditFileTemplates[0].Value))])]):_vm._e(),_vm._v(" "),(_vm.model.FundingAddresses && _vm.model.FundingAddresses.length === 1)?_c('funding-address',{attrs:{"model":_vm.getFundingAddressOptions[0].Value,"showEdit":true},on:{"changeAddress":function (d) { return _vm.$emit('changeAddress', d); }}}):_vm._e(),_vm._v(" "),_c('ed-textarea',{attrs:{"field-label":"Payment Notes","max-length":150,"name":"payment_notes"},on:{"input":_vm.fieldChanged},model:{value:(_vm.paymentNotes),callback:function ($$v) {_vm.paymentNotes=$$v},expression:"paymentNotes"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clear"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pgOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("qy9/");
/* empty harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pi3j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2t6agu085kiyG2458bVp76","Dell":"_3KjnU96p2U8BhGlBCGwhwF","Abbott":"_10H-e9VlMvoxqoN4fSC9U7","Gap":"yHVK5nZn0qGJ2VYNFW3La","Allstate":"_2AD5DJ1logYf9BFi11dff6","Asurion":"_2hoqtcOlG7FWJkBIXidnTG","Invitae":"_2ZQPyJ4NDqLTgy3fSPzGV9","JWE":"JehGjpHBT4-W3ikh92kkR"};

/***/ }),

/***/ "pqHe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__("0VFH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebbd9cce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("L9A4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebbd9cce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "prgC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_13wJnkxGe5s2oqEKPHZcFN","Dell":"_1_okN2Lyt7hmdDRFWnlQ3C","Abbott":"pa-H6Z4WMbXZ3oGQrt-2T","Gap":"_3KTK88rpAsqD8f5rkA_BV_","Allstate":"_36xr5gRse1actBirNR-GiU","Asurion":"_3HozqMDHakhYFEtI_BBwUz","Invitae":"_20BBWxPKU0-8J2pvYdMjLO","JWE":"_1jHrDljmCSB2uZwOXqtPtG"};

/***/ }),

/***/ "q3WB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qDeO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qFHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    card: Object
  },
  data: function data() {
    return {
      returnFunds: ''
    };
  }
});

/***/ }),

/***/ "qNdS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_tabs_vue__ = __webpack_require__("vvHA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66f18dbc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nav_tabs_vue__ = __webpack_require__("26UQ");
function injectStyle (ssrContext) {
  __webpack_require__("9unJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66f18dbc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nav_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qPJb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object
  }
});

/***/ }),

/***/ "qYFL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users__ = __webpack_require__("dl2l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__suppliers__ = __webpack_require__("5V0c");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var navigation = function navigation(modules) {
  return _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_2__suppliers__["a" /* default */])(modules, __WEBPACK_IMPORTED_MODULE_1__users__["a" /* default */]));
};

/***/ }),

/***/ "qYUL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var EVENT_ON_CLOSE = 'onClose';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'md-notification',
  props: {
    type: {
      type: String,
      default: 'info',
      validator: function validator(val) {
        return ['', 'plain', 'primary', 'info', 'success', 'warning', 'danger'].indexOf(val) !== -1;
      }
    },
    icon: String,
    title: String,
    heading: String,
    message: String,
    dismiss: String,
    discard: {
      type: String,
      default: 'Discard'
    },
    allowDismiss: {
      type: Boolean,
      default: true
    },
    progressbar: {
      type: Object
    },
    url: String,
    goto: String,
    target: {
      type: String,
      default: '_blank',
      validator: function validator(val) {
        var targets = ['', '_self', '_blank'];
        return targets.indexOf(val) !== -1;
      }
    },
    width: {
      type: Number,
      default: 350
    },
    position: Object,
    placement: {
      type: Object,
      default: function _default() {
        return {
          from: 'top',
          align: 'right'
        };
      },
      validator: function validator(plmt) {
        var froms = ['top', 'bottom'];
        var aligns = ['left', 'center', 'right'];
        return froms.indexOf(plmt.from) !== -1 && aligns.indexOf(plmt.align) !== -1;
      }
    },
    timeout: {
      type: Number,
      default: 5000
    },
    hide: Boolean
  },
  data: function data() {
    return {};
  },
  computed: {
    withIcon: function withIcon() {
      return this.icon && this.icon.length > 0 ? 'alert-with-icon' : '';
    },
    customPosition: function customPosition() {
      var _this = this;
      var initialMargin = 20;
      var alertHeight = 90;
      var sameAlertsCount = this.$notifications.state.filter(function (alert) {
        return alert.placement && alert.placement.align === _this.placement.align && alert.placement.from === _this.placement.from;
      }).length;
      var pixels = (sameAlertsCount - 1) * alertHeight + initialMargin;
      var styles = {};
      if (this.placement.from === 'top') {
        styles.top = "".concat(pixels, "px");
      } else {
        styles.bottom = "".concat(pixels, "px");
      }
      styles.width = "".concat(this.width, "px");
      return styles;
    }
  },
  methods: {
    close: function close(forceDismiss) {
      if (forceDismiss && forceDismiss.target && this.type !== 'info') {
        this.$router.replace(this.currentPath);
      }
      this.$emit(EVENT_ON_CLOSE, forceDismiss);
    }
  },
  created: function created() {
    this.currentPath = this.$route.fullPath;
  },
  mounted: function mounted() {
    if (this.timeout) {
      setTimeout(this.close, this.timeout);
    }
  }
});

/***/ }),

/***/ "qf/r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("QTCC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61591cde_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("9twA");
function injectStyle (ssrContext) {
  __webpack_require__("pi3j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61591cde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61591cde_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qlOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{staticClass:"btn btn-actionbar",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.validateInvoices()}}},[_vm._v("Edit Invoice\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showModal,"title":"","xsubtitle":"","primaryButton":"OK","secondaryButton":"false"},on:{"close":function($event){_vm.showModal = false}}},[_c('span',{attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"col-md-8 lh15"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.modalContent)}})]),_vm._v(" "),_c('div',{staticClass:"clear"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qqer":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./colors/index.vue": "Xjtk",
	"./colors/palette/index.vue": "S01/",
	"./components/index.vue": "u0y/",
	"./introduction/get-started/index.vue": "/nPV",
	"./introduction/index.vue": "0WKx"
};
function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
};
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e/* lazy-once context */(7).then(function() {
		var id = map[req];
		if(!(id + 1)) // check for number or string
			throw new Error("Cannot find module '" + req + "'.");
		return id;
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "qqer";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "qy9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseChartWidget__ = __webpack_require__("wrv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__("Pej/");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__baseChartWidget__["a" /* default */])('categorySpend-wdg-cmp', __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]));

/***/ }),

/***/ "r4/r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var layouts = {};
var files = __webpack_require__("gR1n");
files.keys().forEach(function (key) {
  var name = key.replace('./', '').replace('/index.vue', '').replace('.vue', '');
  layouts[files(key).alias || name] = files(key);
});
/* harmony default export */ __webpack_exports__["a"] = (layouts);

/***/ }),

/***/ "r4F+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r4I0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rejectReason: '',
      showReject: false
    };
  },
  created: function created() {},
  props: {
    ids: null,
    disabled: false,
    tooltip: '',
    selectedRows: [],
    card: [],
    buttonClass: {
      type: String,
      default: 'btn btn-actionbar col-md-12'
    }
  },
  methods: {
    approveOrRejectCardRefill: function approveOrRejectCardRefill() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var cardId, payload, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (_this.selectedRows && _this.selectedRows.length > 0) {
                cardId = _this.selectedRows[0].data.Id;
              } else {
                cardId = _this.card.Id;
              }
              payload = {
                cardsData: JSON.stringify([{
                  Id: cardId,
                  RejectReason: _this.rejectReason
                }])
              };
              _context.next = 5;
              return _this.api.post(_this.api.$.evedpaycard.approveOrRejectCardRefill, payload);
            case 5:
              response = _context.sent;
              if (response.data) {
                _context.next = 10;
                break;
              }
              throw new Error('Error during the request');
            case 10:
              _this.$emit('success');
            case 11:
              if (response.status === 200) {
                _this.showReject = false;
              }
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ "r4pl":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "rBem":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3QQfn1kthGWl7wtv3WSJUm","Dell":"_3YFudE3K4n6zN-Vga9S-nF","Abbott":"qXhHOfP4ilsaOXmsdesBC","Gap":"_1eDFg5gYfDO9bZd5epo52L","Allstate":"_14NIAEKh3mexCWVmbeX3Mx","Asurion":"ORqK-Cub2AOD9fk17RPlD","Invitae":"_2r8U5E3ZusAtJuKSIEOcLn","JWE":"_3B93b76FZV5o9aDcn56We0"};

/***/ }),

/***/ "rHCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taxLine_vue__ = __webpack_require__("6XR1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ecaaa16_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_taxLine_vue__ = __webpack_require__("8byk");
function injectStyle (ssrContext) {
  __webpack_require__("ZSj5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ecaaa16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taxLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ecaaa16_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_taxLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rMOU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardHolder_vue__ = __webpack_require__("aliK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3d8623_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardHolder_vue__ = __webpack_require__("W4pV");
function injectStyle (ssrContext) {
  __webpack_require__("w7Rz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e3d8623"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardHolder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3d8623_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardHolder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rNB3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * IMPORT MODULE
 *
 * This module handles data imports across the platform.
 *
 * @package Import
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Import',
  data: function data() {
    var _this = this;
    return {
      isDisabled: function isDisabled(setting) {
        // if (setting.status === null) return false
        return typeof setting.value === 'boolean' ? !setting.value : setting.status !== null && !_this.$user.$.companySettings[setting.status];
      },
      backUrl: function backUrl(url, setting) {
        return setting.status !== null && !setting.value || setting.status === null && setting.value === false ? 'javascript:;' : url ? url.replace('[back]', '?back-to=Imports') : '';
      },
      hasPermission: function hasPermission(permission) {
        return _this.$user.$.userPermissions.indexOf(permission) > -1;
      }
    };
  },
  methods: {
    // Import cards flagged with `breakout` have no legacy module — the redesigned
    // native wizard is their only home (ticket 5854). So we always cancel the href
    // (it would otherwise be a dead link) and, when embedded in the v3 shell, post a
    // LEGACY_SHORTCUT_CLICK so the host routes to the native page. Standalone-legacy
    // is a safe no-op. Non-breakout cards are untouched — they navigate via href.
    onImport: function onImport(setting, e) {
      if (!setting.breakout) return;
      if (e && e.preventDefault) e.preventDefault();
      if (window.self === window.top) return;
      // Pin the target origin to the actual embedder (the v3 shell) rather than '*'.
      var target = '*';
      try {
        if (document.referrer) target = new URL(document.referrer).origin;
      } catch (err) {/* malformed referrer → fall back to '*' */}
      window.parent.postMessage({
        type: 'LEGACY_SHORTCUT_CLICK',
        button: setting.breakout
      }, target);
    }
  },
  computed: {
    settings: function settings() {
      var programsLabel = global.app.$user && global.app.$user.sessionSettings ? global.app.$user.sessionSettings.CompanySettings.ProgramsLabel : 'Programs';
      return [{
        name: programsLabel,
        condition: this.hasPermission('CreatePrograms'),
        status: null,
        // value: false,
        description: 'Import data to create and update ' + programsLabel.toLowerCase() + '.',
        configurable: 'Import',
        icon: ['far', 'calendar-alt'],
        url: '#/d/Import/Programs#import-file' // ,
        // endpoint: endpoints.import.programs
      }, {
        name: 'Expenses',
        condition: this.hasPermission('CreateExpenses'),
        status: null,
        // value: false,
        description: 'Import data to create expenses.',
        configurable: 'Import',
        icon: ['fal', 'credit-card'],
        url: '#/d/Import/Expenses' // ,
        // endpoint: endpoints.import.expenses
      }, {
        name: 'Invoices',
        condition: this.hasPermission('CreateEditPO'),
        status: null,
        // value: false,
        description: 'Import data to create invoices.',
        configurable: 'Import',
        icon: ['far', 'file-alt'],
        new: true,
        url: '#/d/Import/Invoices' // ,
        // endpoint: endpoints.import.invoices
      }, {
        name: 'Categories',
        condition: this.hasPermission('Administration'),
        status: null,
        description: 'Import data to create and update categories from your chart of accounts.',
        configurable: 'Import',
        icon: ['far', 'list-alt'],
        new: true,
        // This card's Import button breaks out of the legacy iframe to the native
        // import wizard (ticket 5854); there is no legacy Categories import module,
        // so `onImport` always cancels navigation and the href is an inert
        // placeholder (never a dead route).
        breakout: 'ImportCategories',
        url: 'javascript:;'
      } /* ,
        {
         name: 'Divisions',
         status: null,
         value: false,
         description: 'Import data to create and update division configurations.',
         configurable: 'Import',
         icon: ['far', 'building'],
         url: '#/d/Import/Divisions'// ,
         // endpoint: endpoints.import.divisions
        },
        {
         name: 'Users',
         status: null,
         value: false,
         description: 'Import data to create and update user information.',
         configurable: 'Import',
         icon: ['fas', 'user'],
         url: '#/d/Import/Users'// ,
         // endpoint: endpoints.import.users
        } */];
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "rNIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.fieldLabel)?_c('label',[_vm._v(_vm._s(_vm.fieldLabel)),(_vm.required)?_c('span',[_vm._v(" *"),_c('div',{staticClass:"helptip-wrapper"},[(_vm.helptipBody)?_c('span',{staticClass:"helptip-icon",on:{"click":function($event){return _vm.toggleHelp()}}},[_c('i',{class:[_vm.showHelp ? _vm.hideIcon : _vm.showIcon]})]):_vm._e(),(_vm.helptipBody && _vm.showHelp || _vm.helptipBody && _vm.error)?_c('ed-input-tooltip',{class:{"error-message": _vm.error},attrs:{"helptipHeader":_vm.helptipHeader,"errorTip":_vm.error,"helptipBody":_vm.helptipBody}}):_vm._e()],1)]):_vm._e()]):_vm._e(),_c('label',{class:_vm.classObject,on:{"mousedown":_vm.mousedown}},[(_vm.shouldShowLabel)?_c('span',{staticClass:"vue-switcher__label"},[(_vm.label)?_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e()]):_vm._e(),_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.trigger}}),_c('div',{staticClass:"dawn-switch-switch"},[(!_vm.label && _vm.value)?_c('span',{staticClass:"switch-text",domProps:{"textContent":_vm._s(_vm.textEnabled)}}):_vm._e(),(!_vm.label && !_vm.value)?_c('span',{staticClass:"switch-text",domProps:{"textContent":_vm._s(_vm.textDisabled)}}):_vm._e()])]),(_vm.value)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rR4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ZYxS");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3472567e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("cEym");
function injectStyle (ssrContext) {
  __webpack_require__("GV2d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3472567e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3472567e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rTkR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

var priority = [undefined, 'Standard', 'Rush', 'Immediate'];
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: [String, Number],
    max: {
      type: Number,
      default: 3
    }
  },
  created: function created() {
    this.value = this.params ? this.params.value : this.value;
  },
  computed: {
    show: function show() {
      return this.params ? !this.params.node.rowPinned : true;
    },
    tag: function tag() {
      return this.value;
    },
    priorityNo: function priorityNo() {
      var index = priority.indexOf(this.tag);
      // discounted payment terms case
      // will have the same icon as for Rush status
      if (index === -1) index = priority.indexOf('Rush');
      return index;
    },
    symbol: function symbol() {
      return "priority-".concat(this.priorityNo);
    }
  },
  methods: {
    colorize: function colorize(i) {
      return i > this.max - this.priorityNo;
    }
  }
});

/***/ }),

/***/ "rd3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Predicted coding'),expression:"'Predicted coding'"}],staticClass:"predicted-coding-icon",attrs:{"aria-label":"Predicted coding"}},[_c('svg',{attrs:{"viewBox":"0 0 16 16","focusable":"false","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M9.1 0.7L2.7 8.5h4.5l-0.3 6.8 6.4-8.6H8.8L9.1 0.7z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rjke":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navless-layout-header"},[_vm._t("navbar",function(){return [_c('ed-button',{attrs:{"to":_vm.$routerHistory.previous().path}},[_c('i',{staticClass:"fal fa-chevron-left"}),_vm._v("\n         \n        Back\n      ")])]})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{attrs:{"endpoint":_vm.api.$.evedpaycard.cards}},[(_vm.cards)?_c('div',{key:_vm.cards.id,staticClass:"content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-preview-container"},[_c('div',{staticClass:"card-preview"},[_c('img',{attrs:{"src":"https://d1a4bxjw35af21.cloudfront.net/images_en/eved-pay-logo.svg","alt":"EvedPay Logo"}}),_vm._v(" "),_c('div',{staticClass:"col-md-6 static"},[_c('p',{staticClass:"card-number"},[_vm._v("•••• •••• •••• "+_vm._s(_vm.cards.cardNumber))])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),(_vm.cards.cardStatus === 'Active')?_c('div',{staticClass:"button-container"},[(_vm.isCardHolder)?_c('button',{staticClass:"btn btn-sm custom-button",on:{"click":function () { return _vm.redirectToShowNumber(_vm.cards); }}},[_vm._v("CARD NUMBER")]):_vm._e(),_vm._v(" "),(!_vm.cards.isPhysicalCard)?_c('button',{staticClass:"btn btn-sm custom-button",on:{"click":function () { return _vm.redirectToRequestCard(_vm.cards); }}},[_vm._v("REQUEST PHYSICAL CARD")]):_vm._e(),_vm._v(" "),(_vm.cards.pending === 0)?_c('button',{staticClass:"btn btn-sm custom-button",on:{"click":function () { return _vm.redirectToAddFunds(_vm.cards); }}},[_vm._v(_vm._s(_vm.isUserAdmin ? 'ADD FUNDS' : 'REQUEST ADDITIONAL FUNDS'))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm custom-button",on:{"click":function () { return _vm.redirectToChangePin(_vm.cards); }}},[_vm._v("CHANGE PIN")])]):_vm._e()]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"color":"white","margin":"0px","height":"27px"}},[_vm._v("t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"card-details-text"},[_vm._v("Card Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 card-details-row2"},[_c('div',{staticClass:"col-md-3 static"},[_c('p',{staticClass:"card-expiry"},[_c('span',{staticClass:"small"},[_c('small',[_vm._v("VALID THRU")])]),_vm._v(" "),_c('br'),_vm._v("\n                ••/••\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 static"},[_c('p',{staticClass:"card-ccv"},[_c('span',{staticClass:"small"},[_c('small',[_vm._v("CVV")])]),_vm._v(" "),_c('br'),_vm._v("\n                •••\n              ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rkBV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('span',_vm._l((_vm.tabs),function(tab,key){return _c('a',{staticClass:"navbar-brand",class:{ "active": _vm.isTabActive(tab, key) },attrs:{"href":"#/" + (key === "Dashboard" ? "" : _vm.namespace) + (key == "Dashboard" ? "home" : "/" + key)},on:{"click":function($event){$event.stopPropagation();return _vm.track.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t(tab.alias || key))),(_vm.showSubtabs(tab, key))?_c('div',{staticClass:"sub-menus alt",class:{"none": _vm.newMenus(key) || !tab.subtabs}},[_c('div',{class:{ "container-fluid": !_vm.newMenus(key) }},[(_vm.newMenus(key))?_c('ed-tab-nav',{attrs:{"wide":""}},_vm._l((tab.subtabs),function(subTab,subKey){return _c('ed-tab',{key:subKey,attrs:{"title":_vm.subNavLabel(subKey),"url":"#/" + _vm.sectionNamespace(key, subTab, subKey) + "/" + key + "/" + _vm.section(key, subTab, subKey) + "/","active":_vm.isActive(key, subTab, subKey) && _vm.$root.legacySubtab == "" || key == _vm.$root.legacySubtab,"completed":""}})}),1):_c('ul',{staticClass:"navbar-collapse"},[_c('li',[_vm._l((tab.subtabs),function(subTab,subKey){return (subKey != "label")?_c('a',{class:{ "active": _vm.isActive(key, subTab, subKey) || subTab == _vm.$root.legacySubtab },attrs:{"href":_vm.subTabUrl(key, subTab, subKey)},on:{"click":function($event){$event.stopPropagation();return _vm.track.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.subNavLabel(subKey)))]):_vm._e()}),(!tab.subtabs)?_c('a'):_vm._e()],2)])],1)]):_vm._e()])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rvuV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_vue__ = __webpack_require__("VREj");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rxf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return constants; });
// constants
var constants = {
  invoice: {
    SameDayLabel: 'Immediate',
    ApprovalCheckbox: 'ApprovalCheckbox',
    USD: 'USD'
  },
  columnType: {
    List: 'list',
    Date: 'date',
    Money: 'money',
    Percent: 'percent',
    Qty: 'qty',
    Text: 'text'
  }
};

/***/ }),

/***/ "s/4v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseChartWidget__ = __webpack_require__("wrv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__("pdqT");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__baseChartWidget__["a" /* default */])('hotelSpend-wdg-cmp', __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */]));

/***/ }),

/***/ "s7CT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_39AdL0oLZBSoIuQXIdZ1H1","Dell":"_3_DCq_x5Nk89E9rScs-sPs","Abbott":"cvGpQkMuLO7vkbtiLi2ke","Gap":"_3uJBln0KpQ7PUOx3ggSLl_","Allstate":"_32hjKfzWaPDf2eSmwQcbIc","Asurion":"_14iyQ5TOEQkNXDVmWZnhHG","Invitae":"_1mSUqzkn81h7kSLy9Hdc3p","JWE":"SncC_8jWIDVUMPGFmLPJc"};

/***/ }),

/***/ "sGLf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accounting-system-settings-overlay"},[(this.accountSettings.ShowAccountOrGlCode)?_c('ed-input',{attrs:{"type":"text","required":_vm.pushToAccountingSystem,"validation":"","error":_vm.error,"field-label":"Account/Gl Code"},on:{"validate":_vm.save,"input":function (o) { _vm.accountOrGlCode = o; }},model:{value:(_vm.accountOrGlCode),callback:function ($$v) {_vm.accountOrGlCode=$$v},expression:"accountOrGlCode"}}):_vm._e(),_vm._v(" "),_c('label',[_vm._v("PSL+ Vendor")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pushToAccountingSystem),expression:"pushToAccountingSystem"}],attrs:{"type":"checkbox","id":"push-to-accounting-system"},domProps:{"checked":Array.isArray(_vm.pushToAccountingSystem)?_vm._i(_vm.pushToAccountingSystem,null)>-1:(_vm.pushToAccountingSystem)},on:{"change":function($event){var $$a=_vm.pushToAccountingSystem,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pushToAccountingSystem=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pushToAccountingSystem=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pushToAccountingSystem=$$c}}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-left":"7px","margin-top":"3px"},attrs:{"for":"push-to-accounting-system"}},[_vm._v("Sync Card data with PSL+")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ed-input',{attrs:{"type":"text","maxlength":"6","field-label":"PSL+ Card Number"},on:{"input":function (o) { _vm.cardNumberInAccountingSystem = o; }},model:{value:(_vm.cardNumberInAccountingSystem),callback:function ($$v) {_vm.cardNumberInAccountingSystem=$$v},expression:"cardNumberInAccountingSystem"}},[_c('div',{staticStyle:{"font-size":"smaller","font-style":"italic"},attrs:{"slot":"additionalText"},slot:"additionalText"},[_vm._v("\n      If vendor record is already in PSL+, please enter as displayed in PSL+\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sMu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("1j21");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf7ad10c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("QYmu");
function injectStyle (ssrContext) {
  __webpack_require__("2+zr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf7ad10c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sRHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("RNei");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37789a58_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("14vj");
function injectStyle (ssrContext) {
  __webpack_require__("gEsY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37789a58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37789a58_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sXLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RejectCardFunding_vue__ = __webpack_require__("wcGH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc2466f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RejectCardFunding_vue__ = __webpack_require__("ueD1");
function injectStyle (ssrContext) {
  __webpack_require__("pd28")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fc2466f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RejectCardFunding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc2466f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RejectCardFunding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "seUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root row"},[_c('div',{staticClass:"col-md-12 no-pad"},[_c('table',{staticClass:"table small"},[_c('thead',[_c('tr',[_c('th',{staticClass:"col-md-2"},[_vm._v("Needs Approval")]),_vm._v(" "),(_vm.hasProgramName)?[_c('th',{staticClass:"col-md-3"},[_vm._v(_vm._s(_vm.programLabel))])]:_vm._e(),_vm._v(" "),(_vm.hasSupplier)?[_c('th',{staticClass:"col-md-3"},[_vm._v("Supplier")])]:_vm._e(),_vm._v(" "),(_vm.hasDueDate)?[_c('th',{staticClass:"col-md-2"},[_vm._v("Due Date")])]:_vm._e(),_vm._v(" "),_c('th',{staticClass:"col-md-2"},[_vm._v("Amount")])],2)])]),_vm._v(" "),_c('div',{staticClass:"scroller"},[_c('table',{staticClass:"table small"},[_c('tbody',_vm._l((_vm.list),function(item,i){return _c('tr',{key:i},[_c('td',{staticClass:"col-md-2"},[_vm._v(_vm._s(item.NeedsApprovalLabel || item.NeedsApproval))]),_vm._v(" "),(_vm.hasProgramName)?[(item.ProgramName)?_c('td',{staticClass:"col-md-3"},[_vm._v(_vm._s(item.ProgramName))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.hasSupplier)?[(item.SupplierName)?_c('td',{staticClass:"col-md-3"},[_vm._v(_vm._s(item.SupplierEoNumber ? item.SupplierName + ' (' + item.SupplierEoNumber + ')' : item.SupplierName))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.hasDueDate)?[(item.DueDate)?_c('td',{staticClass:"col-md-2"},[_vm._v(_vm._s(item.DueDate))]):_vm._e()]:_vm._e(),_vm._v(" "),_c('td',{staticClass:"col-md-2"},[(String(item.IsPoolFunding).toLowerCase() === 'true')?[_vm._v("Daily Spend Limit: "+_vm._s(item.DailySpendLimit))]:[_vm._v(_vm._s(item.Amount))]],2)],2)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sknG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "slco":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loginService_js__ = __webpack_require__("6SW0");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */

var mfaSetup = 'MFA_SETUP';
/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'login',
  data: function data() {
    var _this = this;
    return {
      email: '',
      emailValidation: '',
      feedbackMessage: '',
      loginDetails: {
        username: '',
        password: ''
      },
      mfaData: {
        code: '',
        session: '',
        challengeName: '',
        challengeParameters: []
      },
      remember: [{
        status: false,
        label: 'Remember me.'
      }],
      loginError: {
        message: ''
      },
      showFeedback: false,
      showForgotPassword: false,
      loginEndpoint: this.api.$.login,
      mfaOriginText: function mfaOriginText() {
        switch (_this.mfaData.challengeName) {
          case 'SOFTWARE_TOKEN_MFA':
            return 'Check your authenticator for the one-time code';
          case 'CUSTOM_CHALLENGE':
            return 'We sent you a one-time code to your email';
          default:
            return 'We sent you a one-time code to your phone number';
        }
      },
      validEmail: function validEmail(email) {
        var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; // eslint-disable-line
        return re.test(email);
      }
    };
  },
  computed: {
    mfa: function mfa() {
      return typeof this.$route.query.mfa !== 'undefined';
    }
  },
  methods: {
    /**
     * Authenticates user on PHP endpoint
     * then init user in app
     */
    loginUser: function loginUser() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_1__loginService_js__["a" /* default */].login.call(this, this.loginDetails).then(function (res) {
        !res.ChallengeName ? __WEBPACK_IMPORTED_MODULE_1__loginService_js__["a" /* default */].init.call(_this2, _objectSpread(_objectSpread({}, res), {}, {
          sk: res.error ? null : res.sk
        })) : _this2.handleMfa(res);
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_1__loginService_js__["a" /* default */].handle(err);
      });
    },
    /**
     * Displays MFA screen
     */
    handleMfa: function handleMfa(data) {
      if (data.ChallengeName === mfaSetup) {
        __WEBPACK_IMPORTED_MODULE_1__loginService_js__["a" /* default */].init.call(this, data, false);
        this.$router.push('/mfa-setup');
      } else {
        this.mfaData.session = data.Session;
        this.mfaData.challengeName = data.ChallengeName;
        this.mfaData.challengeParameters = data.ChallengeParameters;
        this.$router.push({
          name: 'login',
          query: _objectSpread({
            mfa: null
          }, this.$route.query)
        });
      }
    },
    /**
     * Resends MFA code
     */
    resendMfaCode: function resendMfaCode() {
      // TODO
      this.api.post("".concat(this.api.$.login, "?mfaCodeResend"));
    },
    /**
     * Checks MFA
     * then proceed to authentication
     * */
    checkMfa: function checkMfa() {
      var _this3 = this;
      this.mfaData.code = this.mfaData.code.trim();
      this.api.post("".concat(this.api.$.mfa.validateCode), this.mfaData).then(function (resp) {
        resp.data.error ? _this3.handleBadCode(resp) : __WEBPACK_IMPORTED_MODULE_1__loginService_js__["a" /* default */].init.call(_this3, _objectSpread(_objectSpread({}, resp.data), {}, {
          sk: resp.data.error ? null : resp.data.sk
        }));
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_1__loginService_js__["a" /* default */].handle(err);
      });
    },
    /**
     * Check user authorization on landing in login
     * then redirect acordingly
     */
    loginAuth: function loginAuth() {
      __WEBPACK_IMPORTED_MODULE_1__loginService_js__["a" /* default */].auth.call(this);
    },
    /**
     * Autologin
     * with sk
     */
    autoLogin: function autoLogin(sk) {
      var _this4 = this;
      __WEBPACK_IMPORTED_MODULE_1__loginService_js__["a" /* default */].autoLogin.call(this, sk).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__loginService_js__["a" /* default */].init.call(_this4, res);
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_1__loginService_js__["a" /* default */].handle(err);
      });
    },
    /**
     * Forgot password
     */
    forgotPassword: function forgotPassword() {
      this.showForgotPassword = true;
      this.emailValidation = '';
    },
    /**
     * Send email for resetting password
     */
    submitForgotPassword: function submitForgotPassword() {
      var _this5 = this;
      if (this.validEmail(this.email)) {
        this.emailValidation = '';

        // call endpoint
        this.api.forms.post(this.api.$.settings.my.resetPassword, {
          email: this.email
        }).then(function (res) {
          res && res.data && _this5.passwordResetFeedback(res.data);
        });
        //
      } else {
        this.emailValidation = 'has-error';
      }
    },
    handleBadCode: function handleBadCode(r) {
      if (r.data.session !== this.mfaData.session) {
        this.mfaData.session = r.data.session;
      }
      global.alert(r.data.error || 'Something went wrong');
    },
    passwordResetFeedback: function passwordResetFeedback(message) {
      this.email = '';
      this.feedbackMessage = message;
      this.showForgotPassword = false;
      this.showFeedback = true;
    },
    cancel: function cancel() {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.$route.query.sk ? this.autoLogin(this.$route.query.sk) : this.loginAuth();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "ssMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"autocomplete":"off"}},[_c('div',{staticClass:"navless-layout-header"},[_vm._t("navbar",function(){return [_c('ed-button',{attrs:{"to":_vm.$routerHistory.previous().path}},[_c('i',{staticClass:"fal fa-chevron-left"}),_vm._v("\n         \n        Back\n      ")])]})],2),_vm._v(" "),_c('div',{attrs:{"slot":"body","endpoint":("evedpaycards/" + _vm.cardId + "/set-pin")},slot:"body"},[_c('div',{staticClass:"form"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"label-format"},[_c('label',{staticStyle:{"margin-left":"6px"}},[_vm._v("New 4-Digit Pin")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.pin),function(digit,index){return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin[index]),expression:"pin[index]"}],key:'pin-' + index,ref:'pinInputField' + index,refInFor:true,attrs:{"type":"password","pattern":"[0-9]*","inputmode":"numeric","maxlength":"1","autocomplete":"new-password"},domProps:{"value":(_vm.pin[index])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.pin, index, $event.target.value)},function($event){return _vm.sanitizeInput(index, _vm.pin)}],"keydown":function($event){return _vm.handleBackspace(index, _vm.pin, $event)}}})})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"label-format"},[_c('label',{staticStyle:{"margin-left":"6px"}},[_vm._v("Confirm New 4-Digit Pin")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.confirmPin),function(digit,index){return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPin[index]),expression:"confirmPin[index]"}],key:'confirm-pin-' + index,ref:'confirmInputField' + index,refInFor:true,attrs:{"type":"password","pattern":"[0-9]*","inputmode":"numeric","maxlength":"1","autocomplete":"new-password"},domProps:{"value":(_vm.confirmPin[index])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.confirmPin, index, $event.target.value)},function($event){return _vm.sanitizeInputConfirm(index, _vm.confirmPin)}],"keydown":function($event){return _vm.handleBackspaceConfirm(index, _vm.confirmPin, $event)}}})})],2),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('button',{staticClass:"btn btn-sm custom-button",attrs:{"type":"button"},on:{"click":_vm.changePin}},[_vm._v("UPDATE PIN")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('strong',[_vm._v("Change PIN")])]),_vm._v(" "),_c('p',{staticClass:"custom-description"},[_c('small',[_vm._v("Change your 4-digit pin code to be used for transactions on your EvedPay Card")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "stnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dawn-tab-nav-wrapper",class:{ "wide": _vm.wide }},[(_vm.bottomTabs)?_c('div',{staticClass:"dawn-tab-content"},[_vm._t("default")],2):_vm._e(),_c('div',{staticClass:"dawn-tab-nav",class:{ "wide": _vm.wide, "tabs": _vm.options }},[_c('div',{class:{ "container-fluid": _vm.wide || _vm.options, "text-center": _vm.steps }},[_c('ul',{class:{ "even-spaced": _vm.workflow, "wide container": _vm.wide }},_vm._l((_vm.tabList.length ? _vm.tabList : _vm.tabs),function(tab){return _c('li',{class:_vm.tabClass(tab),on:{"click":function($event){_vm.options ? "" : _vm.selectTab(tab)}}},[(tab.href)?_c('a',{attrs:{"href":_vm.steps ? "javascript:;" : tab.href}},[(tab.icon)?_c('span',{staticClass:"tab-icon-wrapper"},[_c('i',{class:[{ "complete": tab.isCompleted || _vm.steps }, tab.iconClass ]})]):_vm._e(),_c('span',{staticClass:"tab-title-wrapper"},[_vm._v(_vm._s(tab.title))])]):_vm._e(),(tab.to)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.clickTab(tab)}}},[(tab.icon)?_c('span',{staticClass:"tab-icon-wrapper"},[_c('i',{class:[{ "complete": tab.isCompleted || _vm.steps }, tab.iconClass ]})]):_vm._e(),_c('span',{staticClass:"tab-title-wrapper"},[_vm._v(_vm._s(tab.title))])]):_vm._e()])}),0)])]),(!_vm.bottomTabs)?_c('div',{staticClass:"dawn-tab-content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t2M6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("lxXX");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed5b5030_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("0YHh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed5b5030_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "t2nd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(allocations, selectedAllocations, isEditableRefId) {
    return {
      Id: '_',
      '*Name': {
        label: 'Category',
        width: 120,
        options: allocations,
        source: true,
        compose: allocationName,
        selectedOptions: selectedAllocations,
        trackBy: {
          optionTrackBy: 'Key',
          selectedOptionTrackBy: 'Id'
        },
        editable: true
      },
      AdditionalNo: {
        label: 'Ref ID',
        width: 90,
        editable: isEditableRefId,
        maxLength: 50
      },
      Percent: {
        label: 'Allocation Percent',
        width: 80,
        editable: true
      },
      Amount: {
        label: 'Allocation Amount',
        width: 80,
        f: 'data.Amount',
        validSum: {
          value: 0
        },
        editable: true
      }
    };
  }
});
function allocationName(params) {
  return params.data && params.data.Name ? params.data.Name : ' ';
}

/***/ }),

/***/ "tF4L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"InsuranceSuppliersGrid",attrs:{"model":_vm.SupplierModel,"endpoint":_vm.api.$.network.insuranceSuppliers,"default-view":_vm.defaultView,"name":"Manage Insurance","desc":"Check Supplier Certificates","search-placeholder":"Suppliers","fit-columns":"","checkboxes":false,"search":true,"resizing":false,"xviews":"false","footer":"","alias":"InsuranceSuppliersGrid-","export-uri":"InsuranceAvailableSuppliers/ExportList"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tGNh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceiptFolderPicker_vue__ = __webpack_require__("CvWt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_610dc927_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceiptFolderPicker_vue__ = __webpack_require__("69Xe");
function injectStyle (ssrContext) {
  __webpack_require__("Fp7m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-610dc927"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceiptFolderPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_610dc927_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceiptFolderPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tNhx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_I2P_components_TheToolbar__ = __webpack_require__("u9q6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_supplier_certificate_model__ = __webpack_require__("WXkV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var STATUS = {
  SUFFICIENT: 'Sufficient',
  INSUFFICIENT: 'Insufficient',
  N_A: 'N/A'
};
var DETAILS = {
  NO_AUTO: 'Automobile Insurance - The supplier certified that they do not require or involve the ownership, maintenance, or use of an auto.',
  NO_WORKER_COMPENSATION: 'Workers Compensation Insurance - The supplier certified that they do not have any additional employees and therefore are not required to carry Workers Compensation insurance.'
};
var certified = function certified(status) {
  return status ? ["certified", "<b>certified</b>"] : ["certified", "<b>has not certified</b>"];
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */],
    Toolbar: __WEBPACK_IMPORTED_MODULE_1__components_modules_I2P_components_TheToolbar__["a" /* default */]
  },
  computed: {
    subtitle: function subtitle() {
      return this.supplier.Name ? "".concat(this.supplier.Name, "  (").concat(this.supplier.EoNumber, ")") : '...';
    },
    showExpiration: function showExpiration() {
      return this.supplier.InsuranceStatus === STATUS.SUFFICIENT;
    },
    canVerify: function canVerify() {
      return ~this.insuranceStatuses.indexOf(this.supplier.InsuranceStatus);
    },
    hasError: function hasError() {
      return !!this.error;
    },
    insuranceDetails: function insuranceDetails() {
      return this.insuranceDetailsOptions; // .filter(o => o.status)
    }
  },
  data: function data() {
    return {
      certified: certified,
      SupplierCertificateModel: __WEBPACK_IMPORTED_MODULE_2__models_supplier_certificate_model__["a" /* default */],
      supplier: {
        Name: '',
        EoNumber: ''
      },
      insuranceDetailsOptions: [{
        label: DETAILS.NO_AUTO,
        status: null
      }, {
        label: DETAILS.NO_WORKER_COMPENSATION,
        status: null
      }],
      insuranceStatuses: [STATUS.SUFFICIENT, STATUS.INSUFFICIENT, STATUS.N_A],
      status: function status(detail) {
        return {
          type: detail.status === null ? 'info' : detail.status ? 'alt' : 'info'
          // icon: detail.status === null ? 'fas fa-circle' : detail.status ? 'fas fa-check' : 'fas fa-times-circle'
        };
      },
      error: ''
    };
  },
  created: function created() {
    var _this = this;
    this.api.get(this.api.$.network.insuranceSupplierDetails + '/' + this.$route.query.Id).then(function (r) {
      if (r.data) {
        _this.supplier = r.data;
        _this.insuranceDetailsOptions[0].status = r.data.DoesNotUseAuto;
        _this.insuranceDetailsOptions[1].status = r.data.HasNoEmployees;
      }
    });
  },
  mounted: function mounted() {
    this.notifyFullscreen(true);
  },
  beforeDestroy: function beforeDestroy() {
    this.notifyFullscreen(false);
  },
  methods: {
    save: function save() {
      var _this2 = this;
      if (!this.showExpiration) {
        this.supplier.ExpirationDate = null;
      } else if (!this.supplier.ExpirationDate) {
        this.error = 'The Expiration Date is required.';
        return;
      }
      this.error = '';
      this.api.post(this.api.$.network.insuranceSupplierDetails + '/' + this.$route.query.Id, {
        data: this.supplier
      }).then(function (r) {
        if (r.data) {
          _this2.$router.go(-1);
          _this2.$nextTick(function () {
            _this2.$notifications.notify({
              message: "Verification for ".concat(_this2.supplier.Name, " has been successfully recorded."),
              type: 'info',
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          });
        }
      });
    },
    notifyFullscreen: function notifyFullscreen(on) {
      try {
        window.parent.postMessage({
          type: 'legacy-fullscreen',
          on: !!on,
          source: 'insurance-view'
        }, '*');
      } catch (e) {}
    }
  }
});

/***/ }),

/***/ "tUBp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3WHSoisRDBpyNGGdVNx0BZ","Dell":"_3dvIBwhpSUGyuZeOECyPZ3","Abbott":"_2R-XZfE7cKl90xxpz2oCEE","Gap":"_3uuvZwuTSi1L6BK7kvhS39","Allstate":"YQr3KKl3RAzQY3sEs1vC1","Asurion":"_1v7cYpaIF5bsVp2-Dtbkr","Invitae":"GUk12PwVgn_NpEVSDhTB8","JWE":"_2c5ZQBC_LzgVEIGFXrP8qR"};

/***/ }),

/***/ "taVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  InvoiceIsSaved: false,
  IsDraft: true,
  ProgramID: 0,
  ProgramName: '',
  ProgramCurrencyCode: 'USD',
  POid: 0,
  PONumber: '',
  POCreatedDate: null,
  SupplierId: 0,
  SupplierName: '',
  SupplierUserId: 0,
  MyVendorTempEONumber: 0,
  Supplier: {
    VendorID: 0,
    VendorUserID: 0
  },
  InvoiceDate: null,
  DueDate: null,
  PaymentTypeID: 0,
  PaymentType: '',
  CurrencyID: 0,
  CurrencyCode: '',
  CurrencyName: '',
  Attachments: [],
  User: {
    token: ''
  },
  ReferenceNo: '',
  HasRushPayment: false,
  IsSameDayDeposit: false,
  IsReimbursement: false,
  RushPaymentReason: '',
  Errors: {
    ProgramMissing: false,
    // SPRT-18874: set from GetProgramDetails when the selected program is cancelled, so the program
    // field flags it on selection and validate() refuses the save/submit.
    ProgramCancelled: false,
    SupplierMissing: false,
    SupplierZipCodeMissing: false,
    PaymentTypeMissing: false,
    InvoiceDateMissing: false,
    DueDateMissing: false,
    InvoiceDateIncomplete: false,
    DueDateIncomplete: false,
    AttachmentsMissing: false,
    InvoiceCurrencyMissing: false,
    InvoiceAmountMissing: false,
    InvoiceAmountOutOfRange: false,
    InvoiceAmountNegative: false,
    InitialTotalAmountMissing: false,
    POMissing: false,
    ReferenceNoMissing: false,
    AllocationTypeMissing: false,
    AllocationMissing: false,
    InvoiceAmountExceededPOThreshold: false,
    isEditInit: false
  },
  HasAllocationSection: false,
  IsAllocationSelected: false,
  HasAllocationForScan: false,
  InvoiceAmount: '',
  VATGSTAmount: '',
  InvoiceWorkflow: '',
  UseSavingsFields: false,
  InitialTotalAmount: 0,
  CreatedByInfo: {
    Name: '',
    Email: '',
    Phone: ''
  },
  DiscountPaymentTermID: 0,
  DiscountName: '',
  ApproveNote: ''
});

/***/ }),

/***/ "tdUP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_back_vue__ = __webpack_require__("ud1c");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c31eb2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_vue__ = __webpack_require__("OkuY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_back_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c31eb2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tfQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__("NM/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__ = __webpack_require__("Oy1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_js__ = __webpack_require__("Hn6R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_Programs_Card_transactions_tabs__ = __webpack_require__("+C3y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateEnvelope_vue__ = __webpack_require__("coox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReconcileTransaction_vue__ = __webpack_require__("Yqmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CandidateSelector_vue__ = __webpack_require__("jTz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_api_receiptScans__ = __webpack_require__("X3jq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_receiptScan_receiptScanPoller__ = __webpack_require__("N9pM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__core_receiptScan_imageCompression__ = __webpack_require__("D1Zk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__core_feature_flags_feature_flags__ = __webpack_require__("Sg6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__core_events_events__);




function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var cancelTooltip = 'Please select a transaction.';

// reload page after browser back pressed
function handlePopState(event) {
  if (document.location.href.includes('transactions')) {
    window.location.reload();
  }
}
window.addEventListener('popstate', handlePopState);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_5__components_Grid__["a" /* default */],
    CreateEnvelope: __WEBPACK_IMPORTED_MODULE_8__CreateEnvelope_vue__["a" /* default */],
    Reconcile: __WEBPACK_IMPORTED_MODULE_9__ReconcileTransaction_vue__["a" /* default */],
    CandidateSelector: __WEBPACK_IMPORTED_MODULE_10__CandidateSelector_vue__["a" /* default */]
  },
  data: function data() {
    var _this = this;
    return {
      model: __WEBPACK_IMPORTED_MODULE_6__model_js__["a" /* default */],
      sort: {
        TransactionDateFormatted: 'desc'
      },
      tabs: __WEBPACK_IMPORTED_MODULE_7__components_modules_Programs_Card_transactions_tabs__["a" /* default */].tabs,
      selectedProgram: 0,
      selectedSupplier: 0,
      selectedRows: [],
      selectedAll: null,
      showCreateEnvelope: false,
      showReconcile: false,
      fields: [],
      formKey: '',
      splitAmounts: [],
      noteText: '',
      mediaFilesPath: '',
      filteredAttachments: [],
      // PRODUCTDEV-5772 — supporting documents, kept separate from filteredAttachments
      // (receipts) so they never feed IsComplete / ReceiptFiles / Reconciliation Status.
      additionalDocumentsFiles: [],
      requireReceiptDescription: Boolean,
      descriptionIncomplete: false,
      receiptIncomplete: false,
      savePressed: false,
      reconcileAction: 'create',
      selectedBu: [],
      selectedCc: [],
      selectedBuAndCcPair: [],
      selectedCategory: [],
      referenceId: [],
      descriptions: [],
      splitCounter: 1,
      buAndCcPairIncomplete: [],
      buIncomplete: [],
      ccIncomplete: [],
      categoryIncomplete: [],
      itemIds: [],
      transaction: {},
      approvalUsersData: [],
      highlightedTransactionId: '',
      rowClasses: {
        'row-highlight': function rowHighlight(params) {
          return params.data && (params.data.Id === _this.highlightedTransactionId || params.data.EnvelopeId === _this.highlightedTransactionId);
        }
      },
      envelope: {},
      noTooltipFields: ['TransactionStatus', 'ReconciliationStatus', 'TransactionNumber', 'EnvelopeNumber'],
      waitingApprovalStatuses: ['Open - Waiting Approval', 'Exported - Waiting Approval', 'Posted - Waiting Approval'],
      uploadFinished: true,
      editAuth: null,
      receiptScanEnabled: __WEBPACK_IMPORTED_MODULE_14__core_feature_flags_feature_flags__["a" /* default */].receiptScanPrefill,
      // PRODUCTDEV-5788 — global all-transactions table has no single division in context,
      // so the Submit Receipt button shows iff >=1 of the user's divisions is scan-enabled
      // (tenant-wide any-enabled check). Default false so it stays hidden until the check
      // confirms; never shows when every division is "No Receipt Capture".
      anyScanEnabled: false,
      uploadingReceipt: false,
      uploadProgressPct: 0,
      showSubmitReceiptModal: false,
      pendingReceiptFile: null,
      // PRODUCTDEV-5804 — object URL for the pending file so the chip link carries a real href
      // (right-click "Open in new tab"). Lifecycle owned by the pendingReceiptFile watcher.
      pendingReceiptObjectUrl: '',
      showCandidateSelector: false,
      candidateSelectorReceiptId: null,
      candidateSelectorCandidates: [],
      candidateSelectorRowVersion: null,
      candidateSelectorAutoLinked: false,
      candidateSelectorAutoFill: null,
      candidateSelectorLoading: false,
      candidateSelectorMatching: false,
      candidateSelectorLocalImageUrl: null,
      candidateSelectorLocalImageType: null,
      pendingLegacyReceipt: null,
      activePoller: null
    };
  },
  created: function created() {
    var _this2 = this;
    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.divisionName = _this2.singularize(_this2.$root.getUser.settings.Labels.DivisionName);
            _this2.divisionsName = _this2.$root.getUser.settings.Labels.DivisionsName;
            _this2.model.Division.label = _this2.divisionName;
            _this2.programName = _this2.singularize(_this2.$root.getUser.settings.Labels.ProgramLabel);
            _this2.model.ProgramName.label = _this2.programName;
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_16__core_events_events___default.a.EVEDPAY_CARDS.OPEN_RECONCILE);
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_16__core_events_events___default.a.EVEDPAY_CARDS.OPEN_RECONCILE, _this2.handleTransaction);
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$off('receipt-scan-started');
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$on('receipt-scan-started', function (payload) {
              _this2.handleReceiptScanStarted(payload.data);
            });
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$off(__WEBPACK_IMPORTED_MODULE_16__core_events_events___default.a.EVEDPAY_CARDS.OPEN_ENVELOPE);
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_16__core_events_events___default.a.EVEDPAY_CARDS.OPEN_ENVELOPE, function (envelope) {
              _this2.envelope = envelope.data;
              _this2.showCreateEnvelope = true;
            });

            // PRODUCTDEV-5788 — resolve once whether any of the user's divisions is scan-enabled;
            // drives the global Submit Receipt button's visibility. Default-false on any failure.
            // Deferred to $nextTick: on a hard refresh created() runs during app bootstrap, before
            // App.vue's `global.app = new Vue(...)` is assigned, so the httpPlatform request
            // interceptor can't attach the bearer yet and the call would fire anonymously (401).
            // By the next tick bootstrap has finished and global.app is set, so the request goes out
            // authenticated and the button resolves correctly instead of being wrongly hidden.
            if (_this2.receiptScanEnabled) {
              _this2.$nextTick(function () {
                __WEBPACK_IMPORTED_MODULE_11__core_api_receiptScans__["b" /* default */].getAnyScanEnabled().then(function (res) {
                  _this2.anyScanEnabled = !!(res && res.anyEnabled);
                }).catch(function (e) {
                  console.warn('Could not fetch any-scan-enabled (Submit Receipt hidden):', e);
                  _this2.anyScanEnabled = false;
                });
              });
            }
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$off('transaction-reconciled');
            __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$on('transaction-reconciled', function (transactionId) {
              if (_this2.transaction && _this2.transaction.data) {
                var matchedTransaction = _this2.transaction.data.Id === transactionId.data;
                if (matchedTransaction) {
                  var transactionNumber = _this2.transaction.data.TransactionNumber;
                  _this2.$notifications.notify({
                    message: "Transaction ".concat(transactionNumber, " was updated!"),
                    type: 'info',
                    placement: {
                      from: 'top',
                      align: 'center'
                    }
                  });
                }
              }
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    // PRODUCTDEV-5804 — icon glyph + color for the pending receipt chip (ed-upload palette).
    pendingReceiptIcon: function pendingReceiptIcon() {
      var name = (this.pendingReceiptFile && this.pendingReceiptFile.name || '').toLowerCase();
      if (/\.pdf$/.test(name)) return {
        iconClass: 'fa-file-pdf',
        color: '#cb0404'
      };
      if (/\.(png|jpe?g|gif|webp)$/.test(name)) return {
        iconClass: 'fa-file-image',
        color: '#4598d9'
      };
      return {
        iconClass: 'fa-file',
        color: '#acacac'
      };
    },
    selectedId: function selectedId() {
      return this.transaction && this.transaction.data && this.transaction.data.PaymentInvoiceID;
    },
    isUserAdmin: function isUserAdmin() {
      if (this.$user.$.userPermissions.includes('EvedPayCardAdministrator')) {
        return true;
      }
      return false;
    },
    // PRODUCTDEV-5574 — preserves the pre-existing receipt-upload rules: enabled for global admins;
    // for everyone else only when reconcileAction would have been edit/create under the OLD logic
    // (current approver, Draft envelope, or transaction not in an envelope readonly status and not
    // already Approved). Independent of the broader edit auth used for description/coding.
    receiptEditAllowed: function receiptEditAllowed() {
      if (this.isUserAdmin) return true;
      var t = this.transaction && this.transaction.data;
      if (!t || !t.TransactionStatus) return false;
      var inEnvelopeReadonly = ['In Envelope', 'Exported', 'Posted'].includes(t.TransactionStatus);
      if (!inEnvelopeReadonly) return t.ReconciliationStatus !== 'Approved';
      if (t.EnvelopeStatus === 'Draft') return true;
      if (t.ReconciliationStatus === 'Approved') return false;
      return this.isUserInApprovalList();
    }
  },
  activated: function activated() {
    this.selectedRows = [];
    this.envelope = {};
  },
  watch: {
    // PRODUCTDEV-5804 — own the pending file's object URL lifecycle (revoke old, create new) so the
    // chip link has a stable href. Covers every assignment site to pendingReceiptFile.
    pendingReceiptFile: function pendingReceiptFile(file) {
      if (this.pendingReceiptObjectUrl) {
        URL.revokeObjectURL(this.pendingReceiptObjectUrl);
        this.pendingReceiptObjectUrl = '';
      }
      if (file) this.pendingReceiptObjectUrl = URL.createObjectURL(file);
    },
    showCreateEnvelope: function showCreateEnvelope(newValue) {
      if (newValue) {
        this.highlightedTransactionId = this.envelope.Id;
      }
    },
    showCandidateSelector: function showCandidateSelector(newVal) {
      if (!newVal && this.candidateSelectorLocalImageUrl) {
        URL.revokeObjectURL(this.candidateSelectorLocalImageUrl);
        this.candidateSelectorLocalImageUrl = null;
        this.candidateSelectorLocalImageType = null;
      }
    }
  },
  methods: {
    stopSave: function stopSave() {
      this.savePressed = false;
    },
    createReconcile: function createReconcile() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var hasIncompleteField, i, formCopy, updatedFields, form, padArray, rowCount, paddedSelectedBu, paddedSelectedCc, paddedSelectedBuAndCcPair, paddedSelectedCategory, paddedReferenceId, paddedDescriptions, paddedSplitAmounts, EMPTY_GUID, paddedItemIds, response, blockedReason, message;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              hasIncompleteField = false;
              if (!(_this3.selectedProgram && Object.keys(_this3.selectedProgram).length !== 0 && _this3.selectedProgram.Id)) {
                hasIncompleteField = true;
              }
              if ((!_this3.noteText || _this3.noteText && _this3.noteText.length === 0) && _this3.requireReceiptDescription && _this3.filteredAttachments.length !== 0) {
                _this3.descriptionIncomplete = true;
                hasIncompleteField = true;
              } else {
                _this3.descriptionIncomplete = false;
              }
              if (_this3.filteredAttachments.length === 0) {
                hasIncompleteField = true;
              }
              if (!(_this3.transaction.data.EnvelopeId && _this3.transaction.data.EnvelopeId !== '00000000-0000-0000-0000-000000000000' && _this3.filteredAttachments.length === 0 && _this3.transaction.data.EnvelopeStatus !== 'Draft')) {
                _context2.next = 7;
                break;
              }
              _this3.$notifications.notify({
                type: 'info-warn',
                message: 'Receipt is required. Please upload at least one file.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              return _context2.abrupt("return", _this3.stopSave());
            case 7:
              _this3.buAndCcPairIncomplete = new Array(_this3.splitCounter).fill(false);
              _this3.buIncomplete = new Array(_this3.splitCounter).fill(false);
              _this3.ccIncomplete = new Array(_this3.splitCounter).fill(false);
              _this3.categoryIncomplete = new Array(_this3.splitCounter).fill(false);
              for (i = 0; i < _this3.splitCounter; i++) {
                if (_this3.selectedBuAndCcPair) {
                  _this3.buAndCcPairIncomplete[i] = !_this3.selectedBuAndCcPair[i];
                } else if (_this3.selectedBu && _this3.selectedCc) {
                  _this3.buIncomplete[i] = !_this3.selectedBu[i];
                  _this3.ccIncomplete[i] = !_this3.selectedCc[i];
                } else if (_this3.selectedBu && !_this3.selectedCc) {
                  _this3.buIncomplete[i] = !_this3.selectedBu[i];
                } else if (!_this3.selectedBu && _this3.selectedCc) {
                  _this3.ccIncomplete[i] = !_this3.selectedCc[i];
                }
                if (_this3.buAndCcPairIncomplete[i] || _this3.buIncomplete[i] || _this3.ccIncomplete[i]) {
                  hasIncompleteField = true;
                }
                if (!(_this3.selectedCategory && _this3.selectedCategory[i])) {
                  hasIncompleteField = true;
                }

                // check incomplete custom fields
                if (_this3.fields.some(function (item) {
                  return item.some(function (field) {
                    return field && field.Required && (!field.Values || field.Values.length === 0);
                  });
                })) {
                  hasIncompleteField = true;
                }
              }
              if (!_this3.descriptionIncomplete) {
                _context2.next = 14;
                break;
              }
              return _context2.abrupt("return", _this3.stopSave());
            case 14:
              _context2.prev = 14;
              formCopy = JSON.parse(JSON.stringify(_this3.fields));
              updatedFields = formCopy.map(function (i) {
                return i.map(function (x) {
                  if (x.Type === 'select' && x.Values && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(x.Values) === 'object') {
                    x.Values = x.Values.text;
                  } else if (x.Type === 'text' && x.Values && Array.isArray(x.Values) && x.Values.length > 0) {
                    x.Values = x.Values[0];
                  }
                  return x;
                });
              });
              form = {
                Fields: updatedFields,
                CategoryIds: _this3.selectedCategory,
                ReferenceIds: _this3.referenceId,
                Descriptions: _this3.descriptions,
                BusinessUnitIds: _this3.selectedBu,
                CostCenterIds: _this3.selectedCc,
                ProgramBusinessUnitAndCostCenterIds: _this3.selectedBuAndCcPair,
                Amounts: _this3.splitAmounts,
                TransactionReconcileSplitItemIds: _this3.itemIds
              };
              if (!_this3.selectedCardId) {
                _context2.next = 49;
                break;
              }
              // Defensive padding — every per-row array must have splitCounter entries or
              // Legacy's SaveTransactionFields (EvedPayCardsRepository.cs:3848) throws
              // IndexOutOfRange when it iterates Amounts.Count and accesses parallel arrays.
              // Photon-driven splits can outpace the emit chain that syncs these arrays back
              // up, leaving shorter-than-expected lengths at save time — especially on a
              // fresh SUBMIT-match reconcile where the rows come from prefill and never
              // had server-side ItemIds assigned. Mirrors Card-list/index.vue:1818-1862.
              padArray = function padArray(arr, len, fill) {
                var out = Array.isArray(arr) ? arr.slice() : [];
                while (out.length < len) {
                  out.push(fill === undefined ? null : fill);
                }
                return out;
              };
              rowCount = _this3.splitCounter || 1;
              paddedSelectedBu = padArray(_this3.selectedBu, rowCount);
              paddedSelectedCc = padArray(_this3.selectedCc, rowCount);
              paddedSelectedBuAndCcPair = padArray(_this3.selectedBuAndCcPair, rowCount);
              paddedSelectedCategory = padArray(_this3.selectedCategory, rowCount);
              paddedReferenceId = padArray(_this3.referenceId, rowCount);
              paddedDescriptions = padArray(_this3.descriptions, rowCount, '');
              paddedSplitAmounts = padArray(_this3.splitAmounts, rowCount, 0);
              EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
              paddedItemIds = padArray(_this3.itemIds, rowCount, EMPTY_GUID).map(function (id) {
                return id == null || id === '' ? EMPTY_GUID : id;
              });
              form.BusinessUnitIds = paddedSelectedBu;
              form.CostCenterIds = paddedSelectedCc;
              form.ProgramBusinessUnitAndCostCenterIds = paddedSelectedBuAndCcPair;
              form.CategoryIds = paddedSelectedCategory;
              form.ReferenceIds = paddedReferenceId;
              form.Descriptions = paddedDescriptions;
              form.Amounts = paddedSplitAmounts;
              form.TransactionReconcileSplitItemIds = paddedItemIds;
              _context2.next = 40;
              return _this3.api.post(_this3.api.$.evedpaycard.reconcile, _objectSpread(_objectSpread({
                preventError: true
              }, _this3.newReconcile), {}, {
                CardId: _this3.selectedCardId,
                TransactionId: _this3.selectedTransactionId,
                SupplierId: _this3.selectedSupplier && _this3.selectedSupplier.Value ? _this3.selectedSupplier.Value.VendorId : null,
                ProgramId: _this3.selectedProgram && _this3.selectedProgram.Id ? _this3.selectedProgram.Id : null,
                ReceiptFiles: _this3.filteredAttachments,
                AdditionalDocuments: _this3.additionalDocumentsFiles,
                Note: _this3.noteText,
                SplitAmounts: paddedSplitAmounts,
                BusinessUnitIds: paddedSelectedBu,
                CostCenterIds: paddedSelectedCc,
                BusinessUnitAndCostCenterIds: paddedSelectedBuAndCcPair,
                CategoryIds: paddedSelectedCategory,
                ReferenceIds: paddedReferenceId,
                Descriptions: paddedDescriptions,
                IsComplete: !hasIncompleteField,
                Form: form,
                FormKey: _this3.formKey
              }));
            case 40:
              response = _context2.sent;
              if (!response.data) {
                _context2.next = 45;
                break;
              }
              return _context2.abrupt("return", true);
            case 45:
              console.error('Error during the request. Response data is null.');
              _this3.notifyReconcileError('An error occurred while saving. Please try again.');
            case 47:
              _context2.next = 51;
              break;
            case 49:
              console.error('Selected CardId is null or undefined.');
              _this3.notifyReconcileError('An error occurred while saving. Please try again.');
            case 51:
              _context2.next = 60;
              break;
            case 53:
              _context2.prev = 53;
              _context2.t0 = _context2["catch"](14);
              console.error('Error during the request:', _context2.t0);
              blockedReason = _context2.t0 && _context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.reason;
              message = _this3.envelopeEditBlockedMessage(blockedReason) || 'An error occurred while saving. Please try again.';
              _this3.$notifications.notify({
                type: 'plain',
                icon: 'exclamation-circle',
                placement: {
                  from: 'top',
                  align: 'center'
                },
                timeout: 0,
                message: message,
                discard: 'Ok',
                goto: ''
              });
              // Signal save failure to callers (e.g. `confirm()` in transactiondetails.vue checks `hasErrors`
              // before navigating back). Without this, a 403 looks like a successful save to the user.
              _this3.stopSave();
            case 60:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[14, 53]]);
      }))();
    },
    envelopeEditBlockedMessage: function envelopeEditBlockedMessage(reason) {
      switch (reason) {
        case 'EnvelopePostedOrExported':
          return 'This envelope has been posted or exported. Transactions in it can no longer be edited.';
        case 'NotAuthorized':
          return 'You do not have permission to edit this transaction.';
        case 'ProgramChangeNotAllowed':
          return "The ".concat((this.programName || 'department').toLowerCase(), " cannot be changed while the transaction is assigned to an envelope.");
        case 'EnvelopeNotFound':
        case 'TransactionNotFound':
          return 'We could not verify this transaction\'s envelope. Please refresh and try again.';
        default:
          return null;
      }
    },
    notifyReconcileError: function notifyReconcileError(message) {
      this.$notifications.notify({
        type: 'plain',
        icon: 'exclamation-circle',
        placement: {
          from: 'top',
          align: 'center'
        },
        timeout: 0,
        message: message,
        discard: 'Ok',
        goto: ''
      });
    },
    createEnvelope: function createEnvelope() {
      this.showCreateEnvelope = true;
      window.history.pushState({}, '', '#/d/Programs/>Card/envelopes');
    },
    resetValidation: function resetValidation() {
      this.receiptIncomplete = false;
      this.descriptionIncomplete = false;
      this.buAndCcPairIncomplete = new Array(this.splitCounter).fill(false);
      this.buIncomplete = new Array(this.splitCounter).fill(false);
      this.ccIncomplete = new Array(this.splitCounter).fill(false);
      this.categoryIncomplete = new Array(this.splitCounter).fill(false);
    },
    saveAndReconcile: function saveAndReconcile() {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var r;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (_this4.savePressed) {
                _context3.next = 15;
                break;
              }
              _this4.savePressed = true;
              _context3.prev = 2;
              if (!(_this4.reconcileAction === 'view')) {
                _context3.next = 8;
                break;
              }
              if (!_this4.isUserAdmin) {
                _context3.next = 7;
                break;
              }
              _context3.next = 7;
              return _this4.updateReceiptAndDocuments();
            case 7:
              return _context3.abrupt("return", _this4.stopSave());
            case 8:
              _context3.next = 10;
              return _this4.createReconcile();
            case 10:
              r = _context3.sent;
              if (r) {
                __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$emit('transaction-reconciled', _this4.transaction.data.Id);
                _this4.savePressed = false;
                _this4.closeReconcile({
                  userCancelled: false
                });
                _this4.resetModalFields();
              }
            case 12:
              _context3.prev = 12;
              _this4.savePressed = false;
              return _context3.finish(12);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2,, 12, 15]]);
      }))();
    },
    // PRODUCTDEV-5790 — receipt/document-only save for a card admin on a view-locked
    // (submitted-envelope) transaction. Persists via the narrow update-receipt endpoint so
    // coding is never touched. Sends the FULL desired document set: the backend keeps docs by
    // Id and soft-deletes any existing doc not in the list, so this is how an admin's add/remove
    // is applied. (additionalDocumentsFiles is populated from the modal on open, so an untouched
    // doc set round-trips unchanged.)
    updateReceiptAndDocuments: function updateReceiptAndDocuments() {
      var _this5 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var mapFile, payload;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(_this5.filteredAttachments.length === 0)) {
                _context4.next = 3;
                break;
              }
              _this5.$notifications.notify({
                type: 'info-warn',
                message: 'Receipt is required. Please upload at least one file.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              return _context4.abrupt("return");
            case 3:
              mapFile = function mapFile(f) {
                return {
                  id: f.Id || '00000000-0000-0000-0000-000000000000',
                  pathWithName: f.PathWithName,
                  originalName: f.OriginalName,
                  mediaFile: f.MediaFile,
                  sizeBytes: f.SizeBytes,
                  vendorId: f.VendorId
                };
              };
              payload = {
                transactionId: _this5.selectedTransactionId,
                receiptFiles: _this5.filteredAttachments.map(mapFile),
                additionalDocuments: _this5.additionalDocumentsFiles.map(mapFile)
              };
              _context4.prev = 5;
              _context4.next = 8;
              return _this5.api.post(_this5.api.$.evedpaycard.updateReceipt, payload);
            case 8:
              __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$emit('transaction-reconciled', _this5.transaction.data.Id);
              _this5.$notifications.notify({
                type: 'info',
                message: 'Receipt updated successfully',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              _this5.closeReconcile({
                userCancelled: false
              });
              _this5.resetModalFields();
              _context4.next = 18;
              break;
            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](5);
              console.error('Error while updating the receipt:', _context4.t0);
              _this5.notifyReconcileError('An error occurred while saving. Please try again.');
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[5, 14]]);
      }))();
    },
    updateMediaFilesPath: function updateMediaFilesPath(mediaFilesPath) {
      this.mediaFilesPath = mediaFilesPath;
      this.receiptIncomplete = false;
    },
    updateAttachmentsFiles: function updateAttachmentsFiles(filteredAttachments) {
      this.filteredAttachments = filteredAttachments;
    },
    // PRODUCTDEV-5772 — supporting documents from the reconcile modal. Stored apart
    // from filteredAttachments and posted as AdditionalDocuments; never part of
    // ReceiptFiles / IsComplete / Reconciliation Status.
    updateAdditionalDocuments: function updateAdditionalDocuments(additionalDocuments) {
      this.additionalDocumentsFiles = additionalDocuments;
    },
    handleFieldsUpdated: function handleFieldsUpdated(form) {
      this.fields = form.fields;
      this.formKey = form.formKey;
    },
    handleSplitAmounts: function handleSplitAmounts(data) {
      this.splitAmounts = data;
    },
    handleDescriptionText: function handleDescriptionText(data) {
      this.noteText = data.noteText;
      this.requireReceiptDescription = data.requireReceiptDescription;
    },
    handleReconcileCreated: function handleReconcileCreated(data) {
      this.fields = data.fields ? data.fields : this.fields;
      this.itemIds = data.itemIds;
      this.splitCounter = data.splitCounter;
      this.selectedSupplier = data.selectedSupplier;
      this.selectedProgram = data.selectedProgram;
      this.selectedBu = data.selectedBu;
      this.selectedCc = data.selectedCc;
      this.selectedBuAndCcPair = data.selectedBuAndCcPair;
      this.selectedCategory = data.selectedCategory;
      this.referenceId = data.referenceId;
      this.descriptions = data.descriptions;
    },
    handleUploadFinished: function handleUploadFinished(finished) {
      this.uploadFinished = finished;
    },
    singularize: function singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value;
    },
    cardActionDisabled: function cardActionDisabled(actionName) {
      return !!this.actionDisabledReason(actionName);
    },
    actionDisabledReason: function actionDisabledReason(actionName) {
      if (this.selectedRows.length > 1 && actionName === 'reconcile') {
        return 'You can only reconcile one transaction at a time.';
      }
      if (this.selectedRows.length > 0) {
        var firstCardId = this.selectedRows[0].data.CardId;
        var programIds = Array.from(new Set(this.selectedRows.map(function (row) {
          return row && row.data.ProgramId !== null ? row.data.ProgramId : null;
        }).filter(function (id) {
          return id !== null;
        })));
        if (programIds.length > 1 && actionName === 'createEnvelope') {
          return "Only transactions from the same ".concat(this.programName.toLowerCase(), " that are not already part of an envelope can be selected.");
        }
        var _iterator = _createForOfIteratorHelper(this.selectedRows),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var row = _step.value;
            if (row.data.TransactionStatus === 'Rejected' || row.data.TransactionStatus === 'Declined') {
              return 'Only transactions that are not Rejected or Declined can be selected.';
            }
            if (row.data.TransactionStatus === 'Pending' && actionName !== 'reconcile') {
              return 'Only transactions that are not Pending or Declined can be selected.';
            }
            if (row.data.EnvelopeNumber !== null && actionName === 'createEnvelope') {
              return 'Only transactions that are not already part of an envelope can be selected.';
            }
            if (row.data.CardId !== firstCardId) {
              return 'Only transactions from the same card that are not already part of an envelope can be selected.';
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (this.selectedRows.length === 0) {
        return cancelTooltip;
      }
    },
    rowSelected: function rowSelected(event) {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(typeof event === 'boolean')) {
                _context5.next = 4;
                break;
              }
              _this6.selectedAll = event;
              _context5.next = 8;
              break;
            case 4:
              _this6.selectedRows = event;
              if (_this6.highlightedTransactionId && _this6.highlightedTransactionId.length > 0 && !_this6.showReconcile && _this6.selectedRows.length > 0) {
                _this6.highlightedTransactionId = '';
                _this6.redrawRows();
              }
              _context5.next = 8;
              return _this6.applyTransactionContext(_this6.selectedRows[0]);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // PRODUCTDEV-5574 — shared transaction-context setup for every entry point that switches the
    // active transaction (row checkbox + toolbar Reconcile, transaction-number link, etc.). Resets
    // editAuth before fetching so the previous transaction's permissions can't leak into the new
    // row, and re-fetches editAuth whenever the new transaction is in an envelope so the toolbar
    // path also reaches the in-envelope edit gate instead of falling back to view-only.
    applyTransactionContext: function applyTransactionContext(transaction) {
      var _this7 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.transaction = transaction;
              _this7.editAuth = null;
              if (!(_this7.transaction && _this7.transaction.data)) {
                _context6.next = 16;
                break;
              }
              _this7.selectedCardId = _this7.transaction.data.CardId;
              _this7.selectedTransactionId = _this7.transaction.data.Id;
              if (!(_this7.transaction.data.EnvelopeId && _this7.transaction.data.EnvelopeId !== '00000000-0000-0000-0000-000000000000')) {
                _context6.next = 8;
                break;
              }
              _context6.next = 8;
              return _this7.fetchEditAuth(_this7.transaction.data.Id);
            case 8:
              // PRODUCTDEV-5783 — reset before the conditional reload so isUserInApprovalList()
              // reflects THIS transaction's envelope. getApprovalUsers only runs for waiting-approval
              // envelopes, so without this a previously-opened approver envelope's data could leak
              // through and wrongly grant 'edit' on a submitted (read-only) transaction.
              _this7.approvalUsersData = [];
              if (!_this7.waitingApprovalStatuses.includes(_this7.transaction.data.EnvelopeStatus)) {
                _context6.next = 12;
                break;
              }
              _context6.next = 12;
              return _this7.getApprovalUsers(_this7.transaction.data.EnvelopeId);
            case 12:
              _context6.next = 14;
              return _this7.handleReconcileAction(_this7.transaction);
            case 14:
              _context6.next = 17;
              break;
            case 16:
              _this7.reconcileAction = 'create';
            case 17:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    createReconciliationEnvelope: function createReconciliationEnvelope() {
      if (this.selectedRows.length === 0) {
        console.error('No data');
        return;
      }
    },
    showModal: function showModal(showReconcile) {
      if (!this.savePressed) {
        this.showReconcile = !showReconcile;
        if (this.showReconcile) {
          this.highlightedTransactionId = this.transaction.data.Id;
        } else {
          this.redrawRows();
        }
        this.resetModalFields();
      }
    },
    resetFields: function resetFields() {
      this.savePressed = false;
      this.selectedProgram = '';
      this.selectedSupplier = '';
      this.noteText = '';
      this.mediaFilesPath = '';
      this.filteredAttachments = [];
      this.additionalDocumentsFiles = [];
      this.fields = [];
      this.formKey = '';
    },
    resetModalFields: function resetModalFields() {
      if (this.showReconcile) {
        if (this.$refs.reconcileComp) {
          this.$refs.reconcileComp.$refs.formRef.reset();
          this.resetValidation();
          this.resetFields();
        }
      } else {
        this.$refs.grid.onSelectAll(false);
        this.selectedRows = [];
        this.transaction = {};
        this.approvalUsersData = [];
        this.$refs.reconcileComp.$refs.formRef.reset();
        this.resetValidation();
        this.resetFields();
      }
    },
    closeReconcile: function closeReconcile(opts) {
      // userCancelled defaults to true so existing X/cancel callers behave unchanged;
      // saveAndReconcile passes userCancelled:false so cleanupUnsavedReceipts doesn't
      // delete the ReceiptScan that was just linked. Everything else still runs —
      // the modal closes / state resets either way.
      var userCancelled = !opts || opts.userCancelled !== false;
      if (userCancelled) {
        if (this.$refs.reconcileComp && typeof this.$refs.reconcileComp.cleanupUnsavedReceipts === 'function') {
          // Soft-delete any Platform receipt-scans uploaded in this session before tearing
          // down the modal — fire-and-forget so close stays responsive.
          this.$refs.reconcileComp.cleanupUnsavedReceipts();
        }
      } else if (this.$refs.reconcileComp && typeof this.$refs.reconcileComp.claimPendingFolderReceipts === 'function') {
        // PRODUCTDEV-5783 — reconcile saved: claim any receipt picked from the folder this
        // session (deferred FolderSaved → Matched) so it leaves the folder only on save.
        this.$refs.reconcileComp.claimPendingFolderReceipts();
      }
      this.showReconcile = false;
      this.selectedRows = [];
      this.transaction = {};
      this.approvalUsersData = [];
      // PRODUCTDEV-5802 — the reconcile child is destroyed with the modal, so an
      // upload in flight at close time can never emit uploadFinished(true). Reset
      // here or the NEXT reconcile opens with Save permanently disabled.
      this.uploadFinished = true;
      this.refresh();
      this.resetValidation();
      this.resetFields();
      // Strip receiptScanId from URL so a later reconcile opened from the
      // grid doesn't accidentally re-apply the just-matched scan's prefill.
      if (this.$route.query.receiptScanId) {
        var cleaned = _objectSpread({}, this.$route.query);
        delete cleaned.receiptScanId;
        this.$router.replace({
          query: cleaned
        }).catch(function () {});
      }
    },
    handleTransaction: function handleTransaction(transaction) {
      var _this8 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this8.applyTransactionContext(transaction);
            case 2:
              _this8.showReconcile = true;
              _this8.highlightedTransactionId = _this8.transaction.data.Id;
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    handleReconcileAction: function handleReconcileAction(transaction) {
      var _this9 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee8() {
        var readonlyStatuses, isInEnvelopeByTxStatus;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              readonlyStatuses = ['In Envelope', 'Exported', 'Posted'];
              isInEnvelopeByTxStatus = readonlyStatuses.includes(transaction.data.TransactionStatus);
              if (transaction.data.ReconciliationStatus !== 'Open') {
                if (transaction.data.ReconciliationStatus === 'Coded') {
                  if (transaction.data.EnvelopeStatus === 'Draft') {
                    _this9.reconcileAction = 'edit';
                  } else if (!isInEnvelopeByTxStatus || _this9.canEditInEnvelopeFromReconcileModal()) {
                    _this9.reconcileAction = 'edit';
                  } else {
                    _this9.reconcileAction = 'view';
                  }
                } else if (isInEnvelopeByTxStatus && _this9.canEditInEnvelopeFromReconcileModal()) {
                  // PRODUCTDEV-5574 — Approved envelopes (e.g. Open - Approved) remain editable from the
                  // Reconcile modal for authorized roles; per spec they are not editable from the envelope page.
                  _this9.reconcileAction = 'edit';
                } else {
                  _this9.reconcileAction = 'view';
                }
              } else if (isInEnvelopeByTxStatus) {
                if (transaction.data.EnvelopeStatus === 'Draft') {
                  _this9.reconcileAction = 'edit';
                } else if (_this9.canEditInEnvelopeFromReconcileModal()) {
                  _this9.reconcileAction = 'edit';
                } else {
                  _this9.reconcileAction = 'view';
                }
              } else {
                _this9.reconcileAction = 'create';
              }
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    fetchEditAuth: function fetchEditAuth(transactionId) {
      var _this10 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return _this10.api.get(_this10.api.$.evedpaycard.canEditInEnvelopeTransaction, {
                params: {
                  transactionId: transactionId
                }
              });
            case 3:
              response = _context9.sent;
              _this10.editAuth = response.data || null;
              _context9.next = 12;
              break;
            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9["catch"](0);
              console.error('There was a problem fetching transaction edit authorization:', _context9.t0);
              // Fail closed to view-only, but tell the user why so a transient can-edit
              // failure doesn't read as a silent permission downgrade.
              _this10.editAuth = null;
              _this10.$notifications.notify({
                type: 'plain',
                icon: 'exclamation-circle',
                placement: {
                  from: 'top',
                  align: 'center'
                },
                timeout: 0,
                message: 'We could not verify your edit permissions for this transaction. Please refresh and try again.',
                discard: 'Ok',
                goto: ''
              });
            case 12:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[0, 7]]);
      }))();
    },
    getApprovalUsers: function getApprovalUsers(envelopeId) {
      var _this11 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this11.api.get(_this11.api.$.evedpaycard.approvalUsersForEnvelope, {
                params: {
                  envelopeId: envelopeId
                }
              }).then(function (response) {
                _this11.approvalUsersData = response.data;
              }).catch(function (error) {
                console.error('There was a problem with the approval users request:', error);
              });
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    isUserInApprovalList: function isUserInApprovalList() {
      var currentUserID = this.$root.getUser.$.user.UserID;
      if (Array.isArray(this.approvalUsersData)) {
        return this.approvalUsersData.some(function (user) {
          return user.Id === currentUserID && user.IsCurrentAction;
        });
      }
      return false;
    },
    // PRODUCTDEV-5574 — the Reconcile modal does not grant edit access to a Declined-envelope submitter
    // who isn't also a card holder/admin/approver/global admin. That submitter-only path is the
    // envelope page's responsibility (CreateEnvelope.vue editEnvelope flow).
    canEditInEnvelopeFromReconcileModal: function canEditInEnvelopeFromReconcileModal() {
      // ASP.NET MVC's default JsonResult serializes property names as-is (PascalCase),
      // matching the convention used by other endpoints in this controller.
      if (!this.editAuth || !this.editAuth.CanEdit) return false;
      return this.editAuth.IsCardHolder || this.editAuth.IsCardAdmin || this.editAuth.IsApprover || this.editAuth.IsGlobalAdmin;
    },
    updateUrlBackToTransactionsPage: function updateUrlBackToTransactionsPage() {
      window.history.pushState({}, '', '#/d/Programs/>Card/transactions');
    },
    refresh: function refresh() {
      this.$refs.grid.refreshGrid();
    },
    redrawRows: function redrawRows() {
      this.$refs.grid.gridOptions.api.redrawRows();
    },
    openReceiptUpload: function openReceiptUpload() {
      this.pendingReceiptFile = null;
      this.showSubmitReceiptModal = true;
    },
    triggerReceiptFileInput: function triggerReceiptFileInput() {
      this.$refs.receiptUploadInput.click();
    },
    handleReceiptFileSelected: function handleReceiptFileSelected(event) {
      var files = event.target.files;
      if (!files || files.length === 0) {
        return;
      }
      var file = files[0];
      var ALLOWED = ['pdf', 'png', 'jpg', 'jpeg'];
      var parts = file.name ? file.name.split('.') : [];
      var extension = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
      if (!ALLOWED.includes(extension)) {
        this.$notifications.notify({
          type: 'info-warn',
          message: 'Please upload a file with one of these extensions: .pdf, .png, .jpg, .jpeg',
          placement: {
            from: 'top',
            align: 'center'
          }
        });
        if (this.$refs.receiptUploadInput) {
          this.$refs.receiptUploadInput.value = '';
        }
        return;
      }
      var MAX_FILE_SIZE = 10 * 1024 * 1024;
      if (file.size >= MAX_FILE_SIZE) {
        this.$notifications.notify({
          type: 'info-warn',
          message: 'File is too large. Please upload a receipt smaller than 10 MB.',
          placement: {
            from: 'top',
            align: 'center'
          }
        });
        if (this.$refs.receiptUploadInput) {
          this.$refs.receiptUploadInput.value = '';
        }
        return;
      }
      this.pendingReceiptFile = file;
    },
    clearPendingReceiptFile: function clearPendingReceiptFile() {
      this.pendingReceiptFile = null;
      if (this.$refs.receiptUploadInput) {
        this.$refs.receiptUploadInput.value = '';
      }
    },
    formatFileSize: function formatFileSize(bytes) {
      if (!bytes) return '';
      if (bytes < 1024) return bytes + 'b';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + 'Kb';
      return (bytes / (1024 * 1024)).toFixed(1) + 'Mb';
    },
    closeSubmitReceiptModal: function closeSubmitReceiptModal() {
      if (this.uploadingReceipt) return;
      this.showSubmitReceiptModal = false;
      this.pendingReceiptFile = null;
      if (this.$refs.receiptUploadInput) {
        this.$refs.receiptUploadInput.value = '';
      }
    },
    confirmSubmitReceipt: function confirmSubmitReceipt() {
      var _this12 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee11() {
        var file, barDuration, start, barComplete, legacyUrl, legacyToken, legacyPromise, formData, idempotencyKey, submitExtra, uploadPromise, _yield$Promise$all, _yield$Promise$all2, data, legacyMeta;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (_this12.pendingReceiptFile) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return");
            case 2:
              _context11.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_13__core_receiptScan_imageCompression__["a" /* default */])(_this12.pendingReceiptFile);
            case 4:
              file = _context11.sent;
              _this12.uploadingReceipt = true;
              _this12.uploadProgressPct = 0;
              _this12.pendingLegacyReceipt = null;
              barDuration = 4000;
              start = performance.now();
              barComplete = new Promise(function (resolve) {
                var _tick = function tick(now) {
                  var pct = Math.min(100, Math.round((now - start) / barDuration * 100));
                  _this12.uploadProgressPct = pct;
                  if (pct < 100) {
                    _this12._uploadProgressRaf = requestAnimationFrame(_tick);
                  } else {
                    _this12._uploadProgressRaf = null;
                    resolve();
                  }
                };
                _this12._uploadProgressRaf = requestAnimationFrame(_tick);
              });
              legacyUrl = _this12.api && _this12.api.env ? _this12.api.env + _this12.api.$.evedpaycard.receipt : null;
              legacyToken = _this12.$user && _this12.$user.sessionSettings ? _this12.$user.sessionSettings.Token : '';
              legacyPromise = legacyUrl ? function (self) {
                var lf = new FormData();
                lf.append('attachment_upload', file);
                return self.api.post(legacyUrl, lf, {
                  headers: {
                    'Authorization': 'Bearer ' + legacyToken,
                    'Content-Type': 'multipart/form-data'
                  }
                }).then(function (resp) {
                  var body = resp && resp.data;
                  if (typeof body === 'string') {
                    try {
                      body = JSON.parse(body);
                    } catch (e) {
                      body = null;
                    }
                  }
                  if (!body || !body.success || !body.path) return null;
                  var m = body.path.match(/(ClientData\/.*)/);
                  var pathWithName = m && m[1] ? m[1] : body.path;
                  var mediaFile = body.file || pathWithName.split('/').pop();
                  return {
                    path: body.path,
                    pathWithName: pathWithName,
                    mediaFile: mediaFile,
                    file: mediaFile,
                    name: file.name,
                    type: file.type || '',
                    size: file.size || 0
                  };
                }).catch(function (err) {
                  console.warn('Legacy receipt upload failed at Transactions SUBMIT:', err);
                  return null;
                });
              }(_this12) : Promise.resolve(null);
              formData = new FormData();
              formData.append('file', file);
              idempotencyKey = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0;
                var v = c === 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
              }); // Global Transactions tab: no Division to narrow by. BE treats null
              // submitExtra as "no narrowing" and ranks against all programs the user
              // can access.
              submitExtra = null;
              _this12.$notifications.notify({
                type: 'info',
                message: 'Scanning receipt...',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              uploadPromise = __WEBPACK_IMPORTED_MODULE_11__core_api_receiptScans__["b" /* default */].submitReceipt(formData, idempotencyKey, submitExtra);
              _context11.prev = 20;
              _context11.next = 23;
              return barComplete;
            case 23:
              _this12.uploadingReceipt = false;
              if (_this12.candidateSelectorLocalImageUrl) {
                URL.revokeObjectURL(_this12.candidateSelectorLocalImageUrl);
              }
              _this12.candidateSelectorLocalImageUrl = URL.createObjectURL(file);
              _this12.candidateSelectorLocalImageType = file.type || null;
              _this12.closeSubmitReceiptModal();
              _this12.candidateSelectorReceiptId = null;
              _this12.candidateSelectorCandidates = [];
              _this12.candidateSelectorRowVersion = null;
              _this12.candidateSelectorAutoLinked = false;
              _this12.candidateSelectorAutoFill = null;
              _this12.candidateSelectorLoading = true;
              _this12.showCandidateSelector = true;
              _context11.next = 37;
              return Promise.all([uploadPromise, legacyPromise]);
            case 37:
              _yield$Promise$all = _context11.sent;
              _yield$Promise$all2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_yield$Promise$all, 2);
              data = _yield$Promise$all2[0];
              legacyMeta = _yield$Promise$all2[1];
              _this12.pendingLegacyReceipt = legacyMeta || null;
              if (_this12.showCandidateSelector) {
                _context11.next = 45;
                break;
              }
              if (data && data.receiptScanId) {
                __WEBPACK_IMPORTED_MODULE_11__core_api_receiptScans__["b" /* default */].deleteReceipt(data.receiptScanId).catch(function (err) {
                  console.warn('Receipt dispose on mid-upload dismiss failed (ignored):', err);
                });
              }
              return _context11.abrupt("return");
            case 45:
              if (data && data.receiptScanId) {
                __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$emit('receipt-scan-started', {
                  receiptScanId: data.receiptScanId,
                  source: 'transactionsTab'
                });
                if (legacyUrl && !legacyMeta) {
                  _this12.$notifications.notify({
                    type: 'info-warn',
                    message: "Receipt scanned, but it couldn't be attached to the transaction record. Match will still work, but the receipt won't appear on reopen. Cancel and retry if you need the attachment preserved.",
                    placement: {
                      from: 'top',
                      align: 'center'
                    }
                  });
                }
              }
              _context11.next = 61;
              break;
            case 48:
              _context11.prev = 48;
              _context11.t0 = _context11["catch"](20);
              _this12.uploadingReceipt = false;
              _this12.closeSubmitReceiptModal();

              // PRODUCTDEV-5851 — the image couldn't be scanned (e.g. dimensions out of range), but the
              // backend still persisted the receipt (ReadyForMatch, zero candidates) and returns 422 with
              // its receiptScanId. Silently drive the SAME post-scan flow (no error toast) so the user can
              // match manually or save it to their folder. Isolated to this one status — every other error
              // keeps its handling below.
              if (!(_context11.t0.response && _context11.t0.response.status === 422 && _context11.t0.response.data && _context11.t0.response.data.receiptScanId)) {
                _context11.next = 55;
                break;
              }
              __WEBPACK_IMPORTED_MODULE_15__event_bus__["b" /* EventBus */].$emit('receipt-scan-started', {
                receiptScanId: _context11.t0.response.data.receiptScanId,
                source: 'transactionsTab'
              });
              return _context11.abrupt("return");
            case 55:
              if (_this12.showCandidateSelector && _this12.candidateSelectorLoading && !_this12.candidateSelectorReceiptId) {
                _this12.showCandidateSelector = false;
                _this12.candidateSelectorLoading = false;
              }
              if (!_context11.t0.isPlatformSentinelError) {
                _context11.next = 59;
                break;
              }
              _this12.$notifications.notify({
                type: 'info-warn',
                message: 'Receipt capture is temporarily unavailable. Please try again later.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              return _context11.abrupt("return");
            case 59:
              _this12.$notifications.notify({
                type: 'info-warn',
                message: 'Failed to upload receipt. Please try again.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
              console.error('Error uploading receipt:', _context11.t0);
            case 61:
              _context11.prev = 61;
              if (_this12._uploadProgressRaf) {
                cancelAnimationFrame(_this12._uploadProgressRaf);
                _this12._uploadProgressRaf = null;
              }
              _this12.uploadingReceipt = false;
              _this12.uploadProgressPct = 0;
              return _context11.finish(61);
            case 66:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[20, 48, 61, 66]]);
      }))();
    },
    handleReceiptScanStarted: function handleReceiptScanStarted(data) {
      var self = this;
      var receiptScanId = data.receiptScanId;
      if (this.activePoller) {
        this.activePoller.cancel();
      }
      this.candidateSelectorReceiptId = receiptScanId;
      this.candidateSelectorCandidates = [];
      this.candidateSelectorRowVersion = null;
      this.candidateSelectorAutoLinked = false;
      this.candidateSelectorAutoFill = null;
      this.candidateSelectorLoading = true;
      this.showCandidateSelector = true;
      var poller = Object(__WEBPACK_IMPORTED_MODULE_12__core_receiptScan_receiptScanPoller__["a" /* default */])({
        receiptScanId: receiptScanId,
        contextHint: {
          source: data.source
        },
        onStateChange: function onStateChange() {},
        onDone: function onDone() {
          self.activePoller = null;
          __WEBPACK_IMPORTED_MODULE_11__core_api_receiptScans__["b" /* default */].getStatus(receiptScanId).then(function (statusData) {
            var candidates = statusData && statusData.matchCandidates || [];
            if (candidates.length === 1 && statusData.autoLinked) {
              self.showCandidateSelector = false;
              self.candidateSelectorLoading = false;
              self.candidateSelectorReceiptId = null;
              self.openMatchedReconcile(candidates[0].legacyTransactionId, receiptScanId);
              return;
            }
            self.candidateSelectorReceiptId = receiptScanId;
            self.candidateSelectorCandidates = candidates;
            self.candidateSelectorRowVersion = statusData.rowVersion;
            self.candidateSelectorAutoLinked = statusData.autoLinked || false;
            self.candidateSelectorAutoFill = statusData.autoFill || null;
            self.candidateSelectorLoading = false;
            self.showCandidateSelector = true;
          }).catch(function (err) {
            console.error('Error fetching receipt status:', err);
            self.showCandidateSelector = false;
            self.candidateSelectorLoading = false;
            self.$notifications.notify({
              type: 'danger',
              message: 'Failed to retrieve receipt details. Please try again.',
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          });
        },
        onError: function onError(error) {
          self.activePoller = null;
          self.showCandidateSelector = false;
          self.candidateSelectorLoading = false;
          if (error.type === 'unreachable' || error.type === 'timeout') {
            self.$notifications.notify({
              type: 'info',
              message: 'Scan is taking longer than expected. We\'ll keep working on it — check the Receipt Folder later.',
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          } else if (error.type === 'scan_failed') {
            self.$notifications.notify({
              type: 'danger',
              message: 'Scan failed. Please try uploading the receipt again.',
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          } else {
            self.$notifications.notify({
              type: 'danger',
              message: 'Error scanning receipt. Please try again.',
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          }
        }
      });
      this.activePoller = poller;
      poller.start();
    },
    handleMatchSelected: function handleMatchSelected(data) {
      this.candidateSelectorReceiptId = null;
      this.showCandidateSelector = false;
      this.openMatchedReconcile(data.legacyTransactionId, data.receiptScanId);
    },
    openMatchedReconcile: function openMatchedReconcile(legacyTransactionId, receiptScanId) {
      var _this13 = this;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.mark(function _callee12() {
        var prefillP, txP, _yield$Promise$all3, _yield$Promise$all4, resp, rows, tx;
        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this13.stashLegacyReceiptForReconcile(receiptScanId);
              _context12.prev = 1;
              _context12.next = 4;
              return _this13.$router.replace({
                query: _objectSpread(_objectSpread({}, _this13.$route.query), {}, {
                  receiptScanId: receiptScanId
                })
              });
            case 4:
              _context12.next = 8;
              break;
            case 6:
              _context12.prev = 6;
              _context12.t0 = _context12["catch"](1);
            case 8:
              prefillP = __WEBPACK_IMPORTED_MODULE_11__core_api_receiptScans__["b" /* default */].getPrefill(receiptScanId).then(function (data) {
                if (data) {
                  try {
                    global.sessionStorage.setItem('receiptScanPrefill_' + receiptScanId, JSON.stringify(data));
                  } catch (e) {
                    // sessionStorage disabled — Reconcile falls back to API call
                  }
                }
              }).catch(function () {
                // Prefill fetch failed — Reconcile retries via API path
              });
              txP = _this13.api.forms.post(_this13.api.$.evedpaycard.transactions, {
                sort: 'TransactionStatus',
                dir: 'ASC',
                start: 0,
                limit: 1,
                isLiveGrid: true,
                filter: JSON.stringify({
                  Id: legacyTransactionId,
                  searchTerm: ''
                })
              });
              _context12.prev = 10;
              _context12.next = 13;
              return Promise.all([prefillP, txP]);
            case 13:
              _yield$Promise$all3 = _context12.sent;
              _yield$Promise$all4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_yield$Promise$all3, 2);
              resp = _yield$Promise$all4[1];
              rows = resp && resp.data && resp.data.Data;
              if (!(rows && rows.length > 0)) {
                _context12.next = 23;
                break;
              }
              tx = rows[0];
              _context12.next = 21;
              return _this13.handleTransaction({
                data: _objectSpread(_objectSpread({}, tx), {}, {
                  merchant: tx.Merchant,
                  amount: tx.Amount,
                  date: tx.TransactionDate,
                  status: tx.TransactionStatus,
                  reconcileStatus: tx.ReconciliationStatus,
                  id: tx.Id
                })
              });
            case 21:
              _context12.next = 24;
              break;
            case 23:
              _this13.$notifications.notify({
                type: 'warning',
                message: 'Could not open the matched transaction. Click it in the list to view.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            case 24:
              _context12.next = 30;
              break;
            case 26:
              _context12.prev = 26;
              _context12.t1 = _context12["catch"](10);
              console.error('Failed to load matched transaction for reconcile:', _context12.t1);
              _this13.$notifications.notify({
                type: 'warning',
                message: 'Could not open the matched transaction. Click it in the list to view.',
                placement: {
                  from: 'top',
                  align: 'center'
                }
              });
            case 30:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[1, 6], [10, 26]]);
      }))();
    },
    stashLegacyReceiptForReconcile: function stashLegacyReceiptForReconcile(receiptScanId) {
      if (!receiptScanId || !this.pendingLegacyReceipt) return;
      try {
        var key = 'receiptScanLegacyPath_' + receiptScanId;
        global.sessionStorage.setItem(key, JSON.stringify(this.pendingLegacyReceipt));
      } catch (err) {
        console.warn('Could not stash legacy receipt metadata:', err);
      }
    },
    handleSaveToFolder: function handleSaveToFolder() {
      this.showCandidateSelector = false;
      this.candidateSelectorReceiptId = null;
    },
    handleMatchAttempt: function handleMatchAttempt() {
      this.candidateSelectorMatching = true;
    },
    handleMatchError: function handleMatchError() {
      var idToDispose = this.candidateSelectorReceiptId;
      this.candidateSelectorReceiptId = null;
      this.candidateSelectorMatching = false;
      if (idToDispose) {
        __WEBPACK_IMPORTED_MODULE_11__core_api_receiptScans__["b" /* default */].deleteReceipt(idToDispose).catch(function (err) {
          console.warn('Match-error scan dispose failed (ignored):', err);
        });
      }
    },
    handleCandidateSelectorClose: function handleCandidateSelectorClose() {
      var self = this;
      if (self.activePoller) {
        self.activePoller.cancel();
        self.activePoller = null;
      }
      if (self.candidateSelectorMatching) {
        self.candidateSelectorMatching = false;
        self.showCandidateSelector = false;
        self.candidateSelectorLoading = false;
        return;
      }
      var idToDispose = self.candidateSelectorReceiptId;
      self.showCandidateSelector = false;
      self.candidateSelectorLoading = false;
      self.candidateSelectorReceiptId = null;
      if (idToDispose) {
        __WEBPACK_IMPORTED_MODULE_11__core_api_receiptScans__["b" /* default */].deleteReceipt(idToDispose).catch(function (err) {
          console.warn('Receipt dispose on cancel failed (ignored):', err);
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.activePoller) {
      this.activePoller.cancel();
      this.activePoller = null;
    }
    if (this.pendingReceiptObjectUrl) URL.revokeObjectURL(this.pendingReceiptObjectUrl);
  },
  deactivated: function deactivated() {
    if (this.activePoller) {
      this.activePoller.cancel();
      this.activePoller = null;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "th0X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"eZDAUVVGqbFUxJcFPURNX","Dell":"_8w2Vsg1wQVynzaQPr2bYW","Abbott":"_2G2tCuaNNB_I_9W-FFpWw0","Gap":"_1o4GZX_Uc_tspGOimwTUg7","Allstate":"_39saES5VolObOQU9GbVtOV","Asurion":"_1qFzvf_xWFI_NPFQFNNy87","Invitae":"_1wKHMB6_ap3ax2egU1kcE3","JWE":"_1rNBK_yn_WHwUWVhmZKIBF"};

/***/ }),

/***/ "tiZs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "toiP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'more-actions',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],
  props: {
    actions: Array
  },
  data: function data() {
    var _this = this;
    return {
      isDropdownOpen: false,
      showAbove: false,
      component: function component(action) {
        return {
          template: action.tpl,
          data: function data() {
            return {
              params: _this.params
            };
          }
        };
      }
    };
  },
  computed: {
    //
  },
  created: function created() {
    //
  },
  methods: {
    openDropdown: function openDropdown() {
      var _this2 = this;
      this.isDropdownOpen = !this.isDropdownOpen;
      this.params.context.shownPopover = this.isDropdownOpen;
      this.showAbove || this.$nextTick(function () {
        var gridBounds = _this2.params.context.$el.querySelector('.ag-body').getBoundingClientRect();
        var menuBounds = _this2.$refs.dropdownMenu.getBoundingClientRect();
        var gridBottomEdge = gridBounds.top + gridBounds.height;
        var menuBottomEdge = menuBounds.top + menuBounds.height;
        _this2.showAbove = menuBottomEdge > gridBottomEdge;
      });
    },
    closeDropdown: function closeDropdown() {
      if (this.isDropdownOpen) {
        this.isDropdownOpen = false;
      }
    }
  }
});

/***/ }),

/***/ "tp8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dawn-card"},[_c('div',{staticClass:"dawn-card-top"},[_vm._t("top"),(!_vm.hasSlotTop)?_c('span',{staticClass:"close-icon"},[(_vm.removable)?_c('i',{staticClass:"fal fa-times",on:{"click":_vm.removecard}}):_vm._e()]):_vm._e()],2),_c('div',{staticClass:"dawn-card-header"},[(_vm.icon)?_c('span',{staticClass:"dawn-card-header-icon"},[_c('i',{class:_vm.iconClass})]):_vm._e(),_c('span',{staticClass:"dawn-card-header-title"},[_c('p',{staticClass:"title"},[_vm._t("title"),(!_vm.hasSlotTitle)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.titleTooltip),expression:"titleTooltip"}],staticClass:"title-text",on:{"click":_vm.edit}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("title-icon")],2),(_vm.subtitle)?_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])]),_c('div',{staticClass:"dawn-card-body"},[_vm._t("body")],2),_c('div',{staticClass:"dawn-card-footer text-right-"},[_vm._t("footer"),(!_vm.hasSlotFooter)?_c('div',[(_vm.footerButton != "false" && !_vm.href)?_c('ed-button',{attrs:{"button-class":"btn btn-actionbar"},on:{"click":_vm.edit}},[_vm._v(_vm._s(_vm.footerButton))]):_vm._e(),(_vm.footerButton != "false" && !!_vm.href)?_c('ed-button',{attrs:{"button-class":"btn btn-actionbar","href":_vm.href},on:{"click":_vm.edit}},[_vm._v(_vm._s(_vm.footerButton))]):_vm._e()],1):_vm._e()],2),_c('div',{class:{ "dawn-card-help-mask": _vm.$slots.mask }},[_vm._t("mask")],2),_c('div',{staticClass:"dawn-card-tag"},[_vm._v(_vm._s(_vm.$t('New')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tzLG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__otpCardRevealMixin__ = __webpack_require__("vF8d");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpayshownumber',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__otpCardRevealMixin__["a" /* default */]],
  data: function data() {
    return {
      card: null,
      digits: ['', '', '', '', '', '']
    };
  },
  computed: {
    formattedExpirationDate: function formattedExpirationDate() {
      var exp = this.card ? this.card.expirationDate || '' : '';
      if (!exp) {
        return '••/••';
      }
      var match = exp.match(/\/Date\((\d+)\)\//);
      var d = match ? new Date(parseInt(match[1])) : new Date(exp);
      if (isNaN(d.getTime())) {
        return exp;
      }
      var mm = ('0' + (d.getMonth() + 1)).slice(-2);
      var yy = String(d.getFullYear()).slice(-2);
      return mm + '/' + yy;
    },
    displayNameOnCard: function displayNameOnCard() {
      if (!this.card) {
        return '';
      }
      var nameOnCard = (this.card.nameOnCard || '').trim();
      return nameOnCard || this.card.holder;
    },
    passcode: function passcode() {
      return this.digits.join('');
    }
  },
  created: function created() {
    this.fetchCard();
  },
  methods: {
    getCardId: function getCardId() {
      return this.card ? this.card.id : null;
    },
    getPasscode: function getPasscode() {
      return this.digits.join('');
    },
    resetPasscodeInput: function resetPasscodeInput() {
      this.digits = ['', '', '', '', '', ''];
    },
    focusPasscodeInput: function focusPasscodeInput() {
      var _this = this;
      this.$nextTick(function () {
        if (_this.$refs.otpInput0 && _this.$refs.otpInput0[0]) {
          _this.$refs.otpInput0[0].focus();
        }
      });
    },
    fetchCard: function fetchCard() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var cardId, r, fullCard;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cardId = _this2.$route.query.cardid;
              _context.next = 3;
              return _this2.api.get(_this2.api.$.evedpaycard.cardWithDetails, {
                params: {
                  id: cardId
                }
              });
            case 3:
              r = _context.sent;
              fullCard = r.data;
              if (!fullCard) {
                _context.next = 10;
                break;
              }
              if (!(_this2.$user.$.user.UserID !== fullCard.Holder.Id)) {
                _context.next = 9;
                break;
              }
              _this2.$router.replace(_this2.$routerHistory.previous().path);
              return _context.abrupt("return");
            case 9:
              _this2.card = {
                id: fullCard.Id,
                accountId: fullCard.AccountId,
                cardNumber: fullCard.CardNumber,
                holder: fullCard.Holder.Name,
                holderUserId: fullCard.Holder.Id,
                nameOnCard: fullCard.NameOnCard || '',
                expirationDate: fullCard.ExpirationDate || ''
              };
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getAccountId: function getAccountId() {
      return this.card ? this.card.accountId : null;
    },
    onDigitInput: function onDigitInput(index, event) {
      var value = event.target.value.replace(/[^0-9]/g, '');
      this.$set(this.digits, index, value.slice(0, 1));
      event.target.value = this.digits[index];
      if (value && index < 5) {
        var nextRef = this.$refs['otpInput' + (index + 1)];
        if (nextRef && nextRef[0]) {
          nextRef[0].focus();
        }
      }
      if (this.passcode.length === 6 && !this.verifying) {
        this.verifyOtp();
      }
    },
    onDigitKeydown: function onDigitKeydown(index, event) {
      if (event.key === 'Backspace' && !this.digits[index] && index > 0) {
        var prevRef = this.$refs['otpInput' + (index - 1)];
        if (prevRef && prevRef[0]) {
          this.$set(this.digits, index - 1, '');
          prevRef[0].focus();
        }
      }
    },
    onPaste: function onPaste(event) {
      event.preventDefault();
      var pasted = (event.clipboardData || window.clipboardData).getData('text').replace(/[^0-9]/g, '').slice(0, 6);
      for (var i = 0; i < 6; i++) {
        this.$set(this.digits, i, pasted[i] || '');
      }
      if (pasted.length === 6 && !this.verifying) {
        this.verifyOtp();
      }
    }
  }
});

/***/ }),

/***/ "tztp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3D4708B7xQdeAMowiyXgo5","Dell":"XWtTqVuhQ3_o0nEUBe9MI","Abbott":"_3WfSalZfDxEto4WnN7C3IF","Gap":"_3Lw0KnP4CioZn-CpFUiUkY","Allstate":"-M9gRN_BirE9nOdQYJZNd","Asurion":"_3112W2MFm_aYoEreIkNF7N","Invitae":"nkdTFnxe-MDZkJ9z3bNqX","JWE":"_2FT0qmi1qsC-epO-DUcOQO"};

/***/ }),

/***/ "u1B6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receipt-image-viewer"},[_c('div',{staticClass:"receipt-image-wrap",style:({ height: _vm.wrapHeight })},[(_vm.imageUrl && _vm.isPdf)?_c('iframe',{staticClass:"receipt-pdf",style:({ width: (_vm.zoomLevel * 100) + '%' }),attrs:{"src":_vm.imageUrl + '#toolbar=0&navpanes=0&view=FitH',"title":"Receipt PDF"}}):(_vm.imageUrl)?_c('img',{staticClass:"receipt-image",style:({ width: (_vm.zoomLevel * 100) + '%' }),attrs:{"src":_vm.imageUrl,"alt":"Receipt"}}):(_vm.errored)?_c('div',{staticClass:"receipt-image-fallback"},[_c('i',{staticClass:"fas fa-image"}),_vm._v(" "),_c('span',[_vm._v("Image unavailable")])]):_c('div',{staticClass:"receipt-image-fallback"},[_c('i',{staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),(_vm.imageUrl)?_c('div',{staticClass:"zoom-pill"},[_c('button',{staticClass:"zoom-btn",attrs:{"type":"button","disabled":_vm.zoomLevel <= _vm.ZOOM_MIN,"aria-label":"Zoom out"},on:{"click":_vm.zoomOut}},[_vm._v("−")]),_vm._v(" "),_c('button',{staticClass:"zoom-btn",attrs:{"type":"button","disabled":_vm.zoomLevel >= _vm.ZOOM_MAX,"aria-label":"Zoom in"},on:{"click":_vm.zoomIn}},[_vm._v("+")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u2bT":
/***/ (function(module, exports) {

module.exports = {"ProgramStatusName":{"label":"Status","source":"programGrid"},"ProgramName":{"label":"Program Name","details":"program.detail"},"ProgramID":"Program ID","ProgramStartDate":"Start Date","ProgramEndDate":"End Date","Location":"Location","ProgramOwner":{"label":"Program Owner","source":"ProgramsListGrid"},"ClientName":"Client Name"}

/***/ }),

/***/ "u8Yq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approve_dialog_vue__ = __webpack_require__("uN1o");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1411282_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_approve_dialog_vue__ = __webpack_require__("StJP");
function injectStyle (ssrContext) {
  __webpack_require__("TUy4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1411282"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approve_dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1411282_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_approve_dialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "u8vE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(allocations, selectedAllocations) {
    return {
      Id: '_',
      '*Name': {
        label: 'Cost Center',
        width: 120,
        options: allocations,
        source: true,
        compose: allocationName,
        selectedOptions: selectedAllocations,
        trackBy: {
          optionTrackBy: 'Key',
          selectedOptionTrackBy: 'Id'
        },
        editable: true
      },
      AdditionalNo: {
        label: 'Secondary ID',
        width: 90,
        editable: true,
        maxLength: 50
      },
      Percent: {
        label: 'Allocation Percent',
        width: 80,
        editable: true
      },
      Amount: {
        label: 'Allocation Amount',
        width: 80,
        f: 'data.Amount',
        validSum: {
          value: 0
        },
        editable: true
      }
    };
  }
});
function allocationName(params) {
  return params.data && params.data.Name ? params.data.Name : ' ';
}

/***/ }),

/***/ "u9q6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheToolbar_vue__ = __webpack_require__("PtKW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_891b76f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheToolbar_vue__ = __webpack_require__("F6Ut");
function injectStyle (ssrContext) {
  __webpack_require__("CMu3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-891b76f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_891b76f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uN1o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__items_list__ = __webpack_require__("5zl1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_info__ = __webpack_require__("vFKZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showModal: Boolean,
    list: Array,
    programLabel: String,
    cardApproval: Boolean,
    envelopeApproval: Boolean,
    submitEndpoint: String,
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      reason: '',
      reasonError: false
    };
  },
  computed: {
    title: function title() {
      return this.list.length === 1 ? 'You are about to approve this item' : 'You are about to approve these items';
    },
    approvalNoteLabel: function approvalNoteLabel() {
      return this.list && this.list[0] ? this.list[0].ApprovalNoteLabel : 'Approval Note';
    },
    reasonErrorMsg: function reasonErrorMsg() {
      return 'Please enter the ' + this.approvalNoteLabel;
    },
    isReasonRequired: function isReasonRequired() {
      return this.list && this.list[0] && this.list[0].IsApprovalNoteRequired === 'True';
    },
    atLeastOneItemIsInvoice: function atLeastOneItemIsInvoice() {
      return this.list && this.list.some(function (item) {
        return item.NeedsApproval.indexOf('INV') === 0;
      });
    },
    filteredList: function filteredList() {
      return this.list.filter(function (item) {
        if (item.Type === 'Funds Request') {
          var amountWithoutSymbols = item.Amount.replace(/(USD|,)/g, '');
          var budgetBalanceWithoutSymbols = item.BudgetBalance.replace(/(USD|,)/g, '');
          return Number(amountWithoutSymbols) <= Number(budgetBalanceWithoutSymbols);
        }
        return true;
      });
    }
  },
  methods: {
    isFirstItemFundsRequest: function isFirstItemFundsRequest(item) {
      if (item && item.Type && item.Type === 'Funds Request') {
        var amountWithoutSymbols = item.Amount.replace(/(USD|,)/g, '');
        var budgetBalanceWithoutSymbols = item.BudgetBalance.replace(/(USD|,)/g, '');
        return Number(amountWithoutSymbols) <= Number(budgetBalanceWithoutSymbols);
      }
      return true;
    },
    onApprovalNoteChange: function onApprovalNoteChange() {
      if (this.reasonError && this.valid()) {
        this.reasonError = false;
      }
    },
    valid: function valid() {
      if (this.atLeastOneItemIsInvoice && this.isReasonRequired && (!this.reason || !this.reason.trim())) {
        return false;
      }
      return true;
    },
    handleClose: function handleClose() {
      if (this.loading) return;
      this.$emit('close');
    },
    approve: function approve() {
      if (this.loading) return;
      if (this.valid()) {
        this.$emit('approve', this.reason);
      } else {
        this.reasonError = true;
      }
    },
    getEndpoint: function getEndpoint() {
      if (this.cardApproval) {
        return this.api.$.evedpaycard.approveOrReject;
      } else if (this.envelopeApproval) {
        return this.api.$.evedpaycard.approveOrRejectEnvelope;
      } else {
        return this.submitEndpoint;
      }
    }
  },
  components: {
    itemsList: __WEBPACK_IMPORTED_MODULE_0__items_list__["default"],
    userInfo: __WEBPACK_IMPORTED_MODULE_1__user_info__["default"]
  }
});

/***/ }),

/***/ "uODl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Grid_cells_actions__ = __webpack_require__("ayPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_events_events__ = __webpack_require__("1RXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_events_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__core_events_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BUCCModel_js__ = __webpack_require__("dsuC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid__["a" /* default */]
  },
  data: function data() {
    return {
      BUCCModel: __WEBPACK_IMPORTED_MODULE_4__BUCCModel_js__["a" /* default */],
      actions: [__WEBPACK_IMPORTED_MODULE_1__components_Grid_cells_actions__["g" /* remove */]],
      list: utils.collection.list
    };
  },
  computed: {
    getModel: function getModel() {
      return __WEBPACK_IMPORTED_MODULE_4__BUCCModel_js__["a" /* default */].get();
    }
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$on(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.BU_CC.REFRESH, function (r) {
      _this.refresh();
    });
  },
  methods: {
    editPair: function editPair(payload, success, fail) {
      //
      if (!this.validBUCC(payload.data)) {
        fail('Invalid Business Unit & Cost Center pair');
      } else {
        this.api.post(this.api.$.BUAndCC.saveBuAndCcPair, payload.data).then(function (r) {
          return success(r);
        }).catch(function (e) {
          return fail();
        });
      }
    },
    removePair: function removePair(payload, success, fail) {
      //
      var id = +payload.data.Id;
      this.api.delete(this.api.$.BUAndCC.deleteBuAndCcPair + '/' + id, id).then(function (r) {
        return success();
      }).catch(function (e) {
        return fail('Something went wrong. Cannot delete the Business Unit');
      });
    },
    removePairs: function removePairs(payload) {
      //
      var pairIds = [];
      payload.rows.forEach(function (element) {
        pairIds.push(element.data.Id);
      });
      var p = {
        IDs: pairIds
      };
      this.api.post(this.api.$.BUAndCC.deleteBuAndCcPairs, p).then(this.validateDeletePairs);
    },
    addBUCC: function addBUCC() {
      this.$refs.PairedBUCCGrid.addRow({});
    },
    validBUCC: function validBUCC(data) {
      var isValid = false;
      if (data.CostCenterNo && data.CostCenterNo.trim() !== '' && data.BusinessUnitName && data.BusinessUnitName.trim() !== '') {
        isValid = true;
      }
      return isValid;
    },
    refresh: function refresh() {
      this.$refs.PairedBUCCGrid.quickSearch();
      this.$refs.PairedBUCCGrid.onSelectAll(false);
    },
    validateDeletePairs: function validateDeletePairs(r) {
      if (r.data.Errors.length !== 0) {
        alert('Something went wrong. Cannot delete the Business Units.');
      }
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__core_events_events___default.a.BU_CC.REFRESH);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "ubmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-custom-cell ag-cell-date"},[_c('div',{staticClass:"ag-custom-cell-value"},[_vm._v(_vm._s(_vm.formattedDate))]),_vm._v("  "),(_vm.showCaret)?_c('i',{staticClass:"fas fa-caret-down ag-row-expand-icon pull-right",on:{"click":_vm.showDetails}}):_vm._e(),_c('div',{staticClass:"ag-row-details ag-menu ag-menu-date fade",class:{ "shown": _vm.shownDetails },style:(_vm.position)},[_c('i',{staticClass:"ag-row-expand-close fal fa-times",on:{"click":_vm.showDetails}}),_c('div',{staticClass:"ag-row-details-content ag-filter ag-filter-date"},[(_vm.shownDetails)?_c('ed-datepicker',{staticClass:"standalone",attrs:{"placement":"inline","fit":""},on:{"input":_vm.edit}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ud1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    cancel: function cancel() {
      var parentAppFrame = global.top.document.getElementById('VuePageFrame');
      if (parentAppFrame) {
        parentAppFrame.className = 'VuePage';
        global.top.document.body.style.overflow = 'auto';
      }
      window.top.location.href = window.top.location.href.replace('/invoice-scanning', '');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "udCy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  count: 0,
  totalAmount: 0,
  currencyCode: null
});

/***/ }),

/***/ "uduW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_store__ = __webpack_require__("dgq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map_json__ = __webpack_require__("81Tg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__map_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_intercom__ = __webpack_require__("dmNr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_salesforce__ = __webpack_require__("CuX/");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing: 0 */






var User = {
  loginUrl: 'about:blank',
  email: ''
};
var sessionCheckTimer = null;
function logout(noRedirect) {
  var app = global.app;
  localStorage.removeItem('evedUser');
  localStorage.removeItem('evedUserCsrf');
  localStorage.removeItem('evedUserSettings');
  localStorage.removeItem('sessionSettings');
  localStorage.removeItem('eved-menu');
  localStorage.removeItem('eved-user');
  !noRedirect && app.$router.push({
    name: 'login'
  });
  if (app.$store) {
    app.$store.state.isLoggedIn = false;
    app.$store.state.csrf = null;
    app.$user.email = null;
    app.$user.$ = null;
    app.$notifications.removeAll();
  }
  __WEBPACK_IMPORTED_MODULE_2__components_store__["a" /* store */].commit('updateSessionValidity', false);
  !noRedirect && app.api.get(app.api.$.Logout);
  !noRedirect && app.api.get(app.api.$.logout);
  clearInterval(sessionCheckTimer);
  sessionCheckTimer = null;
  __WEBPACK_IMPORTED_MODULE_4__components_intercom__["a" /* default */].logout();
  __WEBPACK_IMPORTED_MODULE_5__components_salesforce__["a" /* default */].logout();
  if (app.$routerHistory) {
    app.$routerHistory.save(['/login']);
  }
  if (window.self !== window.top) {
    if (window.top.app && window.top.app.$router) {
      window.top.app.$router.push('/login?expired');
    }
  }
}
function login(credentials) {
  var _this = this;
  var app = global.app;
  if (credentials.sk) {
    return new Promise(function (resolve, reject) {
      _this.api.get(_this.api.$.login + "?sk=".concat(credentials.sk)).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
  return new Promise(function (resolve, reject) {
    app.api.post(app.api.$.login, credentials, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

/**
 * Bind authentication endpoint response to $user
 *
 * @desc Response object {r}
 * @property {string} sk                  - user token
 * @property {object} user                - user details
 * @property {string} username            - user email
 * @property {Array.<string>} permissions - user permissions
 * @property {Object.<Object>} modules    - user modules
 * @property {string} type                - user type
 * @property {string} subscription        - user subcription
 * @property {string} invoicePrefHidden   - user has accepted e360 terms
 * @property {int} isDell                 - user is from company Dell with ERP
 * @property {(string)number} domain      - user market type id: 1=buyer, 2=buyer/seller, 3=seller
 *
 * @property {string} error               - authentication error
 */
function _init(r, user, company) {
  var _this2 = this;
  this.$ = {};
  Object.keys(__WEBPACK_IMPORTED_MODULE_3__map_json___default.a).forEach(function (key) {
    _this2.$[key] = user[key] = r ? r[__WEBPACK_IMPORTED_MODULE_3__map_json___default.a[key]] : user[key];
  });
  this.$.data = this.$.data || {};
  this.$.settings = this.$.settings || company;
  this.email = r ? r[__WEBPACK_IMPORTED_MODULE_3__map_json___default.a.user].Email : user.email;
  __WEBPACK_IMPORTED_MODULE_2__components_store__["a" /* store */].dispatch('check');
  // store.dispatch('ping')
}
/* harmony default export */ __webpack_exports__["a"] = ({
  $: {
    get: function get() {
      return User;
    },
    default: User
  },
  logout: logout,
  get: function get() {
    return JSON.parse(global.localStorage.getItem('evedUser')) && _objectSpread(_objectSpread({}, JSON.parse(global.localStorage.getItem('evedUser')) || {}), {}, {
      settings: (JSON.parse(localStorage.getItem('sessionSettings')) || {}).CompanySettings || {},
      intercom_hash: (JSON.parse(localStorage.getItem('sessionSettings')) || {}).IntercomHMAC || ''
    });
  },
  getCompanySettings: function getCompanySettings() {
    return JSON.parse(global.localStorage.getItem('sessionSettings') || '{}').CompanySettings || {};
  },
  set: function set(v) {
    return global.localStorage.setItem('evedUser', JSON.stringify(v));
  },
  init: function init() {
    /** Setup user on Vue instance */
    Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype, '$user', {
      get: function get() {
        var user = this.$root.getUser || global.app.$user;
        user.logout = logout;
        user.login = login;
        user.init = function (response, authUser) {
          _init.call(user, response, authUser);
        };
        user.sessionSettings = JSON.parse(localStorage.getItem('sessionSettings'));
        user.settings = user.sessionSettings && user.sessionSettings.CompanySettings || {};
        return user;
      }
    });

    /** Init user with stored user */
    var authUser = JSON.parse(global.localStorage.getItem('evedUser'));
    var companySettings = (JSON.parse(localStorage.getItem('sessionSettings')) || {}).CompanySettings || {};
    if (authUser && authUser.token) {
      _init.call(User, null, authUser, companySettings);

      /** Once set up, start verifying session validity */
      // store.dispatch('ping')
    }
  },
  /**
   * Check token validity
   * at a set interval (10 minutes)
   */
  checkSession: function checkSession(commit) {
    var api = global.app.api;
    var intervalToCheck = 10 * 60 * 1000;
    var expires = global.app.$user.sessionSettings && global.app.$user.sessionSettings.Token ? getTokenExpiration(global.app.$user.sessionSettings.Token) : null;
    if (!expires) {
      return;
    }
    if (__WEBPACK_IMPORTED_MODULE_2__components_store__["a" /* store */].state.isLoggedIn) {
      __WEBPACK_IMPORTED_MODULE_2__components_store__["a" /* store */].commit('updateSessionValidity', true);
      sessionCheckTimer = setInterval(function () {
        ping(commit);
      }, intervalToCheck / 2);
    }
    function ping(commit) {
      var threshold = global.moment().add(intervalToCheck, 'millisecond');
      if (__WEBPACK_IMPORTED_MODULE_2__components_store__["a" /* store */].state.isLoggedIn && expires && expires.isBefore(threshold)) {
        api.post(api.$.settings.my.renew, null, {
          headers: {
            Authorization: "Bearer ".concat(global.app.$user.sessionSettings.Token)
          }
        }).then(function (response) {
          if (response) {
            __WEBPACK_IMPORTED_MODULE_2__components_store__["a" /* store */].commit('updateSessionValidity', true);
            global.localStorage.setItem('sessionSettings', JSON.stringify(_objectSpread(_objectSpread({}, global.app.$user.sessionSettings), {}, {
              Token: response.data.Token
            })));
            expires = getTokenExpiration(response.data.Token);
          } else {
            __WEBPACK_IMPORTED_MODULE_2__components_store__["a" /* store */].commit('updateSessionValidity', false);
          }
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_2__components_store__["a" /* store */].commit('updateSessionValidity', false);
        });
      } else {
        //
      }
    }
    function getTokenExpiration(token) {
      if (!token) {
        return null;
      }
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split("").map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      var decodedToken = JSON.parse(jsonPayload);
      return global.moment(decodedToken.exp * 1000);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "ueD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticStyle:{"margin-bottom":"10px"},attrs:{"button-class":_vm.buttonClass,"ids":_vm.ids,"disabled":_vm.disabled},on:{"click":function($event){_vm.showReject = true}}},[_vm._v("\n    Decline\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Decline Card Funding","show":_vm.showReject,"validation":"","primary-button":"Decline","primaryButtonClass":"btn btn-danger","modalEndpoint":_vm.api.$.evedpaycard.approveOrRejectCardFunding},on:{"close":function($event){_vm.showReject = false, _vm.rejectReason = ''},"confirm":function($event){return _vm.approveOrRejectCardFunding()},"validate":_vm.approveOrRejectCardFunding}},[_c('div',{staticClass:"reject-card-funding-overlay",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Provide a reason for declining the request funds.")]),_vm._v(" "),_c('label',[_vm._v("Reason")]),_vm._v(" "),_c('ed-input',{attrs:{"type":"text"},on:{"input":function (value) { return _vm.rejectReason = value; }},model:{value:(_vm.rejectReason),callback:function ($$v) {_vm.rejectReason=$$v},expression:"rejectReason"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "umJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isDeclined: function isDeclined() {
      return this.params.value.toLowerCase() === 'declined';
    },
    tooltipContent: function tooltipContent() {
      return !this.isDeclined ? this.params.value : this.getDecliningReason();
    }
  },
  methods: {
    getDecliningReason: function getDecliningReason() {
      return 'Declining Reason: ' + this.params.data.DeclineReason;
    }
  }
});

/***/ }),

/***/ "uovb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("zAeo");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0969384_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("WhMl");
function injectStyle (ssrContext) {
  __webpack_require__("XhLg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c0969384"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0969384_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "up34":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ "masked": _vm.masked },attrs:{"id":"app"}},[_c('div',{staticClass:"loading prefetch"}),_c('legacy-auth'),_c('md-notifications'),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ut3w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function getTimeArray(len) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var length = parseInt(len / step);
  return Array.apply(null, {
    length: length
  }).map(function (v, i) {
    return i * step;
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    startAt: null,
    endAt: null,
    value: null,
    show: Boolean,
    range: Boolean
  },
  data: function data() {
    var translation = this.$parent.translation;
    var minuteStep = this.$parent.minuteStep;
    var times = [getTimeArray(24, 1), getTimeArray(60, minuteStep || 1)];
    if (minuteStep === 0) {
      times.push(getTimeArray(60, 1));
    }
    return {
      months: translation.months,
      dates: [],
      years: [],
      now: new Date(),
      currentPanel: 'date',
      times: times
    };
  },
  computed: {
    days: function days() {
      var days = this.$parent.translation.days;
      var firstday = +this.$parent.firstDayOfWeek;
      return days.concat(days).slice(firstday, firstday + 7);
    },
    currentYear: function currentYear() {
      return this.now.getFullYear();
    },
    currentMonth: function currentMonth() {
      return this.now.getMonth();
    },
    curHour: function curHour() {
      return this.now.getHours();
    },
    curMinute: function curMinute() {
      return this.now.getMinutes();
    },
    curSecond: function curSecond() {
      return this.now.getSeconds();
    }
  },
  created: function created() {
    this.updateCalendar();
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.currentPanel = 'date';
        this.updateNow();
      }
    },
    value: {
      handler: 'updateNow',
      immediate: true
    },
    now: 'updateCalendar'
  },
  filters: {
    timeText: function timeText(value) {
      return ('00' + value).slice(String(value).length);
    }
  },
  methods: {
    updateNow: function updateNow() {
      this.now = this.value ? new Date(this.value) : new Date();
    },
    updateCalendar: function updateCalendar() {
      function getCalendar(time, firstday, length, classes) {
        return Array.apply(null, {
          length: length
        }).map(function (v, i) {
          // eslint-disable-line
          var day = firstday + i;
          var date = new Date(time.getFullYear(), time.getMonth(), day, 0, 0, 0);
          date.setDate(day);
          return {
            title: date.toLocaleDateString(),
            date: date,
            day: day,
            classes: classes
          };
        });
      }
      var firstDayOfWeek = this.$parent.firstDayOfWeek;
      var time = new Date(this.now);
      time.setDate(0);
      var lastMonthLength = (time.getDay() + 7 - firstDayOfWeek) % 7 + 1;
      var lastMonthfirst = time.getDate() - (lastMonthLength - 1);
      var lastMonth = getCalendar(time, lastMonthfirst, lastMonthLength, 'lastMonth');
      time.setMonth(time.getMonth() + 2, 0); // 切换到这个月最后一天
      var curMonthLength = time.getDate();
      var curMonth = getCalendar(time, 1, curMonthLength, 'curMonth');
      time.setMonth(time.getMonth() + 1, 1);
      var nextMonthLength = 42 - (lastMonthLength + curMonthLength);
      var nextMonth = getCalendar(time, 1, nextMonthLength, 'nextMonth');
      var index = 0;
      var resIndex = 0;
      var arr = lastMonth.concat(curMonth, nextMonth);
      var result = new Array(6);
      while (index < 42) {
        result[resIndex++] = arr.slice(index, index += 7);
      }
      this.dates = result;
    },
    getDateClasses: function getDateClasses(cell) {
      var classes = [];
      var cellTime = new Date(cell.date).setHours(0, 0, 0, 0);
      var cellEndTime = new Date(cell.date).setHours(23, 59, 59, 999);
      var curTime = this.value ? new Date(this.value).setHours(0, 0, 0, 0) : 0;
      var startTime = this.startAt ? new Date(this.startAt).setHours(0, 0, 0, 0) : 0;
      var endTime = this.endAt ? new Date(this.endAt).setHours(0, 0, 0, 0) : 0;
      var today = new Date().setHours(0, 0, 0, 0);
      if (this.$parent.disabledDays.some(function (v) {
        return +new Date(v) === +cell.date;
      }) || this.$parent.notBefore !== '' && cellEndTime < new Date(this.$parent.notBefore).getTime() || this.$parent.notAfter !== '' && cellTime > new Date(this.$parent.notAfter).getTime()) {
        return 'disabled';
      }
      classes.push(cell.classes);
      if (cellTime === today) {
        classes.push('today');
      }

      // range classes
      if (global.moment(cell.date).format('YYYY-MM-DD') === global.moment(this.value).format('YYYY-MM-DD')) {
        classes.push('current');
      } else if (startTime) {
        if (cellTime < startTime) {
          classes.push('disabled');
        } else if (curTime && cellTime <= curTime) {
          classes.push('inrange');
        }
      } else if (endTime) {
        if (cellTime > endTime) {
          classes.push('disabled');
        } else if (curTime && global.moment(this.value).isBefore(global.moment(cell.date))) {
          classes.push('inrange');
        }
      }
      return classes.join(' ');
    },
    getTimeClasses: function getTimeClasses(value, index) {
      var curValue;
      var cellTime;
      var startTime = this.startAt ? new Date(this.startAt) : 0;
      var endTime = this.endAt ? new Date(this.endAt) : 0;
      var classes = [];
      switch (index) {
        case 0:
          curValue = this.curHour;
          cellTime = new Date(this.now).setHours(value);
          break;
        case 1:
          curValue = this.curMinute;
          cellTime = new Date(this.now).setMinutes(value);
          break;
        case 2:
          curValue = this.curSecond;
          cellTime = new Date(this.now).setSeconds(value);
          break;
      }
      if (this.$parent.notBefore !== '' && cellTime < new Date(this.$parent.notBefore).getTime() || this.$parent.notAfter !== '' && cellTime > new Date(this.$parent.notAfter).getTime()) {
        return 'disabled';
      }
      if (value === curValue) {
        classes.push('cur-time');
      } else if (startTime) {
        if (cellTime < startTime) {
          classes.push('disabled');
        }
      } else if (endTime) {
        if (cellTime > endTime) {
          classes.push('disabled');
        }
      }
      return classes.join(' ');
    },
    showMonths: function showMonths() {
      if (this.currentPanel === 'months') {
        this.currentPanel = 'date';
      } else {
        this.currentPanel = 'months';
      }
    },
    showYears: function showYears() {
      if (this.currentPanel === 'years') {
        this.currentPanel = 'date';
      } else {
        var firstYear = Math.floor(this.now.getFullYear() / 10) * 10;
        var years = [];
        for (var i = 0; i < 10; i++) {
          years.push(firstYear + i);
        }
        this.years = years;
        this.currentPanel = 'years';
      }
    },
    changeYear: function changeYear(flag) {
      if (this.currentPanel === 'years') {
        this.years = this.years.map(function (v) {
          return v + flag * 10;
        });
      } else {
        var now = new Date(this.now);
        now.setFullYear(now.getFullYear() + flag, now.getMonth(), 1);
        this.now = now;
      }
    },
    changeMonth: function changeMonth(flag) {
      var now = new Date(this.now);
      now.setMonth(now.getMonth() + flag, 1);
      this.now = now;
    },
    selectDate: function selectDate(cell) {
      var _this = this;
      var classes = this.getDateClasses(cell);
      if (classes.indexOf('disabled') !== -1) {
        return;
      }
      var date = new Date(cell.date);
      if (this.$parent.type === 'datetime') {
        if (this.value instanceof Date) {
          date.setHours(this.value.getHours(), this.value.getMinutes(), this.value.getSeconds());
        }
        if (this.startAt && date.getTime() < new Date(this.startAt).getTime()) {
          date = new Date(this.startAt);
        } else if (this.endAt && date.getTime() > new Date(this.endAt).getTime()) {
          date = new Date(this.endAt);
        }
        this.currentPanel = 'time';
        this.$nextTick(function () {
          Array.prototype.forEach.call(_this.$el.querySelectorAll('.cur-time'), function (el) {
            el.scrollIntoView();
          });
        });
      }
      this.now = date;
      this.$emit('input', global.moment(date).format('YYYY-MM-DD'));
      this.$emit('select');
    },
    selectYear: function selectYear(year) {
      var now = new Date(this.now);
      now.setFullYear(year);
      this.now = now;
      this.currentPanel = 'months';
    },
    selectMonth: function selectMonth(month) {
      var now = new Date(this.now);
      now.setMonth(month);
      this.now = now;
      this.currentPanel = 'date';
    },
    selectTime: function selectTime(value, index) {
      var classes = this.getTimeClasses(value, index);
      if (classes.indexOf('disabled') !== -1) {
        return;
      }
      var date = new Date(this.now);
      if (index === 0) {
        date.setHours(value);
      } else if (index === 1) {
        date.setMinutes(value);
      } else if (index === 2) {
        date.setSeconds(value);
      }
      this.now = date;
      this.$emit('input', date);
      this.$emit('select');
    },
    selectToday: function selectToday() {
      this.selectDate({
        date: new Date()
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "v/Ma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* eslint spec-file: 0 */

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    editMode: function editMode() {
      return this.$route.params.page === 'edit';
    }
  }
});

/***/ }),

/***/ "v17H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("Usg1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: Object,
    eventHub: Object
  },
  data: function data() {
    return {
      show: true,
      reason: this.model.Reason,
      displayReasonError: false
    };
  },
  computed: {
    title: function title() {
      return this.model.IsSameDayDeposit ? 'Request Rush Payment - ' + utils.constants.invoice.SameDayLabel : 'Request Rush Payment';
    }
  },
  methods: {
    onClose: function onClose() {
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit('closeRushPayment', this.model.InitialDueDate);
      this.show = false;
      this.displayReasonError = false;
    },
    onSave: function onSave() {
      if (!this.isValid()) return;
      this.model.Reason = (this.reason || '').trim();
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["b" /* EventBus */].$emit('saveRushPayment', this.model.Reason);
      this.show = false;
    },
    reasonChanged: function reasonChanged() {
      if (this.displayReasonError) {
        this.isValid();
      }
    },
    isValid: function isValid() {
      this.updateReasonErrorAttribute(false);
      if ((this.reason || '').trim() === '') {
        this.updateReasonErrorAttribute(true);
        return false;
      }
      return true;
    },
    updateReasonErrorAttribute: function updateReasonErrorAttribute(val) {
      if (this.$refs.reasonText && this.$refs.reasonText.$el.children[1]) {
        if (val) {
          this.displayReasonError = true;
          this.$refs.reasonText.$el.children[1].setAttribute('error', val);
        } else {
          this.displayReasonError = false;
          this.$refs.reasonText.$el.children[1].removeAttribute('error');
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "v3UP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"column col-md-2"},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('div',{staticClass:"multiple-rows"},[_vm._v(" "+_vm._s(_vm.Description)+" ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('label',[_vm._v("Internal Note")]),_vm._v(" "),_c('div',{staticClass:"multiple-rows"},[_vm._v(" "+_vm._s(_vm.InternalNote)+" ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('label',[_vm._v("Unit")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.UnitType))]),_vm._v(" "),_c('p')]),_vm._v(" "),(_vm.showBUCCCategColumn)?_c('span',[(_vm.showMixBusinessUnitAndCostCenter || _vm.useBUAndCCSetting)?_c('span',{staticClass:"column col-md-2 wrap"},[_c('label',[_vm._v("Business Unit and Cost Center")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.BusinessUnitAndCostCenter))]),_vm._v(" "),_c('p')]):_c('span',{staticClass:"column col-md-2"},[(_vm.hasBusinessUnitSetting)?_c('span',[_c('label',[_vm._v("Business Unit")]),_vm._v(" "),_c('div',{staticClass:"multiple-rows"},[_vm._v(_vm._s(_vm.BU))]),_vm._v(" "),_c('p')]):_vm._e(),_vm._v(" "),(_vm.hasCostCenterSetting)?_c('span',[_c('label',[_vm._v("Cost Center")]),_vm._v(" "),_c('div',{staticClass:"multiple-rows"},[_vm._v(_vm._s(_vm.CC))]),_vm._v(" "),_c('p')]):_vm._e(),_vm._v(" "),(this.model.isFeeDiscountItem === false)?_c('div',{staticClass:"row"},[_c('span',{staticClass:"col-md-5"},[_c('label',[_vm._v("Category Ref ID")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"multiple-rows"},[_vm._v(_vm._s(_vm.CategoryRefId))]),_vm._v(" "),_c('p')])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showSavingsFields)?_c('span',{staticClass:"column col-md-2"},[_c('label',[_vm._v("Rates")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('span',{staticClass:"col-md-5"},[_vm._v("SGR")]),_vm._v(" "),_c('v-money',{staticClass:"col-md-7 text-right",attrs:{"supplementalPrecision":_vm.supplementalPrecision}},[_vm._v(_vm._s(_vm.model.unitPriceSGR))]),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',{staticClass:"col-md-5"},[_vm._v("Preferred")]),_vm._v(" "),_c('v-money',{staticClass:"col-md-7 text-right",attrs:{"supplementalPrecision":_vm.supplementalPrecision}},[_vm._v(_vm._s(_vm.model.unitPricePreferredRate))]),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',{staticClass:"col-md-5"},[_vm._v("Negotiated")]),_vm._v(" "),_c('v-money',{staticClass:"col-md-7 text-right",attrs:{"supplementalPrecision":_vm.supplementalPrecision}},[_vm._v(_vm._s(_vm.model.unitPriceNegotiatedRate))]),_vm._v(" "),_c('p')],1)]):_vm._e(),_vm._v(" "),_c('span',{class:_vm.taxesAndFeesClass},[_c('label',[_vm._v("Taxes")]),_vm._v(" "),(_vm.existsAtLeastOneTax)?_c('div',{staticClass:"row"},_vm._l((_vm.allTaxes),function(tax){return _c('span',{key:tax.name},[(_vm.showValue(tax.value) && tax.isChecked)?_c('div',[_c('span',{staticClass:"col-md-5"},[_vm._v(_vm._s(tax.name))]),_vm._v(" "),_c('v-money',{staticClass:"col-md-7 text-right"},[_vm._v(_vm._s(tax.value))])],1):_vm._e()])}),0):_c('div',[_vm._v("\n      None\n    ")]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('span',{class:_vm.taxesAndFeesClass},[_c('label',[_vm._v("Fees")]),_vm._v(" "),(_vm.existsAtLeastOneFee)?_c('div',{staticClass:"row"},_vm._l((_vm.model.fees),function(fee){return _c('span',{key:fee.name},[(_vm.showValue(fee.value))?_c('div',[_c('span',{staticClass:"col-md-5"},[_vm._v(_vm._s(fee.name))]),_vm._v(" "),_c('v-money',{staticClass:"col-md-7 text-right"},[_vm._v(_vm._s(fee.value))])],1):_vm._e()])}),0):_c('div',[_vm._v("\n      None\n    ")])]),_vm._v(" "),_c('span',{staticClass:"col-md-2"},[_c('label',[_vm._v("Discounts")]),_vm._v(" "),(_vm.discountExists)?_c('div',[_c('v-money',[_vm._v(_vm._s(-_vm.model.discountAmount))])],1):_c('div',[_vm._v("\n      None\n    ")]),_vm._v(" "),_c('p')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v4a3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v6dw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fileUploadField_vue__ = __webpack_require__("NWtK");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ebcbb57_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_fileUploadField_vue__ = __webpack_require__("C1Tj");
function injectStyle (ssrContext) {
  __webpack_require__("EiP9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fileUploadField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ebcbb57_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_fileUploadField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "v84C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{attrs:{"name":"Programs & Events","desc":"Create and manage your programs and events","search":"","endpoint":_vm.api.$.program.list,"filter":_vm.defaultFilter,"alias":"programGrid"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v86b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestPhysicalCard_vue__ = __webpack_require__("JNij");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cecb35c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestPhysicalCard_vue__ = __webpack_require__("w++6");
function injectStyle (ssrContext) {
  __webpack_require__("r4F+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cecb35c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestPhysicalCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cecb35c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestPhysicalCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v88T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_1Rke-WaBxgTgojYTK_YUmX","Dell":"_2ozyxc0gfXbkTNs1loOJaC","Abbott":"atOzzFHlHQY4vQSQ1SD5B","Gap":"_3USKJse5a_mTATjg3vTcwd","Allstate":"_1Vc4hyuPZR9tlqAibEOFsN","Asurion":"_3qHXsMelRikhsqh4BB7UKe","Invitae":"_g4yIdEuwKdcDvOdYGN27","JWE":"_1RM2AShjlUa9_UsDancmEh"};

/***/ }),

/***/ "v90g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/* harmony default export */ __webpack_exports__["a"] = ({
  track: function track(category, action, label, value) {
    if (global.ga) {
      global.ga('send', 'event', category, action, label, value);
    }
  },
  setup: function setup() {
    //
    if (global.ga) {
      global.ga('create', "UA-6992574-5", 'auto');
    }
  },
  init: function init() {
    // Init snippet
    (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
      };
      i[r].l = 1 * new Date();
      a = s.createElement(o);
      m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "vEJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suppliers_remit_payment_vue__ = __webpack_require__("AfI8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f05f91d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suppliers_remit_payment_vue__ = __webpack_require__("Nie0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suppliers_remit_payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f05f91d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suppliers_remit_payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vF8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


var VISIBILITY_MINUTES = 5;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      state: 'INITIAL',
      sending: false,
      verifying: false,
      canResend: false,
      hideResend: false,
      codeExhausted: false,
      otpErrorMessage: '',
      deliveryMethod: '',
      resendCountdown: 30,
      resendTimer: null,
      cardDetails: {},
      cardAddress: null,
      loadingAddress: false,
      timeLeft: VISIBILITY_MINUTES * 60,
      visibilityTimer: null,
      visibilityChangeHandler: null,
      warningShown: false,
      revealedAt: 0
    };
  },
  computed: {
    revealed: function revealed() {
      return this.state === 'REVEALED';
    },
    formattedCardNumber: function formattedCardNumber() {
      var num = this.cardDetails.CardNumber || '';
      return num.replace(/(.{4})/g, '$1 ').trim();
    },
    otpInstructionMessage: function otpInstructionMessage() {
      return 'To see your card number click the button and you will receive a one-time passcode via text message or email.';
    },
    otpPasscodeHint: function otpPasscodeHint() {
      if (this.deliveryMethod === 'sms') {
        return 'Enter the one-time passcode that you received via text message.';
      }
      if (this.deliveryMethod === 'email') {
        return 'Enter the one-time passcode that you received via email.';
      }
      return 'Enter the one-time passcode that you received.';
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    // Override in component to return the card ID
    getCardId: function getCardId() {
      throw new Error('getCardId() must be implemented by the component');
    },
    // Override in component to return the 6-digit passcode string
    getPasscode: function getPasscode() {
      throw new Error('getPasscode() must be implemented by the component');
    },
    // Override in component to clear the passcode input
    resetPasscodeInput: function resetPasscodeInput() {
      // default no-op, override in component
    },
    // Override in component to return the account ID for address fetch
    getAccountId: function getAccountId() {
      return null;
    },
    fetchAddress: function fetchAddress(accountId) {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!accountId) {
                _context.next = 15;
                break;
              }
              _this.loadingAddress = true;
              _context.prev = 2;
              _context.next = 5;
              return _this.api.get("evedpaycards/accounts/".concat(accountId, "/get-address"));
            case 5:
              response = _context.sent;
              if (response.status === 200) {
                _this.cardAddress = response.data;
              }
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
            case 12:
              _context.prev = 12;
              _this.loadingAddress = false;
              return _context.finish(12);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 9, 12, 15]]);
      }))();
    },
    sendOtp: function sendOtp() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, message;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this2.getCardId()) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this2.sending = true;
              _context2.prev = 3;
              _context2.next = 6;
              return _this2.api.post("".concat(_this2.api.$.evedpaycard.requestCardOtp, "/").concat(_this2.getCardId()), {
                preventError: true
              });
            case 6:
              response = _context2.sent;
              if (response.data && response.data.DeliveryMethod) {
                _this2.deliveryMethod = response.data.DeliveryMethod;
              }
              _this2.state = 'ENTER_CODE';
              _this2.resetPasscodeInput();
              _this2.codeExhausted = false;
              _this2.hideResend = false;
              _this2.otpErrorMessage = '';
              _this2.startResendCooldown();
              _this2.focusPasscodeInput();
              _context2.next = 21;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](3);
              message = _this2.getErrorMessage(_context2.t0);
              if (_context2.t0.response && _context2.t0.response.status === 429 && message.indexOf('15 minutes') !== -1) {
                if (_this2.state === 'ENTER_CODE') {
                  _this2.otpErrorMessage = message;
                  _this2.hideResend = true;
                  _this2.codeExhausted = true;
                } else {
                  _this2.showError(_context2.t0);
                }
              } else {
                _this2.showError(_context2.t0);
              }
            case 21:
              _context2.prev = 21;
              _this2.sending = false;
              return _context2.finish(21);
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 17, 21, 24]]);
      }))();
    },
    // Override in component to focus the passcode input (called after send and after verify failure)
    focusPasscodeInput: function focusPasscodeInput() {},
    resendOtp: function resendOtp() {
      if (this.canResend) {
        this.sendOtp();
      }
    },
    startResendCooldown: function startResendCooldown() {
      var _this3 = this;
      this.canResend = false;
      this.resendCountdown = 30;
      clearInterval(this.resendTimer);
      this.resendTimer = setInterval(function () {
        _this3.resendCountdown--;
        if (_this3.resendCountdown <= 0) {
          _this3.canResend = true;
          clearInterval(_this3.resendTimer);
        }
      }, 1000);
    },
    verifyOtp: function verifyOtp() {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var passcode, response, message;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              passcode = _this4.getPasscode();
              if (!(passcode.length < 6)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _this4.verifying = true;
              _context3.prev = 4;
              _context3.next = 7;
              return _this4.api.post("".concat(_this4.api.$.evedpaycard.verifyCardOtp, "/").concat(_this4.getCardId()), {
                code: passcode,
                preventError: true
              });
            case 7:
              response = _context3.sent;
              _this4.cardDetails = response.data;
              _this4.state = 'REVEALED';
              _this4.fetchAddress(_this4.getAccountId());
              _this4.startVisibilityTimer();
              _context3.next = 20;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](4);
              message = _this4.getErrorMessage(_context3.t0);
              if (_context3.t0.response && _context3.t0.response.status === 429) {
                if (message.indexOf('Resend Code') !== -1) {
                  _this4.codeExhausted = true;
                  _this4.otpErrorMessage = message;
                  _this4.canResend = true;
                  _this4.hideResend = false;
                  clearInterval(_this4.resendTimer);
                } else {
                  _this4.otpErrorMessage = message;
                  _this4.hideResend = true;
                  _this4.codeExhausted = true;
                }
              } else {
                _this4.showError(_context3.t0);
                if (_context3.t0.response && _context3.t0.response.status === 410) {
                  _this4.state = 'INITIAL';
                }
              }
              _this4.resetPasscodeInput();
              _this4.focusPasscodeInput();
            case 20:
              _context3.prev = 20;
              _this4.verifying = false;
              return _context3.finish(20);
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[4, 14, 20, 23]]);
      }))();
    },
    startVisibilityTimer: function startVisibilityTimer() {
      var _this5 = this;
      clearInterval(this.visibilityTimer);
      // Defensive: remove any existing listener before attaching a new one
      if (this.visibilityChangeHandler) {
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
        this.visibilityChangeHandler = null;
      }
      this.revealedAt = Date.now();
      this.timeLeft = VISIBILITY_MINUTES * 60;
      this.warningShown = false;

      // Hide immediately when the tab becomes visible again if the timeout already elapsed.
      // setInterval is throttled/paused in inactive tabs, so it cannot be relied on alone.
      this.visibilityChangeHandler = function () {
        if (document.visibilityState === 'visible') {
          var elapsed = Math.floor((Date.now() - _this5.revealedAt) / 1000);
          if (elapsed >= VISIBILITY_MINUTES * 60) {
            clearInterval(_this5.visibilityTimer);
            _this5.resetOtpState();
          }
        }
      };
      document.addEventListener('visibilitychange', this.visibilityChangeHandler);
      this.visibilityTimer = setInterval(function () {
        var elapsed = Math.floor((Date.now() - _this5.revealedAt) / 1000);
        _this5.timeLeft = Math.max(0, VISIBILITY_MINUTES * 60 - elapsed);
        if (_this5.timeLeft <= 120 && !_this5.warningShown && _this5.timeLeft > 0) {
          _this5.warningShown = true;
          _this5.$notifications.notify({
            message: 'Card details will be hidden soon.',
            type: 'plain',
            icon: 'exclamation-triangle',
            timeout: 5000,
            placement: {
              from: 'top',
              align: 'center'
            }
          });
        }
        if (_this5.timeLeft <= 0) {
          clearInterval(_this5.visibilityTimer);
          _this5.resetOtpState();
          _this5.$notifications.notify({
            message: 'Card details hidden — time expired.',
            type: 'plain',
            icon: 'times-octagon',
            timeout: 5000,
            placement: {
              from: 'top',
              align: 'center'
            }
          });
        }
      }, 1000);
    },
    resetOtpState: function resetOtpState() {
      this.clearTimers();
      this.state = 'INITIAL';
      this.cardDetails = {};
      this.cardAddress = null;
      this.resetPasscodeInput();
      this.canResend = false;
      this.hideResend = false;
      this.codeExhausted = false;
      this.otpErrorMessage = '';
      this.deliveryMethod = '';
    },
    copyCardNumber: function copyCardNumber() {
      var _this6 = this;
      var num = this.cardDetails.CardNumber || '';
      navigator.clipboard.writeText(num).then(function () {
        _this6.$notifications.notify({
          message: 'Card number copied.',
          type: 'info',
          timeout: 2000,
          placement: {
            from: 'top',
            align: 'center'
          }
        });
      }).catch(function () {
        _this6.$notifications.notify({
          message: 'Unable to copy. Please copy manually.',
          type: 'info',
          timeout: 2000,
          placement: {
            from: 'top',
            align: 'center'
          }
        });
      });
    },
    clearTimers: function clearTimers() {
      clearInterval(this.resendTimer);
      clearInterval(this.visibilityTimer);
      if (this.visibilityChangeHandler) {
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
        this.visibilityChangeHandler = null;
      }
    },
    getErrorMessage: function getErrorMessage(error) {
      if (error.response && error.response.data && error.response.data.length) {
        return error.response.data[0].Message || '';
      }
      return '';
    },
    showError: function showError(error) {
      var message = 'Something went wrong. Please try again.';
      var extracted = this.getErrorMessage(error);
      if (extracted) {
        message = extracted;
      } else if (!error.response) {
        message = "We couldn't verify the code. Check your connection and try again.";
      }
      this.$notifications.notify({
        message: message,
        type: 'plain',
        icon: 'times-octagon',
        timeout: 5000,
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    }
  }
});

/***/ }),

/***/ "vFKZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_info_vue__ = __webpack_require__("JTu4");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb89e94_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_info_vue__ = __webpack_require__("i4M7");
function injectStyle (ssrContext) {
  __webpack_require__("GIZD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bb89e94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb89e94_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vGgY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navless_vue__ = __webpack_require__("evZZ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65090f7a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_navless_vue__ = __webpack_require__("xFcj");
function injectStyle (ssrContext) {
  __webpack_require__("gII9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65090f7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navless_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65090f7a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_navless_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vJB6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("bJnc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_609197db_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("1kRI");
function injectStyle (ssrContext) {
  __webpack_require__("mil4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_609197db_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vKsb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("9AbB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2269eb32_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("oXkD");
function injectStyle (ssrContext) {
  __webpack_require__("oML2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2269eb32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2269eb32_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vZ0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bundles_pack__ = __webpack_require__("Mb0Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__docs_pack__ = __webpack_require__("zUEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_legacy_auth__ = __webpack_require__("mnjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_store__ = __webpack_require__("dgq6");
/**
 * Application modules are split into bundles
 * 3 modes provided - bundles.[mode]
 *
 * `all` - one bundle containing all modules
 * `pack` - one or several modules grouped into several bundles (lazy loaded)
 * `lazy` - each module with it's own bundle (lazy loaded)
 *
 */





var allowedComponents = __WEBPACK_IMPORTED_MODULE_2__core_legacy_auth__["a" /* default */].allowedComponents,
  allowedModules = __WEBPACK_IMPORTED_MODULE_2__core_legacy_auth__["a" /* default */].allowedModules;
function init() {
  //
  var user = __WEBPACK_IMPORTED_MODULE_3__components_store__["a" /* store */].state.isLoggedIn;
  user && allowedModules();
  var modules = {
    __get: init
  };
  if (global.config && global.config.namespace === 'docs') {
    // documentation
    modules = __WEBPACK_IMPORTED_MODULE_1__docs_pack__["a" /* default */].pack(eventHandler);
  } else {
    // main app modules
    var bundleEnum = Object.keys(__WEBPACK_IMPORTED_MODULE_0__bundles_pack__["a" /* default */]);
    bundleEnum.forEach(function (module) {
      var alias = __WEBPACK_IMPORTED_MODULE_0__bundles_pack__["a" /* default */][module] && __WEBPACK_IMPORTED_MODULE_0__bundles_pack__["a" /* default */][module].module && __WEBPACK_IMPORTED_MODULE_0__bundles_pack__["a" /* default */][module].module.alias || __WEBPACK_IMPORTED_MODULE_0__bundles_pack__["a" /* default */][module] && __WEBPACK_IMPORTED_MODULE_0__bundles_pack__["a" /* default */][module].alias || module;
      var Module = modules[alias] = __WEBPACK_IMPORTED_MODULE_0__bundles_pack__["a" /* default */][module];
      if (module !== 'lazy' && modules[alias]) {
        modules[alias].on = eventHandler;
      }
      if (Module && Module.pack && user) {
        var mergedPack = Object.assign({}, Module.pack, allowedComponents[alias].pack);
        // const packEnum = Object.keys(Module.pack)
        // const packEnum = Object.keys(allowedComponents[alias].pack)
        var packEnum = Object.keys(mergedPack);
        packEnum.forEach(function (module) {
          var _module = allowedComponents[alias].pack[module];
          var key = _module ? _module.name : module;
          var defaultModule = ~key.indexOf('#');
          key = key.replace('#', '');
          var legacy = key[0] !== key[0].toLowerCase();
          var notAllowed = allowedComponents[alias].pack[module] && allowedComponents[alias].pack[module].notAllowed;
          if (Module.pack[key]) {
            if (legacy) {
              Module.pack[key].legacy = true;
            }
            Module.pack[key].notAllowed = notAllowed;
            if (defaultModule) Module.pack[key].defaultModule = true;
            modules[key] = Module.pack[key];
            modules[key].on = eventHandler;
          }
        });
      }
    });
  }
  return modules;
}
function eventHandler(event, callback) {
  var _module = this.module || this;
  switch (event) {
    case 'beforeLoad':
      if (typeof _module === 'function') {
        _module.resolved || callback.call(_module());
      }
      break;
    case 'afterLoad':
      if (typeof _module === 'function' && _module().then) {
        _module().then(function (value) {
          return _module.resolved && callback.call(value);
        });
      } else {
        // TODO:
        // callback.call(_module)
      }
      break;
  }
  return this;
}
/* harmony default export */ __webpack_exports__["a"] = (init());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "vm9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fundingAmount: '',
      errorMessage: 'The amount cannot be greater than the current balance'
    };
  },
  props: {
    balance: 0,
    addFundsError: Boolean
  }
});

/***/ }),

/***/ "vs3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__ = __webpack_require__("HMpe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_lang__ = __webpack_require__("pe4m");



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import throttle from 'lodash/throttle'


var SEARCH_DEBOUNCE = 300;
var PAGE_SIZE = 20;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-select-list',
  props: {
    fieldLabel: String,
    description: String,
    searchable: Boolean,
    emptyFieldLabel: Boolean,
    hideOptional: Boolean,
    readonly: Boolean,
    required: Boolean,
    value: Array,
    endpoint: String,
    trackBy: {
      type: String,
      default: 'key'
    },
    label: {
      type: String,
      default: 'label'
    },
    pageSize: {
      type: Number,
      default: PAGE_SIZE
    },
    params: {},
    helptipHeader: String,
    helptipBody: String,
    error: Boolean
  },
  computed: {
    filteredList: function filteredList() {
      var _this = this;
      this.updatePs();
      return this.options.filter(function (item) {
        return item.label.toLowerCase().includes(_this.search.toLowerCase());
      });
    },
    selectedList: function selectedList() {
      return this.internalValue.filter(function (item) {
        return item.status;
      });
    },
    selectedFilteredList: function selectedFilteredList() {
      var _this2 = this;
      this.updatePs();
      return this.selectedList.filter(function (item) {
        return item.label.toLowerCase().includes(_this2.search.toLowerCase());
      });
    },
    selectedCount: function selectedCount() {
      return this.selectedList.length;
    }
  },
  data: function data() {
    var _this3 = this;
    return {
      search: '',
      offset: 0,
      pending: false,
      isShowAll: true,
      isSelected: false,
      minChars: 2,
      options: [],
      internalValue: this.value.map(function (item) {
        return {
          key: item[_this3.trackBy],
          label: item[_this3.label] || '[no name]',
          status: true,
          isDisabled: item.IsDisabled
        };
      })
    };
  },
  methods: {
    t: function t(key) {
      return __WEBPACK_IMPORTED_MODULE_5__lang_lang__["a" /* i18n */].t(key);
    },
    updateModel: function updateModel(e) {
      // this.$emit('input', e)
    },
    setModel: function setModel(e) {
      var _this4 = this;
      e.status ? this.internalValue.push(e) : this.internalValue.splice(this.internalValue.findIndex(function (item) {
        return item.key === e.key;
      }), 1);

      //
      this.options = this.options.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          status: _this4.internalValue.filter(function (i) {
            return i.key === item.key;
          }).length > 0
        });
      });
      this.$emit('select', e);
      this.$emit('input', this.internalValue.map(function (item) {
        return item.key;
      }));
    },
    showAll: function showAll() {
      this.isShowAll = true;
      this.isSelected = false;
      this.updatePs();
    },
    showSelected: function showSelected() {
      this.isSelected = true;
      this.isShowAll = false;
      this.updatePs();
    },
    updatePs: function updatePs() {
      var _this5 = this;
      this.$nextTick(function () {
        _this5.ps.update();
      });
    },
    debounceSearching: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function (reset) {
      if (typeof this.minChars === 'number') {
        this.search.length >= this.minChars && this.asyncSearch(this.search, reset ? 0 : undefined);
        if (this.search === '') {
          this.options = [];
          this.asyncSearch('', 0, this.pageSize, false, true);
        }
      } else {
        //
      }
    }, SEARCH_DEBOUNCE),
    asyncSearch: function asyncSearch(query, offset, size, scrolling, reset) {
      var _this6 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this6.pending && reset !== true)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _this6.pending = true;
              _context.next = 5;
              return _this6.api.forms.post(_this6.endpoint, {
                search: {
                  value: query
                },
                start: typeof offset !== 'undefined' ? offset : _this6.offset,
                length: size || _this6.pageSize,
                params: _this6.params
              });
            case 5:
              result = _context.sent;
              if (!(result && result.data && result.data.Data)) {
                _context.next = 12;
                break;
              }
              if (result.data.Data.length) {
                _context.next = 10;
                break;
              }
              _this6.pending = false;
              return _context.abrupt("return");
            case 10:
              if (result.data.Data[0] && _this6.options.findIndex(function (item) {
                return item.key === result.data.Data[0][_this6.trackBy];
              }) > -1) {
                _this6.options = [];
              }
              _this6.options = _this6.options.concat(result.data.Data.map(function (item) {
                return {
                  key: item[_this6.trackBy],
                  label: item[_this6.label] || '[no name]',
                  status: _this6.internalValue.filter(function (option) {
                    return option.key === item[_this6.trackBy];
                  }).length > 0,
                  isDisabled: item.IsDisabled
                };
              })) || _this6.options;
            case 12:
              _this6.pending = false;
              if (scrolling) {
                _this6.offset += _this6.pageSize;
              }
              _this6.updatePs();
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    loadMore: function loadMore(e) {
      if (this.ps.reach.y === 'end') {
        this.asyncSearch(this.search, this.offset, this.pageSize, true);
      }
    }
  },
  created: function created() {
    this.asyncSearch('', 0, this.pageSize, true);
    this.internalValue && this.internalValue.length > 0 && this.$emit('input', this.internalValue.map(function (item) {
      return item.key;
    }));
  },
  mounted: function mounted() {
    var viewport = this.$el.querySelector('.body-wrapper');
    this.ps = new __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__["a" /* default */](viewport, {
      minScrollbarLength: 20,
      mouseWheelSpeed: 30,
      wheelPropagation: false
    });
    viewport.addEventListener('scroll', this.loadMore);
  },
  beforeDestroy: function beforeDestroy() {
    var viewport = this.$el.querySelector('.body-wrapper');
    viewport.removeEventListener('scroll', this.loadMore);
  }
});

/***/ }),

/***/ "vuCG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2cKTpJm3TATDbH1aedJoVp","Dell":"_1TulKgHAqgdVjZLShR6hbj","Abbott":"_1rMdTvKe7NjstA_IJliRHv","Gap":"_3Ia4ipf-Vkco3ssWyFLfTq","Allstate":"_17M5E3Y5kyG2nnXhirZCMs","Asurion":"qynw4vzCRMQKtf2cx5JCZ","Invitae":"_1um2T-3BSpLvOT9ZBX9hZ-","JWE":"_2VEadmw7XHhrW-_EQhZCcs"};

/***/ }),

/***/ "vuhK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"i2p-new-page"},[_c('ed-title-nav',{attrs:{"title":'Reverse AP File',"subtitle":''}},[_c('span',{attrs:{"slot":"action"},slot:"action"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.cancel()}}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("  Back")])])]),_vm._v(" "),_c('toolbar',{attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('ed-button',{attrs:{"button-class":"btn btn-actionbar-primary pull-right","disabled":_vm.busy,"name":"send-reverse"},on:{"click":function($event){return _vm.send()}}},[_vm._v("SEND")]),_vm._v(" "),_c('ed-button',{attrs:{"button-class":"btn btn-actionbar pull-right","name":"cancel-reverse"},on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Cancel")])],1)],1),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"page-two-col"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"right"},[_c('section',{staticClass:"form-shell"},[_c('div',{staticClass:"field"},[(_vm.fundingAddressModel)?_c('funding-address',{attrs:{"model":_vm.fundingAddressModel,"showEdit":false},on:{"changeAddress":_vm.onChangeAddress}}):_c('div',{staticClass:"muted"},[_vm._v("(loading address...)")])],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("To")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email.to),expression:"email.to"}],staticClass:"form-control",attrs:{"type":"email","readonly":""},domProps:{"value":(_vm.email.to)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email, "to", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email.cc),expression:"email.cc"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.email.cc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email, "cc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email.bcc),expression:"email.bcc"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.email.bcc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email, "bcc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Subject")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email.subject),expression:"email.subject"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.email.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email, "subject", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Attached AP File")]),_vm._v(" "),_c('div',{staticClass:"attached"},[_c('a',{attrs:{"href":_vm.apFileUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.apFileLinkText))]),_vm._v(" "),_c('ed-button',{staticClass:"btn btn-actionbar-primary",on:{"click":function($event){_vm.showApReplace = true}}},[_vm._v("REPLACE")])],1)]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"msg-box",domProps:{"innerHTML":_vm._s(_vm.messageHtml)}})])])])])])],1),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.showApReplace,"title":"Replace AP File","primary-button":"Replace","secondary-button":"Cancel","type":"medium","validation":true,"closeOnEsc":true,"name":"replace_ap_file"},on:{"close":_vm.onApClose,"validate":_vm.onApSave}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"col-md-6 no-pad"},[_c('label',[_vm._v("Current AP File")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.apFileName || '(none)'))]),_vm._v(" "),_c('ed-upload',{class:{ loading: !_vm.apUploadFinished },attrs:{"field-label":"Attachment","button-label":"Upload File","readonly":"","multiple":false,"postAction":_vm.api.env + _vm.api.$.upload.uploadFile,"uploadAuto":true,"data":_vm.apUploadSettings,"required":"","showHelptipIcon":false,"helptipHeader":"","error":_vm.apAttachmentMissingError,"helptip-body":_vm.apAttachmentMissingError && 'Please attach a file.' || '',"name":"ap_file_upload"},on:{"input":_vm.onApUploadComplete},model:{value:(_vm.apAttachmentFiles),callback:function ($$v) {_vm.apAttachmentFiles=$$v},expression:"apAttachmentFiles"}}),_vm._v(" "),_c('ed-textarea',{attrs:{"field-label":"Notes","required":false,"maxLength":150,"name":"ap_replace_notes"},model:{value:(_vm.apReplaceNotes),callback:function ($$v) {_vm.apReplaceNotes=$$v},expression:"apReplaceNotes"}})],1),_vm._v(" "),_c('ed-modal',{attrs:{"show":_vm.apDisplayUploadError,"title":"","primaryButton":"false","secondaryButton":"Ok","type":"medium","name":"replace_ap_file_upload_error"},on:{"close":function($event){_vm.apDisplayUploadError = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v(_vm._s(_vm.apUploadError))])])]),_vm._v(" "),_c('div',{staticClass:"clear"})],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"left"},[_c('section',{staticClass:"msg-details"},[_c('h4',[_vm._v("Message Details")]),_vm._v(" "),_c('p',[_vm._v("\n              In addition to the selected user, enter the email address of each person\n              or people you would like to copy (CC) or blind carbon copy (BCC) this\n              statement to.\n            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("CC "),_c('span',{staticClass:"optional"},[_vm._v("– optional")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("BCC "),_c('span',{staticClass:"optional"},[_vm._v("– optional")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vvHA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_tab__ = __webpack_require__("QuRR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("4CTm");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-tabs',
  props: {
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    NavTab: __WEBPACK_IMPORTED_MODULE_0__nav_tab__["a" /* default */]
  },
  computed: {
    hasDefaultSlot: function hasDefaultSlot() {
      return !!this.$slots.default;
    }
  },
  methods: {
    onTabClick: function onTabClick(tabId) {
      var _this = this;
      var tab = this.tabs.find(function (t) {
        return t.id === tabId;
      });
      tab.active = true;
      this.tabs.forEach(function (tab) {
        if (tab.id === tabId) {
          tab.active = true;
          _this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EVENT_ON_TAB_CLICK */], tab || tabId);
        } else {
          tab.active = false;
        }
      }, this);
    }
  }
});

/***/ }),

/***/ "vvpf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3m2lAVXYMgPp80ZDRs0b8r","Dell":"_2NgH2DH_MxKeDGe3bqxXqX","Abbott":"_1LbQqTDkn40kCB7TR69H0J","Gap":"_2sgb_sONLKfNQ1zagggD-f","Allstate":"_1wb51U3rPvKq3DZPb81bS1","Asurion":"_3bD5NbsEJUKN27qY5lFQ7h","Invitae":"_3vQz_GlZvqnadcSVzIzT92","JWE":"_27po7c5JTX8FbCe-e9TkPx"};

/***/ }),

/***/ "vvv5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_33R_032AZYb9w2brHMsINR","Dell":"xE845318pnXhp59Adka9D","Abbott":"_39fWwrYBbUrIbzqzHsYV4z","Gap":"_3QyHD170aUYk4Vw8XggtJn","Allstate":"_2dxdWZVF6i0OYeLeabR7Ae","Asurion":"jr2ncJZlqGdQgerJ2Ie0A","Invitae":"_1jxj_X-QKnCGpupTESdkW8","JWE":"_2W5lcXudrNRPsjjnBfgWFM"};

/***/ }),

/***/ "w++6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"request-card-overlay",attrs:{"endpoint":"Settings/GetDivision"}},[_c('p',{staticClass:"small"},[_vm._v("\n      Send the Cardholder a physical card - provide mailing address below:\n    ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"country"}},[_vm._v("Country")]),_vm._v(" "),_c('ed-select',{attrs:{"placeholder":"Select a country...","options":_vm.countries,"label":"CountryName","track-by":"CountryID","openEndpoint":_vm.api.$.profile.getAllCountries,"error":_vm.doDisplayCountryError,"helptip-header":_vm.doDisplayCountryError && 'Error' || '',"helptip-body":_vm.doDisplayCountryError && 'Please select a country' || '',"disabled":_vm.disableControls,"name":"supplier_country"},on:{"input":function (o) { return _vm.mailingAddress.country = o; },"select":function($event){return _vm.countrySelected($event)},"open":_vm.fetchCountriesOnOpen,"keyup":_vm.fetchCountries,"close":_vm.restoreCountries},model:{value:(_vm.formData.country),callback:function ($$v) {_vm.$set(_vm.formData, "country", $$v)},expression:"formData.country"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"name","placeholder":"Name","maxlength":"40"},on:{"input":function (o) { return _vm.mailingAddress.name = o; }},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),(_vm.errors.name)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.name))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"address"}},[_vm._v("Address")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"address","placeholder":"Address","maxlength":"26"},on:{"input":function (o) { return _vm.mailingAddress.line1 = o; }},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),(_vm.errors.line1)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.line1))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","field-label":"Address Line 2","id":"addressLine2","placeholder":"Address Line 2","maxlength":"26"},on:{"input":function (o) { return _vm.mailingAddress.line2 = o; }},model:{value:(_vm.addressLine2),callback:function ($$v) {_vm.addressLine2=$$v},expression:"addressLine2"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"city","placeholder":"City","maxlength":"25"},on:{"input":function (o) { return _vm.mailingAddress.city = o; }},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}}),_vm._v(" "),(_vm.errors.city)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.city))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-item"},[_c('label',{attrs:{"for":"state"}},[_vm._v("State")]),_vm._v(" "),(_vm.isUS())?_c('ed-select',{attrs:{"options":_vm.USstates,"label":"StateName","track-by":"StateID","name":"us_states"},on:{"input":function (o) { return _vm.mailingAddress.state = o; },"open":_vm.fetchUSStatesOnOpen,"keyup":_vm.fetchUSStates,"close":_vm.restoreUSStates},model:{value:(_vm.formData.state),callback:function ($$v) {_vm.$set(_vm.formData, "state", $$v)},expression:"formData.state"}}):_vm._e(),_vm._v(" "),(_vm.isCanada())?_c('ed-select',{attrs:{"placeholder":"Select a region","options":_vm.canadaStates,"label":"StateName","disabled":_vm.disableControls,"name":"canada_states"},on:{"input":function (o) { return _vm.mailingAddress.state = o; },"open":_vm.fetchCanadaStatesOnOpen,"keyup":_vm.fetchCanadaStates,"close":_vm.restoreCanadaStates},model:{value:(_vm.formData.canadaState),callback:function ($$v) {_vm.$set(_vm.formData, "canadaState", $$v)},expression:"formData.canadaState"}}):_vm._e(),_vm._v(" "),(!_vm.formData.country || !_vm.isCanada() && !_vm.isUS())?_c('ed-input',{attrs:{"placeholder":"Select a region","disabled":_vm.disableControls,"name":"state_region"},on:{"input":function (o) { return _vm.mailingAddress.state = o; }},model:{value:(_vm.formData.region),callback:function ($$v) {_vm.$set(_vm.formData, "region", $$v)},expression:"formData.region"}}):_vm._e(),_vm._v(" "),(_vm.errors.state)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.state))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"input-group-item"},[_c('label',{attrs:{"for":"zipCode"}},[_vm._v("Zip Code")]),_vm._v(" "),_c('ed-input',{staticClass:"full-width",attrs:{"type":"text","id":"zipCode","placeholder":"Zip Code","maxlength":"5"},on:{"input":function (o) { return _vm.mailingAddress.zip = o; }},model:{value:(_vm.zipCode),callback:function ($$v) {_vm.zipCode=$$v},expression:"zipCode"}}),_vm._v(" "),(_vm.errors.zip)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.zip))]):_vm._e()],1)])]),_vm._v(" "),(this.allowRushPhysicalCards)?_c('hr'):_vm._e(),_vm._v(" "),(this.allowRushPhysicalCards)?_c('div',{staticClass:"form-group",class:{ 'is-disabled-field': _vm.account && _vm.account.Available <= 0 }},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n        For a fee, a physical card can be sent via expedited shipping.\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.rushDisabledReason),expression:"rushDisabledReason"}],staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rushOrder),expression:"rushOrder"}],attrs:{"type":"checkbox","id":"rushOrder","disabled":_vm.account && _vm.account.Available <= 0},domProps:{"checked":Array.isArray(_vm.rushOrder)?_vm._i(_vm.rushOrder,null)>-1:(_vm.rushOrder)},on:{"change":function($event){var $$a=_vm.rushOrder,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rushOrder=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rushOrder=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rushOrder=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"small",attrs:{"for":"rushOrder"}},[_vm._v("Rush shipment of this card")])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"rushOrder"}},[_vm._v("Rush Order - "),_c('span',{staticClass:"optional-text"},[_vm._v("optional")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w+zi":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDY0OCAyMzMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDY0OCAyMzM7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPGcgaWQ9IkxheWVyXzEiPgo8L2c+CjxnIGlkPSJMYXllcl8zIj4KCTxnPgoJCTxnPgoJCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQ5LjUsMTQwLjFWOTIuOWg3LjV2NDcuMkgyNDkuNXoiLz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQwNiwxNDAuMVY5Mi45aDcuNXY0Ny4ySDQwNnoiLz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ1Ni44LDk5LjF2NDAuOWgtNy40Vjk5LjFoLTE2Ljh2LTYuMmg0MC45djYuMkg0NTYuOHoiLz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTU0My40LDE0MC4xVjkyLjloMjkuMnY2LjJoLTIxLjd2MTMuNmgxOHY2LjJoLTE4djE0LjloMjIuM3Y2LjJINTQzLjR6Ii8+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0zNzguOSw5Mi45bC0xMi44LDMyLjljLTAuMiwwLjQtMC40LDAuOS0wLjYsMS41Yy0wLjEtMC42LTAuMi0wLjktMC41LTEuNWwtMTMuNy0zMi45aC04LjFsMjAsNDcuMmgzLjkKCQkJCUwzODcsOTIuOUgzNzguOXoiLz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ4OS4xLDE0MC4xbDEyLjgtMzIuOWMwLjItMC40LDAuNC0wLjksMC42LTEuNWMwLjEsMC42LDAuMiwwLjksMC41LDEuNWwxMy43LDMyLjloOC4xbC0yMC00Ny4yaC0zLjkKCQkJCWwtMTkuNyw0Ny4ySDQ4OS4xeiIvPgoJCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMzE5LjgsMTQwLjFsLTI2LjYtMzMuNGMtMC42LTAuNy0yLjEtMi41LTIuNS0zLjZ2MzdoLTYuOVY5Mi45aDcuNWwyNS40LDMyYzAuOCwxLjEsMi42LDMuNiwzLjEsNC45VjkyLjkKCQkJCWg2Ljh2NDcuMkgzMTkuOHoiLz4KCQk8L2c+CgkJPGc+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNDIuMSw3OS41bC0xLjEtMS42Yy03LjctMTEuNi0yNy0yMC45LTQ3LjgtMTUuNEw5MS40LDYzbC0xLTMuN2wxLjktMC41YzE5LjctNS4yLDQyLjEsMi4xLDUxLjksMTcKCQkJCWwxLjEsMS42TDE0Mi4xLDc5LjV6Ii8+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNTEuOCw4Mi44bC0wLjYtMS44Yy00LjMtMTMuMi0yMC40LTI3LjQtNDEuOC0yNy43bC0xLjksMGwwLjEtMy44bDEuOSwwYzIwLjQsMC4zLDM5LjksMTMuMyw0NS41LDMwLjMKCQkJCWwwLjYsMS44TDE1MS44LDgyLjh6Ii8+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNjAuMiw4OC43bC0wLjEtMS45Yy0wLjYtMTMuOS0xMi4yLTMxLjktMzIuOC0zNy45bC0xLjgtMC41bDEuMS0zLjdsMS44LDAuNWMxOS42LDUuOCwzNC45LDIzLjYsMzUuNiw0MS41CgkJCQlsMC4xLDEuOUwxNjAuMiw4OC43eiIvPgoJCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTcwLjQsOTcuNWwtMy43LTAuOWwwLjQtMS45YzMuMi0xMy41LTMuMi0zNC0yMS40LTQ1LjRsLTEuNi0xbDItMy4zbDEuNiwxQzE2NSw1Ni45LDE3NSw3OC4yLDE3MC44LDk1LjYKCQkJCUwxNzAuNCw5Ny41eiIvPgoJCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTc0LjEsMTA3LjhsLTMuNC0xLjlsMC45LTEuN2M2LjctMTIuMSw2LjEtMzMuNi04LjMtNDkuNWwtMS4zLTEuNGwyLjgtMi42bDEuMywxLjQKCQkJCWMxMy43LDE1LjEsMTcuNSwzOC4zLDguOSw1My45TDE3NC4xLDEwNy44eiIvPgoJCTwvZz4KCQk8Zz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE3NSwxMTguOGwtMi43LTIuN2wxLjMtMS40YzkuOC05LjksMTQuOS0zMC43LDUuMy00OS45bC0wLjktMS43bDMuNC0xLjdsMC45LDEuN2M5LjEsMTguMiw2LjYsNDEuNi02LDU0LjMKCQkJCUwxNzUsMTE4Ljh6Ii8+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNzIuOCwxMjkuNWwtMS45LTMuM2wxLjctMWMxMi02LjksMjIuNy0yNS41LDE4LjYtNDYuNmwtMC40LTEuOWwzLjgtMC43bDAuNCwxLjkKCQkJCWMzLjksMjAtNC45LDQxLjgtMjAuNCw1MC43TDE3Mi44LDEyOS41eiIvPgoJCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTY3LjgsMTM5LjNsLTAuOS0zLjdsMS45LTAuNWMxMy41LTMuNCwyOC43LTE4LjUsMzAuNS0zOS45bDAuMi0xLjlsMy44LDAuM2wtMC4yLDEuOQoJCQkJYy0xLjcsMjAuMy0xNiwzOC45LTMzLjQsNDMuM0wxNjcuOCwxMzkuM3oiLz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE2My4yLDE0Ny41Yy0wLjMsMC0wLjYsMC0wLjksMGwtMS45LTAuMWwwLjEtMy44bDEuOSwwLjFjMTMuOCwwLjQsMzIuNi0xMCw0MC4xLTMwLjJsMC43LTEuOGwzLjYsMS4zCgkJCQlsLTAuNywxLjhDMTk5LjEsMTMzLjYsMTgwLjgsMTQ3LjUsMTYzLjIsMTQ3LjV6Ii8+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNjMuNiwxNTUuM2MtMy43LDAtNy4zLTAuNS0xMC44LTEuNmwtMS44LTAuNmwxLjEtMy43bDEuOCwwLjZjMTMuMiw0LjEsMzQuMS0wLjksNDYuNy0xOC4ybDEuMS0xLjYKCQkJCWwzLjEsMi4zbC0xLjEsMS42QzE5NC4zLDE0Ny4zLDE3OC40LDE1NS4zLDE2My42LDE1NS4zeiIvPgoJCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTY0LjEsMTYzLjNjLTgsMC0xNS44LTItMjIuMS02bC0xLjYtMWwyLjEtMy4ybDEuNiwxYzExLjYsNy41LDMzLjEsOC40LDQ5LjktNWwxLjUtMS4ybDIuNCwzbC0xLjUsMS4yCgkJCQlDMTg3LjIsMTU5LjUsMTc1LjMsMTYzLjMsMTY0LjEsMTYzLjN6Ii8+CgkJPC9nPgoJCTxnPgoJCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTY0LjQsMTcxLjRjLTEzLjIsMC0yNS45LTQuOC0zMy43LTEzLjdsLTEuMy0xLjRsMi45LTIuNWwxLjMsMS40YzkuMiwxMC40LDI5LjYsMTcsNDkuNCw4LjdsMS44LTAuNwoJCQkJbDEuNSwzLjVsLTEuOCwwLjdDMTc4LjEsMTcwLjEsMTcxLjIsMTcxLjQsMTY0LjQsMTcxLjR6Ii8+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNjIuNywxNzkuNGMtMTguMiwwLTM2LTkuNy00My0yNC4ybC0wLjgtMS43bDMuNS0xLjdsMC44LDEuN2M2LDEyLjUsMjMuOSwyNC4zLDQ1LjIsMjEuN2wxLjktMC4ybDAuNSwzLjgKCQkJCWwtMS45LDAuMkMxNjYuOCwxNzkuMiwxNjQuOCwxNzkuNCwxNjIuNywxNzkuNHoiLz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE1Mi42LDE4Ni4ybC0xLjktMC4zYy0yMC4yLTMtMzcuOC0xOC42LTQwLjktMzYuMmwtMC4zLTEuOWwzLjgtMC43bDAuMywxLjljMi40LDEzLjcsMTYuNSwyOS45LDM3LjcsMzMuMQoJCQkJbDEuOSwwLjNMMTUyLjYsMTg2LjJ6Ii8+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMzMuMSwxODguNGwtMS44LTAuOGMtMTguNi04LjQtMzEuMy0yOC4xLTI5LjYtNDUuOWwwLjItMS45bDMuOCwwLjRsLTAuMiwxLjljLTEuMywxMy44LDcuOCwzMy4yLDI3LjQsNDIKCQkJCWwxLjgsMC44TDEzMy4xLDE4OC40eiIvPgoJCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTEzLjcsMTg1LjNsLTEuNS0xLjJjLTE1LjctMTMuMS0yMi42LTM1LjUtMTYuMS01Mi4ybDAuNy0xLjhsMy42LDEuNGwtMC43LDEuOGMtNSwxMi45LTEuNCwzNC4xLDE1LDQ3LjkKCQkJCWwxLjUsMS4yTDExMy43LDE4NS4zeiIvPgoJCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNOTUuOCwxNzcuMWwtMS4xLTEuNmMtMTEuNS0xNi44LTEyLjItNDAuMy0xLjUtNTQuNmwxLjItMS41bDMuMSwyLjNsLTEuMiwxLjVjLTguMywxMS4xLTEwLjYsMzIuNCwxLjUsNTAuMgoJCQkJbDEuMSwxLjZMOTUuOCwxNzcuMXoiLz4KCQk8L2c+CgkJPGc+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik02Ni4yLDExMS41bC0zLjQtMS44bDAuOS0xLjdjOS42LTE4LDMwLjItMjkuMyw0Ny44LTI2LjRsMS45LDAuM2wtMC42LDMuOGwtMS45LTAuMwoJCQkJYy0xMy43LTIuMy0zMy43LDUuNS00My44LDI0LjRMNjYuMiwxMTEuNXoiLz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTcwLjEsOTMuMmwtMi44LTIuN2wxLjMtMS40YzE0LjEtMTQuNywzNy0yMC4xLDUzLjItMTIuNWwxLjcsMC44bC0xLjYsMy41bC0xLjctMC44CgkJCQljLTEyLjYtNS45LTMzLjktMy44LTQ4LjgsMTEuN0w3MC4xLDkzLjJ6Ii8+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMzEuOSw3OC44bC0xLjUtMS4zYy0xMC41LTkuMS0zMS43LTEyLjgtNTAuMS0xLjlsLTEuNywxbC0yLTMuM2wxLjctMUM5Niw2MiwxMTkuNCw2MywxMzMsNzQuN2wxLjUsMS4zCgkJCQlMMTMxLjksNzguOHoiLz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTgwLjksMTY0LjNsLTAuNi0xLjhjLTYuNi0xOS4zLTAuOC00Mi4xLDEzLjMtNTNsMS41LTEuMmwyLjMsM2wtMS41LDEuMmMtMTEsOC40LTE5LDI4LjQtMTIsNDguN2wwLjYsMS44CgkJCQlMODAuOSwxNjQuM3oiLz4KCQkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTY5LjksMTQ4bC0wLjEtMS45Yy0xLjEtMjAuNCwxMC41LTQwLjgsMjcuMS00Ny40bDEuOC0wLjdsMS40LDMuNmwtMS44LDAuN2MtMTIuOSw1LjItMjUuOSwyMi4yLTI0LjcsNDMuNwoJCQkJbDAuMSwxLjlMNjkuOSwxNDh6Ii8+CgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik02Ny41LDEzMC4ybC0zLjctMC44bDAuNC0xLjljNC40LTE5LjksMjEuMi0zNi40LDM4LjktMzguNGwxLjktMC4ybDAuNCwzLjhsLTEuOSwwLjIKCQkJCWMtMTMuOCwxLjUtMzAuOSwxNC40LTM1LjYsMzUuNEw2Ny41LDEzMC4yeiIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "w3aj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('label',{staticClass:"control-label"},[_vm._v("Rule Name*")]),_c('ed-input',{ref:"RuleName",attrs:{"endpoint":_vm.api.$.approval.getNewRuleId,"placeholder":"Rule Name"},on:{"keyup":_vm.changeRuleName},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_c('div',{staticClass:"row form-group"},[_vm._m(0),_c('div',{staticClass:"col-md-3"},[_vm._v("  "),_c('label',[_c('checkbox',{staticClass:"inline",attrs:{"option-label":"This rule has parallel routes","option-status":_vm.useParallelApprovalRoutes},on:{"change-status":_vm.changeUsingParallelRoutes}})],1)]),(_vm.useParallelApprovalRoutes)?_c('ed-select',{staticClass:"inline col-md-1",attrs:{"open-direction":"over","placeholder":"Select routes","options":_vm.maxRoutesValues,"label":"label"},on:{"select":function($event){return _vm.updateMaxRoutes($event)}},model:{value:(_vm.MaxRoutes),callback:function ($$v) {_vm.MaxRoutes=$$v},expression:"MaxRoutes"}}):_vm._e()],1),(_vm.optionsAvailable)?_c('rule',{attrs:{"endpoint":_vm.api.$.approval.getRule,"self":_vm.approvalRule[_vm.type.rule],"children":_vm.children,"depth":0,"conditions":_vm.approvalRule[_vm.type.rule].Conditions,"actions":_vm.approvalRule[_vm.type.rule].Actions,"label":"WHEN","conditionOptions":_vm.options,"actionOptions":_vm.actionOptions,"routeValues":_vm.routeValues,"useParallelApprovalRoutes":_vm.useParallelApprovalRoutes}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"col-md-2 row"},[_c('strong',[_vm._v("Conditions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w7Rz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2olF-QfOH2xJJKFLfDczPX","Dell":"_3KWLMDYcaGaVBsWC8fqWNR","Abbott":"KE22-AjUGtamvn4LDp0pb","Gap":"_1nsFliRhabhM1ZxRz1mD0p","Allstate":"n6ZYnAiJiGF1GaxMK0zO1","Asurion":"m8mflZ0YDdrg8gdqg95l4","Invitae":"_2j_3OvlykfxGncqy5483gT","JWE":"_1YdJaFo7AcEbHpxjioYIBy"};

/***/ }),

/***/ "w8kC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme skin",class:_vm.themeNamespace},[_c('accounts',{ref:"accounts",on:{"dismiss":function($event){_vm.switchAccountAfterLogin = false}}}),_c('keep-alive',[(!_vm.switchAccountAfterLogin)?_c(_vm.layout,{tag:"component",staticClass:"layout",class:{ embedded: _vm.featureFlags.legacyViewDisabled },attrs:{"reference":_vm.refName}},[_c(_vm.module(),{ref:"currentModule",tag:"component",staticClass:"module",class:_vm.className})],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wA9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"approval-needed-users"},[_c('div',{staticClass:"col-md-12"},[_c('h2',{staticClass:"table-title"},[_vm._v("Assigned Approvers")]),_vm._v(" "),_c('table',{staticClass:"custom-table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.approvalUsersData),function(user){return (user.IsCurrentAction)?_c('tr',{key:user.id},[_c('td',[_vm._v(_vm._s(user.FirstName)+" "+_vm._s(user.LastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.Email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.Phone))])]):_vm._e()}),0)])]),_vm._v(" "),(_vm.hasNextAssignedApprovers)?_c('div',{staticClass:"col-md-12"},[_c('h2',{staticClass:"table-title"},[_vm._v("Next Assigned Approvers")]),_vm._v(" "),_c('table',{staticClass:"custom-table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.approvalUsersData),function(user){return (!user.IsCurrentAction)?_c('tr',{key:user.id},[_c('td',[_vm._v(_vm._s(user.FirstName)+" "+_vm._s(user.LastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.Email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.Phone))])]):_vm._e()}),0)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name:")]),_vm._v(" "),_c('th',[_vm._v("Email:")]),_vm._v(" "),_c('th',[_vm._v("Phone:")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name:")]),_vm._v(" "),_c('th',[_vm._v("Email:")]),_vm._v(" "),_c('th',[_vm._v("Phone:")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wVmo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wWmw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "waef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_user__ = __webpack_require__("uduW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_legacy_auth_gotoV3__ = __webpack_require__("UYvm");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var CHECK_EMAIL_CODE = 'CHECK_EMAIL_CODE';
var CHECK_SMS_CODE = 'CHECK_SMS_CODE';
/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'mfasetup',
  data: function data() {
    return {
      mfaOption: undefined,
      mfaOptions: [{
        label: " Email: ".concat(this.$user.email),
        id: CHECK_EMAIL_CODE,
        preference: 'CUSTOM_CHALLENGE',
        status: false
      }, {
        label: ' Text message',
        id: CHECK_SMS_CODE,
        preference: 'SMS_MFA',
        status: false,
        additionalInfo: true,
        slotName: 'phoneNumber',
        additionalSetup: this.api.$.mfa.setPhone,
        verifySetup: this.api.$.mfa.checkPhone
      }],
      phone: {
        countryCode: undefined,
        number: undefined
      },
      mfaSetup: {
        phoneNumber: undefined
      },
      validMfaSetup: {
        phoneNumber: true
      },
      mfaChallenge: {
        code: ''
      },
      validMfaChallenge: {
        code: true
      },
      isVerificationSuccessful: false
    };
  },
  methods: {
    setupMfa: function setupMfa() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var user, r;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.isVerificationSuccessful || !_this.mfaOption.verifySetup)) {
                _context.next = 6;
                break;
              }
              _context.next = 3;
              return _this.api.post(_this.api.$.mfa.setConfig, {
                type: _this.mfaOption.preference
              });
            case 3:
              user = __WEBPACK_IMPORTED_MODULE_2__core_user__["a" /* default */].get();
              __WEBPACK_IMPORTED_MODULE_3__core_legacy_auth_gotoV3__["a" /* navigateToV3 */].call(_this, user.token);
              return _context.abrupt("return");
            case 6:
              if (!(!_this.mfaOption.additionalInfo || _this.mfaOption.additionalInfo && _this.mfaSetup[_this.mfaOption.slotName])) {
                _context.next = 15;
                break;
              }
              if (!_this.mfaOption.additionalSetup) {
                _context.next = 14;
                break;
              }
              _context.next = 10;
              return _this.api.post(_this.mfaOption.additionalSetup, _this.mfaSetup);
            case 10:
              r = _context.sent;
              if (!(r && r.data && !r.data.Success)) {
                _context.next = 14;
                break;
              }
              global.alert(r.data.ErrorMessage || 'Something went wrong');
              return _context.abrupt("return");
            case 14:
              if (_this.mfaOption.verifySetup) {
                _this.$refs[_this.mfaOption.id].show = true;
              }
            case 15:
              if (_this.mfaOption.additionalInfo && !_this.mfaSetup[_this.mfaOption.slotName]) {
                _this.validMfaSetup[_this.mfaOption.slotName] = false;
              }
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    verifySetup: function verifySetup() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var r;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _this2.mfaChallenge.code = _this2.mfaChallenge.code.trim();
              _context2.next = 4;
              return _this2.api.post(_this2.mfaOption.verifySetup, _this2.mfaChallenge);
            case 4:
              r = _context2.sent;
              if (r && r.data && r.data.Success) {
                _this2.isVerificationSuccessful = true;
                _this2.$refs['CHECK_SMS_CODE'].show = false;
              } else {
                global.alert(r.data.ErrorMessage || 'Something went wrong');
              }
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              global.alert('Something went wrong');
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 8]]);
      }))();
    },
    cancel: function cancel() {
      this.$user.logout();
    },
    onCountrySelect: function onCountrySelect(_ref) {
      var dialCode = _ref.dialCode;
      this.phone.countryCode = '+' + dialCode;
      this.updatePhone();
    },
    updatePhone: function updatePhone() {
      if (this.phone.number !== undefined) {
        this.mfaSetup.phoneNumber = this.phone.countryCode + this.phone.number.replace(/[/(/)/ -/.]/g, '');
      }
      this.isVerificationSuccessful = false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "wcGH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rejectReason: '',
      showReject: false
    };
  },
  created: function created() {},
  props: {
    ids: null,
    disabled: false,
    tooltip: '',
    selectedRows: [],
    card: [],
    buttonClass: {
      type: String,
      default: 'btn btn-actionbar col-md-12'
    }
  },
  methods: {
    approveOrRejectCardFunding: function approveOrRejectCardFunding() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var cardId, payload, response;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (_this.selectedRows && _this.selectedRows.length > 0) {
                cardId = _this.selectedRows[0].data.Id;
              } else {
                cardId = _this.card.Id;
              }
              payload = {
                cardsData: JSON.stringify([{
                  Id: cardId,
                  RejectReason: _this.rejectReason
                }])
              };
              _context.next = 5;
              return _this.api.post(_this.api.$.evedpaycard.approveOrRejectCardFunding, payload);
            case 5:
              response = _context.sent;
              if (response.data) {
                _context.next = 10;
                break;
              }
              throw new Error('Error during the request');
            case 10:
              _this.$emit('success');
            case 11:
              if (response.status === 200) {
                _this.showReject = false;
              }
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ "wdvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"column col-md-4"},[_c('label',[_vm._v("Invoice Total")]),_vm._v(" "),_c('div',[_c('v-money',{attrs:{"currency":_vm.model.CurrencyCode}},[_vm._v(_vm._s(_vm.model.InvoiceTotalAmount))])],1)]),_vm._v(" "),_c('div',{staticClass:"column col-md-4"},[_c('label',[_vm._v("Payments")]),_vm._v(" "),_c('div',[_c('v-money',{attrs:{"currency":_vm.model.CurrencyCode}},[_vm._v(_vm._s(_vm.model.PaymentsAmount))])],1)]),_vm._v(" "),_c('div',{staticClass:"column col-md-4"},[_c('label',[_vm._v("Balance")]),_vm._v(" "),_c('div',[_c('v-money',{attrs:{"currency":_vm.model.CurrencyCode}},[_vm._v(_vm._s(_vm.model.Balance))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "weJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attachments_details_vue__ = __webpack_require__("6roY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ced1b82_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attachments_details_vue__ = __webpack_require__("Cshb");
function injectStyle (ssrContext) {
  __webpack_require__("WYLj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ced1b82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attachments_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ced1b82_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attachments_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "werl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_vue__ = __webpack_require__("bLAB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219c0c0c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_date_vue__ = __webpack_require__("ubmj");
function injectStyle (ssrContext) {
  __webpack_require__("SSWC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219c0c0c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_date_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "woxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_charts_helper_formatter__ = __webpack_require__("7VNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_charts_helper_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_charts_helper_formatter__);

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(settings) {
    return {
      '*id': '_',
      supplierCompanyName: {
        label: 'Supplier',
        width: 100,
        editable: false
      },
      supplierInvoiceNumber: {
        label: 'Ref ID',
        width: 65,
        editable: false
      },
      programName: {
        label: settings.Labels.ProgramLabel + ' Name',
        width: 65,
        editable: false
      },
      divisionName: {
        label: settings.DivisionName,
        width: 65,
        editable: false
      },
      totalAmount: {
        label: 'Amount',
        compose: totalAmountFormat,
        getter: totalAmountFormat,
        width: 75,
        editable: false,
        type: 'amount text-right'
      }
    };
  }
});
function totalAmountFormat(params) {
  return __WEBPACK_IMPORTED_MODULE_0__core_charts_helper_formatter___default.a.getMoneyFormatedValue(params.data.totalAmount, params.data.currencyCode);
}

/***/ }),

/***/ "wpDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetSnapshot_vue__ = __webpack_require__("VwEv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60dfb857_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetSnapshot_vue__ = __webpack_require__("Wwqk");
function injectStyle (ssrContext) {
  __webpack_require__("5i/S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60dfb857"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetSnapshot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60dfb857_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetSnapshot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wpZr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Themes__ = __webpack_require__("14bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Layouts__ = __webpack_require__("r4/r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules__ = __webpack_require__("vZ0M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GeneralViews_NotImplemented_vue__ = __webpack_require__("p4xt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LegacyContainer__ = __webpack_require__("jIfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_loading_indicators__ = __webpack_require__("WFO1");
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */

//






/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__components_Themes__["a" /* default */].app[this.themeNs]();
  },
  computed: {
    // THEME
    themeNs: function themeNs() {
      return __WEBPACK_IMPORTED_MODULE_0__components_Themes__["a" /* default */].domains[global.location.hostname] || __WEBPACK_IMPORTED_MODULE_0__components_Themes__["a" /* default */].domains['default'];
    },
    theme: function theme() {
      return __WEBPACK_IMPORTED_MODULE_0__components_Themes__["a" /* default */].app[this.themeNs];
    },
    // LAYOUT
    layout: function layout() {
      var app = this._self;
      var route = app.$route;
      var module = __WEBPACK_IMPORTED_MODULE_2__components_modules__["a" /* default */][route.params.page || route.name];
      if (module && module.layout) {
        return __WEBPACK_IMPORTED_MODULE_1__components_Layouts__["a" /* default */][module.layout].default;
      } else {
        // return Layouts.default
        return __WEBPACK_IMPORTED_MODULE_1__components_Layouts__["a" /* default */].other.default;
      }
    }
  },
  data: function data() {
    return {
      // MODULE
      module: function module() {
        var app = this._self;
        var route = app.$route;
        var module = __WEBPACK_IMPORTED_MODULE_2__components_modules__["a" /* default */][route.params.page || route.name];
        if (module && module.pack && route.params.section) {
          module = __WEBPACK_IMPORTED_MODULE_2__components_modules__["a" /* default */][route.params.section];
        }
        if (route.params.namespace === 'i') {
          return __WEBPACK_IMPORTED_MODULE_4__components_LegacyContainer__["a" /* default */];
        }
        if (module) {
          // Hook into before/after loading lazy modules
          // for handling loading indicators
          module.on('afterLoad', function () {
            __WEBPACK_IMPORTED_MODULE_5__core_loading_indicators__["a" /* default */].hook.stop.call(app);
            if (module.legacy) {
              app.className = 'legacy';
            }

            // If module has Grid, apply class
            /* if (this.components && this.components.Grid) {
              if (module.legacy) {
                app.className = 'legacy grid'
              } else {
                app.className = 'grid'
              }
            } */
          }).on('beforeLoad', function () {
            __WEBPACK_IMPORTED_MODULE_5__core_loading_indicators__["a" /* default */].hook.start.call(app);
          });
          return module.module || module;
        } else {
          return __WEBPACK_IMPORTED_MODULE_3__components_GeneralViews_NotImplemented_vue__["a" /* default */];
        }
      },
      className: ''
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "wrv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TEMPLATE = "<md-chart-widget :id='id'\n    :widget='widget'\n    ref='chart'\n    showLegend\n     \n    data-TODO=\"!!! remove the below properties!!!\"\n     \n    :type='widget.chartType'\n    :options='widget.options'\n    :data-source='widget.endPoint' />";
function makeChart(alias, chart) {
  return {
    alias: alias,
    props: {
      widget: Object,
      id: String
    },
    created: function created() {
      this.widget.chartComponent = chart;
      this.$on('scrollIntoView', this.load);
    },
    methods: {
      load: function load() {
        this.$refs.chart.$emit('scrollIntoView');
      }
    },
    template: TEMPLATE
  };
}
/* harmony default export */ __webpack_exports__["a"] = (makeChart);

/***/ }),

/***/ "wvul":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"cYS8lSsLpCojnS0y8U9Pi","Dell":"VslHy-zR4bhyYxvCtG1MP","Abbott":"_3unKhgoQ0uh88YVw4nZ0fR","Gap":"NNPM8ROOAeWXDsxY1UxRT","Allstate":"CWk3KWAlqza8Fh0X_VaGA","Asurion":"_1-0fDIo5jZueajVdgqQ83g","Invitae":"_24C8p0eIrhu0U3whoBmNU1","JWE":"_3GVzIGljc_RpAOigTP1L_4"};

/***/ }),

/***/ "wydl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobile_vue__ = __webpack_require__("SeHP");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_209b1946_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mobile_vue__ = __webpack_require__("Tqan");
function injectStyle (ssrContext) {
  __webpack_require__("hbvy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-209b1946"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_209b1946_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "x2QA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  alias: 'evedpayrequestphysicalcard',
  data: function data() {
    return {
      formData: {
        city: '',
        postalCode: '',
        originalCountryName: '',
        country: {
          CountryID: 0,
          CountryName: ''
        },
        state: {
          StateID: 0,
          StateName: ''
        },
        canadaState: {
          StateID: 0,
          StateName: ''
        },
        region: ''
      },
      USstates: [],
      USoriginalStates: [],
      canadaStates: [],
      originalCanadaStates: [],
      countries: [],
      originalCountries: [],
      mailingAddress: {},
      addObjectUser: {},
      rushOrder: false,
      allowRushPhysicalCards: false,
      cardId: this.$route.query.cardid,
      errors: {}
    };
  },
  created: function created() {
    this.getDivisionSettings();
    this.resetFields();
    this.populateFormData(this.formData);
  },
  methods: {
    requestPhysicalCard: function requestPhysicalCard() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var isValid, response, userFriendlyErrorMessage, errorDataString, firstBracketIndex, secondBracketIndex, colonIndex, endOfMessagePeriod, endOfMessageParenthesis, endOfMessageIndex, detailedMessage;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isValid = _this.validateForm();
              if (isValid) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.prev = 3;
              _context.next = 6;
              return _this.api.post("evedpaycards/".concat(_this.cardId, "/request-physical-card"), {
                preventError: true,
                Shipping: {
                  IsRush: _this.rushOrder,
                  Name: _this.mailingAddress.name,
                  Address: {
                    Country: {
                      Id: 186
                    },
                    Address1: _this.mailingAddress.line1,
                    Address2: _this.mailingAddress.line2,
                    City: _this.mailingAddress.city,
                    State: {
                      Id: _this.mailingAddress.state.StateID
                    },
                    Zip: _this.mailingAddress.zip
                  }
                }
              });
            case 6:
              response = _context.sent;
              if (response.status === 200) {
                _this.$router.push({
                  path: "/evedpay/details?cardid=".concat(_this.cardId),
                  query: _objectSpread(_objectSpread({}, _this.$route.query), _this.$route.query.cardNumber)
                });
              } else {
                alert('Error requesting a physical card. Please try again.');
              }
              _context.next = 16;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              console.error('Exception while requesting physical card:', _context.t0);
              userFriendlyErrorMessage = 'An unexpected error occurred. Please try again.';
              if (_context.t0.response && _context.t0.response.data) {
                errorDataString = JSON.stringify(_context.t0.response.data);
                firstBracketIndex = errorDataString.indexOf('['); // searching for the first bracket in the message
                secondBracketIndex = errorDataString.indexOf('[', firstBracketIndex + 1); // when the first bracket is found, search for the second one
                if (secondBracketIndex !== -1) {
                  colonIndex = errorDataString.indexOf(':', secondBracketIndex); // after the second bracket is found, look for the colon -> from there the message for the user starts
                  if (colonIndex !== -1) {
                    endOfMessagePeriod = errorDataString.indexOf('.', colonIndex); // end when the first period is found
                    endOfMessageParenthesis = errorDataString.indexOf('(', colonIndex); // or end when the first parethesis is found
                    endOfMessageIndex = errorDataString.length; // min index if both are found
                    if (endOfMessagePeriod !== -1 && endOfMessageParenthesis !== -1) {
                      endOfMessageIndex = Math.min(endOfMessagePeriod, endOfMessageParenthesis);
                      // if only period is found
                    } else if (endOfMessagePeriod !== -1) {
                      endOfMessageIndex = endOfMessagePeriod;
                      // if only parenthesis is found
                    } else if (endOfMessageParenthesis !== -1) {
                      endOfMessageIndex = endOfMessageParenthesis;
                    }

                    // extract and trim the detailed error message
                    detailedMessage = errorDataString.substring(colonIndex + 1, endOfMessageIndex).trim();
                    userFriendlyErrorMessage = detailedMessage;

                    // remove any trailing parenthesis from the error message
                    if (userFriendlyErrorMessage.endsWith('(')) {
                      userFriendlyErrorMessage = userFriendlyErrorMessage.slice(0, -1).trim();
                    }
                  }
                }
              }
              alert(userFriendlyErrorMessage);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 10]]);
      }))();
    },
    getDivisionSettings: function getDivisionSettings() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var divisionIDToUse;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.programs = [];
              divisionIDToUse = _this2.$route.query.divisionId;
              _this2.api.post('Settings/GetDivision', {
                divisionID: divisionIDToUse
              }).then(function (response) {
                if (response && response.data) {
                  var responseData = JSON.parse(response.data.Data);
                  var evedPayCardAccountSettingsObj = JSON.parse(responseData.evedPayCardAccountSettings);
                  _this2.allowRushPhysicalCards = evedPayCardAccountSettingsObj.AllowRushPhysicalCards;
                }
              }).catch(function (error) {
                console.warn(error);
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    resetFields: function resetFields() {
      this.rushOrder = false;
      this.mailingAddress = {};
      this.name = '';
      this.formData.country = '';
      this.address = '';
      this.addressLine2 = '';
      this.city = '';
      this.formData.state = '';
      this.formData.canadaState = '';
      this.formData.region = '';
      this.zipCode = '';
    },
    fetchCountriesOnOpen: function fetchCountriesOnOpen() {
      var _this3 = this;
      if (this.countries.length) {} else {
        this.api.forms.post(this.api.$.profile.getAllCountries, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this3.countries = r.data.Data;
            _this3.originalCountries = r.data.Data;
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    fetchCountries: function fetchCountries(value) {
      var _this4 = this;
      this.counter || this.api.forms.post(this.api.$.profile.getAllCountries, {
        q: value || ''
      }).then(function (r) {
        _this4.counter = 0;
        if (r && r.data && r.data.Data) {
          _this4.countries = r.data.Data;
        }
      }).catch(function (e) {
        console.warn(e);
        _this4.counter = 0;
      });
      this.counter = 1;
    },
    restoreCountries: function restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries);
      }
    },
    isUS: function isUS() {
      return this.formData.country && this.formData.country.CountryName === 'United States';
    },
    GetStatesUSURL: function GetStatesUSURL() {
      return this.api.$.profile.getAllStates;
    },
    isCanada: function isCanada() {
      return this.formData.country && this.formData.country.CountryName === 'Canada';
    },
    GetStatesCanadaURL: function GetStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates;
    },
    // Fetch States on OPEN
    fetchUSStatesOnOpen: function fetchUSStatesOnOpen() {
      var url = this.GetStatesUSURL();
      this.fetchStatesOnOpen(this.USstates, url);
    },
    fetchCanadaStatesOnOpen: function fetchCanadaStatesOnOpen() {
      var url = this.GetStatesCanadaURL();
      this.fetchStatesOnOpen(this.canadaStates, url);
    },
    fetchStatesOnOpen: function fetchStatesOnOpen(states, url) {
      var _this5 = this;
      if (states.length && (this.isCanada() || this.isUS())) {} else {
        this.api.forms.post(url, {
          q: ''
        }).then(function (r) {
          if (r && r.data && r.data.Data) {
            _this5.mapStatesDataOnOpen(r.data.Data);
          }
        }).catch(function (e) {
          return console.warn(e);
        });
      }
    },
    mapStatesDataOnOpen: function mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USstates = this.USoriginalStates = data;
      } else {
        this.canadaStates = this.originalCanadaStates = data;
      }
    },
    // Fetch States on search text
    fetchUSStates: function fetchUSStates(value) {
      var url = this.GetStatesUSURL();
      this.fetchStates(value, url);
    },
    fetchCanadaStates: function fetchCanadaStates(value) {
      var url = this.GetStatesCanadaURL();
      this.fetchStates(value, url);
    },
    fetchStates: function fetchStates(value, url) {
      var _this6 = this;
      this.counter || this.api.forms.post(url, {
        q: value || ''
      }).then(function (r) {
        _this6.counter = 0;
        if (r && r.data && r.data.Data) {
          _this6.mapStatesDataOnFetch(r.data.Data);
        }
      }).catch(function (e) {
        console.warn(e);
        _this6.counter = 0;
      });
      this.counter = 1;
    },
    mapStatesDataOnFetch: function mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USstates = data;
      } else {
        this.canadaStates = data;
      }
    },
    // Restore States
    restoreUSStates: function restoreUSStates() {
      this.restoreStates(this.USstates, this.USoriginalStates);
    },
    restoreCanadaStates: function restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates);
    },
    restoreStates: function restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates);
      }
    },
    populateFormData: function populateFormData(data) {
      if (data.CompanyName !== null) {
        this.formData = {
          city: data.City,
          postalCode: data.Zip,
          originalCountryName: data.CountryName,
          country: {
            CountryID: 186,
            CountryName: 'United States'
          },
          state: {
            StateID: data.isCanada === 'False' && data.StateID || 0,
            StateName: data.isCanada === 'False' && data.State || ''
          },
          canadaState: {
            StateID: data.isCanada === 'True' && data.StateID || 0,
            StateName: data.isCanada === 'True' && data.State || ''
          },
          region: data.Region
        };
        this.disableControls = true;
      } else {
        this.disableControls = false;
      }
    },
    countrySelected: function countrySelected(e) {
      this.doDisplayCountryError = false;
      this.resetState(e.CountryName);
    },
    resetState: function resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.formData.state = {
          StateID: 0,
          StateName: ''
        };
        this.formData.canadaState = {
          StateID: 0,
          StateName: ''
        };
        this.formData.region = '';
      } else {
        this.originalCountryName = countryName;
      }
    },
    validateForm: function validateForm() {
      this.errors = {};
      if (!this.mailingAddress.name || !this.mailingAddress.name.trim()) {
        this.errors.name = 'Name is required.';
      }
      if (!this.mailingAddress.line1 || !this.mailingAddress.line1.trim()) {
        this.errors.line1 = 'Address is required.';
      }
      if (!this.mailingAddress.city || !this.mailingAddress.city.trim()) {
        this.errors.city = 'City is required.';
      }
      if (this.isUS() && (!this.mailingAddress.state || !this.mailingAddress.state.StateID)) {
        this.errors.state = 'State is required.';
      }
      if (!this.mailingAddress.zip || !this.mailingAddress.zip.trim()) {
        this.errors.zip = 'Zip Code is required.';
      }
      var isValid = Object.keys(this.errors).length === 0;
      return isValid;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP")))

/***/ }),

/***/ "xFEX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(utils, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FundingAddresses_index__ = __webpack_require__("YYsc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__APFileTemplates_index__ = __webpack_require__("BvCo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_Admin_settings__ = __webpack_require__("Ht71");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FundingAddresses: __WEBPACK_IMPORTED_MODULE_1__FundingAddresses_index__["default"],
    APFileTemplates: __WEBPACK_IMPORTED_MODULE_2__APFileTemplates_index__["default"]
  },
  data: function data() {
    return {
      settings: {},
      settingsCopy: {},
      useTemplates: []
    };
  },
  created: function created() {
    this.settings = this.$user.$.settings; // this.updateSettings()
    this.settingsCopy = utils.copy(this.settings);
    this.useTemplates.push({
      label: 'Reduce number of AP File and funding statement emails to recipients based on the AP File Templates and Funding Addresses below',
      status: this.settingsCopy.HasFundingInvAndAPSettings
    });
  },
  methods: {
    updateSettings: function updateSettings(values) {
      var companySettingsCopy = JSON.parse(global.localStorage.getItem('sessionSettings'));
      var updatedCompanySettings = _objectSpread(_objectSpread({}, companySettingsCopy), {}, {
        CompanySettings: values
      });
      global.localStorage.setItem('sessionSettings', JSON.stringify(updatedCompanySettings));
      this.$user.$.settings = values;
      return __WEBPACK_IMPORTED_MODULE_3__components_modules_Admin_settings__["a" /* default */].methods.updateSettings.call(this, values);
    },
    changeHasFundingInvAndAPSetting: function changeHasFundingInvAndAPSetting(e) {
      if (!e.status) {
        this.settingsCopy.HasFundingInvAndAPSettings = false;
      } else {
        this.settingsCopy.HasFundingInvAndAPSettings = true;
      }
      this.saveSettings();
    },
    saveSettings: function saveSettings(setting) {
      var _this = this;
      var payload = {
        isAllowed: this.settingsCopy.HasFundingInvAndAPSettings
      };
      this.api.forms.post(this.api.$.settings.company.fundingInvAndAPSettings, payload).then(function (r) {
        _this.updateSettings(_this.settingsCopy);
      }).catch(function (e) {
        _this.settingsCopy = utils.copy(_this.settings);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("RMJP"), __webpack_require__("DuR2")))

/***/ }),

/***/ "xFcj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.name,attrs:{"id":"layout"}},[_c('div',{staticClass:"wrapper centered"},[_c('div',{staticClass:"main-panel",class:{ 'loading' : _vm.loading }},[_c('div',{staticClass:"navless-layout-wrapper"},[_c('div',{staticClass:"navless-layout-header"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_c('span',{staticClass:"navless-page-name"},[_c('h2',[_vm._v(_vm._s(_vm.pageName || _vm.description))])]),_c('span',{staticClass:"navless-page-close",on:{"click":_vm.cleanup}},[(_vm.$routerHistory.hasHistory() && !_vm.isBackTo)?_c('router-link',{attrs:{"to":{ path: _vm.source, hash: "" }}},[_vm._v(_vm._s(_vm.$t('Close'))+"  "),_c('i',{staticClass:"fal fa-times-circle"})]):_vm._e(),(_vm.isBackTo)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"fal fa-caret-circle-left"},[_vm._v(" ")]),_vm._v(_vm._s(_vm.$t('Back')))]):_vm._e()],1)])]),_c('div',{staticClass:"row navless-main-body-wrapper"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navless-main-body col-md-12"},[_vm._t("default")],2)])])]),_c('md-footer')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo",attrs:{"href":"javascript:;"}},[_c('img',{attrs:{"src":__webpack_require__("zwB3"),"height":"48"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_store__ = __webpack_require__("dgq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_lang__ = __webpack_require__("pe4m");
//
//
//
//
//
//
//
//
//

/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */



var $t = function $t(key) {
  return __WEBPACK_IMPORTED_MODULE_1__lang_lang__["a" /* i18n */].t(key);
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  boot: function boot(config) {
    global.app = new config.Vue({
      el: '#app',
      store: config.store,
      i18n: config.i18n,
      router: config.router,
      template: '<App/>',
      components: {
        App: config.App
      },
      data: {
        loading: false,
        masked: false,
        Chartist: config.Charts.Chartist,
        currentModule: '',
        legacyTab: '',
        legacySubtab: '',
        innerHeight: window.innerHeight
      },
      asyncComputed: {
        getUser: config.API.getUser
      }
    });
    utils.app = global.app;
  },
  created: function created() {
    // i18n
    var lang = navigator.language;
    // const lang = 'ro'
    Object(__WEBPACK_IMPORTED_MODULE_1__lang_lang__["d" /* loadLanguageAsync */])(lang);

    // this.pubnub.load()

    //
    this.$notifications.reset();

    //
    global.alert = function (m) {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        heading: m,
        timeout: 10000,
        allowDismiss: true,
        placement: {
          from: 'top',
          align: 'center'
        }
      });
    };
  },
  mounted: function mounted() {
    //
    // utils.cssProps.init()
  },
  updated: function updated() {
    //
    // utils.cssProps.refresh()
  },
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_0__components_store__["a" /* store */]
    };
  },
  computed: {
    /**
     * Check session mapped in store and display a notification
     * if logged in and session is invalid
     */
    session: function session() {
      var sessionNotifyIndex;
      if (global.app.$notifications && this.$router.currentRoute.params.namespace !== 'docs') {
        setTimeout(function () {
          if (__WEBPACK_IMPORTED_MODULE_0__components_store__["a" /* store */].state.isLoggedIn && !__WEBPACK_IMPORTED_MODULE_0__components_store__["a" /* store */].state.isSessionValid) {
            sessionNotifyIndex = global.app.$notifications.state.length + 1;
            global.app.$notifications.notify({
              type: 'plain',
              icon: 'exclamation-circle',
              message: $t('Session Expired') + "<br><a class='btn btn-actionbar btn-xs' href=\"#/login\" onclick='window.app.$user.logout()'>" + $t('login.button') + "</a>",
              timeout: 0,
              allowDismiss: false,
              placement: {
                from: 'top',
                align: 'center'
              }
            });
          } else {
            global.app.$notifications.removeNotification(sessionNotifyIndex);
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0__components_store__["a" /* store */].state.isSessionValid;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("RMJP")))

/***/ }),

/***/ "xTRC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'zh': {
    'days': ['日', '一', '二', '三', '四', '五', '六'],
    'months': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    'pickers': ['未来7天', '未来30天', '最近7天', '最近30天'],
    'placeholder': {
      'date': '请选择日期',
      'dateRange': '请选择日期范围'
    }
  },
  'en': {
    'days': ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'],
    'months': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    'pickers': ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
    'placeholder': {
      'date': 'Select Date',
      'dateRange': 'Select Date Range'
    }
  },
  'fr': {
    'days': ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    'months': ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sep', 'Oct', 'Nov', 'Dec'],
    'pickers': ['7 jours suivants', '30 jours suivants', '7 jours précédents', '30 jours précédents'],
    'placeholder': {
      'date': 'Sélectionnez une date',
      'dateRange': 'Sélectionnez une période'
    }
  },
  'es': {
    'days': ['Dom', 'Lun', 'mar', 'Mie', 'Jue', 'Vie', 'Sab'],
    'months': ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    'pickers': ['próximos 7 días', 'próximos 30 días', '7 dás anteriores', '30 das anteriores'],
    'placeholder': {
      'date': 'Seleccionar fecha',
      'dateRange': 'Seleccionar un rango de fechas'
    }
  },
  'pt-br': {
    'days': ['Dom', 'Seg', 'Ter', 'Qua', 'Quin', 'Sex', 'Sáb'],
    'months': ['Jan', 'Fev', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    'pickers': ['próximos 7 dias', 'próximos 30 dias', '7 dias anteriores', ' 30 dias anteriores'],
    'placeholder': {
      'date': 'Selecione uma data',
      'dateRange': 'Selecione um período'
    }
  },
  'ru': {
    'days': ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    'months': ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    'pickers': ['след. 7 дней', 'след. 30 дней', 'прош. 7 дней', 'прош. 30 дней'],
    'placeholder': {
      'date': 'Выберите дату',
      'dateRange': 'Выберите период'
    }
  },
  'de': {
    'days': ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    'months': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    'pickers': ['nächsten 7 Tage', 'nächsten 30 Tage', 'vorigen 7 Tage', 'vorigen 30 Tage'],
    'placeholder': {
      'date': 'Datum auswählen',
      'dateRange': 'Zeitraum auswählen'
    }
  },
  'it': {
    'days': ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    'months': ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    'pickers': ['successivi 7 giorni', 'successivi 30 giorni', 'precedenti 7 giorni', 'precedenti 30 giorni'],
    'placeholder': {
      'date': 'Seleziona una data',
      'dateRange': 'Seleziona un intervallo date'
    }
  },
  'cs': {
    'days': ['Ned', 'Pon', 'Úte', 'Stř', 'Čtv', 'Pát', 'Sob'],
    'months': ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer', 'Čerc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],
    'pickers': ['příštích 7 dní', 'příštích 30 dní', 'předchozích 7 dní', 'předchozích 30 dní'],
    'placeholder': {
      'date': 'Vyberte datum',
      'dateRange': 'Vyberte časové rozmezí'
    }
  }
});

/***/ }),

/***/ "xVGP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"k_Rij9LSW3PNizvfLBOjN","Dell":"_3b4qthdTfcxDGXwaqbwf5w","Abbott":"ScrcHG-AH9oLsIwswWCmR","Gap":"_1fdrL7nPUJ8PI1rL0Q92_n","Allstate":"_1coj8dWx2j8KN1LJsxlpgf","Asurion":"_2h3IJ50ZMZ5GdwLqsh_HLp","Invitae":"_29tP4_aXcKzr3FO2qjYmq8","JWE":"BXXWVQsXxT6b0ofb3EDFh"};

/***/ }),

/***/ "xY7D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/logo-dark.a4916b5.jpg";

/***/ }),

/***/ "xmRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  maxAmount: 999999999,
  defaultUniqueId: '00000000-0000-0000-0000-000000000000'
});

/***/ }),

/***/ "xp7W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

// import { accountType } from '@/components/_modules/Admin/settings'

var tabs = function tabs() {
  return [SCANNING_QUEUE, HISTORY];
};
/* harmony default export */ __webpack_exports__["a"] = ({
  get tabs() {
    return tabs();
  }
});

//
var SCANNING_QUEUE = {
  label: 'Scanning Queue',
  href: {
    params: {
      page: 'InvoiceScan',
      section: 'queue'
    }
  }
};
var HISTORY = {
  label: 'History',
  href: {
    params: {
      page: 'InvoiceScan',
      section: 'history'
    }
  }
};

/***/ }),

/***/ "xth5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  '*Id': '_',
  CompanyNameWithEoNumber: {
    label: 'Company Profile Name (EO Number)',
    width: 200
  },
  CompanyLegalName: {
    label: 'Legal Company Name',
    width: 140
  },
  City: {
    label: 'City',
    width: 75
  },
  StateRegion: {
    label: 'State/Region',
    type: 'text',
    width: 80
  },
  InsuranceStatus: {
    label: 'Status',
    width: 90
  },
  ExpirationDate: {
    label: 'Expiration Date',
    width: 90
  },
  ShouldBeVerified: {
    label: 'Pending Verification',
    width: 105,
    options: [{
      name: 'Yes'
    }, {
      name: 'No'
    }],
    type: 'list'
  },
  $$view: {
    label: 'View Details',
    uri: '#/d/Network/insurance-view-details?Id={{id}}'
  }
});

/***/ }),

/***/ "xwEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("2+iS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba7d3a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("rkBV");
function injectStyle (ssrContext) {
  __webpack_require__("GQh2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba7d3a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y+M7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'InvoiceNumber': {
    label: 'Invoice',
    uid: 'PaymentInvoiceID',
    uri: '#/i/Invoices/sent/?goto=InvoiceDetail/{{id}}/0/payment-list-receive',
    onclick: 'setCookie("from_tab", "SentInvoices", "/")',
    width: 190
  },
  'PONumber': {
    label: 'PO',
    width: 180
  },
  'ClientName': {
    label: 'Client',
    uid: 'PoSenderVci',
    uri: '#/i/Invoices/Profile{{id}}-{{screen}}',
    tooltip: 'View profile of {{text}}'
  },
  'PaymentMethodForSupplier': {
    label: 'Payment Method',
    source: 'PaymentList_PaymentsReceived'
  },
  'PaymentStatus': {
    label: 'Payment Status',
    source: 'PaymentList_PaymentsReceived'
    // render: statuses,
    // width: 270
  },
  'DueDateFormatted': 'Due',
  'DueDate': '_',
  'EstimatedPaymentDateFormatted': {
    label: 'Estimated Payment Date',
    nowrap: false
  },
  'Amount': 'Amount',
  'BatchID': {
    label: 'Batch #',
    visible: false
  },
  'CreatedBy': {
    label: 'Created By',
    visible: false
  },
  'CreatedByName': {
    label: 'Created By Name',
    visible: false
  },
  'UsageFeeWithMarketing': {
    label: 'Merchant Fee Amount',
    visible: false
  },
  'UsagePercentWithMarketing': {
    label: 'Merchant Fee %',
    type: 'percent',
    visible: false
  },
  'NetAmountAfterFees': {
    label: 'Net Amount After Fees',
    visible: false
  },
  'ProcessedDateFormatted': {
    label: 'Payment Processed Date',
    visible: false
  },
  'IsPostPayment': {
    label: 'Process Method',
    compose: ProcessMethod,
    visible: false
  },
  'ProcessFee': {
    label: 'Processing Fee Amount',
    visible: false
  },
  'CcPercent': {
    label: 'Processing Fee %',
    type: 'percent',
    visible: false
  },
  'ReferenceNo': {
    label: 'Reference ID',
    visible: false
  },
  'RejectedDateFormatted': {
    label: 'Rejected Date',
    visible: false
  },
  'RejectedReason': {
    label: 'Rejected Reason',
    source: 'PaymentList_PaymentsReceived',
    visible: false
  },
  'RushPaymentReason': {
    label: 'Rush Payment Reason',
    visible: false
  },
  'PaymentDate': '_',
  'PaymentDateFormatted': {
    label: 'Scheduled Payment Date',
    visible: false
  },
  'SupplierIDCode': {
    label: 'Supplier ID',
    visible: false
  },
  'WithholdingTaxAmount': {
    label: 'Withholding Tax',
    visible: false
  }
});
function ProcessMethod(p) {
  return p.data.IsPostPayment ? 'Posted' : 'Processed';
}

/***/ }),

/***/ "y/ak":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"NZvVIddri-82J2i8zLI-F","Dell":"_1HTEP5usg-Dcm2eYAb3w-d","Abbott":"_3xleV-ixJ_83eZAiyZlopF","Gap":"_3I8xP542_rEjAdt0NM_dPg","Allstate":"_3C9H5N9m-aqJIrGO0MunL3","Asurion":"BQcx2Gbbe13vEkLm7E5Uc","Invitae":"_2fWgcqQGfeM7B_dGYoDEp1","JWE":"_2F79eWLW_Qwi45TLWOZrn2"};

/***/ }),

/***/ "yA1C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_34NBIW0ed02js5nzyP-B9-","Dell":"_3Yu7RtySl88RnerRi2v-x8","Abbott":"_2Br97-S44LmANt69zsgV9T","Gap":"_1IqjGYg2t4eTWptfg4O5qa","Allstate":"gvLEDoEvUahGu2pWboE7g","Asurion":"_1Ux0PVMW9i8j0z8kGVt7Wf","Invitae":"_1DcjDGPqJpE10t6iIUNSjy","JWE":"_3sO11GnqKbqI-XwJ1RVajc"};

/***/ }),

/***/ "yApK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'md-fg-input',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number],
    labelFloating: Boolean,
    rows: Number,
    cols: Number
  }
});

/***/ }),

/***/ "yFC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__("fKPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__("rzQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_components_edTabNav_wizardMixin__ = __webpack_require__("3d8/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_he__ = __webpack_require__("t02m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__I2P_dialogs_InviteSupplierDialog__ = __webpack_require__("hWew");


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import customTypes from './types.json'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImportInvoices',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__core_components_edTabNav_wizardMixin__["a" /* default */]],
  watch: {
    attachedFile: function attachedFile(newVal) {
      this.requiredInvoiceUpload = !(newVal && newVal.length > 0 && this.uploadFileValid);
    }
  },
  methods: {
    /**
     * Updates matched column/columns list
     */
    handleMultimatch: function handleMultimatch(field, value) {
      if (field.Type === 'list') {
        field.Columns = field.Columns || [];
        field.Columns.push(value);
      } else {
        field.Columns = [value];
      }
      this.$forceUpdate();
    },
    /**
     * Removes 1:1 match
     */
    removeMatch: function removeMatch(field) {
      field.Columns = [];
      this.$forceUpdate();
    },
    /**
     * Removes 1:* match
     */
    removeColumn: function removeColumn(column, field) {
      field && field.Columns.splice(field.Columns.indexOf(column), 1);
      this.$forceUpdate();
    },
    /**
     * Gets categories list
     */
    fetchCategories: function fetchCategories(invoiceId) {
      var _this = this;
      var invoice = this.invoices.invoices.filter(function (i) {
        return i['InvoiceID'] === invoiceId && i['ProgramID'] > 0;
      })[0];
      var programId = (invoice || {})['ProgramID'] || 0;
      this.api(this.api.$.invoice.categories + '?programId=' + programId).then(function (r) {
        _this.categories = r.data || [];
      });
    },
    /**
     * Gets suppliers list
     */
    fetchSuppliers: function fetchSuppliers(query) {
      var _this2 = this;
      this.api.forms.post(this.api.$.invoice.suppliers, {
        q: query || ''
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          _this2.suppliers = JSON.parse(r.data.Data);
        }
      });
    },
    /**
     * Gets suppliers list
     */
    fetchPrograms: function fetchPrograms(query) {
      var _this3 = this;
      this.api.forms.post(this.api.$.invoice.list.uploadInvoicePrograms, {
        q: query || '',
        onlyI2PInvoices: true
      }).then(function (r) {
        if (r && r.data && r.data.Data) {
          var parsedPrograms = _this3.splitProgramDetails(r.data.Data);
          _this3.programs = parsedPrograms;
        }
      });
    },
    splitProgramDetails: function splitProgramDetails(programsWithDetails) {
      var newPrograms = [];
      programsWithDetails.map(function (program) {
        var elements = program.Value.split('##');
        var newProgram = {
          Key: program.Key,
          Value: {
            ProgramName: elements[0],
            InternalProgramId: elements[1] ? elements[1] : ''
          }
        };
        newPrograms.push(newProgram);
      });
      return newPrograms;
    },
    /**
     * Checks if required/all fields are matched
     */
    checkMatched: function checkMatched() {
      if (this.data.fieldsMap[0].FieldName !== null) {
        var allRequiredMatched = this.data.fieldsMap.filter(function (field) {
          return field.IsRequired && !(field.Columns && field.Columns.length);
        }).length === 0;
        var allMatched = this.canSkip || this.data.fieldsMap.filter(function (field) {
          return !field.IsRequired && !(field.Columns && field.Columns.length);
        }).length === 0;
        this.notAllRequiredMatched = !allRequiredMatched;
        this.notAllMatched = allRequiredMatched && !allMatched;
        if (!allRequiredMatched) {
          __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* Eved */].INVOICE.IMPORT.INVALID);
        }
        return allRequiredMatched && allMatched;
      }
    },
    /**
     * Can proceed to next step if not all not required are matched
     */
    skipMatch: function skipMatch() {
      this.canSkip = true;
      this.proceed();
      this.canSkip = false;
    },
    /**
     * Callback after each step
     */
    afterEnterStep: function afterEnterStep(step) {
      // Activate Admin menu
      global.Page.showTabs('Admin', 'Import', '#d', null);

      // reset any pending data
      this.$store.state.pendingData = null;
      if (step) {
        __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* Eved */].INVOICE.IMPORT.ENTERED_STEP, step);
      }
    },
    addNewSupplierClickHandler: function addNewSupplierClickHandler() {
      this._openInviteSupplierModalDialog('add');
    },
    _openInviteSupplierModalDialog: function _openInviteSupplierModalDialog(operation) {
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_6__I2P_dialogs_InviteSupplierDialog__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: null,
          invoiceId: this.getInvoiceId,
          eventHub: __WEBPACK_IMPORTED_MODULE_3__event_bus__["b" /* EventBus */],
          operation: operation
        }
      });
      instance.$slots.default = [];
      instance.$mount();
      this.$refs.addNewSupplierDialogContainer.appendChild(instance.$el);
    }
  },
  created: function created() {
    this.importedColumns = [];
    this.he = __WEBPACK_IMPORTED_MODULE_5_he___default.a;
  },
  computed: {
    getInvoices: function getInvoices() {
      var _this4 = this;
      this.invoices.invoices.forEach(function (invoice, i) {
        invoice.selected = typeof invoice.selected === 'undefined' ? !invoice.Duplicates : invoice.selected;
        invoice.selected = typeof invoice.selected !== 'undefined' && (_this4.duplicateInvoiceId(invoice, i) ? (_this4.invoices.invoices[i - 1] || {}).selected : invoice.selected);
        return invoice;
      });
      return this.invoices.invoices || [];
    },
    additionalInfo: function additionalInfo() {
      var o = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(this.getInvoices).filter(this.invoiceToImport).map(function (invoice) {
        var i = _objectSpread({}, invoice);
        var uploadedFile = ((i.attachment || [])[0] || {}).response;
        if (typeof uploadedFile === 'string') {
          i.attachment = JSON.parse(uploadedFile);
        }
        return i;
      });
      return JSON.stringify(o);
    },
    currency: function currency() {
      return this.getInvoices[0].Currency;
    }
  },
  data: function data() {
    var _this5 = this;
    return {
      canSkip: false,
      notAllMatched: false,
      notAllRequiredMatched: false,
      supplierCopy: {},
      data: {
        fieldsMap: [{
          FieldName: null,
          IsRequired: true,
          Columns: []
        }],
        importedColumns: []
      },
      errors: null,
      invoices: {
        invoices: [{
          selected: true
        }],
        defaultCategory: {}
      },
      categories: [],
      suppliers: [],
      programs: [],
      requiredInvoiceUpload: true,
      validItem: function validItem(invoice, i) {
        var hasCategory = invoice.category;
        var hasAttachment = (invoice.attachment || []).length;
        var hasToHaveAttachment = !_this5.duplicateInvoiceId(invoice, i);
        return hasCategory && (hasToHaveAttachment ? hasAttachment && !invoice.uploadFileError : true) || !invoice.selected;
      },
      validAttachment: function validAttachment(invoice, i) {
        var message = ''; // 'Nothing selected'

        if (invoice.attachment && invoice.attachment[0]) {
          var file = invoice.attachment[0];
          var error = file.error;
          switch (error) {
            case 'extension':
              message = 'Wrong format';
              break;
            case 'denied':
              message = 'Server could not be reached';
              break;
          }
          invoice.uploadFileError = message;
          // this.setDetails('uploadFileError', invoice, message, i)
          return;
        }
        invoice.uploadFileError = '';
        // this.setDetails('uploadFileError', invoice, '', i)
      },
      duplicateInvoiceId: function duplicateInvoiceId(invoice, i) {
        if (i === 0) return false;
        return (_this5.invoices.invoices[i - 1] || {})['InvoiceID'] === invoice['InvoiceID'];
      },
      shouldDisplayTotal: function shouldDisplayTotal(invoice, i) {
        return (_this5.invoices.invoices[i + 1] || {})['InvoiceID'] !== invoice['InvoiceID'];
      },
      invoiceToImport: function invoiceToImport(invoice) {
        return invoice.selected;
      },
      /**
       * Column match label
       */
      columnName: function columnName(option, multiple) {
        if (!option) return;
        if (option.length === 0) return '';

        //
        if (multiple === false) {
          return option;
        }

        // 1:* match
        if (multiple) return option && option.length + ' selected';

        // 1:1 match - [LETTER] NAME
        return option && typeof option === 'string' ? option : "[".concat(option.Letter || option[0] && option[0].Letter, "] ").concat(option.Name || option[0] && option[0].Name || '[None]');
      },
      setDetails: function setDetails(field, invoice, value, index) {
        invoice[field] = value;
        this.$set(this.invoices.invoices, index, invoice);
      },
      getProgramLabel: function getProgramLabel(option) {
        if (!option.Value) return 'N/A';
        return option.Value.ProgramName + (option.Value.InternalProgramId ? ' ' + option.Value.InternalProgramId : '');
      },
      changeProgram: function changeProgram(invoice, value, index) {
        var _this6 = this;
        this.setDetails('loading', invoice, true, index);
        this.setDetails('ProgramID', invoice, value.InternalProgramId.replace('(', '').replace(')', ''), index);
        this.setDetails('ProgramName', invoice, value.ProgramName, index);
        this.api.forms.post(this.api.$.invoice.getProcessingFeeByProgram, {
          invoices: JSON.stringify(this.invoices.invoices.filter(function (i) {
            return i['InvoiceID'] === invoice['InvoiceID'];
          }))
        }).then(function (r) {
          if (r.data) {
            _this6.setDetails('ProcessingFee', invoice, r.data.ProcessingFee, index);
          }
          _this6.setDetails('loading', invoice, false, index);
        });
      },
      getSupplierLabel: function getSupplierLabel(option) {
        if (!option.Value) return 'N/A';
        return option.Value.CompanyName + (option.Value.Vci ? '(' + option.Value.Vci + ')' : '');
      },
      changeSupplier: function changeSupplier(invoice, value, index) {
        var _this7 = this;
        this.setDetails('loading', invoice, true, index);
        this.setDetails('SupplierEONumber', invoice, "".concat(value.Vci), index);
        this.setDetails('SupplierID', invoice, '', index);
        this.setDetails('SupplierName', invoice, "".concat(value.CompanyName), index);
        this.setDetails('SupplierContactName', invoice, "".concat(value.SupplierName), index);
        this.setDetails('SupplierEmail', invoice, "".concat(value.SupplierEmail), index);
        this.setDetails('SupplierIsEvedPay', invoice, "".concat(value.IsEvedPay), index);
        this.setDetails('SupplierVendorType', invoice, "".concat(value.VendorType), index);
        this.setDetails('SupplierLogo', invoice, "".concat(value.Logo), index);
        this.setDetails('SupplierCountryName', invoice, "".concat(value.CountryName), index);
        this.setDetails('SupplierCity', invoice, "".concat(value.City), index);
        this.setDetails('StoredSupplierZipCode', invoice, "".concat(value.SupplierZIP), index);
        this.setDetails('SupplierRegionOrState', invoice, "".concat(value.State || value.Region), index);
        this.setDetails('SupplierBusinessType', invoice, "".concat(value.BusinessType), index);
        this.setDetails('SupplierRequestedName', invoice, "".concat(value.SupplierRequestedName), index);
        this.api.forms.post(this.api.$.invoice.validateChangeSupplierAtImport, {
          invoices: JSON.stringify(this.invoices.invoices.filter(function (i) {
            return i['InvoiceID'] === invoice['InvoiceID'];
          }))
        }).then(function (r) {
          if (r.data) {
            if (r.data.Duplicates.length) {
              _this7.setDetails('Duplicates', invoice, r.data.Duplicates, index);
            }
            _this7.setDetails('ProcessingFee', invoice, r.data.ProcessingFee, index);
            _this7.setDetails('ZipCodeErrors', invoice, r.data.ZipCodeErrors, index);
          }
          _this7.setDetails('loading', invoice, false, index);
        });
      },
      editSupplier: function editSupplier(invoice, index) {
        var SupplierName = invoice.SupplierName,
          SupplierEmail = invoice.SupplierEmail,
          SupplierFirstName = invoice.SupplierFirstName,
          SupplierLastName = invoice.SupplierLastName,
          SupplierPhoneNumber = invoice.SupplierPhoneNumber;
        this.supplierCopy = {
          SupplierName: SupplierName,
          SupplierEmail: SupplierEmail,
          SupplierFirstName: SupplierFirstName,
          SupplierLastName: SupplierLastName,
          SupplierPhoneNumber: SupplierPhoneNumber
        };
        this.setDetails('editSupplierModal', invoice, true, index);
      },
      validateSupplier: function validateSupplier(invoice, index) {
        this.setDetails('editSupplierModal', invoice, false, index);
      },
      revertSupplier: function revertSupplier(invoice, index) {
        invoice.SupplierName = this.supplierCopy.SupplierName;
        invoice.SupplierEmail = this.supplierCopy.SupplierEmail;
        invoice.SupplierFirstName = this.supplierCopy.SupplierFirstName;
        invoice.SupplierLastName = this.supplierCopy.SupplierLastName;
        invoice.SupplierPhoneNumber = this.supplierCopy.SupplierPhoneNumber;
        this.setDetails('editSupplierModal', invoice, false, index);
      },
      /**
       * Enables/disables unselected/selected columns
       */
      updateMatches: function updateMatches(fields, columns) {
        if (!columns) return fields || [];
        if (!columns.length) return fields;
        var matchedFields = fields.map(function (field) {
          return field.Columns;
        }).reduce(function (fields, columns) {
          return (fields || []).concat(columns);
        }).filter(function (columns) {
          return columns;
        }).map(function (column) {
          return column.Letter;
        });
        columns = columns.map(function (column) {
          if (~matchedFields.indexOf(column.Letter)) {
            column.$isDisabled = true;
          } else {
            delete column.$isDisabled;
          }
          return column;
        });
        return fields;
      },
      /**
       * Only inject options @open dropdown
       * to avoid performance bottlenecks
       * when rendering large sets
       */
      fetchImportedColumns: function fetchImportedColumns(columns, index) {
        this.$set(this.importedColumns, index, columns);
        this.$forceUpdate();
      },
      getImportedColumns: function getImportedColumns(index) {
        return this.importedColumns[index] || [];
      },
      totalInvoiceAmount: function totalInvoiceAmount(invoice) {
        return this.getInvoices.filter(function (i) {
          return i.InvoiceID === invoice.InvoiceID;
        }).map(function (l) {
          return l.ItemTotalAmountWithTaxes;
        }).reduce(function (a, b) {
          return a + b;
        }, 0);
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "yVeY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3iATEm_q3TvpjQx6FKU8jl","Dell":"_2plVYukV6YMPCTKKGYtDep","Abbott":"-gUA3On9uVDf821vNaiyz","Gap":"_1LrR4BzSPohKl5Jn2gIp1M","Allstate":"_1Ozdtc9u2v1al5hP_OSJR9","Asurion":"vGG-z8nIPQ1zTQTXhk-B_","Invitae":"_2u7nnMVQy4NbQPjurtYNnN","JWE":"_39zhTH9s-LEZ4yGDxFdtvK"};

/***/ }),

/***/ "yVx8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_components_edInputTooltip_index_vue__ = __webpack_require__("7npE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-textarea',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    fieldLabel: String,
    hideOptional: Boolean,
    name: String,
    disabled: Boolean,
    error: Boolean,
    placeholder: String,
    value: [String, Number],
    required: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    rows: Number,
    cols: Number,
    maxLength: Number,
    helptipHeader: String,
    helptipBody: String,
    errorTipHeader: String,
    errorTipBody: String
  },
  directives: {
    focus: {
      inserted: function inserted(el, binding) {
        if (binding.value) el.focus();else el.blur();
      },
      componentUpdated: function componentUpdated(el, binding) {
        if (binding.modifiers.lazy) {
          if (Boolean(binding.value) === Boolean(binding.oldValue)) {
            return;
          }
        }
        if (binding.value) el.focus();else el.blur();
      }
    }
  },
  components: {
    'ed-input-tooltip': __WEBPACK_IMPORTED_MODULE_0__core_components_edInputTooltip_index_vue__["default"]
  },
  data: function data() {
    return {
      focused: false
    };
  },
  computed: {
    remainingChars: function remainingChars() {
      if (!this.maxLength || isNaN(this.maxLength)) return '';
      var chars = this.value && this.value.length;
      var remaining = this.maxLength - chars;
      if (remaining < 0) remaining = 0;
      return remaining + ' characters remaining';
    }
  }
});

/***/ }),

/***/ "yYTH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__ = __webpack_require__("TgOl");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d18d5d7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__ = __webpack_require__("pcPi");
function injectStyle (ssrContext) {
  __webpack_require__("WRyJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d18d5d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d18d5d7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ybBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PredictedCodingIcon'
});

/***/ }),

/***/ "ybql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isRejected: function isRejected() {
      var rejectStatuses = ['Rejected', 'Declined', 'Exported - Rejected', 'Posted - Rejected', 'Exported - Declined', 'Posted - Declined'];
      return rejectStatuses.includes(this.params.value);
    },
    displayValue: function displayValue() {
      return this.params.value.replace(/Rejected/g, 'Declined');
    },
    tooltipContent: function tooltipContent() {
      return !this.isRejected ? this.params.value : this.getRejectionReason();
    }
  },
  methods: {
    getRejectionReason: function getRejectionReason() {
      return 'Decline Reason: ' + this.params.data.RejectionReason + '<br>Only ' + this.params.data.CreatedByUser + ' can edit this envelope.';
    }
  }
});

/***/ }),

/***/ "ycoi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardSelector',
  created: function created() {
    this.redirect();
  },
  activated: function activated() {
    this.redirect(true);
  },
  methods: {
    redirect: function redirect(initial) {
      var domain = parseInt(this.$user.$.domain);
      var isFusion = +this.$user.$.data.IsFusion;
      var userPermissions = this.$user.$.userPermissions;
      var commerceModules = this.$user.$.modules && this.$user.$.modules.Commerce || {};
      if (initial && this.$routerHistory.hasHistory() === '/d/Dashboard/My' && (userPermissions.length === 1 && userPermissions.includes('EvedPayCardUser') || userPermissions.length === 2 && userPermissions.includes('EvedPayCardUser') && userPermissions.includes('Reports')) && commerceModules['EvedPay Cards']) {
        this.$router.replace('/d/Programs/>Card/');
        return;
      }
      if (domain === 1) {
        if (isFusion === 0) {
          this.$router.replace('/i/Dashboard/MyDashboard');
        } else {
          this.$router.replace('/d/Dashboard/MyDashboard');
        }
      } else {
        if (domain !== null && typeof domain !== 'undefined') {
          this.$router.replace('/i/Dashboard');
        } else {
          global.app.$user.logout();
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "ye2/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-wrapper"},[_c('form',{attrs:{"action":"#","endpoint":_vm.endpoint,"no-submit":_vm.$attrs["no-submit"]},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm(_vm.endpoint)}}},[(_vm.formHeader)?_c('h4',[_vm._v(_vm._s(_vm.formHeader))]):_vm._e(),_vm._t("default"),(_vm.submitVisible)?_c('ed-button',{class:_vm.submitClass,attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.submitText))]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ygWI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApprovalNeededUsers_vue__ = __webpack_require__("LnE1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_978c814c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApprovalNeededUsers_vue__ = __webpack_require__("wA9Y");
function injectStyle (ssrContext) {
  __webpack_require__("J7rH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-978c814c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApprovalNeededUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_978c814c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApprovalNeededUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yi8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    var model = {
      'BusinessUnitId': {
        label: '_'
      },
      '*BusinessUnitName': {
        label: 'Business Unit',
        width: 30,
        editable: true
      }
    };
    return model;
  }
});

/***/ }),

/***/ "yjLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ojCN");
/* empty harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ynfE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_item_vue__ = __webpack_require__("0mfs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7134b98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_item_vue__ = __webpack_require__("mEnS");
function injectStyle (ssrContext) {
  __webpack_require__("A1we")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7134b98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yvmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.hasData && !_vm.loading)?_c('div',{staticClass:"row bottom-border"},[_c('span',{staticClass:"header status"},[_vm._v("Status")]),_vm._v(" "),_c('span',{staticClass:"header invoice-number"},[_vm._v("Invoice")]),_vm._v(" "),_c('span',{staticClass:"header total-amount text-right"},[_vm._v("Amount")]),_vm._v(" "),_c('span',{staticClass:"header due-date text-center"},[_vm._v("Due Date")]),_vm._v(" "),_c('span',{staticClass:"header supplier-name text-left"},[_vm._v("Supplier")])]):_vm._e(),_vm._v(" "),(_vm.hasData)?_c('div',{staticClass:"scroller"},[_c('div',_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"row"},[_c('span',{staticClass:"status"},[_c('span',{class:{'indicator': true, 'red': (item.InvoiceStatus.indexOf('Overdue') !== -1)},attrs:{"title":item.InvoiceStatus}},[_vm._v(_vm._s(item.InvoiceStatus))])]),_vm._v(" "),_c('span',{staticClass:"invoice-number",attrs:{"title":item.InvoiceNumber}},[_c('a',{attrs:{"href":item.InvoiceUrl},on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v("\n              "+_vm._s(item.InvoiceNumber)+"\n            ")])]),_vm._v(" "),_c('span',{staticClass:"total-amount text-right",attrs:{"title":item.TotalAmount}},[_vm._v(_vm._s(item.TotalAmount))]),_vm._v(" "),_c('span',{staticClass:"due-date text-center",attrs:{"title":item.DueDate}},[_vm._v(_vm._s(item.DueDate))]),_vm._v(" "),_c('span',{staticClass:"supplier-name text-left",attrs:{"title":item.SupplierName}},[(item.SupplierUrl !== null)?_c('a',{attrs:{"href":item.SupplierUrl}},[_vm._v(_vm._s(item.SupplierName))]):_c('a',{staticClass:"no-link"},[_vm._v(_vm._s(item.SupplierName))])])])}),0)]):_vm._e(),_vm._v(" "),(this.loading)?_c('div',{staticClass:"empty-holder"},[_c('span',{staticClass:"inv-loading"}),_vm._v(" Loading current invoices ...\n    ")]):_vm._e(),_vm._v(" "),(!_vm.hasData && !this.loading)?_c('div',{staticClass:"empty-holder"},[_c('i',{staticClass:"fal fa-list"}),_vm._v(" "),_vm._m(0)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('p',{staticClass:"bold"},[_vm._v("No Invoices Found")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("No invoices are currently open")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yynm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content rule-action-group"},[_c('div',{ref:"actionRaw",staticClass:"row"},[_c('div',{staticClass:"col-md-12"}),_c('div',{staticClass:"well well-sm"},[_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-md-1"},[_vm._v("THEN")]),_c('ed-select',{staticClass:"col-md-5 middle",attrs:{"options":_vm.actionOperators},on:{"select":function($event){return _vm.changeOperator($event)}},model:{value:(_vm.actionOperatorModel),callback:function ($$v) {_vm.actionOperatorModel=$$v},expression:"actionOperatorModel"}}),_vm._t("delete-action"),_vm._l((_vm.processedActions),function(action,i){return _c('div',{key:i,staticClass:"row"},[_c('ed-select',{staticClass:"col-md-3",attrs:{"options":action.actionValues,"label":"label","placeholder":"Select action context"},on:{"select":function($event){return _vm.resetActionLine(action, $event)}},model:{value:(action.__selectedContextType),callback:function ($$v) {_vm.$set(action, "__selectedContextType", $$v)},expression:"action.__selectedContextType"}}),_c('ed-select',{staticClass:"col-md-3",attrs:{"placeholder":"Select operator","options":_vm.operators},on:{"select":function($event){return _vm.changeActionOperator(action, $event)}},model:{value:(_vm.operatorType[action.Operator]),callback:function ($$v) {_vm.$set(_vm.operatorType, action.Operator, $$v)},expression:"operatorType[action.Operator]"}}),_c('ed-select',{staticClass:"col-md-3",attrs:{"placeholder":"Select action","openEndpoint":_vm.api.$.approval.getItemOwnerValues,"multiple":"","checkboxes":"","multilist":"","options":action.__o,"groupLabel":"label","groupValues":"options","label":"Name","trackBy":"Uid","disableSelected":"","globalSelectedValues":_vm.__selectedGlobalOptions,"selectedValues":action.__selectedOp},on:{"apply":function($event){return _vm.setActionOptions(action, $event)},"open":function($event){action.__selectedContextType && _vm.getOptions(action, $event)}},model:{value:(action.__selectedOptions),callback:function ($$v) {_vm.$set(action, "__selectedOptions", $$v)},expression:"action.__selectedOptions"}},[_c('div',{attrs:{"slot":"additionalOptions"},slot:"additionalOptions"},[_c('ed-checkbox',{attrs:{"options":action.__selectedAdditionalOptions}})],1)]),_c('div',{staticClass:"col-md-3 icon-bar"},[_c('div',{staticClass:"fas fa-trash-alt pull-right",on:{"click":function($event){return _vm.deleteConditionModal(action)}}}),_c('div',{staticClass:"fas fa-copy pull-right",on:{"click":function($event){return _vm.copyActionLine(i)}}}),(_vm.useParallelApprovalRoutes && action.__selectedContextType.label === "Request Approval From")?_c('ed-select',{staticClass:"col-md-6",attrs:{"placeholder":"Select route","options":_vm.routeValues,"label":"label"},on:{"select":function($event){return _vm.changeRouteNo(action, $event)}},model:{value:(action._parallelRouteNo),callback:function ($$v) {_vm.$set(action, "_parallelRouteNo", $$v)},expression:"action._parallelRouteNo"}}):_vm._e()],1)],1)})],2)])]),_c('ed-modal',{attrs:{"show":_vm.showDeleteModal,"title":"","subtitle":"Are you sure you want to delete this action?","primaryButton":"Yes","secondaryButton":"No","type":"small"},on:{"close":function($event){_vm.showDeleteModal = false},"confirm":function($event){return _vm.deleteActionLine()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z01l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_vue__ = __webpack_require__("FKdl");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038dd792_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_radio_vue__ = __webpack_require__("kPNv");
function injectStyle (ssrContext) {
  __webpack_require__("LTwu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038dd792_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "z3J+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("MgPI");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f0930f1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("PvP1");
function injectStyle (ssrContext) {
  __webpack_require__("h9OM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f0930f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f0930f1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "zAeo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ed-section',
  props: {
    title: String,
    subtitle: String,
    wide: Boolean,
    fullWidth: Boolean
  },
  computed: {
    offset: function offset() {
      return "col-md-offset-".concat(this.$attrs.offset);
    }
  },
  mounted: function mounted() {
    document.querySelector('.dummy').focus();
  }
});

/***/ }),

/***/ "zEw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-filter"},[_c('p',{staticClass:"column-title"},[_vm._v(_vm._s(_vm.columnTitle)+" (DATE RANGE)")]),_c('ed-datepicker',{ref:'input',attrs:{"placeholder":_vm.columnTitle,"placement":"inline","fit":"","range":"","hidden":"","xformat":"dateFormat"},on:{"update-date":_vm.setRange,"inputRange":_vm.setFormattedDate},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c('ed-button',{staticClass:"btn btn-actionbar",on:{"click":_vm.apply}},[_vm._v(_vm._s(_vm.t("Apply")))]),_vm._v(" \n "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.clear.apply(null, arguments)}}},[_c('u',[_vm._v(_vm._s(_vm.t("clear filter")))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zKv+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3XoJGvbxIcltFS99oCOIUQ","Dell":"_3OrY23B4GgYPQ-VThVQ_7b","Abbott":"_1sl8ukEolD3mTBujufWqPy","Gap":"SHS7Qf9fQUoE1aRMZ-uc_","Allstate":"_3zxuJ2OWWYUByGuV-L-nol","Asurion":"_1SpYYRKdF6N8KI-ZzoE2ne","Invitae":"_1y8-2LlEYqyaSq5QXzHYa9","JWE":"_1T7QP97NFvkmTGD5gPyTHK"};

/***/ }),

/***/ "zS+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAPFileTemplate_vue__ = __webpack_require__("GDnQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ff5eb8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAPFileTemplate_vue__ = __webpack_require__("jd/P");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAPFileTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ff5eb8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAPFileTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zUEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sitemap__ = __webpack_require__("lHmF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sitemap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sitemap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFound_vue__ = __webpack_require__("pqHe");


var bundle = {};
function pack(eventHandler) {
  return include(__WEBPACK_IMPORTED_MODULE_0__sitemap___default.a, eventHandler);
}
function include(components, eventHandler, pack) {
  Object.keys(components).forEach(function (key) {
    var module = (pack ? pack + '/' : '') + key;
    if (components[key].subtabs) {
      include(components[key].subtabs, eventHandler, key);
    }
    bundle[module] = function () {
      return __webpack_require__("qqer")("./".concat(module, "/index.vue")).catch(function (e) {
        console.warn('Doc not found');
        bundle[module] = __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFound_vue__["a" /* default */];
        bundle[module].on = eventHandler;
        var currentPath = global.app.$router.currentRoute.path;
        global.app.$router.push({
          name: '404'
        });
        global.app.$router.push(currentPath);
        global.app.$loading = false;
      });
    };
    bundle[module].on = eventHandler;
  });
  return bundle;
}
/* harmony default export */ __webpack_exports__["a"] = ({
  pack: pack
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "zXEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteCard_vue__ = __webpack_require__("pUcv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357a586a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteCard_vue__ = __webpack_require__("9ZZd");
function injectStyle (ssrContext) {
  __webpack_require__("2iQL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-357a586a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357a586a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zYxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, utils) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("7hDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__("En79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Grid__ = __webpack_require__("8USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Grid_cells_actions__ = __webpack_require__("ayPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_InvoiceDetails__ = __webpack_require__("ePHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_InvoiceDetailsWithDivision__ = __webpack_require__("DRvl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PaymentPriorityTag__ = __webpack_require__("FqzP");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_2__components_Grid__["a" /* default */]
  },
  props: {
    invoices: Array,
    settings: Object
  },
  data: function data() {
    return {
      initialLoad: false,
      fundingCurrencyChanged: 0,
      InvoiceDetailsComponent: __WEBPACK_IMPORTED_MODULE_5__components_InvoiceDetails__["a" /* default */],
      InvoiceDetailsWithDivisionComponent: __WEBPACK_IMPORTED_MODULE_6__components_InvoiceDetailsWithDivision__["a" /* default */],
      uid: this.$route.query.key
    };
  },
  created: function created() {
    var _this = this;
    this.$on(__WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* Eved */].PAYMENT.FUNDING_CURRENCY_CHANGED, function () {
      _this.fundingCurrencyChanged++;
    });
  },
  updated: function updated() {
    this.initialLoad = true;
    this.$refs.PaymentInvoices.updateRowData();
  },
  computed: {
    getTitle: function getTitle() {
      return this.settings.title || ' ';
    },
    getSubtitle: function getSubtitle() {
      return this.settings.subtitle || '';
    },
    actions: function actions() {
      return [__WEBPACK_IMPORTED_MODULE_4__components_Grid_cells_actions__["d" /* expand */]];
    },
    gridModel: function gridModel() {
      var config = {
        SupplierName: {
          label: 'Supplier',
          width: 100,
          editable: false
        },
        '*InvoiceNumber': {
          label: 'Invoice',
          width: 100,
          editable: false
        },
        ProgramName: {
          label: global.app.$user.sessionSettings.CompanySettings.ProgramLabel,
          width: 100,
          editable: false
        },
        OriginalAmount: {
          label: 'OriginalAmount',
          editable: false,
          visible: false
        },
        PaymentPriority: {
          label: 'Payment Priority',
          width: 60,
          editable: false,
          visible: true,
          type: 'tags',
          render: __WEBPACK_IMPORTED_MODULE_7__components_PaymentPriorityTag__["a" /* default */]
        },
        Amount: {
          label: 'Amount',
          width: 60,
          editable: this.settings.editable,
          maxThreshold: {
            value: 0,
            f: 'OriginalAmount'
          },
          minThreshold: {
            value: 0
          }
        },
        details: {
          label: '+',
          details: 'local'
        },
        IsAmountDisabled: {
          label: 'IsAmountDisabled',
          type: utils.constants.columnType.Text,
          editable: false,
          visible: false
        }
      };
      if (!this.settings.isMakePayment || !this.isInvoiceCurrencyDifferentThanFundingCurrency()) {
        config.Amount.currency = this.settings.fundingCurrencyCode;
        config.Amount.f = 'data.Amount';
      }
      if (this.settings.fundingCurrencyCode !== '' && this.isInvoiceCurrencyDifferentThanFundingCurrency()) {
        config.AmountUSD = {
          label: this.getAmountUSDLabel(),
          width: 60,
          editable: false,
          currency: this.settings.fundingCurrencyCode,
          visible: this.settings.displayUSDEquivalent,
          f: 'data.AmountUSD'
        };
      }
      if (this.settings.editable === true) {
        config.Amount.editable = true;
        if (this.settings.isMakePayment) {
          config.Amount.notEditableIf = {
            f: 'IsAmountDisabled'
          };
          config.Amount.infoMessage = function (params) {
            return params.data.IsNonEvedPayReady && !params.data.IsSameDayDeposit ? 'You are about to make payment to a supplier outside of the EvedPay network. At this time, we cannot make partial payments to those outside our network.' : null;
          };
        }
      }
      return config;
    },
    getTotal: function getTotal() {
      var _this2 = this;
      var paymentTotalAmount = 0;
      this.invoices.map(function (inv) {
        if (!inv.IsSameDayDeposit) {
          if (!_this2.settings.isMakePayment || _this2.settings.fundingCurrencyCode && !_this2.isInvoiceCurrencyDifferentThanFundingCurrency()) {
            paymentTotalAmount += Number(inv.Amount);
          } else {
            paymentTotalAmount += Number(inv.AmountUSD);
          }
        }
      });
      return paymentTotalAmount;
    }
  },
  methods: {
    isInvoiceCurrencyDifferentThanFundingCurrency: function isInvoiceCurrencyDifferentThanFundingCurrency(invoices) {
      var _this3 = this;
      var result = this.invoices && this.invoices.find(function (i) {
        return i.CurrencyCode && _this3.settings.fundingCurrencyCode && i.CurrencyCode !== _this3.settings.fundingCurrencyCode;
      });
      if (result) {
        return true;
      } else {
        return false;
      }
    },
    getAmountUSDLabel: function getAmountUSDLabel() {
      var currencyLabel = this.settings.fundingCurrencyCode || utils.constants.invoice.USD;
      return currencyLabel + ' Equivalent';
    },
    updateEventAmount: function updateEventAmount(item) {
      var _this4 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var editedInvoice;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              editedInvoice = _this4.invoices.find(function (inv) {
                return inv.PaymentInvoiceId === item.data.PaymentInvoiceId;
              });
              _context.next = 3;
              return _this4.updateModel(editedInvoice, item);
            case 3:
              _this4.isInvoiceCurrencyDifferentThanFundingCurrency() && _this4.emitCurrencyConversionEvent(item);
              _this4.$emit(__WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* Eved */].PAYMENT.PAYMENT_AMOUNT_CHANGED, {});
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    updateModel: function updateModel(editedInvoice, item) {
      if (editedInvoice && editedInvoice.Events !== null && editedInvoice.Events.length > 0) {
        if (editedInvoice.Events.length > 1) {
          for (var i = 1; i < editedInvoice.Events.length; i++) {
            item.data.Amount -= editedInvoice.Events[i].Balance;
          }
        }
        editedInvoice.Events[0].Balance = item.data.Amount;
      }
    },
    emitCurrencyConversionEvent: function emitCurrencyConversionEvent(item) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* Eved */].PAYMENT.MAKE_PAYMENT_CONVERSION, {
        CurrencyCode: this.settings.fundingCurrencyCode,
        PaymentInvoiceId: item.data.PaymentInvoiceId
      }, this.$refs.PaymentInvoices.updateRowData);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("RMJP")))

/***/ }),

/***/ "ziuV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_Invoices_tabs__ = __webpack_require__("Q++R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LegacyContainer__ = __webpack_require__("jIfZ");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LegacyContainer: __WEBPACK_IMPORTED_MODULE_1__components_LegacyContainer__["a" /* default */]
  },
  data: function data() {
    return {
      tabs: __WEBPACK_IMPORTED_MODULE_0__components_modules_Invoices_tabs__["a" /* default */].tabs
    };
  },
  computed: {
    url: function url() {
      return 'PaymentInvoice/EditInvoice/' + this.$router.currentRoute.query.id + '?fromPage=' + this.$router.currentRoute.query.fromPage;
    }
  }
});

/***/ }),

/***/ "ziuz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_3NeEZD9cRG3kAho1gu1Kly","Dell":"_3UXTEJdak1tQLzeHcMQxmk","Abbott":"L6lNJLAFV5dnBQIg_4Iaa","Gap":"HvrlhIVY0slzKRFKLlni8","Allstate":"_2ORJRvAsUY4xCR6SxiQYus","Asurion":"_2Kl8-rYTwIoOO0C85Ciwrg","Invitae":"J2yXwheZGmzdK9zdyAaCW","JWE":"FFglxqtyikkwN9FFZ4ovQ"};

/***/ }),

/***/ "zjcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Iddi");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf3575c0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ye2/");
function injectStyle (ssrContext) {
  __webpack_require__("Z/NV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf3575c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf3575c0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "zl3+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2cO6Lnk1T7cJbjtyPLhQkn","Dell":"_2VN8UU6DeXy-zwowWM_g0A","Abbott":"VxehLCweCBq41PbuJUO0p","Gap":"_1LB3UUDr7odOSX1ZowbXpU","Allstate":"pbnGbaueJ2aB3_WXv11eT","Asurion":"_2feqbhGkg_hLh7u4GFrqfg","Invitae":"pwFSXi2uP-T8y9M6S1uDq","JWE":"_3BvF00PKCaYmwNEkFSRoxA"};

/***/ }),

/***/ "zlgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue__ = __webpack_require__("V8WY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47d23e5d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_expenses_vue__ = __webpack_require__("KBZp");
function injectStyle (ssrContext) {
  __webpack_require__("YXNu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47d23e5d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47d23e5d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_expenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zseC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestRushPayment_vue__ = __webpack_require__("v17H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d82d2d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestRushPayment_vue__ = __webpack_require__("1YFI");
function injectStyle (ssrContext) {
  __webpack_require__("Ybvc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25d82d2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestRushPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d82d2d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestRushPayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ztSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-left"},[_c('ed-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],attrs:{"button-class":"btn btn-actionbar","disabled":_vm.disabled},on:{"click":function($event){return _vm.showModal(_vm.showAddTransactionNumber)}}},[_vm._v("\n    ADD TRANSACTION NUMBER\n  ")]),_vm._v(" "),_c('ed-modal',{attrs:{"title":"Add Transaction Number","show":_vm.showAddTransactionNumber,"primary-button":"ADD","secondary-button":"CLOSE"},on:{"close":function($event){return _vm.showModal(_vm.showAddTransactionNumber)},"confirm":_vm.saveTransactionNumber}},[_c('div',{staticClass:"add-transaction-number-overlay",attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"small"},[_vm._v("Provide the transaction number from your accounting software. This information will be added to envelopes in this AP File")]),_vm._v(" "),_c('label',[_vm._v("AP File")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.selectedRows),function(row,i){return (_vm.selectedRows.length)?_c('div',{key:i},[_c('div',[_c('small',[_vm._v(_vm._s(row.data.APFile))])])]):_vm._e()}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Transaction Number")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('ed-input',{staticClass:"full-width",attrs:{"placeholder":"Transaction Number"},model:{value:(_vm.transactionNumber),callback:function ($$v) {_vm.transactionNumber=$$v},expression:"transactionNumber"}})],1)],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zwB3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1fad5fff.js